var $a5056a6656605403$exports = {};
/*! For license information please see widget.module.js.LICENSE.txt */ (()=>{
    var t1 = {
        375: (t1, e, i)=>{
            var n = i(853), r = {
                ease: n(.25, .1, .25, 1),
                easeIn: n(.42, 0, 1, 1),
                easeOut: n(0, 0, .58, 1),
                easeInOut: n(.42, 0, .58, 1),
                linear: n(0, 0, 1, 1)
            };
            function a() {}
            function s() {
                var t1 = new Set, e = new Set, i = 0;
                return {
                    next: n,
                    cancel: n,
                    clearAll: function() {
                        t1.clear(), e.clear(), cancelAnimationFrame(i), i = 0;
                    }
                };
                function n(t1) {
                    e.add(t1), i || (i = requestAnimationFrame(r));
                }
                function r() {
                    i = 0;
                    var n = e;
                    e = t1, (t1 = n).forEach(function(t1) {
                        t1();
                    }), t1.clear();
                }
            }
            t1.exports = function(t1, e, i) {
                var n = Object.create(null), s = Object.create(null), o = "function" == typeof (i = i || {}).easing ? i.easing : r[i.easing];
                o || (i.easing && console.warn("Unknown easing function in amator: " + i.easing), o = r.ease);
                var l = "function" == typeof i.step ? i.step : a, c = "function" == typeof i.done ? i.done : a, u = function(t1) {
                    if (!t1) return "undefined" != typeof window && window.requestAnimationFrame ? {
                        next: window.requestAnimationFrame.bind(window),
                        cancel: window.cancelAnimationFrame.bind(window)
                    } : {
                        next: function(t1) {
                            return setTimeout(t1, 1e3 / 60);
                        },
                        cancel: function(t1) {
                            return clearTimeout(t1);
                        }
                    };
                    if ("function" != typeof t1.next) throw new Error("Scheduler is supposed to have next(cb) function");
                    if ("function" != typeof t1.cancel) throw new Error("Scheduler is supposed to have cancel(handle) function");
                    return t1;
                }(i.scheduler), h = Object.keys(e);
                h.forEach(function(i) {
                    n[i] = t1[i], s[i] = e[i] - t1[i];
                });
                var d, p = "number" == typeof i.duration ? i.duration : 400, f = Math.max(1, .06 * p), A = 0;
                return d = u.next(function e() {
                    var i = o(A / f);
                    A += 1, function(e) {
                        h.forEach(function(i) {
                            t1[i] = s[i] * e + n[i];
                        });
                    }(i), A <= f ? (d = u.next(e), l(t1)) : (d = 0, setTimeout(function() {
                        c(t1);
                    }, 0));
                }), {
                    cancel: function() {
                        u.cancel(d), d = 0;
                    }
                };
            }, t1.exports.makeAggregateRaf = s, t1.exports.sharedScheduler = s();
        },
        853: (t1)=>{
            var e = .1, i = "function" == typeof Float32Array;
            function n(t1, e) {
                return 1 - 3 * e + 3 * t1;
            }
            function r(t1, e) {
                return 3 * e - 6 * t1;
            }
            function a(t1) {
                return 3 * t1;
            }
            function s(t1, e, i) {
                return ((n(e, i) * t1 + r(e, i)) * t1 + a(e)) * t1;
            }
            function o(t1, e, i) {
                return 3 * n(e, i) * t1 * t1 + 2 * r(e, i) * t1 + a(e);
            }
            function l(t1) {
                return t1;
            }
            t1.exports = function(t1, n, r, a) {
                if (!(0 <= t1 && t1 <= 1 && 0 <= r && r <= 1)) throw new Error("bezier x values must be in [0, 1] range");
                if (t1 === n && r === a) return l;
                for(var c = i ? new Float32Array(11) : new Array(11), u = 0; u < 11; ++u)c[u] = s(u * e, t1, r);
                return function(i) {
                    return 0 === i ? 0 : 1 === i ? 1 : s(function(i) {
                        for(var n = 0, a = 1; 10 !== a && c[a] <= i; ++a)n += e;
                        --a;
                        var l = n + (i - c[a]) / (c[a + 1] - c[a]) * e, u = o(l, t1, r);
                        return u >= .001 ? function(t1, e, i, n) {
                            for(var r = 0; r < 4; ++r){
                                var a = o(e, i, n);
                                if (0 === a) return e;
                                e -= (s(e, i, n) - t1) / a;
                            }
                            return e;
                        }(i, l, t1, r) : 0 === u ? l : function(t1, e, i, n, r) {
                            var a, o, l = 0;
                            do (a = s(o = e + (i - e) / 2, n, r) - t1) > 0 ? i = o : e = o;
                            while (Math.abs(a) > 1e-7 && ++l < 10);
                            return o;
                        }(i, n, n + e, t1, r);
                    }(i), n, a);
                };
            };
        },
        761: (t1, e, i)=>{
            "use strict";
            i.d(e, {
                A: ()=>M
            });
            var n = i(601), r = i.n(n), a = i(314), s = i.n(a), o = i(417), l = i.n(o), c = new URL(i(425), i.b), u = new URL(i(943), i.b), h = new URL(i(88), i.b), d = new URL(i(562), i.b), p = s()(r()), f = l()(c), A = l()(u), g = l()(h), m = l()(d);
            p.push([
                t1.id,
                `@font-face{font-family:"Roboto Flex";font-style:normal;font-weight:100 1000;font-stretch:100%;font-display:swap;src:url(${f}) format("woff2");unicode-range:U+0460-052F,U+1C80-1C88,U+20B4,U+2DE0-2DFF,U+A640-A69F,U+FE2E-FE2F}@font-face{font-family:"Roboto Flex";font-style:normal;font-weight:100 1000;font-stretch:100%;font-display:swap;src:url(${A}) format("woff2");unicode-range:U+0301,U+0400-045F,U+0490-0491,U+04B0-04B1,U+2116}@font-face{font-family:"Roboto Flex";font-style:normal;font-weight:100 1000;font-stretch:100%;font-display:swap;src:url(${g}) format("woff2");unicode-range:U+0100-02AF,U+0304,U+0308,U+0329,U+1E00-1E9F,U+1EF2-1EFF,U+2020,U+20A0-20AB,U+20AD-20C0,U+2113,U+2C60-2C7F,U+A720-A7FF}@font-face{font-family:"Roboto Flex";font-style:normal;font-weight:100 1000;font-stretch:100%;font-display:swap;src:url(${m}) format("woff2");unicode-range:U+0000-00FF,U+0131,U+0152-0153,U+02BB-02BC,U+02C6,U+02DA,U+02DC,U+0304,U+0308,U+0329,U+2000-206F,U+2074,U+20AC,U+2122,U+2191,U+2193,U+2212,U+2215,U+FEFF,U+FFFD}.widget-application{--main-color: #FFA900;--main-text: #413E3E;width:100%;height:100%;flex:none;overflow:hidden;position:relative;z-index:1;background-color:#fff;font-size:20px}.widget-application *,.widget-application *:before,.widget-application *:after{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;font-family:"Roboto Flex",monospace;text-decoration:none;font-weight:700;color:#413e3e;outline:none;padding:0;margin:0;box-sizing:border-box;-webkit-box-sizing:border-box}.widget-application .widget-logo{position:absolute;left:45px;top:30px;z-index:3}.widget-application--tablet.widget-application .widget-logo{left:36px;top:39px}.widget-application--mobile.widget-application .widget-logo{left:23px;top:24px}.widget-application--smallMobile.widget-application .widget-logo{left:23px;top:21px}.widget-application .widget-logo img{display:block;width:82px;height:82px;object-fit:contain;object-position:center}.widget-application--tablet.widget-application .widget-logo img{width:58px;height:58px}.widget-application--mobile.widget-application .widget-logo img{width:36px;height:36px}.widget-application--smallMobile.widget-application .widget-logo img{width:28px;height:28px}.widget-application .widget-tab__panorama-close-map{position:absolute;right:45px;top:36px;z-index:3;padding:10px;touch-action:none;ouline:none;border:none;box-shadow:none;background:rgba(0,0,0,0);cursor:pointer}.widget-application--tablet.widget-application .widget-tab__panorama-close-map{right:30px;top:35px}.widget-application--mobile.widget-application .widget-tab__panorama-close-map{padding:5px;right:22px;top:20px}.widget-application .widget-tab__panorama-close-map img{display:block;width:50px;height:50px;object-fit:contain;object-position:center}.widget-application--tablet.widget-application .widget-tab__panorama-close-map img{width:40px;height:40px}.widget-application--mobile.widget-application .widget-tab__panorama-close-map img{width:32px;height:32px}.widget-application--smallMobile.widget-application .widget-tab__panorama-close-map img{width:26px;height:26px}.widget-application .widget-enter-fullscreen{display:none;position:absolute;right:45px;top:36px;z-index:3;padding:10px;touch-action:none;ouline:none;border:none;box-shadow:none;background:rgba(0,0,0,0);cursor:pointer}.widget-application--tablet.widget-application .widget-enter-fullscreen{right:30px;top:35px}.widget-application--mobile.widget-application .widget-enter-fullscreen{padding:5px;right:22px;top:20px}.widget-application .widget-enter-fullscreen img{display:block;width:50px;height:50px;object-fit:contain;object-position:center}.widget-application--tablet.widget-application .widget-enter-fullscreen img{width:40px;height:40px}.widget-application--mobile.widget-application .widget-enter-fullscreen img{width:32px;height:32px}.widget-application--smallMobile.widget-application .widget-enter-fullscreen img{width:26px;height:26px}.widget-application .widget-exit-fullscreen{position:absolute;right:45px;top:36px;z-index:3;padding:10px;touch-action:none;ouline:none;border:none;box-shadow:none;background:rgba(0,0,0,0);cursor:pointer}.widget-application--tablet.widget-application .widget-exit-fullscreen{right:30px;top:35px}.widget-application--mobile.widget-application .widget-exit-fullscreen{padding:5px;right:22px;top:20px}.widget-application .widget-exit-fullscreen img{display:block;width:50px;height:50px;object-fit:contain;object-position:center}.widget-application--tablet.widget-application .widget-exit-fullscreen img{width:40px;height:40px}.widget-application--mobile.widget-application .widget-exit-fullscreen img{width:32px;height:32px}.widget-application--smallMobile.widget-application .widget-exit-fullscreen img{width:26px;height:26px}.widget-application .widget-tab-buttons{position:absolute;z-index:3;right:45px;bottom:34px;display:flex;align-items:center;justify-content:flex-end;row-gap:28px}.widget-application--mobile.widget-application .widget-tab-buttons{row-gap:8px;bottom:20px;right:20px}.widget-application .widget-tab-button{ouline:none;border:none;box-shadow:none;background:rgba(0,0,0,0);cursor:pointer;width:60px;height:60px;border-radius:50%;display:flex;align-items:center;justify-content:center;background-color:#ededed;margin-left:24px}.widget-application--mobile.widget-application .widget-tab-button{margin-left:10px;width:44px;height:44px}.widget-application .widget-tab-button--active{background-color:var(--main-color) !important;color:var(--main-text)}.widget-application .widget-tab-button--active img{filter:invert(100%) sepia(99%) saturate(0%) hue-rotate(97deg) brightness(105%) contrast(100%)}.widget-application .widget-tab-button:nth-child(1) img{width:27px;height:17px}.widget-application--mobile.widget-application .widget-tab-button:nth-child(1) img{width:19px;height:12px}.widget-application .widget-tab-button:nth-child(2) img{width:27px;height:17px}.widget-application--mobile.widget-application .widget-tab-button:nth-child(2) img{width:19px;height:12px}.widget-application .widget-tab-button img{width:48px;height:34px}.widget-application--mobile.widget-application .widget-tab-button img{width:35px;height:26px}.widget-application .widget-tab{width:100%;height:100%;display:flex;align-items:center;justify-content:center;padding:60px 30px}.widget-application--smallMobile.widget-application .widget-tab{padding:60px 20px}.widget-application .widget-tab--rotation{padding:0 !important}.widget-application .widget-tab--plan{padding:0 !important}.widget-application .widget-tab--panorama~.widget-tab-buttons button{background-color:#fff}.widget-application .widget-tab-menu{position:absolute;z-index:3;left:15px;top:15px;max-height:100%;overflow-y:auto;padding-bottom:30px}.widget-application .widget-tab-menu__wallpapers{display:flex;flex-wrap:wrap;align-items:flex-start;margin-top:10px;width:100%}.widget-application .widget-tab-menu__wallpapers img{width:30px;height:30px;display:block;object-fit:cover;cursor:pointer;margin-right:10px;margin-block-end:10px}.widget-application .widget-tab-menu ul{list-style-type:none}.widget-application .widget-tab-menu ul li{color:#413e3e;background-color:var(--main-color);padding:5px 15px;border-radius:10px;font-size:.7rem;border:none;cursor:pointer;margin-bottom:15px;width:200px;user-select:none;-webkit-user-select:none;user-drag:none;-webkit-user-drag:none}.widget-application .widget-tab-menu ul li label{display:flex;cursor:inherit;width:100%}.widget-application .widget-tab-menu ul li input[type=color]{cursor:pointer;margin-left:auto;width:50px;height:20px;border:0;border-radius:5px}.widget-application .widget-tab-menu ul li input[type=color]::-webkit-color-swatch-wrapper{display:none !important}.widget-application .widget-tab-menu ul li input[type=file]{display:none}.widget-application .widget-tab-menu ul li:nth-child(1){position:relative}.widget-application .widget-tab-menu ul li:nth-child(1)::after{--bar-width: 2px;content:"";width:20px;height:15px;display:block;background:repeating-linear-gradient(180deg, #000000, #000000 var(--bar-width), rgba(0, 0, 0, 0) var(--bar-width), rgba(0, 0, 0, 0) calc(var(--bar-width) * 3));position:absolute;right:10px;top:50%;transform:translateY(-50%)}.widget-application .widget-instructions{position:absolute;z-index:3;left:0;top:0;width:100%;height:100%;display:flex;align-items:center;justify-content:center;background-position:center;background-repeat:no-repeat;background-size:cover}.widget-application .widget-instructions__content{display:flex;flex-direction:column;align-items:center;justify-content:flex-start;background-color:rgba(234,234,234,.85);border-radius:20px;overflow:hidden;width:400px;max-width:calc(100% - 60px);padding:36px 30px 30px 30px;backdrop-filter:blur(5px);-moz-backdrop-filter:blur(5px);-webkit-backdrop-filter:blur(5px)}.widget-application--mobile.widget-application .widget-instructions__content{width:280px;padding:26px 20px 20px 20px}.widget-application .widget-instructions__steps{display:flex;align-items:flex-start;justify-content:center}.widget-application .widget-instructions__step{display:flex;flex-direction:column;align-items:center;justify-content:flex-start;margin:0 15px}.widget-application--tablet.widget-application .widget-instructions__step{margin:0 10px}.widget-application .widget-instructions__step img{display:block;width:52px;height:80px;object-fit:contain;object-position:center}.widget-application--mobile.widget-application .widget-instructions__step img{width:40px;height:60px}.widget-application--smallMobile.widget-application .widget-instructions__step img{width:35px}.widget-application .widget-instructions__step p{color:#413e3e;font-size:20px;font-weight:700;text-align:center;margin-top:10px;max-width:130px}.widget-application--tablet.widget-application .widget-instructions__step p{font-size:18px;max-width:115px}.widget-application--mobile.widget-application .widget-instructions__step p{font-size:16px}.widget-application--smallMobile.widget-application .widget-instructions__step p{font-size:14px}.widget-application .widget-instructions__hint p{color:#413e3e;font-weight:700;text-align:center;margin-top:1.5em;font-size:14px}.widget-application--tablet.widget-application .widget-instructions__hint p{font-size:12px}.widget-application--mobile.widget-application .widget-instructions__hint p{font-size:10px}.widget-application--smallMobile.widget-application .widget-instructions__hint p{font-size:8px}.widget-application .widget-instructions button{ouline:none;border:none;box-shadow:none;background:rgba(0,0,0,0);cursor:pointer;display:flex;align-items:center;justify-content:center;height:44px;padding:0 33px;border-radius:52px;background-color:var(--main-color);color:var(--main-text);font-size:24px;font-weight:700;text-transform:uppercase;margin:25px auto 0 auto}.widget-application .widget-instructions button:disabled{opacity:.75;cursor:not-allowed}.widget-application--tablet.widget-application .widget-instructions button{font-size:18px;height:40px}.widget-application--mobile.widget-application .widget-instructions button{font-size:16px;height:35px}.widget-application--smallMobile.widget-application .widget-instructions button{font-size:14px;height:26px;padding:0 25px}.widget-application .widget-tab__panorama{width:100%;height:100%;position:absolute;left:0;top:0;z-index:2}.widget-application .widget-tab__panorama-overlay{width:100%;height:100%;overflow:hidden;background:#fff !important}.widget-application .widget-tab__panorama-overlay *{display:none !important}.widget-application .widget-tab__panorama-overlay canvas{display:block !important}.widget-application .widget-tab__panorama-enter-vr{position:absolute;left:50%;bottom:50px;transform:translateX(-50%);z-index:3;padding:10px 15px;border-radius:10px;border:2px solid #000;background-color:#fff;font-size:16px;font-weight:600;cursor:pointer}.widget-application .widget-tab__panorama-enter-vr:disabled{opacity:.5}.widget-application .widget-tab__panorama-controls{position:absolute;z-index:2;left:50%;bottom:35px;display:flex;align-items:center;justify-content:center;padding:8px;border-radius:38px;background-color:rgba(0,0,0,.2);transform:translateX(-50%);backdrop-filter:blur(5px);-moz-backdrop-filter:blur(5px);-webkit-backdrop-filter:blur(5px)}.widget-application--mobile.widget-application .widget-tab__panorama-controls{padding:5px;bottom:22px}.widget-application--smallMobile.widget-application .widget-tab__panorama-controls{bottom:30px}.widget-application .widget-tab__panorama-controls-container{position:absolute;left:50%;bottom:35px;display:flex;column-gap:5px;transform:translateX(-50%)}.widget-application--mobile.widget-application .widget-tab__panorama-controls-container{bottom:25px}.widget-application .widget-tab__panorama-controls-container>div{position:unset;left:unset;bottom:unset;padding:5px;transform:translateX(0)}.widget-application--mobile.widget-application .widget-tab__panorama-controls-container>div{padding:4px}.widget-application .widget-tab__panorama-controls-container .widget-tab__panorama-controls-button{width:40px;height:40px;margin-right:11px}.widget-application--mobile.widget-application .widget-tab__panorama-controls-container .widget-tab__panorama-controls-button{width:34px;height:34px;margin-right:9px}.widget-application .widget-tab__panorama-controls-container .widget-tab__panorama-controls-button img{width:22px}.widget-application--tablet.widget-application .widget-tab__panorama-controls-container .widget-tab__panorama-controls-button img{width:32px}.widget-application--mobile.widget-application .widget-tab__panorama-controls-container .widget-tab__panorama-controls-button img{width:37px}.widget-application .widget-tab__panorama-controls-button{ouline:none;border:none;box-shadow:none;background:rgba(0,0,0,0);cursor:pointer;width:55px;height:55px;border-radius:50%;background-color:#fff;display:flex;align-items:center;justify-content:center;margin-right:18px}.widget-application--tablet.widget-application .widget-tab__panorama-controls-button{width:44px;height:44px}.widget-application--mobile.widget-application .widget-tab__panorama-controls-button{margin-right:10px;width:33px;height:33px}.widget-application--smallMobile.widget-application .widget-tab__panorama-controls-button{width:26px;height:26px}.widget-application .widget-tab__panorama-controls-button:disabled{background-color:#e6e6e6;cursor:not-allowed}.widget-application .widget-tab__panorama-controls-button:disabled img{filter:invert(100%) saturate(0)}.widget-application .widget-tab__panorama-controls-button img{display:block}.widget-application--tablet.widget-application .widget-tab__panorama-controls-button img{transform:scale(0.7)}.widget-application--mobile.widget-application .widget-tab__panorama-controls-button img{transform:scale(0.52)}.widget-application--smallMobile.widget-application .widget-tab__panorama-controls-button img{transform:scale(0.45)}.widget-application .widget-tab__panorama-controls-button:nth-last-child(1){margin-right:0}.widget-application .widget-tab__panorama-controls-button--bareshell{display:flex;align-items:center;column-gap:10px;padding:11px 9px 9px 8px;background:none;border:none;cursor:pointer}.widget-application--mobile.widget-application .widget-tab__panorama-controls-button--bareshell{column-gap:7px;padding:8px 8px 8px 6px}.widget-application .widget-tab__panorama-controls-button--bareshell .checked{right:calc(100% - 2px);transform:translateX(-100%)}.widget-application .widget-tab__panorama-controls-button--bareshell-text{font-size:15px;font-weight:700;line-height:20px;color:#fff}.widget-application--mobile.widget-application .widget-tab__panorama-controls-button--bareshell-text{font-size:13px;line-height:17px}.widget-application .widget-tab__panorama-controls-button--bareshell-switch{position:relative;width:34px;height:19px}.widget-application--mobile.widget-application .widget-tab__panorama-controls-button--bareshell-switch{width:28px;height:16px}.widget-application .widget-tab__panorama-controls-button--bareshell-switch-checkbox{height:0;width:0;visibility:hidden}.widget-application .widget-tab__panorama-controls-button--bareshell-switch-checkbox:checked+.widget-tab__panorama-controls-button--bareshell-switch-label .widget-tab__panorama-controls-button--bareshell-switch-button{right:calc(100% - 2px);transform:translateX(100%)}.widget-application .widget-tab__panorama-controls-button--bareshell-switch-label{position:absolute;top:0;display:flex;align-items:center;justify-content:space-between;width:34px;height:19px;background-color:#fff;border-radius:20px;border:1px solid #fff;transition:background-color .2s}.widget-application--mobile.widget-application .widget-tab__panorama-controls-button--bareshell-switch-label{width:28px;height:16px}.widget-application .widget-tab__panorama-controls-button--bareshell-switch-label .widget-tab__panorama-controls-button--bareshell-switch-button{content:"";position:absolute;top:1px;right:1px;width:14px;height:14px;border-radius:45px;transition:.2s;background:#413e3e}.widget-application--mobile.widget-application .widget-tab__panorama-controls-button--bareshell-switch-label .widget-tab__panorama-controls-button--bareshell-switch-button{width:12px;height:12px}.widget-application .widget-tab__panorama-controls-button span{font-size:23px;font-weight:700;line-height:120%;letter-spacing:-0.12em}.widget-application .widget-tab__panorama-close-map{z-index:4}.widget-application .widget-tab__panorama-map{position:absolute;left:45px;bottom:35px;z-index:3;border-radius:10px;opacity:1;transition:opacity .5s;padding:8px;background-color:#fff;touch-action:none;-webkit-touch-action:none}.widget-application .widget-tab__panorama-map::before{content:"";position:absolute;z-index:-1;left:50%;top:50%;transform:translate(-50%, -50%);width:100%;height:100%;border-radius:inherit;background-color:#fff}.widget-application--tablet.widget-application .widget-tab__panorama-map{left:35px;transform:scale(0.6);transform-origin:0% 100%}.widget-application--mobile.widget-application .widget-tab__panorama-map{left:22px;bottom:22px;transform:scale(0.4)}.widget-application--smallMobile.widget-application .widget-tab__panorama-map{left:20px;bottom:30px;transform:scale(0.35)}.widget-application--mobile.widget-application .widget-tab__panorama-map--bottom{bottom:91px}.widget-application--tablet.widget-application .widget-tab__panorama-map--scaled{transform:scale(1.4) translate(-50%, 50%);left:50%;bottom:50%}.widget-application--tablet.widget-application .widget-tab__panorama-map--scaled::after{content:"";position:absolute;z-index:-2;left:50%;top:50%;transform:translate(-50%, -50%);width:100vw;height:100vh;background-color:rgba(196,196,196,.8)}.widget-application--tablet.widget-application .widget-tab__panorama-map--scaled svg path:active{opacity:.3 !important}.widget-application--mobile.widget-application .widget-tab__panorama-map--scaled{transform:scale(1) translate(-50%, 50%)}.widget-application .widget-tab__panorama-map--hidden{opacity:0;pointer-events:none}.widget-application .widget-tab__panorama-map canvas{width:200px;border-radius:unset;user-select:none;-webkit-user-select:none;user-drag:none;-webkit-user-drag:none;-webkit-backface-visibility:hidden;-ms-transform:translateZ(0);-webkit-transform:translateZ(0);transform:translateZ(0)}.widget-application .widget-tab__panorama-map-image{position:absolute;left:0;top:0;z-index:-1;display:none;user-select:none;-webkit-user-select:none;user-drag:none;-webkit-user-drag:none;-webkit-backface-visibility:hidden;-ms-transform:translateZ(0);-webkit-transform:translateZ(0);transform:translateZ(0)}.widget-application .widget-tab__panorama-map svg{position:absolute;left:50%;top:50%;transform:translate(-50%, -50%);width:200px;height:calc(100% - 16px);z-index:3;display:block;border-radius:inherit}.widget-application .widget-tab__panorama-map svg path{opacity:0;fill:var(--main-color);cursor:pointer}.widget-application .widget-tab__panorama-map svg path:hover{opacity:.3}.widget-application .widget-tab__panorama-map__fov{--x: 0;--y: 0;--rotate: 0;position:absolute;left:calc(var(--x) + 8px);top:calc(var(--y) + 8px);width:16px;height:16px;transform:translate(-50%, -50%) rotate(calc(var(--rotate) * 1rad));transform-origin:50% 50%;z-index:4;pointer-events:none}.widget-application .widget-tab__panorama-map__fov-direction{border-radius:50%;border-left:30px solid rgba(0,0,0,0);border-right:30px solid rgba(0,0,0,0);border-bottom:30px solid rgba(0,0,0,0);border-top:40px solid var(--main-color);opacity:.4;position:absolute;left:50%;top:50%;transform:translate(-50%, -50%);z-index:1}.widget-application .widget-tab__panorama-map__fov-dot{position:relative;z-index:5;width:100%;height:100%;background-color:var(--main-color);border-radius:50%;border:2px solid var(--main-color);box-shadow:inset 0 0 0 2px #fff}.widget-application .widget-tab__panorama-top-view-map{cursor:pointer;position:absolute;left:45px;bottom:35px;z-index:3;border-radius:10px;opacity:1;transition:opacity .5s;padding:8px;background-color:#fff;touch-action:none;-webkit-touch-action:none}.widget-application--tablet.widget-application .widget-tab__panorama-top-view-map{left:35px;transform:scale(0.6);transform-origin:0% 100%}.widget-application--mobile.widget-application .widget-tab__panorama-top-view-map{left:22px;bottom:22px;transform:scale(0.4)}.widget-application--smallMobile.widget-application .widget-tab__panorama-top-view-map{left:20px;bottom:30px;transform:scale(0.35)}.widget-application--tablet.widget-application .widget-tab__panorama-top-view-map--scaled{transform:scale(1.4) translate(-50%, 50%);left:50%;bottom:50%}.widget-application--mobile.widget-application .widget-tab__panorama-top-view-map--bottom{bottom:91px}.widget-application .widget-tab__panorama-top-view-map--hidden{opacity:0;pointer-events:none}.widget-application .widget-tab__panorama-top-view-map .display-wrapper{position:relative}.widget-application .widget-tab__panorama-top-view-map .display-wrapper canvas,.widget-application .widget-tab__panorama-top-view-map .display-wrapper img{position:relative}.widget-application .widget-tab__panorama-top-view-map .display-wrapper canvas.hidden,.widget-application .widget-tab__panorama-top-view-map .display-wrapper img.hidden{display:none}.widget-application .widget-tab__panorama-top-view-map .camera{opacity:.8;display:block;position:absolute;width:8px;height:8px;background:radial-gradient(orange 0%, orange 30%, transparent 45%, transparent 50%, orange 70%);border-radius:50%;transform:translate(-50%, -50%);pointer-events:none;transition:background 200ms,opacity 200ms,width 200ms,height 200ms}.widget-application .widget-tab__panorama-top-view-map .camera--current{--rotate: 0;width:16px;height:16px;opacity:1;transform:translate(-50%, -50%) rotate(calc(var(--rotate) * 1rad))}.widget-application .widget-tab__panorama-top-view-map .camera--current::before{content:"";border-radius:50%;border-left:30px solid rgba(0,0,0,0);border-right:30px solid rgba(0,0,0,0);border-bottom:30px solid rgba(0,0,0,0);border-top:40px solid var(--main-color);opacity:.4;position:absolute;left:50%;top:50%;transform:translate(-50%, -50%);z-index:1}.map-overlay{position:fixed;top:0;left:0;width:100%;height:100%;background:rgba(0,0,0,0);z-index:3;display:none}.map-overlay--visible{display:block}.widget-application .widget-tab__rotation{width:100%;height:100%}.widget-application .widget-tab__rotation-start{ouline:none;border:none;box-shadow:none;background:rgba(0,0,0,0);cursor:pointer;position:absolute;left:50%;bottom:35px;transform:translateX(-50%);display:flex;align-items:center;justify-content:center;padding:0 25px 0 10px;background-color:#eaeaea;border-radius:38px;height:72px;width:202px}.widget-application--tablet.widget-application .widget-tab__rotation-start{height:60px;width:166px;padding:0 20px 0 8px;bottom:35px}.widget-application--mobile.widget-application .widget-tab__rotation-start{height:44px;width:115px;padding:0 10px 0 6px}.widget-application--smallMobile.widget-application .widget-tab__rotation-start{height:36px;width:85px;padding:0 8px 0 6px;bottom:30px}.widget-application .widget-tab__rotation-start-icon{display:flex;align-items:center;justify-content:center;border-radius:50%;background-color:#fff;margin-right:18px;padding:10px}.widget-application--tablet.widget-application .widget-tab__rotation-start-icon{padding:7px;margin-right:15px}.widget-application--mobile.widget-application .widget-tab__rotation-start-icon{margin-right:7px}.widget-application--smallMobile.widget-application .widget-tab__rotation-start-icon{padding:6px;margin-right:5px}.widget-application .widget-tab__rotation-start-icon img{display:block;position:relative;top:2px;width:34px}.widget-application--tablet.widget-application .widget-tab__rotation-start-icon img{width:30px;top:1px}.widget-application--mobile.widget-application .widget-tab__rotation-start-icon img{width:19px;top:0}.widget-application--smallMobile.widget-application .widget-tab__rotation-start-icon img{width:15px}.widget-application .widget-tab__rotation-start span{font-size:24px;font-weight:700;color:#413e3e;text-transform:uppercase;width:100%;display:block;text-align:center;position:relative;top:1px}.widget-application--tablet.widget-application .widget-tab__rotation-start span{font-size:20px}.widget-application--mobile.widget-application .widget-tab__rotation-start span{font-size:14px}.widget-application--smallMobile.widget-application .widget-tab__rotation-start span{font-size:10px;top:0}.widget-application .widget-tab__isometry{width:100%;height:100%;touch-action:none;-webkit-touch-action:none}.widget-application .widget-tab__isometry-container{width:100% !important;height:calc(100% - 290px) !important;position:relative;background-image:none !important}.widget-application--mobile.widget-application .widget-tab__isometry-container{margin-top:96px;height:calc(100% - 312px)}.widget-application .widget-tab__isometry-container img{position:absolute;left:50%;top:50%;transform:translate(-50%, -50%);max-width:calc(100% - 60px);max-height:calc(100% - 60px);width:600px;height:600px;object-fit:contain;opacity:0;pointer-events:none;user-select:none;-webkit-user-select:none;user-drag:none;-webkit-user-drag:none}.widget-application--mobile.widget-application .widget-tab__isometry-container img{max-width:calc(100% - 22px);max-height:100%}.widget-application .widget-tab__isometry-container img.active{opacity:1}.widget-application .widget-tab__threesixty{width:100%;height:100%;touch-action:none;-webkit-touch-action:none}.widget-application .widget-tab__threesixty-container{width:100% !important;height:calc(100% - 270px) !important;position:relative;background-image:none !important}.widget-application--mobile.widget-application .widget-tab__threesixty-container{margin-top:96px;height:calc(100% - 312px)}.widget-application .widget-tab__threesixty-container img{position:absolute;left:50%;top:50%;transform:translate(-50%, -50%);max-width:calc(100% - 60px);max-height:calc(100% - 60px);width:600px;height:600px;object-fit:contain;opacity:0;pointer-events:none;user-select:none;-webkit-user-select:none;user-drag:none;-webkit-user-drag:none}.widget-application--mobile.widget-application .widget-tab__threesixty-container img{max-width:calc(100% - 22px);max-height:100%}.widget-application .widget-tab__threesixty-container img.active{opacity:1}.widget-application .widget-tab__threesixty--active{cursor:move}.widget-application--smallMobile.widget-application .widget-tab__threesixty-container img{max-width:calc(100% - 40px)}.widget-application--smallMobile.widget-application .widget-tab__isometry-container img{max-width:calc(100% - 40px)}.widget-application .widget-tab__isometry-shader{position:absolute;left:50%;top:50%;transform:translate(-50%, -50%);max-width:calc(100vh - 270px);max-height:calc(100vh - 270px);width:600px;height:600px;object-fit:contain}.widget-application--mobile.widget-application .widget-tab__isometry-shader{max-width:calc(100vw - 22px);max-height:calc(100vw - 22px)}.widget-application .widget-tab__isometry-shader canvas{position:absolute;width:100% !important;height:100% !important}.widget-application .widget-tab__isometry .hidden{display:none}.widget-application .widget-tab__isometry-arrows{position:absolute;z-index:3;left:50%;bottom:211px;transform:translateX(-50%);height:36px;display:flex;align-items:center;justify-content:center}.widget-application--mobile.widget-application .widget-tab__isometry-arrows{bottom:162px;height:30px}.widget-application .widget-tab__isometry-arrows span{font-size:14px;font-weight:700;line-height:16px;letter-spacing:.1em;color:#413e3e;display:block;margin:0 5px}.widget-application--mobile.widget-application .widget-tab__isometry-arrows span{font-size:14px;line-height:18px;letter-spacing:0;margin:0 2px}.widget-application .widget-tab__isometry-arrow{ouline:none;border:none;box-shadow:none;background:rgba(0,0,0,0);cursor:pointer;display:flex;align-items:center;justify-content:center;padding:5px}.widget-application .widget-tab__isometry-arrow img{width:16px}.widget-application .widget-tab__isometry-buttons{position:absolute;z-index:3;left:44px;bottom:35px;display:flex;align-items:center;justify-content:flex-end}.widget-application--tablet.widget-application .widget-tab__isometry-buttons{left:35px;bottom:35px}.widget-application--mobile.widget-application .widget-tab__isometry-buttons{left:22px;bottom:22px}.widget-application--smallMobile.widget-application .widget-tab__isometry-buttons{left:20px;bottom:30px}.widget-application .widget-tab__isometry-button{ouline:none;border:none;box-shadow:none;background:rgba(0,0,0,0);cursor:pointer;width:72px;height:72px;border-radius:50%;display:flex;align-items:center;justify-content:center;background-color:#ededed;margin-top:40px}.widget-application--tablet.widget-application .widget-tab__isometry-button{margin-top:20px;width:60px;height:60px}.widget-application--mobile.widget-application .widget-tab__isometry-button{margin-top:10px;width:44px;height:44px}.widget-application--smallMobile.widget-application .widget-tab__isometry-button{width:36px;height:36px}.widget-application .widget-tab__isometry-button img{display:block;width:50px}.widget-application--tablet.widget-application .widget-tab__isometry-button img{width:40px}.widget-application--mobile.widget-application .widget-tab__isometry-button img{width:30px}.widget-application--smallMobile.widget-application .widget-tab__isometry-button img{width:25px}.widget-application .widget-loader{display:block;position:relative;width:80px;height:80px}.widget-application .widget-loader--absolute{position:absolute;left:50%;top:50%;transform:translate(-50%, -50%)}.widget-application .widget-loader--sm{transform:translate(-50%, -50%) scale(0.75)}.widget-application .widget-loader div{position:absolute;top:33px;width:13px;height:13px;border-radius:50%;background:var(--main-color);animation-timing-function:cubic-bezier(0, 1, 1, 0)}.widget-application .widget-loader div:nth-child(1){left:8px;animation:widget-loader-1 .6s infinite}.widget-application .widget-loader div:nth-child(2){left:8px;animation:widget-loader-2 .6s infinite}.widget-application .widget-loader div:nth-child(3){left:32px;animation:widget-loader-2 .6s infinite}.widget-application .widget-loader div:nth-child(4){left:56px;animation:widget-loader-3 .6s infinite}@keyframes widget-loader-1{0%{transform:scale(0)}100%{transform:scale(1)}}@keyframes widget-loader-3{0%{transform:scale(1)}100%{transform:scale(0)}}@keyframes widget-loader-2{0%{transform:translate(0, 0)}100%{transform:translate(24px, 0)}}.widget-application .widget-watermark-button{position:absolute;right:4px;bottom:4px;z-index:1000}.widget-application--tablet.widget-application .widget-watermark-button{right:3px;bottom:2px}.widget-application--mobile.widget-application .widget-watermark-button{right:2px}.widget-application--smallMobile.widget-application .widget-watermark-button{right:13px;bottom:8px}.widget-application .widget-watermark-button a{font-size:18px;line-height:90%;color:#000;opacity:.5}.widget-application--tablet.widget-application .widget-watermark-button a{font-size:15px}.widget-application--mobile.widget-application .widget-watermark-button a{font-size:10px}.widget-application--smallMobile.widget-application .widget-watermark-button a{font-size:9px}.widget-application .widget-watermark-button a span{font-weight:100;font-size:inherit;line-height:90%;color:inherit}.widget-application .floors-select{position:absolute;top:47px;left:50%;background:none;height:37px;border:none;transform:translateX(-50%);cursor:pointer;white-space:nowrap;overflow-x:visible;z-index:3}.widget-application .floors-select--text{user-select:none;-webkit-user-select:none;user-drag:none;-webkit-user-drag:none;font-size:28px;line-height:36px;font-weight:700;word-spacing:-12px;border-bottom:1px #413e3e solid;padding:0 2px}.widget-application--tablet.widget-application .floors-select--text{font-size:24px;line-height:32px;word-spacing:-9px}.widget-application--mobile.widget-application .floors-select--text{font-size:20px;line-height:28px;word-spacing:-6px}.widget-application .floors-select--text:hover{border-bottom:1px #000 solid}.widget-application .floors-select--block{display:flex;flex-direction:column;background:#fff;margin-top:7px;border-radius:6px;-moz-box-shadow:0 0 2px 2px rgba(0,0,0,.2);-webkit-box-shadow:0 0 2px 2px rgba(0,0,0,.2);box-shadow:0 0 2px 2px rgba(0,0,0,.2);overflow:hidden}.widget-application .floors-select--block-item{font-size:20px;text-align:center;line-height:40px;word-spacing:-9px}.widget-application--tablet.widget-application .floors-select--block-item{font-size:18px;word-spacing:-5px}.widget-application--mobile.widget-application .floors-select--block-item{font-size:16px;word-spacing:-4px}.widget-application .floors-select--block-item:active{background:linear-gradient(180deg, rgba(0, 0, 0, 0.1) 0%, rgba(0, 0, 0, 0) 100%)}.widget-application .floors-select--block-item--active{background:var(--main-color)}.widget-application .widget-tab-rooms{user-select:none;-webkit-user-select:none;user-drag:none;-webkit-user-drag:none;position:absolute;bottom:118px;width:100%;max-width:100%;height:69px;overflow-x:scroll;-ms-overflow-style:none;overflow:-moz-scrollbars-none}.widget-application--mobile.widget-application .widget-tab-rooms{bottom:88px;height:50px}.widget-application .widget-tab-rooms::-webkit-scrollbar{width:0;display:none}.widget-application .widget-tab-rooms-container{display:flex;column-gap:22px}.widget-application--mobile.widget-application .widget-tab-rooms-container{column-gap:10px}.widget-application .widget-tab-rooms-item{position:relative;flex-shrink:0;display:flex;flex-direction:column;align-items:center;background:#fff;width:93px;height:69px;padding:4px 3px;border:2px solid var(--main-color);border-radius:12px;cursor:pointer}.widget-application--mobile.widget-application .widget-tab-rooms-item{width:68px;height:50px;padding:2px 0;border-radius:9px}.widget-application .widget-tab-rooms-item:first-child{margin-left:45px}.widget-application--mobile.widget-application .widget-tab-rooms-item:first-child{margin-left:20px}.widget-application .widget-tab-rooms-item:last-child::after{content:"";position:absolute;right:-45px;top:0;width:30px;height:1px}.widget-application--mobile.widget-application .widget-tab-rooms-item:last-child::after{right:-20px;width:20px}.widget-application .widget-tab-rooms-item-img{user-select:none;-webkit-user-select:none;user-drag:none;-webkit-user-drag:none;height:26px !important;width:46px !important}.widget-application--mobile.widget-application .widget-tab-rooms-item-img{height:19px !important;width:34px !important}.widget-application .widget-tab-rooms-item-type{user-select:none;-webkit-user-select:none;user-drag:none;-webkit-user-drag:none;font-size:12px;font-weight:700;line-height:11px;text-align:center;color:rgba(65,62,62,.5);margin-top:3px}.widget-application--mobile.widget-application .widget-tab-rooms-item-type{font-size:9px;line-height:8px;margin-top:2px}.widget-application .widget-tab-rooms-item-area{user-select:none;-webkit-user-select:none;user-drag:none;-webkit-user-drag:none;font-size:10px;font-weight:700;line-height:12px;word-spacing:-1px;text-align:center;color:#413e3e;margin-top:4px}.widget-application--mobile.widget-application .widget-tab-rooms-item-area{font-size:7px;line-height:8px;margin-top:2px}.widget-application .widget-tab-rooms-item-active{background:var(--main-color)}.widget-application .widget-tab-rooms-item-active .widget-tab-rooms-item-img{filter:invert(100%) sepia(99%) saturate(0%) hue-rotate(97deg) brightness(105%) contrast(100%)}.widget-application .widget-tab-rooms-item-active .widget-tab-rooms-item-type{color:#fff}.widget-application .widget-tab-rooms-item-active .widget-tab-rooms-item-area{color:#fff}.widget-application .widget-tab-rooms-switch{position:fixed;bottom:34px;left:45px;width:85px;height:44px}.widget-application--mobile.widget-application .widget-tab-rooms-switch{bottom:20px;left:20px;width:56px;height:29px}.widget-application .widget-tab-rooms-switch-checkbox{height:0;width:0;visibility:hidden}.widget-application .widget-tab-rooms-switch-checkbox:checked+.widget-tab-rooms-switch-label .widget-tab-rooms-switch-button{right:100%;transform:translateX(100%)}.widget-application .widget-tab-rooms-switch-label{position:absolute;top:0;display:flex;align-items:center;justify-content:space-between;cursor:pointer;background:var(--main-color);width:85px;height:44px;border-radius:30px;border:3px solid var(--main-color);transition:background-color .2s}.widget-application--mobile.widget-application .widget-tab-rooms-switch-label{width:56px;height:29px;border-radius:20px;border:2px solid var(--main-color)}.widget-application .widget-tab-rooms-switch-label .widget-tab-rooms-switch-button{position:absolute;top:0;right:0;font-size:18px;font-weight:700;line-height:38px;letter-spacing:-0.03em;color:var(--main-color);width:71px;height:38px;text-align:center;border-radius:30px;transition:.2s;background:#fff}.widget-application--mobile.widget-application .widget-tab-rooms-switch-label .widget-tab-rooms-switch-button{font-size:12px;line-height:25px;width:47px;height:25px;border-radius:20px}.widget-application .panel{position:fixed;top:0;left:0;width:100%;height:100%;z-index:2;pointer-events:none}.widget-application .panel-sidebar{position:absolute;bottom:221px;right:0;z-index:3;pointer-events:auto}.widget-application--tablet.widget-application .panel-sidebar{bottom:calc(50% - 197px)}.widget-application--mobile.widget-application .panel-sidebar{bottom:187px}.widget-application .panel-sidebar-select{display:flex;flex-direction:column;row-gap:6px;overflow-y:scroll;-ms-overflow-style:none;scrollbar-width:none}.widget-application .panel-sidebar-select::-webkit-scrollbar{width:0;height:0}.widget-application .panel-sidebar-select-wrapper{position:absolute;top:0;right:59px;display:none;background:#f5f5f5;width:86px;max-height:calc(100% - 63px);border:8px solid #f5f5f5;border-radius:4px 0 0 4px;overflow:hidden}.widget-application--mobile.widget-application .panel-sidebar-select-wrapper{right:43px;width:76px;max-height:calc(100% - 46px);border:6px solid #f5f5f5}.widget-application .panel-sidebar-select-wrapper-visible{display:block}.widget-application .panel-sidebar-select-wrapper-visible~.panel-sidebar-menu{border-radius:0 0 0 5px;box-shadow:unset !important}.widget-application--mobile.widget-application .panel-sidebar-select-wrapper-visible~.panel-sidebar-menu{border-radius:0 0 0 4px}.widget-application .panel-sidebar-select-item{font-size:16px;font-weight:700;line-height:19px;color:#413e3e;padding:4px 5px;cursor:pointer}.widget-application--mobile.widget-application .panel-sidebar-select-item{font-size:12px;line-height:14px}.widget-application .panel-sidebar-select-item:hover{color:var(--main-color)}.widget-application .panel-sidebar-select-item-active{color:var(--main-color)}.widget-application .panel-sidebar-menu{position:relative;right:0;display:none;flex-direction:column;background:#fff;box-shadow:-1.35px 0px 8.12px 0px rgba(114,114,114,.2509803922);border-radius:5px 0 0 5px;row-gap:6px;padding:8px}.widget-application--mobile.widget-application .panel-sidebar-menu{box-shadow:-1px 0px 6px 0px rgba(114,114,114,.2509803922);border-radius:4px 0 0 4px;row-gap:5px;padding:6px}.widget-application .panel-sidebar-menu-visible{display:flex}.widget-application .panel-sidebar-menu-item{width:44px;height:44px;background:#fff;border:none;cursor:pointer;box-shadow:none;z-index:2}.widget-application--mobile.widget-application .panel-sidebar-menu-item{width:32px;height:32px}.widget-application .panel-sidebar-menu-item:nth-last-child(1){padding:11px}.widget-application--mobile.widget-application .panel-sidebar-menu-item:nth-last-child(1){padding:8px}.widget-application .panel-sidebar-menu-item:nth-last-child(1) img{width:22px;height:22px}.widget-application--mobile.widget-application .panel-sidebar-menu-item:nth-last-child(1) img{width:16px;height:16px}.widget-application .panel-sidebar-menu-item:hover img{filter:invert(67%) sepia(17%) saturate(5617%) hue-rotate(2deg) brightness(105%) contrast(105%)}.widget-application .panel-sidebar-menu-item img{position:relative;width:44px;height:44px;object-fit:contain}.widget-application--mobile.widget-application .panel-sidebar-menu-item img{width:32px;height:32px}.widget-application .panel-sidebar-menu-item-active img{filter:invert(67%) sepia(17%) saturate(5617%) hue-rotate(2deg) brightness(105%) contrast(105%)}.widget-application .panel-sidebar-menu-line{width:44px;height:1px;background:#ededed;margin:5px 0}.widget-application--mobile.widget-application .panel-sidebar-menu-line{width:32px;margin:3px 0}.widget-application .panel-sidebar-menu-toggle{position:absolute;bottom:0;right:0;display:none;align-items:center;justify-content:center;width:22px;height:60px;background:#fff;box-shadow:-1.35px 0px 8.12px 0px rgba(114,114,114,.2509803922);border-radius:5px 0 0 5px;border:none;cursor:pointer}.widget-application--mobile.widget-application .panel-sidebar-menu-toggle{width:16px;height:44px;box-shadow:-1px 0px 6px 0px rgba(114,114,114,.2509803922);border-radius:4px 0 0 4px}.widget-application .panel-sidebar-menu-toggle:hover img{filter:invert(67%) sepia(17%) saturate(5617%) hue-rotate(2deg) brightness(105%) contrast(105%)}.widget-application .panel-sidebar-menu-toggle-visible{display:flex}.widget-application .panel-sidebar-menu-toggle img{width:22px;height:22px}.widget-application--mobile.widget-application .panel-sidebar-menu-toggle img{width:16px;height:16px}`,
                ""
            ]);
            const M = p;
        },
        314: (t1)=>{
            "use strict";
            t1.exports = function(t1) {
                var e = [];
                return e.toString = function() {
                    return this.map(function(e) {
                        var i = "", n = void 0 !== e[5];
                        return e[4] && (i += "@supports (".concat(e[4], ") {")), e[2] && (i += "@media ".concat(e[2], " {")), n && (i += "@layer".concat(e[5].length > 0 ? " ".concat(e[5]) : "", " {")), i += t1(e), n && (i += "}"), e[2] && (i += "}"), e[4] && (i += "}"), i;
                    }).join("");
                }, e.i = function(t1, i, n, r, a) {
                    "string" == typeof t1 && (t1 = [
                        [
                            null,
                            t1,
                            void 0
                        ]
                    ]);
                    var s = {};
                    if (n) for(var o = 0; o < this.length; o++){
                        var l = this[o][0];
                        null != l && (s[l] = !0);
                    }
                    for(var c = 0; c < t1.length; c++){
                        var u = [].concat(t1[c]);
                        n && s[u[0]] || (void 0 !== a && (void 0 === u[5] || (u[1] = "@layer".concat(u[5].length > 0 ? " ".concat(u[5]) : "", " {").concat(u[1], "}")), u[5] = a), i && (u[2] ? (u[1] = "@media ".concat(u[2], " {").concat(u[1], "}"), u[2] = i) : u[2] = i), r && (u[4] ? (u[1] = "@supports (".concat(u[4], ") {").concat(u[1], "}"), u[4] = r) : u[4] = "".concat(r)), e.push(u));
                    }
                }, e;
            };
        },
        417: (t1)=>{
            "use strict";
            t1.exports = function(t1, e) {
                return e || (e = {}), t1 ? (t1 = String(t1.__esModule ? t1.default : t1), /^['"].*['"]$/.test(t1) && (t1 = t1.slice(1, -1)), e.hash && (t1 += e.hash), /["'() \t\n]|(%20)/.test(t1) || e.needQuotes ? '"'.concat(t1.replace(/"/g, '\\"').replace(/\n/g, "\\n"), '"') : t1) : t1;
            };
        },
        601: (t1)=>{
            "use strict";
            t1.exports = function(t1) {
                return t1[1];
            };
        },
        790: (t1)=>{
            t1.exports = function(t1) {
                !function(t1) {
                    if (!t1) throw new Error("Eventify cannot use falsy object as events subject");
                    for(var e = [
                        "on",
                        "fire",
                        "off"
                    ], i = 0; i < e.length; ++i)if (t1.hasOwnProperty(e[i])) throw new Error("Subject cannot be eventified, since it already has property '" + e[i] + "'");
                }(t1);
                var e = function(t1) {
                    var e = Object.create(null);
                    return {
                        on: function(i, n, r) {
                            if ("function" != typeof n) throw new Error("callback is expected to be a function");
                            var a = e[i];
                            return a || (a = e[i] = []), a.push({
                                callback: n,
                                ctx: r
                            }), t1;
                        },
                        off: function(i, n) {
                            if (void 0 === i) return e = Object.create(null), t1;
                            if (e[i]) {
                                if ("function" != typeof n) delete e[i];
                                else for(var r = e[i], a = 0; a < r.length; ++a)r[a].callback === n && r.splice(a, 1);
                            }
                            return t1;
                        },
                        fire: function(i) {
                            var n, r = e[i];
                            if (!r) return t1;
                            arguments.length > 1 && (n = Array.prototype.splice.call(arguments, 1));
                            for(var a = 0; a < r.length; ++a){
                                var s = r[a];
                                s.callback.apply(s.ctx, n);
                            }
                            return t1;
                        }
                    };
                }(t1);
                return t1.on = e.on, t1.off = e.off, t1.fire = e.fire, t1;
            };
        },
        228: (t1)=>{
            "use strict";
            var e = Object.getOwnPropertySymbols, i = Object.prototype.hasOwnProperty, n = Object.prototype.propertyIsEnumerable;
            t1.exports = function() {
                try {
                    if (!Object.assign) return !1;
                    var t1 = new String("abc");
                    if (t1[5] = "de", "5" === Object.getOwnPropertyNames(t1)[0]) return !1;
                    for(var e = {}, i = 0; i < 10; i++)e["_" + String.fromCharCode(i)] = i;
                    if ("0123456789" !== Object.getOwnPropertyNames(e).map(function(t1) {
                        return e[t1];
                    }).join("")) return !1;
                    var n = {};
                    return "abcdefghijklmnopqrst".split("").forEach(function(t1) {
                        n[t1] = t1;
                    }), "abcdefghijklmnopqrst" === Object.keys(Object.assign({}, n)).join("");
                } catch (t1) {
                    return !1;
                }
            }() ? Object.assign : function(t1, r) {
                for(var a, s, o = function(t1) {
                    if (null == t1) throw new TypeError("Object.assign cannot be called with null or undefined");
                    return Object(t1);
                }(t1), l = 1; l < arguments.length; l++){
                    for(var c in a = Object(arguments[l]))i.call(a, c) && (o[c] = a[c]);
                    if (e) {
                        s = e(a);
                        for(var u = 0; u < s.length; u++)n.call(a, s[u]) && (o[s[u]] = a[s[u]]);
                    }
                }
                return o;
            };
        },
        611: (t1, e, i)=>{
            "use strict";
            var n = i(964), r = i(375), a = i(790), s = i(860), o = i(833), l = o(), c = o(!0), u = i(59), h = i(25), d = i(35);
            function p(t1, e) {
                var i = (e = e || {}).controller;
                if (i || (h.canAttach(t1) ? i = h(t1, e) : d.canAttach(t1) && (i = d(t1, e))), !i) throw new Error("Cannot create panzoom for the current type of dom element");
                var o = i.getOwner(), p = {
                    x: 0,
                    y: 0
                }, A = !1, y = new u;
                i.initTransform && i.initTransform(y);
                var v, x = "function" == typeof e.filterKey ? e.filterKey : g, w = "number" == typeof e.pinchSpeed ? e.pinchSpeed : 1, b = e.bounds, T = "number" == typeof e.maxZoom ? e.maxZoom : Number.POSITIVE_INFINITY, E = "number" == typeof e.minZoom ? e.minZoom : 0, I = "number" == typeof e.boundsPadding ? e.boundsPadding : .05, S = "number" == typeof e.zoomDoubleClickSpeed ? e.zoomDoubleClickSpeed : 1.75, N = e.beforeWheel || g, D = e.beforeMouseDown || g, C = "number" == typeof e.zoomSpeed ? e.zoomSpeed : 1, z = f(e.transformOrigin), L = e.enableTextSelection ? c : l;
                !function(t1) {
                    var e = typeof t1;
                    if ("undefined" !== e && "boolean" !== e && !(m(t1.left) && m(t1.top) && m(t1.bottom) && m(t1.right))) throw new Error("Bounds object is not valid. It can be: undefined, boolean (true|false) or an object {left, top, right, bottom}");
                }(b), e.autocenter && function() {
                    var t1, e, n = 0, r = 0, a = at();
                    if (a) n = a.left, r = a.top, t1 = a.right - a.left, e = a.bottom - a.top;
                    else {
                        var s = o.getBoundingClientRect();
                        t1 = s.width, e = s.height;
                    }
                    var l = i.getBBox();
                    if (0 !== l.width && 0 !== l.height) {
                        var c = e / l.height, u = t1 / l.width, h = Math.min(u, c);
                        y.x = -(l.left + l.width / 2) * h + t1 / 2 + n, y.y = -(l.top + l.height / 2) * h + e / 2 + r, y.scale = h;
                    }
                }();
                var O, _, j, P, R, U, k, B, F, Q, H = 0, V = 0, G = 0, Y = null, W = new Date, X = !1, Z = !1;
                k = "smoothScroll" in e && !e.smoothScroll ? {
                    start: g,
                    stop: g,
                    cancel: g
                } : s(function() {
                    return {
                        x: y.x,
                        y: y.y
                    };
                }, function(t1, e) {
                    Lt(), it(t1, e);
                }, e.smoothScroll);
                var J = !1;
                ut();
                var K = {
                    dispose: function() {
                        ht();
                    },
                    moveBy: ct,
                    moveTo: it,
                    smoothMoveTo: function(t1, e) {
                        ct(t1 - y.x, e - y.y, !0);
                    },
                    centerOn: function(t1) {
                        var e = t1.ownerSVGElement;
                        if (!e) throw new Error("ui element is required to be within the scene");
                        var i = t1.getBoundingClientRect(), n = i.left + i.width / 2, r = i.top + i.height / 2, a = e.getBoundingClientRect();
                        ct(a.width / 2 - n, a.height / 2 - r, !0);
                    },
                    zoomTo: zt,
                    zoomAbs: lt,
                    smoothZoom: Dt,
                    smoothZoomAbs: function(t1, e, i) {
                        var n = {
                            scale: y.scale
                        }, a = {
                            scale: i
                        };
                        k.cancel(), Lt(), F = r(n, a, {
                            step: function(i) {
                                lt(t1, e, i.scale);
                            }
                        });
                    },
                    showRectangle: function(t1) {
                        var e = o.getBoundingClientRect(), i = et(e.width, e.height), n = t1.right - t1.left, r = t1.bottom - t1.top;
                        if (!Number.isFinite(n) || !Number.isFinite(r)) throw new Error("Invalid rectangle");
                        var a = i.x / n, s = i.y / r, l = Math.min(a, s);
                        y.x = -(t1.left + n / 2) * l + i.x / 2, y.y = -(t1.top + r / 2) * l + i.y / 2, y.scale = l;
                    },
                    pause: function() {
                        ht(), J = !0;
                    },
                    resume: function() {
                        J && (ut(), J = !1);
                    },
                    isPaused: function() {
                        return J;
                    },
                    getTransform: function() {
                        return y;
                    },
                    getMinZoom: function() {
                        return E;
                    },
                    setMinZoom: function(t1) {
                        E = t1;
                    },
                    getMaxZoom: function() {
                        return T;
                    },
                    setMaxZoom: function(t1) {
                        T = t1;
                    },
                    getTransformOrigin: function() {
                        return z;
                    },
                    setTransformOrigin: function(t1) {
                        z = f(t1);
                    },
                    getZoomSpeed: function() {
                        return C;
                    },
                    setZoomSpeed: function(t1) {
                        if (!Number.isFinite(t1)) throw new Error("Zoom speed should be a number");
                        C = t1;
                    }
                };
                a(K);
                var q = "number" == typeof e.initialX ? e.initialX : y.x, $ = "number" == typeof e.initialY ? e.initialY : y.y, tt = "number" == typeof e.initialZoom ? e.initialZoom : y.scale;
                return q == y.x && $ == y.y && tt == y.scale || lt(q, $, tt), K;
                function et(t1, e) {
                    if (i.getScreenCTM) {
                        var n = i.getScreenCTM(), r = n.a, a = n.d, s = n.e, o = n.f;
                        p.x = t1 * r - s, p.y = e * a - o;
                    } else p.x = t1, p.y = e;
                    return p;
                }
                function it(t1, e) {
                    y.x = t1, y.y = e, rt(), Rt("pan"), st();
                }
                function nt(t1, e) {
                    it(y.x + t1, y.y + e);
                }
                function rt() {
                    var t1 = at();
                    if (t1) {
                        var e, n, r, a, s = !1, o = (r = (e = i.getBBox()).left, a = e.top, {
                            left: (n = {
                                x: r * y.scale + y.x,
                                y: a * y.scale + y.y
                            }).x,
                            top: n.y,
                            right: e.width * y.scale + n.x,
                            bottom: e.height * y.scale + n.y
                        }), l = t1.left - o.right;
                        return l > 0 && (y.x += l, s = !0), (l = t1.right - o.left) < 0 && (y.x += l, s = !0), (l = t1.top - o.bottom) > 0 && (y.y += l, s = !0), (l = t1.bottom - o.top) < 0 && (y.y += l, s = !0), s;
                    }
                }
                function at() {
                    if (b) {
                        if ("boolean" == typeof b) {
                            var t1 = o.getBoundingClientRect(), e = t1.width, i = t1.height;
                            return {
                                left: e * I,
                                top: i * I,
                                right: e * (1 - I),
                                bottom: i * (1 - I)
                            };
                        }
                        return b;
                    }
                }
                function st() {
                    A = !0, v = window.requestAnimationFrame(dt);
                }
                function ot(t1, e, i) {
                    if (M(t1) || M(e) || M(i)) throw new Error("zoom requires valid numbers");
                    var n = y.scale * i;
                    if (n < E) {
                        if (y.scale === E) return;
                        i = E / y.scale;
                    }
                    if (n > T) {
                        if (y.scale === T) return;
                        i = T / y.scale;
                    }
                    var r = et(t1, e);
                    y.x = r.x - i * (r.x - y.x), y.y = r.y - i * (r.y - y.y), b && 1 === I && 1 === E ? (y.scale *= i, rt()) : rt() || (y.scale *= i), Rt("zoom"), st();
                }
                function lt(t1, e, i) {
                    ot(t1, e, i / y.scale);
                }
                function ct(t1, e, i) {
                    if (!i) return nt(t1, e);
                    B && B.cancel();
                    var n = 0, a = 0;
                    B = r({
                        x: 0,
                        y: 0
                    }, {
                        x: t1,
                        y: e
                    }, {
                        step: function(t1) {
                            nt(t1.x - n, t1.y - a), n = t1.x, a = t1.y;
                        }
                    });
                }
                function ut() {
                    o.addEventListener("mousedown", wt, {
                        passive: !1
                    }), o.addEventListener("dblclick", xt, {
                        passive: !1
                    }), o.addEventListener("touchstart", ft, {
                        passive: !1
                    }), o.addEventListener("keydown", pt, {
                        passive: !1
                    }), n.addWheelListener(o, St, {
                        passive: !1
                    }), st();
                }
                function ht() {
                    n.removeWheelListener(o, St), o.removeEventListener("mousedown", wt), o.removeEventListener("keydown", pt), o.removeEventListener("dblclick", xt), o.removeEventListener("touchstart", ft), v && (window.cancelAnimationFrame(v), v = 0), k.cancel(), Et(), It(), L.release(), jt();
                }
                function dt() {
                    A && (A = !1, i.applyTransform(y), Rt("transform"), v = 0);
                }
                function pt(t1) {
                    var e = 0, i = 0, n = 0;
                    if (38 === t1.keyCode ? i = 1 : 40 === t1.keyCode ? i = -1 : 37 === t1.keyCode ? e = 1 : 39 === t1.keyCode ? e = -1 : 189 === t1.keyCode || 109 === t1.keyCode ? n = 1 : 187 !== t1.keyCode && 107 !== t1.keyCode || (n = -1), !x(t1, e, i, n)) {
                        if (e || i) {
                            t1.preventDefault(), t1.stopPropagation();
                            var r = o.getBoundingClientRect();
                            ct(.05 * (a = Math.min(r.width, r.height)) * e, .05 * a * i);
                        }
                        if (n) {
                            var a, s = Ot(100 * n);
                            zt((a = z ? Ct() : {
                                x: (l = o.getBoundingClientRect()).width / 2,
                                y: l.height / 2
                            }).x, a.y, s);
                        }
                        var l;
                    }
                }
                function ft(t1) {
                    if (function(t1) {
                        e.onTouch && !e.onTouch(t1) || (t1.stopPropagation(), t1.preventDefault());
                    }(t1), mt(), 1 === t1.touches.length) return function(t1) {
                        V = new Date;
                        var e = Nt(t1.touches[0]);
                        O = e;
                        var i = et(e.x, e.y);
                        _ = i.x, j = i.y, P = _, R = j, k.cancel(), At();
                    }(t1, t1.touches[0]);
                    2 === t1.touches.length && (U = vt(t1.touches[0], t1.touches[1]), Q = !0, At());
                }
                function At() {
                    X || (X = !0, document.addEventListener("touchmove", gt), document.addEventListener("touchend", yt), document.addEventListener("touchcancel", yt));
                }
                function gt(t1) {
                    if (1 === t1.touches.length) {
                        t1.stopPropagation();
                        var e = et((u = Nt(t1.touches[0])).x, u.y), i = e.x - _, n = e.y - j;
                        0 !== i && 0 !== n && _t(), _ = e.x, j = e.y, ct(i, n);
                    } else if (2 === t1.touches.length) {
                        Q = !0;
                        var r = t1.touches[0], a = t1.touches[1], s = vt(r, a), o = 1 + (s / U - 1) * w, l = Nt(r), c = Nt(a);
                        if (_ = (l.x + c.x) / 2, j = (l.y + c.y) / 2, z) {
                            var u = Ct();
                            _ = u.x, j = u.y;
                        }
                        zt(_, j, o), U = s, t1.stopPropagation(), t1.preventDefault();
                    }
                }
                function mt() {
                    G && (clearTimeout(G), G = 0);
                }
                function Mt(t1) {
                    if (e.onClick) {
                        mt();
                        var i = _ - P, n = j - R;
                        Math.sqrt(i * i + n * n) > 5 || (G = setTimeout(function() {
                            G = 0, e.onClick(t1);
                        }, 300));
                    }
                }
                function yt(t1) {
                    if (mt(), t1.touches.length > 0) {
                        var e = et((i = Nt(t1.touches[0])).x, i.y);
                        _ = e.x, j = e.y;
                    } else {
                        var i, n = new Date;
                        n - H < 300 ? z ? Dt((i = Ct()).x, i.y, S) : Dt(O.x, O.y, S) : n - V < 200 && Mt(t1), H = n, jt(), It();
                    }
                }
                function vt(t1, e) {
                    var i = t1.clientX - e.clientX, n = t1.clientY - e.clientY;
                    return Math.sqrt(i * i + n * n);
                }
                function xt(t1) {
                    !function(t1) {
                        mt(), e.onDoubleClick && !e.onDoubleClick(t1) || (t1.preventDefault(), t1.stopPropagation());
                    }(t1);
                    var i = Nt(t1);
                    z && (i = Ct()), Dt(i.x, i.y, S);
                }
                function wt(t1) {
                    if (mt(), !D(t1)) {
                        if (Y = t1, W = new Date, X) return t1.stopPropagation(), !1;
                        if (1 === t1.button && null !== window.event || 0 === t1.button) {
                            k.cancel();
                            var e = Nt(t1), i = et(e.x, e.y);
                            return P = _ = i.x, R = j = i.y, document.addEventListener("mousemove", bt), document.addEventListener("mouseup", Tt), L.capture(t1.target || t1.srcElement), !1;
                        }
                    }
                }
                function bt(t1) {
                    if (!X) {
                        _t();
                        var e = Nt(t1), i = et(e.x, e.y), n = i.x - _, r = i.y - j;
                        _ = i.x, j = i.y, ct(n, r);
                    }
                }
                function Tt() {
                    new Date - W < 200 && Mt(Y), L.release(), jt(), Et();
                }
                function Et() {
                    document.removeEventListener("mousemove", bt), document.removeEventListener("mouseup", Tt), Z = !1;
                }
                function It() {
                    document.removeEventListener("touchmove", gt), document.removeEventListener("touchend", yt), document.removeEventListener("touchcancel", yt), Z = !1, Q = !1, X = !1;
                }
                function St(t1) {
                    if (!N(t1)) {
                        k.cancel();
                        var e = t1.deltaY;
                        t1.deltaMode > 0 && (e *= 100);
                        var i = Ot(e);
                        if (1 !== i) {
                            var n = z ? Ct() : Nt(t1);
                            zt(n.x, n.y, i), t1.preventDefault();
                        }
                    }
                }
                function Nt(t1) {
                    var e = o.getBoundingClientRect();
                    return {
                        x: t1.clientX - e.left,
                        y: t1.clientY - e.top
                    };
                }
                function Dt(t1, e, i) {
                    var n = y.scale, a = {
                        scale: n
                    }, s = {
                        scale: i * n
                    };
                    k.cancel(), Lt(), F = r(a, s, {
                        step: function(i) {
                            lt(t1, e, i.scale);
                        },
                        done: Pt
                    });
                }
                function Ct() {
                    var t1 = o.getBoundingClientRect();
                    return {
                        x: t1.width * z.x,
                        y: t1.height * z.y
                    };
                }
                function zt(t1, e, i) {
                    return k.cancel(), Lt(), ot(t1, e, i);
                }
                function Lt() {
                    F && (F.cancel(), F = null);
                }
                function Ot(t1) {
                    return 1 - Math.sign(t1) * Math.min(.25, Math.abs(C * t1 / 128));
                }
                function _t() {
                    Z || (Rt("panstart"), Z = !0, k.start());
                }
                function jt() {
                    Z && (Q || k.stop(), Rt("panend"));
                }
                function Pt() {
                    Rt("zoomend");
                }
                function Rt(t1) {
                    K.fire(t1, K);
                }
            }
            function f(t1) {
                if (t1) return "object" == typeof t1 ? (m(t1.x) && m(t1.y) || A(t1), t1) : void A();
            }
            function A(t1) {
                throw console.error(t1), new Error([
                    "Cannot parse transform origin.",
                    "Some good examples:",
                    '  "center center" can be achieved with {x: 0.5, y: 0.5}',
                    '  "top center" can be achieved with {x: 0.5, y: 0}',
                    '  "bottom right" can be achieved with {x: 1, y: 1}'
                ].join("\n"));
            }
            function g() {}
            function m(t1) {
                return Number.isFinite(t1);
            }
            function M(t1) {
                return Number.isNaN ? Number.isNaN(t1) : t1 != t1;
            }
            t1.exports = p, function() {
                if ("undefined" != typeof document) {
                    var t1 = document.getElementsByTagName("script");
                    if (t1) {
                        for(var e, i = 0; i < t1.length; ++i){
                            var n = t1[i];
                            if (n.src && n.src.match(/\bpanzoom(\.min)?\.js/)) {
                                e = n;
                                break;
                            }
                        }
                        if (e) {
                            var r = e.getAttribute("query");
                            if (r) {
                                var a = e.getAttribute("name") || "pz", s = Date.now();
                                !function t1() {
                                    var i = document.querySelector(r);
                                    if (!i) return Date.now() - s < 2e3 ? void setTimeout(t1, 100) : void console.error("Cannot find the panzoom element", a);
                                    var n = function(t1) {
                                        for(var e = t1.attributes, i = {}, n = 0; n < e.length; ++n){
                                            var r = o(e[n]);
                                            r && (i[r.name] = r.value);
                                        }
                                        return i;
                                    }(e);
                                    console.log(n), window[a] = p(i, n);
                                }();
                            }
                        }
                    }
                }
                function o(t1) {
                    if (t1.name && "p" === t1.name[0] && "z" === t1.name[1] && "-" === t1.name[2]) return {
                        name: t1.name.substr(3),
                        value: JSON.parse(t1.value)
                    };
                }
            }();
        },
        833: (t1)=>{
            function e(t1) {
                return t1.stopPropagation(), !1;
            }
            function i() {}
            t1.exports = function(t1) {
                if (t1) return {
                    capture: i,
                    release: i
                };
                var n, r, a, s = !1;
                return {
                    capture: function(t1) {
                        s = !0, r = window.document.onselectstart, a = window.document.ondragstart, window.document.onselectstart = e, (n = t1).ondragstart = e;
                    },
                    release: function() {
                        s && (s = !1, window.document.onselectstart = r, n && (n.ondragstart = a));
                    }
                };
            };
        },
        35: (t1)=>{
            function e(t1) {
                return t1 && t1.parentElement && t1.style;
            }
            t1.exports = function(t1, i) {
                if (!e(t1)) throw new Error("panzoom requires DOM element to be attached to the DOM tree");
                var n = t1.parentElement;
                return t1.scrollTop = 0, i.disableKeyboardInteraction || n.setAttribute("tabindex", 0), {
                    getBBox: function() {
                        return {
                            left: 0,
                            top: 0,
                            width: t1.clientWidth,
                            height: t1.clientHeight
                        };
                    },
                    getOwner: function() {
                        return n;
                    },
                    applyTransform: function(e) {
                        t1.style.transformOrigin = "0 0 0", t1.style.transform = "matrix(" + e.scale + ", 0, 0, " + e.scale + ", " + e.x + ", " + e.y + ")";
                    }
                };
            }, t1.exports.canAttach = e;
        },
        860: (t1)=>{
            function e() {
                return "function" == typeof cancelAnimationFrame ? cancelAnimationFrame : clearTimeout;
            }
            function i() {
                return "function" == typeof requestAnimationFrame ? requestAnimationFrame : function(t1) {
                    return setTimeout(t1, 16);
                };
            }
            t1.exports = function(t1, n, r) {
                "object" != typeof r && (r = {});
                var a, s, o, l, c, u, h, d, p, f, A = "number" == typeof r.minVelocity ? r.minVelocity : 5, g = "number" == typeof r.amplitude ? r.amplitude : .25, m = "function" == typeof r.cancelAnimationFrame ? r.cancelAnimationFrame : e(), M = "function" == typeof r.requestAnimationFrame ? r.requestAnimationFrame : i();
                return {
                    start: function() {
                        a = t1(), u = p = l = h = 0, s = new Date, m(o), m(f), o = M(y);
                    },
                    stop: function() {
                        m(o), m(f);
                        var e = t1();
                        c = e.x, d = e.y, s = Date.now(), (l < -A || l > A) && (c += u = g * l), (h < -A || h > A) && (d += p = g * h), f = M(v);
                    },
                    cancel: function() {
                        m(o), m(f);
                    }
                };
                function y() {
                    var e = Date.now(), i = e - s;
                    s = e;
                    var n = t1(), r = n.x - a.x, c = n.y - a.y;
                    a = n;
                    var u = 1e3 / (1 + i);
                    l = .8 * r * u + .2 * l, h = .8 * c * u + .2 * h, o = M(y);
                }
                function v() {
                    var t1 = Date.now() - s, e = !1, i = 0, r = 0;
                    u && ((i = -u * Math.exp(-t1 / 342)) > .5 || i < -0.5 ? e = !0 : i = u = 0), p && ((r = -p * Math.exp(-t1 / 342)) > .5 || r < -0.5 ? e = !0 : r = p = 0), e && (n(c + i, d + r), f = M(v));
                }
            };
        },
        25: (t1)=>{
            function e(t1) {
                return t1 && t1.ownerSVGElement && t1.getCTM;
            }
            t1.exports = function(t1, i) {
                if (!e(t1)) throw new Error("svg element is required for svg.panzoom to work");
                var n = t1.ownerSVGElement;
                if (!n) throw new Error("Do not apply panzoom to the root <svg> element. Use its child instead (e.g. <g></g>). As of March 2016 only FireFox supported transform on the root element");
                return i.disableKeyboardInteraction || n.setAttribute("tabindex", 0), {
                    getBBox: function() {
                        var e = t1.getBBox();
                        return {
                            left: e.x,
                            top: e.y,
                            width: e.width,
                            height: e.height
                        };
                    },
                    getScreenCTM: function() {
                        var t1 = n.getCTM();
                        return t1 || n.getScreenCTM();
                    },
                    getOwner: function() {
                        return n;
                    },
                    applyTransform: function(e) {
                        t1.setAttribute("transform", "matrix(" + e.scale + " 0 0 " + e.scale + " " + e.x + " " + e.y + ")");
                    },
                    initTransform: function(e) {
                        var i = t1.getCTM();
                        null === i && (i = document.createElementNS("http://www.w3.org/2000/svg", "svg").createSVGMatrix()), e.x = i.e, e.y = i.f, e.scale = i.a, n.removeAttributeNS(null, "viewBox");
                    }
                };
            }, t1.exports.canAttach = e;
        },
        59: (t1)=>{
            t1.exports = function() {
                this.x = 0, this.y = 0, this.scale = 1;
            };
        },
        551: (t1, e, i)=>{
            "use strict";
            var n = i(540), r = i(228), a = i(982);
            function s(t1) {
                for(var e = "https://reactjs.org/docs/error-decoder.html?invariant=" + t1, i = 1; i < arguments.length; i++)e += "&args[]=" + encodeURIComponent(arguments[i]);
                return "Minified React error #" + t1 + "; visit " + e + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
            }
            if (!n) throw Error(s(227));
            var o = new Set, l = {};
            function c(t1, e) {
                u(t1, e), u(t1 + "Capture", e);
            }
            function u(t1, e) {
                for(l[t1] = e, t1 = 0; t1 < e.length; t1++)o.add(e[t1]);
            }
            var h = !("undefined" == typeof window || void 0 === window.document || void 0 === window.document.createElement), d = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, p = Object.prototype.hasOwnProperty, f = {}, A = {};
            function g(t1, e, i, n, r, a, s) {
                this.acceptsBooleans = 2 === e || 3 === e || 4 === e, this.attributeName = n, this.attributeNamespace = r, this.mustUseProperty = i, this.propertyName = t1, this.type = e, this.sanitizeURL = a, this.removeEmptyString = s;
            }
            var m = {};
            "children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(t1) {
                m[t1] = new g(t1, 0, !1, t1, null, !1, !1);
            }), [
                [
                    "acceptCharset",
                    "accept-charset"
                ],
                [
                    "className",
                    "class"
                ],
                [
                    "htmlFor",
                    "for"
                ],
                [
                    "httpEquiv",
                    "http-equiv"
                ]
            ].forEach(function(t1) {
                var e = t1[0];
                m[e] = new g(e, 1, !1, t1[1], null, !1, !1);
            }), [
                "contentEditable",
                "draggable",
                "spellCheck",
                "value"
            ].forEach(function(t1) {
                m[t1] = new g(t1, 2, !1, t1.toLowerCase(), null, !1, !1);
            }), [
                "autoReverse",
                "externalResourcesRequired",
                "focusable",
                "preserveAlpha"
            ].forEach(function(t1) {
                m[t1] = new g(t1, 2, !1, t1, null, !1, !1);
            }), "allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(t1) {
                m[t1] = new g(t1, 3, !1, t1.toLowerCase(), null, !1, !1);
            }), [
                "checked",
                "multiple",
                "muted",
                "selected"
            ].forEach(function(t1) {
                m[t1] = new g(t1, 3, !0, t1, null, !1, !1);
            }), [
                "capture",
                "download"
            ].forEach(function(t1) {
                m[t1] = new g(t1, 4, !1, t1, null, !1, !1);
            }), [
                "cols",
                "rows",
                "size",
                "span"
            ].forEach(function(t1) {
                m[t1] = new g(t1, 6, !1, t1, null, !1, !1);
            }), [
                "rowSpan",
                "start"
            ].forEach(function(t1) {
                m[t1] = new g(t1, 5, !1, t1.toLowerCase(), null, !1, !1);
            });
            var M = /[\-:]([a-z])/g;
            function y(t1) {
                return t1[1].toUpperCase();
            }
            function v(t1, e, i, n) {
                var r = m.hasOwnProperty(e) ? m[e] : null;
                (null !== r ? 0 === r.type : !n && 2 < e.length && ("o" === e[0] || "O" === e[0]) && ("n" === e[1] || "N" === e[1])) || (function(t1, e, i, n) {
                    if (null == e || function(t1, e, i, n) {
                        if (null !== i && 0 === i.type) return !1;
                        switch(typeof e){
                            case "function":
                            case "symbol":
                                return !0;
                            case "boolean":
                                return !n && (null !== i ? !i.acceptsBooleans : "data-" !== (t1 = t1.toLowerCase().slice(0, 5)) && "aria-" !== t1);
                            default:
                                return !1;
                        }
                    }(t1, e, i, n)) return !0;
                    if (n) return !1;
                    if (null !== i) switch(i.type){
                        case 3:
                            return !e;
                        case 4:
                            return !1 === e;
                        case 5:
                            return isNaN(e);
                        case 6:
                            return isNaN(e) || 1 > e;
                    }
                    return !1;
                }(e, i, r, n) && (i = null), n || null === r ? function(t1) {
                    return !!p.call(A, t1) || !p.call(f, t1) && (d.test(t1) ? A[t1] = !0 : (f[t1] = !0, !1));
                }(e) && (null === i ? t1.removeAttribute(e) : t1.setAttribute(e, "" + i)) : r.mustUseProperty ? t1[r.propertyName] = null === i ? 3 !== r.type && "" : i : (e = r.attributeName, n = r.attributeNamespace, null === i ? t1.removeAttribute(e) : (i = 3 === (r = r.type) || 4 === r && !0 === i ? "" : "" + i, n ? t1.setAttributeNS(n, e, i) : t1.setAttribute(e, i))));
            }
            "accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(t1) {
                var e = t1.replace(M, y);
                m[e] = new g(e, 1, !1, t1, null, !1, !1);
            }), "xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(t1) {
                var e = t1.replace(M, y);
                m[e] = new g(e, 1, !1, t1, "http://www.w3.org/1999/xlink", !1, !1);
            }), [
                "xml:base",
                "xml:lang",
                "xml:space"
            ].forEach(function(t1) {
                var e = t1.replace(M, y);
                m[e] = new g(e, 1, !1, t1, "http://www.w3.org/XML/1998/namespace", !1, !1);
            }), [
                "tabIndex",
                "crossOrigin"
            ].forEach(function(t1) {
                m[t1] = new g(t1, 1, !1, t1.toLowerCase(), null, !1, !1);
            }), m.xlinkHref = new g("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1), [
                "src",
                "href",
                "action",
                "formAction"
            ].forEach(function(t1) {
                m[t1] = new g(t1, 1, !1, t1.toLowerCase(), null, !0, !0);
            });
            var x = n.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, w = 60103, b = 60106, T = 60107, E = 60108, I = 60114, S = 60109, N = 60110, D = 60112, C = 60113, z = 60120, L = 60115, O = 60116, _ = 60121, j = 60128, P = 60129, R = 60130, U = 60131;
            if ("function" == typeof Symbol && Symbol.for) {
                var k = Symbol.for;
                w = k("react.element"), b = k("react.portal"), T = k("react.fragment"), E = k("react.strict_mode"), I = k("react.profiler"), S = k("react.provider"), N = k("react.context"), D = k("react.forward_ref"), C = k("react.suspense"), z = k("react.suspense_list"), L = k("react.memo"), O = k("react.lazy"), _ = k("react.block"), k("react.scope"), j = k("react.opaque.id"), P = k("react.debug_trace_mode"), R = k("react.offscreen"), U = k("react.legacy_hidden");
            }
            var B, F = "function" == typeof Symbol && Symbol.iterator;
            function Q(t1) {
                return null === t1 || "object" != typeof t1 ? null : "function" == typeof (t1 = F && t1[F] || t1["@@iterator"]) ? t1 : null;
            }
            function H(t1) {
                if (void 0 === B) try {
                    throw Error();
                } catch (t1) {
                    var e = t1.stack.trim().match(/\n( *(at )?)/);
                    B = e && e[1] || "";
                }
                return "\n" + B + t1;
            }
            var V = !1;
            function G(t1, e) {
                if (!t1 || V) return "";
                V = !0;
                var i = Error.prepareStackTrace;
                Error.prepareStackTrace = void 0;
                try {
                    if (e) {
                        if (e = function() {
                            throw Error();
                        }, Object.defineProperty(e.prototype, "props", {
                            set: function() {
                                throw Error();
                            }
                        }), "object" == typeof Reflect && Reflect.construct) {
                            try {
                                Reflect.construct(e, []);
                            } catch (t1) {
                                var n = t1;
                            }
                            Reflect.construct(t1, [], e);
                        } else {
                            try {
                                e.call();
                            } catch (t1) {
                                n = t1;
                            }
                            t1.call(e.prototype);
                        }
                    } else {
                        try {
                            throw Error();
                        } catch (t1) {
                            n = t1;
                        }
                        t1();
                    }
                } catch (t1) {
                    if (t1 && n && "string" == typeof t1.stack) {
                        for(var r = t1.stack.split("\n"), a = n.stack.split("\n"), s = r.length - 1, o = a.length - 1; 1 <= s && 0 <= o && r[s] !== a[o];)o--;
                        for(; 1 <= s && 0 <= o; s--, o--)if (r[s] !== a[o]) {
                            if (1 !== s || 1 !== o) do {
                                if (s--, 0 > --o || r[s] !== a[o]) return "\n" + r[s].replace(" at new ", " at ");
                            }while (1 <= s && 0 <= o);
                            break;
                        }
                    }
                } finally{
                    V = !1, Error.prepareStackTrace = i;
                }
                return (t1 = t1 ? t1.displayName || t1.name : "") ? H(t1) : "";
            }
            function Y(t1) {
                switch(t1.tag){
                    case 5:
                        return H(t1.type);
                    case 16:
                        return H("Lazy");
                    case 13:
                        return H("Suspense");
                    case 19:
                        return H("SuspenseList");
                    case 0:
                    case 2:
                    case 15:
                        return G(t1.type, !1);
                    case 11:
                        return G(t1.type.render, !1);
                    case 22:
                        return G(t1.type._render, !1);
                    case 1:
                        return G(t1.type, !0);
                    default:
                        return "";
                }
            }
            function W(t1) {
                if (null == t1) return null;
                if ("function" == typeof t1) return t1.displayName || t1.name || null;
                if ("string" == typeof t1) return t1;
                switch(t1){
                    case T:
                        return "Fragment";
                    case b:
                        return "Portal";
                    case I:
                        return "Profiler";
                    case E:
                        return "StrictMode";
                    case C:
                        return "Suspense";
                    case z:
                        return "SuspenseList";
                }
                if ("object" == typeof t1) switch(t1.$$typeof){
                    case N:
                        return (t1.displayName || "Context") + ".Consumer";
                    case S:
                        return (t1._context.displayName || "Context") + ".Provider";
                    case D:
                        var e = t1.render;
                        return e = e.displayName || e.name || "", t1.displayName || ("" !== e ? "ForwardRef(" + e + ")" : "ForwardRef");
                    case L:
                        return W(t1.type);
                    case _:
                        return W(t1._render);
                    case O:
                        e = t1._payload, t1 = t1._init;
                        try {
                            return W(t1(e));
                        } catch (t1) {}
                }
                return null;
            }
            function X(t1) {
                switch(typeof t1){
                    case "boolean":
                    case "number":
                    case "object":
                    case "string":
                    case "undefined":
                        return t1;
                    default:
                        return "";
                }
            }
            function Z(t1) {
                var e = t1.type;
                return (t1 = t1.nodeName) && "input" === t1.toLowerCase() && ("checkbox" === e || "radio" === e);
            }
            function J(t1) {
                t1._valueTracker || (t1._valueTracker = function(t1) {
                    var e = Z(t1) ? "checked" : "value", i = Object.getOwnPropertyDescriptor(t1.constructor.prototype, e), n = "" + t1[e];
                    if (!t1.hasOwnProperty(e) && void 0 !== i && "function" == typeof i.get && "function" == typeof i.set) {
                        var r = i.get, a = i.set;
                        return Object.defineProperty(t1, e, {
                            configurable: !0,
                            get: function() {
                                return r.call(this);
                            },
                            set: function(t1) {
                                n = "" + t1, a.call(this, t1);
                            }
                        }), Object.defineProperty(t1, e, {
                            enumerable: i.enumerable
                        }), {
                            getValue: function() {
                                return n;
                            },
                            setValue: function(t1) {
                                n = "" + t1;
                            },
                            stopTracking: function() {
                                t1._valueTracker = null, delete t1[e];
                            }
                        };
                    }
                }(t1));
            }
            function K(t1) {
                if (!t1) return !1;
                var e = t1._valueTracker;
                if (!e) return !0;
                var i = e.getValue(), n = "";
                return t1 && (n = Z(t1) ? t1.checked ? "true" : "false" : t1.value), (t1 = n) !== i && (e.setValue(t1), !0);
            }
            function q(t1) {
                if (void 0 === (t1 = t1 || ("undefined" != typeof document ? document : void 0))) return null;
                try {
                    return t1.activeElement || t1.body;
                } catch (e) {
                    return t1.body;
                }
            }
            function $(t1, e) {
                var i = e.checked;
                return r({}, e, {
                    defaultChecked: void 0,
                    defaultValue: void 0,
                    value: void 0,
                    checked: null != i ? i : t1._wrapperState.initialChecked
                });
            }
            function tt(t1, e) {
                var i = null == e.defaultValue ? "" : e.defaultValue, n = null != e.checked ? e.checked : e.defaultChecked;
                i = X(null != e.value ? e.value : i), t1._wrapperState = {
                    initialChecked: n,
                    initialValue: i,
                    controlled: "checkbox" === e.type || "radio" === e.type ? null != e.checked : null != e.value
                };
            }
            function et(t1, e) {
                null != (e = e.checked) && v(t1, "checked", e, !1);
            }
            function it(t1, e) {
                et(t1, e);
                var i = X(e.value), n = e.type;
                if (null != i) "number" === n ? (0 === i && "" === t1.value || t1.value != i) && (t1.value = "" + i) : t1.value !== "" + i && (t1.value = "" + i);
                else if ("submit" === n || "reset" === n) return void t1.removeAttribute("value");
                e.hasOwnProperty("value") ? rt(t1, e.type, i) : e.hasOwnProperty("defaultValue") && rt(t1, e.type, X(e.defaultValue)), null == e.checked && null != e.defaultChecked && (t1.defaultChecked = !!e.defaultChecked);
            }
            function nt(t1, e, i) {
                if (e.hasOwnProperty("value") || e.hasOwnProperty("defaultValue")) {
                    var n = e.type;
                    if (!("submit" !== n && "reset" !== n || void 0 !== e.value && null !== e.value)) return;
                    e = "" + t1._wrapperState.initialValue, i || e === t1.value || (t1.value = e), t1.defaultValue = e;
                }
                "" !== (i = t1.name) && (t1.name = ""), t1.defaultChecked = !!t1._wrapperState.initialChecked, "" !== i && (t1.name = i);
            }
            function rt(t1, e, i) {
                "number" === e && q(t1.ownerDocument) === t1 || (null == i ? t1.defaultValue = "" + t1._wrapperState.initialValue : t1.defaultValue !== "" + i && (t1.defaultValue = "" + i));
            }
            function at(t1, e) {
                return t1 = r({
                    children: void 0
                }, e), (e = function(t1) {
                    var e = "";
                    return n.Children.forEach(t1, function(t1) {
                        null != t1 && (e += t1);
                    }), e;
                }(e.children)) && (t1.children = e), t1;
            }
            function st(t1, e, i, n) {
                if (t1 = t1.options, e) {
                    e = {};
                    for(var r = 0; r < i.length; r++)e["$" + i[r]] = !0;
                    for(i = 0; i < t1.length; i++)r = e.hasOwnProperty("$" + t1[i].value), t1[i].selected !== r && (t1[i].selected = r), r && n && (t1[i].defaultSelected = !0);
                } else {
                    for(i = "" + X(i), e = null, r = 0; r < t1.length; r++){
                        if (t1[r].value === i) return t1[r].selected = !0, void (n && (t1[r].defaultSelected = !0));
                        null !== e || t1[r].disabled || (e = t1[r]);
                    }
                    null !== e && (e.selected = !0);
                }
            }
            function ot(t1, e) {
                if (null != e.dangerouslySetInnerHTML) throw Error(s(91));
                return r({}, e, {
                    value: void 0,
                    defaultValue: void 0,
                    children: "" + t1._wrapperState.initialValue
                });
            }
            function lt(t1, e) {
                var i = e.value;
                if (null == i) {
                    if (i = e.children, e = e.defaultValue, null != i) {
                        if (null != e) throw Error(s(92));
                        if (Array.isArray(i)) {
                            if (!(1 >= i.length)) throw Error(s(93));
                            i = i[0];
                        }
                        e = i;
                    }
                    null == e && (e = ""), i = e;
                }
                t1._wrapperState = {
                    initialValue: X(i)
                };
            }
            function ct(t1, e) {
                var i = X(e.value), n = X(e.defaultValue);
                null != i && ((i = "" + i) !== t1.value && (t1.value = i), null == e.defaultValue && t1.defaultValue !== i && (t1.defaultValue = i)), null != n && (t1.defaultValue = "" + n);
            }
            function ut(t1) {
                var e = t1.textContent;
                e === t1._wrapperState.initialValue && "" !== e && null !== e && (t1.value = e);
            }
            var ht = {
                html: "http://www.w3.org/1999/xhtml",
                mathml: "http://www.w3.org/1998/Math/MathML",
                svg: "http://www.w3.org/2000/svg"
            };
            function dt(t1) {
                switch(t1){
                    case "svg":
                        return "http://www.w3.org/2000/svg";
                    case "math":
                        return "http://www.w3.org/1998/Math/MathML";
                    default:
                        return "http://www.w3.org/1999/xhtml";
                }
            }
            function pt(t1, e) {
                return null == t1 || "http://www.w3.org/1999/xhtml" === t1 ? dt(e) : "http://www.w3.org/2000/svg" === t1 && "foreignObject" === e ? "http://www.w3.org/1999/xhtml" : t1;
            }
            var ft, At, gt = (At = function(t1, e) {
                if (t1.namespaceURI !== ht.svg || "innerHTML" in t1) t1.innerHTML = e;
                else {
                    for((ft = ft || document.createElement("div")).innerHTML = "<svg>" + e.valueOf().toString() + "</svg>", e = ft.firstChild; t1.firstChild;)t1.removeChild(t1.firstChild);
                    for(; e.firstChild;)t1.appendChild(e.firstChild);
                }
            }, "undefined" != typeof MSApp && MSApp.execUnsafeLocalFunction ? function(t1, e, i, n) {
                MSApp.execUnsafeLocalFunction(function() {
                    return At(t1, e);
                });
            } : At);
            function mt(t1, e) {
                if (e) {
                    var i = t1.firstChild;
                    if (i && i === t1.lastChild && 3 === i.nodeType) return void (i.nodeValue = e);
                }
                t1.textContent = e;
            }
            var Mt = {
                animationIterationCount: !0,
                borderImageOutset: !0,
                borderImageSlice: !0,
                borderImageWidth: !0,
                boxFlex: !0,
                boxFlexGroup: !0,
                boxOrdinalGroup: !0,
                columnCount: !0,
                columns: !0,
                flex: !0,
                flexGrow: !0,
                flexPositive: !0,
                flexShrink: !0,
                flexNegative: !0,
                flexOrder: !0,
                gridArea: !0,
                gridRow: !0,
                gridRowEnd: !0,
                gridRowSpan: !0,
                gridRowStart: !0,
                gridColumn: !0,
                gridColumnEnd: !0,
                gridColumnSpan: !0,
                gridColumnStart: !0,
                fontWeight: !0,
                lineClamp: !0,
                lineHeight: !0,
                opacity: !0,
                order: !0,
                orphans: !0,
                tabSize: !0,
                widows: !0,
                zIndex: !0,
                zoom: !0,
                fillOpacity: !0,
                floodOpacity: !0,
                stopOpacity: !0,
                strokeDasharray: !0,
                strokeDashoffset: !0,
                strokeMiterlimit: !0,
                strokeOpacity: !0,
                strokeWidth: !0
            }, yt = [
                "Webkit",
                "ms",
                "Moz",
                "O"
            ];
            function vt(t1, e, i) {
                return null == e || "boolean" == typeof e || "" === e ? "" : i || "number" != typeof e || 0 === e || Mt.hasOwnProperty(t1) && Mt[t1] ? ("" + e).trim() : e + "px";
            }
            function xt(t1, e) {
                for(var i in t1 = t1.style, e)if (e.hasOwnProperty(i)) {
                    var n = 0 === i.indexOf("--"), r = vt(i, e[i], n);
                    "float" === i && (i = "cssFloat"), n ? t1.setProperty(i, r) : t1[i] = r;
                }
            }
            Object.keys(Mt).forEach(function(t1) {
                yt.forEach(function(e) {
                    e = e + t1.charAt(0).toUpperCase() + t1.substring(1), Mt[e] = Mt[t1];
                });
            });
            var wt = r({
                menuitem: !0
            }, {
                area: !0,
                base: !0,
                br: !0,
                col: !0,
                embed: !0,
                hr: !0,
                img: !0,
                input: !0,
                keygen: !0,
                link: !0,
                meta: !0,
                param: !0,
                source: !0,
                track: !0,
                wbr: !0
            });
            function bt(t1, e) {
                if (e) {
                    if (wt[t1] && (null != e.children || null != e.dangerouslySetInnerHTML)) throw Error(s(137, t1));
                    if (null != e.dangerouslySetInnerHTML) {
                        if (null != e.children) throw Error(s(60));
                        if ("object" != typeof e.dangerouslySetInnerHTML || !("__html" in e.dangerouslySetInnerHTML)) throw Error(s(61));
                    }
                    if (null != e.style && "object" != typeof e.style) throw Error(s(62));
                }
            }
            function Tt(t1, e) {
                if (-1 === t1.indexOf("-")) return "string" == typeof e.is;
                switch(t1){
                    case "annotation-xml":
                    case "color-profile":
                    case "font-face":
                    case "font-face-src":
                    case "font-face-uri":
                    case "font-face-format":
                    case "font-face-name":
                    case "missing-glyph":
                        return !1;
                    default:
                        return !0;
                }
            }
            function Et(t1) {
                return (t1 = t1.target || t1.srcElement || window).correspondingUseElement && (t1 = t1.correspondingUseElement), 3 === t1.nodeType ? t1.parentNode : t1;
            }
            var It = null, St = null, Nt = null;
            function Dt(t1) {
                if (t1 = ir(t1)) {
                    if ("function" != typeof It) throw Error(s(280));
                    var e = t1.stateNode;
                    e && (e = rr(e), It(t1.stateNode, t1.type, e));
                }
            }
            function Ct(t1) {
                St ? Nt ? Nt.push(t1) : Nt = [
                    t1
                ] : St = t1;
            }
            function zt() {
                if (St) {
                    var t1 = St, e = Nt;
                    if (Nt = St = null, Dt(t1), e) for(t1 = 0; t1 < e.length; t1++)Dt(e[t1]);
                }
            }
            function Lt(t1, e) {
                return t1(e);
            }
            function Ot(t1, e, i, n, r) {
                return t1(e, i, n, r);
            }
            function _t() {}
            var jt = Lt, Pt = !1, Rt = !1;
            function Ut() {
                null === St && null === Nt || (_t(), zt());
            }
            function kt(t1, e) {
                var i = t1.stateNode;
                if (null === i) return null;
                var n = rr(i);
                if (null === n) return null;
                i = n[e];
                t: switch(e){
                    case "onClick":
                    case "onClickCapture":
                    case "onDoubleClick":
                    case "onDoubleClickCapture":
                    case "onMouseDown":
                    case "onMouseDownCapture":
                    case "onMouseMove":
                    case "onMouseMoveCapture":
                    case "onMouseUp":
                    case "onMouseUpCapture":
                    case "onMouseEnter":
                        (n = !n.disabled) || (n = !("button" === (t1 = t1.type) || "input" === t1 || "select" === t1 || "textarea" === t1)), t1 = !n;
                        break t;
                    default:
                        t1 = !1;
                }
                if (t1) return null;
                if (i && "function" != typeof i) throw Error(s(231, e, typeof i));
                return i;
            }
            var Bt = !1;
            if (h) try {
                var Ft = {};
                Object.defineProperty(Ft, "passive", {
                    get: function() {
                        Bt = !0;
                    }
                }), window.addEventListener("test", Ft, Ft), window.removeEventListener("test", Ft, Ft);
            } catch (At) {
                Bt = !1;
            }
            function Qt(t1, e, i, n, r, a, s, o, l) {
                var c = Array.prototype.slice.call(arguments, 3);
                try {
                    e.apply(i, c);
                } catch (t1) {
                    this.onError(t1);
                }
            }
            var Ht = !1, Vt = null, Gt = !1, Yt = null, Wt = {
                onError: function(t1) {
                    Ht = !0, Vt = t1;
                }
            };
            function Xt(t1, e, i, n, r, a, s, o, l) {
                Ht = !1, Vt = null, Qt.apply(Wt, arguments);
            }
            function Zt(t1) {
                var e = t1, i = t1;
                if (t1.alternate) for(; e.return;)e = e.return;
                else {
                    t1 = e;
                    do !!(1026 & (e = t1).flags) && (i = e.return), t1 = e.return;
                    while (t1);
                }
                return 3 === e.tag ? i : null;
            }
            function Jt(t1) {
                if (13 === t1.tag) {
                    var e = t1.memoizedState;
                    if (null === e && null !== (t1 = t1.alternate) && (e = t1.memoizedState), null !== e) return e.dehydrated;
                }
                return null;
            }
            function Kt(t1) {
                if (Zt(t1) !== t1) throw Error(s(188));
            }
            function qt(t1) {
                if (t1 = function(t1) {
                    var e = t1.alternate;
                    if (!e) {
                        if (null === (e = Zt(t1))) throw Error(s(188));
                        return e !== t1 ? null : t1;
                    }
                    for(var i = t1, n = e;;){
                        var r = i.return;
                        if (null === r) break;
                        var a = r.alternate;
                        if (null === a) {
                            if (null !== (n = r.return)) {
                                i = n;
                                continue;
                            }
                            break;
                        }
                        if (r.child === a.child) {
                            for(a = r.child; a;){
                                if (a === i) return Kt(r), t1;
                                if (a === n) return Kt(r), e;
                                a = a.sibling;
                            }
                            throw Error(s(188));
                        }
                        if (i.return !== n.return) i = r, n = a;
                        else {
                            for(var o = !1, l = r.child; l;){
                                if (l === i) {
                                    o = !0, i = r, n = a;
                                    break;
                                }
                                if (l === n) {
                                    o = !0, n = r, i = a;
                                    break;
                                }
                                l = l.sibling;
                            }
                            if (!o) {
                                for(l = a.child; l;){
                                    if (l === i) {
                                        o = !0, i = a, n = r;
                                        break;
                                    }
                                    if (l === n) {
                                        o = !0, n = a, i = r;
                                        break;
                                    }
                                    l = l.sibling;
                                }
                                if (!o) throw Error(s(189));
                            }
                        }
                        if (i.alternate !== n) throw Error(s(190));
                    }
                    if (3 !== i.tag) throw Error(s(188));
                    return i.stateNode.current === i ? t1 : e;
                }(t1), !t1) return null;
                for(var e = t1;;){
                    if (5 === e.tag || 6 === e.tag) return e;
                    if (e.child) e.child.return = e, e = e.child;
                    else {
                        if (e === t1) break;
                        for(; !e.sibling;){
                            if (!e.return || e.return === t1) return null;
                            e = e.return;
                        }
                        e.sibling.return = e.return, e = e.sibling;
                    }
                }
                return null;
            }
            function $t(t1, e) {
                for(var i = t1.alternate; null !== e;){
                    if (e === t1 || e === i) return !0;
                    e = e.return;
                }
                return !1;
            }
            var te, ee, ie, ne, re = !1, ae = [], se = null, oe = null, le = null, ce = new Map, ue = new Map, he = [], de = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
            function pe(t1, e, i, n, r) {
                return {
                    blockedOn: t1,
                    domEventName: e,
                    eventSystemFlags: 16 | i,
                    nativeEvent: r,
                    targetContainers: [
                        n
                    ]
                };
            }
            function fe(t1, e) {
                switch(t1){
                    case "focusin":
                    case "focusout":
                        se = null;
                        break;
                    case "dragenter":
                    case "dragleave":
                        oe = null;
                        break;
                    case "mouseover":
                    case "mouseout":
                        le = null;
                        break;
                    case "pointerover":
                    case "pointerout":
                        ce.delete(e.pointerId);
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                        ue.delete(e.pointerId);
                }
            }
            function Ae(t1, e, i, n, r, a) {
                return null === t1 || t1.nativeEvent !== a ? (t1 = pe(e, i, n, r, a), null !== e && null !== (e = ir(e)) && ee(e), t1) : (t1.eventSystemFlags |= n, e = t1.targetContainers, null !== r && -1 === e.indexOf(r) && e.push(r), t1);
            }
            function ge(t1) {
                var e = er(t1.target);
                if (null !== e) {
                    var i = Zt(e);
                    if (null !== i) {
                        if (13 === (e = i.tag)) {
                            if (null !== (e = Jt(i))) return t1.blockedOn = e, void ne(t1.lanePriority, function() {
                                a.unstable_runWithPriority(t1.priority, function() {
                                    ie(i);
                                });
                            });
                        } else if (3 === e && i.stateNode.hydrate) return void (t1.blockedOn = 3 === i.tag ? i.stateNode.containerInfo : null);
                    }
                }
                t1.blockedOn = null;
            }
            function me(t1) {
                if (null !== t1.blockedOn) return !1;
                for(var e = t1.targetContainers; 0 < e.length;){
                    var i = qe(t1.domEventName, t1.eventSystemFlags, e[0], t1.nativeEvent);
                    if (null !== i) return null !== (e = ir(i)) && ee(e), t1.blockedOn = i, !1;
                    e.shift();
                }
                return !0;
            }
            function Me(t1, e, i) {
                me(t1) && i.delete(e);
            }
            function ye() {
                for(re = !1; 0 < ae.length;){
                    var t1 = ae[0];
                    if (null !== t1.blockedOn) {
                        null !== (t1 = ir(t1.blockedOn)) && te(t1);
                        break;
                    }
                    for(var e = t1.targetContainers; 0 < e.length;){
                        var i = qe(t1.domEventName, t1.eventSystemFlags, e[0], t1.nativeEvent);
                        if (null !== i) {
                            t1.blockedOn = i;
                            break;
                        }
                        e.shift();
                    }
                    null === t1.blockedOn && ae.shift();
                }
                null !== se && me(se) && (se = null), null !== oe && me(oe) && (oe = null), null !== le && me(le) && (le = null), ce.forEach(Me), ue.forEach(Me);
            }
            function ve(t1, e) {
                t1.blockedOn === e && (t1.blockedOn = null, re || (re = !0, a.unstable_scheduleCallback(a.unstable_NormalPriority, ye)));
            }
            function xe(t1) {
                function e(e) {
                    return ve(e, t1);
                }
                if (0 < ae.length) {
                    ve(ae[0], t1);
                    for(var i = 1; i < ae.length; i++){
                        var n = ae[i];
                        n.blockedOn === t1 && (n.blockedOn = null);
                    }
                }
                for(null !== se && ve(se, t1), null !== oe && ve(oe, t1), null !== le && ve(le, t1), ce.forEach(e), ue.forEach(e), i = 0; i < he.length; i++)(n = he[i]).blockedOn === t1 && (n.blockedOn = null);
                for(; 0 < he.length && null === (i = he[0]).blockedOn;)ge(i), null === i.blockedOn && he.shift();
            }
            function we(t1, e) {
                var i = {};
                return i[t1.toLowerCase()] = e.toLowerCase(), i["Webkit" + t1] = "webkit" + e, i["Moz" + t1] = "moz" + e, i;
            }
            var be = {
                animationend: we("Animation", "AnimationEnd"),
                animationiteration: we("Animation", "AnimationIteration"),
                animationstart: we("Animation", "AnimationStart"),
                transitionend: we("Transition", "TransitionEnd")
            }, Te = {}, Ee = {};
            function Ie(t1) {
                if (Te[t1]) return Te[t1];
                if (!be[t1]) return t1;
                var e, i = be[t1];
                for(e in i)if (i.hasOwnProperty(e) && e in Ee) return Te[t1] = i[e];
                return t1;
            }
            h && (Ee = document.createElement("div").style, "AnimationEvent" in window || (delete be.animationend.animation, delete be.animationiteration.animation, delete be.animationstart.animation), "TransitionEvent" in window || delete be.transitionend.transition);
            var Se = Ie("animationend"), Ne = Ie("animationiteration"), De = Ie("animationstart"), Ce = Ie("transitionend"), ze = new Map, Le = new Map, Oe = [
                "abort",
                "abort",
                Se,
                "animationEnd",
                Ne,
                "animationIteration",
                De,
                "animationStart",
                "canplay",
                "canPlay",
                "canplaythrough",
                "canPlayThrough",
                "durationchange",
                "durationChange",
                "emptied",
                "emptied",
                "encrypted",
                "encrypted",
                "ended",
                "ended",
                "error",
                "error",
                "gotpointercapture",
                "gotPointerCapture",
                "load",
                "load",
                "loadeddata",
                "loadedData",
                "loadedmetadata",
                "loadedMetadata",
                "loadstart",
                "loadStart",
                "lostpointercapture",
                "lostPointerCapture",
                "playing",
                "playing",
                "progress",
                "progress",
                "seeking",
                "seeking",
                "stalled",
                "stalled",
                "suspend",
                "suspend",
                "timeupdate",
                "timeUpdate",
                Ce,
                "transitionEnd",
                "waiting",
                "waiting"
            ];
            function _e(t1, e) {
                for(var i = 0; i < t1.length; i += 2){
                    var n = t1[i], r = t1[i + 1];
                    r = "on" + (r[0].toUpperCase() + r.slice(1)), Le.set(n, e), ze.set(n, r), c(r, [
                        n
                    ]);
                }
            }
            (0, a.unstable_now)();
            var je = 8;
            function Pe(t1) {
                if (1 & t1) return je = 15, 1;
                if (2 & t1) return je = 14, 2;
                if (4 & t1) return je = 13, 4;
                var e = 24 & t1;
                return 0 !== e ? (je = 12, e) : 32 & t1 ? (je = 11, 32) : 0 != (e = 192 & t1) ? (je = 10, e) : 256 & t1 ? (je = 9, 256) : 0 != (e = 3584 & t1) ? (je = 8, e) : 4096 & t1 ? (je = 7, 4096) : 0 != (e = 4186112 & t1) ? (je = 6, e) : 0 != (e = 62914560 & t1) ? (je = 5, e) : 67108864 & t1 ? (je = 4, 67108864) : 134217728 & t1 ? (je = 3, 134217728) : 0 != (e = 805306368 & t1) ? (je = 2, e) : 1073741824 & t1 ? (je = 1, 1073741824) : (je = 8, t1);
            }
            function Re(t1, e) {
                var i = t1.pendingLanes;
                if (0 === i) return je = 0;
                var n = 0, r = 0, a = t1.expiredLanes, s = t1.suspendedLanes, o = t1.pingedLanes;
                if (0 !== a) n = a, r = je = 15;
                else if (0 != (a = 134217727 & i)) {
                    var l = a & ~s;
                    0 !== l ? (n = Pe(l), r = je) : 0 != (o &= a) && (n = Pe(o), r = je);
                } else 0 != (a = i & ~s) ? (n = Pe(a), r = je) : 0 !== o && (n = Pe(o), r = je);
                if (0 === n) return 0;
                if (n = i & ((0 > (n = 31 - He(n)) ? 0 : 1 << n) << 1) - 1, 0 !== e && e !== n && !(e & s)) {
                    if (Pe(e), r <= je) return e;
                    je = r;
                }
                if (0 !== (e = t1.entangledLanes)) for(t1 = t1.entanglements, e &= n; 0 < e;)r = 1 << (i = 31 - He(e)), n |= t1[i], e &= ~r;
                return n;
            }
            function Ue(t1) {
                return 0 != (t1 = -1073741825 & t1.pendingLanes) ? t1 : 1073741824 & t1 ? 1073741824 : 0;
            }
            function ke(t1, e) {
                switch(t1){
                    case 15:
                        return 1;
                    case 14:
                        return 2;
                    case 12:
                        return 0 === (t1 = Be(24 & ~e)) ? ke(10, e) : t1;
                    case 10:
                        return 0 === (t1 = Be(192 & ~e)) ? ke(8, e) : t1;
                    case 8:
                        return 0 === (t1 = Be(3584 & ~e)) && 0 === (t1 = Be(4186112 & ~e)) && (t1 = 512), t1;
                    case 2:
                        return 0 === (e = Be(805306368 & ~e)) && (e = 268435456), e;
                }
                throw Error(s(358, t1));
            }
            function Be(t1) {
                return t1 & -t1;
            }
            function Fe(t1) {
                for(var e = [], i = 0; 31 > i; i++)e.push(t1);
                return e;
            }
            function Qe(t1, e, i) {
                t1.pendingLanes |= e;
                var n = e - 1;
                t1.suspendedLanes &= n, t1.pingedLanes &= n, (t1 = t1.eventTimes)[e = 31 - He(e)] = i;
            }
            var He = Math.clz32 ? Math.clz32 : function(t1) {
                return 0 === t1 ? 32 : 31 - (Ve(t1) / Ge | 0) | 0;
            }, Ve = Math.log, Ge = Math.LN2, Ye = a.unstable_UserBlockingPriority, We = a.unstable_runWithPriority, Xe = !0;
            function Ze(t1, e, i, n) {
                Pt || _t();
                var r = Ke, a = Pt;
                Pt = !0;
                try {
                    Ot(r, t1, e, i, n);
                } finally{
                    (Pt = a) || Ut();
                }
            }
            function Je(t1, e, i, n) {
                We(Ye, Ke.bind(null, t1, e, i, n));
            }
            function Ke(t1, e, i, n) {
                var r;
                if (Xe) {
                    if ((r = !(4 & e)) && 0 < ae.length && -1 < de.indexOf(t1)) t1 = pe(null, t1, e, i, n), ae.push(t1);
                    else {
                        var a = qe(t1, e, i, n);
                        if (null === a) r && fe(t1, n);
                        else {
                            if (r) {
                                if (-1 < de.indexOf(t1)) return t1 = pe(a, t1, e, i, n), void ae.push(t1);
                                if (function(t1, e, i, n, r) {
                                    switch(e){
                                        case "focusin":
                                            return se = Ae(se, t1, e, i, n, r), !0;
                                        case "dragenter":
                                            return oe = Ae(oe, t1, e, i, n, r), !0;
                                        case "mouseover":
                                            return le = Ae(le, t1, e, i, n, r), !0;
                                        case "pointerover":
                                            var a = r.pointerId;
                                            return ce.set(a, Ae(ce.get(a) || null, t1, e, i, n, r)), !0;
                                        case "gotpointercapture":
                                            return a = r.pointerId, ue.set(a, Ae(ue.get(a) || null, t1, e, i, n, r)), !0;
                                    }
                                    return !1;
                                }(a, t1, e, i, n)) return;
                                fe(t1, n);
                            }
                            _n(t1, e, n, null, i);
                        }
                    }
                }
            }
            function qe(t1, e, i, n) {
                var r = Et(n);
                if (null !== (r = er(r))) {
                    var a = Zt(r);
                    if (null === a) r = null;
                    else {
                        var s = a.tag;
                        if (13 === s) {
                            if (null !== (r = Jt(a))) return r;
                            r = null;
                        } else if (3 === s) {
                            if (a.stateNode.hydrate) return 3 === a.tag ? a.stateNode.containerInfo : null;
                            r = null;
                        } else a !== r && (r = null);
                    }
                }
                return _n(t1, e, n, r, i), null;
            }
            var $e = null, ti = null, ei = null;
            function ii() {
                if (ei) return ei;
                var t1, e, i = ti, n = i.length, r = "value" in $e ? $e.value : $e.textContent, a = r.length;
                for(t1 = 0; t1 < n && i[t1] === r[t1]; t1++);
                var s = n - t1;
                for(e = 1; e <= s && i[n - e] === r[a - e]; e++);
                return ei = r.slice(t1, 1 < e ? 1 - e : void 0);
            }
            function ni(t1) {
                var e = t1.keyCode;
                return "charCode" in t1 ? 0 === (t1 = t1.charCode) && 13 === e && (t1 = 13) : t1 = e, 10 === t1 && (t1 = 13), 32 <= t1 || 13 === t1 ? t1 : 0;
            }
            function ri() {
                return !0;
            }
            function ai() {
                return !1;
            }
            function si(t1) {
                function e(e, i, n, r, a) {
                    for(var s in this._reactName = e, this._targetInst = n, this.type = i, this.nativeEvent = r, this.target = a, this.currentTarget = null, t1)t1.hasOwnProperty(s) && (e = t1[s], this[s] = e ? e(r) : r[s]);
                    return this.isDefaultPrevented = (null != r.defaultPrevented ? r.defaultPrevented : !1 === r.returnValue) ? ri : ai, this.isPropagationStopped = ai, this;
                }
                return r(e.prototype, {
                    preventDefault: function() {
                        this.defaultPrevented = !0;
                        var t1 = this.nativeEvent;
                        t1 && (t1.preventDefault ? t1.preventDefault() : "unknown" != typeof t1.returnValue && (t1.returnValue = !1), this.isDefaultPrevented = ri);
                    },
                    stopPropagation: function() {
                        var t1 = this.nativeEvent;
                        t1 && (t1.stopPropagation ? t1.stopPropagation() : "unknown" != typeof t1.cancelBubble && (t1.cancelBubble = !0), this.isPropagationStopped = ri);
                    },
                    persist: function() {},
                    isPersistent: ri
                }), e;
            }
            var oi, li, ci, ui = {
                eventPhase: 0,
                bubbles: 0,
                cancelable: 0,
                timeStamp: function(t1) {
                    return t1.timeStamp || Date.now();
                },
                defaultPrevented: 0,
                isTrusted: 0
            }, hi = si(ui), di = r({}, ui, {
                view: 0,
                detail: 0
            }), pi = si(di), fi = r({}, di, {
                screenX: 0,
                screenY: 0,
                clientX: 0,
                clientY: 0,
                pageX: 0,
                pageY: 0,
                ctrlKey: 0,
                shiftKey: 0,
                altKey: 0,
                metaKey: 0,
                getModifierState: Ii,
                button: 0,
                buttons: 0,
                relatedTarget: function(t1) {
                    return void 0 === t1.relatedTarget ? t1.fromElement === t1.srcElement ? t1.toElement : t1.fromElement : t1.relatedTarget;
                },
                movementX: function(t1) {
                    return "movementX" in t1 ? t1.movementX : (t1 !== ci && (ci && "mousemove" === t1.type ? (oi = t1.screenX - ci.screenX, li = t1.screenY - ci.screenY) : li = oi = 0, ci = t1), oi);
                },
                movementY: function(t1) {
                    return "movementY" in t1 ? t1.movementY : li;
                }
            }), Ai = si(fi), gi = si(r({}, fi, {
                dataTransfer: 0
            })), mi = si(r({}, di, {
                relatedTarget: 0
            })), Mi = si(r({}, ui, {
                animationName: 0,
                elapsedTime: 0,
                pseudoElement: 0
            })), yi = r({}, ui, {
                clipboardData: function(t1) {
                    return "clipboardData" in t1 ? t1.clipboardData : window.clipboardData;
                }
            }), vi = si(yi), xi = si(r({}, ui, {
                data: 0
            })), wi = {
                Esc: "Escape",
                Spacebar: " ",
                Left: "ArrowLeft",
                Up: "ArrowUp",
                Right: "ArrowRight",
                Down: "ArrowDown",
                Del: "Delete",
                Win: "OS",
                Menu: "ContextMenu",
                Apps: "ContextMenu",
                Scroll: "ScrollLock",
                MozPrintableKey: "Unidentified"
            }, bi = {
                8: "Backspace",
                9: "Tab",
                12: "Clear",
                13: "Enter",
                16: "Shift",
                17: "Control",
                18: "Alt",
                19: "Pause",
                20: "CapsLock",
                27: "Escape",
                32: " ",
                33: "PageUp",
                34: "PageDown",
                35: "End",
                36: "Home",
                37: "ArrowLeft",
                38: "ArrowUp",
                39: "ArrowRight",
                40: "ArrowDown",
                45: "Insert",
                46: "Delete",
                112: "F1",
                113: "F2",
                114: "F3",
                115: "F4",
                116: "F5",
                117: "F6",
                118: "F7",
                119: "F8",
                120: "F9",
                121: "F10",
                122: "F11",
                123: "F12",
                144: "NumLock",
                145: "ScrollLock",
                224: "Meta"
            }, Ti = {
                Alt: "altKey",
                Control: "ctrlKey",
                Meta: "metaKey",
                Shift: "shiftKey"
            };
            function Ei(t1) {
                var e = this.nativeEvent;
                return e.getModifierState ? e.getModifierState(t1) : !!(t1 = Ti[t1]) && !!e[t1];
            }
            function Ii() {
                return Ei;
            }
            var Si = r({}, di, {
                key: function(t1) {
                    if (t1.key) {
                        var e = wi[t1.key] || t1.key;
                        if ("Unidentified" !== e) return e;
                    }
                    return "keypress" === t1.type ? 13 === (t1 = ni(t1)) ? "Enter" : String.fromCharCode(t1) : "keydown" === t1.type || "keyup" === t1.type ? bi[t1.keyCode] || "Unidentified" : "";
                },
                code: 0,
                location: 0,
                ctrlKey: 0,
                shiftKey: 0,
                altKey: 0,
                metaKey: 0,
                repeat: 0,
                locale: 0,
                getModifierState: Ii,
                charCode: function(t1) {
                    return "keypress" === t1.type ? ni(t1) : 0;
                },
                keyCode: function(t1) {
                    return "keydown" === t1.type || "keyup" === t1.type ? t1.keyCode : 0;
                },
                which: function(t1) {
                    return "keypress" === t1.type ? ni(t1) : "keydown" === t1.type || "keyup" === t1.type ? t1.keyCode : 0;
                }
            }), Ni = si(Si), Di = si(r({}, fi, {
                pointerId: 0,
                width: 0,
                height: 0,
                pressure: 0,
                tangentialPressure: 0,
                tiltX: 0,
                tiltY: 0,
                twist: 0,
                pointerType: 0,
                isPrimary: 0
            })), Ci = si(r({}, di, {
                touches: 0,
                targetTouches: 0,
                changedTouches: 0,
                altKey: 0,
                metaKey: 0,
                ctrlKey: 0,
                shiftKey: 0,
                getModifierState: Ii
            })), zi = si(r({}, ui, {
                propertyName: 0,
                elapsedTime: 0,
                pseudoElement: 0
            })), Li = r({}, fi, {
                deltaX: function(t1) {
                    return "deltaX" in t1 ? t1.deltaX : "wheelDeltaX" in t1 ? -t1.wheelDeltaX : 0;
                },
                deltaY: function(t1) {
                    return "deltaY" in t1 ? t1.deltaY : "wheelDeltaY" in t1 ? -t1.wheelDeltaY : "wheelDelta" in t1 ? -t1.wheelDelta : 0;
                },
                deltaZ: 0,
                deltaMode: 0
            }), Oi = si(Li), _i = [
                9,
                13,
                27,
                32
            ], ji = h && "CompositionEvent" in window, Pi = null;
            h && "documentMode" in document && (Pi = document.documentMode);
            var Ri = h && "TextEvent" in window && !Pi, Ui = h && (!ji || Pi && 8 < Pi && 11 >= Pi), ki = String.fromCharCode(32), Bi = !1;
            function Fi(t1, e) {
                switch(t1){
                    case "keyup":
                        return -1 !== _i.indexOf(e.keyCode);
                    case "keydown":
                        return 229 !== e.keyCode;
                    case "keypress":
                    case "mousedown":
                    case "focusout":
                        return !0;
                    default:
                        return !1;
                }
            }
            function Qi(t1) {
                return "object" == typeof (t1 = t1.detail) && "data" in t1 ? t1.data : null;
            }
            var Hi = !1, Vi = {
                color: !0,
                date: !0,
                datetime: !0,
                "datetime-local": !0,
                email: !0,
                month: !0,
                number: !0,
                password: !0,
                range: !0,
                search: !0,
                tel: !0,
                text: !0,
                time: !0,
                url: !0,
                week: !0
            };
            function Gi(t1) {
                var e = t1 && t1.nodeName && t1.nodeName.toLowerCase();
                return "input" === e ? !!Vi[t1.type] : "textarea" === e;
            }
            function Yi(t1, e, i, n) {
                Ct(n), 0 < (e = Pn(e, "onChange")).length && (i = new hi("onChange", "change", null, i, n), t1.push({
                    event: i,
                    listeners: e
                }));
            }
            var Wi = null, Xi = null;
            function Zi(t1) {
                Nn(t1, 0);
            }
            function Ji(t1) {
                if (K(nr(t1))) return t1;
            }
            function Ki(t1, e) {
                if ("change" === t1) return e;
            }
            var qi = !1;
            if (h) {
                var $i;
                if (h) {
                    var tn = "oninput" in document;
                    if (!tn) {
                        var en = document.createElement("div");
                        en.setAttribute("oninput", "return;"), tn = "function" == typeof en.oninput;
                    }
                    $i = tn;
                } else $i = !1;
                qi = $i && (!document.documentMode || 9 < document.documentMode);
            }
            function nn() {
                Wi && (Wi.detachEvent("onpropertychange", rn), Xi = Wi = null);
            }
            function rn(t1) {
                if ("value" === t1.propertyName && Ji(Xi)) {
                    var e = [];
                    if (Yi(e, Xi, t1, Et(t1)), t1 = Zi, Pt) t1(e);
                    else {
                        Pt = !0;
                        try {
                            Lt(t1, e);
                        } finally{
                            Pt = !1, Ut();
                        }
                    }
                }
            }
            function an(t1, e, i) {
                "focusin" === t1 ? (nn(), Xi = i, (Wi = e).attachEvent("onpropertychange", rn)) : "focusout" === t1 && nn();
            }
            function sn(t1) {
                if ("selectionchange" === t1 || "keyup" === t1 || "keydown" === t1) return Ji(Xi);
            }
            function on(t1, e) {
                if ("click" === t1) return Ji(e);
            }
            function ln(t1, e) {
                if ("input" === t1 || "change" === t1) return Ji(e);
            }
            var cn = "function" == typeof Object.is ? Object.is : function(t1, e) {
                return t1 === e && (0 !== t1 || 1 / t1 == 1 / e) || t1 != t1 && e != e;
            }, un = Object.prototype.hasOwnProperty;
            function hn(t1, e) {
                if (cn(t1, e)) return !0;
                if ("object" != typeof t1 || null === t1 || "object" != typeof e || null === e) return !1;
                var i = Object.keys(t1), n = Object.keys(e);
                if (i.length !== n.length) return !1;
                for(n = 0; n < i.length; n++)if (!un.call(e, i[n]) || !cn(t1[i[n]], e[i[n]])) return !1;
                return !0;
            }
            function dn(t1) {
                for(; t1 && t1.firstChild;)t1 = t1.firstChild;
                return t1;
            }
            function pn(t1, e) {
                var i, n = dn(t1);
                for(t1 = 0; n;){
                    if (3 === n.nodeType) {
                        if (i = t1 + n.textContent.length, t1 <= e && i >= e) return {
                            node: n,
                            offset: e - t1
                        };
                        t1 = i;
                    }
                    t: {
                        for(; n;){
                            if (n.nextSibling) {
                                n = n.nextSibling;
                                break t;
                            }
                            n = n.parentNode;
                        }
                        n = void 0;
                    }
                    n = dn(n);
                }
            }
            function fn(t1, e) {
                return !(!t1 || !e) && (t1 === e || (!t1 || 3 !== t1.nodeType) && (e && 3 === e.nodeType ? fn(t1, e.parentNode) : "contains" in t1 ? t1.contains(e) : !!t1.compareDocumentPosition && !!(16 & t1.compareDocumentPosition(e))));
            }
            function An() {
                for(var t1 = window, e = q(); e instanceof t1.HTMLIFrameElement;){
                    try {
                        var i = "string" == typeof e.contentWindow.location.href;
                    } catch (t1) {
                        i = !1;
                    }
                    if (!i) break;
                    e = q((t1 = e.contentWindow).document);
                }
                return e;
            }
            function gn(t1) {
                var e = t1 && t1.nodeName && t1.nodeName.toLowerCase();
                return e && ("input" === e && ("text" === t1.type || "search" === t1.type || "tel" === t1.type || "url" === t1.type || "password" === t1.type) || "textarea" === e || "true" === t1.contentEditable);
            }
            var mn = h && "documentMode" in document && 11 >= document.documentMode, Mn = null, yn = null, vn = null, xn = !1;
            function wn(t1, e, i) {
                var n = i.window === i ? i.document : 9 === i.nodeType ? i : i.ownerDocument;
                xn || null == Mn || Mn !== q(n) || (n = "selectionStart" in (n = Mn) && gn(n) ? {
                    start: n.selectionStart,
                    end: n.selectionEnd
                } : {
                    anchorNode: (n = (n.ownerDocument && n.ownerDocument.defaultView || window).getSelection()).anchorNode,
                    anchorOffset: n.anchorOffset,
                    focusNode: n.focusNode,
                    focusOffset: n.focusOffset
                }, vn && hn(vn, n) || (vn = n, 0 < (n = Pn(yn, "onSelect")).length && (e = new hi("onSelect", "select", null, e, i), t1.push({
                    event: e,
                    listeners: n
                }), e.target = Mn)));
            }
            _e("cancel cancel click click close close contextmenu contextMenu copy copy cut cut auxclick auxClick dblclick doubleClick dragend dragEnd dragstart dragStart drop drop focusin focus focusout blur input input invalid invalid keydown keyDown keypress keyPress keyup keyUp mousedown mouseDown mouseup mouseUp paste paste pause pause play play pointercancel pointerCancel pointerdown pointerDown pointerup pointerUp ratechange rateChange reset reset seeked seeked submit submit touchcancel touchCancel touchend touchEnd touchstart touchStart volumechange volumeChange".split(" "), 0), _e("drag drag dragenter dragEnter dragexit dragExit dragleave dragLeave dragover dragOver mousemove mouseMove mouseout mouseOut mouseover mouseOver pointermove pointerMove pointerout pointerOut pointerover pointerOver scroll scroll toggle toggle touchmove touchMove wheel wheel".split(" "), 1), _e(Oe, 2);
            for(var bn = "change selectionchange textInput compositionstart compositionend compositionupdate".split(" "), Tn = 0; Tn < bn.length; Tn++)Le.set(bn[Tn], 0);
            u("onMouseEnter", [
                "mouseout",
                "mouseover"
            ]), u("onMouseLeave", [
                "mouseout",
                "mouseover"
            ]), u("onPointerEnter", [
                "pointerout",
                "pointerover"
            ]), u("onPointerLeave", [
                "pointerout",
                "pointerover"
            ]), c("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" ")), c("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" ")), c("onBeforeInput", [
                "compositionend",
                "keypress",
                "textInput",
                "paste"
            ]), c("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" ")), c("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" ")), c("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
            var En = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), In = new Set("cancel close invalid load scroll toggle".split(" ").concat(En));
            function Sn(t1, e, i) {
                var n = t1.type || "unknown-event";
                t1.currentTarget = i, function(t1, e, i, n, r, a, o, l, c) {
                    if (Xt.apply(this, arguments), Ht) {
                        if (!Ht) throw Error(s(198));
                        var u = Vt;
                        Ht = !1, Vt = null, Gt || (Gt = !0, Yt = u);
                    }
                }(n, e, void 0, t1), t1.currentTarget = null;
            }
            function Nn(t1, e) {
                e = !!(4 & e);
                for(var i = 0; i < t1.length; i++){
                    var n = t1[i], r = n.event;
                    n = n.listeners;
                    t: {
                        var a = void 0;
                        if (e) for(var s = n.length - 1; 0 <= s; s--){
                            var o = n[s], l = o.instance, c = o.currentTarget;
                            if (o = o.listener, l !== a && r.isPropagationStopped()) break t;
                            Sn(r, o, c), a = l;
                        }
                        else for(s = 0; s < n.length; s++){
                            if (l = (o = n[s]).instance, c = o.currentTarget, o = o.listener, l !== a && r.isPropagationStopped()) break t;
                            Sn(r, o, c), a = l;
                        }
                    }
                }
                if (Gt) throw t1 = Yt, Gt = !1, Yt = null, t1;
            }
            function Dn(t1, e) {
                var i = ar(e), n = t1 + "__bubble";
                i.has(n) || (On(e, t1, 2, !1), i.add(n));
            }
            var Cn = "_reactListening" + Math.random().toString(36).slice(2);
            function zn(t1) {
                t1[Cn] || (t1[Cn] = !0, o.forEach(function(e) {
                    In.has(e) || Ln(e, !1, t1, null), Ln(e, !0, t1, null);
                }));
            }
            function Ln(t1, e, i, n) {
                var r = 4 < arguments.length && void 0 !== arguments[4] ? arguments[4] : 0, a = i;
                if ("selectionchange" === t1 && 9 !== i.nodeType && (a = i.ownerDocument), null !== n && !e && In.has(t1)) {
                    if ("scroll" !== t1) return;
                    r |= 2, a = n;
                }
                var s = ar(a), o = t1 + "__" + (e ? "capture" : "bubble");
                s.has(o) || (e && (r |= 4), On(a, t1, r, e), s.add(o));
            }
            function On(t1, e, i, n) {
                var r = Le.get(e);
                switch(void 0 === r ? 2 : r){
                    case 0:
                        r = Ze;
                        break;
                    case 1:
                        r = Je;
                        break;
                    default:
                        r = Ke;
                }
                i = r.bind(null, e, i, t1), r = void 0, !Bt || "touchstart" !== e && "touchmove" !== e && "wheel" !== e || (r = !0), n ? void 0 !== r ? t1.addEventListener(e, i, {
                    capture: !0,
                    passive: r
                }) : t1.addEventListener(e, i, !0) : void 0 !== r ? t1.addEventListener(e, i, {
                    passive: r
                }) : t1.addEventListener(e, i, !1);
            }
            function _n(t1, e, i, n, r) {
                var a = n;
                if (!(1 & e || 2 & e || null === n)) t: for(;;){
                    if (null === n) return;
                    var s = n.tag;
                    if (3 === s || 4 === s) {
                        var o = n.stateNode.containerInfo;
                        if (o === r || 8 === o.nodeType && o.parentNode === r) break;
                        if (4 === s) for(s = n.return; null !== s;){
                            var l = s.tag;
                            if ((3 === l || 4 === l) && ((l = s.stateNode.containerInfo) === r || 8 === l.nodeType && l.parentNode === r)) return;
                            s = s.return;
                        }
                        for(; null !== o;){
                            if (null === (s = er(o))) return;
                            if (5 === (l = s.tag) || 6 === l) {
                                n = a = s;
                                continue t;
                            }
                            o = o.parentNode;
                        }
                    }
                    n = n.return;
                }
                !function(t1, e, i) {
                    if (Rt) return t1();
                    Rt = !0;
                    try {
                        return jt(t1, e, i);
                    } finally{
                        Rt = !1, Ut();
                    }
                }(function() {
                    var n = a, r = Et(i), s = [];
                    t: {
                        var o = ze.get(t1);
                        if (void 0 !== o) {
                            var l = hi, c = t1;
                            switch(t1){
                                case "keypress":
                                    if (0 === ni(i)) break t;
                                case "keydown":
                                case "keyup":
                                    l = Ni;
                                    break;
                                case "focusin":
                                    c = "focus", l = mi;
                                    break;
                                case "focusout":
                                    c = "blur", l = mi;
                                    break;
                                case "beforeblur":
                                case "afterblur":
                                    l = mi;
                                    break;
                                case "click":
                                    if (2 === i.button) break t;
                                case "auxclick":
                                case "dblclick":
                                case "mousedown":
                                case "mousemove":
                                case "mouseup":
                                case "mouseout":
                                case "mouseover":
                                case "contextmenu":
                                    l = Ai;
                                    break;
                                case "drag":
                                case "dragend":
                                case "dragenter":
                                case "dragexit":
                                case "dragleave":
                                case "dragover":
                                case "dragstart":
                                case "drop":
                                    l = gi;
                                    break;
                                case "touchcancel":
                                case "touchend":
                                case "touchmove":
                                case "touchstart":
                                    l = Ci;
                                    break;
                                case Se:
                                case Ne:
                                case De:
                                    l = Mi;
                                    break;
                                case Ce:
                                    l = zi;
                                    break;
                                case "scroll":
                                    l = pi;
                                    break;
                                case "wheel":
                                    l = Oi;
                                    break;
                                case "copy":
                                case "cut":
                                case "paste":
                                    l = vi;
                                    break;
                                case "gotpointercapture":
                                case "lostpointercapture":
                                case "pointercancel":
                                case "pointerdown":
                                case "pointermove":
                                case "pointerout":
                                case "pointerover":
                                case "pointerup":
                                    l = Di;
                            }
                            var u = !!(4 & e), h = !u && "scroll" === t1, d = u ? null !== o ? o + "Capture" : null : o;
                            u = [];
                            for(var p, f = n; null !== f;){
                                var A = (p = f).stateNode;
                                if (5 === p.tag && null !== A && (p = A, null !== d && null != (A = kt(f, d)) && u.push(jn(f, A, p))), h) break;
                                f = f.return;
                            }
                            0 < u.length && (o = new l(o, c, null, i, r), s.push({
                                event: o,
                                listeners: u
                            }));
                        }
                    }
                    if (!(7 & e)) {
                        if (l = "mouseout" === t1 || "pointerout" === t1, (!(o = "mouseover" === t1 || "pointerover" === t1) || 16 & e || !(c = i.relatedTarget || i.fromElement) || !er(c) && !c[$n]) && (l || o) && (o = r.window === r ? r : (o = r.ownerDocument) ? o.defaultView || o.parentWindow : window, l ? (l = n, null !== (c = (c = i.relatedTarget || i.toElement) ? er(c) : null) && (c !== (h = Zt(c)) || 5 !== c.tag && 6 !== c.tag) && (c = null)) : (l = null, c = n), l !== c)) {
                            if (u = Ai, A = "onMouseLeave", d = "onMouseEnter", f = "mouse", "pointerout" !== t1 && "pointerover" !== t1 || (u = Di, A = "onPointerLeave", d = "onPointerEnter", f = "pointer"), h = null == l ? o : nr(l), p = null == c ? o : nr(c), (o = new u(A, f + "leave", l, i, r)).target = h, o.relatedTarget = p, A = null, er(r) === n && ((u = new u(d, f + "enter", c, i, r)).target = p, u.relatedTarget = h, A = u), h = A, l && c) t: {
                                for(d = c, f = 0, p = u = l; p; p = Rn(p))f++;
                                for(p = 0, A = d; A; A = Rn(A))p++;
                                for(; 0 < f - p;)u = Rn(u), f--;
                                for(; 0 < p - f;)d = Rn(d), p--;
                                for(; f--;){
                                    if (u === d || null !== d && u === d.alternate) break t;
                                    u = Rn(u), d = Rn(d);
                                }
                                u = null;
                            }
                            else u = null;
                            null !== l && Un(s, o, l, u, !1), null !== c && null !== h && Un(s, h, c, u, !0);
                        }
                        if ("select" === (l = (o = n ? nr(n) : window).nodeName && o.nodeName.toLowerCase()) || "input" === l && "file" === o.type) var g = Ki;
                        else if (Gi(o)) {
                            if (qi) g = ln;
                            else {
                                g = sn;
                                var m = an;
                            }
                        } else (l = o.nodeName) && "input" === l.toLowerCase() && ("checkbox" === o.type || "radio" === o.type) && (g = on);
                        switch(g && (g = g(t1, n)) ? Yi(s, g, i, r) : (m && m(t1, o, n), "focusout" === t1 && (m = o._wrapperState) && m.controlled && "number" === o.type && rt(o, "number", o.value)), m = n ? nr(n) : window, t1){
                            case "focusin":
                                (Gi(m) || "true" === m.contentEditable) && (Mn = m, yn = n, vn = null);
                                break;
                            case "focusout":
                                vn = yn = Mn = null;
                                break;
                            case "mousedown":
                                xn = !0;
                                break;
                            case "contextmenu":
                            case "mouseup":
                            case "dragend":
                                xn = !1, wn(s, i, r);
                                break;
                            case "selectionchange":
                                if (mn) break;
                            case "keydown":
                            case "keyup":
                                wn(s, i, r);
                        }
                        var M;
                        if (ji) t: {
                            switch(t1){
                                case "compositionstart":
                                    var y = "onCompositionStart";
                                    break t;
                                case "compositionend":
                                    y = "onCompositionEnd";
                                    break t;
                                case "compositionupdate":
                                    y = "onCompositionUpdate";
                                    break t;
                            }
                            y = void 0;
                        }
                        else Hi ? Fi(t1, i) && (y = "onCompositionEnd") : "keydown" === t1 && 229 === i.keyCode && (y = "onCompositionStart");
                        y && (Ui && "ko" !== i.locale && (Hi || "onCompositionStart" !== y ? "onCompositionEnd" === y && Hi && (M = ii()) : (ti = "value" in ($e = r) ? $e.value : $e.textContent, Hi = !0)), 0 < (m = Pn(n, y)).length && (y = new xi(y, t1, null, i, r), s.push({
                            event: y,
                            listeners: m
                        }), (M || null !== (M = Qi(i))) && (y.data = M))), (M = Ri ? function(t1, e) {
                            switch(t1){
                                case "compositionend":
                                    return Qi(e);
                                case "keypress":
                                    return 32 !== e.which ? null : (Bi = !0, ki);
                                case "textInput":
                                    return (t1 = e.data) === ki && Bi ? null : t1;
                                default:
                                    return null;
                            }
                        }(t1, i) : function(t1, e) {
                            if (Hi) return "compositionend" === t1 || !ji && Fi(t1, e) ? (t1 = ii(), ei = ti = $e = null, Hi = !1, t1) : null;
                            switch(t1){
                                case "paste":
                                default:
                                    return null;
                                case "keypress":
                                    if (!(e.ctrlKey || e.altKey || e.metaKey) || e.ctrlKey && e.altKey) {
                                        if (e.char && 1 < e.char.length) return e.char;
                                        if (e.which) return String.fromCharCode(e.which);
                                    }
                                    return null;
                                case "compositionend":
                                    return Ui && "ko" !== e.locale ? null : e.data;
                            }
                        }(t1, i)) && 0 < (n = Pn(n, "onBeforeInput")).length && (r = new xi("onBeforeInput", "beforeinput", null, i, r), s.push({
                            event: r,
                            listeners: n
                        }), r.data = M);
                    }
                    Nn(s, e);
                });
            }
            function jn(t1, e, i) {
                return {
                    instance: t1,
                    listener: e,
                    currentTarget: i
                };
            }
            function Pn(t1, e) {
                for(var i = e + "Capture", n = []; null !== t1;){
                    var r = t1, a = r.stateNode;
                    5 === r.tag && null !== a && (r = a, null != (a = kt(t1, i)) && n.unshift(jn(t1, a, r)), null != (a = kt(t1, e)) && n.push(jn(t1, a, r))), t1 = t1.return;
                }
                return n;
            }
            function Rn(t1) {
                if (null === t1) return null;
                do t1 = t1.return;
                while (t1 && 5 !== t1.tag);
                return t1 || null;
            }
            function Un(t1, e, i, n, r) {
                for(var a = e._reactName, s = []; null !== i && i !== n;){
                    var o = i, l = o.alternate, c = o.stateNode;
                    if (null !== l && l === n) break;
                    5 === o.tag && null !== c && (o = c, r ? null != (l = kt(i, a)) && s.unshift(jn(i, l, o)) : r || null != (l = kt(i, a)) && s.push(jn(i, l, o))), i = i.return;
                }
                0 !== s.length && t1.push({
                    event: e,
                    listeners: s
                });
            }
            function kn() {}
            var Bn = null, Fn = null;
            function Qn(t1, e) {
                switch(t1){
                    case "button":
                    case "input":
                    case "select":
                    case "textarea":
                        return !!e.autoFocus;
                }
                return !1;
            }
            function Hn(t1, e) {
                return "textarea" === t1 || "option" === t1 || "noscript" === t1 || "string" == typeof e.children || "number" == typeof e.children || "object" == typeof e.dangerouslySetInnerHTML && null !== e.dangerouslySetInnerHTML && null != e.dangerouslySetInnerHTML.__html;
            }
            var Vn = "function" == typeof setTimeout ? setTimeout : void 0, Gn = "function" == typeof clearTimeout ? clearTimeout : void 0;
            function Yn(t1) {
                (1 === t1.nodeType || 9 === t1.nodeType && null != (t1 = t1.body)) && (t1.textContent = "");
            }
            function Wn(t1) {
                for(; null != t1; t1 = t1.nextSibling){
                    var e = t1.nodeType;
                    if (1 === e || 3 === e) break;
                }
                return t1;
            }
            function Xn(t1) {
                t1 = t1.previousSibling;
                for(var e = 0; t1;){
                    if (8 === t1.nodeType) {
                        var i = t1.data;
                        if ("$" === i || "$!" === i || "$?" === i) {
                            if (0 === e) return t1;
                            e--;
                        } else "/$" === i && e++;
                    }
                    t1 = t1.previousSibling;
                }
                return null;
            }
            var Zn = 0, Jn = Math.random().toString(36).slice(2), Kn = "__reactFiber$" + Jn, qn = "__reactProps$" + Jn, $n = "__reactContainer$" + Jn, tr = "__reactEvents$" + Jn;
            function er(t1) {
                var e = t1[Kn];
                if (e) return e;
                for(var i = t1.parentNode; i;){
                    if (e = i[$n] || i[Kn]) {
                        if (i = e.alternate, null !== e.child || null !== i && null !== i.child) for(t1 = Xn(t1); null !== t1;){
                            if (i = t1[Kn]) return i;
                            t1 = Xn(t1);
                        }
                        return e;
                    }
                    i = (t1 = i).parentNode;
                }
                return null;
            }
            function ir(t1) {
                return !(t1 = t1[Kn] || t1[$n]) || 5 !== t1.tag && 6 !== t1.tag && 13 !== t1.tag && 3 !== t1.tag ? null : t1;
            }
            function nr(t1) {
                if (5 === t1.tag || 6 === t1.tag) return t1.stateNode;
                throw Error(s(33));
            }
            function rr(t1) {
                return t1[qn] || null;
            }
            function ar(t1) {
                var e = t1[tr];
                return void 0 === e && (e = t1[tr] = new Set), e;
            }
            var sr = [], or = -1;
            function lr(t1) {
                return {
                    current: t1
                };
            }
            function cr(t1) {
                0 > or || (t1.current = sr[or], sr[or] = null, or--);
            }
            function ur(t1, e) {
                or++, sr[or] = t1.current, t1.current = e;
            }
            var hr = {}, dr = lr(hr), pr = lr(!1), fr = hr;
            function Ar(t1, e) {
                var i = t1.type.contextTypes;
                if (!i) return hr;
                var n = t1.stateNode;
                if (n && n.__reactInternalMemoizedUnmaskedChildContext === e) return n.__reactInternalMemoizedMaskedChildContext;
                var r, a = {};
                for(r in i)a[r] = e[r];
                return n && ((t1 = t1.stateNode).__reactInternalMemoizedUnmaskedChildContext = e, t1.__reactInternalMemoizedMaskedChildContext = a), a;
            }
            function gr(t1) {
                return null != t1.childContextTypes;
            }
            function mr() {
                cr(pr), cr(dr);
            }
            function Mr(t1, e, i) {
                if (dr.current !== hr) throw Error(s(168));
                ur(dr, e), ur(pr, i);
            }
            function yr(t1, e, i) {
                var n = t1.stateNode;
                if (t1 = e.childContextTypes, "function" != typeof n.getChildContext) return i;
                for(var a in n = n.getChildContext())if (!(a in t1)) throw Error(s(108, W(e) || "Unknown", a));
                return r({}, i, n);
            }
            function vr(t1) {
                return t1 = (t1 = t1.stateNode) && t1.__reactInternalMemoizedMergedChildContext || hr, fr = dr.current, ur(dr, t1), ur(pr, pr.current), !0;
            }
            function xr(t1, e, i) {
                var n = t1.stateNode;
                if (!n) throw Error(s(169));
                i ? (t1 = yr(t1, e, fr), n.__reactInternalMemoizedMergedChildContext = t1, cr(pr), cr(dr), ur(dr, t1)) : cr(pr), ur(pr, i);
            }
            var wr = null, br = null, Tr = a.unstable_runWithPriority, Er = a.unstable_scheduleCallback, Ir = a.unstable_cancelCallback, Sr = a.unstable_shouldYield, Nr = a.unstable_requestPaint, Dr = a.unstable_now, Cr = a.unstable_getCurrentPriorityLevel, zr = a.unstable_ImmediatePriority, Lr = a.unstable_UserBlockingPriority, Or = a.unstable_NormalPriority, _r = a.unstable_LowPriority, jr = a.unstable_IdlePriority, Pr = {}, Rr = void 0 !== Nr ? Nr : function() {}, Ur = null, kr = null, Br = !1, Fr = Dr(), Qr = 1e4 > Fr ? Dr : function() {
                return Dr() - Fr;
            };
            function Hr() {
                switch(Cr()){
                    case zr:
                        return 99;
                    case Lr:
                        return 98;
                    case Or:
                        return 97;
                    case _r:
                        return 96;
                    case jr:
                        return 95;
                    default:
                        throw Error(s(332));
                }
            }
            function Vr(t1) {
                switch(t1){
                    case 99:
                        return zr;
                    case 98:
                        return Lr;
                    case 97:
                        return Or;
                    case 96:
                        return _r;
                    case 95:
                        return jr;
                    default:
                        throw Error(s(332));
                }
            }
            function Gr(t1, e) {
                return t1 = Vr(t1), Tr(t1, e);
            }
            function Yr(t1, e, i) {
                return t1 = Vr(t1), Er(t1, e, i);
            }
            function Wr() {
                if (null !== kr) {
                    var t1 = kr;
                    kr = null, Ir(t1);
                }
                Xr();
            }
            function Xr() {
                if (!Br && null !== Ur) {
                    Br = !0;
                    var t1 = 0;
                    try {
                        var e = Ur;
                        Gr(99, function() {
                            for(; t1 < e.length; t1++){
                                var i = e[t1];
                                do i = i(!0);
                                while (null !== i);
                            }
                        }), Ur = null;
                    } catch (e) {
                        throw null !== Ur && (Ur = Ur.slice(t1 + 1)), Er(zr, Wr), e;
                    } finally{
                        Br = !1;
                    }
                }
            }
            var Zr = x.ReactCurrentBatchConfig;
            function Jr(t1, e) {
                if (t1 && t1.defaultProps) {
                    for(var i in e = r({}, e), t1 = t1.defaultProps)void 0 === e[i] && (e[i] = t1[i]);
                    return e;
                }
                return e;
            }
            var Kr = lr(null), qr = null, $r = null, ta = null;
            function ea() {
                ta = $r = qr = null;
            }
            function ia(t1) {
                var e = Kr.current;
                cr(Kr), t1.type._context._currentValue = e;
            }
            function na(t1, e) {
                for(; null !== t1;){
                    var i = t1.alternate;
                    if ((t1.childLanes & e) === e) {
                        if (null === i || (i.childLanes & e) === e) break;
                        i.childLanes |= e;
                    } else t1.childLanes |= e, null !== i && (i.childLanes |= e);
                    t1 = t1.return;
                }
            }
            function ra(t1, e) {
                qr = t1, ta = $r = null, null !== (t1 = t1.dependencies) && null !== t1.firstContext && (!!(t1.lanes & e) && (js = !0), t1.firstContext = null);
            }
            function aa(t1, e) {
                if (ta !== t1 && !1 !== e && 0 !== e) {
                    if ("number" == typeof e && 1073741823 !== e || (ta = t1, e = 1073741823), e = {
                        context: t1,
                        observedBits: e,
                        next: null
                    }, null === $r) {
                        if (null === qr) throw Error(s(308));
                        $r = e, qr.dependencies = {
                            lanes: 0,
                            firstContext: e,
                            responders: null
                        };
                    } else $r = $r.next = e;
                }
                return t1._currentValue;
            }
            var sa = !1;
            function oa(t1) {
                t1.updateQueue = {
                    baseState: t1.memoizedState,
                    firstBaseUpdate: null,
                    lastBaseUpdate: null,
                    shared: {
                        pending: null
                    },
                    effects: null
                };
            }
            function la(t1, e) {
                t1 = t1.updateQueue, e.updateQueue === t1 && (e.updateQueue = {
                    baseState: t1.baseState,
                    firstBaseUpdate: t1.firstBaseUpdate,
                    lastBaseUpdate: t1.lastBaseUpdate,
                    shared: t1.shared,
                    effects: t1.effects
                });
            }
            function ca(t1, e) {
                return {
                    eventTime: t1,
                    lane: e,
                    tag: 0,
                    payload: null,
                    callback: null,
                    next: null
                };
            }
            function ua(t1, e) {
                if (null !== (t1 = t1.updateQueue)) {
                    var i = (t1 = t1.shared).pending;
                    null === i ? e.next = e : (e.next = i.next, i.next = e), t1.pending = e;
                }
            }
            function ha(t1, e) {
                var i = t1.updateQueue, n = t1.alternate;
                if (null !== n && i === (n = n.updateQueue)) {
                    var r = null, a = null;
                    if (null !== (i = i.firstBaseUpdate)) {
                        do {
                            var s = {
                                eventTime: i.eventTime,
                                lane: i.lane,
                                tag: i.tag,
                                payload: i.payload,
                                callback: i.callback,
                                next: null
                            };
                            null === a ? r = a = s : a = a.next = s, i = i.next;
                        }while (null !== i);
                        null === a ? r = a = e : a = a.next = e;
                    } else r = a = e;
                    return i = {
                        baseState: n.baseState,
                        firstBaseUpdate: r,
                        lastBaseUpdate: a,
                        shared: n.shared,
                        effects: n.effects
                    }, void (t1.updateQueue = i);
                }
                null === (t1 = i.lastBaseUpdate) ? i.firstBaseUpdate = e : t1.next = e, i.lastBaseUpdate = e;
            }
            function da(t1, e, i, n) {
                var a = t1.updateQueue;
                sa = !1;
                var s = a.firstBaseUpdate, o = a.lastBaseUpdate, l = a.shared.pending;
                if (null !== l) {
                    a.shared.pending = null;
                    var c = l, u = c.next;
                    c.next = null, null === o ? s = u : o.next = u, o = c;
                    var h = t1.alternate;
                    if (null !== h) {
                        var d = (h = h.updateQueue).lastBaseUpdate;
                        d !== o && (null === d ? h.firstBaseUpdate = u : d.next = u, h.lastBaseUpdate = c);
                    }
                }
                if (null !== s) {
                    for(d = a.baseState, o = 0, h = u = c = null;;){
                        l = s.lane;
                        var p = s.eventTime;
                        if ((n & l) === l) {
                            null !== h && (h = h.next = {
                                eventTime: p,
                                lane: 0,
                                tag: s.tag,
                                payload: s.payload,
                                callback: s.callback,
                                next: null
                            });
                            t: {
                                var f = t1, A = s;
                                switch(l = e, p = i, A.tag){
                                    case 1:
                                        if ("function" == typeof (f = A.payload)) {
                                            d = f.call(p, d, l);
                                            break t;
                                        }
                                        d = f;
                                        break t;
                                    case 3:
                                        f.flags = -4097 & f.flags | 64;
                                    case 0:
                                        if (null == (l = "function" == typeof (f = A.payload) ? f.call(p, d, l) : f)) break t;
                                        d = r({}, d, l);
                                        break t;
                                    case 2:
                                        sa = !0;
                                }
                            }
                            null !== s.callback && (t1.flags |= 32, null === (l = a.effects) ? a.effects = [
                                s
                            ] : l.push(s));
                        } else p = {
                            eventTime: p,
                            lane: l,
                            tag: s.tag,
                            payload: s.payload,
                            callback: s.callback,
                            next: null
                        }, null === h ? (u = h = p, c = d) : h = h.next = p, o |= l;
                        if (null === (s = s.next)) {
                            if (null === (l = a.shared.pending)) break;
                            s = l.next, l.next = null, a.lastBaseUpdate = l, a.shared.pending = null;
                        }
                    }
                    null === h && (c = d), a.baseState = c, a.firstBaseUpdate = u, a.lastBaseUpdate = h, ko |= o, t1.lanes = o, t1.memoizedState = d;
                }
            }
            function pa(t1, e, i) {
                if (t1 = e.effects, e.effects = null, null !== t1) for(e = 0; e < t1.length; e++){
                    var n = t1[e], r = n.callback;
                    if (null !== r) {
                        if (n.callback = null, n = i, "function" != typeof r) throw Error(s(191, r));
                        r.call(n);
                    }
                }
            }
            var fa = (new n.Component).refs;
            function Aa(t1, e, i, n) {
                i = null == (i = i(n, e = t1.memoizedState)) ? e : r({}, e, i), t1.memoizedState = i, 0 === t1.lanes && (t1.updateQueue.baseState = i);
            }
            var ga = {
                isMounted: function(t1) {
                    return !!(t1 = t1._reactInternals) && Zt(t1) === t1;
                },
                enqueueSetState: function(t1, e, i) {
                    t1 = t1._reactInternals;
                    var n = ul(), r = hl(t1), a = ca(n, r);
                    a.payload = e, null != i && (a.callback = i), ua(t1, a), dl(t1, r, n);
                },
                enqueueReplaceState: function(t1, e, i) {
                    t1 = t1._reactInternals;
                    var n = ul(), r = hl(t1), a = ca(n, r);
                    a.tag = 1, a.payload = e, null != i && (a.callback = i), ua(t1, a), dl(t1, r, n);
                },
                enqueueForceUpdate: function(t1, e) {
                    t1 = t1._reactInternals;
                    var i = ul(), n = hl(t1), r = ca(i, n);
                    r.tag = 2, null != e && (r.callback = e), ua(t1, r), dl(t1, n, i);
                }
            };
            function ma(t1, e, i, n, r, a, s) {
                return "function" == typeof (t1 = t1.stateNode).shouldComponentUpdate ? t1.shouldComponentUpdate(n, a, s) : !(e.prototype && e.prototype.isPureReactComponent && hn(i, n) && hn(r, a));
            }
            function Ma(t1, e, i) {
                var n = !1, r = hr, a = e.contextType;
                return "object" == typeof a && null !== a ? a = aa(a) : (r = gr(e) ? fr : dr.current, a = (n = null != (n = e.contextTypes)) ? Ar(t1, r) : hr), e = new e(i, a), t1.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, e.updater = ga, t1.stateNode = e, e._reactInternals = t1, n && ((t1 = t1.stateNode).__reactInternalMemoizedUnmaskedChildContext = r, t1.__reactInternalMemoizedMaskedChildContext = a), e;
            }
            function ya(t1, e, i, n) {
                t1 = e.state, "function" == typeof e.componentWillReceiveProps && e.componentWillReceiveProps(i, n), "function" == typeof e.UNSAFE_componentWillReceiveProps && e.UNSAFE_componentWillReceiveProps(i, n), e.state !== t1 && ga.enqueueReplaceState(e, e.state, null);
            }
            function va(t1, e, i, n) {
                var r = t1.stateNode;
                r.props = i, r.state = t1.memoizedState, r.refs = fa, oa(t1);
                var a = e.contextType;
                "object" == typeof a && null !== a ? r.context = aa(a) : (a = gr(e) ? fr : dr.current, r.context = Ar(t1, a)), da(t1, i, r, n), r.state = t1.memoizedState, "function" == typeof (a = e.getDerivedStateFromProps) && (Aa(t1, e, a, i), r.state = t1.memoizedState), "function" == typeof e.getDerivedStateFromProps || "function" == typeof r.getSnapshotBeforeUpdate || "function" != typeof r.UNSAFE_componentWillMount && "function" != typeof r.componentWillMount || (e = r.state, "function" == typeof r.componentWillMount && r.componentWillMount(), "function" == typeof r.UNSAFE_componentWillMount && r.UNSAFE_componentWillMount(), e !== r.state && ga.enqueueReplaceState(r, r.state, null), da(t1, i, r, n), r.state = t1.memoizedState), "function" == typeof r.componentDidMount && (t1.flags |= 4);
            }
            var xa = Array.isArray;
            function wa(t1, e, i) {
                if (null !== (t1 = i.ref) && "function" != typeof t1 && "object" != typeof t1) {
                    if (i._owner) {
                        if (i = i._owner) {
                            if (1 !== i.tag) throw Error(s(309));
                            var n = i.stateNode;
                        }
                        if (!n) throw Error(s(147, t1));
                        var r = "" + t1;
                        return null !== e && null !== e.ref && "function" == typeof e.ref && e.ref._stringRef === r ? e.ref : (e = function(t1) {
                            var e = n.refs;
                            e === fa && (e = n.refs = {}), null === t1 ? delete e[r] : e[r] = t1;
                        }, e._stringRef = r, e);
                    }
                    if ("string" != typeof t1) throw Error(s(284));
                    if (!i._owner) throw Error(s(290, t1));
                }
                return t1;
            }
            function ba(t1, e) {
                if ("textarea" !== t1.type) throw Error(s(31, "[object Object]" === Object.prototype.toString.call(e) ? "object with keys {" + Object.keys(e).join(", ") + "}" : e));
            }
            function Ta(t1) {
                function e(e, i) {
                    if (t1) {
                        var n = e.lastEffect;
                        null !== n ? (n.nextEffect = i, e.lastEffect = i) : e.firstEffect = e.lastEffect = i, i.nextEffect = null, i.flags = 8;
                    }
                }
                function i(i, n) {
                    if (!t1) return null;
                    for(; null !== n;)e(i, n), n = n.sibling;
                    return null;
                }
                function n(t1, e) {
                    for(t1 = new Map; null !== e;)null !== e.key ? t1.set(e.key, e) : t1.set(e.index, e), e = e.sibling;
                    return t1;
                }
                function r(t1, e) {
                    return (t1 = Vl(t1, e)).index = 0, t1.sibling = null, t1;
                }
                function a(e, i, n) {
                    return e.index = n, t1 ? null !== (n = e.alternate) ? (n = n.index) < i ? (e.flags = 2, i) : n : (e.flags = 2, i) : i;
                }
                function o(e) {
                    return t1 && null === e.alternate && (e.flags = 2), e;
                }
                function l(t1, e, i, n) {
                    return null === e || 6 !== e.tag ? ((e = Xl(i, t1.mode, n)).return = t1, e) : ((e = r(e, i)).return = t1, e);
                }
                function c(t1, e, i, n) {
                    return null !== e && e.elementType === i.type ? ((n = r(e, i.props)).ref = wa(t1, e, i), n.return = t1, n) : ((n = Gl(i.type, i.key, i.props, null, t1.mode, n)).ref = wa(t1, e, i), n.return = t1, n);
                }
                function u(t1, e, i, n) {
                    return null === e || 4 !== e.tag || e.stateNode.containerInfo !== i.containerInfo || e.stateNode.implementation !== i.implementation ? ((e = Zl(i, t1.mode, n)).return = t1, e) : ((e = r(e, i.children || [])).return = t1, e);
                }
                function h(t1, e, i, n, a) {
                    return null === e || 7 !== e.tag ? ((e = Yl(i, t1.mode, n, a)).return = t1, e) : ((e = r(e, i)).return = t1, e);
                }
                function d(t1, e, i) {
                    if ("string" == typeof e || "number" == typeof e) return (e = Xl("" + e, t1.mode, i)).return = t1, e;
                    if ("object" == typeof e && null !== e) {
                        switch(e.$$typeof){
                            case w:
                                return (i = Gl(e.type, e.key, e.props, null, t1.mode, i)).ref = wa(t1, null, e), i.return = t1, i;
                            case b:
                                return (e = Zl(e, t1.mode, i)).return = t1, e;
                        }
                        if (xa(e) || Q(e)) return (e = Yl(e, t1.mode, i, null)).return = t1, e;
                        ba(t1, e);
                    }
                    return null;
                }
                function p(t1, e, i, n) {
                    var r = null !== e ? e.key : null;
                    if ("string" == typeof i || "number" == typeof i) return null !== r ? null : l(t1, e, "" + i, n);
                    if ("object" == typeof i && null !== i) {
                        switch(i.$$typeof){
                            case w:
                                return i.key === r ? i.type === T ? h(t1, e, i.props.children, n, r) : c(t1, e, i, n) : null;
                            case b:
                                return i.key === r ? u(t1, e, i, n) : null;
                        }
                        if (xa(i) || Q(i)) return null !== r ? null : h(t1, e, i, n, null);
                        ba(t1, i);
                    }
                    return null;
                }
                function f(t1, e, i, n, r) {
                    if ("string" == typeof n || "number" == typeof n) return l(e, t1 = t1.get(i) || null, "" + n, r);
                    if ("object" == typeof n && null !== n) {
                        switch(n.$$typeof){
                            case w:
                                return t1 = t1.get(null === n.key ? i : n.key) || null, n.type === T ? h(e, t1, n.props.children, r, n.key) : c(e, t1, n, r);
                            case b:
                                return u(e, t1 = t1.get(null === n.key ? i : n.key) || null, n, r);
                        }
                        if (xa(n) || Q(n)) return h(e, t1 = t1.get(i) || null, n, r, null);
                        ba(e, n);
                    }
                    return null;
                }
                function A(r, s, o, l) {
                    for(var c = null, u = null, h = s, A = s = 0, g = null; null !== h && A < o.length; A++){
                        h.index > A ? (g = h, h = null) : g = h.sibling;
                        var m = p(r, h, o[A], l);
                        if (null === m) {
                            null === h && (h = g);
                            break;
                        }
                        t1 && h && null === m.alternate && e(r, h), s = a(m, s, A), null === u ? c = m : u.sibling = m, u = m, h = g;
                    }
                    if (A === o.length) return i(r, h), c;
                    if (null === h) {
                        for(; A < o.length; A++)null !== (h = d(r, o[A], l)) && (s = a(h, s, A), null === u ? c = h : u.sibling = h, u = h);
                        return c;
                    }
                    for(h = n(r, h); A < o.length; A++)null !== (g = f(h, r, A, o[A], l)) && (t1 && null !== g.alternate && h.delete(null === g.key ? A : g.key), s = a(g, s, A), null === u ? c = g : u.sibling = g, u = g);
                    return t1 && h.forEach(function(t1) {
                        return e(r, t1);
                    }), c;
                }
                function g(r, o, l, c) {
                    var u = Q(l);
                    if ("function" != typeof u) throw Error(s(150));
                    if (null == (l = u.call(l))) throw Error(s(151));
                    for(var h = u = null, A = o, g = o = 0, m = null, M = l.next(); null !== A && !M.done; g++, M = l.next()){
                        A.index > g ? (m = A, A = null) : m = A.sibling;
                        var y = p(r, A, M.value, c);
                        if (null === y) {
                            null === A && (A = m);
                            break;
                        }
                        t1 && A && null === y.alternate && e(r, A), o = a(y, o, g), null === h ? u = y : h.sibling = y, h = y, A = m;
                    }
                    if (M.done) return i(r, A), u;
                    if (null === A) {
                        for(; !M.done; g++, M = l.next())null !== (M = d(r, M.value, c)) && (o = a(M, o, g), null === h ? u = M : h.sibling = M, h = M);
                        return u;
                    }
                    for(A = n(r, A); !M.done; g++, M = l.next())null !== (M = f(A, r, g, M.value, c)) && (t1 && null !== M.alternate && A.delete(null === M.key ? g : M.key), o = a(M, o, g), null === h ? u = M : h.sibling = M, h = M);
                    return t1 && A.forEach(function(t1) {
                        return e(r, t1);
                    }), u;
                }
                return function(t1, n, a, l) {
                    var c = "object" == typeof a && null !== a && a.type === T && null === a.key;
                    c && (a = a.props.children);
                    var u = "object" == typeof a && null !== a;
                    if (u) switch(a.$$typeof){
                        case w:
                            t: {
                                for(u = a.key, c = n; null !== c;){
                                    if (c.key === u) {
                                        if (7 === c.tag) {
                                            if (a.type === T) {
                                                i(t1, c.sibling), (n = r(c, a.props.children)).return = t1, t1 = n;
                                                break t;
                                            }
                                        } else if (c.elementType === a.type) {
                                            i(t1, c.sibling), (n = r(c, a.props)).ref = wa(t1, c, a), n.return = t1, t1 = n;
                                            break t;
                                        }
                                        i(t1, c);
                                        break;
                                    }
                                    e(t1, c), c = c.sibling;
                                }
                                a.type === T ? ((n = Yl(a.props.children, t1.mode, l, a.key)).return = t1, t1 = n) : ((l = Gl(a.type, a.key, a.props, null, t1.mode, l)).ref = wa(t1, n, a), l.return = t1, t1 = l);
                            }
                            return o(t1);
                        case b:
                            t: {
                                for(c = a.key; null !== n;){
                                    if (n.key === c) {
                                        if (4 === n.tag && n.stateNode.containerInfo === a.containerInfo && n.stateNode.implementation === a.implementation) {
                                            i(t1, n.sibling), (n = r(n, a.children || [])).return = t1, t1 = n;
                                            break t;
                                        }
                                        i(t1, n);
                                        break;
                                    }
                                    e(t1, n), n = n.sibling;
                                }
                                (n = Zl(a, t1.mode, l)).return = t1, t1 = n;
                            }
                            return o(t1);
                    }
                    if ("string" == typeof a || "number" == typeof a) return a = "" + a, null !== n && 6 === n.tag ? (i(t1, n.sibling), (n = r(n, a)).return = t1, t1 = n) : (i(t1, n), (n = Xl(a, t1.mode, l)).return = t1, t1 = n), o(t1);
                    if (xa(a)) return A(t1, n, a, l);
                    if (Q(a)) return g(t1, n, a, l);
                    if (u && ba(t1, a), void 0 === a && !c) switch(t1.tag){
                        case 1:
                        case 22:
                        case 0:
                        case 11:
                        case 15:
                            throw Error(s(152, W(t1.type) || "Component"));
                    }
                    return i(t1, n);
                };
            }
            var Ea = Ta(!0), Ia = Ta(!1), Sa = {}, Na = lr(Sa), Da = lr(Sa), Ca = lr(Sa);
            function za(t1) {
                if (t1 === Sa) throw Error(s(174));
                return t1;
            }
            function La(t1, e) {
                switch(ur(Ca, e), ur(Da, t1), ur(Na, Sa), t1 = e.nodeType){
                    case 9:
                    case 11:
                        e = (e = e.documentElement) ? e.namespaceURI : pt(null, "");
                        break;
                    default:
                        e = pt(e = (t1 = 8 === t1 ? e.parentNode : e).namespaceURI || null, t1 = t1.tagName);
                }
                cr(Na), ur(Na, e);
            }
            function Oa() {
                cr(Na), cr(Da), cr(Ca);
            }
            function _a(t1) {
                za(Ca.current);
                var e = za(Na.current), i = pt(e, t1.type);
                e !== i && (ur(Da, t1), ur(Na, i));
            }
            function ja(t1) {
                Da.current === t1 && (cr(Na), cr(Da));
            }
            var Pa = lr(0);
            function Ra(t1) {
                for(var e = t1; null !== e;){
                    if (13 === e.tag) {
                        var i = e.memoizedState;
                        if (null !== i && (null === (i = i.dehydrated) || "$?" === i.data || "$!" === i.data)) return e;
                    } else if (19 === e.tag && void 0 !== e.memoizedProps.revealOrder) {
                        if (64 & e.flags) return e;
                    } else if (null !== e.child) {
                        e.child.return = e, e = e.child;
                        continue;
                    }
                    if (e === t1) break;
                    for(; null === e.sibling;){
                        if (null === e.return || e.return === t1) return null;
                        e = e.return;
                    }
                    e.sibling.return = e.return, e = e.sibling;
                }
                return null;
            }
            var Ua = null, ka = null, Ba = !1;
            function Fa(t1, e) {
                var i = Ql(5, null, null, 0);
                i.elementType = "DELETED", i.type = "DELETED", i.stateNode = e, i.return = t1, i.flags = 8, null !== t1.lastEffect ? (t1.lastEffect.nextEffect = i, t1.lastEffect = i) : t1.firstEffect = t1.lastEffect = i;
            }
            function Qa(t1, e) {
                switch(t1.tag){
                    case 5:
                        var i = t1.type;
                        return null !== (e = 1 !== e.nodeType || i.toLowerCase() !== e.nodeName.toLowerCase() ? null : e) && (t1.stateNode = e, !0);
                    case 6:
                        return null !== (e = "" === t1.pendingProps || 3 !== e.nodeType ? null : e) && (t1.stateNode = e, !0);
                    default:
                        return !1;
                }
            }
            function Ha(t1) {
                if (Ba) {
                    var e = ka;
                    if (e) {
                        var i = e;
                        if (!Qa(t1, e)) {
                            if (!(e = Wn(i.nextSibling)) || !Qa(t1, e)) return t1.flags = -1025 & t1.flags | 2, Ba = !1, void (Ua = t1);
                            Fa(Ua, i);
                        }
                        Ua = t1, ka = Wn(e.firstChild);
                    } else t1.flags = -1025 & t1.flags | 2, Ba = !1, Ua = t1;
                }
            }
            function Va(t1) {
                for(t1 = t1.return; null !== t1 && 5 !== t1.tag && 3 !== t1.tag && 13 !== t1.tag;)t1 = t1.return;
                Ua = t1;
            }
            function Ga(t1) {
                if (t1 !== Ua) return !1;
                if (!Ba) return Va(t1), Ba = !0, !1;
                var e = t1.type;
                if (5 !== t1.tag || "head" !== e && "body" !== e && !Hn(e, t1.memoizedProps)) for(e = ka; e;)Fa(t1, e), e = Wn(e.nextSibling);
                if (Va(t1), 13 === t1.tag) {
                    if (!(t1 = null !== (t1 = t1.memoizedState) ? t1.dehydrated : null)) throw Error(s(317));
                    t: {
                        for(t1 = t1.nextSibling, e = 0; t1;){
                            if (8 === t1.nodeType) {
                                var i = t1.data;
                                if ("/$" === i) {
                                    if (0 === e) {
                                        ka = Wn(t1.nextSibling);
                                        break t;
                                    }
                                    e--;
                                } else "$" !== i && "$!" !== i && "$?" !== i || e++;
                            }
                            t1 = t1.nextSibling;
                        }
                        ka = null;
                    }
                } else ka = Ua ? Wn(t1.stateNode.nextSibling) : null;
                return !0;
            }
            function Ya() {
                ka = Ua = null, Ba = !1;
            }
            var Wa = [];
            function Xa() {
                for(var t1 = 0; t1 < Wa.length; t1++)Wa[t1]._workInProgressVersionPrimary = null;
                Wa.length = 0;
            }
            var Za = x.ReactCurrentDispatcher, Ja = x.ReactCurrentBatchConfig, Ka = 0, qa = null, $a = null, ts = null, es = !1, is = !1;
            function ns() {
                throw Error(s(321));
            }
            function rs(t1, e) {
                if (null === e) return !1;
                for(var i = 0; i < e.length && i < t1.length; i++)if (!cn(t1[i], e[i])) return !1;
                return !0;
            }
            function as(t1, e, i, n, r, a) {
                if (Ka = a, qa = e, e.memoizedState = null, e.updateQueue = null, e.lanes = 0, Za.current = null === t1 || null === t1.memoizedState ? zs : Ls, t1 = i(n, r), is) {
                    a = 0;
                    do {
                        if (is = !1, !(25 > a)) throw Error(s(301));
                        a += 1, ts = $a = null, e.updateQueue = null, Za.current = Os, t1 = i(n, r);
                    }while (is);
                }
                if (Za.current = Cs, e = null !== $a && null !== $a.next, Ka = 0, ts = $a = qa = null, es = !1, e) throw Error(s(300));
                return t1;
            }
            function ss() {
                var t1 = {
                    memoizedState: null,
                    baseState: null,
                    baseQueue: null,
                    queue: null,
                    next: null
                };
                return null === ts ? qa.memoizedState = ts = t1 : ts = ts.next = t1, ts;
            }
            function os() {
                if (null === $a) {
                    var t1 = qa.alternate;
                    t1 = null !== t1 ? t1.memoizedState : null;
                } else t1 = $a.next;
                var e = null === ts ? qa.memoizedState : ts.next;
                if (null !== e) ts = e, $a = t1;
                else {
                    if (null === t1) throw Error(s(310));
                    t1 = {
                        memoizedState: ($a = t1).memoizedState,
                        baseState: $a.baseState,
                        baseQueue: $a.baseQueue,
                        queue: $a.queue,
                        next: null
                    }, null === ts ? qa.memoizedState = ts = t1 : ts = ts.next = t1;
                }
                return ts;
            }
            function ls(t1, e) {
                return "function" == typeof e ? e(t1) : e;
            }
            function cs(t1) {
                var e = os(), i = e.queue;
                if (null === i) throw Error(s(311));
                i.lastRenderedReducer = t1;
                var n = $a, r = n.baseQueue, a = i.pending;
                if (null !== a) {
                    if (null !== r) {
                        var o = r.next;
                        r.next = a.next, a.next = o;
                    }
                    n.baseQueue = r = a, i.pending = null;
                }
                if (null !== r) {
                    r = r.next, n = n.baseState;
                    var l = o = a = null, c = r;
                    do {
                        var u = c.lane;
                        if ((Ka & u) === u) null !== l && (l = l.next = {
                            lane: 0,
                            action: c.action,
                            eagerReducer: c.eagerReducer,
                            eagerState: c.eagerState,
                            next: null
                        }), n = c.eagerReducer === t1 ? c.eagerState : t1(n, c.action);
                        else {
                            var h = {
                                lane: u,
                                action: c.action,
                                eagerReducer: c.eagerReducer,
                                eagerState: c.eagerState,
                                next: null
                            };
                            null === l ? (o = l = h, a = n) : l = l.next = h, qa.lanes |= u, ko |= u;
                        }
                        c = c.next;
                    }while (null !== c && c !== r);
                    null === l ? a = n : l.next = o, cn(n, e.memoizedState) || (js = !0), e.memoizedState = n, e.baseState = a, e.baseQueue = l, i.lastRenderedState = n;
                }
                return [
                    e.memoizedState,
                    i.dispatch
                ];
            }
            function us(t1) {
                var e = os(), i = e.queue;
                if (null === i) throw Error(s(311));
                i.lastRenderedReducer = t1;
                var n = i.dispatch, r = i.pending, a = e.memoizedState;
                if (null !== r) {
                    i.pending = null;
                    var o = r = r.next;
                    do a = t1(a, o.action), o = o.next;
                    while (o !== r);
                    cn(a, e.memoizedState) || (js = !0), e.memoizedState = a, null === e.baseQueue && (e.baseState = a), i.lastRenderedState = a;
                }
                return [
                    a,
                    n
                ];
            }
            function hs(t1, e, i) {
                var n = e._getVersion;
                n = n(e._source);
                var r = e._workInProgressVersionPrimary;
                if (null !== r ? t1 = r === n : (t1 = t1.mutableReadLanes, (t1 = (Ka & t1) === t1) && (e._workInProgressVersionPrimary = n, Wa.push(e))), t1) return i(e._source);
                throw Wa.push(e), Error(s(350));
            }
            function ds(t1, e, i, n) {
                var r = zo;
                if (null === r) throw Error(s(349));
                var a = e._getVersion, o = a(e._source), l = Za.current, c = l.useState(function() {
                    return hs(r, e, i);
                }), u = c[1], h = c[0];
                c = ts;
                var d = t1.memoizedState, p = d.refs, f = p.getSnapshot, A = d.source;
                d = d.subscribe;
                var g = qa;
                return t1.memoizedState = {
                    refs: p,
                    source: e,
                    subscribe: n
                }, l.useEffect(function() {
                    p.getSnapshot = i, p.setSnapshot = u;
                    var t1 = a(e._source);
                    if (!cn(o, t1)) {
                        t1 = i(e._source), cn(h, t1) || (u(t1), t1 = hl(g), r.mutableReadLanes |= t1 & r.pendingLanes), t1 = r.mutableReadLanes, r.entangledLanes |= t1;
                        for(var n = r.entanglements, s = t1; 0 < s;){
                            var l = 31 - He(s), c = 1 << l;
                            n[l] |= t1, s &= ~c;
                        }
                    }
                }, [
                    i,
                    e,
                    n
                ]), l.useEffect(function() {
                    return n(e._source, function() {
                        var t1 = p.getSnapshot, i = p.setSnapshot;
                        try {
                            i(t1(e._source));
                            var n = hl(g);
                            r.mutableReadLanes |= n & r.pendingLanes;
                        } catch (t1) {
                            i(function() {
                                throw t1;
                            });
                        }
                    });
                }, [
                    e,
                    n
                ]), cn(f, i) && cn(A, e) && cn(d, n) || ((t1 = {
                    pending: null,
                    dispatch: null,
                    lastRenderedReducer: ls,
                    lastRenderedState: h
                }).dispatch = u = Ds.bind(null, qa, t1), c.queue = t1, c.baseQueue = null, h = hs(r, e, i), c.memoizedState = c.baseState = h), h;
            }
            function ps(t1, e, i) {
                return ds(os(), t1, e, i);
            }
            function fs(t1) {
                var e = ss();
                return "function" == typeof t1 && (t1 = t1()), e.memoizedState = e.baseState = t1, t1 = (t1 = e.queue = {
                    pending: null,
                    dispatch: null,
                    lastRenderedReducer: ls,
                    lastRenderedState: t1
                }).dispatch = Ds.bind(null, qa, t1), [
                    e.memoizedState,
                    t1
                ];
            }
            function As(t1, e, i, n) {
                return t1 = {
                    tag: t1,
                    create: e,
                    destroy: i,
                    deps: n,
                    next: null
                }, null === (e = qa.updateQueue) ? (e = {
                    lastEffect: null
                }, qa.updateQueue = e, e.lastEffect = t1.next = t1) : null === (i = e.lastEffect) ? e.lastEffect = t1.next = t1 : (n = i.next, i.next = t1, t1.next = n, e.lastEffect = t1), t1;
            }
            function gs(t1) {
                return t1 = {
                    current: t1
                }, ss().memoizedState = t1;
            }
            function ms() {
                return os().memoizedState;
            }
            function Ms(t1, e, i, n) {
                var r = ss();
                qa.flags |= t1, r.memoizedState = As(1 | e, i, void 0, void 0 === n ? null : n);
            }
            function ys(t1, e, i, n) {
                var r = os();
                n = void 0 === n ? null : n;
                var a = void 0;
                if (null !== $a) {
                    var s = $a.memoizedState;
                    if (a = s.destroy, null !== n && rs(n, s.deps)) return void As(e, i, a, n);
                }
                qa.flags |= t1, r.memoizedState = As(1 | e, i, a, n);
            }
            function vs(t1, e) {
                return Ms(516, 4, t1, e);
            }
            function xs(t1, e) {
                return ys(516, 4, t1, e);
            }
            function ws(t1, e) {
                return ys(4, 2, t1, e);
            }
            function bs(t1, e) {
                return "function" == typeof e ? (t1 = t1(), e(t1), function() {
                    e(null);
                }) : null != e ? (t1 = t1(), e.current = t1, function() {
                    e.current = null;
                }) : void 0;
            }
            function Ts(t1, e, i) {
                return i = null != i ? i.concat([
                    t1
                ]) : null, ys(4, 2, bs.bind(null, e, t1), i);
            }
            function Es() {}
            function Is(t1, e) {
                var i = os();
                e = void 0 === e ? null : e;
                var n = i.memoizedState;
                return null !== n && null !== e && rs(e, n[1]) ? n[0] : (i.memoizedState = [
                    t1,
                    e
                ], t1);
            }
            function Ss(t1, e) {
                var i = os();
                e = void 0 === e ? null : e;
                var n = i.memoizedState;
                return null !== n && null !== e && rs(e, n[1]) ? n[0] : (t1 = t1(), i.memoizedState = [
                    t1,
                    e
                ], t1);
            }
            function Ns(t1, e) {
                var i = Hr();
                Gr(98 > i ? 98 : i, function() {
                    t1(!0);
                }), Gr(97 < i ? 97 : i, function() {
                    var i = Ja.transition;
                    Ja.transition = 1;
                    try {
                        t1(!1), e();
                    } finally{
                        Ja.transition = i;
                    }
                });
            }
            function Ds(t1, e, i) {
                var n = ul(), r = hl(t1), a = {
                    lane: r,
                    action: i,
                    eagerReducer: null,
                    eagerState: null,
                    next: null
                }, s = e.pending;
                if (null === s ? a.next = a : (a.next = s.next, s.next = a), e.pending = a, s = t1.alternate, t1 === qa || null !== s && s === qa) is = es = !0;
                else {
                    if (0 === t1.lanes && (null === s || 0 === s.lanes) && null !== (s = e.lastRenderedReducer)) try {
                        var o = e.lastRenderedState, l = s(o, i);
                        if (a.eagerReducer = s, a.eagerState = l, cn(l, o)) return;
                    } catch (t1) {}
                    dl(t1, r, n);
                }
            }
            var Cs = {
                readContext: aa,
                useCallback: ns,
                useContext: ns,
                useEffect: ns,
                useImperativeHandle: ns,
                useLayoutEffect: ns,
                useMemo: ns,
                useReducer: ns,
                useRef: ns,
                useState: ns,
                useDebugValue: ns,
                useDeferredValue: ns,
                useTransition: ns,
                useMutableSource: ns,
                useOpaqueIdentifier: ns,
                unstable_isNewReconciler: !1
            }, zs = {
                readContext: aa,
                useCallback: function(t1, e) {
                    return ss().memoizedState = [
                        t1,
                        void 0 === e ? null : e
                    ], t1;
                },
                useContext: aa,
                useEffect: vs,
                useImperativeHandle: function(t1, e, i) {
                    return i = null != i ? i.concat([
                        t1
                    ]) : null, Ms(4, 2, bs.bind(null, e, t1), i);
                },
                useLayoutEffect: function(t1, e) {
                    return Ms(4, 2, t1, e);
                },
                useMemo: function(t1, e) {
                    var i = ss();
                    return e = void 0 === e ? null : e, t1 = t1(), i.memoizedState = [
                        t1,
                        e
                    ], t1;
                },
                useReducer: function(t1, e, i) {
                    var n = ss();
                    return e = void 0 !== i ? i(e) : e, n.memoizedState = n.baseState = e, t1 = (t1 = n.queue = {
                        pending: null,
                        dispatch: null,
                        lastRenderedReducer: t1,
                        lastRenderedState: e
                    }).dispatch = Ds.bind(null, qa, t1), [
                        n.memoizedState,
                        t1
                    ];
                },
                useRef: gs,
                useState: fs,
                useDebugValue: Es,
                useDeferredValue: function(t1) {
                    var e = fs(t1), i = e[0], n = e[1];
                    return vs(function() {
                        var e = Ja.transition;
                        Ja.transition = 1;
                        try {
                            n(t1);
                        } finally{
                            Ja.transition = e;
                        }
                    }, [
                        t1
                    ]), i;
                },
                useTransition: function() {
                    var t1 = fs(!1), e = t1[0];
                    return gs(t1 = Ns.bind(null, t1[1])), [
                        t1,
                        e
                    ];
                },
                useMutableSource: function(t1, e, i) {
                    var n = ss();
                    return n.memoizedState = {
                        refs: {
                            getSnapshot: e,
                            setSnapshot: null
                        },
                        source: t1,
                        subscribe: i
                    }, ds(n, t1, e, i);
                },
                useOpaqueIdentifier: function() {
                    if (Ba) {
                        var t1 = !1, e = function(t1) {
                            return {
                                $$typeof: j,
                                toString: t1,
                                valueOf: t1
                            };
                        }(function() {
                            throw t1 || (t1 = !0, i("r:" + (Zn++).toString(36))), Error(s(355));
                        }), i = fs(e)[1];
                        return !(2 & qa.mode) && (qa.flags |= 516, As(5, function() {
                            i("r:" + (Zn++).toString(36));
                        }, void 0, null)), e;
                    }
                    return fs(e = "r:" + (Zn++).toString(36)), e;
                },
                unstable_isNewReconciler: !1
            }, Ls = {
                readContext: aa,
                useCallback: Is,
                useContext: aa,
                useEffect: xs,
                useImperativeHandle: Ts,
                useLayoutEffect: ws,
                useMemo: Ss,
                useReducer: cs,
                useRef: ms,
                useState: function() {
                    return cs(ls);
                },
                useDebugValue: Es,
                useDeferredValue: function(t1) {
                    var e = cs(ls), i = e[0], n = e[1];
                    return xs(function() {
                        var e = Ja.transition;
                        Ja.transition = 1;
                        try {
                            n(t1);
                        } finally{
                            Ja.transition = e;
                        }
                    }, [
                        t1
                    ]), i;
                },
                useTransition: function() {
                    var t1 = cs(ls)[0];
                    return [
                        ms().current,
                        t1
                    ];
                },
                useMutableSource: ps,
                useOpaqueIdentifier: function() {
                    return cs(ls)[0];
                },
                unstable_isNewReconciler: !1
            }, Os = {
                readContext: aa,
                useCallback: Is,
                useContext: aa,
                useEffect: xs,
                useImperativeHandle: Ts,
                useLayoutEffect: ws,
                useMemo: Ss,
                useReducer: us,
                useRef: ms,
                useState: function() {
                    return us(ls);
                },
                useDebugValue: Es,
                useDeferredValue: function(t1) {
                    var e = us(ls), i = e[0], n = e[1];
                    return xs(function() {
                        var e = Ja.transition;
                        Ja.transition = 1;
                        try {
                            n(t1);
                        } finally{
                            Ja.transition = e;
                        }
                    }, [
                        t1
                    ]), i;
                },
                useTransition: function() {
                    var t1 = us(ls)[0];
                    return [
                        ms().current,
                        t1
                    ];
                },
                useMutableSource: ps,
                useOpaqueIdentifier: function() {
                    return us(ls)[0];
                },
                unstable_isNewReconciler: !1
            }, _s = x.ReactCurrentOwner, js = !1;
            function Ps(t1, e, i, n) {
                e.child = null === t1 ? Ia(e, null, i, n) : Ea(e, t1.child, i, n);
            }
            function Rs(t1, e, i, n, r) {
                i = i.render;
                var a = e.ref;
                return ra(e, r), n = as(t1, e, i, n, a, r), null === t1 || js ? (e.flags |= 1, Ps(t1, e, n, r), e.child) : (e.updateQueue = t1.updateQueue, e.flags &= -517, t1.lanes &= ~r, io(t1, e, r));
            }
            function Us(t1, e, i, n, r, a) {
                if (null === t1) {
                    var s = i.type;
                    return "function" != typeof s || Hl(s) || void 0 !== s.defaultProps || null !== i.compare || void 0 !== i.defaultProps ? ((t1 = Gl(i.type, null, n, e, e.mode, a)).ref = e.ref, t1.return = e, e.child = t1) : (e.tag = 15, e.type = s, ks(t1, e, s, n, r, a));
                }
                return s = t1.child, r & a || (r = s.memoizedProps, !(i = null !== (i = i.compare) ? i : hn)(r, n) || t1.ref !== e.ref) ? (e.flags |= 1, (t1 = Vl(s, n)).ref = e.ref, t1.return = e, e.child = t1) : io(t1, e, a);
            }
            function ks(t1, e, i, n, r, a) {
                if (null !== t1 && hn(t1.memoizedProps, n) && t1.ref === e.ref) {
                    if (js = !1, !(a & r)) return e.lanes = t1.lanes, io(t1, e, a);
                    16384 & t1.flags && (js = !0);
                }
                return Qs(t1, e, i, n, a);
            }
            function Bs(t1, e, i) {
                var n = e.pendingProps, r = n.children, a = null !== t1 ? t1.memoizedState : null;
                if ("hidden" === n.mode || "unstable-defer-without-hiding" === n.mode) {
                    if (4 & e.mode) {
                        if (!(1073741824 & i)) return t1 = null !== a ? a.baseLanes | i : i, e.lanes = e.childLanes = 1073741824, e.memoizedState = {
                            baseLanes: t1
                        }, vl(0, t1), null;
                        e.memoizedState = {
                            baseLanes: 0
                        }, vl(0, null !== a ? a.baseLanes : i);
                    } else e.memoizedState = {
                        baseLanes: 0
                    }, vl(0, i);
                } else null !== a ? (n = a.baseLanes | i, e.memoizedState = null) : n = i, vl(0, n);
                return Ps(t1, e, r, i), e.child;
            }
            function Fs(t1, e) {
                var i = e.ref;
                (null === t1 && null !== i || null !== t1 && t1.ref !== i) && (e.flags |= 128);
            }
            function Qs(t1, e, i, n, r) {
                var a = gr(i) ? fr : dr.current;
                return a = Ar(e, a), ra(e, r), i = as(t1, e, i, n, a, r), null === t1 || js ? (e.flags |= 1, Ps(t1, e, i, r), e.child) : (e.updateQueue = t1.updateQueue, e.flags &= -517, t1.lanes &= ~r, io(t1, e, r));
            }
            function Hs(t1, e, i, n, r) {
                if (gr(i)) {
                    var a = !0;
                    vr(e);
                } else a = !1;
                if (ra(e, r), null === e.stateNode) null !== t1 && (t1.alternate = null, e.alternate = null, e.flags |= 2), Ma(e, i, n), va(e, i, n, r), n = !0;
                else if (null === t1) {
                    var s = e.stateNode, o = e.memoizedProps;
                    s.props = o;
                    var l = s.context, c = i.contextType;
                    c = "object" == typeof c && null !== c ? aa(c) : Ar(e, c = gr(i) ? fr : dr.current);
                    var u = i.getDerivedStateFromProps, h = "function" == typeof u || "function" == typeof s.getSnapshotBeforeUpdate;
                    h || "function" != typeof s.UNSAFE_componentWillReceiveProps && "function" != typeof s.componentWillReceiveProps || (o !== n || l !== c) && ya(e, s, n, c), sa = !1;
                    var d = e.memoizedState;
                    s.state = d, da(e, n, s, r), l = e.memoizedState, o !== n || d !== l || pr.current || sa ? ("function" == typeof u && (Aa(e, i, u, n), l = e.memoizedState), (o = sa || ma(e, i, o, n, d, l, c)) ? (h || "function" != typeof s.UNSAFE_componentWillMount && "function" != typeof s.componentWillMount || ("function" == typeof s.componentWillMount && s.componentWillMount(), "function" == typeof s.UNSAFE_componentWillMount && s.UNSAFE_componentWillMount()), "function" == typeof s.componentDidMount && (e.flags |= 4)) : ("function" == typeof s.componentDidMount && (e.flags |= 4), e.memoizedProps = n, e.memoizedState = l), s.props = n, s.state = l, s.context = c, n = o) : ("function" == typeof s.componentDidMount && (e.flags |= 4), n = !1);
                } else {
                    s = e.stateNode, la(t1, e), o = e.memoizedProps, c = e.type === e.elementType ? o : Jr(e.type, o), s.props = c, h = e.pendingProps, d = s.context, l = "object" == typeof (l = i.contextType) && null !== l ? aa(l) : Ar(e, l = gr(i) ? fr : dr.current);
                    var p = i.getDerivedStateFromProps;
                    (u = "function" == typeof p || "function" == typeof s.getSnapshotBeforeUpdate) || "function" != typeof s.UNSAFE_componentWillReceiveProps && "function" != typeof s.componentWillReceiveProps || (o !== h || d !== l) && ya(e, s, n, l), sa = !1, d = e.memoizedState, s.state = d, da(e, n, s, r);
                    var f = e.memoizedState;
                    o !== h || d !== f || pr.current || sa ? ("function" == typeof p && (Aa(e, i, p, n), f = e.memoizedState), (c = sa || ma(e, i, c, n, d, f, l)) ? (u || "function" != typeof s.UNSAFE_componentWillUpdate && "function" != typeof s.componentWillUpdate || ("function" == typeof s.componentWillUpdate && s.componentWillUpdate(n, f, l), "function" == typeof s.UNSAFE_componentWillUpdate && s.UNSAFE_componentWillUpdate(n, f, l)), "function" == typeof s.componentDidUpdate && (e.flags |= 4), "function" == typeof s.getSnapshotBeforeUpdate && (e.flags |= 256)) : ("function" != typeof s.componentDidUpdate || o === t1.memoizedProps && d === t1.memoizedState || (e.flags |= 4), "function" != typeof s.getSnapshotBeforeUpdate || o === t1.memoizedProps && d === t1.memoizedState || (e.flags |= 256), e.memoizedProps = n, e.memoizedState = f), s.props = n, s.state = f, s.context = l, n = c) : ("function" != typeof s.componentDidUpdate || o === t1.memoizedProps && d === t1.memoizedState || (e.flags |= 4), "function" != typeof s.getSnapshotBeforeUpdate || o === t1.memoizedProps && d === t1.memoizedState || (e.flags |= 256), n = !1);
                }
                return Vs(t1, e, i, n, a, r);
            }
            function Vs(t1, e, i, n, r, a) {
                Fs(t1, e);
                var s = !!(64 & e.flags);
                if (!n && !s) return r && xr(e, i, !1), io(t1, e, a);
                n = e.stateNode, _s.current = e;
                var o = s && "function" != typeof i.getDerivedStateFromError ? null : n.render();
                return e.flags |= 1, null !== t1 && s ? (e.child = Ea(e, t1.child, null, a), e.child = Ea(e, null, o, a)) : Ps(t1, e, o, a), e.memoizedState = n.state, r && xr(e, i, !0), e.child;
            }
            function Gs(t1) {
                var e = t1.stateNode;
                e.pendingContext ? Mr(0, e.pendingContext, e.pendingContext !== e.context) : e.context && Mr(0, e.context, !1), La(t1, e.containerInfo);
            }
            var Ys, Ws, Xs, Zs, Js = {
                dehydrated: null,
                retryLane: 0
            };
            function Ks(t1, e, i) {
                var n, r = e.pendingProps, a = Pa.current, s = !1;
                return (n = !!(64 & e.flags)) || (n = (null === t1 || null !== t1.memoizedState) && !!(2 & a)), n ? (s = !0, e.flags &= -65) : null !== t1 && null === t1.memoizedState || void 0 === r.fallback || !0 === r.unstable_avoidThisFallback || (a |= 1), ur(Pa, 1 & a), null === t1 ? (void 0 !== r.fallback && Ha(e), t1 = r.children, a = r.fallback, s ? (t1 = qs(e, t1, a, i), e.child.memoizedState = {
                    baseLanes: i
                }, e.memoizedState = Js, t1) : "number" == typeof r.unstable_expectedLoadTime ? (t1 = qs(e, t1, a, i), e.child.memoizedState = {
                    baseLanes: i
                }, e.memoizedState = Js, e.lanes = 33554432, t1) : ((i = Wl({
                    mode: "visible",
                    children: t1
                }, e.mode, i, null)).return = e, e.child = i)) : (t1.memoizedState, s ? (r = function(t1, e, i, n, r) {
                    var a = e.mode, s = t1.child;
                    t1 = s.sibling;
                    var o = {
                        mode: "hidden",
                        children: i
                    };
                    return 2 & a || e.child === s ? i = Vl(s, o) : ((i = e.child).childLanes = 0, i.pendingProps = o, null !== (s = i.lastEffect) ? (e.firstEffect = i.firstEffect, e.lastEffect = s, s.nextEffect = null) : e.firstEffect = e.lastEffect = null), null !== t1 ? n = Vl(t1, n) : (n = Yl(n, a, r, null)).flags |= 2, n.return = e, i.return = e, i.sibling = n, e.child = i, n;
                }(t1, e, r.children, r.fallback, i), s = e.child, a = t1.child.memoizedState, s.memoizedState = null === a ? {
                    baseLanes: i
                } : {
                    baseLanes: a.baseLanes | i
                }, s.childLanes = t1.childLanes & ~i, e.memoizedState = Js, r) : (i = function(t1, e, i, n) {
                    var r = t1.child;
                    return t1 = r.sibling, i = Vl(r, {
                        mode: "visible",
                        children: i
                    }), !(2 & e.mode) && (i.lanes = n), i.return = e, i.sibling = null, null !== t1 && (t1.nextEffect = null, t1.flags = 8, e.firstEffect = e.lastEffect = t1), e.child = i;
                }(t1, e, r.children, i), e.memoizedState = null, i));
            }
            function qs(t1, e, i, n) {
                var r = t1.mode, a = t1.child;
                return e = {
                    mode: "hidden",
                    children: e
                }, 2 & r || null === a ? a = Wl(e, r, 0, null) : (a.childLanes = 0, a.pendingProps = e), i = Yl(i, r, n, null), a.return = t1, i.return = t1, a.sibling = i, t1.child = a, i;
            }
            function $s(t1, e) {
                t1.lanes |= e;
                var i = t1.alternate;
                null !== i && (i.lanes |= e), na(t1.return, e);
            }
            function to(t1, e, i, n, r, a) {
                var s = t1.memoizedState;
                null === s ? t1.memoizedState = {
                    isBackwards: e,
                    rendering: null,
                    renderingStartTime: 0,
                    last: n,
                    tail: i,
                    tailMode: r,
                    lastEffect: a
                } : (s.isBackwards = e, s.rendering = null, s.renderingStartTime = 0, s.last = n, s.tail = i, s.tailMode = r, s.lastEffect = a);
            }
            function eo(t1, e, i) {
                var n = e.pendingProps, r = n.revealOrder, a = n.tail;
                if (Ps(t1, e, n.children, i), 2 & (n = Pa.current)) n = 1 & n | 2, e.flags |= 64;
                else {
                    if (null !== t1 && 64 & t1.flags) t: for(t1 = e.child; null !== t1;){
                        if (13 === t1.tag) null !== t1.memoizedState && $s(t1, i);
                        else if (19 === t1.tag) $s(t1, i);
                        else if (null !== t1.child) {
                            t1.child.return = t1, t1 = t1.child;
                            continue;
                        }
                        if (t1 === e) break t;
                        for(; null === t1.sibling;){
                            if (null === t1.return || t1.return === e) break t;
                            t1 = t1.return;
                        }
                        t1.sibling.return = t1.return, t1 = t1.sibling;
                    }
                    n &= 1;
                }
                if (ur(Pa, n), 2 & e.mode) switch(r){
                    case "forwards":
                        for(i = e.child, r = null; null !== i;)null !== (t1 = i.alternate) && null === Ra(t1) && (r = i), i = i.sibling;
                        null === (i = r) ? (r = e.child, e.child = null) : (r = i.sibling, i.sibling = null), to(e, !1, r, i, a, e.lastEffect);
                        break;
                    case "backwards":
                        for(i = null, r = e.child, e.child = null; null !== r;){
                            if (null !== (t1 = r.alternate) && null === Ra(t1)) {
                                e.child = r;
                                break;
                            }
                            t1 = r.sibling, r.sibling = i, i = r, r = t1;
                        }
                        to(e, !0, i, null, a, e.lastEffect);
                        break;
                    case "together":
                        to(e, !1, null, null, void 0, e.lastEffect);
                        break;
                    default:
                        e.memoizedState = null;
                }
                else e.memoizedState = null;
                return e.child;
            }
            function io(t1, e, i) {
                if (null !== t1 && (e.dependencies = t1.dependencies), ko |= e.lanes, i & e.childLanes) {
                    if (null !== t1 && e.child !== t1.child) throw Error(s(153));
                    if (null !== e.child) {
                        for(i = Vl(t1 = e.child, t1.pendingProps), e.child = i, i.return = e; null !== t1.sibling;)t1 = t1.sibling, (i = i.sibling = Vl(t1, t1.pendingProps)).return = e;
                        i.sibling = null;
                    }
                    return e.child;
                }
                return null;
            }
            function no(t1, e) {
                if (!Ba) switch(t1.tailMode){
                    case "hidden":
                        e = t1.tail;
                        for(var i = null; null !== e;)null !== e.alternate && (i = e), e = e.sibling;
                        null === i ? t1.tail = null : i.sibling = null;
                        break;
                    case "collapsed":
                        i = t1.tail;
                        for(var n = null; null !== i;)null !== i.alternate && (n = i), i = i.sibling;
                        null === n ? e || null === t1.tail ? t1.tail = null : t1.tail.sibling = null : n.sibling = null;
                }
            }
            function ro(t1, e, i) {
                var n = e.pendingProps;
                switch(e.tag){
                    case 2:
                    case 16:
                    case 15:
                    case 0:
                    case 11:
                    case 7:
                    case 8:
                    case 12:
                    case 9:
                    case 14:
                        return null;
                    case 1:
                    case 17:
                        return gr(e.type) && mr(), null;
                    case 3:
                        return Oa(), cr(pr), cr(dr), Xa(), (n = e.stateNode).pendingContext && (n.context = n.pendingContext, n.pendingContext = null), null !== t1 && null !== t1.child || (Ga(e) ? e.flags |= 4 : n.hydrate || (e.flags |= 256)), Ws(e), null;
                    case 5:
                        ja(e);
                        var a = za(Ca.current);
                        if (i = e.type, null !== t1 && null != e.stateNode) Xs(t1, e, i, n, a), t1.ref !== e.ref && (e.flags |= 128);
                        else {
                            if (!n) {
                                if (null === e.stateNode) throw Error(s(166));
                                return null;
                            }
                            if (t1 = za(Na.current), Ga(e)) {
                                n = e.stateNode, i = e.type;
                                var o = e.memoizedProps;
                                switch(n[Kn] = e, n[qn] = o, i){
                                    case "dialog":
                                        Dn("cancel", n), Dn("close", n);
                                        break;
                                    case "iframe":
                                    case "object":
                                    case "embed":
                                        Dn("load", n);
                                        break;
                                    case "video":
                                    case "audio":
                                        for(t1 = 0; t1 < En.length; t1++)Dn(En[t1], n);
                                        break;
                                    case "source":
                                        Dn("error", n);
                                        break;
                                    case "img":
                                    case "image":
                                    case "link":
                                        Dn("error", n), Dn("load", n);
                                        break;
                                    case "details":
                                        Dn("toggle", n);
                                        break;
                                    case "input":
                                        tt(n, o), Dn("invalid", n);
                                        break;
                                    case "select":
                                        n._wrapperState = {
                                            wasMultiple: !!o.multiple
                                        }, Dn("invalid", n);
                                        break;
                                    case "textarea":
                                        lt(n, o), Dn("invalid", n);
                                }
                                for(var c in bt(i, o), t1 = null, o)o.hasOwnProperty(c) && (a = o[c], "children" === c ? "string" == typeof a ? n.textContent !== a && (t1 = [
                                    "children",
                                    a
                                ]) : "number" == typeof a && n.textContent !== "" + a && (t1 = [
                                    "children",
                                    "" + a
                                ]) : l.hasOwnProperty(c) && null != a && "onScroll" === c && Dn("scroll", n));
                                switch(i){
                                    case "input":
                                        J(n), nt(n, o, !0);
                                        break;
                                    case "textarea":
                                        J(n), ut(n);
                                        break;
                                    case "select":
                                    case "option":
                                        break;
                                    default:
                                        "function" == typeof o.onClick && (n.onclick = kn);
                                }
                                n = t1, e.updateQueue = n, null !== n && (e.flags |= 4);
                            } else {
                                switch(c = 9 === a.nodeType ? a : a.ownerDocument, t1 === ht.html && (t1 = dt(i)), t1 === ht.html ? "script" === i ? ((t1 = c.createElement("div")).innerHTML = "<script></script>", t1 = t1.removeChild(t1.firstChild)) : "string" == typeof n.is ? t1 = c.createElement(i, {
                                    is: n.is
                                }) : (t1 = c.createElement(i), "select" === i && (c = t1, n.multiple ? c.multiple = !0 : n.size && (c.size = n.size))) : t1 = c.createElementNS(t1, i), t1[Kn] = e, t1[qn] = n, Ys(t1, e, !1, !1), e.stateNode = t1, c = Tt(i, n), i){
                                    case "dialog":
                                        Dn("cancel", t1), Dn("close", t1), a = n;
                                        break;
                                    case "iframe":
                                    case "object":
                                    case "embed":
                                        Dn("load", t1), a = n;
                                        break;
                                    case "video":
                                    case "audio":
                                        for(a = 0; a < En.length; a++)Dn(En[a], t1);
                                        a = n;
                                        break;
                                    case "source":
                                        Dn("error", t1), a = n;
                                        break;
                                    case "img":
                                    case "image":
                                    case "link":
                                        Dn("error", t1), Dn("load", t1), a = n;
                                        break;
                                    case "details":
                                        Dn("toggle", t1), a = n;
                                        break;
                                    case "input":
                                        tt(t1, n), a = $(t1, n), Dn("invalid", t1);
                                        break;
                                    case "option":
                                        a = at(t1, n);
                                        break;
                                    case "select":
                                        t1._wrapperState = {
                                            wasMultiple: !!n.multiple
                                        }, a = r({}, n, {
                                            value: void 0
                                        }), Dn("invalid", t1);
                                        break;
                                    case "textarea":
                                        lt(t1, n), a = ot(t1, n), Dn("invalid", t1);
                                        break;
                                    default:
                                        a = n;
                                }
                                bt(i, a);
                                var u = a;
                                for(o in u)if (u.hasOwnProperty(o)) {
                                    var h = u[o];
                                    "style" === o ? xt(t1, h) : "dangerouslySetInnerHTML" === o ? null != (h = h ? h.__html : void 0) && gt(t1, h) : "children" === o ? "string" == typeof h ? ("textarea" !== i || "" !== h) && mt(t1, h) : "number" == typeof h && mt(t1, "" + h) : "suppressContentEditableWarning" !== o && "suppressHydrationWarning" !== o && "autoFocus" !== o && (l.hasOwnProperty(o) ? null != h && "onScroll" === o && Dn("scroll", t1) : null != h && v(t1, o, h, c));
                                }
                                switch(i){
                                    case "input":
                                        J(t1), nt(t1, n, !1);
                                        break;
                                    case "textarea":
                                        J(t1), ut(t1);
                                        break;
                                    case "option":
                                        null != n.value && t1.setAttribute("value", "" + X(n.value));
                                        break;
                                    case "select":
                                        t1.multiple = !!n.multiple, null != (o = n.value) ? st(t1, !!n.multiple, o, !1) : null != n.defaultValue && st(t1, !!n.multiple, n.defaultValue, !0);
                                        break;
                                    default:
                                        "function" == typeof a.onClick && (t1.onclick = kn);
                                }
                                Qn(i, n) && (e.flags |= 4);
                            }
                            null !== e.ref && (e.flags |= 128);
                        }
                        return null;
                    case 6:
                        if (t1 && null != e.stateNode) Zs(t1, e, t1.memoizedProps, n);
                        else {
                            if ("string" != typeof n && null === e.stateNode) throw Error(s(166));
                            i = za(Ca.current), za(Na.current), Ga(e) ? (n = e.stateNode, i = e.memoizedProps, n[Kn] = e, n.nodeValue !== i && (e.flags |= 4)) : ((n = (9 === i.nodeType ? i : i.ownerDocument).createTextNode(n))[Kn] = e, e.stateNode = n);
                        }
                        return null;
                    case 13:
                        return cr(Pa), n = e.memoizedState, 64 & e.flags ? (e.lanes = i, e) : (n = null !== n, i = !1, null === t1 ? void 0 !== e.memoizedProps.fallback && Ga(e) : i = null !== t1.memoizedState, n && !i && 2 & e.mode && (null === t1 && !0 !== e.memoizedProps.unstable_avoidThisFallback || 1 & Pa.current ? 0 === Po && (Po = 3) : (0 !== Po && 3 !== Po || (Po = 4), null === zo || !(134217727 & ko) && !(134217727 & Bo) || gl(zo, Oo))), (n || i) && (e.flags |= 4), null);
                    case 4:
                        return Oa(), Ws(e), null === t1 && zn(e.stateNode.containerInfo), null;
                    case 10:
                        return ia(e), null;
                    case 19:
                        if (cr(Pa), null === (n = e.memoizedState)) return null;
                        if (o = !!(64 & e.flags), null === (c = n.rendering)) {
                            if (o) no(n, !1);
                            else {
                                if (0 !== Po || null !== t1 && 64 & t1.flags) for(t1 = e.child; null !== t1;){
                                    if (null !== (c = Ra(t1))) {
                                        for(e.flags |= 64, no(n, !1), null !== (o = c.updateQueue) && (e.updateQueue = o, e.flags |= 4), null === n.lastEffect && (e.firstEffect = null), e.lastEffect = n.lastEffect, n = i, i = e.child; null !== i;)t1 = n, (o = i).flags &= 2, o.nextEffect = null, o.firstEffect = null, o.lastEffect = null, null === (c = o.alternate) ? (o.childLanes = 0, o.lanes = t1, o.child = null, o.memoizedProps = null, o.memoizedState = null, o.updateQueue = null, o.dependencies = null, o.stateNode = null) : (o.childLanes = c.childLanes, o.lanes = c.lanes, o.child = c.child, o.memoizedProps = c.memoizedProps, o.memoizedState = c.memoizedState, o.updateQueue = c.updateQueue, o.type = c.type, t1 = c.dependencies, o.dependencies = null === t1 ? null : {
                                            lanes: t1.lanes,
                                            firstContext: t1.firstContext
                                        }), i = i.sibling;
                                        return ur(Pa, 1 & Pa.current | 2), e.child;
                                    }
                                    t1 = t1.sibling;
                                }
                                null !== n.tail && Qr() > Vo && (e.flags |= 64, o = !0, no(n, !1), e.lanes = 33554432);
                            }
                        } else {
                            if (!o) {
                                if (null !== (t1 = Ra(c))) {
                                    if (e.flags |= 64, o = !0, null !== (i = t1.updateQueue) && (e.updateQueue = i, e.flags |= 4), no(n, !0), null === n.tail && "hidden" === n.tailMode && !c.alternate && !Ba) return null !== (e = e.lastEffect = n.lastEffect) && (e.nextEffect = null), null;
                                } else 2 * Qr() - n.renderingStartTime > Vo && 1073741824 !== i && (e.flags |= 64, o = !0, no(n, !1), e.lanes = 33554432);
                            }
                            n.isBackwards ? (c.sibling = e.child, e.child = c) : (null !== (i = n.last) ? i.sibling = c : e.child = c, n.last = c);
                        }
                        return null !== n.tail ? (i = n.tail, n.rendering = i, n.tail = i.sibling, n.lastEffect = e.lastEffect, n.renderingStartTime = Qr(), i.sibling = null, e = Pa.current, ur(Pa, o ? 1 & e | 2 : 1 & e), i) : null;
                    case 23:
                    case 24:
                        return xl(), null !== t1 && null !== t1.memoizedState != (null !== e.memoizedState) && "unstable-defer-without-hiding" !== n.mode && (e.flags |= 4), null;
                }
                throw Error(s(156, e.tag));
            }
            function ao(t1) {
                switch(t1.tag){
                    case 1:
                        gr(t1.type) && mr();
                        var e = t1.flags;
                        return 4096 & e ? (t1.flags = -4097 & e | 64, t1) : null;
                    case 3:
                        if (Oa(), cr(pr), cr(dr), Xa(), 64 & (e = t1.flags)) throw Error(s(285));
                        return t1.flags = -4097 & e | 64, t1;
                    case 5:
                        return ja(t1), null;
                    case 13:
                        return cr(Pa), 4096 & (e = t1.flags) ? (t1.flags = -4097 & e | 64, t1) : null;
                    case 19:
                        return cr(Pa), null;
                    case 4:
                        return Oa(), null;
                    case 10:
                        return ia(t1), null;
                    case 23:
                    case 24:
                        return xl(), null;
                    default:
                        return null;
                }
            }
            function so(t1, e) {
                try {
                    var i = "", n = e;
                    do i += Y(n), n = n.return;
                    while (n);
                    var r = i;
                } catch (t1) {
                    r = "\nError generating stack: " + t1.message + "\n" + t1.stack;
                }
                return {
                    value: t1,
                    source: e,
                    stack: r
                };
            }
            function oo(t1, e) {
                try {
                    console.error(e.value);
                } catch (t1) {
                    setTimeout(function() {
                        throw t1;
                    });
                }
            }
            Ys = function(t1, e) {
                for(var i = e.child; null !== i;){
                    if (5 === i.tag || 6 === i.tag) t1.appendChild(i.stateNode);
                    else if (4 !== i.tag && null !== i.child) {
                        i.child.return = i, i = i.child;
                        continue;
                    }
                    if (i === e) break;
                    for(; null === i.sibling;){
                        if (null === i.return || i.return === e) return;
                        i = i.return;
                    }
                    i.sibling.return = i.return, i = i.sibling;
                }
            }, Ws = function() {}, Xs = function(t1, e, i, n) {
                var a = t1.memoizedProps;
                if (a !== n) {
                    t1 = e.stateNode, za(Na.current);
                    var s, o = null;
                    switch(i){
                        case "input":
                            a = $(t1, a), n = $(t1, n), o = [];
                            break;
                        case "option":
                            a = at(t1, a), n = at(t1, n), o = [];
                            break;
                        case "select":
                            a = r({}, a, {
                                value: void 0
                            }), n = r({}, n, {
                                value: void 0
                            }), o = [];
                            break;
                        case "textarea":
                            a = ot(t1, a), n = ot(t1, n), o = [];
                            break;
                        default:
                            "function" != typeof a.onClick && "function" == typeof n.onClick && (t1.onclick = kn);
                    }
                    for(h in bt(i, n), i = null, a)if (!n.hasOwnProperty(h) && a.hasOwnProperty(h) && null != a[h]) {
                        if ("style" === h) {
                            var c = a[h];
                            for(s in c)c.hasOwnProperty(s) && (i || (i = {}), i[s] = "");
                        } else "dangerouslySetInnerHTML" !== h && "children" !== h && "suppressContentEditableWarning" !== h && "suppressHydrationWarning" !== h && "autoFocus" !== h && (l.hasOwnProperty(h) ? o || (o = []) : (o = o || []).push(h, null));
                    }
                    for(h in n){
                        var u = n[h];
                        if (c = null != a ? a[h] : void 0, n.hasOwnProperty(h) && u !== c && (null != u || null != c)) {
                            if ("style" === h) {
                                if (c) {
                                    for(s in c)!c.hasOwnProperty(s) || u && u.hasOwnProperty(s) || (i || (i = {}), i[s] = "");
                                    for(s in u)u.hasOwnProperty(s) && c[s] !== u[s] && (i || (i = {}), i[s] = u[s]);
                                } else i || (o || (o = []), o.push(h, i)), i = u;
                            } else "dangerouslySetInnerHTML" === h ? (u = u ? u.__html : void 0, c = c ? c.__html : void 0, null != u && c !== u && (o = o || []).push(h, u)) : "children" === h ? "string" != typeof u && "number" != typeof u || (o = o || []).push(h, "" + u) : "suppressContentEditableWarning" !== h && "suppressHydrationWarning" !== h && (l.hasOwnProperty(h) ? (null != u && "onScroll" === h && Dn("scroll", t1), o || c === u || (o = [])) : "object" == typeof u && null !== u && u.$$typeof === j ? u.toString() : (o = o || []).push(h, u));
                        }
                    }
                    i && (o = o || []).push("style", i);
                    var h = o;
                    (e.updateQueue = h) && (e.flags |= 4);
                }
            }, Zs = function(t1, e, i, n) {
                i !== n && (e.flags |= 4);
            };
            var lo = "function" == typeof WeakMap ? WeakMap : Map;
            function co(t1, e, i) {
                (i = ca(-1, i)).tag = 3, i.payload = {
                    element: null
                };
                var n = e.value;
                return i.callback = function() {
                    Xo || (Xo = !0, Zo = n), oo(0, e);
                }, i;
            }
            function uo(t1, e, i) {
                (i = ca(-1, i)).tag = 3;
                var n = t1.type.getDerivedStateFromError;
                if ("function" == typeof n) {
                    var r = e.value;
                    i.payload = function() {
                        return oo(0, e), n(r);
                    };
                }
                var a = t1.stateNode;
                return null !== a && "function" == typeof a.componentDidCatch && (i.callback = function() {
                    "function" != typeof n && (null === Jo ? Jo = new Set([
                        this
                    ]) : Jo.add(this), oo(0, e));
                    var t1 = e.stack;
                    this.componentDidCatch(e.value, {
                        componentStack: null !== t1 ? t1 : ""
                    });
                }), i;
            }
            var ho = "function" == typeof WeakSet ? WeakSet : Set;
            function po(t1) {
                var e = t1.ref;
                if (null !== e) {
                    if ("function" == typeof e) try {
                        e(null);
                    } catch (e) {
                        Ul(t1, e);
                    }
                    else e.current = null;
                }
            }
            function fo(t1, e) {
                switch(e.tag){
                    case 0:
                    case 11:
                    case 15:
                    case 22:
                    case 5:
                    case 6:
                    case 4:
                    case 17:
                        return;
                    case 1:
                        if (256 & e.flags && null !== t1) {
                            var i = t1.memoizedProps, n = t1.memoizedState;
                            e = (t1 = e.stateNode).getSnapshotBeforeUpdate(e.elementType === e.type ? i : Jr(e.type, i), n), t1.__reactInternalSnapshotBeforeUpdate = e;
                        }
                        return;
                    case 3:
                        return void (256 & e.flags && Yn(e.stateNode.containerInfo));
                }
                throw Error(s(163));
            }
            function Ao(t1, e, i) {
                switch(i.tag){
                    case 0:
                    case 11:
                    case 15:
                    case 22:
                        if (null !== (e = null !== (e = i.updateQueue) ? e.lastEffect : null)) {
                            t1 = e = e.next;
                            do {
                                if (!(3 & ~t1.tag)) {
                                    var n = t1.create;
                                    t1.destroy = n();
                                }
                                t1 = t1.next;
                            }while (t1 !== e);
                        }
                        if (null !== (e = null !== (e = i.updateQueue) ? e.lastEffect : null)) {
                            t1 = e = e.next;
                            do {
                                var r = t1;
                                n = r.next, 4 & (r = r.tag) && 1 & r && (jl(i, t1), _l(i, t1)), t1 = n;
                            }while (t1 !== e);
                        }
                        return;
                    case 1:
                        return t1 = i.stateNode, 4 & i.flags && (null === e ? t1.componentDidMount() : (n = i.elementType === i.type ? e.memoizedProps : Jr(i.type, e.memoizedProps), t1.componentDidUpdate(n, e.memoizedState, t1.__reactInternalSnapshotBeforeUpdate))), void (null !== (e = i.updateQueue) && pa(i, e, t1));
                    case 3:
                        if (null !== (e = i.updateQueue)) {
                            if (t1 = null, null !== i.child) switch(i.child.tag){
                                case 5:
                                case 1:
                                    t1 = i.child.stateNode;
                            }
                            pa(i, e, t1);
                        }
                        return;
                    case 5:
                        return t1 = i.stateNode, void (null === e && 4 & i.flags && Qn(i.type, i.memoizedProps) && t1.focus());
                    case 6:
                    case 4:
                    case 12:
                    case 19:
                    case 17:
                    case 20:
                    case 21:
                    case 23:
                    case 24:
                        return;
                    case 13:
                        return void (null === i.memoizedState && (i = i.alternate, null !== i && (i = i.memoizedState, null !== i && (i = i.dehydrated, null !== i && xe(i)))));
                }
                throw Error(s(163));
            }
            function go(t1, e) {
                for(var i = t1;;){
                    if (5 === i.tag) {
                        var n = i.stateNode;
                        if (e) "function" == typeof (n = n.style).setProperty ? n.setProperty("display", "none", "important") : n.display = "none";
                        else {
                            n = i.stateNode;
                            var r = i.memoizedProps.style;
                            r = null != r && r.hasOwnProperty("display") ? r.display : null, n.style.display = vt("display", r);
                        }
                    } else if (6 === i.tag) i.stateNode.nodeValue = e ? "" : i.memoizedProps;
                    else if ((23 !== i.tag && 24 !== i.tag || null === i.memoizedState || i === t1) && null !== i.child) {
                        i.child.return = i, i = i.child;
                        continue;
                    }
                    if (i === t1) break;
                    for(; null === i.sibling;){
                        if (null === i.return || i.return === t1) return;
                        i = i.return;
                    }
                    i.sibling.return = i.return, i = i.sibling;
                }
            }
            function mo(t1, e) {
                if (br && "function" == typeof br.onCommitFiberUnmount) try {
                    br.onCommitFiberUnmount(wr, e);
                } catch (t1) {}
                switch(e.tag){
                    case 0:
                    case 11:
                    case 14:
                    case 15:
                    case 22:
                        if (null !== (t1 = e.updateQueue) && null !== (t1 = t1.lastEffect)) {
                            var i = t1 = t1.next;
                            do {
                                var n = i, r = n.destroy;
                                if (n = n.tag, void 0 !== r) {
                                    if (4 & n) jl(e, i);
                                    else {
                                        n = e;
                                        try {
                                            r();
                                        } catch (t1) {
                                            Ul(n, t1);
                                        }
                                    }
                                }
                                i = i.next;
                            }while (i !== t1);
                        }
                        break;
                    case 1:
                        if (po(e), "function" == typeof (t1 = e.stateNode).componentWillUnmount) try {
                            t1.props = e.memoizedProps, t1.state = e.memoizedState, t1.componentWillUnmount();
                        } catch (t1) {
                            Ul(e, t1);
                        }
                        break;
                    case 5:
                        po(e);
                        break;
                    case 4:
                        bo(t1, e);
                }
            }
            function Mo(t1) {
                t1.alternate = null, t1.child = null, t1.dependencies = null, t1.firstEffect = null, t1.lastEffect = null, t1.memoizedProps = null, t1.memoizedState = null, t1.pendingProps = null, t1.return = null, t1.updateQueue = null;
            }
            function yo(t1) {
                return 5 === t1.tag || 3 === t1.tag || 4 === t1.tag;
            }
            function vo(t1) {
                t: {
                    for(var e = t1.return; null !== e;){
                        if (yo(e)) break t;
                        e = e.return;
                    }
                    throw Error(s(160));
                }
                var i = e;
                switch(e = i.stateNode, i.tag){
                    case 5:
                        var n = !1;
                        break;
                    case 3:
                    case 4:
                        e = e.containerInfo, n = !0;
                        break;
                    default:
                        throw Error(s(161));
                }
                16 & i.flags && (mt(e, ""), i.flags &= -17);
                t: e: for(i = t1;;){
                    for(; null === i.sibling;){
                        if (null === i.return || yo(i.return)) {
                            i = null;
                            break t;
                        }
                        i = i.return;
                    }
                    for(i.sibling.return = i.return, i = i.sibling; 5 !== i.tag && 6 !== i.tag && 18 !== i.tag;){
                        if (2 & i.flags) continue e;
                        if (null === i.child || 4 === i.tag) continue e;
                        i.child.return = i, i = i.child;
                    }
                    if (!(2 & i.flags)) {
                        i = i.stateNode;
                        break t;
                    }
                }
                n ? xo(t1, i, e) : wo(t1, i, e);
            }
            function xo(t1, e, i) {
                var n = t1.tag, r = 5 === n || 6 === n;
                if (r) t1 = r ? t1.stateNode : t1.stateNode.instance, e ? 8 === i.nodeType ? i.parentNode.insertBefore(t1, e) : i.insertBefore(t1, e) : (8 === i.nodeType ? (e = i.parentNode).insertBefore(t1, i) : (e = i).appendChild(t1), null != (i = i._reactRootContainer) || null !== e.onclick || (e.onclick = kn));
                else if (4 !== n && null !== (t1 = t1.child)) for(xo(t1, e, i), t1 = t1.sibling; null !== t1;)xo(t1, e, i), t1 = t1.sibling;
            }
            function wo(t1, e, i) {
                var n = t1.tag, r = 5 === n || 6 === n;
                if (r) t1 = r ? t1.stateNode : t1.stateNode.instance, e ? i.insertBefore(t1, e) : i.appendChild(t1);
                else if (4 !== n && null !== (t1 = t1.child)) for(wo(t1, e, i), t1 = t1.sibling; null !== t1;)wo(t1, e, i), t1 = t1.sibling;
            }
            function bo(t1, e) {
                for(var i, n, r = e, a = !1;;){
                    if (!a) {
                        a = r.return;
                        t: for(;;){
                            if (null === a) throw Error(s(160));
                            switch(i = a.stateNode, a.tag){
                                case 5:
                                    n = !1;
                                    break t;
                                case 3:
                                case 4:
                                    i = i.containerInfo, n = !0;
                                    break t;
                            }
                            a = a.return;
                        }
                        a = !0;
                    }
                    if (5 === r.tag || 6 === r.tag) {
                        t: for(var o = t1, l = r, c = l;;)if (mo(o, c), null !== c.child && 4 !== c.tag) c.child.return = c, c = c.child;
                        else {
                            if (c === l) break t;
                            for(; null === c.sibling;){
                                if (null === c.return || c.return === l) break t;
                                c = c.return;
                            }
                            c.sibling.return = c.return, c = c.sibling;
                        }
                        n ? (o = i, l = r.stateNode, 8 === o.nodeType ? o.parentNode.removeChild(l) : o.removeChild(l)) : i.removeChild(r.stateNode);
                    } else if (4 === r.tag) {
                        if (null !== r.child) {
                            i = r.stateNode.containerInfo, n = !0, r.child.return = r, r = r.child;
                            continue;
                        }
                    } else if (mo(t1, r), null !== r.child) {
                        r.child.return = r, r = r.child;
                        continue;
                    }
                    if (r === e) break;
                    for(; null === r.sibling;){
                        if (null === r.return || r.return === e) return;
                        4 === (r = r.return).tag && (a = !1);
                    }
                    r.sibling.return = r.return, r = r.sibling;
                }
            }
            function To(t1, e) {
                switch(e.tag){
                    case 0:
                    case 11:
                    case 14:
                    case 15:
                    case 22:
                        var i = e.updateQueue;
                        if (null !== (i = null !== i ? i.lastEffect : null)) {
                            var n = i = i.next;
                            do !(3 & ~n.tag) && (t1 = n.destroy, n.destroy = void 0, void 0 !== t1 && t1()), n = n.next;
                            while (n !== i);
                        }
                        return;
                    case 1:
                    case 12:
                    case 17:
                        return;
                    case 5:
                        if (null != (i = e.stateNode)) {
                            n = e.memoizedProps;
                            var r = null !== t1 ? t1.memoizedProps : n;
                            t1 = e.type;
                            var a = e.updateQueue;
                            if (e.updateQueue = null, null !== a) {
                                for(i[qn] = n, "input" === t1 && "radio" === n.type && null != n.name && et(i, n), Tt(t1, r), e = Tt(t1, n), r = 0; r < a.length; r += 2){
                                    var o = a[r], l = a[r + 1];
                                    "style" === o ? xt(i, l) : "dangerouslySetInnerHTML" === o ? gt(i, l) : "children" === o ? mt(i, l) : v(i, o, l, e);
                                }
                                switch(t1){
                                    case "input":
                                        it(i, n);
                                        break;
                                    case "textarea":
                                        ct(i, n);
                                        break;
                                    case "select":
                                        t1 = i._wrapperState.wasMultiple, i._wrapperState.wasMultiple = !!n.multiple, null != (a = n.value) ? st(i, !!n.multiple, a, !1) : t1 !== !!n.multiple && (null != n.defaultValue ? st(i, !!n.multiple, n.defaultValue, !0) : st(i, !!n.multiple, n.multiple ? [] : "", !1));
                                }
                            }
                        }
                        return;
                    case 6:
                        if (null === e.stateNode) throw Error(s(162));
                        return void (e.stateNode.nodeValue = e.memoizedProps);
                    case 3:
                        return void ((i = e.stateNode).hydrate && (i.hydrate = !1, xe(i.containerInfo)));
                    case 13:
                        return null !== e.memoizedState && (Ho = Qr(), go(e.child, !0)), void Eo(e);
                    case 19:
                        return void Eo(e);
                    case 23:
                    case 24:
                        return void go(e, null !== e.memoizedState);
                }
                throw Error(s(163));
            }
            function Eo(t1) {
                var e = t1.updateQueue;
                if (null !== e) {
                    t1.updateQueue = null;
                    var i = t1.stateNode;
                    null === i && (i = t1.stateNode = new ho), e.forEach(function(e) {
                        var n = Bl.bind(null, t1, e);
                        i.has(e) || (i.add(e), e.then(n, n));
                    });
                }
            }
            function Io(t1, e) {
                return null !== t1 && (null === (t1 = t1.memoizedState) || null !== t1.dehydrated) && null !== (e = e.memoizedState) && null === e.dehydrated;
            }
            var So = Math.ceil, No = x.ReactCurrentDispatcher, Do = x.ReactCurrentOwner, Co = 0, zo = null, Lo = null, Oo = 0, _o = 0, jo = lr(0), Po = 0, Ro = null, Uo = 0, ko = 0, Bo = 0, Fo = 0, Qo = null, Ho = 0, Vo = 1 / 0;
            function Go() {
                Vo = Qr() + 500;
            }
            var Yo, Wo = null, Xo = !1, Zo = null, Jo = null, Ko = !1, qo = null, $o = 90, tl = [], el = [], il = null, nl = 0, rl = null, al = -1, sl = 0, ol = 0, ll = null, cl = !1;
            function ul() {
                return 48 & Co ? Qr() : -1 !== al ? al : al = Qr();
            }
            function hl(t1) {
                if (!(2 & (t1 = t1.mode))) return 1;
                if (!(4 & t1)) return 99 === Hr() ? 1 : 2;
                if (0 === sl && (sl = Uo), 0 !== Zr.transition) {
                    0 !== ol && (ol = null !== Qo ? Qo.pendingLanes : 0), t1 = sl;
                    var e = 4186112 & ~ol;
                    return 0 == (e &= -e) && 0 == (e = (t1 = 4186112 & ~t1) & -t1) && (e = 8192), e;
                }
                return t1 = Hr(), t1 = ke(4 & Co && 98 === t1 ? 12 : t1 = function(t1) {
                    switch(t1){
                        case 99:
                            return 15;
                        case 98:
                            return 10;
                        case 97:
                        case 96:
                            return 8;
                        case 95:
                            return 2;
                        default:
                            return 0;
                    }
                }(t1), sl);
            }
            function dl(t1, e, i) {
                if (50 < nl) throw nl = 0, rl = null, Error(s(185));
                if (null === (t1 = pl(t1, e))) return null;
                Qe(t1, e, i), t1 === zo && (Bo |= e, 4 === Po && gl(t1, Oo));
                var n = Hr();
                1 === e ? 8 & Co && !(48 & Co) ? ml(t1) : (fl(t1, i), 0 === Co && (Go(), Wr())) : (!(4 & Co) || 98 !== n && 99 !== n || (null === il ? il = new Set([
                    t1
                ]) : il.add(t1)), fl(t1, i)), Qo = t1;
            }
            function pl(t1, e) {
                t1.lanes |= e;
                var i = t1.alternate;
                for(null !== i && (i.lanes |= e), i = t1, t1 = t1.return; null !== t1;)t1.childLanes |= e, null !== (i = t1.alternate) && (i.childLanes |= e), i = t1, t1 = t1.return;
                return 3 === i.tag ? i.stateNode : null;
            }
            function fl(t1, e) {
                for(var i = t1.callbackNode, n = t1.suspendedLanes, r = t1.pingedLanes, a = t1.expirationTimes, o = t1.pendingLanes; 0 < o;){
                    var l = 31 - He(o), c = 1 << l, u = a[l];
                    if (-1 === u) {
                        if (!(c & n) || c & r) {
                            u = e, Pe(c);
                            var h = je;
                            a[l] = 10 <= h ? u + 250 : 6 <= h ? u + 5e3 : -1;
                        }
                    } else u <= e && (t1.expiredLanes |= c);
                    o &= ~c;
                }
                if (n = Re(t1, t1 === zo ? Oo : 0), e = je, 0 === n) null !== i && (i !== Pr && Ir(i), t1.callbackNode = null, t1.callbackPriority = 0);
                else {
                    if (null !== i) {
                        if (t1.callbackPriority === e) return;
                        i !== Pr && Ir(i);
                    }
                    15 === e ? (i = ml.bind(null, t1), null === Ur ? (Ur = [
                        i
                    ], kr = Er(zr, Xr)) : Ur.push(i), i = Pr) : 14 === e ? i = Yr(99, ml.bind(null, t1)) : (i = function(t1) {
                        switch(t1){
                            case 15:
                            case 14:
                                return 99;
                            case 13:
                            case 12:
                            case 11:
                            case 10:
                                return 98;
                            case 9:
                            case 8:
                            case 7:
                            case 6:
                            case 4:
                            case 5:
                                return 97;
                            case 3:
                            case 2:
                            case 1:
                                return 95;
                            case 0:
                                return 90;
                            default:
                                throw Error(s(358, t1));
                        }
                    }(e), i = Yr(i, Al.bind(null, t1))), t1.callbackPriority = e, t1.callbackNode = i;
                }
            }
            function Al(t1) {
                if (al = -1, ol = sl = 0, 48 & Co) throw Error(s(327));
                var e = t1.callbackNode;
                if (Ol() && t1.callbackNode !== e) return null;
                var i = Re(t1, t1 === zo ? Oo : 0);
                if (0 === i) return null;
                var n = i, r = Co;
                Co |= 16;
                var a = Tl();
                for(zo === t1 && Oo === n || (Go(), wl(t1, n));;)try {
                    Sl();
                    break;
                } catch (e) {
                    bl(t1, e);
                }
                if (ea(), No.current = a, Co = r, null !== Lo ? n = 0 : (zo = null, Oo = 0, n = Po), Uo & Bo) wl(t1, 0);
                else if (0 !== n) {
                    if (2 === n && (Co |= 64, t1.hydrate && (t1.hydrate = !1, Yn(t1.containerInfo)), 0 !== (i = Ue(t1)) && (n = El(t1, i))), 1 === n) throw e = Ro, wl(t1, 0), gl(t1, i), fl(t1, Qr()), e;
                    switch(t1.finishedWork = t1.current.alternate, t1.finishedLanes = i, n){
                        case 0:
                        case 1:
                            throw Error(s(345));
                        case 2:
                        case 5:
                            Cl(t1);
                            break;
                        case 3:
                            if (gl(t1, i), (62914560 & i) === i && 10 < (n = Ho + 500 - Qr())) {
                                if (0 !== Re(t1, 0)) break;
                                if (((r = t1.suspendedLanes) & i) !== i) {
                                    ul(), t1.pingedLanes |= t1.suspendedLanes & r;
                                    break;
                                }
                                t1.timeoutHandle = Vn(Cl.bind(null, t1), n);
                                break;
                            }
                            Cl(t1);
                            break;
                        case 4:
                            if (gl(t1, i), (4186112 & i) === i) break;
                            for(n = t1.eventTimes, r = -1; 0 < i;){
                                var o = 31 - He(i);
                                a = 1 << o, (o = n[o]) > r && (r = o), i &= ~a;
                            }
                            if (i = r, 10 < (i = (120 > (i = Qr() - i) ? 120 : 480 > i ? 480 : 1080 > i ? 1080 : 1920 > i ? 1920 : 3e3 > i ? 3e3 : 4320 > i ? 4320 : 1960 * So(i / 1960)) - i)) {
                                t1.timeoutHandle = Vn(Cl.bind(null, t1), i);
                                break;
                            }
                            Cl(t1);
                            break;
                        default:
                            throw Error(s(329));
                    }
                }
                return fl(t1, Qr()), t1.callbackNode === e ? Al.bind(null, t1) : null;
            }
            function gl(t1, e) {
                for(e &= ~Fo, e &= ~Bo, t1.suspendedLanes |= e, t1.pingedLanes &= ~e, t1 = t1.expirationTimes; 0 < e;){
                    var i = 31 - He(e), n = 1 << i;
                    t1[i] = -1, e &= ~n;
                }
            }
            function ml(t1) {
                if (48 & Co) throw Error(s(327));
                if (Ol(), t1 === zo && t1.expiredLanes & Oo) {
                    var e = Oo, i = El(t1, e);
                    Uo & Bo && (i = El(t1, e = Re(t1, e)));
                } else i = El(t1, e = Re(t1, 0));
                if (0 !== t1.tag && 2 === i && (Co |= 64, t1.hydrate && (t1.hydrate = !1, Yn(t1.containerInfo)), 0 !== (e = Ue(t1)) && (i = El(t1, e))), 1 === i) throw i = Ro, wl(t1, 0), gl(t1, e), fl(t1, Qr()), i;
                return t1.finishedWork = t1.current.alternate, t1.finishedLanes = e, Cl(t1), fl(t1, Qr()), null;
            }
            function Ml(t1, e) {
                var i = Co;
                Co |= 1;
                try {
                    return t1(e);
                } finally{
                    0 === (Co = i) && (Go(), Wr());
                }
            }
            function yl(t1, e) {
                var i = Co;
                Co &= -2, Co |= 8;
                try {
                    return t1(e);
                } finally{
                    0 === (Co = i) && (Go(), Wr());
                }
            }
            function vl(t1, e) {
                ur(jo, _o), _o |= e, Uo |= e;
            }
            function xl() {
                _o = jo.current, cr(jo);
            }
            function wl(t1, e) {
                t1.finishedWork = null, t1.finishedLanes = 0;
                var i = t1.timeoutHandle;
                if (-1 !== i && (t1.timeoutHandle = -1, Gn(i)), null !== Lo) for(i = Lo.return; null !== i;){
                    var n = i;
                    switch(n.tag){
                        case 1:
                            null != (n = n.type.childContextTypes) && mr();
                            break;
                        case 3:
                            Oa(), cr(pr), cr(dr), Xa();
                            break;
                        case 5:
                            ja(n);
                            break;
                        case 4:
                            Oa();
                            break;
                        case 13:
                        case 19:
                            cr(Pa);
                            break;
                        case 10:
                            ia(n);
                            break;
                        case 23:
                        case 24:
                            xl();
                    }
                    i = i.return;
                }
                zo = t1, Lo = Vl(t1.current, null), Oo = _o = Uo = e, Po = 0, Ro = null, Fo = Bo = ko = 0;
            }
            function bl(t1, e) {
                for(;;){
                    var i = Lo;
                    try {
                        if (ea(), Za.current = Cs, es) {
                            for(var n = qa.memoizedState; null !== n;){
                                var r = n.queue;
                                null !== r && (r.pending = null), n = n.next;
                            }
                            es = !1;
                        }
                        if (Ka = 0, ts = $a = qa = null, is = !1, Do.current = null, null === i || null === i.return) {
                            Po = 1, Ro = e, Lo = null;
                            break;
                        }
                        t: {
                            var a = t1, s = i.return, o = i, l = e;
                            if (e = Oo, o.flags |= 2048, o.firstEffect = o.lastEffect = null, null !== l && "object" == typeof l && "function" == typeof l.then) {
                                var c = l;
                                if (!(2 & o.mode)) {
                                    var u = o.alternate;
                                    u ? (o.updateQueue = u.updateQueue, o.memoizedState = u.memoizedState, o.lanes = u.lanes) : (o.updateQueue = null, o.memoizedState = null);
                                }
                                var h = !!(1 & Pa.current), d = s;
                                do {
                                    var p;
                                    if (p = 13 === d.tag) {
                                        var f = d.memoizedState;
                                        if (null !== f) p = null !== f.dehydrated;
                                        else {
                                            var A = d.memoizedProps;
                                            p = void 0 !== A.fallback && (!0 !== A.unstable_avoidThisFallback || !h);
                                        }
                                    }
                                    if (p) {
                                        var g = d.updateQueue;
                                        if (null === g) {
                                            var m = new Set;
                                            m.add(c), d.updateQueue = m;
                                        } else g.add(c);
                                        if (!(2 & d.mode)) {
                                            if (d.flags |= 64, o.flags |= 16384, o.flags &= -2981, 1 === o.tag) {
                                                if (null === o.alternate) o.tag = 17;
                                                else {
                                                    var M = ca(-1, 1);
                                                    M.tag = 2, ua(o, M);
                                                }
                                            }
                                            o.lanes |= 1;
                                            break t;
                                        }
                                        l = void 0, o = e;
                                        var y = a.pingCache;
                                        if (null === y ? (y = a.pingCache = new lo, l = new Set, y.set(c, l)) : void 0 === (l = y.get(c)) && (l = new Set, y.set(c, l)), !l.has(o)) {
                                            l.add(o);
                                            var v = kl.bind(null, a, c, o);
                                            c.then(v, v);
                                        }
                                        d.flags |= 4096, d.lanes = e;
                                        break t;
                                    }
                                    d = d.return;
                                }while (null !== d);
                                l = Error((W(o.type) || "A React component") + " suspended while rendering, but no fallback UI was specified.\n\nAdd a <Suspense fallback=...> component higher in the tree to provide a loading indicator or placeholder to display.");
                            }
                            5 !== Po && (Po = 2), l = so(l, o), d = s;
                            do {
                                switch(d.tag){
                                    case 3:
                                        a = l, d.flags |= 4096, e &= -e, d.lanes |= e, ha(d, co(0, a, e));
                                        break t;
                                    case 1:
                                        a = l;
                                        var x = d.type, w = d.stateNode;
                                        if (!(64 & d.flags || "function" != typeof x.getDerivedStateFromError && (null === w || "function" != typeof w.componentDidCatch || null !== Jo && Jo.has(w)))) {
                                            d.flags |= 4096, e &= -e, d.lanes |= e, ha(d, uo(d, a, e));
                                            break t;
                                        }
                                }
                                d = d.return;
                            }while (null !== d);
                        }
                        Dl(i);
                    } catch (t1) {
                        e = t1, Lo === i && null !== i && (Lo = i = i.return);
                        continue;
                    }
                    break;
                }
            }
            function Tl() {
                var t1 = No.current;
                return No.current = Cs, null === t1 ? Cs : t1;
            }
            function El(t1, e) {
                var i = Co;
                Co |= 16;
                var n = Tl();
                for(zo === t1 && Oo === e || wl(t1, e);;)try {
                    Il();
                    break;
                } catch (e) {
                    bl(t1, e);
                }
                if (ea(), Co = i, No.current = n, null !== Lo) throw Error(s(261));
                return zo = null, Oo = 0, Po;
            }
            function Il() {
                for(; null !== Lo;)Nl(Lo);
            }
            function Sl() {
                for(; null !== Lo && !Sr();)Nl(Lo);
            }
            function Nl(t1) {
                var e = Yo(t1.alternate, t1, _o);
                t1.memoizedProps = t1.pendingProps, null === e ? Dl(t1) : Lo = e, Do.current = null;
            }
            function Dl(t1) {
                var e = t1;
                do {
                    var i = e.alternate;
                    if (t1 = e.return, 2048 & e.flags) {
                        if (null !== (i = ao(e))) return i.flags &= 2047, void (Lo = i);
                        null !== t1 && (t1.firstEffect = t1.lastEffect = null, t1.flags |= 2048);
                    } else {
                        if (null !== (i = ro(i, e, _o))) return void (Lo = i);
                        if (24 !== (i = e).tag && 23 !== i.tag || null === i.memoizedState || 1073741824 & _o || !(4 & i.mode)) {
                            for(var n = 0, r = i.child; null !== r;)n |= r.lanes | r.childLanes, r = r.sibling;
                            i.childLanes = n;
                        }
                        null !== t1 && !(2048 & t1.flags) && (null === t1.firstEffect && (t1.firstEffect = e.firstEffect), null !== e.lastEffect && (null !== t1.lastEffect && (t1.lastEffect.nextEffect = e.firstEffect), t1.lastEffect = e.lastEffect), 1 < e.flags && (null !== t1.lastEffect ? t1.lastEffect.nextEffect = e : t1.firstEffect = e, t1.lastEffect = e));
                    }
                    if (null !== (e = e.sibling)) return void (Lo = e);
                    Lo = e = t1;
                }while (null !== e);
                0 === Po && (Po = 5);
            }
            function Cl(t1) {
                var e = Hr();
                return Gr(99, zl.bind(null, t1, e)), null;
            }
            function zl(t1, e) {
                do Ol();
                while (null !== qo);
                if (48 & Co) throw Error(s(327));
                var i = t1.finishedWork;
                if (null === i) return null;
                if (t1.finishedWork = null, t1.finishedLanes = 0, i === t1.current) throw Error(s(177));
                t1.callbackNode = null;
                var n = i.lanes | i.childLanes, r = n, a = t1.pendingLanes & ~r;
                t1.pendingLanes = r, t1.suspendedLanes = 0, t1.pingedLanes = 0, t1.expiredLanes &= r, t1.mutableReadLanes &= r, t1.entangledLanes &= r, r = t1.entanglements;
                for(var o = t1.eventTimes, l = t1.expirationTimes; 0 < a;){
                    var c = 31 - He(a), u = 1 << c;
                    r[c] = 0, o[c] = -1, l[c] = -1, a &= ~u;
                }
                if (null !== il && !(24 & n) && il.has(t1) && il.delete(t1), t1 === zo && (Lo = zo = null, Oo = 0), 1 < i.flags ? null !== i.lastEffect ? (i.lastEffect.nextEffect = i, n = i.firstEffect) : n = i : n = i.firstEffect, null !== n) {
                    if (r = Co, Co |= 32, Do.current = null, Bn = Xe, gn(o = An())) {
                        if ("selectionStart" in o) l = {
                            start: o.selectionStart,
                            end: o.selectionEnd
                        };
                        else t: if (l = (l = o.ownerDocument) && l.defaultView || window, (u = l.getSelection && l.getSelection()) && 0 !== u.rangeCount) {
                            l = u.anchorNode, a = u.anchorOffset, c = u.focusNode, u = u.focusOffset;
                            try {
                                l.nodeType, c.nodeType;
                            } catch (t1) {
                                l = null;
                                break t;
                            }
                            var h = 0, d = -1, p = -1, f = 0, A = 0, g = o, m = null;
                            e: for(;;){
                                for(var M; g !== l || 0 !== a && 3 !== g.nodeType || (d = h + a), g !== c || 0 !== u && 3 !== g.nodeType || (p = h + u), 3 === g.nodeType && (h += g.nodeValue.length), null !== (M = g.firstChild);)m = g, g = M;
                                for(;;){
                                    if (g === o) break e;
                                    if (m === l && ++f === a && (d = h), m === c && ++A === u && (p = h), null !== (M = g.nextSibling)) break;
                                    m = (g = m).parentNode;
                                }
                                g = M;
                            }
                            l = -1 === d || -1 === p ? null : {
                                start: d,
                                end: p
                            };
                        } else l = null;
                        l = l || {
                            start: 0,
                            end: 0
                        };
                    } else l = null;
                    Fn = {
                        focusedElem: o,
                        selectionRange: l
                    }, Xe = !1, ll = null, cl = !1, Wo = n;
                    do try {
                        Ll();
                    } catch (t1) {
                        if (null === Wo) throw Error(s(330));
                        Ul(Wo, t1), Wo = Wo.nextEffect;
                    }
                    while (null !== Wo);
                    ll = null, Wo = n;
                    do try {
                        for(o = t1; null !== Wo;){
                            var y = Wo.flags;
                            if (16 & y && mt(Wo.stateNode, ""), 128 & y) {
                                var v = Wo.alternate;
                                if (null !== v) {
                                    var x = v.ref;
                                    null !== x && ("function" == typeof x ? x(null) : x.current = null);
                                }
                            }
                            switch(1038 & y){
                                case 2:
                                    vo(Wo), Wo.flags &= -3;
                                    break;
                                case 6:
                                    vo(Wo), Wo.flags &= -3, To(Wo.alternate, Wo);
                                    break;
                                case 1024:
                                    Wo.flags &= -1025;
                                    break;
                                case 1028:
                                    Wo.flags &= -1025, To(Wo.alternate, Wo);
                                    break;
                                case 4:
                                    To(Wo.alternate, Wo);
                                    break;
                                case 8:
                                    bo(o, l = Wo);
                                    var w = l.alternate;
                                    Mo(l), null !== w && Mo(w);
                            }
                            Wo = Wo.nextEffect;
                        }
                    } catch (t1) {
                        if (null === Wo) throw Error(s(330));
                        Ul(Wo, t1), Wo = Wo.nextEffect;
                    }
                    while (null !== Wo);
                    if (x = Fn, v = An(), y = x.focusedElem, o = x.selectionRange, v !== y && y && y.ownerDocument && fn(y.ownerDocument.documentElement, y)) {
                        null !== o && gn(y) && (v = o.start, void 0 === (x = o.end) && (x = v), "selectionStart" in y ? (y.selectionStart = v, y.selectionEnd = Math.min(x, y.value.length)) : (x = (v = y.ownerDocument || document) && v.defaultView || window).getSelection && (x = x.getSelection(), l = y.textContent.length, w = Math.min(o.start, l), o = void 0 === o.end ? w : Math.min(o.end, l), !x.extend && w > o && (l = o, o = w, w = l), l = pn(y, w), a = pn(y, o), l && a && (1 !== x.rangeCount || x.anchorNode !== l.node || x.anchorOffset !== l.offset || x.focusNode !== a.node || x.focusOffset !== a.offset) && ((v = v.createRange()).setStart(l.node, l.offset), x.removeAllRanges(), w > o ? (x.addRange(v), x.extend(a.node, a.offset)) : (v.setEnd(a.node, a.offset), x.addRange(v))))), v = [];
                        for(x = y; x = x.parentNode;)1 === x.nodeType && v.push({
                            element: x,
                            left: x.scrollLeft,
                            top: x.scrollTop
                        });
                        for("function" == typeof y.focus && y.focus(), y = 0; y < v.length; y++)(x = v[y]).element.scrollLeft = x.left, x.element.scrollTop = x.top;
                    }
                    Xe = !!Bn, Fn = Bn = null, t1.current = i, Wo = n;
                    do try {
                        for(y = t1; null !== Wo;){
                            var b = Wo.flags;
                            if (36 & b && Ao(y, Wo.alternate, Wo), 128 & b) {
                                v = void 0;
                                var T = Wo.ref;
                                if (null !== T) {
                                    var E = Wo.stateNode;
                                    Wo.tag, v = E, "function" == typeof T ? T(v) : T.current = v;
                                }
                            }
                            Wo = Wo.nextEffect;
                        }
                    } catch (t1) {
                        if (null === Wo) throw Error(s(330));
                        Ul(Wo, t1), Wo = Wo.nextEffect;
                    }
                    while (null !== Wo);
                    Wo = null, Rr(), Co = r;
                } else t1.current = i;
                if (Ko) Ko = !1, qo = t1, $o = e;
                else for(Wo = n; null !== Wo;)e = Wo.nextEffect, Wo.nextEffect = null, 8 & Wo.flags && ((b = Wo).sibling = null, b.stateNode = null), Wo = e;
                if (0 === (n = t1.pendingLanes) && (Jo = null), 1 === n ? t1 === rl ? nl++ : (nl = 0, rl = t1) : nl = 0, i = i.stateNode, br && "function" == typeof br.onCommitFiberRoot) try {
                    br.onCommitFiberRoot(wr, i, void 0, !(64 & ~i.current.flags));
                } catch (t1) {}
                if (fl(t1, Qr()), Xo) throw Xo = !1, t1 = Zo, Zo = null, t1;
                return 8 & Co || Wr(), null;
            }
            function Ll() {
                for(; null !== Wo;){
                    var t1 = Wo.alternate;
                    cl || null === ll || (8 & Wo.flags ? $t(Wo, ll) && (cl = !0) : 13 === Wo.tag && Io(t1, Wo) && $t(Wo, ll) && (cl = !0));
                    var e = Wo.flags;
                    256 & e && fo(t1, Wo), !(512 & e) || Ko || (Ko = !0, Yr(97, function() {
                        return Ol(), null;
                    })), Wo = Wo.nextEffect;
                }
            }
            function Ol() {
                if (90 !== $o) {
                    var t1 = 97 < $o ? 97 : $o;
                    return $o = 90, Gr(t1, Pl);
                }
                return !1;
            }
            function _l(t1, e) {
                tl.push(e, t1), Ko || (Ko = !0, Yr(97, function() {
                    return Ol(), null;
                }));
            }
            function jl(t1, e) {
                el.push(e, t1), Ko || (Ko = !0, Yr(97, function() {
                    return Ol(), null;
                }));
            }
            function Pl() {
                if (null === qo) return !1;
                var t1 = qo;
                if (qo = null, 48 & Co) throw Error(s(331));
                var e = Co;
                Co |= 32;
                var i = el;
                el = [];
                for(var n = 0; n < i.length; n += 2){
                    var r = i[n], a = i[n + 1], o = r.destroy;
                    if (r.destroy = void 0, "function" == typeof o) try {
                        o();
                    } catch (t1) {
                        if (null === a) throw Error(s(330));
                        Ul(a, t1);
                    }
                }
                for(i = tl, tl = [], n = 0; n < i.length; n += 2){
                    r = i[n], a = i[n + 1];
                    try {
                        var l = r.create;
                        r.destroy = l();
                    } catch (t1) {
                        if (null === a) throw Error(s(330));
                        Ul(a, t1);
                    }
                }
                for(l = t1.current.firstEffect; null !== l;)t1 = l.nextEffect, l.nextEffect = null, 8 & l.flags && (l.sibling = null, l.stateNode = null), l = t1;
                return Co = e, Wr(), !0;
            }
            function Rl(t1, e, i) {
                ua(t1, e = co(0, e = so(i, e), 1)), e = ul(), null !== (t1 = pl(t1, 1)) && (Qe(t1, 1, e), fl(t1, e));
            }
            function Ul(t1, e) {
                if (3 === t1.tag) Rl(t1, t1, e);
                else for(var i = t1.return; null !== i;){
                    if (3 === i.tag) {
                        Rl(i, t1, e);
                        break;
                    }
                    if (1 === i.tag) {
                        var n = i.stateNode;
                        if ("function" == typeof i.type.getDerivedStateFromError || "function" == typeof n.componentDidCatch && (null === Jo || !Jo.has(n))) {
                            var r = uo(i, t1 = so(e, t1), 1);
                            if (ua(i, r), r = ul(), null !== (i = pl(i, 1))) Qe(i, 1, r), fl(i, r);
                            else if ("function" == typeof n.componentDidCatch && (null === Jo || !Jo.has(n))) try {
                                n.componentDidCatch(e, t1);
                            } catch (t1) {}
                            break;
                        }
                    }
                    i = i.return;
                }
            }
            function kl(t1, e, i) {
                var n = t1.pingCache;
                null !== n && n.delete(e), e = ul(), t1.pingedLanes |= t1.suspendedLanes & i, zo === t1 && (Oo & i) === i && (4 === Po || 3 === Po && (62914560 & Oo) === Oo && 500 > Qr() - Ho ? wl(t1, 0) : Fo |= i), fl(t1, e);
            }
            function Bl(t1, e) {
                var i = t1.stateNode;
                null !== i && i.delete(e), 0 == (e = 0) && (2 & (e = t1.mode) ? 4 & e ? (0 === sl && (sl = Uo), 0 === (e = Be(62914560 & ~sl)) && (e = 4194304)) : e = 99 === Hr() ? 1 : 2 : e = 1), i = ul(), null !== (t1 = pl(t1, e)) && (Qe(t1, e, i), fl(t1, i));
            }
            function Fl(t1, e, i, n) {
                this.tag = t1, this.key = i, this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null, this.index = 0, this.ref = null, this.pendingProps = e, this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null, this.mode = n, this.flags = 0, this.lastEffect = this.firstEffect = this.nextEffect = null, this.childLanes = this.lanes = 0, this.alternate = null;
            }
            function Ql(t1, e, i, n) {
                return new Fl(t1, e, i, n);
            }
            function Hl(t1) {
                return !(!(t1 = t1.prototype) || !t1.isReactComponent);
            }
            function Vl(t1, e) {
                var i = t1.alternate;
                return null === i ? ((i = Ql(t1.tag, e, t1.key, t1.mode)).elementType = t1.elementType, i.type = t1.type, i.stateNode = t1.stateNode, i.alternate = t1, t1.alternate = i) : (i.pendingProps = e, i.type = t1.type, i.flags = 0, i.nextEffect = null, i.firstEffect = null, i.lastEffect = null), i.childLanes = t1.childLanes, i.lanes = t1.lanes, i.child = t1.child, i.memoizedProps = t1.memoizedProps, i.memoizedState = t1.memoizedState, i.updateQueue = t1.updateQueue, e = t1.dependencies, i.dependencies = null === e ? null : {
                    lanes: e.lanes,
                    firstContext: e.firstContext
                }, i.sibling = t1.sibling, i.index = t1.index, i.ref = t1.ref, i;
            }
            function Gl(t1, e, i, n, r, a) {
                var o = 2;
                if (n = t1, "function" == typeof t1) Hl(t1) && (o = 1);
                else if ("string" == typeof t1) o = 5;
                else t: switch(t1){
                    case T:
                        return Yl(i.children, r, a, e);
                    case P:
                        o = 8, r |= 16;
                        break;
                    case E:
                        o = 8, r |= 1;
                        break;
                    case I:
                        return (t1 = Ql(12, i, e, 8 | r)).elementType = I, t1.type = I, t1.lanes = a, t1;
                    case C:
                        return (t1 = Ql(13, i, e, r)).type = C, t1.elementType = C, t1.lanes = a, t1;
                    case z:
                        return (t1 = Ql(19, i, e, r)).elementType = z, t1.lanes = a, t1;
                    case R:
                        return Wl(i, r, a, e);
                    case U:
                        return (t1 = Ql(24, i, e, r)).elementType = U, t1.lanes = a, t1;
                    default:
                        if ("object" == typeof t1 && null !== t1) switch(t1.$$typeof){
                            case S:
                                o = 10;
                                break t;
                            case N:
                                o = 9;
                                break t;
                            case D:
                                o = 11;
                                break t;
                            case L:
                                o = 14;
                                break t;
                            case O:
                                o = 16, n = null;
                                break t;
                            case _:
                                o = 22;
                                break t;
                        }
                        throw Error(s(130, null == t1 ? t1 : typeof t1, ""));
                }
                return (e = Ql(o, i, e, r)).elementType = t1, e.type = n, e.lanes = a, e;
            }
            function Yl(t1, e, i, n) {
                return (t1 = Ql(7, t1, n, e)).lanes = i, t1;
            }
            function Wl(t1, e, i, n) {
                return (t1 = Ql(23, t1, n, e)).elementType = R, t1.lanes = i, t1;
            }
            function Xl(t1, e, i) {
                return (t1 = Ql(6, t1, null, e)).lanes = i, t1;
            }
            function Zl(t1, e, i) {
                return (e = Ql(4, null !== t1.children ? t1.children : [], t1.key, e)).lanes = i, e.stateNode = {
                    containerInfo: t1.containerInfo,
                    pendingChildren: null,
                    implementation: t1.implementation
                }, e;
            }
            function Jl(t1, e, i) {
                this.tag = e, this.containerInfo = t1, this.finishedWork = this.pingCache = this.current = this.pendingChildren = null, this.timeoutHandle = -1, this.pendingContext = this.context = null, this.hydrate = i, this.callbackNode = null, this.callbackPriority = 0, this.eventTimes = Fe(0), this.expirationTimes = Fe(-1), this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0, this.entanglements = Fe(0), this.mutableSourceEagerHydrationData = null;
            }
            function Kl(t1, e, i, n) {
                var r = e.current, a = ul(), o = hl(r);
                t: if (i) {
                    e: {
                        if (Zt(i = i._reactInternals) !== i || 1 !== i.tag) throw Error(s(170));
                        var l = i;
                        do {
                            switch(l.tag){
                                case 3:
                                    l = l.stateNode.context;
                                    break e;
                                case 1:
                                    if (gr(l.type)) {
                                        l = l.stateNode.__reactInternalMemoizedMergedChildContext;
                                        break e;
                                    }
                            }
                            l = l.return;
                        }while (null !== l);
                        throw Error(s(171));
                    }
                    if (1 === i.tag) {
                        var c = i.type;
                        if (gr(c)) {
                            i = yr(i, c, l);
                            break t;
                        }
                    }
                    i = l;
                } else i = hr;
                return null === e.context ? e.context = i : e.pendingContext = i, (e = ca(a, o)).payload = {
                    element: t1
                }, null !== (n = void 0 === n ? null : n) && (e.callback = n), ua(r, e), dl(r, o, a), o;
            }
            function ql(t1) {
                return (t1 = t1.current).child ? (t1.child.tag, t1.child.stateNode) : null;
            }
            function $l(t1, e) {
                if (null !== (t1 = t1.memoizedState) && null !== t1.dehydrated) {
                    var i = t1.retryLane;
                    t1.retryLane = 0 !== i && i < e ? i : e;
                }
            }
            function tc(t1, e) {
                $l(t1, e), (t1 = t1.alternate) && $l(t1, e);
            }
            function ec(t1, e, i) {
                var n = null != i && null != i.hydrationOptions && i.hydrationOptions.mutableSources || null;
                if (i = new Jl(t1, e, null != i && !0 === i.hydrate), e = Ql(3, null, null, 2 === e ? 7 : 1 === e ? 3 : 0), i.current = e, e.stateNode = i, oa(e), t1[$n] = i.current, zn(8 === t1.nodeType ? t1.parentNode : t1), n) for(t1 = 0; t1 < n.length; t1++){
                    var r = (e = n[t1])._getVersion;
                    r = r(e._source), null == i.mutableSourceEagerHydrationData ? i.mutableSourceEagerHydrationData = [
                        e,
                        r
                    ] : i.mutableSourceEagerHydrationData.push(e, r);
                }
                this._internalRoot = i;
            }
            function ic(t1) {
                return !(!t1 || 1 !== t1.nodeType && 9 !== t1.nodeType && 11 !== t1.nodeType && (8 !== t1.nodeType || " react-mount-point-unstable " !== t1.nodeValue));
            }
            function nc(t1, e, i, n, r) {
                var a = i._reactRootContainer;
                if (a) {
                    var s = a._internalRoot;
                    if ("function" == typeof r) {
                        var o = r;
                        r = function() {
                            var t1 = ql(s);
                            o.call(t1);
                        };
                    }
                    Kl(e, s, t1, r);
                } else {
                    if (a = i._reactRootContainer = function(t1, e) {
                        if (e || (e = !(!(e = t1 ? 9 === t1.nodeType ? t1.documentElement : t1.firstChild : null) || 1 !== e.nodeType || !e.hasAttribute("data-reactroot"))), !e) for(var i; i = t1.lastChild;)t1.removeChild(i);
                        return new ec(t1, 0, e ? {
                            hydrate: !0
                        } : void 0);
                    }(i, n), s = a._internalRoot, "function" == typeof r) {
                        var l = r;
                        r = function() {
                            var t1 = ql(s);
                            l.call(t1);
                        };
                    }
                    yl(function() {
                        Kl(e, s, t1, r);
                    });
                }
                return ql(s);
            }
            function rc(t1, e) {
                var i = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
                if (!ic(e)) throw Error(s(200));
                return function(t1, e, i) {
                    var n = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
                    return {
                        $$typeof: b,
                        key: null == n ? null : "" + n,
                        children: t1,
                        containerInfo: e,
                        implementation: i
                    };
                }(t1, e, null, i);
            }
            Yo = function(t1, e, i) {
                var n = e.lanes;
                if (null !== t1) {
                    if (t1.memoizedProps !== e.pendingProps || pr.current) js = !0;
                    else {
                        if (!(i & n)) {
                            switch(js = !1, e.tag){
                                case 3:
                                    Gs(e), Ya();
                                    break;
                                case 5:
                                    _a(e);
                                    break;
                                case 1:
                                    gr(e.type) && vr(e);
                                    break;
                                case 4:
                                    La(e, e.stateNode.containerInfo);
                                    break;
                                case 10:
                                    n = e.memoizedProps.value;
                                    var r = e.type._context;
                                    ur(Kr, r._currentValue), r._currentValue = n;
                                    break;
                                case 13:
                                    if (null !== e.memoizedState) return i & e.child.childLanes ? Ks(t1, e, i) : (ur(Pa, 1 & Pa.current), null !== (e = io(t1, e, i)) ? e.sibling : null);
                                    ur(Pa, 1 & Pa.current);
                                    break;
                                case 19:
                                    if (n = !!(i & e.childLanes), 64 & t1.flags) {
                                        if (n) return eo(t1, e, i);
                                        e.flags |= 64;
                                    }
                                    if (null !== (r = e.memoizedState) && (r.rendering = null, r.tail = null, r.lastEffect = null), ur(Pa, Pa.current), n) break;
                                    return null;
                                case 23:
                                case 24:
                                    return e.lanes = 0, Bs(t1, e, i);
                            }
                            return io(t1, e, i);
                        }
                        js = !!(16384 & t1.flags);
                    }
                } else js = !1;
                switch(e.lanes = 0, e.tag){
                    case 2:
                        if (n = e.type, null !== t1 && (t1.alternate = null, e.alternate = null, e.flags |= 2), t1 = e.pendingProps, r = Ar(e, dr.current), ra(e, i), r = as(null, e, n, t1, r, i), e.flags |= 1, "object" == typeof r && null !== r && "function" == typeof r.render && void 0 === r.$$typeof) {
                            if (e.tag = 1, e.memoizedState = null, e.updateQueue = null, gr(n)) {
                                var a = !0;
                                vr(e);
                            } else a = !1;
                            e.memoizedState = null !== r.state && void 0 !== r.state ? r.state : null, oa(e);
                            var o = n.getDerivedStateFromProps;
                            "function" == typeof o && Aa(e, n, o, t1), r.updater = ga, e.stateNode = r, r._reactInternals = e, va(e, n, t1, i), e = Vs(null, e, n, !0, a, i);
                        } else e.tag = 0, Ps(null, e, r, i), e = e.child;
                        return e;
                    case 16:
                        r = e.elementType;
                        t: {
                            switch(null !== t1 && (t1.alternate = null, e.alternate = null, e.flags |= 2), t1 = e.pendingProps, r = (a = r._init)(r._payload), e.type = r, a = e.tag = function(t1) {
                                if ("function" == typeof t1) return Hl(t1) ? 1 : 0;
                                if (null != t1) {
                                    if ((t1 = t1.$$typeof) === D) return 11;
                                    if (t1 === L) return 14;
                                }
                                return 2;
                            }(r), t1 = Jr(r, t1), a){
                                case 0:
                                    e = Qs(null, e, r, t1, i);
                                    break t;
                                case 1:
                                    e = Hs(null, e, r, t1, i);
                                    break t;
                                case 11:
                                    e = Rs(null, e, r, t1, i);
                                    break t;
                                case 14:
                                    e = Us(null, e, r, Jr(r.type, t1), n, i);
                                    break t;
                            }
                            throw Error(s(306, r, ""));
                        }
                        return e;
                    case 0:
                        return n = e.type, r = e.pendingProps, Qs(t1, e, n, r = e.elementType === n ? r : Jr(n, r), i);
                    case 1:
                        return n = e.type, r = e.pendingProps, Hs(t1, e, n, r = e.elementType === n ? r : Jr(n, r), i);
                    case 3:
                        if (Gs(e), n = e.updateQueue, null === t1 || null === n) throw Error(s(282));
                        if (n = e.pendingProps, r = null !== (r = e.memoizedState) ? r.element : null, la(t1, e), da(e, n, null, i), (n = e.memoizedState.element) === r) Ya(), e = io(t1, e, i);
                        else {
                            if ((a = (r = e.stateNode).hydrate) && (ka = Wn(e.stateNode.containerInfo.firstChild), Ua = e, a = Ba = !0), a) {
                                if (null != (t1 = r.mutableSourceEagerHydrationData)) for(r = 0; r < t1.length; r += 2)(a = t1[r])._workInProgressVersionPrimary = t1[r + 1], Wa.push(a);
                                for(i = Ia(e, null, n, i), e.child = i; i;)i.flags = -3 & i.flags | 1024, i = i.sibling;
                            } else Ps(t1, e, n, i), Ya();
                            e = e.child;
                        }
                        return e;
                    case 5:
                        return _a(e), null === t1 && Ha(e), n = e.type, r = e.pendingProps, a = null !== t1 ? t1.memoizedProps : null, o = r.children, Hn(n, r) ? o = null : null !== a && Hn(n, a) && (e.flags |= 16), Fs(t1, e), Ps(t1, e, o, i), e.child;
                    case 6:
                        return null === t1 && Ha(e), null;
                    case 13:
                        return Ks(t1, e, i);
                    case 4:
                        return La(e, e.stateNode.containerInfo), n = e.pendingProps, null === t1 ? e.child = Ea(e, null, n, i) : Ps(t1, e, n, i), e.child;
                    case 11:
                        return n = e.type, r = e.pendingProps, Rs(t1, e, n, r = e.elementType === n ? r : Jr(n, r), i);
                    case 7:
                        return Ps(t1, e, e.pendingProps, i), e.child;
                    case 8:
                    case 12:
                        return Ps(t1, e, e.pendingProps.children, i), e.child;
                    case 10:
                        t: {
                            n = e.type._context, r = e.pendingProps, o = e.memoizedProps, a = r.value;
                            var l = e.type._context;
                            if (ur(Kr, l._currentValue), l._currentValue = a, null !== o) {
                                if (l = o.value, 0 == (a = cn(l, a) ? 0 : 0 | ("function" == typeof n._calculateChangedBits ? n._calculateChangedBits(l, a) : 1073741823))) {
                                    if (o.children === r.children && !pr.current) {
                                        e = io(t1, e, i);
                                        break t;
                                    }
                                } else for(null !== (l = e.child) && (l.return = e); null !== l;){
                                    var c = l.dependencies;
                                    if (null !== c) {
                                        o = l.child;
                                        for(var u = c.firstContext; null !== u;){
                                            if (u.context === n && u.observedBits & a) {
                                                1 === l.tag && ((u = ca(-1, i & -i)).tag = 2, ua(l, u)), l.lanes |= i, null !== (u = l.alternate) && (u.lanes |= i), na(l.return, i), c.lanes |= i;
                                                break;
                                            }
                                            u = u.next;
                                        }
                                    } else o = 10 === l.tag && l.type === e.type ? null : l.child;
                                    if (null !== o) o.return = l;
                                    else for(o = l; null !== o;){
                                        if (o === e) {
                                            o = null;
                                            break;
                                        }
                                        if (null !== (l = o.sibling)) {
                                            l.return = o.return, o = l;
                                            break;
                                        }
                                        o = o.return;
                                    }
                                    l = o;
                                }
                            }
                            Ps(t1, e, r.children, i), e = e.child;
                        }
                        return e;
                    case 9:
                        return r = e.type, n = (a = e.pendingProps).children, ra(e, i), n = n(r = aa(r, a.unstable_observedBits)), e.flags |= 1, Ps(t1, e, n, i), e.child;
                    case 14:
                        return a = Jr(r = e.type, e.pendingProps), Us(t1, e, r, a = Jr(r.type, a), n, i);
                    case 15:
                        return ks(t1, e, e.type, e.pendingProps, n, i);
                    case 17:
                        return n = e.type, r = e.pendingProps, r = e.elementType === n ? r : Jr(n, r), null !== t1 && (t1.alternate = null, e.alternate = null, e.flags |= 2), e.tag = 1, gr(n) ? (t1 = !0, vr(e)) : t1 = !1, ra(e, i), Ma(e, n, r), va(e, n, r, i), Vs(null, e, n, !0, t1, i);
                    case 19:
                        return eo(t1, e, i);
                    case 23:
                    case 24:
                        return Bs(t1, e, i);
                }
                throw Error(s(156, e.tag));
            }, ec.prototype.render = function(t1) {
                Kl(t1, this._internalRoot, null, null);
            }, ec.prototype.unmount = function() {
                var t1 = this._internalRoot, e = t1.containerInfo;
                Kl(null, t1, null, function() {
                    e[$n] = null;
                });
            }, te = function(t1) {
                13 === t1.tag && (dl(t1, 4, ul()), tc(t1, 4));
            }, ee = function(t1) {
                13 === t1.tag && (dl(t1, 67108864, ul()), tc(t1, 67108864));
            }, ie = function(t1) {
                if (13 === t1.tag) {
                    var e = ul(), i = hl(t1);
                    dl(t1, i, e), tc(t1, i);
                }
            }, ne = function(t1, e) {
                return e();
            }, It = function(t1, e, i) {
                switch(e){
                    case "input":
                        if (it(t1, i), e = i.name, "radio" === i.type && null != e) {
                            for(i = t1; i.parentNode;)i = i.parentNode;
                            for(i = i.querySelectorAll("input[name=" + JSON.stringify("" + e) + '][type="radio"]'), e = 0; e < i.length; e++){
                                var n = i[e];
                                if (n !== t1 && n.form === t1.form) {
                                    var r = rr(n);
                                    if (!r) throw Error(s(90));
                                    K(n), it(n, r);
                                }
                            }
                        }
                        break;
                    case "textarea":
                        ct(t1, i);
                        break;
                    case "select":
                        null != (e = i.value) && st(t1, !!i.multiple, e, !1);
                }
            }, Lt = Ml, Ot = function(t1, e, i, n, r) {
                var a = Co;
                Co |= 4;
                try {
                    return Gr(98, t1.bind(null, e, i, n, r));
                } finally{
                    0 === (Co = a) && (Go(), Wr());
                }
            }, _t = function() {
                !(49 & Co) && (function() {
                    if (null !== il) {
                        var t1 = il;
                        il = null, t1.forEach(function(t1) {
                            t1.expiredLanes |= 24 & t1.pendingLanes, fl(t1, Qr());
                        });
                    }
                    Wr();
                }(), Ol());
            }, jt = function(t1, e) {
                var i = Co;
                Co |= 2;
                try {
                    return t1(e);
                } finally{
                    0 === (Co = i) && (Go(), Wr());
                }
            };
            var ac = {
                Events: [
                    ir,
                    nr,
                    rr,
                    Ct,
                    zt,
                    Ol,
                    {
                        current: !1
                    }
                ]
            }, sc = {
                findFiberByHostInstance: er,
                bundleType: 0,
                version: "17.0.2",
                rendererPackageName: "react-dom"
            }, oc = {
                bundleType: sc.bundleType,
                version: sc.version,
                rendererPackageName: sc.rendererPackageName,
                rendererConfig: sc.rendererConfig,
                overrideHookState: null,
                overrideHookStateDeletePath: null,
                overrideHookStateRenamePath: null,
                overrideProps: null,
                overridePropsDeletePath: null,
                overridePropsRenamePath: null,
                setSuspenseHandler: null,
                scheduleUpdate: null,
                currentDispatcherRef: x.ReactCurrentDispatcher,
                findHostInstanceByFiber: function(t1) {
                    return null === (t1 = qt(t1)) ? null : t1.stateNode;
                },
                findFiberByHostInstance: sc.findFiberByHostInstance || function() {
                    return null;
                },
                findHostInstancesForRefresh: null,
                scheduleRefresh: null,
                scheduleRoot: null,
                setRefreshHandler: null,
                getCurrentFiber: null
            };
            if ("undefined" != typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
                var lc = __REACT_DEVTOOLS_GLOBAL_HOOK__;
                if (!lc.isDisabled && lc.supportsFiber) try {
                    wr = lc.inject(oc), br = lc;
                } catch (At) {}
            }
            e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = ac, e.createPortal = rc, e.findDOMNode = function(t1) {
                if (null == t1) return null;
                if (1 === t1.nodeType) return t1;
                var e = t1._reactInternals;
                if (void 0 === e) {
                    if ("function" == typeof t1.render) throw Error(s(188));
                    throw Error(s(268, Object.keys(t1)));
                }
                return null === (t1 = qt(e)) ? null : t1.stateNode;
            }, e.flushSync = function(t1, e) {
                var i = Co;
                if (48 & i) return t1(e);
                Co |= 1;
                try {
                    if (t1) return Gr(99, t1.bind(null, e));
                } finally{
                    Co = i, Wr();
                }
            }, e.hydrate = function(t1, e, i) {
                if (!ic(e)) throw Error(s(200));
                return nc(null, t1, e, !0, i);
            }, e.render = function(t1, e, i) {
                if (!ic(e)) throw Error(s(200));
                return nc(null, t1, e, !1, i);
            }, e.unmountComponentAtNode = function(t1) {
                if (!ic(t1)) throw Error(s(40));
                return !!t1._reactRootContainer && (yl(function() {
                    nc(null, null, t1, !1, function() {
                        t1._reactRootContainer = null, t1[$n] = null;
                    });
                }), !0);
            }, e.unstable_batchedUpdates = Ml, e.unstable_createPortal = function(t1, e) {
                return rc(t1, e, 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null);
            }, e.unstable_renderSubtreeIntoContainer = function(t1, e, i, n) {
                if (!ic(i)) throw Error(s(200));
                if (null == t1 || void 0 === t1._reactInternals) throw Error(s(38));
                return nc(t1, e, i, !1, n);
            }, e.version = "17.0.2";
        },
        961: (t1, e, i)=>{
            "use strict";
            !function t1() {
                if ("undefined" != typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ && "function" == typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE) try {
                    __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(t1);
                } catch (t1) {
                    console.error(t1);
                }
            }(), t1.exports = i(551);
        },
        287: (t1, e, i)=>{
            "use strict";
            var n = i(228), r = 60103, a = 60106;
            e.Fragment = 60107, e.StrictMode = 60108, e.Profiler = 60114;
            var s = 60109, o = 60110, l = 60112;
            e.Suspense = 60113;
            var c = 60115, u = 60116;
            if ("function" == typeof Symbol && Symbol.for) {
                var h = Symbol.for;
                r = h("react.element"), a = h("react.portal"), e.Fragment = h("react.fragment"), e.StrictMode = h("react.strict_mode"), e.Profiler = h("react.profiler"), s = h("react.provider"), o = h("react.context"), l = h("react.forward_ref"), e.Suspense = h("react.suspense"), c = h("react.memo"), u = h("react.lazy");
            }
            var d = "function" == typeof Symbol && Symbol.iterator;
            function p(t1) {
                for(var e = "https://reactjs.org/docs/error-decoder.html?invariant=" + t1, i = 1; i < arguments.length; i++)e += "&args[]=" + encodeURIComponent(arguments[i]);
                return "Minified React error #" + t1 + "; visit " + e + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
            }
            var f = {
                isMounted: function() {
                    return !1;
                },
                enqueueForceUpdate: function() {},
                enqueueReplaceState: function() {},
                enqueueSetState: function() {}
            }, A = {};
            function g(t1, e, i) {
                this.props = t1, this.context = e, this.refs = A, this.updater = i || f;
            }
            function m() {}
            function M(t1, e, i) {
                this.props = t1, this.context = e, this.refs = A, this.updater = i || f;
            }
            g.prototype.isReactComponent = {}, g.prototype.setState = function(t1, e) {
                if ("object" != typeof t1 && "function" != typeof t1 && null != t1) throw Error(p(85));
                this.updater.enqueueSetState(this, t1, e, "setState");
            }, g.prototype.forceUpdate = function(t1) {
                this.updater.enqueueForceUpdate(this, t1, "forceUpdate");
            }, m.prototype = g.prototype;
            var y = M.prototype = new m;
            y.constructor = M, n(y, g.prototype), y.isPureReactComponent = !0;
            var v = {
                current: null
            }, x = Object.prototype.hasOwnProperty, w = {
                key: !0,
                ref: !0,
                __self: !0,
                __source: !0
            };
            function b(t1, e, i) {
                var n, a = {}, s = null, o = null;
                if (null != e) for(n in void 0 !== e.ref && (o = e.ref), void 0 !== e.key && (s = "" + e.key), e)x.call(e, n) && !w.hasOwnProperty(n) && (a[n] = e[n]);
                var l = arguments.length - 2;
                if (1 === l) a.children = i;
                else if (1 < l) {
                    for(var c = Array(l), u = 0; u < l; u++)c[u] = arguments[u + 2];
                    a.children = c;
                }
                if (t1 && t1.defaultProps) for(n in l = t1.defaultProps)void 0 === a[n] && (a[n] = l[n]);
                return {
                    $$typeof: r,
                    type: t1,
                    key: s,
                    ref: o,
                    props: a,
                    _owner: v.current
                };
            }
            function T(t1) {
                return "object" == typeof t1 && null !== t1 && t1.$$typeof === r;
            }
            var E = /\/+/g;
            function I(t1, e) {
                return "object" == typeof t1 && null !== t1 && null != t1.key ? function(t1) {
                    var e = {
                        "=": "=0",
                        ":": "=2"
                    };
                    return "$" + t1.replace(/[=:]/g, function(t1) {
                        return e[t1];
                    });
                }("" + t1.key) : e.toString(36);
            }
            function S(t1, e, i, n, s) {
                var o = typeof t1;
                "undefined" !== o && "boolean" !== o || (t1 = null);
                var l = !1;
                if (null === t1) l = !0;
                else switch(o){
                    case "string":
                    case "number":
                        l = !0;
                        break;
                    case "object":
                        switch(t1.$$typeof){
                            case r:
                            case a:
                                l = !0;
                        }
                }
                if (l) return s = s(l = t1), t1 = "" === n ? "." + I(l, 0) : n, Array.isArray(s) ? (i = "", null != t1 && (i = t1.replace(E, "$&/") + "/"), S(s, e, i, "", function(t1) {
                    return t1;
                })) : null != s && (T(s) && (s = function(t1, e) {
                    return {
                        $$typeof: r,
                        type: t1.type,
                        key: e,
                        ref: t1.ref,
                        props: t1.props,
                        _owner: t1._owner
                    };
                }(s, i + (!s.key || l && l.key === s.key ? "" : ("" + s.key).replace(E, "$&/") + "/") + t1)), e.push(s)), 1;
                if (l = 0, n = "" === n ? "." : n + ":", Array.isArray(t1)) for(var c = 0; c < t1.length; c++){
                    var u = n + I(o = t1[c], c);
                    l += S(o, e, i, u, s);
                }
                else if (u = function(t1) {
                    return null === t1 || "object" != typeof t1 ? null : "function" == typeof (t1 = d && t1[d] || t1["@@iterator"]) ? t1 : null;
                }(t1), "function" == typeof u) for(t1 = u.call(t1), c = 0; !(o = t1.next()).done;)l += S(o = o.value, e, i, u = n + I(o, c++), s);
                else if ("object" === o) throw e = "" + t1, Error(p(31, "[object Object]" === e ? "object with keys {" + Object.keys(t1).join(", ") + "}" : e));
                return l;
            }
            function N(t1, e, i) {
                if (null == t1) return t1;
                var n = [], r = 0;
                return S(t1, n, "", "", function(t1) {
                    return e.call(i, t1, r++);
                }), n;
            }
            function D(t1) {
                if (-1 === t1._status) {
                    var e = t1._result;
                    e = e(), t1._status = 0, t1._result = e, e.then(function(e) {
                        0 === t1._status && (e = e.default, t1._status = 1, t1._result = e);
                    }, function(e) {
                        0 === t1._status && (t1._status = 2, t1._result = e);
                    });
                }
                if (1 === t1._status) return t1._result;
                throw t1._result;
            }
            var C = {
                current: null
            };
            function z() {
                var t1 = C.current;
                if (null === t1) throw Error(p(321));
                return t1;
            }
            var L = {
                ReactCurrentDispatcher: C,
                ReactCurrentBatchConfig: {
                    transition: 0
                },
                ReactCurrentOwner: v,
                IsSomeRendererActing: {
                    current: !1
                },
                assign: n
            };
            e.Children = {
                map: N,
                forEach: function(t1, e, i) {
                    N(t1, function() {
                        e.apply(this, arguments);
                    }, i);
                },
                count: function(t1) {
                    var e = 0;
                    return N(t1, function() {
                        e++;
                    }), e;
                },
                toArray: function(t1) {
                    return N(t1, function(t1) {
                        return t1;
                    }) || [];
                },
                only: function(t1) {
                    if (!T(t1)) throw Error(p(143));
                    return t1;
                }
            }, e.Component = g, e.PureComponent = M, e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = L, e.cloneElement = function(t1, e, i) {
                if (null == t1) throw Error(p(267, t1));
                var a = n({}, t1.props), s = t1.key, o = t1.ref, l = t1._owner;
                if (null != e) {
                    if (void 0 !== e.ref && (o = e.ref, l = v.current), void 0 !== e.key && (s = "" + e.key), t1.type && t1.type.defaultProps) var c = t1.type.defaultProps;
                    for(u in e)x.call(e, u) && !w.hasOwnProperty(u) && (a[u] = void 0 === e[u] && void 0 !== c ? c[u] : e[u]);
                }
                var u = arguments.length - 2;
                if (1 === u) a.children = i;
                else if (1 < u) {
                    c = Array(u);
                    for(var h = 0; h < u; h++)c[h] = arguments[h + 2];
                    a.children = c;
                }
                return {
                    $$typeof: r,
                    type: t1.type,
                    key: s,
                    ref: o,
                    props: a,
                    _owner: l
                };
            }, e.createContext = function(t1, e) {
                return void 0 === e && (e = null), (t1 = {
                    $$typeof: o,
                    _calculateChangedBits: e,
                    _currentValue: t1,
                    _currentValue2: t1,
                    _threadCount: 0,
                    Provider: null,
                    Consumer: null
                }).Provider = {
                    $$typeof: s,
                    _context: t1
                }, t1.Consumer = t1;
            }, e.createElement = b, e.createFactory = function(t1) {
                var e = b.bind(null, t1);
                return e.type = t1, e;
            }, e.createRef = function() {
                return {
                    current: null
                };
            }, e.forwardRef = function(t1) {
                return {
                    $$typeof: l,
                    render: t1
                };
            }, e.isValidElement = T, e.lazy = function(t1) {
                return {
                    $$typeof: u,
                    _payload: {
                        _status: -1,
                        _result: t1
                    },
                    _init: D
                };
            }, e.memo = function(t1, e) {
                return {
                    $$typeof: c,
                    type: t1,
                    compare: void 0 === e ? null : e
                };
            }, e.useCallback = function(t1, e) {
                return z().useCallback(t1, e);
            }, e.useContext = function(t1, e) {
                return z().useContext(t1, e);
            }, e.useDebugValue = function() {}, e.useEffect = function(t1, e) {
                return z().useEffect(t1, e);
            }, e.useImperativeHandle = function(t1, e, i) {
                return z().useImperativeHandle(t1, e, i);
            }, e.useLayoutEffect = function(t1, e) {
                return z().useLayoutEffect(t1, e);
            }, e.useMemo = function(t1, e) {
                return z().useMemo(t1, e);
            }, e.useReducer = function(t1, e, i) {
                return z().useReducer(t1, e, i);
            }, e.useRef = function(t1) {
                return z().useRef(t1);
            }, e.useState = function(t1) {
                return z().useState(t1);
            }, e.version = "17.0.2";
        },
        540: (t1, e, i)=>{
            "use strict";
            t1.exports = i(287);
        },
        463: (t1, e)=>{
            "use strict";
            var i, n, r, a;
            if ("object" == typeof performance && "function" == typeof performance.now) {
                var s = performance;
                e.unstable_now = function() {
                    return s.now();
                };
            } else {
                var o = Date, l = o.now();
                e.unstable_now = function() {
                    return o.now() - l;
                };
            }
            if ("undefined" == typeof window || "function" != typeof MessageChannel) {
                var c = null, u = null, h = function() {
                    if (null !== c) try {
                        var t1 = e.unstable_now();
                        c(!0, t1), c = null;
                    } catch (t1) {
                        throw setTimeout(h, 0), t1;
                    }
                };
                i = function(t1) {
                    null !== c ? setTimeout(i, 0, t1) : (c = t1, setTimeout(h, 0));
                }, n = function(t1, e) {
                    u = setTimeout(t1, e);
                }, r = function() {
                    clearTimeout(u);
                }, e.unstable_shouldYield = function() {
                    return !1;
                }, a = e.unstable_forceFrameRate = function() {};
            } else {
                var d = window.setTimeout, p = window.clearTimeout;
                if ("undefined" != typeof console) {
                    var f = window.cancelAnimationFrame;
                    "function" != typeof window.requestAnimationFrame && console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://reactjs.org/link/react-polyfills"), "function" != typeof f && console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://reactjs.org/link/react-polyfills");
                }
                var A = !1, g = null, m = -1, M = 5, y = 0;
                e.unstable_shouldYield = function() {
                    return e.unstable_now() >= y;
                }, a = function() {}, e.unstable_forceFrameRate = function(t1) {
                    0 > t1 || 125 < t1 ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : M = 0 < t1 ? Math.floor(1e3 / t1) : 5;
                };
                var v = new MessageChannel, x = v.port2;
                v.port1.onmessage = function() {
                    if (null !== g) {
                        var t1 = e.unstable_now();
                        y = t1 + M;
                        try {
                            g(!0, t1) ? x.postMessage(null) : (A = !1, g = null);
                        } catch (t1) {
                            throw x.postMessage(null), t1;
                        }
                    } else A = !1;
                }, i = function(t1) {
                    g = t1, A || (A = !0, x.postMessage(null));
                }, n = function(t1, i) {
                    m = d(function() {
                        t1(e.unstable_now());
                    }, i);
                }, r = function() {
                    p(m), m = -1;
                };
            }
            function w(t1, e) {
                var i = t1.length;
                t1.push(e);
                t: for(;;){
                    var n = i - 1 >>> 1, r = t1[n];
                    if (!(void 0 !== r && 0 < E(r, e))) break t;
                    t1[n] = e, t1[i] = r, i = n;
                }
            }
            function b(t1) {
                return void 0 === (t1 = t1[0]) ? null : t1;
            }
            function T(t1) {
                var e = t1[0];
                if (void 0 !== e) {
                    var i = t1.pop();
                    if (i !== e) {
                        t1[0] = i;
                        t: for(var n = 0, r = t1.length; n < r;){
                            var a = 2 * (n + 1) - 1, s = t1[a], o = a + 1, l = t1[o];
                            if (void 0 !== s && 0 > E(s, i)) void 0 !== l && 0 > E(l, s) ? (t1[n] = l, t1[o] = i, n = o) : (t1[n] = s, t1[a] = i, n = a);
                            else {
                                if (!(void 0 !== l && 0 > E(l, i))) break t;
                                t1[n] = l, t1[o] = i, n = o;
                            }
                        }
                    }
                    return e;
                }
                return null;
            }
            function E(t1, e) {
                var i = t1.sortIndex - e.sortIndex;
                return 0 !== i ? i : t1.id - e.id;
            }
            var I = [], S = [], N = 1, D = null, C = 3, z = !1, L = !1, O = !1;
            function _(t1) {
                for(var e = b(S); null !== e;){
                    if (null === e.callback) T(S);
                    else {
                        if (!(e.startTime <= t1)) break;
                        T(S), e.sortIndex = e.expirationTime, w(I, e);
                    }
                    e = b(S);
                }
            }
            function j(t1) {
                if (O = !1, _(t1), !L) {
                    if (null !== b(I)) L = !0, i(P);
                    else {
                        var e = b(S);
                        null !== e && n(j, e.startTime - t1);
                    }
                }
            }
            function P(t1, i) {
                L = !1, O && (O = !1, r()), z = !0;
                var a = C;
                try {
                    for(_(i), D = b(I); null !== D && (!(D.expirationTime > i) || t1 && !e.unstable_shouldYield());){
                        var s = D.callback;
                        if ("function" == typeof s) {
                            D.callback = null, C = D.priorityLevel;
                            var o = s(D.expirationTime <= i);
                            i = e.unstable_now(), "function" == typeof o ? D.callback = o : D === b(I) && T(I), _(i);
                        } else T(I);
                        D = b(I);
                    }
                    if (null !== D) var l = !0;
                    else {
                        var c = b(S);
                        null !== c && n(j, c.startTime - i), l = !1;
                    }
                    return l;
                } finally{
                    D = null, C = a, z = !1;
                }
            }
            var R = a;
            e.unstable_IdlePriority = 5, e.unstable_ImmediatePriority = 1, e.unstable_LowPriority = 4, e.unstable_NormalPriority = 3, e.unstable_Profiling = null, e.unstable_UserBlockingPriority = 2, e.unstable_cancelCallback = function(t1) {
                t1.callback = null;
            }, e.unstable_continueExecution = function() {
                L || z || (L = !0, i(P));
            }, e.unstable_getCurrentPriorityLevel = function() {
                return C;
            }, e.unstable_getFirstCallbackNode = function() {
                return b(I);
            }, e.unstable_next = function(t1) {
                switch(C){
                    case 1:
                    case 2:
                    case 3:
                        var e = 3;
                        break;
                    default:
                        e = C;
                }
                var i = C;
                C = e;
                try {
                    return t1();
                } finally{
                    C = i;
                }
            }, e.unstable_pauseExecution = function() {}, e.unstable_requestPaint = R, e.unstable_runWithPriority = function(t1, e) {
                switch(t1){
                    case 1:
                    case 2:
                    case 3:
                    case 4:
                    case 5:
                        break;
                    default:
                        t1 = 3;
                }
                var i = C;
                C = t1;
                try {
                    return e();
                } finally{
                    C = i;
                }
            }, e.unstable_scheduleCallback = function(t1, a, s) {
                var o = e.unstable_now();
                switch(s = "object" == typeof s && null !== s && "number" == typeof (s = s.delay) && 0 < s ? o + s : o, t1){
                    case 1:
                        var l = -1;
                        break;
                    case 2:
                        l = 250;
                        break;
                    case 5:
                        l = 1073741823;
                        break;
                    case 4:
                        l = 1e4;
                        break;
                    default:
                        l = 5e3;
                }
                return t1 = {
                    id: N++,
                    callback: a,
                    priorityLevel: t1,
                    startTime: s,
                    expirationTime: l = s + l,
                    sortIndex: -1
                }, s > o ? (t1.sortIndex = s, w(S, t1), null === b(I) && t1 === b(S) && (O ? r() : O = !0, n(j, s - o))) : (t1.sortIndex = l, w(I, t1), L || z || (L = !0, i(P))), t1;
            }, e.unstable_wrapCallback = function(t1) {
                var e = C;
                return function() {
                    var i = C;
                    C = e;
                    try {
                        return t1.apply(this, arguments);
                    } finally{
                        C = i;
                    }
                };
            };
        },
        982: (t1, e, i)=>{
            "use strict";
            t1.exports = i(463);
        },
        72: (t1)=>{
            "use strict";
            var e = [];
            function i(t1) {
                for(var i = -1, n = 0; n < e.length; n++)if (e[n].identifier === t1) {
                    i = n;
                    break;
                }
                return i;
            }
            function n(t1, n) {
                for(var a = {}, s = [], o = 0; o < t1.length; o++){
                    var l = t1[o], c = n.base ? l[0] + n.base : l[0], u = a[c] || 0, h = "".concat(c, " ").concat(u);
                    a[c] = u + 1;
                    var d = i(h), p = {
                        css: l[1],
                        media: l[2],
                        sourceMap: l[3],
                        supports: l[4],
                        layer: l[5]
                    };
                    if (-1 !== d) e[d].references++, e[d].updater(p);
                    else {
                        var f = r(p, n);
                        n.byIndex = o, e.splice(o, 0, {
                            identifier: h,
                            updater: f,
                            references: 1
                        });
                    }
                    s.push(h);
                }
                return s;
            }
            function r(t1, e) {
                var i = e.domAPI(e);
                return i.update(t1), function(e) {
                    if (e) {
                        if (e.css === t1.css && e.media === t1.media && e.sourceMap === t1.sourceMap && e.supports === t1.supports && e.layer === t1.layer) return;
                        i.update(t1 = e);
                    } else i.remove();
                };
            }
            t1.exports = function(t1, r) {
                var a = n(t1 = t1 || [], r = r || {});
                return function(t1) {
                    t1 = t1 || [];
                    for(var s = 0; s < a.length; s++){
                        var o = i(a[s]);
                        e[o].references--;
                    }
                    for(var l = n(t1, r), c = 0; c < a.length; c++){
                        var u = i(a[c]);
                        0 === e[u].references && (e[u].updater(), e.splice(u, 1));
                    }
                    a = l;
                };
            };
        },
        659: (t1)=>{
            "use strict";
            var e = {};
            t1.exports = function(t1, i) {
                var n = function(t1) {
                    if (void 0 === e[t1]) {
                        var i = document.querySelector(t1);
                        if (window.HTMLIFrameElement && i instanceof window.HTMLIFrameElement) try {
                            i = i.contentDocument.head;
                        } catch (t1) {
                            i = null;
                        }
                        e[t1] = i;
                    }
                    return e[t1];
                }(t1);
                if (!n) throw new Error("Couldn't find a style target. This probably means that the value for the 'insert' parameter is invalid.");
                n.appendChild(i);
            };
        },
        159: (t1)=>{
            "use strict";
            t1.exports = function(t1) {
                var e = document.createElement("style");
                return t1.setAttributes(e, t1.attributes), t1.insert(e, t1.options), e;
            };
        },
        56: (t1, e, i)=>{
            "use strict";
            t1.exports = function(t1) {
                var e = i.nc;
                e && t1.setAttribute("nonce", e);
            };
        },
        825: (t1)=>{
            "use strict";
            t1.exports = function(t1) {
                if ("undefined" == typeof document) return {
                    update: function() {},
                    remove: function() {}
                };
                var e = t1.insertStyleElement(t1);
                return {
                    update: function(i) {
                        !function(t1, e, i) {
                            var n = "";
                            i.supports && (n += "@supports (".concat(i.supports, ") {")), i.media && (n += "@media ".concat(i.media, " {"));
                            var r = void 0 !== i.layer;
                            r && (n += "@layer".concat(i.layer.length > 0 ? " ".concat(i.layer) : "", " {")), n += i.css, r && (n += "}"), i.media && (n += "}"), i.supports && (n += "}");
                            var a = i.sourceMap;
                            a && "undefined" != typeof btoa && (n += "\n/*# sourceMappingURL=data:application/json;base64,".concat(btoa(unescape(encodeURIComponent(JSON.stringify(a)))), " */")), e.styleTagTransform(n, t1, e.options);
                        }(e, t1, i);
                    },
                    remove: function() {
                        !function(t1) {
                            if (null === t1.parentNode) return !1;
                            t1.parentNode.removeChild(t1);
                        }(e);
                    }
                };
            };
        },
        113: (t1)=>{
            "use strict";
            t1.exports = function(t1, e) {
                if (e.styleSheet) e.styleSheet.cssText = t1;
                else {
                    for(; e.firstChild;)e.removeChild(e.firstChild);
                    e.appendChild(document.createTextNode(t1));
                }
            };
        },
        232: function(t1, e, i) {
            var n;
            !function(r, a) {
                "use strict";
                var s = "function", o = "undefined", l = "object", c = "string", u = "major", h = "model", d = "name", p = "type", f = "vendor", A = "version", g = "architecture", m = "console", M = "mobile", y = "tablet", v = "smarttv", x = "wearable", w = "embedded", b = "Amazon", T = "Apple", E = "ASUS", I = "BlackBerry", S = "Browser", N = "Chrome", D = "Firefox", C = "Google", z = "Huawei", L = "LG", O = "Microsoft", _ = "Motorola", j = "Opera", P = "Samsung", R = "Sharp", U = "Sony", k = "Xiaomi", B = "Zebra", F = "Facebook", Q = "Chromium OS", H = "Mac OS", V = function(t1) {
                    for(var e = {}, i = 0; i < t1.length; i++)e[t1[i].toUpperCase()] = t1[i];
                    return e;
                }, G = function(t1, e) {
                    return typeof t1 === c && -1 !== Y(e).indexOf(Y(t1));
                }, Y = function(t1) {
                    return t1.toLowerCase();
                }, W = function(t1, e) {
                    if (typeof t1 === c) return t1 = t1.replace(/^\s\s*/, ""), typeof e === o ? t1 : t1.substring(0, 500);
                }, X = function(t1, e) {
                    for(var i, n, r, o, c, u, h = 0; h < e.length && !c;){
                        var d = e[h], p = e[h + 1];
                        for(i = n = 0; i < d.length && !c && d[i];)if (c = d[i++].exec(t1)) for(r = 0; r < p.length; r++)u = c[++n], typeof (o = p[r]) === l && o.length > 0 ? 2 === o.length ? typeof o[1] == s ? this[o[0]] = o[1].call(this, u) : this[o[0]] = o[1] : 3 === o.length ? typeof o[1] !== s || o[1].exec && o[1].test ? this[o[0]] = u ? u.replace(o[1], o[2]) : a : this[o[0]] = u ? o[1].call(this, u, o[2]) : a : 4 === o.length && (this[o[0]] = u ? o[3].call(this, u.replace(o[1], o[2])) : a) : this[o] = u || a;
                        h += 2;
                    }
                }, Z = function(t1, e) {
                    for(var i in e)if (typeof e[i] === l && e[i].length > 0) {
                        for(var n = 0; n < e[i].length; n++)if (G(e[i][n], t1)) return "?" === i ? a : i;
                    } else if (G(e[i], t1)) return "?" === i ? a : i;
                    return t1;
                }, J = {
                    ME: "4.90",
                    "NT 3.11": "NT3.51",
                    "NT 4.0": "NT4.0",
                    2e3: "NT 5.0",
                    XP: [
                        "NT 5.1",
                        "NT 5.2"
                    ],
                    Vista: "NT 6.0",
                    7: "NT 6.1",
                    8: "NT 6.2",
                    8.1: "NT 6.3",
                    10: [
                        "NT 6.4",
                        "NT 10.0"
                    ],
                    RT: "ARM"
                }, K = {
                    browser: [
                        [
                            /\b(?:crmo|crios)\/([\w\.]+)/i
                        ],
                        [
                            A,
                            [
                                d,
                                "Chrome"
                            ]
                        ],
                        [
                            /edg(?:e|ios|a)?\/([\w\.]+)/i
                        ],
                        [
                            A,
                            [
                                d,
                                "Edge"
                            ]
                        ],
                        [
                            /(opera mini)\/([-\w\.]+)/i,
                            /(opera [mobiletab]{3,6})\b.+version\/([-\w\.]+)/i,
                            /(opera)(?:.+version\/|[\/ ]+)([\w\.]+)/i
                        ],
                        [
                            d,
                            A
                        ],
                        [
                            /opios[\/ ]+([\w\.]+)/i
                        ],
                        [
                            A,
                            [
                                d,
                                j + " Mini"
                            ]
                        ],
                        [
                            /\bop(?:rg)?x\/([\w\.]+)/i
                        ],
                        [
                            A,
                            [
                                d,
                                j + " GX"
                            ]
                        ],
                        [
                            /\bopr\/([\w\.]+)/i
                        ],
                        [
                            A,
                            [
                                d,
                                j
                            ]
                        ],
                        [
                            /\bb[ai]*d(?:uhd|[ub]*[aekoprswx]{5,6})[\/ ]?([\w\.]+)/i
                        ],
                        [
                            A,
                            [
                                d,
                                "Baidu"
                            ]
                        ],
                        [
                            /(kindle)\/([\w\.]+)/i,
                            /(lunascape|maxthon|netfront|jasmine|blazer)[\/ ]?([\w\.]*)/i,
                            /(avant|iemobile|slim)\s?(?:browser)?[\/ ]?([\w\.]*)/i,
                            /(?:ms|\()(ie) ([\w\.]+)/i,
                            /(flock|rockmelt|midori|epiphany|silk|skyfire|bolt|iron|vivaldi|iridium|phantomjs|bowser|quark|qupzilla|falkon|rekonq|puffin|brave|whale(?!.+naver)|qqbrowserlite|qq|duckduckgo)\/([-\w\.]+)/i,
                            /(heytap|ovi)browser\/([\d\.]+)/i,
                            /(weibo)__([\d\.]+)/i
                        ],
                        [
                            d,
                            A
                        ],
                        [
                            /\bddg\/([\w\.]+)/i
                        ],
                        [
                            A,
                            [
                                d,
                                "DuckDuckGo"
                            ]
                        ],
                        [
                            /(?:\buc? ?browser|(?:juc.+)ucweb)[\/ ]?([\w\.]+)/i
                        ],
                        [
                            A,
                            [
                                d,
                                "UC" + S
                            ]
                        ],
                        [
                            /microm.+\bqbcore\/([\w\.]+)/i,
                            /\bqbcore\/([\w\.]+).+microm/i,
                            /micromessenger\/([\w\.]+)/i
                        ],
                        [
                            A,
                            [
                                d,
                                "WeChat"
                            ]
                        ],
                        [
                            /konqueror\/([\w\.]+)/i
                        ],
                        [
                            A,
                            [
                                d,
                                "Konqueror"
                            ]
                        ],
                        [
                            /trident.+rv[: ]([\w\.]{1,9})\b.+like gecko/i
                        ],
                        [
                            A,
                            [
                                d,
                                "IE"
                            ]
                        ],
                        [
                            /ya(?:search)?browser\/([\w\.]+)/i
                        ],
                        [
                            A,
                            [
                                d,
                                "Yandex"
                            ]
                        ],
                        [
                            /slbrowser\/([\w\.]+)/i
                        ],
                        [
                            A,
                            [
                                d,
                                "Smart Lenovo " + S
                            ]
                        ],
                        [
                            /(avast|avg)\/([\w\.]+)/i
                        ],
                        [
                            [
                                d,
                                /(.+)/,
                                "$1 Secure " + S
                            ],
                            A
                        ],
                        [
                            /\bfocus\/([\w\.]+)/i
                        ],
                        [
                            A,
                            [
                                d,
                                D + " Focus"
                            ]
                        ],
                        [
                            /\bopt\/([\w\.]+)/i
                        ],
                        [
                            A,
                            [
                                d,
                                j + " Touch"
                            ]
                        ],
                        [
                            /coc_coc\w+\/([\w\.]+)/i
                        ],
                        [
                            A,
                            [
                                d,
                                "Coc Coc"
                            ]
                        ],
                        [
                            /dolfin\/([\w\.]+)/i
                        ],
                        [
                            A,
                            [
                                d,
                                "Dolphin"
                            ]
                        ],
                        [
                            /coast\/([\w\.]+)/i
                        ],
                        [
                            A,
                            [
                                d,
                                j + " Coast"
                            ]
                        ],
                        [
                            /miuibrowser\/([\w\.]+)/i
                        ],
                        [
                            A,
                            [
                                d,
                                "MIUI " + S
                            ]
                        ],
                        [
                            /fxios\/([-\w\.]+)/i
                        ],
                        [
                            A,
                            [
                                d,
                                D
                            ]
                        ],
                        [
                            /\bqihu|(qi?ho?o?|360)browser/i
                        ],
                        [
                            [
                                d,
                                "360 " + S
                            ]
                        ],
                        [
                            /(oculus|sailfish|huawei|vivo)browser\/([\w\.]+)/i
                        ],
                        [
                            [
                                d,
                                /(.+)/,
                                "$1 " + S
                            ],
                            A
                        ],
                        [
                            /samsungbrowser\/([\w\.]+)/i
                        ],
                        [
                            A,
                            [
                                d,
                                P + " Internet"
                            ]
                        ],
                        [
                            /(comodo_dragon)\/([\w\.]+)/i
                        ],
                        [
                            [
                                d,
                                /_/g,
                                " "
                            ],
                            A
                        ],
                        [
                            /metasr[\/ ]?([\d\.]+)/i
                        ],
                        [
                            A,
                            [
                                d,
                                "Sogou Explorer"
                            ]
                        ],
                        [
                            /(sogou)mo\w+\/([\d\.]+)/i
                        ],
                        [
                            [
                                d,
                                "Sogou Mobile"
                            ],
                            A
                        ],
                        [
                            /(electron)\/([\w\.]+) safari/i,
                            /(tesla)(?: qtcarbrowser|\/(20\d\d\.[-\w\.]+))/i,
                            /m?(qqbrowser|2345Explorer)[\/ ]?([\w\.]+)/i
                        ],
                        [
                            d,
                            A
                        ],
                        [
                            /(lbbrowser)/i,
                            /\[(linkedin)app\]/i
                        ],
                        [
                            d
                        ],
                        [
                            /((?:fban\/fbios|fb_iab\/fb4a)(?!.+fbav)|;fbav\/([\w\.]+);)/i
                        ],
                        [
                            [
                                d,
                                F
                            ],
                            A
                        ],
                        [
                            /(Klarna)\/([\w\.]+)/i,
                            /(kakao(?:talk|story))[\/ ]([\w\.]+)/i,
                            /(naver)\(.*?(\d+\.[\w\.]+).*\)/i,
                            /safari (line)\/([\w\.]+)/i,
                            /\b(line)\/([\w\.]+)\/iab/i,
                            /(alipay)client\/([\w\.]+)/i,
                            /(twitter)(?:and| f.+e\/([\w\.]+))/i,
                            /(chromium|instagram|snapchat)[\/ ]([-\w\.]+)/i
                        ],
                        [
                            d,
                            A
                        ],
                        [
                            /\bgsa\/([\w\.]+) .*safari\//i
                        ],
                        [
                            A,
                            [
                                d,
                                "GSA"
                            ]
                        ],
                        [
                            /musical_ly(?:.+app_?version\/|_)([\w\.]+)/i
                        ],
                        [
                            A,
                            [
                                d,
                                "TikTok"
                            ]
                        ],
                        [
                            /headlesschrome(?:\/([\w\.]+)| )/i
                        ],
                        [
                            A,
                            [
                                d,
                                N + " Headless"
                            ]
                        ],
                        [
                            / wv\).+(chrome)\/([\w\.]+)/i
                        ],
                        [
                            [
                                d,
                                N + " WebView"
                            ],
                            A
                        ],
                        [
                            /droid.+ version\/([\w\.]+)\b.+(?:mobile safari|safari)/i
                        ],
                        [
                            A,
                            [
                                d,
                                "Android " + S
                            ]
                        ],
                        [
                            /(chrome|omniweb|arora|[tizenoka]{5} ?browser)\/v?([\w\.]+)/i
                        ],
                        [
                            d,
                            A
                        ],
                        [
                            /version\/([\w\.\,]+) .*mobile\/\w+ (safari)/i
                        ],
                        [
                            A,
                            [
                                d,
                                "Mobile Safari"
                            ]
                        ],
                        [
                            /version\/([\w(\.|\,)]+) .*(mobile ?safari|safari)/i
                        ],
                        [
                            A,
                            d
                        ],
                        [
                            /webkit.+?(mobile ?safari|safari)(\/[\w\.]+)/i
                        ],
                        [
                            d,
                            [
                                A,
                                Z,
                                {
                                    "1.0": "/8",
                                    1.2: "/1",
                                    1.3: "/3",
                                    "2.0": "/412",
                                    "2.0.2": "/416",
                                    "2.0.3": "/417",
                                    "2.0.4": "/419",
                                    "?": "/"
                                }
                            ]
                        ],
                        [
                            /(webkit|khtml)\/([\w\.]+)/i
                        ],
                        [
                            d,
                            A
                        ],
                        [
                            /(navigator|netscape\d?)\/([-\w\.]+)/i
                        ],
                        [
                            [
                                d,
                                "Netscape"
                            ],
                            A
                        ],
                        [
                            /mobile vr; rv:([\w\.]+)\).+firefox/i
                        ],
                        [
                            A,
                            [
                                d,
                                D + " Reality"
                            ]
                        ],
                        [
                            /ekiohf.+(flow)\/([\w\.]+)/i,
                            /(swiftfox)/i,
                            /(icedragon|iceweasel|camino|chimera|fennec|maemo browser|minimo|conkeror|klar)[\/ ]?([\w\.\+]+)/i,
                            /(seamonkey|k-meleon|icecat|iceape|firebird|phoenix|palemoon|basilisk|waterfox)\/([-\w\.]+)$/i,
                            /(firefox)\/([\w\.]+)/i,
                            /(mozilla)\/([\w\.]+) .+rv\:.+gecko\/\d+/i,
                            /(polaris|lynx|dillo|icab|doris|amaya|w3m|netsurf|sleipnir|obigo|mosaic|(?:go|ice|up)[\. ]?browser)[-\/ ]?v?([\w\.]+)/i,
                            /(links) \(([\w\.]+)/i,
                            /panasonic;(viera)/i
                        ],
                        [
                            d,
                            A
                        ],
                        [
                            /(cobalt)\/([\w\.]+)/i
                        ],
                        [
                            d,
                            [
                                A,
                                /master.|lts./,
                                ""
                            ]
                        ]
                    ],
                    cpu: [
                        [
                            /(?:(amd|x(?:(?:86|64)[-_])?|wow|win)64)[;\)]/i
                        ],
                        [
                            [
                                g,
                                "amd64"
                            ]
                        ],
                        [
                            /(ia32(?=;))/i
                        ],
                        [
                            [
                                g,
                                Y
                            ]
                        ],
                        [
                            /((?:i[346]|x)86)[;\)]/i
                        ],
                        [
                            [
                                g,
                                "ia32"
                            ]
                        ],
                        [
                            /\b(aarch64|arm(v?8e?l?|_?64))\b/i
                        ],
                        [
                            [
                                g,
                                "arm64"
                            ]
                        ],
                        [
                            /\b(arm(?:v[67])?ht?n?[fl]p?)\b/i
                        ],
                        [
                            [
                                g,
                                "armhf"
                            ]
                        ],
                        [
                            /windows (ce|mobile); ppc;/i
                        ],
                        [
                            [
                                g,
                                "arm"
                            ]
                        ],
                        [
                            /((?:ppc|powerpc)(?:64)?)(?: mac|;|\))/i
                        ],
                        [
                            [
                                g,
                                /ower/,
                                "",
                                Y
                            ]
                        ],
                        [
                            /(sun4\w)[;\)]/i
                        ],
                        [
                            [
                                g,
                                "sparc"
                            ]
                        ],
                        [
                            /((?:avr32|ia64(?=;))|68k(?=\))|\barm(?=v(?:[1-7]|[5-7]1)l?|;|eabi)|(?=atmel )avr|(?:irix|mips|sparc)(?:64)?\b|pa-risc)/i
                        ],
                        [
                            [
                                g,
                                Y
                            ]
                        ]
                    ],
                    device: [
                        [
                            /\b(sch-i[89]0\d|shw-m380s|sm-[ptx]\w{2,4}|gt-[pn]\d{2,4}|sgh-t8[56]9|nexus 10)/i
                        ],
                        [
                            h,
                            [
                                f,
                                P
                            ],
                            [
                                p,
                                y
                            ]
                        ],
                        [
                            /\b((?:s[cgp]h|gt|sm)-\w+|sc[g-]?[\d]+a?|galaxy nexus)/i,
                            /samsung[- ]([-\w]+)/i,
                            /sec-(sgh\w+)/i
                        ],
                        [
                            h,
                            [
                                f,
                                P
                            ],
                            [
                                p,
                                M
                            ]
                        ],
                        [
                            /(?:\/|\()(ip(?:hone|od)[\w, ]*)(?:\/|;)/i
                        ],
                        [
                            h,
                            [
                                f,
                                T
                            ],
                            [
                                p,
                                M
                            ]
                        ],
                        [
                            /\((ipad);[-\w\),; ]+apple/i,
                            /applecoremedia\/[\w\.]+ \((ipad)/i,
                            /\b(ipad)\d\d?,\d\d?[;\]].+ios/i
                        ],
                        [
                            h,
                            [
                                f,
                                T
                            ],
                            [
                                p,
                                y
                            ]
                        ],
                        [
                            /(macintosh);/i
                        ],
                        [
                            h,
                            [
                                f,
                                T
                            ]
                        ],
                        [
                            /\b(sh-?[altvz]?\d\d[a-ekm]?)/i
                        ],
                        [
                            h,
                            [
                                f,
                                R
                            ],
                            [
                                p,
                                M
                            ]
                        ],
                        [
                            /\b((?:ag[rs][23]?|bah2?|sht?|btv)-a?[lw]\d{2})\b(?!.+d\/s)/i
                        ],
                        [
                            h,
                            [
                                f,
                                z
                            ],
                            [
                                p,
                                y
                            ]
                        ],
                        [
                            /(?:huawei|honor)([-\w ]+)[;\)]/i,
                            /\b(nexus 6p|\w{2,4}e?-[atu]?[ln][\dx][012359c][adn]?)\b(?!.+d\/s)/i
                        ],
                        [
                            h,
                            [
                                f,
                                z
                            ],
                            [
                                p,
                                M
                            ]
                        ],
                        [
                            /\b(poco[\w ]+|m2\d{3}j\d\d[a-z]{2})(?: bui|\))/i,
                            /\b; (\w+) build\/hm\1/i,
                            /\b(hm[-_ ]?note?[_ ]?(?:\d\w)?) bui/i,
                            /\b(redmi[\-_ ]?(?:note|k)?[\w_ ]+)(?: bui|\))/i,
                            /oid[^\)]+; (m?[12][0-389][01]\w{3,6}[c-y])( bui|; wv|\))/i,
                            /\b(mi[-_ ]?(?:a\d|one|one[_ ]plus|note lte|max|cc)?[_ ]?(?:\d?\w?)[_ ]?(?:plus|se|lite)?)(?: bui|\))/i
                        ],
                        [
                            [
                                h,
                                /_/g,
                                " "
                            ],
                            [
                                f,
                                k
                            ],
                            [
                                p,
                                M
                            ]
                        ],
                        [
                            /oid[^\)]+; (2\d{4}(283|rpbf)[cgl])( bui|\))/i,
                            /\b(mi[-_ ]?(?:pad)(?:[\w_ ]+))(?: bui|\))/i
                        ],
                        [
                            [
                                h,
                                /_/g,
                                " "
                            ],
                            [
                                f,
                                k
                            ],
                            [
                                p,
                                y
                            ]
                        ],
                        [
                            /; (\w+) bui.+ oppo/i,
                            /\b(cph[12]\d{3}|p(?:af|c[al]|d\w|e[ar])[mt]\d0|x9007|a101op)\b/i
                        ],
                        [
                            h,
                            [
                                f,
                                "OPPO"
                            ],
                            [
                                p,
                                M
                            ]
                        ],
                        [
                            /\b(opd2\d{3}a?) bui/i
                        ],
                        [
                            h,
                            [
                                f,
                                "OPPO"
                            ],
                            [
                                p,
                                y
                            ]
                        ],
                        [
                            /vivo (\w+)(?: bui|\))/i,
                            /\b(v[12]\d{3}\w?[at])(?: bui|;)/i
                        ],
                        [
                            h,
                            [
                                f,
                                "Vivo"
                            ],
                            [
                                p,
                                M
                            ]
                        ],
                        [
                            /\b(rmx[1-3]\d{3})(?: bui|;|\))/i
                        ],
                        [
                            h,
                            [
                                f,
                                "Realme"
                            ],
                            [
                                p,
                                M
                            ]
                        ],
                        [
                            /\b(milestone|droid(?:[2-4x]| (?:bionic|x2|pro|razr))?:?( 4g)?)\b[\w ]+build\//i,
                            /\bmot(?:orola)?[- ](\w*)/i,
                            /((?:moto[\w\(\) ]+|xt\d{3,4}|nexus 6)(?= bui|\)))/i
                        ],
                        [
                            h,
                            [
                                f,
                                _
                            ],
                            [
                                p,
                                M
                            ]
                        ],
                        [
                            /\b(mz60\d|xoom[2 ]{0,2}) build\//i
                        ],
                        [
                            h,
                            [
                                f,
                                _
                            ],
                            [
                                p,
                                y
                            ]
                        ],
                        [
                            /((?=lg)?[vl]k\-?\d{3}) bui| 3\.[-\w; ]{10}lg?-([06cv9]{3,4})/i
                        ],
                        [
                            h,
                            [
                                f,
                                L
                            ],
                            [
                                p,
                                y
                            ]
                        ],
                        [
                            /(lm(?:-?f100[nv]?|-[\w\.]+)(?= bui|\))|nexus [45])/i,
                            /\blg[-e;\/ ]+((?!browser|netcast|android tv)\w+)/i,
                            /\blg-?([\d\w]+) bui/i
                        ],
                        [
                            h,
                            [
                                f,
                                L
                            ],
                            [
                                p,
                                M
                            ]
                        ],
                        [
                            /(ideatab[-\w ]+)/i,
                            /lenovo ?(s[56]000[-\w]+|tab(?:[\w ]+)|yt[-\d\w]{6}|tb[-\d\w]{6})/i
                        ],
                        [
                            h,
                            [
                                f,
                                "Lenovo"
                            ],
                            [
                                p,
                                y
                            ]
                        ],
                        [
                            /(?:maemo|nokia).*(n900|lumia \d+)/i,
                            /nokia[-_ ]?([-\w\.]*)/i
                        ],
                        [
                            [
                                h,
                                /_/g,
                                " "
                            ],
                            [
                                f,
                                "Nokia"
                            ],
                            [
                                p,
                                M
                            ]
                        ],
                        [
                            /(pixel c)\b/i
                        ],
                        [
                            h,
                            [
                                f,
                                C
                            ],
                            [
                                p,
                                y
                            ]
                        ],
                        [
                            /droid.+; (pixel[\daxl ]{0,6})(?: bui|\))/i
                        ],
                        [
                            h,
                            [
                                f,
                                C
                            ],
                            [
                                p,
                                M
                            ]
                        ],
                        [
                            /droid.+ (a?\d[0-2]{2}so|[c-g]\d{4}|so[-gl]\w+|xq-a\w[4-7][12])(?= bui|\).+chrome\/(?![1-6]{0,1}\d\.))/i
                        ],
                        [
                            h,
                            [
                                f,
                                U
                            ],
                            [
                                p,
                                M
                            ]
                        ],
                        [
                            /sony tablet [ps]/i,
                            /\b(?:sony)?sgp\w+(?: bui|\))/i
                        ],
                        [
                            [
                                h,
                                "Xperia Tablet"
                            ],
                            [
                                f,
                                U
                            ],
                            [
                                p,
                                y
                            ]
                        ],
                        [
                            / (kb2005|in20[12]5|be20[12][59])\b/i,
                            /(?:one)?(?:plus)? (a\d0\d\d)(?: b|\))/i
                        ],
                        [
                            h,
                            [
                                f,
                                "OnePlus"
                            ],
                            [
                                p,
                                M
                            ]
                        ],
                        [
                            /(alexa)webm/i,
                            /(kf[a-z]{2}wi|aeo[c-r]{2})( bui|\))/i,
                            /(kf[a-z]+)( bui|\)).+silk\//i
                        ],
                        [
                            h,
                            [
                                f,
                                b
                            ],
                            [
                                p,
                                y
                            ]
                        ],
                        [
                            /((?:sd|kf)[0349hijorstuw]+)( bui|\)).+silk\//i
                        ],
                        [
                            [
                                h,
                                /(.+)/g,
                                "Fire Phone $1"
                            ],
                            [
                                f,
                                b
                            ],
                            [
                                p,
                                M
                            ]
                        ],
                        [
                            /(playbook);[-\w\),; ]+(rim)/i
                        ],
                        [
                            h,
                            f,
                            [
                                p,
                                y
                            ]
                        ],
                        [
                            /\b((?:bb[a-f]|st[hv])100-\d)/i,
                            /\(bb10; (\w+)/i
                        ],
                        [
                            h,
                            [
                                f,
                                I
                            ],
                            [
                                p,
                                M
                            ]
                        ],
                        [
                            /(?:\b|asus_)(transfo[prime ]{4,10} \w+|eeepc|slider \w+|nexus 7|padfone|p00[cj])/i
                        ],
                        [
                            h,
                            [
                                f,
                                E
                            ],
                            [
                                p,
                                y
                            ]
                        ],
                        [
                            / (z[bes]6[027][012][km][ls]|zenfone \d\w?)\b/i
                        ],
                        [
                            h,
                            [
                                f,
                                E
                            ],
                            [
                                p,
                                M
                            ]
                        ],
                        [
                            /(nexus 9)/i
                        ],
                        [
                            h,
                            [
                                f,
                                "HTC"
                            ],
                            [
                                p,
                                y
                            ]
                        ],
                        [
                            /(htc)[-;_ ]{1,2}([\w ]+(?=\)| bui)|\w+)/i,
                            /(zte)[- ]([\w ]+?)(?: bui|\/|\))/i,
                            /(alcatel|geeksphone|nexian|panasonic(?!(?:;|\.))|sony(?!-bra))[-_ ]?([-\w]*)/i
                        ],
                        [
                            f,
                            [
                                h,
                                /_/g,
                                " "
                            ],
                            [
                                p,
                                M
                            ]
                        ],
                        [
                            /droid.+; ([ab][1-7]-?[0178a]\d\d?)/i
                        ],
                        [
                            h,
                            [
                                f,
                                "Acer"
                            ],
                            [
                                p,
                                y
                            ]
                        ],
                        [
                            /droid.+; (m[1-5] note) bui/i,
                            /\bmz-([-\w]{2,})/i
                        ],
                        [
                            h,
                            [
                                f,
                                "Meizu"
                            ],
                            [
                                p,
                                M
                            ]
                        ],
                        [
                            /; ((?:power )?armor(?:[\w ]{0,8}))(?: bui|\))/i
                        ],
                        [
                            h,
                            [
                                f,
                                "Ulefone"
                            ],
                            [
                                p,
                                M
                            ]
                        ],
                        [
                            /(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus|dell|meizu|motorola|polytron|infinix|tecno)[-_ ]?([-\w]*)/i,
                            /(hp) ([\w ]+\w)/i,
                            /(asus)-?(\w+)/i,
                            /(microsoft); (lumia[\w ]+)/i,
                            /(lenovo)[-_ ]?([-\w]+)/i,
                            /(jolla)/i,
                            /(oppo) ?([\w ]+) bui/i
                        ],
                        [
                            f,
                            h,
                            [
                                p,
                                M
                            ]
                        ],
                        [
                            /(kobo)\s(ereader|touch)/i,
                            /(archos) (gamepad2?)/i,
                            /(hp).+(touchpad(?!.+tablet)|tablet)/i,
                            /(kindle)\/([\w\.]+)/i,
                            /(nook)[\w ]+build\/(\w+)/i,
                            /(dell) (strea[kpr\d ]*[\dko])/i,
                            /(le[- ]+pan)[- ]+(\w{1,9}) bui/i,
                            /(trinity)[- ]*(t\d{3}) bui/i,
                            /(gigaset)[- ]+(q\w{1,9}) bui/i,
                            /(vodafone) ([\w ]+)(?:\)| bui)/i
                        ],
                        [
                            f,
                            h,
                            [
                                p,
                                y
                            ]
                        ],
                        [
                            /(surface duo)/i
                        ],
                        [
                            h,
                            [
                                f,
                                O
                            ],
                            [
                                p,
                                y
                            ]
                        ],
                        [
                            /droid [\d\.]+; (fp\du?)(?: b|\))/i
                        ],
                        [
                            h,
                            [
                                f,
                                "Fairphone"
                            ],
                            [
                                p,
                                M
                            ]
                        ],
                        [
                            /(u304aa)/i
                        ],
                        [
                            h,
                            [
                                f,
                                "AT&T"
                            ],
                            [
                                p,
                                M
                            ]
                        ],
                        [
                            /\bsie-(\w*)/i
                        ],
                        [
                            h,
                            [
                                f,
                                "Siemens"
                            ],
                            [
                                p,
                                M
                            ]
                        ],
                        [
                            /\b(rct\w+) b/i
                        ],
                        [
                            h,
                            [
                                f,
                                "RCA"
                            ],
                            [
                                p,
                                y
                            ]
                        ],
                        [
                            /\b(venue[\d ]{2,7}) b/i
                        ],
                        [
                            h,
                            [
                                f,
                                "Dell"
                            ],
                            [
                                p,
                                y
                            ]
                        ],
                        [
                            /\b(q(?:mv|ta)\w+) b/i
                        ],
                        [
                            h,
                            [
                                f,
                                "Verizon"
                            ],
                            [
                                p,
                                y
                            ]
                        ],
                        [
                            /\b(?:barnes[& ]+noble |bn[rt])([\w\+ ]*) b/i
                        ],
                        [
                            h,
                            [
                                f,
                                "Barnes & Noble"
                            ],
                            [
                                p,
                                y
                            ]
                        ],
                        [
                            /\b(tm\d{3}\w+) b/i
                        ],
                        [
                            h,
                            [
                                f,
                                "NuVision"
                            ],
                            [
                                p,
                                y
                            ]
                        ],
                        [
                            /\b(k88) b/i
                        ],
                        [
                            h,
                            [
                                f,
                                "ZTE"
                            ],
                            [
                                p,
                                y
                            ]
                        ],
                        [
                            /\b(nx\d{3}j) b/i
                        ],
                        [
                            h,
                            [
                                f,
                                "ZTE"
                            ],
                            [
                                p,
                                M
                            ]
                        ],
                        [
                            /\b(gen\d{3}) b.+49h/i
                        ],
                        [
                            h,
                            [
                                f,
                                "Swiss"
                            ],
                            [
                                p,
                                M
                            ]
                        ],
                        [
                            /\b(zur\d{3}) b/i
                        ],
                        [
                            h,
                            [
                                f,
                                "Swiss"
                            ],
                            [
                                p,
                                y
                            ]
                        ],
                        [
                            /\b((zeki)?tb.*\b) b/i
                        ],
                        [
                            h,
                            [
                                f,
                                "Zeki"
                            ],
                            [
                                p,
                                y
                            ]
                        ],
                        [
                            /\b([yr]\d{2}) b/i,
                            /\b(dragon[- ]+touch |dt)(\w{5}) b/i
                        ],
                        [
                            [
                                f,
                                "Dragon Touch"
                            ],
                            h,
                            [
                                p,
                                y
                            ]
                        ],
                        [
                            /\b(ns-?\w{0,9}) b/i
                        ],
                        [
                            h,
                            [
                                f,
                                "Insignia"
                            ],
                            [
                                p,
                                y
                            ]
                        ],
                        [
                            /\b((nxa|next)-?\w{0,9}) b/i
                        ],
                        [
                            h,
                            [
                                f,
                                "NextBook"
                            ],
                            [
                                p,
                                y
                            ]
                        ],
                        [
                            /\b(xtreme\_)?(v(1[045]|2[015]|[3469]0|7[05])) b/i
                        ],
                        [
                            [
                                f,
                                "Voice"
                            ],
                            h,
                            [
                                p,
                                M
                            ]
                        ],
                        [
                            /\b(lvtel\-)?(v1[12]) b/i
                        ],
                        [
                            [
                                f,
                                "LvTel"
                            ],
                            h,
                            [
                                p,
                                M
                            ]
                        ],
                        [
                            /\b(ph-1) /i
                        ],
                        [
                            h,
                            [
                                f,
                                "Essential"
                            ],
                            [
                                p,
                                M
                            ]
                        ],
                        [
                            /\b(v(100md|700na|7011|917g).*\b) b/i
                        ],
                        [
                            h,
                            [
                                f,
                                "Envizen"
                            ],
                            [
                                p,
                                y
                            ]
                        ],
                        [
                            /\b(trio[-\w\. ]+) b/i
                        ],
                        [
                            h,
                            [
                                f,
                                "MachSpeed"
                            ],
                            [
                                p,
                                y
                            ]
                        ],
                        [
                            /\btu_(1491) b/i
                        ],
                        [
                            h,
                            [
                                f,
                                "Rotor"
                            ],
                            [
                                p,
                                y
                            ]
                        ],
                        [
                            /(shield[\w ]+) b/i
                        ],
                        [
                            h,
                            [
                                f,
                                "Nvidia"
                            ],
                            [
                                p,
                                y
                            ]
                        ],
                        [
                            /(sprint) (\w+)/i
                        ],
                        [
                            f,
                            h,
                            [
                                p,
                                M
                            ]
                        ],
                        [
                            /(kin\.[onetw]{3})/i
                        ],
                        [
                            [
                                h,
                                /\./g,
                                " "
                            ],
                            [
                                f,
                                O
                            ],
                            [
                                p,
                                M
                            ]
                        ],
                        [
                            /droid.+; (cc6666?|et5[16]|mc[239][23]x?|vc8[03]x?)\)/i
                        ],
                        [
                            h,
                            [
                                f,
                                B
                            ],
                            [
                                p,
                                y
                            ]
                        ],
                        [
                            /droid.+; (ec30|ps20|tc[2-8]\d[kx])\)/i
                        ],
                        [
                            h,
                            [
                                f,
                                B
                            ],
                            [
                                p,
                                M
                            ]
                        ],
                        [
                            /smart-tv.+(samsung)/i
                        ],
                        [
                            f,
                            [
                                p,
                                v
                            ]
                        ],
                        [
                            /hbbtv.+maple;(\d+)/i
                        ],
                        [
                            [
                                h,
                                /^/,
                                "SmartTV"
                            ],
                            [
                                f,
                                P
                            ],
                            [
                                p,
                                v
                            ]
                        ],
                        [
                            /(nux; netcast.+smarttv|lg (netcast\.tv-201\d|android tv))/i
                        ],
                        [
                            [
                                f,
                                L
                            ],
                            [
                                p,
                                v
                            ]
                        ],
                        [
                            /(apple) ?tv/i
                        ],
                        [
                            f,
                            [
                                h,
                                T + " TV"
                            ],
                            [
                                p,
                                v
                            ]
                        ],
                        [
                            /crkey/i
                        ],
                        [
                            [
                                h,
                                N + "cast"
                            ],
                            [
                                f,
                                C
                            ],
                            [
                                p,
                                v
                            ]
                        ],
                        [
                            /droid.+aft(\w+)( bui|\))/i
                        ],
                        [
                            h,
                            [
                                f,
                                b
                            ],
                            [
                                p,
                                v
                            ]
                        ],
                        [
                            /\(dtv[\);].+(aquos)/i,
                            /(aquos-tv[\w ]+)\)/i
                        ],
                        [
                            h,
                            [
                                f,
                                R
                            ],
                            [
                                p,
                                v
                            ]
                        ],
                        [
                            /(bravia[\w ]+)( bui|\))/i
                        ],
                        [
                            h,
                            [
                                f,
                                U
                            ],
                            [
                                p,
                                v
                            ]
                        ],
                        [
                            /(mitv-\w{5}) bui/i
                        ],
                        [
                            h,
                            [
                                f,
                                k
                            ],
                            [
                                p,
                                v
                            ]
                        ],
                        [
                            /Hbbtv.*(technisat) (.*);/i
                        ],
                        [
                            f,
                            h,
                            [
                                p,
                                v
                            ]
                        ],
                        [
                            /\b(roku)[\dx]*[\)\/]((?:dvp-)?[\d\.]*)/i,
                            /hbbtv\/\d+\.\d+\.\d+ +\([\w\+ ]*; *([\w\d][^;]*);([^;]*)/i
                        ],
                        [
                            [
                                f,
                                W
                            ],
                            [
                                h,
                                W
                            ],
                            [
                                p,
                                v
                            ]
                        ],
                        [
                            /\b(android tv|smart[- ]?tv|opera tv|tv; rv:)\b/i
                        ],
                        [
                            [
                                p,
                                v
                            ]
                        ],
                        [
                            /(ouya)/i,
                            /(nintendo) ([wids3utch]+)/i
                        ],
                        [
                            f,
                            h,
                            [
                                p,
                                m
                            ]
                        ],
                        [
                            /droid.+; (shield) bui/i
                        ],
                        [
                            h,
                            [
                                f,
                                "Nvidia"
                            ],
                            [
                                p,
                                m
                            ]
                        ],
                        [
                            /(playstation [345portablevi]+)/i
                        ],
                        [
                            h,
                            [
                                f,
                                U
                            ],
                            [
                                p,
                                m
                            ]
                        ],
                        [
                            /\b(xbox(?: one)?(?!; xbox))[\); ]/i
                        ],
                        [
                            h,
                            [
                                f,
                                O
                            ],
                            [
                                p,
                                m
                            ]
                        ],
                        [
                            /((pebble))app/i
                        ],
                        [
                            f,
                            h,
                            [
                                p,
                                x
                            ]
                        ],
                        [
                            /(watch)(?: ?os[,\/]|\d,\d\/)[\d\.]+/i
                        ],
                        [
                            h,
                            [
                                f,
                                T
                            ],
                            [
                                p,
                                x
                            ]
                        ],
                        [
                            /droid.+; (glass) \d/i
                        ],
                        [
                            h,
                            [
                                f,
                                C
                            ],
                            [
                                p,
                                x
                            ]
                        ],
                        [
                            /droid.+; (wt63?0{2,3})\)/i
                        ],
                        [
                            h,
                            [
                                f,
                                B
                            ],
                            [
                                p,
                                x
                            ]
                        ],
                        [
                            /(quest( \d| pro)?)/i
                        ],
                        [
                            h,
                            [
                                f,
                                F
                            ],
                            [
                                p,
                                x
                            ]
                        ],
                        [
                            /(tesla)(?: qtcarbrowser|\/[-\w\.]+)/i
                        ],
                        [
                            f,
                            [
                                p,
                                w
                            ]
                        ],
                        [
                            /(aeobc)\b/i
                        ],
                        [
                            h,
                            [
                                f,
                                b
                            ],
                            [
                                p,
                                w
                            ]
                        ],
                        [
                            /droid .+?; ([^;]+?)(?: bui|; wv\)|\) applew).+? mobile safari/i
                        ],
                        [
                            h,
                            [
                                p,
                                M
                            ]
                        ],
                        [
                            /droid .+?; ([^;]+?)(?: bui|\) applew).+?(?! mobile) safari/i
                        ],
                        [
                            h,
                            [
                                p,
                                y
                            ]
                        ],
                        [
                            /\b((tablet|tab)[;\/]|focus\/\d(?!.+mobile))/i
                        ],
                        [
                            [
                                p,
                                y
                            ]
                        ],
                        [
                            /(phone|mobile(?:[;\/]| [ \w\/\.]*safari)|pda(?=.+windows ce))/i
                        ],
                        [
                            [
                                p,
                                M
                            ]
                        ],
                        [
                            /(android[-\w\. ]{0,9});.+buil/i
                        ],
                        [
                            h,
                            [
                                f,
                                "Generic"
                            ]
                        ]
                    ],
                    engine: [
                        [
                            /windows.+ edge\/([\w\.]+)/i
                        ],
                        [
                            A,
                            [
                                d,
                                "EdgeHTML"
                            ]
                        ],
                        [
                            /webkit\/537\.36.+chrome\/(?!27)([\w\.]+)/i
                        ],
                        [
                            A,
                            [
                                d,
                                "Blink"
                            ]
                        ],
                        [
                            /(presto)\/([\w\.]+)/i,
                            /(webkit|trident|netfront|netsurf|amaya|lynx|w3m|goanna)\/([\w\.]+)/i,
                            /ekioh(flow)\/([\w\.]+)/i,
                            /(khtml|tasman|links)[\/ ]\(?([\w\.]+)/i,
                            /(icab)[\/ ]([23]\.[\d\.]+)/i,
                            /\b(libweb)/i
                        ],
                        [
                            d,
                            A
                        ],
                        [
                            /rv\:([\w\.]{1,9})\b.+(gecko)/i
                        ],
                        [
                            A,
                            d
                        ]
                    ],
                    os: [
                        [
                            /microsoft (windows) (vista|xp)/i
                        ],
                        [
                            d,
                            A
                        ],
                        [
                            /(windows (?:phone(?: os)?|mobile))[\/ ]?([\d\.\w ]*)/i
                        ],
                        [
                            d,
                            [
                                A,
                                Z,
                                J
                            ]
                        ],
                        [
                            /windows nt 6\.2; (arm)/i,
                            /windows[\/ ]?([ntce\d\. ]+\w)(?!.+xbox)/i,
                            /(?:win(?=3|9|n)|win 9x )([nt\d\.]+)/i
                        ],
                        [
                            [
                                A,
                                Z,
                                J
                            ],
                            [
                                d,
                                "Windows"
                            ]
                        ],
                        [
                            /ip[honead]{2,4}\b(?:.*os ([\w]+) like mac|; opera)/i,
                            /(?:ios;fbsv\/|iphone.+ios[\/ ])([\d\.]+)/i,
                            /cfnetwork\/.+darwin/i
                        ],
                        [
                            [
                                A,
                                /_/g,
                                "."
                            ],
                            [
                                d,
                                "iOS"
                            ]
                        ],
                        [
                            /(mac os x) ?([\w\. ]*)/i,
                            /(macintosh|mac_powerpc\b)(?!.+haiku)/i
                        ],
                        [
                            [
                                d,
                                H
                            ],
                            [
                                A,
                                /_/g,
                                "."
                            ]
                        ],
                        [
                            /droid ([\w\.]+)\b.+(android[- ]x86|harmonyos)/i
                        ],
                        [
                            A,
                            d
                        ],
                        [
                            /(android|webos|qnx|bada|rim tablet os|maemo|meego|sailfish)[-\/ ]?([\w\.]*)/i,
                            /(blackberry)\w*\/([\w\.]*)/i,
                            /(tizen|kaios)[\/ ]([\w\.]+)/i,
                            /\((series40);/i
                        ],
                        [
                            d,
                            A
                        ],
                        [
                            /\(bb(10);/i
                        ],
                        [
                            A,
                            [
                                d,
                                I
                            ]
                        ],
                        [
                            /(?:symbian ?os|symbos|s60(?=;)|series60)[-\/ ]?([\w\.]*)/i
                        ],
                        [
                            A,
                            [
                                d,
                                "Symbian"
                            ]
                        ],
                        [
                            /mozilla\/[\d\.]+ \((?:mobile|tablet|tv|mobile; [\w ]+); rv:.+ gecko\/([\w\.]+)/i
                        ],
                        [
                            A,
                            [
                                d,
                                D + " OS"
                            ]
                        ],
                        [
                            /web0s;.+rt(tv)/i,
                            /\b(?:hp)?wos(?:browser)?\/([\w\.]+)/i
                        ],
                        [
                            A,
                            [
                                d,
                                "webOS"
                            ]
                        ],
                        [
                            /watch(?: ?os[,\/]|\d,\d\/)([\d\.]+)/i
                        ],
                        [
                            A,
                            [
                                d,
                                "watchOS"
                            ]
                        ],
                        [
                            /crkey\/([\d\.]+)/i
                        ],
                        [
                            A,
                            [
                                d,
                                N + "cast"
                            ]
                        ],
                        [
                            /(cros) [\w]+(?:\)| ([\w\.]+)\b)/i
                        ],
                        [
                            [
                                d,
                                Q
                            ],
                            A
                        ],
                        [
                            /panasonic;(viera)/i,
                            /(netrange)mmh/i,
                            /(nettv)\/(\d+\.[\w\.]+)/i,
                            /(nintendo|playstation) ([wids345portablevuch]+)/i,
                            /(xbox); +xbox ([^\);]+)/i,
                            /\b(joli|palm)\b ?(?:os)?\/?([\w\.]*)/i,
                            /(mint)[\/\(\) ]?(\w*)/i,
                            /(mageia|vectorlinux)[; ]/i,
                            /([kxln]?ubuntu|debian|suse|opensuse|gentoo|arch(?= linux)|slackware|fedora|mandriva|centos|pclinuxos|red ?hat|zenwalk|linpus|raspbian|plan 9|minix|risc os|contiki|deepin|manjaro|elementary os|sabayon|linspire)(?: gnu\/linux)?(?: enterprise)?(?:[- ]linux)?(?:-gnu)?[-\/ ]?(?!chrom|package)([-\w\.]*)/i,
                            /(hurd|linux) ?([\w\.]*)/i,
                            /(gnu) ?([\w\.]*)/i,
                            /\b([-frentopcghs]{0,5}bsd|dragonfly)[\/ ]?(?!amd|[ix346]{1,2}86)([\w\.]*)/i,
                            /(haiku) (\w+)/i
                        ],
                        [
                            d,
                            A
                        ],
                        [
                            /(sunos) ?([\w\.\d]*)/i
                        ],
                        [
                            [
                                d,
                                "Solaris"
                            ],
                            A
                        ],
                        [
                            /((?:open)?solaris)[-\/ ]?([\w\.]*)/i,
                            /(aix) ((\d)(?=\.|\)| )[\w\.])*/i,
                            /\b(beos|os\/2|amigaos|morphos|openvms|fuchsia|hp-ux|serenityos)/i,
                            /(unix) ?([\w\.]*)/i
                        ],
                        [
                            d,
                            A
                        ]
                    ]
                }, q = function(t1, e) {
                    if (typeof t1 === l && (e = t1, t1 = a), !(this instanceof q)) return new q(t1, e).getResult();
                    var i = typeof r !== o && r.navigator ? r.navigator : a, n = t1 || (i && i.userAgent ? i.userAgent : ""), m = i && i.userAgentData ? i.userAgentData : a, v = e ? function(t1, e) {
                        var i = {};
                        for(var n in t1)e[n] && e[n].length % 2 == 0 ? i[n] = e[n].concat(t1[n]) : i[n] = t1[n];
                        return i;
                    }(K, e) : K, x = i && i.userAgent == n;
                    return this.getBrowser = function() {
                        var t1, e = {};
                        return e[d] = a, e[A] = a, X.call(e, n, v.browser), e[u] = typeof (t1 = e[A]) === c ? t1.replace(/[^\d\.]/g, "").split(".")[0] : a, x && i && i.brave && typeof i.brave.isBrave == s && (e[d] = "Brave"), e;
                    }, this.getCPU = function() {
                        var t1 = {};
                        return t1[g] = a, X.call(t1, n, v.cpu), t1;
                    }, this.getDevice = function() {
                        var t1 = {};
                        return t1[f] = a, t1[h] = a, t1[p] = a, X.call(t1, n, v.device), x && !t1[p] && m && m.mobile && (t1[p] = M), x && "Macintosh" == t1[h] && i && typeof i.standalone !== o && i.maxTouchPoints && i.maxTouchPoints > 2 && (t1[h] = "iPad", t1[p] = y), t1;
                    }, this.getEngine = function() {
                        var t1 = {};
                        return t1[d] = a, t1[A] = a, X.call(t1, n, v.engine), t1;
                    }, this.getOS = function() {
                        var t1 = {};
                        return t1[d] = a, t1[A] = a, X.call(t1, n, v.os), x && !t1[d] && m && m.platform && "Unknown" != m.platform && (t1[d] = m.platform.replace(/chrome os/i, Q).replace(/macos/i, H)), t1;
                    }, this.getResult = function() {
                        return {
                            ua: this.getUA(),
                            browser: this.getBrowser(),
                            engine: this.getEngine(),
                            os: this.getOS(),
                            device: this.getDevice(),
                            cpu: this.getCPU()
                        };
                    }, this.getUA = function() {
                        return n;
                    }, this.setUA = function(t1) {
                        return n = typeof t1 === c && t1.length > 500 ? W(t1, 500) : t1, this;
                    }, this.setUA(n), this;
                };
                q.VERSION = "1.0.38", q.BROWSER = V([
                    d,
                    A,
                    u
                ]), q.CPU = V([
                    g
                ]), q.DEVICE = V([
                    h,
                    f,
                    p,
                    m,
                    M,
                    v,
                    y,
                    x,
                    w
                ]), q.ENGINE = q.OS = V([
                    d,
                    A
                ]), typeof e !== o ? (t1.exports && (e = t1.exports = q), e.UAParser = q) : i.amdO ? (n = (function() {
                    return q;
                }).call(e, i, e, t1)) === a || (t1.exports = n) : typeof r !== o && (r.UAParser = q);
                var $ = typeof r !== o && (r.jQuery || r.Zepto);
                if ($ && !$.ua) {
                    var tt = new q;
                    $.ua = tt.getResult(), $.ua.get = function() {
                        return tt.getUA();
                    }, $.ua.set = function(t1) {
                        tt.setUA(t1);
                        var e = tt.getResult();
                        for(var i in e)$.ua[i] = e[i];
                    };
                }
            }("object" == typeof window ? window : this);
        },
        964: (t1)=>{
            function e(t1, e, i) {
                t1.addEventListener("wheel", e, i);
            }
            t1.exports = e, t1.exports.addWheelListener = e, t1.exports.removeWheelListener = function(t1, e, i) {
                t1.removeEventListener("wheel", e, i);
            };
        },
        425: (t1)=>{
            "use strict";
            t1.exports = "data:font/woff2;base64,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";
        },
        943: (t1)=>{
            "use strict";
            t1.exports = "data:font/woff2;base64,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";
        },
        88: (t1)=>{
            "use strict";
            t1.exports = "data:font/woff2;base64,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";
        },
        562: (t1)=>{
            "use strict";
            t1.exports = "data:font/woff2;base64,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";
        }
    }, e = {};
    function i(n) {
        var r = e[n];
        if (void 0 !== r) return r.exports;
        var a = e[n] = {
            id: n,
            exports: {}
        };
        return t1[n].call(a.exports, a, a.exports, i), a.exports;
    }
    i.m = t1, i.amdO = {}, i.n = (t1)=>{
        var e = t1 && t1.__esModule ? ()=>t1.default : ()=>t1;
        return i.d(e, {
            a: e
        }), e;
    }, i.d = (t1, e)=>{
        for(var n in e)i.o(e, n) && !i.o(t1, n) && Object.defineProperty(t1, n, {
            enumerable: !0,
            get: e[n]
        });
    }, i.g = function() {
        if ("object" == typeof globalThis) return globalThis;
        try {
            return this || new Function("return this")();
        } catch (t1) {
            if ("object" == typeof window) return window;
        }
    }(), i.o = (t1, e)=>Object.prototype.hasOwnProperty.call(t1, e), i.r = (t1)=>{
        "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t1, Symbol.toStringTag, {
            value: "Module"
        }), Object.defineProperty(t1, "__esModule", {
            value: !0
        });
    }, i.b = document.baseURI || self.location.href, i.nc = void 0;
    var n = {};
    (()=>{
        "use strict";
        i.r(n), i.d(n, {
            ApiStore: ()=>wn,
            Widget: ()=>FC,
            rotationModes: ()=>kn
        });
        var t1 = {};
        i.r(t1), i.d(t1, {
            ACESFilmicToneMapping: ()=>Vr,
            AddEquation: ()=>cr,
            AddOperation: ()=>kr,
            AdditiveAnimationBlendMode: ()=>bs,
            AdditiveBlending: ()=>ar,
            AlphaFormat: ()=>Ta,
            AlwaysCompare: ()=>ho,
            AlwaysDepth: ()=>Cr,
            AlwaysStencilFunc: ()=>no,
            AmbientLight: ()=>Nm,
            AnimationAction: ()=>mM,
            AnimationClip: ()=>qg,
            AnimationLoader: ()=>om,
            AnimationMixer: ()=>yM,
            AnimationObjectGroup: ()=>gM,
            AnimationUtils: ()=>kg,
            ArcCurve: ()=>rA,
            ArrayCamera: ()=>Ip,
            ArrowHelper: ()=>uy,
            AttachedBindMode: ()=>Yr,
            Audio: ()=>eM,
            AudioAnalyser: ()=>oM,
            AudioContext: ()=>Qm,
            AudioListener: ()=>tM,
            AudioLoader: ()=>Hm,
            AxesHelper: ()=>hy,
            BackSide: ()=>tr,
            BasicDepthPacking: ()=>Ds,
            BasicShadowMap: ()=>Zn,
            Bone: ()=>Mf,
            BooleanKeyframeTrack: ()=>Gg,
            Box2: ()=>zM,
            Box3: ()=>Tl,
            Box3Helper: ()=>ay,
            BoxGeometry: ()=>ju,
            BoxHelper: ()=>ry,
            BufferAttribute: ()=>Kc,
            BufferGeometry: ()=>Au,
            BufferGeometryLoader: ()=>jm,
            ByteType: ()=>fa,
            Cache: ()=>tm,
            Camera: ()=>Fu,
            CameraHelper: ()=>ey,
            CanvasTexture: ()=>eA,
            CapsuleGeometry: ()=>EA,
            CatmullRomCurve3: ()=>uA,
            CineonToneMapping: ()=>Hr,
            CircleGeometry: ()=>IA,
            ClampToEdgeWrapping: ()=>ea,
            Clock: ()=>Xm,
            Color: ()=>kc,
            ColorKeyframeTrack: ()=>Yg,
            ColorManagement: ()=>il,
            CompressedArrayTexture: ()=>$f,
            CompressedCubeTexture: ()=>tA,
            CompressedTexture: ()=>qf,
            CompressedTextureLoader: ()=>lm,
            ConeGeometry: ()=>NA,
            ConstantAlphaFactor: ()=>Sr,
            ConstantColorFactor: ()=>Er,
            CubeCamera: ()=>Vu,
            CubeReflectionMapping: ()=>Zr,
            CubeRefractionMapping: ()=>Jr,
            CubeTexture: ()=>Gu,
            CubeTextureLoader: ()=>um,
            CubeUVReflectionMapping: ()=>$r,
            CubicBezierCurve: ()=>fA,
            CubicBezierCurve3: ()=>AA,
            CubicInterpolant: ()=>Fg,
            CullFaceBack: ()=>Yn,
            CullFaceFront: ()=>Wn,
            CullFaceFrontBack: ()=>Xn,
            CullFaceNone: ()=>Gn,
            Curve: ()=>iA,
            CurvePath: ()=>wA,
            CustomBlending: ()=>lr,
            CustomToneMapping: ()=>Gr,
            CylinderGeometry: ()=>SA,
            Cylindrical: ()=>DM,
            Data3DTexture: ()=>ml,
            DataArrayTexture: ()=>Al,
            DataTexture: ()=>yf,
            DataTextureLoader: ()=>hm,
            DataUtils: ()=>Xc,
            DecrementStencilOp: ()=>Ys,
            DecrementWrapStencilOp: ()=>Xs,
            DefaultLoadingManager: ()=>im,
            DepthFormat: ()=>Na,
            DepthStencilFormat: ()=>Da,
            DepthTexture: ()=>Cp,
            DetachedBindMode: ()=>Wr,
            DirectionalLight: ()=>Sm,
            DirectionalLightHelper: ()=>qM,
            DiscreteInterpolant: ()=>Hg,
            DisplayP3ColorSpace: ()=>Ps,
            DodecahedronGeometry: ()=>CA,
            DoubleSide: ()=>er,
            DstAlphaFactor: ()=>vr,
            DstColorFactor: ()=>wr,
            DynamicCopyUsage: ()=>vo,
            DynamicDrawUsage: ()=>fo,
            DynamicReadUsage: ()=>mo,
            EdgesGeometry: ()=>jA,
            EllipseCurve: ()=>nA,
            EqualCompare: ()=>so,
            EqualDepth: ()=>Or,
            EqualStencilFunc: ()=>qs,
            EquirectangularReflectionMapping: ()=>Kr,
            EquirectangularRefractionMapping: ()=>qr,
            Euler: ()=>oc,
            EventDispatcher: ()=>So,
            ExtrudeGeometry: ()=>ug,
            FileLoader: ()=>sm,
            Float16BufferAttribute: ()=>au,
            Float32BufferAttribute: ()=>su,
            Float64BufferAttribute: ()=>ou,
            FloatType: ()=>ya,
            Fog: ()=>Rp,
            FogExp2: ()=>Pp,
            FramebufferTexture: ()=>Kf,
            FrontSide: ()=>$n,
            Frustum: ()=>$u,
            GLBufferAttribute: ()=>TM,
            GLSL1: ()=>wo,
            GLSL3: ()=>bo,
            GreaterCompare: ()=>lo,
            GreaterDepth: ()=>jr,
            GreaterEqualCompare: ()=>uo,
            GreaterEqualDepth: ()=>_r,
            GreaterEqualStencilFunc: ()=>io,
            GreaterStencilFunc: ()=>to,
            GridHelper: ()=>WM,
            Group: ()=>Sp,
            HalfFloatType: ()=>va,
            HemisphereLight: ()=>fm,
            HemisphereLightHelper: ()=>YM,
            IcosahedronGeometry: ()=>dg,
            ImageBitmapLoader: ()=>Bm,
            ImageLoader: ()=>cm,
            ImageUtils: ()=>sl,
            IncrementStencilOp: ()=>Gs,
            IncrementWrapStencilOp: ()=>Ws,
            InstancedBufferAttribute: ()=>bf,
            InstancedBufferGeometry: ()=>_m,
            InstancedInterleavedBuffer: ()=>bM,
            InstancedMesh: ()=>zf,
            Int16BufferAttribute: ()=>eu,
            Int32BufferAttribute: ()=>nu,
            Int8BufferAttribute: ()=>qc,
            IntType: ()=>ma,
            InterleavedBuffer: ()=>kp,
            InterleavedBufferAttribute: ()=>Fp,
            Interpolant: ()=>Bg,
            InterpolateDiscrete: ()=>gs,
            InterpolateLinear: ()=>ms,
            InterpolateSmooth: ()=>Ms,
            InvertStencilOp: ()=>Zs,
            KeepStencilOp: ()=>Hs,
            KeyframeTrack: ()=>Vg,
            LOD: ()=>of,
            LatheGeometry: ()=>TA,
            Layers: ()=>lc,
            LessCompare: ()=>ao,
            LessDepth: ()=>zr,
            LessEqualCompare: ()=>oo,
            LessEqualDepth: ()=>Lr,
            LessEqualStencilFunc: ()=>$s,
            LessStencilFunc: ()=>Ks,
            Light: ()=>pm,
            LightProbe: ()=>zm,
            Line: ()=>Uf,
            Line3: ()=>_M,
            LineBasicMaterial: ()=>Lf,
            LineCurve: ()=>gA,
            LineCurve3: ()=>mA,
            LineDashedMaterial: ()=>Og,
            LineLoop: ()=>Qf,
            LineSegments: ()=>Ff,
            LinearDisplayP3ColorSpace: ()=>Rs,
            LinearEncoding: ()=>Ss,
            LinearFilter: ()=>la,
            LinearInterpolant: ()=>Qg,
            LinearMipMapLinearFilter: ()=>da,
            LinearMipMapNearestFilter: ()=>ua,
            LinearMipmapLinearFilter: ()=>ha,
            LinearMipmapNearestFilter: ()=>ca,
            LinearSRGBColorSpace: ()=>js,
            LinearToneMapping: ()=>Fr,
            LinearTransfer: ()=>Us,
            Loader: ()=>nm,
            LoaderUtils: ()=>Om,
            LoadingManager: ()=>em,
            LoopOnce: ()=>ps,
            LoopPingPong: ()=>As,
            LoopRepeat: ()=>fs,
            LuminanceAlphaFormat: ()=>Sa,
            LuminanceFormat: ()=>Ia,
            MOUSE: ()=>Hn,
            Material: ()=>Qc,
            MaterialLoader: ()=>Lm,
            MathUtils: ()=>Fo,
            Matrix3: ()=>Ho,
            Matrix4: ()=>Kl,
            MaxEquation: ()=>pr,
            Mesh: ()=>Ou,
            MeshBasicMaterial: ()=>Hc,
            MeshDepthMaterial: ()=>vp,
            MeshDistanceMaterial: ()=>xp,
            MeshLambertMaterial: ()=>zg,
            MeshMatcapMaterial: ()=>Lg,
            MeshNormalMaterial: ()=>Cg,
            MeshPhongMaterial: ()=>Ng,
            MeshPhysicalMaterial: ()=>Sg,
            MeshStandardMaterial: ()=>Ig,
            MeshToonMaterial: ()=>Dg,
            MinEquation: ()=>dr,
            MirroredRepeatWrapping: ()=>ia,
            MixOperation: ()=>Ur,
            MultiplyBlending: ()=>or,
            MultiplyOperation: ()=>Rr,
            NearestFilter: ()=>na,
            NearestMipMapLinearFilter: ()=>oa,
            NearestMipMapNearestFilter: ()=>aa,
            NearestMipmapLinearFilter: ()=>sa,
            NearestMipmapNearestFilter: ()=>ra,
            NeverCompare: ()=>ro,
            NeverDepth: ()=>Dr,
            NeverStencilFunc: ()=>Js,
            NoBlending: ()=>nr,
            NoColorSpace: ()=>Os,
            NoToneMapping: ()=>Br,
            NormalAnimationBlendMode: ()=>ws,
            NormalBlending: ()=>rr,
            NotEqualCompare: ()=>co,
            NotEqualDepth: ()=>Pr,
            NotEqualStencilFunc: ()=>eo,
            NumberKeyframeTrack: ()=>Wg,
            Object3D: ()=>wc,
            ObjectLoader: ()=>Pm,
            ObjectSpaceNormalMap: ()=>Ls,
            OctahedronGeometry: ()=>pg,
            OneFactor: ()=>Ar,
            OneMinusConstantAlphaFactor: ()=>Nr,
            OneMinusConstantColorFactor: ()=>Ir,
            OneMinusDstAlphaFactor: ()=>xr,
            OneMinusDstColorFactor: ()=>br,
            OneMinusSrcAlphaFactor: ()=>yr,
            OneMinusSrcColorFactor: ()=>mr,
            OrthographicCamera: ()=>ph,
            P3Primaries: ()=>Fs,
            PCFShadowMap: ()=>Jn,
            PCFSoftShadowMap: ()=>Kn,
            PMREMGenerator: ()=>bh,
            Path: ()=>bA,
            PerspectiveCamera: ()=>Qu,
            Plane: ()=>Ju,
            PlaneGeometry: ()=>ih,
            PlaneHelper: ()=>sy,
            PointLight: ()=>Em,
            PointLightHelper: ()=>QM,
            Points: ()=>Xf,
            PointsMaterial: ()=>Hf,
            PolarGridHelper: ()=>XM,
            PolyhedronGeometry: ()=>DA,
            PositionalAudio: ()=>sM,
            PropertyBinding: ()=>AM,
            PropertyMixer: ()=>lM,
            QuadraticBezierCurve: ()=>MA,
            QuadraticBezierCurve3: ()=>yA,
            Quaternion: ()=>vl,
            QuaternionKeyframeTrack: ()=>Zg,
            QuaternionLinearInterpolant: ()=>Xg,
            RED_GREEN_RGTC2_Format: ()=>hs,
            RED_RGTC1_Format: ()=>cs,
            REVISION: ()=>Qn,
            RGBADepthPacking: ()=>Cs,
            RGBAFormat: ()=>Ea,
            RGBAIntegerFormat: ()=>_a,
            RGBA_ASTC_10x10_Format: ()=>ns,
            RGBA_ASTC_10x5_Format: ()=>ts,
            RGBA_ASTC_10x6_Format: ()=>es,
            RGBA_ASTC_10x8_Format: ()=>is,
            RGBA_ASTC_12x10_Format: ()=>rs,
            RGBA_ASTC_12x12_Format: ()=>as,
            RGBA_ASTC_4x4_Format: ()=>Ya,
            RGBA_ASTC_5x4_Format: ()=>Wa,
            RGBA_ASTC_5x5_Format: ()=>Xa,
            RGBA_ASTC_6x5_Format: ()=>Za,
            RGBA_ASTC_6x6_Format: ()=>Ja,
            RGBA_ASTC_8x5_Format: ()=>Ka,
            RGBA_ASTC_8x6_Format: ()=>qa,
            RGBA_ASTC_8x8_Format: ()=>$a,
            RGBA_BPTC_Format: ()=>ss,
            RGBA_ETC2_EAC_Format: ()=>Ga,
            RGBA_PVRTC_2BPPV1_Format: ()=>Qa,
            RGBA_PVRTC_4BPPV1_Format: ()=>Fa,
            RGBA_S3TC_DXT1_Format: ()=>Pa,
            RGBA_S3TC_DXT3_Format: ()=>Ra,
            RGBA_S3TC_DXT5_Format: ()=>Ua,
            RGB_BPTC_SIGNED_Format: ()=>os,
            RGB_BPTC_UNSIGNED_Format: ()=>ls,
            RGB_ETC1_Format: ()=>Ha,
            RGB_ETC2_Format: ()=>Va,
            RGB_PVRTC_2BPPV1_Format: ()=>Ba,
            RGB_PVRTC_4BPPV1_Format: ()=>ka,
            RGB_S3TC_DXT1_Format: ()=>ja,
            RGFormat: ()=>La,
            RGIntegerFormat: ()=>Oa,
            RawShaderMaterial: ()=>Eg,
            Ray: ()=>Jl,
            Raycaster: ()=>EM,
            Rec709Primaries: ()=>Bs,
            RectAreaLight: ()=>Dm,
            RedFormat: ()=>Ca,
            RedIntegerFormat: ()=>za,
            ReinhardToneMapping: ()=>Qr,
            RenderTarget: ()=>pl,
            RepeatWrapping: ()=>ta,
            ReplaceStencilOp: ()=>Vs,
            ReverseSubtractEquation: ()=>hr,
            RingGeometry: ()=>fg,
            SIGNED_RED_GREEN_RGTC2_Format: ()=>ds,
            SIGNED_RED_RGTC1_Format: ()=>us,
            SRGBColorSpace: ()=>_s,
            SRGBTransfer: ()=>ks,
            Scene: ()=>Up,
            ShaderChunk: ()=>nh,
            ShaderLib: ()=>ah,
            ShaderMaterial: ()=>Bu,
            ShadowMaterial: ()=>Tg,
            Shape: ()=>PA,
            ShapeGeometry: ()=>Ag,
            ShapePath: ()=>dy,
            ShapeUtils: ()=>og,
            ShortType: ()=>Aa,
            Skeleton: ()=>wf,
            SkeletonHelper: ()=>BM,
            SkinnedMesh: ()=>mf,
            Source: ()=>ll,
            Sphere: ()=>Ql,
            SphereGeometry: ()=>gg,
            Spherical: ()=>NM,
            SphericalHarmonics3: ()=>Cm,
            SplineCurve: ()=>vA,
            SpotLight: ()=>vm,
            SpotLightHelper: ()=>PM,
            Sprite: ()=>nf,
            SpriteMaterial: ()=>Qp,
            SrcAlphaFactor: ()=>Mr,
            SrcAlphaSaturateFactor: ()=>Tr,
            SrcColorFactor: ()=>gr,
            StaticCopyUsage: ()=>yo,
            StaticDrawUsage: ()=>po,
            StaticReadUsage: ()=>go,
            StereoCamera: ()=>Wm,
            StreamCopyUsage: ()=>xo,
            StreamDrawUsage: ()=>Ao,
            StreamReadUsage: ()=>Mo,
            StringKeyframeTrack: ()=>Jg,
            SubtractEquation: ()=>ur,
            SubtractiveBlending: ()=>sr,
            TOUCH: ()=>Vn,
            TangentSpaceNormalMap: ()=>zs,
            TetrahedronGeometry: ()=>mg,
            Texture: ()=>hl,
            TextureLoader: ()=>dm,
            TorusGeometry: ()=>Mg,
            TorusKnotGeometry: ()=>yg,
            Triangle: ()=>_c,
            TriangleFanDrawMode: ()=>Is,
            TriangleStripDrawMode: ()=>Es,
            TrianglesDrawMode: ()=>Ts,
            TubeGeometry: ()=>vg,
            TwoPassDoubleSide: ()=>ir,
            UVMapping: ()=>Xr,
            Uint16BufferAttribute: ()=>iu,
            Uint32BufferAttribute: ()=>ru,
            Uint8BufferAttribute: ()=>$c,
            Uint8ClampedBufferAttribute: ()=>tu,
            Uniform: ()=>vM,
            UniformsGroup: ()=>wM,
            UniformsLib: ()=>rh,
            UniformsUtils: ()=>ku,
            UnsignedByteType: ()=>pa,
            UnsignedInt248Type: ()=>ba,
            UnsignedIntType: ()=>Ma,
            UnsignedShort4444Type: ()=>xa,
            UnsignedShort5551Type: ()=>wa,
            UnsignedShortType: ()=>ga,
            VSMShadowMap: ()=>qn,
            Vector2: ()=>Qo,
            Vector3: ()=>xl,
            Vector4: ()=>dl,
            VectorKeyframeTrack: ()=>Kg,
            VideoTexture: ()=>Jf,
            WebGL1Renderer: ()=>jp,
            WebGL3DRenderTarget: ()=>Ml,
            WebGLArrayRenderTarget: ()=>gl,
            WebGLCoordinateSystem: ()=>Eo,
            WebGLCubeRenderTarget: ()=>Yu,
            WebGLMultipleRenderTargets: ()=>yl,
            WebGLRenderTarget: ()=>fl,
            WebGLRenderer: ()=>_p,
            WebGLUtils: ()=>Ep,
            WebGPUCoordinateSystem: ()=>Io,
            WireframeGeometry: ()=>xg,
            WrapAroundEnding: ()=>xs,
            ZeroCurvatureEnding: ()=>ys,
            ZeroFactor: ()=>fr,
            ZeroSlopeEnding: ()=>vs,
            ZeroStencilOp: ()=>Qs,
            _SRGBAFormat: ()=>To,
            createCanvasElement: ()=>Zo,
            sRGBEncoding: ()=>Ns
        });
        var e = i(540), r = i(72), a = i.n(r), s = i(825), o = i.n(s), l = i(659), c = i.n(l), u = i(56), h = i.n(u), d = i(159), p = i.n(d), f = i(113), A = i.n(f), g = i(761), m = {};
        function M(t1) {
            for(var e = arguments.length, i = new Array(e > 1 ? e - 1 : 0), n = 1; n < e; n++)i[n - 1] = arguments[n];
            throw new Error("number" == typeof t1 ? "[MobX] minified error nr: " + t1 + (i.length ? " " + i.map(String).join(",") : "") + ". Find the full error at: https://github.com/mobxjs/mobx/blob/main/packages/mobx/src/errors.ts" : "[MobX] " + t1);
        }
        m.styleTagTransform = A(), m.setAttributes = h(), m.insert = c().bind(null, "head"), m.domAPI = o(), m.insertStyleElement = p(), a()(g.A, m), g.A && g.A.locals && g.A.locals;
        var y = {};
        function v() {
            return "undefined" != typeof globalThis ? globalThis : "undefined" != typeof window ? window : void 0 !== i.g ? i.g : "undefined" != typeof self ? self : y;
        }
        var x = Object.assign, w = Object.getOwnPropertyDescriptor, b = Object.defineProperty, T = Object.prototype, E = [];
        Object.freeze(E);
        var I = {};
        Object.freeze(I);
        var S = "undefined" != typeof Proxy, N = Object.toString();
        function D() {
            S || M("Proxy not available");
        }
        function C(t1) {
            var e = !1;
            return function() {
                if (!e) return e = !0, t1.apply(this, arguments);
            };
        }
        var z = function() {};
        function L(t1) {
            return "function" == typeof t1;
        }
        function O(t1) {
            switch(typeof t1){
                case "string":
                case "symbol":
                case "number":
                    return !0;
            }
            return !1;
        }
        function _(t1) {
            return null !== t1 && "object" == typeof t1;
        }
        function j(t1) {
            if (!_(t1)) return !1;
            var e = Object.getPrototypeOf(t1);
            if (null == e) return !0;
            var i = Object.hasOwnProperty.call(e, "constructor") && e.constructor;
            return "function" == typeof i && i.toString() === N;
        }
        function P(t1) {
            var e = null == t1 ? void 0 : t1.constructor;
            return !!e && ("GeneratorFunction" === e.name || "GeneratorFunction" === e.displayName);
        }
        function R(t1, e, i) {
            b(t1, e, {
                enumerable: !1,
                writable: !0,
                configurable: !0,
                value: i
            });
        }
        function U(t1, e, i) {
            b(t1, e, {
                enumerable: !1,
                writable: !1,
                configurable: !0,
                value: i
            });
        }
        function k(t1, e) {
            var i = "isMobX" + t1;
            return e.prototype[i] = !0, function(t1) {
                return _(t1) && !0 === t1[i];
            };
        }
        function B(t1) {
            return null != t1 && "[object Map]" === Object.prototype.toString.call(t1);
        }
        function F(t1) {
            return null != t1 && "[object Set]" === Object.prototype.toString.call(t1);
        }
        var Q = void 0 !== Object.getOwnPropertySymbols, H = "undefined" != typeof Reflect && Reflect.ownKeys ? Reflect.ownKeys : Q ? function(t1) {
            return Object.getOwnPropertyNames(t1).concat(Object.getOwnPropertySymbols(t1));
        } : Object.getOwnPropertyNames;
        function V(t1) {
            return null === t1 ? null : "object" == typeof t1 ? "" + t1 : t1;
        }
        function G(t1, e) {
            return T.hasOwnProperty.call(t1, e);
        }
        var Y = Object.getOwnPropertyDescriptors || function(t1) {
            var e = {};
            return H(t1).forEach(function(i) {
                e[i] = w(t1, i);
            }), e;
        };
        function W(t1, e) {
            return !!(t1 & e);
        }
        function X(t1, e, i) {
            return i ? t1 |= e : t1 &= ~e, t1;
        }
        function Z(t1, e) {
            (null == e || e > t1.length) && (e = t1.length);
            for(var i = 0, n = Array(e); i < e; i++)n[i] = t1[i];
            return n;
        }
        function J(t1, e) {
            for(var i = 0; i < e.length; i++){
                var n = e[i];
                n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t1, it(n.key), n);
            }
        }
        function K(t1, e, i) {
            return e && J(t1.prototype, e), i && J(t1, i), Object.defineProperty(t1, "prototype", {
                writable: !1
            }), t1;
        }
        function q(t1, e) {
            var i = "undefined" != typeof Symbol && t1[Symbol.iterator] || t1["@@iterator"];
            if (i) return (i = i.call(t1)).next.bind(i);
            if (Array.isArray(t1) || (i = function(t1, e) {
                if (t1) {
                    if ("string" == typeof t1) return Z(t1, e);
                    var i = ({}).toString.call(t1).slice(8, -1);
                    return "Object" === i && t1.constructor && (i = t1.constructor.name), "Map" === i || "Set" === i ? Array.from(t1) : "Arguments" === i || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(i) ? Z(t1, e) : void 0;
                }
            }(t1)) || e && t1 && "number" == typeof t1.length) {
                i && (t1 = i);
                var n = 0;
                return function() {
                    return n >= t1.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: t1[n++]
                    };
                };
            }
            throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
        }
        function $() {
            return $ = Object.assign ? Object.assign.bind() : function(t1) {
                for(var e = 1; e < arguments.length; e++){
                    var i = arguments[e];
                    for(var n in i)({}).hasOwnProperty.call(i, n) && (t1[n] = i[n]);
                }
                return t1;
            }, $.apply(null, arguments);
        }
        function tt(t1, e) {
            t1.prototype = Object.create(e.prototype), t1.prototype.constructor = t1, et(t1, e);
        }
        function et(t1, e) {
            return et = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t1, e) {
                return t1.__proto__ = e, t1;
            }, et(t1, e);
        }
        function it(t1) {
            var e = function(t1) {
                if ("object" != typeof t1 || !t1) return t1;
                var e = t1[Symbol.toPrimitive];
                if (void 0 !== e) {
                    var i = e.call(t1, "string");
                    if ("object" != typeof i) return i;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return String(t1);
            }(t1);
            return "symbol" == typeof e ? e : e + "";
        }
        var nt = Symbol("mobx-stored-annotations");
        function rt(t1) {
            return Object.assign(function(e, i) {
                if (st(i)) return t1.decorate_20223_(e, i);
                at(e, i, t1);
            }, t1);
        }
        function at(t1, e, i) {
            G(t1, nt) || R(t1, nt, $({}, t1[nt])), function(t1) {
                return t1.annotationType_ === ft;
            }(i) || (t1[nt][e] = i);
        }
        function st(t1) {
            return "object" == typeof t1 && "string" == typeof t1.kind;
        }
        var ot = Symbol("mobx administration"), lt = function() {
            function t1(t1) {
                void 0 === t1 && (t1 = "Atom"), this.name_ = void 0, this.flags_ = 0, this.observers_ = new Set, this.lastAccessedBy_ = 0, this.lowestObserverState_ = he.NOT_TRACKING_, this.onBOL = void 0, this.onBUOL = void 0, this.name_ = t1;
            }
            var e = t1.prototype;
            return e.onBO = function() {
                this.onBOL && this.onBOL.forEach(function(t1) {
                    return t1();
                });
            }, e.onBUO = function() {
                this.onBUOL && this.onBUOL.forEach(function(t1) {
                    return t1();
                });
            }, e.reportObserved = function() {
                return Oe(this);
            }, e.reportChanged = function() {
                ze(), _e(this), Le();
            }, e.toString = function() {
                return this.name_;
            }, K(t1, [
                {
                    key: "isBeingObserved",
                    get: function() {
                        return W(this.flags_, t1.isBeingObservedMask_);
                    },
                    set: function(e) {
                        this.flags_ = X(this.flags_, t1.isBeingObservedMask_, e);
                    }
                },
                {
                    key: "isPendingUnobservation",
                    get: function() {
                        return W(this.flags_, t1.isPendingUnobservationMask_);
                    },
                    set: function(e) {
                        this.flags_ = X(this.flags_, t1.isPendingUnobservationMask_, e);
                    }
                },
                {
                    key: "diffValue",
                    get: function() {
                        return W(this.flags_, t1.diffValueMask_) ? 1 : 0;
                    },
                    set: function(e) {
                        this.flags_ = X(this.flags_, t1.diffValueMask_, 1 === e);
                    }
                }
            ]);
        }();
        lt.isBeingObservedMask_ = 1, lt.isPendingUnobservationMask_ = 2, lt.diffValueMask_ = 4;
        var ct = k("Atom", lt);
        function ut(t1, e, i) {
            void 0 === e && (e = z), void 0 === i && (i = z);
            var n = new lt(t1);
            return e !== z && ei(qe, n, e, undefined), i !== z && ti(n, i), n;
        }
        var ht = {
            identity: function(t1, e) {
                return t1 === e;
            },
            structural: function(t1, e) {
                return gn(t1, e);
            },
            default: function(t1, e) {
                return Object.is ? Object.is(t1, e) : t1 === e ? 0 !== t1 || 1 / t1 == 1 / e : t1 != t1 && e != e;
            },
            shallow: function(t1, e) {
                return gn(t1, e, 1);
            }
        };
        function dt(t1, e, i) {
            return pi(t1) ? t1 : Array.isArray(t1) ? Kt.array(t1, {
                name: i
            }) : j(t1) ? Kt.object(t1, void 0, {
                name: i
            }) : B(t1) ? Kt.map(t1, {
                name: i
            }) : F(t1) ? Kt.set(t1, {
                name: i
            }) : "function" != typeof t1 || Je(t1) || di(t1) ? t1 : P(t1) ? ui(t1) : Ze(i, t1);
        }
        function pt(t1) {
            return t1;
        }
        var ft = "override";
        function At(t1, e) {
            return {
                annotationType_: t1,
                options_: e,
                make_: gt,
                extend_: mt,
                decorate_20223_: Mt
            };
        }
        function gt(t1, e, i, n) {
            var r;
            if (null != (r = this.options_) && r.bound) return null === this.extend_(t1, e, i, !1) ? 0 : 1;
            if (n === t1.target_) return null === this.extend_(t1, e, i, !1) ? 0 : 2;
            if (Je(i.value)) return 1;
            var a = yt(t1, this, e, i, !1);
            return b(n, e, a), 2;
        }
        function mt(t1, e, i, n) {
            var r = yt(t1, this, e, i);
            return t1.defineProperty_(e, r, n);
        }
        function Mt(t1, e) {
            var i = e.kind, n = e.name, r = e.addInitializer, a = this;
            if ("field" != i) {
                var s, o, l, c, u, h;
                if ("method" == i) return Je(t1) || (o = t1, t1 = se(null != (l = null == (c = a.options_) ? void 0 : c.name) ? l : n.toString(), o, null != (u = null == (h = a.options_) ? void 0 : h.autoAction) && u)), null != (s = this.options_) && s.bound && r(function() {
                    var t1 = this, e = t1[n].bind(t1);
                    e.isMobxAction = !0, t1[n] = e;
                }), t1;
                M("Cannot apply '" + a.annotationType_ + "' to '" + String(n) + "' (kind: " + i + "):\n'" + a.annotationType_ + "' can only be used on properties with a function value.");
            } else r(function() {
                at(this, n, a);
            });
        }
        function yt(t1, e, i, n, r) {
            var a, s, o, l, c, u, h, d;
            void 0 === r && (r = Ne.safeDescriptors), d = n, e.annotationType_, d.value;
            var p, f = n.value;
            return null != (a = e.options_) && a.bound && (f = f.bind(null != (p = t1.proxy_) ? p : t1.target_)), {
                value: se(null != (s = null == (o = e.options_) ? void 0 : o.name) ? s : i.toString(), f, null != (l = null == (c = e.options_) ? void 0 : c.autoAction) && l, null != (u = e.options_) && u.bound ? null != (h = t1.proxy_) ? h : t1.target_ : void 0),
                configurable: !r || t1.isPlainObject_,
                enumerable: !1,
                writable: !r
            };
        }
        function vt(t1, e) {
            return {
                annotationType_: t1,
                options_: e,
                make_: xt,
                extend_: wt,
                decorate_20223_: bt
            };
        }
        function xt(t1, e, i, n) {
            var r;
            if (n === t1.target_) return null === this.extend_(t1, e, i, !1) ? 0 : 2;
            if (null != (r = this.options_) && r.bound && (!G(t1.target_, e) || !di(t1.target_[e])) && null === this.extend_(t1, e, i, !1)) return 0;
            if (di(i.value)) return 1;
            var a = Tt(t1, this, 0, i, !1, !1);
            return b(n, e, a), 2;
        }
        function wt(t1, e, i, n) {
            var r, a = Tt(t1, this, 0, i, null == (r = this.options_) ? void 0 : r.bound);
            return t1.defineProperty_(e, a, n);
        }
        function bt(t1, e) {
            var i, n = e.name, r = e.addInitializer;
            return di(t1) || (t1 = ui(t1)), null != (i = this.options_) && i.bound && r(function() {
                var t1 = this, e = t1[n].bind(t1);
                e.isMobXFlow = !0, t1[n] = e;
            }), t1;
        }
        function Tt(t1, e, i, n, r, a) {
            var s;
            void 0 === a && (a = Ne.safeDescriptors), s = n, e.annotationType_, s.value;
            var o, l = n.value;
            return di(l) || (l = ui(l)), r && ((l = l.bind(null != (o = t1.proxy_) ? o : t1.target_)).isMobXFlow = !0), {
                value: l,
                configurable: !a || t1.isPlainObject_,
                enumerable: !1,
                writable: !a
            };
        }
        function Et(t1, e) {
            return {
                annotationType_: t1,
                options_: e,
                make_: It,
                extend_: St,
                decorate_20223_: Nt
            };
        }
        function It(t1, e, i) {
            return null === this.extend_(t1, e, i, !1) ? 0 : 1;
        }
        function St(t1, e, i, n) {
            var r;
            return r = i, this.annotationType_, r.get, t1.defineComputedProperty_(e, $({}, this.options_, {
                get: i.get,
                set: i.set
            }), n);
        }
        function Nt(t1, e) {
            var i = this, n = e.name;
            return (0, e.addInitializer)(function() {
                var e = Xi(this)[ot], r = $({}, i.options_, {
                    get: t1,
                    context: this
                });
                r.name || (r.name = "ObservableObject." + n.toString()), e.values_.set(n, new ue(r));
            }), function() {
                return this[ot].getObservablePropValue_(n);
            };
        }
        function Dt(t1, e) {
            return {
                annotationType_: t1,
                options_: e,
                make_: Ct,
                extend_: zt,
                decorate_20223_: Lt
            };
        }
        function Ct(t1, e, i) {
            return null === this.extend_(t1, e, i, !1) ? 0 : 1;
        }
        function zt(t1, e, i, n) {
            var r, a;
            return this.annotationType_, t1.defineObservableProperty_(e, i.value, null != (r = null == (a = this.options_) ? void 0 : a.enhancer) ? r : dt, n);
        }
        function Lt(t1, e) {
            var i = this, n = e.kind, r = e.name, a = new WeakSet;
            function s(t1, e) {
                var n, s, o = Xi(t1)[ot], l = new ce(e, null != (n = null == (s = i.options_) ? void 0 : s.enhancer) ? n : dt, "ObservableObject." + r.toString(), !1);
                o.values_.set(r, l), a.add(t1);
            }
            if ("accessor" == n) return {
                get: function() {
                    return a.has(this) || s(this, t1.get.call(this)), this[ot].getObservablePropValue_(r);
                },
                set: function(t1) {
                    return a.has(this) || s(this, t1), this[ot].setObservablePropValue_(r, t1);
                },
                init: function(t1) {
                    return a.has(this) || s(this, t1), t1;
                }
            };
        }
        var Ot = "true", _t = jt();
        function jt(t1) {
            return {
                annotationType_: Ot,
                options_: t1,
                make_: Pt,
                extend_: Rt,
                decorate_20223_: Ut
            };
        }
        function Pt(t1, e, i, n) {
            var r, a, s, o;
            if (i.get) return ee.make_(t1, e, i, n);
            if (i.set) {
                var l = se(e.toString(), i.set);
                return n === t1.target_ ? null === t1.defineProperty_(e, {
                    configurable: !Ne.safeDescriptors || t1.isPlainObject_,
                    set: l
                }) ? 0 : 2 : (b(n, e, {
                    configurable: !0,
                    set: l
                }), 2);
            }
            if (n !== t1.target_ && "function" == typeof i.value) return P(i.value) ? (null != (o = this.options_) && o.autoBind ? ui.bound : ui).make_(t1, e, i, n) : (null != (s = this.options_) && s.autoBind ? Ze.bound : Ze).make_(t1, e, i, n);
            var c, u = !1 === (null == (r = this.options_) ? void 0 : r.deep) ? Kt.ref : Kt;
            return "function" == typeof i.value && null != (a = this.options_) && a.autoBind && (i.value = i.value.bind(null != (c = t1.proxy_) ? c : t1.target_)), u.make_(t1, e, i, n);
        }
        function Rt(t1, e, i, n) {
            var r, a, s;
            return i.get ? ee.extend_(t1, e, i, n) : i.set ? t1.defineProperty_(e, {
                configurable: !Ne.safeDescriptors || t1.isPlainObject_,
                set: se(e.toString(), i.set)
            }, n) : ("function" == typeof i.value && null != (r = this.options_) && r.autoBind && (i.value = i.value.bind(null != (s = t1.proxy_) ? s : t1.target_)), (!1 === (null == (a = this.options_) ? void 0 : a.deep) ? Kt.ref : Kt).extend_(t1, e, i, n));
        }
        function Ut(t1, e) {
            M("'" + this.annotationType_ + "' cannot be used as a decorator");
        }
        var kt = {
            deep: !0,
            name: void 0,
            defaultDecorator: void 0,
            proxy: !0
        };
        function Bt(t1) {
            return t1 || kt;
        }
        Object.freeze(kt);
        var Ft = Dt("observable"), Qt = Dt("observable.ref", {
            enhancer: pt
        }), Ht = Dt("observable.shallow", {
            enhancer: function(t1, e, i) {
                return null == t1 || Ki(t1) || Pi(t1) || Fi(t1) || Vi(t1) ? t1 : Array.isArray(t1) ? Kt.array(t1, {
                    name: i,
                    deep: !1
                }) : j(t1) ? Kt.object(t1, void 0, {
                    name: i,
                    deep: !1
                }) : B(t1) ? Kt.map(t1, {
                    name: i,
                    deep: !1
                }) : F(t1) ? Kt.set(t1, {
                    name: i,
                    deep: !1
                }) : void 0;
            }
        }), Vt = Dt("observable.struct", {
            enhancer: function(t1, e) {
                return gn(t1, e) ? e : t1;
            }
        }), Gt = rt(Ft);
        function Yt(t1) {
            var e, i, n;
            return !0 === t1.deep ? dt : !1 === t1.deep ? pt : (e = t1.defaultDecorator) && null != (i = null == (n = e.options_) ? void 0 : n.enhancer) ? i : dt;
        }
        function Wt(t1, e, i) {
            return st(e) ? Ft.decorate_20223_(t1, e) : O(e) ? void at(t1, e, Ft) : pi(t1) ? t1 : j(t1) ? Kt.object(t1, e, i) : Array.isArray(t1) ? Kt.array(t1, e) : B(t1) ? Kt.map(t1, e) : F(t1) ? Kt.set(t1, e) : "object" == typeof t1 && null !== t1 ? t1 : Kt.box(t1, e);
        }
        x(Wt, Gt);
        var Xt, Zt, Jt = {
            box: function(t1, e) {
                var i = Bt(e);
                return new ce(t1, Yt(i), i.name, !0, i.equals);
            },
            array: function(t1, e) {
                var i = Bt(e);
                return (!1 === Ne.useProxies || !1 === i.proxy ? un : Di)(t1, Yt(i), i.name);
            },
            map: function(t1, e) {
                var i = Bt(e);
                return new Bi(t1, Yt(i), i.name);
            },
            set: function(t1, e) {
                var i = Bt(e);
                return new Hi(t1, Yt(i), i.name);
            },
            object: function(t1, e, i) {
                return fn(function() {
                    return ri(!1 === Ne.useProxies || !1 === (null == i ? void 0 : i.proxy) ? Xi({}, i) : function(t1, e) {
                        var i, n;
                        return D(), null != (n = (i = (t1 = Xi(t1, e))[ot]).proxy_) ? n : i.proxy_ = new Proxy(t1, gi);
                    }({}, i), t1, e);
                });
            },
            ref: rt(Qt),
            shallow: rt(Ht),
            deep: Gt,
            struct: rt(Vt)
        }, Kt = x(Wt, Jt), qt = "computed", $t = Et(qt), te = Et("computed.struct", {
            equals: ht.structural
        }), ee = function(t1, e) {
            if (st(e)) return $t.decorate_20223_(t1, e);
            if (O(e)) return at(t1, e, $t);
            if (j(t1)) return rt(Et(qt, t1));
            var i = j(e) ? e : {};
            return i.get = t1, i.name || (i.name = t1.name || ""), new ue(i);
        };
        Object.assign(ee, $t), ee.struct = rt(te);
        var ie = 0, ne = 1, re = null != (Xt = null == (Zt = w(function() {}, "name")) ? void 0 : Zt.configurable) && Xt, ae = {
            value: "action",
            configurable: !0,
            writable: !1,
            enumerable: !1
        };
        function se(t1, e, i, n) {
            function r() {
                return function(t1, e, i, n, r) {
                    var a = function(t1, e) {
                        var i = !1, n = 0, r = Ne.trackingDerivation, a = !e || !r;
                        ze();
                        var s = Ne.allowStateChanges;
                        a && (ve(), s = oe(!0));
                        var o = {
                            runAsAction_: a,
                            prevDerivation_: r,
                            prevAllowStateChanges_: s,
                            prevAllowStateReads_: we(!0),
                            notifySpy_: i,
                            startTime_: n,
                            actionId_: ne++,
                            parentActionId_: ie
                        };
                        return ie = o.actionId_, o;
                    }(0, e);
                    try {
                        return i.apply(n, r);
                    } catch (t1) {
                        throw a.error_ = t1, t1;
                    } finally{
                        !function(t1) {
                            ie !== t1.actionId_ && M(30), ie = t1.parentActionId_, void 0 !== t1.error_ && (Ne.suppressReactionErrors = !0), le(t1.prevAllowStateChanges_), be(t1.prevAllowStateReads_), Le(), t1.runAsAction_ && xe(t1.prevDerivation_), Ne.suppressReactionErrors = !1;
                        }(a);
                    }
                }(0, i, e, n || this, arguments);
            }
            return void 0 === i && (i = !1), r.isMobxAction = !0, r.toString = function() {
                return e.toString();
            }, re && (ae.value = t1, b(r, "name", ae)), r;
        }
        function oe(t1) {
            var e = Ne.allowStateChanges;
            return Ne.allowStateChanges = t1, e;
        }
        function le(t1) {
            Ne.allowStateChanges = t1;
        }
        var ce = function(t1) {
            function e(e, i, n, r, a) {
                var s;
                return void 0 === n && (n = "ObservableValue"), void 0 === r && (r = !0), void 0 === a && (a = ht.default), (s = t1.call(this, n) || this).enhancer = void 0, s.name_ = void 0, s.equals = void 0, s.hasUnreportedChange_ = !1, s.interceptors_ = void 0, s.changeListeners_ = void 0, s.value_ = void 0, s.dehancer = void 0, s.enhancer = i, s.name_ = n, s.equals = a, s.value_ = i(e, void 0, n), s;
            }
            tt(e, t1);
            var i = e.prototype;
            return i.dehanceValue = function(t1) {
                return void 0 !== this.dehancer ? this.dehancer(t1) : t1;
            }, i.set = function(t1) {
                this.value_, (t1 = this.prepareNewValue_(t1)) !== Ne.UNCHANGED && this.setNewValue_(t1);
            }, i.prepareNewValue_ = function(t1) {
                if (mi(this)) {
                    var e = yi(this, {
                        object: this,
                        type: Ii,
                        newValue: t1
                    });
                    if (!e) return Ne.UNCHANGED;
                    t1 = e.newValue;
                }
                return t1 = this.enhancer(t1, this.value_, this.name_), this.equals(this.value_, t1) ? Ne.UNCHANGED : t1;
            }, i.setNewValue_ = function(t1) {
                var e = this.value_;
                this.value_ = t1, this.reportChanged(), vi(this) && wi(this, {
                    type: Ii,
                    object: this,
                    newValue: t1,
                    oldValue: e
                });
            }, i.get = function() {
                return this.reportObserved(), this.dehanceValue(this.value_);
            }, i.intercept_ = function(t1) {
                return Mi(this, t1);
            }, i.observe_ = function(t1, e) {
                return e && t1({
                    observableKind: "value",
                    debugObjectName: this.name_,
                    object: this,
                    type: Ii,
                    newValue: this.value_,
                    oldValue: void 0
                }), xi(this, t1);
            }, i.raw = function() {
                return this.value_;
            }, i.toJSON = function() {
                return this.get();
            }, i.toString = function() {
                return this.name_ + "[" + this.value_ + "]";
            }, i.valueOf = function() {
                return V(this.get());
            }, i[Symbol.toPrimitive] = function() {
                return this.valueOf();
            }, e;
        }(lt), ue = function() {
            function t1(t1) {
                this.dependenciesState_ = he.NOT_TRACKING_, this.observing_ = [], this.newObserving_ = null, this.observers_ = new Set, this.runId_ = 0, this.lastAccessedBy_ = 0, this.lowestObserverState_ = he.UP_TO_DATE_, this.unboundDepsCount_ = 0, this.value_ = new fe(null), this.name_ = void 0, this.triggeredBy_ = void 0, this.flags_ = 0, this.derivation = void 0, this.setter_ = void 0, this.isTracing_ = de.NONE, this.scope_ = void 0, this.equals_ = void 0, this.requiresReaction_ = void 0, this.keepAlive_ = void 0, this.onBOL = void 0, this.onBUOL = void 0, t1.get || M(31), this.derivation = t1.get, this.name_ = t1.name || "ComputedValue", t1.set && (this.setter_ = se("ComputedValue-setter", t1.set)), this.equals_ = t1.equals || (t1.compareStructural || t1.struct ? ht.structural : ht.default), this.scope_ = t1.context, this.requiresReaction_ = t1.requiresReaction, this.keepAlive_ = !!t1.keepAlive;
            }
            var e = t1.prototype;
            return e.onBecomeStale_ = function() {
                var t1;
                (t1 = this).lowestObserverState_ === he.UP_TO_DATE_ && (t1.lowestObserverState_ = he.POSSIBLY_STALE_, t1.observers_.forEach(function(t1) {
                    t1.dependenciesState_ === he.UP_TO_DATE_ && (t1.dependenciesState_ = he.POSSIBLY_STALE_, t1.onBecomeStale_());
                }));
            }, e.onBO = function() {
                this.onBOL && this.onBOL.forEach(function(t1) {
                    return t1();
                });
            }, e.onBUO = function() {
                this.onBUOL && this.onBUOL.forEach(function(t1) {
                    return t1();
                });
            }, e.get = function() {
                if (this.isComputing && M(32, this.name_, this.derivation), 0 !== Ne.inBatch || 0 !== this.observers_.size || this.keepAlive_) {
                    if (Oe(this), ge(this)) {
                        var t1 = Ne.trackingContext;
                        this.keepAlive_ && !t1 && (Ne.trackingContext = this), this.trackAndCompute() && (e = this).lowestObserverState_ !== he.STALE_ && (e.lowestObserverState_ = he.STALE_, e.observers_.forEach(function(t1) {
                            t1.dependenciesState_ === he.POSSIBLY_STALE_ ? t1.dependenciesState_ = he.STALE_ : t1.dependenciesState_ === he.UP_TO_DATE_ && (e.lowestObserverState_ = he.UP_TO_DATE_);
                        })), Ne.trackingContext = t1;
                    }
                } else ge(this) && (this.warnAboutUntrackedRead_(), ze(), this.value_ = this.computeValue_(!1), Le());
                var e, i = this.value_;
                if (Ae(i)) throw i.cause;
                return i;
            }, e.set = function(t1) {
                if (this.setter_) {
                    this.isRunningSetter && M(33, this.name_), this.isRunningSetter = !0;
                    try {
                        this.setter_.call(this.scope_, t1);
                    } finally{
                        this.isRunningSetter = !1;
                    }
                } else M(34, this.name_);
            }, e.trackAndCompute = function() {
                var t1 = this.value_, e = this.dependenciesState_ === he.NOT_TRACKING_, i = this.computeValue_(!0), n = e || Ae(t1) || Ae(i) || !this.equals_(t1, i);
                return n && (this.value_ = i), n;
            }, e.computeValue_ = function(t1) {
                this.isComputing = !0;
                var e, i = oe(!1);
                if (t1) e = me(this, this.derivation, this.scope_);
                else if (!0 === Ne.disableErrorBoundaries) e = this.derivation.call(this.scope_);
                else try {
                    e = this.derivation.call(this.scope_);
                } catch (t1) {
                    e = new fe(t1);
                }
                return le(i), this.isComputing = !1, e;
            }, e.suspend_ = function() {
                this.keepAlive_ || (Me(this), this.value_ = void 0);
            }, e.observe_ = function(t1, e) {
                var i = this, n = !0, r = void 0;
                return function(t1, e) {
                    var i, n, r, a;
                    void 0 === e && (e = I);
                    var s, o = null != (i = null == (n = e) ? void 0 : n.name) ? i : "Autorun";
                    if (e.scheduler || e.delay) {
                        var l = function(t1) {
                            return t1.scheduler ? t1.scheduler : t1.delay ? function(e) {
                                return setTimeout(e, t1.delay);
                            } : Ke;
                        }(e), c = !1;
                        s = new je(o, function() {
                            c || (c = !0, l(function() {
                                c = !1, s.isDisposed || s.track(u);
                            }));
                        }, e.onError, e.requiresObservable);
                    } else s = new je(o, function() {
                        this.track(u);
                    }, e.onError, e.requiresObservable);
                    function u() {
                        t1(s);
                    }
                    return null != (r = e) && null != (r = r.signal) && r.aborted || s.schedule_(), s.getDisposer_(null == (a = e) ? void 0 : a.signal);
                }(function() {
                    var a = i.get();
                    if (!n || e) {
                        var s = ve();
                        t1({
                            observableKind: "computed",
                            debugObjectName: i.name_,
                            type: Ii,
                            object: i,
                            newValue: a,
                            oldValue: r
                        }), xe(s);
                    }
                    n = !1, r = a;
                });
            }, e.warnAboutUntrackedRead_ = function() {}, e.toString = function() {
                return this.name_ + "[" + this.derivation.toString() + "]";
            }, e.valueOf = function() {
                return V(this.get());
            }, e[Symbol.toPrimitive] = function() {
                return this.valueOf();
            }, K(t1, [
                {
                    key: "isComputing",
                    get: function() {
                        return W(this.flags_, t1.isComputingMask_);
                    },
                    set: function(e) {
                        this.flags_ = X(this.flags_, t1.isComputingMask_, e);
                    }
                },
                {
                    key: "isRunningSetter",
                    get: function() {
                        return W(this.flags_, t1.isRunningSetterMask_);
                    },
                    set: function(e) {
                        this.flags_ = X(this.flags_, t1.isRunningSetterMask_, e);
                    }
                },
                {
                    key: "isBeingObserved",
                    get: function() {
                        return W(this.flags_, t1.isBeingObservedMask_);
                    },
                    set: function(e) {
                        this.flags_ = X(this.flags_, t1.isBeingObservedMask_, e);
                    }
                },
                {
                    key: "isPendingUnobservation",
                    get: function() {
                        return W(this.flags_, t1.isPendingUnobservationMask_);
                    },
                    set: function(e) {
                        this.flags_ = X(this.flags_, t1.isPendingUnobservationMask_, e);
                    }
                },
                {
                    key: "diffValue",
                    get: function() {
                        return W(this.flags_, t1.diffValueMask_) ? 1 : 0;
                    },
                    set: function(e) {
                        this.flags_ = X(this.flags_, t1.diffValueMask_, 1 === e);
                    }
                }
            ]);
        }();
        ue.isComputingMask_ = 1, ue.isRunningSetterMask_ = 2, ue.isBeingObservedMask_ = 4, ue.isPendingUnobservationMask_ = 8, ue.diffValueMask_ = 16;
        var he, de, pe = k("ComputedValue", ue);
        !function(t1) {
            t1[t1.NOT_TRACKING_ = -1] = "NOT_TRACKING_", t1[t1.UP_TO_DATE_ = 0] = "UP_TO_DATE_", t1[t1.POSSIBLY_STALE_ = 1] = "POSSIBLY_STALE_", t1[t1.STALE_ = 2] = "STALE_";
        }(he || (he = {})), function(t1) {
            t1[t1.NONE = 0] = "NONE", t1[t1.LOG = 1] = "LOG", t1[t1.BREAK = 2] = "BREAK";
        }(de || (de = {}));
        var fe = function(t1) {
            this.cause = void 0, this.cause = t1;
        };
        function Ae(t1) {
            return t1 instanceof fe;
        }
        function ge(t1) {
            switch(t1.dependenciesState_){
                case he.UP_TO_DATE_:
                    return !1;
                case he.NOT_TRACKING_:
                case he.STALE_:
                    return !0;
                case he.POSSIBLY_STALE_:
                    for(var e = we(!0), i = ve(), n = t1.observing_, r = n.length, a = 0; a < r; a++){
                        var s = n[a];
                        if (pe(s)) {
                            if (Ne.disableErrorBoundaries) s.get();
                            else try {
                                s.get();
                            } catch (t1) {
                                return xe(i), be(e), !0;
                            }
                            if (t1.dependenciesState_ === he.STALE_) return xe(i), be(e), !0;
                        }
                    }
                    return Te(t1), xe(i), be(e), !1;
            }
        }
        function me(t1, e, i) {
            var n = we(!0);
            Te(t1), t1.newObserving_ = new Array(0 === t1.runId_ ? 100 : t1.observing_.length), t1.unboundDepsCount_ = 0, t1.runId_ = ++Ne.runId;
            var r, a = Ne.trackingDerivation;
            if (Ne.trackingDerivation = t1, Ne.inBatch++, !0 === Ne.disableErrorBoundaries) r = e.call(i);
            else try {
                r = e.call(i);
            } catch (t1) {
                r = new fe(t1);
            }
            return Ne.inBatch--, Ne.trackingDerivation = a, function(t1) {
                for(var e = t1.observing_, i = t1.observing_ = t1.newObserving_, n = he.UP_TO_DATE_, r = 0, a = t1.unboundDepsCount_, s = 0; s < a; s++){
                    var o = i[s];
                    0 === o.diffValue && (o.diffValue = 1, r !== s && (i[r] = o), r++), o.dependenciesState_ > n && (n = o.dependenciesState_);
                }
                for(i.length = r, t1.newObserving_ = null, a = e.length; a--;){
                    var l = e[a];
                    0 === l.diffValue && De(l, t1), l.diffValue = 0;
                }
                for(; r--;){
                    var c = i[r];
                    1 === c.diffValue && (c.diffValue = 0, h = t1, (u = c).observers_.add(h), u.lowestObserverState_ > h.dependenciesState_ && (u.lowestObserverState_ = h.dependenciesState_));
                }
                var u, h;
                n !== he.UP_TO_DATE_ && (t1.dependenciesState_ = n, t1.onBecomeStale_());
            }(t1), be(n), r;
        }
        function Me(t1) {
            var e = t1.observing_;
            t1.observing_ = [];
            for(var i = e.length; i--;)De(e[i], t1);
            t1.dependenciesState_ = he.NOT_TRACKING_;
        }
        function ye(t1) {
            var e = ve();
            try {
                return t1();
            } finally{
                xe(e);
            }
        }
        function ve() {
            var t1 = Ne.trackingDerivation;
            return Ne.trackingDerivation = null, t1;
        }
        function xe(t1) {
            Ne.trackingDerivation = t1;
        }
        function we(t1) {
            var e = Ne.allowStateReads;
            return Ne.allowStateReads = t1, e;
        }
        function be(t1) {
            Ne.allowStateReads = t1;
        }
        function Te(t1) {
            if (t1.dependenciesState_ !== he.UP_TO_DATE_) {
                t1.dependenciesState_ = he.UP_TO_DATE_;
                for(var e = t1.observing_, i = e.length; i--;)e[i].lowestObserverState_ = he.UP_TO_DATE_;
            }
        }
        var Ee = function() {
            this.version = 6, this.UNCHANGED = {}, this.trackingDerivation = null, this.trackingContext = null, this.runId = 0, this.mobxGuid = 0, this.inBatch = 0, this.pendingUnobservations = [], this.pendingReactions = [], this.isRunningReactions = !1, this.allowStateChanges = !1, this.allowStateReads = !0, this.enforceActions = !0, this.spyListeners = [], this.globalReactionErrorHandlers = [], this.computedRequiresReaction = !1, this.reactionRequiresObservable = !1, this.observableRequiresReaction = !1, this.disableErrorBoundaries = !1, this.suppressReactionErrors = !1, this.useProxies = !0, this.verifyProxies = !1, this.safeDescriptors = !0;
        }, Ie = !0, Se = !1, Ne = function() {
            var t1 = v();
            return t1.__mobxInstanceCount > 0 && !t1.__mobxGlobals && (Ie = !1), t1.__mobxGlobals && t1.__mobxGlobals.version !== (new Ee).version && (Ie = !1), Ie ? t1.__mobxGlobals ? (t1.__mobxInstanceCount += 1, t1.__mobxGlobals.UNCHANGED || (t1.__mobxGlobals.UNCHANGED = {}), t1.__mobxGlobals) : (t1.__mobxInstanceCount = 1, t1.__mobxGlobals = new Ee) : (setTimeout(function() {
                Se || M(35);
            }, 1), new Ee);
        }();
        function De(t1, e) {
            t1.observers_.delete(e), 0 === t1.observers_.size && Ce(t1);
        }
        function Ce(t1) {
            !1 === t1.isPendingUnobservation && (t1.isPendingUnobservation = !0, Ne.pendingUnobservations.push(t1));
        }
        function ze() {
            Ne.inBatch++;
        }
        function Le() {
            if (0 == --Ne.inBatch) {
                Ue();
                for(var t1 = Ne.pendingUnobservations, e = 0; e < t1.length; e++){
                    var i = t1[e];
                    i.isPendingUnobservation = !1, 0 === i.observers_.size && (i.isBeingObserved && (i.isBeingObserved = !1, i.onBUO()), i instanceof ue && i.suspend_());
                }
                Ne.pendingUnobservations = [];
            }
        }
        function Oe(t1) {
            var e = Ne.trackingDerivation;
            return null !== e ? (e.runId_ !== t1.lastAccessedBy_ && (t1.lastAccessedBy_ = e.runId_, e.newObserving_[e.unboundDepsCount_++] = t1, !t1.isBeingObserved && Ne.trackingContext && (t1.isBeingObserved = !0, t1.onBO())), t1.isBeingObserved) : (0 === t1.observers_.size && Ne.inBatch > 0 && Ce(t1), !1);
        }
        function _e(t1) {
            t1.lowestObserverState_ !== he.STALE_ && (t1.lowestObserverState_ = he.STALE_, t1.observers_.forEach(function(t1) {
                t1.dependenciesState_ === he.UP_TO_DATE_ && t1.onBecomeStale_(), t1.dependenciesState_ = he.STALE_;
            }));
        }
        var je = function() {
            function t1(t1, e, i, n) {
                void 0 === t1 && (t1 = "Reaction"), this.name_ = void 0, this.onInvalidate_ = void 0, this.errorHandler_ = void 0, this.requiresObservable_ = void 0, this.observing_ = [], this.newObserving_ = [], this.dependenciesState_ = he.NOT_TRACKING_, this.runId_ = 0, this.unboundDepsCount_ = 0, this.flags_ = 0, this.isTracing_ = de.NONE, this.name_ = t1, this.onInvalidate_ = e, this.errorHandler_ = i, this.requiresObservable_ = n;
            }
            var e = t1.prototype;
            return e.onBecomeStale_ = function() {
                this.schedule_();
            }, e.schedule_ = function() {
                this.isScheduled || (this.isScheduled = !0, Ne.pendingReactions.push(this), Ue());
            }, e.runReaction_ = function() {
                if (!this.isDisposed) {
                    ze(), this.isScheduled = !1;
                    var t1 = Ne.trackingContext;
                    if (Ne.trackingContext = this, ge(this)) {
                        this.isTrackPending = !0;
                        try {
                            this.onInvalidate_();
                        } catch (t1) {
                            this.reportExceptionInDerivation_(t1);
                        }
                    }
                    Ne.trackingContext = t1, Le();
                }
            }, e.track = function(t1) {
                if (!this.isDisposed) {
                    ze(), this.isRunning = !0;
                    var e = Ne.trackingContext;
                    Ne.trackingContext = this;
                    var i = me(this, t1, void 0);
                    Ne.trackingContext = e, this.isRunning = !1, this.isTrackPending = !1, this.isDisposed && Me(this), Ae(i) && this.reportExceptionInDerivation_(i.cause), Le();
                }
            }, e.reportExceptionInDerivation_ = function(t1) {
                var e = this;
                if (this.errorHandler_) this.errorHandler_(t1, this);
                else {
                    if (Ne.disableErrorBoundaries) throw t1;
                    var i = "[mobx] uncaught error in '" + this + "'";
                    Ne.suppressReactionErrors || console.error(i, t1), Ne.globalReactionErrorHandlers.forEach(function(i) {
                        return i(t1, e);
                    });
                }
            }, e.dispose = function() {
                this.isDisposed || (this.isDisposed = !0, this.isRunning || (ze(), Me(this), Le()));
            }, e.getDisposer_ = function(t1) {
                var e = this, i = function i() {
                    e.dispose(), null == t1 || null == t1.removeEventListener || t1.removeEventListener("abort", i);
                };
                return null == t1 || null == t1.addEventListener || t1.addEventListener("abort", i), i[ot] = this, i;
            }, e.toString = function() {
                return "Reaction[" + this.name_ + "]";
            }, e.trace = function(t1) {
                void 0 === t1 && (t1 = !1);
            }, K(t1, [
                {
                    key: "isDisposed",
                    get: function() {
                        return W(this.flags_, t1.isDisposedMask_);
                    },
                    set: function(e) {
                        this.flags_ = X(this.flags_, t1.isDisposedMask_, e);
                    }
                },
                {
                    key: "isScheduled",
                    get: function() {
                        return W(this.flags_, t1.isScheduledMask_);
                    },
                    set: function(e) {
                        this.flags_ = X(this.flags_, t1.isScheduledMask_, e);
                    }
                },
                {
                    key: "isTrackPending",
                    get: function() {
                        return W(this.flags_, t1.isTrackPendingMask_);
                    },
                    set: function(e) {
                        this.flags_ = X(this.flags_, t1.isTrackPendingMask_, e);
                    }
                },
                {
                    key: "isRunning",
                    get: function() {
                        return W(this.flags_, t1.isRunningMask_);
                    },
                    set: function(e) {
                        this.flags_ = X(this.flags_, t1.isRunningMask_, e);
                    }
                },
                {
                    key: "diffValue",
                    get: function() {
                        return W(this.flags_, t1.diffValueMask_) ? 1 : 0;
                    },
                    set: function(e) {
                        this.flags_ = X(this.flags_, t1.diffValueMask_, 1 === e);
                    }
                }
            ]);
        }();
        je.isDisposedMask_ = 1, je.isScheduledMask_ = 2, je.isTrackPendingMask_ = 4, je.isRunningMask_ = 8, je.diffValueMask_ = 16;
        var Pe = 100, Re = function(t1) {
            return t1();
        };
        function Ue() {
            Ne.inBatch > 0 || Ne.isRunningReactions || Re(ke);
        }
        function ke() {
            Ne.isRunningReactions = !0;
            for(var t1 = Ne.pendingReactions, e = 0; t1.length > 0;){
                ++e === Pe && (console.error("[mobx] cycle in reaction: " + t1[0]), t1.splice(0));
                for(var i = t1.splice(0), n = 0, r = i.length; n < r; n++)i[n].runReaction_();
            }
            Ne.isRunningReactions = !1;
        }
        var Be = k("Reaction", je), Fe = "action", Qe = "autoAction", He = At(Fe), Ve = At("action.bound", {
            bound: !0
        }), Ge = At(Qe, {
            autoAction: !0
        }), Ye = At("autoAction.bound", {
            autoAction: !0,
            bound: !0
        });
        function We(t1) {
            return function(e, i) {
                return L(e) ? se(e.name || "<unnamed action>", e, t1) : L(i) ? se(e, i, t1) : st(i) ? (t1 ? Ge : He).decorate_20223_(e, i) : O(i) ? at(e, i, t1 ? Ge : He) : O(e) ? rt(At(t1 ? Qe : Fe, {
                    name: e,
                    autoAction: t1
                })) : void 0;
            };
        }
        var Xe = We(!1);
        Object.assign(Xe, He);
        var Ze = We(!0);
        function Je(t1) {
            return L(t1) && !0 === t1.isMobxAction;
        }
        Object.assign(Ze, Ge), Xe.bound = rt(Ve), Ze.bound = rt(Ye);
        var Ke = function(t1) {
            return t1();
        };
        var qe = "onBO", $e = "onBUO";
        function ti(t1, e, i) {
            return ei($e, t1, e, i);
        }
        function ei(t1, e, i, n) {
            var r = "function" == typeof n ? hn(e, i) : hn(e), a = L(n) ? n : i, s = t1 + "L";
            return r[s] ? r[s].add(a) : r[s] = new Set([
                a
            ]), function() {
                var t1 = r[s];
                t1 && (t1.delete(a), 0 === t1.size && delete r[s]);
            };
        }
        var ii = "always";
        function ni(t1) {
            !0 === t1.isolateGlobalState && function() {
                if ((Ne.pendingReactions.length || Ne.inBatch || Ne.isRunningReactions) && M(36), Se = !0, Ie) {
                    var t1 = v();
                    0 == --t1.__mobxInstanceCount && (t1.__mobxGlobals = void 0), Ne = new Ee;
                }
            }();
            var e, i, n = t1.useProxies, r = t1.enforceActions;
            if (void 0 !== n && (Ne.useProxies = n === ii || "never" !== n && "undefined" != typeof Proxy), "ifavailable" === n && (Ne.verifyProxies = !0), void 0 !== r) {
                var a = r === ii ? ii : "observed" === r;
                Ne.enforceActions = a, Ne.allowStateChanges = !0 !== a && a !== ii;
            }
            [
                "computedRequiresReaction",
                "reactionRequiresObservable",
                "observableRequiresReaction",
                "disableErrorBoundaries",
                "safeDescriptors"
            ].forEach(function(e) {
                e in t1 && (Ne[e] = !!t1[e]);
            }), Ne.allowStateReads = !Ne.observableRequiresReaction, t1.reactionScheduler && (e = t1.reactionScheduler, i = Re, Re = function(t1) {
                return e(function() {
                    return i(t1);
                });
            });
        }
        function ri(t1, e, i, n) {
            var r = Y(e);
            return fn(function() {
                var e = Xi(t1, n)[ot];
                H(r).forEach(function(t1) {
                    e.extend_(t1, r[t1], !i || !(t1 in i) || i[t1]);
                });
            }), t1;
        }
        function ai(t1) {
            var e, i = {
                name: t1.name_
            };
            return t1.observing_ && t1.observing_.length > 0 && (i.dependencies = (e = t1.observing_, Array.from(new Set(e))).map(ai)), i;
        }
        var si = 0;
        function oi() {
            this.message = "FLOW_CANCELLED";
        }
        oi.prototype = Object.create(Error.prototype);
        var li = vt("flow"), ci = vt("flow.bound", {
            bound: !0
        }), ui = Object.assign(function(t1, e) {
            if (st(e)) return li.decorate_20223_(t1, e);
            if (O(e)) return at(t1, e, li);
            var i = t1, n = i.name || "<unnamed flow>", r = function() {
                var t1, e = arguments, r = ++si, a = Xe(n + " - runid: " + r + " - init", i).apply(this, e), s = void 0, o = new Promise(function(e, i) {
                    var o = 0;
                    function l(t1) {
                        var e;
                        s = void 0;
                        try {
                            e = Xe(n + " - runid: " + r + " - yield " + o++, a.next).call(a, t1);
                        } catch (t1) {
                            return i(t1);
                        }
                        u(e);
                    }
                    function c(t1) {
                        var e;
                        s = void 0;
                        try {
                            e = Xe(n + " - runid: " + r + " - yield " + o++, a.throw).call(a, t1);
                        } catch (t1) {
                            return i(t1);
                        }
                        u(e);
                    }
                    function u(t1) {
                        if (!L(null == t1 ? void 0 : t1.then)) return t1.done ? e(t1.value) : (s = Promise.resolve(t1.value)).then(l, c);
                        t1.then(u, i);
                    }
                    t1 = i, l(void 0);
                });
                return o.cancel = Xe(n + " - runid: " + r + " - cancel", function() {
                    try {
                        s && hi(s);
                        var e = a.return(void 0), i = Promise.resolve(e.value);
                        i.then(z, z), hi(i), t1(new oi);
                    } catch (e) {
                        t1(e);
                    }
                }), o;
            };
            return r.isMobXFlow = !0, r;
        }, li);
        function hi(t1) {
            L(t1.cancel) && t1.cancel();
        }
        function di(t1) {
            return !0 === (null == t1 ? void 0 : t1.isMobXFlow);
        }
        function pi(t1) {
            return function(t1, e) {
                return !!t1 && (void 0 !== e ? !!Ki(t1) && t1[ot].values_.has(e) : Ki(t1) || !!t1[ot] || ct(t1) || Be(t1) || pe(t1));
            }(t1);
        }
        function fi(t1, e) {
            void 0 === e && (e = void 0), ze();
            try {
                return t1.apply(e);
            } finally{
                Le();
            }
        }
        function Ai(t1) {
            return t1[ot];
        }
        ui.bound = rt(ci);
        var gi = {
            has: function(t1, e) {
                return Ai(t1).has_(e);
            },
            get: function(t1, e) {
                return Ai(t1).get_(e);
            },
            set: function(t1, e, i) {
                var n;
                return !!O(e) && (null == (n = Ai(t1).set_(e, i, !0)) || n);
            },
            deleteProperty: function(t1, e) {
                var i;
                return !!O(e) && (null == (i = Ai(t1).delete_(e, !0)) || i);
            },
            defineProperty: function(t1, e, i) {
                var n;
                return null == (n = Ai(t1).defineProperty_(e, i)) || n;
            },
            ownKeys: function(t1) {
                return Ai(t1).ownKeys_();
            },
            preventExtensions: function(t1) {
                M(13);
            }
        };
        function mi(t1) {
            return void 0 !== t1.interceptors_ && t1.interceptors_.length > 0;
        }
        function Mi(t1, e) {
            var i = t1.interceptors_ || (t1.interceptors_ = []);
            return i.push(e), C(function() {
                var t1 = i.indexOf(e);
                -1 !== t1 && i.splice(t1, 1);
            });
        }
        function yi(t1, e) {
            var i = ve();
            try {
                for(var n = [].concat(t1.interceptors_ || []), r = 0, a = n.length; r < a && ((e = n[r](e)) && !e.type && M(14), e); r++);
                return e;
            } finally{
                xe(i);
            }
        }
        function vi(t1) {
            return void 0 !== t1.changeListeners_ && t1.changeListeners_.length > 0;
        }
        function xi(t1, e) {
            var i = t1.changeListeners_ || (t1.changeListeners_ = []);
            return i.push(e), C(function() {
                var t1 = i.indexOf(e);
                -1 !== t1 && i.splice(t1, 1);
            });
        }
        function wi(t1, e) {
            var i = ve(), n = t1.changeListeners_;
            if (n) {
                for(var r = 0, a = (n = n.slice()).length; r < a; r++)n[r](e);
                xe(i);
            }
        }
        var bi = Symbol("mobx-keys");
        function Ti(t1, e, i) {
            return j(t1) ? ri(t1, t1, e, i) : (fn(function() {
                var n = Xi(t1, i)[ot];
                if (!t1[bi]) {
                    var r = Object.getPrototypeOf(t1), a = new Set([].concat(H(t1), H(r)));
                    a.delete("constructor"), a.delete(ot), R(r, bi, a);
                }
                t1[bi].forEach(function(t1) {
                    return n.make_(t1, !e || !(t1 in e) || e[t1]);
                });
            }), t1);
        }
        var Ei = "splice", Ii = "update", Si = {
            get: function(t1, e) {
                var i = t1[ot];
                return e === ot ? i : "length" === e ? i.getArrayLength_() : "string" != typeof e || isNaN(e) ? G(Ci, e) ? Ci[e] : t1[e] : i.get_(parseInt(e));
            },
            set: function(t1, e, i) {
                var n = t1[ot];
                return "length" === e && n.setArrayLength_(i), "symbol" == typeof e || isNaN(e) ? t1[e] = i : n.set_(parseInt(e), i), !0;
            },
            preventExtensions: function() {
                M(15);
            }
        }, Ni = function() {
            function t1(t1, e, i, n) {
                void 0 === t1 && (t1 = "ObservableArray"), this.owned_ = void 0, this.legacyMode_ = void 0, this.atom_ = void 0, this.values_ = [], this.interceptors_ = void 0, this.changeListeners_ = void 0, this.enhancer_ = void 0, this.dehancer = void 0, this.proxy_ = void 0, this.lastKnownLength_ = 0, this.owned_ = i, this.legacyMode_ = n, this.atom_ = new lt(t1), this.enhancer_ = function(t1, i) {
                    return e(t1, i, "ObservableArray[..]");
                };
            }
            var e = t1.prototype;
            return e.dehanceValue_ = function(t1) {
                return void 0 !== this.dehancer ? this.dehancer(t1) : t1;
            }, e.dehanceValues_ = function(t1) {
                return void 0 !== this.dehancer && t1.length > 0 ? t1.map(this.dehancer) : t1;
            }, e.intercept_ = function(t1) {
                return Mi(this, t1);
            }, e.observe_ = function(t1, e) {
                return void 0 === e && (e = !1), e && t1({
                    observableKind: "array",
                    object: this.proxy_,
                    debugObjectName: this.atom_.name_,
                    type: "splice",
                    index: 0,
                    added: this.values_.slice(),
                    addedCount: this.values_.length,
                    removed: [],
                    removedCount: 0
                }), xi(this, t1);
            }, e.getArrayLength_ = function() {
                return this.atom_.reportObserved(), this.values_.length;
            }, e.setArrayLength_ = function(t1) {
                ("number" != typeof t1 || isNaN(t1) || t1 < 0) && M("Out of range: " + t1);
                var e = this.values_.length;
                if (t1 !== e) {
                    if (t1 > e) {
                        for(var i = new Array(t1 - e), n = 0; n < t1 - e; n++)i[n] = void 0;
                        this.spliceWithArray_(e, 0, i);
                    } else this.spliceWithArray_(t1, e - t1);
                }
            }, e.updateArrayLength_ = function(t1, e) {
                t1 !== this.lastKnownLength_ && M(16), this.lastKnownLength_ += e, this.legacyMode_ && e > 0 && cn(t1 + e + 1);
            }, e.spliceWithArray_ = function(t1, e, i) {
                var n = this;
                this.atom_;
                var r = this.values_.length;
                if (void 0 === t1 ? t1 = 0 : t1 > r ? t1 = r : t1 < 0 && (t1 = Math.max(0, r + t1)), e = 1 === arguments.length ? r - t1 : null == e ? 0 : Math.max(0, Math.min(e, r - t1)), void 0 === i && (i = E), mi(this)) {
                    var a = yi(this, {
                        object: this.proxy_,
                        type: Ei,
                        index: t1,
                        removedCount: e,
                        added: i
                    });
                    if (!a) return E;
                    e = a.removedCount, i = a.added;
                }
                if (i = 0 === i.length ? i : i.map(function(t1) {
                    return n.enhancer_(t1, void 0);
                }), this.legacyMode_) {
                    var s = i.length - e;
                    this.updateArrayLength_(r, s);
                }
                var o = this.spliceItemsIntoValues_(t1, e, i);
                return 0 === e && 0 === i.length || this.notifyArraySplice_(t1, i, o), this.dehanceValues_(o);
            }, e.spliceItemsIntoValues_ = function(t1, e, i) {
                var n;
                if (i.length < 1e4) return (n = this.values_).splice.apply(n, [
                    t1,
                    e
                ].concat(i));
                var r = this.values_.slice(t1, t1 + e), a = this.values_.slice(t1 + e);
                this.values_.length += i.length - e;
                for(var s = 0; s < i.length; s++)this.values_[t1 + s] = i[s];
                for(var o = 0; o < a.length; o++)this.values_[t1 + i.length + o] = a[o];
                return r;
            }, e.notifyArrayChildUpdate_ = function(t1, e, i) {
                var n = !this.owned_ && !1, r = vi(this), a = r || n ? {
                    observableKind: "array",
                    object: this.proxy_,
                    type: Ii,
                    debugObjectName: this.atom_.name_,
                    index: t1,
                    newValue: e,
                    oldValue: i
                } : null;
                this.atom_.reportChanged(), r && wi(this, a);
            }, e.notifyArraySplice_ = function(t1, e, i) {
                var n = !this.owned_ && !1, r = vi(this), a = r || n ? {
                    observableKind: "array",
                    object: this.proxy_,
                    debugObjectName: this.atom_.name_,
                    type: Ei,
                    index: t1,
                    removed: i,
                    added: e,
                    removedCount: i.length,
                    addedCount: e.length
                } : null;
                this.atom_.reportChanged(), r && wi(this, a);
            }, e.get_ = function(t1) {
                if (!(this.legacyMode_ && t1 >= this.values_.length)) return this.atom_.reportObserved(), this.dehanceValue_(this.values_[t1]);
                console.warn("[mobx] Out of bounds read: " + t1);
            }, e.set_ = function(t1, e) {
                var i = this.values_;
                if (this.legacyMode_ && t1 > i.length && M(17, t1, i.length), t1 < i.length) {
                    this.atom_;
                    var n = i[t1];
                    if (mi(this)) {
                        var r = yi(this, {
                            type: Ii,
                            object: this.proxy_,
                            index: t1,
                            newValue: e
                        });
                        if (!r) return;
                        e = r.newValue;
                    }
                    (e = this.enhancer_(e, n)) !== n && (i[t1] = e, this.notifyArrayChildUpdate_(t1, e, n));
                } else {
                    for(var a = new Array(t1 + 1 - i.length), s = 0; s < a.length - 1; s++)a[s] = void 0;
                    a[a.length - 1] = e, this.spliceWithArray_(i.length, 0, a);
                }
            }, t1;
        }();
        function Di(t1, e, i, n) {
            return void 0 === i && (i = "ObservableArray"), void 0 === n && (n = !1), D(), fn(function() {
                var r = new Ni(i, e, n, !1);
                U(r.values_, ot, r);
                var a = new Proxy(r.values_, Si);
                return r.proxy_ = a, t1 && t1.length && r.spliceWithArray_(0, 0, t1), a;
            });
        }
        var Ci = {
            clear: function() {
                return this.splice(0);
            },
            replace: function(t1) {
                var e = this[ot];
                return e.spliceWithArray_(0, e.values_.length, t1);
            },
            toJSON: function() {
                return this.slice();
            },
            splice: function(t1, e) {
                for(var i = arguments.length, n = new Array(i > 2 ? i - 2 : 0), r = 2; r < i; r++)n[r - 2] = arguments[r];
                var a = this[ot];
                switch(arguments.length){
                    case 0:
                        return [];
                    case 1:
                        return a.spliceWithArray_(t1);
                    case 2:
                        return a.spliceWithArray_(t1, e);
                }
                return a.spliceWithArray_(t1, e, n);
            },
            spliceWithArray: function(t1, e, i) {
                return this[ot].spliceWithArray_(t1, e, i);
            },
            push: function() {
                for(var t1 = this[ot], e = arguments.length, i = new Array(e), n = 0; n < e; n++)i[n] = arguments[n];
                return t1.spliceWithArray_(t1.values_.length, 0, i), t1.values_.length;
            },
            pop: function() {
                return this.splice(Math.max(this[ot].values_.length - 1, 0), 1)[0];
            },
            shift: function() {
                return this.splice(0, 1)[0];
            },
            unshift: function() {
                for(var t1 = this[ot], e = arguments.length, i = new Array(e), n = 0; n < e; n++)i[n] = arguments[n];
                return t1.spliceWithArray_(0, 0, i), t1.values_.length;
            },
            reverse: function() {
                return Ne.trackingDerivation && M(37, "reverse"), this.replace(this.slice().reverse()), this;
            },
            sort: function() {
                Ne.trackingDerivation && M(37, "sort");
                var t1 = this.slice();
                return t1.sort.apply(t1, arguments), this.replace(t1), this;
            },
            remove: function(t1) {
                var e = this[ot], i = e.dehanceValues_(e.values_).indexOf(t1);
                return i > -1 && (this.splice(i, 1), !0);
            }
        };
        function zi(t1, e) {
            "function" == typeof Array.prototype[t1] && (Ci[t1] = e(t1));
        }
        function Li(t1) {
            return function() {
                var e = this[ot];
                e.atom_.reportObserved();
                var i = e.dehanceValues_(e.values_);
                return i[t1].apply(i, arguments);
            };
        }
        function Oi(t1) {
            return function(e, i) {
                var n = this, r = this[ot];
                return r.atom_.reportObserved(), r.dehanceValues_(r.values_)[t1](function(t1, r) {
                    return e.call(i, t1, r, n);
                });
            };
        }
        function _i(t1) {
            return function() {
                var e = this, i = this[ot];
                i.atom_.reportObserved();
                var n = i.dehanceValues_(i.values_), r = arguments[0];
                return arguments[0] = function(t1, i, n) {
                    return r(t1, i, n, e);
                }, n[t1].apply(n, arguments);
            };
        }
        zi("at", Li), zi("concat", Li), zi("flat", Li), zi("includes", Li), zi("indexOf", Li), zi("join", Li), zi("lastIndexOf", Li), zi("slice", Li), zi("toString", Li), zi("toLocaleString", Li), zi("toSorted", Li), zi("toSpliced", Li), zi("with", Li), zi("every", Oi), zi("filter", Oi), zi("find", Oi), zi("findIndex", Oi), zi("findLast", Oi), zi("findLastIndex", Oi), zi("flatMap", Oi), zi("forEach", Oi), zi("map", Oi), zi("some", Oi), zi("toReversed", Oi), zi("reduce", _i), zi("reduceRight", _i);
        var ji = k("ObservableArrayAdministration", Ni);
        function Pi(t1) {
            return _(t1) && ji(t1[ot]);
        }
        var Ri = {}, Ui = "add", ki = "delete", Bi = function() {
            function t1(t1, e, i) {
                var n = this;
                void 0 === e && (e = dt), void 0 === i && (i = "ObservableMap"), this.enhancer_ = void 0, this.name_ = void 0, this[ot] = Ri, this.data_ = void 0, this.hasMap_ = void 0, this.keysAtom_ = void 0, this.interceptors_ = void 0, this.changeListeners_ = void 0, this.dehancer = void 0, this.enhancer_ = e, this.name_ = i, L(Map) || M(18), fn(function() {
                    n.keysAtom_ = ut("ObservableMap.keys()"), n.data_ = new Map, n.hasMap_ = new Map, t1 && n.merge(t1);
                });
            }
            var e = t1.prototype;
            return e.has_ = function(t1) {
                return this.data_.has(t1);
            }, e.has = function(t1) {
                var e = this;
                if (!Ne.trackingDerivation) return this.has_(t1);
                var i = this.hasMap_.get(t1);
                if (!i) {
                    var n = i = new ce(this.has_(t1), pt, "ObservableMap.key?", !1);
                    this.hasMap_.set(t1, n), ti(n, function() {
                        return e.hasMap_.delete(t1);
                    });
                }
                return i.get();
            }, e.set = function(t1, e) {
                var i = this.has_(t1);
                if (mi(this)) {
                    var n = yi(this, {
                        type: i ? Ii : Ui,
                        object: this,
                        newValue: e,
                        name: t1
                    });
                    if (!n) return this;
                    e = n.newValue;
                }
                return i ? this.updateValue_(t1, e) : this.addValue_(t1, e), this;
            }, e.delete = function(t1) {
                var e = this;
                if (this.keysAtom_, mi(this) && !yi(this, {
                    type: ki,
                    object: this,
                    name: t1
                })) return !1;
                if (this.has_(t1)) {
                    var i = vi(this), n = i ? {
                        observableKind: "map",
                        debugObjectName: this.name_,
                        type: ki,
                        object: this,
                        oldValue: this.data_.get(t1).value_,
                        name: t1
                    } : null;
                    return fi(function() {
                        var i;
                        e.keysAtom_.reportChanged(), null == (i = e.hasMap_.get(t1)) || i.setNewValue_(!1), e.data_.get(t1).setNewValue_(void 0), e.data_.delete(t1);
                    }), i && wi(this, n), !0;
                }
                return !1;
            }, e.updateValue_ = function(t1, e) {
                var i = this.data_.get(t1);
                if ((e = i.prepareNewValue_(e)) !== Ne.UNCHANGED) {
                    var n = vi(this), r = n ? {
                        observableKind: "map",
                        debugObjectName: this.name_,
                        type: Ii,
                        object: this,
                        oldValue: i.value_,
                        name: t1,
                        newValue: e
                    } : null;
                    i.setNewValue_(e), n && wi(this, r);
                }
            }, e.addValue_ = function(t1, e) {
                var i = this;
                this.keysAtom_, fi(function() {
                    var n, r = new ce(e, i.enhancer_, "ObservableMap.key", !1);
                    i.data_.set(t1, r), e = r.value_, null == (n = i.hasMap_.get(t1)) || n.setNewValue_(!0), i.keysAtom_.reportChanged();
                });
                var n = vi(this), r = n ? {
                    observableKind: "map",
                    debugObjectName: this.name_,
                    type: Ui,
                    object: this,
                    name: t1,
                    newValue: e
                } : null;
                n && wi(this, r);
            }, e.get = function(t1) {
                return this.has(t1) ? this.dehanceValue_(this.data_.get(t1).get()) : this.dehanceValue_(void 0);
            }, e.dehanceValue_ = function(t1) {
                return void 0 !== this.dehancer ? this.dehancer(t1) : t1;
            }, e.keys = function() {
                return this.keysAtom_.reportObserved(), this.data_.keys();
            }, e.values = function() {
                var t1 = this, e = this.keys();
                return yn({
                    next: function() {
                        var i = e.next(), n = i.done, r = i.value;
                        return {
                            done: n,
                            value: n ? void 0 : t1.get(r)
                        };
                    }
                });
            }, e.entries = function() {
                var t1 = this, e = this.keys();
                return yn({
                    next: function() {
                        var i = e.next(), n = i.done, r = i.value;
                        return {
                            done: n,
                            value: n ? void 0 : [
                                r,
                                t1.get(r)
                            ]
                        };
                    }
                });
            }, e[Symbol.iterator] = function() {
                return this.entries();
            }, e.forEach = function(t1, e) {
                for(var i, n = q(this); !(i = n()).done;){
                    var r = i.value, a = r[0], s = r[1];
                    t1.call(e, s, a, this);
                }
            }, e.merge = function(t1) {
                var e = this;
                return Fi(t1) && (t1 = new Map(t1)), fi(function() {
                    var i, n, r;
                    j(t1) ? (function(t1) {
                        var e = Object.keys(t1);
                        if (!Q) return e;
                        var i = Object.getOwnPropertySymbols(t1);
                        return i.length ? [].concat(e, i.filter(function(e) {
                            return T.propertyIsEnumerable.call(t1, e);
                        })) : e;
                    })(t1).forEach(function(i) {
                        return e.set(i, t1[i]);
                    }) : Array.isArray(t1) ? t1.forEach(function(t1) {
                        var i = t1[0], n = t1[1];
                        return e.set(i, n);
                    }) : B(t1) ? (i = t1, n = Object.getPrototypeOf(i), r = Object.getPrototypeOf(n), null !== Object.getPrototypeOf(r) && M(19, t1), t1.forEach(function(t1, i) {
                        return e.set(i, t1);
                    })) : null != t1 && M(20, t1);
                }), this;
            }, e.clear = function() {
                var t1 = this;
                fi(function() {
                    ye(function() {
                        for(var e, i = q(t1.keys()); !(e = i()).done;){
                            var n = e.value;
                            t1.delete(n);
                        }
                    });
                });
            }, e.replace = function(t1) {
                var e = this;
                return fi(function() {
                    for(var i, n = function(t1) {
                        if (B(t1) || Fi(t1)) return t1;
                        if (Array.isArray(t1)) return new Map(t1);
                        if (j(t1)) {
                            var e = new Map;
                            for(var i in t1)e.set(i, t1[i]);
                            return e;
                        }
                        return M(21, t1);
                    }(t1), r = new Map, a = !1, s = q(e.data_.keys()); !(i = s()).done;){
                        var o = i.value;
                        if (!n.has(o)) {
                            if (e.delete(o)) a = !0;
                            else {
                                var l = e.data_.get(o);
                                r.set(o, l);
                            }
                        }
                    }
                    for(var c, u = q(n.entries()); !(c = u()).done;){
                        var h = c.value, d = h[0], p = h[1], f = e.data_.has(d);
                        if (e.set(d, p), e.data_.has(d)) {
                            var A = e.data_.get(d);
                            r.set(d, A), f || (a = !0);
                        }
                    }
                    if (!a) {
                        if (e.data_.size !== r.size) e.keysAtom_.reportChanged();
                        else for(var g = e.data_.keys(), m = r.keys(), y = g.next(), v = m.next(); !y.done;){
                            if (y.value !== v.value) {
                                e.keysAtom_.reportChanged();
                                break;
                            }
                            y = g.next(), v = m.next();
                        }
                    }
                    e.data_ = r;
                }), this;
            }, e.toString = function() {
                return "[object ObservableMap]";
            }, e.toJSON = function() {
                return Array.from(this);
            }, e.observe_ = function(t1, e) {
                return xi(this, t1);
            }, e.intercept_ = function(t1) {
                return Mi(this, t1);
            }, K(t1, [
                {
                    key: "size",
                    get: function() {
                        return this.keysAtom_.reportObserved(), this.data_.size;
                    }
                },
                {
                    key: Symbol.toStringTag,
                    get: function() {
                        return "Map";
                    }
                }
            ]);
        }(), Fi = k("ObservableMap", Bi), Qi = {}, Hi = function() {
            function t1(t1, e, i) {
                var n = this;
                void 0 === e && (e = dt), void 0 === i && (i = "ObservableSet"), this.name_ = void 0, this[ot] = Qi, this.data_ = new Set, this.atom_ = void 0, this.changeListeners_ = void 0, this.interceptors_ = void 0, this.dehancer = void 0, this.enhancer_ = void 0, this.name_ = i, L(Set) || M(22), this.enhancer_ = function(t1, n) {
                    return e(t1, n, i);
                }, fn(function() {
                    n.atom_ = ut(n.name_), t1 && n.replace(t1);
                });
            }
            var e = t1.prototype;
            return e.dehanceValue_ = function(t1) {
                return void 0 !== this.dehancer ? this.dehancer(t1) : t1;
            }, e.clear = function() {
                var t1 = this;
                fi(function() {
                    ye(function() {
                        for(var e, i = q(t1.data_.values()); !(e = i()).done;){
                            var n = e.value;
                            t1.delete(n);
                        }
                    });
                });
            }, e.forEach = function(t1, e) {
                for(var i, n = q(this); !(i = n()).done;){
                    var r = i.value;
                    t1.call(e, r, r, this);
                }
            }, e.add = function(t1) {
                var e = this;
                if (this.atom_, mi(this) && !yi(this, {
                    type: Ui,
                    object: this,
                    newValue: t1
                })) return this;
                if (!this.has(t1)) {
                    fi(function() {
                        e.data_.add(e.enhancer_(t1, void 0)), e.atom_.reportChanged();
                    });
                    var i = vi(this), n = i ? {
                        observableKind: "set",
                        debugObjectName: this.name_,
                        type: Ui,
                        object: this,
                        newValue: t1
                    } : null;
                    i && wi(this, n);
                }
                return this;
            }, e.delete = function(t1) {
                var e = this;
                if (mi(this) && !yi(this, {
                    type: ki,
                    object: this,
                    oldValue: t1
                })) return !1;
                if (this.has(t1)) {
                    var i = vi(this), n = i ? {
                        observableKind: "set",
                        debugObjectName: this.name_,
                        type: ki,
                        object: this,
                        oldValue: t1
                    } : null;
                    return fi(function() {
                        e.atom_.reportChanged(), e.data_.delete(t1);
                    }), i && wi(this, n), !0;
                }
                return !1;
            }, e.has = function(t1) {
                return this.atom_.reportObserved(), this.data_.has(this.dehanceValue_(t1));
            }, e.entries = function() {
                var t1 = 0, e = Array.from(this.keys()), i = Array.from(this.values());
                return yn({
                    next: function() {
                        var n = t1;
                        return t1 += 1, n < i.length ? {
                            value: [
                                e[n],
                                i[n]
                            ],
                            done: !1
                        } : {
                            done: !0
                        };
                    }
                });
            }, e.keys = function() {
                return this.values();
            }, e.values = function() {
                this.atom_.reportObserved();
                var t1 = this, e = 0, i = Array.from(this.data_.values());
                return yn({
                    next: function() {
                        return e < i.length ? {
                            value: t1.dehanceValue_(i[e++]),
                            done: !1
                        } : {
                            done: !0
                        };
                    }
                });
            }, e.intersection = function(t1) {
                return F(t1) ? t1.intersection(this) : new Set(this).intersection(t1);
            }, e.union = function(t1) {
                return F(t1) ? t1.union(this) : new Set(this).union(t1);
            }, e.difference = function(t1) {
                return new Set(this).difference(t1);
            }, e.symmetricDifference = function(t1) {
                return F(t1) ? t1.symmetricDifference(this) : new Set(this).symmetricDifference(t1);
            }, e.isSubsetOf = function(t1) {
                return new Set(this).isSubsetOf(t1);
            }, e.isSupersetOf = function(t1) {
                return new Set(this).isSupersetOf(t1);
            }, e.isDisjointFrom = function(t1) {
                return F(t1) ? t1.isDisjointFrom(this) : new Set(this).isDisjointFrom(t1);
            }, e.replace = function(t1) {
                var e = this;
                return Vi(t1) && (t1 = new Set(t1)), fi(function() {
                    Array.isArray(t1) || F(t1) ? (e.clear(), t1.forEach(function(t1) {
                        return e.add(t1);
                    })) : null != t1 && M("Cannot initialize set from " + t1);
                }), this;
            }, e.observe_ = function(t1, e) {
                return xi(this, t1);
            }, e.intercept_ = function(t1) {
                return Mi(this, t1);
            }, e.toJSON = function() {
                return Array.from(this);
            }, e.toString = function() {
                return "[object ObservableSet]";
            }, e[Symbol.iterator] = function() {
                return this.values();
            }, K(t1, [
                {
                    key: "size",
                    get: function() {
                        return this.atom_.reportObserved(), this.data_.size;
                    }
                },
                {
                    key: Symbol.toStringTag,
                    get: function() {
                        return "Set";
                    }
                }
            ]);
        }(), Vi = k("ObservableSet", Hi), Gi = Object.create(null), Yi = "remove", Wi = function() {
            function t1(t1, e, i, n) {
                void 0 === e && (e = new Map), void 0 === n && (n = _t), this.target_ = void 0, this.values_ = void 0, this.name_ = void 0, this.defaultAnnotation_ = void 0, this.keysAtom_ = void 0, this.changeListeners_ = void 0, this.interceptors_ = void 0, this.proxy_ = void 0, this.isPlainObject_ = void 0, this.appliedAnnotations_ = void 0, this.pendingKeys_ = void 0, this.target_ = t1, this.values_ = e, this.name_ = i, this.defaultAnnotation_ = n, this.keysAtom_ = new lt("ObservableObject.keys"), this.isPlainObject_ = j(this.target_);
            }
            var e = t1.prototype;
            return e.getObservablePropValue_ = function(t1) {
                return this.values_.get(t1).get();
            }, e.setObservablePropValue_ = function(t1, e) {
                var i = this.values_.get(t1);
                if (i instanceof ue) return i.set(e), !0;
                if (mi(this)) {
                    var n = yi(this, {
                        type: Ii,
                        object: this.proxy_ || this.target_,
                        name: t1,
                        newValue: e
                    });
                    if (!n) return null;
                    e = n.newValue;
                }
                if ((e = i.prepareNewValue_(e)) !== Ne.UNCHANGED) {
                    var r = vi(this), a = r ? {
                        type: Ii,
                        observableKind: "object",
                        debugObjectName: this.name_,
                        object: this.proxy_ || this.target_,
                        oldValue: i.value_,
                        name: t1,
                        newValue: e
                    } : null;
                    i.setNewValue_(e), r && wi(this, a);
                }
                return !0;
            }, e.get_ = function(t1) {
                return Ne.trackingDerivation && !G(this.target_, t1) && this.has_(t1), this.target_[t1];
            }, e.set_ = function(t1, e, i) {
                return void 0 === i && (i = !1), G(this.target_, t1) ? this.values_.has(t1) ? this.setObservablePropValue_(t1, e) : i ? Reflect.set(this.target_, t1, e) : (this.target_[t1] = e, !0) : this.extend_(t1, {
                    value: e,
                    enumerable: !0,
                    writable: !0,
                    configurable: !0
                }, this.defaultAnnotation_, i);
            }, e.has_ = function(t1) {
                if (!Ne.trackingDerivation) return t1 in this.target_;
                this.pendingKeys_ || (this.pendingKeys_ = new Map);
                var e = this.pendingKeys_.get(t1);
                return e || (e = new ce(t1 in this.target_, pt, "ObservableObject.key?", !1), this.pendingKeys_.set(t1, e)), e.get();
            }, e.make_ = function(t1, e) {
                if (!0 === e && (e = this.defaultAnnotation_), !1 !== e) {
                    if (!(t1 in this.target_)) {
                        var i;
                        if (null != (i = this.target_[nt]) && i[t1]) return;
                        M(1, e.annotationType_, this.name_ + "." + t1.toString());
                    }
                    for(var n = this.target_; n && n !== T;){
                        var r = w(n, t1);
                        if (r) {
                            var a = e.make_(this, t1, r, n);
                            if (0 === a) return;
                            if (1 === a) break;
                        }
                        n = Object.getPrototypeOf(n);
                    }
                    qi(this, 0, t1);
                }
            }, e.extend_ = function(t1, e, i, n) {
                if (void 0 === n && (n = !1), !0 === i && (i = this.defaultAnnotation_), !1 === i) return this.defineProperty_(t1, e, n);
                var r = i.extend_(this, t1, e, n);
                return r && qi(this, 0, t1), r;
            }, e.defineProperty_ = function(t1, e, i) {
                void 0 === i && (i = !1), this.keysAtom_;
                try {
                    ze();
                    var n = this.delete_(t1);
                    if (!n) return n;
                    if (mi(this)) {
                        var r = yi(this, {
                            object: this.proxy_ || this.target_,
                            name: t1,
                            type: Ui,
                            newValue: e.value
                        });
                        if (!r) return null;
                        var a = r.newValue;
                        e.value !== a && (e = $({}, e, {
                            value: a
                        }));
                    }
                    if (i) {
                        if (!Reflect.defineProperty(this.target_, t1, e)) return !1;
                    } else b(this.target_, t1, e);
                    this.notifyPropertyAddition_(t1, e.value);
                } finally{
                    Le();
                }
                return !0;
            }, e.defineObservableProperty_ = function(t1, e, i, n) {
                void 0 === n && (n = !1), this.keysAtom_;
                try {
                    ze();
                    var r = this.delete_(t1);
                    if (!r) return r;
                    if (mi(this)) {
                        var a = yi(this, {
                            object: this.proxy_ || this.target_,
                            name: t1,
                            type: Ui,
                            newValue: e
                        });
                        if (!a) return null;
                        e = a.newValue;
                    }
                    var s = Ji(t1), o = {
                        configurable: !Ne.safeDescriptors || this.isPlainObject_,
                        enumerable: !0,
                        get: s.get,
                        set: s.set
                    };
                    if (n) {
                        if (!Reflect.defineProperty(this.target_, t1, o)) return !1;
                    } else b(this.target_, t1, o);
                    var l = new ce(e, i, "ObservableObject.key", !1);
                    this.values_.set(t1, l), this.notifyPropertyAddition_(t1, l.value_);
                } finally{
                    Le();
                }
                return !0;
            }, e.defineComputedProperty_ = function(t1, e, i) {
                void 0 === i && (i = !1), this.keysAtom_;
                try {
                    ze();
                    var n = this.delete_(t1);
                    if (!n) return n;
                    if (mi(this) && !yi(this, {
                        object: this.proxy_ || this.target_,
                        name: t1,
                        type: Ui,
                        newValue: void 0
                    })) return null;
                    e.name || (e.name = "ObservableObject.key"), e.context = this.proxy_ || this.target_;
                    var r = Ji(t1), a = {
                        configurable: !Ne.safeDescriptors || this.isPlainObject_,
                        enumerable: !1,
                        get: r.get,
                        set: r.set
                    };
                    if (i) {
                        if (!Reflect.defineProperty(this.target_, t1, a)) return !1;
                    } else b(this.target_, t1, a);
                    this.values_.set(t1, new ue(e)), this.notifyPropertyAddition_(t1, void 0);
                } finally{
                    Le();
                }
                return !0;
            }, e.delete_ = function(t1, e) {
                if (void 0 === e && (e = !1), this.keysAtom_, !G(this.target_, t1)) return !0;
                if (mi(this) && !yi(this, {
                    object: this.proxy_ || this.target_,
                    name: t1,
                    type: Yi
                })) return null;
                try {
                    var i;
                    ze();
                    var n, r = vi(this), a = this.values_.get(t1), s = void 0;
                    if (!a && r && (s = null == (n = w(this.target_, t1)) ? void 0 : n.value), e) {
                        if (!Reflect.deleteProperty(this.target_, t1)) return !1;
                    } else delete this.target_[t1];
                    if (a && (this.values_.delete(t1), a instanceof ce && (s = a.value_), _e(a)), this.keysAtom_.reportChanged(), null == (i = this.pendingKeys_) || null == (i = i.get(t1)) || i.set(t1 in this.target_), r) {
                        var o = {
                            type: Yi,
                            observableKind: "object",
                            object: this.proxy_ || this.target_,
                            debugObjectName: this.name_,
                            oldValue: s,
                            name: t1
                        };
                        r && wi(this, o);
                    }
                } finally{
                    Le();
                }
                return !0;
            }, e.observe_ = function(t1, e) {
                return xi(this, t1);
            }, e.intercept_ = function(t1) {
                return Mi(this, t1);
            }, e.notifyPropertyAddition_ = function(t1, e) {
                var i, n = vi(this);
                if (n) {
                    var r = n ? {
                        type: Ui,
                        observableKind: "object",
                        debugObjectName: this.name_,
                        object: this.proxy_ || this.target_,
                        name: t1,
                        newValue: e
                    } : null;
                    n && wi(this, r);
                }
                null == (i = this.pendingKeys_) || null == (i = i.get(t1)) || i.set(!0), this.keysAtom_.reportChanged();
            }, e.ownKeys_ = function() {
                return this.keysAtom_.reportObserved(), H(this.target_);
            }, e.keys_ = function() {
                return this.keysAtom_.reportObserved(), Object.keys(this.target_);
            }, t1;
        }();
        function Xi(t1, e) {
            var i;
            if (G(t1, ot)) return t1;
            var n = null != (i = null == e ? void 0 : e.name) ? i : "ObservableObject", r = new Wi(t1, new Map, String(n), function(t1) {
                var e;
                return t1 ? null != (e = t1.defaultDecorator) ? e : jt(t1) : void 0;
            }(e));
            return R(t1, ot, r), t1;
        }
        var Zi = k("ObservableObjectAdministration", Wi);
        function Ji(t1) {
            return Gi[t1] || (Gi[t1] = {
                get: function() {
                    return this[ot].getObservablePropValue_(t1);
                },
                set: function(e) {
                    return this[ot].setObservablePropValue_(t1, e);
                }
            });
        }
        function Ki(t1) {
            return !!_(t1) && Zi(t1[ot]);
        }
        function qi(t1, e, i) {
            var n;
            null == (n = t1.target_[nt]) || delete n[i];
        }
        var $i, tn, en = on(0), nn = function() {
            var t1 = !1, e = {};
            return Object.defineProperty(e, "0", {
                set: function() {
                    t1 = !0;
                }
            }), Object.create(e)[0] = 1, !1 === t1;
        }(), rn = 0, an = function() {};
        $i = an, tn = Array.prototype, Object.setPrototypeOf ? Object.setPrototypeOf($i.prototype, tn) : void 0 !== $i.prototype.__proto__ ? $i.prototype.__proto__ = tn : $i.prototype = tn;
        var sn = function(t1) {
            function e(e, i, n, r) {
                var a;
                return void 0 === n && (n = "ObservableArray"), void 0 === r && (r = !1), a = t1.call(this) || this, fn(function() {
                    var t1 = new Ni(n, i, r, !0);
                    t1.proxy_ = a, U(a, ot, t1), e && e.length && a.spliceWithArray(0, 0, e), nn && Object.defineProperty(a, "0", en);
                }), a;
            }
            tt(e, t1);
            var i = e.prototype;
            return i.concat = function() {
                this[ot].atom_.reportObserved();
                for(var t1 = arguments.length, e = new Array(t1), i = 0; i < t1; i++)e[i] = arguments[i];
                return Array.prototype.concat.apply(this.slice(), e.map(function(t1) {
                    return Pi(t1) ? t1.slice() : t1;
                }));
            }, i[Symbol.iterator] = function() {
                var t1 = this, e = 0;
                return yn({
                    next: function() {
                        return e < t1.length ? {
                            value: t1[e++],
                            done: !1
                        } : {
                            done: !0,
                            value: void 0
                        };
                    }
                });
            }, K(e, [
                {
                    key: "length",
                    get: function() {
                        return this[ot].getArrayLength_();
                    },
                    set: function(t1) {
                        this[ot].setArrayLength_(t1);
                    }
                },
                {
                    key: Symbol.toStringTag,
                    get: function() {
                        return "Array";
                    }
                }
            ]);
        }(an);
        function on(t1) {
            return {
                enumerable: !1,
                configurable: !0,
                get: function() {
                    return this[ot].get_(t1);
                },
                set: function(e) {
                    this[ot].set_(t1, e);
                }
            };
        }
        function ln(t1) {
            b(sn.prototype, "" + t1, on(t1));
        }
        function cn(t1) {
            if (t1 > rn) {
                for(var e = rn; e < t1 + 100; e++)ln(e);
                rn = t1;
            }
        }
        function un(t1, e, i) {
            return new sn(t1, e, i);
        }
        function hn(t1, e) {
            if ("object" == typeof t1 && null !== t1) {
                if (Pi(t1)) return void 0 !== e && M(23), t1[ot].atom_;
                if (Vi(t1)) return t1.atom_;
                if (Fi(t1)) {
                    if (void 0 === e) return t1.keysAtom_;
                    var i = t1.data_.get(e) || t1.hasMap_.get(e);
                    return i || M(25, e, pn(t1)), i;
                }
                if (Ki(t1)) {
                    if (!e) return M(26);
                    var n = t1[ot].values_.get(e);
                    return n || M(27, e, pn(t1)), n;
                }
                if (ct(t1) || pe(t1) || Be(t1)) return t1;
            } else if (L(t1) && Be(t1[ot])) return t1[ot];
            M(28);
        }
        function dn(t1, e) {
            return t1 || M(29), void 0 !== e ? dn(hn(t1, e)) : ct(t1) || pe(t1) || Be(t1) || Fi(t1) || Vi(t1) ? t1 : t1[ot] ? t1[ot] : void M(24, t1);
        }
        function pn(t1, e) {
            var i;
            if (void 0 !== e) i = hn(t1, e);
            else {
                if (Je(t1)) return t1.name;
                i = Ki(t1) || Fi(t1) || Vi(t1) ? dn(t1) : hn(t1);
            }
            return i.name_;
        }
        function fn(t1) {
            var e = ve(), i = oe(!0);
            ze();
            try {
                return t1();
            } finally{
                Le(), le(i), xe(e);
            }
        }
        Object.entries(Ci).forEach(function(t1) {
            var e = t1[0], i = t1[1];
            "concat" !== e && R(sn.prototype, e, i);
        }), cn(1e3);
        var An = T.toString;
        function gn(t1, e, i) {
            return void 0 === i && (i = -1), mn(t1, e, i);
        }
        function mn(t1, e, i, n, r) {
            if (t1 === e) return 0 !== t1 || 1 / t1 == 1 / e;
            if (null == t1 || null == e) return !1;
            if (t1 != t1) return e != e;
            var a = typeof t1;
            if ("function" !== a && "object" !== a && "object" != typeof e) return !1;
            var s = An.call(t1);
            if (s !== An.call(e)) return !1;
            switch(s){
                case "[object RegExp]":
                case "[object String]":
                    return "" + t1 == "" + e;
                case "[object Number]":
                    return +t1 != +t1 ? +e != +e : 0 == +t1 ? 1 / +t1 == 1 / e : +t1 == +e;
                case "[object Date]":
                case "[object Boolean]":
                    return +t1 == +e;
                case "[object Symbol]":
                    return "undefined" != typeof Symbol && Symbol.valueOf.call(t1) === Symbol.valueOf.call(e);
                case "[object Map]":
                case "[object Set]":
                    i >= 0 && i++;
            }
            t1 = Mn(t1), e = Mn(e);
            var o = "[object Array]" === s;
            if (!o) {
                if ("object" != typeof t1 || "object" != typeof e) return !1;
                var l = t1.constructor, c = e.constructor;
                if (l !== c && !(L(l) && l instanceof l && L(c) && c instanceof c) && "constructor" in t1 && "constructor" in e) return !1;
            }
            if (0 === i) return !1;
            i < 0 && (i = -1), r = r || [];
            for(var u = (n = n || []).length; u--;)if (n[u] === t1) return r[u] === e;
            if (n.push(t1), r.push(e), o) {
                if ((u = t1.length) !== e.length) return !1;
                for(; u--;)if (!mn(t1[u], e[u], i - 1, n, r)) return !1;
            } else {
                var h, d = Object.keys(t1);
                if (u = d.length, Object.keys(e).length !== u) return !1;
                for(; u--;)if (!G(e, h = d[u]) || !mn(t1[h], e[h], i - 1, n, r)) return !1;
            }
            return n.pop(), r.pop(), !0;
        }
        function Mn(t1) {
            return Pi(t1) ? t1.slice() : B(t1) || Fi(t1) || F(t1) || Vi(t1) ? Array.from(t1.entries()) : t1;
        }
        function yn(t1) {
            return t1[Symbol.iterator] = vn, t1;
        }
        function vn() {
            return this;
        }
        function xn(t1, e, i) {
            return (e = function(t1) {
                var e = function(t1) {
                    if ("object" != typeof t1 || !t1) return t1;
                    var e = t1[Symbol.toPrimitive];
                    if (void 0 !== e) {
                        var i = e.call(t1, "string");
                        if ("object" != typeof i) return i;
                        throw new TypeError("@@toPrimitive must return a primitive value.");
                    }
                    return String(t1);
                }(t1);
                return "symbol" == typeof e ? e : e + "";
            }(e)) in t1 ? Object.defineProperty(t1, e, {
                value: i,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : t1[e] = i, t1;
        }
        [
            "Symbol",
            "Map",
            "Set"
        ].forEach(function(t1) {
            void 0 === v()[t1] && M("MobX requires global '" + t1 + "' to be available or polyfilled");
        }), "object" == typeof __MOBX_DEVTOOLS_GLOBAL_HOOK__ && __MOBX_DEVTOOLS_GLOBAL_HOOK__.injectMobx({
            spy: function(t1) {
                return console.warn("[mobx.spy] Is a no-op in production builds"), function() {};
            },
            extras: {
                getDebugName: pn
            },
            $mobx: ot
        }), ni({
            useProxies: "never"
        });
        const wn = class {
            constructor(t1){
                xn(this, "API_URL", null), xn(this, "getBrandingData", (t1)=>t1 ? {
                        name: t1.company_name,
                        url: t1.company_url
                    } : null), xn(this, "getParsedData", async (t1)=>{
                    var e, i;
                    const n = await this.loadJson(t1.json.value), r = this.getBrandingData(t1.widget_branding), a = t1.original_plans_img || [], s = t1.styled_plan_img || [], o = t1.floors.map((t1, e)=>{
                        var i, n;
                        return {
                            ...t1,
                            original_plan_img: null !== (i = null !== (n = s[e]) && void 0 !== n ? n : a[e]) && void 0 !== i ? i : null
                        };
                    }), l = t1.capabilities;
                    return {
                        raw: t1,
                        parsed: {
                            locale: (null === (e = t1.widget_branding) || void 0 === e ? void 0 : e.widget_language) || "en",
                            logo: (null === (i = t1.widget_branding) || void 0 === i ? void 0 : i.logo_path) || null,
                            floors: o,
                            branding: r,
                            json: n,
                            capabilities: l
                        }
                    };
                }), xn(this, "loadFurnitureData", async ()=>{
                    const t1 = "".concat(this.API_URL, "/api/furniture"), e = await fetch(t1);
                    return await e.json();
                }), xn(this, "loadCrmWidgetData", async (t1)=>{
                    const e = "".concat(this.API_URL, "/api/crm/plans/").concat(t1, "/widget"), i = await fetch(e, {
                        headers: {
                            "Widget-Version": "3.0.2"
                        }
                    }), n = await i.json();
                    return this.getParsedData(n);
                }), xn(this, "loadWidgetData", async (t1)=>{
                    const e = "".concat(this.API_URL, "/api/plans/").concat(t1, "/v3/widget"), i = await fetch(e, {
                        headers: {
                            "Widget-Version": "3.0.2"
                        }
                    }), n = await i.json();
                    return this.getParsedData(n);
                }), xn(this, "loadEditorData", async (t1, e)=>{
                    const i = "".concat(this.API_URL, "/api/plans/").concat(t1, "/editor?token=").concat(e), n = await fetch(i);
                    return await n.json();
                }), xn(this, "loadPanoramaData", async (t1)=>{
                    const e = "".concat(this.API_URL, "/api/plans/").concat(t1, "/panorama"), i = await fetch(e);
                    return await i.json();
                }), xn(this, "loadJson", async (t1)=>{
                    const e = await fetch(t1);
                    return await e.json();
                }), Ti(this), this.API_URL = t1;
            }
        }, bn = JSON.parse('{"create-points":"\u0421\u043E\u0437\u0434\u0430\u0432\u0430\u0439\u0442\u0435 \u0442\u043E\u0447\u043A\u0438","delete-points":"\u0423\u0434\u0430\u043B\u044F\u0439\u0442\u0435 \u0442\u043E\u0447\u043A\u0438","research-plan":"\u0418\u0441\u0441\u043B\u0435\u0434\u043E\u0432\u0430\u0442\u044C \u043F\u043B\u0430\u043D\u0438\u0440\u043E\u0432\u043A\u0443","rotate-plan":"\u0412\u0440\u0430\u0449\u0430\u0442\u044C \u043F\u043B\u0430\u043D\u0438\u0440\u043E\u0432\u043A\u0443","ok":"\u041E\u043A","made-by-link":"https://hart-estate.ru/","made-by-text":"hart-estate.ru","instructions-hint-text":"","floor":"$0 \u044D\u0442\u0430\u0436"}'), Tn = JSON.parse('{"create-points":"Create a point","delete-points":"Remove point","research-plan":"Research plan","rotate-plan":"Rotate plan","ok":"Ok","made-by-link":"https://getfloorplan.com/","made-by-text":"getfloorplan.com","instructions-hint-text":"","floor":"$0 floor","floorNumberEndings":{"1":"st","2":"nd","3":"d","rest":"th"}}'), En = JSON.parse('{"research-plan":"klicken","rotate-plan":"drehen","ok":"Ok","made-by-link":"","made-by-text":"","instructions-hint-text":"","floor":"$0 boden"}'), In = JSON.parse('{"research-plan":"Explora el dise\xf1o","rotate-plan":"Girar dise\xf1o","rotate":"Comenzar","stop":"Detener","plan":"Disposici\xf3n","off":"Apagar","on":"Encender","ok":"Ok","menu":"Men\xfa","wasd":"WASD","view-from-above":"Vista desde arriba","free-camera":"Revisi\xf3n gratuita","shadows":"Oscuridad","hide-walls":"Ocultar paredes","show-walls":"Mostrar paredes","hide-doors":"Ocultar puertas","show-doors":"Mostrar puertas","material":"Material","texture":"Textura","color":"Color","wall-color":"Color de la pared","wall-texture":"Textura de la pared","upload-wall-texture":"Textura de la pared de carga","made-by-link":"","made-by-text":"","instructions-hint-text":"","floor":"$0 piso"}'), Sn = JSON.parse('{"create-points":"\u8A08\u6E2C\u958B\u59CB","delete-points":"\u78BA\u5B9A","research-plan":"\u30BF\u30C3\u30D7\u3057\u3066\u79FB\u52D5","rotate-plan":"\u30C9\u30E9\u30C3\u30B0\u3067\u79FB\u52D5","ok":"Ok","made-by-link":"","made-by-text":"","instructions-hint-text":"","floor":"$0 \u968E"}');
        function Nn(t1, e, i) {
            return (e = function(t1) {
                var e = function(t1) {
                    if ("object" != typeof t1 || !t1) return t1;
                    var e = t1[Symbol.toPrimitive];
                    if (void 0 !== e) {
                        var i = e.call(t1, "string");
                        if ("object" != typeof i) return i;
                        throw new TypeError("@@toPrimitive must return a primitive value.");
                    }
                    return String(t1);
                }(t1);
                return "symbol" == typeof e ? e : e + "";
            }(e)) in t1 ? Object.defineProperty(t1, e, {
                value: i,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : t1[e] = i, t1;
        }
        ni({
            useProxies: "never"
        });
        const Dn = new class {
            constructor(){
                Nn(this, "availableLocales", [
                    "ru",
                    "en",
                    "de",
                    "es",
                    "ja"
                ]), Nn(this, "locales", {
                    ru: bn,
                    en: Tn,
                    de: En,
                    es: In,
                    ja: Sn
                }), Nn(this, "currentLocale", "en"), Nn(this, "getLocaleText", (t1)=>this.localeData[t1]), Nn(this, "setCurrentLocale", (t1)=>{
                    this.availableLocales.some((e)=>e === t1) && (this.currentLocale = t1);
                }), Ti(this);
            }
            get localeData() {
                return this.locales[this.currentLocale];
            }
        };
        function Cn(t1, e, i) {
            return (e = function(t1) {
                var e = function(t1) {
                    if ("object" != typeof t1 || !t1) return t1;
                    var e = t1[Symbol.toPrimitive];
                    if (void 0 !== e) {
                        var i = e.call(t1, "string");
                        if ("object" != typeof i) return i;
                        throw new TypeError("@@toPrimitive must return a primitive value.");
                    }
                    return String(t1);
                }(t1);
                return "symbol" == typeof e ? e : e + "";
            }(e)) in t1 ? Object.defineProperty(t1, e, {
                value: i,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : t1[e] = i, t1;
        }
        ni({
            useProxies: "never"
        });
        const zn = new class {
            constructor(){
                Cn(this, "controlsVisible", !0), Cn(this, "currentFloorIndex", 0), Cn(this, "configParams", null), Cn(this, "listeners", {
                    resize: []
                }), Ti(this);
            }
            get primaryCameraPointId() {
                var t1;
                if (!this.config.json) return null;
                const e = this.config.json.Floors[this.currentFloorIndex];
                if (this.config.primaryCameraPointId && e.CameraPoints.some((t1)=>{
                    let { ID: e } = t1;
                    return e === this.config.primaryCameraPointId;
                })) return this.config.primaryCameraPointId;
                const i = e.PrimaryCameraPointId || null, n = (null === (t1 = this.config.json.Meta) || void 0 === t1 ? void 0 : t1.PrimaryCameraPointId) || null;
                return i || n;
            }
            get initialPanoramaRoomId() {
                if (!this.config.json) return null;
                const { Rooms: t1 } = this.config.json.Floors[this.currentFloorIndex].Units[0], e = [
                    ...t1
                ].sort((t1, e)=>e.Area - t1.Area), i = e.find((t1)=>{
                    let { Type: e } = t1;
                    return "Living" === e;
                }), n = e[0];
                return (null == i ? void 0 : i.ID) || (null == n ? void 0 : n.ID) || null;
            }
            get config() {
                return this.getFloorConfig(this.currentFloorIndex);
            }
            get prevFloorIndex() {
                const t1 = this.currentFloorIndex - 1;
                return t1 < 0 ? this.configParams.floors.length - 1 : t1;
            }
            get nextFloorIndex() {
                return (this.currentFloorIndex + 1) % this.configParams.floors.length;
            }
            get dictionaryOverrides() {
                return this.configParams.dictionaryOverrides;
            }
            get autoRotatePanarama() {
                return this.configParams.autoRotate;
            }
            get instructionVisible() {
                return this.configParams.instructionVisible;
            }
            get scales() {
                return this.config.scales;
            }
            isCapable(t1) {
                var e;
                return Boolean(null === (e = this.config.capabilities) || void 0 === e || null === (e = e[t1]) || void 0 === e ? void 0 : e.enabled);
            }
            getFloorConfig(t1) {
                const e = this.getFloorParamByKey("original_plan_img", t1), i = this.getFloorParamByKey("styled_plan_img", t1), n = this.getFloorParamByKey("original_plans_img", t1), r = this.getFloorParamByKey("top_view_img", t1), a = this.getFloorParamByKey("panorama", t1), s = this.getFloorParamByKey("rotate", t1);
                return {
                    ...this.configParams,
                    originalPlans: n,
                    planImage: i || e,
                    rotationData: s,
                    panoramaData: a,
                    topViewImage: r
                };
            }
            setCurrentFloorIndex(t1) {
                this.currentFloorIndex = t1;
            }
            setPrevFloorIndex() {
                this.setCurrentFloorIndex(this.prevFloorIndex);
            }
            setNextFloorIndex() {
                this.setCurrentFloorIndex(this.nextFloorIndex);
            }
            getFloorParamByKey(t1, e) {
                return this.configParams.floors[e][t1];
            }
            isTabIncluded(t1) {
                return this.config.tabs.find((e)=>e === t1);
            }
            setConfig(t1) {
                this.configParams = t1, Dn.setCurrentLocale(t1.locale), this.dispatchEvent("resize", {
                    width: t1.width,
                    height: t1.height
                });
            }
            hideControls() {
                this.controlsVisible = !1;
            }
            showControls() {
                this.controlsVisible = !0;
            }
            addEventListener(t1, e) {
                this.listeners[t1] && this.listeners[t1].push(e);
            }
            dispatchEvent(t1) {
                let e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null;
                this.listeners[t1] && this.listeners[t1].forEach((t1)=>t1(e));
            }
        }, Ln = [
            [
                "requestFullscreen",
                "exitFullscreen",
                "fullscreenElement",
                "fullscreenEnabled",
                "fullscreenchange",
                "fullscreenerror"
            ],
            [
                "webkitRequestFullscreen",
                "webkitExitFullscreen",
                "webkitFullscreenElement",
                "webkitFullscreenEnabled",
                "webkitfullscreenchange",
                "webkitfullscreenerror"
            ],
            [
                "webkitRequestFullScreen",
                "webkitCancelFullScreen",
                "webkitCurrentFullScreenElement",
                "webkitCancelFullScreen",
                "webkitfullscreenchange",
                "webkitfullscreenerror"
            ],
            [
                "mozRequestFullScreen",
                "mozCancelFullScreen",
                "mozFullScreenElement",
                "mozFullScreenEnabled",
                "mozfullscreenchange",
                "mozfullscreenerror"
            ],
            [
                "msRequestFullscreen",
                "msExitFullscreen",
                "msFullscreenElement",
                "msFullscreenEnabled",
                "MSFullscreenChange",
                "MSFullscreenError"
            ]
        ], On = (()=>{
            if ("undefined" == typeof document) return !1;
            const t1 = Ln[0], e = {};
            for (const i of Ln){
                const n = i?.[1];
                if (n in document) {
                    for (const [n, r] of i.entries())e[t1[n]] = r;
                    return e;
                }
            }
            return !1;
        })(), _n = {
            change: On.fullscreenchange,
            error: On.fullscreenerror
        };
        let jn = {
            request: (t1 = document.documentElement, e)=>new Promise((i, n)=>{
                    const r = ()=>{
                        jn.off("change", r), i();
                    };
                    jn.on("change", r);
                    const a = t1[On.requestFullscreen](e);
                    a instanceof Promise && a.then(r).catch(n);
                }),
            exit: ()=>new Promise((t1, e)=>{
                    if (!jn.isFullscreen) return void t1();
                    const i = ()=>{
                        jn.off("change", i), t1();
                    };
                    jn.on("change", i);
                    const n = document[On.exitFullscreen]();
                    n instanceof Promise && n.then(i).catch(e);
                }),
            toggle: (t1, e)=>jn.isFullscreen ? jn.exit() : jn.request(t1, e),
            onchange (t1) {
                jn.on("change", t1);
            },
            onerror (t1) {
                jn.on("error", t1);
            },
            on (t1, e) {
                const i = _n[t1];
                i && document.addEventListener(i, e, !1);
            },
            off (t1, e) {
                const i = _n[t1];
                i && document.removeEventListener(i, e, !1);
            },
            raw: On
        };
        Object.defineProperties(jn, {
            isFullscreen: {
                get: ()=>Boolean(document[On.fullscreenElement])
            },
            element: {
                enumerable: !0,
                get: ()=>document[On.fullscreenElement] ?? void 0
            },
            isEnabled: {
                enumerable: !0,
                get: ()=>Boolean(document[On.fullscreenEnabled])
            }
        }), On || (jn = {
            isEnabled: !1
        });
        const Pn = jn;
        function Rn(t1, e, i) {
            return (e = function(t1) {
                var e = function(t1) {
                    if ("object" != typeof t1 || !t1) return t1;
                    var e = t1[Symbol.toPrimitive];
                    if (void 0 !== e) {
                        var i = e.call(t1, "string");
                        if ("object" != typeof i) return i;
                        throw new TypeError("@@toPrimitive must return a primitive value.");
                    }
                    return String(t1);
                }(t1);
                return "symbol" == typeof e ? e : e + "";
            }(e)) in t1 ? Object.defineProperty(t1, e, {
                value: i,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : t1[e] = i, t1;
        }
        ni({
            useProxies: "never"
        });
        const Un = new class {
            constructor(){
                Rn(this, "enabled", Pn.isEnabled), Rn(this, "active", !1), Rn(this, "element", null), Rn(this, "width", null), Rn(this, "height", null), Ti(this);
            }
            init() {
                this.element = document.querySelector("#widget-application"), this.enabled && (this.resize(zn.config), Pn.on("change", ()=>{
                    setTimeout(()=>{
                        this.active = Pn.isFullscreen, this.active ? zn.setConfig({
                            ...zn.config,
                            width: window.innerWidth,
                            height: window.innerHeight
                        }) : zn.setConfig({
                            ...zn.config,
                            width: this.width,
                            height: this.height
                        });
                    }, 100);
                }));
            }
            async enter() {
                return await Pn.request(this.element);
            }
            async exit() {
                return await Pn.exit();
            }
            resize(t1) {
                let { width: e, height: i } = t1;
                this.width = e, this.height = i;
            }
        }, kn = {
            DEFAULT: 0,
            THREESIXTY: 1
        }, Bn = {
            tabs: [
                "rotation",
                "area",
                "panorama"
            ],
            logo: null,
            logoUrl: null,
            width: 1920,
            height: 1080,
            resizable: !0,
            rotationMode: kn.DEFAULT,
            floors: [],
            panoramaFov: 75,
            preloadPerPanoramaCount: 3,
            forcePreloadNonCached: !0,
            forceTopViewOnMap: !0,
            topViewResolutionUpscale: 2,
            enableCameraTransitionBetweenPanoramas: !0,
            enableCameraRotationBetweenPanoramas: !1,
            primaryCameraPointId: null,
            json: null,
            locale: "en",
            API_URL: "https://backend.estate.hart-digital.com",
            branding: null,
            colors: {
                main: "#FFA900",
                mainText: "#413E3E"
            },
            panoramaIcons: {
                spot: "data:image/png;base64,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",
                interactiveSpot: "data:image/png;base64,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",
                door: "data:image/png;base64,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"
            },
            dictionaryOverrides: null,
            instructionVisible: !0,
            autoRotate: !1,
            scales: [
                "x1",
                "x05"
            ],
            enableGyroscope: !0,
            scaleButtonType: "img",
            floorNumberEndingsVisible: !1
        }, Fn = Bn, Qn = "158", Hn = {
            LEFT: 0,
            MIDDLE: 1,
            RIGHT: 2,
            ROTATE: 0,
            DOLLY: 1,
            PAN: 2
        }, Vn = {
            ROTATE: 0,
            PAN: 1,
            DOLLY_PAN: 2,
            DOLLY_ROTATE: 3
        }, Gn = 0, Yn = 1, Wn = 2, Xn = 3, Zn = 0, Jn = 1, Kn = 2, qn = 3, $n = 0, tr = 1, er = 2, ir = 2, nr = 0, rr = 1, ar = 2, sr = 3, or = 4, lr = 5, cr = 100, ur = 101, hr = 102, dr = 103, pr = 104, fr = 200, Ar = 201, gr = 202, mr = 203, Mr = 204, yr = 205, vr = 206, xr = 207, wr = 208, br = 209, Tr = 210, Er = 211, Ir = 212, Sr = 213, Nr = 214, Dr = 0, Cr = 1, zr = 2, Lr = 3, Or = 4, _r = 5, jr = 6, Pr = 7, Rr = 0, Ur = 1, kr = 2, Br = 0, Fr = 1, Qr = 2, Hr = 3, Vr = 4, Gr = 5, Yr = "attached", Wr = "detached", Xr = 300, Zr = 301, Jr = 302, Kr = 303, qr = 304, $r = 306, ta = 1e3, ea = 1001, ia = 1002, na = 1003, ra = 1004, aa = 1004, sa = 1005, oa = 1005, la = 1006, ca = 1007, ua = 1007, ha = 1008, da = 1008, pa = 1009, fa = 1010, Aa = 1011, ga = 1012, ma = 1013, Ma = 1014, ya = 1015, va = 1016, xa = 1017, wa = 1018, ba = 1020, Ta = 1021, Ea = 1023, Ia = 1024, Sa = 1025, Na = 1026, Da = 1027, Ca = 1028, za = 1029, La = 1030, Oa = 1031, _a = 1033, ja = 33776, Pa = 33777, Ra = 33778, Ua = 33779, ka = 35840, Ba = 35841, Fa = 35842, Qa = 35843, Ha = 36196, Va = 37492, Ga = 37496, Ya = 37808, Wa = 37809, Xa = 37810, Za = 37811, Ja = 37812, Ka = 37813, qa = 37814, $a = 37815, ts = 37816, es = 37817, is = 37818, ns = 37819, rs = 37820, as = 37821, ss = 36492, os = 36494, ls = 36495, cs = 36283, us = 36284, hs = 36285, ds = 36286, ps = 2200, fs = 2201, As = 2202, gs = 2300, ms = 2301, Ms = 2302, ys = 2400, vs = 2401, xs = 2402, ws = 2500, bs = 2501, Ts = 0, Es = 1, Is = 2, Ss = 3e3, Ns = 3001, Ds = 3200, Cs = 3201, zs = 0, Ls = 1, Os = "", _s = "srgb", js = "srgb-linear", Ps = "display-p3", Rs = "display-p3-linear", Us = "linear", ks = "srgb", Bs = "rec709", Fs = "p3", Qs = 0, Hs = 7680, Vs = 7681, Gs = 7682, Ys = 7683, Ws = 34055, Xs = 34056, Zs = 5386, Js = 512, Ks = 513, qs = 514, $s = 515, to = 516, eo = 517, io = 518, no = 519, ro = 512, ao = 513, so = 514, oo = 515, lo = 516, co = 517, uo = 518, ho = 519, po = 35044, fo = 35048, Ao = 35040, go = 35045, mo = 35049, Mo = 35041, yo = 35046, vo = 35050, xo = 35042, wo = "100", bo = "300 es", To = 1035, Eo = 2e3, Io = 2001;
        class So {
            addEventListener(t1, e) {
                void 0 === this._listeners && (this._listeners = {});
                const i = this._listeners;
                void 0 === i[t1] && (i[t1] = []), -1 === i[t1].indexOf(e) && i[t1].push(e);
            }
            hasEventListener(t1, e) {
                if (void 0 === this._listeners) return !1;
                const i = this._listeners;
                return void 0 !== i[t1] && -1 !== i[t1].indexOf(e);
            }
            removeEventListener(t1, e) {
                if (void 0 === this._listeners) return;
                const i = this._listeners[t1];
                if (void 0 !== i) {
                    const t1 = i.indexOf(e);
                    -1 !== t1 && i.splice(t1, 1);
                }
            }
            dispatchEvent(t1) {
                if (void 0 === this._listeners) return;
                const e = this._listeners[t1.type];
                if (void 0 !== e) {
                    t1.target = this;
                    const i = e.slice(0);
                    for(let e = 0, n = i.length; e < n; e++)i[e].call(this, t1);
                    t1.target = null;
                }
            }
        }
        const No = [
            "00",
            "01",
            "02",
            "03",
            "04",
            "05",
            "06",
            "07",
            "08",
            "09",
            "0a",
            "0b",
            "0c",
            "0d",
            "0e",
            "0f",
            "10",
            "11",
            "12",
            "13",
            "14",
            "15",
            "16",
            "17",
            "18",
            "19",
            "1a",
            "1b",
            "1c",
            "1d",
            "1e",
            "1f",
            "20",
            "21",
            "22",
            "23",
            "24",
            "25",
            "26",
            "27",
            "28",
            "29",
            "2a",
            "2b",
            "2c",
            "2d",
            "2e",
            "2f",
            "30",
            "31",
            "32",
            "33",
            "34",
            "35",
            "36",
            "37",
            "38",
            "39",
            "3a",
            "3b",
            "3c",
            "3d",
            "3e",
            "3f",
            "40",
            "41",
            "42",
            "43",
            "44",
            "45",
            "46",
            "47",
            "48",
            "49",
            "4a",
            "4b",
            "4c",
            "4d",
            "4e",
            "4f",
            "50",
            "51",
            "52",
            "53",
            "54",
            "55",
            "56",
            "57",
            "58",
            "59",
            "5a",
            "5b",
            "5c",
            "5d",
            "5e",
            "5f",
            "60",
            "61",
            "62",
            "63",
            "64",
            "65",
            "66",
            "67",
            "68",
            "69",
            "6a",
            "6b",
            "6c",
            "6d",
            "6e",
            "6f",
            "70",
            "71",
            "72",
            "73",
            "74",
            "75",
            "76",
            "77",
            "78",
            "79",
            "7a",
            "7b",
            "7c",
            "7d",
            "7e",
            "7f",
            "80",
            "81",
            "82",
            "83",
            "84",
            "85",
            "86",
            "87",
            "88",
            "89",
            "8a",
            "8b",
            "8c",
            "8d",
            "8e",
            "8f",
            "90",
            "91",
            "92",
            "93",
            "94",
            "95",
            "96",
            "97",
            "98",
            "99",
            "9a",
            "9b",
            "9c",
            "9d",
            "9e",
            "9f",
            "a0",
            "a1",
            "a2",
            "a3",
            "a4",
            "a5",
            "a6",
            "a7",
            "a8",
            "a9",
            "aa",
            "ab",
            "ac",
            "ad",
            "ae",
            "af",
            "b0",
            "b1",
            "b2",
            "b3",
            "b4",
            "b5",
            "b6",
            "b7",
            "b8",
            "b9",
            "ba",
            "bb",
            "bc",
            "bd",
            "be",
            "bf",
            "c0",
            "c1",
            "c2",
            "c3",
            "c4",
            "c5",
            "c6",
            "c7",
            "c8",
            "c9",
            "ca",
            "cb",
            "cc",
            "cd",
            "ce",
            "cf",
            "d0",
            "d1",
            "d2",
            "d3",
            "d4",
            "d5",
            "d6",
            "d7",
            "d8",
            "d9",
            "da",
            "db",
            "dc",
            "dd",
            "de",
            "df",
            "e0",
            "e1",
            "e2",
            "e3",
            "e4",
            "e5",
            "e6",
            "e7",
            "e8",
            "e9",
            "ea",
            "eb",
            "ec",
            "ed",
            "ee",
            "ef",
            "f0",
            "f1",
            "f2",
            "f3",
            "f4",
            "f5",
            "f6",
            "f7",
            "f8",
            "f9",
            "fa",
            "fb",
            "fc",
            "fd",
            "fe",
            "ff"
        ];
        let Do = 1234567;
        const Co = Math.PI / 180, zo = 180 / Math.PI;
        function Lo() {
            const t1 = 4294967295 * Math.random() | 0, e = 4294967295 * Math.random() | 0, i = 4294967295 * Math.random() | 0, n = 4294967295 * Math.random() | 0;
            return (No[255 & t1] + No[t1 >> 8 & 255] + No[t1 >> 16 & 255] + No[t1 >> 24 & 255] + "-" + No[255 & e] + No[e >> 8 & 255] + "-" + No[e >> 16 & 15 | 64] + No[e >> 24 & 255] + "-" + No[63 & i | 128] + No[i >> 8 & 255] + "-" + No[i >> 16 & 255] + No[i >> 24 & 255] + No[255 & n] + No[n >> 8 & 255] + No[n >> 16 & 255] + No[n >> 24 & 255]).toLowerCase();
        }
        function Oo(t1, e, i) {
            return Math.max(e, Math.min(i, t1));
        }
        function _o(t1, e) {
            return (t1 % e + e) % e;
        }
        function jo(t1, e, i) {
            return (1 - i) * t1 + i * e;
        }
        function Po(t1) {
            return !(t1 & t1 - 1) && 0 !== t1;
        }
        function Ro(t1) {
            return Math.pow(2, Math.ceil(Math.log(t1) / Math.LN2));
        }
        function Uo(t1) {
            return Math.pow(2, Math.floor(Math.log(t1) / Math.LN2));
        }
        function ko(t1, e) {
            switch(e.constructor){
                case Float32Array:
                    return t1;
                case Uint32Array:
                    return t1 / 4294967295;
                case Uint16Array:
                    return t1 / 65535;
                case Uint8Array:
                    return t1 / 255;
                case Int32Array:
                    return Math.max(t1 / 2147483647, -1);
                case Int16Array:
                    return Math.max(t1 / 32767, -1);
                case Int8Array:
                    return Math.max(t1 / 127, -1);
                default:
                    throw new Error("Invalid component type.");
            }
        }
        function Bo(t1, e) {
            switch(e.constructor){
                case Float32Array:
                    return t1;
                case Uint32Array:
                    return Math.round(4294967295 * t1);
                case Uint16Array:
                    return Math.round(65535 * t1);
                case Uint8Array:
                    return Math.round(255 * t1);
                case Int32Array:
                    return Math.round(2147483647 * t1);
                case Int16Array:
                    return Math.round(32767 * t1);
                case Int8Array:
                    return Math.round(127 * t1);
                default:
                    throw new Error("Invalid component type.");
            }
        }
        const Fo = {
            DEG2RAD: Co,
            RAD2DEG: zo,
            generateUUID: Lo,
            clamp: Oo,
            euclideanModulo: _o,
            mapLinear: function(t1, e, i, n, r) {
                return n + (t1 - e) * (r - n) / (i - e);
            },
            inverseLerp: function(t1, e, i) {
                return t1 !== e ? (i - t1) / (e - t1) : 0;
            },
            lerp: jo,
            damp: function(t1, e, i, n) {
                return jo(t1, e, 1 - Math.exp(-i * n));
            },
            pingpong: function(t1, e = 1) {
                return e - Math.abs(_o(t1, 2 * e) - e);
            },
            smoothstep: function(t1, e, i) {
                return t1 <= e ? 0 : t1 >= i ? 1 : (t1 = (t1 - e) / (i - e)) * t1 * (3 - 2 * t1);
            },
            smootherstep: function(t1, e, i) {
                return t1 <= e ? 0 : t1 >= i ? 1 : (t1 = (t1 - e) / (i - e)) * t1 * t1 * (t1 * (6 * t1 - 15) + 10);
            },
            randInt: function(t1, e) {
                return t1 + Math.floor(Math.random() * (e - t1 + 1));
            },
            randFloat: function(t1, e) {
                return t1 + Math.random() * (e - t1);
            },
            randFloatSpread: function(t1) {
                return t1 * (.5 - Math.random());
            },
            seededRandom: function(t1) {
                void 0 !== t1 && (Do = t1);
                let e = Do += 1831565813;
                return e = Math.imul(e ^ e >>> 15, 1 | e), e ^= e + Math.imul(e ^ e >>> 7, 61 | e), ((e ^ e >>> 14) >>> 0) / 4294967296;
            },
            degToRad: function(t1) {
                return t1 * Co;
            },
            radToDeg: function(t1) {
                return t1 * zo;
            },
            isPowerOfTwo: Po,
            ceilPowerOfTwo: Ro,
            floorPowerOfTwo: Uo,
            setQuaternionFromProperEuler: function(t1, e, i, n, r) {
                const a = Math.cos, s = Math.sin, o = a(i / 2), l = s(i / 2), c = a((e + n) / 2), u = s((e + n) / 2), h = a((e - n) / 2), d = s((e - n) / 2), p = a((n - e) / 2), f = s((n - e) / 2);
                switch(r){
                    case "XYX":
                        t1.set(o * u, l * h, l * d, o * c);
                        break;
                    case "YZY":
                        t1.set(l * d, o * u, l * h, o * c);
                        break;
                    case "ZXZ":
                        t1.set(l * h, l * d, o * u, o * c);
                        break;
                    case "XZX":
                        t1.set(o * u, l * f, l * p, o * c);
                        break;
                    case "YXY":
                        t1.set(l * p, o * u, l * f, o * c);
                        break;
                    case "ZYZ":
                        t1.set(l * f, l * p, o * u, o * c);
                        break;
                    default:
                        console.warn("THREE.MathUtils: .setQuaternionFromProperEuler() encountered an unknown order: " + r);
                }
            },
            normalize: Bo,
            denormalize: ko
        };
        class Qo {
            constructor(t1 = 0, e = 0){
                Qo.prototype.isVector2 = !0, this.x = t1, this.y = e;
            }
            get width() {
                return this.x;
            }
            set width(t1) {
                this.x = t1;
            }
            get height() {
                return this.y;
            }
            set height(t1) {
                this.y = t1;
            }
            set(t1, e) {
                return this.x = t1, this.y = e, this;
            }
            setScalar(t1) {
                return this.x = t1, this.y = t1, this;
            }
            setX(t1) {
                return this.x = t1, this;
            }
            setY(t1) {
                return this.y = t1, this;
            }
            setComponent(t1, e) {
                switch(t1){
                    case 0:
                        this.x = e;
                        break;
                    case 1:
                        this.y = e;
                        break;
                    default:
                        throw new Error("index is out of range: " + t1);
                }
                return this;
            }
            getComponent(t1) {
                switch(t1){
                    case 0:
                        return this.x;
                    case 1:
                        return this.y;
                    default:
                        throw new Error("index is out of range: " + t1);
                }
            }
            clone() {
                return new this.constructor(this.x, this.y);
            }
            copy(t1) {
                return this.x = t1.x, this.y = t1.y, this;
            }
            add(t1) {
                return this.x += t1.x, this.y += t1.y, this;
            }
            addScalar(t1) {
                return this.x += t1, this.y += t1, this;
            }
            addVectors(t1, e) {
                return this.x = t1.x + e.x, this.y = t1.y + e.y, this;
            }
            addScaledVector(t1, e) {
                return this.x += t1.x * e, this.y += t1.y * e, this;
            }
            sub(t1) {
                return this.x -= t1.x, this.y -= t1.y, this;
            }
            subScalar(t1) {
                return this.x -= t1, this.y -= t1, this;
            }
            subVectors(t1, e) {
                return this.x = t1.x - e.x, this.y = t1.y - e.y, this;
            }
            multiply(t1) {
                return this.x *= t1.x, this.y *= t1.y, this;
            }
            multiplyScalar(t1) {
                return this.x *= t1, this.y *= t1, this;
            }
            divide(t1) {
                return this.x /= t1.x, this.y /= t1.y, this;
            }
            divideScalar(t1) {
                return this.multiplyScalar(1 / t1);
            }
            applyMatrix3(t1) {
                const e = this.x, i = this.y, n = t1.elements;
                return this.x = n[0] * e + n[3] * i + n[6], this.y = n[1] * e + n[4] * i + n[7], this;
            }
            min(t1) {
                return this.x = Math.min(this.x, t1.x), this.y = Math.min(this.y, t1.y), this;
            }
            max(t1) {
                return this.x = Math.max(this.x, t1.x), this.y = Math.max(this.y, t1.y), this;
            }
            clamp(t1, e) {
                return this.x = Math.max(t1.x, Math.min(e.x, this.x)), this.y = Math.max(t1.y, Math.min(e.y, this.y)), this;
            }
            clampScalar(t1, e) {
                return this.x = Math.max(t1, Math.min(e, this.x)), this.y = Math.max(t1, Math.min(e, this.y)), this;
            }
            clampLength(t1, e) {
                const i = this.length();
                return this.divideScalar(i || 1).multiplyScalar(Math.max(t1, Math.min(e, i)));
            }
            floor() {
                return this.x = Math.floor(this.x), this.y = Math.floor(this.y), this;
            }
            ceil() {
                return this.x = Math.ceil(this.x), this.y = Math.ceil(this.y), this;
            }
            round() {
                return this.x = Math.round(this.x), this.y = Math.round(this.y), this;
            }
            roundToZero() {
                return this.x = Math.trunc(this.x), this.y = Math.trunc(this.y), this;
            }
            negate() {
                return this.x = -this.x, this.y = -this.y, this;
            }
            dot(t1) {
                return this.x * t1.x + this.y * t1.y;
            }
            cross(t1) {
                return this.x * t1.y - this.y * t1.x;
            }
            lengthSq() {
                return this.x * this.x + this.y * this.y;
            }
            length() {
                return Math.sqrt(this.x * this.x + this.y * this.y);
            }
            manhattanLength() {
                return Math.abs(this.x) + Math.abs(this.y);
            }
            normalize() {
                return this.divideScalar(this.length() || 1);
            }
            angle() {
                return Math.atan2(-this.y, -this.x) + Math.PI;
            }
            angleTo(t1) {
                const e = Math.sqrt(this.lengthSq() * t1.lengthSq());
                if (0 === e) return Math.PI / 2;
                const i = this.dot(t1) / e;
                return Math.acos(Oo(i, -1, 1));
            }
            distanceTo(t1) {
                return Math.sqrt(this.distanceToSquared(t1));
            }
            distanceToSquared(t1) {
                const e = this.x - t1.x, i = this.y - t1.y;
                return e * e + i * i;
            }
            manhattanDistanceTo(t1) {
                return Math.abs(this.x - t1.x) + Math.abs(this.y - t1.y);
            }
            setLength(t1) {
                return this.normalize().multiplyScalar(t1);
            }
            lerp(t1, e) {
                return this.x += (t1.x - this.x) * e, this.y += (t1.y - this.y) * e, this;
            }
            lerpVectors(t1, e, i) {
                return this.x = t1.x + (e.x - t1.x) * i, this.y = t1.y + (e.y - t1.y) * i, this;
            }
            equals(t1) {
                return t1.x === this.x && t1.y === this.y;
            }
            fromArray(t1, e = 0) {
                return this.x = t1[e], this.y = t1[e + 1], this;
            }
            toArray(t1 = [], e = 0) {
                return t1[e] = this.x, t1[e + 1] = this.y, t1;
            }
            fromBufferAttribute(t1, e) {
                return this.x = t1.getX(e), this.y = t1.getY(e), this;
            }
            rotateAround(t1, e) {
                const i = Math.cos(e), n = Math.sin(e), r = this.x - t1.x, a = this.y - t1.y;
                return this.x = r * i - a * n + t1.x, this.y = r * n + a * i + t1.y, this;
            }
            random() {
                return this.x = Math.random(), this.y = Math.random(), this;
            }
            *[Symbol.iterator]() {
                yield this.x, yield this.y;
            }
        }
        class Ho {
            constructor(t1, e, i, n, r, a, s, o, l){
                Ho.prototype.isMatrix3 = !0, this.elements = [
                    1,
                    0,
                    0,
                    0,
                    1,
                    0,
                    0,
                    0,
                    1
                ], void 0 !== t1 && this.set(t1, e, i, n, r, a, s, o, l);
            }
            set(t1, e, i, n, r, a, s, o, l) {
                const c = this.elements;
                return c[0] = t1, c[1] = n, c[2] = s, c[3] = e, c[4] = r, c[5] = o, c[6] = i, c[7] = a, c[8] = l, this;
            }
            identity() {
                return this.set(1, 0, 0, 0, 1, 0, 0, 0, 1), this;
            }
            copy(t1) {
                const e = this.elements, i = t1.elements;
                return e[0] = i[0], e[1] = i[1], e[2] = i[2], e[3] = i[3], e[4] = i[4], e[5] = i[5], e[6] = i[6], e[7] = i[7], e[8] = i[8], this;
            }
            extractBasis(t1, e, i) {
                return t1.setFromMatrix3Column(this, 0), e.setFromMatrix3Column(this, 1), i.setFromMatrix3Column(this, 2), this;
            }
            setFromMatrix4(t1) {
                const e = t1.elements;
                return this.set(e[0], e[4], e[8], e[1], e[5], e[9], e[2], e[6], e[10]), this;
            }
            multiply(t1) {
                return this.multiplyMatrices(this, t1);
            }
            premultiply(t1) {
                return this.multiplyMatrices(t1, this);
            }
            multiplyMatrices(t1, e) {
                const i = t1.elements, n = e.elements, r = this.elements, a = i[0], s = i[3], o = i[6], l = i[1], c = i[4], u = i[7], h = i[2], d = i[5], p = i[8], f = n[0], A = n[3], g = n[6], m = n[1], M = n[4], y = n[7], v = n[2], x = n[5], w = n[8];
                return r[0] = a * f + s * m + o * v, r[3] = a * A + s * M + o * x, r[6] = a * g + s * y + o * w, r[1] = l * f + c * m + u * v, r[4] = l * A + c * M + u * x, r[7] = l * g + c * y + u * w, r[2] = h * f + d * m + p * v, r[5] = h * A + d * M + p * x, r[8] = h * g + d * y + p * w, this;
            }
            multiplyScalar(t1) {
                const e = this.elements;
                return e[0] *= t1, e[3] *= t1, e[6] *= t1, e[1] *= t1, e[4] *= t1, e[7] *= t1, e[2] *= t1, e[5] *= t1, e[8] *= t1, this;
            }
            determinant() {
                const t1 = this.elements, e = t1[0], i = t1[1], n = t1[2], r = t1[3], a = t1[4], s = t1[5], o = t1[6], l = t1[7], c = t1[8];
                return e * a * c - e * s * l - i * r * c + i * s * o + n * r * l - n * a * o;
            }
            invert() {
                const t1 = this.elements, e = t1[0], i = t1[1], n = t1[2], r = t1[3], a = t1[4], s = t1[5], o = t1[6], l = t1[7], c = t1[8], u = c * a - s * l, h = s * o - c * r, d = l * r - a * o, p = e * u + i * h + n * d;
                if (0 === p) return this.set(0, 0, 0, 0, 0, 0, 0, 0, 0);
                const f = 1 / p;
                return t1[0] = u * f, t1[1] = (n * l - c * i) * f, t1[2] = (s * i - n * a) * f, t1[3] = h * f, t1[4] = (c * e - n * o) * f, t1[5] = (n * r - s * e) * f, t1[6] = d * f, t1[7] = (i * o - l * e) * f, t1[8] = (a * e - i * r) * f, this;
            }
            transpose() {
                let t1;
                const e = this.elements;
                return t1 = e[1], e[1] = e[3], e[3] = t1, t1 = e[2], e[2] = e[6], e[6] = t1, t1 = e[5], e[5] = e[7], e[7] = t1, this;
            }
            getNormalMatrix(t1) {
                return this.setFromMatrix4(t1).invert().transpose();
            }
            transposeIntoArray(t1) {
                const e = this.elements;
                return t1[0] = e[0], t1[1] = e[3], t1[2] = e[6], t1[3] = e[1], t1[4] = e[4], t1[5] = e[7], t1[6] = e[2], t1[7] = e[5], t1[8] = e[8], this;
            }
            setUvTransform(t1, e, i, n, r, a, s) {
                const o = Math.cos(r), l = Math.sin(r);
                return this.set(i * o, i * l, -i * (o * a + l * s) + a + t1, -n * l, n * o, -n * (-l * a + o * s) + s + e, 0, 0, 1), this;
            }
            scale(t1, e) {
                return this.premultiply(Vo.makeScale(t1, e)), this;
            }
            rotate(t1) {
                return this.premultiply(Vo.makeRotation(-t1)), this;
            }
            translate(t1, e) {
                return this.premultiply(Vo.makeTranslation(t1, e)), this;
            }
            makeTranslation(t1, e) {
                return t1.isVector2 ? this.set(1, 0, t1.x, 0, 1, t1.y, 0, 0, 1) : this.set(1, 0, t1, 0, 1, e, 0, 0, 1), this;
            }
            makeRotation(t1) {
                const e = Math.cos(t1), i = Math.sin(t1);
                return this.set(e, -i, 0, i, e, 0, 0, 0, 1), this;
            }
            makeScale(t1, e) {
                return this.set(t1, 0, 0, 0, e, 0, 0, 0, 1), this;
            }
            equals(t1) {
                const e = this.elements, i = t1.elements;
                for(let t1 = 0; t1 < 9; t1++)if (e[t1] !== i[t1]) return !1;
                return !0;
            }
            fromArray(t1, e = 0) {
                for(let i = 0; i < 9; i++)this.elements[i] = t1[i + e];
                return this;
            }
            toArray(t1 = [], e = 0) {
                const i = this.elements;
                return t1[e] = i[0], t1[e + 1] = i[1], t1[e + 2] = i[2], t1[e + 3] = i[3], t1[e + 4] = i[4], t1[e + 5] = i[5], t1[e + 6] = i[6], t1[e + 7] = i[7], t1[e + 8] = i[8], t1;
            }
            clone() {
                return (new this.constructor).fromArray(this.elements);
            }
        }
        const Vo = new Ho;
        function Go(t1) {
            for(let e = t1.length - 1; e >= 0; --e)if (t1[e] >= 65535) return !0;
            return !1;
        }
        const Yo = {
            Int8Array: Int8Array,
            Uint8Array: Uint8Array,
            Uint8ClampedArray: Uint8ClampedArray,
            Int16Array: Int16Array,
            Uint16Array: Uint16Array,
            Int32Array: Int32Array,
            Uint32Array: Uint32Array,
            Float32Array: Float32Array,
            Float64Array: Float64Array
        };
        function Wo(t1, e) {
            return new Yo[t1](e);
        }
        function Xo(t1) {
            return document.createElementNS("http://www.w3.org/1999/xhtml", t1);
        }
        function Zo() {
            const t1 = Xo("canvas");
            return t1.style.display = "block", t1;
        }
        const Jo = {};
        function Ko(t1) {
            t1 in Jo || (Jo[t1] = !0, console.warn(t1));
        }
        const qo = (new Ho).set(.8224621, .177538, 0, .0331941, .9668058, 0, .0170827, .0723974, .9105199), $o = (new Ho).set(1.2249401, -0.2249404, 0, -0.0420569, 1.0420571, 0, -0.0196376, -0.0786361, 1.0982735), tl = {
            [js]: {
                transfer: Us,
                primaries: Bs,
                toReference: (t1)=>t1,
                fromReference: (t1)=>t1
            },
            [_s]: {
                transfer: ks,
                primaries: Bs,
                toReference: (t1)=>t1.convertSRGBToLinear(),
                fromReference: (t1)=>t1.convertLinearToSRGB()
            },
            [Rs]: {
                transfer: Us,
                primaries: Fs,
                toReference: (t1)=>t1.applyMatrix3($o),
                fromReference: (t1)=>t1.applyMatrix3(qo)
            },
            [Ps]: {
                transfer: ks,
                primaries: Fs,
                toReference: (t1)=>t1.convertSRGBToLinear().applyMatrix3($o),
                fromReference: (t1)=>t1.applyMatrix3(qo).convertLinearToSRGB()
            }
        }, el = new Set([
            js,
            Rs
        ]), il = {
            enabled: !0,
            _workingColorSpace: js,
            get legacyMode () {
                return console.warn("THREE.ColorManagement: .legacyMode=false renamed to .enabled=true in r150."), !this.enabled;
            },
            set legacyMode (t){
                console.warn("THREE.ColorManagement: .legacyMode=false renamed to .enabled=true in r150."), this.enabled = !t;
            },
            get workingColorSpace () {
                return this._workingColorSpace;
            },
            set workingColorSpace (t){
                if (!el.has(t)) throw new Error(`Unsupported working color space, "${t}".`);
                this._workingColorSpace = t;
            },
            convert: function(t1, e, i) {
                if (!1 === this.enabled || e === i || !e || !i) return t1;
                const n = tl[e].toReference;
                return (0, tl[i].fromReference)(n(t1));
            },
            fromWorkingColorSpace: function(t1, e) {
                return this.convert(t1, this._workingColorSpace, e);
            },
            toWorkingColorSpace: function(t1, e) {
                return this.convert(t1, e, this._workingColorSpace);
            },
            getPrimaries: function(t1) {
                return tl[t1].primaries;
            },
            getTransfer: function(t1) {
                return t1 === Os ? Us : tl[t1].transfer;
            }
        };
        function nl(t1) {
            return t1 < .04045 ? .0773993808 * t1 : Math.pow(.9478672986 * t1 + .0521327014, 2.4);
        }
        function rl(t1) {
            return t1 < .0031308 ? 12.92 * t1 : 1.055 * Math.pow(t1, .41666) - .055;
        }
        let al;
        class sl {
            static getDataURL(t1) {
                if (/^data:/i.test(t1.src)) return t1.src;
                if ("undefined" == typeof HTMLCanvasElement) return t1.src;
                let e;
                if (t1 instanceof HTMLCanvasElement) e = t1;
                else {
                    void 0 === al && (al = Xo("canvas")), al.width = t1.width, al.height = t1.height;
                    const i = al.getContext("2d");
                    t1 instanceof ImageData ? i.putImageData(t1, 0, 0) : i.drawImage(t1, 0, 0, t1.width, t1.height), e = al;
                }
                return e.width > 2048 || e.height > 2048 ? (console.warn("THREE.ImageUtils.getDataURL: Image converted to jpg for performance reasons", t1), e.toDataURL("image/jpeg", .6)) : e.toDataURL("image/png");
            }
            static sRGBToLinear(t1) {
                if ("undefined" != typeof HTMLImageElement && t1 instanceof HTMLImageElement || "undefined" != typeof HTMLCanvasElement && t1 instanceof HTMLCanvasElement || "undefined" != typeof ImageBitmap && t1 instanceof ImageBitmap) {
                    const e = Xo("canvas");
                    e.width = t1.width, e.height = t1.height;
                    const i = e.getContext("2d");
                    i.drawImage(t1, 0, 0, t1.width, t1.height);
                    const n = i.getImageData(0, 0, t1.width, t1.height), r = n.data;
                    for(let t1 = 0; t1 < r.length; t1++)r[t1] = 255 * nl(r[t1] / 255);
                    return i.putImageData(n, 0, 0), e;
                }
                if (t1.data) {
                    const e = t1.data.slice(0);
                    for(let t1 = 0; t1 < e.length; t1++)e instanceof Uint8Array || e instanceof Uint8ClampedArray ? e[t1] = Math.floor(255 * nl(e[t1] / 255)) : e[t1] = nl(e[t1]);
                    return {
                        data: e,
                        width: t1.width,
                        height: t1.height
                    };
                }
                return console.warn("THREE.ImageUtils.sRGBToLinear(): Unsupported image type. No color space conversion applied."), t1;
            }
        }
        let ol = 0;
        class ll {
            constructor(t1 = null){
                this.isSource = !0, Object.defineProperty(this, "id", {
                    value: ol++
                }), this.uuid = Lo(), this.data = t1, this.version = 0;
            }
            set needsUpdate(t1) {
                !0 === t1 && this.version++;
            }
            toJSON(t1) {
                const e = void 0 === t1 || "string" == typeof t1;
                if (!e && void 0 !== t1.images[this.uuid]) return t1.images[this.uuid];
                const i = {
                    uuid: this.uuid,
                    url: ""
                }, n = this.data;
                if (null !== n) {
                    let t1;
                    if (Array.isArray(n)) {
                        t1 = [];
                        for(let e = 0, i = n.length; e < i; e++)n[e].isDataTexture ? t1.push(cl(n[e].image)) : t1.push(cl(n[e]));
                    } else t1 = cl(n);
                    i.url = t1;
                }
                return e || (t1.images[this.uuid] = i), i;
            }
        }
        function cl(t1) {
            return "undefined" != typeof HTMLImageElement && t1 instanceof HTMLImageElement || "undefined" != typeof HTMLCanvasElement && t1 instanceof HTMLCanvasElement || "undefined" != typeof ImageBitmap && t1 instanceof ImageBitmap ? sl.getDataURL(t1) : t1.data ? {
                data: Array.from(t1.data),
                width: t1.width,
                height: t1.height,
                type: t1.data.constructor.name
            } : (console.warn("THREE.Texture: Unable to serialize Texture."), {});
        }
        let ul = 0;
        class hl extends So {
            constructor(t1 = hl.DEFAULT_IMAGE, e = hl.DEFAULT_MAPPING, i = ea, n = ea, r = la, a = ha, s = Ea, o = pa, l = hl.DEFAULT_ANISOTROPY, c = Os){
                super(), this.isTexture = !0, Object.defineProperty(this, "id", {
                    value: ul++
                }), this.uuid = Lo(), this.name = "", this.source = new ll(t1), this.mipmaps = [], this.mapping = e, this.channel = 0, this.wrapS = i, this.wrapT = n, this.magFilter = r, this.minFilter = a, this.anisotropy = l, this.format = s, this.internalFormat = null, this.type = o, this.offset = new Qo(0, 0), this.repeat = new Qo(1, 1), this.center = new Qo(0, 0), this.rotation = 0, this.matrixAutoUpdate = !0, this.matrix = new Ho, this.generateMipmaps = !0, this.premultiplyAlpha = !1, this.flipY = !0, this.unpackAlignment = 4, "string" == typeof c ? this.colorSpace = c : (Ko("THREE.Texture: Property .encoding has been replaced by .colorSpace."), this.colorSpace = c === Ns ? _s : Os), this.userData = {}, this.version = 0, this.onUpdate = null, this.isRenderTargetTexture = !1, this.needsPMREMUpdate = !1;
            }
            get image() {
                return this.source.data;
            }
            set image(t1 = null) {
                this.source.data = t1;
            }
            updateMatrix() {
                this.matrix.setUvTransform(this.offset.x, this.offset.y, this.repeat.x, this.repeat.y, this.rotation, this.center.x, this.center.y);
            }
            clone() {
                return (new this.constructor).copy(this);
            }
            copy(t1) {
                return this.name = t1.name, this.source = t1.source, this.mipmaps = t1.mipmaps.slice(0), this.mapping = t1.mapping, this.channel = t1.channel, this.wrapS = t1.wrapS, this.wrapT = t1.wrapT, this.magFilter = t1.magFilter, this.minFilter = t1.minFilter, this.anisotropy = t1.anisotropy, this.format = t1.format, this.internalFormat = t1.internalFormat, this.type = t1.type, this.offset.copy(t1.offset), this.repeat.copy(t1.repeat), this.center.copy(t1.center), this.rotation = t1.rotation, this.matrixAutoUpdate = t1.matrixAutoUpdate, this.matrix.copy(t1.matrix), this.generateMipmaps = t1.generateMipmaps, this.premultiplyAlpha = t1.premultiplyAlpha, this.flipY = t1.flipY, this.unpackAlignment = t1.unpackAlignment, this.colorSpace = t1.colorSpace, this.userData = JSON.parse(JSON.stringify(t1.userData)), this.needsUpdate = !0, this;
            }
            toJSON(t1) {
                const e = void 0 === t1 || "string" == typeof t1;
                if (!e && void 0 !== t1.textures[this.uuid]) return t1.textures[this.uuid];
                const i = {
                    metadata: {
                        version: 4.6,
                        type: "Texture",
                        generator: "Texture.toJSON"
                    },
                    uuid: this.uuid,
                    name: this.name,
                    image: this.source.toJSON(t1).uuid,
                    mapping: this.mapping,
                    channel: this.channel,
                    repeat: [
                        this.repeat.x,
                        this.repeat.y
                    ],
                    offset: [
                        this.offset.x,
                        this.offset.y
                    ],
                    center: [
                        this.center.x,
                        this.center.y
                    ],
                    rotation: this.rotation,
                    wrap: [
                        this.wrapS,
                        this.wrapT
                    ],
                    format: this.format,
                    internalFormat: this.internalFormat,
                    type: this.type,
                    colorSpace: this.colorSpace,
                    minFilter: this.minFilter,
                    magFilter: this.magFilter,
                    anisotropy: this.anisotropy,
                    flipY: this.flipY,
                    generateMipmaps: this.generateMipmaps,
                    premultiplyAlpha: this.premultiplyAlpha,
                    unpackAlignment: this.unpackAlignment
                };
                return Object.keys(this.userData).length > 0 && (i.userData = this.userData), e || (t1.textures[this.uuid] = i), i;
            }
            dispose() {
                this.dispatchEvent({
                    type: "dispose"
                });
            }
            transformUv(t1) {
                if (this.mapping !== Xr) return t1;
                if (t1.applyMatrix3(this.matrix), t1.x < 0 || t1.x > 1) switch(this.wrapS){
                    case ta:
                        t1.x = t1.x - Math.floor(t1.x);
                        break;
                    case ea:
                        t1.x = t1.x < 0 ? 0 : 1;
                        break;
                    case ia:
                        1 === Math.abs(Math.floor(t1.x) % 2) ? t1.x = Math.ceil(t1.x) - t1.x : t1.x = t1.x - Math.floor(t1.x);
                }
                if (t1.y < 0 || t1.y > 1) switch(this.wrapT){
                    case ta:
                        t1.y = t1.y - Math.floor(t1.y);
                        break;
                    case ea:
                        t1.y = t1.y < 0 ? 0 : 1;
                        break;
                    case ia:
                        1 === Math.abs(Math.floor(t1.y) % 2) ? t1.y = Math.ceil(t1.y) - t1.y : t1.y = t1.y - Math.floor(t1.y);
                }
                return this.flipY && (t1.y = 1 - t1.y), t1;
            }
            set needsUpdate(t1) {
                !0 === t1 && (this.version++, this.source.needsUpdate = !0);
            }
            get encoding() {
                return Ko("THREE.Texture: Property .encoding has been replaced by .colorSpace."), this.colorSpace === _s ? Ns : Ss;
            }
            set encoding(t1) {
                Ko("THREE.Texture: Property .encoding has been replaced by .colorSpace."), this.colorSpace = t1 === Ns ? _s : Os;
            }
        }
        hl.DEFAULT_IMAGE = null, hl.DEFAULT_MAPPING = Xr, hl.DEFAULT_ANISOTROPY = 1;
        class dl {
            constructor(t1 = 0, e = 0, i = 0, n = 1){
                dl.prototype.isVector4 = !0, this.x = t1, this.y = e, this.z = i, this.w = n;
            }
            get width() {
                return this.z;
            }
            set width(t1) {
                this.z = t1;
            }
            get height() {
                return this.w;
            }
            set height(t1) {
                this.w = t1;
            }
            set(t1, e, i, n) {
                return this.x = t1, this.y = e, this.z = i, this.w = n, this;
            }
            setScalar(t1) {
                return this.x = t1, this.y = t1, this.z = t1, this.w = t1, this;
            }
            setX(t1) {
                return this.x = t1, this;
            }
            setY(t1) {
                return this.y = t1, this;
            }
            setZ(t1) {
                return this.z = t1, this;
            }
            setW(t1) {
                return this.w = t1, this;
            }
            setComponent(t1, e) {
                switch(t1){
                    case 0:
                        this.x = e;
                        break;
                    case 1:
                        this.y = e;
                        break;
                    case 2:
                        this.z = e;
                        break;
                    case 3:
                        this.w = e;
                        break;
                    default:
                        throw new Error("index is out of range: " + t1);
                }
                return this;
            }
            getComponent(t1) {
                switch(t1){
                    case 0:
                        return this.x;
                    case 1:
                        return this.y;
                    case 2:
                        return this.z;
                    case 3:
                        return this.w;
                    default:
                        throw new Error("index is out of range: " + t1);
                }
            }
            clone() {
                return new this.constructor(this.x, this.y, this.z, this.w);
            }
            copy(t1) {
                return this.x = t1.x, this.y = t1.y, this.z = t1.z, this.w = void 0 !== t1.w ? t1.w : 1, this;
            }
            add(t1) {
                return this.x += t1.x, this.y += t1.y, this.z += t1.z, this.w += t1.w, this;
            }
            addScalar(t1) {
                return this.x += t1, this.y += t1, this.z += t1, this.w += t1, this;
            }
            addVectors(t1, e) {
                return this.x = t1.x + e.x, this.y = t1.y + e.y, this.z = t1.z + e.z, this.w = t1.w + e.w, this;
            }
            addScaledVector(t1, e) {
                return this.x += t1.x * e, this.y += t1.y * e, this.z += t1.z * e, this.w += t1.w * e, this;
            }
            sub(t1) {
                return this.x -= t1.x, this.y -= t1.y, this.z -= t1.z, this.w -= t1.w, this;
            }
            subScalar(t1) {
                return this.x -= t1, this.y -= t1, this.z -= t1, this.w -= t1, this;
            }
            subVectors(t1, e) {
                return this.x = t1.x - e.x, this.y = t1.y - e.y, this.z = t1.z - e.z, this.w = t1.w - e.w, this;
            }
            multiply(t1) {
                return this.x *= t1.x, this.y *= t1.y, this.z *= t1.z, this.w *= t1.w, this;
            }
            multiplyScalar(t1) {
                return this.x *= t1, this.y *= t1, this.z *= t1, this.w *= t1, this;
            }
            applyMatrix4(t1) {
                const e = this.x, i = this.y, n = this.z, r = this.w, a = t1.elements;
                return this.x = a[0] * e + a[4] * i + a[8] * n + a[12] * r, this.y = a[1] * e + a[5] * i + a[9] * n + a[13] * r, this.z = a[2] * e + a[6] * i + a[10] * n + a[14] * r, this.w = a[3] * e + a[7] * i + a[11] * n + a[15] * r, this;
            }
            divideScalar(t1) {
                return this.multiplyScalar(1 / t1);
            }
            setAxisAngleFromQuaternion(t1) {
                this.w = 2 * Math.acos(t1.w);
                const e = Math.sqrt(1 - t1.w * t1.w);
                return e < 1e-4 ? (this.x = 1, this.y = 0, this.z = 0) : (this.x = t1.x / e, this.y = t1.y / e, this.z = t1.z / e), this;
            }
            setAxisAngleFromRotationMatrix(t1) {
                let e, i, n, r;
                const a = .01, s = .1, o = t1.elements, l = o[0], c = o[4], u = o[8], h = o[1], d = o[5], p = o[9], f = o[2], A = o[6], g = o[10];
                if (Math.abs(c - h) < a && Math.abs(u - f) < a && Math.abs(p - A) < a) {
                    if (Math.abs(c + h) < s && Math.abs(u + f) < s && Math.abs(p + A) < s && Math.abs(l + d + g - 3) < s) return this.set(1, 0, 0, 0), this;
                    e = Math.PI;
                    const t1 = (l + 1) / 2, o = (d + 1) / 2, m = (g + 1) / 2, M = (c + h) / 4, y = (u + f) / 4, v = (p + A) / 4;
                    return t1 > o && t1 > m ? t1 < a ? (i = 0, n = .707106781, r = .707106781) : (i = Math.sqrt(t1), n = M / i, r = y / i) : o > m ? o < a ? (i = .707106781, n = 0, r = .707106781) : (n = Math.sqrt(o), i = M / n, r = v / n) : m < a ? (i = .707106781, n = .707106781, r = 0) : (r = Math.sqrt(m), i = y / r, n = v / r), this.set(i, n, r, e), this;
                }
                let m = Math.sqrt((A - p) * (A - p) + (u - f) * (u - f) + (h - c) * (h - c));
                return Math.abs(m) < .001 && (m = 1), this.x = (A - p) / m, this.y = (u - f) / m, this.z = (h - c) / m, this.w = Math.acos((l + d + g - 1) / 2), this;
            }
            min(t1) {
                return this.x = Math.min(this.x, t1.x), this.y = Math.min(this.y, t1.y), this.z = Math.min(this.z, t1.z), this.w = Math.min(this.w, t1.w), this;
            }
            max(t1) {
                return this.x = Math.max(this.x, t1.x), this.y = Math.max(this.y, t1.y), this.z = Math.max(this.z, t1.z), this.w = Math.max(this.w, t1.w), this;
            }
            clamp(t1, e) {
                return this.x = Math.max(t1.x, Math.min(e.x, this.x)), this.y = Math.max(t1.y, Math.min(e.y, this.y)), this.z = Math.max(t1.z, Math.min(e.z, this.z)), this.w = Math.max(t1.w, Math.min(e.w, this.w)), this;
            }
            clampScalar(t1, e) {
                return this.x = Math.max(t1, Math.min(e, this.x)), this.y = Math.max(t1, Math.min(e, this.y)), this.z = Math.max(t1, Math.min(e, this.z)), this.w = Math.max(t1, Math.min(e, this.w)), this;
            }
            clampLength(t1, e) {
                const i = this.length();
                return this.divideScalar(i || 1).multiplyScalar(Math.max(t1, Math.min(e, i)));
            }
            floor() {
                return this.x = Math.floor(this.x), this.y = Math.floor(this.y), this.z = Math.floor(this.z), this.w = Math.floor(this.w), this;
            }
            ceil() {
                return this.x = Math.ceil(this.x), this.y = Math.ceil(this.y), this.z = Math.ceil(this.z), this.w = Math.ceil(this.w), this;
            }
            round() {
                return this.x = Math.round(this.x), this.y = Math.round(this.y), this.z = Math.round(this.z), this.w = Math.round(this.w), this;
            }
            roundToZero() {
                return this.x = Math.trunc(this.x), this.y = Math.trunc(this.y), this.z = Math.trunc(this.z), this.w = Math.trunc(this.w), this;
            }
            negate() {
                return this.x = -this.x, this.y = -this.y, this.z = -this.z, this.w = -this.w, this;
            }
            dot(t1) {
                return this.x * t1.x + this.y * t1.y + this.z * t1.z + this.w * t1.w;
            }
            lengthSq() {
                return this.x * this.x + this.y * this.y + this.z * this.z + this.w * this.w;
            }
            length() {
                return Math.sqrt(this.x * this.x + this.y * this.y + this.z * this.z + this.w * this.w);
            }
            manhattanLength() {
                return Math.abs(this.x) + Math.abs(this.y) + Math.abs(this.z) + Math.abs(this.w);
            }
            normalize() {
                return this.divideScalar(this.length() || 1);
            }
            setLength(t1) {
                return this.normalize().multiplyScalar(t1);
            }
            lerp(t1, e) {
                return this.x += (t1.x - this.x) * e, this.y += (t1.y - this.y) * e, this.z += (t1.z - this.z) * e, this.w += (t1.w - this.w) * e, this;
            }
            lerpVectors(t1, e, i) {
                return this.x = t1.x + (e.x - t1.x) * i, this.y = t1.y + (e.y - t1.y) * i, this.z = t1.z + (e.z - t1.z) * i, this.w = t1.w + (e.w - t1.w) * i, this;
            }
            equals(t1) {
                return t1.x === this.x && t1.y === this.y && t1.z === this.z && t1.w === this.w;
            }
            fromArray(t1, e = 0) {
                return this.x = t1[e], this.y = t1[e + 1], this.z = t1[e + 2], this.w = t1[e + 3], this;
            }
            toArray(t1 = [], e = 0) {
                return t1[e] = this.x, t1[e + 1] = this.y, t1[e + 2] = this.z, t1[e + 3] = this.w, t1;
            }
            fromBufferAttribute(t1, e) {
                return this.x = t1.getX(e), this.y = t1.getY(e), this.z = t1.getZ(e), this.w = t1.getW(e), this;
            }
            random() {
                return this.x = Math.random(), this.y = Math.random(), this.z = Math.random(), this.w = Math.random(), this;
            }
            *[Symbol.iterator]() {
                yield this.x, yield this.y, yield this.z, yield this.w;
            }
        }
        class pl extends So {
            constructor(t1 = 1, e = 1, i = {}){
                super(), this.isRenderTarget = !0, this.width = t1, this.height = e, this.depth = 1, this.scissor = new dl(0, 0, t1, e), this.scissorTest = !1, this.viewport = new dl(0, 0, t1, e);
                const n = {
                    width: t1,
                    height: e,
                    depth: 1
                };
                void 0 !== i.encoding && (Ko("THREE.WebGLRenderTarget: option.encoding has been replaced by option.colorSpace."), i.colorSpace = i.encoding === Ns ? _s : Os), i = Object.assign({
                    generateMipmaps: !1,
                    internalFormat: null,
                    minFilter: la,
                    depthBuffer: !0,
                    stencilBuffer: !1,
                    depthTexture: null,
                    samples: 0
                }, i), this.texture = new hl(n, i.mapping, i.wrapS, i.wrapT, i.magFilter, i.minFilter, i.format, i.type, i.anisotropy, i.colorSpace), this.texture.isRenderTargetTexture = !0, this.texture.flipY = !1, this.texture.generateMipmaps = i.generateMipmaps, this.texture.internalFormat = i.internalFormat, this.depthBuffer = i.depthBuffer, this.stencilBuffer = i.stencilBuffer, this.depthTexture = i.depthTexture, this.samples = i.samples;
            }
            setSize(t1, e, i = 1) {
                this.width === t1 && this.height === e && this.depth === i || (this.width = t1, this.height = e, this.depth = i, this.texture.image.width = t1, this.texture.image.height = e, this.texture.image.depth = i, this.dispose()), this.viewport.set(0, 0, t1, e), this.scissor.set(0, 0, t1, e);
            }
            clone() {
                return (new this.constructor).copy(this);
            }
            copy(t1) {
                this.width = t1.width, this.height = t1.height, this.depth = t1.depth, this.scissor.copy(t1.scissor), this.scissorTest = t1.scissorTest, this.viewport.copy(t1.viewport), this.texture = t1.texture.clone(), this.texture.isRenderTargetTexture = !0;
                const e = Object.assign({}, t1.texture.image);
                return this.texture.source = new ll(e), this.depthBuffer = t1.depthBuffer, this.stencilBuffer = t1.stencilBuffer, null !== t1.depthTexture && (this.depthTexture = t1.depthTexture.clone()), this.samples = t1.samples, this;
            }
            dispose() {
                this.dispatchEvent({
                    type: "dispose"
                });
            }
        }
        class fl extends pl {
            constructor(t1 = 1, e = 1, i = {}){
                super(t1, e, i), this.isWebGLRenderTarget = !0;
            }
        }
        class Al extends hl {
            constructor(t1 = null, e = 1, i = 1, n = 1){
                super(null), this.isDataArrayTexture = !0, this.image = {
                    data: t1,
                    width: e,
                    height: i,
                    depth: n
                }, this.magFilter = na, this.minFilter = na, this.wrapR = ea, this.generateMipmaps = !1, this.flipY = !1, this.unpackAlignment = 1;
            }
        }
        class gl extends fl {
            constructor(t1 = 1, e = 1, i = 1){
                super(t1, e), this.isWebGLArrayRenderTarget = !0, this.depth = i, this.texture = new Al(null, t1, e, i), this.texture.isRenderTargetTexture = !0;
            }
        }
        class ml extends hl {
            constructor(t1 = null, e = 1, i = 1, n = 1){
                super(null), this.isData3DTexture = !0, this.image = {
                    data: t1,
                    width: e,
                    height: i,
                    depth: n
                }, this.magFilter = na, this.minFilter = na, this.wrapR = ea, this.generateMipmaps = !1, this.flipY = !1, this.unpackAlignment = 1;
            }
        }
        class Ml extends fl {
            constructor(t1 = 1, e = 1, i = 1){
                super(t1, e), this.isWebGL3DRenderTarget = !0, this.depth = i, this.texture = new ml(null, t1, e, i), this.texture.isRenderTargetTexture = !0;
            }
        }
        class yl extends fl {
            constructor(t1 = 1, e = 1, i = 1, n = {}){
                super(t1, e, n), this.isWebGLMultipleRenderTargets = !0;
                const r = this.texture;
                this.texture = [];
                for(let t1 = 0; t1 < i; t1++)this.texture[t1] = r.clone(), this.texture[t1].isRenderTargetTexture = !0;
            }
            setSize(t1, e, i = 1) {
                if (this.width !== t1 || this.height !== e || this.depth !== i) {
                    this.width = t1, this.height = e, this.depth = i;
                    for(let n = 0, r = this.texture.length; n < r; n++)this.texture[n].image.width = t1, this.texture[n].image.height = e, this.texture[n].image.depth = i;
                    this.dispose();
                }
                this.viewport.set(0, 0, t1, e), this.scissor.set(0, 0, t1, e);
            }
            copy(t1) {
                this.dispose(), this.width = t1.width, this.height = t1.height, this.depth = t1.depth, this.scissor.copy(t1.scissor), this.scissorTest = t1.scissorTest, this.viewport.copy(t1.viewport), this.depthBuffer = t1.depthBuffer, this.stencilBuffer = t1.stencilBuffer, null !== t1.depthTexture && (this.depthTexture = t1.depthTexture.clone()), this.texture.length = 0;
                for(let e = 0, i = t1.texture.length; e < i; e++)this.texture[e] = t1.texture[e].clone(), this.texture[e].isRenderTargetTexture = !0;
                return this;
            }
        }
        class vl {
            constructor(t1 = 0, e = 0, i = 0, n = 1){
                this.isQuaternion = !0, this._x = t1, this._y = e, this._z = i, this._w = n;
            }
            static slerpFlat(t1, e, i, n, r, a, s) {
                let o = i[n + 0], l = i[n + 1], c = i[n + 2], u = i[n + 3];
                const h = r[a + 0], d = r[a + 1], p = r[a + 2], f = r[a + 3];
                if (0 === s) return t1[e + 0] = o, t1[e + 1] = l, t1[e + 2] = c, void (t1[e + 3] = u);
                if (1 === s) return t1[e + 0] = h, t1[e + 1] = d, t1[e + 2] = p, void (t1[e + 3] = f);
                if (u !== f || o !== h || l !== d || c !== p) {
                    let t1 = 1 - s;
                    const e = o * h + l * d + c * p + u * f, i = e >= 0 ? 1 : -1, n = 1 - e * e;
                    if (n > Number.EPSILON) {
                        const r = Math.sqrt(n), a = Math.atan2(r, e * i);
                        t1 = Math.sin(t1 * a) / r, s = Math.sin(s * a) / r;
                    }
                    const r = s * i;
                    if (o = o * t1 + h * r, l = l * t1 + d * r, c = c * t1 + p * r, u = u * t1 + f * r, t1 === 1 - s) {
                        const t1 = 1 / Math.sqrt(o * o + l * l + c * c + u * u);
                        o *= t1, l *= t1, c *= t1, u *= t1;
                    }
                }
                t1[e] = o, t1[e + 1] = l, t1[e + 2] = c, t1[e + 3] = u;
            }
            static multiplyQuaternionsFlat(t1, e, i, n, r, a) {
                const s = i[n], o = i[n + 1], l = i[n + 2], c = i[n + 3], u = r[a], h = r[a + 1], d = r[a + 2], p = r[a + 3];
                return t1[e] = s * p + c * u + o * d - l * h, t1[e + 1] = o * p + c * h + l * u - s * d, t1[e + 2] = l * p + c * d + s * h - o * u, t1[e + 3] = c * p - s * u - o * h - l * d, t1;
            }
            get x() {
                return this._x;
            }
            set x(t1) {
                this._x = t1, this._onChangeCallback();
            }
            get y() {
                return this._y;
            }
            set y(t1) {
                this._y = t1, this._onChangeCallback();
            }
            get z() {
                return this._z;
            }
            set z(t1) {
                this._z = t1, this._onChangeCallback();
            }
            get w() {
                return this._w;
            }
            set w(t1) {
                this._w = t1, this._onChangeCallback();
            }
            set(t1, e, i, n) {
                return this._x = t1, this._y = e, this._z = i, this._w = n, this._onChangeCallback(), this;
            }
            clone() {
                return new this.constructor(this._x, this._y, this._z, this._w);
            }
            copy(t1) {
                return this._x = t1.x, this._y = t1.y, this._z = t1.z, this._w = t1.w, this._onChangeCallback(), this;
            }
            setFromEuler(t1, e) {
                const i = t1._x, n = t1._y, r = t1._z, a = t1._order, s = Math.cos, o = Math.sin, l = s(i / 2), c = s(n / 2), u = s(r / 2), h = o(i / 2), d = o(n / 2), p = o(r / 2);
                switch(a){
                    case "XYZ":
                        this._x = h * c * u + l * d * p, this._y = l * d * u - h * c * p, this._z = l * c * p + h * d * u, this._w = l * c * u - h * d * p;
                        break;
                    case "YXZ":
                        this._x = h * c * u + l * d * p, this._y = l * d * u - h * c * p, this._z = l * c * p - h * d * u, this._w = l * c * u + h * d * p;
                        break;
                    case "ZXY":
                        this._x = h * c * u - l * d * p, this._y = l * d * u + h * c * p, this._z = l * c * p + h * d * u, this._w = l * c * u - h * d * p;
                        break;
                    case "ZYX":
                        this._x = h * c * u - l * d * p, this._y = l * d * u + h * c * p, this._z = l * c * p - h * d * u, this._w = l * c * u + h * d * p;
                        break;
                    case "YZX":
                        this._x = h * c * u + l * d * p, this._y = l * d * u + h * c * p, this._z = l * c * p - h * d * u, this._w = l * c * u - h * d * p;
                        break;
                    case "XZY":
                        this._x = h * c * u - l * d * p, this._y = l * d * u - h * c * p, this._z = l * c * p + h * d * u, this._w = l * c * u + h * d * p;
                        break;
                    default:
                        console.warn("THREE.Quaternion: .setFromEuler() encountered an unknown order: " + a);
                }
                return !1 !== e && this._onChangeCallback(), this;
            }
            setFromAxisAngle(t1, e) {
                const i = e / 2, n = Math.sin(i);
                return this._x = t1.x * n, this._y = t1.y * n, this._z = t1.z * n, this._w = Math.cos(i), this._onChangeCallback(), this;
            }
            setFromRotationMatrix(t1) {
                const e = t1.elements, i = e[0], n = e[4], r = e[8], a = e[1], s = e[5], o = e[9], l = e[2], c = e[6], u = e[10], h = i + s + u;
                if (h > 0) {
                    const t1 = .5 / Math.sqrt(h + 1);
                    this._w = .25 / t1, this._x = (c - o) * t1, this._y = (r - l) * t1, this._z = (a - n) * t1;
                } else if (i > s && i > u) {
                    const t1 = 2 * Math.sqrt(1 + i - s - u);
                    this._w = (c - o) / t1, this._x = .25 * t1, this._y = (n + a) / t1, this._z = (r + l) / t1;
                } else if (s > u) {
                    const t1 = 2 * Math.sqrt(1 + s - i - u);
                    this._w = (r - l) / t1, this._x = (n + a) / t1, this._y = .25 * t1, this._z = (o + c) / t1;
                } else {
                    const t1 = 2 * Math.sqrt(1 + u - i - s);
                    this._w = (a - n) / t1, this._x = (r + l) / t1, this._y = (o + c) / t1, this._z = .25 * t1;
                }
                return this._onChangeCallback(), this;
            }
            setFromUnitVectors(t1, e) {
                let i = t1.dot(e) + 1;
                return i < Number.EPSILON ? (i = 0, Math.abs(t1.x) > Math.abs(t1.z) ? (this._x = -t1.y, this._y = t1.x, this._z = 0, this._w = i) : (this._x = 0, this._y = -t1.z, this._z = t1.y, this._w = i)) : (this._x = t1.y * e.z - t1.z * e.y, this._y = t1.z * e.x - t1.x * e.z, this._z = t1.x * e.y - t1.y * e.x, this._w = i), this.normalize();
            }
            angleTo(t1) {
                return 2 * Math.acos(Math.abs(Oo(this.dot(t1), -1, 1)));
            }
            rotateTowards(t1, e) {
                const i = this.angleTo(t1);
                if (0 === i) return this;
                const n = Math.min(1, e / i);
                return this.slerp(t1, n), this;
            }
            identity() {
                return this.set(0, 0, 0, 1);
            }
            invert() {
                return this.conjugate();
            }
            conjugate() {
                return this._x *= -1, this._y *= -1, this._z *= -1, this._onChangeCallback(), this;
            }
            dot(t1) {
                return this._x * t1._x + this._y * t1._y + this._z * t1._z + this._w * t1._w;
            }
            lengthSq() {
                return this._x * this._x + this._y * this._y + this._z * this._z + this._w * this._w;
            }
            length() {
                return Math.sqrt(this._x * this._x + this._y * this._y + this._z * this._z + this._w * this._w);
            }
            normalize() {
                let t1 = this.length();
                return 0 === t1 ? (this._x = 0, this._y = 0, this._z = 0, this._w = 1) : (t1 = 1 / t1, this._x = this._x * t1, this._y = this._y * t1, this._z = this._z * t1, this._w = this._w * t1), this._onChangeCallback(), this;
            }
            multiply(t1) {
                return this.multiplyQuaternions(this, t1);
            }
            premultiply(t1) {
                return this.multiplyQuaternions(t1, this);
            }
            multiplyQuaternions(t1, e) {
                const i = t1._x, n = t1._y, r = t1._z, a = t1._w, s = e._x, o = e._y, l = e._z, c = e._w;
                return this._x = i * c + a * s + n * l - r * o, this._y = n * c + a * o + r * s - i * l, this._z = r * c + a * l + i * o - n * s, this._w = a * c - i * s - n * o - r * l, this._onChangeCallback(), this;
            }
            slerp(t1, e) {
                if (0 === e) return this;
                if (1 === e) return this.copy(t1);
                const i = this._x, n = this._y, r = this._z, a = this._w;
                let s = a * t1._w + i * t1._x + n * t1._y + r * t1._z;
                if (s < 0 ? (this._w = -t1._w, this._x = -t1._x, this._y = -t1._y, this._z = -t1._z, s = -s) : this.copy(t1), s >= 1) return this._w = a, this._x = i, this._y = n, this._z = r, this;
                const o = 1 - s * s;
                if (o <= Number.EPSILON) {
                    const t1 = 1 - e;
                    return this._w = t1 * a + e * this._w, this._x = t1 * i + e * this._x, this._y = t1 * n + e * this._y, this._z = t1 * r + e * this._z, this.normalize(), this._onChangeCallback(), this;
                }
                const l = Math.sqrt(o), c = Math.atan2(l, s), u = Math.sin((1 - e) * c) / l, h = Math.sin(e * c) / l;
                return this._w = a * u + this._w * h, this._x = i * u + this._x * h, this._y = n * u + this._y * h, this._z = r * u + this._z * h, this._onChangeCallback(), this;
            }
            slerpQuaternions(t1, e, i) {
                return this.copy(t1).slerp(e, i);
            }
            random() {
                const t1 = Math.random(), e = Math.sqrt(1 - t1), i = Math.sqrt(t1), n = 2 * Math.PI * Math.random(), r = 2 * Math.PI * Math.random();
                return this.set(e * Math.cos(n), i * Math.sin(r), i * Math.cos(r), e * Math.sin(n));
            }
            equals(t1) {
                return t1._x === this._x && t1._y === this._y && t1._z === this._z && t1._w === this._w;
            }
            fromArray(t1, e = 0) {
                return this._x = t1[e], this._y = t1[e + 1], this._z = t1[e + 2], this._w = t1[e + 3], this._onChangeCallback(), this;
            }
            toArray(t1 = [], e = 0) {
                return t1[e] = this._x, t1[e + 1] = this._y, t1[e + 2] = this._z, t1[e + 3] = this._w, t1;
            }
            fromBufferAttribute(t1, e) {
                return this._x = t1.getX(e), this._y = t1.getY(e), this._z = t1.getZ(e), this._w = t1.getW(e), this;
            }
            toJSON() {
                return this.toArray();
            }
            _onChange(t1) {
                return this._onChangeCallback = t1, this;
            }
            _onChangeCallback() {}
            *[Symbol.iterator]() {
                yield this._x, yield this._y, yield this._z, yield this._w;
            }
        }
        class xl {
            constructor(t1 = 0, e = 0, i = 0){
                xl.prototype.isVector3 = !0, this.x = t1, this.y = e, this.z = i;
            }
            set(t1, e, i) {
                return void 0 === i && (i = this.z), this.x = t1, this.y = e, this.z = i, this;
            }
            setScalar(t1) {
                return this.x = t1, this.y = t1, this.z = t1, this;
            }
            setX(t1) {
                return this.x = t1, this;
            }
            setY(t1) {
                return this.y = t1, this;
            }
            setZ(t1) {
                return this.z = t1, this;
            }
            setComponent(t1, e) {
                switch(t1){
                    case 0:
                        this.x = e;
                        break;
                    case 1:
                        this.y = e;
                        break;
                    case 2:
                        this.z = e;
                        break;
                    default:
                        throw new Error("index is out of range: " + t1);
                }
                return this;
            }
            getComponent(t1) {
                switch(t1){
                    case 0:
                        return this.x;
                    case 1:
                        return this.y;
                    case 2:
                        return this.z;
                    default:
                        throw new Error("index is out of range: " + t1);
                }
            }
            clone() {
                return new this.constructor(this.x, this.y, this.z);
            }
            copy(t1) {
                return this.x = t1.x, this.y = t1.y, this.z = t1.z, this;
            }
            add(t1) {
                return this.x += t1.x, this.y += t1.y, this.z += t1.z, this;
            }
            addScalar(t1) {
                return this.x += t1, this.y += t1, this.z += t1, this;
            }
            addVectors(t1, e) {
                return this.x = t1.x + e.x, this.y = t1.y + e.y, this.z = t1.z + e.z, this;
            }
            addScaledVector(t1, e) {
                return this.x += t1.x * e, this.y += t1.y * e, this.z += t1.z * e, this;
            }
            sub(t1) {
                return this.x -= t1.x, this.y -= t1.y, this.z -= t1.z, this;
            }
            subScalar(t1) {
                return this.x -= t1, this.y -= t1, this.z -= t1, this;
            }
            subVectors(t1, e) {
                return this.x = t1.x - e.x, this.y = t1.y - e.y, this.z = t1.z - e.z, this;
            }
            multiply(t1) {
                return this.x *= t1.x, this.y *= t1.y, this.z *= t1.z, this;
            }
            multiplyScalar(t1) {
                return this.x *= t1, this.y *= t1, this.z *= t1, this;
            }
            multiplyVectors(t1, e) {
                return this.x = t1.x * e.x, this.y = t1.y * e.y, this.z = t1.z * e.z, this;
            }
            applyEuler(t1) {
                return this.applyQuaternion(bl.setFromEuler(t1));
            }
            applyAxisAngle(t1, e) {
                return this.applyQuaternion(bl.setFromAxisAngle(t1, e));
            }
            applyMatrix3(t1) {
                const e = this.x, i = this.y, n = this.z, r = t1.elements;
                return this.x = r[0] * e + r[3] * i + r[6] * n, this.y = r[1] * e + r[4] * i + r[7] * n, this.z = r[2] * e + r[5] * i + r[8] * n, this;
            }
            applyNormalMatrix(t1) {
                return this.applyMatrix3(t1).normalize();
            }
            applyMatrix4(t1) {
                const e = this.x, i = this.y, n = this.z, r = t1.elements, a = 1 / (r[3] * e + r[7] * i + r[11] * n + r[15]);
                return this.x = (r[0] * e + r[4] * i + r[8] * n + r[12]) * a, this.y = (r[1] * e + r[5] * i + r[9] * n + r[13]) * a, this.z = (r[2] * e + r[6] * i + r[10] * n + r[14]) * a, this;
            }
            applyQuaternion(t1) {
                const e = this.x, i = this.y, n = this.z, r = t1.x, a = t1.y, s = t1.z, o = t1.w, l = 2 * (a * n - s * i), c = 2 * (s * e - r * n), u = 2 * (r * i - a * e);
                return this.x = e + o * l + a * u - s * c, this.y = i + o * c + s * l - r * u, this.z = n + o * u + r * c - a * l, this;
            }
            project(t1) {
                return this.applyMatrix4(t1.matrixWorldInverse).applyMatrix4(t1.projectionMatrix);
            }
            unproject(t1) {
                return this.applyMatrix4(t1.projectionMatrixInverse).applyMatrix4(t1.matrixWorld);
            }
            transformDirection(t1) {
                const e = this.x, i = this.y, n = this.z, r = t1.elements;
                return this.x = r[0] * e + r[4] * i + r[8] * n, this.y = r[1] * e + r[5] * i + r[9] * n, this.z = r[2] * e + r[6] * i + r[10] * n, this.normalize();
            }
            divide(t1) {
                return this.x /= t1.x, this.y /= t1.y, this.z /= t1.z, this;
            }
            divideScalar(t1) {
                return this.multiplyScalar(1 / t1);
            }
            min(t1) {
                return this.x = Math.min(this.x, t1.x), this.y = Math.min(this.y, t1.y), this.z = Math.min(this.z, t1.z), this;
            }
            max(t1) {
                return this.x = Math.max(this.x, t1.x), this.y = Math.max(this.y, t1.y), this.z = Math.max(this.z, t1.z), this;
            }
            clamp(t1, e) {
                return this.x = Math.max(t1.x, Math.min(e.x, this.x)), this.y = Math.max(t1.y, Math.min(e.y, this.y)), this.z = Math.max(t1.z, Math.min(e.z, this.z)), this;
            }
            clampScalar(t1, e) {
                return this.x = Math.max(t1, Math.min(e, this.x)), this.y = Math.max(t1, Math.min(e, this.y)), this.z = Math.max(t1, Math.min(e, this.z)), this;
            }
            clampLength(t1, e) {
                const i = this.length();
                return this.divideScalar(i || 1).multiplyScalar(Math.max(t1, Math.min(e, i)));
            }
            floor() {
                return this.x = Math.floor(this.x), this.y = Math.floor(this.y), this.z = Math.floor(this.z), this;
            }
            ceil() {
                return this.x = Math.ceil(this.x), this.y = Math.ceil(this.y), this.z = Math.ceil(this.z), this;
            }
            round() {
                return this.x = Math.round(this.x), this.y = Math.round(this.y), this.z = Math.round(this.z), this;
            }
            roundToZero() {
                return this.x = Math.trunc(this.x), this.y = Math.trunc(this.y), this.z = Math.trunc(this.z), this;
            }
            negate() {
                return this.x = -this.x, this.y = -this.y, this.z = -this.z, this;
            }
            dot(t1) {
                return this.x * t1.x + this.y * t1.y + this.z * t1.z;
            }
            lengthSq() {
                return this.x * this.x + this.y * this.y + this.z * this.z;
            }
            length() {
                return Math.sqrt(this.x * this.x + this.y * this.y + this.z * this.z);
            }
            manhattanLength() {
                return Math.abs(this.x) + Math.abs(this.y) + Math.abs(this.z);
            }
            normalize() {
                return this.divideScalar(this.length() || 1);
            }
            setLength(t1) {
                return this.normalize().multiplyScalar(t1);
            }
            lerp(t1, e) {
                return this.x += (t1.x - this.x) * e, this.y += (t1.y - this.y) * e, this.z += (t1.z - this.z) * e, this;
            }
            lerpVectors(t1, e, i) {
                return this.x = t1.x + (e.x - t1.x) * i, this.y = t1.y + (e.y - t1.y) * i, this.z = t1.z + (e.z - t1.z) * i, this;
            }
            cross(t1) {
                return this.crossVectors(this, t1);
            }
            crossVectors(t1, e) {
                const i = t1.x, n = t1.y, r = t1.z, a = e.x, s = e.y, o = e.z;
                return this.x = n * o - r * s, this.y = r * a - i * o, this.z = i * s - n * a, this;
            }
            projectOnVector(t1) {
                const e = t1.lengthSq();
                if (0 === e) return this.set(0, 0, 0);
                const i = t1.dot(this) / e;
                return this.copy(t1).multiplyScalar(i);
            }
            projectOnPlane(t1) {
                return wl.copy(this).projectOnVector(t1), this.sub(wl);
            }
            reflect(t1) {
                return this.sub(wl.copy(t1).multiplyScalar(2 * this.dot(t1)));
            }
            angleTo(t1) {
                const e = Math.sqrt(this.lengthSq() * t1.lengthSq());
                if (0 === e) return Math.PI / 2;
                const i = this.dot(t1) / e;
                return Math.acos(Oo(i, -1, 1));
            }
            distanceTo(t1) {
                return Math.sqrt(this.distanceToSquared(t1));
            }
            distanceToSquared(t1) {
                const e = this.x - t1.x, i = this.y - t1.y, n = this.z - t1.z;
                return e * e + i * i + n * n;
            }
            manhattanDistanceTo(t1) {
                return Math.abs(this.x - t1.x) + Math.abs(this.y - t1.y) + Math.abs(this.z - t1.z);
            }
            setFromSpherical(t1) {
                return this.setFromSphericalCoords(t1.radius, t1.phi, t1.theta);
            }
            setFromSphericalCoords(t1, e, i) {
                const n = Math.sin(e) * t1;
                return this.x = n * Math.sin(i), this.y = Math.cos(e) * t1, this.z = n * Math.cos(i), this;
            }
            setFromCylindrical(t1) {
                return this.setFromCylindricalCoords(t1.radius, t1.theta, t1.y);
            }
            setFromCylindricalCoords(t1, e, i) {
                return this.x = t1 * Math.sin(e), this.y = i, this.z = t1 * Math.cos(e), this;
            }
            setFromMatrixPosition(t1) {
                const e = t1.elements;
                return this.x = e[12], this.y = e[13], this.z = e[14], this;
            }
            setFromMatrixScale(t1) {
                const e = this.setFromMatrixColumn(t1, 0).length(), i = this.setFromMatrixColumn(t1, 1).length(), n = this.setFromMatrixColumn(t1, 2).length();
                return this.x = e, this.y = i, this.z = n, this;
            }
            setFromMatrixColumn(t1, e) {
                return this.fromArray(t1.elements, 4 * e);
            }
            setFromMatrix3Column(t1, e) {
                return this.fromArray(t1.elements, 3 * e);
            }
            setFromEuler(t1) {
                return this.x = t1._x, this.y = t1._y, this.z = t1._z, this;
            }
            setFromColor(t1) {
                return this.x = t1.r, this.y = t1.g, this.z = t1.b, this;
            }
            equals(t1) {
                return t1.x === this.x && t1.y === this.y && t1.z === this.z;
            }
            fromArray(t1, e = 0) {
                return this.x = t1[e], this.y = t1[e + 1], this.z = t1[e + 2], this;
            }
            toArray(t1 = [], e = 0) {
                return t1[e] = this.x, t1[e + 1] = this.y, t1[e + 2] = this.z, t1;
            }
            fromBufferAttribute(t1, e) {
                return this.x = t1.getX(e), this.y = t1.getY(e), this.z = t1.getZ(e), this;
            }
            random() {
                return this.x = Math.random(), this.y = Math.random(), this.z = Math.random(), this;
            }
            randomDirection() {
                const t1 = 2 * (Math.random() - .5), e = Math.random() * Math.PI * 2, i = Math.sqrt(1 - t1 ** 2);
                return this.x = i * Math.cos(e), this.y = i * Math.sin(e), this.z = t1, this;
            }
            *[Symbol.iterator]() {
                yield this.x, yield this.y, yield this.z;
            }
        }
        const wl = new xl, bl = new vl;
        class Tl {
            constructor(t1 = new xl(1 / 0, 1 / 0, 1 / 0), e = new xl(-1 / 0, -1 / 0, -1 / 0)){
                this.isBox3 = !0, this.min = t1, this.max = e;
            }
            set(t1, e) {
                return this.min.copy(t1), this.max.copy(e), this;
            }
            setFromArray(t1) {
                this.makeEmpty();
                for(let e = 0, i = t1.length; e < i; e += 3)this.expandByPoint(Il.fromArray(t1, e));
                return this;
            }
            setFromBufferAttribute(t1) {
                this.makeEmpty();
                for(let e = 0, i = t1.count; e < i; e++)this.expandByPoint(Il.fromBufferAttribute(t1, e));
                return this;
            }
            setFromPoints(t1) {
                this.makeEmpty();
                for(let e = 0, i = t1.length; e < i; e++)this.expandByPoint(t1[e]);
                return this;
            }
            setFromCenterAndSize(t1, e) {
                const i = Il.copy(e).multiplyScalar(.5);
                return this.min.copy(t1).sub(i), this.max.copy(t1).add(i), this;
            }
            setFromObject(t1, e = !1) {
                return this.makeEmpty(), this.expandByObject(t1, e);
            }
            clone() {
                return (new this.constructor).copy(this);
            }
            copy(t1) {
                return this.min.copy(t1.min), this.max.copy(t1.max), this;
            }
            makeEmpty() {
                return this.min.x = this.min.y = this.min.z = 1 / 0, this.max.x = this.max.y = this.max.z = -1 / 0, this;
            }
            isEmpty() {
                return this.max.x < this.min.x || this.max.y < this.min.y || this.max.z < this.min.z;
            }
            getCenter(t1) {
                return this.isEmpty() ? t1.set(0, 0, 0) : t1.addVectors(this.min, this.max).multiplyScalar(.5);
            }
            getSize(t1) {
                return this.isEmpty() ? t1.set(0, 0, 0) : t1.subVectors(this.max, this.min);
            }
            expandByPoint(t1) {
                return this.min.min(t1), this.max.max(t1), this;
            }
            expandByVector(t1) {
                return this.min.sub(t1), this.max.add(t1), this;
            }
            expandByScalar(t1) {
                return this.min.addScalar(-t1), this.max.addScalar(t1), this;
            }
            expandByObject(t1, e = !1) {
                t1.updateWorldMatrix(!1, !1);
                const i = t1.geometry;
                if (void 0 !== i) {
                    const n = i.getAttribute("position");
                    if (!0 === e && void 0 !== n && !0 !== t1.isInstancedMesh) for(let e = 0, i = n.count; e < i; e++)!0 === t1.isMesh ? t1.getVertexPosition(e, Il) : Il.fromBufferAttribute(n, e), Il.applyMatrix4(t1.matrixWorld), this.expandByPoint(Il);
                    else void 0 !== t1.boundingBox ? (null === t1.boundingBox && t1.computeBoundingBox(), Sl.copy(t1.boundingBox)) : (null === i.boundingBox && i.computeBoundingBox(), Sl.copy(i.boundingBox)), Sl.applyMatrix4(t1.matrixWorld), this.union(Sl);
                }
                const n = t1.children;
                for(let t1 = 0, i = n.length; t1 < i; t1++)this.expandByObject(n[t1], e);
                return this;
            }
            containsPoint(t1) {
                return !(t1.x < this.min.x || t1.x > this.max.x || t1.y < this.min.y || t1.y > this.max.y || t1.z < this.min.z || t1.z > this.max.z);
            }
            containsBox(t1) {
                return this.min.x <= t1.min.x && t1.max.x <= this.max.x && this.min.y <= t1.min.y && t1.max.y <= this.max.y && this.min.z <= t1.min.z && t1.max.z <= this.max.z;
            }
            getParameter(t1, e) {
                return e.set((t1.x - this.min.x) / (this.max.x - this.min.x), (t1.y - this.min.y) / (this.max.y - this.min.y), (t1.z - this.min.z) / (this.max.z - this.min.z));
            }
            intersectsBox(t1) {
                return !(t1.max.x < this.min.x || t1.min.x > this.max.x || t1.max.y < this.min.y || t1.min.y > this.max.y || t1.max.z < this.min.z || t1.min.z > this.max.z);
            }
            intersectsSphere(t1) {
                return this.clampPoint(t1.center, Il), Il.distanceToSquared(t1.center) <= t1.radius * t1.radius;
            }
            intersectsPlane(t1) {
                let e, i;
                return t1.normal.x > 0 ? (e = t1.normal.x * this.min.x, i = t1.normal.x * this.max.x) : (e = t1.normal.x * this.max.x, i = t1.normal.x * this.min.x), t1.normal.y > 0 ? (e += t1.normal.y * this.min.y, i += t1.normal.y * this.max.y) : (e += t1.normal.y * this.max.y, i += t1.normal.y * this.min.y), t1.normal.z > 0 ? (e += t1.normal.z * this.min.z, i += t1.normal.z * this.max.z) : (e += t1.normal.z * this.max.z, i += t1.normal.z * this.min.z), e <= -t1.constant && i >= -t1.constant;
            }
            intersectsTriangle(t1) {
                if (this.isEmpty()) return !1;
                this.getCenter(_l), jl.subVectors(this.max, _l), Nl.subVectors(t1.a, _l), Dl.subVectors(t1.b, _l), Cl.subVectors(t1.c, _l), zl.subVectors(Dl, Nl), Ll.subVectors(Cl, Dl), Ol.subVectors(Nl, Cl);
                let e = [
                    0,
                    -zl.z,
                    zl.y,
                    0,
                    -Ll.z,
                    Ll.y,
                    0,
                    -Ol.z,
                    Ol.y,
                    zl.z,
                    0,
                    -zl.x,
                    Ll.z,
                    0,
                    -Ll.x,
                    Ol.z,
                    0,
                    -Ol.x,
                    -zl.y,
                    zl.x,
                    0,
                    -Ll.y,
                    Ll.x,
                    0,
                    -Ol.y,
                    Ol.x,
                    0
                ];
                return !!Ul(e, Nl, Dl, Cl, jl) && (e = [
                    1,
                    0,
                    0,
                    0,
                    1,
                    0,
                    0,
                    0,
                    1
                ], !!Ul(e, Nl, Dl, Cl, jl) && (Pl.crossVectors(zl, Ll), e = [
                    Pl.x,
                    Pl.y,
                    Pl.z
                ], Ul(e, Nl, Dl, Cl, jl)));
            }
            clampPoint(t1, e) {
                return e.copy(t1).clamp(this.min, this.max);
            }
            distanceToPoint(t1) {
                return this.clampPoint(t1, Il).distanceTo(t1);
            }
            getBoundingSphere(t1) {
                return this.isEmpty() ? t1.makeEmpty() : (this.getCenter(t1.center), t1.radius = .5 * this.getSize(Il).length()), t1;
            }
            intersect(t1) {
                return this.min.max(t1.min), this.max.min(t1.max), this.isEmpty() && this.makeEmpty(), this;
            }
            union(t1) {
                return this.min.min(t1.min), this.max.max(t1.max), this;
            }
            applyMatrix4(t1) {
                return this.isEmpty() || (El[0].set(this.min.x, this.min.y, this.min.z).applyMatrix4(t1), El[1].set(this.min.x, this.min.y, this.max.z).applyMatrix4(t1), El[2].set(this.min.x, this.max.y, this.min.z).applyMatrix4(t1), El[3].set(this.min.x, this.max.y, this.max.z).applyMatrix4(t1), El[4].set(this.max.x, this.min.y, this.min.z).applyMatrix4(t1), El[5].set(this.max.x, this.min.y, this.max.z).applyMatrix4(t1), El[6].set(this.max.x, this.max.y, this.min.z).applyMatrix4(t1), El[7].set(this.max.x, this.max.y, this.max.z).applyMatrix4(t1), this.setFromPoints(El)), this;
            }
            translate(t1) {
                return this.min.add(t1), this.max.add(t1), this;
            }
            equals(t1) {
                return t1.min.equals(this.min) && t1.max.equals(this.max);
            }
        }
        const El = [
            new xl,
            new xl,
            new xl,
            new xl,
            new xl,
            new xl,
            new xl,
            new xl
        ], Il = new xl, Sl = new Tl, Nl = new xl, Dl = new xl, Cl = new xl, zl = new xl, Ll = new xl, Ol = new xl, _l = new xl, jl = new xl, Pl = new xl, Rl = new xl;
        function Ul(t1, e, i, n, r) {
            for(let a = 0, s = t1.length - 3; a <= s; a += 3){
                Rl.fromArray(t1, a);
                const s = r.x * Math.abs(Rl.x) + r.y * Math.abs(Rl.y) + r.z * Math.abs(Rl.z), o = e.dot(Rl), l = i.dot(Rl), c = n.dot(Rl);
                if (Math.max(-Math.max(o, l, c), Math.min(o, l, c)) > s) return !1;
            }
            return !0;
        }
        const kl = new Tl, Bl = new xl, Fl = new xl;
        class Ql {
            constructor(t1 = new xl, e = -1){
                this.center = t1, this.radius = e;
            }
            set(t1, e) {
                return this.center.copy(t1), this.radius = e, this;
            }
            setFromPoints(t1, e) {
                const i = this.center;
                void 0 !== e ? i.copy(e) : kl.setFromPoints(t1).getCenter(i);
                let n = 0;
                for(let e = 0, r = t1.length; e < r; e++)n = Math.max(n, i.distanceToSquared(t1[e]));
                return this.radius = Math.sqrt(n), this;
            }
            copy(t1) {
                return this.center.copy(t1.center), this.radius = t1.radius, this;
            }
            isEmpty() {
                return this.radius < 0;
            }
            makeEmpty() {
                return this.center.set(0, 0, 0), this.radius = -1, this;
            }
            containsPoint(t1) {
                return t1.distanceToSquared(this.center) <= this.radius * this.radius;
            }
            distanceToPoint(t1) {
                return t1.distanceTo(this.center) - this.radius;
            }
            intersectsSphere(t1) {
                const e = this.radius + t1.radius;
                return t1.center.distanceToSquared(this.center) <= e * e;
            }
            intersectsBox(t1) {
                return t1.intersectsSphere(this);
            }
            intersectsPlane(t1) {
                return Math.abs(t1.distanceToPoint(this.center)) <= this.radius;
            }
            clampPoint(t1, e) {
                const i = this.center.distanceToSquared(t1);
                return e.copy(t1), i > this.radius * this.radius && (e.sub(this.center).normalize(), e.multiplyScalar(this.radius).add(this.center)), e;
            }
            getBoundingBox(t1) {
                return this.isEmpty() ? (t1.makeEmpty(), t1) : (t1.set(this.center, this.center), t1.expandByScalar(this.radius), t1);
            }
            applyMatrix4(t1) {
                return this.center.applyMatrix4(t1), this.radius = this.radius * t1.getMaxScaleOnAxis(), this;
            }
            translate(t1) {
                return this.center.add(t1), this;
            }
            expandByPoint(t1) {
                if (this.isEmpty()) return this.center.copy(t1), this.radius = 0, this;
                Bl.subVectors(t1, this.center);
                const e = Bl.lengthSq();
                if (e > this.radius * this.radius) {
                    const t1 = Math.sqrt(e), i = .5 * (t1 - this.radius);
                    this.center.addScaledVector(Bl, i / t1), this.radius += i;
                }
                return this;
            }
            union(t1) {
                return t1.isEmpty() ? this : this.isEmpty() ? (this.copy(t1), this) : (!0 === this.center.equals(t1.center) ? this.radius = Math.max(this.radius, t1.radius) : (Fl.subVectors(t1.center, this.center).setLength(t1.radius), this.expandByPoint(Bl.copy(t1.center).add(Fl)), this.expandByPoint(Bl.copy(t1.center).sub(Fl))), this);
            }
            equals(t1) {
                return t1.center.equals(this.center) && t1.radius === this.radius;
            }
            clone() {
                return (new this.constructor).copy(this);
            }
        }
        const Hl = new xl, Vl = new xl, Gl = new xl, Yl = new xl, Wl = new xl, Xl = new xl, Zl = new xl;
        class Jl {
            constructor(t1 = new xl, e = new xl(0, 0, -1)){
                this.origin = t1, this.direction = e;
            }
            set(t1, e) {
                return this.origin.copy(t1), this.direction.copy(e), this;
            }
            copy(t1) {
                return this.origin.copy(t1.origin), this.direction.copy(t1.direction), this;
            }
            at(t1, e) {
                return e.copy(this.origin).addScaledVector(this.direction, t1);
            }
            lookAt(t1) {
                return this.direction.copy(t1).sub(this.origin).normalize(), this;
            }
            recast(t1) {
                return this.origin.copy(this.at(t1, Hl)), this;
            }
            closestPointToPoint(t1, e) {
                e.subVectors(t1, this.origin);
                const i = e.dot(this.direction);
                return i < 0 ? e.copy(this.origin) : e.copy(this.origin).addScaledVector(this.direction, i);
            }
            distanceToPoint(t1) {
                return Math.sqrt(this.distanceSqToPoint(t1));
            }
            distanceSqToPoint(t1) {
                const e = Hl.subVectors(t1, this.origin).dot(this.direction);
                return e < 0 ? this.origin.distanceToSquared(t1) : (Hl.copy(this.origin).addScaledVector(this.direction, e), Hl.distanceToSquared(t1));
            }
            distanceSqToSegment(t1, e, i, n) {
                Vl.copy(t1).add(e).multiplyScalar(.5), Gl.copy(e).sub(t1).normalize(), Yl.copy(this.origin).sub(Vl);
                const r = .5 * t1.distanceTo(e), a = -this.direction.dot(Gl), s = Yl.dot(this.direction), o = -Yl.dot(Gl), l = Yl.lengthSq(), c = Math.abs(1 - a * a);
                let u, h, d, p;
                if (c > 0) {
                    if (u = a * o - s, h = a * s - o, p = r * c, u >= 0) {
                        if (h >= -p) {
                            if (h <= p) {
                                const t1 = 1 / c;
                                u *= t1, h *= t1, d = u * (u + a * h + 2 * s) + h * (a * u + h + 2 * o) + l;
                            } else h = r, u = Math.max(0, -(a * h + s)), d = -u * u + h * (h + 2 * o) + l;
                        } else h = -r, u = Math.max(0, -(a * h + s)), d = -u * u + h * (h + 2 * o) + l;
                    } else h <= -p ? (u = Math.max(0, -(-a * r + s)), h = u > 0 ? -r : Math.min(Math.max(-r, -o), r), d = -u * u + h * (h + 2 * o) + l) : h <= p ? (u = 0, h = Math.min(Math.max(-r, -o), r), d = h * (h + 2 * o) + l) : (u = Math.max(0, -(a * r + s)), h = u > 0 ? r : Math.min(Math.max(-r, -o), r), d = -u * u + h * (h + 2 * o) + l);
                } else h = a > 0 ? -r : r, u = Math.max(0, -(a * h + s)), d = -u * u + h * (h + 2 * o) + l;
                return i && i.copy(this.origin).addScaledVector(this.direction, u), n && n.copy(Vl).addScaledVector(Gl, h), d;
            }
            intersectSphere(t1, e) {
                Hl.subVectors(t1.center, this.origin);
                const i = Hl.dot(this.direction), n = Hl.dot(Hl) - i * i, r = t1.radius * t1.radius;
                if (n > r) return null;
                const a = Math.sqrt(r - n), s = i - a, o = i + a;
                return o < 0 ? null : s < 0 ? this.at(o, e) : this.at(s, e);
            }
            intersectsSphere(t1) {
                return this.distanceSqToPoint(t1.center) <= t1.radius * t1.radius;
            }
            distanceToPlane(t1) {
                const e = t1.normal.dot(this.direction);
                if (0 === e) return 0 === t1.distanceToPoint(this.origin) ? 0 : null;
                const i = -(this.origin.dot(t1.normal) + t1.constant) / e;
                return i >= 0 ? i : null;
            }
            intersectPlane(t1, e) {
                const i = this.distanceToPlane(t1);
                return null === i ? null : this.at(i, e);
            }
            intersectsPlane(t1) {
                const e = t1.distanceToPoint(this.origin);
                return 0 === e || t1.normal.dot(this.direction) * e < 0;
            }
            intersectBox(t1, e) {
                let i, n, r, a, s, o;
                const l = 1 / this.direction.x, c = 1 / this.direction.y, u = 1 / this.direction.z, h = this.origin;
                return l >= 0 ? (i = (t1.min.x - h.x) * l, n = (t1.max.x - h.x) * l) : (i = (t1.max.x - h.x) * l, n = (t1.min.x - h.x) * l), c >= 0 ? (r = (t1.min.y - h.y) * c, a = (t1.max.y - h.y) * c) : (r = (t1.max.y - h.y) * c, a = (t1.min.y - h.y) * c), i > a || r > n ? null : ((r > i || isNaN(i)) && (i = r), (a < n || isNaN(n)) && (n = a), u >= 0 ? (s = (t1.min.z - h.z) * u, o = (t1.max.z - h.z) * u) : (s = (t1.max.z - h.z) * u, o = (t1.min.z - h.z) * u), i > o || s > n ? null : ((s > i || i != i) && (i = s), (o < n || n != n) && (n = o), n < 0 ? null : this.at(i >= 0 ? i : n, e)));
            }
            intersectsBox(t1) {
                return null !== this.intersectBox(t1, Hl);
            }
            intersectTriangle(t1, e, i, n, r) {
                Wl.subVectors(e, t1), Xl.subVectors(i, t1), Zl.crossVectors(Wl, Xl);
                let a, s = this.direction.dot(Zl);
                if (s > 0) {
                    if (n) return null;
                    a = 1;
                } else {
                    if (!(s < 0)) return null;
                    a = -1, s = -s;
                }
                Yl.subVectors(this.origin, t1);
                const o = a * this.direction.dot(Xl.crossVectors(Yl, Xl));
                if (o < 0) return null;
                const l = a * this.direction.dot(Wl.cross(Yl));
                if (l < 0) return null;
                if (o + l > s) return null;
                const c = -a * Yl.dot(Zl);
                return c < 0 ? null : this.at(c / s, r);
            }
            applyMatrix4(t1) {
                return this.origin.applyMatrix4(t1), this.direction.transformDirection(t1), this;
            }
            equals(t1) {
                return t1.origin.equals(this.origin) && t1.direction.equals(this.direction);
            }
            clone() {
                return (new this.constructor).copy(this);
            }
        }
        class Kl {
            constructor(t1, e, i, n, r, a, s, o, l, c, u, h, d, p, f, A){
                Kl.prototype.isMatrix4 = !0, this.elements = [
                    1,
                    0,
                    0,
                    0,
                    0,
                    1,
                    0,
                    0,
                    0,
                    0,
                    1,
                    0,
                    0,
                    0,
                    0,
                    1
                ], void 0 !== t1 && this.set(t1, e, i, n, r, a, s, o, l, c, u, h, d, p, f, A);
            }
            set(t1, e, i, n, r, a, s, o, l, c, u, h, d, p, f, A) {
                const g = this.elements;
                return g[0] = t1, g[4] = e, g[8] = i, g[12] = n, g[1] = r, g[5] = a, g[9] = s, g[13] = o, g[2] = l, g[6] = c, g[10] = u, g[14] = h, g[3] = d, g[7] = p, g[11] = f, g[15] = A, this;
            }
            identity() {
                return this.set(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1), this;
            }
            clone() {
                return (new Kl).fromArray(this.elements);
            }
            copy(t1) {
                const e = this.elements, i = t1.elements;
                return e[0] = i[0], e[1] = i[1], e[2] = i[2], e[3] = i[3], e[4] = i[4], e[5] = i[5], e[6] = i[6], e[7] = i[7], e[8] = i[8], e[9] = i[9], e[10] = i[10], e[11] = i[11], e[12] = i[12], e[13] = i[13], e[14] = i[14], e[15] = i[15], this;
            }
            copyPosition(t1) {
                const e = this.elements, i = t1.elements;
                return e[12] = i[12], e[13] = i[13], e[14] = i[14], this;
            }
            setFromMatrix3(t1) {
                const e = t1.elements;
                return this.set(e[0], e[3], e[6], 0, e[1], e[4], e[7], 0, e[2], e[5], e[8], 0, 0, 0, 0, 1), this;
            }
            extractBasis(t1, e, i) {
                return t1.setFromMatrixColumn(this, 0), e.setFromMatrixColumn(this, 1), i.setFromMatrixColumn(this, 2), this;
            }
            makeBasis(t1, e, i) {
                return this.set(t1.x, e.x, i.x, 0, t1.y, e.y, i.y, 0, t1.z, e.z, i.z, 0, 0, 0, 0, 1), this;
            }
            extractRotation(t1) {
                const e = this.elements, i = t1.elements, n = 1 / ql.setFromMatrixColumn(t1, 0).length(), r = 1 / ql.setFromMatrixColumn(t1, 1).length(), a = 1 / ql.setFromMatrixColumn(t1, 2).length();
                return e[0] = i[0] * n, e[1] = i[1] * n, e[2] = i[2] * n, e[3] = 0, e[4] = i[4] * r, e[5] = i[5] * r, e[6] = i[6] * r, e[7] = 0, e[8] = i[8] * a, e[9] = i[9] * a, e[10] = i[10] * a, e[11] = 0, e[12] = 0, e[13] = 0, e[14] = 0, e[15] = 1, this;
            }
            makeRotationFromEuler(t1) {
                const e = this.elements, i = t1.x, n = t1.y, r = t1.z, a = Math.cos(i), s = Math.sin(i), o = Math.cos(n), l = Math.sin(n), c = Math.cos(r), u = Math.sin(r);
                if ("XYZ" === t1.order) {
                    const t1 = a * c, i = a * u, n = s * c, r = s * u;
                    e[0] = o * c, e[4] = -o * u, e[8] = l, e[1] = i + n * l, e[5] = t1 - r * l, e[9] = -s * o, e[2] = r - t1 * l, e[6] = n + i * l, e[10] = a * o;
                } else if ("YXZ" === t1.order) {
                    const t1 = o * c, i = o * u, n = l * c, r = l * u;
                    e[0] = t1 + r * s, e[4] = n * s - i, e[8] = a * l, e[1] = a * u, e[5] = a * c, e[9] = -s, e[2] = i * s - n, e[6] = r + t1 * s, e[10] = a * o;
                } else if ("ZXY" === t1.order) {
                    const t1 = o * c, i = o * u, n = l * c, r = l * u;
                    e[0] = t1 - r * s, e[4] = -a * u, e[8] = n + i * s, e[1] = i + n * s, e[5] = a * c, e[9] = r - t1 * s, e[2] = -a * l, e[6] = s, e[10] = a * o;
                } else if ("ZYX" === t1.order) {
                    const t1 = a * c, i = a * u, n = s * c, r = s * u;
                    e[0] = o * c, e[4] = n * l - i, e[8] = t1 * l + r, e[1] = o * u, e[5] = r * l + t1, e[9] = i * l - n, e[2] = -l, e[6] = s * o, e[10] = a * o;
                } else if ("YZX" === t1.order) {
                    const t1 = a * o, i = a * l, n = s * o, r = s * l;
                    e[0] = o * c, e[4] = r - t1 * u, e[8] = n * u + i, e[1] = u, e[5] = a * c, e[9] = -s * c, e[2] = -l * c, e[6] = i * u + n, e[10] = t1 - r * u;
                } else if ("XZY" === t1.order) {
                    const t1 = a * o, i = a * l, n = s * o, r = s * l;
                    e[0] = o * c, e[4] = -u, e[8] = l * c, e[1] = t1 * u + r, e[5] = a * c, e[9] = i * u - n, e[2] = n * u - i, e[6] = s * c, e[10] = r * u + t1;
                }
                return e[3] = 0, e[7] = 0, e[11] = 0, e[12] = 0, e[13] = 0, e[14] = 0, e[15] = 1, this;
            }
            makeRotationFromQuaternion(t1) {
                return this.compose(tc, t1, ec);
            }
            lookAt(t1, e, i) {
                const n = this.elements;
                return rc.subVectors(t1, e), 0 === rc.lengthSq() && (rc.z = 1), rc.normalize(), ic.crossVectors(i, rc), 0 === ic.lengthSq() && (1 === Math.abs(i.z) ? rc.x += 1e-4 : rc.z += 1e-4, rc.normalize(), ic.crossVectors(i, rc)), ic.normalize(), nc.crossVectors(rc, ic), n[0] = ic.x, n[4] = nc.x, n[8] = rc.x, n[1] = ic.y, n[5] = nc.y, n[9] = rc.y, n[2] = ic.z, n[6] = nc.z, n[10] = rc.z, this;
            }
            multiply(t1) {
                return this.multiplyMatrices(this, t1);
            }
            premultiply(t1) {
                return this.multiplyMatrices(t1, this);
            }
            multiplyMatrices(t1, e) {
                const i = t1.elements, n = e.elements, r = this.elements, a = i[0], s = i[4], o = i[8], l = i[12], c = i[1], u = i[5], h = i[9], d = i[13], p = i[2], f = i[6], A = i[10], g = i[14], m = i[3], M = i[7], y = i[11], v = i[15], x = n[0], w = n[4], b = n[8], T = n[12], E = n[1], I = n[5], S = n[9], N = n[13], D = n[2], C = n[6], z = n[10], L = n[14], O = n[3], _ = n[7], j = n[11], P = n[15];
                return r[0] = a * x + s * E + o * D + l * O, r[4] = a * w + s * I + o * C + l * _, r[8] = a * b + s * S + o * z + l * j, r[12] = a * T + s * N + o * L + l * P, r[1] = c * x + u * E + h * D + d * O, r[5] = c * w + u * I + h * C + d * _, r[9] = c * b + u * S + h * z + d * j, r[13] = c * T + u * N + h * L + d * P, r[2] = p * x + f * E + A * D + g * O, r[6] = p * w + f * I + A * C + g * _, r[10] = p * b + f * S + A * z + g * j, r[14] = p * T + f * N + A * L + g * P, r[3] = m * x + M * E + y * D + v * O, r[7] = m * w + M * I + y * C + v * _, r[11] = m * b + M * S + y * z + v * j, r[15] = m * T + M * N + y * L + v * P, this;
            }
            multiplyScalar(t1) {
                const e = this.elements;
                return e[0] *= t1, e[4] *= t1, e[8] *= t1, e[12] *= t1, e[1] *= t1, e[5] *= t1, e[9] *= t1, e[13] *= t1, e[2] *= t1, e[6] *= t1, e[10] *= t1, e[14] *= t1, e[3] *= t1, e[7] *= t1, e[11] *= t1, e[15] *= t1, this;
            }
            determinant() {
                const t1 = this.elements, e = t1[0], i = t1[4], n = t1[8], r = t1[12], a = t1[1], s = t1[5], o = t1[9], l = t1[13], c = t1[2], u = t1[6], h = t1[10], d = t1[14];
                return t1[3] * (+r * o * u - n * l * u - r * s * h + i * l * h + n * s * d - i * o * d) + t1[7] * (+e * o * d - e * l * h + r * a * h - n * a * d + n * l * c - r * o * c) + t1[11] * (+e * l * u - e * s * d - r * a * u + i * a * d + r * s * c - i * l * c) + t1[15] * (-n * s * c - e * o * u + e * s * h + n * a * u - i * a * h + i * o * c);
            }
            transpose() {
                const t1 = this.elements;
                let e;
                return e = t1[1], t1[1] = t1[4], t1[4] = e, e = t1[2], t1[2] = t1[8], t1[8] = e, e = t1[6], t1[6] = t1[9], t1[9] = e, e = t1[3], t1[3] = t1[12], t1[12] = e, e = t1[7], t1[7] = t1[13], t1[13] = e, e = t1[11], t1[11] = t1[14], t1[14] = e, this;
            }
            setPosition(t1, e, i) {
                const n = this.elements;
                return t1.isVector3 ? (n[12] = t1.x, n[13] = t1.y, n[14] = t1.z) : (n[12] = t1, n[13] = e, n[14] = i), this;
            }
            invert() {
                const t1 = this.elements, e = t1[0], i = t1[1], n = t1[2], r = t1[3], a = t1[4], s = t1[5], o = t1[6], l = t1[7], c = t1[8], u = t1[9], h = t1[10], d = t1[11], p = t1[12], f = t1[13], A = t1[14], g = t1[15], m = u * A * l - f * h * l + f * o * d - s * A * d - u * o * g + s * h * g, M = p * h * l - c * A * l - p * o * d + a * A * d + c * o * g - a * h * g, y = c * f * l - p * u * l + p * s * d - a * f * d - c * s * g + a * u * g, v = p * u * o - c * f * o - p * s * h + a * f * h + c * s * A - a * u * A, x = e * m + i * M + n * y + r * v;
                if (0 === x) return this.set(0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0);
                const w = 1 / x;
                return t1[0] = m * w, t1[1] = (f * h * r - u * A * r - f * n * d + i * A * d + u * n * g - i * h * g) * w, t1[2] = (s * A * r - f * o * r + f * n * l - i * A * l - s * n * g + i * o * g) * w, t1[3] = (u * o * r - s * h * r - u * n * l + i * h * l + s * n * d - i * o * d) * w, t1[4] = M * w, t1[5] = (c * A * r - p * h * r + p * n * d - e * A * d - c * n * g + e * h * g) * w, t1[6] = (p * o * r - a * A * r - p * n * l + e * A * l + a * n * g - e * o * g) * w, t1[7] = (a * h * r - c * o * r + c * n * l - e * h * l - a * n * d + e * o * d) * w, t1[8] = y * w, t1[9] = (p * u * r - c * f * r - p * i * d + e * f * d + c * i * g - e * u * g) * w, t1[10] = (a * f * r - p * s * r + p * i * l - e * f * l - a * i * g + e * s * g) * w, t1[11] = (c * s * r - a * u * r - c * i * l + e * u * l + a * i * d - e * s * d) * w, t1[12] = v * w, t1[13] = (c * f * n - p * u * n + p * i * h - e * f * h - c * i * A + e * u * A) * w, t1[14] = (p * s * n - a * f * n - p * i * o + e * f * o + a * i * A - e * s * A) * w, t1[15] = (a * u * n - c * s * n + c * i * o - e * u * o - a * i * h + e * s * h) * w, this;
            }
            scale(t1) {
                const e = this.elements, i = t1.x, n = t1.y, r = t1.z;
                return e[0] *= i, e[4] *= n, e[8] *= r, e[1] *= i, e[5] *= n, e[9] *= r, e[2] *= i, e[6] *= n, e[10] *= r, e[3] *= i, e[7] *= n, e[11] *= r, this;
            }
            getMaxScaleOnAxis() {
                const t1 = this.elements, e = t1[0] * t1[0] + t1[1] * t1[1] + t1[2] * t1[2], i = t1[4] * t1[4] + t1[5] * t1[5] + t1[6] * t1[6], n = t1[8] * t1[8] + t1[9] * t1[9] + t1[10] * t1[10];
                return Math.sqrt(Math.max(e, i, n));
            }
            makeTranslation(t1, e, i) {
                return t1.isVector3 ? this.set(1, 0, 0, t1.x, 0, 1, 0, t1.y, 0, 0, 1, t1.z, 0, 0, 0, 1) : this.set(1, 0, 0, t1, 0, 1, 0, e, 0, 0, 1, i, 0, 0, 0, 1), this;
            }
            makeRotationX(t1) {
                const e = Math.cos(t1), i = Math.sin(t1);
                return this.set(1, 0, 0, 0, 0, e, -i, 0, 0, i, e, 0, 0, 0, 0, 1), this;
            }
            makeRotationY(t1) {
                const e = Math.cos(t1), i = Math.sin(t1);
                return this.set(e, 0, i, 0, 0, 1, 0, 0, -i, 0, e, 0, 0, 0, 0, 1), this;
            }
            makeRotationZ(t1) {
                const e = Math.cos(t1), i = Math.sin(t1);
                return this.set(e, -i, 0, 0, i, e, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1), this;
            }
            makeRotationAxis(t1, e) {
                const i = Math.cos(e), n = Math.sin(e), r = 1 - i, a = t1.x, s = t1.y, o = t1.z, l = r * a, c = r * s;
                return this.set(l * a + i, l * s - n * o, l * o + n * s, 0, l * s + n * o, c * s + i, c * o - n * a, 0, l * o - n * s, c * o + n * a, r * o * o + i, 0, 0, 0, 0, 1), this;
            }
            makeScale(t1, e, i) {
                return this.set(t1, 0, 0, 0, 0, e, 0, 0, 0, 0, i, 0, 0, 0, 0, 1), this;
            }
            makeShear(t1, e, i, n, r, a) {
                return this.set(1, i, r, 0, t1, 1, a, 0, e, n, 1, 0, 0, 0, 0, 1), this;
            }
            compose(t1, e, i) {
                const n = this.elements, r = e._x, a = e._y, s = e._z, o = e._w, l = r + r, c = a + a, u = s + s, h = r * l, d = r * c, p = r * u, f = a * c, A = a * u, g = s * u, m = o * l, M = o * c, y = o * u, v = i.x, x = i.y, w = i.z;
                return n[0] = (1 - (f + g)) * v, n[1] = (d + y) * v, n[2] = (p - M) * v, n[3] = 0, n[4] = (d - y) * x, n[5] = (1 - (h + g)) * x, n[6] = (A + m) * x, n[7] = 0, n[8] = (p + M) * w, n[9] = (A - m) * w, n[10] = (1 - (h + f)) * w, n[11] = 0, n[12] = t1.x, n[13] = t1.y, n[14] = t1.z, n[15] = 1, this;
            }
            decompose(t1, e, i) {
                const n = this.elements;
                let r = ql.set(n[0], n[1], n[2]).length();
                const a = ql.set(n[4], n[5], n[6]).length(), s = ql.set(n[8], n[9], n[10]).length();
                this.determinant() < 0 && (r = -r), t1.x = n[12], t1.y = n[13], t1.z = n[14], $l.copy(this);
                const o = 1 / r, l = 1 / a, c = 1 / s;
                return $l.elements[0] *= o, $l.elements[1] *= o, $l.elements[2] *= o, $l.elements[4] *= l, $l.elements[5] *= l, $l.elements[6] *= l, $l.elements[8] *= c, $l.elements[9] *= c, $l.elements[10] *= c, e.setFromRotationMatrix($l), i.x = r, i.y = a, i.z = s, this;
            }
            makePerspective(t1, e, i, n, r, a, s = Eo) {
                const o = this.elements, l = 2 * r / (e - t1), c = 2 * r / (i - n), u = (e + t1) / (e - t1), h = (i + n) / (i - n);
                let d, p;
                if (s === Eo) d = -(a + r) / (a - r), p = -2 * a * r / (a - r);
                else {
                    if (s !== Io) throw new Error("THREE.Matrix4.makePerspective(): Invalid coordinate system: " + s);
                    d = -a / (a - r), p = -a * r / (a - r);
                }
                return o[0] = l, o[4] = 0, o[8] = u, o[12] = 0, o[1] = 0, o[5] = c, o[9] = h, o[13] = 0, o[2] = 0, o[6] = 0, o[10] = d, o[14] = p, o[3] = 0, o[7] = 0, o[11] = -1, o[15] = 0, this;
            }
            makeOrthographic(t1, e, i, n, r, a, s = Eo) {
                const o = this.elements, l = 1 / (e - t1), c = 1 / (i - n), u = 1 / (a - r), h = (e + t1) * l, d = (i + n) * c;
                let p, f;
                if (s === Eo) p = (a + r) * u, f = -2 * u;
                else {
                    if (s !== Io) throw new Error("THREE.Matrix4.makeOrthographic(): Invalid coordinate system: " + s);
                    p = r * u, f = -1 * u;
                }
                return o[0] = 2 * l, o[4] = 0, o[8] = 0, o[12] = -h, o[1] = 0, o[5] = 2 * c, o[9] = 0, o[13] = -d, o[2] = 0, o[6] = 0, o[10] = f, o[14] = -p, o[3] = 0, o[7] = 0, o[11] = 0, o[15] = 1, this;
            }
            equals(t1) {
                const e = this.elements, i = t1.elements;
                for(let t1 = 0; t1 < 16; t1++)if (e[t1] !== i[t1]) return !1;
                return !0;
            }
            fromArray(t1, e = 0) {
                for(let i = 0; i < 16; i++)this.elements[i] = t1[i + e];
                return this;
            }
            toArray(t1 = [], e = 0) {
                const i = this.elements;
                return t1[e] = i[0], t1[e + 1] = i[1], t1[e + 2] = i[2], t1[e + 3] = i[3], t1[e + 4] = i[4], t1[e + 5] = i[5], t1[e + 6] = i[6], t1[e + 7] = i[7], t1[e + 8] = i[8], t1[e + 9] = i[9], t1[e + 10] = i[10], t1[e + 11] = i[11], t1[e + 12] = i[12], t1[e + 13] = i[13], t1[e + 14] = i[14], t1[e + 15] = i[15], t1;
            }
        }
        const ql = new xl, $l = new Kl, tc = new xl(0, 0, 0), ec = new xl(1, 1, 1), ic = new xl, nc = new xl, rc = new xl, ac = new Kl, sc = new vl;
        class oc {
            constructor(t1 = 0, e = 0, i = 0, n = oc.DEFAULT_ORDER){
                this.isEuler = !0, this._x = t1, this._y = e, this._z = i, this._order = n;
            }
            get x() {
                return this._x;
            }
            set x(t1) {
                this._x = t1, this._onChangeCallback();
            }
            get y() {
                return this._y;
            }
            set y(t1) {
                this._y = t1, this._onChangeCallback();
            }
            get z() {
                return this._z;
            }
            set z(t1) {
                this._z = t1, this._onChangeCallback();
            }
            get order() {
                return this._order;
            }
            set order(t1) {
                this._order = t1, this._onChangeCallback();
            }
            set(t1, e, i, n = this._order) {
                return this._x = t1, this._y = e, this._z = i, this._order = n, this._onChangeCallback(), this;
            }
            clone() {
                return new this.constructor(this._x, this._y, this._z, this._order);
            }
            copy(t1) {
                return this._x = t1._x, this._y = t1._y, this._z = t1._z, this._order = t1._order, this._onChangeCallback(), this;
            }
            setFromRotationMatrix(t1, e = this._order, i = !0) {
                const n = t1.elements, r = n[0], a = n[4], s = n[8], o = n[1], l = n[5], c = n[9], u = n[2], h = n[6], d = n[10];
                switch(e){
                    case "XYZ":
                        this._y = Math.asin(Oo(s, -1, 1)), Math.abs(s) < .9999999 ? (this._x = Math.atan2(-c, d), this._z = Math.atan2(-a, r)) : (this._x = Math.atan2(h, l), this._z = 0);
                        break;
                    case "YXZ":
                        this._x = Math.asin(-Oo(c, -1, 1)), Math.abs(c) < .9999999 ? (this._y = Math.atan2(s, d), this._z = Math.atan2(o, l)) : (this._y = Math.atan2(-u, r), this._z = 0);
                        break;
                    case "ZXY":
                        this._x = Math.asin(Oo(h, -1, 1)), Math.abs(h) < .9999999 ? (this._y = Math.atan2(-u, d), this._z = Math.atan2(-a, l)) : (this._y = 0, this._z = Math.atan2(o, r));
                        break;
                    case "ZYX":
                        this._y = Math.asin(-Oo(u, -1, 1)), Math.abs(u) < .9999999 ? (this._x = Math.atan2(h, d), this._z = Math.atan2(o, r)) : (this._x = 0, this._z = Math.atan2(-a, l));
                        break;
                    case "YZX":
                        this._z = Math.asin(Oo(o, -1, 1)), Math.abs(o) < .9999999 ? (this._x = Math.atan2(-c, l), this._y = Math.atan2(-u, r)) : (this._x = 0, this._y = Math.atan2(s, d));
                        break;
                    case "XZY":
                        this._z = Math.asin(-Oo(a, -1, 1)), Math.abs(a) < .9999999 ? (this._x = Math.atan2(h, l), this._y = Math.atan2(s, r)) : (this._x = Math.atan2(-c, d), this._y = 0);
                        break;
                    default:
                        console.warn("THREE.Euler: .setFromRotationMatrix() encountered an unknown order: " + e);
                }
                return this._order = e, !0 === i && this._onChangeCallback(), this;
            }
            setFromQuaternion(t1, e, i) {
                return ac.makeRotationFromQuaternion(t1), this.setFromRotationMatrix(ac, e, i);
            }
            setFromVector3(t1, e = this._order) {
                return this.set(t1.x, t1.y, t1.z, e);
            }
            reorder(t1) {
                return sc.setFromEuler(this), this.setFromQuaternion(sc, t1);
            }
            equals(t1) {
                return t1._x === this._x && t1._y === this._y && t1._z === this._z && t1._order === this._order;
            }
            fromArray(t1) {
                return this._x = t1[0], this._y = t1[1], this._z = t1[2], void 0 !== t1[3] && (this._order = t1[3]), this._onChangeCallback(), this;
            }
            toArray(t1 = [], e = 0) {
                return t1[e] = this._x, t1[e + 1] = this._y, t1[e + 2] = this._z, t1[e + 3] = this._order, t1;
            }
            _onChange(t1) {
                return this._onChangeCallback = t1, this;
            }
            _onChangeCallback() {}
            *[Symbol.iterator]() {
                yield this._x, yield this._y, yield this._z, yield this._order;
            }
        }
        oc.DEFAULT_ORDER = "XYZ";
        class lc {
            constructor(){
                this.mask = 1;
            }
            set(t1) {
                this.mask = 1 << t1 >>> 0;
            }
            enable(t1) {
                this.mask |= 1 << t1;
            }
            enableAll() {
                this.mask = -1;
            }
            toggle(t1) {
                this.mask ^= 1 << t1;
            }
            disable(t1) {
                this.mask &= ~(1 << t1);
            }
            disableAll() {
                this.mask = 0;
            }
            test(t1) {
                return !!(this.mask & t1.mask);
            }
            isEnabled(t1) {
                return !!(this.mask & 1 << t1);
            }
        }
        let cc = 0;
        const uc = new xl, hc = new vl, dc = new Kl, pc = new xl, fc = new xl, Ac = new xl, gc = new vl, mc = new xl(1, 0, 0), Mc = new xl(0, 1, 0), yc = new xl(0, 0, 1), vc = {
            type: "added"
        }, xc = {
            type: "removed"
        };
        class wc extends So {
            constructor(){
                super(), this.isObject3D = !0, Object.defineProperty(this, "id", {
                    value: cc++
                }), this.uuid = Lo(), this.name = "", this.type = "Object3D", this.parent = null, this.children = [], this.up = wc.DEFAULT_UP.clone();
                const t1 = new xl, e = new oc, i = new vl, n = new xl(1, 1, 1);
                e._onChange(function() {
                    i.setFromEuler(e, !1);
                }), i._onChange(function() {
                    e.setFromQuaternion(i, void 0, !1);
                }), Object.defineProperties(this, {
                    position: {
                        configurable: !0,
                        enumerable: !0,
                        value: t1
                    },
                    rotation: {
                        configurable: !0,
                        enumerable: !0,
                        value: e
                    },
                    quaternion: {
                        configurable: !0,
                        enumerable: !0,
                        value: i
                    },
                    scale: {
                        configurable: !0,
                        enumerable: !0,
                        value: n
                    },
                    modelViewMatrix: {
                        value: new Kl
                    },
                    normalMatrix: {
                        value: new Ho
                    }
                }), this.matrix = new Kl, this.matrixWorld = new Kl, this.matrixAutoUpdate = wc.DEFAULT_MATRIX_AUTO_UPDATE, this.matrixWorldNeedsUpdate = !1, this.matrixWorldAutoUpdate = wc.DEFAULT_MATRIX_WORLD_AUTO_UPDATE, this.layers = new lc, this.visible = !0, this.castShadow = !1, this.receiveShadow = !1, this.frustumCulled = !0, this.renderOrder = 0, this.animations = [], this.userData = {};
            }
            onBeforeRender() {}
            onAfterRender() {}
            applyMatrix4(t1) {
                this.matrixAutoUpdate && this.updateMatrix(), this.matrix.premultiply(t1), this.matrix.decompose(this.position, this.quaternion, this.scale);
            }
            applyQuaternion(t1) {
                return this.quaternion.premultiply(t1), this;
            }
            setRotationFromAxisAngle(t1, e) {
                this.quaternion.setFromAxisAngle(t1, e);
            }
            setRotationFromEuler(t1) {
                this.quaternion.setFromEuler(t1, !0);
            }
            setRotationFromMatrix(t1) {
                this.quaternion.setFromRotationMatrix(t1);
            }
            setRotationFromQuaternion(t1) {
                this.quaternion.copy(t1);
            }
            rotateOnAxis(t1, e) {
                return hc.setFromAxisAngle(t1, e), this.quaternion.multiply(hc), this;
            }
            rotateOnWorldAxis(t1, e) {
                return hc.setFromAxisAngle(t1, e), this.quaternion.premultiply(hc), this;
            }
            rotateX(t1) {
                return this.rotateOnAxis(mc, t1);
            }
            rotateY(t1) {
                return this.rotateOnAxis(Mc, t1);
            }
            rotateZ(t1) {
                return this.rotateOnAxis(yc, t1);
            }
            translateOnAxis(t1, e) {
                return uc.copy(t1).applyQuaternion(this.quaternion), this.position.add(uc.multiplyScalar(e)), this;
            }
            translateX(t1) {
                return this.translateOnAxis(mc, t1);
            }
            translateY(t1) {
                return this.translateOnAxis(Mc, t1);
            }
            translateZ(t1) {
                return this.translateOnAxis(yc, t1);
            }
            localToWorld(t1) {
                return this.updateWorldMatrix(!0, !1), t1.applyMatrix4(this.matrixWorld);
            }
            worldToLocal(t1) {
                return this.updateWorldMatrix(!0, !1), t1.applyMatrix4(dc.copy(this.matrixWorld).invert());
            }
            lookAt(t1, e, i) {
                t1.isVector3 ? pc.copy(t1) : pc.set(t1, e, i);
                const n = this.parent;
                this.updateWorldMatrix(!0, !1), fc.setFromMatrixPosition(this.matrixWorld), this.isCamera || this.isLight ? dc.lookAt(fc, pc, this.up) : dc.lookAt(pc, fc, this.up), this.quaternion.setFromRotationMatrix(dc), n && (dc.extractRotation(n.matrixWorld), hc.setFromRotationMatrix(dc), this.quaternion.premultiply(hc.invert()));
            }
            add(t1) {
                if (arguments.length > 1) {
                    for(let t1 = 0; t1 < arguments.length; t1++)this.add(arguments[t1]);
                    return this;
                }
                return t1 === this ? (console.error("THREE.Object3D.add: object can't be added as a child of itself.", t1), this) : (t1 && t1.isObject3D ? (null !== t1.parent && t1.parent.remove(t1), t1.parent = this, this.children.push(t1), t1.dispatchEvent(vc)) : console.error("THREE.Object3D.add: object not an instance of THREE.Object3D.", t1), this);
            }
            remove(t1) {
                if (arguments.length > 1) {
                    for(let t1 = 0; t1 < arguments.length; t1++)this.remove(arguments[t1]);
                    return this;
                }
                const e = this.children.indexOf(t1);
                return -1 !== e && (t1.parent = null, this.children.splice(e, 1), t1.dispatchEvent(xc)), this;
            }
            removeFromParent() {
                const t1 = this.parent;
                return null !== t1 && t1.remove(this), this;
            }
            clear() {
                return this.remove(...this.children);
            }
            attach(t1) {
                return this.updateWorldMatrix(!0, !1), dc.copy(this.matrixWorld).invert(), null !== t1.parent && (t1.parent.updateWorldMatrix(!0, !1), dc.multiply(t1.parent.matrixWorld)), t1.applyMatrix4(dc), this.add(t1), t1.updateWorldMatrix(!1, !0), this;
            }
            getObjectById(t1) {
                return this.getObjectByProperty("id", t1);
            }
            getObjectByName(t1) {
                return this.getObjectByProperty("name", t1);
            }
            getObjectByProperty(t1, e) {
                if (this[t1] === e) return this;
                for(let i = 0, n = this.children.length; i < n; i++){
                    const n = this.children[i].getObjectByProperty(t1, e);
                    if (void 0 !== n) return n;
                }
            }
            getObjectsByProperty(t1, e) {
                let i = [];
                this[t1] === e && i.push(this);
                for(let n = 0, r = this.children.length; n < r; n++){
                    const r = this.children[n].getObjectsByProperty(t1, e);
                    r.length > 0 && (i = i.concat(r));
                }
                return i;
            }
            getWorldPosition(t1) {
                return this.updateWorldMatrix(!0, !1), t1.setFromMatrixPosition(this.matrixWorld);
            }
            getWorldQuaternion(t1) {
                return this.updateWorldMatrix(!0, !1), this.matrixWorld.decompose(fc, t1, Ac), t1;
            }
            getWorldScale(t1) {
                return this.updateWorldMatrix(!0, !1), this.matrixWorld.decompose(fc, gc, t1), t1;
            }
            getWorldDirection(t1) {
                this.updateWorldMatrix(!0, !1);
                const e = this.matrixWorld.elements;
                return t1.set(e[8], e[9], e[10]).normalize();
            }
            raycast() {}
            traverse(t1) {
                t1(this);
                const e = this.children;
                for(let i = 0, n = e.length; i < n; i++)e[i].traverse(t1);
            }
            traverseVisible(t1) {
                if (!1 === this.visible) return;
                t1(this);
                const e = this.children;
                for(let i = 0, n = e.length; i < n; i++)e[i].traverseVisible(t1);
            }
            traverseAncestors(t1) {
                const e = this.parent;
                null !== e && (t1(e), e.traverseAncestors(t1));
            }
            updateMatrix() {
                this.matrix.compose(this.position, this.quaternion, this.scale), this.matrixWorldNeedsUpdate = !0;
            }
            updateMatrixWorld(t1) {
                this.matrixAutoUpdate && this.updateMatrix(), (this.matrixWorldNeedsUpdate || t1) && (null === this.parent ? this.matrixWorld.copy(this.matrix) : this.matrixWorld.multiplyMatrices(this.parent.matrixWorld, this.matrix), this.matrixWorldNeedsUpdate = !1, t1 = !0);
                const e = this.children;
                for(let i = 0, n = e.length; i < n; i++){
                    const n = e[i];
                    !0 !== n.matrixWorldAutoUpdate && !0 !== t1 || n.updateMatrixWorld(t1);
                }
            }
            updateWorldMatrix(t1, e) {
                const i = this.parent;
                if (!0 === t1 && null !== i && !0 === i.matrixWorldAutoUpdate && i.updateWorldMatrix(!0, !1), this.matrixAutoUpdate && this.updateMatrix(), null === this.parent ? this.matrixWorld.copy(this.matrix) : this.matrixWorld.multiplyMatrices(this.parent.matrixWorld, this.matrix), !0 === e) {
                    const t1 = this.children;
                    for(let e = 0, i = t1.length; e < i; e++){
                        const i = t1[e];
                        !0 === i.matrixWorldAutoUpdate && i.updateWorldMatrix(!1, !0);
                    }
                }
            }
            toJSON(t1) {
                const e = void 0 === t1 || "string" == typeof t1, i = {};
                e && (t1 = {
                    geometries: {},
                    materials: {},
                    textures: {},
                    images: {},
                    shapes: {},
                    skeletons: {},
                    animations: {},
                    nodes: {}
                }, i.metadata = {
                    version: 4.6,
                    type: "Object",
                    generator: "Object3D.toJSON"
                });
                const n = {};
                function r(e, i) {
                    return void 0 === e[i.uuid] && (e[i.uuid] = i.toJSON(t1)), i.uuid;
                }
                if (n.uuid = this.uuid, n.type = this.type, "" !== this.name && (n.name = this.name), !0 === this.castShadow && (n.castShadow = !0), !0 === this.receiveShadow && (n.receiveShadow = !0), !1 === this.visible && (n.visible = !1), !1 === this.frustumCulled && (n.frustumCulled = !1), 0 !== this.renderOrder && (n.renderOrder = this.renderOrder), Object.keys(this.userData).length > 0 && (n.userData = this.userData), n.layers = this.layers.mask, n.matrix = this.matrix.toArray(), n.up = this.up.toArray(), !1 === this.matrixAutoUpdate && (n.matrixAutoUpdate = !1), this.isInstancedMesh && (n.type = "InstancedMesh", n.count = this.count, n.instanceMatrix = this.instanceMatrix.toJSON(), null !== this.instanceColor && (n.instanceColor = this.instanceColor.toJSON())), this.isScene) this.background && (this.background.isColor ? n.background = this.background.toJSON() : this.background.isTexture && (n.background = this.background.toJSON(t1).uuid)), this.environment && this.environment.isTexture && !0 !== this.environment.isRenderTargetTexture && (n.environment = this.environment.toJSON(t1).uuid);
                else if (this.isMesh || this.isLine || this.isPoints) {
                    n.geometry = r(t1.geometries, this.geometry);
                    const e = this.geometry.parameters;
                    if (void 0 !== e && void 0 !== e.shapes) {
                        const i = e.shapes;
                        if (Array.isArray(i)) for(let e = 0, n = i.length; e < n; e++){
                            const n = i[e];
                            r(t1.shapes, n);
                        }
                        else r(t1.shapes, i);
                    }
                }
                if (this.isSkinnedMesh && (n.bindMode = this.bindMode, n.bindMatrix = this.bindMatrix.toArray(), void 0 !== this.skeleton && (r(t1.skeletons, this.skeleton), n.skeleton = this.skeleton.uuid)), void 0 !== this.material) {
                    if (Array.isArray(this.material)) {
                        const e = [];
                        for(let i = 0, n = this.material.length; i < n; i++)e.push(r(t1.materials, this.material[i]));
                        n.material = e;
                    } else n.material = r(t1.materials, this.material);
                }
                if (this.children.length > 0) {
                    n.children = [];
                    for(let e = 0; e < this.children.length; e++)n.children.push(this.children[e].toJSON(t1).object);
                }
                if (this.animations.length > 0) {
                    n.animations = [];
                    for(let e = 0; e < this.animations.length; e++){
                        const i = this.animations[e];
                        n.animations.push(r(t1.animations, i));
                    }
                }
                if (e) {
                    const e = a(t1.geometries), n = a(t1.materials), r = a(t1.textures), s = a(t1.images), o = a(t1.shapes), l = a(t1.skeletons), c = a(t1.animations), u = a(t1.nodes);
                    e.length > 0 && (i.geometries = e), n.length > 0 && (i.materials = n), r.length > 0 && (i.textures = r), s.length > 0 && (i.images = s), o.length > 0 && (i.shapes = o), l.length > 0 && (i.skeletons = l), c.length > 0 && (i.animations = c), u.length > 0 && (i.nodes = u);
                }
                return i.object = n, i;
                function a(t1) {
                    const e = [];
                    for(const i in t1){
                        const n = t1[i];
                        delete n.metadata, e.push(n);
                    }
                    return e;
                }
            }
            clone(t1) {
                return (new this.constructor).copy(this, t1);
            }
            copy(t1, e = !0) {
                if (this.name = t1.name, this.up.copy(t1.up), this.position.copy(t1.position), this.rotation.order = t1.rotation.order, this.quaternion.copy(t1.quaternion), this.scale.copy(t1.scale), this.matrix.copy(t1.matrix), this.matrixWorld.copy(t1.matrixWorld), this.matrixAutoUpdate = t1.matrixAutoUpdate, this.matrixWorldNeedsUpdate = t1.matrixWorldNeedsUpdate, this.matrixWorldAutoUpdate = t1.matrixWorldAutoUpdate, this.layers.mask = t1.layers.mask, this.visible = t1.visible, this.castShadow = t1.castShadow, this.receiveShadow = t1.receiveShadow, this.frustumCulled = t1.frustumCulled, this.renderOrder = t1.renderOrder, this.animations = t1.animations.slice(), this.userData = JSON.parse(JSON.stringify(t1.userData)), !0 === e) for(let e = 0; e < t1.children.length; e++){
                    const i = t1.children[e];
                    this.add(i.clone());
                }
                return this;
            }
        }
        wc.DEFAULT_UP = new xl(0, 1, 0), wc.DEFAULT_MATRIX_AUTO_UPDATE = !0, wc.DEFAULT_MATRIX_WORLD_AUTO_UPDATE = !0;
        const bc = new xl, Tc = new xl, Ec = new xl, Ic = new xl, Sc = new xl, Nc = new xl, Dc = new xl, Cc = new xl, zc = new xl, Lc = new xl;
        let Oc = !1;
        class _c {
            constructor(t1 = new xl, e = new xl, i = new xl){
                this.a = t1, this.b = e, this.c = i;
            }
            static getNormal(t1, e, i, n) {
                n.subVectors(i, e), bc.subVectors(t1, e), n.cross(bc);
                const r = n.lengthSq();
                return r > 0 ? n.multiplyScalar(1 / Math.sqrt(r)) : n.set(0, 0, 0);
            }
            static getBarycoord(t1, e, i, n, r) {
                bc.subVectors(n, e), Tc.subVectors(i, e), Ec.subVectors(t1, e);
                const a = bc.dot(bc), s = bc.dot(Tc), o = bc.dot(Ec), l = Tc.dot(Tc), c = Tc.dot(Ec), u = a * l - s * s;
                if (0 === u) return r.set(-2, -1, -1);
                const h = 1 / u, d = (l * o - s * c) * h, p = (a * c - s * o) * h;
                return r.set(1 - d - p, p, d);
            }
            static containsPoint(t1, e, i, n) {
                return this.getBarycoord(t1, e, i, n, Ic), Ic.x >= 0 && Ic.y >= 0 && Ic.x + Ic.y <= 1;
            }
            static getUV(t1, e, i, n, r, a, s, o) {
                return !1 === Oc && (console.warn("THREE.Triangle.getUV() has been renamed to THREE.Triangle.getInterpolation()."), Oc = !0), this.getInterpolation(t1, e, i, n, r, a, s, o);
            }
            static getInterpolation(t1, e, i, n, r, a, s, o) {
                return this.getBarycoord(t1, e, i, n, Ic), o.setScalar(0), o.addScaledVector(r, Ic.x), o.addScaledVector(a, Ic.y), o.addScaledVector(s, Ic.z), o;
            }
            static isFrontFacing(t1, e, i, n) {
                return bc.subVectors(i, e), Tc.subVectors(t1, e), bc.cross(Tc).dot(n) < 0;
            }
            set(t1, e, i) {
                return this.a.copy(t1), this.b.copy(e), this.c.copy(i), this;
            }
            setFromPointsAndIndices(t1, e, i, n) {
                return this.a.copy(t1[e]), this.b.copy(t1[i]), this.c.copy(t1[n]), this;
            }
            setFromAttributeAndIndices(t1, e, i, n) {
                return this.a.fromBufferAttribute(t1, e), this.b.fromBufferAttribute(t1, i), this.c.fromBufferAttribute(t1, n), this;
            }
            clone() {
                return (new this.constructor).copy(this);
            }
            copy(t1) {
                return this.a.copy(t1.a), this.b.copy(t1.b), this.c.copy(t1.c), this;
            }
            getArea() {
                return bc.subVectors(this.c, this.b), Tc.subVectors(this.a, this.b), .5 * bc.cross(Tc).length();
            }
            getMidpoint(t1) {
                return t1.addVectors(this.a, this.b).add(this.c).multiplyScalar(1 / 3);
            }
            getNormal(t1) {
                return _c.getNormal(this.a, this.b, this.c, t1);
            }
            getPlane(t1) {
                return t1.setFromCoplanarPoints(this.a, this.b, this.c);
            }
            getBarycoord(t1, e) {
                return _c.getBarycoord(t1, this.a, this.b, this.c, e);
            }
            getUV(t1, e, i, n, r) {
                return !1 === Oc && (console.warn("THREE.Triangle.getUV() has been renamed to THREE.Triangle.getInterpolation()."), Oc = !0), _c.getInterpolation(t1, this.a, this.b, this.c, e, i, n, r);
            }
            getInterpolation(t1, e, i, n, r) {
                return _c.getInterpolation(t1, this.a, this.b, this.c, e, i, n, r);
            }
            containsPoint(t1) {
                return _c.containsPoint(t1, this.a, this.b, this.c);
            }
            isFrontFacing(t1) {
                return _c.isFrontFacing(this.a, this.b, this.c, t1);
            }
            intersectsBox(t1) {
                return t1.intersectsTriangle(this);
            }
            closestPointToPoint(t1, e) {
                const i = this.a, n = this.b, r = this.c;
                let a, s;
                Sc.subVectors(n, i), Nc.subVectors(r, i), Cc.subVectors(t1, i);
                const o = Sc.dot(Cc), l = Nc.dot(Cc);
                if (o <= 0 && l <= 0) return e.copy(i);
                zc.subVectors(t1, n);
                const c = Sc.dot(zc), u = Nc.dot(zc);
                if (c >= 0 && u <= c) return e.copy(n);
                const h = o * u - c * l;
                if (h <= 0 && o >= 0 && c <= 0) return a = o / (o - c), e.copy(i).addScaledVector(Sc, a);
                Lc.subVectors(t1, r);
                const d = Sc.dot(Lc), p = Nc.dot(Lc);
                if (p >= 0 && d <= p) return e.copy(r);
                const f = d * l - o * p;
                if (f <= 0 && l >= 0 && p <= 0) return s = l / (l - p), e.copy(i).addScaledVector(Nc, s);
                const A = c * p - d * u;
                if (A <= 0 && u - c >= 0 && d - p >= 0) return Dc.subVectors(r, n), s = (u - c) / (u - c + (d - p)), e.copy(n).addScaledVector(Dc, s);
                const g = 1 / (A + f + h);
                return a = f * g, s = h * g, e.copy(i).addScaledVector(Sc, a).addScaledVector(Nc, s);
            }
            equals(t1) {
                return t1.a.equals(this.a) && t1.b.equals(this.b) && t1.c.equals(this.c);
            }
        }
        const jc = {
            aliceblue: 15792383,
            antiquewhite: 16444375,
            aqua: 65535,
            aquamarine: 8388564,
            azure: 15794175,
            beige: 16119260,
            bisque: 16770244,
            black: 0,
            blanchedalmond: 16772045,
            blue: 255,
            blueviolet: 9055202,
            brown: 10824234,
            burlywood: 14596231,
            cadetblue: 6266528,
            chartreuse: 8388352,
            chocolate: 13789470,
            coral: 16744272,
            cornflowerblue: 6591981,
            cornsilk: 16775388,
            crimson: 14423100,
            cyan: 65535,
            darkblue: 139,
            darkcyan: 35723,
            darkgoldenrod: 12092939,
            darkgray: 11119017,
            darkgreen: 25600,
            darkgrey: 11119017,
            darkkhaki: 12433259,
            darkmagenta: 9109643,
            darkolivegreen: 5597999,
            darkorange: 16747520,
            darkorchid: 10040012,
            darkred: 9109504,
            darksalmon: 15308410,
            darkseagreen: 9419919,
            darkslateblue: 4734347,
            darkslategray: 3100495,
            darkslategrey: 3100495,
            darkturquoise: 52945,
            darkviolet: 9699539,
            deeppink: 16716947,
            deepskyblue: 49151,
            dimgray: 6908265,
            dimgrey: 6908265,
            dodgerblue: 2003199,
            firebrick: 11674146,
            floralwhite: 16775920,
            forestgreen: 2263842,
            fuchsia: 16711935,
            gainsboro: 14474460,
            ghostwhite: 16316671,
            gold: 16766720,
            goldenrod: 14329120,
            gray: 8421504,
            green: 32768,
            greenyellow: 11403055,
            grey: 8421504,
            honeydew: 15794160,
            hotpink: 16738740,
            indianred: 13458524,
            indigo: 4915330,
            ivory: 16777200,
            khaki: 15787660,
            lavender: 15132410,
            lavenderblush: 16773365,
            lawngreen: 8190976,
            lemonchiffon: 16775885,
            lightblue: 11393254,
            lightcoral: 15761536,
            lightcyan: 14745599,
            lightgoldenrodyellow: 16448210,
            lightgray: 13882323,
            lightgreen: 9498256,
            lightgrey: 13882323,
            lightpink: 16758465,
            lightsalmon: 16752762,
            lightseagreen: 2142890,
            lightskyblue: 8900346,
            lightslategray: 7833753,
            lightslategrey: 7833753,
            lightsteelblue: 11584734,
            lightyellow: 16777184,
            lime: 65280,
            limegreen: 3329330,
            linen: 16445670,
            magenta: 16711935,
            maroon: 8388608,
            mediumaquamarine: 6737322,
            mediumblue: 205,
            mediumorchid: 12211667,
            mediumpurple: 9662683,
            mediumseagreen: 3978097,
            mediumslateblue: 8087790,
            mediumspringgreen: 64154,
            mediumturquoise: 4772300,
            mediumvioletred: 13047173,
            midnightblue: 1644912,
            mintcream: 16121850,
            mistyrose: 16770273,
            moccasin: 16770229,
            navajowhite: 16768685,
            navy: 128,
            oldlace: 16643558,
            olive: 8421376,
            olivedrab: 7048739,
            orange: 16753920,
            orangered: 16729344,
            orchid: 14315734,
            palegoldenrod: 15657130,
            palegreen: 10025880,
            paleturquoise: 11529966,
            palevioletred: 14381203,
            papayawhip: 16773077,
            peachpuff: 16767673,
            peru: 13468991,
            pink: 16761035,
            plum: 14524637,
            powderblue: 11591910,
            purple: 8388736,
            rebeccapurple: 6697881,
            red: 16711680,
            rosybrown: 12357519,
            royalblue: 4286945,
            saddlebrown: 9127187,
            salmon: 16416882,
            sandybrown: 16032864,
            seagreen: 3050327,
            seashell: 16774638,
            sienna: 10506797,
            silver: 12632256,
            skyblue: 8900331,
            slateblue: 6970061,
            slategray: 7372944,
            slategrey: 7372944,
            snow: 16775930,
            springgreen: 65407,
            steelblue: 4620980,
            tan: 13808780,
            teal: 32896,
            thistle: 14204888,
            tomato: 16737095,
            turquoise: 4251856,
            violet: 15631086,
            wheat: 16113331,
            white: 16777215,
            whitesmoke: 16119285,
            yellow: 16776960,
            yellowgreen: 10145074
        }, Pc = {
            h: 0,
            s: 0,
            l: 0
        }, Rc = {
            h: 0,
            s: 0,
            l: 0
        };
        function Uc(t1, e, i) {
            return i < 0 && (i += 1), i > 1 && (i -= 1), i < 1 / 6 ? t1 + 6 * (e - t1) * i : i < .5 ? e : i < 2 / 3 ? t1 + 6 * (e - t1) * (2 / 3 - i) : t1;
        }
        class kc {
            constructor(t1, e, i){
                return this.isColor = !0, this.r = 1, this.g = 1, this.b = 1, this.set(t1, e, i);
            }
            set(t1, e, i) {
                if (void 0 === e && void 0 === i) {
                    const e = t1;
                    e && e.isColor ? this.copy(e) : "number" == typeof e ? this.setHex(e) : "string" == typeof e && this.setStyle(e);
                } else this.setRGB(t1, e, i);
                return this;
            }
            setScalar(t1) {
                return this.r = t1, this.g = t1, this.b = t1, this;
            }
            setHex(t1, e = _s) {
                return t1 = Math.floor(t1), this.r = (t1 >> 16 & 255) / 255, this.g = (t1 >> 8 & 255) / 255, this.b = (255 & t1) / 255, il.toWorkingColorSpace(this, e), this;
            }
            setRGB(t1, e, i, n = il.workingColorSpace) {
                return this.r = t1, this.g = e, this.b = i, il.toWorkingColorSpace(this, n), this;
            }
            setHSL(t1, e, i, n = il.workingColorSpace) {
                if (t1 = _o(t1, 1), e = Oo(e, 0, 1), i = Oo(i, 0, 1), 0 === e) this.r = this.g = this.b = i;
                else {
                    const n = i <= .5 ? i * (1 + e) : i + e - i * e, r = 2 * i - n;
                    this.r = Uc(r, n, t1 + 1 / 3), this.g = Uc(r, n, t1), this.b = Uc(r, n, t1 - 1 / 3);
                }
                return il.toWorkingColorSpace(this, n), this;
            }
            setStyle(t1, e = _s) {
                function i(e) {
                    void 0 !== e && parseFloat(e) < 1 && console.warn("THREE.Color: Alpha component of " + t1 + " will be ignored.");
                }
                let n;
                if (n = /^(\w+)\(([^\)]*)\)/.exec(t1)) {
                    let r;
                    const a = n[1], s = n[2];
                    switch(a){
                        case "rgb":
                        case "rgba":
                            if (r = /^\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(s)) return i(r[4]), this.setRGB(Math.min(255, parseInt(r[1], 10)) / 255, Math.min(255, parseInt(r[2], 10)) / 255, Math.min(255, parseInt(r[3], 10)) / 255, e);
                            if (r = /^\s*(\d+)\%\s*,\s*(\d+)\%\s*,\s*(\d+)\%\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(s)) return i(r[4]), this.setRGB(Math.min(100, parseInt(r[1], 10)) / 100, Math.min(100, parseInt(r[2], 10)) / 100, Math.min(100, parseInt(r[3], 10)) / 100, e);
                            break;
                        case "hsl":
                        case "hsla":
                            if (r = /^\s*(\d*\.?\d+)\s*,\s*(\d*\.?\d+)\%\s*,\s*(\d*\.?\d+)\%\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(s)) return i(r[4]), this.setHSL(parseFloat(r[1]) / 360, parseFloat(r[2]) / 100, parseFloat(r[3]) / 100, e);
                            break;
                        default:
                            console.warn("THREE.Color: Unknown color model " + t1);
                    }
                } else if (n = /^\#([A-Fa-f\d]+)$/.exec(t1)) {
                    const i = n[1], r = i.length;
                    if (3 === r) return this.setRGB(parseInt(i.charAt(0), 16) / 15, parseInt(i.charAt(1), 16) / 15, parseInt(i.charAt(2), 16) / 15, e);
                    if (6 === r) return this.setHex(parseInt(i, 16), e);
                    console.warn("THREE.Color: Invalid hex color " + t1);
                } else if (t1 && t1.length > 0) return this.setColorName(t1, e);
                return this;
            }
            setColorName(t1, e = _s) {
                const i = jc[t1.toLowerCase()];
                return void 0 !== i ? this.setHex(i, e) : console.warn("THREE.Color: Unknown color " + t1), this;
            }
            clone() {
                return new this.constructor(this.r, this.g, this.b);
            }
            copy(t1) {
                return this.r = t1.r, this.g = t1.g, this.b = t1.b, this;
            }
            copySRGBToLinear(t1) {
                return this.r = nl(t1.r), this.g = nl(t1.g), this.b = nl(t1.b), this;
            }
            copyLinearToSRGB(t1) {
                return this.r = rl(t1.r), this.g = rl(t1.g), this.b = rl(t1.b), this;
            }
            convertSRGBToLinear() {
                return this.copySRGBToLinear(this), this;
            }
            convertLinearToSRGB() {
                return this.copyLinearToSRGB(this), this;
            }
            getHex(t1 = _s) {
                return il.fromWorkingColorSpace(Bc.copy(this), t1), 65536 * Math.round(Oo(255 * Bc.r, 0, 255)) + 256 * Math.round(Oo(255 * Bc.g, 0, 255)) + Math.round(Oo(255 * Bc.b, 0, 255));
            }
            getHexString(t1 = _s) {
                return ("000000" + this.getHex(t1).toString(16)).slice(-6);
            }
            getHSL(t1, e = il.workingColorSpace) {
                il.fromWorkingColorSpace(Bc.copy(this), e);
                const i = Bc.r, n = Bc.g, r = Bc.b, a = Math.max(i, n, r), s = Math.min(i, n, r);
                let o, l;
                const c = (s + a) / 2;
                if (s === a) o = 0, l = 0;
                else {
                    const t1 = a - s;
                    switch(l = c <= .5 ? t1 / (a + s) : t1 / (2 - a - s), a){
                        case i:
                            o = (n - r) / t1 + (n < r ? 6 : 0);
                            break;
                        case n:
                            o = (r - i) / t1 + 2;
                            break;
                        case r:
                            o = (i - n) / t1 + 4;
                    }
                    o /= 6;
                }
                return t1.h = o, t1.s = l, t1.l = c, t1;
            }
            getRGB(t1, e = il.workingColorSpace) {
                return il.fromWorkingColorSpace(Bc.copy(this), e), t1.r = Bc.r, t1.g = Bc.g, t1.b = Bc.b, t1;
            }
            getStyle(t1 = _s) {
                il.fromWorkingColorSpace(Bc.copy(this), t1);
                const e = Bc.r, i = Bc.g, n = Bc.b;
                return t1 !== _s ? `color(${t1} ${e.toFixed(3)} ${i.toFixed(3)} ${n.toFixed(3)})` : `rgb(${Math.round(255 * e)},${Math.round(255 * i)},${Math.round(255 * n)})`;
            }
            offsetHSL(t1, e, i) {
                return this.getHSL(Pc), this.setHSL(Pc.h + t1, Pc.s + e, Pc.l + i);
            }
            add(t1) {
                return this.r += t1.r, this.g += t1.g, this.b += t1.b, this;
            }
            addColors(t1, e) {
                return this.r = t1.r + e.r, this.g = t1.g + e.g, this.b = t1.b + e.b, this;
            }
            addScalar(t1) {
                return this.r += t1, this.g += t1, this.b += t1, this;
            }
            sub(t1) {
                return this.r = Math.max(0, this.r - t1.r), this.g = Math.max(0, this.g - t1.g), this.b = Math.max(0, this.b - t1.b), this;
            }
            multiply(t1) {
                return this.r *= t1.r, this.g *= t1.g, this.b *= t1.b, this;
            }
            multiplyScalar(t1) {
                return this.r *= t1, this.g *= t1, this.b *= t1, this;
            }
            lerp(t1, e) {
                return this.r += (t1.r - this.r) * e, this.g += (t1.g - this.g) * e, this.b += (t1.b - this.b) * e, this;
            }
            lerpColors(t1, e, i) {
                return this.r = t1.r + (e.r - t1.r) * i, this.g = t1.g + (e.g - t1.g) * i, this.b = t1.b + (e.b - t1.b) * i, this;
            }
            lerpHSL(t1, e) {
                this.getHSL(Pc), t1.getHSL(Rc);
                const i = jo(Pc.h, Rc.h, e), n = jo(Pc.s, Rc.s, e), r = jo(Pc.l, Rc.l, e);
                return this.setHSL(i, n, r), this;
            }
            setFromVector3(t1) {
                return this.r = t1.x, this.g = t1.y, this.b = t1.z, this;
            }
            applyMatrix3(t1) {
                const e = this.r, i = this.g, n = this.b, r = t1.elements;
                return this.r = r[0] * e + r[3] * i + r[6] * n, this.g = r[1] * e + r[4] * i + r[7] * n, this.b = r[2] * e + r[5] * i + r[8] * n, this;
            }
            equals(t1) {
                return t1.r === this.r && t1.g === this.g && t1.b === this.b;
            }
            fromArray(t1, e = 0) {
                return this.r = t1[e], this.g = t1[e + 1], this.b = t1[e + 2], this;
            }
            toArray(t1 = [], e = 0) {
                return t1[e] = this.r, t1[e + 1] = this.g, t1[e + 2] = this.b, t1;
            }
            fromBufferAttribute(t1, e) {
                return this.r = t1.getX(e), this.g = t1.getY(e), this.b = t1.getZ(e), this;
            }
            toJSON() {
                return this.getHex();
            }
            *[Symbol.iterator]() {
                yield this.r, yield this.g, yield this.b;
            }
        }
        const Bc = new kc;
        kc.NAMES = jc;
        let Fc = 0;
        class Qc extends So {
            constructor(){
                super(), this.isMaterial = !0, Object.defineProperty(this, "id", {
                    value: Fc++
                }), this.uuid = Lo(), this.name = "", this.type = "Material", this.blending = rr, this.side = $n, this.vertexColors = !1, this.opacity = 1, this.transparent = !1, this.alphaHash = !1, this.blendSrc = Mr, this.blendDst = yr, this.blendEquation = cr, this.blendSrcAlpha = null, this.blendDstAlpha = null, this.blendEquationAlpha = null, this.blendColor = new kc(0, 0, 0), this.blendAlpha = 0, this.depthFunc = Lr, this.depthTest = !0, this.depthWrite = !0, this.stencilWriteMask = 255, this.stencilFunc = no, this.stencilRef = 0, this.stencilFuncMask = 255, this.stencilFail = Hs, this.stencilZFail = Hs, this.stencilZPass = Hs, this.stencilWrite = !1, this.clippingPlanes = null, this.clipIntersection = !1, this.clipShadows = !1, this.shadowSide = null, this.colorWrite = !0, this.precision = null, this.polygonOffset = !1, this.polygonOffsetFactor = 0, this.polygonOffsetUnits = 0, this.dithering = !1, this.alphaToCoverage = !1, this.premultipliedAlpha = !1, this.forceSinglePass = !1, this.visible = !0, this.toneMapped = !0, this.userData = {}, this.version = 0, this._alphaTest = 0;
            }
            get alphaTest() {
                return this._alphaTest;
            }
            set alphaTest(t1) {
                this._alphaTest > 0 != t1 > 0 && this.version++, this._alphaTest = t1;
            }
            onBuild() {}
            onBeforeRender() {}
            onBeforeCompile() {}
            customProgramCacheKey() {
                return this.onBeforeCompile.toString();
            }
            setValues(t1) {
                if (void 0 !== t1) for(const e in t1){
                    const i = t1[e];
                    if (void 0 === i) {
                        console.warn(`THREE.Material: parameter '${e}' has value of undefined.`);
                        continue;
                    }
                    const n = this[e];
                    void 0 !== n ? n && n.isColor ? n.set(i) : n && n.isVector3 && i && i.isVector3 ? n.copy(i) : this[e] = i : console.warn(`THREE.Material: '${e}' is not a property of THREE.${this.type}.`);
                }
            }
            toJSON(t1) {
                const e = void 0 === t1 || "string" == typeof t1;
                e && (t1 = {
                    textures: {},
                    images: {}
                });
                const i = {
                    metadata: {
                        version: 4.6,
                        type: "Material",
                        generator: "Material.toJSON"
                    }
                };
                function n(t1) {
                    const e = [];
                    for(const i in t1){
                        const n = t1[i];
                        delete n.metadata, e.push(n);
                    }
                    return e;
                }
                if (i.uuid = this.uuid, i.type = this.type, "" !== this.name && (i.name = this.name), this.color && this.color.isColor && (i.color = this.color.getHex()), void 0 !== this.roughness && (i.roughness = this.roughness), void 0 !== this.metalness && (i.metalness = this.metalness), void 0 !== this.sheen && (i.sheen = this.sheen), this.sheenColor && this.sheenColor.isColor && (i.sheenColor = this.sheenColor.getHex()), void 0 !== this.sheenRoughness && (i.sheenRoughness = this.sheenRoughness), this.emissive && this.emissive.isColor && (i.emissive = this.emissive.getHex()), this.emissiveIntensity && 1 !== this.emissiveIntensity && (i.emissiveIntensity = this.emissiveIntensity), this.specular && this.specular.isColor && (i.specular = this.specular.getHex()), void 0 !== this.specularIntensity && (i.specularIntensity = this.specularIntensity), this.specularColor && this.specularColor.isColor && (i.specularColor = this.specularColor.getHex()), void 0 !== this.shininess && (i.shininess = this.shininess), void 0 !== this.clearcoat && (i.clearcoat = this.clearcoat), void 0 !== this.clearcoatRoughness && (i.clearcoatRoughness = this.clearcoatRoughness), this.clearcoatMap && this.clearcoatMap.isTexture && (i.clearcoatMap = this.clearcoatMap.toJSON(t1).uuid), this.clearcoatRoughnessMap && this.clearcoatRoughnessMap.isTexture && (i.clearcoatRoughnessMap = this.clearcoatRoughnessMap.toJSON(t1).uuid), this.clearcoatNormalMap && this.clearcoatNormalMap.isTexture && (i.clearcoatNormalMap = this.clearcoatNormalMap.toJSON(t1).uuid, i.clearcoatNormalScale = this.clearcoatNormalScale.toArray()), void 0 !== this.iridescence && (i.iridescence = this.iridescence), void 0 !== this.iridescenceIOR && (i.iridescenceIOR = this.iridescenceIOR), void 0 !== this.iridescenceThicknessRange && (i.iridescenceThicknessRange = this.iridescenceThicknessRange), this.iridescenceMap && this.iridescenceMap.isTexture && (i.iridescenceMap = this.iridescenceMap.toJSON(t1).uuid), this.iridescenceThicknessMap && this.iridescenceThicknessMap.isTexture && (i.iridescenceThicknessMap = this.iridescenceThicknessMap.toJSON(t1).uuid), void 0 !== this.anisotropy && (i.anisotropy = this.anisotropy), void 0 !== this.anisotropyRotation && (i.anisotropyRotation = this.anisotropyRotation), this.anisotropyMap && this.anisotropyMap.isTexture && (i.anisotropyMap = this.anisotropyMap.toJSON(t1).uuid), this.map && this.map.isTexture && (i.map = this.map.toJSON(t1).uuid), this.matcap && this.matcap.isTexture && (i.matcap = this.matcap.toJSON(t1).uuid), this.alphaMap && this.alphaMap.isTexture && (i.alphaMap = this.alphaMap.toJSON(t1).uuid), this.lightMap && this.lightMap.isTexture && (i.lightMap = this.lightMap.toJSON(t1).uuid, i.lightMapIntensity = this.lightMapIntensity), this.aoMap && this.aoMap.isTexture && (i.aoMap = this.aoMap.toJSON(t1).uuid, i.aoMapIntensity = this.aoMapIntensity), this.bumpMap && this.bumpMap.isTexture && (i.bumpMap = this.bumpMap.toJSON(t1).uuid, i.bumpScale = this.bumpScale), this.normalMap && this.normalMap.isTexture && (i.normalMap = this.normalMap.toJSON(t1).uuid, i.normalMapType = this.normalMapType, i.normalScale = this.normalScale.toArray()), this.displacementMap && this.displacementMap.isTexture && (i.displacementMap = this.displacementMap.toJSON(t1).uuid, i.displacementScale = this.displacementScale, i.displacementBias = this.displacementBias), this.roughnessMap && this.roughnessMap.isTexture && (i.roughnessMap = this.roughnessMap.toJSON(t1).uuid), this.metalnessMap && this.metalnessMap.isTexture && (i.metalnessMap = this.metalnessMap.toJSON(t1).uuid), this.emissiveMap && this.emissiveMap.isTexture && (i.emissiveMap = this.emissiveMap.toJSON(t1).uuid), this.specularMap && this.specularMap.isTexture && (i.specularMap = this.specularMap.toJSON(t1).uuid), this.specularIntensityMap && this.specularIntensityMap.isTexture && (i.specularIntensityMap = this.specularIntensityMap.toJSON(t1).uuid), this.specularColorMap && this.specularColorMap.isTexture && (i.specularColorMap = this.specularColorMap.toJSON(t1).uuid), this.envMap && this.envMap.isTexture && (i.envMap = this.envMap.toJSON(t1).uuid, void 0 !== this.combine && (i.combine = this.combine)), void 0 !== this.envMapIntensity && (i.envMapIntensity = this.envMapIntensity), void 0 !== this.reflectivity && (i.reflectivity = this.reflectivity), void 0 !== this.refractionRatio && (i.refractionRatio = this.refractionRatio), this.gradientMap && this.gradientMap.isTexture && (i.gradientMap = this.gradientMap.toJSON(t1).uuid), void 0 !== this.transmission && (i.transmission = this.transmission), this.transmissionMap && this.transmissionMap.isTexture && (i.transmissionMap = this.transmissionMap.toJSON(t1).uuid), void 0 !== this.thickness && (i.thickness = this.thickness), this.thicknessMap && this.thicknessMap.isTexture && (i.thicknessMap = this.thicknessMap.toJSON(t1).uuid), void 0 !== this.attenuationDistance && this.attenuationDistance !== 1 / 0 && (i.attenuationDistance = this.attenuationDistance), void 0 !== this.attenuationColor && (i.attenuationColor = this.attenuationColor.getHex()), void 0 !== this.size && (i.size = this.size), null !== this.shadowSide && (i.shadowSide = this.shadowSide), void 0 !== this.sizeAttenuation && (i.sizeAttenuation = this.sizeAttenuation), this.blending !== rr && (i.blending = this.blending), this.side !== $n && (i.side = this.side), !0 === this.vertexColors && (i.vertexColors = !0), this.opacity < 1 && (i.opacity = this.opacity), !0 === this.transparent && (i.transparent = !0), this.blendSrc !== Mr && (i.blendSrc = this.blendSrc), this.blendDst !== yr && (i.blendDst = this.blendDst), this.blendEquation !== cr && (i.blendEquation = this.blendEquation), null !== this.blendSrcAlpha && (i.blendSrcAlpha = this.blendSrcAlpha), null !== this.blendDstAlpha && (i.blendDstAlpha = this.blendDstAlpha), null !== this.blendEquationAlpha && (i.blendEquationAlpha = this.blendEquationAlpha), this.blendColor && this.blendColor.isColor && (i.blendColor = this.blendColor.getHex()), 0 !== this.blendAlpha && (i.blendAlpha = this.blendAlpha), this.depthFunc !== Lr && (i.depthFunc = this.depthFunc), !1 === this.depthTest && (i.depthTest = this.depthTest), !1 === this.depthWrite && (i.depthWrite = this.depthWrite), !1 === this.colorWrite && (i.colorWrite = this.colorWrite), 255 !== this.stencilWriteMask && (i.stencilWriteMask = this.stencilWriteMask), this.stencilFunc !== no && (i.stencilFunc = this.stencilFunc), 0 !== this.stencilRef && (i.stencilRef = this.stencilRef), 255 !== this.stencilFuncMask && (i.stencilFuncMask = this.stencilFuncMask), this.stencilFail !== Hs && (i.stencilFail = this.stencilFail), this.stencilZFail !== Hs && (i.stencilZFail = this.stencilZFail), this.stencilZPass !== Hs && (i.stencilZPass = this.stencilZPass), !0 === this.stencilWrite && (i.stencilWrite = this.stencilWrite), void 0 !== this.rotation && 0 !== this.rotation && (i.rotation = this.rotation), !0 === this.polygonOffset && (i.polygonOffset = !0), 0 !== this.polygonOffsetFactor && (i.polygonOffsetFactor = this.polygonOffsetFactor), 0 !== this.polygonOffsetUnits && (i.polygonOffsetUnits = this.polygonOffsetUnits), void 0 !== this.linewidth && 1 !== this.linewidth && (i.linewidth = this.linewidth), void 0 !== this.dashSize && (i.dashSize = this.dashSize), void 0 !== this.gapSize && (i.gapSize = this.gapSize), void 0 !== this.scale && (i.scale = this.scale), !0 === this.dithering && (i.dithering = !0), this.alphaTest > 0 && (i.alphaTest = this.alphaTest), !0 === this.alphaHash && (i.alphaHash = !0), !0 === this.alphaToCoverage && (i.alphaToCoverage = !0), !0 === this.premultipliedAlpha && (i.premultipliedAlpha = !0), !0 === this.forceSinglePass && (i.forceSinglePass = !0), !0 === this.wireframe && (i.wireframe = !0), this.wireframeLinewidth > 1 && (i.wireframeLinewidth = this.wireframeLinewidth), "round" !== this.wireframeLinecap && (i.wireframeLinecap = this.wireframeLinecap), "round" !== this.wireframeLinejoin && (i.wireframeLinejoin = this.wireframeLinejoin), !0 === this.flatShading && (i.flatShading = !0), !1 === this.visible && (i.visible = !1), !1 === this.toneMapped && (i.toneMapped = !1), !1 === this.fog && (i.fog = !1), Object.keys(this.userData).length > 0 && (i.userData = this.userData), e) {
                    const e = n(t1.textures), r = n(t1.images);
                    e.length > 0 && (i.textures = e), r.length > 0 && (i.images = r);
                }
                return i;
            }
            clone() {
                return (new this.constructor).copy(this);
            }
            copy(t1) {
                this.name = t1.name, this.blending = t1.blending, this.side = t1.side, this.vertexColors = t1.vertexColors, this.opacity = t1.opacity, this.transparent = t1.transparent, this.blendSrc = t1.blendSrc, this.blendDst = t1.blendDst, this.blendEquation = t1.blendEquation, this.blendSrcAlpha = t1.blendSrcAlpha, this.blendDstAlpha = t1.blendDstAlpha, this.blendEquationAlpha = t1.blendEquationAlpha, this.blendColor.copy(t1.blendColor), this.blendAlpha = t1.blendAlpha, this.depthFunc = t1.depthFunc, this.depthTest = t1.depthTest, this.depthWrite = t1.depthWrite, this.stencilWriteMask = t1.stencilWriteMask, this.stencilFunc = t1.stencilFunc, this.stencilRef = t1.stencilRef, this.stencilFuncMask = t1.stencilFuncMask, this.stencilFail = t1.stencilFail, this.stencilZFail = t1.stencilZFail, this.stencilZPass = t1.stencilZPass, this.stencilWrite = t1.stencilWrite;
                const e = t1.clippingPlanes;
                let i = null;
                if (null !== e) {
                    const t1 = e.length;
                    i = new Array(t1);
                    for(let n = 0; n !== t1; ++n)i[n] = e[n].clone();
                }
                return this.clippingPlanes = i, this.clipIntersection = t1.clipIntersection, this.clipShadows = t1.clipShadows, this.shadowSide = t1.shadowSide, this.colorWrite = t1.colorWrite, this.precision = t1.precision, this.polygonOffset = t1.polygonOffset, this.polygonOffsetFactor = t1.polygonOffsetFactor, this.polygonOffsetUnits = t1.polygonOffsetUnits, this.dithering = t1.dithering, this.alphaTest = t1.alphaTest, this.alphaHash = t1.alphaHash, this.alphaToCoverage = t1.alphaToCoverage, this.premultipliedAlpha = t1.premultipliedAlpha, this.forceSinglePass = t1.forceSinglePass, this.visible = t1.visible, this.toneMapped = t1.toneMapped, this.userData = JSON.parse(JSON.stringify(t1.userData)), this;
            }
            dispose() {
                this.dispatchEvent({
                    type: "dispose"
                });
            }
            set needsUpdate(t1) {
                !0 === t1 && this.version++;
            }
        }
        class Hc extends Qc {
            constructor(t1){
                super(), this.isMeshBasicMaterial = !0, this.type = "MeshBasicMaterial", this.color = new kc(16777215), this.map = null, this.lightMap = null, this.lightMapIntensity = 1, this.aoMap = null, this.aoMapIntensity = 1, this.specularMap = null, this.alphaMap = null, this.envMap = null, this.combine = Rr, this.reflectivity = 1, this.refractionRatio = .98, this.wireframe = !1, this.wireframeLinewidth = 1, this.wireframeLinecap = "round", this.wireframeLinejoin = "round", this.fog = !0, this.setValues(t1);
            }
            copy(t1) {
                return super.copy(t1), this.color.copy(t1.color), this.map = t1.map, this.lightMap = t1.lightMap, this.lightMapIntensity = t1.lightMapIntensity, this.aoMap = t1.aoMap, this.aoMapIntensity = t1.aoMapIntensity, this.specularMap = t1.specularMap, this.alphaMap = t1.alphaMap, this.envMap = t1.envMap, this.combine = t1.combine, this.reflectivity = t1.reflectivity, this.refractionRatio = t1.refractionRatio, this.wireframe = t1.wireframe, this.wireframeLinewidth = t1.wireframeLinewidth, this.wireframeLinecap = t1.wireframeLinecap, this.wireframeLinejoin = t1.wireframeLinejoin, this.fog = t1.fog, this;
            }
        }
        const Vc = Gc();
        function Gc() {
            const t1 = new ArrayBuffer(4), e = new Float32Array(t1), i = new Uint32Array(t1), n = new Uint32Array(512), r = new Uint32Array(512);
            for(let t1 = 0; t1 < 256; ++t1){
                const e = t1 - 127;
                e < -27 ? (n[t1] = 0, n[256 | t1] = 32768, r[t1] = 24, r[256 | t1] = 24) : e < -14 ? (n[t1] = 1024 >> -e - 14, n[256 | t1] = 1024 >> -e - 14 | 32768, r[t1] = -e - 1, r[256 | t1] = -e - 1) : e <= 15 ? (n[t1] = e + 15 << 10, n[256 | t1] = e + 15 << 10 | 32768, r[t1] = 13, r[256 | t1] = 13) : e < 128 ? (n[t1] = 31744, n[256 | t1] = 64512, r[t1] = 24, r[256 | t1] = 24) : (n[t1] = 31744, n[256 | t1] = 64512, r[t1] = 13, r[256 | t1] = 13);
            }
            const a = new Uint32Array(2048), s = new Uint32Array(64), o = new Uint32Array(64);
            for(let t1 = 1; t1 < 1024; ++t1){
                let e = t1 << 13, i = 0;
                for(; !(8388608 & e);)e <<= 1, i -= 8388608;
                e &= -8388609, i += 947912704, a[t1] = e | i;
            }
            for(let t1 = 1024; t1 < 2048; ++t1)a[t1] = 939524096 + (t1 - 1024 << 13);
            for(let t1 = 1; t1 < 31; ++t1)s[t1] = t1 << 23;
            s[31] = 1199570944, s[32] = 2147483648;
            for(let t1 = 33; t1 < 63; ++t1)s[t1] = 2147483648 + (t1 - 32 << 23);
            s[63] = 3347054592;
            for(let t1 = 1; t1 < 64; ++t1)32 !== t1 && (o[t1] = 1024);
            return {
                floatView: e,
                uint32View: i,
                baseTable: n,
                shiftTable: r,
                mantissaTable: a,
                exponentTable: s,
                offsetTable: o
            };
        }
        function Yc(t1) {
            Math.abs(t1) > 65504 && console.warn("THREE.DataUtils.toHalfFloat(): Value out of range."), t1 = Oo(t1, -65504, 65504), Vc.floatView[0] = t1;
            const e = Vc.uint32View[0], i = e >> 23 & 511;
            return Vc.baseTable[i] + ((8388607 & e) >> Vc.shiftTable[i]);
        }
        function Wc(t1) {
            const e = t1 >> 10;
            return Vc.uint32View[0] = Vc.mantissaTable[Vc.offsetTable[e] + (1023 & t1)] + Vc.exponentTable[e], Vc.floatView[0];
        }
        const Xc = {
            toHalfFloat: Yc,
            fromHalfFloat: Wc
        }, Zc = new xl, Jc = new Qo;
        class Kc {
            constructor(t1, e, i = !1){
                if (Array.isArray(t1)) throw new TypeError("THREE.BufferAttribute: array should be a Typed Array.");
                this.isBufferAttribute = !0, this.name = "", this.array = t1, this.itemSize = e, this.count = void 0 !== t1 ? t1.length / e : 0, this.normalized = i, this.usage = po, this.updateRange = {
                    offset: 0,
                    count: -1
                }, this.gpuType = ya, this.version = 0;
            }
            onUploadCallback() {}
            set needsUpdate(t1) {
                !0 === t1 && this.version++;
            }
            setUsage(t1) {
                return this.usage = t1, this;
            }
            copy(t1) {
                return this.name = t1.name, this.array = new t1.array.constructor(t1.array), this.itemSize = t1.itemSize, this.count = t1.count, this.normalized = t1.normalized, this.usage = t1.usage, this.gpuType = t1.gpuType, this;
            }
            copyAt(t1, e, i) {
                t1 *= this.itemSize, i *= e.itemSize;
                for(let n = 0, r = this.itemSize; n < r; n++)this.array[t1 + n] = e.array[i + n];
                return this;
            }
            copyArray(t1) {
                return this.array.set(t1), this;
            }
            applyMatrix3(t1) {
                if (2 === this.itemSize) for(let e = 0, i = this.count; e < i; e++)Jc.fromBufferAttribute(this, e), Jc.applyMatrix3(t1), this.setXY(e, Jc.x, Jc.y);
                else if (3 === this.itemSize) for(let e = 0, i = this.count; e < i; e++)Zc.fromBufferAttribute(this, e), Zc.applyMatrix3(t1), this.setXYZ(e, Zc.x, Zc.y, Zc.z);
                return this;
            }
            applyMatrix4(t1) {
                for(let e = 0, i = this.count; e < i; e++)Zc.fromBufferAttribute(this, e), Zc.applyMatrix4(t1), this.setXYZ(e, Zc.x, Zc.y, Zc.z);
                return this;
            }
            applyNormalMatrix(t1) {
                for(let e = 0, i = this.count; e < i; e++)Zc.fromBufferAttribute(this, e), Zc.applyNormalMatrix(t1), this.setXYZ(e, Zc.x, Zc.y, Zc.z);
                return this;
            }
            transformDirection(t1) {
                for(let e = 0, i = this.count; e < i; e++)Zc.fromBufferAttribute(this, e), Zc.transformDirection(t1), this.setXYZ(e, Zc.x, Zc.y, Zc.z);
                return this;
            }
            set(t1, e = 0) {
                return this.array.set(t1, e), this;
            }
            getComponent(t1, e) {
                let i = this.array[t1 * this.itemSize + e];
                return this.normalized && (i = ko(i, this.array)), i;
            }
            setComponent(t1, e, i) {
                return this.normalized && (i = Bo(i, this.array)), this.array[t1 * this.itemSize + e] = i, this;
            }
            getX(t1) {
                let e = this.array[t1 * this.itemSize];
                return this.normalized && (e = ko(e, this.array)), e;
            }
            setX(t1, e) {
                return this.normalized && (e = Bo(e, this.array)), this.array[t1 * this.itemSize] = e, this;
            }
            getY(t1) {
                let e = this.array[t1 * this.itemSize + 1];
                return this.normalized && (e = ko(e, this.array)), e;
            }
            setY(t1, e) {
                return this.normalized && (e = Bo(e, this.array)), this.array[t1 * this.itemSize + 1] = e, this;
            }
            getZ(t1) {
                let e = this.array[t1 * this.itemSize + 2];
                return this.normalized && (e = ko(e, this.array)), e;
            }
            setZ(t1, e) {
                return this.normalized && (e = Bo(e, this.array)), this.array[t1 * this.itemSize + 2] = e, this;
            }
            getW(t1) {
                let e = this.array[t1 * this.itemSize + 3];
                return this.normalized && (e = ko(e, this.array)), e;
            }
            setW(t1, e) {
                return this.normalized && (e = Bo(e, this.array)), this.array[t1 * this.itemSize + 3] = e, this;
            }
            setXY(t1, e, i) {
                return t1 *= this.itemSize, this.normalized && (e = Bo(e, this.array), i = Bo(i, this.array)), this.array[t1 + 0] = e, this.array[t1 + 1] = i, this;
            }
            setXYZ(t1, e, i, n) {
                return t1 *= this.itemSize, this.normalized && (e = Bo(e, this.array), i = Bo(i, this.array), n = Bo(n, this.array)), this.array[t1 + 0] = e, this.array[t1 + 1] = i, this.array[t1 + 2] = n, this;
            }
            setXYZW(t1, e, i, n, r) {
                return t1 *= this.itemSize, this.normalized && (e = Bo(e, this.array), i = Bo(i, this.array), n = Bo(n, this.array), r = Bo(r, this.array)), this.array[t1 + 0] = e, this.array[t1 + 1] = i, this.array[t1 + 2] = n, this.array[t1 + 3] = r, this;
            }
            onUpload(t1) {
                return this.onUploadCallback = t1, this;
            }
            clone() {
                return new this.constructor(this.array, this.itemSize).copy(this);
            }
            toJSON() {
                const t1 = {
                    itemSize: this.itemSize,
                    type: this.array.constructor.name,
                    array: Array.from(this.array),
                    normalized: this.normalized
                };
                return "" !== this.name && (t1.name = this.name), this.usage !== po && (t1.usage = this.usage), 0 === this.updateRange.offset && -1 === this.updateRange.count || (t1.updateRange = this.updateRange), t1;
            }
        }
        class qc extends Kc {
            constructor(t1, e, i){
                super(new Int8Array(t1), e, i);
            }
        }
        class $c extends Kc {
            constructor(t1, e, i){
                super(new Uint8Array(t1), e, i);
            }
        }
        class tu extends Kc {
            constructor(t1, e, i){
                super(new Uint8ClampedArray(t1), e, i);
            }
        }
        class eu extends Kc {
            constructor(t1, e, i){
                super(new Int16Array(t1), e, i);
            }
        }
        class iu extends Kc {
            constructor(t1, e, i){
                super(new Uint16Array(t1), e, i);
            }
        }
        class nu extends Kc {
            constructor(t1, e, i){
                super(new Int32Array(t1), e, i);
            }
        }
        class ru extends Kc {
            constructor(t1, e, i){
                super(new Uint32Array(t1), e, i);
            }
        }
        class au extends Kc {
            constructor(t1, e, i){
                super(new Uint16Array(t1), e, i), this.isFloat16BufferAttribute = !0;
            }
            getX(t1) {
                let e = Wc(this.array[t1 * this.itemSize]);
                return this.normalized && (e = ko(e, this.array)), e;
            }
            setX(t1, e) {
                return this.normalized && (e = Bo(e, this.array)), this.array[t1 * this.itemSize] = Yc(e), this;
            }
            getY(t1) {
                let e = Wc(this.array[t1 * this.itemSize + 1]);
                return this.normalized && (e = ko(e, this.array)), e;
            }
            setY(t1, e) {
                return this.normalized && (e = Bo(e, this.array)), this.array[t1 * this.itemSize + 1] = Yc(e), this;
            }
            getZ(t1) {
                let e = Wc(this.array[t1 * this.itemSize + 2]);
                return this.normalized && (e = ko(e, this.array)), e;
            }
            setZ(t1, e) {
                return this.normalized && (e = Bo(e, this.array)), this.array[t1 * this.itemSize + 2] = Yc(e), this;
            }
            getW(t1) {
                let e = Wc(this.array[t1 * this.itemSize + 3]);
                return this.normalized && (e = ko(e, this.array)), e;
            }
            setW(t1, e) {
                return this.normalized && (e = Bo(e, this.array)), this.array[t1 * this.itemSize + 3] = Yc(e), this;
            }
            setXY(t1, e, i) {
                return t1 *= this.itemSize, this.normalized && (e = Bo(e, this.array), i = Bo(i, this.array)), this.array[t1 + 0] = Yc(e), this.array[t1 + 1] = Yc(i), this;
            }
            setXYZ(t1, e, i, n) {
                return t1 *= this.itemSize, this.normalized && (e = Bo(e, this.array), i = Bo(i, this.array), n = Bo(n, this.array)), this.array[t1 + 0] = Yc(e), this.array[t1 + 1] = Yc(i), this.array[t1 + 2] = Yc(n), this;
            }
            setXYZW(t1, e, i, n, r) {
                return t1 *= this.itemSize, this.normalized && (e = Bo(e, this.array), i = Bo(i, this.array), n = Bo(n, this.array), r = Bo(r, this.array)), this.array[t1 + 0] = Yc(e), this.array[t1 + 1] = Yc(i), this.array[t1 + 2] = Yc(n), this.array[t1 + 3] = Yc(r), this;
            }
        }
        class su extends Kc {
            constructor(t1, e, i){
                super(new Float32Array(t1), e, i);
            }
        }
        class ou extends Kc {
            constructor(t1, e, i){
                super(new Float64Array(t1), e, i);
            }
        }
        let lu = 0;
        const cu = new Kl, uu = new wc, hu = new xl, du = new Tl, pu = new Tl, fu = new xl;
        class Au extends So {
            constructor(){
                super(), this.isBufferGeometry = !0, Object.defineProperty(this, "id", {
                    value: lu++
                }), this.uuid = Lo(), this.name = "", this.type = "BufferGeometry", this.index = null, this.attributes = {}, this.morphAttributes = {}, this.morphTargetsRelative = !1, this.groups = [], this.boundingBox = null, this.boundingSphere = null, this.drawRange = {
                    start: 0,
                    count: 1 / 0
                }, this.userData = {};
            }
            getIndex() {
                return this.index;
            }
            setIndex(t1) {
                return Array.isArray(t1) ? this.index = new (Go(t1) ? ru : iu)(t1, 1) : this.index = t1, this;
            }
            getAttribute(t1) {
                return this.attributes[t1];
            }
            setAttribute(t1, e) {
                return this.attributes[t1] = e, this;
            }
            deleteAttribute(t1) {
                return delete this.attributes[t1], this;
            }
            hasAttribute(t1) {
                return void 0 !== this.attributes[t1];
            }
            addGroup(t1, e, i = 0) {
                this.groups.push({
                    start: t1,
                    count: e,
                    materialIndex: i
                });
            }
            clearGroups() {
                this.groups = [];
            }
            setDrawRange(t1, e) {
                this.drawRange.start = t1, this.drawRange.count = e;
            }
            applyMatrix4(t1) {
                const e = this.attributes.position;
                void 0 !== e && (e.applyMatrix4(t1), e.needsUpdate = !0);
                const i = this.attributes.normal;
                if (void 0 !== i) {
                    const e = (new Ho).getNormalMatrix(t1);
                    i.applyNormalMatrix(e), i.needsUpdate = !0;
                }
                const n = this.attributes.tangent;
                return void 0 !== n && (n.transformDirection(t1), n.needsUpdate = !0), null !== this.boundingBox && this.computeBoundingBox(), null !== this.boundingSphere && this.computeBoundingSphere(), this;
            }
            applyQuaternion(t1) {
                return cu.makeRotationFromQuaternion(t1), this.applyMatrix4(cu), this;
            }
            rotateX(t1) {
                return cu.makeRotationX(t1), this.applyMatrix4(cu), this;
            }
            rotateY(t1) {
                return cu.makeRotationY(t1), this.applyMatrix4(cu), this;
            }
            rotateZ(t1) {
                return cu.makeRotationZ(t1), this.applyMatrix4(cu), this;
            }
            translate(t1, e, i) {
                return cu.makeTranslation(t1, e, i), this.applyMatrix4(cu), this;
            }
            scale(t1, e, i) {
                return cu.makeScale(t1, e, i), this.applyMatrix4(cu), this;
            }
            lookAt(t1) {
                return uu.lookAt(t1), uu.updateMatrix(), this.applyMatrix4(uu.matrix), this;
            }
            center() {
                return this.computeBoundingBox(), this.boundingBox.getCenter(hu).negate(), this.translate(hu.x, hu.y, hu.z), this;
            }
            setFromPoints(t1) {
                const e = [];
                for(let i = 0, n = t1.length; i < n; i++){
                    const n = t1[i];
                    e.push(n.x, n.y, n.z || 0);
                }
                return this.setAttribute("position", new su(e, 3)), this;
            }
            computeBoundingBox() {
                null === this.boundingBox && (this.boundingBox = new Tl);
                const t1 = this.attributes.position, e = this.morphAttributes.position;
                if (t1 && t1.isGLBufferAttribute) return console.error('THREE.BufferGeometry.computeBoundingBox(): GLBufferAttribute requires a manual bounding box. Alternatively set "mesh.frustumCulled" to "false".', this), void this.boundingBox.set(new xl(-1 / 0, -1 / 0, -1 / 0), new xl(1 / 0, 1 / 0, 1 / 0));
                if (void 0 !== t1) {
                    if (this.boundingBox.setFromBufferAttribute(t1), e) for(let t1 = 0, i = e.length; t1 < i; t1++){
                        const i = e[t1];
                        du.setFromBufferAttribute(i), this.morphTargetsRelative ? (fu.addVectors(this.boundingBox.min, du.min), this.boundingBox.expandByPoint(fu), fu.addVectors(this.boundingBox.max, du.max), this.boundingBox.expandByPoint(fu)) : (this.boundingBox.expandByPoint(du.min), this.boundingBox.expandByPoint(du.max));
                    }
                } else this.boundingBox.makeEmpty();
                (isNaN(this.boundingBox.min.x) || isNaN(this.boundingBox.min.y) || isNaN(this.boundingBox.min.z)) && console.error('THREE.BufferGeometry.computeBoundingBox(): Computed min/max have NaN values. The "position" attribute is likely to have NaN values.', this);
            }
            computeBoundingSphere() {
                null === this.boundingSphere && (this.boundingSphere = new Ql);
                const t1 = this.attributes.position, e = this.morphAttributes.position;
                if (t1 && t1.isGLBufferAttribute) return console.error('THREE.BufferGeometry.computeBoundingSphere(): GLBufferAttribute requires a manual bounding sphere. Alternatively set "mesh.frustumCulled" to "false".', this), void this.boundingSphere.set(new xl, 1 / 0);
                if (t1) {
                    const i = this.boundingSphere.center;
                    if (du.setFromBufferAttribute(t1), e) for(let t1 = 0, i = e.length; t1 < i; t1++){
                        const i = e[t1];
                        pu.setFromBufferAttribute(i), this.morphTargetsRelative ? (fu.addVectors(du.min, pu.min), du.expandByPoint(fu), fu.addVectors(du.max, pu.max), du.expandByPoint(fu)) : (du.expandByPoint(pu.min), du.expandByPoint(pu.max));
                    }
                    du.getCenter(i);
                    let n = 0;
                    for(let e = 0, r = t1.count; e < r; e++)fu.fromBufferAttribute(t1, e), n = Math.max(n, i.distanceToSquared(fu));
                    if (e) for(let r = 0, a = e.length; r < a; r++){
                        const a = e[r], s = this.morphTargetsRelative;
                        for(let e = 0, r = a.count; e < r; e++)fu.fromBufferAttribute(a, e), s && (hu.fromBufferAttribute(t1, e), fu.add(hu)), n = Math.max(n, i.distanceToSquared(fu));
                    }
                    this.boundingSphere.radius = Math.sqrt(n), isNaN(this.boundingSphere.radius) && console.error('THREE.BufferGeometry.computeBoundingSphere(): Computed radius is NaN. The "position" attribute is likely to have NaN values.', this);
                }
            }
            computeTangents() {
                const t1 = this.index, e = this.attributes;
                if (null === t1 || void 0 === e.position || void 0 === e.normal || void 0 === e.uv) return void console.error("THREE.BufferGeometry: .computeTangents() failed. Missing required attributes (index, position, normal or uv)");
                const i = t1.array, n = e.position.array, r = e.normal.array, a = e.uv.array, s = n.length / 3;
                !1 === this.hasAttribute("tangent") && this.setAttribute("tangent", new Kc(new Float32Array(4 * s), 4));
                const o = this.getAttribute("tangent").array, l = [], c = [];
                for(let t1 = 0; t1 < s; t1++)l[t1] = new xl, c[t1] = new xl;
                const u = new xl, h = new xl, d = new xl, p = new Qo, f = new Qo, A = new Qo, g = new xl, m = new xl;
                function M(t1, e, i) {
                    u.fromArray(n, 3 * t1), h.fromArray(n, 3 * e), d.fromArray(n, 3 * i), p.fromArray(a, 2 * t1), f.fromArray(a, 2 * e), A.fromArray(a, 2 * i), h.sub(u), d.sub(u), f.sub(p), A.sub(p);
                    const r = 1 / (f.x * A.y - A.x * f.y);
                    isFinite(r) && (g.copy(h).multiplyScalar(A.y).addScaledVector(d, -f.y).multiplyScalar(r), m.copy(d).multiplyScalar(f.x).addScaledVector(h, -A.x).multiplyScalar(r), l[t1].add(g), l[e].add(g), l[i].add(g), c[t1].add(m), c[e].add(m), c[i].add(m));
                }
                let y = this.groups;
                0 === y.length && (y = [
                    {
                        start: 0,
                        count: i.length
                    }
                ]);
                for(let t1 = 0, e = y.length; t1 < e; ++t1){
                    const e = y[t1], n = e.start;
                    for(let t1 = n, r = n + e.count; t1 < r; t1 += 3)M(i[t1 + 0], i[t1 + 1], i[t1 + 2]);
                }
                const v = new xl, x = new xl, w = new xl, b = new xl;
                function T(t1) {
                    w.fromArray(r, 3 * t1), b.copy(w);
                    const e = l[t1];
                    v.copy(e), v.sub(w.multiplyScalar(w.dot(e))).normalize(), x.crossVectors(b, e);
                    const i = x.dot(c[t1]) < 0 ? -1 : 1;
                    o[4 * t1] = v.x, o[4 * t1 + 1] = v.y, o[4 * t1 + 2] = v.z, o[4 * t1 + 3] = i;
                }
                for(let t1 = 0, e = y.length; t1 < e; ++t1){
                    const e = y[t1], n = e.start;
                    for(let t1 = n, r = n + e.count; t1 < r; t1 += 3)T(i[t1 + 0]), T(i[t1 + 1]), T(i[t1 + 2]);
                }
            }
            computeVertexNormals() {
                const t1 = this.index, e = this.getAttribute("position");
                if (void 0 !== e) {
                    let i = this.getAttribute("normal");
                    if (void 0 === i) i = new Kc(new Float32Array(3 * e.count), 3), this.setAttribute("normal", i);
                    else for(let t1 = 0, e = i.count; t1 < e; t1++)i.setXYZ(t1, 0, 0, 0);
                    const n = new xl, r = new xl, a = new xl, s = new xl, o = new xl, l = new xl, c = new xl, u = new xl;
                    if (t1) for(let h = 0, d = t1.count; h < d; h += 3){
                        const d = t1.getX(h + 0), p = t1.getX(h + 1), f = t1.getX(h + 2);
                        n.fromBufferAttribute(e, d), r.fromBufferAttribute(e, p), a.fromBufferAttribute(e, f), c.subVectors(a, r), u.subVectors(n, r), c.cross(u), s.fromBufferAttribute(i, d), o.fromBufferAttribute(i, p), l.fromBufferAttribute(i, f), s.add(c), o.add(c), l.add(c), i.setXYZ(d, s.x, s.y, s.z), i.setXYZ(p, o.x, o.y, o.z), i.setXYZ(f, l.x, l.y, l.z);
                    }
                    else for(let t1 = 0, s = e.count; t1 < s; t1 += 3)n.fromBufferAttribute(e, t1 + 0), r.fromBufferAttribute(e, t1 + 1), a.fromBufferAttribute(e, t1 + 2), c.subVectors(a, r), u.subVectors(n, r), c.cross(u), i.setXYZ(t1 + 0, c.x, c.y, c.z), i.setXYZ(t1 + 1, c.x, c.y, c.z), i.setXYZ(t1 + 2, c.x, c.y, c.z);
                    this.normalizeNormals(), i.needsUpdate = !0;
                }
            }
            normalizeNormals() {
                const t1 = this.attributes.normal;
                for(let e = 0, i = t1.count; e < i; e++)fu.fromBufferAttribute(t1, e), fu.normalize(), t1.setXYZ(e, fu.x, fu.y, fu.z);
            }
            toNonIndexed() {
                function t1(t1, e) {
                    const i = t1.array, n = t1.itemSize, r = t1.normalized, a = new i.constructor(e.length * n);
                    let s = 0, o = 0;
                    for(let r = 0, l = e.length; r < l; r++){
                        s = t1.isInterleavedBufferAttribute ? e[r] * t1.data.stride + t1.offset : e[r] * n;
                        for(let t1 = 0; t1 < n; t1++)a[o++] = i[s++];
                    }
                    return new Kc(a, n, r);
                }
                if (null === this.index) return console.warn("THREE.BufferGeometry.toNonIndexed(): BufferGeometry is already non-indexed."), this;
                const e = new Au, i = this.index.array, n = this.attributes;
                for(const r in n){
                    const a = t1(n[r], i);
                    e.setAttribute(r, a);
                }
                const r = this.morphAttributes;
                for(const n in r){
                    const a = [], s = r[n];
                    for(let e = 0, n = s.length; e < n; e++){
                        const n = t1(s[e], i);
                        a.push(n);
                    }
                    e.morphAttributes[n] = a;
                }
                e.morphTargetsRelative = this.morphTargetsRelative;
                const a = this.groups;
                for(let t1 = 0, i = a.length; t1 < i; t1++){
                    const i = a[t1];
                    e.addGroup(i.start, i.count, i.materialIndex);
                }
                return e;
            }
            toJSON() {
                const t1 = {
                    metadata: {
                        version: 4.6,
                        type: "BufferGeometry",
                        generator: "BufferGeometry.toJSON"
                    }
                };
                if (t1.uuid = this.uuid, t1.type = this.type, "" !== this.name && (t1.name = this.name), Object.keys(this.userData).length > 0 && (t1.userData = this.userData), void 0 !== this.parameters) {
                    const e = this.parameters;
                    for(const i in e)void 0 !== e[i] && (t1[i] = e[i]);
                    return t1;
                }
                t1.data = {
                    attributes: {}
                };
                const e = this.index;
                null !== e && (t1.data.index = {
                    type: e.array.constructor.name,
                    array: Array.prototype.slice.call(e.array)
                });
                const i = this.attributes;
                for(const e in i){
                    const n = i[e];
                    t1.data.attributes[e] = n.toJSON(t1.data);
                }
                const n = {};
                let r = !1;
                for(const e in this.morphAttributes){
                    const i = this.morphAttributes[e], a = [];
                    for(let e = 0, n = i.length; e < n; e++){
                        const n = i[e];
                        a.push(n.toJSON(t1.data));
                    }
                    a.length > 0 && (n[e] = a, r = !0);
                }
                r && (t1.data.morphAttributes = n, t1.data.morphTargetsRelative = this.morphTargetsRelative);
                const a = this.groups;
                a.length > 0 && (t1.data.groups = JSON.parse(JSON.stringify(a)));
                const s = this.boundingSphere;
                return null !== s && (t1.data.boundingSphere = {
                    center: s.center.toArray(),
                    radius: s.radius
                }), t1;
            }
            clone() {
                return (new this.constructor).copy(this);
            }
            copy(t1) {
                this.index = null, this.attributes = {}, this.morphAttributes = {}, this.groups = [], this.boundingBox = null, this.boundingSphere = null;
                const e = {};
                this.name = t1.name;
                const i = t1.index;
                null !== i && this.setIndex(i.clone(e));
                const n = t1.attributes;
                for(const t1 in n){
                    const i = n[t1];
                    this.setAttribute(t1, i.clone(e));
                }
                const r = t1.morphAttributes;
                for(const t1 in r){
                    const i = [], n = r[t1];
                    for(let t1 = 0, r = n.length; t1 < r; t1++)i.push(n[t1].clone(e));
                    this.morphAttributes[t1] = i;
                }
                this.morphTargetsRelative = t1.morphTargetsRelative;
                const a = t1.groups;
                for(let t1 = 0, e = a.length; t1 < e; t1++){
                    const e = a[t1];
                    this.addGroup(e.start, e.count, e.materialIndex);
                }
                const s = t1.boundingBox;
                null !== s && (this.boundingBox = s.clone());
                const o = t1.boundingSphere;
                return null !== o && (this.boundingSphere = o.clone()), this.drawRange.start = t1.drawRange.start, this.drawRange.count = t1.drawRange.count, this.userData = t1.userData, this;
            }
            dispose() {
                this.dispatchEvent({
                    type: "dispose"
                });
            }
        }
        const gu = new Kl, mu = new Jl, Mu = new Ql, yu = new xl, vu = new xl, xu = new xl, wu = new xl, bu = new xl, Tu = new xl, Eu = new Qo, Iu = new Qo, Su = new Qo, Nu = new xl, Du = new xl, Cu = new xl, zu = new xl, Lu = new xl;
        class Ou extends wc {
            constructor(t1 = new Au, e = new Hc){
                super(), this.isMesh = !0, this.type = "Mesh", this.geometry = t1, this.material = e, this.updateMorphTargets();
            }
            copy(t1, e) {
                return super.copy(t1, e), void 0 !== t1.morphTargetInfluences && (this.morphTargetInfluences = t1.morphTargetInfluences.slice()), void 0 !== t1.morphTargetDictionary && (this.morphTargetDictionary = Object.assign({}, t1.morphTargetDictionary)), this.material = Array.isArray(t1.material) ? t1.material.slice() : t1.material, this.geometry = t1.geometry, this;
            }
            updateMorphTargets() {
                const t1 = this.geometry.morphAttributes, e = Object.keys(t1);
                if (e.length > 0) {
                    const i = t1[e[0]];
                    if (void 0 !== i) {
                        this.morphTargetInfluences = [], this.morphTargetDictionary = {};
                        for(let t1 = 0, e = i.length; t1 < e; t1++){
                            const e = i[t1].name || String(t1);
                            this.morphTargetInfluences.push(0), this.morphTargetDictionary[e] = t1;
                        }
                    }
                }
            }
            getVertexPosition(t1, e) {
                const i = this.geometry, n = i.attributes.position, r = i.morphAttributes.position, a = i.morphTargetsRelative;
                e.fromBufferAttribute(n, t1);
                const s = this.morphTargetInfluences;
                if (r && s) {
                    Tu.set(0, 0, 0);
                    for(let i = 0, n = r.length; i < n; i++){
                        const n = s[i], o = r[i];
                        0 !== n && (bu.fromBufferAttribute(o, t1), a ? Tu.addScaledVector(bu, n) : Tu.addScaledVector(bu.sub(e), n));
                    }
                    e.add(Tu);
                }
                return e;
            }
            raycast(t1, e) {
                const i = this.geometry, n = this.material, r = this.matrixWorld;
                if (void 0 !== n) {
                    if (null === i.boundingSphere && i.computeBoundingSphere(), Mu.copy(i.boundingSphere), Mu.applyMatrix4(r), mu.copy(t1.ray).recast(t1.near), !1 === Mu.containsPoint(mu.origin)) {
                        if (null === mu.intersectSphere(Mu, yu)) return;
                        if (mu.origin.distanceToSquared(yu) > (t1.far - t1.near) ** 2) return;
                    }
                    gu.copy(r).invert(), mu.copy(t1.ray).applyMatrix4(gu), null !== i.boundingBox && !1 === mu.intersectsBox(i.boundingBox) || this._computeIntersections(t1, e, mu);
                }
            }
            _computeIntersections(t1, e, i) {
                let n;
                const r = this.geometry, a = this.material, s = r.index, o = r.attributes.position, l = r.attributes.uv, c = r.attributes.uv1, u = r.attributes.normal, h = r.groups, d = r.drawRange;
                if (null !== s) {
                    if (Array.isArray(a)) for(let r = 0, o = h.length; r < o; r++){
                        const o = h[r], p = a[o.materialIndex];
                        for(let r = Math.max(o.start, d.start), a = Math.min(s.count, Math.min(o.start + o.count, d.start + d.count)); r < a; r += 3)n = _u(this, p, t1, i, l, c, u, s.getX(r), s.getX(r + 1), s.getX(r + 2)), n && (n.faceIndex = Math.floor(r / 3), n.face.materialIndex = o.materialIndex, e.push(n));
                    }
                    else for(let r = Math.max(0, d.start), o = Math.min(s.count, d.start + d.count); r < o; r += 3)n = _u(this, a, t1, i, l, c, u, s.getX(r), s.getX(r + 1), s.getX(r + 2)), n && (n.faceIndex = Math.floor(r / 3), e.push(n));
                } else if (void 0 !== o) {
                    if (Array.isArray(a)) for(let r = 0, s = h.length; r < s; r++){
                        const s = h[r], p = a[s.materialIndex];
                        for(let r = Math.max(s.start, d.start), a = Math.min(o.count, Math.min(s.start + s.count, d.start + d.count)); r < a; r += 3)n = _u(this, p, t1, i, l, c, u, r, r + 1, r + 2), n && (n.faceIndex = Math.floor(r / 3), n.face.materialIndex = s.materialIndex, e.push(n));
                    }
                    else for(let r = Math.max(0, d.start), s = Math.min(o.count, d.start + d.count); r < s; r += 3)n = _u(this, a, t1, i, l, c, u, r, r + 1, r + 2), n && (n.faceIndex = Math.floor(r / 3), e.push(n));
                }
            }
        }
        function _u(t1, e, i, n, r, a, s, o, l, c) {
            t1.getVertexPosition(o, vu), t1.getVertexPosition(l, xu), t1.getVertexPosition(c, wu);
            const u = function(t1, e, i, n, r, a, s, o) {
                let l;
                if (l = e.side === tr ? n.intersectTriangle(s, a, r, !0, o) : n.intersectTriangle(r, a, s, e.side === $n, o), null === l) return null;
                Lu.copy(o), Lu.applyMatrix4(t1.matrixWorld);
                const c = i.ray.origin.distanceTo(Lu);
                return c < i.near || c > i.far ? null : {
                    distance: c,
                    point: Lu.clone(),
                    object: t1
                };
            }(t1, e, i, n, vu, xu, wu, zu);
            if (u) {
                r && (Eu.fromBufferAttribute(r, o), Iu.fromBufferAttribute(r, l), Su.fromBufferAttribute(r, c), u.uv = _c.getInterpolation(zu, vu, xu, wu, Eu, Iu, Su, new Qo)), a && (Eu.fromBufferAttribute(a, o), Iu.fromBufferAttribute(a, l), Su.fromBufferAttribute(a, c), u.uv1 = _c.getInterpolation(zu, vu, xu, wu, Eu, Iu, Su, new Qo), u.uv2 = u.uv1), s && (Nu.fromBufferAttribute(s, o), Du.fromBufferAttribute(s, l), Cu.fromBufferAttribute(s, c), u.normal = _c.getInterpolation(zu, vu, xu, wu, Nu, Du, Cu, new xl), u.normal.dot(n.direction) > 0 && u.normal.multiplyScalar(-1));
                const t1 = {
                    a: o,
                    b: l,
                    c: c,
                    normal: new xl,
                    materialIndex: 0
                };
                _c.getNormal(vu, xu, wu, t1.normal), u.face = t1;
            }
            return u;
        }
        class ju extends Au {
            constructor(t1 = 1, e = 1, i = 1, n = 1, r = 1, a = 1){
                super(), this.type = "BoxGeometry", this.parameters = {
                    width: t1,
                    height: e,
                    depth: i,
                    widthSegments: n,
                    heightSegments: r,
                    depthSegments: a
                };
                const s = this;
                n = Math.floor(n), r = Math.floor(r), a = Math.floor(a);
                const o = [], l = [], c = [], u = [];
                let h = 0, d = 0;
                function p(t1, e, i, n, r, a, p, f, A, g, m) {
                    const M = a / A, y = p / g, v = a / 2, x = p / 2, w = f / 2, b = A + 1, T = g + 1;
                    let E = 0, I = 0;
                    const S = new xl;
                    for(let a = 0; a < T; a++){
                        const s = a * y - x;
                        for(let o = 0; o < b; o++){
                            const h = o * M - v;
                            S[t1] = h * n, S[e] = s * r, S[i] = w, l.push(S.x, S.y, S.z), S[t1] = 0, S[e] = 0, S[i] = f > 0 ? 1 : -1, c.push(S.x, S.y, S.z), u.push(o / A), u.push(1 - a / g), E += 1;
                        }
                    }
                    for(let t1 = 0; t1 < g; t1++)for(let e = 0; e < A; e++){
                        const i = h + e + b * t1, n = h + e + b * (t1 + 1), r = h + (e + 1) + b * (t1 + 1), a = h + (e + 1) + b * t1;
                        o.push(i, n, a), o.push(n, r, a), I += 6;
                    }
                    s.addGroup(d, I, m), d += I, h += E;
                }
                p("z", "y", "x", -1, -1, i, e, t1, a, r, 0), p("z", "y", "x", 1, -1, i, e, -t1, a, r, 1), p("x", "z", "y", 1, 1, t1, i, e, n, a, 2), p("x", "z", "y", 1, -1, t1, i, -e, n, a, 3), p("x", "y", "z", 1, -1, t1, e, i, n, r, 4), p("x", "y", "z", -1, -1, t1, e, -i, n, r, 5), this.setIndex(o), this.setAttribute("position", new su(l, 3)), this.setAttribute("normal", new su(c, 3)), this.setAttribute("uv", new su(u, 2));
            }
            copy(t1) {
                return super.copy(t1), this.parameters = Object.assign({}, t1.parameters), this;
            }
            static fromJSON(t1) {
                return new ju(t1.width, t1.height, t1.depth, t1.widthSegments, t1.heightSegments, t1.depthSegments);
            }
        }
        function Pu(t1) {
            const e = {};
            for(const i in t1){
                e[i] = {};
                for(const n in t1[i]){
                    const r = t1[i][n];
                    r && (r.isColor || r.isMatrix3 || r.isMatrix4 || r.isVector2 || r.isVector3 || r.isVector4 || r.isTexture || r.isQuaternion) ? r.isRenderTargetTexture ? (console.warn("UniformsUtils: Textures of render targets cannot be cloned via cloneUniforms() or mergeUniforms()."), e[i][n] = null) : e[i][n] = r.clone() : Array.isArray(r) ? e[i][n] = r.slice() : e[i][n] = r;
                }
            }
            return e;
        }
        function Ru(t1) {
            const e = {};
            for(let i = 0; i < t1.length; i++){
                const n = Pu(t1[i]);
                for(const t1 in n)e[t1] = n[t1];
            }
            return e;
        }
        function Uu(t1) {
            return null === t1.getRenderTarget() ? t1.outputColorSpace : il.workingColorSpace;
        }
        const ku = {
            clone: Pu,
            merge: Ru
        };
        class Bu extends Qc {
            constructor(t1){
                super(), this.isShaderMaterial = !0, this.type = "ShaderMaterial", this.defines = {}, this.uniforms = {}, this.uniformsGroups = [], this.vertexShader = "void main() {\n	gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );\n}", this.fragmentShader = "void main() {\n	gl_FragColor = vec4( 1.0, 0.0, 0.0, 1.0 );\n}", this.linewidth = 1, this.wireframe = !1, this.wireframeLinewidth = 1, this.fog = !1, this.lights = !1, this.clipping = !1, this.forceSinglePass = !0, this.extensions = {
                    derivatives: !1,
                    fragDepth: !1,
                    drawBuffers: !1,
                    shaderTextureLOD: !1
                }, this.defaultAttributeValues = {
                    color: [
                        1,
                        1,
                        1
                    ],
                    uv: [
                        0,
                        0
                    ],
                    uv1: [
                        0,
                        0
                    ]
                }, this.index0AttributeName = void 0, this.uniformsNeedUpdate = !1, this.glslVersion = null, void 0 !== t1 && this.setValues(t1);
            }
            copy(t1) {
                return super.copy(t1), this.fragmentShader = t1.fragmentShader, this.vertexShader = t1.vertexShader, this.uniforms = Pu(t1.uniforms), this.uniformsGroups = function(t1) {
                    const e = [];
                    for(let i = 0; i < t1.length; i++)e.push(t1[i].clone());
                    return e;
                }(t1.uniformsGroups), this.defines = Object.assign({}, t1.defines), this.wireframe = t1.wireframe, this.wireframeLinewidth = t1.wireframeLinewidth, this.fog = t1.fog, this.lights = t1.lights, this.clipping = t1.clipping, this.extensions = Object.assign({}, t1.extensions), this.glslVersion = t1.glslVersion, this;
            }
            toJSON(t1) {
                const e = super.toJSON(t1);
                e.glslVersion = this.glslVersion, e.uniforms = {};
                for(const i in this.uniforms){
                    const n = this.uniforms[i].value;
                    n && n.isTexture ? e.uniforms[i] = {
                        type: "t",
                        value: n.toJSON(t1).uuid
                    } : n && n.isColor ? e.uniforms[i] = {
                        type: "c",
                        value: n.getHex()
                    } : n && n.isVector2 ? e.uniforms[i] = {
                        type: "v2",
                        value: n.toArray()
                    } : n && n.isVector3 ? e.uniforms[i] = {
                        type: "v3",
                        value: n.toArray()
                    } : n && n.isVector4 ? e.uniforms[i] = {
                        type: "v4",
                        value: n.toArray()
                    } : n && n.isMatrix3 ? e.uniforms[i] = {
                        type: "m3",
                        value: n.toArray()
                    } : n && n.isMatrix4 ? e.uniforms[i] = {
                        type: "m4",
                        value: n.toArray()
                    } : e.uniforms[i] = {
                        value: n
                    };
                }
                Object.keys(this.defines).length > 0 && (e.defines = this.defines), e.vertexShader = this.vertexShader, e.fragmentShader = this.fragmentShader, e.lights = this.lights, e.clipping = this.clipping;
                const i = {};
                for(const t1 in this.extensions)!0 === this.extensions[t1] && (i[t1] = !0);
                return Object.keys(i).length > 0 && (e.extensions = i), e;
            }
        }
        class Fu extends wc {
            constructor(){
                super(), this.isCamera = !0, this.type = "Camera", this.matrixWorldInverse = new Kl, this.projectionMatrix = new Kl, this.projectionMatrixInverse = new Kl, this.coordinateSystem = Eo;
            }
            copy(t1, e) {
                return super.copy(t1, e), this.matrixWorldInverse.copy(t1.matrixWorldInverse), this.projectionMatrix.copy(t1.projectionMatrix), this.projectionMatrixInverse.copy(t1.projectionMatrixInverse), this.coordinateSystem = t1.coordinateSystem, this;
            }
            getWorldDirection(t1) {
                return super.getWorldDirection(t1).negate();
            }
            updateMatrixWorld(t1) {
                super.updateMatrixWorld(t1), this.matrixWorldInverse.copy(this.matrixWorld).invert();
            }
            updateWorldMatrix(t1, e) {
                super.updateWorldMatrix(t1, e), this.matrixWorldInverse.copy(this.matrixWorld).invert();
            }
            clone() {
                return (new this.constructor).copy(this);
            }
        }
        class Qu extends Fu {
            constructor(t1 = 50, e = 1, i = .1, n = 2e3){
                super(), this.isPerspectiveCamera = !0, this.type = "PerspectiveCamera", this.fov = t1, this.zoom = 1, this.near = i, this.far = n, this.focus = 10, this.aspect = e, this.view = null, this.filmGauge = 35, this.filmOffset = 0, this.updateProjectionMatrix();
            }
            copy(t1, e) {
                return super.copy(t1, e), this.fov = t1.fov, this.zoom = t1.zoom, this.near = t1.near, this.far = t1.far, this.focus = t1.focus, this.aspect = t1.aspect, this.view = null === t1.view ? null : Object.assign({}, t1.view), this.filmGauge = t1.filmGauge, this.filmOffset = t1.filmOffset, this;
            }
            setFocalLength(t1) {
                const e = .5 * this.getFilmHeight() / t1;
                this.fov = 2 * zo * Math.atan(e), this.updateProjectionMatrix();
            }
            getFocalLength() {
                const t1 = Math.tan(.5 * Co * this.fov);
                return .5 * this.getFilmHeight() / t1;
            }
            getEffectiveFOV() {
                return 2 * zo * Math.atan(Math.tan(.5 * Co * this.fov) / this.zoom);
            }
            getFilmWidth() {
                return this.filmGauge * Math.min(this.aspect, 1);
            }
            getFilmHeight() {
                return this.filmGauge / Math.max(this.aspect, 1);
            }
            setViewOffset(t1, e, i, n, r, a) {
                this.aspect = t1 / e, null === this.view && (this.view = {
                    enabled: !0,
                    fullWidth: 1,
                    fullHeight: 1,
                    offsetX: 0,
                    offsetY: 0,
                    width: 1,
                    height: 1
                }), this.view.enabled = !0, this.view.fullWidth = t1, this.view.fullHeight = e, this.view.offsetX = i, this.view.offsetY = n, this.view.width = r, this.view.height = a, this.updateProjectionMatrix();
            }
            clearViewOffset() {
                null !== this.view && (this.view.enabled = !1), this.updateProjectionMatrix();
            }
            updateProjectionMatrix() {
                const t1 = this.near;
                let e = t1 * Math.tan(.5 * Co * this.fov) / this.zoom, i = 2 * e, n = this.aspect * i, r = -0.5 * n;
                const a = this.view;
                if (null !== this.view && this.view.enabled) {
                    const t1 = a.fullWidth, s = a.fullHeight;
                    r += a.offsetX * n / t1, e -= a.offsetY * i / s, n *= a.width / t1, i *= a.height / s;
                }
                const s = this.filmOffset;
                0 !== s && (r += t1 * s / this.getFilmWidth()), this.projectionMatrix.makePerspective(r, r + n, e, e - i, t1, this.far, this.coordinateSystem), this.projectionMatrixInverse.copy(this.projectionMatrix).invert();
            }
            toJSON(t1) {
                const e = super.toJSON(t1);
                return e.object.fov = this.fov, e.object.zoom = this.zoom, e.object.near = this.near, e.object.far = this.far, e.object.focus = this.focus, e.object.aspect = this.aspect, null !== this.view && (e.object.view = Object.assign({}, this.view)), e.object.filmGauge = this.filmGauge, e.object.filmOffset = this.filmOffset, e;
            }
        }
        const Hu = -90;
        class Vu extends wc {
            constructor(t1, e, i){
                super(), this.type = "CubeCamera", this.renderTarget = i, this.coordinateSystem = null, this.activeMipmapLevel = 0;
                const n = new Qu(Hu, 1, t1, e);
                n.layers = this.layers, this.add(n);
                const r = new Qu(Hu, 1, t1, e);
                r.layers = this.layers, this.add(r);
                const a = new Qu(Hu, 1, t1, e);
                a.layers = this.layers, this.add(a);
                const s = new Qu(Hu, 1, t1, e);
                s.layers = this.layers, this.add(s);
                const o = new Qu(Hu, 1, t1, e);
                o.layers = this.layers, this.add(o);
                const l = new Qu(Hu, 1, t1, e);
                l.layers = this.layers, this.add(l);
            }
            updateCoordinateSystem() {
                const t1 = this.coordinateSystem, e = this.children.concat(), [i, n, r, a, s, o] = e;
                for (const t1 of e)this.remove(t1);
                if (t1 === Eo) i.up.set(0, 1, 0), i.lookAt(1, 0, 0), n.up.set(0, 1, 0), n.lookAt(-1, 0, 0), r.up.set(0, 0, -1), r.lookAt(0, 1, 0), a.up.set(0, 0, 1), a.lookAt(0, -1, 0), s.up.set(0, 1, 0), s.lookAt(0, 0, 1), o.up.set(0, 1, 0), o.lookAt(0, 0, -1);
                else {
                    if (t1 !== Io) throw new Error("THREE.CubeCamera.updateCoordinateSystem(): Invalid coordinate system: " + t1);
                    i.up.set(0, -1, 0), i.lookAt(-1, 0, 0), n.up.set(0, -1, 0), n.lookAt(1, 0, 0), r.up.set(0, 0, 1), r.lookAt(0, 1, 0), a.up.set(0, 0, -1), a.lookAt(0, -1, 0), s.up.set(0, -1, 0), s.lookAt(0, 0, 1), o.up.set(0, -1, 0), o.lookAt(0, 0, -1);
                }
                for (const t1 of e)this.add(t1), t1.updateMatrixWorld();
            }
            update(t1, e) {
                null === this.parent && this.updateMatrixWorld();
                const { renderTarget: i, activeMipmapLevel: n } = this;
                this.coordinateSystem !== t1.coordinateSystem && (this.coordinateSystem = t1.coordinateSystem, this.updateCoordinateSystem());
                const [r, a, s, o, l, c] = this.children, u = t1.getRenderTarget(), h = t1.getActiveCubeFace(), d = t1.getActiveMipmapLevel(), p = t1.xr.enabled;
                t1.xr.enabled = !1;
                const f = i.texture.generateMipmaps;
                i.texture.generateMipmaps = !1, t1.setRenderTarget(i, 0, n), t1.render(e, r), t1.setRenderTarget(i, 1, n), t1.render(e, a), t1.setRenderTarget(i, 2, n), t1.render(e, s), t1.setRenderTarget(i, 3, n), t1.render(e, o), t1.setRenderTarget(i, 4, n), t1.render(e, l), i.texture.generateMipmaps = f, t1.setRenderTarget(i, 5, n), t1.render(e, c), t1.setRenderTarget(u, h, d), t1.xr.enabled = p, i.texture.needsPMREMUpdate = !0;
            }
        }
        class Gu extends hl {
            constructor(t1, e, i, n, r, a, s, o, l, c){
                super(t1 = void 0 !== t1 ? t1 : [], e = void 0 !== e ? e : Zr, i, n, r, a, s, o, l, c), this.isCubeTexture = !0, this.flipY = !1;
            }
            get images() {
                return this.image;
            }
            set images(t1) {
                this.image = t1;
            }
        }
        class Yu extends fl {
            constructor(t1 = 1, e = {}){
                super(t1, t1, e), this.isWebGLCubeRenderTarget = !0;
                const i = {
                    width: t1,
                    height: t1,
                    depth: 1
                }, n = [
                    i,
                    i,
                    i,
                    i,
                    i,
                    i
                ];
                void 0 !== e.encoding && (Ko("THREE.WebGLCubeRenderTarget: option.encoding has been replaced by option.colorSpace."), e.colorSpace = e.encoding === Ns ? _s : Os), this.texture = new Gu(n, e.mapping, e.wrapS, e.wrapT, e.magFilter, e.minFilter, e.format, e.type, e.anisotropy, e.colorSpace), this.texture.isRenderTargetTexture = !0, this.texture.generateMipmaps = void 0 !== e.generateMipmaps && e.generateMipmaps, this.texture.minFilter = void 0 !== e.minFilter ? e.minFilter : la;
            }
            fromEquirectangularTexture(t1, e) {
                this.texture.type = e.type, this.texture.colorSpace = e.colorSpace, this.texture.generateMipmaps = e.generateMipmaps, this.texture.minFilter = e.minFilter, this.texture.magFilter = e.magFilter;
                const i = {
                    tEquirect: {
                        value: null
                    }
                }, n = "\n\n				varying vec3 vWorldDirection;\n\n				vec3 transformDirection( in vec3 dir, in mat4 matrix ) {\n\n					return normalize( ( matrix * vec4( dir, 0.0 ) ).xyz );\n\n				}\n\n				void main() {\n\n					vWorldDirection = transformDirection( position, modelMatrix );\n\n					#include <begin_vertex>\n					#include <project_vertex>\n\n				}\n			", r = "\n\n				uniform sampler2D tEquirect;\n\n				varying vec3 vWorldDirection;\n\n				#include <common>\n\n				void main() {\n\n					vec3 direction = normalize( vWorldDirection );\n\n					vec2 sampleUV = equirectUv( direction );\n\n					gl_FragColor = texture2D( tEquirect, sampleUV );\n\n				}\n			", a = new ju(5, 5, 5), s = new Bu({
                    name: "CubemapFromEquirect",
                    uniforms: Pu(i),
                    vertexShader: n,
                    fragmentShader: r,
                    side: tr,
                    blending: nr
                });
                s.uniforms.tEquirect.value = e;
                const o = new Ou(a, s), l = e.minFilter;
                return e.minFilter === ha && (e.minFilter = la), new Vu(1, 10, this).update(t1, o), e.minFilter = l, o.geometry.dispose(), o.material.dispose(), this;
            }
            clear(t1, e, i, n) {
                const r = t1.getRenderTarget();
                for(let r = 0; r < 6; r++)t1.setRenderTarget(this, r), t1.clear(e, i, n);
                t1.setRenderTarget(r);
            }
        }
        const Wu = new xl, Xu = new xl, Zu = new Ho;
        class Ju {
            constructor(t1 = new xl(1, 0, 0), e = 0){
                this.isPlane = !0, this.normal = t1, this.constant = e;
            }
            set(t1, e) {
                return this.normal.copy(t1), this.constant = e, this;
            }
            setComponents(t1, e, i, n) {
                return this.normal.set(t1, e, i), this.constant = n, this;
            }
            setFromNormalAndCoplanarPoint(t1, e) {
                return this.normal.copy(t1), this.constant = -e.dot(this.normal), this;
            }
            setFromCoplanarPoints(t1, e, i) {
                const n = Wu.subVectors(i, e).cross(Xu.subVectors(t1, e)).normalize();
                return this.setFromNormalAndCoplanarPoint(n, t1), this;
            }
            copy(t1) {
                return this.normal.copy(t1.normal), this.constant = t1.constant, this;
            }
            normalize() {
                const t1 = 1 / this.normal.length();
                return this.normal.multiplyScalar(t1), this.constant *= t1, this;
            }
            negate() {
                return this.constant *= -1, this.normal.negate(), this;
            }
            distanceToPoint(t1) {
                return this.normal.dot(t1) + this.constant;
            }
            distanceToSphere(t1) {
                return this.distanceToPoint(t1.center) - t1.radius;
            }
            projectPoint(t1, e) {
                return e.copy(t1).addScaledVector(this.normal, -this.distanceToPoint(t1));
            }
            intersectLine(t1, e) {
                const i = t1.delta(Wu), n = this.normal.dot(i);
                if (0 === n) return 0 === this.distanceToPoint(t1.start) ? e.copy(t1.start) : null;
                const r = -(t1.start.dot(this.normal) + this.constant) / n;
                return r < 0 || r > 1 ? null : e.copy(t1.start).addScaledVector(i, r);
            }
            intersectsLine(t1) {
                const e = this.distanceToPoint(t1.start), i = this.distanceToPoint(t1.end);
                return e < 0 && i > 0 || i < 0 && e > 0;
            }
            intersectsBox(t1) {
                return t1.intersectsPlane(this);
            }
            intersectsSphere(t1) {
                return t1.intersectsPlane(this);
            }
            coplanarPoint(t1) {
                return t1.copy(this.normal).multiplyScalar(-this.constant);
            }
            applyMatrix4(t1, e) {
                const i = e || Zu.getNormalMatrix(t1), n = this.coplanarPoint(Wu).applyMatrix4(t1), r = this.normal.applyMatrix3(i).normalize();
                return this.constant = -n.dot(r), this;
            }
            translate(t1) {
                return this.constant -= t1.dot(this.normal), this;
            }
            equals(t1) {
                return t1.normal.equals(this.normal) && t1.constant === this.constant;
            }
            clone() {
                return (new this.constructor).copy(this);
            }
        }
        const Ku = new Ql, qu = new xl;
        class $u {
            constructor(t1 = new Ju, e = new Ju, i = new Ju, n = new Ju, r = new Ju, a = new Ju){
                this.planes = [
                    t1,
                    e,
                    i,
                    n,
                    r,
                    a
                ];
            }
            set(t1, e, i, n, r, a) {
                const s = this.planes;
                return s[0].copy(t1), s[1].copy(e), s[2].copy(i), s[3].copy(n), s[4].copy(r), s[5].copy(a), this;
            }
            copy(t1) {
                const e = this.planes;
                for(let i = 0; i < 6; i++)e[i].copy(t1.planes[i]);
                return this;
            }
            setFromProjectionMatrix(t1, e = Eo) {
                const i = this.planes, n = t1.elements, r = n[0], a = n[1], s = n[2], o = n[3], l = n[4], c = n[5], u = n[6], h = n[7], d = n[8], p = n[9], f = n[10], A = n[11], g = n[12], m = n[13], M = n[14], y = n[15];
                if (i[0].setComponents(o - r, h - l, A - d, y - g).normalize(), i[1].setComponents(o + r, h + l, A + d, y + g).normalize(), i[2].setComponents(o + a, h + c, A + p, y + m).normalize(), i[3].setComponents(o - a, h - c, A - p, y - m).normalize(), i[4].setComponents(o - s, h - u, A - f, y - M).normalize(), e === Eo) i[5].setComponents(o + s, h + u, A + f, y + M).normalize();
                else {
                    if (e !== Io) throw new Error("THREE.Frustum.setFromProjectionMatrix(): Invalid coordinate system: " + e);
                    i[5].setComponents(s, u, f, M).normalize();
                }
                return this;
            }
            intersectsObject(t1) {
                if (void 0 !== t1.boundingSphere) null === t1.boundingSphere && t1.computeBoundingSphere(), Ku.copy(t1.boundingSphere).applyMatrix4(t1.matrixWorld);
                else {
                    const e = t1.geometry;
                    null === e.boundingSphere && e.computeBoundingSphere(), Ku.copy(e.boundingSphere).applyMatrix4(t1.matrixWorld);
                }
                return this.intersectsSphere(Ku);
            }
            intersectsSprite(t1) {
                return Ku.center.set(0, 0, 0), Ku.radius = .7071067811865476, Ku.applyMatrix4(t1.matrixWorld), this.intersectsSphere(Ku);
            }
            intersectsSphere(t1) {
                const e = this.planes, i = t1.center, n = -t1.radius;
                for(let t1 = 0; t1 < 6; t1++)if (e[t1].distanceToPoint(i) < n) return !1;
                return !0;
            }
            intersectsBox(t1) {
                const e = this.planes;
                for(let i = 0; i < 6; i++){
                    const n = e[i];
                    if (qu.x = n.normal.x > 0 ? t1.max.x : t1.min.x, qu.y = n.normal.y > 0 ? t1.max.y : t1.min.y, qu.z = n.normal.z > 0 ? t1.max.z : t1.min.z, n.distanceToPoint(qu) < 0) return !1;
                }
                return !0;
            }
            containsPoint(t1) {
                const e = this.planes;
                for(let i = 0; i < 6; i++)if (e[i].distanceToPoint(t1) < 0) return !1;
                return !0;
            }
            clone() {
                return (new this.constructor).copy(this);
            }
        }
        function th() {
            let t1 = null, e = !1, i = null, n = null;
            function r(e, a) {
                i(e, a), n = t1.requestAnimationFrame(r);
            }
            return {
                start: function() {
                    !0 !== e && null !== i && (n = t1.requestAnimationFrame(r), e = !0);
                },
                stop: function() {
                    t1.cancelAnimationFrame(n), e = !1;
                },
                setAnimationLoop: function(t1) {
                    i = t1;
                },
                setContext: function(e) {
                    t1 = e;
                }
            };
        }
        function eh(t1, e) {
            const i = e.isWebGL2, n = new WeakMap;
            return {
                get: function(t1) {
                    return t1.isInterleavedBufferAttribute && (t1 = t1.data), n.get(t1);
                },
                remove: function(e) {
                    e.isInterleavedBufferAttribute && (e = e.data);
                    const i = n.get(e);
                    i && (t1.deleteBuffer(i.buffer), n.delete(e));
                },
                update: function(e, r) {
                    if (e.isGLBufferAttribute) {
                        const t1 = n.get(e);
                        return void ((!t1 || t1.version < e.version) && n.set(e, {
                            buffer: e.buffer,
                            type: e.type,
                            bytesPerElement: e.elementSize,
                            version: e.version
                        }));
                    }
                    e.isInterleavedBufferAttribute && (e = e.data);
                    const a = n.get(e);
                    void 0 === a ? n.set(e, function(e, n) {
                        const r = e.array, a = e.usage, s = t1.createBuffer();
                        let o;
                        if (t1.bindBuffer(n, s), t1.bufferData(n, r, a), e.onUploadCallback(), r instanceof Float32Array) o = t1.FLOAT;
                        else if (r instanceof Uint16Array) {
                            if (e.isFloat16BufferAttribute) {
                                if (!i) throw new Error("THREE.WebGLAttributes: Usage of Float16BufferAttribute requires WebGL2.");
                                o = t1.HALF_FLOAT;
                            } else o = t1.UNSIGNED_SHORT;
                        } else if (r instanceof Int16Array) o = t1.SHORT;
                        else if (r instanceof Uint32Array) o = t1.UNSIGNED_INT;
                        else if (r instanceof Int32Array) o = t1.INT;
                        else if (r instanceof Int8Array) o = t1.BYTE;
                        else if (r instanceof Uint8Array) o = t1.UNSIGNED_BYTE;
                        else {
                            if (!(r instanceof Uint8ClampedArray)) throw new Error("THREE.WebGLAttributes: Unsupported buffer data format: " + r);
                            o = t1.UNSIGNED_BYTE;
                        }
                        return {
                            buffer: s,
                            type: o,
                            bytesPerElement: r.BYTES_PER_ELEMENT,
                            version: e.version
                        };
                    }(e, r)) : a.version < e.version && (function(e, n, r) {
                        const a = n.array, s = n.updateRange;
                        t1.bindBuffer(r, e), -1 === s.count ? t1.bufferSubData(r, 0, a) : (i ? t1.bufferSubData(r, s.offset * a.BYTES_PER_ELEMENT, a, s.offset, s.count) : t1.bufferSubData(r, s.offset * a.BYTES_PER_ELEMENT, a.subarray(s.offset, s.offset + s.count)), s.count = -1), n.onUploadCallback();
                    }(a.buffer, e, r), a.version = e.version);
                }
            };
        }
        class ih extends Au {
            constructor(t1 = 1, e = 1, i = 1, n = 1){
                super(), this.type = "PlaneGeometry", this.parameters = {
                    width: t1,
                    height: e,
                    widthSegments: i,
                    heightSegments: n
                };
                const r = t1 / 2, a = e / 2, s = Math.floor(i), o = Math.floor(n), l = s + 1, c = o + 1, u = t1 / s, h = e / o, d = [], p = [], f = [], A = [];
                for(let t1 = 0; t1 < c; t1++){
                    const e = t1 * h - a;
                    for(let i = 0; i < l; i++){
                        const n = i * u - r;
                        p.push(n, -e, 0), f.push(0, 0, 1), A.push(i / s), A.push(1 - t1 / o);
                    }
                }
                for(let t1 = 0; t1 < o; t1++)for(let e = 0; e < s; e++){
                    const i = e + l * t1, n = e + l * (t1 + 1), r = e + 1 + l * (t1 + 1), a = e + 1 + l * t1;
                    d.push(i, n, a), d.push(n, r, a);
                }
                this.setIndex(d), this.setAttribute("position", new su(p, 3)), this.setAttribute("normal", new su(f, 3)), this.setAttribute("uv", new su(A, 2));
            }
            copy(t1) {
                return super.copy(t1), this.parameters = Object.assign({}, t1.parameters), this;
            }
            static fromJSON(t1) {
                return new ih(t1.width, t1.height, t1.widthSegments, t1.heightSegments);
            }
        }
        const nh = {
            alphahash_fragment: "#ifdef USE_ALPHAHASH\n	if ( diffuseColor.a < getAlphaHashThreshold( vPosition ) ) discard;\n#endif",
            alphahash_pars_fragment: "#ifdef USE_ALPHAHASH\n	const float ALPHA_HASH_SCALE = 0.05;\n	float hash2D( vec2 value ) {\n		return fract( 1.0e4 * sin( 17.0 * value.x + 0.1 * value.y ) * ( 0.1 + abs( sin( 13.0 * value.y + value.x ) ) ) );\n	}\n	float hash3D( vec3 value ) {\n		return hash2D( vec2( hash2D( value.xy ), value.z ) );\n	}\n	float getAlphaHashThreshold( vec3 position ) {\n		float maxDeriv = max(\n			length( dFdx( position.xyz ) ),\n			length( dFdy( position.xyz ) )\n		);\n		float pixScale = 1.0 / ( ALPHA_HASH_SCALE * maxDeriv );\n		vec2 pixScales = vec2(\n			exp2( floor( log2( pixScale ) ) ),\n			exp2( ceil( log2( pixScale ) ) )\n		);\n		vec2 alpha = vec2(\n			hash3D( floor( pixScales.x * position.xyz ) ),\n			hash3D( floor( pixScales.y * position.xyz ) )\n		);\n		float lerpFactor = fract( log2( pixScale ) );\n		float x = ( 1.0 - lerpFactor ) * alpha.x + lerpFactor * alpha.y;\n		float a = min( lerpFactor, 1.0 - lerpFactor );\n		vec3 cases = vec3(\n			x * x / ( 2.0 * a * ( 1.0 - a ) ),\n			( x - 0.5 * a ) / ( 1.0 - a ),\n			1.0 - ( ( 1.0 - x ) * ( 1.0 - x ) / ( 2.0 * a * ( 1.0 - a ) ) )\n		);\n		float threshold = ( x < ( 1.0 - a ) )\n			? ( ( x < a ) ? cases.x : cases.y )\n			: cases.z;\n		return clamp( threshold , 1.0e-6, 1.0 );\n	}\n#endif",
            alphamap_fragment: "#ifdef USE_ALPHAMAP\n	diffuseColor.a *= texture2D( alphaMap, vAlphaMapUv ).g;\n#endif",
            alphamap_pars_fragment: "#ifdef USE_ALPHAMAP\n	uniform sampler2D alphaMap;\n#endif",
            alphatest_fragment: "#ifdef USE_ALPHATEST\n	if ( diffuseColor.a < alphaTest ) discard;\n#endif",
            alphatest_pars_fragment: "#ifdef USE_ALPHATEST\n	uniform float alphaTest;\n#endif",
            aomap_fragment: "#ifdef USE_AOMAP\n	float ambientOcclusion = ( texture2D( aoMap, vAoMapUv ).r - 1.0 ) * aoMapIntensity + 1.0;\n	reflectedLight.indirectDiffuse *= ambientOcclusion;\n	#if defined( USE_CLEARCOAT ) \n		clearcoatSpecularIndirect *= ambientOcclusion;\n	#endif\n	#if defined( USE_SHEEN ) \n		sheenSpecularIndirect *= ambientOcclusion;\n	#endif\n	#if defined( USE_ENVMAP ) && defined( STANDARD )\n		float dotNV = saturate( dot( geometryNormal, geometryViewDir ) );\n		reflectedLight.indirectSpecular *= computeSpecularOcclusion( dotNV, ambientOcclusion, material.roughness );\n	#endif\n#endif",
            aomap_pars_fragment: "#ifdef USE_AOMAP\n	uniform sampler2D aoMap;\n	uniform float aoMapIntensity;\n#endif",
            begin_vertex: "vec3 transformed = vec3( position );\n#ifdef USE_ALPHAHASH\n	vPosition = vec3( position );\n#endif",
            beginnormal_vertex: "vec3 objectNormal = vec3( normal );\n#ifdef USE_TANGENT\n	vec3 objectTangent = vec3( tangent.xyz );\n#endif",
            bsdfs: "float G_BlinnPhong_Implicit( ) {\n	return 0.25;\n}\nfloat D_BlinnPhong( const in float shininess, const in float dotNH ) {\n	return RECIPROCAL_PI * ( shininess * 0.5 + 1.0 ) * pow( dotNH, shininess );\n}\nvec3 BRDF_BlinnPhong( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, const in vec3 specularColor, const in float shininess ) {\n	vec3 halfDir = normalize( lightDir + viewDir );\n	float dotNH = saturate( dot( normal, halfDir ) );\n	float dotVH = saturate( dot( viewDir, halfDir ) );\n	vec3 F = F_Schlick( specularColor, 1.0, dotVH );\n	float G = G_BlinnPhong_Implicit( );\n	float D = D_BlinnPhong( shininess, dotNH );\n	return F * ( G * D );\n} // validated",
            iridescence_fragment: "#ifdef USE_IRIDESCENCE\n	const mat3 XYZ_TO_REC709 = mat3(\n		 3.2404542, -0.9692660,  0.0556434,\n		-1.5371385,  1.8760108, -0.2040259,\n		-0.4985314,  0.0415560,  1.0572252\n	);\n	vec3 Fresnel0ToIor( vec3 fresnel0 ) {\n		vec3 sqrtF0 = sqrt( fresnel0 );\n		return ( vec3( 1.0 ) + sqrtF0 ) / ( vec3( 1.0 ) - sqrtF0 );\n	}\n	vec3 IorToFresnel0( vec3 transmittedIor, float incidentIor ) {\n		return pow2( ( transmittedIor - vec3( incidentIor ) ) / ( transmittedIor + vec3( incidentIor ) ) );\n	}\n	float IorToFresnel0( float transmittedIor, float incidentIor ) {\n		return pow2( ( transmittedIor - incidentIor ) / ( transmittedIor + incidentIor ));\n	}\n	vec3 evalSensitivity( float OPD, vec3 shift ) {\n		float phase = 2.0 * PI * OPD * 1.0e-9;\n		vec3 val = vec3( 5.4856e-13, 4.4201e-13, 5.2481e-13 );\n		vec3 pos = vec3( 1.6810e+06, 1.7953e+06, 2.2084e+06 );\n		vec3 var = vec3( 4.3278e+09, 9.3046e+09, 6.6121e+09 );\n		vec3 xyz = val * sqrt( 2.0 * PI * var ) * cos( pos * phase + shift ) * exp( - pow2( phase ) * var );\n		xyz.x += 9.7470e-14 * sqrt( 2.0 * PI * 4.5282e+09 ) * cos( 2.2399e+06 * phase + shift[ 0 ] ) * exp( - 4.5282e+09 * pow2( phase ) );\n		xyz /= 1.0685e-7;\n		vec3 rgb = XYZ_TO_REC709 * xyz;\n		return rgb;\n	}\n	vec3 evalIridescence( float outsideIOR, float eta2, float cosTheta1, float thinFilmThickness, vec3 baseF0 ) {\n		vec3 I;\n		float iridescenceIOR = mix( outsideIOR, eta2, smoothstep( 0.0, 0.03, thinFilmThickness ) );\n		float sinTheta2Sq = pow2( outsideIOR / iridescenceIOR ) * ( 1.0 - pow2( cosTheta1 ) );\n		float cosTheta2Sq = 1.0 - sinTheta2Sq;\n		if ( cosTheta2Sq < 0.0 ) {\n			return vec3( 1.0 );\n		}\n		float cosTheta2 = sqrt( cosTheta2Sq );\n		float R0 = IorToFresnel0( iridescenceIOR, outsideIOR );\n		float R12 = F_Schlick( R0, 1.0, cosTheta1 );\n		float T121 = 1.0 - R12;\n		float phi12 = 0.0;\n		if ( iridescenceIOR < outsideIOR ) phi12 = PI;\n		float phi21 = PI - phi12;\n		vec3 baseIOR = Fresnel0ToIor( clamp( baseF0, 0.0, 0.9999 ) );		vec3 R1 = IorToFresnel0( baseIOR, iridescenceIOR );\n		vec3 R23 = F_Schlick( R1, 1.0, cosTheta2 );\n		vec3 phi23 = vec3( 0.0 );\n		if ( baseIOR[ 0 ] < iridescenceIOR ) phi23[ 0 ] = PI;\n		if ( baseIOR[ 1 ] < iridescenceIOR ) phi23[ 1 ] = PI;\n		if ( baseIOR[ 2 ] < iridescenceIOR ) phi23[ 2 ] = PI;\n		float OPD = 2.0 * iridescenceIOR * thinFilmThickness * cosTheta2;\n		vec3 phi = vec3( phi21 ) + phi23;\n		vec3 R123 = clamp( R12 * R23, 1e-5, 0.9999 );\n		vec3 r123 = sqrt( R123 );\n		vec3 Rs = pow2( T121 ) * R23 / ( vec3( 1.0 ) - R123 );\n		vec3 C0 = R12 + Rs;\n		I = C0;\n		vec3 Cm = Rs - T121;\n		for ( int m = 1; m <= 2; ++ m ) {\n			Cm *= r123;\n			vec3 Sm = 2.0 * evalSensitivity( float( m ) * OPD, float( m ) * phi );\n			I += Cm * Sm;\n		}\n		return max( I, vec3( 0.0 ) );\n	}\n#endif",
            bumpmap_pars_fragment: "#ifdef USE_BUMPMAP\n	uniform sampler2D bumpMap;\n	uniform float bumpScale;\n	vec2 dHdxy_fwd() {\n		vec2 dSTdx = dFdx( vBumpMapUv );\n		vec2 dSTdy = dFdy( vBumpMapUv );\n		float Hll = bumpScale * texture2D( bumpMap, vBumpMapUv ).x;\n		float dBx = bumpScale * texture2D( bumpMap, vBumpMapUv + dSTdx ).x - Hll;\n		float dBy = bumpScale * texture2D( bumpMap, vBumpMapUv + dSTdy ).x - Hll;\n		return vec2( dBx, dBy );\n	}\n	vec3 perturbNormalArb( vec3 surf_pos, vec3 surf_norm, vec2 dHdxy, float faceDirection ) {\n		vec3 vSigmaX = normalize( dFdx( surf_pos.xyz ) );\n		vec3 vSigmaY = normalize( dFdy( surf_pos.xyz ) );\n		vec3 vN = surf_norm;\n		vec3 R1 = cross( vSigmaY, vN );\n		vec3 R2 = cross( vN, vSigmaX );\n		float fDet = dot( vSigmaX, R1 ) * faceDirection;\n		vec3 vGrad = sign( fDet ) * ( dHdxy.x * R1 + dHdxy.y * R2 );\n		return normalize( abs( fDet ) * surf_norm - vGrad );\n	}\n#endif",
            clipping_planes_fragment: "#if NUM_CLIPPING_PLANES > 0\n	vec4 plane;\n	#pragma unroll_loop_start\n	for ( int i = 0; i < UNION_CLIPPING_PLANES; i ++ ) {\n		plane = clippingPlanes[ i ];\n		if ( dot( vClipPosition, plane.xyz ) > plane.w ) discard;\n	}\n	#pragma unroll_loop_end\n	#if UNION_CLIPPING_PLANES < NUM_CLIPPING_PLANES\n		bool clipped = true;\n		#pragma unroll_loop_start\n		for ( int i = UNION_CLIPPING_PLANES; i < NUM_CLIPPING_PLANES; i ++ ) {\n			plane = clippingPlanes[ i ];\n			clipped = ( dot( vClipPosition, plane.xyz ) > plane.w ) && clipped;\n		}\n		#pragma unroll_loop_end\n		if ( clipped ) discard;\n	#endif\n#endif",
            clipping_planes_pars_fragment: "#if NUM_CLIPPING_PLANES > 0\n	varying vec3 vClipPosition;\n	uniform vec4 clippingPlanes[ NUM_CLIPPING_PLANES ];\n#endif",
            clipping_planes_pars_vertex: "#if NUM_CLIPPING_PLANES > 0\n	varying vec3 vClipPosition;\n#endif",
            clipping_planes_vertex: "#if NUM_CLIPPING_PLANES > 0\n	vClipPosition = - mvPosition.xyz;\n#endif",
            color_fragment: "#if defined( USE_COLOR_ALPHA )\n	diffuseColor *= vColor;\n#elif defined( USE_COLOR )\n	diffuseColor.rgb *= vColor;\n#endif",
            color_pars_fragment: "#if defined( USE_COLOR_ALPHA )\n	varying vec4 vColor;\n#elif defined( USE_COLOR )\n	varying vec3 vColor;\n#endif",
            color_pars_vertex: "#if defined( USE_COLOR_ALPHA )\n	varying vec4 vColor;\n#elif defined( USE_COLOR ) || defined( USE_INSTANCING_COLOR )\n	varying vec3 vColor;\n#endif",
            color_vertex: "#if defined( USE_COLOR_ALPHA )\n	vColor = vec4( 1.0 );\n#elif defined( USE_COLOR ) || defined( USE_INSTANCING_COLOR )\n	vColor = vec3( 1.0 );\n#endif\n#ifdef USE_COLOR\n	vColor *= color;\n#endif\n#ifdef USE_INSTANCING_COLOR\n	vColor.xyz *= instanceColor.xyz;\n#endif",
            common: "#define PI 3.141592653589793\n#define PI2 6.283185307179586\n#define PI_HALF 1.5707963267948966\n#define RECIPROCAL_PI 0.3183098861837907\n#define RECIPROCAL_PI2 0.15915494309189535\n#define EPSILON 1e-6\n#ifndef saturate\n#define saturate( a ) clamp( a, 0.0, 1.0 )\n#endif\n#define whiteComplement( a ) ( 1.0 - saturate( a ) )\nfloat pow2( const in float x ) { return x*x; }\nvec3 pow2( const in vec3 x ) { return x*x; }\nfloat pow3( const in float x ) { return x*x*x; }\nfloat pow4( const in float x ) { float x2 = x*x; return x2*x2; }\nfloat max3( const in vec3 v ) { return max( max( v.x, v.y ), v.z ); }\nfloat average( const in vec3 v ) { return dot( v, vec3( 0.3333333 ) ); }\nhighp float rand( const in vec2 uv ) {\n	const highp float a = 12.9898, b = 78.233, c = 43758.5453;\n	highp float dt = dot( uv.xy, vec2( a,b ) ), sn = mod( dt, PI );\n	return fract( sin( sn ) * c );\n}\n#ifdef HIGH_PRECISION\n	float precisionSafeLength( vec3 v ) { return length( v ); }\n#else\n	float precisionSafeLength( vec3 v ) {\n		float maxComponent = max3( abs( v ) );\n		return length( v / maxComponent ) * maxComponent;\n	}\n#endif\nstruct IncidentLight {\n	vec3 color;\n	vec3 direction;\n	bool visible;\n};\nstruct ReflectedLight {\n	vec3 directDiffuse;\n	vec3 directSpecular;\n	vec3 indirectDiffuse;\n	vec3 indirectSpecular;\n};\n#ifdef USE_ALPHAHASH\n	varying vec3 vPosition;\n#endif\nvec3 transformDirection( in vec3 dir, in mat4 matrix ) {\n	return normalize( ( matrix * vec4( dir, 0.0 ) ).xyz );\n}\nvec3 inverseTransformDirection( in vec3 dir, in mat4 matrix ) {\n	return normalize( ( vec4( dir, 0.0 ) * matrix ).xyz );\n}\nmat3 transposeMat3( const in mat3 m ) {\n	mat3 tmp;\n	tmp[ 0 ] = vec3( m[ 0 ].x, m[ 1 ].x, m[ 2 ].x );\n	tmp[ 1 ] = vec3( m[ 0 ].y, m[ 1 ].y, m[ 2 ].y );\n	tmp[ 2 ] = vec3( m[ 0 ].z, m[ 1 ].z, m[ 2 ].z );\n	return tmp;\n}\nfloat luminance( const in vec3 rgb ) {\n	const vec3 weights = vec3( 0.2126729, 0.7151522, 0.0721750 );\n	return dot( weights, rgb );\n}\nbool isPerspectiveMatrix( mat4 m ) {\n	return m[ 2 ][ 3 ] == - 1.0;\n}\nvec2 equirectUv( in vec3 dir ) {\n	float u = atan( dir.z, dir.x ) * RECIPROCAL_PI2 + 0.5;\n	float v = asin( clamp( dir.y, - 1.0, 1.0 ) ) * RECIPROCAL_PI + 0.5;\n	return vec2( u, v );\n}\nvec3 BRDF_Lambert( const in vec3 diffuseColor ) {\n	return RECIPROCAL_PI * diffuseColor;\n}\nvec3 F_Schlick( const in vec3 f0, const in float f90, const in float dotVH ) {\n	float fresnel = exp2( ( - 5.55473 * dotVH - 6.98316 ) * dotVH );\n	return f0 * ( 1.0 - fresnel ) + ( f90 * fresnel );\n}\nfloat F_Schlick( const in float f0, const in float f90, const in float dotVH ) {\n	float fresnel = exp2( ( - 5.55473 * dotVH - 6.98316 ) * dotVH );\n	return f0 * ( 1.0 - fresnel ) + ( f90 * fresnel );\n} // validated",
            cube_uv_reflection_fragment: "#ifdef ENVMAP_TYPE_CUBE_UV\n	#define cubeUV_minMipLevel 4.0\n	#define cubeUV_minTileSize 16.0\n	float getFace( vec3 direction ) {\n		vec3 absDirection = abs( direction );\n		float face = - 1.0;\n		if ( absDirection.x > absDirection.z ) {\n			if ( absDirection.x > absDirection.y )\n				face = direction.x > 0.0 ? 0.0 : 3.0;\n			else\n				face = direction.y > 0.0 ? 1.0 : 4.0;\n		} else {\n			if ( absDirection.z > absDirection.y )\n				face = direction.z > 0.0 ? 2.0 : 5.0;\n			else\n				face = direction.y > 0.0 ? 1.0 : 4.0;\n		}\n		return face;\n	}\n	vec2 getUV( vec3 direction, float face ) {\n		vec2 uv;\n		if ( face == 0.0 ) {\n			uv = vec2( direction.z, direction.y ) / abs( direction.x );\n		} else if ( face == 1.0 ) {\n			uv = vec2( - direction.x, - direction.z ) / abs( direction.y );\n		} else if ( face == 2.0 ) {\n			uv = vec2( - direction.x, direction.y ) / abs( direction.z );\n		} else if ( face == 3.0 ) {\n			uv = vec2( - direction.z, direction.y ) / abs( direction.x );\n		} else if ( face == 4.0 ) {\n			uv = vec2( - direction.x, direction.z ) / abs( direction.y );\n		} else {\n			uv = vec2( direction.x, direction.y ) / abs( direction.z );\n		}\n		return 0.5 * ( uv + 1.0 );\n	}\n	vec3 bilinearCubeUV( sampler2D envMap, vec3 direction, float mipInt ) {\n		float face = getFace( direction );\n		float filterInt = max( cubeUV_minMipLevel - mipInt, 0.0 );\n		mipInt = max( mipInt, cubeUV_minMipLevel );\n		float faceSize = exp2( mipInt );\n		highp vec2 uv = getUV( direction, face ) * ( faceSize - 2.0 ) + 1.0;\n		if ( face > 2.0 ) {\n			uv.y += faceSize;\n			face -= 3.0;\n		}\n		uv.x += face * faceSize;\n		uv.x += filterInt * 3.0 * cubeUV_minTileSize;\n		uv.y += 4.0 * ( exp2( CUBEUV_MAX_MIP ) - faceSize );\n		uv.x *= CUBEUV_TEXEL_WIDTH;\n		uv.y *= CUBEUV_TEXEL_HEIGHT;\n		#ifdef texture2DGradEXT\n			return texture2DGradEXT( envMap, uv, vec2( 0.0 ), vec2( 0.0 ) ).rgb;\n		#else\n			return texture2D( envMap, uv ).rgb;\n		#endif\n	}\n	#define cubeUV_r0 1.0\n	#define cubeUV_v0 0.339\n	#define cubeUV_m0 - 2.0\n	#define cubeUV_r1 0.8\n	#define cubeUV_v1 0.276\n	#define cubeUV_m1 - 1.0\n	#define cubeUV_r4 0.4\n	#define cubeUV_v4 0.046\n	#define cubeUV_m4 2.0\n	#define cubeUV_r5 0.305\n	#define cubeUV_v5 0.016\n	#define cubeUV_m5 3.0\n	#define cubeUV_r6 0.21\n	#define cubeUV_v6 0.0038\n	#define cubeUV_m6 4.0\n	float roughnessToMip( float roughness ) {\n		float mip = 0.0;\n		if ( roughness >= cubeUV_r1 ) {\n			mip = ( cubeUV_r0 - roughness ) * ( cubeUV_m1 - cubeUV_m0 ) / ( cubeUV_r0 - cubeUV_r1 ) + cubeUV_m0;\n		} else if ( roughness >= cubeUV_r4 ) {\n			mip = ( cubeUV_r1 - roughness ) * ( cubeUV_m4 - cubeUV_m1 ) / ( cubeUV_r1 - cubeUV_r4 ) + cubeUV_m1;\n		} else if ( roughness >= cubeUV_r5 ) {\n			mip = ( cubeUV_r4 - roughness ) * ( cubeUV_m5 - cubeUV_m4 ) / ( cubeUV_r4 - cubeUV_r5 ) + cubeUV_m4;\n		} else if ( roughness >= cubeUV_r6 ) {\n			mip = ( cubeUV_r5 - roughness ) * ( cubeUV_m6 - cubeUV_m5 ) / ( cubeUV_r5 - cubeUV_r6 ) + cubeUV_m5;\n		} else {\n			mip = - 2.0 * log2( 1.16 * roughness );		}\n		return mip;\n	}\n	vec4 textureCubeUV( sampler2D envMap, vec3 sampleDir, float roughness ) {\n		float mip = clamp( roughnessToMip( roughness ), cubeUV_m0, CUBEUV_MAX_MIP );\n		float mipF = fract( mip );\n		float mipInt = floor( mip );\n		vec3 color0 = bilinearCubeUV( envMap, sampleDir, mipInt );\n		if ( mipF == 0.0 ) {\n			return vec4( color0, 1.0 );\n		} else {\n			vec3 color1 = bilinearCubeUV( envMap, sampleDir, mipInt + 1.0 );\n			return vec4( mix( color0, color1, mipF ), 1.0 );\n		}\n	}\n#endif",
            defaultnormal_vertex: "vec3 transformedNormal = objectNormal;\n#ifdef USE_INSTANCING\n	mat3 m = mat3( instanceMatrix );\n	transformedNormal /= vec3( dot( m[ 0 ], m[ 0 ] ), dot( m[ 1 ], m[ 1 ] ), dot( m[ 2 ], m[ 2 ] ) );\n	transformedNormal = m * transformedNormal;\n#endif\ntransformedNormal = normalMatrix * transformedNormal;\n#ifdef FLIP_SIDED\n	transformedNormal = - transformedNormal;\n#endif\n#ifdef USE_TANGENT\n	vec3 transformedTangent = ( modelViewMatrix * vec4( objectTangent, 0.0 ) ).xyz;\n	#ifdef FLIP_SIDED\n		transformedTangent = - transformedTangent;\n	#endif\n#endif",
            displacementmap_pars_vertex: "#ifdef USE_DISPLACEMENTMAP\n	uniform sampler2D displacementMap;\n	uniform float displacementScale;\n	uniform float displacementBias;\n#endif",
            displacementmap_vertex: "#ifdef USE_DISPLACEMENTMAP\n	transformed += normalize( objectNormal ) * ( texture2D( displacementMap, vDisplacementMapUv ).x * displacementScale + displacementBias );\n#endif",
            emissivemap_fragment: "#ifdef USE_EMISSIVEMAP\n	vec4 emissiveColor = texture2D( emissiveMap, vEmissiveMapUv );\n	totalEmissiveRadiance *= emissiveColor.rgb;\n#endif",
            emissivemap_pars_fragment: "#ifdef USE_EMISSIVEMAP\n	uniform sampler2D emissiveMap;\n#endif",
            colorspace_fragment: "gl_FragColor = linearToOutputTexel( gl_FragColor );",
            colorspace_pars_fragment: "\nconst mat3 LINEAR_SRGB_TO_LINEAR_DISPLAY_P3 = mat3(\n	vec3( 0.8224621, 0.177538, 0.0 ),\n	vec3( 0.0331941, 0.9668058, 0.0 ),\n	vec3( 0.0170827, 0.0723974, 0.9105199 )\n);\nconst mat3 LINEAR_DISPLAY_P3_TO_LINEAR_SRGB = mat3(\n	vec3( 1.2249401, - 0.2249404, 0.0 ),\n	vec3( - 0.0420569, 1.0420571, 0.0 ),\n	vec3( - 0.0196376, - 0.0786361, 1.0982735 )\n);\nvec4 LinearSRGBToLinearDisplayP3( in vec4 value ) {\n	return vec4( value.rgb * LINEAR_SRGB_TO_LINEAR_DISPLAY_P3, value.a );\n}\nvec4 LinearDisplayP3ToLinearSRGB( in vec4 value ) {\n	return vec4( value.rgb * LINEAR_DISPLAY_P3_TO_LINEAR_SRGB, value.a );\n}\nvec4 LinearTransferOETF( in vec4 value ) {\n	return value;\n}\nvec4 sRGBTransferOETF( in vec4 value ) {\n	return vec4( mix( pow( value.rgb, vec3( 0.41666 ) ) * 1.055 - vec3( 0.055 ), value.rgb * 12.92, vec3( lessThanEqual( value.rgb, vec3( 0.0031308 ) ) ) ), value.a );\n}\nvec4 LinearToLinear( in vec4 value ) {\n	return value;\n}\nvec4 LinearTosRGB( in vec4 value ) {\n	return sRGBTransferOETF( value );\n}",
            envmap_fragment: "#ifdef USE_ENVMAP\n	#ifdef ENV_WORLDPOS\n		vec3 cameraToFrag;\n		if ( isOrthographic ) {\n			cameraToFrag = normalize( vec3( - viewMatrix[ 0 ][ 2 ], - viewMatrix[ 1 ][ 2 ], - viewMatrix[ 2 ][ 2 ] ) );\n		} else {\n			cameraToFrag = normalize( vWorldPosition - cameraPosition );\n		}\n		vec3 worldNormal = inverseTransformDirection( normal, viewMatrix );\n		#ifdef ENVMAP_MODE_REFLECTION\n			vec3 reflectVec = reflect( cameraToFrag, worldNormal );\n		#else\n			vec3 reflectVec = refract( cameraToFrag, worldNormal, refractionRatio );\n		#endif\n	#else\n		vec3 reflectVec = vReflect;\n	#endif\n	#ifdef ENVMAP_TYPE_CUBE\n		vec4 envColor = textureCube( envMap, vec3( flipEnvMap * reflectVec.x, reflectVec.yz ) );\n	#else\n		vec4 envColor = vec4( 0.0 );\n	#endif\n	#ifdef ENVMAP_BLENDING_MULTIPLY\n		outgoingLight = mix( outgoingLight, outgoingLight * envColor.xyz, specularStrength * reflectivity );\n	#elif defined( ENVMAP_BLENDING_MIX )\n		outgoingLight = mix( outgoingLight, envColor.xyz, specularStrength * reflectivity );\n	#elif defined( ENVMAP_BLENDING_ADD )\n		outgoingLight += envColor.xyz * specularStrength * reflectivity;\n	#endif\n#endif",
            envmap_common_pars_fragment: "#ifdef USE_ENVMAP\n	uniform float envMapIntensity;\n	uniform float flipEnvMap;\n	#ifdef ENVMAP_TYPE_CUBE\n		uniform samplerCube envMap;\n	#else\n		uniform sampler2D envMap;\n	#endif\n	\n#endif",
            envmap_pars_fragment: "#ifdef USE_ENVMAP\n	uniform float reflectivity;\n	#if defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) || defined( PHONG ) || defined( LAMBERT )\n		#define ENV_WORLDPOS\n	#endif\n	#ifdef ENV_WORLDPOS\n		varying vec3 vWorldPosition;\n		uniform float refractionRatio;\n	#else\n		varying vec3 vReflect;\n	#endif\n#endif",
            envmap_pars_vertex: "#ifdef USE_ENVMAP\n	#if defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) || defined( PHONG ) || defined( LAMBERT )\n		#define ENV_WORLDPOS\n	#endif\n	#ifdef ENV_WORLDPOS\n		\n		varying vec3 vWorldPosition;\n	#else\n		varying vec3 vReflect;\n		uniform float refractionRatio;\n	#endif\n#endif",
            envmap_physical_pars_fragment: "#ifdef USE_ENVMAP\n	vec3 getIBLIrradiance( const in vec3 normal ) {\n		#ifdef ENVMAP_TYPE_CUBE_UV\n			vec3 worldNormal = inverseTransformDirection( normal, viewMatrix );\n			vec4 envMapColor = textureCubeUV( envMap, worldNormal, 1.0 );\n			return PI * envMapColor.rgb * envMapIntensity;\n		#else\n			return vec3( 0.0 );\n		#endif\n	}\n	vec3 getIBLRadiance( const in vec3 viewDir, const in vec3 normal, const in float roughness ) {\n		#ifdef ENVMAP_TYPE_CUBE_UV\n			vec3 reflectVec = reflect( - viewDir, normal );\n			reflectVec = normalize( mix( reflectVec, normal, roughness * roughness) );\n			reflectVec = inverseTransformDirection( reflectVec, viewMatrix );\n			vec4 envMapColor = textureCubeUV( envMap, reflectVec, roughness );\n			return envMapColor.rgb * envMapIntensity;\n		#else\n			return vec3( 0.0 );\n		#endif\n	}\n	#ifdef USE_ANISOTROPY\n		vec3 getIBLAnisotropyRadiance( const in vec3 viewDir, const in vec3 normal, const in float roughness, const in vec3 bitangent, const in float anisotropy ) {\n			#ifdef ENVMAP_TYPE_CUBE_UV\n				vec3 bentNormal = cross( bitangent, viewDir );\n				bentNormal = normalize( cross( bentNormal, bitangent ) );\n				bentNormal = normalize( mix( bentNormal, normal, pow2( pow2( 1.0 - anisotropy * ( 1.0 - roughness ) ) ) ) );\n				return getIBLRadiance( viewDir, bentNormal, roughness );\n			#else\n				return vec3( 0.0 );\n			#endif\n		}\n	#endif\n#endif",
            envmap_vertex: "#ifdef USE_ENVMAP\n	#ifdef ENV_WORLDPOS\n		vWorldPosition = worldPosition.xyz;\n	#else\n		vec3 cameraToVertex;\n		if ( isOrthographic ) {\n			cameraToVertex = normalize( vec3( - viewMatrix[ 0 ][ 2 ], - viewMatrix[ 1 ][ 2 ], - viewMatrix[ 2 ][ 2 ] ) );\n		} else {\n			cameraToVertex = normalize( worldPosition.xyz - cameraPosition );\n		}\n		vec3 worldNormal = inverseTransformDirection( transformedNormal, viewMatrix );\n		#ifdef ENVMAP_MODE_REFLECTION\n			vReflect = reflect( cameraToVertex, worldNormal );\n		#else\n			vReflect = refract( cameraToVertex, worldNormal, refractionRatio );\n		#endif\n	#endif\n#endif",
            fog_vertex: "#ifdef USE_FOG\n	vFogDepth = - mvPosition.z;\n#endif",
            fog_pars_vertex: "#ifdef USE_FOG\n	varying float vFogDepth;\n#endif",
            fog_fragment: "#ifdef USE_FOG\n	#ifdef FOG_EXP2\n		float fogFactor = 1.0 - exp( - fogDensity * fogDensity * vFogDepth * vFogDepth );\n	#else\n		float fogFactor = smoothstep( fogNear, fogFar, vFogDepth );\n	#endif\n	gl_FragColor.rgb = mix( gl_FragColor.rgb, fogColor, fogFactor );\n#endif",
            fog_pars_fragment: "#ifdef USE_FOG\n	uniform vec3 fogColor;\n	varying float vFogDepth;\n	#ifdef FOG_EXP2\n		uniform float fogDensity;\n	#else\n		uniform float fogNear;\n		uniform float fogFar;\n	#endif\n#endif",
            gradientmap_pars_fragment: "#ifdef USE_GRADIENTMAP\n	uniform sampler2D gradientMap;\n#endif\nvec3 getGradientIrradiance( vec3 normal, vec3 lightDirection ) {\n	float dotNL = dot( normal, lightDirection );\n	vec2 coord = vec2( dotNL * 0.5 + 0.5, 0.0 );\n	#ifdef USE_GRADIENTMAP\n		return vec3( texture2D( gradientMap, coord ).r );\n	#else\n		vec2 fw = fwidth( coord ) * 0.5;\n		return mix( vec3( 0.7 ), vec3( 1.0 ), smoothstep( 0.7 - fw.x, 0.7 + fw.x, coord.x ) );\n	#endif\n}",
            lightmap_fragment: "#ifdef USE_LIGHTMAP\n	vec4 lightMapTexel = texture2D( lightMap, vLightMapUv );\n	vec3 lightMapIrradiance = lightMapTexel.rgb * lightMapIntensity;\n	reflectedLight.indirectDiffuse += lightMapIrradiance;\n#endif",
            lightmap_pars_fragment: "#ifdef USE_LIGHTMAP\n	uniform sampler2D lightMap;\n	uniform float lightMapIntensity;\n#endif",
            lights_lambert_fragment: "LambertMaterial material;\nmaterial.diffuseColor = diffuseColor.rgb;\nmaterial.specularStrength = specularStrength;",
            lights_lambert_pars_fragment: "varying vec3 vViewPosition;\nstruct LambertMaterial {\n	vec3 diffuseColor;\n	float specularStrength;\n};\nvoid RE_Direct_Lambert( const in IncidentLight directLight, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in LambertMaterial material, inout ReflectedLight reflectedLight ) {\n	float dotNL = saturate( dot( geometryNormal, directLight.direction ) );\n	vec3 irradiance = dotNL * directLight.color;\n	reflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\nvoid RE_IndirectDiffuse_Lambert( const in vec3 irradiance, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in LambertMaterial material, inout ReflectedLight reflectedLight ) {\n	reflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\n#define RE_Direct				RE_Direct_Lambert\n#define RE_IndirectDiffuse		RE_IndirectDiffuse_Lambert",
            lights_pars_begin: "uniform bool receiveShadow;\nuniform vec3 ambientLightColor;\n#if defined( USE_LIGHT_PROBES )\n	uniform vec3 lightProbe[ 9 ];\n#endif\nvec3 shGetIrradianceAt( in vec3 normal, in vec3 shCoefficients[ 9 ] ) {\n	float x = normal.x, y = normal.y, z = normal.z;\n	vec3 result = shCoefficients[ 0 ] * 0.886227;\n	result += shCoefficients[ 1 ] * 2.0 * 0.511664 * y;\n	result += shCoefficients[ 2 ] * 2.0 * 0.511664 * z;\n	result += shCoefficients[ 3 ] * 2.0 * 0.511664 * x;\n	result += shCoefficients[ 4 ] * 2.0 * 0.429043 * x * y;\n	result += shCoefficients[ 5 ] * 2.0 * 0.429043 * y * z;\n	result += shCoefficients[ 6 ] * ( 0.743125 * z * z - 0.247708 );\n	result += shCoefficients[ 7 ] * 2.0 * 0.429043 * x * z;\n	result += shCoefficients[ 8 ] * 0.429043 * ( x * x - y * y );\n	return result;\n}\nvec3 getLightProbeIrradiance( const in vec3 lightProbe[ 9 ], const in vec3 normal ) {\n	vec3 worldNormal = inverseTransformDirection( normal, viewMatrix );\n	vec3 irradiance = shGetIrradianceAt( worldNormal, lightProbe );\n	return irradiance;\n}\nvec3 getAmbientLightIrradiance( const in vec3 ambientLightColor ) {\n	vec3 irradiance = ambientLightColor;\n	return irradiance;\n}\nfloat getDistanceAttenuation( const in float lightDistance, const in float cutoffDistance, const in float decayExponent ) {\n	#if defined ( LEGACY_LIGHTS )\n		if ( cutoffDistance > 0.0 && decayExponent > 0.0 ) {\n			return pow( saturate( - lightDistance / cutoffDistance + 1.0 ), decayExponent );\n		}\n		return 1.0;\n	#else\n		float distanceFalloff = 1.0 / max( pow( lightDistance, decayExponent ), 0.01 );\n		if ( cutoffDistance > 0.0 ) {\n			distanceFalloff *= pow2( saturate( 1.0 - pow4( lightDistance / cutoffDistance ) ) );\n		}\n		return distanceFalloff;\n	#endif\n}\nfloat getSpotAttenuation( const in float coneCosine, const in float penumbraCosine, const in float angleCosine ) {\n	return smoothstep( coneCosine, penumbraCosine, angleCosine );\n}\n#if NUM_DIR_LIGHTS > 0\n	struct DirectionalLight {\n		vec3 direction;\n		vec3 color;\n	};\n	uniform DirectionalLight directionalLights[ NUM_DIR_LIGHTS ];\n	void getDirectionalLightInfo( const in DirectionalLight directionalLight, out IncidentLight light ) {\n		light.color = directionalLight.color;\n		light.direction = directionalLight.direction;\n		light.visible = true;\n	}\n#endif\n#if NUM_POINT_LIGHTS > 0\n	struct PointLight {\n		vec3 position;\n		vec3 color;\n		float distance;\n		float decay;\n	};\n	uniform PointLight pointLights[ NUM_POINT_LIGHTS ];\n	void getPointLightInfo( const in PointLight pointLight, const in vec3 geometryPosition, out IncidentLight light ) {\n		vec3 lVector = pointLight.position - geometryPosition;\n		light.direction = normalize( lVector );\n		float lightDistance = length( lVector );\n		light.color = pointLight.color;\n		light.color *= getDistanceAttenuation( lightDistance, pointLight.distance, pointLight.decay );\n		light.visible = ( light.color != vec3( 0.0 ) );\n	}\n#endif\n#if NUM_SPOT_LIGHTS > 0\n	struct SpotLight {\n		vec3 position;\n		vec3 direction;\n		vec3 color;\n		float distance;\n		float decay;\n		float coneCos;\n		float penumbraCos;\n	};\n	uniform SpotLight spotLights[ NUM_SPOT_LIGHTS ];\n	void getSpotLightInfo( const in SpotLight spotLight, const in vec3 geometryPosition, out IncidentLight light ) {\n		vec3 lVector = spotLight.position - geometryPosition;\n		light.direction = normalize( lVector );\n		float angleCos = dot( light.direction, spotLight.direction );\n		float spotAttenuation = getSpotAttenuation( spotLight.coneCos, spotLight.penumbraCos, angleCos );\n		if ( spotAttenuation > 0.0 ) {\n			float lightDistance = length( lVector );\n			light.color = spotLight.color * spotAttenuation;\n			light.color *= getDistanceAttenuation( lightDistance, spotLight.distance, spotLight.decay );\n			light.visible = ( light.color != vec3( 0.0 ) );\n		} else {\n			light.color = vec3( 0.0 );\n			light.visible = false;\n		}\n	}\n#endif\n#if NUM_RECT_AREA_LIGHTS > 0\n	struct RectAreaLight {\n		vec3 color;\n		vec3 position;\n		vec3 halfWidth;\n		vec3 halfHeight;\n	};\n	uniform sampler2D ltc_1;	uniform sampler2D ltc_2;\n	uniform RectAreaLight rectAreaLights[ NUM_RECT_AREA_LIGHTS ];\n#endif\n#if NUM_HEMI_LIGHTS > 0\n	struct HemisphereLight {\n		vec3 direction;\n		vec3 skyColor;\n		vec3 groundColor;\n	};\n	uniform HemisphereLight hemisphereLights[ NUM_HEMI_LIGHTS ];\n	vec3 getHemisphereLightIrradiance( const in HemisphereLight hemiLight, const in vec3 normal ) {\n		float dotNL = dot( normal, hemiLight.direction );\n		float hemiDiffuseWeight = 0.5 * dotNL + 0.5;\n		vec3 irradiance = mix( hemiLight.groundColor, hemiLight.skyColor, hemiDiffuseWeight );\n		return irradiance;\n	}\n#endif",
            lights_toon_fragment: "ToonMaterial material;\nmaterial.diffuseColor = diffuseColor.rgb;",
            lights_toon_pars_fragment: "varying vec3 vViewPosition;\nstruct ToonMaterial {\n	vec3 diffuseColor;\n};\nvoid RE_Direct_Toon( const in IncidentLight directLight, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in ToonMaterial material, inout ReflectedLight reflectedLight ) {\n	vec3 irradiance = getGradientIrradiance( geometryNormal, directLight.direction ) * directLight.color;\n	reflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\nvoid RE_IndirectDiffuse_Toon( const in vec3 irradiance, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in ToonMaterial material, inout ReflectedLight reflectedLight ) {\n	reflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\n#define RE_Direct				RE_Direct_Toon\n#define RE_IndirectDiffuse		RE_IndirectDiffuse_Toon",
            lights_phong_fragment: "BlinnPhongMaterial material;\nmaterial.diffuseColor = diffuseColor.rgb;\nmaterial.specularColor = specular;\nmaterial.specularShininess = shininess;\nmaterial.specularStrength = specularStrength;",
            lights_phong_pars_fragment: "varying vec3 vViewPosition;\nstruct BlinnPhongMaterial {\n	vec3 diffuseColor;\n	vec3 specularColor;\n	float specularShininess;\n	float specularStrength;\n};\nvoid RE_Direct_BlinnPhong( const in IncidentLight directLight, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in BlinnPhongMaterial material, inout ReflectedLight reflectedLight ) {\n	float dotNL = saturate( dot( geometryNormal, directLight.direction ) );\n	vec3 irradiance = dotNL * directLight.color;\n	reflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n	reflectedLight.directSpecular += irradiance * BRDF_BlinnPhong( directLight.direction, geometryViewDir, geometryNormal, material.specularColor, material.specularShininess ) * material.specularStrength;\n}\nvoid RE_IndirectDiffuse_BlinnPhong( const in vec3 irradiance, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in BlinnPhongMaterial material, inout ReflectedLight reflectedLight ) {\n	reflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\n#define RE_Direct				RE_Direct_BlinnPhong\n#define RE_IndirectDiffuse		RE_IndirectDiffuse_BlinnPhong",
            lights_physical_fragment: "PhysicalMaterial material;\nmaterial.diffuseColor = diffuseColor.rgb * ( 1.0 - metalnessFactor );\nvec3 dxy = max( abs( dFdx( nonPerturbedNormal ) ), abs( dFdy( nonPerturbedNormal ) ) );\nfloat geometryRoughness = max( max( dxy.x, dxy.y ), dxy.z );\nmaterial.roughness = max( roughnessFactor, 0.0525 );material.roughness += geometryRoughness;\nmaterial.roughness = min( material.roughness, 1.0 );\n#ifdef IOR\n	material.ior = ior;\n	#ifdef USE_SPECULAR\n		float specularIntensityFactor = specularIntensity;\n		vec3 specularColorFactor = specularColor;\n		#ifdef USE_SPECULAR_COLORMAP\n			specularColorFactor *= texture2D( specularColorMap, vSpecularColorMapUv ).rgb;\n		#endif\n		#ifdef USE_SPECULAR_INTENSITYMAP\n			specularIntensityFactor *= texture2D( specularIntensityMap, vSpecularIntensityMapUv ).a;\n		#endif\n		material.specularF90 = mix( specularIntensityFactor, 1.0, metalnessFactor );\n	#else\n		float specularIntensityFactor = 1.0;\n		vec3 specularColorFactor = vec3( 1.0 );\n		material.specularF90 = 1.0;\n	#endif\n	material.specularColor = mix( min( pow2( ( material.ior - 1.0 ) / ( material.ior + 1.0 ) ) * specularColorFactor, vec3( 1.0 ) ) * specularIntensityFactor, diffuseColor.rgb, metalnessFactor );\n#else\n	material.specularColor = mix( vec3( 0.04 ), diffuseColor.rgb, metalnessFactor );\n	material.specularF90 = 1.0;\n#endif\n#ifdef USE_CLEARCOAT\n	material.clearcoat = clearcoat;\n	material.clearcoatRoughness = clearcoatRoughness;\n	material.clearcoatF0 = vec3( 0.04 );\n	material.clearcoatF90 = 1.0;\n	#ifdef USE_CLEARCOATMAP\n		material.clearcoat *= texture2D( clearcoatMap, vClearcoatMapUv ).x;\n	#endif\n	#ifdef USE_CLEARCOAT_ROUGHNESSMAP\n		material.clearcoatRoughness *= texture2D( clearcoatRoughnessMap, vClearcoatRoughnessMapUv ).y;\n	#endif\n	material.clearcoat = saturate( material.clearcoat );	material.clearcoatRoughness = max( material.clearcoatRoughness, 0.0525 );\n	material.clearcoatRoughness += geometryRoughness;\n	material.clearcoatRoughness = min( material.clearcoatRoughness, 1.0 );\n#endif\n#ifdef USE_IRIDESCENCE\n	material.iridescence = iridescence;\n	material.iridescenceIOR = iridescenceIOR;\n	#ifdef USE_IRIDESCENCEMAP\n		material.iridescence *= texture2D( iridescenceMap, vIridescenceMapUv ).r;\n	#endif\n	#ifdef USE_IRIDESCENCE_THICKNESSMAP\n		material.iridescenceThickness = (iridescenceThicknessMaximum - iridescenceThicknessMinimum) * texture2D( iridescenceThicknessMap, vIridescenceThicknessMapUv ).g + iridescenceThicknessMinimum;\n	#else\n		material.iridescenceThickness = iridescenceThicknessMaximum;\n	#endif\n#endif\n#ifdef USE_SHEEN\n	material.sheenColor = sheenColor;\n	#ifdef USE_SHEEN_COLORMAP\n		material.sheenColor *= texture2D( sheenColorMap, vSheenColorMapUv ).rgb;\n	#endif\n	material.sheenRoughness = clamp( sheenRoughness, 0.07, 1.0 );\n	#ifdef USE_SHEEN_ROUGHNESSMAP\n		material.sheenRoughness *= texture2D( sheenRoughnessMap, vSheenRoughnessMapUv ).a;\n	#endif\n#endif\n#ifdef USE_ANISOTROPY\n	#ifdef USE_ANISOTROPYMAP\n		mat2 anisotropyMat = mat2( anisotropyVector.x, anisotropyVector.y, - anisotropyVector.y, anisotropyVector.x );\n		vec3 anisotropyPolar = texture2D( anisotropyMap, vAnisotropyMapUv ).rgb;\n		vec2 anisotropyV = anisotropyMat * normalize( 2.0 * anisotropyPolar.rg - vec2( 1.0 ) ) * anisotropyPolar.b;\n	#else\n		vec2 anisotropyV = anisotropyVector;\n	#endif\n	material.anisotropy = length( anisotropyV );\n	anisotropyV /= material.anisotropy;\n	material.anisotropy = saturate( material.anisotropy );\n	material.alphaT = mix( pow2( material.roughness ), 1.0, pow2( material.anisotropy ) );\n	material.anisotropyT = tbn[ 0 ] * anisotropyV.x - tbn[ 1 ] * anisotropyV.y;\n	material.anisotropyB = tbn[ 1 ] * anisotropyV.x + tbn[ 0 ] * anisotropyV.y;\n#endif",
            lights_physical_pars_fragment: "struct PhysicalMaterial {\n	vec3 diffuseColor;\n	float roughness;\n	vec3 specularColor;\n	float specularF90;\n	#ifdef USE_CLEARCOAT\n		float clearcoat;\n		float clearcoatRoughness;\n		vec3 clearcoatF0;\n		float clearcoatF90;\n	#endif\n	#ifdef USE_IRIDESCENCE\n		float iridescence;\n		float iridescenceIOR;\n		float iridescenceThickness;\n		vec3 iridescenceFresnel;\n		vec3 iridescenceF0;\n	#endif\n	#ifdef USE_SHEEN\n		vec3 sheenColor;\n		float sheenRoughness;\n	#endif\n	#ifdef IOR\n		float ior;\n	#endif\n	#ifdef USE_TRANSMISSION\n		float transmission;\n		float transmissionAlpha;\n		float thickness;\n		float attenuationDistance;\n		vec3 attenuationColor;\n	#endif\n	#ifdef USE_ANISOTROPY\n		float anisotropy;\n		float alphaT;\n		vec3 anisotropyT;\n		vec3 anisotropyB;\n	#endif\n};\nvec3 clearcoatSpecularDirect = vec3( 0.0 );\nvec3 clearcoatSpecularIndirect = vec3( 0.0 );\nvec3 sheenSpecularDirect = vec3( 0.0 );\nvec3 sheenSpecularIndirect = vec3(0.0 );\nvec3 Schlick_to_F0( const in vec3 f, const in float f90, const in float dotVH ) {\n    float x = clamp( 1.0 - dotVH, 0.0, 1.0 );\n    float x2 = x * x;\n    float x5 = clamp( x * x2 * x2, 0.0, 0.9999 );\n    return ( f - vec3( f90 ) * x5 ) / ( 1.0 - x5 );\n}\nfloat V_GGX_SmithCorrelated( const in float alpha, const in float dotNL, const in float dotNV ) {\n	float a2 = pow2( alpha );\n	float gv = dotNL * sqrt( a2 + ( 1.0 - a2 ) * pow2( dotNV ) );\n	float gl = dotNV * sqrt( a2 + ( 1.0 - a2 ) * pow2( dotNL ) );\n	return 0.5 / max( gv + gl, EPSILON );\n}\nfloat D_GGX( const in float alpha, const in float dotNH ) {\n	float a2 = pow2( alpha );\n	float denom = pow2( dotNH ) * ( a2 - 1.0 ) + 1.0;\n	return RECIPROCAL_PI * a2 / pow2( denom );\n}\n#ifdef USE_ANISOTROPY\n	float V_GGX_SmithCorrelated_Anisotropic( const in float alphaT, const in float alphaB, const in float dotTV, const in float dotBV, const in float dotTL, const in float dotBL, const in float dotNV, const in float dotNL ) {\n		float gv = dotNL * length( vec3( alphaT * dotTV, alphaB * dotBV, dotNV ) );\n		float gl = dotNV * length( vec3( alphaT * dotTL, alphaB * dotBL, dotNL ) );\n		float v = 0.5 / ( gv + gl );\n		return saturate(v);\n	}\n	float D_GGX_Anisotropic( const in float alphaT, const in float alphaB, const in float dotNH, const in float dotTH, const in float dotBH ) {\n		float a2 = alphaT * alphaB;\n		highp vec3 v = vec3( alphaB * dotTH, alphaT * dotBH, a2 * dotNH );\n		highp float v2 = dot( v, v );\n		float w2 = a2 / v2;\n		return RECIPROCAL_PI * a2 * pow2 ( w2 );\n	}\n#endif\n#ifdef USE_CLEARCOAT\n	vec3 BRDF_GGX_Clearcoat( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, const in PhysicalMaterial material) {\n		vec3 f0 = material.clearcoatF0;\n		float f90 = material.clearcoatF90;\n		float roughness = material.clearcoatRoughness;\n		float alpha = pow2( roughness );\n		vec3 halfDir = normalize( lightDir + viewDir );\n		float dotNL = saturate( dot( normal, lightDir ) );\n		float dotNV = saturate( dot( normal, viewDir ) );\n		float dotNH = saturate( dot( normal, halfDir ) );\n		float dotVH = saturate( dot( viewDir, halfDir ) );\n		vec3 F = F_Schlick( f0, f90, dotVH );\n		float V = V_GGX_SmithCorrelated( alpha, dotNL, dotNV );\n		float D = D_GGX( alpha, dotNH );\n		return F * ( V * D );\n	}\n#endif\nvec3 BRDF_GGX( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, const in PhysicalMaterial material ) {\n	vec3 f0 = material.specularColor;\n	float f90 = material.specularF90;\n	float roughness = material.roughness;\n	float alpha = pow2( roughness );\n	vec3 halfDir = normalize( lightDir + viewDir );\n	float dotNL = saturate( dot( normal, lightDir ) );\n	float dotNV = saturate( dot( normal, viewDir ) );\n	float dotNH = saturate( dot( normal, halfDir ) );\n	float dotVH = saturate( dot( viewDir, halfDir ) );\n	vec3 F = F_Schlick( f0, f90, dotVH );\n	#ifdef USE_IRIDESCENCE\n		F = mix( F, material.iridescenceFresnel, material.iridescence );\n	#endif\n	#ifdef USE_ANISOTROPY\n		float dotTL = dot( material.anisotropyT, lightDir );\n		float dotTV = dot( material.anisotropyT, viewDir );\n		float dotTH = dot( material.anisotropyT, halfDir );\n		float dotBL = dot( material.anisotropyB, lightDir );\n		float dotBV = dot( material.anisotropyB, viewDir );\n		float dotBH = dot( material.anisotropyB, halfDir );\n		float V = V_GGX_SmithCorrelated_Anisotropic( material.alphaT, alpha, dotTV, dotBV, dotTL, dotBL, dotNV, dotNL );\n		float D = D_GGX_Anisotropic( material.alphaT, alpha, dotNH, dotTH, dotBH );\n	#else\n		float V = V_GGX_SmithCorrelated( alpha, dotNL, dotNV );\n		float D = D_GGX( alpha, dotNH );\n	#endif\n	return F * ( V * D );\n}\nvec2 LTC_Uv( const in vec3 N, const in vec3 V, const in float roughness ) {\n	const float LUT_SIZE = 64.0;\n	const float LUT_SCALE = ( LUT_SIZE - 1.0 ) / LUT_SIZE;\n	const float LUT_BIAS = 0.5 / LUT_SIZE;\n	float dotNV = saturate( dot( N, V ) );\n	vec2 uv = vec2( roughness, sqrt( 1.0 - dotNV ) );\n	uv = uv * LUT_SCALE + LUT_BIAS;\n	return uv;\n}\nfloat LTC_ClippedSphereFormFactor( const in vec3 f ) {\n	float l = length( f );\n	return max( ( l * l + f.z ) / ( l + 1.0 ), 0.0 );\n}\nvec3 LTC_EdgeVectorFormFactor( const in vec3 v1, const in vec3 v2 ) {\n	float x = dot( v1, v2 );\n	float y = abs( x );\n	float a = 0.8543985 + ( 0.4965155 + 0.0145206 * y ) * y;\n	float b = 3.4175940 + ( 4.1616724 + y ) * y;\n	float v = a / b;\n	float theta_sintheta = ( x > 0.0 ) ? v : 0.5 * inversesqrt( max( 1.0 - x * x, 1e-7 ) ) - v;\n	return cross( v1, v2 ) * theta_sintheta;\n}\nvec3 LTC_Evaluate( const in vec3 N, const in vec3 V, const in vec3 P, const in mat3 mInv, const in vec3 rectCoords[ 4 ] ) {\n	vec3 v1 = rectCoords[ 1 ] - rectCoords[ 0 ];\n	vec3 v2 = rectCoords[ 3 ] - rectCoords[ 0 ];\n	vec3 lightNormal = cross( v1, v2 );\n	if( dot( lightNormal, P - rectCoords[ 0 ] ) < 0.0 ) return vec3( 0.0 );\n	vec3 T1, T2;\n	T1 = normalize( V - N * dot( V, N ) );\n	T2 = - cross( N, T1 );\n	mat3 mat = mInv * transposeMat3( mat3( T1, T2, N ) );\n	vec3 coords[ 4 ];\n	coords[ 0 ] = mat * ( rectCoords[ 0 ] - P );\n	coords[ 1 ] = mat * ( rectCoords[ 1 ] - P );\n	coords[ 2 ] = mat * ( rectCoords[ 2 ] - P );\n	coords[ 3 ] = mat * ( rectCoords[ 3 ] - P );\n	coords[ 0 ] = normalize( coords[ 0 ] );\n	coords[ 1 ] = normalize( coords[ 1 ] );\n	coords[ 2 ] = normalize( coords[ 2 ] );\n	coords[ 3 ] = normalize( coords[ 3 ] );\n	vec3 vectorFormFactor = vec3( 0.0 );\n	vectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 0 ], coords[ 1 ] );\n	vectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 1 ], coords[ 2 ] );\n	vectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 2 ], coords[ 3 ] );\n	vectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 3 ], coords[ 0 ] );\n	float result = LTC_ClippedSphereFormFactor( vectorFormFactor );\n	return vec3( result );\n}\n#if defined( USE_SHEEN )\nfloat D_Charlie( float roughness, float dotNH ) {\n	float alpha = pow2( roughness );\n	float invAlpha = 1.0 / alpha;\n	float cos2h = dotNH * dotNH;\n	float sin2h = max( 1.0 - cos2h, 0.0078125 );\n	return ( 2.0 + invAlpha ) * pow( sin2h, invAlpha * 0.5 ) / ( 2.0 * PI );\n}\nfloat V_Neubelt( float dotNV, float dotNL ) {\n	return saturate( 1.0 / ( 4.0 * ( dotNL + dotNV - dotNL * dotNV ) ) );\n}\nvec3 BRDF_Sheen( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, vec3 sheenColor, const in float sheenRoughness ) {\n	vec3 halfDir = normalize( lightDir + viewDir );\n	float dotNL = saturate( dot( normal, lightDir ) );\n	float dotNV = saturate( dot( normal, viewDir ) );\n	float dotNH = saturate( dot( normal, halfDir ) );\n	float D = D_Charlie( sheenRoughness, dotNH );\n	float V = V_Neubelt( dotNV, dotNL );\n	return sheenColor * ( D * V );\n}\n#endif\nfloat IBLSheenBRDF( const in vec3 normal, const in vec3 viewDir, const in float roughness ) {\n	float dotNV = saturate( dot( normal, viewDir ) );\n	float r2 = roughness * roughness;\n	float a = roughness < 0.25 ? -339.2 * r2 + 161.4 * roughness - 25.9 : -8.48 * r2 + 14.3 * roughness - 9.95;\n	float b = roughness < 0.25 ? 44.0 * r2 - 23.7 * roughness + 3.26 : 1.97 * r2 - 3.27 * roughness + 0.72;\n	float DG = exp( a * dotNV + b ) + ( roughness < 0.25 ? 0.0 : 0.1 * ( roughness - 0.25 ) );\n	return saturate( DG * RECIPROCAL_PI );\n}\nvec2 DFGApprox( const in vec3 normal, const in vec3 viewDir, const in float roughness ) {\n	float dotNV = saturate( dot( normal, viewDir ) );\n	const vec4 c0 = vec4( - 1, - 0.0275, - 0.572, 0.022 );\n	const vec4 c1 = vec4( 1, 0.0425, 1.04, - 0.04 );\n	vec4 r = roughness * c0 + c1;\n	float a004 = min( r.x * r.x, exp2( - 9.28 * dotNV ) ) * r.x + r.y;\n	vec2 fab = vec2( - 1.04, 1.04 ) * a004 + r.zw;\n	return fab;\n}\nvec3 EnvironmentBRDF( const in vec3 normal, const in vec3 viewDir, const in vec3 specularColor, const in float specularF90, const in float roughness ) {\n	vec2 fab = DFGApprox( normal, viewDir, roughness );\n	return specularColor * fab.x + specularF90 * fab.y;\n}\n#ifdef USE_IRIDESCENCE\nvoid computeMultiscatteringIridescence( const in vec3 normal, const in vec3 viewDir, const in vec3 specularColor, const in float specularF90, const in float iridescence, const in vec3 iridescenceF0, const in float roughness, inout vec3 singleScatter, inout vec3 multiScatter ) {\n#else\nvoid computeMultiscattering( const in vec3 normal, const in vec3 viewDir, const in vec3 specularColor, const in float specularF90, const in float roughness, inout vec3 singleScatter, inout vec3 multiScatter ) {\n#endif\n	vec2 fab = DFGApprox( normal, viewDir, roughness );\n	#ifdef USE_IRIDESCENCE\n		vec3 Fr = mix( specularColor, iridescenceF0, iridescence );\n	#else\n		vec3 Fr = specularColor;\n	#endif\n	vec3 FssEss = Fr * fab.x + specularF90 * fab.y;\n	float Ess = fab.x + fab.y;\n	float Ems = 1.0 - Ess;\n	vec3 Favg = Fr + ( 1.0 - Fr ) * 0.047619;	vec3 Fms = FssEss * Favg / ( 1.0 - Ems * Favg );\n	singleScatter += FssEss;\n	multiScatter += Fms * Ems;\n}\n#if NUM_RECT_AREA_LIGHTS > 0\n	void RE_Direct_RectArea_Physical( const in RectAreaLight rectAreaLight, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {\n		vec3 normal = geometryNormal;\n		vec3 viewDir = geometryViewDir;\n		vec3 position = geometryPosition;\n		vec3 lightPos = rectAreaLight.position;\n		vec3 halfWidth = rectAreaLight.halfWidth;\n		vec3 halfHeight = rectAreaLight.halfHeight;\n		vec3 lightColor = rectAreaLight.color;\n		float roughness = material.roughness;\n		vec3 rectCoords[ 4 ];\n		rectCoords[ 0 ] = lightPos + halfWidth - halfHeight;		rectCoords[ 1 ] = lightPos - halfWidth - halfHeight;\n		rectCoords[ 2 ] = lightPos - halfWidth + halfHeight;\n		rectCoords[ 3 ] = lightPos + halfWidth + halfHeight;\n		vec2 uv = LTC_Uv( normal, viewDir, roughness );\n		vec4 t1 = texture2D( ltc_1, uv );\n		vec4 t2 = texture2D( ltc_2, uv );\n		mat3 mInv = mat3(\n			vec3( t1.x, 0, t1.y ),\n			vec3(    0, 1,    0 ),\n			vec3( t1.z, 0, t1.w )\n		);\n		vec3 fresnel = ( material.specularColor * t2.x + ( vec3( 1.0 ) - material.specularColor ) * t2.y );\n		reflectedLight.directSpecular += lightColor * fresnel * LTC_Evaluate( normal, viewDir, position, mInv, rectCoords );\n		reflectedLight.directDiffuse += lightColor * material.diffuseColor * LTC_Evaluate( normal, viewDir, position, mat3( 1.0 ), rectCoords );\n	}\n#endif\nvoid RE_Direct_Physical( const in IncidentLight directLight, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {\n	float dotNL = saturate( dot( geometryNormal, directLight.direction ) );\n	vec3 irradiance = dotNL * directLight.color;\n	#ifdef USE_CLEARCOAT\n		float dotNLcc = saturate( dot( geometryClearcoatNormal, directLight.direction ) );\n		vec3 ccIrradiance = dotNLcc * directLight.color;\n		clearcoatSpecularDirect += ccIrradiance * BRDF_GGX_Clearcoat( directLight.direction, geometryViewDir, geometryClearcoatNormal, material );\n	#endif\n	#ifdef USE_SHEEN\n		sheenSpecularDirect += irradiance * BRDF_Sheen( directLight.direction, geometryViewDir, geometryNormal, material.sheenColor, material.sheenRoughness );\n	#endif\n	reflectedLight.directSpecular += irradiance * BRDF_GGX( directLight.direction, geometryViewDir, geometryNormal, material );\n	reflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\nvoid RE_IndirectDiffuse_Physical( const in vec3 irradiance, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {\n	reflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\nvoid RE_IndirectSpecular_Physical( const in vec3 radiance, const in vec3 irradiance, const in vec3 clearcoatRadiance, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in PhysicalMaterial material, inout ReflectedLight reflectedLight) {\n	#ifdef USE_CLEARCOAT\n		clearcoatSpecularIndirect += clearcoatRadiance * EnvironmentBRDF( geometryClearcoatNormal, geometryViewDir, material.clearcoatF0, material.clearcoatF90, material.clearcoatRoughness );\n	#endif\n	#ifdef USE_SHEEN\n		sheenSpecularIndirect += irradiance * material.sheenColor * IBLSheenBRDF( geometryNormal, geometryViewDir, material.sheenRoughness );\n	#endif\n	vec3 singleScattering = vec3( 0.0 );\n	vec3 multiScattering = vec3( 0.0 );\n	vec3 cosineWeightedIrradiance = irradiance * RECIPROCAL_PI;\n	#ifdef USE_IRIDESCENCE\n		computeMultiscatteringIridescence( geometryNormal, geometryViewDir, material.specularColor, material.specularF90, material.iridescence, material.iridescenceFresnel, material.roughness, singleScattering, multiScattering );\n	#else\n		computeMultiscattering( geometryNormal, geometryViewDir, material.specularColor, material.specularF90, material.roughness, singleScattering, multiScattering );\n	#endif\n	vec3 totalScattering = singleScattering + multiScattering;\n	vec3 diffuse = material.diffuseColor * ( 1.0 - max( max( totalScattering.r, totalScattering.g ), totalScattering.b ) );\n	reflectedLight.indirectSpecular += radiance * singleScattering;\n	reflectedLight.indirectSpecular += multiScattering * cosineWeightedIrradiance;\n	reflectedLight.indirectDiffuse += diffuse * cosineWeightedIrradiance;\n}\n#define RE_Direct				RE_Direct_Physical\n#define RE_Direct_RectArea		RE_Direct_RectArea_Physical\n#define RE_IndirectDiffuse		RE_IndirectDiffuse_Physical\n#define RE_IndirectSpecular		RE_IndirectSpecular_Physical\nfloat computeSpecularOcclusion( const in float dotNV, const in float ambientOcclusion, const in float roughness ) {\n	return saturate( pow( dotNV + ambientOcclusion, exp2( - 16.0 * roughness - 1.0 ) ) - 1.0 + ambientOcclusion );\n}",
            lights_fragment_begin: "\nvec3 geometryPosition = - vViewPosition;\nvec3 geometryNormal = normal;\nvec3 geometryViewDir = ( isOrthographic ) ? vec3( 0, 0, 1 ) : normalize( vViewPosition );\nvec3 geometryClearcoatNormal = vec3( 0.0 );\n#ifdef USE_CLEARCOAT\n	geometryClearcoatNormal = clearcoatNormal;\n#endif\n#ifdef USE_IRIDESCENCE\n	float dotNVi = saturate( dot( normal, geometryViewDir ) );\n	if ( material.iridescenceThickness == 0.0 ) {\n		material.iridescence = 0.0;\n	} else {\n		material.iridescence = saturate( material.iridescence );\n	}\n	if ( material.iridescence > 0.0 ) {\n		material.iridescenceFresnel = evalIridescence( 1.0, material.iridescenceIOR, dotNVi, material.iridescenceThickness, material.specularColor );\n		material.iridescenceF0 = Schlick_to_F0( material.iridescenceFresnel, 1.0, dotNVi );\n	}\n#endif\nIncidentLight directLight;\n#if ( NUM_POINT_LIGHTS > 0 ) && defined( RE_Direct )\n	PointLight pointLight;\n	#if defined( USE_SHADOWMAP ) && NUM_POINT_LIGHT_SHADOWS > 0\n	PointLightShadow pointLightShadow;\n	#endif\n	#pragma unroll_loop_start\n	for ( int i = 0; i < NUM_POINT_LIGHTS; i ++ ) {\n		pointLight = pointLights[ i ];\n		getPointLightInfo( pointLight, geometryPosition, directLight );\n		#if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_POINT_LIGHT_SHADOWS )\n		pointLightShadow = pointLightShadows[ i ];\n		directLight.color *= ( directLight.visible && receiveShadow ) ? getPointShadow( pointShadowMap[ i ], pointLightShadow.shadowMapSize, pointLightShadow.shadowBias, pointLightShadow.shadowRadius, vPointShadowCoord[ i ], pointLightShadow.shadowCameraNear, pointLightShadow.shadowCameraFar ) : 1.0;\n		#endif\n		RE_Direct( directLight, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );\n	}\n	#pragma unroll_loop_end\n#endif\n#if ( NUM_SPOT_LIGHTS > 0 ) && defined( RE_Direct )\n	SpotLight spotLight;\n	vec4 spotColor;\n	vec3 spotLightCoord;\n	bool inSpotLightMap;\n	#if defined( USE_SHADOWMAP ) && NUM_SPOT_LIGHT_SHADOWS > 0\n	SpotLightShadow spotLightShadow;\n	#endif\n	#pragma unroll_loop_start\n	for ( int i = 0; i < NUM_SPOT_LIGHTS; i ++ ) {\n		spotLight = spotLights[ i ];\n		getSpotLightInfo( spotLight, geometryPosition, directLight );\n		#if ( UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS_WITH_MAPS )\n		#define SPOT_LIGHT_MAP_INDEX UNROLLED_LOOP_INDEX\n		#elif ( UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS )\n		#define SPOT_LIGHT_MAP_INDEX NUM_SPOT_LIGHT_MAPS\n		#else\n		#define SPOT_LIGHT_MAP_INDEX ( UNROLLED_LOOP_INDEX - NUM_SPOT_LIGHT_SHADOWS + NUM_SPOT_LIGHT_SHADOWS_WITH_MAPS )\n		#endif\n		#if ( SPOT_LIGHT_MAP_INDEX < NUM_SPOT_LIGHT_MAPS )\n			spotLightCoord = vSpotLightCoord[ i ].xyz / vSpotLightCoord[ i ].w;\n			inSpotLightMap = all( lessThan( abs( spotLightCoord * 2. - 1. ), vec3( 1.0 ) ) );\n			spotColor = texture2D( spotLightMap[ SPOT_LIGHT_MAP_INDEX ], spotLightCoord.xy );\n			directLight.color = inSpotLightMap ? directLight.color * spotColor.rgb : directLight.color;\n		#endif\n		#undef SPOT_LIGHT_MAP_INDEX\n		#if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS )\n		spotLightShadow = spotLightShadows[ i ];\n		directLight.color *= ( directLight.visible && receiveShadow ) ? getShadow( spotShadowMap[ i ], spotLightShadow.shadowMapSize, spotLightShadow.shadowBias, spotLightShadow.shadowRadius, vSpotLightCoord[ i ] ) : 1.0;\n		#endif\n		RE_Direct( directLight, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );\n	}\n	#pragma unroll_loop_end\n#endif\n#if ( NUM_DIR_LIGHTS > 0 ) && defined( RE_Direct )\n	DirectionalLight directionalLight;\n	#if defined( USE_SHADOWMAP ) && NUM_DIR_LIGHT_SHADOWS > 0\n	DirectionalLightShadow directionalLightShadow;\n	#endif\n	#pragma unroll_loop_start\n	for ( int i = 0; i < NUM_DIR_LIGHTS; i ++ ) {\n		directionalLight = directionalLights[ i ];\n		getDirectionalLightInfo( directionalLight, directLight );\n		#if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_DIR_LIGHT_SHADOWS )\n		directionalLightShadow = directionalLightShadows[ i ];\n		directLight.color *= ( directLight.visible && receiveShadow ) ? getShadow( directionalShadowMap[ i ], directionalLightShadow.shadowMapSize, directionalLightShadow.shadowBias, directionalLightShadow.shadowRadius, vDirectionalShadowCoord[ i ] ) : 1.0;\n		#endif\n		RE_Direct( directLight, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );\n	}\n	#pragma unroll_loop_end\n#endif\n#if ( NUM_RECT_AREA_LIGHTS > 0 ) && defined( RE_Direct_RectArea )\n	RectAreaLight rectAreaLight;\n	#pragma unroll_loop_start\n	for ( int i = 0; i < NUM_RECT_AREA_LIGHTS; i ++ ) {\n		rectAreaLight = rectAreaLights[ i ];\n		RE_Direct_RectArea( rectAreaLight, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );\n	}\n	#pragma unroll_loop_end\n#endif\n#if defined( RE_IndirectDiffuse )\n	vec3 iblIrradiance = vec3( 0.0 );\n	vec3 irradiance = getAmbientLightIrradiance( ambientLightColor );\n	#if defined( USE_LIGHT_PROBES )\n		irradiance += getLightProbeIrradiance( lightProbe, geometryNormal );\n	#endif\n	#if ( NUM_HEMI_LIGHTS > 0 )\n		#pragma unroll_loop_start\n		for ( int i = 0; i < NUM_HEMI_LIGHTS; i ++ ) {\n			irradiance += getHemisphereLightIrradiance( hemisphereLights[ i ], geometryNormal );\n		}\n		#pragma unroll_loop_end\n	#endif\n#endif\n#if defined( RE_IndirectSpecular )\n	vec3 radiance = vec3( 0.0 );\n	vec3 clearcoatRadiance = vec3( 0.0 );\n#endif",
            lights_fragment_maps: "#if defined( RE_IndirectDiffuse )\n	#ifdef USE_LIGHTMAP\n		vec4 lightMapTexel = texture2D( lightMap, vLightMapUv );\n		vec3 lightMapIrradiance = lightMapTexel.rgb * lightMapIntensity;\n		irradiance += lightMapIrradiance;\n	#endif\n	#if defined( USE_ENVMAP ) && defined( STANDARD ) && defined( ENVMAP_TYPE_CUBE_UV )\n		iblIrradiance += getIBLIrradiance( geometryNormal );\n	#endif\n#endif\n#if defined( USE_ENVMAP ) && defined( RE_IndirectSpecular )\n	#ifdef USE_ANISOTROPY\n		radiance += getIBLAnisotropyRadiance( geometryViewDir, geometryNormal, material.roughness, material.anisotropyB, material.anisotropy );\n	#else\n		radiance += getIBLRadiance( geometryViewDir, geometryNormal, material.roughness );\n	#endif\n	#ifdef USE_CLEARCOAT\n		clearcoatRadiance += getIBLRadiance( geometryViewDir, geometryClearcoatNormal, material.clearcoatRoughness );\n	#endif\n#endif",
            lights_fragment_end: "#if defined( RE_IndirectDiffuse )\n	RE_IndirectDiffuse( irradiance, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );\n#endif\n#if defined( RE_IndirectSpecular )\n	RE_IndirectSpecular( radiance, iblIrradiance, clearcoatRadiance, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );\n#endif",
            logdepthbuf_fragment: "#if defined( USE_LOGDEPTHBUF ) && defined( USE_LOGDEPTHBUF_EXT )\n	gl_FragDepthEXT = vIsPerspective == 0.0 ? gl_FragCoord.z : log2( vFragDepth ) * logDepthBufFC * 0.5;\n#endif",
            logdepthbuf_pars_fragment: "#if defined( USE_LOGDEPTHBUF ) && defined( USE_LOGDEPTHBUF_EXT )\n	uniform float logDepthBufFC;\n	varying float vFragDepth;\n	varying float vIsPerspective;\n#endif",
            logdepthbuf_pars_vertex: "#ifdef USE_LOGDEPTHBUF\n	#ifdef USE_LOGDEPTHBUF_EXT\n		varying float vFragDepth;\n		varying float vIsPerspective;\n	#else\n		uniform float logDepthBufFC;\n	#endif\n#endif",
            logdepthbuf_vertex: "#ifdef USE_LOGDEPTHBUF\n	#ifdef USE_LOGDEPTHBUF_EXT\n		vFragDepth = 1.0 + gl_Position.w;\n		vIsPerspective = float( isPerspectiveMatrix( projectionMatrix ) );\n	#else\n		if ( isPerspectiveMatrix( projectionMatrix ) ) {\n			gl_Position.z = log2( max( EPSILON, gl_Position.w + 1.0 ) ) * logDepthBufFC - 1.0;\n			gl_Position.z *= gl_Position.w;\n		}\n	#endif\n#endif",
            map_fragment: "#ifdef USE_MAP\n	vec4 sampledDiffuseColor = texture2D( map, vMapUv );\n	#ifdef DECODE_VIDEO_TEXTURE\n		sampledDiffuseColor = vec4( mix( pow( sampledDiffuseColor.rgb * 0.9478672986 + vec3( 0.0521327014 ), vec3( 2.4 ) ), sampledDiffuseColor.rgb * 0.0773993808, vec3( lessThanEqual( sampledDiffuseColor.rgb, vec3( 0.04045 ) ) ) ), sampledDiffuseColor.w );\n	\n	#endif\n	diffuseColor *= sampledDiffuseColor;\n#endif",
            map_pars_fragment: "#ifdef USE_MAP\n	uniform sampler2D map;\n#endif",
            map_particle_fragment: "#if defined( USE_MAP ) || defined( USE_ALPHAMAP )\n	#if defined( USE_POINTS_UV )\n		vec2 uv = vUv;\n	#else\n		vec2 uv = ( uvTransform * vec3( gl_PointCoord.x, 1.0 - gl_PointCoord.y, 1 ) ).xy;\n	#endif\n#endif\n#ifdef USE_MAP\n	diffuseColor *= texture2D( map, uv );\n#endif\n#ifdef USE_ALPHAMAP\n	diffuseColor.a *= texture2D( alphaMap, uv ).g;\n#endif",
            map_particle_pars_fragment: "#if defined( USE_POINTS_UV )\n	varying vec2 vUv;\n#else\n	#if defined( USE_MAP ) || defined( USE_ALPHAMAP )\n		uniform mat3 uvTransform;\n	#endif\n#endif\n#ifdef USE_MAP\n	uniform sampler2D map;\n#endif\n#ifdef USE_ALPHAMAP\n	uniform sampler2D alphaMap;\n#endif",
            metalnessmap_fragment: "float metalnessFactor = metalness;\n#ifdef USE_METALNESSMAP\n	vec4 texelMetalness = texture2D( metalnessMap, vMetalnessMapUv );\n	metalnessFactor *= texelMetalness.b;\n#endif",
            metalnessmap_pars_fragment: "#ifdef USE_METALNESSMAP\n	uniform sampler2D metalnessMap;\n#endif",
            morphcolor_vertex: "#if defined( USE_MORPHCOLORS ) && defined( MORPHTARGETS_TEXTURE )\n	vColor *= morphTargetBaseInfluence;\n	for ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {\n		#if defined( USE_COLOR_ALPHA )\n			if ( morphTargetInfluences[ i ] != 0.0 ) vColor += getMorph( gl_VertexID, i, 2 ) * morphTargetInfluences[ i ];\n		#elif defined( USE_COLOR )\n			if ( morphTargetInfluences[ i ] != 0.0 ) vColor += getMorph( gl_VertexID, i, 2 ).rgb * morphTargetInfluences[ i ];\n		#endif\n	}\n#endif",
            morphnormal_vertex: "#ifdef USE_MORPHNORMALS\n	objectNormal *= morphTargetBaseInfluence;\n	#ifdef MORPHTARGETS_TEXTURE\n		for ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {\n			if ( morphTargetInfluences[ i ] != 0.0 ) objectNormal += getMorph( gl_VertexID, i, 1 ).xyz * morphTargetInfluences[ i ];\n		}\n	#else\n		objectNormal += morphNormal0 * morphTargetInfluences[ 0 ];\n		objectNormal += morphNormal1 * morphTargetInfluences[ 1 ];\n		objectNormal += morphNormal2 * morphTargetInfluences[ 2 ];\n		objectNormal += morphNormal3 * morphTargetInfluences[ 3 ];\n	#endif\n#endif",
            morphtarget_pars_vertex: "#ifdef USE_MORPHTARGETS\n	uniform float morphTargetBaseInfluence;\n	#ifdef MORPHTARGETS_TEXTURE\n		uniform float morphTargetInfluences[ MORPHTARGETS_COUNT ];\n		uniform sampler2DArray morphTargetsTexture;\n		uniform ivec2 morphTargetsTextureSize;\n		vec4 getMorph( const in int vertexIndex, const in int morphTargetIndex, const in int offset ) {\n			int texelIndex = vertexIndex * MORPHTARGETS_TEXTURE_STRIDE + offset;\n			int y = texelIndex / morphTargetsTextureSize.x;\n			int x = texelIndex - y * morphTargetsTextureSize.x;\n			ivec3 morphUV = ivec3( x, y, morphTargetIndex );\n			return texelFetch( morphTargetsTexture, morphUV, 0 );\n		}\n	#else\n		#ifndef USE_MORPHNORMALS\n			uniform float morphTargetInfluences[ 8 ];\n		#else\n			uniform float morphTargetInfluences[ 4 ];\n		#endif\n	#endif\n#endif",
            morphtarget_vertex: "#ifdef USE_MORPHTARGETS\n	transformed *= morphTargetBaseInfluence;\n	#ifdef MORPHTARGETS_TEXTURE\n		for ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {\n			if ( morphTargetInfluences[ i ] != 0.0 ) transformed += getMorph( gl_VertexID, i, 0 ).xyz * morphTargetInfluences[ i ];\n		}\n	#else\n		transformed += morphTarget0 * morphTargetInfluences[ 0 ];\n		transformed += morphTarget1 * morphTargetInfluences[ 1 ];\n		transformed += morphTarget2 * morphTargetInfluences[ 2 ];\n		transformed += morphTarget3 * morphTargetInfluences[ 3 ];\n		#ifndef USE_MORPHNORMALS\n			transformed += morphTarget4 * morphTargetInfluences[ 4 ];\n			transformed += morphTarget5 * morphTargetInfluences[ 5 ];\n			transformed += morphTarget6 * morphTargetInfluences[ 6 ];\n			transformed += morphTarget7 * morphTargetInfluences[ 7 ];\n		#endif\n	#endif\n#endif",
            normal_fragment_begin: "float faceDirection = gl_FrontFacing ? 1.0 : - 1.0;\n#ifdef FLAT_SHADED\n	vec3 fdx = dFdx( vViewPosition );\n	vec3 fdy = dFdy( vViewPosition );\n	vec3 normal = normalize( cross( fdx, fdy ) );\n#else\n	vec3 normal = normalize( vNormal );\n	#ifdef DOUBLE_SIDED\n		normal *= faceDirection;\n	#endif\n#endif\n#if defined( USE_NORMALMAP_TANGENTSPACE ) || defined( USE_CLEARCOAT_NORMALMAP ) || defined( USE_ANISOTROPY )\n	#ifdef USE_TANGENT\n		mat3 tbn = mat3( normalize( vTangent ), normalize( vBitangent ), normal );\n	#else\n		mat3 tbn = getTangentFrame( - vViewPosition, normal,\n		#if defined( USE_NORMALMAP )\n			vNormalMapUv\n		#elif defined( USE_CLEARCOAT_NORMALMAP )\n			vClearcoatNormalMapUv\n		#else\n			vUv\n		#endif\n		);\n	#endif\n	#if defined( DOUBLE_SIDED ) && ! defined( FLAT_SHADED )\n		tbn[0] *= faceDirection;\n		tbn[1] *= faceDirection;\n	#endif\n#endif\n#ifdef USE_CLEARCOAT_NORMALMAP\n	#ifdef USE_TANGENT\n		mat3 tbn2 = mat3( normalize( vTangent ), normalize( vBitangent ), normal );\n	#else\n		mat3 tbn2 = getTangentFrame( - vViewPosition, normal, vClearcoatNormalMapUv );\n	#endif\n	#if defined( DOUBLE_SIDED ) && ! defined( FLAT_SHADED )\n		tbn2[0] *= faceDirection;\n		tbn2[1] *= faceDirection;\n	#endif\n#endif\nvec3 nonPerturbedNormal = normal;",
            normal_fragment_maps: "#ifdef USE_NORMALMAP_OBJECTSPACE\n	normal = texture2D( normalMap, vNormalMapUv ).xyz * 2.0 - 1.0;\n	#ifdef FLIP_SIDED\n		normal = - normal;\n	#endif\n	#ifdef DOUBLE_SIDED\n		normal = normal * faceDirection;\n	#endif\n	normal = normalize( normalMatrix * normal );\n#elif defined( USE_NORMALMAP_TANGENTSPACE )\n	vec3 mapN = texture2D( normalMap, vNormalMapUv ).xyz * 2.0 - 1.0;\n	mapN.xy *= normalScale;\n	normal = normalize( tbn * mapN );\n#elif defined( USE_BUMPMAP )\n	normal = perturbNormalArb( - vViewPosition, normal, dHdxy_fwd(), faceDirection );\n#endif",
            normal_pars_fragment: "#ifndef FLAT_SHADED\n	varying vec3 vNormal;\n	#ifdef USE_TANGENT\n		varying vec3 vTangent;\n		varying vec3 vBitangent;\n	#endif\n#endif",
            normal_pars_vertex: "#ifndef FLAT_SHADED\n	varying vec3 vNormal;\n	#ifdef USE_TANGENT\n		varying vec3 vTangent;\n		varying vec3 vBitangent;\n	#endif\n#endif",
            normal_vertex: "#ifndef FLAT_SHADED\n	vNormal = normalize( transformedNormal );\n	#ifdef USE_TANGENT\n		vTangent = normalize( transformedTangent );\n		vBitangent = normalize( cross( vNormal, vTangent ) * tangent.w );\n	#endif\n#endif",
            normalmap_pars_fragment: "#ifdef USE_NORMALMAP\n	uniform sampler2D normalMap;\n	uniform vec2 normalScale;\n#endif\n#ifdef USE_NORMALMAP_OBJECTSPACE\n	uniform mat3 normalMatrix;\n#endif\n#if ! defined ( USE_TANGENT ) && ( defined ( USE_NORMALMAP_TANGENTSPACE ) || defined ( USE_CLEARCOAT_NORMALMAP ) || defined( USE_ANISOTROPY ) )\n	mat3 getTangentFrame( vec3 eye_pos, vec3 surf_norm, vec2 uv ) {\n		vec3 q0 = dFdx( eye_pos.xyz );\n		vec3 q1 = dFdy( eye_pos.xyz );\n		vec2 st0 = dFdx( uv.st );\n		vec2 st1 = dFdy( uv.st );\n		vec3 N = surf_norm;\n		vec3 q1perp = cross( q1, N );\n		vec3 q0perp = cross( N, q0 );\n		vec3 T = q1perp * st0.x + q0perp * st1.x;\n		vec3 B = q1perp * st0.y + q0perp * st1.y;\n		float det = max( dot( T, T ), dot( B, B ) );\n		float scale = ( det == 0.0 ) ? 0.0 : inversesqrt( det );\n		return mat3( T * scale, B * scale, N );\n	}\n#endif",
            clearcoat_normal_fragment_begin: "#ifdef USE_CLEARCOAT\n	vec3 clearcoatNormal = nonPerturbedNormal;\n#endif",
            clearcoat_normal_fragment_maps: "#ifdef USE_CLEARCOAT_NORMALMAP\n	vec3 clearcoatMapN = texture2D( clearcoatNormalMap, vClearcoatNormalMapUv ).xyz * 2.0 - 1.0;\n	clearcoatMapN.xy *= clearcoatNormalScale;\n	clearcoatNormal = normalize( tbn2 * clearcoatMapN );\n#endif",
            clearcoat_pars_fragment: "#ifdef USE_CLEARCOATMAP\n	uniform sampler2D clearcoatMap;\n#endif\n#ifdef USE_CLEARCOAT_NORMALMAP\n	uniform sampler2D clearcoatNormalMap;\n	uniform vec2 clearcoatNormalScale;\n#endif\n#ifdef USE_CLEARCOAT_ROUGHNESSMAP\n	uniform sampler2D clearcoatRoughnessMap;\n#endif",
            iridescence_pars_fragment: "#ifdef USE_IRIDESCENCEMAP\n	uniform sampler2D iridescenceMap;\n#endif\n#ifdef USE_IRIDESCENCE_THICKNESSMAP\n	uniform sampler2D iridescenceThicknessMap;\n#endif",
            opaque_fragment: "#ifdef OPAQUE\ndiffuseColor.a = 1.0;\n#endif\n#ifdef USE_TRANSMISSION\ndiffuseColor.a *= material.transmissionAlpha;\n#endif\ngl_FragColor = vec4( outgoingLight, diffuseColor.a );",
            packing: "vec3 packNormalToRGB( const in vec3 normal ) {\n	return normalize( normal ) * 0.5 + 0.5;\n}\nvec3 unpackRGBToNormal( const in vec3 rgb ) {\n	return 2.0 * rgb.xyz - 1.0;\n}\nconst float PackUpscale = 256. / 255.;const float UnpackDownscale = 255. / 256.;\nconst vec3 PackFactors = vec3( 256. * 256. * 256., 256. * 256., 256. );\nconst vec4 UnpackFactors = UnpackDownscale / vec4( PackFactors, 1. );\nconst float ShiftRight8 = 1. / 256.;\nvec4 packDepthToRGBA( const in float v ) {\n	vec4 r = vec4( fract( v * PackFactors ), v );\n	r.yzw -= r.xyz * ShiftRight8;	return r * PackUpscale;\n}\nfloat unpackRGBAToDepth( const in vec4 v ) {\n	return dot( v, UnpackFactors );\n}\nvec2 packDepthToRG( in highp float v ) {\n	return packDepthToRGBA( v ).yx;\n}\nfloat unpackRGToDepth( const in highp vec2 v ) {\n	return unpackRGBAToDepth( vec4( v.xy, 0.0, 0.0 ) );\n}\nvec4 pack2HalfToRGBA( vec2 v ) {\n	vec4 r = vec4( v.x, fract( v.x * 255.0 ), v.y, fract( v.y * 255.0 ) );\n	return vec4( r.x - r.y / 255.0, r.y, r.z - r.w / 255.0, r.w );\n}\nvec2 unpackRGBATo2Half( vec4 v ) {\n	return vec2( v.x + ( v.y / 255.0 ), v.z + ( v.w / 255.0 ) );\n}\nfloat viewZToOrthographicDepth( const in float viewZ, const in float near, const in float far ) {\n	return ( viewZ + near ) / ( near - far );\n}\nfloat orthographicDepthToViewZ( const in float depth, const in float near, const in float far ) {\n	return depth * ( near - far ) - near;\n}\nfloat viewZToPerspectiveDepth( const in float viewZ, const in float near, const in float far ) {\n	return ( ( near + viewZ ) * far ) / ( ( far - near ) * viewZ );\n}\nfloat perspectiveDepthToViewZ( const in float depth, const in float near, const in float far ) {\n	return ( near * far ) / ( ( far - near ) * depth - far );\n}",
            premultiplied_alpha_fragment: "#ifdef PREMULTIPLIED_ALPHA\n	gl_FragColor.rgb *= gl_FragColor.a;\n#endif",
            project_vertex: "vec4 mvPosition = vec4( transformed, 1.0 );\n#ifdef USE_INSTANCING\n	mvPosition = instanceMatrix * mvPosition;\n#endif\nmvPosition = modelViewMatrix * mvPosition;\ngl_Position = projectionMatrix * mvPosition;",
            dithering_fragment: "#ifdef DITHERING\n	gl_FragColor.rgb = dithering( gl_FragColor.rgb );\n#endif",
            dithering_pars_fragment: "#ifdef DITHERING\n	vec3 dithering( vec3 color ) {\n		float grid_position = rand( gl_FragCoord.xy );\n		vec3 dither_shift_RGB = vec3( 0.25 / 255.0, -0.25 / 255.0, 0.25 / 255.0 );\n		dither_shift_RGB = mix( 2.0 * dither_shift_RGB, -2.0 * dither_shift_RGB, grid_position );\n		return color + dither_shift_RGB;\n	}\n#endif",
            roughnessmap_fragment: "float roughnessFactor = roughness;\n#ifdef USE_ROUGHNESSMAP\n	vec4 texelRoughness = texture2D( roughnessMap, vRoughnessMapUv );\n	roughnessFactor *= texelRoughness.g;\n#endif",
            roughnessmap_pars_fragment: "#ifdef USE_ROUGHNESSMAP\n	uniform sampler2D roughnessMap;\n#endif",
            shadowmap_pars_fragment: "#if NUM_SPOT_LIGHT_COORDS > 0\n	varying vec4 vSpotLightCoord[ NUM_SPOT_LIGHT_COORDS ];\n#endif\n#if NUM_SPOT_LIGHT_MAPS > 0\n	uniform sampler2D spotLightMap[ NUM_SPOT_LIGHT_MAPS ];\n#endif\n#ifdef USE_SHADOWMAP\n	#if NUM_DIR_LIGHT_SHADOWS > 0\n		uniform sampler2D directionalShadowMap[ NUM_DIR_LIGHT_SHADOWS ];\n		varying vec4 vDirectionalShadowCoord[ NUM_DIR_LIGHT_SHADOWS ];\n		struct DirectionalLightShadow {\n			float shadowBias;\n			float shadowNormalBias;\n			float shadowRadius;\n			vec2 shadowMapSize;\n		};\n		uniform DirectionalLightShadow directionalLightShadows[ NUM_DIR_LIGHT_SHADOWS ];\n	#endif\n	#if NUM_SPOT_LIGHT_SHADOWS > 0\n		uniform sampler2D spotShadowMap[ NUM_SPOT_LIGHT_SHADOWS ];\n		struct SpotLightShadow {\n			float shadowBias;\n			float shadowNormalBias;\n			float shadowRadius;\n			vec2 shadowMapSize;\n		};\n		uniform SpotLightShadow spotLightShadows[ NUM_SPOT_LIGHT_SHADOWS ];\n	#endif\n	#if NUM_POINT_LIGHT_SHADOWS > 0\n		uniform sampler2D pointShadowMap[ NUM_POINT_LIGHT_SHADOWS ];\n		varying vec4 vPointShadowCoord[ NUM_POINT_LIGHT_SHADOWS ];\n		struct PointLightShadow {\n			float shadowBias;\n			float shadowNormalBias;\n			float shadowRadius;\n			vec2 shadowMapSize;\n			float shadowCameraNear;\n			float shadowCameraFar;\n		};\n		uniform PointLightShadow pointLightShadows[ NUM_POINT_LIGHT_SHADOWS ];\n	#endif\n	float texture2DCompare( sampler2D depths, vec2 uv, float compare ) {\n		return step( compare, unpackRGBAToDepth( texture2D( depths, uv ) ) );\n	}\n	vec2 texture2DDistribution( sampler2D shadow, vec2 uv ) {\n		return unpackRGBATo2Half( texture2D( shadow, uv ) );\n	}\n	float VSMShadow (sampler2D shadow, vec2 uv, float compare ){\n		float occlusion = 1.0;\n		vec2 distribution = texture2DDistribution( shadow, uv );\n		float hard_shadow = step( compare , distribution.x );\n		if (hard_shadow != 1.0 ) {\n			float distance = compare - distribution.x ;\n			float variance = max( 0.00000, distribution.y * distribution.y );\n			float softness_probability = variance / (variance + distance * distance );			softness_probability = clamp( ( softness_probability - 0.3 ) / ( 0.95 - 0.3 ), 0.0, 1.0 );			occlusion = clamp( max( hard_shadow, softness_probability ), 0.0, 1.0 );\n		}\n		return occlusion;\n	}\n	float getShadow( sampler2D shadowMap, vec2 shadowMapSize, float shadowBias, float shadowRadius, vec4 shadowCoord ) {\n		float shadow = 1.0;\n		shadowCoord.xyz /= shadowCoord.w;\n		shadowCoord.z += shadowBias;\n		bool inFrustum = shadowCoord.x >= 0.0 && shadowCoord.x <= 1.0 && shadowCoord.y >= 0.0 && shadowCoord.y <= 1.0;\n		bool frustumTest = inFrustum && shadowCoord.z <= 1.0;\n		if ( frustumTest ) {\n		#if defined( SHADOWMAP_TYPE_PCF )\n			vec2 texelSize = vec2( 1.0 ) / shadowMapSize;\n			float dx0 = - texelSize.x * shadowRadius;\n			float dy0 = - texelSize.y * shadowRadius;\n			float dx1 = + texelSize.x * shadowRadius;\n			float dy1 = + texelSize.y * shadowRadius;\n			float dx2 = dx0 / 2.0;\n			float dy2 = dy0 / 2.0;\n			float dx3 = dx1 / 2.0;\n			float dy3 = dy1 / 2.0;\n			shadow = (\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx0, dy0 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy0 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx1, dy0 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx2, dy2 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy2 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx3, dy2 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx0, 0.0 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx2, 0.0 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy, shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx3, 0.0 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx1, 0.0 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx2, dy3 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy3 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx3, dy3 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx0, dy1 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy1 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx1, dy1 ), shadowCoord.z )\n			) * ( 1.0 / 17.0 );\n		#elif defined( SHADOWMAP_TYPE_PCF_SOFT )\n			vec2 texelSize = vec2( 1.0 ) / shadowMapSize;\n			float dx = texelSize.x;\n			float dy = texelSize.y;\n			vec2 uv = shadowCoord.xy;\n			vec2 f = fract( uv * shadowMapSize + 0.5 );\n			uv -= f * texelSize;\n			shadow = (\n				texture2DCompare( shadowMap, uv, shadowCoord.z ) +\n				texture2DCompare( shadowMap, uv + vec2( dx, 0.0 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, uv + vec2( 0.0, dy ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, uv + texelSize, shadowCoord.z ) +\n				mix( texture2DCompare( shadowMap, uv + vec2( -dx, 0.0 ), shadowCoord.z ),\n					 texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, 0.0 ), shadowCoord.z ),\n					 f.x ) +\n				mix( texture2DCompare( shadowMap, uv + vec2( -dx, dy ), shadowCoord.z ),\n					 texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, dy ), shadowCoord.z ),\n					 f.x ) +\n				mix( texture2DCompare( shadowMap, uv + vec2( 0.0, -dy ), shadowCoord.z ),\n					 texture2DCompare( shadowMap, uv + vec2( 0.0, 2.0 * dy ), shadowCoord.z ),\n					 f.y ) +\n				mix( texture2DCompare( shadowMap, uv + vec2( dx, -dy ), shadowCoord.z ),\n					 texture2DCompare( shadowMap, uv + vec2( dx, 2.0 * dy ), shadowCoord.z ),\n					 f.y ) +\n				mix( mix( texture2DCompare( shadowMap, uv + vec2( -dx, -dy ), shadowCoord.z ),\n						  texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, -dy ), shadowCoord.z ),\n						  f.x ),\n					 mix( texture2DCompare( shadowMap, uv + vec2( -dx, 2.0 * dy ), shadowCoord.z ),\n						  texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, 2.0 * dy ), shadowCoord.z ),\n						  f.x ),\n					 f.y )\n			) * ( 1.0 / 9.0 );\n		#elif defined( SHADOWMAP_TYPE_VSM )\n			shadow = VSMShadow( shadowMap, shadowCoord.xy, shadowCoord.z );\n		#else\n			shadow = texture2DCompare( shadowMap, shadowCoord.xy, shadowCoord.z );\n		#endif\n		}\n		return shadow;\n	}\n	vec2 cubeToUV( vec3 v, float texelSizeY ) {\n		vec3 absV = abs( v );\n		float scaleToCube = 1.0 / max( absV.x, max( absV.y, absV.z ) );\n		absV *= scaleToCube;\n		v *= scaleToCube * ( 1.0 - 2.0 * texelSizeY );\n		vec2 planar = v.xy;\n		float almostATexel = 1.5 * texelSizeY;\n		float almostOne = 1.0 - almostATexel;\n		if ( absV.z >= almostOne ) {\n			if ( v.z > 0.0 )\n				planar.x = 4.0 - v.x;\n		} else if ( absV.x >= almostOne ) {\n			float signX = sign( v.x );\n			planar.x = v.z * signX + 2.0 * signX;\n		} else if ( absV.y >= almostOne ) {\n			float signY = sign( v.y );\n			planar.x = v.x + 2.0 * signY + 2.0;\n			planar.y = v.z * signY - 2.0;\n		}\n		return vec2( 0.125, 0.25 ) * planar + vec2( 0.375, 0.75 );\n	}\n	float getPointShadow( sampler2D shadowMap, vec2 shadowMapSize, float shadowBias, float shadowRadius, vec4 shadowCoord, float shadowCameraNear, float shadowCameraFar ) {\n		vec2 texelSize = vec2( 1.0 ) / ( shadowMapSize * vec2( 4.0, 2.0 ) );\n		vec3 lightToPosition = shadowCoord.xyz;\n		float dp = ( length( lightToPosition ) - shadowCameraNear ) / ( shadowCameraFar - shadowCameraNear );		dp += shadowBias;\n		vec3 bd3D = normalize( lightToPosition );\n		#if defined( SHADOWMAP_TYPE_PCF ) || defined( SHADOWMAP_TYPE_PCF_SOFT ) || defined( SHADOWMAP_TYPE_VSM )\n			vec2 offset = vec2( - 1, 1 ) * shadowRadius * texelSize.y;\n			return (\n				texture2DCompare( shadowMap, cubeToUV( bd3D + offset.xyy, texelSize.y ), dp ) +\n				texture2DCompare( shadowMap, cubeToUV( bd3D + offset.yyy, texelSize.y ), dp ) +\n				texture2DCompare( shadowMap, cubeToUV( bd3D + offset.xyx, texelSize.y ), dp ) +\n				texture2DCompare( shadowMap, cubeToUV( bd3D + offset.yyx, texelSize.y ), dp ) +\n				texture2DCompare( shadowMap, cubeToUV( bd3D, texelSize.y ), dp ) +\n				texture2DCompare( shadowMap, cubeToUV( bd3D + offset.xxy, texelSize.y ), dp ) +\n				texture2DCompare( shadowMap, cubeToUV( bd3D + offset.yxy, texelSize.y ), dp ) +\n				texture2DCompare( shadowMap, cubeToUV( bd3D + offset.xxx, texelSize.y ), dp ) +\n				texture2DCompare( shadowMap, cubeToUV( bd3D + offset.yxx, texelSize.y ), dp )\n			) * ( 1.0 / 9.0 );\n		#else\n			return texture2DCompare( shadowMap, cubeToUV( bd3D, texelSize.y ), dp );\n		#endif\n	}\n#endif",
            shadowmap_pars_vertex: "#if NUM_SPOT_LIGHT_COORDS > 0\n	uniform mat4 spotLightMatrix[ NUM_SPOT_LIGHT_COORDS ];\n	varying vec4 vSpotLightCoord[ NUM_SPOT_LIGHT_COORDS ];\n#endif\n#ifdef USE_SHADOWMAP\n	#if NUM_DIR_LIGHT_SHADOWS > 0\n		uniform mat4 directionalShadowMatrix[ NUM_DIR_LIGHT_SHADOWS ];\n		varying vec4 vDirectionalShadowCoord[ NUM_DIR_LIGHT_SHADOWS ];\n		struct DirectionalLightShadow {\n			float shadowBias;\n			float shadowNormalBias;\n			float shadowRadius;\n			vec2 shadowMapSize;\n		};\n		uniform DirectionalLightShadow directionalLightShadows[ NUM_DIR_LIGHT_SHADOWS ];\n	#endif\n	#if NUM_SPOT_LIGHT_SHADOWS > 0\n		struct SpotLightShadow {\n			float shadowBias;\n			float shadowNormalBias;\n			float shadowRadius;\n			vec2 shadowMapSize;\n		};\n		uniform SpotLightShadow spotLightShadows[ NUM_SPOT_LIGHT_SHADOWS ];\n	#endif\n	#if NUM_POINT_LIGHT_SHADOWS > 0\n		uniform mat4 pointShadowMatrix[ NUM_POINT_LIGHT_SHADOWS ];\n		varying vec4 vPointShadowCoord[ NUM_POINT_LIGHT_SHADOWS ];\n		struct PointLightShadow {\n			float shadowBias;\n			float shadowNormalBias;\n			float shadowRadius;\n			vec2 shadowMapSize;\n			float shadowCameraNear;\n			float shadowCameraFar;\n		};\n		uniform PointLightShadow pointLightShadows[ NUM_POINT_LIGHT_SHADOWS ];\n	#endif\n#endif",
            shadowmap_vertex: "#if ( defined( USE_SHADOWMAP ) && ( NUM_DIR_LIGHT_SHADOWS > 0 || NUM_POINT_LIGHT_SHADOWS > 0 ) ) || ( NUM_SPOT_LIGHT_COORDS > 0 )\n	vec3 shadowWorldNormal = inverseTransformDirection( transformedNormal, viewMatrix );\n	vec4 shadowWorldPosition;\n#endif\n#if defined( USE_SHADOWMAP )\n	#if NUM_DIR_LIGHT_SHADOWS > 0\n		#pragma unroll_loop_start\n		for ( int i = 0; i < NUM_DIR_LIGHT_SHADOWS; i ++ ) {\n			shadowWorldPosition = worldPosition + vec4( shadowWorldNormal * directionalLightShadows[ i ].shadowNormalBias, 0 );\n			vDirectionalShadowCoord[ i ] = directionalShadowMatrix[ i ] * shadowWorldPosition;\n		}\n		#pragma unroll_loop_end\n	#endif\n	#if NUM_POINT_LIGHT_SHADOWS > 0\n		#pragma unroll_loop_start\n		for ( int i = 0; i < NUM_POINT_LIGHT_SHADOWS; i ++ ) {\n			shadowWorldPosition = worldPosition + vec4( shadowWorldNormal * pointLightShadows[ i ].shadowNormalBias, 0 );\n			vPointShadowCoord[ i ] = pointShadowMatrix[ i ] * shadowWorldPosition;\n		}\n		#pragma unroll_loop_end\n	#endif\n#endif\n#if NUM_SPOT_LIGHT_COORDS > 0\n	#pragma unroll_loop_start\n	for ( int i = 0; i < NUM_SPOT_LIGHT_COORDS; i ++ ) {\n		shadowWorldPosition = worldPosition;\n		#if ( defined( USE_SHADOWMAP ) && UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS )\n			shadowWorldPosition.xyz += shadowWorldNormal * spotLightShadows[ i ].shadowNormalBias;\n		#endif\n		vSpotLightCoord[ i ] = spotLightMatrix[ i ] * shadowWorldPosition;\n	}\n	#pragma unroll_loop_end\n#endif",
            shadowmask_pars_fragment: "float getShadowMask() {\n	float shadow = 1.0;\n	#ifdef USE_SHADOWMAP\n	#if NUM_DIR_LIGHT_SHADOWS > 0\n	DirectionalLightShadow directionalLight;\n	#pragma unroll_loop_start\n	for ( int i = 0; i < NUM_DIR_LIGHT_SHADOWS; i ++ ) {\n		directionalLight = directionalLightShadows[ i ];\n		shadow *= receiveShadow ? getShadow( directionalShadowMap[ i ], directionalLight.shadowMapSize, directionalLight.shadowBias, directionalLight.shadowRadius, vDirectionalShadowCoord[ i ] ) : 1.0;\n	}\n	#pragma unroll_loop_end\n	#endif\n	#if NUM_SPOT_LIGHT_SHADOWS > 0\n	SpotLightShadow spotLight;\n	#pragma unroll_loop_start\n	for ( int i = 0; i < NUM_SPOT_LIGHT_SHADOWS; i ++ ) {\n		spotLight = spotLightShadows[ i ];\n		shadow *= receiveShadow ? getShadow( spotShadowMap[ i ], spotLight.shadowMapSize, spotLight.shadowBias, spotLight.shadowRadius, vSpotLightCoord[ i ] ) : 1.0;\n	}\n	#pragma unroll_loop_end\n	#endif\n	#if NUM_POINT_LIGHT_SHADOWS > 0\n	PointLightShadow pointLight;\n	#pragma unroll_loop_start\n	for ( int i = 0; i < NUM_POINT_LIGHT_SHADOWS; i ++ ) {\n		pointLight = pointLightShadows[ i ];\n		shadow *= receiveShadow ? getPointShadow( pointShadowMap[ i ], pointLight.shadowMapSize, pointLight.shadowBias, pointLight.shadowRadius, vPointShadowCoord[ i ], pointLight.shadowCameraNear, pointLight.shadowCameraFar ) : 1.0;\n	}\n	#pragma unroll_loop_end\n	#endif\n	#endif\n	return shadow;\n}",
            skinbase_vertex: "#ifdef USE_SKINNING\n	mat4 boneMatX = getBoneMatrix( skinIndex.x );\n	mat4 boneMatY = getBoneMatrix( skinIndex.y );\n	mat4 boneMatZ = getBoneMatrix( skinIndex.z );\n	mat4 boneMatW = getBoneMatrix( skinIndex.w );\n#endif",
            skinning_pars_vertex: "#ifdef USE_SKINNING\n	uniform mat4 bindMatrix;\n	uniform mat4 bindMatrixInverse;\n	uniform highp sampler2D boneTexture;\n	uniform int boneTextureSize;\n	mat4 getBoneMatrix( const in float i ) {\n		float j = i * 4.0;\n		float x = mod( j, float( boneTextureSize ) );\n		float y = floor( j / float( boneTextureSize ) );\n		float dx = 1.0 / float( boneTextureSize );\n		float dy = 1.0 / float( boneTextureSize );\n		y = dy * ( y + 0.5 );\n		vec4 v1 = texture2D( boneTexture, vec2( dx * ( x + 0.5 ), y ) );\n		vec4 v2 = texture2D( boneTexture, vec2( dx * ( x + 1.5 ), y ) );\n		vec4 v3 = texture2D( boneTexture, vec2( dx * ( x + 2.5 ), y ) );\n		vec4 v4 = texture2D( boneTexture, vec2( dx * ( x + 3.5 ), y ) );\n		mat4 bone = mat4( v1, v2, v3, v4 );\n		return bone;\n	}\n#endif",
            skinning_vertex: "#ifdef USE_SKINNING\n	vec4 skinVertex = bindMatrix * vec4( transformed, 1.0 );\n	vec4 skinned = vec4( 0.0 );\n	skinned += boneMatX * skinVertex * skinWeight.x;\n	skinned += boneMatY * skinVertex * skinWeight.y;\n	skinned += boneMatZ * skinVertex * skinWeight.z;\n	skinned += boneMatW * skinVertex * skinWeight.w;\n	transformed = ( bindMatrixInverse * skinned ).xyz;\n#endif",
            skinnormal_vertex: "#ifdef USE_SKINNING\n	mat4 skinMatrix = mat4( 0.0 );\n	skinMatrix += skinWeight.x * boneMatX;\n	skinMatrix += skinWeight.y * boneMatY;\n	skinMatrix += skinWeight.z * boneMatZ;\n	skinMatrix += skinWeight.w * boneMatW;\n	skinMatrix = bindMatrixInverse * skinMatrix * bindMatrix;\n	objectNormal = vec4( skinMatrix * vec4( objectNormal, 0.0 ) ).xyz;\n	#ifdef USE_TANGENT\n		objectTangent = vec4( skinMatrix * vec4( objectTangent, 0.0 ) ).xyz;\n	#endif\n#endif",
            specularmap_fragment: "float specularStrength;\n#ifdef USE_SPECULARMAP\n	vec4 texelSpecular = texture2D( specularMap, vSpecularMapUv );\n	specularStrength = texelSpecular.r;\n#else\n	specularStrength = 1.0;\n#endif",
            specularmap_pars_fragment: "#ifdef USE_SPECULARMAP\n	uniform sampler2D specularMap;\n#endif",
            tonemapping_fragment: "#if defined( TONE_MAPPING )\n	gl_FragColor.rgb = toneMapping( gl_FragColor.rgb );\n#endif",
            tonemapping_pars_fragment: "#ifndef saturate\n#define saturate( a ) clamp( a, 0.0, 1.0 )\n#endif\nuniform float toneMappingExposure;\nvec3 LinearToneMapping( vec3 color ) {\n	return saturate( toneMappingExposure * color );\n}\nvec3 ReinhardToneMapping( vec3 color ) {\n	color *= toneMappingExposure;\n	return saturate( color / ( vec3( 1.0 ) + color ) );\n}\nvec3 OptimizedCineonToneMapping( vec3 color ) {\n	color *= toneMappingExposure;\n	color = max( vec3( 0.0 ), color - 0.004 );\n	return pow( ( color * ( 6.2 * color + 0.5 ) ) / ( color * ( 6.2 * color + 1.7 ) + 0.06 ), vec3( 2.2 ) );\n}\nvec3 RRTAndODTFit( vec3 v ) {\n	vec3 a = v * ( v + 0.0245786 ) - 0.000090537;\n	vec3 b = v * ( 0.983729 * v + 0.4329510 ) + 0.238081;\n	return a / b;\n}\nvec3 ACESFilmicToneMapping( vec3 color ) {\n	const mat3 ACESInputMat = mat3(\n		vec3( 0.59719, 0.07600, 0.02840 ),		vec3( 0.35458, 0.90834, 0.13383 ),\n		vec3( 0.04823, 0.01566, 0.83777 )\n	);\n	const mat3 ACESOutputMat = mat3(\n		vec3(  1.60475, -0.10208, -0.00327 ),		vec3( -0.53108,  1.10813, -0.07276 ),\n		vec3( -0.07367, -0.00605,  1.07602 )\n	);\n	color *= toneMappingExposure / 0.6;\n	color = ACESInputMat * color;\n	color = RRTAndODTFit( color );\n	color = ACESOutputMat * color;\n	return saturate( color );\n}\nvec3 CustomToneMapping( vec3 color ) { return color; }",
            transmission_fragment: "#ifdef USE_TRANSMISSION\n	material.transmission = transmission;\n	material.transmissionAlpha = 1.0;\n	material.thickness = thickness;\n	material.attenuationDistance = attenuationDistance;\n	material.attenuationColor = attenuationColor;\n	#ifdef USE_TRANSMISSIONMAP\n		material.transmission *= texture2D( transmissionMap, vTransmissionMapUv ).r;\n	#endif\n	#ifdef USE_THICKNESSMAP\n		material.thickness *= texture2D( thicknessMap, vThicknessMapUv ).g;\n	#endif\n	vec3 pos = vWorldPosition;\n	vec3 v = normalize( cameraPosition - pos );\n	vec3 n = inverseTransformDirection( normal, viewMatrix );\n	vec4 transmitted = getIBLVolumeRefraction(\n		n, v, material.roughness, material.diffuseColor, material.specularColor, material.specularF90,\n		pos, modelMatrix, viewMatrix, projectionMatrix, material.ior, material.thickness,\n		material.attenuationColor, material.attenuationDistance );\n	material.transmissionAlpha = mix( material.transmissionAlpha, transmitted.a, material.transmission );\n	totalDiffuse = mix( totalDiffuse, transmitted.rgb, material.transmission );\n#endif",
            transmission_pars_fragment: "#ifdef USE_TRANSMISSION\n	uniform float transmission;\n	uniform float thickness;\n	uniform float attenuationDistance;\n	uniform vec3 attenuationColor;\n	#ifdef USE_TRANSMISSIONMAP\n		uniform sampler2D transmissionMap;\n	#endif\n	#ifdef USE_THICKNESSMAP\n		uniform sampler2D thicknessMap;\n	#endif\n	uniform vec2 transmissionSamplerSize;\n	uniform sampler2D transmissionSamplerMap;\n	uniform mat4 modelMatrix;\n	uniform mat4 projectionMatrix;\n	varying vec3 vWorldPosition;\n	float w0( float a ) {\n		return ( 1.0 / 6.0 ) * ( a * ( a * ( - a + 3.0 ) - 3.0 ) + 1.0 );\n	}\n	float w1( float a ) {\n		return ( 1.0 / 6.0 ) * ( a *  a * ( 3.0 * a - 6.0 ) + 4.0 );\n	}\n	float w2( float a ){\n		return ( 1.0 / 6.0 ) * ( a * ( a * ( - 3.0 * a + 3.0 ) + 3.0 ) + 1.0 );\n	}\n	float w3( float a ) {\n		return ( 1.0 / 6.0 ) * ( a * a * a );\n	}\n	float g0( float a ) {\n		return w0( a ) + w1( a );\n	}\n	float g1( float a ) {\n		return w2( a ) + w3( a );\n	}\n	float h0( float a ) {\n		return - 1.0 + w1( a ) / ( w0( a ) + w1( a ) );\n	}\n	float h1( float a ) {\n		return 1.0 + w3( a ) / ( w2( a ) + w3( a ) );\n	}\n	vec4 bicubic( sampler2D tex, vec2 uv, vec4 texelSize, float lod ) {\n		uv = uv * texelSize.zw + 0.5;\n		vec2 iuv = floor( uv );\n		vec2 fuv = fract( uv );\n		float g0x = g0( fuv.x );\n		float g1x = g1( fuv.x );\n		float h0x = h0( fuv.x );\n		float h1x = h1( fuv.x );\n		float h0y = h0( fuv.y );\n		float h1y = h1( fuv.y );\n		vec2 p0 = ( vec2( iuv.x + h0x, iuv.y + h0y ) - 0.5 ) * texelSize.xy;\n		vec2 p1 = ( vec2( iuv.x + h1x, iuv.y + h0y ) - 0.5 ) * texelSize.xy;\n		vec2 p2 = ( vec2( iuv.x + h0x, iuv.y + h1y ) - 0.5 ) * texelSize.xy;\n		vec2 p3 = ( vec2( iuv.x + h1x, iuv.y + h1y ) - 0.5 ) * texelSize.xy;\n		return g0( fuv.y ) * ( g0x * textureLod( tex, p0, lod ) + g1x * textureLod( tex, p1, lod ) ) +\n			g1( fuv.y ) * ( g0x * textureLod( tex, p2, lod ) + g1x * textureLod( tex, p3, lod ) );\n	}\n	vec4 textureBicubic( sampler2D sampler, vec2 uv, float lod ) {\n		vec2 fLodSize = vec2( textureSize( sampler, int( lod ) ) );\n		vec2 cLodSize = vec2( textureSize( sampler, int( lod + 1.0 ) ) );\n		vec2 fLodSizeInv = 1.0 / fLodSize;\n		vec2 cLodSizeInv = 1.0 / cLodSize;\n		vec4 fSample = bicubic( sampler, uv, vec4( fLodSizeInv, fLodSize ), floor( lod ) );\n		vec4 cSample = bicubic( sampler, uv, vec4( cLodSizeInv, cLodSize ), ceil( lod ) );\n		return mix( fSample, cSample, fract( lod ) );\n	}\n	vec3 getVolumeTransmissionRay( const in vec3 n, const in vec3 v, const in float thickness, const in float ior, const in mat4 modelMatrix ) {\n		vec3 refractionVector = refract( - v, normalize( n ), 1.0 / ior );\n		vec3 modelScale;\n		modelScale.x = length( vec3( modelMatrix[ 0 ].xyz ) );\n		modelScale.y = length( vec3( modelMatrix[ 1 ].xyz ) );\n		modelScale.z = length( vec3( modelMatrix[ 2 ].xyz ) );\n		return normalize( refractionVector ) * thickness * modelScale;\n	}\n	float applyIorToRoughness( const in float roughness, const in float ior ) {\n		return roughness * clamp( ior * 2.0 - 2.0, 0.0, 1.0 );\n	}\n	vec4 getTransmissionSample( const in vec2 fragCoord, const in float roughness, const in float ior ) {\n		float lod = log2( transmissionSamplerSize.x ) * applyIorToRoughness( roughness, ior );\n		return textureBicubic( transmissionSamplerMap, fragCoord.xy, lod );\n	}\n	vec3 volumeAttenuation( const in float transmissionDistance, const in vec3 attenuationColor, const in float attenuationDistance ) {\n		if ( isinf( attenuationDistance ) ) {\n			return vec3( 1.0 );\n		} else {\n			vec3 attenuationCoefficient = -log( attenuationColor ) / attenuationDistance;\n			vec3 transmittance = exp( - attenuationCoefficient * transmissionDistance );			return transmittance;\n		}\n	}\n	vec4 getIBLVolumeRefraction( const in vec3 n, const in vec3 v, const in float roughness, const in vec3 diffuseColor,\n		const in vec3 specularColor, const in float specularF90, const in vec3 position, const in mat4 modelMatrix,\n		const in mat4 viewMatrix, const in mat4 projMatrix, const in float ior, const in float thickness,\n		const in vec3 attenuationColor, const in float attenuationDistance ) {\n		vec3 transmissionRay = getVolumeTransmissionRay( n, v, thickness, ior, modelMatrix );\n		vec3 refractedRayExit = position + transmissionRay;\n		vec4 ndcPos = projMatrix * viewMatrix * vec4( refractedRayExit, 1.0 );\n		vec2 refractionCoords = ndcPos.xy / ndcPos.w;\n		refractionCoords += 1.0;\n		refractionCoords /= 2.0;\n		vec4 transmittedLight = getTransmissionSample( refractionCoords, roughness, ior );\n		vec3 transmittance = diffuseColor * volumeAttenuation( length( transmissionRay ), attenuationColor, attenuationDistance );\n		vec3 attenuatedColor = transmittance * transmittedLight.rgb;\n		vec3 F = EnvironmentBRDF( n, v, specularColor, specularF90, roughness );\n		float transmittanceFactor = ( transmittance.r + transmittance.g + transmittance.b ) / 3.0;\n		return vec4( ( 1.0 - F ) * attenuatedColor, 1.0 - ( 1.0 - transmittedLight.a ) * transmittanceFactor );\n	}\n#endif",
            uv_pars_fragment: "#if defined( USE_UV ) || defined( USE_ANISOTROPY )\n	varying vec2 vUv;\n#endif\n#ifdef USE_MAP\n	varying vec2 vMapUv;\n#endif\n#ifdef USE_ALPHAMAP\n	varying vec2 vAlphaMapUv;\n#endif\n#ifdef USE_LIGHTMAP\n	varying vec2 vLightMapUv;\n#endif\n#ifdef USE_AOMAP\n	varying vec2 vAoMapUv;\n#endif\n#ifdef USE_BUMPMAP\n	varying vec2 vBumpMapUv;\n#endif\n#ifdef USE_NORMALMAP\n	varying vec2 vNormalMapUv;\n#endif\n#ifdef USE_EMISSIVEMAP\n	varying vec2 vEmissiveMapUv;\n#endif\n#ifdef USE_METALNESSMAP\n	varying vec2 vMetalnessMapUv;\n#endif\n#ifdef USE_ROUGHNESSMAP\n	varying vec2 vRoughnessMapUv;\n#endif\n#ifdef USE_ANISOTROPYMAP\n	varying vec2 vAnisotropyMapUv;\n#endif\n#ifdef USE_CLEARCOATMAP\n	varying vec2 vClearcoatMapUv;\n#endif\n#ifdef USE_CLEARCOAT_NORMALMAP\n	varying vec2 vClearcoatNormalMapUv;\n#endif\n#ifdef USE_CLEARCOAT_ROUGHNESSMAP\n	varying vec2 vClearcoatRoughnessMapUv;\n#endif\n#ifdef USE_IRIDESCENCEMAP\n	varying vec2 vIridescenceMapUv;\n#endif\n#ifdef USE_IRIDESCENCE_THICKNESSMAP\n	varying vec2 vIridescenceThicknessMapUv;\n#endif\n#ifdef USE_SHEEN_COLORMAP\n	varying vec2 vSheenColorMapUv;\n#endif\n#ifdef USE_SHEEN_ROUGHNESSMAP\n	varying vec2 vSheenRoughnessMapUv;\n#endif\n#ifdef USE_SPECULARMAP\n	varying vec2 vSpecularMapUv;\n#endif\n#ifdef USE_SPECULAR_COLORMAP\n	varying vec2 vSpecularColorMapUv;\n#endif\n#ifdef USE_SPECULAR_INTENSITYMAP\n	varying vec2 vSpecularIntensityMapUv;\n#endif\n#ifdef USE_TRANSMISSIONMAP\n	uniform mat3 transmissionMapTransform;\n	varying vec2 vTransmissionMapUv;\n#endif\n#ifdef USE_THICKNESSMAP\n	uniform mat3 thicknessMapTransform;\n	varying vec2 vThicknessMapUv;\n#endif",
            uv_pars_vertex: "#if defined( USE_UV ) || defined( USE_ANISOTROPY )\n	varying vec2 vUv;\n#endif\n#ifdef USE_MAP\n	uniform mat3 mapTransform;\n	varying vec2 vMapUv;\n#endif\n#ifdef USE_ALPHAMAP\n	uniform mat3 alphaMapTransform;\n	varying vec2 vAlphaMapUv;\n#endif\n#ifdef USE_LIGHTMAP\n	uniform mat3 lightMapTransform;\n	varying vec2 vLightMapUv;\n#endif\n#ifdef USE_AOMAP\n	uniform mat3 aoMapTransform;\n	varying vec2 vAoMapUv;\n#endif\n#ifdef USE_BUMPMAP\n	uniform mat3 bumpMapTransform;\n	varying vec2 vBumpMapUv;\n#endif\n#ifdef USE_NORMALMAP\n	uniform mat3 normalMapTransform;\n	varying vec2 vNormalMapUv;\n#endif\n#ifdef USE_DISPLACEMENTMAP\n	uniform mat3 displacementMapTransform;\n	varying vec2 vDisplacementMapUv;\n#endif\n#ifdef USE_EMISSIVEMAP\n	uniform mat3 emissiveMapTransform;\n	varying vec2 vEmissiveMapUv;\n#endif\n#ifdef USE_METALNESSMAP\n	uniform mat3 metalnessMapTransform;\n	varying vec2 vMetalnessMapUv;\n#endif\n#ifdef USE_ROUGHNESSMAP\n	uniform mat3 roughnessMapTransform;\n	varying vec2 vRoughnessMapUv;\n#endif\n#ifdef USE_ANISOTROPYMAP\n	uniform mat3 anisotropyMapTransform;\n	varying vec2 vAnisotropyMapUv;\n#endif\n#ifdef USE_CLEARCOATMAP\n	uniform mat3 clearcoatMapTransform;\n	varying vec2 vClearcoatMapUv;\n#endif\n#ifdef USE_CLEARCOAT_NORMALMAP\n	uniform mat3 clearcoatNormalMapTransform;\n	varying vec2 vClearcoatNormalMapUv;\n#endif\n#ifdef USE_CLEARCOAT_ROUGHNESSMAP\n	uniform mat3 clearcoatRoughnessMapTransform;\n	varying vec2 vClearcoatRoughnessMapUv;\n#endif\n#ifdef USE_SHEEN_COLORMAP\n	uniform mat3 sheenColorMapTransform;\n	varying vec2 vSheenColorMapUv;\n#endif\n#ifdef USE_SHEEN_ROUGHNESSMAP\n	uniform mat3 sheenRoughnessMapTransform;\n	varying vec2 vSheenRoughnessMapUv;\n#endif\n#ifdef USE_IRIDESCENCEMAP\n	uniform mat3 iridescenceMapTransform;\n	varying vec2 vIridescenceMapUv;\n#endif\n#ifdef USE_IRIDESCENCE_THICKNESSMAP\n	uniform mat3 iridescenceThicknessMapTransform;\n	varying vec2 vIridescenceThicknessMapUv;\n#endif\n#ifdef USE_SPECULARMAP\n	uniform mat3 specularMapTransform;\n	varying vec2 vSpecularMapUv;\n#endif\n#ifdef USE_SPECULAR_COLORMAP\n	uniform mat3 specularColorMapTransform;\n	varying vec2 vSpecularColorMapUv;\n#endif\n#ifdef USE_SPECULAR_INTENSITYMAP\n	uniform mat3 specularIntensityMapTransform;\n	varying vec2 vSpecularIntensityMapUv;\n#endif\n#ifdef USE_TRANSMISSIONMAP\n	uniform mat3 transmissionMapTransform;\n	varying vec2 vTransmissionMapUv;\n#endif\n#ifdef USE_THICKNESSMAP\n	uniform mat3 thicknessMapTransform;\n	varying vec2 vThicknessMapUv;\n#endif",
            uv_vertex: "#if defined( USE_UV ) || defined( USE_ANISOTROPY )\n	vUv = vec3( uv, 1 ).xy;\n#endif\n#ifdef USE_MAP\n	vMapUv = ( mapTransform * vec3( MAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_ALPHAMAP\n	vAlphaMapUv = ( alphaMapTransform * vec3( ALPHAMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_LIGHTMAP\n	vLightMapUv = ( lightMapTransform * vec3( LIGHTMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_AOMAP\n	vAoMapUv = ( aoMapTransform * vec3( AOMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_BUMPMAP\n	vBumpMapUv = ( bumpMapTransform * vec3( BUMPMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_NORMALMAP\n	vNormalMapUv = ( normalMapTransform * vec3( NORMALMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_DISPLACEMENTMAP\n	vDisplacementMapUv = ( displacementMapTransform * vec3( DISPLACEMENTMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_EMISSIVEMAP\n	vEmissiveMapUv = ( emissiveMapTransform * vec3( EMISSIVEMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_METALNESSMAP\n	vMetalnessMapUv = ( metalnessMapTransform * vec3( METALNESSMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_ROUGHNESSMAP\n	vRoughnessMapUv = ( roughnessMapTransform * vec3( ROUGHNESSMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_ANISOTROPYMAP\n	vAnisotropyMapUv = ( anisotropyMapTransform * vec3( ANISOTROPYMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_CLEARCOATMAP\n	vClearcoatMapUv = ( clearcoatMapTransform * vec3( CLEARCOATMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_CLEARCOAT_NORMALMAP\n	vClearcoatNormalMapUv = ( clearcoatNormalMapTransform * vec3( CLEARCOAT_NORMALMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_CLEARCOAT_ROUGHNESSMAP\n	vClearcoatRoughnessMapUv = ( clearcoatRoughnessMapTransform * vec3( CLEARCOAT_ROUGHNESSMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_IRIDESCENCEMAP\n	vIridescenceMapUv = ( iridescenceMapTransform * vec3( IRIDESCENCEMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_IRIDESCENCE_THICKNESSMAP\n	vIridescenceThicknessMapUv = ( iridescenceThicknessMapTransform * vec3( IRIDESCENCE_THICKNESSMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_SHEEN_COLORMAP\n	vSheenColorMapUv = ( sheenColorMapTransform * vec3( SHEEN_COLORMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_SHEEN_ROUGHNESSMAP\n	vSheenRoughnessMapUv = ( sheenRoughnessMapTransform * vec3( SHEEN_ROUGHNESSMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_SPECULARMAP\n	vSpecularMapUv = ( specularMapTransform * vec3( SPECULARMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_SPECULAR_COLORMAP\n	vSpecularColorMapUv = ( specularColorMapTransform * vec3( SPECULAR_COLORMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_SPECULAR_INTENSITYMAP\n	vSpecularIntensityMapUv = ( specularIntensityMapTransform * vec3( SPECULAR_INTENSITYMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_TRANSMISSIONMAP\n	vTransmissionMapUv = ( transmissionMapTransform * vec3( TRANSMISSIONMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_THICKNESSMAP\n	vThicknessMapUv = ( thicknessMapTransform * vec3( THICKNESSMAP_UV, 1 ) ).xy;\n#endif",
            worldpos_vertex: "#if defined( USE_ENVMAP ) || defined( DISTANCE ) || defined ( USE_SHADOWMAP ) || defined ( USE_TRANSMISSION ) || NUM_SPOT_LIGHT_COORDS > 0\n	vec4 worldPosition = vec4( transformed, 1.0 );\n	#ifdef USE_INSTANCING\n		worldPosition = instanceMatrix * worldPosition;\n	#endif\n	worldPosition = modelMatrix * worldPosition;\n#endif",
            background_vert: "varying vec2 vUv;\nuniform mat3 uvTransform;\nvoid main() {\n	vUv = ( uvTransform * vec3( uv, 1 ) ).xy;\n	gl_Position = vec4( position.xy, 1.0, 1.0 );\n}",
            background_frag: "uniform sampler2D t2D;\nuniform float backgroundIntensity;\nvarying vec2 vUv;\nvoid main() {\n	vec4 texColor = texture2D( t2D, vUv );\n	#ifdef DECODE_VIDEO_TEXTURE\n		texColor = vec4( mix( pow( texColor.rgb * 0.9478672986 + vec3( 0.0521327014 ), vec3( 2.4 ) ), texColor.rgb * 0.0773993808, vec3( lessThanEqual( texColor.rgb, vec3( 0.04045 ) ) ) ), texColor.w );\n	#endif\n	texColor.rgb *= backgroundIntensity;\n	gl_FragColor = texColor;\n	#include <tonemapping_fragment>\n	#include <colorspace_fragment>\n}",
            backgroundCube_vert: "varying vec3 vWorldDirection;\n#include <common>\nvoid main() {\n	vWorldDirection = transformDirection( position, modelMatrix );\n	#include <begin_vertex>\n	#include <project_vertex>\n	gl_Position.z = gl_Position.w;\n}",
            backgroundCube_frag: "#ifdef ENVMAP_TYPE_CUBE\n	uniform samplerCube envMap;\n#elif defined( ENVMAP_TYPE_CUBE_UV )\n	uniform sampler2D envMap;\n#endif\nuniform float flipEnvMap;\nuniform float backgroundBlurriness;\nuniform float backgroundIntensity;\nvarying vec3 vWorldDirection;\n#include <cube_uv_reflection_fragment>\nvoid main() {\n	#ifdef ENVMAP_TYPE_CUBE\n		vec4 texColor = textureCube( envMap, vec3( flipEnvMap * vWorldDirection.x, vWorldDirection.yz ) );\n	#elif defined( ENVMAP_TYPE_CUBE_UV )\n		vec4 texColor = textureCubeUV( envMap, vWorldDirection, backgroundBlurriness );\n	#else\n		vec4 texColor = vec4( 0.0, 0.0, 0.0, 1.0 );\n	#endif\n	texColor.rgb *= backgroundIntensity;\n	gl_FragColor = texColor;\n	#include <tonemapping_fragment>\n	#include <colorspace_fragment>\n}",
            cube_vert: "varying vec3 vWorldDirection;\n#include <common>\nvoid main() {\n	vWorldDirection = transformDirection( position, modelMatrix );\n	#include <begin_vertex>\n	#include <project_vertex>\n	gl_Position.z = gl_Position.w;\n}",
            cube_frag: "uniform samplerCube tCube;\nuniform float tFlip;\nuniform float opacity;\nvarying vec3 vWorldDirection;\nvoid main() {\n	vec4 texColor = textureCube( tCube, vec3( tFlip * vWorldDirection.x, vWorldDirection.yz ) );\n	gl_FragColor = texColor;\n	gl_FragColor.a *= opacity;\n	#include <tonemapping_fragment>\n	#include <colorspace_fragment>\n}",
            depth_vert: "#include <common>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvarying vec2 vHighPrecisionZW;\nvoid main() {\n	#include <uv_vertex>\n	#include <skinbase_vertex>\n	#ifdef USE_DISPLACEMENTMAP\n		#include <beginnormal_vertex>\n		#include <morphnormal_vertex>\n		#include <skinnormal_vertex>\n	#endif\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <skinning_vertex>\n	#include <displacementmap_vertex>\n	#include <project_vertex>\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n	vHighPrecisionZW = gl_Position.zw;\n}",
            depth_frag: "#if DEPTH_PACKING == 3200\n	uniform float opacity;\n#endif\n#include <common>\n#include <packing>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvarying vec2 vHighPrecisionZW;\nvoid main() {\n	#include <clipping_planes_fragment>\n	vec4 diffuseColor = vec4( 1.0 );\n	#if DEPTH_PACKING == 3200\n		diffuseColor.a = opacity;\n	#endif\n	#include <map_fragment>\n	#include <alphamap_fragment>\n	#include <alphatest_fragment>\n	#include <alphahash_fragment>\n	#include <logdepthbuf_fragment>\n	float fragCoordZ = 0.5 * vHighPrecisionZW[0] / vHighPrecisionZW[1] + 0.5;\n	#if DEPTH_PACKING == 3200\n		gl_FragColor = vec4( vec3( 1.0 - fragCoordZ ), opacity );\n	#elif DEPTH_PACKING == 3201\n		gl_FragColor = packDepthToRGBA( fragCoordZ );\n	#endif\n}",
            distanceRGBA_vert: "#define DISTANCE\nvarying vec3 vWorldPosition;\n#include <common>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n	#include <uv_vertex>\n	#include <skinbase_vertex>\n	#ifdef USE_DISPLACEMENTMAP\n		#include <beginnormal_vertex>\n		#include <morphnormal_vertex>\n		#include <skinnormal_vertex>\n	#endif\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <skinning_vertex>\n	#include <displacementmap_vertex>\n	#include <project_vertex>\n	#include <worldpos_vertex>\n	#include <clipping_planes_vertex>\n	vWorldPosition = worldPosition.xyz;\n}",
            distanceRGBA_frag: "#define DISTANCE\nuniform vec3 referencePosition;\nuniform float nearDistance;\nuniform float farDistance;\nvarying vec3 vWorldPosition;\n#include <common>\n#include <packing>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main () {\n	#include <clipping_planes_fragment>\n	vec4 diffuseColor = vec4( 1.0 );\n	#include <map_fragment>\n	#include <alphamap_fragment>\n	#include <alphatest_fragment>\n	#include <alphahash_fragment>\n	float dist = length( vWorldPosition - referencePosition );\n	dist = ( dist - nearDistance ) / ( farDistance - nearDistance );\n	dist = saturate( dist );\n	gl_FragColor = packDepthToRGBA( dist );\n}",
            equirect_vert: "varying vec3 vWorldDirection;\n#include <common>\nvoid main() {\n	vWorldDirection = transformDirection( position, modelMatrix );\n	#include <begin_vertex>\n	#include <project_vertex>\n}",
            equirect_frag: "uniform sampler2D tEquirect;\nvarying vec3 vWorldDirection;\n#include <common>\nvoid main() {\n	vec3 direction = normalize( vWorldDirection );\n	vec2 sampleUV = equirectUv( direction );\n	gl_FragColor = texture2D( tEquirect, sampleUV );\n	#include <tonemapping_fragment>\n	#include <colorspace_fragment>\n}",
            linedashed_vert: "uniform float scale;\nattribute float lineDistance;\nvarying float vLineDistance;\n#include <common>\n#include <uv_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n	vLineDistance = scale * lineDistance;\n	#include <uv_vertex>\n	#include <color_vertex>\n	#include <morphcolor_vertex>\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <project_vertex>\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n	#include <fog_vertex>\n}",
            linedashed_frag: "uniform vec3 diffuse;\nuniform float opacity;\nuniform float dashSize;\nuniform float totalSize;\nvarying float vLineDistance;\n#include <common>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <fog_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n	#include <clipping_planes_fragment>\n	if ( mod( vLineDistance, totalSize ) > dashSize ) {\n		discard;\n	}\n	vec3 outgoingLight = vec3( 0.0 );\n	vec4 diffuseColor = vec4( diffuse, opacity );\n	#include <logdepthbuf_fragment>\n	#include <map_fragment>\n	#include <color_fragment>\n	outgoingLight = diffuseColor.rgb;\n	#include <opaque_fragment>\n	#include <tonemapping_fragment>\n	#include <colorspace_fragment>\n	#include <fog_fragment>\n	#include <premultiplied_alpha_fragment>\n}",
            meshbasic_vert: "#include <common>\n#include <uv_pars_vertex>\n#include <envmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n	#include <uv_vertex>\n	#include <color_vertex>\n	#include <morphcolor_vertex>\n	#if defined ( USE_ENVMAP ) || defined ( USE_SKINNING )\n		#include <beginnormal_vertex>\n		#include <morphnormal_vertex>\n		#include <skinbase_vertex>\n		#include <skinnormal_vertex>\n		#include <defaultnormal_vertex>\n	#endif\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <skinning_vertex>\n	#include <project_vertex>\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n	#include <worldpos_vertex>\n	#include <envmap_vertex>\n	#include <fog_vertex>\n}",
            meshbasic_frag: "uniform vec3 diffuse;\nuniform float opacity;\n#ifndef FLAT_SHADED\n	varying vec3 vNormal;\n#endif\n#include <common>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_pars_fragment>\n#include <fog_pars_fragment>\n#include <specularmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n	#include <clipping_planes_fragment>\n	vec4 diffuseColor = vec4( diffuse, opacity );\n	#include <logdepthbuf_fragment>\n	#include <map_fragment>\n	#include <color_fragment>\n	#include <alphamap_fragment>\n	#include <alphatest_fragment>\n	#include <alphahash_fragment>\n	#include <specularmap_fragment>\n	ReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n	#ifdef USE_LIGHTMAP\n		vec4 lightMapTexel = texture2D( lightMap, vLightMapUv );\n		reflectedLight.indirectDiffuse += lightMapTexel.rgb * lightMapIntensity * RECIPROCAL_PI;\n	#else\n		reflectedLight.indirectDiffuse += vec3( 1.0 );\n	#endif\n	#include <aomap_fragment>\n	reflectedLight.indirectDiffuse *= diffuseColor.rgb;\n	vec3 outgoingLight = reflectedLight.indirectDiffuse;\n	#include <envmap_fragment>\n	#include <opaque_fragment>\n	#include <tonemapping_fragment>\n	#include <colorspace_fragment>\n	#include <fog_fragment>\n	#include <premultiplied_alpha_fragment>\n	#include <dithering_fragment>\n}",
            meshlambert_vert: "#define LAMBERT\nvarying vec3 vViewPosition;\n#include <common>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <envmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n	#include <uv_vertex>\n	#include <color_vertex>\n	#include <morphcolor_vertex>\n	#include <beginnormal_vertex>\n	#include <morphnormal_vertex>\n	#include <skinbase_vertex>\n	#include <skinnormal_vertex>\n	#include <defaultnormal_vertex>\n	#include <normal_vertex>\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <skinning_vertex>\n	#include <displacementmap_vertex>\n	#include <project_vertex>\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n	vViewPosition = - mvPosition.xyz;\n	#include <worldpos_vertex>\n	#include <envmap_vertex>\n	#include <shadowmap_vertex>\n	#include <fog_vertex>\n}",
            meshlambert_frag: "#define LAMBERT\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform float opacity;\n#include <common>\n#include <packing>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_pars_fragment>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <normal_pars_fragment>\n#include <lights_lambert_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <specularmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n	#include <clipping_planes_fragment>\n	vec4 diffuseColor = vec4( diffuse, opacity );\n	ReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n	vec3 totalEmissiveRadiance = emissive;\n	#include <logdepthbuf_fragment>\n	#include <map_fragment>\n	#include <color_fragment>\n	#include <alphamap_fragment>\n	#include <alphatest_fragment>\n	#include <alphahash_fragment>\n	#include <specularmap_fragment>\n	#include <normal_fragment_begin>\n	#include <normal_fragment_maps>\n	#include <emissivemap_fragment>\n	#include <lights_lambert_fragment>\n	#include <lights_fragment_begin>\n	#include <lights_fragment_maps>\n	#include <lights_fragment_end>\n	#include <aomap_fragment>\n	vec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + totalEmissiveRadiance;\n	#include <envmap_fragment>\n	#include <opaque_fragment>\n	#include <tonemapping_fragment>\n	#include <colorspace_fragment>\n	#include <fog_fragment>\n	#include <premultiplied_alpha_fragment>\n	#include <dithering_fragment>\n}",
            meshmatcap_vert: "#define MATCAP\nvarying vec3 vViewPosition;\n#include <common>\n#include <uv_pars_vertex>\n#include <color_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n	#include <uv_vertex>\n	#include <color_vertex>\n	#include <morphcolor_vertex>\n	#include <beginnormal_vertex>\n	#include <morphnormal_vertex>\n	#include <skinbase_vertex>\n	#include <skinnormal_vertex>\n	#include <defaultnormal_vertex>\n	#include <normal_vertex>\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <skinning_vertex>\n	#include <displacementmap_vertex>\n	#include <project_vertex>\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n	#include <fog_vertex>\n	vViewPosition = - mvPosition.xyz;\n}",
            meshmatcap_frag: "#define MATCAP\nuniform vec3 diffuse;\nuniform float opacity;\nuniform sampler2D matcap;\nvarying vec3 vViewPosition;\n#include <common>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <fog_pars_fragment>\n#include <normal_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n	#include <clipping_planes_fragment>\n	vec4 diffuseColor = vec4( diffuse, opacity );\n	#include <logdepthbuf_fragment>\n	#include <map_fragment>\n	#include <color_fragment>\n	#include <alphamap_fragment>\n	#include <alphatest_fragment>\n	#include <alphahash_fragment>\n	#include <normal_fragment_begin>\n	#include <normal_fragment_maps>\n	vec3 viewDir = normalize( vViewPosition );\n	vec3 x = normalize( vec3( viewDir.z, 0.0, - viewDir.x ) );\n	vec3 y = cross( viewDir, x );\n	vec2 uv = vec2( dot( x, normal ), dot( y, normal ) ) * 0.495 + 0.5;\n	#ifdef USE_MATCAP\n		vec4 matcapColor = texture2D( matcap, uv );\n	#else\n		vec4 matcapColor = vec4( vec3( mix( 0.2, 0.8, uv.y ) ), 1.0 );\n	#endif\n	vec3 outgoingLight = diffuseColor.rgb * matcapColor.rgb;\n	#include <opaque_fragment>\n	#include <tonemapping_fragment>\n	#include <colorspace_fragment>\n	#include <fog_fragment>\n	#include <premultiplied_alpha_fragment>\n	#include <dithering_fragment>\n}",
            meshnormal_vert: "#define NORMAL\n#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( USE_NORMALMAP_TANGENTSPACE )\n	varying vec3 vViewPosition;\n#endif\n#include <common>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n	#include <uv_vertex>\n	#include <beginnormal_vertex>\n	#include <morphnormal_vertex>\n	#include <skinbase_vertex>\n	#include <skinnormal_vertex>\n	#include <defaultnormal_vertex>\n	#include <normal_vertex>\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <skinning_vertex>\n	#include <displacementmap_vertex>\n	#include <project_vertex>\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( USE_NORMALMAP_TANGENTSPACE )\n	vViewPosition = - mvPosition.xyz;\n#endif\n}",
            meshnormal_frag: "#define NORMAL\nuniform float opacity;\n#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( USE_NORMALMAP_TANGENTSPACE )\n	varying vec3 vViewPosition;\n#endif\n#include <packing>\n#include <uv_pars_fragment>\n#include <normal_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n	#include <clipping_planes_fragment>\n	#include <logdepthbuf_fragment>\n	#include <normal_fragment_begin>\n	#include <normal_fragment_maps>\n	gl_FragColor = vec4( packNormalToRGB( normal ), opacity );\n	#ifdef OPAQUE\n		gl_FragColor.a = 1.0;\n	#endif\n}",
            meshphong_vert: "#define PHONG\nvarying vec3 vViewPosition;\n#include <common>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <envmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n	#include <uv_vertex>\n	#include <color_vertex>\n	#include <morphcolor_vertex>\n	#include <beginnormal_vertex>\n	#include <morphnormal_vertex>\n	#include <skinbase_vertex>\n	#include <skinnormal_vertex>\n	#include <defaultnormal_vertex>\n	#include <normal_vertex>\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <skinning_vertex>\n	#include <displacementmap_vertex>\n	#include <project_vertex>\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n	vViewPosition = - mvPosition.xyz;\n	#include <worldpos_vertex>\n	#include <envmap_vertex>\n	#include <shadowmap_vertex>\n	#include <fog_vertex>\n}",
            meshphong_frag: "#define PHONG\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform vec3 specular;\nuniform float shininess;\nuniform float opacity;\n#include <common>\n#include <packing>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_pars_fragment>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <normal_pars_fragment>\n#include <lights_phong_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <specularmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n	#include <clipping_planes_fragment>\n	vec4 diffuseColor = vec4( diffuse, opacity );\n	ReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n	vec3 totalEmissiveRadiance = emissive;\n	#include <logdepthbuf_fragment>\n	#include <map_fragment>\n	#include <color_fragment>\n	#include <alphamap_fragment>\n	#include <alphatest_fragment>\n	#include <alphahash_fragment>\n	#include <specularmap_fragment>\n	#include <normal_fragment_begin>\n	#include <normal_fragment_maps>\n	#include <emissivemap_fragment>\n	#include <lights_phong_fragment>\n	#include <lights_fragment_begin>\n	#include <lights_fragment_maps>\n	#include <lights_fragment_end>\n	#include <aomap_fragment>\n	vec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + reflectedLight.directSpecular + reflectedLight.indirectSpecular + totalEmissiveRadiance;\n	#include <envmap_fragment>\n	#include <opaque_fragment>\n	#include <tonemapping_fragment>\n	#include <colorspace_fragment>\n	#include <fog_fragment>\n	#include <premultiplied_alpha_fragment>\n	#include <dithering_fragment>\n}",
            meshphysical_vert: "#define STANDARD\nvarying vec3 vViewPosition;\n#ifdef USE_TRANSMISSION\n	varying vec3 vWorldPosition;\n#endif\n#include <common>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n	#include <uv_vertex>\n	#include <color_vertex>\n	#include <morphcolor_vertex>\n	#include <beginnormal_vertex>\n	#include <morphnormal_vertex>\n	#include <skinbase_vertex>\n	#include <skinnormal_vertex>\n	#include <defaultnormal_vertex>\n	#include <normal_vertex>\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <skinning_vertex>\n	#include <displacementmap_vertex>\n	#include <project_vertex>\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n	vViewPosition = - mvPosition.xyz;\n	#include <worldpos_vertex>\n	#include <shadowmap_vertex>\n	#include <fog_vertex>\n#ifdef USE_TRANSMISSION\n	vWorldPosition = worldPosition.xyz;\n#endif\n}",
            meshphysical_frag: "#define STANDARD\n#ifdef PHYSICAL\n	#define IOR\n	#define USE_SPECULAR\n#endif\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform float roughness;\nuniform float metalness;\nuniform float opacity;\n#ifdef IOR\n	uniform float ior;\n#endif\n#ifdef USE_SPECULAR\n	uniform float specularIntensity;\n	uniform vec3 specularColor;\n	#ifdef USE_SPECULAR_COLORMAP\n		uniform sampler2D specularColorMap;\n	#endif\n	#ifdef USE_SPECULAR_INTENSITYMAP\n		uniform sampler2D specularIntensityMap;\n	#endif\n#endif\n#ifdef USE_CLEARCOAT\n	uniform float clearcoat;\n	uniform float clearcoatRoughness;\n#endif\n#ifdef USE_IRIDESCENCE\n	uniform float iridescence;\n	uniform float iridescenceIOR;\n	uniform float iridescenceThicknessMinimum;\n	uniform float iridescenceThicknessMaximum;\n#endif\n#ifdef USE_SHEEN\n	uniform vec3 sheenColor;\n	uniform float sheenRoughness;\n	#ifdef USE_SHEEN_COLORMAP\n		uniform sampler2D sheenColorMap;\n	#endif\n	#ifdef USE_SHEEN_ROUGHNESSMAP\n		uniform sampler2D sheenRoughnessMap;\n	#endif\n#endif\n#ifdef USE_ANISOTROPY\n	uniform vec2 anisotropyVector;\n	#ifdef USE_ANISOTROPYMAP\n		uniform sampler2D anisotropyMap;\n	#endif\n#endif\nvarying vec3 vViewPosition;\n#include <common>\n#include <packing>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <iridescence_fragment>\n#include <cube_uv_reflection_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_physical_pars_fragment>\n#include <fog_pars_fragment>\n#include <lights_pars_begin>\n#include <normal_pars_fragment>\n#include <lights_physical_pars_fragment>\n#include <transmission_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <clearcoat_pars_fragment>\n#include <iridescence_pars_fragment>\n#include <roughnessmap_pars_fragment>\n#include <metalnessmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n	#include <clipping_planes_fragment>\n	vec4 diffuseColor = vec4( diffuse, opacity );\n	ReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n	vec3 totalEmissiveRadiance = emissive;\n	#include <logdepthbuf_fragment>\n	#include <map_fragment>\n	#include <color_fragment>\n	#include <alphamap_fragment>\n	#include <alphatest_fragment>\n	#include <alphahash_fragment>\n	#include <roughnessmap_fragment>\n	#include <metalnessmap_fragment>\n	#include <normal_fragment_begin>\n	#include <normal_fragment_maps>\n	#include <clearcoat_normal_fragment_begin>\n	#include <clearcoat_normal_fragment_maps>\n	#include <emissivemap_fragment>\n	#include <lights_physical_fragment>\n	#include <lights_fragment_begin>\n	#include <lights_fragment_maps>\n	#include <lights_fragment_end>\n	#include <aomap_fragment>\n	vec3 totalDiffuse = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse;\n	vec3 totalSpecular = reflectedLight.directSpecular + reflectedLight.indirectSpecular;\n	#include <transmission_fragment>\n	vec3 outgoingLight = totalDiffuse + totalSpecular + totalEmissiveRadiance;\n	#ifdef USE_SHEEN\n		float sheenEnergyComp = 1.0 - 0.157 * max3( material.sheenColor );\n		outgoingLight = outgoingLight * sheenEnergyComp + sheenSpecularDirect + sheenSpecularIndirect;\n	#endif\n	#ifdef USE_CLEARCOAT\n		float dotNVcc = saturate( dot( geometryClearcoatNormal, geometryViewDir ) );\n		vec3 Fcc = F_Schlick( material.clearcoatF0, material.clearcoatF90, dotNVcc );\n		outgoingLight = outgoingLight * ( 1.0 - material.clearcoat * Fcc ) + ( clearcoatSpecularDirect + clearcoatSpecularIndirect ) * material.clearcoat;\n	#endif\n	#include <opaque_fragment>\n	#include <tonemapping_fragment>\n	#include <colorspace_fragment>\n	#include <fog_fragment>\n	#include <premultiplied_alpha_fragment>\n	#include <dithering_fragment>\n}",
            meshtoon_vert: "#define TOON\nvarying vec3 vViewPosition;\n#include <common>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n	#include <uv_vertex>\n	#include <color_vertex>\n	#include <morphcolor_vertex>\n	#include <beginnormal_vertex>\n	#include <morphnormal_vertex>\n	#include <skinbase_vertex>\n	#include <skinnormal_vertex>\n	#include <defaultnormal_vertex>\n	#include <normal_vertex>\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <skinning_vertex>\n	#include <displacementmap_vertex>\n	#include <project_vertex>\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n	vViewPosition = - mvPosition.xyz;\n	#include <worldpos_vertex>\n	#include <shadowmap_vertex>\n	#include <fog_vertex>\n}",
            meshtoon_frag: "#define TOON\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform float opacity;\n#include <common>\n#include <packing>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <gradientmap_pars_fragment>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <normal_pars_fragment>\n#include <lights_toon_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n	#include <clipping_planes_fragment>\n	vec4 diffuseColor = vec4( diffuse, opacity );\n	ReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n	vec3 totalEmissiveRadiance = emissive;\n	#include <logdepthbuf_fragment>\n	#include <map_fragment>\n	#include <color_fragment>\n	#include <alphamap_fragment>\n	#include <alphatest_fragment>\n	#include <alphahash_fragment>\n	#include <normal_fragment_begin>\n	#include <normal_fragment_maps>\n	#include <emissivemap_fragment>\n	#include <lights_toon_fragment>\n	#include <lights_fragment_begin>\n	#include <lights_fragment_maps>\n	#include <lights_fragment_end>\n	#include <aomap_fragment>\n	vec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + totalEmissiveRadiance;\n	#include <opaque_fragment>\n	#include <tonemapping_fragment>\n	#include <colorspace_fragment>\n	#include <fog_fragment>\n	#include <premultiplied_alpha_fragment>\n	#include <dithering_fragment>\n}",
            points_vert: "uniform float size;\nuniform float scale;\n#include <common>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\n#ifdef USE_POINTS_UV\n	varying vec2 vUv;\n	uniform mat3 uvTransform;\n#endif\nvoid main() {\n	#ifdef USE_POINTS_UV\n		vUv = ( uvTransform * vec3( uv, 1 ) ).xy;\n	#endif\n	#include <color_vertex>\n	#include <morphcolor_vertex>\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <project_vertex>\n	gl_PointSize = size;\n	#ifdef USE_SIZEATTENUATION\n		bool isPerspective = isPerspectiveMatrix( projectionMatrix );\n		if ( isPerspective ) gl_PointSize *= ( scale / - mvPosition.z );\n	#endif\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n	#include <worldpos_vertex>\n	#include <fog_vertex>\n}",
            points_frag: "uniform vec3 diffuse;\nuniform float opacity;\n#include <common>\n#include <color_pars_fragment>\n#include <map_particle_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <fog_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n	#include <clipping_planes_fragment>\n	vec3 outgoingLight = vec3( 0.0 );\n	vec4 diffuseColor = vec4( diffuse, opacity );\n	#include <logdepthbuf_fragment>\n	#include <map_particle_fragment>\n	#include <color_fragment>\n	#include <alphatest_fragment>\n	#include <alphahash_fragment>\n	outgoingLight = diffuseColor.rgb;\n	#include <opaque_fragment>\n	#include <tonemapping_fragment>\n	#include <colorspace_fragment>\n	#include <fog_fragment>\n	#include <premultiplied_alpha_fragment>\n}",
            shadow_vert: "#include <common>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <shadowmap_pars_vertex>\nvoid main() {\n	#include <beginnormal_vertex>\n	#include <morphnormal_vertex>\n	#include <skinbase_vertex>\n	#include <skinnormal_vertex>\n	#include <defaultnormal_vertex>\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <skinning_vertex>\n	#include <project_vertex>\n	#include <logdepthbuf_vertex>\n	#include <worldpos_vertex>\n	#include <shadowmap_vertex>\n	#include <fog_vertex>\n}",
            shadow_frag: "uniform vec3 color;\nuniform float opacity;\n#include <common>\n#include <packing>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <logdepthbuf_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <shadowmask_pars_fragment>\nvoid main() {\n	#include <logdepthbuf_fragment>\n	gl_FragColor = vec4( color, opacity * ( 1.0 - getShadowMask() ) );\n	#include <tonemapping_fragment>\n	#include <colorspace_fragment>\n	#include <fog_fragment>\n}",
            sprite_vert: "uniform float rotation;\nuniform vec2 center;\n#include <common>\n#include <uv_pars_vertex>\n#include <fog_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n	#include <uv_vertex>\n	vec4 mvPosition = modelViewMatrix * vec4( 0.0, 0.0, 0.0, 1.0 );\n	vec2 scale;\n	scale.x = length( vec3( modelMatrix[ 0 ].x, modelMatrix[ 0 ].y, modelMatrix[ 0 ].z ) );\n	scale.y = length( vec3( modelMatrix[ 1 ].x, modelMatrix[ 1 ].y, modelMatrix[ 1 ].z ) );\n	#ifndef USE_SIZEATTENUATION\n		bool isPerspective = isPerspectiveMatrix( projectionMatrix );\n		if ( isPerspective ) scale *= - mvPosition.z;\n	#endif\n	vec2 alignedPosition = ( position.xy - ( center - vec2( 0.5 ) ) ) * scale;\n	vec2 rotatedPosition;\n	rotatedPosition.x = cos( rotation ) * alignedPosition.x - sin( rotation ) * alignedPosition.y;\n	rotatedPosition.y = sin( rotation ) * alignedPosition.x + cos( rotation ) * alignedPosition.y;\n	mvPosition.xy += rotatedPosition;\n	gl_Position = projectionMatrix * mvPosition;\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n	#include <fog_vertex>\n}",
            sprite_frag: "uniform vec3 diffuse;\nuniform float opacity;\n#include <common>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <fog_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n	#include <clipping_planes_fragment>\n	vec3 outgoingLight = vec3( 0.0 );\n	vec4 diffuseColor = vec4( diffuse, opacity );\n	#include <logdepthbuf_fragment>\n	#include <map_fragment>\n	#include <alphamap_fragment>\n	#include <alphatest_fragment>\n	#include <alphahash_fragment>\n	outgoingLight = diffuseColor.rgb;\n	#include <opaque_fragment>\n	#include <tonemapping_fragment>\n	#include <colorspace_fragment>\n	#include <fog_fragment>\n}"
        }, rh = {
            common: {
                diffuse: {
                    value: new kc(16777215)
                },
                opacity: {
                    value: 1
                },
                map: {
                    value: null
                },
                mapTransform: {
                    value: new Ho
                },
                alphaMap: {
                    value: null
                },
                alphaMapTransform: {
                    value: new Ho
                },
                alphaTest: {
                    value: 0
                }
            },
            specularmap: {
                specularMap: {
                    value: null
                },
                specularMapTransform: {
                    value: new Ho
                }
            },
            envmap: {
                envMap: {
                    value: null
                },
                flipEnvMap: {
                    value: -1
                },
                reflectivity: {
                    value: 1
                },
                ior: {
                    value: 1.5
                },
                refractionRatio: {
                    value: .98
                }
            },
            aomap: {
                aoMap: {
                    value: null
                },
                aoMapIntensity: {
                    value: 1
                },
                aoMapTransform: {
                    value: new Ho
                }
            },
            lightmap: {
                lightMap: {
                    value: null
                },
                lightMapIntensity: {
                    value: 1
                },
                lightMapTransform: {
                    value: new Ho
                }
            },
            bumpmap: {
                bumpMap: {
                    value: null
                },
                bumpMapTransform: {
                    value: new Ho
                },
                bumpScale: {
                    value: 1
                }
            },
            normalmap: {
                normalMap: {
                    value: null
                },
                normalMapTransform: {
                    value: new Ho
                },
                normalScale: {
                    value: new Qo(1, 1)
                }
            },
            displacementmap: {
                displacementMap: {
                    value: null
                },
                displacementMapTransform: {
                    value: new Ho
                },
                displacementScale: {
                    value: 1
                },
                displacementBias: {
                    value: 0
                }
            },
            emissivemap: {
                emissiveMap: {
                    value: null
                },
                emissiveMapTransform: {
                    value: new Ho
                }
            },
            metalnessmap: {
                metalnessMap: {
                    value: null
                },
                metalnessMapTransform: {
                    value: new Ho
                }
            },
            roughnessmap: {
                roughnessMap: {
                    value: null
                },
                roughnessMapTransform: {
                    value: new Ho
                }
            },
            gradientmap: {
                gradientMap: {
                    value: null
                }
            },
            fog: {
                fogDensity: {
                    value: 25e-5
                },
                fogNear: {
                    value: 1
                },
                fogFar: {
                    value: 2e3
                },
                fogColor: {
                    value: new kc(16777215)
                }
            },
            lights: {
                ambientLightColor: {
                    value: []
                },
                lightProbe: {
                    value: []
                },
                directionalLights: {
                    value: [],
                    properties: {
                        direction: {},
                        color: {}
                    }
                },
                directionalLightShadows: {
                    value: [],
                    properties: {
                        shadowBias: {},
                        shadowNormalBias: {},
                        shadowRadius: {},
                        shadowMapSize: {}
                    }
                },
                directionalShadowMap: {
                    value: []
                },
                directionalShadowMatrix: {
                    value: []
                },
                spotLights: {
                    value: [],
                    properties: {
                        color: {},
                        position: {},
                        direction: {},
                        distance: {},
                        coneCos: {},
                        penumbraCos: {},
                        decay: {}
                    }
                },
                spotLightShadows: {
                    value: [],
                    properties: {
                        shadowBias: {},
                        shadowNormalBias: {},
                        shadowRadius: {},
                        shadowMapSize: {}
                    }
                },
                spotLightMap: {
                    value: []
                },
                spotShadowMap: {
                    value: []
                },
                spotLightMatrix: {
                    value: []
                },
                pointLights: {
                    value: [],
                    properties: {
                        color: {},
                        position: {},
                        decay: {},
                        distance: {}
                    }
                },
                pointLightShadows: {
                    value: [],
                    properties: {
                        shadowBias: {},
                        shadowNormalBias: {},
                        shadowRadius: {},
                        shadowMapSize: {},
                        shadowCameraNear: {},
                        shadowCameraFar: {}
                    }
                },
                pointShadowMap: {
                    value: []
                },
                pointShadowMatrix: {
                    value: []
                },
                hemisphereLights: {
                    value: [],
                    properties: {
                        direction: {},
                        skyColor: {},
                        groundColor: {}
                    }
                },
                rectAreaLights: {
                    value: [],
                    properties: {
                        color: {},
                        position: {},
                        width: {},
                        height: {}
                    }
                },
                ltc_1: {
                    value: null
                },
                ltc_2: {
                    value: null
                }
            },
            points: {
                diffuse: {
                    value: new kc(16777215)
                },
                opacity: {
                    value: 1
                },
                size: {
                    value: 1
                },
                scale: {
                    value: 1
                },
                map: {
                    value: null
                },
                alphaMap: {
                    value: null
                },
                alphaMapTransform: {
                    value: new Ho
                },
                alphaTest: {
                    value: 0
                },
                uvTransform: {
                    value: new Ho
                }
            },
            sprite: {
                diffuse: {
                    value: new kc(16777215)
                },
                opacity: {
                    value: 1
                },
                center: {
                    value: new Qo(.5, .5)
                },
                rotation: {
                    value: 0
                },
                map: {
                    value: null
                },
                mapTransform: {
                    value: new Ho
                },
                alphaMap: {
                    value: null
                },
                alphaMapTransform: {
                    value: new Ho
                },
                alphaTest: {
                    value: 0
                }
            }
        }, ah = {
            basic: {
                uniforms: Ru([
                    rh.common,
                    rh.specularmap,
                    rh.envmap,
                    rh.aomap,
                    rh.lightmap,
                    rh.fog
                ]),
                vertexShader: nh.meshbasic_vert,
                fragmentShader: nh.meshbasic_frag
            },
            lambert: {
                uniforms: Ru([
                    rh.common,
                    rh.specularmap,
                    rh.envmap,
                    rh.aomap,
                    rh.lightmap,
                    rh.emissivemap,
                    rh.bumpmap,
                    rh.normalmap,
                    rh.displacementmap,
                    rh.fog,
                    rh.lights,
                    {
                        emissive: {
                            value: new kc(0)
                        }
                    }
                ]),
                vertexShader: nh.meshlambert_vert,
                fragmentShader: nh.meshlambert_frag
            },
            phong: {
                uniforms: Ru([
                    rh.common,
                    rh.specularmap,
                    rh.envmap,
                    rh.aomap,
                    rh.lightmap,
                    rh.emissivemap,
                    rh.bumpmap,
                    rh.normalmap,
                    rh.displacementmap,
                    rh.fog,
                    rh.lights,
                    {
                        emissive: {
                            value: new kc(0)
                        },
                        specular: {
                            value: new kc(1118481)
                        },
                        shininess: {
                            value: 30
                        }
                    }
                ]),
                vertexShader: nh.meshphong_vert,
                fragmentShader: nh.meshphong_frag
            },
            standard: {
                uniforms: Ru([
                    rh.common,
                    rh.envmap,
                    rh.aomap,
                    rh.lightmap,
                    rh.emissivemap,
                    rh.bumpmap,
                    rh.normalmap,
                    rh.displacementmap,
                    rh.roughnessmap,
                    rh.metalnessmap,
                    rh.fog,
                    rh.lights,
                    {
                        emissive: {
                            value: new kc(0)
                        },
                        roughness: {
                            value: 1
                        },
                        metalness: {
                            value: 0
                        },
                        envMapIntensity: {
                            value: 1
                        }
                    }
                ]),
                vertexShader: nh.meshphysical_vert,
                fragmentShader: nh.meshphysical_frag
            },
            toon: {
                uniforms: Ru([
                    rh.common,
                    rh.aomap,
                    rh.lightmap,
                    rh.emissivemap,
                    rh.bumpmap,
                    rh.normalmap,
                    rh.displacementmap,
                    rh.gradientmap,
                    rh.fog,
                    rh.lights,
                    {
                        emissive: {
                            value: new kc(0)
                        }
                    }
                ]),
                vertexShader: nh.meshtoon_vert,
                fragmentShader: nh.meshtoon_frag
            },
            matcap: {
                uniforms: Ru([
                    rh.common,
                    rh.bumpmap,
                    rh.normalmap,
                    rh.displacementmap,
                    rh.fog,
                    {
                        matcap: {
                            value: null
                        }
                    }
                ]),
                vertexShader: nh.meshmatcap_vert,
                fragmentShader: nh.meshmatcap_frag
            },
            points: {
                uniforms: Ru([
                    rh.points,
                    rh.fog
                ]),
                vertexShader: nh.points_vert,
                fragmentShader: nh.points_frag
            },
            dashed: {
                uniforms: Ru([
                    rh.common,
                    rh.fog,
                    {
                        scale: {
                            value: 1
                        },
                        dashSize: {
                            value: 1
                        },
                        totalSize: {
                            value: 2
                        }
                    }
                ]),
                vertexShader: nh.linedashed_vert,
                fragmentShader: nh.linedashed_frag
            },
            depth: {
                uniforms: Ru([
                    rh.common,
                    rh.displacementmap
                ]),
                vertexShader: nh.depth_vert,
                fragmentShader: nh.depth_frag
            },
            normal: {
                uniforms: Ru([
                    rh.common,
                    rh.bumpmap,
                    rh.normalmap,
                    rh.displacementmap,
                    {
                        opacity: {
                            value: 1
                        }
                    }
                ]),
                vertexShader: nh.meshnormal_vert,
                fragmentShader: nh.meshnormal_frag
            },
            sprite: {
                uniforms: Ru([
                    rh.sprite,
                    rh.fog
                ]),
                vertexShader: nh.sprite_vert,
                fragmentShader: nh.sprite_frag
            },
            background: {
                uniforms: {
                    uvTransform: {
                        value: new Ho
                    },
                    t2D: {
                        value: null
                    },
                    backgroundIntensity: {
                        value: 1
                    }
                },
                vertexShader: nh.background_vert,
                fragmentShader: nh.background_frag
            },
            backgroundCube: {
                uniforms: {
                    envMap: {
                        value: null
                    },
                    flipEnvMap: {
                        value: -1
                    },
                    backgroundBlurriness: {
                        value: 0
                    },
                    backgroundIntensity: {
                        value: 1
                    }
                },
                vertexShader: nh.backgroundCube_vert,
                fragmentShader: nh.backgroundCube_frag
            },
            cube: {
                uniforms: {
                    tCube: {
                        value: null
                    },
                    tFlip: {
                        value: -1
                    },
                    opacity: {
                        value: 1
                    }
                },
                vertexShader: nh.cube_vert,
                fragmentShader: nh.cube_frag
            },
            equirect: {
                uniforms: {
                    tEquirect: {
                        value: null
                    }
                },
                vertexShader: nh.equirect_vert,
                fragmentShader: nh.equirect_frag
            },
            distanceRGBA: {
                uniforms: Ru([
                    rh.common,
                    rh.displacementmap,
                    {
                        referencePosition: {
                            value: new xl
                        },
                        nearDistance: {
                            value: 1
                        },
                        farDistance: {
                            value: 1e3
                        }
                    }
                ]),
                vertexShader: nh.distanceRGBA_vert,
                fragmentShader: nh.distanceRGBA_frag
            },
            shadow: {
                uniforms: Ru([
                    rh.lights,
                    rh.fog,
                    {
                        color: {
                            value: new kc(0)
                        },
                        opacity: {
                            value: 1
                        }
                    }
                ]),
                vertexShader: nh.shadow_vert,
                fragmentShader: nh.shadow_frag
            }
        };
        ah.physical = {
            uniforms: Ru([
                ah.standard.uniforms,
                {
                    clearcoat: {
                        value: 0
                    },
                    clearcoatMap: {
                        value: null
                    },
                    clearcoatMapTransform: {
                        value: new Ho
                    },
                    clearcoatNormalMap: {
                        value: null
                    },
                    clearcoatNormalMapTransform: {
                        value: new Ho
                    },
                    clearcoatNormalScale: {
                        value: new Qo(1, 1)
                    },
                    clearcoatRoughness: {
                        value: 0
                    },
                    clearcoatRoughnessMap: {
                        value: null
                    },
                    clearcoatRoughnessMapTransform: {
                        value: new Ho
                    },
                    iridescence: {
                        value: 0
                    },
                    iridescenceMap: {
                        value: null
                    },
                    iridescenceMapTransform: {
                        value: new Ho
                    },
                    iridescenceIOR: {
                        value: 1.3
                    },
                    iridescenceThicknessMinimum: {
                        value: 100
                    },
                    iridescenceThicknessMaximum: {
                        value: 400
                    },
                    iridescenceThicknessMap: {
                        value: null
                    },
                    iridescenceThicknessMapTransform: {
                        value: new Ho
                    },
                    sheen: {
                        value: 0
                    },
                    sheenColor: {
                        value: new kc(0)
                    },
                    sheenColorMap: {
                        value: null
                    },
                    sheenColorMapTransform: {
                        value: new Ho
                    },
                    sheenRoughness: {
                        value: 1
                    },
                    sheenRoughnessMap: {
                        value: null
                    },
                    sheenRoughnessMapTransform: {
                        value: new Ho
                    },
                    transmission: {
                        value: 0
                    },
                    transmissionMap: {
                        value: null
                    },
                    transmissionMapTransform: {
                        value: new Ho
                    },
                    transmissionSamplerSize: {
                        value: new Qo
                    },
                    transmissionSamplerMap: {
                        value: null
                    },
                    thickness: {
                        value: 0
                    },
                    thicknessMap: {
                        value: null
                    },
                    thicknessMapTransform: {
                        value: new Ho
                    },
                    attenuationDistance: {
                        value: 0
                    },
                    attenuationColor: {
                        value: new kc(0)
                    },
                    specularColor: {
                        value: new kc(1, 1, 1)
                    },
                    specularColorMap: {
                        value: null
                    },
                    specularColorMapTransform: {
                        value: new Ho
                    },
                    specularIntensity: {
                        value: 1
                    },
                    specularIntensityMap: {
                        value: null
                    },
                    specularIntensityMapTransform: {
                        value: new Ho
                    },
                    anisotropyVector: {
                        value: new Qo
                    },
                    anisotropyMap: {
                        value: null
                    },
                    anisotropyMapTransform: {
                        value: new Ho
                    }
                }
            ]),
            vertexShader: nh.meshphysical_vert,
            fragmentShader: nh.meshphysical_frag
        };
        const sh = {
            r: 0,
            b: 0,
            g: 0
        };
        function oh(t1, e, i, n, r, a, s) {
            const o = new kc(0);
            let l, c, u = !0 === a ? 0 : 1, h = null, d = 0, p = null;
            function f(e, i) {
                e.getRGB(sh, Uu(t1)), n.buffers.color.setClear(sh.r, sh.g, sh.b, i, s);
            }
            return {
                getClearColor: function() {
                    return o;
                },
                setClearColor: function(t1, e = 1) {
                    o.set(t1), u = e, f(o, u);
                },
                getClearAlpha: function() {
                    return u;
                },
                setClearAlpha: function(t1) {
                    u = t1, f(o, u);
                },
                render: function(a, A) {
                    let g = !1, m = !0 === A.isScene ? A.background : null;
                    m && m.isTexture && (m = (A.backgroundBlurriness > 0 ? i : e).get(m)), null === m ? f(o, u) : m && m.isColor && (f(m, 1), g = !0);
                    const M = t1.xr.getEnvironmentBlendMode();
                    "additive" === M ? n.buffers.color.setClear(0, 0, 0, 1, s) : "alpha-blend" === M && n.buffers.color.setClear(0, 0, 0, 0, s), (t1.autoClear || g) && t1.clear(t1.autoClearColor, t1.autoClearDepth, t1.autoClearStencil), m && (m.isCubeTexture || m.mapping === $r) ? (void 0 === c && (c = new Ou(new ju(1, 1, 1), new Bu({
                        name: "BackgroundCubeMaterial",
                        uniforms: Pu(ah.backgroundCube.uniforms),
                        vertexShader: ah.backgroundCube.vertexShader,
                        fragmentShader: ah.backgroundCube.fragmentShader,
                        side: tr,
                        depthTest: !1,
                        depthWrite: !1,
                        fog: !1
                    })), c.geometry.deleteAttribute("normal"), c.geometry.deleteAttribute("uv"), c.onBeforeRender = function(t1, e, i) {
                        this.matrixWorld.copyPosition(i.matrixWorld);
                    }, Object.defineProperty(c.material, "envMap", {
                        get: function() {
                            return this.uniforms.envMap.value;
                        }
                    }), r.update(c)), c.material.uniforms.envMap.value = m, c.material.uniforms.flipEnvMap.value = m.isCubeTexture && !1 === m.isRenderTargetTexture ? -1 : 1, c.material.uniforms.backgroundBlurriness.value = A.backgroundBlurriness, c.material.uniforms.backgroundIntensity.value = A.backgroundIntensity, c.material.toneMapped = il.getTransfer(m.colorSpace) !== ks, h === m && d === m.version && p === t1.toneMapping || (c.material.needsUpdate = !0, h = m, d = m.version, p = t1.toneMapping), c.layers.enableAll(), a.unshift(c, c.geometry, c.material, 0, 0, null)) : m && m.isTexture && (void 0 === l && (l = new Ou(new ih(2, 2), new Bu({
                        name: "BackgroundMaterial",
                        uniforms: Pu(ah.background.uniforms),
                        vertexShader: ah.background.vertexShader,
                        fragmentShader: ah.background.fragmentShader,
                        side: $n,
                        depthTest: !1,
                        depthWrite: !1,
                        fog: !1
                    })), l.geometry.deleteAttribute("normal"), Object.defineProperty(l.material, "map", {
                        get: function() {
                            return this.uniforms.t2D.value;
                        }
                    }), r.update(l)), l.material.uniforms.t2D.value = m, l.material.uniforms.backgroundIntensity.value = A.backgroundIntensity, l.material.toneMapped = il.getTransfer(m.colorSpace) !== ks, !0 === m.matrixAutoUpdate && m.updateMatrix(), l.material.uniforms.uvTransform.value.copy(m.matrix), h === m && d === m.version && p === t1.toneMapping || (l.material.needsUpdate = !0, h = m, d = m.version, p = t1.toneMapping), l.layers.enableAll(), a.unshift(l, l.geometry, l.material, 0, 0, null));
                }
            };
        }
        function lh(t1, e, i, n) {
            const r = t1.getParameter(t1.MAX_VERTEX_ATTRIBS), a = n.isWebGL2 ? null : e.get("OES_vertex_array_object"), s = n.isWebGL2 || null !== a, o = {}, l = p(null);
            let c = l, u = !1;
            function h(e) {
                return n.isWebGL2 ? t1.bindVertexArray(e) : a.bindVertexArrayOES(e);
            }
            function d(e) {
                return n.isWebGL2 ? t1.deleteVertexArray(e) : a.deleteVertexArrayOES(e);
            }
            function p(t1) {
                const e = [], i = [], n = [];
                for(let t1 = 0; t1 < r; t1++)e[t1] = 0, i[t1] = 0, n[t1] = 0;
                return {
                    geometry: null,
                    program: null,
                    wireframe: !1,
                    newAttributes: e,
                    enabledAttributes: i,
                    attributeDivisors: n,
                    object: t1,
                    attributes: {},
                    index: null
                };
            }
            function f() {
                const t1 = c.newAttributes;
                for(let e = 0, i = t1.length; e < i; e++)t1[e] = 0;
            }
            function A(t1) {
                g(t1, 0);
            }
            function g(i, r) {
                const a = c.newAttributes, s = c.enabledAttributes, o = c.attributeDivisors;
                a[i] = 1, 0 === s[i] && (t1.enableVertexAttribArray(i), s[i] = 1), o[i] !== r && ((n.isWebGL2 ? t1 : e.get("ANGLE_instanced_arrays"))[n.isWebGL2 ? "vertexAttribDivisor" : "vertexAttribDivisorANGLE"](i, r), o[i] = r);
            }
            function m() {
                const e = c.newAttributes, i = c.enabledAttributes;
                for(let n = 0, r = i.length; n < r; n++)i[n] !== e[n] && (t1.disableVertexAttribArray(n), i[n] = 0);
            }
            function M(e, i, n, r, a, s, o) {
                !0 === o ? t1.vertexAttribIPointer(e, i, n, a, s) : t1.vertexAttribPointer(e, i, n, r, a, s);
            }
            function y() {
                v(), u = !0, c !== l && (c = l, h(c.object));
            }
            function v() {
                l.geometry = null, l.program = null, l.wireframe = !1;
            }
            return {
                setup: function(r, l, d, y, v) {
                    let x = !1;
                    if (s) {
                        const e = function(e, i, r) {
                            const s = !0 === r.wireframe;
                            let l = o[e.id];
                            void 0 === l && (l = {}, o[e.id] = l);
                            let c = l[i.id];
                            void 0 === c && (c = {}, l[i.id] = c);
                            let u = c[s];
                            return void 0 === u && (u = p(n.isWebGL2 ? t1.createVertexArray() : a.createVertexArrayOES()), c[s] = u), u;
                        }(y, d, l);
                        c !== e && (c = e, h(c.object)), x = function(t1, e, i, n) {
                            const r = c.attributes, a = e.attributes;
                            let s = 0;
                            const o = i.getAttributes();
                            for(const e in o)if (o[e].location >= 0) {
                                const i = r[e];
                                let n = a[e];
                                if (void 0 === n && ("instanceMatrix" === e && t1.instanceMatrix && (n = t1.instanceMatrix), "instanceColor" === e && t1.instanceColor && (n = t1.instanceColor)), void 0 === i) return !0;
                                if (i.attribute !== n) return !0;
                                if (n && i.data !== n.data) return !0;
                                s++;
                            }
                            return c.attributesNum !== s || c.index !== n;
                        }(r, y, d, v), x && function(t1, e, i, n) {
                            const r = {}, a = e.attributes;
                            let s = 0;
                            const o = i.getAttributes();
                            for(const e in o)if (o[e].location >= 0) {
                                let i = a[e];
                                void 0 === i && ("instanceMatrix" === e && t1.instanceMatrix && (i = t1.instanceMatrix), "instanceColor" === e && t1.instanceColor && (i = t1.instanceColor));
                                const n = {};
                                n.attribute = i, i && i.data && (n.data = i.data), r[e] = n, s++;
                            }
                            c.attributes = r, c.attributesNum = s, c.index = n;
                        }(r, y, d, v);
                    } else {
                        const t1 = !0 === l.wireframe;
                        c.geometry === y.id && c.program === d.id && c.wireframe === t1 || (c.geometry = y.id, c.program = d.id, c.wireframe = t1, x = !0);
                    }
                    null !== v && i.update(v, t1.ELEMENT_ARRAY_BUFFER), (x || u) && (u = !1, function(r, a, s, o) {
                        if (!1 === n.isWebGL2 && (r.isInstancedMesh || o.isInstancedBufferGeometry) && null === e.get("ANGLE_instanced_arrays")) return;
                        f();
                        const l = o.attributes, c = s.getAttributes(), u = a.defaultAttributeValues;
                        for(const e in c){
                            const a = c[e];
                            if (a.location >= 0) {
                                let s = l[e];
                                if (void 0 === s && ("instanceMatrix" === e && r.instanceMatrix && (s = r.instanceMatrix), "instanceColor" === e && r.instanceColor && (s = r.instanceColor)), void 0 !== s) {
                                    const e = s.normalized, l = s.itemSize, c = i.get(s);
                                    if (void 0 === c) continue;
                                    const u = c.buffer, h = c.type, d = c.bytesPerElement, p = !0 === n.isWebGL2 && (h === t1.INT || h === t1.UNSIGNED_INT || s.gpuType === ma);
                                    if (s.isInterleavedBufferAttribute) {
                                        const i = s.data, n = i.stride, c = s.offset;
                                        if (i.isInstancedInterleavedBuffer) {
                                            for(let t1 = 0; t1 < a.locationSize; t1++)g(a.location + t1, i.meshPerAttribute);
                                            !0 !== r.isInstancedMesh && void 0 === o._maxInstanceCount && (o._maxInstanceCount = i.meshPerAttribute * i.count);
                                        } else for(let t1 = 0; t1 < a.locationSize; t1++)A(a.location + t1);
                                        t1.bindBuffer(t1.ARRAY_BUFFER, u);
                                        for(let t1 = 0; t1 < a.locationSize; t1++)M(a.location + t1, l / a.locationSize, h, e, n * d, (c + l / a.locationSize * t1) * d, p);
                                    } else {
                                        if (s.isInstancedBufferAttribute) {
                                            for(let t1 = 0; t1 < a.locationSize; t1++)g(a.location + t1, s.meshPerAttribute);
                                            !0 !== r.isInstancedMesh && void 0 === o._maxInstanceCount && (o._maxInstanceCount = s.meshPerAttribute * s.count);
                                        } else for(let t1 = 0; t1 < a.locationSize; t1++)A(a.location + t1);
                                        t1.bindBuffer(t1.ARRAY_BUFFER, u);
                                        for(let t1 = 0; t1 < a.locationSize; t1++)M(a.location + t1, l / a.locationSize, h, e, l * d, l / a.locationSize * t1 * d, p);
                                    }
                                } else if (void 0 !== u) {
                                    const i = u[e];
                                    if (void 0 !== i) switch(i.length){
                                        case 2:
                                            t1.vertexAttrib2fv(a.location, i);
                                            break;
                                        case 3:
                                            t1.vertexAttrib3fv(a.location, i);
                                            break;
                                        case 4:
                                            t1.vertexAttrib4fv(a.location, i);
                                            break;
                                        default:
                                            t1.vertexAttrib1fv(a.location, i);
                                    }
                                }
                            }
                        }
                        m();
                    }(r, l, d, y), null !== v && t1.bindBuffer(t1.ELEMENT_ARRAY_BUFFER, i.get(v).buffer));
                },
                reset: y,
                resetDefaultState: v,
                dispose: function() {
                    y();
                    for(const t1 in o){
                        const e = o[t1];
                        for(const t1 in e){
                            const i = e[t1];
                            for(const t1 in i)d(i[t1].object), delete i[t1];
                            delete e[t1];
                        }
                        delete o[t1];
                    }
                },
                releaseStatesOfGeometry: function(t1) {
                    if (void 0 === o[t1.id]) return;
                    const e = o[t1.id];
                    for(const t1 in e){
                        const i = e[t1];
                        for(const t1 in i)d(i[t1].object), delete i[t1];
                        delete e[t1];
                    }
                    delete o[t1.id];
                },
                releaseStatesOfProgram: function(t1) {
                    for(const e in o){
                        const i = o[e];
                        if (void 0 === i[t1.id]) continue;
                        const n = i[t1.id];
                        for(const t1 in n)d(n[t1].object), delete n[t1];
                        delete i[t1.id];
                    }
                },
                initAttributes: f,
                enableAttribute: A,
                disableUnusedAttributes: m
            };
        }
        function ch(t1, e, i, n) {
            const r = n.isWebGL2;
            let a;
            this.setMode = function(t1) {
                a = t1;
            }, this.render = function(e, n) {
                t1.drawArrays(a, e, n), i.update(n, a, 1);
            }, this.renderInstances = function(n, s, o) {
                if (0 === o) return;
                let l, c;
                if (r) l = t1, c = "drawArraysInstanced";
                else if (l = e.get("ANGLE_instanced_arrays"), c = "drawArraysInstancedANGLE", null === l) return void console.error("THREE.WebGLBufferRenderer: using THREE.InstancedBufferGeometry but hardware does not support extension ANGLE_instanced_arrays.");
                l[c](a, n, s, o), i.update(s, a, o);
            };
        }
        function uh(t1, e, i) {
            let n;
            function r(e) {
                if ("highp" === e) {
                    if (t1.getShaderPrecisionFormat(t1.VERTEX_SHADER, t1.HIGH_FLOAT).precision > 0 && t1.getShaderPrecisionFormat(t1.FRAGMENT_SHADER, t1.HIGH_FLOAT).precision > 0) return "highp";
                    e = "mediump";
                }
                return "mediump" === e && t1.getShaderPrecisionFormat(t1.VERTEX_SHADER, t1.MEDIUM_FLOAT).precision > 0 && t1.getShaderPrecisionFormat(t1.FRAGMENT_SHADER, t1.MEDIUM_FLOAT).precision > 0 ? "mediump" : "lowp";
            }
            const a = "undefined" != typeof WebGL2RenderingContext && "WebGL2RenderingContext" === t1.constructor.name;
            let s = void 0 !== i.precision ? i.precision : "highp";
            const o = r(s);
            o !== s && (console.warn("THREE.WebGLRenderer:", s, "not supported, using", o, "instead."), s = o);
            const l = a || e.has("WEBGL_draw_buffers"), c = !0 === i.logarithmicDepthBuffer, u = t1.getParameter(t1.MAX_TEXTURE_IMAGE_UNITS), h = t1.getParameter(t1.MAX_VERTEX_TEXTURE_IMAGE_UNITS), d = t1.getParameter(t1.MAX_TEXTURE_SIZE), p = t1.getParameter(t1.MAX_CUBE_MAP_TEXTURE_SIZE), f = t1.getParameter(t1.MAX_VERTEX_ATTRIBS), A = t1.getParameter(t1.MAX_VERTEX_UNIFORM_VECTORS), g = t1.getParameter(t1.MAX_VARYING_VECTORS), m = t1.getParameter(t1.MAX_FRAGMENT_UNIFORM_VECTORS), M = h > 0, y = a || e.has("OES_texture_float");
            return {
                isWebGL2: a,
                drawBuffers: l,
                getMaxAnisotropy: function() {
                    if (void 0 !== n) return n;
                    if (!0 === e.has("EXT_texture_filter_anisotropic")) {
                        const i = e.get("EXT_texture_filter_anisotropic");
                        n = t1.getParameter(i.MAX_TEXTURE_MAX_ANISOTROPY_EXT);
                    } else n = 0;
                    return n;
                },
                getMaxPrecision: r,
                precision: s,
                logarithmicDepthBuffer: c,
                maxTextures: u,
                maxVertexTextures: h,
                maxTextureSize: d,
                maxCubemapSize: p,
                maxAttributes: f,
                maxVertexUniforms: A,
                maxVaryings: g,
                maxFragmentUniforms: m,
                vertexTextures: M,
                floatFragmentTextures: y,
                floatVertexTextures: M && y,
                maxSamples: a ? t1.getParameter(t1.MAX_SAMPLES) : 0
            };
        }
        function hh(t1) {
            const e = this;
            let i = null, n = 0, r = !1, a = !1;
            const s = new Ju, o = new Ho, l = {
                value: null,
                needsUpdate: !1
            };
            function c(t1, i, n, r) {
                const a = null !== t1 ? t1.length : 0;
                let c = null;
                if (0 !== a) {
                    if (c = l.value, !0 !== r || null === c) {
                        const e = n + 4 * a, r = i.matrixWorldInverse;
                        o.getNormalMatrix(r), (null === c || c.length < e) && (c = new Float32Array(e));
                        for(let e = 0, i = n; e !== a; ++e, i += 4)s.copy(t1[e]).applyMatrix4(r, o), s.normal.toArray(c, i), c[i + 3] = s.constant;
                    }
                    l.value = c, l.needsUpdate = !0;
                }
                return e.numPlanes = a, e.numIntersection = 0, c;
            }
            this.uniform = l, this.numPlanes = 0, this.numIntersection = 0, this.init = function(t1, e) {
                const i = 0 !== t1.length || e || 0 !== n || r;
                return r = e, n = t1.length, i;
            }, this.beginShadows = function() {
                a = !0, c(null);
            }, this.endShadows = function() {
                a = !1;
            }, this.setGlobalState = function(t1, e) {
                i = c(t1, e, 0);
            }, this.setState = function(s, o, u) {
                const h = s.clippingPlanes, d = s.clipIntersection, p = s.clipShadows, f = t1.get(s);
                if (!r || null === h || 0 === h.length || a && !p) a ? c(null) : (l.value !== i && (l.value = i, l.needsUpdate = n > 0), e.numPlanes = n, e.numIntersection = 0);
                else {
                    const t1 = a ? 0 : n, e = 4 * t1;
                    let r = f.clippingState || null;
                    l.value = r, r = c(h, o, e, u);
                    for(let t1 = 0; t1 !== e; ++t1)r[t1] = i[t1];
                    f.clippingState = r, this.numIntersection = d ? this.numPlanes : 0, this.numPlanes += t1;
                }
            };
        }
        function dh(t1) {
            let e = new WeakMap;
            function i(t1, e) {
                return e === Kr ? t1.mapping = Zr : e === qr && (t1.mapping = Jr), t1;
            }
            function n(t1) {
                const i = t1.target;
                i.removeEventListener("dispose", n);
                const r = e.get(i);
                void 0 !== r && (e.delete(i), r.dispose());
            }
            return {
                get: function(r) {
                    if (r && r.isTexture && !1 === r.isRenderTargetTexture) {
                        const a = r.mapping;
                        if (a === Kr || a === qr) {
                            if (e.has(r)) return i(e.get(r).texture, r.mapping);
                            {
                                const a = r.image;
                                if (a && a.height > 0) {
                                    const s = new Yu(a.height / 2);
                                    return s.fromEquirectangularTexture(t1, r), e.set(r, s), r.addEventListener("dispose", n), i(s.texture, r.mapping);
                                }
                                return null;
                            }
                        }
                    }
                    return r;
                },
                dispose: function() {
                    e = new WeakMap;
                }
            };
        }
        class ph extends Fu {
            constructor(t1 = -1, e = 1, i = 1, n = -1, r = .1, a = 2e3){
                super(), this.isOrthographicCamera = !0, this.type = "OrthographicCamera", this.zoom = 1, this.view = null, this.left = t1, this.right = e, this.top = i, this.bottom = n, this.near = r, this.far = a, this.updateProjectionMatrix();
            }
            copy(t1, e) {
                return super.copy(t1, e), this.left = t1.left, this.right = t1.right, this.top = t1.top, this.bottom = t1.bottom, this.near = t1.near, this.far = t1.far, this.zoom = t1.zoom, this.view = null === t1.view ? null : Object.assign({}, t1.view), this;
            }
            setViewOffset(t1, e, i, n, r, a) {
                null === this.view && (this.view = {
                    enabled: !0,
                    fullWidth: 1,
                    fullHeight: 1,
                    offsetX: 0,
                    offsetY: 0,
                    width: 1,
                    height: 1
                }), this.view.enabled = !0, this.view.fullWidth = t1, this.view.fullHeight = e, this.view.offsetX = i, this.view.offsetY = n, this.view.width = r, this.view.height = a, this.updateProjectionMatrix();
            }
            clearViewOffset() {
                null !== this.view && (this.view.enabled = !1), this.updateProjectionMatrix();
            }
            updateProjectionMatrix() {
                const t1 = (this.right - this.left) / (2 * this.zoom), e = (this.top - this.bottom) / (2 * this.zoom), i = (this.right + this.left) / 2, n = (this.top + this.bottom) / 2;
                let r = i - t1, a = i + t1, s = n + e, o = n - e;
                if (null !== this.view && this.view.enabled) {
                    const t1 = (this.right - this.left) / this.view.fullWidth / this.zoom, e = (this.top - this.bottom) / this.view.fullHeight / this.zoom;
                    r += t1 * this.view.offsetX, a = r + t1 * this.view.width, s -= e * this.view.offsetY, o = s - e * this.view.height;
                }
                this.projectionMatrix.makeOrthographic(r, a, s, o, this.near, this.far, this.coordinateSystem), this.projectionMatrixInverse.copy(this.projectionMatrix).invert();
            }
            toJSON(t1) {
                const e = super.toJSON(t1);
                return e.object.zoom = this.zoom, e.object.left = this.left, e.object.right = this.right, e.object.top = this.top, e.object.bottom = this.bottom, e.object.near = this.near, e.object.far = this.far, null !== this.view && (e.object.view = Object.assign({}, this.view)), e;
            }
        }
        const fh = [
            .125,
            .215,
            .35,
            .446,
            .526,
            .582
        ], Ah = new ph, gh = new kc;
        let mh = null, Mh = 0, yh = 0;
        const vh = (1 + Math.sqrt(5)) / 2, xh = 1 / vh, wh = [
            new xl(1, 1, 1),
            new xl(-1, 1, 1),
            new xl(1, 1, -1),
            new xl(-1, 1, -1),
            new xl(0, vh, xh),
            new xl(0, vh, -xh),
            new xl(xh, 0, vh),
            new xl(-xh, 0, vh),
            new xl(vh, xh, 0),
            new xl(-vh, xh, 0)
        ];
        class bh {
            constructor(t1){
                this._renderer = t1, this._pingPongRenderTarget = null, this._lodMax = 0, this._cubeSize = 0, this._lodPlanes = [], this._sizeLods = [], this._sigmas = [], this._blurMaterial = null, this._cubemapMaterial = null, this._equirectMaterial = null, this._compileMaterial(this._blurMaterial);
            }
            fromScene(t1, e = 0, i = .1, n = 100) {
                mh = this._renderer.getRenderTarget(), Mh = this._renderer.getActiveCubeFace(), yh = this._renderer.getActiveMipmapLevel(), this._setSize(256);
                const r = this._allocateTargets();
                return r.depthBuffer = !0, this._sceneToCubeUV(t1, i, n, r), e > 0 && this._blur(r, 0, 0, e), this._applyPMREM(r), this._cleanup(r), r;
            }
            fromEquirectangular(t1, e = null) {
                return this._fromTexture(t1, e);
            }
            fromCubemap(t1, e = null) {
                return this._fromTexture(t1, e);
            }
            compileCubemapShader() {
                null === this._cubemapMaterial && (this._cubemapMaterial = Sh(), this._compileMaterial(this._cubemapMaterial));
            }
            compileEquirectangularShader() {
                null === this._equirectMaterial && (this._equirectMaterial = Ih(), this._compileMaterial(this._equirectMaterial));
            }
            dispose() {
                this._dispose(), null !== this._cubemapMaterial && this._cubemapMaterial.dispose(), null !== this._equirectMaterial && this._equirectMaterial.dispose();
            }
            _setSize(t1) {
                this._lodMax = Math.floor(Math.log2(t1)), this._cubeSize = Math.pow(2, this._lodMax);
            }
            _dispose() {
                null !== this._blurMaterial && this._blurMaterial.dispose(), null !== this._pingPongRenderTarget && this._pingPongRenderTarget.dispose();
                for(let t1 = 0; t1 < this._lodPlanes.length; t1++)this._lodPlanes[t1].dispose();
            }
            _cleanup(t1) {
                this._renderer.setRenderTarget(mh, Mh, yh), t1.scissorTest = !1, Eh(t1, 0, 0, t1.width, t1.height);
            }
            _fromTexture(t1, e) {
                t1.mapping === Zr || t1.mapping === Jr ? this._setSize(0 === t1.image.length ? 16 : t1.image[0].width || t1.image[0].image.width) : this._setSize(t1.image.width / 4), mh = this._renderer.getRenderTarget(), Mh = this._renderer.getActiveCubeFace(), yh = this._renderer.getActiveMipmapLevel();
                const i = e || this._allocateTargets();
                return this._textureToCubeUV(t1, i), this._applyPMREM(i), this._cleanup(i), i;
            }
            _allocateTargets() {
                const t1 = 3 * Math.max(this._cubeSize, 112), e = 4 * this._cubeSize, i = {
                    magFilter: la,
                    minFilter: la,
                    generateMipmaps: !1,
                    type: va,
                    format: Ea,
                    colorSpace: js,
                    depthBuffer: !1
                }, n = Th(t1, e, i);
                if (null === this._pingPongRenderTarget || this._pingPongRenderTarget.width !== t1 || this._pingPongRenderTarget.height !== e) {
                    null !== this._pingPongRenderTarget && this._dispose(), this._pingPongRenderTarget = Th(t1, e, i);
                    const { _lodMax: n } = this;
                    ({ sizeLods: this._sizeLods, lodPlanes: this._lodPlanes, sigmas: this._sigmas } = function(t1) {
                        const e = [], i = [], n = [];
                        let r = t1;
                        const a = t1 - 4 + 1 + fh.length;
                        for(let s = 0; s < a; s++){
                            const a = Math.pow(2, r);
                            i.push(a);
                            let o = 1 / a;
                            s > t1 - 4 ? o = fh[s - t1 + 4 - 1] : 0 === s && (o = 0), n.push(o);
                            const l = 1 / (a - 2), c = -l, u = 1 + l, h = [
                                c,
                                c,
                                u,
                                c,
                                u,
                                u,
                                c,
                                c,
                                u,
                                u,
                                c,
                                u
                            ], d = 6, p = 6, f = 3, A = 2, g = 1, m = new Float32Array(f * p * d), M = new Float32Array(A * p * d), y = new Float32Array(g * p * d);
                            for(let t1 = 0; t1 < d; t1++){
                                const e = t1 % 3 * 2 / 3 - 1, i = t1 > 2 ? 0 : -1, n = [
                                    e,
                                    i,
                                    0,
                                    e + 2 / 3,
                                    i,
                                    0,
                                    e + 2 / 3,
                                    i + 1,
                                    0,
                                    e,
                                    i,
                                    0,
                                    e + 2 / 3,
                                    i + 1,
                                    0,
                                    e,
                                    i + 1,
                                    0
                                ];
                                m.set(n, f * p * t1), M.set(h, A * p * t1);
                                const r = [
                                    t1,
                                    t1,
                                    t1,
                                    t1,
                                    t1,
                                    t1
                                ];
                                y.set(r, g * p * t1);
                            }
                            const v = new Au;
                            v.setAttribute("position", new Kc(m, f)), v.setAttribute("uv", new Kc(M, A)), v.setAttribute("faceIndex", new Kc(y, g)), e.push(v), r > 4 && r--;
                        }
                        return {
                            lodPlanes: e,
                            sizeLods: i,
                            sigmas: n
                        };
                    }(n)), this._blurMaterial = function(t1, e, i) {
                        const n = new Float32Array(20), r = new xl(0, 1, 0);
                        return new Bu({
                            name: "SphericalGaussianBlur",
                            defines: {
                                n: 20,
                                CUBEUV_TEXEL_WIDTH: 1 / e,
                                CUBEUV_TEXEL_HEIGHT: 1 / i,
                                CUBEUV_MAX_MIP: `${t1}.0`
                            },
                            uniforms: {
                                envMap: {
                                    value: null
                                },
                                samples: {
                                    value: 1
                                },
                                weights: {
                                    value: n
                                },
                                latitudinal: {
                                    value: !1
                                },
                                dTheta: {
                                    value: 0
                                },
                                mipInt: {
                                    value: 0
                                },
                                poleAxis: {
                                    value: r
                                }
                            },
                            vertexShader: "\n\n		precision mediump float;\n		precision mediump int;\n\n		attribute float faceIndex;\n\n		varying vec3 vOutputDirection;\n\n		// RH coordinate system; PMREM face-indexing convention\n		vec3 getDirection( vec2 uv, float face ) {\n\n			uv = 2.0 * uv - 1.0;\n\n			vec3 direction = vec3( uv, 1.0 );\n\n			if ( face == 0.0 ) {\n\n				direction = direction.zyx; // ( 1, v, u ) pos x\n\n			} else if ( face == 1.0 ) {\n\n				direction = direction.xzy;\n				direction.xz *= -1.0; // ( -u, 1, -v ) pos y\n\n			} else if ( face == 2.0 ) {\n\n				direction.x *= -1.0; // ( -u, v, 1 ) pos z\n\n			} else if ( face == 3.0 ) {\n\n				direction = direction.zyx;\n				direction.xz *= -1.0; // ( -1, v, -u ) neg x\n\n			} else if ( face == 4.0 ) {\n\n				direction = direction.xzy;\n				direction.xy *= -1.0; // ( -u, -1, v ) neg y\n\n			} else if ( face == 5.0 ) {\n\n				direction.z *= -1.0; // ( u, v, -1 ) neg z\n\n			}\n\n			return direction;\n\n		}\n\n		void main() {\n\n			vOutputDirection = getDirection( uv, faceIndex );\n			gl_Position = vec4( position, 1.0 );\n\n		}\n	",
                            fragmentShader: "\n\n			precision mediump float;\n			precision mediump int;\n\n			varying vec3 vOutputDirection;\n\n			uniform sampler2D envMap;\n			uniform int samples;\n			uniform float weights[ n ];\n			uniform bool latitudinal;\n			uniform float dTheta;\n			uniform float mipInt;\n			uniform vec3 poleAxis;\n\n			#define ENVMAP_TYPE_CUBE_UV\n			#include <cube_uv_reflection_fragment>\n\n			vec3 getSample( float theta, vec3 axis ) {\n\n				float cosTheta = cos( theta );\n				// Rodrigues' axis-angle rotation\n				vec3 sampleDirection = vOutputDirection * cosTheta\n					+ cross( axis, vOutputDirection ) * sin( theta )\n					+ axis * dot( axis, vOutputDirection ) * ( 1.0 - cosTheta );\n\n				return bilinearCubeUV( envMap, sampleDirection, mipInt );\n\n			}\n\n			void main() {\n\n				vec3 axis = latitudinal ? poleAxis : cross( poleAxis, vOutputDirection );\n\n				if ( all( equal( axis, vec3( 0.0 ) ) ) ) {\n\n					axis = vec3( vOutputDirection.z, 0.0, - vOutputDirection.x );\n\n				}\n\n				axis = normalize( axis );\n\n				gl_FragColor = vec4( 0.0, 0.0, 0.0, 1.0 );\n				gl_FragColor.rgb += weights[ 0 ] * getSample( 0.0, axis );\n\n				for ( int i = 1; i < n; i++ ) {\n\n					if ( i >= samples ) {\n\n						break;\n\n					}\n\n					float theta = dTheta * float( i );\n					gl_FragColor.rgb += weights[ i ] * getSample( -1.0 * theta, axis );\n					gl_FragColor.rgb += weights[ i ] * getSample( theta, axis );\n\n				}\n\n			}\n		",
                            blending: nr,
                            depthTest: !1,
                            depthWrite: !1
                        });
                    }(n, t1, e);
                }
                return n;
            }
            _compileMaterial(t1) {
                const e = new Ou(this._lodPlanes[0], t1);
                this._renderer.compile(e, Ah);
            }
            _sceneToCubeUV(t1, e, i, n) {
                const r = new Qu(90, 1, e, i), a = [
                    1,
                    -1,
                    1,
                    1,
                    1,
                    1
                ], s = [
                    1,
                    1,
                    1,
                    -1,
                    -1,
                    -1
                ], o = this._renderer, l = o.autoClear, c = o.toneMapping;
                o.getClearColor(gh), o.toneMapping = Br, o.autoClear = !1;
                const u = new Hc({
                    name: "PMREM.Background",
                    side: tr,
                    depthWrite: !1,
                    depthTest: !1
                }), h = new Ou(new ju, u);
                let d = !1;
                const p = t1.background;
                p ? p.isColor && (u.color.copy(p), t1.background = null, d = !0) : (u.color.copy(gh), d = !0);
                for(let e = 0; e < 6; e++){
                    const i = e % 3;
                    0 === i ? (r.up.set(0, a[e], 0), r.lookAt(s[e], 0, 0)) : 1 === i ? (r.up.set(0, 0, a[e]), r.lookAt(0, s[e], 0)) : (r.up.set(0, a[e], 0), r.lookAt(0, 0, s[e]));
                    const l = this._cubeSize;
                    Eh(n, i * l, e > 2 ? l : 0, l, l), o.setRenderTarget(n), d && o.render(h, r), o.render(t1, r);
                }
                h.geometry.dispose(), h.material.dispose(), o.toneMapping = c, o.autoClear = l, t1.background = p;
            }
            _textureToCubeUV(t1, e) {
                const i = this._renderer, n = t1.mapping === Zr || t1.mapping === Jr;
                n ? (null === this._cubemapMaterial && (this._cubemapMaterial = Sh()), this._cubemapMaterial.uniforms.flipEnvMap.value = !1 === t1.isRenderTargetTexture ? -1 : 1) : null === this._equirectMaterial && (this._equirectMaterial = Ih());
                const r = n ? this._cubemapMaterial : this._equirectMaterial, a = new Ou(this._lodPlanes[0], r);
                r.uniforms.envMap.value = t1;
                const s = this._cubeSize;
                Eh(e, 0, 0, 3 * s, 2 * s), i.setRenderTarget(e), i.render(a, Ah);
            }
            _applyPMREM(t1) {
                const e = this._renderer, i = e.autoClear;
                e.autoClear = !1;
                for(let e = 1; e < this._lodPlanes.length; e++){
                    const i = Math.sqrt(this._sigmas[e] * this._sigmas[e] - this._sigmas[e - 1] * this._sigmas[e - 1]), n = wh[(e - 1) % wh.length];
                    this._blur(t1, e - 1, e, i, n);
                }
                e.autoClear = i;
            }
            _blur(t1, e, i, n, r) {
                const a = this._pingPongRenderTarget;
                this._halfBlur(t1, a, e, i, n, "latitudinal", r), this._halfBlur(a, t1, i, i, n, "longitudinal", r);
            }
            _halfBlur(t1, e, i, n, r, a, s) {
                const o = this._renderer, l = this._blurMaterial;
                "latitudinal" !== a && "longitudinal" !== a && console.error("blur direction must be either latitudinal or longitudinal!");
                const c = new Ou(this._lodPlanes[n], l), u = l.uniforms, h = this._sizeLods[i] - 1, d = isFinite(r) ? Math.PI / (2 * h) : 2 * Math.PI / 39, p = r / d, f = isFinite(r) ? 1 + Math.floor(3 * p) : 20;
                f > 20 && console.warn(`sigmaRadians, ${r}, is too large and will clip, as it requested ${f} samples when the maximum is set to 20`);
                const A = [];
                let g = 0;
                for(let t1 = 0; t1 < 20; ++t1){
                    const e = t1 / p, i = Math.exp(-e * e / 2);
                    A.push(i), 0 === t1 ? g += i : t1 < f && (g += 2 * i);
                }
                for(let t1 = 0; t1 < A.length; t1++)A[t1] = A[t1] / g;
                u.envMap.value = t1.texture, u.samples.value = f, u.weights.value = A, u.latitudinal.value = "latitudinal" === a, s && (u.poleAxis.value = s);
                const { _lodMax: m } = this;
                u.dTheta.value = d, u.mipInt.value = m - i;
                const M = this._sizeLods[n];
                Eh(e, 3 * M * (n > m - 4 ? n - m + 4 : 0), 4 * (this._cubeSize - M), 3 * M, 2 * M), o.setRenderTarget(e), o.render(c, Ah);
            }
        }
        function Th(t1, e, i) {
            const n = new fl(t1, e, i);
            return n.texture.mapping = $r, n.texture.name = "PMREM.cubeUv", n.scissorTest = !0, n;
        }
        function Eh(t1, e, i, n, r) {
            t1.viewport.set(e, i, n, r), t1.scissor.set(e, i, n, r);
        }
        function Ih() {
            return new Bu({
                name: "EquirectangularToCubeUV",
                uniforms: {
                    envMap: {
                        value: null
                    }
                },
                vertexShader: "\n\n		precision mediump float;\n		precision mediump int;\n\n		attribute float faceIndex;\n\n		varying vec3 vOutputDirection;\n\n		// RH coordinate system; PMREM face-indexing convention\n		vec3 getDirection( vec2 uv, float face ) {\n\n			uv = 2.0 * uv - 1.0;\n\n			vec3 direction = vec3( uv, 1.0 );\n\n			if ( face == 0.0 ) {\n\n				direction = direction.zyx; // ( 1, v, u ) pos x\n\n			} else if ( face == 1.0 ) {\n\n				direction = direction.xzy;\n				direction.xz *= -1.0; // ( -u, 1, -v ) pos y\n\n			} else if ( face == 2.0 ) {\n\n				direction.x *= -1.0; // ( -u, v, 1 ) pos z\n\n			} else if ( face == 3.0 ) {\n\n				direction = direction.zyx;\n				direction.xz *= -1.0; // ( -1, v, -u ) neg x\n\n			} else if ( face == 4.0 ) {\n\n				direction = direction.xzy;\n				direction.xy *= -1.0; // ( -u, -1, v ) neg y\n\n			} else if ( face == 5.0 ) {\n\n				direction.z *= -1.0; // ( u, v, -1 ) neg z\n\n			}\n\n			return direction;\n\n		}\n\n		void main() {\n\n			vOutputDirection = getDirection( uv, faceIndex );\n			gl_Position = vec4( position, 1.0 );\n\n		}\n	",
                fragmentShader: "\n\n			precision mediump float;\n			precision mediump int;\n\n			varying vec3 vOutputDirection;\n\n			uniform sampler2D envMap;\n\n			#include <common>\n\n			void main() {\n\n				vec3 outputDirection = normalize( vOutputDirection );\n				vec2 uv = equirectUv( outputDirection );\n\n				gl_FragColor = vec4( texture2D ( envMap, uv ).rgb, 1.0 );\n\n			}\n		",
                blending: nr,
                depthTest: !1,
                depthWrite: !1
            });
        }
        function Sh() {
            return new Bu({
                name: "CubemapToCubeUV",
                uniforms: {
                    envMap: {
                        value: null
                    },
                    flipEnvMap: {
                        value: -1
                    }
                },
                vertexShader: "\n\n		precision mediump float;\n		precision mediump int;\n\n		attribute float faceIndex;\n\n		varying vec3 vOutputDirection;\n\n		// RH coordinate system; PMREM face-indexing convention\n		vec3 getDirection( vec2 uv, float face ) {\n\n			uv = 2.0 * uv - 1.0;\n\n			vec3 direction = vec3( uv, 1.0 );\n\n			if ( face == 0.0 ) {\n\n				direction = direction.zyx; // ( 1, v, u ) pos x\n\n			} else if ( face == 1.0 ) {\n\n				direction = direction.xzy;\n				direction.xz *= -1.0; // ( -u, 1, -v ) pos y\n\n			} else if ( face == 2.0 ) {\n\n				direction.x *= -1.0; // ( -u, v, 1 ) pos z\n\n			} else if ( face == 3.0 ) {\n\n				direction = direction.zyx;\n				direction.xz *= -1.0; // ( -1, v, -u ) neg x\n\n			} else if ( face == 4.0 ) {\n\n				direction = direction.xzy;\n				direction.xy *= -1.0; // ( -u, -1, v ) neg y\n\n			} else if ( face == 5.0 ) {\n\n				direction.z *= -1.0; // ( u, v, -1 ) neg z\n\n			}\n\n			return direction;\n\n		}\n\n		void main() {\n\n			vOutputDirection = getDirection( uv, faceIndex );\n			gl_Position = vec4( position, 1.0 );\n\n		}\n	",
                fragmentShader: "\n\n			precision mediump float;\n			precision mediump int;\n\n			uniform float flipEnvMap;\n\n			varying vec3 vOutputDirection;\n\n			uniform samplerCube envMap;\n\n			void main() {\n\n				gl_FragColor = textureCube( envMap, vec3( flipEnvMap * vOutputDirection.x, vOutputDirection.yz ) );\n\n			}\n		",
                blending: nr,
                depthTest: !1,
                depthWrite: !1
            });
        }
        function Nh(t1) {
            let e = new WeakMap, i = null;
            function n(t1) {
                const i = t1.target;
                i.removeEventListener("dispose", n);
                const r = e.get(i);
                void 0 !== r && (e.delete(i), r.dispose());
            }
            return {
                get: function(r) {
                    if (r && r.isTexture) {
                        const a = r.mapping, s = a === Kr || a === qr, o = a === Zr || a === Jr;
                        if (s || o) {
                            if (r.isRenderTargetTexture && !0 === r.needsPMREMUpdate) {
                                r.needsPMREMUpdate = !1;
                                let n = e.get(r);
                                return null === i && (i = new bh(t1)), n = s ? i.fromEquirectangular(r, n) : i.fromCubemap(r, n), e.set(r, n), n.texture;
                            }
                            if (e.has(r)) return e.get(r).texture;
                            {
                                const a = r.image;
                                if (s && a && a.height > 0 || o && a && function(t1) {
                                    let e = 0;
                                    for(let i = 0; i < 6; i++)void 0 !== t1[i] && e++;
                                    return 6 === e;
                                }(a)) {
                                    null === i && (i = new bh(t1));
                                    const a = s ? i.fromEquirectangular(r) : i.fromCubemap(r);
                                    return e.set(r, a), r.addEventListener("dispose", n), a.texture;
                                }
                                return null;
                            }
                        }
                    }
                    return r;
                },
                dispose: function() {
                    e = new WeakMap, null !== i && (i.dispose(), i = null);
                }
            };
        }
        function Dh(t1) {
            const e = {};
            function i(i) {
                if (void 0 !== e[i]) return e[i];
                let n;
                switch(i){
                    case "WEBGL_depth_texture":
                        n = t1.getExtension("WEBGL_depth_texture") || t1.getExtension("MOZ_WEBGL_depth_texture") || t1.getExtension("WEBKIT_WEBGL_depth_texture");
                        break;
                    case "EXT_texture_filter_anisotropic":
                        n = t1.getExtension("EXT_texture_filter_anisotropic") || t1.getExtension("MOZ_EXT_texture_filter_anisotropic") || t1.getExtension("WEBKIT_EXT_texture_filter_anisotropic");
                        break;
                    case "WEBGL_compressed_texture_s3tc":
                        n = t1.getExtension("WEBGL_compressed_texture_s3tc") || t1.getExtension("MOZ_WEBGL_compressed_texture_s3tc") || t1.getExtension("WEBKIT_WEBGL_compressed_texture_s3tc");
                        break;
                    case "WEBGL_compressed_texture_pvrtc":
                        n = t1.getExtension("WEBGL_compressed_texture_pvrtc") || t1.getExtension("WEBKIT_WEBGL_compressed_texture_pvrtc");
                        break;
                    default:
                        n = t1.getExtension(i);
                }
                return e[i] = n, n;
            }
            return {
                has: function(t1) {
                    return null !== i(t1);
                },
                init: function(t1) {
                    t1.isWebGL2 ? i("EXT_color_buffer_float") : (i("WEBGL_depth_texture"), i("OES_texture_float"), i("OES_texture_half_float"), i("OES_texture_half_float_linear"), i("OES_standard_derivatives"), i("OES_element_index_uint"), i("OES_vertex_array_object"), i("ANGLE_instanced_arrays")), i("OES_texture_float_linear"), i("EXT_color_buffer_half_float"), i("WEBGL_multisampled_render_to_texture");
                },
                get: function(t1) {
                    const e = i(t1);
                    return null === e && console.warn("THREE.WebGLRenderer: " + t1 + " extension not supported."), e;
                }
            };
        }
        function Ch(t1, e, i, n) {
            const r = {}, a = new WeakMap;
            function s(t1) {
                const o = t1.target;
                null !== o.index && e.remove(o.index);
                for(const t1 in o.attributes)e.remove(o.attributes[t1]);
                for(const t1 in o.morphAttributes){
                    const i = o.morphAttributes[t1];
                    for(let t1 = 0, n = i.length; t1 < n; t1++)e.remove(i[t1]);
                }
                o.removeEventListener("dispose", s), delete r[o.id];
                const l = a.get(o);
                l && (e.remove(l), a.delete(o)), n.releaseStatesOfGeometry(o), !0 === o.isInstancedBufferGeometry && delete o._maxInstanceCount, i.memory.geometries--;
            }
            function o(t1) {
                const i = [], n = t1.index, r = t1.attributes.position;
                let s = 0;
                if (null !== n) {
                    const t1 = n.array;
                    s = n.version;
                    for(let e = 0, n = t1.length; e < n; e += 3){
                        const n = t1[e + 0], r = t1[e + 1], a = t1[e + 2];
                        i.push(n, r, r, a, a, n);
                    }
                } else {
                    if (void 0 === r) return;
                    {
                        const t1 = r.array;
                        s = r.version;
                        for(let e = 0, n = t1.length / 3 - 1; e < n; e += 3){
                            const t1 = e + 0, n = e + 1, r = e + 2;
                            i.push(t1, n, n, r, r, t1);
                        }
                    }
                }
                const o = new (Go(i) ? ru : iu)(i, 1);
                o.version = s;
                const l = a.get(t1);
                l && e.remove(l), a.set(t1, o);
            }
            return {
                get: function(t1, e) {
                    return !0 === r[e.id] || (e.addEventListener("dispose", s), r[e.id] = !0, i.memory.geometries++), e;
                },
                update: function(i) {
                    const n = i.attributes;
                    for(const i in n)e.update(n[i], t1.ARRAY_BUFFER);
                    const r = i.morphAttributes;
                    for(const i in r){
                        const n = r[i];
                        for(let i = 0, r = n.length; i < r; i++)e.update(n[i], t1.ARRAY_BUFFER);
                    }
                },
                getWireframeAttribute: function(t1) {
                    const e = a.get(t1);
                    if (e) {
                        const i = t1.index;
                        null !== i && e.version < i.version && o(t1);
                    } else o(t1);
                    return a.get(t1);
                }
            };
        }
        function zh(t1, e, i, n) {
            const r = n.isWebGL2;
            let a, s, o;
            this.setMode = function(t1) {
                a = t1;
            }, this.setIndex = function(t1) {
                s = t1.type, o = t1.bytesPerElement;
            }, this.render = function(e, n) {
                t1.drawElements(a, n, s, e * o), i.update(n, a, 1);
            }, this.renderInstances = function(n, l, c) {
                if (0 === c) return;
                let u, h;
                if (r) u = t1, h = "drawElementsInstanced";
                else if (u = e.get("ANGLE_instanced_arrays"), h = "drawElementsInstancedANGLE", null === u) return void console.error("THREE.WebGLIndexedBufferRenderer: using THREE.InstancedBufferGeometry but hardware does not support extension ANGLE_instanced_arrays.");
                u[h](a, l, s, n * o, c), i.update(l, a, c);
            };
        }
        function Lh(t1) {
            const e = {
                frame: 0,
                calls: 0,
                triangles: 0,
                points: 0,
                lines: 0
            };
            return {
                memory: {
                    geometries: 0,
                    textures: 0
                },
                render: e,
                programs: null,
                autoReset: !0,
                reset: function() {
                    e.calls = 0, e.triangles = 0, e.points = 0, e.lines = 0;
                },
                update: function(i, n, r) {
                    switch(e.calls++, n){
                        case t1.TRIANGLES:
                            e.triangles += r * (i / 3);
                            break;
                        case t1.LINES:
                            e.lines += r * (i / 2);
                            break;
                        case t1.LINE_STRIP:
                            e.lines += r * (i - 1);
                            break;
                        case t1.LINE_LOOP:
                            e.lines += r * i;
                            break;
                        case t1.POINTS:
                            e.points += r * i;
                            break;
                        default:
                            console.error("THREE.WebGLInfo: Unknown draw mode:", n);
                    }
                }
            };
        }
        function Oh(t1, e) {
            return t1[0] - e[0];
        }
        function _h(t1, e) {
            return Math.abs(e[1]) - Math.abs(t1[1]);
        }
        function jh(t1, e, i) {
            const n = {}, r = new Float32Array(8), a = new WeakMap, s = new dl, o = [];
            for(let t1 = 0; t1 < 8; t1++)o[t1] = [
                t1,
                0
            ];
            return {
                update: function(l, c, u) {
                    const h = l.morphTargetInfluences;
                    if (!0 === e.isWebGL2) {
                        const d = c.morphAttributes.position || c.morphAttributes.normal || c.morphAttributes.color, p = void 0 !== d ? d.length : 0;
                        let f = a.get(c);
                        if (void 0 === f || f.count !== p) {
                            void 0 !== f && f.texture.dispose();
                            const m = void 0 !== c.morphAttributes.position, M = void 0 !== c.morphAttributes.normal, y = void 0 !== c.morphAttributes.color, v = c.morphAttributes.position || [], x = c.morphAttributes.normal || [], w = c.morphAttributes.color || [];
                            let b = 0;
                            !0 === m && (b = 1), !0 === M && (b = 2), !0 === y && (b = 3);
                            let T = c.attributes.position.count * b, E = 1;
                            T > e.maxTextureSize && (E = Math.ceil(T / e.maxTextureSize), T = e.maxTextureSize);
                            const I = new Float32Array(T * E * 4 * p), S = new Al(I, T, E, p);
                            S.type = ya, S.needsUpdate = !0;
                            const N = 4 * b;
                            for(let C = 0; C < p; C++){
                                const z = v[C], L = x[C], O = w[C], _ = T * E * 4 * C;
                                for(let j = 0; j < z.count; j++){
                                    const P = j * N;
                                    !0 === m && (s.fromBufferAttribute(z, j), I[_ + P + 0] = s.x, I[_ + P + 1] = s.y, I[_ + P + 2] = s.z, I[_ + P + 3] = 0), !0 === M && (s.fromBufferAttribute(L, j), I[_ + P + 4] = s.x, I[_ + P + 5] = s.y, I[_ + P + 6] = s.z, I[_ + P + 7] = 0), !0 === y && (s.fromBufferAttribute(O, j), I[_ + P + 8] = s.x, I[_ + P + 9] = s.y, I[_ + P + 10] = s.z, I[_ + P + 11] = 4 === O.itemSize ? s.w : 1);
                                }
                            }
                            function D() {
                                S.dispose(), a.delete(c), c.removeEventListener("dispose", D);
                            }
                            f = {
                                count: p,
                                texture: S,
                                size: new Qo(T, E)
                            }, a.set(c, f), c.addEventListener("dispose", D);
                        }
                        let A = 0;
                        for(let R = 0; R < h.length; R++)A += h[R];
                        const g = c.morphTargetsRelative ? 1 : 1 - A;
                        u.getUniforms().setValue(t1, "morphTargetBaseInfluence", g), u.getUniforms().setValue(t1, "morphTargetInfluences", h), u.getUniforms().setValue(t1, "morphTargetsTexture", f.texture, i), u.getUniforms().setValue(t1, "morphTargetsTextureSize", f.size);
                    } else {
                        const U = void 0 === h ? 0 : h.length;
                        let k = n[c.id];
                        if (void 0 === k || k.length !== U) {
                            k = [];
                            for(let V = 0; V < U; V++)k[V] = [
                                V,
                                0
                            ];
                            n[c.id] = k;
                        }
                        for(let G = 0; G < U; G++){
                            const Y = k[G];
                            Y[0] = G, Y[1] = h[G];
                        }
                        k.sort(_h);
                        for(let W = 0; W < 8; W++)W < U && k[W][1] ? (o[W][0] = k[W][0], o[W][1] = k[W][1]) : (o[W][0] = Number.MAX_SAFE_INTEGER, o[W][1] = 0);
                        o.sort(Oh);
                        const B = c.morphAttributes.position, F = c.morphAttributes.normal;
                        let Q = 0;
                        for(let X = 0; X < 8; X++){
                            const Z = o[X], J = Z[0], K = Z[1];
                            J !== Number.MAX_SAFE_INTEGER && K ? (B && c.getAttribute("morphTarget" + X) !== B[J] && c.setAttribute("morphTarget" + X, B[J]), F && c.getAttribute("morphNormal" + X) !== F[J] && c.setAttribute("morphNormal" + X, F[J]), r[X] = K, Q += K) : (B && !0 === c.hasAttribute("morphTarget" + X) && c.deleteAttribute("morphTarget" + X), F && !0 === c.hasAttribute("morphNormal" + X) && c.deleteAttribute("morphNormal" + X), r[X] = 0);
                        }
                        const H = c.morphTargetsRelative ? 1 : 1 - Q;
                        u.getUniforms().setValue(t1, "morphTargetBaseInfluence", H), u.getUniforms().setValue(t1, "morphTargetInfluences", r);
                    }
                }
            };
        }
        function Ph(t1, e, i, n) {
            let r = new WeakMap;
            function a(t1) {
                const e = t1.target;
                e.removeEventListener("dispose", a), i.remove(e.instanceMatrix), null !== e.instanceColor && i.remove(e.instanceColor);
            }
            return {
                update: function(s) {
                    const o = n.render.frame, l = s.geometry, c = e.get(s, l);
                    if (r.get(c) !== o && (e.update(c), r.set(c, o)), s.isInstancedMesh && (!1 === s.hasEventListener("dispose", a) && s.addEventListener("dispose", a), r.get(s) !== o && (i.update(s.instanceMatrix, t1.ARRAY_BUFFER), null !== s.instanceColor && i.update(s.instanceColor, t1.ARRAY_BUFFER), r.set(s, o))), s.isSkinnedMesh) {
                        const t1 = s.skeleton;
                        r.get(t1) !== o && (t1.update(), r.set(t1, o));
                    }
                    return c;
                },
                dispose: function() {
                    r = new WeakMap;
                }
            };
        }
        const Rh = new hl, Uh = new Al, kh = new ml, Bh = new Gu, Fh = [], Qh = [], Hh = new Float32Array(16), Vh = new Float32Array(9), Gh = new Float32Array(4);
        function Yh(t1, e, i) {
            const n = t1[0];
            if (n <= 0 || n > 0) return t1;
            const r = e * i;
            let a = Fh[r];
            if (void 0 === a && (a = new Float32Array(r), Fh[r] = a), 0 !== e) {
                n.toArray(a, 0);
                for(let n = 1, r = 0; n !== e; ++n)r += i, t1[n].toArray(a, r);
            }
            return a;
        }
        function Wh(t1, e) {
            if (t1.length !== e.length) return !1;
            for(let i = 0, n = t1.length; i < n; i++)if (t1[i] !== e[i]) return !1;
            return !0;
        }
        function Xh(t1, e) {
            for(let i = 0, n = e.length; i < n; i++)t1[i] = e[i];
        }
        function Zh(t1, e) {
            let i = Qh[e];
            void 0 === i && (i = new Int32Array(e), Qh[e] = i);
            for(let n = 0; n !== e; ++n)i[n] = t1.allocateTextureUnit();
            return i;
        }
        function Jh(t1, e) {
            const i = this.cache;
            i[0] !== e && (t1.uniform1f(this.addr, e), i[0] = e);
        }
        function Kh(t1, e) {
            const i = this.cache;
            if (void 0 !== e.x) i[0] === e.x && i[1] === e.y || (t1.uniform2f(this.addr, e.x, e.y), i[0] = e.x, i[1] = e.y);
            else {
                if (Wh(i, e)) return;
                t1.uniform2fv(this.addr, e), Xh(i, e);
            }
        }
        function qh(t1, e) {
            const i = this.cache;
            if (void 0 !== e.x) i[0] === e.x && i[1] === e.y && i[2] === e.z || (t1.uniform3f(this.addr, e.x, e.y, e.z), i[0] = e.x, i[1] = e.y, i[2] = e.z);
            else if (void 0 !== e.r) i[0] === e.r && i[1] === e.g && i[2] === e.b || (t1.uniform3f(this.addr, e.r, e.g, e.b), i[0] = e.r, i[1] = e.g, i[2] = e.b);
            else {
                if (Wh(i, e)) return;
                t1.uniform3fv(this.addr, e), Xh(i, e);
            }
        }
        function $h(t1, e) {
            const i = this.cache;
            if (void 0 !== e.x) i[0] === e.x && i[1] === e.y && i[2] === e.z && i[3] === e.w || (t1.uniform4f(this.addr, e.x, e.y, e.z, e.w), i[0] = e.x, i[1] = e.y, i[2] = e.z, i[3] = e.w);
            else {
                if (Wh(i, e)) return;
                t1.uniform4fv(this.addr, e), Xh(i, e);
            }
        }
        function td(t1, e) {
            const i = this.cache, n = e.elements;
            if (void 0 === n) {
                if (Wh(i, e)) return;
                t1.uniformMatrix2fv(this.addr, !1, e), Xh(i, e);
            } else {
                if (Wh(i, n)) return;
                Gh.set(n), t1.uniformMatrix2fv(this.addr, !1, Gh), Xh(i, n);
            }
        }
        function ed(t1, e) {
            const i = this.cache, n = e.elements;
            if (void 0 === n) {
                if (Wh(i, e)) return;
                t1.uniformMatrix3fv(this.addr, !1, e), Xh(i, e);
            } else {
                if (Wh(i, n)) return;
                Vh.set(n), t1.uniformMatrix3fv(this.addr, !1, Vh), Xh(i, n);
            }
        }
        function id(t1, e) {
            const i = this.cache, n = e.elements;
            if (void 0 === n) {
                if (Wh(i, e)) return;
                t1.uniformMatrix4fv(this.addr, !1, e), Xh(i, e);
            } else {
                if (Wh(i, n)) return;
                Hh.set(n), t1.uniformMatrix4fv(this.addr, !1, Hh), Xh(i, n);
            }
        }
        function nd(t1, e) {
            const i = this.cache;
            i[0] !== e && (t1.uniform1i(this.addr, e), i[0] = e);
        }
        function rd(t1, e) {
            const i = this.cache;
            if (void 0 !== e.x) i[0] === e.x && i[1] === e.y || (t1.uniform2i(this.addr, e.x, e.y), i[0] = e.x, i[1] = e.y);
            else {
                if (Wh(i, e)) return;
                t1.uniform2iv(this.addr, e), Xh(i, e);
            }
        }
        function ad(t1, e) {
            const i = this.cache;
            if (void 0 !== e.x) i[0] === e.x && i[1] === e.y && i[2] === e.z || (t1.uniform3i(this.addr, e.x, e.y, e.z), i[0] = e.x, i[1] = e.y, i[2] = e.z);
            else {
                if (Wh(i, e)) return;
                t1.uniform3iv(this.addr, e), Xh(i, e);
            }
        }
        function sd(t1, e) {
            const i = this.cache;
            if (void 0 !== e.x) i[0] === e.x && i[1] === e.y && i[2] === e.z && i[3] === e.w || (t1.uniform4i(this.addr, e.x, e.y, e.z, e.w), i[0] = e.x, i[1] = e.y, i[2] = e.z, i[3] = e.w);
            else {
                if (Wh(i, e)) return;
                t1.uniform4iv(this.addr, e), Xh(i, e);
            }
        }
        function od(t1, e) {
            const i = this.cache;
            i[0] !== e && (t1.uniform1ui(this.addr, e), i[0] = e);
        }
        function ld(t1, e) {
            const i = this.cache;
            if (void 0 !== e.x) i[0] === e.x && i[1] === e.y || (t1.uniform2ui(this.addr, e.x, e.y), i[0] = e.x, i[1] = e.y);
            else {
                if (Wh(i, e)) return;
                t1.uniform2uiv(this.addr, e), Xh(i, e);
            }
        }
        function cd(t1, e) {
            const i = this.cache;
            if (void 0 !== e.x) i[0] === e.x && i[1] === e.y && i[2] === e.z || (t1.uniform3ui(this.addr, e.x, e.y, e.z), i[0] = e.x, i[1] = e.y, i[2] = e.z);
            else {
                if (Wh(i, e)) return;
                t1.uniform3uiv(this.addr, e), Xh(i, e);
            }
        }
        function ud(t1, e) {
            const i = this.cache;
            if (void 0 !== e.x) i[0] === e.x && i[1] === e.y && i[2] === e.z && i[3] === e.w || (t1.uniform4ui(this.addr, e.x, e.y, e.z, e.w), i[0] = e.x, i[1] = e.y, i[2] = e.z, i[3] = e.w);
            else {
                if (Wh(i, e)) return;
                t1.uniform4uiv(this.addr, e), Xh(i, e);
            }
        }
        function hd(t1, e, i) {
            const n = this.cache, r = i.allocateTextureUnit();
            n[0] !== r && (t1.uniform1i(this.addr, r), n[0] = r), i.setTexture2D(e || Rh, r);
        }
        function dd(t1, e, i) {
            const n = this.cache, r = i.allocateTextureUnit();
            n[0] !== r && (t1.uniform1i(this.addr, r), n[0] = r), i.setTexture3D(e || kh, r);
        }
        function pd(t1, e, i) {
            const n = this.cache, r = i.allocateTextureUnit();
            n[0] !== r && (t1.uniform1i(this.addr, r), n[0] = r), i.setTextureCube(e || Bh, r);
        }
        function fd(t1, e, i) {
            const n = this.cache, r = i.allocateTextureUnit();
            n[0] !== r && (t1.uniform1i(this.addr, r), n[0] = r), i.setTexture2DArray(e || Uh, r);
        }
        function Ad(t1, e) {
            t1.uniform1fv(this.addr, e);
        }
        function gd(t1, e) {
            const i = Yh(e, this.size, 2);
            t1.uniform2fv(this.addr, i);
        }
        function md(t1, e) {
            const i = Yh(e, this.size, 3);
            t1.uniform3fv(this.addr, i);
        }
        function Md(t1, e) {
            const i = Yh(e, this.size, 4);
            t1.uniform4fv(this.addr, i);
        }
        function yd(t1, e) {
            const i = Yh(e, this.size, 4);
            t1.uniformMatrix2fv(this.addr, !1, i);
        }
        function vd(t1, e) {
            const i = Yh(e, this.size, 9);
            t1.uniformMatrix3fv(this.addr, !1, i);
        }
        function xd(t1, e) {
            const i = Yh(e, this.size, 16);
            t1.uniformMatrix4fv(this.addr, !1, i);
        }
        function wd(t1, e) {
            t1.uniform1iv(this.addr, e);
        }
        function bd(t1, e) {
            t1.uniform2iv(this.addr, e);
        }
        function Td(t1, e) {
            t1.uniform3iv(this.addr, e);
        }
        function Ed(t1, e) {
            t1.uniform4iv(this.addr, e);
        }
        function Id(t1, e) {
            t1.uniform1uiv(this.addr, e);
        }
        function Sd(t1, e) {
            t1.uniform2uiv(this.addr, e);
        }
        function Nd(t1, e) {
            t1.uniform3uiv(this.addr, e);
        }
        function Dd(t1, e) {
            t1.uniform4uiv(this.addr, e);
        }
        function Cd(t1, e, i) {
            const n = this.cache, r = e.length, a = Zh(i, r);
            Wh(n, a) || (t1.uniform1iv(this.addr, a), Xh(n, a));
            for(let t1 = 0; t1 !== r; ++t1)i.setTexture2D(e[t1] || Rh, a[t1]);
        }
        function zd(t1, e, i) {
            const n = this.cache, r = e.length, a = Zh(i, r);
            Wh(n, a) || (t1.uniform1iv(this.addr, a), Xh(n, a));
            for(let t1 = 0; t1 !== r; ++t1)i.setTexture3D(e[t1] || kh, a[t1]);
        }
        function Ld(t1, e, i) {
            const n = this.cache, r = e.length, a = Zh(i, r);
            Wh(n, a) || (t1.uniform1iv(this.addr, a), Xh(n, a));
            for(let t1 = 0; t1 !== r; ++t1)i.setTextureCube(e[t1] || Bh, a[t1]);
        }
        function Od(t1, e, i) {
            const n = this.cache, r = e.length, a = Zh(i, r);
            Wh(n, a) || (t1.uniform1iv(this.addr, a), Xh(n, a));
            for(let t1 = 0; t1 !== r; ++t1)i.setTexture2DArray(e[t1] || Uh, a[t1]);
        }
        class _d {
            constructor(t1, e, i){
                this.id = t1, this.addr = i, this.cache = [], this.setValue = function(t1) {
                    switch(t1){
                        case 5126:
                            return Jh;
                        case 35664:
                            return Kh;
                        case 35665:
                            return qh;
                        case 35666:
                            return $h;
                        case 35674:
                            return td;
                        case 35675:
                            return ed;
                        case 35676:
                            return id;
                        case 5124:
                        case 35670:
                            return nd;
                        case 35667:
                        case 35671:
                            return rd;
                        case 35668:
                        case 35672:
                            return ad;
                        case 35669:
                        case 35673:
                            return sd;
                        case 5125:
                            return od;
                        case 36294:
                            return ld;
                        case 36295:
                            return cd;
                        case 36296:
                            return ud;
                        case 35678:
                        case 36198:
                        case 36298:
                        case 36306:
                        case 35682:
                            return hd;
                        case 35679:
                        case 36299:
                        case 36307:
                            return dd;
                        case 35680:
                        case 36300:
                        case 36308:
                        case 36293:
                            return pd;
                        case 36289:
                        case 36303:
                        case 36311:
                        case 36292:
                            return fd;
                    }
                }(e.type);
            }
        }
        class jd {
            constructor(t1, e, i){
                this.id = t1, this.addr = i, this.cache = [], this.size = e.size, this.setValue = function(t1) {
                    switch(t1){
                        case 5126:
                            return Ad;
                        case 35664:
                            return gd;
                        case 35665:
                            return md;
                        case 35666:
                            return Md;
                        case 35674:
                            return yd;
                        case 35675:
                            return vd;
                        case 35676:
                            return xd;
                        case 5124:
                        case 35670:
                            return wd;
                        case 35667:
                        case 35671:
                            return bd;
                        case 35668:
                        case 35672:
                            return Td;
                        case 35669:
                        case 35673:
                            return Ed;
                        case 5125:
                            return Id;
                        case 36294:
                            return Sd;
                        case 36295:
                            return Nd;
                        case 36296:
                            return Dd;
                        case 35678:
                        case 36198:
                        case 36298:
                        case 36306:
                        case 35682:
                            return Cd;
                        case 35679:
                        case 36299:
                        case 36307:
                            return zd;
                        case 35680:
                        case 36300:
                        case 36308:
                        case 36293:
                            return Ld;
                        case 36289:
                        case 36303:
                        case 36311:
                        case 36292:
                            return Od;
                    }
                }(e.type);
            }
        }
        class Pd {
            constructor(t1){
                this.id = t1, this.seq = [], this.map = {};
            }
            setValue(t1, e, i) {
                const n = this.seq;
                for(let r = 0, a = n.length; r !== a; ++r){
                    const a = n[r];
                    a.setValue(t1, e[a.id], i);
                }
            }
        }
        const Rd = /(\w+)(\])?(\[|\.)?/g;
        function Ud(t1, e) {
            t1.seq.push(e), t1.map[e.id] = e;
        }
        function kd(t1, e, i) {
            const n = t1.name, r = n.length;
            for(Rd.lastIndex = 0;;){
                const a = Rd.exec(n), s = Rd.lastIndex;
                let o = a[1];
                const l = "]" === a[2], c = a[3];
                if (l && (o |= 0), void 0 === c || "[" === c && s + 2 === r) {
                    Ud(i, void 0 === c ? new _d(o, t1, e) : new jd(o, t1, e));
                    break;
                }
                {
                    let t1 = i.map[o];
                    void 0 === t1 && (t1 = new Pd(o), Ud(i, t1)), i = t1;
                }
            }
        }
        class Bd {
            constructor(t1, e){
                this.seq = [], this.map = {};
                const i = t1.getProgramParameter(e, t1.ACTIVE_UNIFORMS);
                for(let n = 0; n < i; ++n){
                    const i = t1.getActiveUniform(e, n);
                    kd(i, t1.getUniformLocation(e, i.name), this);
                }
            }
            setValue(t1, e, i, n) {
                const r = this.map[e];
                void 0 !== r && r.setValue(t1, i, n);
            }
            setOptional(t1, e, i) {
                const n = e[i];
                void 0 !== n && this.setValue(t1, i, n);
            }
            static upload(t1, e, i, n) {
                for(let r = 0, a = e.length; r !== a; ++r){
                    const a = e[r], s = i[a.id];
                    !1 !== s.needsUpdate && a.setValue(t1, s.value, n);
                }
            }
            static seqWithValue(t1, e) {
                const i = [];
                for(let n = 0, r = t1.length; n !== r; ++n){
                    const r = t1[n];
                    r.id in e && i.push(r);
                }
                return i;
            }
        }
        function Fd(t1, e, i) {
            const n = t1.createShader(e);
            return t1.shaderSource(n, i), t1.compileShader(n), n;
        }
        const Qd = 37297;
        let Hd = 0;
        function Vd(t1, e, i) {
            const n = t1.getShaderParameter(e, t1.COMPILE_STATUS), r = t1.getShaderInfoLog(e).trim();
            if (n && "" === r) return "";
            const a = /ERROR: 0:(\d+)/.exec(r);
            if (a) {
                const n = parseInt(a[1]);
                return i.toUpperCase() + "\n\n" + r + "\n\n" + function(t1, e) {
                    const i = t1.split("\n"), n = [], r = Math.max(e - 6, 0), a = Math.min(e + 6, i.length);
                    for(let t1 = r; t1 < a; t1++){
                        const r = t1 + 1;
                        n.push(`${r === e ? ">" : " "} ${r}: ${i[t1]}`);
                    }
                    return n.join("\n");
                }(t1.getShaderSource(e), n);
            }
            return r;
        }
        function Gd(t1, e) {
            const i = function(t1) {
                const e = il.getPrimaries(il.workingColorSpace), i = il.getPrimaries(t1);
                let n;
                switch(e === i ? n = "" : e === Fs && i === Bs ? n = "LinearDisplayP3ToLinearSRGB" : e === Bs && i === Fs && (n = "LinearSRGBToLinearDisplayP3"), t1){
                    case js:
                    case Rs:
                        return [
                            n,
                            "LinearTransferOETF"
                        ];
                    case _s:
                    case Ps:
                        return [
                            n,
                            "sRGBTransferOETF"
                        ];
                    default:
                        return console.warn("THREE.WebGLProgram: Unsupported color space:", t1), [
                            n,
                            "LinearTransferOETF"
                        ];
                }
            }(e);
            return `vec4 ${t1}( vec4 value ) { return ${i[0]}( ${i[1]}( value ) ); }`;
        }
        function Yd(t1, e) {
            let i;
            switch(e){
                case Fr:
                    i = "Linear";
                    break;
                case Qr:
                    i = "Reinhard";
                    break;
                case Hr:
                    i = "OptimizedCineon";
                    break;
                case Vr:
                    i = "ACESFilmic";
                    break;
                case Gr:
                    i = "Custom";
                    break;
                default:
                    console.warn("THREE.WebGLProgram: Unsupported toneMapping:", e), i = "Linear";
            }
            return "vec3 " + t1 + "( vec3 color ) { return " + i + "ToneMapping( color ); }";
        }
        function Wd(t1) {
            return "" !== t1;
        }
        function Xd(t1, e) {
            const i = e.numSpotLightShadows + e.numSpotLightMaps - e.numSpotLightShadowsWithMaps;
            return t1.replace(/NUM_DIR_LIGHTS/g, e.numDirLights).replace(/NUM_SPOT_LIGHTS/g, e.numSpotLights).replace(/NUM_SPOT_LIGHT_MAPS/g, e.numSpotLightMaps).replace(/NUM_SPOT_LIGHT_COORDS/g, i).replace(/NUM_RECT_AREA_LIGHTS/g, e.numRectAreaLights).replace(/NUM_POINT_LIGHTS/g, e.numPointLights).replace(/NUM_HEMI_LIGHTS/g, e.numHemiLights).replace(/NUM_DIR_LIGHT_SHADOWS/g, e.numDirLightShadows).replace(/NUM_SPOT_LIGHT_SHADOWS_WITH_MAPS/g, e.numSpotLightShadowsWithMaps).replace(/NUM_SPOT_LIGHT_SHADOWS/g, e.numSpotLightShadows).replace(/NUM_POINT_LIGHT_SHADOWS/g, e.numPointLightShadows);
        }
        function Zd(t1, e) {
            return t1.replace(/NUM_CLIPPING_PLANES/g, e.numClippingPlanes).replace(/UNION_CLIPPING_PLANES/g, e.numClippingPlanes - e.numClipIntersection);
        }
        const Jd = /^[ \t]*#include +<([\w\d./]+)>/gm;
        function Kd(t1) {
            return t1.replace(Jd, $d);
        }
        const qd = new Map([
            [
                "encodings_fragment",
                "colorspace_fragment"
            ],
            [
                "encodings_pars_fragment",
                "colorspace_pars_fragment"
            ],
            [
                "output_fragment",
                "opaque_fragment"
            ]
        ]);
        function $d(t1, e) {
            let i = nh[e];
            if (void 0 === i) {
                const t1 = qd.get(e);
                if (void 0 === t1) throw new Error("Can not resolve #include <" + e + ">");
                i = nh[t1], console.warn('THREE.WebGLRenderer: Shader chunk "%s" has been deprecated. Use "%s" instead.', e, t1);
            }
            return Kd(i);
        }
        const tp = /#pragma unroll_loop_start\s+for\s*\(\s*int\s+i\s*=\s*(\d+)\s*;\s*i\s*<\s*(\d+)\s*;\s*i\s*\+\+\s*\)\s*{([\s\S]+?)}\s+#pragma unroll_loop_end/g;
        function ep(t1) {
            return t1.replace(tp, ip);
        }
        function ip(t1, e, i, n) {
            let r = "";
            for(let t1 = parseInt(e); t1 < parseInt(i); t1++)r += n.replace(/\[\s*i\s*\]/g, "[ " + t1 + " ]").replace(/UNROLLED_LOOP_INDEX/g, t1);
            return r;
        }
        function np(t1) {
            let e = "precision " + t1.precision + " float;\nprecision " + t1.precision + " int;";
            return "highp" === t1.precision ? e += "\n#define HIGH_PRECISION" : "mediump" === t1.precision ? e += "\n#define MEDIUM_PRECISION" : "lowp" === t1.precision && (e += "\n#define LOW_PRECISION"), e;
        }
        function rp(t1, e, i, n) {
            const r = t1.getContext(), a = i.defines;
            let s = i.vertexShader, o = i.fragmentShader;
            const l = function(t1) {
                let e = "SHADOWMAP_TYPE_BASIC";
                return t1.shadowMapType === Jn ? e = "SHADOWMAP_TYPE_PCF" : t1.shadowMapType === Kn ? e = "SHADOWMAP_TYPE_PCF_SOFT" : t1.shadowMapType === qn && (e = "SHADOWMAP_TYPE_VSM"), e;
            }(i), c = function(t1) {
                let e = "ENVMAP_TYPE_CUBE";
                if (t1.envMap) switch(t1.envMapMode){
                    case Zr:
                    case Jr:
                        e = "ENVMAP_TYPE_CUBE";
                        break;
                    case $r:
                        e = "ENVMAP_TYPE_CUBE_UV";
                }
                return e;
            }(i), u = function(t1) {
                let e = "ENVMAP_MODE_REFLECTION";
                return t1.envMap && t1.envMapMode === Jr && (e = "ENVMAP_MODE_REFRACTION"), e;
            }(i), h = function(t1) {
                let e = "ENVMAP_BLENDING_NONE";
                if (t1.envMap) switch(t1.combine){
                    case Rr:
                        e = "ENVMAP_BLENDING_MULTIPLY";
                        break;
                    case Ur:
                        e = "ENVMAP_BLENDING_MIX";
                        break;
                    case kr:
                        e = "ENVMAP_BLENDING_ADD";
                }
                return e;
            }(i), d = function(t1) {
                const e = t1.envMapCubeUVHeight;
                if (null === e) return null;
                const i = Math.log2(e) - 2, n = 1 / e;
                return {
                    texelWidth: 1 / (3 * Math.max(Math.pow(2, i), 112)),
                    texelHeight: n,
                    maxMip: i
                };
            }(i), p = i.isWebGL2 ? "" : function(t1) {
                return [
                    t1.extensionDerivatives || t1.envMapCubeUVHeight || t1.bumpMap || t1.normalMapTangentSpace || t1.clearcoatNormalMap || t1.flatShading || "physical" === t1.shaderID ? "#extension GL_OES_standard_derivatives : enable" : "",
                    (t1.extensionFragDepth || t1.logarithmicDepthBuffer) && t1.rendererExtensionFragDepth ? "#extension GL_EXT_frag_depth : enable" : "",
                    t1.extensionDrawBuffers && t1.rendererExtensionDrawBuffers ? "#extension GL_EXT_draw_buffers : require" : "",
                    (t1.extensionShaderTextureLOD || t1.envMap || t1.transmission) && t1.rendererExtensionShaderTextureLod ? "#extension GL_EXT_shader_texture_lod : enable" : ""
                ].filter(Wd).join("\n");
            }(i), f = function(t1) {
                const e = [];
                for(const i in t1){
                    const n = t1[i];
                    !1 !== n && e.push("#define " + i + " " + n);
                }
                return e.join("\n");
            }(a), A = r.createProgram();
            let g, m, M = i.glslVersion ? "#version " + i.glslVersion + "\n" : "";
            i.isRawShaderMaterial ? (g = [
                "#define SHADER_TYPE " + i.shaderType,
                "#define SHADER_NAME " + i.shaderName,
                f
            ].filter(Wd).join("\n"), g.length > 0 && (g += "\n"), m = [
                p,
                "#define SHADER_TYPE " + i.shaderType,
                "#define SHADER_NAME " + i.shaderName,
                f
            ].filter(Wd).join("\n"), m.length > 0 && (m += "\n")) : (g = [
                np(i),
                "#define SHADER_TYPE " + i.shaderType,
                "#define SHADER_NAME " + i.shaderName,
                f,
                i.instancing ? "#define USE_INSTANCING" : "",
                i.instancingColor ? "#define USE_INSTANCING_COLOR" : "",
                i.useFog && i.fog ? "#define USE_FOG" : "",
                i.useFog && i.fogExp2 ? "#define FOG_EXP2" : "",
                i.map ? "#define USE_MAP" : "",
                i.envMap ? "#define USE_ENVMAP" : "",
                i.envMap ? "#define " + u : "",
                i.lightMap ? "#define USE_LIGHTMAP" : "",
                i.aoMap ? "#define USE_AOMAP" : "",
                i.bumpMap ? "#define USE_BUMPMAP" : "",
                i.normalMap ? "#define USE_NORMALMAP" : "",
                i.normalMapObjectSpace ? "#define USE_NORMALMAP_OBJECTSPACE" : "",
                i.normalMapTangentSpace ? "#define USE_NORMALMAP_TANGENTSPACE" : "",
                i.displacementMap ? "#define USE_DISPLACEMENTMAP" : "",
                i.emissiveMap ? "#define USE_EMISSIVEMAP" : "",
                i.anisotropy ? "#define USE_ANISOTROPY" : "",
                i.anisotropyMap ? "#define USE_ANISOTROPYMAP" : "",
                i.clearcoatMap ? "#define USE_CLEARCOATMAP" : "",
                i.clearcoatRoughnessMap ? "#define USE_CLEARCOAT_ROUGHNESSMAP" : "",
                i.clearcoatNormalMap ? "#define USE_CLEARCOAT_NORMALMAP" : "",
                i.iridescenceMap ? "#define USE_IRIDESCENCEMAP" : "",
                i.iridescenceThicknessMap ? "#define USE_IRIDESCENCE_THICKNESSMAP" : "",
                i.specularMap ? "#define USE_SPECULARMAP" : "",
                i.specularColorMap ? "#define USE_SPECULAR_COLORMAP" : "",
                i.specularIntensityMap ? "#define USE_SPECULAR_INTENSITYMAP" : "",
                i.roughnessMap ? "#define USE_ROUGHNESSMAP" : "",
                i.metalnessMap ? "#define USE_METALNESSMAP" : "",
                i.alphaMap ? "#define USE_ALPHAMAP" : "",
                i.alphaHash ? "#define USE_ALPHAHASH" : "",
                i.transmission ? "#define USE_TRANSMISSION" : "",
                i.transmissionMap ? "#define USE_TRANSMISSIONMAP" : "",
                i.thicknessMap ? "#define USE_THICKNESSMAP" : "",
                i.sheenColorMap ? "#define USE_SHEEN_COLORMAP" : "",
                i.sheenRoughnessMap ? "#define USE_SHEEN_ROUGHNESSMAP" : "",
                i.mapUv ? "#define MAP_UV " + i.mapUv : "",
                i.alphaMapUv ? "#define ALPHAMAP_UV " + i.alphaMapUv : "",
                i.lightMapUv ? "#define LIGHTMAP_UV " + i.lightMapUv : "",
                i.aoMapUv ? "#define AOMAP_UV " + i.aoMapUv : "",
                i.emissiveMapUv ? "#define EMISSIVEMAP_UV " + i.emissiveMapUv : "",
                i.bumpMapUv ? "#define BUMPMAP_UV " + i.bumpMapUv : "",
                i.normalMapUv ? "#define NORMALMAP_UV " + i.normalMapUv : "",
                i.displacementMapUv ? "#define DISPLACEMENTMAP_UV " + i.displacementMapUv : "",
                i.metalnessMapUv ? "#define METALNESSMAP_UV " + i.metalnessMapUv : "",
                i.roughnessMapUv ? "#define ROUGHNESSMAP_UV " + i.roughnessMapUv : "",
                i.anisotropyMapUv ? "#define ANISOTROPYMAP_UV " + i.anisotropyMapUv : "",
                i.clearcoatMapUv ? "#define CLEARCOATMAP_UV " + i.clearcoatMapUv : "",
                i.clearcoatNormalMapUv ? "#define CLEARCOAT_NORMALMAP_UV " + i.clearcoatNormalMapUv : "",
                i.clearcoatRoughnessMapUv ? "#define CLEARCOAT_ROUGHNESSMAP_UV " + i.clearcoatRoughnessMapUv : "",
                i.iridescenceMapUv ? "#define IRIDESCENCEMAP_UV " + i.iridescenceMapUv : "",
                i.iridescenceThicknessMapUv ? "#define IRIDESCENCE_THICKNESSMAP_UV " + i.iridescenceThicknessMapUv : "",
                i.sheenColorMapUv ? "#define SHEEN_COLORMAP_UV " + i.sheenColorMapUv : "",
                i.sheenRoughnessMapUv ? "#define SHEEN_ROUGHNESSMAP_UV " + i.sheenRoughnessMapUv : "",
                i.specularMapUv ? "#define SPECULARMAP_UV " + i.specularMapUv : "",
                i.specularColorMapUv ? "#define SPECULAR_COLORMAP_UV " + i.specularColorMapUv : "",
                i.specularIntensityMapUv ? "#define SPECULAR_INTENSITYMAP_UV " + i.specularIntensityMapUv : "",
                i.transmissionMapUv ? "#define TRANSMISSIONMAP_UV " + i.transmissionMapUv : "",
                i.thicknessMapUv ? "#define THICKNESSMAP_UV " + i.thicknessMapUv : "",
                i.vertexTangents && !1 === i.flatShading ? "#define USE_TANGENT" : "",
                i.vertexColors ? "#define USE_COLOR" : "",
                i.vertexAlphas ? "#define USE_COLOR_ALPHA" : "",
                i.vertexUv1s ? "#define USE_UV1" : "",
                i.vertexUv2s ? "#define USE_UV2" : "",
                i.vertexUv3s ? "#define USE_UV3" : "",
                i.pointsUvs ? "#define USE_POINTS_UV" : "",
                i.flatShading ? "#define FLAT_SHADED" : "",
                i.skinning ? "#define USE_SKINNING" : "",
                i.morphTargets ? "#define USE_MORPHTARGETS" : "",
                i.morphNormals && !1 === i.flatShading ? "#define USE_MORPHNORMALS" : "",
                i.morphColors && i.isWebGL2 ? "#define USE_MORPHCOLORS" : "",
                i.morphTargetsCount > 0 && i.isWebGL2 ? "#define MORPHTARGETS_TEXTURE" : "",
                i.morphTargetsCount > 0 && i.isWebGL2 ? "#define MORPHTARGETS_TEXTURE_STRIDE " + i.morphTextureStride : "",
                i.morphTargetsCount > 0 && i.isWebGL2 ? "#define MORPHTARGETS_COUNT " + i.morphTargetsCount : "",
                i.doubleSided ? "#define DOUBLE_SIDED" : "",
                i.flipSided ? "#define FLIP_SIDED" : "",
                i.shadowMapEnabled ? "#define USE_SHADOWMAP" : "",
                i.shadowMapEnabled ? "#define " + l : "",
                i.sizeAttenuation ? "#define USE_SIZEATTENUATION" : "",
                i.numLightProbes > 0 ? "#define USE_LIGHT_PROBES" : "",
                i.useLegacyLights ? "#define LEGACY_LIGHTS" : "",
                i.logarithmicDepthBuffer ? "#define USE_LOGDEPTHBUF" : "",
                i.logarithmicDepthBuffer && i.rendererExtensionFragDepth ? "#define USE_LOGDEPTHBUF_EXT" : "",
                "uniform mat4 modelMatrix;",
                "uniform mat4 modelViewMatrix;",
                "uniform mat4 projectionMatrix;",
                "uniform mat4 viewMatrix;",
                "uniform mat3 normalMatrix;",
                "uniform vec3 cameraPosition;",
                "uniform bool isOrthographic;",
                "#ifdef USE_INSTANCING",
                "	attribute mat4 instanceMatrix;",
                "#endif",
                "#ifdef USE_INSTANCING_COLOR",
                "	attribute vec3 instanceColor;",
                "#endif",
                "attribute vec3 position;",
                "attribute vec3 normal;",
                "attribute vec2 uv;",
                "#ifdef USE_UV1",
                "	attribute vec2 uv1;",
                "#endif",
                "#ifdef USE_UV2",
                "	attribute vec2 uv2;",
                "#endif",
                "#ifdef USE_UV3",
                "	attribute vec2 uv3;",
                "#endif",
                "#ifdef USE_TANGENT",
                "	attribute vec4 tangent;",
                "#endif",
                "#if defined( USE_COLOR_ALPHA )",
                "	attribute vec4 color;",
                "#elif defined( USE_COLOR )",
                "	attribute vec3 color;",
                "#endif",
                "#if ( defined( USE_MORPHTARGETS ) && ! defined( MORPHTARGETS_TEXTURE ) )",
                "	attribute vec3 morphTarget0;",
                "	attribute vec3 morphTarget1;",
                "	attribute vec3 morphTarget2;",
                "	attribute vec3 morphTarget3;",
                "	#ifdef USE_MORPHNORMALS",
                "		attribute vec3 morphNormal0;",
                "		attribute vec3 morphNormal1;",
                "		attribute vec3 morphNormal2;",
                "		attribute vec3 morphNormal3;",
                "	#else",
                "		attribute vec3 morphTarget4;",
                "		attribute vec3 morphTarget5;",
                "		attribute vec3 morphTarget6;",
                "		attribute vec3 morphTarget7;",
                "	#endif",
                "#endif",
                "#ifdef USE_SKINNING",
                "	attribute vec4 skinIndex;",
                "	attribute vec4 skinWeight;",
                "#endif",
                "\n"
            ].filter(Wd).join("\n"), m = [
                p,
                np(i),
                "#define SHADER_TYPE " + i.shaderType,
                "#define SHADER_NAME " + i.shaderName,
                f,
                i.useFog && i.fog ? "#define USE_FOG" : "",
                i.useFog && i.fogExp2 ? "#define FOG_EXP2" : "",
                i.map ? "#define USE_MAP" : "",
                i.matcap ? "#define USE_MATCAP" : "",
                i.envMap ? "#define USE_ENVMAP" : "",
                i.envMap ? "#define " + c : "",
                i.envMap ? "#define " + u : "",
                i.envMap ? "#define " + h : "",
                d ? "#define CUBEUV_TEXEL_WIDTH " + d.texelWidth : "",
                d ? "#define CUBEUV_TEXEL_HEIGHT " + d.texelHeight : "",
                d ? "#define CUBEUV_MAX_MIP " + d.maxMip + ".0" : "",
                i.lightMap ? "#define USE_LIGHTMAP" : "",
                i.aoMap ? "#define USE_AOMAP" : "",
                i.bumpMap ? "#define USE_BUMPMAP" : "",
                i.normalMap ? "#define USE_NORMALMAP" : "",
                i.normalMapObjectSpace ? "#define USE_NORMALMAP_OBJECTSPACE" : "",
                i.normalMapTangentSpace ? "#define USE_NORMALMAP_TANGENTSPACE" : "",
                i.emissiveMap ? "#define USE_EMISSIVEMAP" : "",
                i.anisotropy ? "#define USE_ANISOTROPY" : "",
                i.anisotropyMap ? "#define USE_ANISOTROPYMAP" : "",
                i.clearcoat ? "#define USE_CLEARCOAT" : "",
                i.clearcoatMap ? "#define USE_CLEARCOATMAP" : "",
                i.clearcoatRoughnessMap ? "#define USE_CLEARCOAT_ROUGHNESSMAP" : "",
                i.clearcoatNormalMap ? "#define USE_CLEARCOAT_NORMALMAP" : "",
                i.iridescence ? "#define USE_IRIDESCENCE" : "",
                i.iridescenceMap ? "#define USE_IRIDESCENCEMAP" : "",
                i.iridescenceThicknessMap ? "#define USE_IRIDESCENCE_THICKNESSMAP" : "",
                i.specularMap ? "#define USE_SPECULARMAP" : "",
                i.specularColorMap ? "#define USE_SPECULAR_COLORMAP" : "",
                i.specularIntensityMap ? "#define USE_SPECULAR_INTENSITYMAP" : "",
                i.roughnessMap ? "#define USE_ROUGHNESSMAP" : "",
                i.metalnessMap ? "#define USE_METALNESSMAP" : "",
                i.alphaMap ? "#define USE_ALPHAMAP" : "",
                i.alphaTest ? "#define USE_ALPHATEST" : "",
                i.alphaHash ? "#define USE_ALPHAHASH" : "",
                i.sheen ? "#define USE_SHEEN" : "",
                i.sheenColorMap ? "#define USE_SHEEN_COLORMAP" : "",
                i.sheenRoughnessMap ? "#define USE_SHEEN_ROUGHNESSMAP" : "",
                i.transmission ? "#define USE_TRANSMISSION" : "",
                i.transmissionMap ? "#define USE_TRANSMISSIONMAP" : "",
                i.thicknessMap ? "#define USE_THICKNESSMAP" : "",
                i.vertexTangents && !1 === i.flatShading ? "#define USE_TANGENT" : "",
                i.vertexColors || i.instancingColor ? "#define USE_COLOR" : "",
                i.vertexAlphas ? "#define USE_COLOR_ALPHA" : "",
                i.vertexUv1s ? "#define USE_UV1" : "",
                i.vertexUv2s ? "#define USE_UV2" : "",
                i.vertexUv3s ? "#define USE_UV3" : "",
                i.pointsUvs ? "#define USE_POINTS_UV" : "",
                i.gradientMap ? "#define USE_GRADIENTMAP" : "",
                i.flatShading ? "#define FLAT_SHADED" : "",
                i.doubleSided ? "#define DOUBLE_SIDED" : "",
                i.flipSided ? "#define FLIP_SIDED" : "",
                i.shadowMapEnabled ? "#define USE_SHADOWMAP" : "",
                i.shadowMapEnabled ? "#define " + l : "",
                i.premultipliedAlpha ? "#define PREMULTIPLIED_ALPHA" : "",
                i.numLightProbes > 0 ? "#define USE_LIGHT_PROBES" : "",
                i.useLegacyLights ? "#define LEGACY_LIGHTS" : "",
                i.decodeVideoTexture ? "#define DECODE_VIDEO_TEXTURE" : "",
                i.logarithmicDepthBuffer ? "#define USE_LOGDEPTHBUF" : "",
                i.logarithmicDepthBuffer && i.rendererExtensionFragDepth ? "#define USE_LOGDEPTHBUF_EXT" : "",
                "uniform mat4 viewMatrix;",
                "uniform vec3 cameraPosition;",
                "uniform bool isOrthographic;",
                i.toneMapping !== Br ? "#define TONE_MAPPING" : "",
                i.toneMapping !== Br ? nh.tonemapping_pars_fragment : "",
                i.toneMapping !== Br ? Yd("toneMapping", i.toneMapping) : "",
                i.dithering ? "#define DITHERING" : "",
                i.opaque ? "#define OPAQUE" : "",
                nh.colorspace_pars_fragment,
                Gd("linearToOutputTexel", i.outputColorSpace),
                i.useDepthPacking ? "#define DEPTH_PACKING " + i.depthPacking : "",
                "\n"
            ].filter(Wd).join("\n")), s = Kd(s), s = Xd(s, i), s = Zd(s, i), o = Kd(o), o = Xd(o, i), o = Zd(o, i), s = ep(s), o = ep(o), i.isWebGL2 && !0 !== i.isRawShaderMaterial && (M = "#version 300 es\n", g = [
                "precision mediump sampler2DArray;",
                "#define attribute in",
                "#define varying out",
                "#define texture2D texture"
            ].join("\n") + "\n" + g, m = [
                "precision mediump sampler2DArray;",
                "#define varying in",
                i.glslVersion === bo ? "" : "layout(location = 0) out highp vec4 pc_fragColor;",
                i.glslVersion === bo ? "" : "#define gl_FragColor pc_fragColor",
                "#define gl_FragDepthEXT gl_FragDepth",
                "#define texture2D texture",
                "#define textureCube texture",
                "#define texture2DProj textureProj",
                "#define texture2DLodEXT textureLod",
                "#define texture2DProjLodEXT textureProjLod",
                "#define textureCubeLodEXT textureLod",
                "#define texture2DGradEXT textureGrad",
                "#define texture2DProjGradEXT textureProjGrad",
                "#define textureCubeGradEXT textureGrad"
            ].join("\n") + "\n" + m);
            const y = M + g + s, v = M + m + o, x = Fd(r, r.VERTEX_SHADER, y), w = Fd(r, r.FRAGMENT_SHADER, v);
            function b(e) {
                if (t1.debug.checkShaderErrors) {
                    const i = r.getProgramInfoLog(A).trim(), n = r.getShaderInfoLog(x).trim(), a = r.getShaderInfoLog(w).trim();
                    let s = !0, o = !0;
                    if (!1 === r.getProgramParameter(A, r.LINK_STATUS)) {
                        if (s = !1, "function" == typeof t1.debug.onShaderError) t1.debug.onShaderError(r, A, x, w);
                        else {
                            const t1 = Vd(r, x, "vertex"), e = Vd(r, w, "fragment");
                            console.error("THREE.WebGLProgram: Shader Error " + r.getError() + " - VALIDATE_STATUS " + r.getProgramParameter(A, r.VALIDATE_STATUS) + "\n\nProgram Info Log: " + i + "\n" + t1 + "\n" + e);
                        }
                    } else "" !== i ? console.warn("THREE.WebGLProgram: Program Info Log:", i) : "" !== n && "" !== a || (o = !1);
                    o && (e.diagnostics = {
                        runnable: s,
                        programLog: i,
                        vertexShader: {
                            log: n,
                            prefix: g
                        },
                        fragmentShader: {
                            log: a,
                            prefix: m
                        }
                    });
                }
                r.deleteShader(x), r.deleteShader(w), T = new Bd(r, A), E = function(t1, e) {
                    const i = {}, n = t1.getProgramParameter(e, t1.ACTIVE_ATTRIBUTES);
                    for(let r = 0; r < n; r++){
                        const n = t1.getActiveAttrib(e, r), a = n.name;
                        let s = 1;
                        n.type === t1.FLOAT_MAT2 && (s = 2), n.type === t1.FLOAT_MAT3 && (s = 3), n.type === t1.FLOAT_MAT4 && (s = 4), i[a] = {
                            type: n.type,
                            location: t1.getAttribLocation(e, a),
                            locationSize: s
                        };
                    }
                    return i;
                }(r, A);
            }
            let T, E;
            r.attachShader(A, x), r.attachShader(A, w), void 0 !== i.index0AttributeName ? r.bindAttribLocation(A, 0, i.index0AttributeName) : !0 === i.morphTargets && r.bindAttribLocation(A, 0, "position"), r.linkProgram(A), this.getUniforms = function() {
                return void 0 === T && b(this), T;
            }, this.getAttributes = function() {
                return void 0 === E && b(this), E;
            };
            let I = !1 === i.rendererExtensionParallelShaderCompile;
            return this.isReady = function() {
                return !1 === I && (I = r.getProgramParameter(A, Qd)), I;
            }, this.destroy = function() {
                n.releaseStatesOfProgram(this), r.deleteProgram(A), this.program = void 0;
            }, this.type = i.shaderType, this.name = i.shaderName, this.id = Hd++, this.cacheKey = e, this.usedTimes = 1, this.program = A, this.vertexShader = x, this.fragmentShader = w, this;
        }
        let ap = 0;
        class sp {
            constructor(){
                this.shaderCache = new Map, this.materialCache = new Map;
            }
            update(t1) {
                const e = t1.vertexShader, i = t1.fragmentShader, n = this._getShaderStage(e), r = this._getShaderStage(i), a = this._getShaderCacheForMaterial(t1);
                return !1 === a.has(n) && (a.add(n), n.usedTimes++), !1 === a.has(r) && (a.add(r), r.usedTimes++), this;
            }
            remove(t1) {
                const e = this.materialCache.get(t1);
                for (const t1 of e)t1.usedTimes--, 0 === t1.usedTimes && this.shaderCache.delete(t1.code);
                return this.materialCache.delete(t1), this;
            }
            getVertexShaderID(t1) {
                return this._getShaderStage(t1.vertexShader).id;
            }
            getFragmentShaderID(t1) {
                return this._getShaderStage(t1.fragmentShader).id;
            }
            dispose() {
                this.shaderCache.clear(), this.materialCache.clear();
            }
            _getShaderCacheForMaterial(t1) {
                const e = this.materialCache;
                let i = e.get(t1);
                return void 0 === i && (i = new Set, e.set(t1, i)), i;
            }
            _getShaderStage(t1) {
                const e = this.shaderCache;
                let i = e.get(t1);
                return void 0 === i && (i = new op(t1), e.set(t1, i)), i;
            }
        }
        class op {
            constructor(t1){
                this.id = ap++, this.code = t1, this.usedTimes = 0;
            }
        }
        function lp(t1, e, i, n, r, a, s) {
            const o = new lc, l = new sp, c = [], u = r.isWebGL2, h = r.logarithmicDepthBuffer, d = r.vertexTextures;
            let p = r.precision;
            const f = {
                MeshDepthMaterial: "depth",
                MeshDistanceMaterial: "distanceRGBA",
                MeshNormalMaterial: "normal",
                MeshBasicMaterial: "basic",
                MeshLambertMaterial: "lambert",
                MeshPhongMaterial: "phong",
                MeshToonMaterial: "toon",
                MeshStandardMaterial: "physical",
                MeshPhysicalMaterial: "physical",
                MeshMatcapMaterial: "matcap",
                LineBasicMaterial: "basic",
                LineDashedMaterial: "dashed",
                PointsMaterial: "points",
                ShadowMaterial: "shadow",
                SpriteMaterial: "sprite"
            };
            function A(t1) {
                return 0 === t1 ? "uv" : `uv${t1}`;
            }
            return {
                getParameters: function(a, o, c, g, m) {
                    const M = g.fog, y = m.geometry, v = a.isMeshStandardMaterial ? g.environment : null, x = (a.isMeshStandardMaterial ? i : e).get(a.envMap || v), w = x && x.mapping === $r ? x.image.height : null, b = f[a.type];
                    null !== a.precision && (p = r.getMaxPrecision(a.precision), p !== a.precision && console.warn("THREE.WebGLProgram.getParameters:", a.precision, "not supported, using", p, "instead."));
                    const T = y.morphAttributes.position || y.morphAttributes.normal || y.morphAttributes.color, E = void 0 !== T ? T.length : 0;
                    let I, S, N, D, C = 0;
                    if (void 0 !== y.morphAttributes.position && (C = 1), void 0 !== y.morphAttributes.normal && (C = 2), void 0 !== y.morphAttributes.color && (C = 3), b) {
                        const t1 = ah[b];
                        I = t1.vertexShader, S = t1.fragmentShader;
                    } else I = a.vertexShader, S = a.fragmentShader, l.update(a), N = l.getVertexShaderID(a), D = l.getFragmentShaderID(a);
                    const z = t1.getRenderTarget(), L = !0 === m.isInstancedMesh, O = !!a.map, _ = !!a.matcap, j = !!x, P = !!a.aoMap, R = !!a.lightMap, U = !!a.bumpMap, k = !!a.normalMap, B = !!a.displacementMap, F = !!a.emissiveMap, Q = !!a.metalnessMap, H = !!a.roughnessMap, V = a.anisotropy > 0, G = a.clearcoat > 0, Y = a.iridescence > 0, W = a.sheen > 0, X = a.transmission > 0, Z = V && !!a.anisotropyMap, J = G && !!a.clearcoatMap, K = G && !!a.clearcoatNormalMap, q = G && !!a.clearcoatRoughnessMap, $ = Y && !!a.iridescenceMap, tt = Y && !!a.iridescenceThicknessMap, et = W && !!a.sheenColorMap, it = W && !!a.sheenRoughnessMap, nt = !!a.specularMap, rt = !!a.specularColorMap, at = !!a.specularIntensityMap, st = X && !!a.transmissionMap, ot = X && !!a.thicknessMap, lt = !!a.gradientMap, ct = !!a.alphaMap, ut = a.alphaTest > 0, ht = !!a.alphaHash, dt = !!a.extensions, pt = !!y.attributes.uv1, ft = !!y.attributes.uv2, At = !!y.attributes.uv3;
                    let gt = Br;
                    return a.toneMapped && (null !== z && !0 !== z.isXRRenderTarget || (gt = t1.toneMapping)), {
                        isWebGL2: u,
                        shaderID: b,
                        shaderType: a.type,
                        shaderName: a.name,
                        vertexShader: I,
                        fragmentShader: S,
                        defines: a.defines,
                        customVertexShaderID: N,
                        customFragmentShaderID: D,
                        isRawShaderMaterial: !0 === a.isRawShaderMaterial,
                        glslVersion: a.glslVersion,
                        precision: p,
                        instancing: L,
                        instancingColor: L && null !== m.instanceColor,
                        supportsVertexTextures: d,
                        outputColorSpace: null === z ? t1.outputColorSpace : !0 === z.isXRRenderTarget ? z.texture.colorSpace : js,
                        map: O,
                        matcap: _,
                        envMap: j,
                        envMapMode: j && x.mapping,
                        envMapCubeUVHeight: w,
                        aoMap: P,
                        lightMap: R,
                        bumpMap: U,
                        normalMap: k,
                        displacementMap: d && B,
                        emissiveMap: F,
                        normalMapObjectSpace: k && a.normalMapType === Ls,
                        normalMapTangentSpace: k && a.normalMapType === zs,
                        metalnessMap: Q,
                        roughnessMap: H,
                        anisotropy: V,
                        anisotropyMap: Z,
                        clearcoat: G,
                        clearcoatMap: J,
                        clearcoatNormalMap: K,
                        clearcoatRoughnessMap: q,
                        iridescence: Y,
                        iridescenceMap: $,
                        iridescenceThicknessMap: tt,
                        sheen: W,
                        sheenColorMap: et,
                        sheenRoughnessMap: it,
                        specularMap: nt,
                        specularColorMap: rt,
                        specularIntensityMap: at,
                        transmission: X,
                        transmissionMap: st,
                        thicknessMap: ot,
                        gradientMap: lt,
                        opaque: !1 === a.transparent && a.blending === rr,
                        alphaMap: ct,
                        alphaTest: ut,
                        alphaHash: ht,
                        combine: a.combine,
                        mapUv: O && A(a.map.channel),
                        aoMapUv: P && A(a.aoMap.channel),
                        lightMapUv: R && A(a.lightMap.channel),
                        bumpMapUv: U && A(a.bumpMap.channel),
                        normalMapUv: k && A(a.normalMap.channel),
                        displacementMapUv: B && A(a.displacementMap.channel),
                        emissiveMapUv: F && A(a.emissiveMap.channel),
                        metalnessMapUv: Q && A(a.metalnessMap.channel),
                        roughnessMapUv: H && A(a.roughnessMap.channel),
                        anisotropyMapUv: Z && A(a.anisotropyMap.channel),
                        clearcoatMapUv: J && A(a.clearcoatMap.channel),
                        clearcoatNormalMapUv: K && A(a.clearcoatNormalMap.channel),
                        clearcoatRoughnessMapUv: q && A(a.clearcoatRoughnessMap.channel),
                        iridescenceMapUv: $ && A(a.iridescenceMap.channel),
                        iridescenceThicknessMapUv: tt && A(a.iridescenceThicknessMap.channel),
                        sheenColorMapUv: et && A(a.sheenColorMap.channel),
                        sheenRoughnessMapUv: it && A(a.sheenRoughnessMap.channel),
                        specularMapUv: nt && A(a.specularMap.channel),
                        specularColorMapUv: rt && A(a.specularColorMap.channel),
                        specularIntensityMapUv: at && A(a.specularIntensityMap.channel),
                        transmissionMapUv: st && A(a.transmissionMap.channel),
                        thicknessMapUv: ot && A(a.thicknessMap.channel),
                        alphaMapUv: ct && A(a.alphaMap.channel),
                        vertexTangents: !!y.attributes.tangent && (k || V),
                        vertexColors: a.vertexColors,
                        vertexAlphas: !0 === a.vertexColors && !!y.attributes.color && 4 === y.attributes.color.itemSize,
                        vertexUv1s: pt,
                        vertexUv2s: ft,
                        vertexUv3s: At,
                        pointsUvs: !0 === m.isPoints && !!y.attributes.uv && (O || ct),
                        fog: !!M,
                        useFog: !0 === a.fog,
                        fogExp2: M && M.isFogExp2,
                        flatShading: !0 === a.flatShading,
                        sizeAttenuation: !0 === a.sizeAttenuation,
                        logarithmicDepthBuffer: h,
                        skinning: !0 === m.isSkinnedMesh,
                        morphTargets: void 0 !== y.morphAttributes.position,
                        morphNormals: void 0 !== y.morphAttributes.normal,
                        morphColors: void 0 !== y.morphAttributes.color,
                        morphTargetsCount: E,
                        morphTextureStride: C,
                        numDirLights: o.directional.length,
                        numPointLights: o.point.length,
                        numSpotLights: o.spot.length,
                        numSpotLightMaps: o.spotLightMap.length,
                        numRectAreaLights: o.rectArea.length,
                        numHemiLights: o.hemi.length,
                        numDirLightShadows: o.directionalShadowMap.length,
                        numPointLightShadows: o.pointShadowMap.length,
                        numSpotLightShadows: o.spotShadowMap.length,
                        numSpotLightShadowsWithMaps: o.numSpotLightShadowsWithMaps,
                        numLightProbes: o.numLightProbes,
                        numClippingPlanes: s.numPlanes,
                        numClipIntersection: s.numIntersection,
                        dithering: a.dithering,
                        shadowMapEnabled: t1.shadowMap.enabled && c.length > 0,
                        shadowMapType: t1.shadowMap.type,
                        toneMapping: gt,
                        useLegacyLights: t1._useLegacyLights,
                        decodeVideoTexture: O && !0 === a.map.isVideoTexture && il.getTransfer(a.map.colorSpace) === ks,
                        premultipliedAlpha: a.premultipliedAlpha,
                        doubleSided: a.side === er,
                        flipSided: a.side === tr,
                        useDepthPacking: a.depthPacking >= 0,
                        depthPacking: a.depthPacking || 0,
                        index0AttributeName: a.index0AttributeName,
                        extensionDerivatives: dt && !0 === a.extensions.derivatives,
                        extensionFragDepth: dt && !0 === a.extensions.fragDepth,
                        extensionDrawBuffers: dt && !0 === a.extensions.drawBuffers,
                        extensionShaderTextureLOD: dt && !0 === a.extensions.shaderTextureLOD,
                        rendererExtensionFragDepth: u || n.has("EXT_frag_depth"),
                        rendererExtensionDrawBuffers: u || n.has("WEBGL_draw_buffers"),
                        rendererExtensionShaderTextureLod: u || n.has("EXT_shader_texture_lod"),
                        rendererExtensionParallelShaderCompile: n.has("KHR_parallel_shader_compile"),
                        customProgramCacheKey: a.customProgramCacheKey()
                    };
                },
                getProgramCacheKey: function(e) {
                    const i = [];
                    if (e.shaderID ? i.push(e.shaderID) : (i.push(e.customVertexShaderID), i.push(e.customFragmentShaderID)), void 0 !== e.defines) for(const t1 in e.defines)i.push(t1), i.push(e.defines[t1]);
                    return !1 === e.isRawShaderMaterial && (function(t1, e) {
                        t1.push(e.precision), t1.push(e.outputColorSpace), t1.push(e.envMapMode), t1.push(e.envMapCubeUVHeight), t1.push(e.mapUv), t1.push(e.alphaMapUv), t1.push(e.lightMapUv), t1.push(e.aoMapUv), t1.push(e.bumpMapUv), t1.push(e.normalMapUv), t1.push(e.displacementMapUv), t1.push(e.emissiveMapUv), t1.push(e.metalnessMapUv), t1.push(e.roughnessMapUv), t1.push(e.anisotropyMapUv), t1.push(e.clearcoatMapUv), t1.push(e.clearcoatNormalMapUv), t1.push(e.clearcoatRoughnessMapUv), t1.push(e.iridescenceMapUv), t1.push(e.iridescenceThicknessMapUv), t1.push(e.sheenColorMapUv), t1.push(e.sheenRoughnessMapUv), t1.push(e.specularMapUv), t1.push(e.specularColorMapUv), t1.push(e.specularIntensityMapUv), t1.push(e.transmissionMapUv), t1.push(e.thicknessMapUv), t1.push(e.combine), t1.push(e.fogExp2), t1.push(e.sizeAttenuation), t1.push(e.morphTargetsCount), t1.push(e.morphAttributeCount), t1.push(e.numDirLights), t1.push(e.numPointLights), t1.push(e.numSpotLights), t1.push(e.numSpotLightMaps), t1.push(e.numHemiLights), t1.push(e.numRectAreaLights), t1.push(e.numDirLightShadows), t1.push(e.numPointLightShadows), t1.push(e.numSpotLightShadows), t1.push(e.numSpotLightShadowsWithMaps), t1.push(e.numLightProbes), t1.push(e.shadowMapType), t1.push(e.toneMapping), t1.push(e.numClippingPlanes), t1.push(e.numClipIntersection), t1.push(e.depthPacking);
                    }(i, e), function(t1, e) {
                        o.disableAll(), e.isWebGL2 && o.enable(0), e.supportsVertexTextures && o.enable(1), e.instancing && o.enable(2), e.instancingColor && o.enable(3), e.matcap && o.enable(4), e.envMap && o.enable(5), e.normalMapObjectSpace && o.enable(6), e.normalMapTangentSpace && o.enable(7), e.clearcoat && o.enable(8), e.iridescence && o.enable(9), e.alphaTest && o.enable(10), e.vertexColors && o.enable(11), e.vertexAlphas && o.enable(12), e.vertexUv1s && o.enable(13), e.vertexUv2s && o.enable(14), e.vertexUv3s && o.enable(15), e.vertexTangents && o.enable(16), e.anisotropy && o.enable(17), e.alphaHash && o.enable(18), t1.push(o.mask), o.disableAll(), e.fog && o.enable(0), e.useFog && o.enable(1), e.flatShading && o.enable(2), e.logarithmicDepthBuffer && o.enable(3), e.skinning && o.enable(4), e.morphTargets && o.enable(5), e.morphNormals && o.enable(6), e.morphColors && o.enable(7), e.premultipliedAlpha && o.enable(8), e.shadowMapEnabled && o.enable(9), e.useLegacyLights && o.enable(10), e.doubleSided && o.enable(11), e.flipSided && o.enable(12), e.useDepthPacking && o.enable(13), e.dithering && o.enable(14), e.transmission && o.enable(15), e.sheen && o.enable(16), e.opaque && o.enable(17), e.pointsUvs && o.enable(18), e.decodeVideoTexture && o.enable(19), t1.push(o.mask);
                    }(i, e), i.push(t1.outputColorSpace)), i.push(e.customProgramCacheKey), i.join();
                },
                getUniforms: function(t1) {
                    const e = f[t1.type];
                    let i;
                    if (e) {
                        const t1 = ah[e];
                        i = ku.clone(t1.uniforms);
                    } else i = t1.uniforms;
                    return i;
                },
                acquireProgram: function(e, i) {
                    let n;
                    for(let t1 = 0, e = c.length; t1 < e; t1++){
                        const e = c[t1];
                        if (e.cacheKey === i) {
                            n = e, ++n.usedTimes;
                            break;
                        }
                    }
                    return void 0 === n && (n = new rp(t1, i, e, a), c.push(n)), n;
                },
                releaseProgram: function(t1) {
                    if (0 == --t1.usedTimes) {
                        const e = c.indexOf(t1);
                        c[e] = c[c.length - 1], c.pop(), t1.destroy();
                    }
                },
                releaseShaderCache: function(t1) {
                    l.remove(t1);
                },
                programs: c,
                dispose: function() {
                    l.dispose();
                }
            };
        }
        function cp() {
            let t1 = new WeakMap;
            return {
                get: function(e) {
                    let i = t1.get(e);
                    return void 0 === i && (i = {}, t1.set(e, i)), i;
                },
                remove: function(e) {
                    t1.delete(e);
                },
                update: function(e, i, n) {
                    t1.get(e)[i] = n;
                },
                dispose: function() {
                    t1 = new WeakMap;
                }
            };
        }
        function up(t1, e) {
            return t1.groupOrder !== e.groupOrder ? t1.groupOrder - e.groupOrder : t1.renderOrder !== e.renderOrder ? t1.renderOrder - e.renderOrder : t1.material.id !== e.material.id ? t1.material.id - e.material.id : t1.z !== e.z ? t1.z - e.z : t1.id - e.id;
        }
        function hp(t1, e) {
            return t1.groupOrder !== e.groupOrder ? t1.groupOrder - e.groupOrder : t1.renderOrder !== e.renderOrder ? t1.renderOrder - e.renderOrder : t1.z !== e.z ? e.z - t1.z : t1.id - e.id;
        }
        function dp() {
            const t1 = [];
            let e = 0;
            const i = [], n = [], r = [];
            function a(i, n, r, a, s, o) {
                let l = t1[e];
                return void 0 === l ? (l = {
                    id: i.id,
                    object: i,
                    geometry: n,
                    material: r,
                    groupOrder: a,
                    renderOrder: i.renderOrder,
                    z: s,
                    group: o
                }, t1[e] = l) : (l.id = i.id, l.object = i, l.geometry = n, l.material = r, l.groupOrder = a, l.renderOrder = i.renderOrder, l.z = s, l.group = o), e++, l;
            }
            return {
                opaque: i,
                transmissive: n,
                transparent: r,
                init: function() {
                    e = 0, i.length = 0, n.length = 0, r.length = 0;
                },
                push: function(t1, e, s, o, l, c) {
                    const u = a(t1, e, s, o, l, c);
                    s.transmission > 0 ? n.push(u) : !0 === s.transparent ? r.push(u) : i.push(u);
                },
                unshift: function(t1, e, s, o, l, c) {
                    const u = a(t1, e, s, o, l, c);
                    s.transmission > 0 ? n.unshift(u) : !0 === s.transparent ? r.unshift(u) : i.unshift(u);
                },
                finish: function() {
                    for(let i = e, n = t1.length; i < n; i++){
                        const e = t1[i];
                        if (null === e.id) break;
                        e.id = null, e.object = null, e.geometry = null, e.material = null, e.group = null;
                    }
                },
                sort: function(t1, e) {
                    i.length > 1 && i.sort(t1 || up), n.length > 1 && n.sort(e || hp), r.length > 1 && r.sort(e || hp);
                }
            };
        }
        function pp() {
            let t1 = new WeakMap;
            return {
                get: function(e, i) {
                    const n = t1.get(e);
                    let r;
                    return void 0 === n ? (r = new dp, t1.set(e, [
                        r
                    ])) : i >= n.length ? (r = new dp, n.push(r)) : r = n[i], r;
                },
                dispose: function() {
                    t1 = new WeakMap;
                }
            };
        }
        function fp() {
            const t1 = {};
            return {
                get: function(e) {
                    if (void 0 !== t1[e.id]) return t1[e.id];
                    let i;
                    switch(e.type){
                        case "DirectionalLight":
                            i = {
                                direction: new xl,
                                color: new kc
                            };
                            break;
                        case "SpotLight":
                            i = {
                                position: new xl,
                                direction: new xl,
                                color: new kc,
                                distance: 0,
                                coneCos: 0,
                                penumbraCos: 0,
                                decay: 0
                            };
                            break;
                        case "PointLight":
                            i = {
                                position: new xl,
                                color: new kc,
                                distance: 0,
                                decay: 0
                            };
                            break;
                        case "HemisphereLight":
                            i = {
                                direction: new xl,
                                skyColor: new kc,
                                groundColor: new kc
                            };
                            break;
                        case "RectAreaLight":
                            i = {
                                color: new kc,
                                position: new xl,
                                halfWidth: new xl,
                                halfHeight: new xl
                            };
                    }
                    return t1[e.id] = i, i;
                }
            };
        }
        let Ap = 0;
        function gp(t1, e) {
            return (e.castShadow ? 2 : 0) - (t1.castShadow ? 2 : 0) + (e.map ? 1 : 0) - (t1.map ? 1 : 0);
        }
        function mp(t1, e) {
            const i = new fp, n = function() {
                const t1 = {};
                return {
                    get: function(e) {
                        if (void 0 !== t1[e.id]) return t1[e.id];
                        let i;
                        switch(e.type){
                            case "DirectionalLight":
                            case "SpotLight":
                                i = {
                                    shadowBias: 0,
                                    shadowNormalBias: 0,
                                    shadowRadius: 1,
                                    shadowMapSize: new Qo
                                };
                                break;
                            case "PointLight":
                                i = {
                                    shadowBias: 0,
                                    shadowNormalBias: 0,
                                    shadowRadius: 1,
                                    shadowMapSize: new Qo,
                                    shadowCameraNear: 1,
                                    shadowCameraFar: 1e3
                                };
                        }
                        return t1[e.id] = i, i;
                    }
                };
            }(), r = {
                version: 0,
                hash: {
                    directionalLength: -1,
                    pointLength: -1,
                    spotLength: -1,
                    rectAreaLength: -1,
                    hemiLength: -1,
                    numDirectionalShadows: -1,
                    numPointShadows: -1,
                    numSpotShadows: -1,
                    numSpotMaps: -1,
                    numLightProbes: -1
                },
                ambient: [
                    0,
                    0,
                    0
                ],
                probe: [],
                directional: [],
                directionalShadow: [],
                directionalShadowMap: [],
                directionalShadowMatrix: [],
                spot: [],
                spotLightMap: [],
                spotShadow: [],
                spotShadowMap: [],
                spotLightMatrix: [],
                rectArea: [],
                rectAreaLTC1: null,
                rectAreaLTC2: null,
                point: [],
                pointShadow: [],
                pointShadowMap: [],
                pointShadowMatrix: [],
                hemi: [],
                numSpotLightShadowsWithMaps: 0,
                numLightProbes: 0
            };
            for(let t1 = 0; t1 < 9; t1++)r.probe.push(new xl);
            const a = new xl, s = new Kl, o = new Kl;
            return {
                setup: function(a, s) {
                    let o = 0, l = 0, c = 0;
                    for(let t1 = 0; t1 < 9; t1++)r.probe[t1].set(0, 0, 0);
                    let u = 0, h = 0, d = 0, p = 0, f = 0, A = 0, g = 0, m = 0, M = 0, y = 0, v = 0;
                    a.sort(gp);
                    const x = !0 === s ? Math.PI : 1;
                    for(let t1 = 0, e = a.length; t1 < e; t1++){
                        const e = a[t1], s = e.color, w = e.intensity, b = e.distance, T = e.shadow && e.shadow.map ? e.shadow.map.texture : null;
                        if (e.isAmbientLight) o += s.r * w * x, l += s.g * w * x, c += s.b * w * x;
                        else if (e.isLightProbe) {
                            for(let t1 = 0; t1 < 9; t1++)r.probe[t1].addScaledVector(e.sh.coefficients[t1], w);
                            v++;
                        } else if (e.isDirectionalLight) {
                            const t1 = i.get(e);
                            if (t1.color.copy(e.color).multiplyScalar(e.intensity * x), e.castShadow) {
                                const t1 = e.shadow, i = n.get(e);
                                i.shadowBias = t1.bias, i.shadowNormalBias = t1.normalBias, i.shadowRadius = t1.radius, i.shadowMapSize = t1.mapSize, r.directionalShadow[u] = i, r.directionalShadowMap[u] = T, r.directionalShadowMatrix[u] = e.shadow.matrix, A++;
                            }
                            r.directional[u] = t1, u++;
                        } else if (e.isSpotLight) {
                            const t1 = i.get(e);
                            t1.position.setFromMatrixPosition(e.matrixWorld), t1.color.copy(s).multiplyScalar(w * x), t1.distance = b, t1.coneCos = Math.cos(e.angle), t1.penumbraCos = Math.cos(e.angle * (1 - e.penumbra)), t1.decay = e.decay, r.spot[d] = t1;
                            const a = e.shadow;
                            if (e.map && (r.spotLightMap[M] = e.map, M++, a.updateMatrices(e), e.castShadow && y++), r.spotLightMatrix[d] = a.matrix, e.castShadow) {
                                const t1 = n.get(e);
                                t1.shadowBias = a.bias, t1.shadowNormalBias = a.normalBias, t1.shadowRadius = a.radius, t1.shadowMapSize = a.mapSize, r.spotShadow[d] = t1, r.spotShadowMap[d] = T, m++;
                            }
                            d++;
                        } else if (e.isRectAreaLight) {
                            const t1 = i.get(e);
                            t1.color.copy(s).multiplyScalar(w), t1.halfWidth.set(.5 * e.width, 0, 0), t1.halfHeight.set(0, .5 * e.height, 0), r.rectArea[p] = t1, p++;
                        } else if (e.isPointLight) {
                            const t1 = i.get(e);
                            if (t1.color.copy(e.color).multiplyScalar(e.intensity * x), t1.distance = e.distance, t1.decay = e.decay, e.castShadow) {
                                const t1 = e.shadow, i = n.get(e);
                                i.shadowBias = t1.bias, i.shadowNormalBias = t1.normalBias, i.shadowRadius = t1.radius, i.shadowMapSize = t1.mapSize, i.shadowCameraNear = t1.camera.near, i.shadowCameraFar = t1.camera.far, r.pointShadow[h] = i, r.pointShadowMap[h] = T, r.pointShadowMatrix[h] = e.shadow.matrix, g++;
                            }
                            r.point[h] = t1, h++;
                        } else if (e.isHemisphereLight) {
                            const t1 = i.get(e);
                            t1.skyColor.copy(e.color).multiplyScalar(w * x), t1.groundColor.copy(e.groundColor).multiplyScalar(w * x), r.hemi[f] = t1, f++;
                        }
                    }
                    p > 0 && (e.isWebGL2 || !0 === t1.has("OES_texture_float_linear") ? (r.rectAreaLTC1 = rh.LTC_FLOAT_1, r.rectAreaLTC2 = rh.LTC_FLOAT_2) : !0 === t1.has("OES_texture_half_float_linear") ? (r.rectAreaLTC1 = rh.LTC_HALF_1, r.rectAreaLTC2 = rh.LTC_HALF_2) : console.error("THREE.WebGLRenderer: Unable to use RectAreaLight. Missing WebGL extensions.")), r.ambient[0] = o, r.ambient[1] = l, r.ambient[2] = c;
                    const w = r.hash;
                    w.directionalLength === u && w.pointLength === h && w.spotLength === d && w.rectAreaLength === p && w.hemiLength === f && w.numDirectionalShadows === A && w.numPointShadows === g && w.numSpotShadows === m && w.numSpotMaps === M && w.numLightProbes === v || (r.directional.length = u, r.spot.length = d, r.rectArea.length = p, r.point.length = h, r.hemi.length = f, r.directionalShadow.length = A, r.directionalShadowMap.length = A, r.pointShadow.length = g, r.pointShadowMap.length = g, r.spotShadow.length = m, r.spotShadowMap.length = m, r.directionalShadowMatrix.length = A, r.pointShadowMatrix.length = g, r.spotLightMatrix.length = m + M - y, r.spotLightMap.length = M, r.numSpotLightShadowsWithMaps = y, r.numLightProbes = v, w.directionalLength = u, w.pointLength = h, w.spotLength = d, w.rectAreaLength = p, w.hemiLength = f, w.numDirectionalShadows = A, w.numPointShadows = g, w.numSpotShadows = m, w.numSpotMaps = M, w.numLightProbes = v, r.version = Ap++);
                },
                setupView: function(t1, e) {
                    let i = 0, n = 0, l = 0, c = 0, u = 0;
                    const h = e.matrixWorldInverse;
                    for(let e = 0, d = t1.length; e < d; e++){
                        const d = t1[e];
                        if (d.isDirectionalLight) {
                            const t1 = r.directional[i];
                            t1.direction.setFromMatrixPosition(d.matrixWorld), a.setFromMatrixPosition(d.target.matrixWorld), t1.direction.sub(a), t1.direction.transformDirection(h), i++;
                        } else if (d.isSpotLight) {
                            const t1 = r.spot[l];
                            t1.position.setFromMatrixPosition(d.matrixWorld), t1.position.applyMatrix4(h), t1.direction.setFromMatrixPosition(d.matrixWorld), a.setFromMatrixPosition(d.target.matrixWorld), t1.direction.sub(a), t1.direction.transformDirection(h), l++;
                        } else if (d.isRectAreaLight) {
                            const t1 = r.rectArea[c];
                            t1.position.setFromMatrixPosition(d.matrixWorld), t1.position.applyMatrix4(h), o.identity(), s.copy(d.matrixWorld), s.premultiply(h), o.extractRotation(s), t1.halfWidth.set(.5 * d.width, 0, 0), t1.halfHeight.set(0, .5 * d.height, 0), t1.halfWidth.applyMatrix4(o), t1.halfHeight.applyMatrix4(o), c++;
                        } else if (d.isPointLight) {
                            const t1 = r.point[n];
                            t1.position.setFromMatrixPosition(d.matrixWorld), t1.position.applyMatrix4(h), n++;
                        } else if (d.isHemisphereLight) {
                            const t1 = r.hemi[u];
                            t1.direction.setFromMatrixPosition(d.matrixWorld), t1.direction.transformDirection(h), u++;
                        }
                    }
                },
                state: r
            };
        }
        function Mp(t1, e) {
            const i = new mp(t1, e), n = [], r = [];
            return {
                init: function() {
                    n.length = 0, r.length = 0;
                },
                state: {
                    lightsArray: n,
                    shadowsArray: r,
                    lights: i
                },
                setupLights: function(t1) {
                    i.setup(n, t1);
                },
                setupLightsView: function(t1) {
                    i.setupView(n, t1);
                },
                pushLight: function(t1) {
                    n.push(t1);
                },
                pushShadow: function(t1) {
                    r.push(t1);
                }
            };
        }
        function yp(t1, e) {
            let i = new WeakMap;
            return {
                get: function(n, r = 0) {
                    const a = i.get(n);
                    let s;
                    return void 0 === a ? (s = new Mp(t1, e), i.set(n, [
                        s
                    ])) : r >= a.length ? (s = new Mp(t1, e), a.push(s)) : s = a[r], s;
                },
                dispose: function() {
                    i = new WeakMap;
                }
            };
        }
        class vp extends Qc {
            constructor(t1){
                super(), this.isMeshDepthMaterial = !0, this.type = "MeshDepthMaterial", this.depthPacking = Ds, this.map = null, this.alphaMap = null, this.displacementMap = null, this.displacementScale = 1, this.displacementBias = 0, this.wireframe = !1, this.wireframeLinewidth = 1, this.setValues(t1);
            }
            copy(t1) {
                return super.copy(t1), this.depthPacking = t1.depthPacking, this.map = t1.map, this.alphaMap = t1.alphaMap, this.displacementMap = t1.displacementMap, this.displacementScale = t1.displacementScale, this.displacementBias = t1.displacementBias, this.wireframe = t1.wireframe, this.wireframeLinewidth = t1.wireframeLinewidth, this;
            }
        }
        class xp extends Qc {
            constructor(t1){
                super(), this.isMeshDistanceMaterial = !0, this.type = "MeshDistanceMaterial", this.map = null, this.alphaMap = null, this.displacementMap = null, this.displacementScale = 1, this.displacementBias = 0, this.setValues(t1);
            }
            copy(t1) {
                return super.copy(t1), this.map = t1.map, this.alphaMap = t1.alphaMap, this.displacementMap = t1.displacementMap, this.displacementScale = t1.displacementScale, this.displacementBias = t1.displacementBias, this;
            }
        }
        function wp(t1, e, i) {
            let n = new $u;
            const r = new Qo, a = new Qo, s = new dl, o = new vp({
                depthPacking: Cs
            }), l = new xp, c = {}, u = i.maxTextureSize, h = {
                [$n]: tr,
                [tr]: $n,
                [er]: er
            }, d = new Bu({
                defines: {
                    VSM_SAMPLES: 8
                },
                uniforms: {
                    shadow_pass: {
                        value: null
                    },
                    resolution: {
                        value: new Qo
                    },
                    radius: {
                        value: 4
                    }
                },
                vertexShader: "void main() {\n	gl_Position = vec4( position, 1.0 );\n}",
                fragmentShader: "uniform sampler2D shadow_pass;\nuniform vec2 resolution;\nuniform float radius;\n#include <packing>\nvoid main() {\n	const float samples = float( VSM_SAMPLES );\n	float mean = 0.0;\n	float squared_mean = 0.0;\n	float uvStride = samples <= 1.0 ? 0.0 : 2.0 / ( samples - 1.0 );\n	float uvStart = samples <= 1.0 ? 0.0 : - 1.0;\n	for ( float i = 0.0; i < samples; i ++ ) {\n		float uvOffset = uvStart + i * uvStride;\n		#ifdef HORIZONTAL_PASS\n			vec2 distribution = unpackRGBATo2Half( texture2D( shadow_pass, ( gl_FragCoord.xy + vec2( uvOffset, 0.0 ) * radius ) / resolution ) );\n			mean += distribution.x;\n			squared_mean += distribution.y * distribution.y + distribution.x * distribution.x;\n		#else\n			float depth = unpackRGBAToDepth( texture2D( shadow_pass, ( gl_FragCoord.xy + vec2( 0.0, uvOffset ) * radius ) / resolution ) );\n			mean += depth;\n			squared_mean += depth * depth;\n		#endif\n	}\n	mean = mean / samples;\n	squared_mean = squared_mean / samples;\n	float std_dev = sqrt( squared_mean - mean * mean );\n	gl_FragColor = pack2HalfToRGBA( vec2( mean, std_dev ) );\n}"
            }), p = d.clone();
            p.defines.HORIZONTAL_PASS = 1;
            const f = new Au;
            f.setAttribute("position", new Kc(new Float32Array([
                -1,
                -1,
                .5,
                3,
                -1,
                .5,
                -1,
                3,
                .5
            ]), 3));
            const A = new Ou(f, d), g = this;
            this.enabled = !1, this.autoUpdate = !0, this.needsUpdate = !1, this.type = Jn;
            let m = this.type;
            function M(i, n) {
                const a = e.update(A);
                d.defines.VSM_SAMPLES !== i.blurSamples && (d.defines.VSM_SAMPLES = i.blurSamples, p.defines.VSM_SAMPLES = i.blurSamples, d.needsUpdate = !0, p.needsUpdate = !0), null === i.mapPass && (i.mapPass = new fl(r.x, r.y)), d.uniforms.shadow_pass.value = i.map.texture, d.uniforms.resolution.value = i.mapSize, d.uniforms.radius.value = i.radius, t1.setRenderTarget(i.mapPass), t1.clear(), t1.renderBufferDirect(n, null, a, d, A, null), p.uniforms.shadow_pass.value = i.mapPass.texture, p.uniforms.resolution.value = i.mapSize, p.uniforms.radius.value = i.radius, t1.setRenderTarget(i.map), t1.clear(), t1.renderBufferDirect(n, null, a, p, A, null);
            }
            function y(e, i, n, r) {
                let a = null;
                const s = !0 === n.isPointLight ? e.customDistanceMaterial : e.customDepthMaterial;
                if (void 0 !== s) a = s;
                else if (a = !0 === n.isPointLight ? l : o, t1.localClippingEnabled && !0 === i.clipShadows && Array.isArray(i.clippingPlanes) && 0 !== i.clippingPlanes.length || i.displacementMap && 0 !== i.displacementScale || i.alphaMap && i.alphaTest > 0 || i.map && i.alphaTest > 0) {
                    const t1 = a.uuid, e = i.uuid;
                    let n = c[t1];
                    void 0 === n && (n = {}, c[t1] = n);
                    let r = n[e];
                    void 0 === r && (r = a.clone(), n[e] = r), a = r;
                }
                return a.visible = i.visible, a.wireframe = i.wireframe, a.side = r === qn ? null !== i.shadowSide ? i.shadowSide : i.side : null !== i.shadowSide ? i.shadowSide : h[i.side], a.alphaMap = i.alphaMap, a.alphaTest = i.alphaTest, a.map = i.map, a.clipShadows = i.clipShadows, a.clippingPlanes = i.clippingPlanes, a.clipIntersection = i.clipIntersection, a.displacementMap = i.displacementMap, a.displacementScale = i.displacementScale, a.displacementBias = i.displacementBias, a.wireframeLinewidth = i.wireframeLinewidth, a.linewidth = i.linewidth, !0 === n.isPointLight && !0 === a.isMeshDistanceMaterial && (t1.properties.get(a).light = n), a;
            }
            function v(i, r, a, s, o) {
                if (!1 === i.visible) return;
                if (i.layers.test(r.layers) && (i.isMesh || i.isLine || i.isPoints) && (i.castShadow || i.receiveShadow && o === qn) && (!i.frustumCulled || n.intersectsObject(i))) {
                    i.modelViewMatrix.multiplyMatrices(a.matrixWorldInverse, i.matrixWorld);
                    const n = e.update(i), r = i.material;
                    if (Array.isArray(r)) {
                        const e = n.groups;
                        for(let l = 0, c = e.length; l < c; l++){
                            const c = e[l], u = r[c.materialIndex];
                            if (u && u.visible) {
                                const e = y(i, u, s, o);
                                t1.renderBufferDirect(a, null, n, e, i, c);
                            }
                        }
                    } else if (r.visible) {
                        const e = y(i, r, s, o);
                        t1.renderBufferDirect(a, null, n, e, i, null);
                    }
                }
                const l = i.children;
                for(let t1 = 0, e = l.length; t1 < e; t1++)v(l[t1], r, a, s, o);
            }
            this.render = function(e, i, o) {
                if (!1 === g.enabled) return;
                if (!1 === g.autoUpdate && !1 === g.needsUpdate) return;
                if (0 === e.length) return;
                const l = t1.getRenderTarget(), c = t1.getActiveCubeFace(), h = t1.getActiveMipmapLevel(), d = t1.state;
                d.setBlending(nr), d.buffers.color.setClear(1, 1, 1, 1), d.buffers.depth.setTest(!0), d.setScissorTest(!1);
                const p = m !== qn && this.type === qn, f = m === qn && this.type !== qn;
                for(let l = 0, c = e.length; l < c; l++){
                    const c = e[l], h = c.shadow;
                    if (void 0 === h) {
                        console.warn("THREE.WebGLShadowMap:", c, "has no shadow.");
                        continue;
                    }
                    if (!1 === h.autoUpdate && !1 === h.needsUpdate) continue;
                    r.copy(h.mapSize);
                    const A = h.getFrameExtents();
                    if (r.multiply(A), a.copy(h.mapSize), (r.x > u || r.y > u) && (r.x > u && (a.x = Math.floor(u / A.x), r.x = a.x * A.x, h.mapSize.x = a.x), r.y > u && (a.y = Math.floor(u / A.y), r.y = a.y * A.y, h.mapSize.y = a.y)), null === h.map || !0 === p || !0 === f) {
                        const t1 = this.type !== qn ? {
                            minFilter: na,
                            magFilter: na
                        } : {};
                        null !== h.map && h.map.dispose(), h.map = new fl(r.x, r.y, t1), h.map.texture.name = c.name + ".shadowMap", h.camera.updateProjectionMatrix();
                    }
                    t1.setRenderTarget(h.map), t1.clear();
                    const g = h.getViewportCount();
                    for(let t1 = 0; t1 < g; t1++){
                        const e = h.getViewport(t1);
                        s.set(a.x * e.x, a.y * e.y, a.x * e.z, a.y * e.w), d.viewport(s), h.updateMatrices(c, t1), n = h.getFrustum(), v(i, o, h.camera, c, this.type);
                    }
                    !0 !== h.isPointLightShadow && this.type === qn && M(h, o), h.needsUpdate = !1;
                }
                m = this.type, g.needsUpdate = !1, t1.setRenderTarget(l, c, h);
            };
        }
        function bp(t1, e, i) {
            const n = i.isWebGL2, r = new function() {
                let e = !1;
                const i = new dl;
                let n = null;
                const r = new dl(0, 0, 0, 0);
                return {
                    setMask: function(i) {
                        n === i || e || (t1.colorMask(i, i, i, i), n = i);
                    },
                    setLocked: function(t1) {
                        e = t1;
                    },
                    setClear: function(e, n, a, s, o) {
                        !0 === o && (e *= s, n *= s, a *= s), i.set(e, n, a, s), !1 === r.equals(i) && (t1.clearColor(e, n, a, s), r.copy(i));
                    },
                    reset: function() {
                        e = !1, n = null, r.set(-1, 0, 0, 0);
                    }
                };
            }, a = new function() {
                let e = !1, i = null, n = null, r = null;
                return {
                    setTest: function(e) {
                        e ? Q(t1.DEPTH_TEST) : H(t1.DEPTH_TEST);
                    },
                    setMask: function(n) {
                        i === n || e || (t1.depthMask(n), i = n);
                    },
                    setFunc: function(e) {
                        if (n !== e) {
                            switch(e){
                                case Dr:
                                    t1.depthFunc(t1.NEVER);
                                    break;
                                case Cr:
                                    t1.depthFunc(t1.ALWAYS);
                                    break;
                                case zr:
                                    t1.depthFunc(t1.LESS);
                                    break;
                                case Lr:
                                    t1.depthFunc(t1.LEQUAL);
                                    break;
                                case Or:
                                    t1.depthFunc(t1.EQUAL);
                                    break;
                                case _r:
                                    t1.depthFunc(t1.GEQUAL);
                                    break;
                                case jr:
                                    t1.depthFunc(t1.GREATER);
                                    break;
                                case Pr:
                                    t1.depthFunc(t1.NOTEQUAL);
                                    break;
                                default:
                                    t1.depthFunc(t1.LEQUAL);
                            }
                            n = e;
                        }
                    },
                    setLocked: function(t1) {
                        e = t1;
                    },
                    setClear: function(e) {
                        r !== e && (t1.clearDepth(e), r = e);
                    },
                    reset: function() {
                        e = !1, i = null, n = null, r = null;
                    }
                };
            }, s = new function() {
                let e = !1, i = null, n = null, r = null, a = null, s = null, o = null, l = null, c = null;
                return {
                    setTest: function(i) {
                        e || (i ? Q(t1.STENCIL_TEST) : H(t1.STENCIL_TEST));
                    },
                    setMask: function(n) {
                        i === n || e || (t1.stencilMask(n), i = n);
                    },
                    setFunc: function(e, i, s) {
                        n === e && r === i && a === s || (t1.stencilFunc(e, i, s), n = e, r = i, a = s);
                    },
                    setOp: function(e, i, n) {
                        s === e && o === i && l === n || (t1.stencilOp(e, i, n), s = e, o = i, l = n);
                    },
                    setLocked: function(t1) {
                        e = t1;
                    },
                    setClear: function(e) {
                        c !== e && (t1.clearStencil(e), c = e);
                    },
                    reset: function() {
                        e = !1, i = null, n = null, r = null, a = null, s = null, o = null, l = null, c = null;
                    }
                };
            }, o = new WeakMap, l = new WeakMap;
            let c = {}, u = {}, h = new WeakMap, d = [], p = null, f = !1, A = null, g = null, m = null, M = null, y = null, v = null, x = null, w = new kc(0, 0, 0), b = 0, T = !1, E = null, I = null, S = null, N = null, D = null;
            const C = t1.getParameter(t1.MAX_COMBINED_TEXTURE_IMAGE_UNITS);
            let z = !1, L = 0;
            const O = t1.getParameter(t1.VERSION);
            -1 !== O.indexOf("WebGL") ? (L = parseFloat(/^WebGL (\d)/.exec(O)[1]), z = L >= 1) : -1 !== O.indexOf("OpenGL ES") && (L = parseFloat(/^OpenGL ES (\d)/.exec(O)[1]), z = L >= 2);
            let _ = null, j = {};
            const P = t1.getParameter(t1.SCISSOR_BOX), R = t1.getParameter(t1.VIEWPORT), U = (new dl).fromArray(P), k = (new dl).fromArray(R);
            function B(e, i, r, a) {
                const s = new Uint8Array(4), o = t1.createTexture();
                t1.bindTexture(e, o), t1.texParameteri(e, t1.TEXTURE_MIN_FILTER, t1.NEAREST), t1.texParameteri(e, t1.TEXTURE_MAG_FILTER, t1.NEAREST);
                for(let o = 0; o < r; o++)!n || e !== t1.TEXTURE_3D && e !== t1.TEXTURE_2D_ARRAY ? t1.texImage2D(i + o, 0, t1.RGBA, 1, 1, 0, t1.RGBA, t1.UNSIGNED_BYTE, s) : t1.texImage3D(i, 0, t1.RGBA, 1, 1, a, 0, t1.RGBA, t1.UNSIGNED_BYTE, s);
                return o;
            }
            const F = {};
            function Q(e) {
                !0 !== c[e] && (t1.enable(e), c[e] = !0);
            }
            function H(e) {
                !1 !== c[e] && (t1.disable(e), c[e] = !1);
            }
            F[t1.TEXTURE_2D] = B(t1.TEXTURE_2D, t1.TEXTURE_2D, 1), F[t1.TEXTURE_CUBE_MAP] = B(t1.TEXTURE_CUBE_MAP, t1.TEXTURE_CUBE_MAP_POSITIVE_X, 6), n && (F[t1.TEXTURE_2D_ARRAY] = B(t1.TEXTURE_2D_ARRAY, t1.TEXTURE_2D_ARRAY, 1, 1), F[t1.TEXTURE_3D] = B(t1.TEXTURE_3D, t1.TEXTURE_3D, 1, 1)), r.setClear(0, 0, 0, 1), a.setClear(1), s.setClear(0), Q(t1.DEPTH_TEST), a.setFunc(Lr), W(!1), X(Yn), Q(t1.CULL_FACE), Y(nr);
            const V = {
                [cr]: t1.FUNC_ADD,
                [ur]: t1.FUNC_SUBTRACT,
                [hr]: t1.FUNC_REVERSE_SUBTRACT
            };
            if (n) V[dr] = t1.MIN, V[pr] = t1.MAX;
            else {
                const t1 = e.get("EXT_blend_minmax");
                null !== t1 && (V[dr] = t1.MIN_EXT, V[pr] = t1.MAX_EXT);
            }
            const G = {
                [fr]: t1.ZERO,
                [Ar]: t1.ONE,
                [gr]: t1.SRC_COLOR,
                [Mr]: t1.SRC_ALPHA,
                [Tr]: t1.SRC_ALPHA_SATURATE,
                [wr]: t1.DST_COLOR,
                [vr]: t1.DST_ALPHA,
                [mr]: t1.ONE_MINUS_SRC_COLOR,
                [yr]: t1.ONE_MINUS_SRC_ALPHA,
                [br]: t1.ONE_MINUS_DST_COLOR,
                [xr]: t1.ONE_MINUS_DST_ALPHA,
                [Er]: t1.CONSTANT_COLOR,
                [Ir]: t1.ONE_MINUS_CONSTANT_COLOR,
                [Sr]: t1.CONSTANT_ALPHA,
                [Nr]: t1.ONE_MINUS_CONSTANT_ALPHA
            };
            function Y(e, i, n, r, a, s, o, l, c, u) {
                if (e !== nr) {
                    if (!1 === f && (Q(t1.BLEND), f = !0), e === lr) a = a || i, s = s || n, o = o || r, i === g && a === y || (t1.blendEquationSeparate(V[i], V[a]), g = i, y = a), n === m && r === M && s === v && o === x || (t1.blendFuncSeparate(G[n], G[r], G[s], G[o]), m = n, M = r, v = s, x = o), !1 !== l.equals(w) && c === b || (t1.blendColor(l.r, l.g, l.b, c), w.copy(l), b = c), A = e, T = !1;
                    else if (e !== A || u !== T) {
                        if (g === cr && y === cr || (t1.blendEquation(t1.FUNC_ADD), g = cr, y = cr), u) switch(e){
                            case rr:
                                t1.blendFuncSeparate(t1.ONE, t1.ONE_MINUS_SRC_ALPHA, t1.ONE, t1.ONE_MINUS_SRC_ALPHA);
                                break;
                            case ar:
                                t1.blendFunc(t1.ONE, t1.ONE);
                                break;
                            case sr:
                                t1.blendFuncSeparate(t1.ZERO, t1.ONE_MINUS_SRC_COLOR, t1.ZERO, t1.ONE);
                                break;
                            case or:
                                t1.blendFuncSeparate(t1.ZERO, t1.SRC_COLOR, t1.ZERO, t1.SRC_ALPHA);
                                break;
                            default:
                                console.error("THREE.WebGLState: Invalid blending: ", e);
                        }
                        else switch(e){
                            case rr:
                                t1.blendFuncSeparate(t1.SRC_ALPHA, t1.ONE_MINUS_SRC_ALPHA, t1.ONE, t1.ONE_MINUS_SRC_ALPHA);
                                break;
                            case ar:
                                t1.blendFunc(t1.SRC_ALPHA, t1.ONE);
                                break;
                            case sr:
                                t1.blendFuncSeparate(t1.ZERO, t1.ONE_MINUS_SRC_COLOR, t1.ZERO, t1.ONE);
                                break;
                            case or:
                                t1.blendFunc(t1.ZERO, t1.SRC_COLOR);
                                break;
                            default:
                                console.error("THREE.WebGLState: Invalid blending: ", e);
                        }
                        m = null, M = null, v = null, x = null, w.set(0, 0, 0), b = 0, A = e, T = u;
                    }
                } else !0 === f && (H(t1.BLEND), f = !1);
            }
            function W(e) {
                E !== e && (e ? t1.frontFace(t1.CW) : t1.frontFace(t1.CCW), E = e);
            }
            function X(e) {
                e !== Gn ? (Q(t1.CULL_FACE), e !== I && (e === Yn ? t1.cullFace(t1.BACK) : e === Wn ? t1.cullFace(t1.FRONT) : t1.cullFace(t1.FRONT_AND_BACK))) : H(t1.CULL_FACE), I = e;
            }
            function Z(e, i, n) {
                e ? (Q(t1.POLYGON_OFFSET_FILL), N === i && D === n || (t1.polygonOffset(i, n), N = i, D = n)) : H(t1.POLYGON_OFFSET_FILL);
            }
            return {
                buffers: {
                    color: r,
                    depth: a,
                    stencil: s
                },
                enable: Q,
                disable: H,
                bindFramebuffer: function(e, i) {
                    return u[e] !== i && (t1.bindFramebuffer(e, i), u[e] = i, n && (e === t1.DRAW_FRAMEBUFFER && (u[t1.FRAMEBUFFER] = i), e === t1.FRAMEBUFFER && (u[t1.DRAW_FRAMEBUFFER] = i)), !0);
                },
                drawBuffers: function(n, r) {
                    let a = d, s = !1;
                    if (n) {
                        if (a = h.get(r), void 0 === a && (a = [], h.set(r, a)), n.isWebGLMultipleRenderTargets) {
                            const e = n.texture;
                            if (a.length !== e.length || a[0] !== t1.COLOR_ATTACHMENT0) {
                                for(let i = 0, n = e.length; i < n; i++)a[i] = t1.COLOR_ATTACHMENT0 + i;
                                a.length = e.length, s = !0;
                            }
                        } else a[0] !== t1.COLOR_ATTACHMENT0 && (a[0] = t1.COLOR_ATTACHMENT0, s = !0);
                    } else a[0] !== t1.BACK && (a[0] = t1.BACK, s = !0);
                    s && (i.isWebGL2 ? t1.drawBuffers(a) : e.get("WEBGL_draw_buffers").drawBuffersWEBGL(a));
                },
                useProgram: function(e) {
                    return p !== e && (t1.useProgram(e), p = e, !0);
                },
                setBlending: Y,
                setMaterial: function(e, i) {
                    e.side === er ? H(t1.CULL_FACE) : Q(t1.CULL_FACE);
                    let n = e.side === tr;
                    i && (n = !n), W(n), e.blending === rr && !1 === e.transparent ? Y(nr) : Y(e.blending, e.blendEquation, e.blendSrc, e.blendDst, e.blendEquationAlpha, e.blendSrcAlpha, e.blendDstAlpha, e.blendColor, e.blendAlpha, e.premultipliedAlpha), a.setFunc(e.depthFunc), a.setTest(e.depthTest), a.setMask(e.depthWrite), r.setMask(e.colorWrite);
                    const o = e.stencilWrite;
                    s.setTest(o), o && (s.setMask(e.stencilWriteMask), s.setFunc(e.stencilFunc, e.stencilRef, e.stencilFuncMask), s.setOp(e.stencilFail, e.stencilZFail, e.stencilZPass)), Z(e.polygonOffset, e.polygonOffsetFactor, e.polygonOffsetUnits), !0 === e.alphaToCoverage ? Q(t1.SAMPLE_ALPHA_TO_COVERAGE) : H(t1.SAMPLE_ALPHA_TO_COVERAGE);
                },
                setFlipSided: W,
                setCullFace: X,
                setLineWidth: function(e) {
                    e !== S && (z && t1.lineWidth(e), S = e);
                },
                setPolygonOffset: Z,
                setScissorTest: function(e) {
                    e ? Q(t1.SCISSOR_TEST) : H(t1.SCISSOR_TEST);
                },
                activeTexture: function(e) {
                    void 0 === e && (e = t1.TEXTURE0 + C - 1), _ !== e && (t1.activeTexture(e), _ = e);
                },
                bindTexture: function(e, i, n) {
                    void 0 === n && (n = null === _ ? t1.TEXTURE0 + C - 1 : _);
                    let r = j[n];
                    void 0 === r && (r = {
                        type: void 0,
                        texture: void 0
                    }, j[n] = r), r.type === e && r.texture === i || (_ !== n && (t1.activeTexture(n), _ = n), t1.bindTexture(e, i || F[e]), r.type = e, r.texture = i);
                },
                unbindTexture: function() {
                    const e = j[_];
                    void 0 !== e && void 0 !== e.type && (t1.bindTexture(e.type, null), e.type = void 0, e.texture = void 0);
                },
                compressedTexImage2D: function() {
                    try {
                        t1.compressedTexImage2D.apply(t1, arguments);
                    } catch (t1) {
                        console.error("THREE.WebGLState:", t1);
                    }
                },
                compressedTexImage3D: function() {
                    try {
                        t1.compressedTexImage3D.apply(t1, arguments);
                    } catch (t1) {
                        console.error("THREE.WebGLState:", t1);
                    }
                },
                texImage2D: function() {
                    try {
                        t1.texImage2D.apply(t1, arguments);
                    } catch (t1) {
                        console.error("THREE.WebGLState:", t1);
                    }
                },
                texImage3D: function() {
                    try {
                        t1.texImage3D.apply(t1, arguments);
                    } catch (t1) {
                        console.error("THREE.WebGLState:", t1);
                    }
                },
                updateUBOMapping: function(e, i) {
                    let n = l.get(i);
                    void 0 === n && (n = new WeakMap, l.set(i, n));
                    let r = n.get(e);
                    void 0 === r && (r = t1.getUniformBlockIndex(i, e.name), n.set(e, r));
                },
                uniformBlockBinding: function(e, i) {
                    const n = l.get(i).get(e);
                    o.get(i) !== n && (t1.uniformBlockBinding(i, n, e.__bindingPointIndex), o.set(i, n));
                },
                texStorage2D: function() {
                    try {
                        t1.texStorage2D.apply(t1, arguments);
                    } catch (t1) {
                        console.error("THREE.WebGLState:", t1);
                    }
                },
                texStorage3D: function() {
                    try {
                        t1.texStorage3D.apply(t1, arguments);
                    } catch (t1) {
                        console.error("THREE.WebGLState:", t1);
                    }
                },
                texSubImage2D: function() {
                    try {
                        t1.texSubImage2D.apply(t1, arguments);
                    } catch (t1) {
                        console.error("THREE.WebGLState:", t1);
                    }
                },
                texSubImage3D: function() {
                    try {
                        t1.texSubImage3D.apply(t1, arguments);
                    } catch (t1) {
                        console.error("THREE.WebGLState:", t1);
                    }
                },
                compressedTexSubImage2D: function() {
                    try {
                        t1.compressedTexSubImage2D.apply(t1, arguments);
                    } catch (t1) {
                        console.error("THREE.WebGLState:", t1);
                    }
                },
                compressedTexSubImage3D: function() {
                    try {
                        t1.compressedTexSubImage3D.apply(t1, arguments);
                    } catch (t1) {
                        console.error("THREE.WebGLState:", t1);
                    }
                },
                scissor: function(e) {
                    !1 === U.equals(e) && (t1.scissor(e.x, e.y, e.z, e.w), U.copy(e));
                },
                viewport: function(e) {
                    !1 === k.equals(e) && (t1.viewport(e.x, e.y, e.z, e.w), k.copy(e));
                },
                reset: function() {
                    t1.disable(t1.BLEND), t1.disable(t1.CULL_FACE), t1.disable(t1.DEPTH_TEST), t1.disable(t1.POLYGON_OFFSET_FILL), t1.disable(t1.SCISSOR_TEST), t1.disable(t1.STENCIL_TEST), t1.disable(t1.SAMPLE_ALPHA_TO_COVERAGE), t1.blendEquation(t1.FUNC_ADD), t1.blendFunc(t1.ONE, t1.ZERO), t1.blendFuncSeparate(t1.ONE, t1.ZERO, t1.ONE, t1.ZERO), t1.blendColor(0, 0, 0, 0), t1.colorMask(!0, !0, !0, !0), t1.clearColor(0, 0, 0, 0), t1.depthMask(!0), t1.depthFunc(t1.LESS), t1.clearDepth(1), t1.stencilMask(4294967295), t1.stencilFunc(t1.ALWAYS, 0, 4294967295), t1.stencilOp(t1.KEEP, t1.KEEP, t1.KEEP), t1.clearStencil(0), t1.cullFace(t1.BACK), t1.frontFace(t1.CCW), t1.polygonOffset(0, 0), t1.activeTexture(t1.TEXTURE0), t1.bindFramebuffer(t1.FRAMEBUFFER, null), !0 === n && (t1.bindFramebuffer(t1.DRAW_FRAMEBUFFER, null), t1.bindFramebuffer(t1.READ_FRAMEBUFFER, null)), t1.useProgram(null), t1.lineWidth(1), t1.scissor(0, 0, t1.canvas.width, t1.canvas.height), t1.viewport(0, 0, t1.canvas.width, t1.canvas.height), c = {}, _ = null, j = {}, u = {}, h = new WeakMap, d = [], p = null, f = !1, A = null, g = null, m = null, M = null, y = null, v = null, x = null, w = new kc(0, 0, 0), b = 0, T = !1, E = null, I = null, S = null, N = null, D = null, U.set(0, 0, t1.canvas.width, t1.canvas.height), k.set(0, 0, t1.canvas.width, t1.canvas.height), r.reset(), a.reset(), s.reset();
                }
            };
        }
        function Tp(t1, e, i, n, r, a, s) {
            const o = r.isWebGL2, l = r.maxTextures, c = r.maxCubemapSize, u = r.maxTextureSize, h = r.maxSamples, d = e.has("WEBGL_multisampled_render_to_texture") ? e.get("WEBGL_multisampled_render_to_texture") : null, p = "undefined" != typeof navigator && /OculusBrowser/g.test(navigator.userAgent), f = new WeakMap;
            let A;
            const g = new WeakMap;
            let m = !1;
            try {
                m = "undefined" != typeof OffscreenCanvas && null !== new OffscreenCanvas(1, 1).getContext("2d");
            } catch (t1) {}
            function M(t1, e) {
                return m ? new OffscreenCanvas(t1, e) : Xo("canvas");
            }
            function y(t1, e, i, n) {
                let r = 1;
                if ((t1.width > n || t1.height > n) && (r = n / Math.max(t1.width, t1.height)), r < 1 || !0 === e) {
                    if ("undefined" != typeof HTMLImageElement && t1 instanceof HTMLImageElement || "undefined" != typeof HTMLCanvasElement && t1 instanceof HTMLCanvasElement || "undefined" != typeof ImageBitmap && t1 instanceof ImageBitmap) {
                        const n = e ? Uo : Math.floor, a = n(r * t1.width), s = n(r * t1.height);
                        void 0 === A && (A = M(a, s));
                        const o = i ? M(a, s) : A;
                        return o.width = a, o.height = s, o.getContext("2d").drawImage(t1, 0, 0, a, s), console.warn("THREE.WebGLRenderer: Texture has been resized from (" + t1.width + "x" + t1.height + ") to (" + a + "x" + s + ")."), o;
                    }
                    return "data" in t1 && console.warn("THREE.WebGLRenderer: Image in DataTexture is too big (" + t1.width + "x" + t1.height + ")."), t1;
                }
                return t1;
            }
            function v(t1) {
                return Po(t1.width) && Po(t1.height);
            }
            function x(t1, e) {
                return t1.generateMipmaps && e && t1.minFilter !== na && t1.minFilter !== la;
            }
            function w(e) {
                t1.generateMipmap(e);
            }
            function b(i, n, r, a, s = !1) {
                if (!1 === o) return n;
                if (null !== i) {
                    if (void 0 !== t1[i]) return t1[i];
                    console.warn("THREE.WebGLRenderer: Attempt to use non-existing WebGL internal format '" + i + "'");
                }
                let l = n;
                if (n === t1.RED && (r === t1.FLOAT && (l = t1.R32F), r === t1.HALF_FLOAT && (l = t1.R16F), r === t1.UNSIGNED_BYTE && (l = t1.R8)), n === t1.RED_INTEGER && (r === t1.UNSIGNED_BYTE && (l = t1.R8UI), r === t1.UNSIGNED_SHORT && (l = t1.R16UI), r === t1.UNSIGNED_INT && (l = t1.R32UI), r === t1.BYTE && (l = t1.R8I), r === t1.SHORT && (l = t1.R16I), r === t1.INT && (l = t1.R32I)), n === t1.RG && (r === t1.FLOAT && (l = t1.RG32F), r === t1.HALF_FLOAT && (l = t1.RG16F), r === t1.UNSIGNED_BYTE && (l = t1.RG8)), n === t1.RGBA) {
                    const e = s ? Us : il.getTransfer(a);
                    r === t1.FLOAT && (l = t1.RGBA32F), r === t1.HALF_FLOAT && (l = t1.RGBA16F), r === t1.UNSIGNED_BYTE && (l = e === ks ? t1.SRGB8_ALPHA8 : t1.RGBA8), r === t1.UNSIGNED_SHORT_4_4_4_4 && (l = t1.RGBA4), r === t1.UNSIGNED_SHORT_5_5_5_1 && (l = t1.RGB5_A1);
                }
                return l !== t1.R16F && l !== t1.R32F && l !== t1.RG16F && l !== t1.RG32F && l !== t1.RGBA16F && l !== t1.RGBA32F || e.get("EXT_color_buffer_float"), l;
            }
            function T(t1, e, i) {
                return !0 === x(t1, i) || t1.isFramebufferTexture && t1.minFilter !== na && t1.minFilter !== la ? Math.log2(Math.max(e.width, e.height)) + 1 : void 0 !== t1.mipmaps && t1.mipmaps.length > 0 ? t1.mipmaps.length : t1.isCompressedTexture && Array.isArray(t1.image) ? e.mipmaps.length : 1;
            }
            function E(e) {
                return e === na || e === ra || e === sa ? t1.NEAREST : t1.LINEAR;
            }
            function I(t1) {
                const e = t1.target;
                e.removeEventListener("dispose", I), function(t1) {
                    const e = n.get(t1);
                    if (void 0 === e.__webglInit) return;
                    const i = t1.source, r = g.get(i);
                    if (r) {
                        const n = r[e.__cacheKey];
                        n.usedTimes--, 0 === n.usedTimes && N(t1), 0 === Object.keys(r).length && g.delete(i);
                    }
                    n.remove(t1);
                }(e), e.isVideoTexture && f.delete(e);
            }
            function S(e) {
                const i = e.target;
                i.removeEventListener("dispose", S), function(e) {
                    const i = e.texture, r = n.get(e), a = n.get(i);
                    if (void 0 !== a.__webglTexture && (t1.deleteTexture(a.__webglTexture), s.memory.textures--), e.depthTexture && e.depthTexture.dispose(), e.isWebGLCubeRenderTarget) for(let e = 0; e < 6; e++){
                        if (Array.isArray(r.__webglFramebuffer[e])) for(let i = 0; i < r.__webglFramebuffer[e].length; i++)t1.deleteFramebuffer(r.__webglFramebuffer[e][i]);
                        else t1.deleteFramebuffer(r.__webglFramebuffer[e]);
                        r.__webglDepthbuffer && t1.deleteRenderbuffer(r.__webglDepthbuffer[e]);
                    }
                    else {
                        if (Array.isArray(r.__webglFramebuffer)) for(let e = 0; e < r.__webglFramebuffer.length; e++)t1.deleteFramebuffer(r.__webglFramebuffer[e]);
                        else t1.deleteFramebuffer(r.__webglFramebuffer);
                        if (r.__webglDepthbuffer && t1.deleteRenderbuffer(r.__webglDepthbuffer), r.__webglMultisampledFramebuffer && t1.deleteFramebuffer(r.__webglMultisampledFramebuffer), r.__webglColorRenderbuffer) for(let e = 0; e < r.__webglColorRenderbuffer.length; e++)r.__webglColorRenderbuffer[e] && t1.deleteRenderbuffer(r.__webglColorRenderbuffer[e]);
                        r.__webglDepthRenderbuffer && t1.deleteRenderbuffer(r.__webglDepthRenderbuffer);
                    }
                    if (e.isWebGLMultipleRenderTargets) for(let e = 0, r = i.length; e < r; e++){
                        const r = n.get(i[e]);
                        r.__webglTexture && (t1.deleteTexture(r.__webglTexture), s.memory.textures--), n.remove(i[e]);
                    }
                    n.remove(i), n.remove(e);
                }(i);
            }
            function N(e) {
                const i = n.get(e);
                t1.deleteTexture(i.__webglTexture);
                const r = e.source;
                delete g.get(r)[i.__cacheKey], s.memory.textures--;
            }
            let D = 0;
            function C(e, r) {
                const a = n.get(e);
                if (e.isVideoTexture && function(t1) {
                    const e = s.render.frame;
                    f.get(t1) !== e && (f.set(t1, e), t1.update());
                }(e), !1 === e.isRenderTargetTexture && e.version > 0 && a.__version !== e.version) {
                    const t1 = e.image;
                    if (null === t1) console.warn("THREE.WebGLRenderer: Texture marked for update but no image data found.");
                    else {
                        if (!1 !== t1.complete) return void P(a, e, r);
                        console.warn("THREE.WebGLRenderer: Texture marked for update but image is incomplete");
                    }
                }
                i.bindTexture(t1.TEXTURE_2D, a.__webglTexture, t1.TEXTURE0 + r);
            }
            const z = {
                [ta]: t1.REPEAT,
                [ea]: t1.CLAMP_TO_EDGE,
                [ia]: t1.MIRRORED_REPEAT
            }, L = {
                [na]: t1.NEAREST,
                [ra]: t1.NEAREST_MIPMAP_NEAREST,
                [sa]: t1.NEAREST_MIPMAP_LINEAR,
                [la]: t1.LINEAR,
                [ca]: t1.LINEAR_MIPMAP_NEAREST,
                [ha]: t1.LINEAR_MIPMAP_LINEAR
            }, O = {
                [ro]: t1.NEVER,
                [ho]: t1.ALWAYS,
                [ao]: t1.LESS,
                [oo]: t1.LEQUAL,
                [so]: t1.EQUAL,
                [uo]: t1.GEQUAL,
                [lo]: t1.GREATER,
                [co]: t1.NOTEQUAL
            };
            function _(i, a, s) {
                if (s ? (t1.texParameteri(i, t1.TEXTURE_WRAP_S, z[a.wrapS]), t1.texParameteri(i, t1.TEXTURE_WRAP_T, z[a.wrapT]), i !== t1.TEXTURE_3D && i !== t1.TEXTURE_2D_ARRAY || t1.texParameteri(i, t1.TEXTURE_WRAP_R, z[a.wrapR]), t1.texParameteri(i, t1.TEXTURE_MAG_FILTER, L[a.magFilter]), t1.texParameteri(i, t1.TEXTURE_MIN_FILTER, L[a.minFilter])) : (t1.texParameteri(i, t1.TEXTURE_WRAP_S, t1.CLAMP_TO_EDGE), t1.texParameteri(i, t1.TEXTURE_WRAP_T, t1.CLAMP_TO_EDGE), i !== t1.TEXTURE_3D && i !== t1.TEXTURE_2D_ARRAY || t1.texParameteri(i, t1.TEXTURE_WRAP_R, t1.CLAMP_TO_EDGE), a.wrapS === ea && a.wrapT === ea || console.warn("THREE.WebGLRenderer: Texture is not power of two. Texture.wrapS and Texture.wrapT should be set to THREE.ClampToEdgeWrapping."), t1.texParameteri(i, t1.TEXTURE_MAG_FILTER, E(a.magFilter)), t1.texParameteri(i, t1.TEXTURE_MIN_FILTER, E(a.minFilter)), a.minFilter !== na && a.minFilter !== la && console.warn("THREE.WebGLRenderer: Texture is not power of two. Texture.minFilter should be set to THREE.NearestFilter or THREE.LinearFilter.")), a.compareFunction && (t1.texParameteri(i, t1.TEXTURE_COMPARE_MODE, t1.COMPARE_REF_TO_TEXTURE), t1.texParameteri(i, t1.TEXTURE_COMPARE_FUNC, O[a.compareFunction])), !0 === e.has("EXT_texture_filter_anisotropic")) {
                    const s = e.get("EXT_texture_filter_anisotropic");
                    if (a.magFilter === na) return;
                    if (a.minFilter !== sa && a.minFilter !== ha) return;
                    if (a.type === ya && !1 === e.has("OES_texture_float_linear")) return;
                    if (!1 === o && a.type === va && !1 === e.has("OES_texture_half_float_linear")) return;
                    (a.anisotropy > 1 || n.get(a).__currentAnisotropy) && (t1.texParameterf(i, s.TEXTURE_MAX_ANISOTROPY_EXT, Math.min(a.anisotropy, r.getMaxAnisotropy())), n.get(a).__currentAnisotropy = a.anisotropy);
                }
            }
            function j(e, i) {
                let n = !1;
                void 0 === e.__webglInit && (e.__webglInit = !0, i.addEventListener("dispose", I));
                const r = i.source;
                let a = g.get(r);
                void 0 === a && (a = {}, g.set(r, a));
                const o = function(t1) {
                    const e = [];
                    return e.push(t1.wrapS), e.push(t1.wrapT), e.push(t1.wrapR || 0), e.push(t1.magFilter), e.push(t1.minFilter), e.push(t1.anisotropy), e.push(t1.internalFormat), e.push(t1.format), e.push(t1.type), e.push(t1.generateMipmaps), e.push(t1.premultiplyAlpha), e.push(t1.flipY), e.push(t1.unpackAlignment), e.push(t1.colorSpace), e.join();
                }(i);
                if (o !== e.__cacheKey) {
                    void 0 === a[o] && (a[o] = {
                        texture: t1.createTexture(),
                        usedTimes: 0
                    }, s.memory.textures++, n = !0), a[o].usedTimes++;
                    const r = a[e.__cacheKey];
                    void 0 !== r && (a[e.__cacheKey].usedTimes--, 0 === r.usedTimes && N(i)), e.__cacheKey = o, e.__webglTexture = a[o].texture;
                }
                return n;
            }
            function P(e, r, s) {
                let l = t1.TEXTURE_2D;
                (r.isDataArrayTexture || r.isCompressedArrayTexture) && (l = t1.TEXTURE_2D_ARRAY), r.isData3DTexture && (l = t1.TEXTURE_3D);
                const c = j(e, r), h = r.source;
                i.bindTexture(l, e.__webglTexture, t1.TEXTURE0 + s);
                const d = n.get(h);
                if (h.version !== d.__version || !0 === c) {
                    i.activeTexture(t1.TEXTURE0 + s);
                    const e = il.getPrimaries(il.workingColorSpace), n = r.colorSpace === Os ? null : il.getPrimaries(r.colorSpace), p = r.colorSpace === Os || e === n ? t1.NONE : t1.BROWSER_DEFAULT_WEBGL;
                    t1.pixelStorei(t1.UNPACK_FLIP_Y_WEBGL, r.flipY), t1.pixelStorei(t1.UNPACK_PREMULTIPLY_ALPHA_WEBGL, r.premultiplyAlpha), t1.pixelStorei(t1.UNPACK_ALIGNMENT, r.unpackAlignment), t1.pixelStorei(t1.UNPACK_COLORSPACE_CONVERSION_WEBGL, p);
                    const f = function(t1) {
                        return !o && (t1.wrapS !== ea || t1.wrapT !== ea || t1.minFilter !== na && t1.minFilter !== la);
                    }(r) && !1 === v(r.image);
                    let A = y(r.image, f, !1, u);
                    A = Q(r, A);
                    const g = v(A) || o, m = a.convert(r.format, r.colorSpace);
                    let M, E = a.convert(r.type), I = b(r.internalFormat, m, E, r.colorSpace, r.isVideoTexture);
                    _(l, r, g);
                    const S = r.mipmaps, N = o && !0 !== r.isVideoTexture, D = void 0 === d.__version || !0 === c, C = T(r, A, g);
                    if (r.isDepthTexture) I = t1.DEPTH_COMPONENT, o ? I = r.type === ya ? t1.DEPTH_COMPONENT32F : r.type === Ma ? t1.DEPTH_COMPONENT24 : r.type === ba ? t1.DEPTH24_STENCIL8 : t1.DEPTH_COMPONENT16 : r.type === ya && console.error("WebGLRenderer: Floating point depth texture requires WebGL2."), r.format === Na && I === t1.DEPTH_COMPONENT && r.type !== ga && r.type !== Ma && (console.warn("THREE.WebGLRenderer: Use UnsignedShortType or UnsignedIntType for DepthFormat DepthTexture."), r.type = Ma, E = a.convert(r.type)), r.format === Da && I === t1.DEPTH_COMPONENT && (I = t1.DEPTH_STENCIL, r.type !== ba && (console.warn("THREE.WebGLRenderer: Use UnsignedInt248Type for DepthStencilFormat DepthTexture."), r.type = ba, E = a.convert(r.type))), D && (N ? i.texStorage2D(t1.TEXTURE_2D, 1, I, A.width, A.height) : i.texImage2D(t1.TEXTURE_2D, 0, I, A.width, A.height, 0, m, E, null));
                    else if (r.isDataTexture) {
                        if (S.length > 0 && g) {
                            N && D && i.texStorage2D(t1.TEXTURE_2D, C, I, S[0].width, S[0].height);
                            for(let e = 0, n = S.length; e < n; e++)M = S[e], N ? i.texSubImage2D(t1.TEXTURE_2D, e, 0, 0, M.width, M.height, m, E, M.data) : i.texImage2D(t1.TEXTURE_2D, e, I, M.width, M.height, 0, m, E, M.data);
                            r.generateMipmaps = !1;
                        } else N ? (D && i.texStorage2D(t1.TEXTURE_2D, C, I, A.width, A.height), i.texSubImage2D(t1.TEXTURE_2D, 0, 0, 0, A.width, A.height, m, E, A.data)) : i.texImage2D(t1.TEXTURE_2D, 0, I, A.width, A.height, 0, m, E, A.data);
                    } else if (r.isCompressedTexture) {
                        if (r.isCompressedArrayTexture) {
                            N && D && i.texStorage3D(t1.TEXTURE_2D_ARRAY, C, I, S[0].width, S[0].height, A.depth);
                            for(let e = 0, n = S.length; e < n; e++)M = S[e], r.format !== Ea ? null !== m ? N ? i.compressedTexSubImage3D(t1.TEXTURE_2D_ARRAY, e, 0, 0, 0, M.width, M.height, A.depth, m, M.data, 0, 0) : i.compressedTexImage3D(t1.TEXTURE_2D_ARRAY, e, I, M.width, M.height, A.depth, 0, M.data, 0, 0) : console.warn("THREE.WebGLRenderer: Attempt to load unsupported compressed texture format in .uploadTexture()") : N ? i.texSubImage3D(t1.TEXTURE_2D_ARRAY, e, 0, 0, 0, M.width, M.height, A.depth, m, E, M.data) : i.texImage3D(t1.TEXTURE_2D_ARRAY, e, I, M.width, M.height, A.depth, 0, m, E, M.data);
                        } else {
                            N && D && i.texStorage2D(t1.TEXTURE_2D, C, I, S[0].width, S[0].height);
                            for(let e = 0, n = S.length; e < n; e++)M = S[e], r.format !== Ea ? null !== m ? N ? i.compressedTexSubImage2D(t1.TEXTURE_2D, e, 0, 0, M.width, M.height, m, M.data) : i.compressedTexImage2D(t1.TEXTURE_2D, e, I, M.width, M.height, 0, M.data) : console.warn("THREE.WebGLRenderer: Attempt to load unsupported compressed texture format in .uploadTexture()") : N ? i.texSubImage2D(t1.TEXTURE_2D, e, 0, 0, M.width, M.height, m, E, M.data) : i.texImage2D(t1.TEXTURE_2D, e, I, M.width, M.height, 0, m, E, M.data);
                        }
                    } else if (r.isDataArrayTexture) N ? (D && i.texStorage3D(t1.TEXTURE_2D_ARRAY, C, I, A.width, A.height, A.depth), i.texSubImage3D(t1.TEXTURE_2D_ARRAY, 0, 0, 0, 0, A.width, A.height, A.depth, m, E, A.data)) : i.texImage3D(t1.TEXTURE_2D_ARRAY, 0, I, A.width, A.height, A.depth, 0, m, E, A.data);
                    else if (r.isData3DTexture) N ? (D && i.texStorage3D(t1.TEXTURE_3D, C, I, A.width, A.height, A.depth), i.texSubImage3D(t1.TEXTURE_3D, 0, 0, 0, 0, A.width, A.height, A.depth, m, E, A.data)) : i.texImage3D(t1.TEXTURE_3D, 0, I, A.width, A.height, A.depth, 0, m, E, A.data);
                    else if (r.isFramebufferTexture) {
                        if (D) {
                            if (N) i.texStorage2D(t1.TEXTURE_2D, C, I, A.width, A.height);
                            else {
                                let e = A.width, n = A.height;
                                for(let r = 0; r < C; r++)i.texImage2D(t1.TEXTURE_2D, r, I, e, n, 0, m, E, null), e >>= 1, n >>= 1;
                            }
                        }
                    } else if (S.length > 0 && g) {
                        N && D && i.texStorage2D(t1.TEXTURE_2D, C, I, S[0].width, S[0].height);
                        for(let e = 0, n = S.length; e < n; e++)M = S[e], N ? i.texSubImage2D(t1.TEXTURE_2D, e, 0, 0, m, E, M) : i.texImage2D(t1.TEXTURE_2D, e, I, m, E, M);
                        r.generateMipmaps = !1;
                    } else N ? (D && i.texStorage2D(t1.TEXTURE_2D, C, I, A.width, A.height), i.texSubImage2D(t1.TEXTURE_2D, 0, 0, 0, m, E, A)) : i.texImage2D(t1.TEXTURE_2D, 0, I, m, E, A);
                    x(r, g) && w(l), d.__version = h.version, r.onUpdate && r.onUpdate(r);
                }
                e.__version = r.version;
            }
            function R(e, r, s, o, l, c) {
                const u = a.convert(s.format, s.colorSpace), h = a.convert(s.type), p = b(s.internalFormat, u, h, s.colorSpace);
                if (!n.get(r).__hasExternalTextures) {
                    const e = Math.max(1, r.width >> c), n = Math.max(1, r.height >> c);
                    l === t1.TEXTURE_3D || l === t1.TEXTURE_2D_ARRAY ? i.texImage3D(l, c, p, e, n, r.depth, 0, u, h, null) : i.texImage2D(l, c, p, e, n, 0, u, h, null);
                }
                i.bindFramebuffer(t1.FRAMEBUFFER, e), F(r) ? d.framebufferTexture2DMultisampleEXT(t1.FRAMEBUFFER, o, l, n.get(s).__webglTexture, 0, B(r)) : (l === t1.TEXTURE_2D || l >= t1.TEXTURE_CUBE_MAP_POSITIVE_X && l <= t1.TEXTURE_CUBE_MAP_NEGATIVE_Z) && t1.framebufferTexture2D(t1.FRAMEBUFFER, o, l, n.get(s).__webglTexture, c), i.bindFramebuffer(t1.FRAMEBUFFER, null);
            }
            function U(e, i, n) {
                if (t1.bindRenderbuffer(t1.RENDERBUFFER, e), i.depthBuffer && !i.stencilBuffer) {
                    let r = !0 === o ? t1.DEPTH_COMPONENT24 : t1.DEPTH_COMPONENT16;
                    if (n || F(i)) {
                        const e = i.depthTexture;
                        e && e.isDepthTexture && (e.type === ya ? r = t1.DEPTH_COMPONENT32F : e.type === Ma && (r = t1.DEPTH_COMPONENT24));
                        const n = B(i);
                        F(i) ? d.renderbufferStorageMultisampleEXT(t1.RENDERBUFFER, n, r, i.width, i.height) : t1.renderbufferStorageMultisample(t1.RENDERBUFFER, n, r, i.width, i.height);
                    } else t1.renderbufferStorage(t1.RENDERBUFFER, r, i.width, i.height);
                    t1.framebufferRenderbuffer(t1.FRAMEBUFFER, t1.DEPTH_ATTACHMENT, t1.RENDERBUFFER, e);
                } else if (i.depthBuffer && i.stencilBuffer) {
                    const r = B(i);
                    n && !1 === F(i) ? t1.renderbufferStorageMultisample(t1.RENDERBUFFER, r, t1.DEPTH24_STENCIL8, i.width, i.height) : F(i) ? d.renderbufferStorageMultisampleEXT(t1.RENDERBUFFER, r, t1.DEPTH24_STENCIL8, i.width, i.height) : t1.renderbufferStorage(t1.RENDERBUFFER, t1.DEPTH_STENCIL, i.width, i.height), t1.framebufferRenderbuffer(t1.FRAMEBUFFER, t1.DEPTH_STENCIL_ATTACHMENT, t1.RENDERBUFFER, e);
                } else {
                    const e = !0 === i.isWebGLMultipleRenderTargets ? i.texture : [
                        i.texture
                    ];
                    for(let r = 0; r < e.length; r++){
                        const s = e[r], o = a.convert(s.format, s.colorSpace), l = a.convert(s.type), c = b(s.internalFormat, o, l, s.colorSpace), u = B(i);
                        n && !1 === F(i) ? t1.renderbufferStorageMultisample(t1.RENDERBUFFER, u, c, i.width, i.height) : F(i) ? d.renderbufferStorageMultisampleEXT(t1.RENDERBUFFER, u, c, i.width, i.height) : t1.renderbufferStorage(t1.RENDERBUFFER, c, i.width, i.height);
                    }
                }
                t1.bindRenderbuffer(t1.RENDERBUFFER, null);
            }
            function k(e) {
                const r = n.get(e), a = !0 === e.isWebGLCubeRenderTarget;
                if (e.depthTexture && !r.__autoAllocateDepthBuffer) {
                    if (a) throw new Error("target.depthTexture not supported in Cube render targets");
                    !function(e, r) {
                        if (r && r.isWebGLCubeRenderTarget) throw new Error("Depth Texture with cube render targets is not supported");
                        if (i.bindFramebuffer(t1.FRAMEBUFFER, e), !r.depthTexture || !r.depthTexture.isDepthTexture) throw new Error("renderTarget.depthTexture must be an instance of THREE.DepthTexture");
                        n.get(r.depthTexture).__webglTexture && r.depthTexture.image.width === r.width && r.depthTexture.image.height === r.height || (r.depthTexture.image.width = r.width, r.depthTexture.image.height = r.height, r.depthTexture.needsUpdate = !0), C(r.depthTexture, 0);
                        const a = n.get(r.depthTexture).__webglTexture, s = B(r);
                        if (r.depthTexture.format === Na) F(r) ? d.framebufferTexture2DMultisampleEXT(t1.FRAMEBUFFER, t1.DEPTH_ATTACHMENT, t1.TEXTURE_2D, a, 0, s) : t1.framebufferTexture2D(t1.FRAMEBUFFER, t1.DEPTH_ATTACHMENT, t1.TEXTURE_2D, a, 0);
                        else {
                            if (r.depthTexture.format !== Da) throw new Error("Unknown depthTexture format");
                            F(r) ? d.framebufferTexture2DMultisampleEXT(t1.FRAMEBUFFER, t1.DEPTH_STENCIL_ATTACHMENT, t1.TEXTURE_2D, a, 0, s) : t1.framebufferTexture2D(t1.FRAMEBUFFER, t1.DEPTH_STENCIL_ATTACHMENT, t1.TEXTURE_2D, a, 0);
                        }
                    }(r.__webglFramebuffer, e);
                } else if (a) {
                    r.__webglDepthbuffer = [];
                    for(let n = 0; n < 6; n++)i.bindFramebuffer(t1.FRAMEBUFFER, r.__webglFramebuffer[n]), r.__webglDepthbuffer[n] = t1.createRenderbuffer(), U(r.__webglDepthbuffer[n], e, !1);
                } else i.bindFramebuffer(t1.FRAMEBUFFER, r.__webglFramebuffer), r.__webglDepthbuffer = t1.createRenderbuffer(), U(r.__webglDepthbuffer, e, !1);
                i.bindFramebuffer(t1.FRAMEBUFFER, null);
            }
            function B(t1) {
                return Math.min(h, t1.samples);
            }
            function F(t1) {
                const i = n.get(t1);
                return o && t1.samples > 0 && !0 === e.has("WEBGL_multisampled_render_to_texture") && !1 !== i.__useRenderToTexture;
            }
            function Q(t1, i) {
                const n = t1.colorSpace, r = t1.format, a = t1.type;
                return !0 === t1.isCompressedTexture || !0 === t1.isVideoTexture || t1.format === To || n !== js && n !== Os && (il.getTransfer(n) === ks ? !1 === o ? !0 === e.has("EXT_sRGB") && r === Ea ? (t1.format = To, t1.minFilter = la, t1.generateMipmaps = !1) : i = sl.sRGBToLinear(i) : r === Ea && a === pa || console.warn("THREE.WebGLTextures: sRGB encoded textures have to use RGBAFormat and UnsignedByteType.") : console.error("THREE.WebGLTextures: Unsupported texture color space:", n)), i;
            }
            this.allocateTextureUnit = function() {
                const t1 = D;
                return t1 >= l && console.warn("THREE.WebGLTextures: Trying to use " + t1 + " texture units while this GPU supports only " + l), D += 1, t1;
            }, this.resetTextureUnits = function() {
                D = 0;
            }, this.setTexture2D = C, this.setTexture2DArray = function(e, r) {
                const a = n.get(e);
                e.version > 0 && a.__version !== e.version ? P(a, e, r) : i.bindTexture(t1.TEXTURE_2D_ARRAY, a.__webglTexture, t1.TEXTURE0 + r);
            }, this.setTexture3D = function(e, r) {
                const a = n.get(e);
                e.version > 0 && a.__version !== e.version ? P(a, e, r) : i.bindTexture(t1.TEXTURE_3D, a.__webglTexture, t1.TEXTURE0 + r);
            }, this.setTextureCube = function(e, r) {
                const s = n.get(e);
                e.version > 0 && s.__version !== e.version ? function(e, r, s) {
                    if (6 !== r.image.length) return;
                    const l = j(e, r), u = r.source;
                    i.bindTexture(t1.TEXTURE_CUBE_MAP, e.__webglTexture, t1.TEXTURE0 + s);
                    const h = n.get(u);
                    if (u.version !== h.__version || !0 === l) {
                        i.activeTexture(t1.TEXTURE0 + s);
                        const e = il.getPrimaries(il.workingColorSpace), n = r.colorSpace === Os ? null : il.getPrimaries(r.colorSpace), d = r.colorSpace === Os || e === n ? t1.NONE : t1.BROWSER_DEFAULT_WEBGL;
                        t1.pixelStorei(t1.UNPACK_FLIP_Y_WEBGL, r.flipY), t1.pixelStorei(t1.UNPACK_PREMULTIPLY_ALPHA_WEBGL, r.premultiplyAlpha), t1.pixelStorei(t1.UNPACK_ALIGNMENT, r.unpackAlignment), t1.pixelStorei(t1.UNPACK_COLORSPACE_CONVERSION_WEBGL, d);
                        const p = r.isCompressedTexture || r.image[0].isCompressedTexture, f = r.image[0] && r.image[0].isDataTexture, A = [];
                        for(let t1 = 0; t1 < 6; t1++)A[t1] = p || f ? f ? r.image[t1].image : r.image[t1] : y(r.image[t1], !1, !0, c), A[t1] = Q(r, A[t1]);
                        const g = A[0], m = v(g) || o, M = a.convert(r.format, r.colorSpace), E = a.convert(r.type), I = b(r.internalFormat, M, E, r.colorSpace), S = o && !0 !== r.isVideoTexture, N = void 0 === h.__version || !0 === l;
                        let D, C = T(r, g, m);
                        if (_(t1.TEXTURE_CUBE_MAP, r, m), p) {
                            S && N && i.texStorage2D(t1.TEXTURE_CUBE_MAP, C, I, g.width, g.height);
                            for(let e = 0; e < 6; e++){
                                D = A[e].mipmaps;
                                for(let n = 0; n < D.length; n++){
                                    const a = D[n];
                                    r.format !== Ea ? null !== M ? S ? i.compressedTexSubImage2D(t1.TEXTURE_CUBE_MAP_POSITIVE_X + e, n, 0, 0, a.width, a.height, M, a.data) : i.compressedTexImage2D(t1.TEXTURE_CUBE_MAP_POSITIVE_X + e, n, I, a.width, a.height, 0, a.data) : console.warn("THREE.WebGLRenderer: Attempt to load unsupported compressed texture format in .setTextureCube()") : S ? i.texSubImage2D(t1.TEXTURE_CUBE_MAP_POSITIVE_X + e, n, 0, 0, a.width, a.height, M, E, a.data) : i.texImage2D(t1.TEXTURE_CUBE_MAP_POSITIVE_X + e, n, I, a.width, a.height, 0, M, E, a.data);
                                }
                            }
                        } else {
                            D = r.mipmaps, S && N && (D.length > 0 && C++, i.texStorage2D(t1.TEXTURE_CUBE_MAP, C, I, A[0].width, A[0].height));
                            for(let e = 0; e < 6; e++)if (f) {
                                S ? i.texSubImage2D(t1.TEXTURE_CUBE_MAP_POSITIVE_X + e, 0, 0, 0, A[e].width, A[e].height, M, E, A[e].data) : i.texImage2D(t1.TEXTURE_CUBE_MAP_POSITIVE_X + e, 0, I, A[e].width, A[e].height, 0, M, E, A[e].data);
                                for(let n = 0; n < D.length; n++){
                                    const r = D[n].image[e].image;
                                    S ? i.texSubImage2D(t1.TEXTURE_CUBE_MAP_POSITIVE_X + e, n + 1, 0, 0, r.width, r.height, M, E, r.data) : i.texImage2D(t1.TEXTURE_CUBE_MAP_POSITIVE_X + e, n + 1, I, r.width, r.height, 0, M, E, r.data);
                                }
                            } else {
                                S ? i.texSubImage2D(t1.TEXTURE_CUBE_MAP_POSITIVE_X + e, 0, 0, 0, M, E, A[e]) : i.texImage2D(t1.TEXTURE_CUBE_MAP_POSITIVE_X + e, 0, I, M, E, A[e]);
                                for(let n = 0; n < D.length; n++){
                                    const r = D[n];
                                    S ? i.texSubImage2D(t1.TEXTURE_CUBE_MAP_POSITIVE_X + e, n + 1, 0, 0, M, E, r.image[e]) : i.texImage2D(t1.TEXTURE_CUBE_MAP_POSITIVE_X + e, n + 1, I, M, E, r.image[e]);
                                }
                            }
                        }
                        x(r, m) && w(t1.TEXTURE_CUBE_MAP), h.__version = u.version, r.onUpdate && r.onUpdate(r);
                    }
                    e.__version = r.version;
                }(s, e, r) : i.bindTexture(t1.TEXTURE_CUBE_MAP, s.__webglTexture, t1.TEXTURE0 + r);
            }, this.rebindTextures = function(e, i, r) {
                const a = n.get(e);
                void 0 !== i && R(a.__webglFramebuffer, e, e.texture, t1.COLOR_ATTACHMENT0, t1.TEXTURE_2D, 0), void 0 !== r && k(e);
            }, this.setupRenderTarget = function(e) {
                const l = e.texture, c = n.get(e), u = n.get(l);
                e.addEventListener("dispose", S), !0 !== e.isWebGLMultipleRenderTargets && (void 0 === u.__webglTexture && (u.__webglTexture = t1.createTexture()), u.__version = l.version, s.memory.textures++);
                const h = !0 === e.isWebGLCubeRenderTarget, d = !0 === e.isWebGLMultipleRenderTargets, p = v(e) || o;
                if (h) {
                    c.__webglFramebuffer = [];
                    for(let e = 0; e < 6; e++)if (o && l.mipmaps && l.mipmaps.length > 0) {
                        c.__webglFramebuffer[e] = [];
                        for(let i = 0; i < l.mipmaps.length; i++)c.__webglFramebuffer[e][i] = t1.createFramebuffer();
                    } else c.__webglFramebuffer[e] = t1.createFramebuffer();
                } else {
                    if (o && l.mipmaps && l.mipmaps.length > 0) {
                        c.__webglFramebuffer = [];
                        for(let e = 0; e < l.mipmaps.length; e++)c.__webglFramebuffer[e] = t1.createFramebuffer();
                    } else c.__webglFramebuffer = t1.createFramebuffer();
                    if (d) {
                        if (r.drawBuffers) {
                            const i = e.texture;
                            for(let e = 0, r = i.length; e < r; e++){
                                const r = n.get(i[e]);
                                void 0 === r.__webglTexture && (r.__webglTexture = t1.createTexture(), s.memory.textures++);
                            }
                        } else console.warn("THREE.WebGLRenderer: WebGLMultipleRenderTargets can only be used with WebGL2 or WEBGL_draw_buffers extension.");
                    }
                    if (o && e.samples > 0 && !1 === F(e)) {
                        const n = d ? l : [
                            l
                        ];
                        c.__webglMultisampledFramebuffer = t1.createFramebuffer(), c.__webglColorRenderbuffer = [], i.bindFramebuffer(t1.FRAMEBUFFER, c.__webglMultisampledFramebuffer);
                        for(let i = 0; i < n.length; i++){
                            const r = n[i];
                            c.__webglColorRenderbuffer[i] = t1.createRenderbuffer(), t1.bindRenderbuffer(t1.RENDERBUFFER, c.__webglColorRenderbuffer[i]);
                            const s = a.convert(r.format, r.colorSpace), o = a.convert(r.type), l = b(r.internalFormat, s, o, r.colorSpace, !0 === e.isXRRenderTarget), u = B(e);
                            t1.renderbufferStorageMultisample(t1.RENDERBUFFER, u, l, e.width, e.height), t1.framebufferRenderbuffer(t1.FRAMEBUFFER, t1.COLOR_ATTACHMENT0 + i, t1.RENDERBUFFER, c.__webglColorRenderbuffer[i]);
                        }
                        t1.bindRenderbuffer(t1.RENDERBUFFER, null), e.depthBuffer && (c.__webglDepthRenderbuffer = t1.createRenderbuffer(), U(c.__webglDepthRenderbuffer, e, !0)), i.bindFramebuffer(t1.FRAMEBUFFER, null);
                    }
                }
                if (h) {
                    i.bindTexture(t1.TEXTURE_CUBE_MAP, u.__webglTexture), _(t1.TEXTURE_CUBE_MAP, l, p);
                    for(let i = 0; i < 6; i++)if (o && l.mipmaps && l.mipmaps.length > 0) for(let n = 0; n < l.mipmaps.length; n++)R(c.__webglFramebuffer[i][n], e, l, t1.COLOR_ATTACHMENT0, t1.TEXTURE_CUBE_MAP_POSITIVE_X + i, n);
                    else R(c.__webglFramebuffer[i], e, l, t1.COLOR_ATTACHMENT0, t1.TEXTURE_CUBE_MAP_POSITIVE_X + i, 0);
                    x(l, p) && w(t1.TEXTURE_CUBE_MAP), i.unbindTexture();
                } else if (d) {
                    const r = e.texture;
                    for(let a = 0, s = r.length; a < s; a++){
                        const s = r[a], o = n.get(s);
                        i.bindTexture(t1.TEXTURE_2D, o.__webglTexture), _(t1.TEXTURE_2D, s, p), R(c.__webglFramebuffer, e, s, t1.COLOR_ATTACHMENT0 + a, t1.TEXTURE_2D, 0), x(s, p) && w(t1.TEXTURE_2D);
                    }
                    i.unbindTexture();
                } else {
                    let n = t1.TEXTURE_2D;
                    if ((e.isWebGL3DRenderTarget || e.isWebGLArrayRenderTarget) && (o ? n = e.isWebGL3DRenderTarget ? t1.TEXTURE_3D : t1.TEXTURE_2D_ARRAY : console.error("THREE.WebGLTextures: THREE.Data3DTexture and THREE.DataArrayTexture only supported with WebGL2.")), i.bindTexture(n, u.__webglTexture), _(n, l, p), o && l.mipmaps && l.mipmaps.length > 0) for(let i = 0; i < l.mipmaps.length; i++)R(c.__webglFramebuffer[i], e, l, t1.COLOR_ATTACHMENT0, n, i);
                    else R(c.__webglFramebuffer, e, l, t1.COLOR_ATTACHMENT0, n, 0);
                    x(l, p) && w(n), i.unbindTexture();
                }
                e.depthBuffer && k(e);
            }, this.updateRenderTargetMipmap = function(e) {
                const r = v(e) || o, a = !0 === e.isWebGLMultipleRenderTargets ? e.texture : [
                    e.texture
                ];
                for(let s = 0, o = a.length; s < o; s++){
                    const o = a[s];
                    if (x(o, r)) {
                        const r = e.isWebGLCubeRenderTarget ? t1.TEXTURE_CUBE_MAP : t1.TEXTURE_2D, a = n.get(o).__webglTexture;
                        i.bindTexture(r, a), w(r), i.unbindTexture();
                    }
                }
            }, this.updateMultisampleRenderTarget = function(e) {
                if (o && e.samples > 0 && !1 === F(e)) {
                    const r = e.isWebGLMultipleRenderTargets ? e.texture : [
                        e.texture
                    ], a = e.width, s = e.height;
                    let o = t1.COLOR_BUFFER_BIT;
                    const l = [], c = e.stencilBuffer ? t1.DEPTH_STENCIL_ATTACHMENT : t1.DEPTH_ATTACHMENT, u = n.get(e), h = !0 === e.isWebGLMultipleRenderTargets;
                    if (h) for(let e = 0; e < r.length; e++)i.bindFramebuffer(t1.FRAMEBUFFER, u.__webglMultisampledFramebuffer), t1.framebufferRenderbuffer(t1.FRAMEBUFFER, t1.COLOR_ATTACHMENT0 + e, t1.RENDERBUFFER, null), i.bindFramebuffer(t1.FRAMEBUFFER, u.__webglFramebuffer), t1.framebufferTexture2D(t1.DRAW_FRAMEBUFFER, t1.COLOR_ATTACHMENT0 + e, t1.TEXTURE_2D, null, 0);
                    i.bindFramebuffer(t1.READ_FRAMEBUFFER, u.__webglMultisampledFramebuffer), i.bindFramebuffer(t1.DRAW_FRAMEBUFFER, u.__webglFramebuffer);
                    for(let i = 0; i < r.length; i++){
                        l.push(t1.COLOR_ATTACHMENT0 + i), e.depthBuffer && l.push(c);
                        const d = void 0 !== u.__ignoreDepthValues && u.__ignoreDepthValues;
                        if (!1 === d && (e.depthBuffer && (o |= t1.DEPTH_BUFFER_BIT), e.stencilBuffer && (o |= t1.STENCIL_BUFFER_BIT)), h && t1.framebufferRenderbuffer(t1.READ_FRAMEBUFFER, t1.COLOR_ATTACHMENT0, t1.RENDERBUFFER, u.__webglColorRenderbuffer[i]), !0 === d && (t1.invalidateFramebuffer(t1.READ_FRAMEBUFFER, [
                            c
                        ]), t1.invalidateFramebuffer(t1.DRAW_FRAMEBUFFER, [
                            c
                        ])), h) {
                            const e = n.get(r[i]).__webglTexture;
                            t1.framebufferTexture2D(t1.DRAW_FRAMEBUFFER, t1.COLOR_ATTACHMENT0, t1.TEXTURE_2D, e, 0);
                        }
                        t1.blitFramebuffer(0, 0, a, s, 0, 0, a, s, o, t1.NEAREST), p && t1.invalidateFramebuffer(t1.READ_FRAMEBUFFER, l);
                    }
                    if (i.bindFramebuffer(t1.READ_FRAMEBUFFER, null), i.bindFramebuffer(t1.DRAW_FRAMEBUFFER, null), h) for(let e = 0; e < r.length; e++){
                        i.bindFramebuffer(t1.FRAMEBUFFER, u.__webglMultisampledFramebuffer), t1.framebufferRenderbuffer(t1.FRAMEBUFFER, t1.COLOR_ATTACHMENT0 + e, t1.RENDERBUFFER, u.__webglColorRenderbuffer[e]);
                        const a = n.get(r[e]).__webglTexture;
                        i.bindFramebuffer(t1.FRAMEBUFFER, u.__webglFramebuffer), t1.framebufferTexture2D(t1.DRAW_FRAMEBUFFER, t1.COLOR_ATTACHMENT0 + e, t1.TEXTURE_2D, a, 0);
                    }
                    i.bindFramebuffer(t1.DRAW_FRAMEBUFFER, u.__webglMultisampledFramebuffer);
                }
            }, this.setupDepthRenderbuffer = k, this.setupFrameBufferTexture = R, this.useMultisampledRTT = F;
        }
        function Ep(t1, e, i) {
            const n = i.isWebGL2;
            return {
                convert: function(i, r = Os) {
                    let a;
                    const s = il.getTransfer(r);
                    if (i === pa) return t1.UNSIGNED_BYTE;
                    if (i === xa) return t1.UNSIGNED_SHORT_4_4_4_4;
                    if (i === wa) return t1.UNSIGNED_SHORT_5_5_5_1;
                    if (i === fa) return t1.BYTE;
                    if (i === Aa) return t1.SHORT;
                    if (i === ga) return t1.UNSIGNED_SHORT;
                    if (i === ma) return t1.INT;
                    if (i === Ma) return t1.UNSIGNED_INT;
                    if (i === ya) return t1.FLOAT;
                    if (i === va) return n ? t1.HALF_FLOAT : (a = e.get("OES_texture_half_float"), null !== a ? a.HALF_FLOAT_OES : null);
                    if (i === Ta) return t1.ALPHA;
                    if (i === Ea) return t1.RGBA;
                    if (i === Ia) return t1.LUMINANCE;
                    if (i === Sa) return t1.LUMINANCE_ALPHA;
                    if (i === Na) return t1.DEPTH_COMPONENT;
                    if (i === Da) return t1.DEPTH_STENCIL;
                    if (i === To) return a = e.get("EXT_sRGB"), null !== a ? a.SRGB_ALPHA_EXT : null;
                    if (i === Ca) return t1.RED;
                    if (i === za) return t1.RED_INTEGER;
                    if (i === La) return t1.RG;
                    if (i === Oa) return t1.RG_INTEGER;
                    if (i === _a) return t1.RGBA_INTEGER;
                    if (i === ja || i === Pa || i === Ra || i === Ua) {
                        if (s === ks) {
                            if (a = e.get("WEBGL_compressed_texture_s3tc_srgb"), null === a) return null;
                            if (i === ja) return a.COMPRESSED_SRGB_S3TC_DXT1_EXT;
                            if (i === Pa) return a.COMPRESSED_SRGB_ALPHA_S3TC_DXT1_EXT;
                            if (i === Ra) return a.COMPRESSED_SRGB_ALPHA_S3TC_DXT3_EXT;
                            if (i === Ua) return a.COMPRESSED_SRGB_ALPHA_S3TC_DXT5_EXT;
                        } else {
                            if (a = e.get("WEBGL_compressed_texture_s3tc"), null === a) return null;
                            if (i === ja) return a.COMPRESSED_RGB_S3TC_DXT1_EXT;
                            if (i === Pa) return a.COMPRESSED_RGBA_S3TC_DXT1_EXT;
                            if (i === Ra) return a.COMPRESSED_RGBA_S3TC_DXT3_EXT;
                            if (i === Ua) return a.COMPRESSED_RGBA_S3TC_DXT5_EXT;
                        }
                    }
                    if (i === ka || i === Ba || i === Fa || i === Qa) {
                        if (a = e.get("WEBGL_compressed_texture_pvrtc"), null === a) return null;
                        if (i === ka) return a.COMPRESSED_RGB_PVRTC_4BPPV1_IMG;
                        if (i === Ba) return a.COMPRESSED_RGB_PVRTC_2BPPV1_IMG;
                        if (i === Fa) return a.COMPRESSED_RGBA_PVRTC_4BPPV1_IMG;
                        if (i === Qa) return a.COMPRESSED_RGBA_PVRTC_2BPPV1_IMG;
                    }
                    if (i === Ha) return a = e.get("WEBGL_compressed_texture_etc1"), null !== a ? a.COMPRESSED_RGB_ETC1_WEBGL : null;
                    if (i === Va || i === Ga) {
                        if (a = e.get("WEBGL_compressed_texture_etc"), null === a) return null;
                        if (i === Va) return s === ks ? a.COMPRESSED_SRGB8_ETC2 : a.COMPRESSED_RGB8_ETC2;
                        if (i === Ga) return s === ks ? a.COMPRESSED_SRGB8_ALPHA8_ETC2_EAC : a.COMPRESSED_RGBA8_ETC2_EAC;
                    }
                    if (i === Ya || i === Wa || i === Xa || i === Za || i === Ja || i === Ka || i === qa || i === $a || i === ts || i === es || i === is || i === ns || i === rs || i === as) {
                        if (a = e.get("WEBGL_compressed_texture_astc"), null === a) return null;
                        if (i === Ya) return s === ks ? a.COMPRESSED_SRGB8_ALPHA8_ASTC_4x4_KHR : a.COMPRESSED_RGBA_ASTC_4x4_KHR;
                        if (i === Wa) return s === ks ? a.COMPRESSED_SRGB8_ALPHA8_ASTC_5x4_KHR : a.COMPRESSED_RGBA_ASTC_5x4_KHR;
                        if (i === Xa) return s === ks ? a.COMPRESSED_SRGB8_ALPHA8_ASTC_5x5_KHR : a.COMPRESSED_RGBA_ASTC_5x5_KHR;
                        if (i === Za) return s === ks ? a.COMPRESSED_SRGB8_ALPHA8_ASTC_6x5_KHR : a.COMPRESSED_RGBA_ASTC_6x5_KHR;
                        if (i === Ja) return s === ks ? a.COMPRESSED_SRGB8_ALPHA8_ASTC_6x6_KHR : a.COMPRESSED_RGBA_ASTC_6x6_KHR;
                        if (i === Ka) return s === ks ? a.COMPRESSED_SRGB8_ALPHA8_ASTC_8x5_KHR : a.COMPRESSED_RGBA_ASTC_8x5_KHR;
                        if (i === qa) return s === ks ? a.COMPRESSED_SRGB8_ALPHA8_ASTC_8x6_KHR : a.COMPRESSED_RGBA_ASTC_8x6_KHR;
                        if (i === $a) return s === ks ? a.COMPRESSED_SRGB8_ALPHA8_ASTC_8x8_KHR : a.COMPRESSED_RGBA_ASTC_8x8_KHR;
                        if (i === ts) return s === ks ? a.COMPRESSED_SRGB8_ALPHA8_ASTC_10x5_KHR : a.COMPRESSED_RGBA_ASTC_10x5_KHR;
                        if (i === es) return s === ks ? a.COMPRESSED_SRGB8_ALPHA8_ASTC_10x6_KHR : a.COMPRESSED_RGBA_ASTC_10x6_KHR;
                        if (i === is) return s === ks ? a.COMPRESSED_SRGB8_ALPHA8_ASTC_10x8_KHR : a.COMPRESSED_RGBA_ASTC_10x8_KHR;
                        if (i === ns) return s === ks ? a.COMPRESSED_SRGB8_ALPHA8_ASTC_10x10_KHR : a.COMPRESSED_RGBA_ASTC_10x10_KHR;
                        if (i === rs) return s === ks ? a.COMPRESSED_SRGB8_ALPHA8_ASTC_12x10_KHR : a.COMPRESSED_RGBA_ASTC_12x10_KHR;
                        if (i === as) return s === ks ? a.COMPRESSED_SRGB8_ALPHA8_ASTC_12x12_KHR : a.COMPRESSED_RGBA_ASTC_12x12_KHR;
                    }
                    if (i === ss || i === os || i === ls) {
                        if (a = e.get("EXT_texture_compression_bptc"), null === a) return null;
                        if (i === ss) return s === ks ? a.COMPRESSED_SRGB_ALPHA_BPTC_UNORM_EXT : a.COMPRESSED_RGBA_BPTC_UNORM_EXT;
                        if (i === os) return a.COMPRESSED_RGB_BPTC_SIGNED_FLOAT_EXT;
                        if (i === ls) return a.COMPRESSED_RGB_BPTC_UNSIGNED_FLOAT_EXT;
                    }
                    if (i === cs || i === us || i === hs || i === ds) {
                        if (a = e.get("EXT_texture_compression_rgtc"), null === a) return null;
                        if (i === ss) return a.COMPRESSED_RED_RGTC1_EXT;
                        if (i === us) return a.COMPRESSED_SIGNED_RED_RGTC1_EXT;
                        if (i === hs) return a.COMPRESSED_RED_GREEN_RGTC2_EXT;
                        if (i === ds) return a.COMPRESSED_SIGNED_RED_GREEN_RGTC2_EXT;
                    }
                    return i === ba ? n ? t1.UNSIGNED_INT_24_8 : (a = e.get("WEBGL_depth_texture"), null !== a ? a.UNSIGNED_INT_24_8_WEBGL : null) : void 0 !== t1[i] ? t1[i] : null;
                }
            };
        }
        class Ip extends Qu {
            constructor(t1 = []){
                super(), this.isArrayCamera = !0, this.cameras = t1;
            }
        }
        class Sp extends wc {
            constructor(){
                super(), this.isGroup = !0, this.type = "Group";
            }
        }
        const Np = {
            type: "move"
        };
        class Dp {
            constructor(){
                this._targetRay = null, this._grip = null, this._hand = null;
            }
            getHandSpace() {
                return null === this._hand && (this._hand = new Sp, this._hand.matrixAutoUpdate = !1, this._hand.visible = !1, this._hand.joints = {}, this._hand.inputState = {
                    pinching: !1
                }), this._hand;
            }
            getTargetRaySpace() {
                return null === this._targetRay && (this._targetRay = new Sp, this._targetRay.matrixAutoUpdate = !1, this._targetRay.visible = !1, this._targetRay.hasLinearVelocity = !1, this._targetRay.linearVelocity = new xl, this._targetRay.hasAngularVelocity = !1, this._targetRay.angularVelocity = new xl), this._targetRay;
            }
            getGripSpace() {
                return null === this._grip && (this._grip = new Sp, this._grip.matrixAutoUpdate = !1, this._grip.visible = !1, this._grip.hasLinearVelocity = !1, this._grip.linearVelocity = new xl, this._grip.hasAngularVelocity = !1, this._grip.angularVelocity = new xl), this._grip;
            }
            dispatchEvent(t1) {
                return null !== this._targetRay && this._targetRay.dispatchEvent(t1), null !== this._grip && this._grip.dispatchEvent(t1), null !== this._hand && this._hand.dispatchEvent(t1), this;
            }
            connect(t1) {
                if (t1 && t1.hand) {
                    const e = this._hand;
                    if (e) for (const i of t1.hand.values())this._getHandJoint(e, i);
                }
                return this.dispatchEvent({
                    type: "connected",
                    data: t1
                }), this;
            }
            disconnect(t1) {
                return this.dispatchEvent({
                    type: "disconnected",
                    data: t1
                }), null !== this._targetRay && (this._targetRay.visible = !1), null !== this._grip && (this._grip.visible = !1), null !== this._hand && (this._hand.visible = !1), this;
            }
            update(t1, e, i) {
                let n = null, r = null, a = null;
                const s = this._targetRay, o = this._grip, l = this._hand;
                if (t1 && "visible-blurred" !== e.session.visibilityState) {
                    if (l && t1.hand) {
                        a = !0;
                        for (const n of t1.hand.values()){
                            const t1 = e.getJointPose(n, i), r = this._getHandJoint(l, n);
                            null !== t1 && (r.matrix.fromArray(t1.transform.matrix), r.matrix.decompose(r.position, r.rotation, r.scale), r.matrixWorldNeedsUpdate = !0, r.jointRadius = t1.radius), r.visible = null !== t1;
                        }
                        const n = l.joints["index-finger-tip"], r = l.joints["thumb-tip"], s = n.position.distanceTo(r.position), o = .02, c = .005;
                        l.inputState.pinching && s > o + c ? (l.inputState.pinching = !1, this.dispatchEvent({
                            type: "pinchend",
                            handedness: t1.handedness,
                            target: this
                        })) : !l.inputState.pinching && s <= o - c && (l.inputState.pinching = !0, this.dispatchEvent({
                            type: "pinchstart",
                            handedness: t1.handedness,
                            target: this
                        }));
                    } else null !== o && t1.gripSpace && (r = e.getPose(t1.gripSpace, i), null !== r && (o.matrix.fromArray(r.transform.matrix), o.matrix.decompose(o.position, o.rotation, o.scale), o.matrixWorldNeedsUpdate = !0, r.linearVelocity ? (o.hasLinearVelocity = !0, o.linearVelocity.copy(r.linearVelocity)) : o.hasLinearVelocity = !1, r.angularVelocity ? (o.hasAngularVelocity = !0, o.angularVelocity.copy(r.angularVelocity)) : o.hasAngularVelocity = !1));
                    null !== s && (n = e.getPose(t1.targetRaySpace, i), null === n && null !== r && (n = r), null !== n && (s.matrix.fromArray(n.transform.matrix), s.matrix.decompose(s.position, s.rotation, s.scale), s.matrixWorldNeedsUpdate = !0, n.linearVelocity ? (s.hasLinearVelocity = !0, s.linearVelocity.copy(n.linearVelocity)) : s.hasLinearVelocity = !1, n.angularVelocity ? (s.hasAngularVelocity = !0, s.angularVelocity.copy(n.angularVelocity)) : s.hasAngularVelocity = !1, this.dispatchEvent(Np)));
                }
                return null !== s && (s.visible = null !== n), null !== o && (o.visible = null !== r), null !== l && (l.visible = null !== a), this;
            }
            _getHandJoint(t1, e) {
                if (void 0 === t1.joints[e.jointName]) {
                    const i = new Sp;
                    i.matrixAutoUpdate = !1, i.visible = !1, t1.joints[e.jointName] = i, t1.add(i);
                }
                return t1.joints[e.jointName];
            }
        }
        class Cp extends hl {
            constructor(t1, e, i, n, r, a, s, o, l, c){
                if ((c = void 0 !== c ? c : Na) !== Na && c !== Da) throw new Error("DepthTexture format must be either THREE.DepthFormat or THREE.DepthStencilFormat");
                void 0 === i && c === Na && (i = Ma), void 0 === i && c === Da && (i = ba), super(null, n, r, a, s, o, c, i, l), this.isDepthTexture = !0, this.image = {
                    width: t1,
                    height: e
                }, this.magFilter = void 0 !== s ? s : na, this.minFilter = void 0 !== o ? o : na, this.flipY = !1, this.generateMipmaps = !1, this.compareFunction = null;
            }
            copy(t1) {
                return super.copy(t1), this.compareFunction = t1.compareFunction, this;
            }
            toJSON(t1) {
                const e = super.toJSON(t1);
                return null !== this.compareFunction && (e.compareFunction = this.compareFunction), e;
            }
        }
        class zp extends So {
            constructor(t1, e){
                super();
                const i = this;
                let n = null, r = 1, a = null, s = "local-floor", o = 1, l = null, c = null, u = null, h = null, d = null, p = null;
                const f = e.getContextAttributes();
                let A = null, g = null;
                const m = [], M = [], y = new Qu;
                y.layers.enable(1), y.viewport = new dl;
                const v = new Qu;
                v.layers.enable(2), v.viewport = new dl;
                const x = [
                    y,
                    v
                ], w = new Ip;
                w.layers.enable(1), w.layers.enable(2);
                let b = null, T = null;
                function E(t1) {
                    const e = M.indexOf(t1.inputSource);
                    if (-1 === e) return;
                    const i = m[e];
                    void 0 !== i && (i.update(t1.inputSource, t1.frame, l || a), i.dispatchEvent({
                        type: t1.type,
                        data: t1.inputSource
                    }));
                }
                function I() {
                    n.removeEventListener("select", E), n.removeEventListener("selectstart", E), n.removeEventListener("selectend", E), n.removeEventListener("squeeze", E), n.removeEventListener("squeezestart", E), n.removeEventListener("squeezeend", E), n.removeEventListener("end", I), n.removeEventListener("inputsourceschange", S);
                    for(let t1 = 0; t1 < m.length; t1++){
                        const e = M[t1];
                        null !== e && (M[t1] = null, m[t1].disconnect(e));
                    }
                    b = null, T = null, t1.setRenderTarget(A), d = null, h = null, u = null, n = null, g = null, L.stop(), i.isPresenting = !1, i.dispatchEvent({
                        type: "sessionend"
                    });
                }
                function S(t1) {
                    for(let e = 0; e < t1.removed.length; e++){
                        const i = t1.removed[e], n = M.indexOf(i);
                        n >= 0 && (M[n] = null, m[n].disconnect(i));
                    }
                    for(let e = 0; e < t1.added.length; e++){
                        const i = t1.added[e];
                        let n = M.indexOf(i);
                        if (-1 === n) {
                            for(let t1 = 0; t1 < m.length; t1++){
                                if (t1 >= M.length) {
                                    M.push(i), n = t1;
                                    break;
                                }
                                if (null === M[t1]) {
                                    M[t1] = i, n = t1;
                                    break;
                                }
                            }
                            if (-1 === n) break;
                        }
                        const r = m[n];
                        r && r.connect(i);
                    }
                }
                this.cameraAutoUpdate = !0, this.enabled = !1, this.isPresenting = !1, this.getController = function(t1) {
                    let e = m[t1];
                    return void 0 === e && (e = new Dp, m[t1] = e), e.getTargetRaySpace();
                }, this.getControllerGrip = function(t1) {
                    let e = m[t1];
                    return void 0 === e && (e = new Dp, m[t1] = e), e.getGripSpace();
                }, this.getHand = function(t1) {
                    let e = m[t1];
                    return void 0 === e && (e = new Dp, m[t1] = e), e.getHandSpace();
                }, this.setFramebufferScaleFactor = function(t1) {
                    r = t1, !0 === i.isPresenting && console.warn("THREE.WebXRManager: Cannot change framebuffer scale while presenting.");
                }, this.setReferenceSpaceType = function(t1) {
                    s = t1, !0 === i.isPresenting && console.warn("THREE.WebXRManager: Cannot change reference space type while presenting.");
                }, this.getReferenceSpace = function() {
                    return l || a;
                }, this.setReferenceSpace = function(t1) {
                    l = t1;
                }, this.getBaseLayer = function() {
                    return null !== h ? h : d;
                }, this.getBinding = function() {
                    return u;
                }, this.getFrame = function() {
                    return p;
                }, this.getSession = function() {
                    return n;
                }, this.setSession = async function(c) {
                    if (n = c, null !== n) {
                        if (A = t1.getRenderTarget(), n.addEventListener("select", E), n.addEventListener("selectstart", E), n.addEventListener("selectend", E), n.addEventListener("squeeze", E), n.addEventListener("squeezestart", E), n.addEventListener("squeezeend", E), n.addEventListener("end", I), n.addEventListener("inputsourceschange", S), !0 !== f.xrCompatible && await e.makeXRCompatible(), void 0 === n.renderState.layers || !1 === t1.capabilities.isWebGL2) {
                            const i = {
                                antialias: void 0 !== n.renderState.layers || f.antialias,
                                alpha: !0,
                                depth: f.depth,
                                stencil: f.stencil,
                                framebufferScaleFactor: r
                            };
                            d = new XRWebGLLayer(n, e, i), n.updateRenderState({
                                baseLayer: d
                            }), g = new fl(d.framebufferWidth, d.framebufferHeight, {
                                format: Ea,
                                type: pa,
                                colorSpace: t1.outputColorSpace,
                                stencilBuffer: f.stencil
                            });
                        } else {
                            let i = null, a = null, s = null;
                            f.depth && (s = f.stencil ? e.DEPTH24_STENCIL8 : e.DEPTH_COMPONENT24, i = f.stencil ? Da : Na, a = f.stencil ? ba : Ma);
                            const o = {
                                colorFormat: e.RGBA8,
                                depthFormat: s,
                                scaleFactor: r
                            };
                            u = new XRWebGLBinding(n, e), h = u.createProjectionLayer(o), n.updateRenderState({
                                layers: [
                                    h
                                ]
                            }), g = new fl(h.textureWidth, h.textureHeight, {
                                format: Ea,
                                type: pa,
                                depthTexture: new Cp(h.textureWidth, h.textureHeight, a, void 0, void 0, void 0, void 0, void 0, void 0, i),
                                stencilBuffer: f.stencil,
                                colorSpace: t1.outputColorSpace,
                                samples: f.antialias ? 4 : 0
                            }), t1.properties.get(g).__ignoreDepthValues = h.ignoreDepthValues;
                        }
                        g.isXRRenderTarget = !0, this.setFoveation(o), l = null, a = await n.requestReferenceSpace(s), L.setContext(n), L.start(), i.isPresenting = !0, i.dispatchEvent({
                            type: "sessionstart"
                        });
                    }
                }, this.getEnvironmentBlendMode = function() {
                    if (null !== n) return n.environmentBlendMode;
                };
                const N = new xl, D = new xl;
                function C(t1, e) {
                    null === e ? t1.matrixWorld.copy(t1.matrix) : t1.matrixWorld.multiplyMatrices(e.matrixWorld, t1.matrix), t1.matrixWorldInverse.copy(t1.matrixWorld).invert();
                }
                this.updateCamera = function(t1) {
                    if (null === n) return;
                    w.near = v.near = y.near = t1.near, w.far = v.far = y.far = t1.far, b === w.near && T === w.far || (n.updateRenderState({
                        depthNear: w.near,
                        depthFar: w.far
                    }), b = w.near, T = w.far);
                    const e = t1.parent, i = w.cameras;
                    C(w, e);
                    for(let t1 = 0; t1 < i.length; t1++)C(i[t1], e);
                    2 === i.length ? function(t1, e, i) {
                        N.setFromMatrixPosition(e.matrixWorld), D.setFromMatrixPosition(i.matrixWorld);
                        const n = N.distanceTo(D), r = e.projectionMatrix.elements, a = i.projectionMatrix.elements, s = r[14] / (r[10] - 1), o = r[14] / (r[10] + 1), l = (r[9] + 1) / r[5], c = (r[9] - 1) / r[5], u = (r[8] - 1) / r[0], h = (a[8] + 1) / a[0], d = s * u, p = s * h, f = n / (-u + h), A = f * -u;
                        e.matrixWorld.decompose(t1.position, t1.quaternion, t1.scale), t1.translateX(A), t1.translateZ(f), t1.matrixWorld.compose(t1.position, t1.quaternion, t1.scale), t1.matrixWorldInverse.copy(t1.matrixWorld).invert();
                        const g = s + f, m = o + f, M = d - A, y = p + (n - A), v = l * o / m * g, x = c * o / m * g;
                        t1.projectionMatrix.makePerspective(M, y, v, x, g, m), t1.projectionMatrixInverse.copy(t1.projectionMatrix).invert();
                    }(w, y, v) : w.projectionMatrix.copy(y.projectionMatrix), function(t1, e, i) {
                        null === i ? t1.matrix.copy(e.matrixWorld) : (t1.matrix.copy(i.matrixWorld), t1.matrix.invert(), t1.matrix.multiply(e.matrixWorld)), t1.matrix.decompose(t1.position, t1.quaternion, t1.scale), t1.updateMatrixWorld(!0), t1.projectionMatrix.copy(e.projectionMatrix), t1.projectionMatrixInverse.copy(e.projectionMatrixInverse), t1.isPerspectiveCamera && (t1.fov = 2 * zo * Math.atan(1 / t1.projectionMatrix.elements[5]), t1.zoom = 1);
                    }(t1, w, e);
                }, this.getCamera = function() {
                    return w;
                }, this.getFoveation = function() {
                    if (null !== h || null !== d) return o;
                }, this.setFoveation = function(t1) {
                    o = t1, null !== h && (h.fixedFoveation = t1), null !== d && void 0 !== d.fixedFoveation && (d.fixedFoveation = t1);
                };
                let z = null;
                const L = new th;
                L.setAnimationLoop(function(e, n) {
                    if (c = n.getViewerPose(l || a), p = n, null !== c) {
                        const e = c.views;
                        null !== d && (t1.setRenderTargetFramebuffer(g, d.framebuffer), t1.setRenderTarget(g));
                        let i = !1;
                        e.length !== w.cameras.length && (w.cameras.length = 0, i = !0);
                        for(let n = 0; n < e.length; n++){
                            const r = e[n];
                            let a = null;
                            if (null !== d) a = d.getViewport(r);
                            else {
                                const e = u.getViewSubImage(h, r);
                                a = e.viewport, 0 === n && (t1.setRenderTargetTextures(g, e.colorTexture, h.ignoreDepthValues ? void 0 : e.depthStencilTexture), t1.setRenderTarget(g));
                            }
                            let s = x[n];
                            void 0 === s && (s = new Qu, s.layers.enable(n), s.viewport = new dl, x[n] = s), s.matrix.fromArray(r.transform.matrix), s.matrix.decompose(s.position, s.quaternion, s.scale), s.projectionMatrix.fromArray(r.projectionMatrix), s.projectionMatrixInverse.copy(s.projectionMatrix).invert(), s.viewport.set(a.x, a.y, a.width, a.height), 0 === n && (w.matrix.copy(s.matrix), w.matrix.decompose(w.position, w.quaternion, w.scale)), !0 === i && w.cameras.push(s);
                        }
                    }
                    for(let t1 = 0; t1 < m.length; t1++){
                        const e = M[t1], i = m[t1];
                        null !== e && void 0 !== i && i.update(e, n, l || a);
                    }
                    z && z(e, n), n.detectedPlanes && i.dispatchEvent({
                        type: "planesdetected",
                        data: n
                    }), p = null;
                }), this.setAnimationLoop = function(t1) {
                    z = t1;
                }, this.dispose = function() {};
            }
        }
        function Lp(t1, e) {
            function i(t1, e) {
                !0 === t1.matrixAutoUpdate && t1.updateMatrix(), e.value.copy(t1.matrix);
            }
            function n(n, r) {
                n.opacity.value = r.opacity, r.color && n.diffuse.value.copy(r.color), r.emissive && n.emissive.value.copy(r.emissive).multiplyScalar(r.emissiveIntensity), r.map && (n.map.value = r.map, i(r.map, n.mapTransform)), r.alphaMap && (n.alphaMap.value = r.alphaMap, i(r.alphaMap, n.alphaMapTransform)), r.bumpMap && (n.bumpMap.value = r.bumpMap, i(r.bumpMap, n.bumpMapTransform), n.bumpScale.value = r.bumpScale, r.side === tr && (n.bumpScale.value *= -1)), r.normalMap && (n.normalMap.value = r.normalMap, i(r.normalMap, n.normalMapTransform), n.normalScale.value.copy(r.normalScale), r.side === tr && n.normalScale.value.negate()), r.displacementMap && (n.displacementMap.value = r.displacementMap, i(r.displacementMap, n.displacementMapTransform), n.displacementScale.value = r.displacementScale, n.displacementBias.value = r.displacementBias), r.emissiveMap && (n.emissiveMap.value = r.emissiveMap, i(r.emissiveMap, n.emissiveMapTransform)), r.specularMap && (n.specularMap.value = r.specularMap, i(r.specularMap, n.specularMapTransform)), r.alphaTest > 0 && (n.alphaTest.value = r.alphaTest);
                const a = e.get(r).envMap;
                if (a && (n.envMap.value = a, n.flipEnvMap.value = a.isCubeTexture && !1 === a.isRenderTargetTexture ? -1 : 1, n.reflectivity.value = r.reflectivity, n.ior.value = r.ior, n.refractionRatio.value = r.refractionRatio), r.lightMap) {
                    n.lightMap.value = r.lightMap;
                    const e = !0 === t1._useLegacyLights ? Math.PI : 1;
                    n.lightMapIntensity.value = r.lightMapIntensity * e, i(r.lightMap, n.lightMapTransform);
                }
                r.aoMap && (n.aoMap.value = r.aoMap, n.aoMapIntensity.value = r.aoMapIntensity, i(r.aoMap, n.aoMapTransform));
            }
            return {
                refreshFogUniforms: function(e, i) {
                    i.color.getRGB(e.fogColor.value, Uu(t1)), i.isFog ? (e.fogNear.value = i.near, e.fogFar.value = i.far) : i.isFogExp2 && (e.fogDensity.value = i.density);
                },
                refreshMaterialUniforms: function(t1, r, a, s, o) {
                    r.isMeshBasicMaterial || r.isMeshLambertMaterial ? n(t1, r) : r.isMeshToonMaterial ? (n(t1, r), function(t1, e) {
                        e.gradientMap && (t1.gradientMap.value = e.gradientMap);
                    }(t1, r)) : r.isMeshPhongMaterial ? (n(t1, r), function(t1, e) {
                        t1.specular.value.copy(e.specular), t1.shininess.value = Math.max(e.shininess, 1e-4);
                    }(t1, r)) : r.isMeshStandardMaterial ? (n(t1, r), function(t1, n) {
                        t1.metalness.value = n.metalness, n.metalnessMap && (t1.metalnessMap.value = n.metalnessMap, i(n.metalnessMap, t1.metalnessMapTransform)), t1.roughness.value = n.roughness, n.roughnessMap && (t1.roughnessMap.value = n.roughnessMap, i(n.roughnessMap, t1.roughnessMapTransform));
                        e.get(n).envMap && (t1.envMapIntensity.value = n.envMapIntensity);
                    }(t1, r), r.isMeshPhysicalMaterial && function(t1, e, n) {
                        t1.ior.value = e.ior, e.sheen > 0 && (t1.sheenColor.value.copy(e.sheenColor).multiplyScalar(e.sheen), t1.sheenRoughness.value = e.sheenRoughness, e.sheenColorMap && (t1.sheenColorMap.value = e.sheenColorMap, i(e.sheenColorMap, t1.sheenColorMapTransform)), e.sheenRoughnessMap && (t1.sheenRoughnessMap.value = e.sheenRoughnessMap, i(e.sheenRoughnessMap, t1.sheenRoughnessMapTransform))), e.clearcoat > 0 && (t1.clearcoat.value = e.clearcoat, t1.clearcoatRoughness.value = e.clearcoatRoughness, e.clearcoatMap && (t1.clearcoatMap.value = e.clearcoatMap, i(e.clearcoatMap, t1.clearcoatMapTransform)), e.clearcoatRoughnessMap && (t1.clearcoatRoughnessMap.value = e.clearcoatRoughnessMap, i(e.clearcoatRoughnessMap, t1.clearcoatRoughnessMapTransform)), e.clearcoatNormalMap && (t1.clearcoatNormalMap.value = e.clearcoatNormalMap, i(e.clearcoatNormalMap, t1.clearcoatNormalMapTransform), t1.clearcoatNormalScale.value.copy(e.clearcoatNormalScale), e.side === tr && t1.clearcoatNormalScale.value.negate())), e.iridescence > 0 && (t1.iridescence.value = e.iridescence, t1.iridescenceIOR.value = e.iridescenceIOR, t1.iridescenceThicknessMinimum.value = e.iridescenceThicknessRange[0], t1.iridescenceThicknessMaximum.value = e.iridescenceThicknessRange[1], e.iridescenceMap && (t1.iridescenceMap.value = e.iridescenceMap, i(e.iridescenceMap, t1.iridescenceMapTransform)), e.iridescenceThicknessMap && (t1.iridescenceThicknessMap.value = e.iridescenceThicknessMap, i(e.iridescenceThicknessMap, t1.iridescenceThicknessMapTransform))), e.transmission > 0 && (t1.transmission.value = e.transmission, t1.transmissionSamplerMap.value = n.texture, t1.transmissionSamplerSize.value.set(n.width, n.height), e.transmissionMap && (t1.transmissionMap.value = e.transmissionMap, i(e.transmissionMap, t1.transmissionMapTransform)), t1.thickness.value = e.thickness, e.thicknessMap && (t1.thicknessMap.value = e.thicknessMap, i(e.thicknessMap, t1.thicknessMapTransform)), t1.attenuationDistance.value = e.attenuationDistance, t1.attenuationColor.value.copy(e.attenuationColor)), e.anisotropy > 0 && (t1.anisotropyVector.value.set(e.anisotropy * Math.cos(e.anisotropyRotation), e.anisotropy * Math.sin(e.anisotropyRotation)), e.anisotropyMap && (t1.anisotropyMap.value = e.anisotropyMap, i(e.anisotropyMap, t1.anisotropyMapTransform))), t1.specularIntensity.value = e.specularIntensity, t1.specularColor.value.copy(e.specularColor), e.specularColorMap && (t1.specularColorMap.value = e.specularColorMap, i(e.specularColorMap, t1.specularColorMapTransform)), e.specularIntensityMap && (t1.specularIntensityMap.value = e.specularIntensityMap, i(e.specularIntensityMap, t1.specularIntensityMapTransform));
                    }(t1, r, o)) : r.isMeshMatcapMaterial ? (n(t1, r), function(t1, e) {
                        e.matcap && (t1.matcap.value = e.matcap);
                    }(t1, r)) : r.isMeshDepthMaterial ? n(t1, r) : r.isMeshDistanceMaterial ? (n(t1, r), function(t1, i) {
                        const n = e.get(i).light;
                        t1.referencePosition.value.setFromMatrixPosition(n.matrixWorld), t1.nearDistance.value = n.shadow.camera.near, t1.farDistance.value = n.shadow.camera.far;
                    }(t1, r)) : r.isMeshNormalMaterial ? n(t1, r) : r.isLineBasicMaterial ? (function(t1, e) {
                        t1.diffuse.value.copy(e.color), t1.opacity.value = e.opacity, e.map && (t1.map.value = e.map, i(e.map, t1.mapTransform));
                    }(t1, r), r.isLineDashedMaterial && function(t1, e) {
                        t1.dashSize.value = e.dashSize, t1.totalSize.value = e.dashSize + e.gapSize, t1.scale.value = e.scale;
                    }(t1, r)) : r.isPointsMaterial ? function(t1, e, n, r) {
                        t1.diffuse.value.copy(e.color), t1.opacity.value = e.opacity, t1.size.value = e.size * n, t1.scale.value = .5 * r, e.map && (t1.map.value = e.map, i(e.map, t1.uvTransform)), e.alphaMap && (t1.alphaMap.value = e.alphaMap, i(e.alphaMap, t1.alphaMapTransform)), e.alphaTest > 0 && (t1.alphaTest.value = e.alphaTest);
                    }(t1, r, a, s) : r.isSpriteMaterial ? function(t1, e) {
                        t1.diffuse.value.copy(e.color), t1.opacity.value = e.opacity, t1.rotation.value = e.rotation, e.map && (t1.map.value = e.map, i(e.map, t1.mapTransform)), e.alphaMap && (t1.alphaMap.value = e.alphaMap, i(e.alphaMap, t1.alphaMapTransform)), e.alphaTest > 0 && (t1.alphaTest.value = e.alphaTest);
                    }(t1, r) : r.isShadowMaterial ? (t1.color.value.copy(r.color), t1.opacity.value = r.opacity) : r.isShaderMaterial && (r.uniformsNeedUpdate = !1);
                }
            };
        }
        function Op(t1, e, i, n) {
            let r = {}, a = {}, s = [];
            const o = i.isWebGL2 ? t1.getParameter(t1.MAX_UNIFORM_BUFFER_BINDINGS) : 0;
            function l(t1, e, i) {
                const n = t1.value;
                if (void 0 === i[e]) {
                    if ("number" == typeof n) i[e] = n;
                    else {
                        const t1 = Array.isArray(n) ? n : [
                            n
                        ], r = [];
                        for(let e = 0; e < t1.length; e++)r.push(t1[e].clone());
                        i[e] = r;
                    }
                    return !0;
                }
                if ("number" == typeof n) {
                    if (i[e] !== n) return i[e] = n, !0;
                } else {
                    const t1 = Array.isArray(i[e]) ? i[e] : [
                        i[e]
                    ], r = Array.isArray(n) ? n : [
                        n
                    ];
                    for(let e = 0; e < t1.length; e++){
                        const i = t1[e];
                        if (!1 === i.equals(r[e])) return i.copy(r[e]), !0;
                    }
                }
                return !1;
            }
            function c(t1) {
                const e = {
                    boundary: 0,
                    storage: 0
                };
                return "number" == typeof t1 ? (e.boundary = 4, e.storage = 4) : t1.isVector2 ? (e.boundary = 8, e.storage = 8) : t1.isVector3 || t1.isColor ? (e.boundary = 16, e.storage = 12) : t1.isVector4 ? (e.boundary = 16, e.storage = 16) : t1.isMatrix3 ? (e.boundary = 48, e.storage = 48) : t1.isMatrix4 ? (e.boundary = 64, e.storage = 64) : t1.isTexture ? console.warn("THREE.WebGLRenderer: Texture samplers can not be part of an uniforms group.") : console.warn("THREE.WebGLRenderer: Unsupported uniform value type.", t1), e;
            }
            function u(e) {
                const i = e.target;
                i.removeEventListener("dispose", u);
                const n = s.indexOf(i.__bindingPointIndex);
                s.splice(n, 1), t1.deleteBuffer(r[i.id]), delete r[i.id], delete a[i.id];
            }
            return {
                bind: function(t1, e) {
                    const i = e.program;
                    n.uniformBlockBinding(t1, i);
                },
                update: function(i, h) {
                    let d = r[i.id];
                    void 0 === d && (function(t1) {
                        const e = t1.uniforms;
                        let i = 0;
                        let n = 0;
                        for(let t1 = 0, r = e.length; t1 < r; t1++){
                            const r = e[t1], a = {
                                boundary: 0,
                                storage: 0
                            }, s = Array.isArray(r.value) ? r.value : [
                                r.value
                            ];
                            for(let t1 = 0, e = s.length; t1 < e; t1++){
                                const e = c(s[t1]);
                                a.boundary += e.boundary, a.storage += e.storage;
                            }
                            r.__data = new Float32Array(a.storage / Float32Array.BYTES_PER_ELEMENT), r.__offset = i, t1 > 0 && (n = i % 16, 0 !== n && 16 - n - a.boundary < 0 && (i += 16 - n, r.__offset = i)), i += a.storage;
                        }
                        n = i % 16, n > 0 && (i += 16 - n), t1.__size = i, t1.__cache = {};
                    }(i), d = function(e) {
                        const i = function() {
                            for(let t1 = 0; t1 < o; t1++)if (-1 === s.indexOf(t1)) return s.push(t1), t1;
                            return console.error("THREE.WebGLRenderer: Maximum number of simultaneously usable uniforms groups reached."), 0;
                        }();
                        e.__bindingPointIndex = i;
                        const n = t1.createBuffer(), r = e.__size, a = e.usage;
                        return t1.bindBuffer(t1.UNIFORM_BUFFER, n), t1.bufferData(t1.UNIFORM_BUFFER, r, a), t1.bindBuffer(t1.UNIFORM_BUFFER, null), t1.bindBufferBase(t1.UNIFORM_BUFFER, i, n), n;
                    }(i), r[i.id] = d, i.addEventListener("dispose", u));
                    const p = h.program;
                    n.updateUBOMapping(i, p);
                    const f = e.render.frame;
                    a[i.id] !== f && (function(e) {
                        const i = r[e.id], n = e.uniforms, a = e.__cache;
                        t1.bindBuffer(t1.UNIFORM_BUFFER, i);
                        for(let e = 0, i = n.length; e < i; e++){
                            const i = n[e];
                            if (!0 === l(i, e, a)) {
                                const e = i.__offset, n = Array.isArray(i.value) ? i.value : [
                                    i.value
                                ];
                                let r = 0;
                                for(let a = 0; a < n.length; a++){
                                    const s = n[a], o = c(s);
                                    "number" == typeof s ? (i.__data[0] = s, t1.bufferSubData(t1.UNIFORM_BUFFER, e + r, i.__data)) : s.isMatrix3 ? (i.__data[0] = s.elements[0], i.__data[1] = s.elements[1], i.__data[2] = s.elements[2], i.__data[3] = s.elements[0], i.__data[4] = s.elements[3], i.__data[5] = s.elements[4], i.__data[6] = s.elements[5], i.__data[7] = s.elements[0], i.__data[8] = s.elements[6], i.__data[9] = s.elements[7], i.__data[10] = s.elements[8], i.__data[11] = s.elements[0]) : (s.toArray(i.__data, r), r += o.storage / Float32Array.BYTES_PER_ELEMENT);
                                }
                                t1.bufferSubData(t1.UNIFORM_BUFFER, e, i.__data);
                            }
                        }
                        t1.bindBuffer(t1.UNIFORM_BUFFER, null);
                    }(i), a[i.id] = f);
                },
                dispose: function() {
                    for(const e in r)t1.deleteBuffer(r[e]);
                    s = [], r = {}, a = {};
                }
            };
        }
        class _p {
            constructor(t1 = {}){
                const { canvas: e = Zo(), context: i = null, depth: n = !0, stencil: r = !0, alpha: a = !1, antialias: s = !1, premultipliedAlpha: o = !0, preserveDrawingBuffer: l = !1, powerPreference: c = "default", failIfMajorPerformanceCaveat: u = !1 } = t1;
                let h;
                this.isWebGLRenderer = !0, h = null !== i ? i.getContextAttributes().alpha : a;
                const d = new Uint32Array(4), p = new Int32Array(4);
                let f = null, A = null;
                const g = [], m = [];
                this.domElement = e, this.debug = {
                    checkShaderErrors: !0,
                    onShaderError: null
                }, this.autoClear = !0, this.autoClearColor = !0, this.autoClearDepth = !0, this.autoClearStencil = !0, this.sortObjects = !0, this.clippingPlanes = [], this.localClippingEnabled = !1, this._outputColorSpace = _s, this._useLegacyLights = !1, this.toneMapping = Br, this.toneMappingExposure = 1;
                const M = this;
                let y = !1, v = 0, x = 0, w = null, b = -1, T = null;
                const E = new dl, I = new dl;
                let S = null;
                const N = new kc(0);
                let D = 0, C = e.width, z = e.height, L = 1, O = null, _ = null;
                const j = new dl(0, 0, C, z), P = new dl(0, 0, C, z);
                let R = !1;
                const U = new $u;
                let k = !1, B = !1, F = null;
                const Q = new Kl, H = new Qo, V = new xl, G = {
                    background: null,
                    fog: null,
                    environment: null,
                    overrideMaterial: null,
                    isScene: !0
                };
                function Y() {
                    return null === w ? L : 1;
                }
                let W, X, Z, J, K, q, $, tt, et, it, nt, rt, at, st, ot, lt, ct, ut, ht, dt, pt, ft, At, gt, mt = i;
                function Mt(t1, i) {
                    for(let n = 0; n < t1.length; n++){
                        const r = t1[n], a = e.getContext(r, i);
                        if (null !== a) return a;
                    }
                    return null;
                }
                try {
                    const t1 = {
                        alpha: !0,
                        depth: n,
                        stencil: r,
                        antialias: s,
                        premultipliedAlpha: o,
                        preserveDrawingBuffer: l,
                        powerPreference: c,
                        failIfMajorPerformanceCaveat: u
                    };
                    if ("setAttribute" in e && e.setAttribute("data-engine", `three.js r${Qn}`), e.addEventListener("webglcontextlost", xt, !1), e.addEventListener("webglcontextrestored", wt, !1), e.addEventListener("webglcontextcreationerror", bt, !1), null === mt) {
                        const e = [
                            "webgl2",
                            "webgl",
                            "experimental-webgl"
                        ];
                        if (!0 === M.isWebGL1Renderer && e.shift(), mt = Mt(e, t1), null === mt) throw Mt(e) ? new Error("Error creating WebGL context with your selected attributes.") : new Error("Error creating WebGL context.");
                    }
                    "undefined" != typeof WebGLRenderingContext && mt instanceof WebGLRenderingContext && console.warn("THREE.WebGLRenderer: WebGL 1 support was deprecated in r153 and will be removed in r163."), void 0 === mt.getShaderPrecisionFormat && (mt.getShaderPrecisionFormat = function() {
                        return {
                            rangeMin: 1,
                            rangeMax: 1,
                            precision: 1
                        };
                    });
                } catch (t1) {
                    throw console.error("THREE.WebGLRenderer: " + t1.message), t1;
                }
                function yt() {
                    W = new Dh(mt), X = new uh(mt, W, t1), W.init(X), ft = new Ep(mt, W, X), Z = new bp(mt, W, X), J = new Lh(mt), K = new cp, q = new Tp(mt, W, Z, K, X, ft, J), $ = new dh(M), tt = new Nh(M), et = new eh(mt, X), At = new lh(mt, W, et, X), it = new Ch(mt, et, J, At), nt = new Ph(mt, it, et, J), ht = new jh(mt, X, q), lt = new hh(K), rt = new lp(M, $, tt, W, X, At, lt), at = new Lp(M, K), st = new pp, ot = new yp(W, X), ut = new oh(M, $, tt, Z, nt, h, o), ct = new wp(M, nt, X), gt = new Op(mt, J, X, Z), dt = new ch(mt, W, J, X), pt = new zh(mt, W, J, X), J.programs = rt.programs, M.capabilities = X, M.extensions = W, M.properties = K, M.renderLists = st, M.shadowMap = ct, M.state = Z, M.info = J;
                }
                yt();
                const vt = new zp(M, mt);
                function xt(t1) {
                    t1.preventDefault(), console.log("THREE.WebGLRenderer: Context Lost."), y = !0;
                }
                function wt() {
                    console.log("THREE.WebGLRenderer: Context Restored."), y = !1;
                    const t1 = J.autoReset, e = ct.enabled, i = ct.autoUpdate, n = ct.needsUpdate, r = ct.type;
                    yt(), J.autoReset = t1, ct.enabled = e, ct.autoUpdate = i, ct.needsUpdate = n, ct.type = r;
                }
                function bt(t1) {
                    console.error("THREE.WebGLRenderer: A WebGL context could not be created. Reason: ", t1.statusMessage);
                }
                function Tt(t1) {
                    const e = t1.target;
                    e.removeEventListener("dispose", Tt), function(t1) {
                        (function(t1) {
                            const e = K.get(t1).programs;
                            void 0 !== e && (e.forEach(function(t1) {
                                rt.releaseProgram(t1);
                            }), t1.isShaderMaterial && rt.releaseShaderCache(t1));
                        })(t1), K.remove(t1);
                    }(e);
                }
                function Et(t1, e, i) {
                    !0 === t1.transparent && t1.side === er && !1 === t1.forceSinglePass ? (t1.side = tr, t1.needsUpdate = !0, _t(t1, e, i), t1.side = $n, t1.needsUpdate = !0, _t(t1, e, i), t1.side = er) : _t(t1, e, i);
                }
                this.xr = vt, this.getContext = function() {
                    return mt;
                }, this.getContextAttributes = function() {
                    return mt.getContextAttributes();
                }, this.forceContextLoss = function() {
                    const t1 = W.get("WEBGL_lose_context");
                    t1 && t1.loseContext();
                }, this.forceContextRestore = function() {
                    const t1 = W.get("WEBGL_lose_context");
                    t1 && t1.restoreContext();
                }, this.getPixelRatio = function() {
                    return L;
                }, this.setPixelRatio = function(t1) {
                    void 0 !== t1 && (L = t1, this.setSize(C, z, !1));
                }, this.getSize = function(t1) {
                    return t1.set(C, z);
                }, this.setSize = function(t1, i, n = !0) {
                    vt.isPresenting ? console.warn("THREE.WebGLRenderer: Can't change size while VR device is presenting.") : (C = t1, z = i, e.width = Math.floor(t1 * L), e.height = Math.floor(i * L), !0 === n && (e.style.width = t1 + "px", e.style.height = i + "px"), this.setViewport(0, 0, t1, i));
                }, this.getDrawingBufferSize = function(t1) {
                    return t1.set(C * L, z * L).floor();
                }, this.setDrawingBufferSize = function(t1, i, n) {
                    C = t1, z = i, L = n, e.width = Math.floor(t1 * n), e.height = Math.floor(i * n), this.setViewport(0, 0, t1, i);
                }, this.getCurrentViewport = function(t1) {
                    return t1.copy(E);
                }, this.getViewport = function(t1) {
                    return t1.copy(j);
                }, this.setViewport = function(t1, e, i, n) {
                    t1.isVector4 ? j.set(t1.x, t1.y, t1.z, t1.w) : j.set(t1, e, i, n), Z.viewport(E.copy(j).multiplyScalar(L).floor());
                }, this.getScissor = function(t1) {
                    return t1.copy(P);
                }, this.setScissor = function(t1, e, i, n) {
                    t1.isVector4 ? P.set(t1.x, t1.y, t1.z, t1.w) : P.set(t1, e, i, n), Z.scissor(I.copy(P).multiplyScalar(L).floor());
                }, this.getScissorTest = function() {
                    return R;
                }, this.setScissorTest = function(t1) {
                    Z.setScissorTest(R = t1);
                }, this.setOpaqueSort = function(t1) {
                    O = t1;
                }, this.setTransparentSort = function(t1) {
                    _ = t1;
                }, this.getClearColor = function(t1) {
                    return t1.copy(ut.getClearColor());
                }, this.setClearColor = function() {
                    ut.setClearColor.apply(ut, arguments);
                }, this.getClearAlpha = function() {
                    return ut.getClearAlpha();
                }, this.setClearAlpha = function() {
                    ut.setClearAlpha.apply(ut, arguments);
                }, this.clear = function(t1 = !0, e = !0, i = !0) {
                    let n = 0;
                    if (t1) {
                        let t1 = !1;
                        if (null !== w) {
                            const e = w.texture.format;
                            t1 = e === _a || e === Oa || e === za;
                        }
                        if (t1) {
                            const t1 = w.texture.type, e = t1 === pa || t1 === Ma || t1 === ga || t1 === ba || t1 === xa || t1 === wa, i = ut.getClearColor(), n = ut.getClearAlpha(), r = i.r, a = i.g, s = i.b;
                            e ? (d[0] = r, d[1] = a, d[2] = s, d[3] = n, mt.clearBufferuiv(mt.COLOR, 0, d)) : (p[0] = r, p[1] = a, p[2] = s, p[3] = n, mt.clearBufferiv(mt.COLOR, 0, p));
                        } else n |= mt.COLOR_BUFFER_BIT;
                    }
                    e && (n |= mt.DEPTH_BUFFER_BIT), i && (n |= mt.STENCIL_BUFFER_BIT, this.state.buffers.stencil.setMask(4294967295)), mt.clear(n);
                }, this.clearColor = function() {
                    this.clear(!0, !1, !1);
                }, this.clearDepth = function() {
                    this.clear(!1, !0, !1);
                }, this.clearStencil = function() {
                    this.clear(!1, !1, !0);
                }, this.dispose = function() {
                    e.removeEventListener("webglcontextlost", xt, !1), e.removeEventListener("webglcontextrestored", wt, !1), e.removeEventListener("webglcontextcreationerror", bt, !1), st.dispose(), ot.dispose(), K.dispose(), $.dispose(), tt.dispose(), nt.dispose(), At.dispose(), gt.dispose(), rt.dispose(), vt.dispose(), vt.removeEventListener("sessionstart", St), vt.removeEventListener("sessionend", Nt), F && (F.dispose(), F = null), Dt.stop();
                }, this.renderBufferDirect = function(t1, e, i, n, r, a) {
                    null === e && (e = G);
                    const s = r.isMesh && r.matrixWorld.determinant() < 0, o = function(t1, e, i, n, r) {
                        !0 !== e.isScene && (e = G), q.resetTextureUnits();
                        const a = e.fog, s = n.isMeshStandardMaterial ? e.environment : null, o = null === w ? M.outputColorSpace : !0 === w.isXRRenderTarget ? w.texture.colorSpace : js, l = (n.isMeshStandardMaterial ? tt : $).get(n.envMap || s), c = !0 === n.vertexColors && !!i.attributes.color && 4 === i.attributes.color.itemSize, u = !!i.attributes.tangent && (!!n.normalMap || n.anisotropy > 0), h = !!i.morphAttributes.position, d = !!i.morphAttributes.normal, p = !!i.morphAttributes.color;
                        let f = Br;
                        n.toneMapped && (null !== w && !0 !== w.isXRRenderTarget || (f = M.toneMapping));
                        const g = i.morphAttributes.position || i.morphAttributes.normal || i.morphAttributes.color, m = void 0 !== g ? g.length : 0, y = K.get(n), v = A.state.lights;
                        if (!0 === k && (!0 === B || t1 !== T)) {
                            const e = t1 === T && n.id === b;
                            lt.setState(n, t1, e);
                        }
                        let x = !1;
                        n.version === y.__version ? y.needsLights && y.lightsStateVersion !== v.state.version || y.outputColorSpace !== o || r.isInstancedMesh && !1 === y.instancing ? x = !0 : r.isInstancedMesh || !0 !== y.instancing ? r.isSkinnedMesh && !1 === y.skinning ? x = !0 : r.isSkinnedMesh || !0 !== y.skinning ? r.isInstancedMesh && !0 === y.instancingColor && null === r.instanceColor || r.isInstancedMesh && !1 === y.instancingColor && null !== r.instanceColor || y.envMap !== l || !0 === n.fog && y.fog !== a ? x = !0 : void 0 === y.numClippingPlanes || y.numClippingPlanes === lt.numPlanes && y.numIntersection === lt.numIntersection ? (y.vertexAlphas !== c || y.vertexTangents !== u || y.morphTargets !== h || y.morphNormals !== d || y.morphColors !== p || y.toneMapping !== f || !0 === X.isWebGL2 && y.morphTargetsCount !== m) && (x = !0) : x = !0 : x = !0 : x = !0 : (x = !0, y.__version = n.version);
                        let E = y.currentProgram;
                        !0 === x && (E = _t(n, e, r));
                        let I = !1, S = !1, N = !1;
                        const D = E.getUniforms(), C = y.uniforms;
                        if (Z.useProgram(E.program) && (I = !0, S = !0, N = !0), n.id !== b && (b = n.id, S = !0), I || T !== t1) {
                            D.setValue(mt, "projectionMatrix", t1.projectionMatrix), D.setValue(mt, "viewMatrix", t1.matrixWorldInverse);
                            const e = D.map.cameraPosition;
                            void 0 !== e && e.setValue(mt, V.setFromMatrixPosition(t1.matrixWorld)), X.logarithmicDepthBuffer && D.setValue(mt, "logDepthBufFC", 2 / (Math.log(t1.far + 1) / Math.LN2)), (n.isMeshPhongMaterial || n.isMeshToonMaterial || n.isMeshLambertMaterial || n.isMeshBasicMaterial || n.isMeshStandardMaterial || n.isShaderMaterial) && D.setValue(mt, "isOrthographic", !0 === t1.isOrthographicCamera), T !== t1 && (T = t1, S = !0, N = !0);
                        }
                        if (r.isSkinnedMesh) {
                            D.setOptional(mt, r, "bindMatrix"), D.setOptional(mt, r, "bindMatrixInverse");
                            const t1 = r.skeleton;
                            t1 && (X.floatVertexTextures ? (null === t1.boneTexture && t1.computeBoneTexture(), D.setValue(mt, "boneTexture", t1.boneTexture, q), D.setValue(mt, "boneTextureSize", t1.boneTextureSize)) : console.warn("THREE.WebGLRenderer: SkinnedMesh can only be used with WebGL 2. With WebGL 1 OES_texture_float and vertex textures support is required."));
                        }
                        const O = i.morphAttributes;
                        var _, j;
                        if ((void 0 !== O.position || void 0 !== O.normal || void 0 !== O.color && !0 === X.isWebGL2) && ht.update(r, i, E), (S || y.receiveShadow !== r.receiveShadow) && (y.receiveShadow = r.receiveShadow, D.setValue(mt, "receiveShadow", r.receiveShadow)), n.isMeshGouraudMaterial && null !== n.envMap && (C.envMap.value = l, C.flipEnvMap.value = l.isCubeTexture && !1 === l.isRenderTargetTexture ? -1 : 1), S && (D.setValue(mt, "toneMappingExposure", M.toneMappingExposure), y.needsLights && (j = N, (_ = C).ambientLightColor.needsUpdate = j, _.lightProbe.needsUpdate = j, _.directionalLights.needsUpdate = j, _.directionalLightShadows.needsUpdate = j, _.pointLights.needsUpdate = j, _.pointLightShadows.needsUpdate = j, _.spotLights.needsUpdate = j, _.spotLightShadows.needsUpdate = j, _.rectAreaLights.needsUpdate = j, _.hemisphereLights.needsUpdate = j), a && !0 === n.fog && at.refreshFogUniforms(C, a), at.refreshMaterialUniforms(C, n, L, z, F), Bd.upload(mt, jt(y), C, q)), n.isShaderMaterial && !0 === n.uniformsNeedUpdate && (Bd.upload(mt, jt(y), C, q), n.uniformsNeedUpdate = !1), n.isSpriteMaterial && D.setValue(mt, "center", r.center), D.setValue(mt, "modelViewMatrix", r.modelViewMatrix), D.setValue(mt, "normalMatrix", r.normalMatrix), D.setValue(mt, "modelMatrix", r.matrixWorld), n.isShaderMaterial || n.isRawShaderMaterial) {
                            const t1 = n.uniformsGroups;
                            for(let e = 0, i = t1.length; e < i; e++)if (X.isWebGL2) {
                                const i = t1[e];
                                gt.update(i, E), gt.bind(i, E);
                            } else console.warn("THREE.WebGLRenderer: Uniform Buffer Objects can only be used with WebGL 2.");
                        }
                        return E;
                    }(t1, e, i, n, r);
                    Z.setMaterial(n, s);
                    let l = i.index, c = 1;
                    if (!0 === n.wireframe) {
                        if (l = it.getWireframeAttribute(i), void 0 === l) return;
                        c = 2;
                    }
                    const u = i.drawRange, h = i.attributes.position;
                    let d = u.start * c, p = (u.start + u.count) * c;
                    null !== a && (d = Math.max(d, a.start * c), p = Math.min(p, (a.start + a.count) * c)), null !== l ? (d = Math.max(d, 0), p = Math.min(p, l.count)) : null != h && (d = Math.max(d, 0), p = Math.min(p, h.count));
                    const f = p - d;
                    if (f < 0 || f === 1 / 0) return;
                    let g;
                    At.setup(r, n, o, i, l);
                    let m = dt;
                    if (null !== l && (g = et.get(l), m = pt, m.setIndex(g)), r.isMesh) !0 === n.wireframe ? (Z.setLineWidth(n.wireframeLinewidth * Y()), m.setMode(mt.LINES)) : m.setMode(mt.TRIANGLES);
                    else if (r.isLine) {
                        let t1 = n.linewidth;
                        void 0 === t1 && (t1 = 1), Z.setLineWidth(t1 * Y()), r.isLineSegments ? m.setMode(mt.LINES) : r.isLineLoop ? m.setMode(mt.LINE_LOOP) : m.setMode(mt.LINE_STRIP);
                    } else r.isPoints ? m.setMode(mt.POINTS) : r.isSprite && m.setMode(mt.TRIANGLES);
                    if (r.isInstancedMesh) m.renderInstances(d, f, r.count);
                    else if (i.isInstancedBufferGeometry) {
                        const t1 = void 0 !== i._maxInstanceCount ? i._maxInstanceCount : 1 / 0, e = Math.min(i.instanceCount, t1);
                        m.renderInstances(d, f, e);
                    } else m.render(d, f);
                }, this.compile = function(t1, e, i = null) {
                    null === i && (i = t1), A = ot.get(i), A.init(), m.push(A), i.traverseVisible(function(t1) {
                        t1.isLight && t1.layers.test(e.layers) && (A.pushLight(t1), t1.castShadow && A.pushShadow(t1));
                    }), t1 !== i && t1.traverseVisible(function(t1) {
                        t1.isLight && t1.layers.test(e.layers) && (A.pushLight(t1), t1.castShadow && A.pushShadow(t1));
                    }), A.setupLights(M._useLegacyLights);
                    const n = new Set;
                    return t1.traverse(function(t1) {
                        const e = t1.material;
                        if (e) {
                            if (Array.isArray(e)) for(let r = 0; r < e.length; r++){
                                const a = e[r];
                                Et(a, i, t1), n.add(a);
                            }
                            else Et(e, i, t1), n.add(e);
                        }
                    }), m.pop(), A = null, n;
                }, this.compileAsync = function(t1, e, i = null) {
                    const n = this.compile(t1, e, i);
                    return new Promise((e)=>{
                        function i() {
                            n.forEach(function(t1) {
                                K.get(t1).currentProgram.isReady() && n.delete(t1);
                            }), 0 !== n.size ? setTimeout(i, 10) : e(t1);
                        }
                        null !== W.get("KHR_parallel_shader_compile") ? i() : setTimeout(i, 10);
                    });
                };
                let It = null;
                function St() {
                    Dt.stop();
                }
                function Nt() {
                    Dt.start();
                }
                const Dt = new th;
                function Ct(t1, e, i, n) {
                    if (!1 === t1.visible) return;
                    if (t1.layers.test(e.layers)) {
                        if (t1.isGroup) i = t1.renderOrder;
                        else if (t1.isLOD) !0 === t1.autoUpdate && t1.update(e);
                        else if (t1.isLight) A.pushLight(t1), t1.castShadow && A.pushShadow(t1);
                        else if (t1.isSprite) {
                            if (!t1.frustumCulled || U.intersectsSprite(t1)) {
                                n && V.setFromMatrixPosition(t1.matrixWorld).applyMatrix4(Q);
                                const e = nt.update(t1), r = t1.material;
                                r.visible && f.push(t1, e, r, i, V.z, null);
                            }
                        } else if ((t1.isMesh || t1.isLine || t1.isPoints) && (!t1.frustumCulled || U.intersectsObject(t1))) {
                            const e = nt.update(t1), r = t1.material;
                            if (n && (void 0 !== t1.boundingSphere ? (null === t1.boundingSphere && t1.computeBoundingSphere(), V.copy(t1.boundingSphere.center)) : (null === e.boundingSphere && e.computeBoundingSphere(), V.copy(e.boundingSphere.center)), V.applyMatrix4(t1.matrixWorld).applyMatrix4(Q)), Array.isArray(r)) {
                                const n = e.groups;
                                for(let a = 0, s = n.length; a < s; a++){
                                    const s = n[a], o = r[s.materialIndex];
                                    o && o.visible && f.push(t1, e, o, i, V.z, s);
                                }
                            } else r.visible && f.push(t1, e, r, i, V.z, null);
                        }
                    }
                    const r = t1.children;
                    for(let t1 = 0, a = r.length; t1 < a; t1++)Ct(r[t1], e, i, n);
                }
                function zt(t1, e, i, n) {
                    const r = t1.opaque, a = t1.transmissive, s = t1.transparent;
                    A.setupLightsView(i), !0 === k && lt.setGlobalState(M.clippingPlanes, i), a.length > 0 && function(t1, e, i, n) {
                        if (null !== (!0 === i.isScene ? i.overrideMaterial : null)) return;
                        const r = X.isWebGL2;
                        null === F && (F = new fl(1, 1, {
                            generateMipmaps: !0,
                            type: W.has("EXT_color_buffer_half_float") ? va : pa,
                            minFilter: ha,
                            samples: r ? 4 : 0
                        })), M.getDrawingBufferSize(H), r ? F.setSize(H.x, H.y) : F.setSize(Uo(H.x), Uo(H.y));
                        const a = M.getRenderTarget();
                        M.setRenderTarget(F), M.getClearColor(N), D = M.getClearAlpha(), D < 1 && M.setClearColor(16777215, .5), M.clear();
                        const s = M.toneMapping;
                        M.toneMapping = Br, Lt(t1, i, n), q.updateMultisampleRenderTarget(F), q.updateRenderTargetMipmap(F);
                        let o = !1;
                        for(let t1 = 0, r = e.length; t1 < r; t1++){
                            const r = e[t1], a = r.object, s = r.geometry, l = r.material, c = r.group;
                            if (l.side === er && a.layers.test(n.layers)) {
                                const t1 = l.side;
                                l.side = tr, l.needsUpdate = !0, Ot(a, i, n, s, l, c), l.side = t1, l.needsUpdate = !0, o = !0;
                            }
                        }
                        !0 === o && (q.updateMultisampleRenderTarget(F), q.updateRenderTargetMipmap(F)), M.setRenderTarget(a), M.setClearColor(N, D), M.toneMapping = s;
                    }(r, a, e, i), n && Z.viewport(E.copy(n)), r.length > 0 && Lt(r, e, i), a.length > 0 && Lt(a, e, i), s.length > 0 && Lt(s, e, i), Z.buffers.depth.setTest(!0), Z.buffers.depth.setMask(!0), Z.buffers.color.setMask(!0), Z.setPolygonOffset(!1);
                }
                function Lt(t1, e, i) {
                    const n = !0 === e.isScene ? e.overrideMaterial : null;
                    for(let r = 0, a = t1.length; r < a; r++){
                        const a = t1[r], s = a.object, o = a.geometry, l = null === n ? a.material : n, c = a.group;
                        s.layers.test(i.layers) && Ot(s, e, i, o, l, c);
                    }
                }
                function Ot(t1, e, i, n, r, a) {
                    t1.onBeforeRender(M, e, i, n, r, a), t1.modelViewMatrix.multiplyMatrices(i.matrixWorldInverse, t1.matrixWorld), t1.normalMatrix.getNormalMatrix(t1.modelViewMatrix), r.onBeforeRender(M, e, i, n, t1, a), !0 === r.transparent && r.side === er && !1 === r.forceSinglePass ? (r.side = tr, r.needsUpdate = !0, M.renderBufferDirect(i, e, n, r, t1, a), r.side = $n, r.needsUpdate = !0, M.renderBufferDirect(i, e, n, r, t1, a), r.side = er) : M.renderBufferDirect(i, e, n, r, t1, a), t1.onAfterRender(M, e, i, n, r, a);
                }
                function _t(t1, e, i) {
                    !0 !== e.isScene && (e = G);
                    const n = K.get(t1), r = A.state.lights, a = A.state.shadowsArray, s = r.state.version, o = rt.getParameters(t1, r.state, a, e, i), l = rt.getProgramCacheKey(o);
                    let c = n.programs;
                    n.environment = t1.isMeshStandardMaterial ? e.environment : null, n.fog = e.fog, n.envMap = (t1.isMeshStandardMaterial ? tt : $).get(t1.envMap || n.environment), void 0 === c && (t1.addEventListener("dispose", Tt), c = new Map, n.programs = c);
                    let u = c.get(l);
                    if (void 0 !== u) {
                        if (n.currentProgram === u && n.lightsStateVersion === s) return Pt(t1, o), u;
                    } else o.uniforms = rt.getUniforms(t1), t1.onBuild(i, o, M), t1.onBeforeCompile(o, M), u = rt.acquireProgram(o, l), c.set(l, u), n.uniforms = o.uniforms;
                    const h = n.uniforms;
                    return (t1.isShaderMaterial || t1.isRawShaderMaterial) && !0 !== t1.clipping || (h.clippingPlanes = lt.uniform), Pt(t1, o), n.needsLights = function(t1) {
                        return t1.isMeshLambertMaterial || t1.isMeshToonMaterial || t1.isMeshPhongMaterial || t1.isMeshStandardMaterial || t1.isShadowMaterial || t1.isShaderMaterial && !0 === t1.lights;
                    }(t1), n.lightsStateVersion = s, n.needsLights && (h.ambientLightColor.value = r.state.ambient, h.lightProbe.value = r.state.probe, h.directionalLights.value = r.state.directional, h.directionalLightShadows.value = r.state.directionalShadow, h.spotLights.value = r.state.spot, h.spotLightShadows.value = r.state.spotShadow, h.rectAreaLights.value = r.state.rectArea, h.ltc_1.value = r.state.rectAreaLTC1, h.ltc_2.value = r.state.rectAreaLTC2, h.pointLights.value = r.state.point, h.pointLightShadows.value = r.state.pointShadow, h.hemisphereLights.value = r.state.hemi, h.directionalShadowMap.value = r.state.directionalShadowMap, h.directionalShadowMatrix.value = r.state.directionalShadowMatrix, h.spotShadowMap.value = r.state.spotShadowMap, h.spotLightMatrix.value = r.state.spotLightMatrix, h.spotLightMap.value = r.state.spotLightMap, h.pointShadowMap.value = r.state.pointShadowMap, h.pointShadowMatrix.value = r.state.pointShadowMatrix), n.currentProgram = u, n.uniformsList = null, u;
                }
                function jt(t1) {
                    if (null === t1.uniformsList) {
                        const e = t1.currentProgram.getUniforms();
                        t1.uniformsList = Bd.seqWithValue(e.seq, t1.uniforms);
                    }
                    return t1.uniformsList;
                }
                function Pt(t1, e) {
                    const i = K.get(t1);
                    i.outputColorSpace = e.outputColorSpace, i.instancing = e.instancing, i.instancingColor = e.instancingColor, i.skinning = e.skinning, i.morphTargets = e.morphTargets, i.morphNormals = e.morphNormals, i.morphColors = e.morphColors, i.morphTargetsCount = e.morphTargetsCount, i.numClippingPlanes = e.numClippingPlanes, i.numIntersection = e.numClipIntersection, i.vertexAlphas = e.vertexAlphas, i.vertexTangents = e.vertexTangents, i.toneMapping = e.toneMapping;
                }
                Dt.setAnimationLoop(function(t1) {
                    It && It(t1);
                }), "undefined" != typeof self && Dt.setContext(self), this.setAnimationLoop = function(t1) {
                    It = t1, vt.setAnimationLoop(t1), null === t1 ? Dt.stop() : Dt.start();
                }, vt.addEventListener("sessionstart", St), vt.addEventListener("sessionend", Nt), this.render = function(t1, e) {
                    if (void 0 !== e && !0 !== e.isCamera) return void console.error("THREE.WebGLRenderer.render: camera is not an instance of THREE.Camera.");
                    if (!0 === y) return;
                    !0 === t1.matrixWorldAutoUpdate && t1.updateMatrixWorld(), null === e.parent && !0 === e.matrixWorldAutoUpdate && e.updateMatrixWorld(), !0 === vt.enabled && !0 === vt.isPresenting && (!0 === vt.cameraAutoUpdate && vt.updateCamera(e), e = vt.getCamera()), !0 === t1.isScene && t1.onBeforeRender(M, t1, e, w), A = ot.get(t1, m.length), A.init(), m.push(A), Q.multiplyMatrices(e.projectionMatrix, e.matrixWorldInverse), U.setFromProjectionMatrix(Q), B = this.localClippingEnabled, k = lt.init(this.clippingPlanes, B), f = st.get(t1, g.length), f.init(), g.push(f), Ct(t1, e, 0, M.sortObjects), f.finish(), !0 === M.sortObjects && f.sort(O, _), this.info.render.frame++, !0 === k && lt.beginShadows();
                    const i = A.state.shadowsArray;
                    if (ct.render(i, t1, e), !0 === k && lt.endShadows(), !0 === this.info.autoReset && this.info.reset(), ut.render(f, t1), A.setupLights(M._useLegacyLights), e.isArrayCamera) {
                        const i = e.cameras;
                        for(let e = 0, n = i.length; e < n; e++){
                            const n = i[e];
                            zt(f, t1, n, n.viewport);
                        }
                    } else zt(f, t1, e);
                    null !== w && (q.updateMultisampleRenderTarget(w), q.updateRenderTargetMipmap(w)), !0 === t1.isScene && t1.onAfterRender(M, t1, e), At.resetDefaultState(), b = -1, T = null, m.pop(), A = m.length > 0 ? m[m.length - 1] : null, g.pop(), f = g.length > 0 ? g[g.length - 1] : null;
                }, this.getActiveCubeFace = function() {
                    return v;
                }, this.getActiveMipmapLevel = function() {
                    return x;
                }, this.getRenderTarget = function() {
                    return w;
                }, this.setRenderTargetTextures = function(t1, e, i) {
                    K.get(t1.texture).__webglTexture = e, K.get(t1.depthTexture).__webglTexture = i;
                    const n = K.get(t1);
                    n.__hasExternalTextures = !0, n.__hasExternalTextures && (n.__autoAllocateDepthBuffer = void 0 === i, n.__autoAllocateDepthBuffer || !0 === W.has("WEBGL_multisampled_render_to_texture") && (console.warn("THREE.WebGLRenderer: Render-to-texture extension was disabled because an external texture was provided"), n.__useRenderToTexture = !1));
                }, this.setRenderTargetFramebuffer = function(t1, e) {
                    const i = K.get(t1);
                    i.__webglFramebuffer = e, i.__useDefaultFramebuffer = void 0 === e;
                }, this.setRenderTarget = function(t1, e = 0, i = 0) {
                    w = t1, v = e, x = i;
                    let n = !0, r = null, a = !1, s = !1;
                    if (t1) {
                        const o = K.get(t1);
                        void 0 !== o.__useDefaultFramebuffer ? (Z.bindFramebuffer(mt.FRAMEBUFFER, null), n = !1) : void 0 === o.__webglFramebuffer ? q.setupRenderTarget(t1) : o.__hasExternalTextures && q.rebindTextures(t1, K.get(t1.texture).__webglTexture, K.get(t1.depthTexture).__webglTexture);
                        const l = t1.texture;
                        (l.isData3DTexture || l.isDataArrayTexture || l.isCompressedArrayTexture) && (s = !0);
                        const c = K.get(t1).__webglFramebuffer;
                        t1.isWebGLCubeRenderTarget ? (r = Array.isArray(c[e]) ? c[e][i] : c[e], a = !0) : r = X.isWebGL2 && t1.samples > 0 && !1 === q.useMultisampledRTT(t1) ? K.get(t1).__webglMultisampledFramebuffer : Array.isArray(c) ? c[i] : c, E.copy(t1.viewport), I.copy(t1.scissor), S = t1.scissorTest;
                    } else E.copy(j).multiplyScalar(L).floor(), I.copy(P).multiplyScalar(L).floor(), S = R;
                    if (Z.bindFramebuffer(mt.FRAMEBUFFER, r) && X.drawBuffers && n && Z.drawBuffers(t1, r), Z.viewport(E), Z.scissor(I), Z.setScissorTest(S), a) {
                        const n = K.get(t1.texture);
                        mt.framebufferTexture2D(mt.FRAMEBUFFER, mt.COLOR_ATTACHMENT0, mt.TEXTURE_CUBE_MAP_POSITIVE_X + e, n.__webglTexture, i);
                    } else if (s) {
                        const n = K.get(t1.texture), r = e || 0;
                        mt.framebufferTextureLayer(mt.FRAMEBUFFER, mt.COLOR_ATTACHMENT0, n.__webglTexture, i || 0, r);
                    }
                    b = -1;
                }, this.readRenderTargetPixels = function(t1, e, i, n, r, a, s) {
                    if (!t1 || !t1.isWebGLRenderTarget) return void console.error("THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not THREE.WebGLRenderTarget.");
                    let o = K.get(t1).__webglFramebuffer;
                    if (t1.isWebGLCubeRenderTarget && void 0 !== s && (o = o[s]), o) {
                        Z.bindFramebuffer(mt.FRAMEBUFFER, o);
                        try {
                            const s = t1.texture, o = s.format, l = s.type;
                            if (o !== Ea && ft.convert(o) !== mt.getParameter(mt.IMPLEMENTATION_COLOR_READ_FORMAT)) return void console.error("THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not in RGBA or implementation defined format.");
                            const c = l === va && (W.has("EXT_color_buffer_half_float") || X.isWebGL2 && W.has("EXT_color_buffer_float"));
                            if (!(l === pa || ft.convert(l) === mt.getParameter(mt.IMPLEMENTATION_COLOR_READ_TYPE) || l === ya && (X.isWebGL2 || W.has("OES_texture_float") || W.has("WEBGL_color_buffer_float")) || c)) return void console.error("THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not in UnsignedByteType or implementation defined type.");
                            e >= 0 && e <= t1.width - n && i >= 0 && i <= t1.height - r && mt.readPixels(e, i, n, r, ft.convert(o), ft.convert(l), a);
                        } finally{
                            const t1 = null !== w ? K.get(w).__webglFramebuffer : null;
                            Z.bindFramebuffer(mt.FRAMEBUFFER, t1);
                        }
                    }
                }, this.copyFramebufferToTexture = function(t1, e, i = 0) {
                    const n = Math.pow(2, -i), r = Math.floor(e.image.width * n), a = Math.floor(e.image.height * n);
                    q.setTexture2D(e, 0), mt.copyTexSubImage2D(mt.TEXTURE_2D, i, 0, 0, t1.x, t1.y, r, a), Z.unbindTexture();
                }, this.copyTextureToTexture = function(t1, e, i, n = 0) {
                    const r = e.image.width, a = e.image.height, s = ft.convert(i.format), o = ft.convert(i.type);
                    q.setTexture2D(i, 0), mt.pixelStorei(mt.UNPACK_FLIP_Y_WEBGL, i.flipY), mt.pixelStorei(mt.UNPACK_PREMULTIPLY_ALPHA_WEBGL, i.premultiplyAlpha), mt.pixelStorei(mt.UNPACK_ALIGNMENT, i.unpackAlignment), e.isDataTexture ? mt.texSubImage2D(mt.TEXTURE_2D, n, t1.x, t1.y, r, a, s, o, e.image.data) : e.isCompressedTexture ? mt.compressedTexSubImage2D(mt.TEXTURE_2D, n, t1.x, t1.y, e.mipmaps[0].width, e.mipmaps[0].height, s, e.mipmaps[0].data) : mt.texSubImage2D(mt.TEXTURE_2D, n, t1.x, t1.y, s, o, e.image), 0 === n && i.generateMipmaps && mt.generateMipmap(mt.TEXTURE_2D), Z.unbindTexture();
                }, this.copyTextureToTexture3D = function(t1, e, i, n, r = 0) {
                    if (M.isWebGL1Renderer) return void console.warn("THREE.WebGLRenderer.copyTextureToTexture3D: can only be used with WebGL2.");
                    const a = t1.max.x - t1.min.x + 1, s = t1.max.y - t1.min.y + 1, o = t1.max.z - t1.min.z + 1, l = ft.convert(n.format), c = ft.convert(n.type);
                    let u;
                    if (n.isData3DTexture) q.setTexture3D(n, 0), u = mt.TEXTURE_3D;
                    else {
                        if (!n.isDataArrayTexture) return void console.warn("THREE.WebGLRenderer.copyTextureToTexture3D: only supports THREE.DataTexture3D and THREE.DataTexture2DArray.");
                        q.setTexture2DArray(n, 0), u = mt.TEXTURE_2D_ARRAY;
                    }
                    mt.pixelStorei(mt.UNPACK_FLIP_Y_WEBGL, n.flipY), mt.pixelStorei(mt.UNPACK_PREMULTIPLY_ALPHA_WEBGL, n.premultiplyAlpha), mt.pixelStorei(mt.UNPACK_ALIGNMENT, n.unpackAlignment);
                    const h = mt.getParameter(mt.UNPACK_ROW_LENGTH), d = mt.getParameter(mt.UNPACK_IMAGE_HEIGHT), p = mt.getParameter(mt.UNPACK_SKIP_PIXELS), f = mt.getParameter(mt.UNPACK_SKIP_ROWS), A = mt.getParameter(mt.UNPACK_SKIP_IMAGES), g = i.isCompressedTexture ? i.mipmaps[0] : i.image;
                    mt.pixelStorei(mt.UNPACK_ROW_LENGTH, g.width), mt.pixelStorei(mt.UNPACK_IMAGE_HEIGHT, g.height), mt.pixelStorei(mt.UNPACK_SKIP_PIXELS, t1.min.x), mt.pixelStorei(mt.UNPACK_SKIP_ROWS, t1.min.y), mt.pixelStorei(mt.UNPACK_SKIP_IMAGES, t1.min.z), i.isDataTexture || i.isData3DTexture ? mt.texSubImage3D(u, r, e.x, e.y, e.z, a, s, o, l, c, g.data) : i.isCompressedArrayTexture ? (console.warn("THREE.WebGLRenderer.copyTextureToTexture3D: untested support for compressed srcTexture."), mt.compressedTexSubImage3D(u, r, e.x, e.y, e.z, a, s, o, l, g.data)) : mt.texSubImage3D(u, r, e.x, e.y, e.z, a, s, o, l, c, g), mt.pixelStorei(mt.UNPACK_ROW_LENGTH, h), mt.pixelStorei(mt.UNPACK_IMAGE_HEIGHT, d), mt.pixelStorei(mt.UNPACK_SKIP_PIXELS, p), mt.pixelStorei(mt.UNPACK_SKIP_ROWS, f), mt.pixelStorei(mt.UNPACK_SKIP_IMAGES, A), 0 === r && n.generateMipmaps && mt.generateMipmap(u), Z.unbindTexture();
                }, this.initTexture = function(t1) {
                    t1.isCubeTexture ? q.setTextureCube(t1, 0) : t1.isData3DTexture ? q.setTexture3D(t1, 0) : t1.isDataArrayTexture || t1.isCompressedArrayTexture ? q.setTexture2DArray(t1, 0) : q.setTexture2D(t1, 0), Z.unbindTexture();
                }, this.resetState = function() {
                    v = 0, x = 0, w = null, Z.reset(), At.reset();
                }, "undefined" != typeof __THREE_DEVTOOLS__ && __THREE_DEVTOOLS__.dispatchEvent(new CustomEvent("observe", {
                    detail: this
                }));
            }
            get coordinateSystem() {
                return Eo;
            }
            get outputColorSpace() {
                return this._outputColorSpace;
            }
            set outputColorSpace(t1) {
                this._outputColorSpace = t1;
                const e = this.getContext();
                e.drawingBufferColorSpace = t1 === Ps ? "display-p3" : "srgb", e.unpackColorSpace = il.workingColorSpace === Rs ? "display-p3" : "srgb";
            }
            get physicallyCorrectLights() {
                return console.warn("THREE.WebGLRenderer: The property .physicallyCorrectLights has been removed. Set renderer.useLegacyLights instead."), !this.useLegacyLights;
            }
            set physicallyCorrectLights(t1) {
                console.warn("THREE.WebGLRenderer: The property .physicallyCorrectLights has been removed. Set renderer.useLegacyLights instead."), this.useLegacyLights = !t1;
            }
            get outputEncoding() {
                return console.warn("THREE.WebGLRenderer: Property .outputEncoding has been removed. Use .outputColorSpace instead."), this.outputColorSpace === _s ? Ns : Ss;
            }
            set outputEncoding(t1) {
                console.warn("THREE.WebGLRenderer: Property .outputEncoding has been removed. Use .outputColorSpace instead."), this.outputColorSpace = t1 === Ns ? _s : js;
            }
            get useLegacyLights() {
                return console.warn("THREE.WebGLRenderer: The property .useLegacyLights has been deprecated. Migrate your lighting according to the following guide: https://discourse.threejs.org/t/updates-to-lighting-in-three-js-r155/53733."), this._useLegacyLights;
            }
            set useLegacyLights(t1) {
                console.warn("THREE.WebGLRenderer: The property .useLegacyLights has been deprecated. Migrate your lighting according to the following guide: https://discourse.threejs.org/t/updates-to-lighting-in-three-js-r155/53733."), this._useLegacyLights = t1;
            }
        }
        class jp extends _p {
        }
        jp.prototype.isWebGL1Renderer = !0;
        class Pp {
            constructor(t1, e = 25e-5){
                this.isFogExp2 = !0, this.name = "", this.color = new kc(t1), this.density = e;
            }
            clone() {
                return new Pp(this.color, this.density);
            }
            toJSON() {
                return {
                    type: "FogExp2",
                    name: this.name,
                    color: this.color.getHex(),
                    density: this.density
                };
            }
        }
        class Rp {
            constructor(t1, e = 1, i = 1e3){
                this.isFog = !0, this.name = "", this.color = new kc(t1), this.near = e, this.far = i;
            }
            clone() {
                return new Rp(this.color, this.near, this.far);
            }
            toJSON() {
                return {
                    type: "Fog",
                    name: this.name,
                    color: this.color.getHex(),
                    near: this.near,
                    far: this.far
                };
            }
        }
        class Up extends wc {
            constructor(){
                super(), this.isScene = !0, this.type = "Scene", this.background = null, this.environment = null, this.fog = null, this.backgroundBlurriness = 0, this.backgroundIntensity = 1, this.overrideMaterial = null, "undefined" != typeof __THREE_DEVTOOLS__ && __THREE_DEVTOOLS__.dispatchEvent(new CustomEvent("observe", {
                    detail: this
                }));
            }
            copy(t1, e) {
                return super.copy(t1, e), null !== t1.background && (this.background = t1.background.clone()), null !== t1.environment && (this.environment = t1.environment.clone()), null !== t1.fog && (this.fog = t1.fog.clone()), this.backgroundBlurriness = t1.backgroundBlurriness, this.backgroundIntensity = t1.backgroundIntensity, null !== t1.overrideMaterial && (this.overrideMaterial = t1.overrideMaterial.clone()), this.matrixAutoUpdate = t1.matrixAutoUpdate, this;
            }
            toJSON(t1) {
                const e = super.toJSON(t1);
                return null !== this.fog && (e.object.fog = this.fog.toJSON()), this.backgroundBlurriness > 0 && (e.object.backgroundBlurriness = this.backgroundBlurriness), 1 !== this.backgroundIntensity && (e.object.backgroundIntensity = this.backgroundIntensity), e;
            }
        }
        class kp {
            constructor(t1, e){
                this.isInterleavedBuffer = !0, this.array = t1, this.stride = e, this.count = void 0 !== t1 ? t1.length / e : 0, this.usage = po, this.updateRange = {
                    offset: 0,
                    count: -1
                }, this.version = 0, this.uuid = Lo();
            }
            onUploadCallback() {}
            set needsUpdate(t1) {
                !0 === t1 && this.version++;
            }
            setUsage(t1) {
                return this.usage = t1, this;
            }
            copy(t1) {
                return this.array = new t1.array.constructor(t1.array), this.count = t1.count, this.stride = t1.stride, this.usage = t1.usage, this;
            }
            copyAt(t1, e, i) {
                t1 *= this.stride, i *= e.stride;
                for(let n = 0, r = this.stride; n < r; n++)this.array[t1 + n] = e.array[i + n];
                return this;
            }
            set(t1, e = 0) {
                return this.array.set(t1, e), this;
            }
            clone(t1) {
                void 0 === t1.arrayBuffers && (t1.arrayBuffers = {}), void 0 === this.array.buffer._uuid && (this.array.buffer._uuid = Lo()), void 0 === t1.arrayBuffers[this.array.buffer._uuid] && (t1.arrayBuffers[this.array.buffer._uuid] = this.array.slice(0).buffer);
                const e = new this.array.constructor(t1.arrayBuffers[this.array.buffer._uuid]), i = new this.constructor(e, this.stride);
                return i.setUsage(this.usage), i;
            }
            onUpload(t1) {
                return this.onUploadCallback = t1, this;
            }
            toJSON(t1) {
                return void 0 === t1.arrayBuffers && (t1.arrayBuffers = {}), void 0 === this.array.buffer._uuid && (this.array.buffer._uuid = Lo()), void 0 === t1.arrayBuffers[this.array.buffer._uuid] && (t1.arrayBuffers[this.array.buffer._uuid] = Array.from(new Uint32Array(this.array.buffer))), {
                    uuid: this.uuid,
                    buffer: this.array.buffer._uuid,
                    type: this.array.constructor.name,
                    stride: this.stride
                };
            }
        }
        const Bp = new xl;
        class Fp {
            constructor(t1, e, i, n = !1){
                this.isInterleavedBufferAttribute = !0, this.name = "", this.data = t1, this.itemSize = e, this.offset = i, this.normalized = n;
            }
            get count() {
                return this.data.count;
            }
            get array() {
                return this.data.array;
            }
            set needsUpdate(t1) {
                this.data.needsUpdate = t1;
            }
            applyMatrix4(t1) {
                for(let e = 0, i = this.data.count; e < i; e++)Bp.fromBufferAttribute(this, e), Bp.applyMatrix4(t1), this.setXYZ(e, Bp.x, Bp.y, Bp.z);
                return this;
            }
            applyNormalMatrix(t1) {
                for(let e = 0, i = this.count; e < i; e++)Bp.fromBufferAttribute(this, e), Bp.applyNormalMatrix(t1), this.setXYZ(e, Bp.x, Bp.y, Bp.z);
                return this;
            }
            transformDirection(t1) {
                for(let e = 0, i = this.count; e < i; e++)Bp.fromBufferAttribute(this, e), Bp.transformDirection(t1), this.setXYZ(e, Bp.x, Bp.y, Bp.z);
                return this;
            }
            setX(t1, e) {
                return this.normalized && (e = Bo(e, this.array)), this.data.array[t1 * this.data.stride + this.offset] = e, this;
            }
            setY(t1, e) {
                return this.normalized && (e = Bo(e, this.array)), this.data.array[t1 * this.data.stride + this.offset + 1] = e, this;
            }
            setZ(t1, e) {
                return this.normalized && (e = Bo(e, this.array)), this.data.array[t1 * this.data.stride + this.offset + 2] = e, this;
            }
            setW(t1, e) {
                return this.normalized && (e = Bo(e, this.array)), this.data.array[t1 * this.data.stride + this.offset + 3] = e, this;
            }
            getX(t1) {
                let e = this.data.array[t1 * this.data.stride + this.offset];
                return this.normalized && (e = ko(e, this.array)), e;
            }
            getY(t1) {
                let e = this.data.array[t1 * this.data.stride + this.offset + 1];
                return this.normalized && (e = ko(e, this.array)), e;
            }
            getZ(t1) {
                let e = this.data.array[t1 * this.data.stride + this.offset + 2];
                return this.normalized && (e = ko(e, this.array)), e;
            }
            getW(t1) {
                let e = this.data.array[t1 * this.data.stride + this.offset + 3];
                return this.normalized && (e = ko(e, this.array)), e;
            }
            setXY(t1, e, i) {
                return t1 = t1 * this.data.stride + this.offset, this.normalized && (e = Bo(e, this.array), i = Bo(i, this.array)), this.data.array[t1 + 0] = e, this.data.array[t1 + 1] = i, this;
            }
            setXYZ(t1, e, i, n) {
                return t1 = t1 * this.data.stride + this.offset, this.normalized && (e = Bo(e, this.array), i = Bo(i, this.array), n = Bo(n, this.array)), this.data.array[t1 + 0] = e, this.data.array[t1 + 1] = i, this.data.array[t1 + 2] = n, this;
            }
            setXYZW(t1, e, i, n, r) {
                return t1 = t1 * this.data.stride + this.offset, this.normalized && (e = Bo(e, this.array), i = Bo(i, this.array), n = Bo(n, this.array), r = Bo(r, this.array)), this.data.array[t1 + 0] = e, this.data.array[t1 + 1] = i, this.data.array[t1 + 2] = n, this.data.array[t1 + 3] = r, this;
            }
            clone(t1) {
                if (void 0 === t1) {
                    console.log("THREE.InterleavedBufferAttribute.clone(): Cloning an interleaved buffer attribute will de-interleave buffer data.");
                    const t1 = [];
                    for(let e = 0; e < this.count; e++){
                        const i = e * this.data.stride + this.offset;
                        for(let e = 0; e < this.itemSize; e++)t1.push(this.data.array[i + e]);
                    }
                    return new Kc(new this.array.constructor(t1), this.itemSize, this.normalized);
                }
                return void 0 === t1.interleavedBuffers && (t1.interleavedBuffers = {}), void 0 === t1.interleavedBuffers[this.data.uuid] && (t1.interleavedBuffers[this.data.uuid] = this.data.clone(t1)), new Fp(t1.interleavedBuffers[this.data.uuid], this.itemSize, this.offset, this.normalized);
            }
            toJSON(t1) {
                if (void 0 === t1) {
                    console.log("THREE.InterleavedBufferAttribute.toJSON(): Serializing an interleaved buffer attribute will de-interleave buffer data.");
                    const t1 = [];
                    for(let e = 0; e < this.count; e++){
                        const i = e * this.data.stride + this.offset;
                        for(let e = 0; e < this.itemSize; e++)t1.push(this.data.array[i + e]);
                    }
                    return {
                        itemSize: this.itemSize,
                        type: this.array.constructor.name,
                        array: t1,
                        normalized: this.normalized
                    };
                }
                return void 0 === t1.interleavedBuffers && (t1.interleavedBuffers = {}), void 0 === t1.interleavedBuffers[this.data.uuid] && (t1.interleavedBuffers[this.data.uuid] = this.data.toJSON(t1)), {
                    isInterleavedBufferAttribute: !0,
                    itemSize: this.itemSize,
                    data: this.data.uuid,
                    offset: this.offset,
                    normalized: this.normalized
                };
            }
        }
        class Qp extends Qc {
            constructor(t1){
                super(), this.isSpriteMaterial = !0, this.type = "SpriteMaterial", this.color = new kc(16777215), this.map = null, this.alphaMap = null, this.rotation = 0, this.sizeAttenuation = !0, this.transparent = !0, this.fog = !0, this.setValues(t1);
            }
            copy(t1) {
                return super.copy(t1), this.color.copy(t1.color), this.map = t1.map, this.alphaMap = t1.alphaMap, this.rotation = t1.rotation, this.sizeAttenuation = t1.sizeAttenuation, this.fog = t1.fog, this;
            }
        }
        let Hp;
        const Vp = new xl, Gp = new xl, Yp = new xl, Wp = new Qo, Xp = new Qo, Zp = new Kl, Jp = new xl, Kp = new xl, qp = new xl, $p = new Qo, tf = new Qo, ef = new Qo;
        class nf extends wc {
            constructor(t1 = new Qp){
                if (super(), this.isSprite = !0, this.type = "Sprite", void 0 === Hp) {
                    Hp = new Au;
                    const t1 = new Float32Array([
                        -0.5,
                        -0.5,
                        0,
                        0,
                        0,
                        .5,
                        -0.5,
                        0,
                        1,
                        0,
                        .5,
                        .5,
                        0,
                        1,
                        1,
                        -0.5,
                        .5,
                        0,
                        0,
                        1
                    ]), e = new kp(t1, 5);
                    Hp.setIndex([
                        0,
                        1,
                        2,
                        0,
                        2,
                        3
                    ]), Hp.setAttribute("position", new Fp(e, 3, 0, !1)), Hp.setAttribute("uv", new Fp(e, 2, 3, !1));
                }
                this.geometry = Hp, this.material = t1, this.center = new Qo(.5, .5);
            }
            raycast(t1, e) {
                null === t1.camera && console.error('THREE.Sprite: "Raycaster.camera" needs to be set in order to raycast against sprites.'), Gp.setFromMatrixScale(this.matrixWorld), Zp.copy(t1.camera.matrixWorld), this.modelViewMatrix.multiplyMatrices(t1.camera.matrixWorldInverse, this.matrixWorld), Yp.setFromMatrixPosition(this.modelViewMatrix), t1.camera.isPerspectiveCamera && !1 === this.material.sizeAttenuation && Gp.multiplyScalar(-Yp.z);
                const i = this.material.rotation;
                let n, r;
                0 !== i && (r = Math.cos(i), n = Math.sin(i));
                const a = this.center;
                rf(Jp.set(-0.5, -0.5, 0), Yp, a, Gp, n, r), rf(Kp.set(.5, -0.5, 0), Yp, a, Gp, n, r), rf(qp.set(.5, .5, 0), Yp, a, Gp, n, r), $p.set(0, 0), tf.set(1, 0), ef.set(1, 1);
                let s = t1.ray.intersectTriangle(Jp, Kp, qp, !1, Vp);
                if (null === s && (rf(Kp.set(-0.5, .5, 0), Yp, a, Gp, n, r), tf.set(0, 1), s = t1.ray.intersectTriangle(Jp, qp, Kp, !1, Vp), null === s)) return;
                const o = t1.ray.origin.distanceTo(Vp);
                o < t1.near || o > t1.far || e.push({
                    distance: o,
                    point: Vp.clone(),
                    uv: _c.getInterpolation(Vp, Jp, Kp, qp, $p, tf, ef, new Qo),
                    face: null,
                    object: this
                });
            }
            copy(t1, e) {
                return super.copy(t1, e), void 0 !== t1.center && this.center.copy(t1.center), this.material = t1.material, this;
            }
        }
        function rf(t1, e, i, n, r, a) {
            Wp.subVectors(t1, i).addScalar(.5).multiply(n), void 0 !== r ? (Xp.x = a * Wp.x - r * Wp.y, Xp.y = r * Wp.x + a * Wp.y) : Xp.copy(Wp), t1.copy(e), t1.x += Xp.x, t1.y += Xp.y, t1.applyMatrix4(Zp);
        }
        const af = new xl, sf = new xl;
        class of extends wc {
            constructor(){
                super(), this._currentLevel = 0, this.type = "LOD", Object.defineProperties(this, {
                    levels: {
                        enumerable: !0,
                        value: []
                    },
                    isLOD: {
                        value: !0
                    }
                }), this.autoUpdate = !0;
            }
            copy(t1) {
                super.copy(t1, !1);
                const e = t1.levels;
                for(let t1 = 0, i = e.length; t1 < i; t1++){
                    const i = e[t1];
                    this.addLevel(i.object.clone(), i.distance, i.hysteresis);
                }
                return this.autoUpdate = t1.autoUpdate, this;
            }
            addLevel(t1, e = 0, i = 0) {
                e = Math.abs(e);
                const n = this.levels;
                let r;
                for(r = 0; r < n.length && !(e < n[r].distance); r++);
                return n.splice(r, 0, {
                    distance: e,
                    hysteresis: i,
                    object: t1
                }), this.add(t1), this;
            }
            getCurrentLevel() {
                return this._currentLevel;
            }
            getObjectForDistance(t1) {
                const e = this.levels;
                if (e.length > 0) {
                    let i, n;
                    for(i = 1, n = e.length; i < n; i++){
                        let n = e[i].distance;
                        if (e[i].object.visible && (n -= n * e[i].hysteresis), t1 < n) break;
                    }
                    return e[i - 1].object;
                }
                return null;
            }
            raycast(t1, e) {
                if (this.levels.length > 0) {
                    af.setFromMatrixPosition(this.matrixWorld);
                    const i = t1.ray.origin.distanceTo(af);
                    this.getObjectForDistance(i).raycast(t1, e);
                }
            }
            update(t1) {
                const e = this.levels;
                if (e.length > 1) {
                    af.setFromMatrixPosition(t1.matrixWorld), sf.setFromMatrixPosition(this.matrixWorld);
                    const i = af.distanceTo(sf) / t1.zoom;
                    let n, r;
                    for(e[0].object.visible = !0, n = 1, r = e.length; n < r; n++){
                        let t1 = e[n].distance;
                        if (e[n].object.visible && (t1 -= t1 * e[n].hysteresis), !(i >= t1)) break;
                        e[n - 1].object.visible = !1, e[n].object.visible = !0;
                    }
                    for(this._currentLevel = n - 1; n < r; n++)e[n].object.visible = !1;
                }
            }
            toJSON(t1) {
                const e = super.toJSON(t1);
                !1 === this.autoUpdate && (e.object.autoUpdate = !1), e.object.levels = [];
                const i = this.levels;
                for(let t1 = 0, n = i.length; t1 < n; t1++){
                    const n = i[t1];
                    e.object.levels.push({
                        object: n.object.uuid,
                        distance: n.distance,
                        hysteresis: n.hysteresis
                    });
                }
                return e;
            }
        }
        const lf = new xl, cf = new dl, uf = new dl, hf = new xl, df = new Kl, pf = new xl, ff = new Ql, Af = new Kl, gf = new Jl;
        class mf extends Ou {
            constructor(t1, e){
                super(t1, e), this.isSkinnedMesh = !0, this.type = "SkinnedMesh", this.bindMode = Yr, this.bindMatrix = new Kl, this.bindMatrixInverse = new Kl, this.boundingBox = null, this.boundingSphere = null;
            }
            computeBoundingBox() {
                const t1 = this.geometry;
                null === this.boundingBox && (this.boundingBox = new Tl), this.boundingBox.makeEmpty();
                const e = t1.getAttribute("position");
                for(let t1 = 0; t1 < e.count; t1++)this.getVertexPosition(t1, pf), this.boundingBox.expandByPoint(pf);
            }
            computeBoundingSphere() {
                const t1 = this.geometry;
                null === this.boundingSphere && (this.boundingSphere = new Ql), this.boundingSphere.makeEmpty();
                const e = t1.getAttribute("position");
                for(let t1 = 0; t1 < e.count; t1++)this.getVertexPosition(t1, pf), this.boundingSphere.expandByPoint(pf);
            }
            copy(t1, e) {
                return super.copy(t1, e), this.bindMode = t1.bindMode, this.bindMatrix.copy(t1.bindMatrix), this.bindMatrixInverse.copy(t1.bindMatrixInverse), this.skeleton = t1.skeleton, null !== t1.boundingBox && (this.boundingBox = t1.boundingBox.clone()), null !== t1.boundingSphere && (this.boundingSphere = t1.boundingSphere.clone()), this;
            }
            raycast(t1, e) {
                const i = this.material, n = this.matrixWorld;
                void 0 !== i && (null === this.boundingSphere && this.computeBoundingSphere(), ff.copy(this.boundingSphere), ff.applyMatrix4(n), !1 !== t1.ray.intersectsSphere(ff) && (Af.copy(n).invert(), gf.copy(t1.ray).applyMatrix4(Af), null !== this.boundingBox && !1 === gf.intersectsBox(this.boundingBox) || this._computeIntersections(t1, e, gf)));
            }
            getVertexPosition(t1, e) {
                return super.getVertexPosition(t1, e), this.applyBoneTransform(t1, e), e;
            }
            bind(t1, e) {
                this.skeleton = t1, void 0 === e && (this.updateMatrixWorld(!0), this.skeleton.calculateInverses(), e = this.matrixWorld), this.bindMatrix.copy(e), this.bindMatrixInverse.copy(e).invert();
            }
            pose() {
                this.skeleton.pose();
            }
            normalizeSkinWeights() {
                const t1 = new dl, e = this.geometry.attributes.skinWeight;
                for(let i = 0, n = e.count; i < n; i++){
                    t1.fromBufferAttribute(e, i);
                    const n = 1 / t1.manhattanLength();
                    n !== 1 / 0 ? t1.multiplyScalar(n) : t1.set(1, 0, 0, 0), e.setXYZW(i, t1.x, t1.y, t1.z, t1.w);
                }
            }
            updateMatrixWorld(t1) {
                super.updateMatrixWorld(t1), this.bindMode === Yr ? this.bindMatrixInverse.copy(this.matrixWorld).invert() : this.bindMode === Wr ? this.bindMatrixInverse.copy(this.bindMatrix).invert() : console.warn("THREE.SkinnedMesh: Unrecognized bindMode: " + this.bindMode);
            }
            applyBoneTransform(t1, e) {
                const i = this.skeleton, n = this.geometry;
                cf.fromBufferAttribute(n.attributes.skinIndex, t1), uf.fromBufferAttribute(n.attributes.skinWeight, t1), lf.copy(e).applyMatrix4(this.bindMatrix), e.set(0, 0, 0);
                for(let t1 = 0; t1 < 4; t1++){
                    const n = uf.getComponent(t1);
                    if (0 !== n) {
                        const r = cf.getComponent(t1);
                        df.multiplyMatrices(i.bones[r].matrixWorld, i.boneInverses[r]), e.addScaledVector(hf.copy(lf).applyMatrix4(df), n);
                    }
                }
                return e.applyMatrix4(this.bindMatrixInverse);
            }
            boneTransform(t1, e) {
                return console.warn("THREE.SkinnedMesh: .boneTransform() was renamed to .applyBoneTransform() in r151."), this.applyBoneTransform(t1, e);
            }
        }
        class Mf extends wc {
            constructor(){
                super(), this.isBone = !0, this.type = "Bone";
            }
        }
        class yf extends hl {
            constructor(t1 = null, e = 1, i = 1, n, r, a, s, o, l = na, c = na, u, h){
                super(null, a, s, o, l, c, n, r, u, h), this.isDataTexture = !0, this.image = {
                    data: t1,
                    width: e,
                    height: i
                }, this.generateMipmaps = !1, this.flipY = !1, this.unpackAlignment = 1;
            }
        }
        const vf = new Kl, xf = new Kl;
        class wf {
            constructor(t1 = [], e = []){
                this.uuid = Lo(), this.bones = t1.slice(0), this.boneInverses = e, this.boneMatrices = null, this.boneTexture = null, this.boneTextureSize = 0, this.init();
            }
            init() {
                const t1 = this.bones, e = this.boneInverses;
                if (this.boneMatrices = new Float32Array(16 * t1.length), 0 === e.length) this.calculateInverses();
                else if (t1.length !== e.length) {
                    console.warn("THREE.Skeleton: Number of inverse bone matrices does not match amount of bones."), this.boneInverses = [];
                    for(let t1 = 0, e = this.bones.length; t1 < e; t1++)this.boneInverses.push(new Kl);
                }
            }
            calculateInverses() {
                this.boneInverses.length = 0;
                for(let t1 = 0, e = this.bones.length; t1 < e; t1++){
                    const e = new Kl;
                    this.bones[t1] && e.copy(this.bones[t1].matrixWorld).invert(), this.boneInverses.push(e);
                }
            }
            pose() {
                for(let t1 = 0, e = this.bones.length; t1 < e; t1++){
                    const e = this.bones[t1];
                    e && e.matrixWorld.copy(this.boneInverses[t1]).invert();
                }
                for(let t1 = 0, e = this.bones.length; t1 < e; t1++){
                    const e = this.bones[t1];
                    e && (e.parent && e.parent.isBone ? (e.matrix.copy(e.parent.matrixWorld).invert(), e.matrix.multiply(e.matrixWorld)) : e.matrix.copy(e.matrixWorld), e.matrix.decompose(e.position, e.quaternion, e.scale));
                }
            }
            update() {
                const t1 = this.bones, e = this.boneInverses, i = this.boneMatrices, n = this.boneTexture;
                for(let n = 0, r = t1.length; n < r; n++){
                    const r = t1[n] ? t1[n].matrixWorld : xf;
                    vf.multiplyMatrices(r, e[n]), vf.toArray(i, 16 * n);
                }
                null !== n && (n.needsUpdate = !0);
            }
            clone() {
                return new wf(this.bones, this.boneInverses);
            }
            computeBoneTexture() {
                let t1 = Math.sqrt(4 * this.bones.length);
                t1 = Ro(t1), t1 = Math.max(t1, 4);
                const e = new Float32Array(t1 * t1 * 4);
                e.set(this.boneMatrices);
                const i = new yf(e, t1, t1, Ea, ya);
                return i.needsUpdate = !0, this.boneMatrices = e, this.boneTexture = i, this.boneTextureSize = t1, this;
            }
            getBoneByName(t1) {
                for(let e = 0, i = this.bones.length; e < i; e++){
                    const i = this.bones[e];
                    if (i.name === t1) return i;
                }
            }
            dispose() {
                null !== this.boneTexture && (this.boneTexture.dispose(), this.boneTexture = null);
            }
            fromJSON(t1, e) {
                this.uuid = t1.uuid;
                for(let i = 0, n = t1.bones.length; i < n; i++){
                    const n = t1.bones[i];
                    let r = e[n];
                    void 0 === r && (console.warn("THREE.Skeleton: No bone found with UUID:", n), r = new Mf), this.bones.push(r), this.boneInverses.push((new Kl).fromArray(t1.boneInverses[i]));
                }
                return this.init(), this;
            }
            toJSON() {
                const t1 = {
                    metadata: {
                        version: 4.6,
                        type: "Skeleton",
                        generator: "Skeleton.toJSON"
                    },
                    bones: [],
                    boneInverses: []
                };
                t1.uuid = this.uuid;
                const e = this.bones, i = this.boneInverses;
                for(let n = 0, r = e.length; n < r; n++){
                    const r = e[n];
                    t1.bones.push(r.uuid);
                    const a = i[n];
                    t1.boneInverses.push(a.toArray());
                }
                return t1;
            }
        }
        class bf extends Kc {
            constructor(t1, e, i, n = 1){
                super(t1, e, i), this.isInstancedBufferAttribute = !0, this.meshPerAttribute = n;
            }
            copy(t1) {
                return super.copy(t1), this.meshPerAttribute = t1.meshPerAttribute, this;
            }
            toJSON() {
                const t1 = super.toJSON();
                return t1.meshPerAttribute = this.meshPerAttribute, t1.isInstancedBufferAttribute = !0, t1;
            }
        }
        const Tf = new Kl, Ef = new Kl, If = [], Sf = new Tl, Nf = new Kl, Df = new Ou, Cf = new Ql;
        class zf extends Ou {
            constructor(t1, e, i){
                super(t1, e), this.isInstancedMesh = !0, this.instanceMatrix = new bf(new Float32Array(16 * i), 16), this.instanceColor = null, this.count = i, this.boundingBox = null, this.boundingSphere = null;
                for(let t1 = 0; t1 < i; t1++)this.setMatrixAt(t1, Nf);
            }
            computeBoundingBox() {
                const t1 = this.geometry, e = this.count;
                null === this.boundingBox && (this.boundingBox = new Tl), null === t1.boundingBox && t1.computeBoundingBox(), this.boundingBox.makeEmpty();
                for(let i = 0; i < e; i++)this.getMatrixAt(i, Tf), Sf.copy(t1.boundingBox).applyMatrix4(Tf), this.boundingBox.union(Sf);
            }
            computeBoundingSphere() {
                const t1 = this.geometry, e = this.count;
                null === this.boundingSphere && (this.boundingSphere = new Ql), null === t1.boundingSphere && t1.computeBoundingSphere(), this.boundingSphere.makeEmpty();
                for(let i = 0; i < e; i++)this.getMatrixAt(i, Tf), Cf.copy(t1.boundingSphere).applyMatrix4(Tf), this.boundingSphere.union(Cf);
            }
            copy(t1, e) {
                return super.copy(t1, e), this.instanceMatrix.copy(t1.instanceMatrix), null !== t1.instanceColor && (this.instanceColor = t1.instanceColor.clone()), this.count = t1.count, null !== t1.boundingBox && (this.boundingBox = t1.boundingBox.clone()), null !== t1.boundingSphere && (this.boundingSphere = t1.boundingSphere.clone()), this;
            }
            getColorAt(t1, e) {
                e.fromArray(this.instanceColor.array, 3 * t1);
            }
            getMatrixAt(t1, e) {
                e.fromArray(this.instanceMatrix.array, 16 * t1);
            }
            raycast(t1, e) {
                const i = this.matrixWorld, n = this.count;
                if (Df.geometry = this.geometry, Df.material = this.material, void 0 !== Df.material && (null === this.boundingSphere && this.computeBoundingSphere(), Cf.copy(this.boundingSphere), Cf.applyMatrix4(i), !1 !== t1.ray.intersectsSphere(Cf))) for(let r = 0; r < n; r++){
                    this.getMatrixAt(r, Tf), Ef.multiplyMatrices(i, Tf), Df.matrixWorld = Ef, Df.raycast(t1, If);
                    for(let t1 = 0, i = If.length; t1 < i; t1++){
                        const i = If[t1];
                        i.instanceId = r, i.object = this, e.push(i);
                    }
                    If.length = 0;
                }
            }
            setColorAt(t1, e) {
                null === this.instanceColor && (this.instanceColor = new bf(new Float32Array(3 * this.instanceMatrix.count), 3)), e.toArray(this.instanceColor.array, 3 * t1);
            }
            setMatrixAt(t1, e) {
                e.toArray(this.instanceMatrix.array, 16 * t1);
            }
            updateMorphTargets() {}
            dispose() {
                this.dispatchEvent({
                    type: "dispose"
                });
            }
        }
        class Lf extends Qc {
            constructor(t1){
                super(), this.isLineBasicMaterial = !0, this.type = "LineBasicMaterial", this.color = new kc(16777215), this.map = null, this.linewidth = 1, this.linecap = "round", this.linejoin = "round", this.fog = !0, this.setValues(t1);
            }
            copy(t1) {
                return super.copy(t1), this.color.copy(t1.color), this.map = t1.map, this.linewidth = t1.linewidth, this.linecap = t1.linecap, this.linejoin = t1.linejoin, this.fog = t1.fog, this;
            }
        }
        const Of = new xl, _f = new xl, jf = new Kl, Pf = new Jl, Rf = new Ql;
        class Uf extends wc {
            constructor(t1 = new Au, e = new Lf){
                super(), this.isLine = !0, this.type = "Line", this.geometry = t1, this.material = e, this.updateMorphTargets();
            }
            copy(t1, e) {
                return super.copy(t1, e), this.material = Array.isArray(t1.material) ? t1.material.slice() : t1.material, this.geometry = t1.geometry, this;
            }
            computeLineDistances() {
                const t1 = this.geometry;
                if (null === t1.index) {
                    const e = t1.attributes.position, i = [
                        0
                    ];
                    for(let t1 = 1, n = e.count; t1 < n; t1++)Of.fromBufferAttribute(e, t1 - 1), _f.fromBufferAttribute(e, t1), i[t1] = i[t1 - 1], i[t1] += Of.distanceTo(_f);
                    t1.setAttribute("lineDistance", new su(i, 1));
                } else console.warn("THREE.Line.computeLineDistances(): Computation only possible with non-indexed BufferGeometry.");
                return this;
            }
            raycast(t1, e) {
                const i = this.geometry, n = this.matrixWorld, r = t1.params.Line.threshold, a = i.drawRange;
                if (null === i.boundingSphere && i.computeBoundingSphere(), Rf.copy(i.boundingSphere), Rf.applyMatrix4(n), Rf.radius += r, !1 === t1.ray.intersectsSphere(Rf)) return;
                jf.copy(n).invert(), Pf.copy(t1.ray).applyMatrix4(jf);
                const s = r / ((this.scale.x + this.scale.y + this.scale.z) / 3), o = s * s, l = new xl, c = new xl, u = new xl, h = new xl, d = this.isLineSegments ? 2 : 1, p = i.index, f = i.attributes.position;
                if (null !== p) for(let i = Math.max(0, a.start), n = Math.min(p.count, a.start + a.count) - 1; i < n; i += d){
                    const n = p.getX(i), r = p.getX(i + 1);
                    if (l.fromBufferAttribute(f, n), c.fromBufferAttribute(f, r), Pf.distanceSqToSegment(l, c, h, u) > o) continue;
                    h.applyMatrix4(this.matrixWorld);
                    const a = t1.ray.origin.distanceTo(h);
                    a < t1.near || a > t1.far || e.push({
                        distance: a,
                        point: u.clone().applyMatrix4(this.matrixWorld),
                        index: i,
                        face: null,
                        faceIndex: null,
                        object: this
                    });
                }
                else for(let i = Math.max(0, a.start), n = Math.min(f.count, a.start + a.count) - 1; i < n; i += d){
                    if (l.fromBufferAttribute(f, i), c.fromBufferAttribute(f, i + 1), Pf.distanceSqToSegment(l, c, h, u) > o) continue;
                    h.applyMatrix4(this.matrixWorld);
                    const n = t1.ray.origin.distanceTo(h);
                    n < t1.near || n > t1.far || e.push({
                        distance: n,
                        point: u.clone().applyMatrix4(this.matrixWorld),
                        index: i,
                        face: null,
                        faceIndex: null,
                        object: this
                    });
                }
            }
            updateMorphTargets() {
                const t1 = this.geometry.morphAttributes, e = Object.keys(t1);
                if (e.length > 0) {
                    const i = t1[e[0]];
                    if (void 0 !== i) {
                        this.morphTargetInfluences = [], this.morphTargetDictionary = {};
                        for(let t1 = 0, e = i.length; t1 < e; t1++){
                            const e = i[t1].name || String(t1);
                            this.morphTargetInfluences.push(0), this.morphTargetDictionary[e] = t1;
                        }
                    }
                }
            }
        }
        const kf = new xl, Bf = new xl;
        class Ff extends Uf {
            constructor(t1, e){
                super(t1, e), this.isLineSegments = !0, this.type = "LineSegments";
            }
            computeLineDistances() {
                const t1 = this.geometry;
                if (null === t1.index) {
                    const e = t1.attributes.position, i = [];
                    for(let t1 = 0, n = e.count; t1 < n; t1 += 2)kf.fromBufferAttribute(e, t1), Bf.fromBufferAttribute(e, t1 + 1), i[t1] = 0 === t1 ? 0 : i[t1 - 1], i[t1 + 1] = i[t1] + kf.distanceTo(Bf);
                    t1.setAttribute("lineDistance", new su(i, 1));
                } else console.warn("THREE.LineSegments.computeLineDistances(): Computation only possible with non-indexed BufferGeometry.");
                return this;
            }
        }
        class Qf extends Uf {
            constructor(t1, e){
                super(t1, e), this.isLineLoop = !0, this.type = "LineLoop";
            }
        }
        class Hf extends Qc {
            constructor(t1){
                super(), this.isPointsMaterial = !0, this.type = "PointsMaterial", this.color = new kc(16777215), this.map = null, this.alphaMap = null, this.size = 1, this.sizeAttenuation = !0, this.fog = !0, this.setValues(t1);
            }
            copy(t1) {
                return super.copy(t1), this.color.copy(t1.color), this.map = t1.map, this.alphaMap = t1.alphaMap, this.size = t1.size, this.sizeAttenuation = t1.sizeAttenuation, this.fog = t1.fog, this;
            }
        }
        const Vf = new Kl, Gf = new Jl, Yf = new Ql, Wf = new xl;
        class Xf extends wc {
            constructor(t1 = new Au, e = new Hf){
                super(), this.isPoints = !0, this.type = "Points", this.geometry = t1, this.material = e, this.updateMorphTargets();
            }
            copy(t1, e) {
                return super.copy(t1, e), this.material = Array.isArray(t1.material) ? t1.material.slice() : t1.material, this.geometry = t1.geometry, this;
            }
            raycast(t1, e) {
                const i = this.geometry, n = this.matrixWorld, r = t1.params.Points.threshold, a = i.drawRange;
                if (null === i.boundingSphere && i.computeBoundingSphere(), Yf.copy(i.boundingSphere), Yf.applyMatrix4(n), Yf.radius += r, !1 === t1.ray.intersectsSphere(Yf)) return;
                Vf.copy(n).invert(), Gf.copy(t1.ray).applyMatrix4(Vf);
                const s = r / ((this.scale.x + this.scale.y + this.scale.z) / 3), o = s * s, l = i.index, c = i.attributes.position;
                if (null !== l) for(let i = Math.max(0, a.start), r = Math.min(l.count, a.start + a.count); i < r; i++){
                    const r = l.getX(i);
                    Wf.fromBufferAttribute(c, r), Zf(Wf, r, o, n, t1, e, this);
                }
                else for(let i = Math.max(0, a.start), r = Math.min(c.count, a.start + a.count); i < r; i++)Wf.fromBufferAttribute(c, i), Zf(Wf, i, o, n, t1, e, this);
            }
            updateMorphTargets() {
                const t1 = this.geometry.morphAttributes, e = Object.keys(t1);
                if (e.length > 0) {
                    const i = t1[e[0]];
                    if (void 0 !== i) {
                        this.morphTargetInfluences = [], this.morphTargetDictionary = {};
                        for(let t1 = 0, e = i.length; t1 < e; t1++){
                            const e = i[t1].name || String(t1);
                            this.morphTargetInfluences.push(0), this.morphTargetDictionary[e] = t1;
                        }
                    }
                }
            }
        }
        function Zf(t1, e, i, n, r, a, s) {
            const o = Gf.distanceSqToPoint(t1);
            if (o < i) {
                const i = new xl;
                Gf.closestPointToPoint(t1, i), i.applyMatrix4(n);
                const l = r.ray.origin.distanceTo(i);
                if (l < r.near || l > r.far) return;
                a.push({
                    distance: l,
                    distanceToRay: Math.sqrt(o),
                    point: i,
                    index: e,
                    face: null,
                    object: s
                });
            }
        }
        class Jf extends hl {
            constructor(t1, e, i, n, r, a, s, o, l){
                super(t1, e, i, n, r, a, s, o, l), this.isVideoTexture = !0, this.minFilter = void 0 !== a ? a : la, this.magFilter = void 0 !== r ? r : la, this.generateMipmaps = !1;
                const c = this;
                "requestVideoFrameCallback" in t1 && t1.requestVideoFrameCallback(function e() {
                    c.needsUpdate = !0, t1.requestVideoFrameCallback(e);
                });
            }
            clone() {
                return new this.constructor(this.image).copy(this);
            }
            update() {
                const t1 = this.image;
                !1 == "requestVideoFrameCallback" in t1 && t1.readyState >= t1.HAVE_CURRENT_DATA && (this.needsUpdate = !0);
            }
        }
        class Kf extends hl {
            constructor(t1, e){
                super({
                    width: t1,
                    height: e
                }), this.isFramebufferTexture = !0, this.magFilter = na, this.minFilter = na, this.generateMipmaps = !1, this.needsUpdate = !0;
            }
        }
        class qf extends hl {
            constructor(t1, e, i, n, r, a, s, o, l, c, u, h){
                super(null, a, s, o, l, c, n, r, u, h), this.isCompressedTexture = !0, this.image = {
                    width: e,
                    height: i
                }, this.mipmaps = t1, this.flipY = !1, this.generateMipmaps = !1;
            }
        }
        class $f extends qf {
            constructor(t1, e, i, n, r, a){
                super(t1, e, i, r, a), this.isCompressedArrayTexture = !0, this.image.depth = n, this.wrapR = ea;
            }
        }
        class tA extends qf {
            constructor(t1, e, i){
                super(void 0, t1[0].width, t1[0].height, e, i, Zr), this.isCompressedCubeTexture = !0, this.isCubeTexture = !0, this.image = t1;
            }
        }
        class eA extends hl {
            constructor(t1, e, i, n, r, a, s, o, l){
                super(t1, e, i, n, r, a, s, o, l), this.isCanvasTexture = !0, this.needsUpdate = !0;
            }
        }
        class iA {
            constructor(){
                this.type = "Curve", this.arcLengthDivisions = 200;
            }
            getPoint() {
                return console.warn("THREE.Curve: .getPoint() not implemented."), null;
            }
            getPointAt(t1, e) {
                const i = this.getUtoTmapping(t1);
                return this.getPoint(i, e);
            }
            getPoints(t1 = 5) {
                const e = [];
                for(let i = 0; i <= t1; i++)e.push(this.getPoint(i / t1));
                return e;
            }
            getSpacedPoints(t1 = 5) {
                const e = [];
                for(let i = 0; i <= t1; i++)e.push(this.getPointAt(i / t1));
                return e;
            }
            getLength() {
                const t1 = this.getLengths();
                return t1[t1.length - 1];
            }
            getLengths(t1 = this.arcLengthDivisions) {
                if (this.cacheArcLengths && this.cacheArcLengths.length === t1 + 1 && !this.needsUpdate) return this.cacheArcLengths;
                this.needsUpdate = !1;
                const e = [];
                let i, n = this.getPoint(0), r = 0;
                e.push(0);
                for(let a = 1; a <= t1; a++)i = this.getPoint(a / t1), r += i.distanceTo(n), e.push(r), n = i;
                return this.cacheArcLengths = e, e;
            }
            updateArcLengths() {
                this.needsUpdate = !0, this.getLengths();
            }
            getUtoTmapping(t1, e) {
                const i = this.getLengths();
                let n = 0;
                const r = i.length;
                let a;
                a = e || t1 * i[r - 1];
                let s, o = 0, l = r - 1;
                for(; o <= l;)if (n = Math.floor(o + (l - o) / 2), s = i[n] - a, s < 0) o = n + 1;
                else {
                    if (!(s > 0)) {
                        l = n;
                        break;
                    }
                    l = n - 1;
                }
                if (n = l, i[n] === a) return n / (r - 1);
                const c = i[n];
                return (n + (a - c) / (i[n + 1] - c)) / (r - 1);
            }
            getTangent(t1, e) {
                const i = 1e-4;
                let n = t1 - i, r = t1 + i;
                n < 0 && (n = 0), r > 1 && (r = 1);
                const a = this.getPoint(n), s = this.getPoint(r), o = e || (a.isVector2 ? new Qo : new xl);
                return o.copy(s).sub(a).normalize(), o;
            }
            getTangentAt(t1, e) {
                const i = this.getUtoTmapping(t1);
                return this.getTangent(i, e);
            }
            computeFrenetFrames(t1, e) {
                const i = new xl, n = [], r = [], a = [], s = new xl, o = new Kl;
                for(let e = 0; e <= t1; e++){
                    const i = e / t1;
                    n[e] = this.getTangentAt(i, new xl);
                }
                r[0] = new xl, a[0] = new xl;
                let l = Number.MAX_VALUE;
                const c = Math.abs(n[0].x), u = Math.abs(n[0].y), h = Math.abs(n[0].z);
                c <= l && (l = c, i.set(1, 0, 0)), u <= l && (l = u, i.set(0, 1, 0)), h <= l && i.set(0, 0, 1), s.crossVectors(n[0], i).normalize(), r[0].crossVectors(n[0], s), a[0].crossVectors(n[0], r[0]);
                for(let e = 1; e <= t1; e++){
                    if (r[e] = r[e - 1].clone(), a[e] = a[e - 1].clone(), s.crossVectors(n[e - 1], n[e]), s.length() > Number.EPSILON) {
                        s.normalize();
                        const t1 = Math.acos(Oo(n[e - 1].dot(n[e]), -1, 1));
                        r[e].applyMatrix4(o.makeRotationAxis(s, t1));
                    }
                    a[e].crossVectors(n[e], r[e]);
                }
                if (!0 === e) {
                    let e = Math.acos(Oo(r[0].dot(r[t1]), -1, 1));
                    e /= t1, n[0].dot(s.crossVectors(r[0], r[t1])) > 0 && (e = -e);
                    for(let i = 1; i <= t1; i++)r[i].applyMatrix4(o.makeRotationAxis(n[i], e * i)), a[i].crossVectors(n[i], r[i]);
                }
                return {
                    tangents: n,
                    normals: r,
                    binormals: a
                };
            }
            clone() {
                return (new this.constructor).copy(this);
            }
            copy(t1) {
                return this.arcLengthDivisions = t1.arcLengthDivisions, this;
            }
            toJSON() {
                const t1 = {
                    metadata: {
                        version: 4.6,
                        type: "Curve",
                        generator: "Curve.toJSON"
                    }
                };
                return t1.arcLengthDivisions = this.arcLengthDivisions, t1.type = this.type, t1;
            }
            fromJSON(t1) {
                return this.arcLengthDivisions = t1.arcLengthDivisions, this;
            }
        }
        class nA extends iA {
            constructor(t1 = 0, e = 0, i = 1, n = 1, r = 0, a = 2 * Math.PI, s = !1, o = 0){
                super(), this.isEllipseCurve = !0, this.type = "EllipseCurve", this.aX = t1, this.aY = e, this.xRadius = i, this.yRadius = n, this.aStartAngle = r, this.aEndAngle = a, this.aClockwise = s, this.aRotation = o;
            }
            getPoint(t1, e) {
                const i = e || new Qo, n = 2 * Math.PI;
                let r = this.aEndAngle - this.aStartAngle;
                const a = Math.abs(r) < Number.EPSILON;
                for(; r < 0;)r += n;
                for(; r > n;)r -= n;
                r < Number.EPSILON && (r = a ? 0 : n), !0 !== this.aClockwise || a || (r === n ? r = -n : r -= n);
                const s = this.aStartAngle + t1 * r;
                let o = this.aX + this.xRadius * Math.cos(s), l = this.aY + this.yRadius * Math.sin(s);
                if (0 !== this.aRotation) {
                    const t1 = Math.cos(this.aRotation), e = Math.sin(this.aRotation), i = o - this.aX, n = l - this.aY;
                    o = i * t1 - n * e + this.aX, l = i * e + n * t1 + this.aY;
                }
                return i.set(o, l);
            }
            copy(t1) {
                return super.copy(t1), this.aX = t1.aX, this.aY = t1.aY, this.xRadius = t1.xRadius, this.yRadius = t1.yRadius, this.aStartAngle = t1.aStartAngle, this.aEndAngle = t1.aEndAngle, this.aClockwise = t1.aClockwise, this.aRotation = t1.aRotation, this;
            }
            toJSON() {
                const t1 = super.toJSON();
                return t1.aX = this.aX, t1.aY = this.aY, t1.xRadius = this.xRadius, t1.yRadius = this.yRadius, t1.aStartAngle = this.aStartAngle, t1.aEndAngle = this.aEndAngle, t1.aClockwise = this.aClockwise, t1.aRotation = this.aRotation, t1;
            }
            fromJSON(t1) {
                return super.fromJSON(t1), this.aX = t1.aX, this.aY = t1.aY, this.xRadius = t1.xRadius, this.yRadius = t1.yRadius, this.aStartAngle = t1.aStartAngle, this.aEndAngle = t1.aEndAngle, this.aClockwise = t1.aClockwise, this.aRotation = t1.aRotation, this;
            }
        }
        class rA extends nA {
            constructor(t1, e, i, n, r, a){
                super(t1, e, i, i, n, r, a), this.isArcCurve = !0, this.type = "ArcCurve";
            }
        }
        function aA() {
            let t1 = 0, e = 0, i = 0, n = 0;
            function r(r, a, s, o) {
                t1 = r, e = s, i = -3 * r + 3 * a - 2 * s - o, n = 2 * r - 2 * a + s + o;
            }
            return {
                initCatmullRom: function(t1, e, i, n, a) {
                    r(e, i, a * (i - t1), a * (n - e));
                },
                initNonuniformCatmullRom: function(t1, e, i, n, a, s, o) {
                    let l = (e - t1) / a - (i - t1) / (a + s) + (i - e) / s, c = (i - e) / s - (n - e) / (s + o) + (n - i) / o;
                    l *= s, c *= s, r(e, i, l, c);
                },
                calc: function(r) {
                    const a = r * r;
                    return t1 + e * r + i * a + n * (a * r);
                }
            };
        }
        const sA = new xl, oA = new aA, lA = new aA, cA = new aA;
        class uA extends iA {
            constructor(t1 = [], e = !1, i = "centripetal", n = .5){
                super(), this.isCatmullRomCurve3 = !0, this.type = "CatmullRomCurve3", this.points = t1, this.closed = e, this.curveType = i, this.tension = n;
            }
            getPoint(t1, e = new xl) {
                const i = e, n = this.points, r = n.length, a = (r - (this.closed ? 0 : 1)) * t1;
                let s, o, l = Math.floor(a), c = a - l;
                this.closed ? l += l > 0 ? 0 : (Math.floor(Math.abs(l) / r) + 1) * r : 0 === c && l === r - 1 && (l = r - 2, c = 1), this.closed || l > 0 ? s = n[(l - 1) % r] : (sA.subVectors(n[0], n[1]).add(n[0]), s = sA);
                const u = n[l % r], h = n[(l + 1) % r];
                if (this.closed || l + 2 < r ? o = n[(l + 2) % r] : (sA.subVectors(n[r - 1], n[r - 2]).add(n[r - 1]), o = sA), "centripetal" === this.curveType || "chordal" === this.curveType) {
                    const t1 = "chordal" === this.curveType ? .5 : .25;
                    let e = Math.pow(s.distanceToSquared(u), t1), i = Math.pow(u.distanceToSquared(h), t1), n = Math.pow(h.distanceToSquared(o), t1);
                    i < 1e-4 && (i = 1), e < 1e-4 && (e = i), n < 1e-4 && (n = i), oA.initNonuniformCatmullRom(s.x, u.x, h.x, o.x, e, i, n), lA.initNonuniformCatmullRom(s.y, u.y, h.y, o.y, e, i, n), cA.initNonuniformCatmullRom(s.z, u.z, h.z, o.z, e, i, n);
                } else "catmullrom" === this.curveType && (oA.initCatmullRom(s.x, u.x, h.x, o.x, this.tension), lA.initCatmullRom(s.y, u.y, h.y, o.y, this.tension), cA.initCatmullRom(s.z, u.z, h.z, o.z, this.tension));
                return i.set(oA.calc(c), lA.calc(c), cA.calc(c)), i;
            }
            copy(t1) {
                super.copy(t1), this.points = [];
                for(let e = 0, i = t1.points.length; e < i; e++){
                    const i = t1.points[e];
                    this.points.push(i.clone());
                }
                return this.closed = t1.closed, this.curveType = t1.curveType, this.tension = t1.tension, this;
            }
            toJSON() {
                const t1 = super.toJSON();
                t1.points = [];
                for(let e = 0, i = this.points.length; e < i; e++){
                    const i = this.points[e];
                    t1.points.push(i.toArray());
                }
                return t1.closed = this.closed, t1.curveType = this.curveType, t1.tension = this.tension, t1;
            }
            fromJSON(t1) {
                super.fromJSON(t1), this.points = [];
                for(let e = 0, i = t1.points.length; e < i; e++){
                    const i = t1.points[e];
                    this.points.push((new xl).fromArray(i));
                }
                return this.closed = t1.closed, this.curveType = t1.curveType, this.tension = t1.tension, this;
            }
        }
        function hA(t1, e, i, n, r) {
            const a = .5 * (n - e), s = .5 * (r - i), o = t1 * t1;
            return (2 * i - 2 * n + a + s) * (t1 * o) + (-3 * i + 3 * n - 2 * a - s) * o + a * t1 + i;
        }
        function dA(t1, e, i, n) {
            return function(t1, e) {
                const i = 1 - t1;
                return i * i * e;
            }(t1, e) + function(t1, e) {
                return 2 * (1 - t1) * t1 * e;
            }(t1, i) + function(t1, e) {
                return t1 * t1 * e;
            }(t1, n);
        }
        function pA(t1, e, i, n, r) {
            return function(t1, e) {
                const i = 1 - t1;
                return i * i * i * e;
            }(t1, e) + function(t1, e) {
                const i = 1 - t1;
                return 3 * i * i * t1 * e;
            }(t1, i) + function(t1, e) {
                return 3 * (1 - t1) * t1 * t1 * e;
            }(t1, n) + function(t1, e) {
                return t1 * t1 * t1 * e;
            }(t1, r);
        }
        class fA extends iA {
            constructor(t1 = new Qo, e = new Qo, i = new Qo, n = new Qo){
                super(), this.isCubicBezierCurve = !0, this.type = "CubicBezierCurve", this.v0 = t1, this.v1 = e, this.v2 = i, this.v3 = n;
            }
            getPoint(t1, e = new Qo) {
                const i = e, n = this.v0, r = this.v1, a = this.v2, s = this.v3;
                return i.set(pA(t1, n.x, r.x, a.x, s.x), pA(t1, n.y, r.y, a.y, s.y)), i;
            }
            copy(t1) {
                return super.copy(t1), this.v0.copy(t1.v0), this.v1.copy(t1.v1), this.v2.copy(t1.v2), this.v3.copy(t1.v3), this;
            }
            toJSON() {
                const t1 = super.toJSON();
                return t1.v0 = this.v0.toArray(), t1.v1 = this.v1.toArray(), t1.v2 = this.v2.toArray(), t1.v3 = this.v3.toArray(), t1;
            }
            fromJSON(t1) {
                return super.fromJSON(t1), this.v0.fromArray(t1.v0), this.v1.fromArray(t1.v1), this.v2.fromArray(t1.v2), this.v3.fromArray(t1.v3), this;
            }
        }
        class AA extends iA {
            constructor(t1 = new xl, e = new xl, i = new xl, n = new xl){
                super(), this.isCubicBezierCurve3 = !0, this.type = "CubicBezierCurve3", this.v0 = t1, this.v1 = e, this.v2 = i, this.v3 = n;
            }
            getPoint(t1, e = new xl) {
                const i = e, n = this.v0, r = this.v1, a = this.v2, s = this.v3;
                return i.set(pA(t1, n.x, r.x, a.x, s.x), pA(t1, n.y, r.y, a.y, s.y), pA(t1, n.z, r.z, a.z, s.z)), i;
            }
            copy(t1) {
                return super.copy(t1), this.v0.copy(t1.v0), this.v1.copy(t1.v1), this.v2.copy(t1.v2), this.v3.copy(t1.v3), this;
            }
            toJSON() {
                const t1 = super.toJSON();
                return t1.v0 = this.v0.toArray(), t1.v1 = this.v1.toArray(), t1.v2 = this.v2.toArray(), t1.v3 = this.v3.toArray(), t1;
            }
            fromJSON(t1) {
                return super.fromJSON(t1), this.v0.fromArray(t1.v0), this.v1.fromArray(t1.v1), this.v2.fromArray(t1.v2), this.v3.fromArray(t1.v3), this;
            }
        }
        class gA extends iA {
            constructor(t1 = new Qo, e = new Qo){
                super(), this.isLineCurve = !0, this.type = "LineCurve", this.v1 = t1, this.v2 = e;
            }
            getPoint(t1, e = new Qo) {
                const i = e;
                return 1 === t1 ? i.copy(this.v2) : (i.copy(this.v2).sub(this.v1), i.multiplyScalar(t1).add(this.v1)), i;
            }
            getPointAt(t1, e) {
                return this.getPoint(t1, e);
            }
            getTangent(t1, e = new Qo) {
                return e.subVectors(this.v2, this.v1).normalize();
            }
            getTangentAt(t1, e) {
                return this.getTangent(t1, e);
            }
            copy(t1) {
                return super.copy(t1), this.v1.copy(t1.v1), this.v2.copy(t1.v2), this;
            }
            toJSON() {
                const t1 = super.toJSON();
                return t1.v1 = this.v1.toArray(), t1.v2 = this.v2.toArray(), t1;
            }
            fromJSON(t1) {
                return super.fromJSON(t1), this.v1.fromArray(t1.v1), this.v2.fromArray(t1.v2), this;
            }
        }
        class mA extends iA {
            constructor(t1 = new xl, e = new xl){
                super(), this.isLineCurve3 = !0, this.type = "LineCurve3", this.v1 = t1, this.v2 = e;
            }
            getPoint(t1, e = new xl) {
                const i = e;
                return 1 === t1 ? i.copy(this.v2) : (i.copy(this.v2).sub(this.v1), i.multiplyScalar(t1).add(this.v1)), i;
            }
            getPointAt(t1, e) {
                return this.getPoint(t1, e);
            }
            getTangent(t1, e = new xl) {
                return e.subVectors(this.v2, this.v1).normalize();
            }
            getTangentAt(t1, e) {
                return this.getTangent(t1, e);
            }
            copy(t1) {
                return super.copy(t1), this.v1.copy(t1.v1), this.v2.copy(t1.v2), this;
            }
            toJSON() {
                const t1 = super.toJSON();
                return t1.v1 = this.v1.toArray(), t1.v2 = this.v2.toArray(), t1;
            }
            fromJSON(t1) {
                return super.fromJSON(t1), this.v1.fromArray(t1.v1), this.v2.fromArray(t1.v2), this;
            }
        }
        class MA extends iA {
            constructor(t1 = new Qo, e = new Qo, i = new Qo){
                super(), this.isQuadraticBezierCurve = !0, this.type = "QuadraticBezierCurve", this.v0 = t1, this.v1 = e, this.v2 = i;
            }
            getPoint(t1, e = new Qo) {
                const i = e, n = this.v0, r = this.v1, a = this.v2;
                return i.set(dA(t1, n.x, r.x, a.x), dA(t1, n.y, r.y, a.y)), i;
            }
            copy(t1) {
                return super.copy(t1), this.v0.copy(t1.v0), this.v1.copy(t1.v1), this.v2.copy(t1.v2), this;
            }
            toJSON() {
                const t1 = super.toJSON();
                return t1.v0 = this.v0.toArray(), t1.v1 = this.v1.toArray(), t1.v2 = this.v2.toArray(), t1;
            }
            fromJSON(t1) {
                return super.fromJSON(t1), this.v0.fromArray(t1.v0), this.v1.fromArray(t1.v1), this.v2.fromArray(t1.v2), this;
            }
        }
        class yA extends iA {
            constructor(t1 = new xl, e = new xl, i = new xl){
                super(), this.isQuadraticBezierCurve3 = !0, this.type = "QuadraticBezierCurve3", this.v0 = t1, this.v1 = e, this.v2 = i;
            }
            getPoint(t1, e = new xl) {
                const i = e, n = this.v0, r = this.v1, a = this.v2;
                return i.set(dA(t1, n.x, r.x, a.x), dA(t1, n.y, r.y, a.y), dA(t1, n.z, r.z, a.z)), i;
            }
            copy(t1) {
                return super.copy(t1), this.v0.copy(t1.v0), this.v1.copy(t1.v1), this.v2.copy(t1.v2), this;
            }
            toJSON() {
                const t1 = super.toJSON();
                return t1.v0 = this.v0.toArray(), t1.v1 = this.v1.toArray(), t1.v2 = this.v2.toArray(), t1;
            }
            fromJSON(t1) {
                return super.fromJSON(t1), this.v0.fromArray(t1.v0), this.v1.fromArray(t1.v1), this.v2.fromArray(t1.v2), this;
            }
        }
        class vA extends iA {
            constructor(t1 = []){
                super(), this.isSplineCurve = !0, this.type = "SplineCurve", this.points = t1;
            }
            getPoint(t1, e = new Qo) {
                const i = e, n = this.points, r = (n.length - 1) * t1, a = Math.floor(r), s = r - a, o = n[0 === a ? a : a - 1], l = n[a], c = n[a > n.length - 2 ? n.length - 1 : a + 1], u = n[a > n.length - 3 ? n.length - 1 : a + 2];
                return i.set(hA(s, o.x, l.x, c.x, u.x), hA(s, o.y, l.y, c.y, u.y)), i;
            }
            copy(t1) {
                super.copy(t1), this.points = [];
                for(let e = 0, i = t1.points.length; e < i; e++){
                    const i = t1.points[e];
                    this.points.push(i.clone());
                }
                return this;
            }
            toJSON() {
                const t1 = super.toJSON();
                t1.points = [];
                for(let e = 0, i = this.points.length; e < i; e++){
                    const i = this.points[e];
                    t1.points.push(i.toArray());
                }
                return t1;
            }
            fromJSON(t1) {
                super.fromJSON(t1), this.points = [];
                for(let e = 0, i = t1.points.length; e < i; e++){
                    const i = t1.points[e];
                    this.points.push((new Qo).fromArray(i));
                }
                return this;
            }
        }
        var xA = Object.freeze({
            __proto__: null,
            ArcCurve: rA,
            CatmullRomCurve3: uA,
            CubicBezierCurve: fA,
            CubicBezierCurve3: AA,
            EllipseCurve: nA,
            LineCurve: gA,
            LineCurve3: mA,
            QuadraticBezierCurve: MA,
            QuadraticBezierCurve3: yA,
            SplineCurve: vA
        });
        class wA extends iA {
            constructor(){
                super(), this.type = "CurvePath", this.curves = [], this.autoClose = !1;
            }
            add(t1) {
                this.curves.push(t1);
            }
            closePath() {
                const t1 = this.curves[0].getPoint(0), e = this.curves[this.curves.length - 1].getPoint(1);
                if (!t1.equals(e)) {
                    const i = !0 === t1.isVector2 ? "LineCurve" : "LineCurve3";
                    this.curves.push(new xA[i](e, t1));
                }
                return this;
            }
            getPoint(t1, e) {
                const i = t1 * this.getLength(), n = this.getCurveLengths();
                let r = 0;
                for(; r < n.length;){
                    if (n[r] >= i) {
                        const t1 = n[r] - i, a = this.curves[r], s = a.getLength(), o = 0 === s ? 0 : 1 - t1 / s;
                        return a.getPointAt(o, e);
                    }
                    r++;
                }
                return null;
            }
            getLength() {
                const t1 = this.getCurveLengths();
                return t1[t1.length - 1];
            }
            updateArcLengths() {
                this.needsUpdate = !0, this.cacheLengths = null, this.getCurveLengths();
            }
            getCurveLengths() {
                if (this.cacheLengths && this.cacheLengths.length === this.curves.length) return this.cacheLengths;
                const t1 = [];
                let e = 0;
                for(let i = 0, n = this.curves.length; i < n; i++)e += this.curves[i].getLength(), t1.push(e);
                return this.cacheLengths = t1, t1;
            }
            getSpacedPoints(t1 = 40) {
                const e = [];
                for(let i = 0; i <= t1; i++)e.push(this.getPoint(i / t1));
                return this.autoClose && e.push(e[0]), e;
            }
            getPoints(t1 = 12) {
                const e = [];
                let i;
                for(let n = 0, r = this.curves; n < r.length; n++){
                    const a = r[n], s = a.isEllipseCurve ? 2 * t1 : a.isLineCurve || a.isLineCurve3 ? 1 : a.isSplineCurve ? t1 * a.points.length : t1, o = a.getPoints(s);
                    for(let t1 = 0; t1 < o.length; t1++){
                        const n = o[t1];
                        i && i.equals(n) || (e.push(n), i = n);
                    }
                }
                return this.autoClose && e.length > 1 && !e[e.length - 1].equals(e[0]) && e.push(e[0]), e;
            }
            copy(t1) {
                super.copy(t1), this.curves = [];
                for(let e = 0, i = t1.curves.length; e < i; e++){
                    const i = t1.curves[e];
                    this.curves.push(i.clone());
                }
                return this.autoClose = t1.autoClose, this;
            }
            toJSON() {
                const t1 = super.toJSON();
                t1.autoClose = this.autoClose, t1.curves = [];
                for(let e = 0, i = this.curves.length; e < i; e++){
                    const i = this.curves[e];
                    t1.curves.push(i.toJSON());
                }
                return t1;
            }
            fromJSON(t1) {
                super.fromJSON(t1), this.autoClose = t1.autoClose, this.curves = [];
                for(let e = 0, i = t1.curves.length; e < i; e++){
                    const i = t1.curves[e];
                    this.curves.push((new xA[i.type]).fromJSON(i));
                }
                return this;
            }
        }
        class bA extends wA {
            constructor(t1){
                super(), this.type = "Path", this.currentPoint = new Qo, t1 && this.setFromPoints(t1);
            }
            setFromPoints(t1) {
                this.moveTo(t1[0].x, t1[0].y);
                for(let e = 1, i = t1.length; e < i; e++)this.lineTo(t1[e].x, t1[e].y);
                return this;
            }
            moveTo(t1, e) {
                return this.currentPoint.set(t1, e), this;
            }
            lineTo(t1, e) {
                const i = new gA(this.currentPoint.clone(), new Qo(t1, e));
                return this.curves.push(i), this.currentPoint.set(t1, e), this;
            }
            quadraticCurveTo(t1, e, i, n) {
                const r = new MA(this.currentPoint.clone(), new Qo(t1, e), new Qo(i, n));
                return this.curves.push(r), this.currentPoint.set(i, n), this;
            }
            bezierCurveTo(t1, e, i, n, r, a) {
                const s = new fA(this.currentPoint.clone(), new Qo(t1, e), new Qo(i, n), new Qo(r, a));
                return this.curves.push(s), this.currentPoint.set(r, a), this;
            }
            splineThru(t1) {
                const e = [
                    this.currentPoint.clone()
                ].concat(t1), i = new vA(e);
                return this.curves.push(i), this.currentPoint.copy(t1[t1.length - 1]), this;
            }
            arc(t1, e, i, n, r, a) {
                const s = this.currentPoint.x, o = this.currentPoint.y;
                return this.absarc(t1 + s, e + o, i, n, r, a), this;
            }
            absarc(t1, e, i, n, r, a) {
                return this.absellipse(t1, e, i, i, n, r, a), this;
            }
            ellipse(t1, e, i, n, r, a, s, o) {
                const l = this.currentPoint.x, c = this.currentPoint.y;
                return this.absellipse(t1 + l, e + c, i, n, r, a, s, o), this;
            }
            absellipse(t1, e, i, n, r, a, s, o) {
                const l = new nA(t1, e, i, n, r, a, s, o);
                if (this.curves.length > 0) {
                    const t1 = l.getPoint(0);
                    t1.equals(this.currentPoint) || this.lineTo(t1.x, t1.y);
                }
                this.curves.push(l);
                const c = l.getPoint(1);
                return this.currentPoint.copy(c), this;
            }
            copy(t1) {
                return super.copy(t1), this.currentPoint.copy(t1.currentPoint), this;
            }
            toJSON() {
                const t1 = super.toJSON();
                return t1.currentPoint = this.currentPoint.toArray(), t1;
            }
            fromJSON(t1) {
                return super.fromJSON(t1), this.currentPoint.fromArray(t1.currentPoint), this;
            }
        }
        class TA extends Au {
            constructor(t1 = [
                new Qo(0, -0.5),
                new Qo(.5, 0),
                new Qo(0, .5)
            ], e = 12, i = 0, n = 2 * Math.PI){
                super(), this.type = "LatheGeometry", this.parameters = {
                    points: t1,
                    segments: e,
                    phiStart: i,
                    phiLength: n
                }, e = Math.floor(e), n = Oo(n, 0, 2 * Math.PI);
                const r = [], a = [], s = [], o = [], l = [], c = 1 / e, u = new xl, h = new Qo, d = new xl, p = new xl, f = new xl;
                let A = 0, g = 0;
                for(let e = 0; e <= t1.length - 1; e++)switch(e){
                    case 0:
                        A = t1[e + 1].x - t1[e].x, g = t1[e + 1].y - t1[e].y, d.x = 1 * g, d.y = -A, d.z = 0 * g, f.copy(d), d.normalize(), o.push(d.x, d.y, d.z);
                        break;
                    case t1.length - 1:
                        o.push(f.x, f.y, f.z);
                        break;
                    default:
                        A = t1[e + 1].x - t1[e].x, g = t1[e + 1].y - t1[e].y, d.x = 1 * g, d.y = -A, d.z = 0 * g, p.copy(d), d.x += f.x, d.y += f.y, d.z += f.z, d.normalize(), o.push(d.x, d.y, d.z), f.copy(p);
                }
                for(let r = 0; r <= e; r++){
                    const d = i + r * c * n, p = Math.sin(d), f = Math.cos(d);
                    for(let i = 0; i <= t1.length - 1; i++){
                        u.x = t1[i].x * p, u.y = t1[i].y, u.z = t1[i].x * f, a.push(u.x, u.y, u.z), h.x = r / e, h.y = i / (t1.length - 1), s.push(h.x, h.y);
                        const n = o[3 * i + 0] * p, c = o[3 * i + 1], d = o[3 * i + 0] * f;
                        l.push(n, c, d);
                    }
                }
                for(let i = 0; i < e; i++)for(let e = 0; e < t1.length - 1; e++){
                    const n = e + i * t1.length, a = n, s = n + t1.length, o = n + t1.length + 1, l = n + 1;
                    r.push(a, s, l), r.push(o, l, s);
                }
                this.setIndex(r), this.setAttribute("position", new su(a, 3)), this.setAttribute("uv", new su(s, 2)), this.setAttribute("normal", new su(l, 3));
            }
            copy(t1) {
                return super.copy(t1), this.parameters = Object.assign({}, t1.parameters), this;
            }
            static fromJSON(t1) {
                return new TA(t1.points, t1.segments, t1.phiStart, t1.phiLength);
            }
        }
        class EA extends TA {
            constructor(t1 = 1, e = 1, i = 4, n = 8){
                const r = new bA;
                r.absarc(0, -e / 2, t1, 1.5 * Math.PI, 0), r.absarc(0, e / 2, t1, 0, .5 * Math.PI), super(r.getPoints(i), n), this.type = "CapsuleGeometry", this.parameters = {
                    radius: t1,
                    length: e,
                    capSegments: i,
                    radialSegments: n
                };
            }
            static fromJSON(t1) {
                return new EA(t1.radius, t1.length, t1.capSegments, t1.radialSegments);
            }
        }
        class IA extends Au {
            constructor(t1 = 1, e = 32, i = 0, n = 2 * Math.PI){
                super(), this.type = "CircleGeometry", this.parameters = {
                    radius: t1,
                    segments: e,
                    thetaStart: i,
                    thetaLength: n
                }, e = Math.max(3, e);
                const r = [], a = [], s = [], o = [], l = new xl, c = new Qo;
                a.push(0, 0, 0), s.push(0, 0, 1), o.push(.5, .5);
                for(let r = 0, u = 3; r <= e; r++, u += 3){
                    const h = i + r / e * n;
                    l.x = t1 * Math.cos(h), l.y = t1 * Math.sin(h), a.push(l.x, l.y, l.z), s.push(0, 0, 1), c.x = (a[u] / t1 + 1) / 2, c.y = (a[u + 1] / t1 + 1) / 2, o.push(c.x, c.y);
                }
                for(let t1 = 1; t1 <= e; t1++)r.push(t1, t1 + 1, 0);
                this.setIndex(r), this.setAttribute("position", new su(a, 3)), this.setAttribute("normal", new su(s, 3)), this.setAttribute("uv", new su(o, 2));
            }
            copy(t1) {
                return super.copy(t1), this.parameters = Object.assign({}, t1.parameters), this;
            }
            static fromJSON(t1) {
                return new IA(t1.radius, t1.segments, t1.thetaStart, t1.thetaLength);
            }
        }
        class SA extends Au {
            constructor(t1 = 1, e = 1, i = 1, n = 32, r = 1, a = !1, s = 0, o = 2 * Math.PI){
                super(), this.type = "CylinderGeometry", this.parameters = {
                    radiusTop: t1,
                    radiusBottom: e,
                    height: i,
                    radialSegments: n,
                    heightSegments: r,
                    openEnded: a,
                    thetaStart: s,
                    thetaLength: o
                };
                const l = this;
                n = Math.floor(n), r = Math.floor(r);
                const c = [], u = [], h = [], d = [];
                let p = 0;
                const f = [], A = i / 2;
                let g = 0;
                function m(i) {
                    const r = p, a = new Qo, f = new xl;
                    let m = 0;
                    const M = !0 === i ? t1 : e, y = !0 === i ? 1 : -1;
                    for(let t1 = 1; t1 <= n; t1++)u.push(0, A * y, 0), h.push(0, y, 0), d.push(.5, .5), p++;
                    const v = p;
                    for(let t1 = 0; t1 <= n; t1++){
                        const e = t1 / n * o + s, i = Math.cos(e), r = Math.sin(e);
                        f.x = M * r, f.y = A * y, f.z = M * i, u.push(f.x, f.y, f.z), h.push(0, y, 0), a.x = .5 * i + .5, a.y = .5 * r * y + .5, d.push(a.x, a.y), p++;
                    }
                    for(let t1 = 0; t1 < n; t1++){
                        const e = r + t1, n = v + t1;
                        !0 === i ? c.push(n, n + 1, e) : c.push(n + 1, n, e), m += 3;
                    }
                    l.addGroup(g, m, !0 === i ? 1 : 2), g += m;
                }
                !function() {
                    const a = new xl, m = new xl;
                    let M = 0;
                    const y = (e - t1) / i;
                    for(let l = 0; l <= r; l++){
                        const c = [], g = l / r, M = g * (e - t1) + t1;
                        for(let t1 = 0; t1 <= n; t1++){
                            const e = t1 / n, r = e * o + s, l = Math.sin(r), f = Math.cos(r);
                            m.x = M * l, m.y = -g * i + A, m.z = M * f, u.push(m.x, m.y, m.z), a.set(l, y, f).normalize(), h.push(a.x, a.y, a.z), d.push(e, 1 - g), c.push(p++);
                        }
                        f.push(c);
                    }
                    for(let t1 = 0; t1 < n; t1++)for(let e = 0; e < r; e++){
                        const i = f[e][t1], n = f[e + 1][t1], r = f[e + 1][t1 + 1], a = f[e][t1 + 1];
                        c.push(i, n, a), c.push(n, r, a), M += 6;
                    }
                    l.addGroup(g, M, 0), g += M;
                }(), !1 === a && (t1 > 0 && m(!0), e > 0 && m(!1)), this.setIndex(c), this.setAttribute("position", new su(u, 3)), this.setAttribute("normal", new su(h, 3)), this.setAttribute("uv", new su(d, 2));
            }
            copy(t1) {
                return super.copy(t1), this.parameters = Object.assign({}, t1.parameters), this;
            }
            static fromJSON(t1) {
                return new SA(t1.radiusTop, t1.radiusBottom, t1.height, t1.radialSegments, t1.heightSegments, t1.openEnded, t1.thetaStart, t1.thetaLength);
            }
        }
        class NA extends SA {
            constructor(t1 = 1, e = 1, i = 32, n = 1, r = !1, a = 0, s = 2 * Math.PI){
                super(0, t1, e, i, n, r, a, s), this.type = "ConeGeometry", this.parameters = {
                    radius: t1,
                    height: e,
                    radialSegments: i,
                    heightSegments: n,
                    openEnded: r,
                    thetaStart: a,
                    thetaLength: s
                };
            }
            static fromJSON(t1) {
                return new NA(t1.radius, t1.height, t1.radialSegments, t1.heightSegments, t1.openEnded, t1.thetaStart, t1.thetaLength);
            }
        }
        class DA extends Au {
            constructor(t1 = [], e = [], i = 1, n = 0){
                super(), this.type = "PolyhedronGeometry", this.parameters = {
                    vertices: t1,
                    indices: e,
                    radius: i,
                    detail: n
                };
                const r = [], a = [];
                function s(t1, e, i, n) {
                    const r = n + 1, a = [];
                    for(let n = 0; n <= r; n++){
                        a[n] = [];
                        const s = t1.clone().lerp(i, n / r), o = e.clone().lerp(i, n / r), l = r - n;
                        for(let t1 = 0; t1 <= l; t1++)a[n][t1] = 0 === t1 && n === r ? s : s.clone().lerp(o, t1 / l);
                    }
                    for(let t1 = 0; t1 < r; t1++)for(let e = 0; e < 2 * (r - t1) - 1; e++){
                        const i = Math.floor(e / 2);
                        e % 2 == 0 ? (o(a[t1][i + 1]), o(a[t1 + 1][i]), o(a[t1][i])) : (o(a[t1][i + 1]), o(a[t1 + 1][i + 1]), o(a[t1 + 1][i]));
                    }
                }
                function o(t1) {
                    r.push(t1.x, t1.y, t1.z);
                }
                function l(e, i) {
                    const n = 3 * e;
                    i.x = t1[n + 0], i.y = t1[n + 1], i.z = t1[n + 2];
                }
                function c(t1, e, i, n) {
                    n < 0 && 1 === t1.x && (a[e] = t1.x - 1), 0 === i.x && 0 === i.z && (a[e] = n / 2 / Math.PI + .5);
                }
                function u(t1) {
                    return Math.atan2(t1.z, -t1.x);
                }
                !function(t1) {
                    const i = new xl, n = new xl, r = new xl;
                    for(let a = 0; a < e.length; a += 3)l(e[a + 0], i), l(e[a + 1], n), l(e[a + 2], r), s(i, n, r, t1);
                }(n), function(t1) {
                    const e = new xl;
                    for(let i = 0; i < r.length; i += 3)e.x = r[i + 0], e.y = r[i + 1], e.z = r[i + 2], e.normalize().multiplyScalar(t1), r[i + 0] = e.x, r[i + 1] = e.y, r[i + 2] = e.z;
                }(i), function() {
                    const t1 = new xl;
                    for(let i = 0; i < r.length; i += 3){
                        t1.x = r[i + 0], t1.y = r[i + 1], t1.z = r[i + 2];
                        const n = u(t1) / 2 / Math.PI + .5, s = (e = t1, Math.atan2(-e.y, Math.sqrt(e.x * e.x + e.z * e.z)) / Math.PI + .5);
                        a.push(n, 1 - s);
                    }
                    var e;
                    (function() {
                        const t1 = new xl, e = new xl, i = new xl, n = new xl, s = new Qo, o = new Qo, l = new Qo;
                        for(let h = 0, d = 0; h < r.length; h += 9, d += 6){
                            t1.set(r[h + 0], r[h + 1], r[h + 2]), e.set(r[h + 3], r[h + 4], r[h + 5]), i.set(r[h + 6], r[h + 7], r[h + 8]), s.set(a[d + 0], a[d + 1]), o.set(a[d + 2], a[d + 3]), l.set(a[d + 4], a[d + 5]), n.copy(t1).add(e).add(i).divideScalar(3);
                            const p = u(n);
                            c(s, d + 0, t1, p), c(o, d + 2, e, p), c(l, d + 4, i, p);
                        }
                    })(), function() {
                        for(let t1 = 0; t1 < a.length; t1 += 6){
                            const e = a[t1 + 0], i = a[t1 + 2], n = a[t1 + 4], r = Math.max(e, i, n), s = Math.min(e, i, n);
                            r > .9 && s < .1 && (e < .2 && (a[t1 + 0] += 1), i < .2 && (a[t1 + 2] += 1), n < .2 && (a[t1 + 4] += 1));
                        }
                    }();
                }(), this.setAttribute("position", new su(r, 3)), this.setAttribute("normal", new su(r.slice(), 3)), this.setAttribute("uv", new su(a, 2)), 0 === n ? this.computeVertexNormals() : this.normalizeNormals();
            }
            copy(t1) {
                return super.copy(t1), this.parameters = Object.assign({}, t1.parameters), this;
            }
            static fromJSON(t1) {
                return new DA(t1.vertices, t1.indices, t1.radius, t1.details);
            }
        }
        class CA extends DA {
            constructor(t1 = 1, e = 0){
                const i = (1 + Math.sqrt(5)) / 2, n = 1 / i;
                super([
                    -1,
                    -1,
                    -1,
                    -1,
                    -1,
                    1,
                    -1,
                    1,
                    -1,
                    -1,
                    1,
                    1,
                    1,
                    -1,
                    -1,
                    1,
                    -1,
                    1,
                    1,
                    1,
                    -1,
                    1,
                    1,
                    1,
                    0,
                    -n,
                    -i,
                    0,
                    -n,
                    i,
                    0,
                    n,
                    -i,
                    0,
                    n,
                    i,
                    -n,
                    -i,
                    0,
                    -n,
                    i,
                    0,
                    n,
                    -i,
                    0,
                    n,
                    i,
                    0,
                    -i,
                    0,
                    -n,
                    i,
                    0,
                    -n,
                    -i,
                    0,
                    n,
                    i,
                    0,
                    n
                ], [
                    3,
                    11,
                    7,
                    3,
                    7,
                    15,
                    3,
                    15,
                    13,
                    7,
                    19,
                    17,
                    7,
                    17,
                    6,
                    7,
                    6,
                    15,
                    17,
                    4,
                    8,
                    17,
                    8,
                    10,
                    17,
                    10,
                    6,
                    8,
                    0,
                    16,
                    8,
                    16,
                    2,
                    8,
                    2,
                    10,
                    0,
                    12,
                    1,
                    0,
                    1,
                    18,
                    0,
                    18,
                    16,
                    6,
                    10,
                    2,
                    6,
                    2,
                    13,
                    6,
                    13,
                    15,
                    2,
                    16,
                    18,
                    2,
                    18,
                    3,
                    2,
                    3,
                    13,
                    18,
                    1,
                    9,
                    18,
                    9,
                    11,
                    18,
                    11,
                    3,
                    4,
                    14,
                    12,
                    4,
                    12,
                    0,
                    4,
                    0,
                    8,
                    11,
                    9,
                    5,
                    11,
                    5,
                    19,
                    11,
                    19,
                    7,
                    19,
                    5,
                    14,
                    19,
                    14,
                    4,
                    19,
                    4,
                    17,
                    1,
                    12,
                    14,
                    1,
                    14,
                    5,
                    1,
                    5,
                    9
                ], t1, e), this.type = "DodecahedronGeometry", this.parameters = {
                    radius: t1,
                    detail: e
                };
            }
            static fromJSON(t1) {
                return new CA(t1.radius, t1.detail);
            }
        }
        const zA = new xl, LA = new xl, OA = new xl, _A = new _c;
        class jA extends Au {
            constructor(t1 = null, e = 1){
                if (super(), this.type = "EdgesGeometry", this.parameters = {
                    geometry: t1,
                    thresholdAngle: e
                }, null !== t1) {
                    const i = 4, n = Math.pow(10, i), r = Math.cos(Co * e), a = t1.getIndex(), s = t1.getAttribute("position"), o = a ? a.count : s.count, l = [
                        0,
                        0,
                        0
                    ], c = [
                        "a",
                        "b",
                        "c"
                    ], u = new Array(3), h = {}, d = [];
                    for(let t1 = 0; t1 < o; t1 += 3){
                        a ? (l[0] = a.getX(t1), l[1] = a.getX(t1 + 1), l[2] = a.getX(t1 + 2)) : (l[0] = t1, l[1] = t1 + 1, l[2] = t1 + 2);
                        const { a: e, b: i, c: o } = _A;
                        if (e.fromBufferAttribute(s, l[0]), i.fromBufferAttribute(s, l[1]), o.fromBufferAttribute(s, l[2]), _A.getNormal(OA), u[0] = `${Math.round(e.x * n)},${Math.round(e.y * n)},${Math.round(e.z * n)}`, u[1] = `${Math.round(i.x * n)},${Math.round(i.y * n)},${Math.round(i.z * n)}`, u[2] = `${Math.round(o.x * n)},${Math.round(o.y * n)},${Math.round(o.z * n)}`, u[0] !== u[1] && u[1] !== u[2] && u[2] !== u[0]) for(let t1 = 0; t1 < 3; t1++){
                            const e = (t1 + 1) % 3, i = u[t1], n = u[e], a = _A[c[t1]], s = _A[c[e]], o = `${i}_${n}`, p = `${n}_${i}`;
                            p in h && h[p] ? (OA.dot(h[p].normal) <= r && (d.push(a.x, a.y, a.z), d.push(s.x, s.y, s.z)), h[p] = null) : o in h || (h[o] = {
                                index0: l[t1],
                                index1: l[e],
                                normal: OA.clone()
                            });
                        }
                    }
                    for(const t1 in h)if (h[t1]) {
                        const { index0: e, index1: i } = h[t1];
                        zA.fromBufferAttribute(s, e), LA.fromBufferAttribute(s, i), d.push(zA.x, zA.y, zA.z), d.push(LA.x, LA.y, LA.z);
                    }
                    this.setAttribute("position", new su(d, 3));
                }
            }
            copy(t1) {
                return super.copy(t1), this.parameters = Object.assign({}, t1.parameters), this;
            }
        }
        class PA extends bA {
            constructor(t1){
                super(t1), this.uuid = Lo(), this.type = "Shape", this.holes = [];
            }
            getPointsHoles(t1) {
                const e = [];
                for(let i = 0, n = this.holes.length; i < n; i++)e[i] = this.holes[i].getPoints(t1);
                return e;
            }
            extractPoints(t1) {
                return {
                    shape: this.getPoints(t1),
                    holes: this.getPointsHoles(t1)
                };
            }
            copy(t1) {
                super.copy(t1), this.holes = [];
                for(let e = 0, i = t1.holes.length; e < i; e++){
                    const i = t1.holes[e];
                    this.holes.push(i.clone());
                }
                return this;
            }
            toJSON() {
                const t1 = super.toJSON();
                t1.uuid = this.uuid, t1.holes = [];
                for(let e = 0, i = this.holes.length; e < i; e++){
                    const i = this.holes[e];
                    t1.holes.push(i.toJSON());
                }
                return t1;
            }
            fromJSON(t1) {
                super.fromJSON(t1), this.uuid = t1.uuid, this.holes = [];
                for(let e = 0, i = t1.holes.length; e < i; e++){
                    const i = t1.holes[e];
                    this.holes.push((new bA).fromJSON(i));
                }
                return this;
            }
        }
        function RA(t1, e, i, n, r) {
            let a, s;
            if (r === function(t1, e, i, n) {
                let r = 0;
                for(let a = e, s = i - n; a < i; a += n)r += (t1[s] - t1[a]) * (t1[a + 1] + t1[s + 1]), s = a;
                return r;
            }(t1, e, i, n) > 0) for(a = e; a < i; a += n)s = rg(a, t1[a], t1[a + 1], s);
            else for(a = i - n; a >= e; a -= n)s = rg(a, t1[a], t1[a + 1], s);
            return s && qA(s, s.next) && (ag(s), s = s.next), s;
        }
        function UA(t1, e) {
            if (!t1) return t1;
            e || (e = t1);
            let i, n = t1;
            do if (i = !1, n.steiner || !qA(n, n.next) && 0 !== KA(n.prev, n, n.next)) n = n.next;
            else {
                if (ag(n), n = e = n.prev, n === n.next) break;
                i = !0;
            }
            while (i || n !== e);
            return e;
        }
        function kA(t1, e, i, n, r, a, s) {
            if (!t1) return;
            !s && a && function(t1, e, i, n) {
                let r = t1;
                do 0 === r.z && (r.z = WA(r.x, r.y, e, i, n)), r.prevZ = r.prev, r.nextZ = r.next, r = r.next;
                while (r !== t1);
                r.prevZ.nextZ = null, r.prevZ = null, function(t1) {
                    let e, i, n, r, a, s, o, l, c = 1;
                    do {
                        for(i = t1, t1 = null, a = null, s = 0; i;){
                            for(s++, n = i, o = 0, e = 0; e < c && (o++, n = n.nextZ, n); e++);
                            for(l = c; o > 0 || l > 0 && n;)0 !== o && (0 === l || !n || i.z <= n.z) ? (r = i, i = i.nextZ, o--) : (r = n, n = n.nextZ, l--), a ? a.nextZ = r : t1 = r, r.prevZ = a, a = r;
                            i = n;
                        }
                        a.nextZ = null, c *= 2;
                    }while (s > 1);
                }(r);
            }(t1, n, r, a);
            let o, l, c = t1;
            for(; t1.prev !== t1.next;)if (o = t1.prev, l = t1.next, a ? FA(t1, n, r, a) : BA(t1)) e.push(o.i / i | 0), e.push(t1.i / i | 0), e.push(l.i / i | 0), ag(t1), t1 = l.next, c = l.next;
            else if ((t1 = l) === c) {
                s ? 1 === s ? kA(t1 = QA(UA(t1), e, i), e, i, n, r, a, 2) : 2 === s && HA(t1, e, i, n, r, a) : kA(UA(t1), e, i, n, r, a, 1);
                break;
            }
        }
        function BA(t1) {
            const e = t1.prev, i = t1, n = t1.next;
            if (KA(e, i, n) >= 0) return !1;
            const r = e.x, a = i.x, s = n.x, o = e.y, l = i.y, c = n.y, u = r < a ? r < s ? r : s : a < s ? a : s, h = o < l ? o < c ? o : c : l < c ? l : c, d = r > a ? r > s ? r : s : a > s ? a : s, p = o > l ? o > c ? o : c : l > c ? l : c;
            let f = n.next;
            for(; f !== e;){
                if (f.x >= u && f.x <= d && f.y >= h && f.y <= p && ZA(r, o, a, l, s, c, f.x, f.y) && KA(f.prev, f, f.next) >= 0) return !1;
                f = f.next;
            }
            return !0;
        }
        function FA(t1, e, i, n) {
            const r = t1.prev, a = t1, s = t1.next;
            if (KA(r, a, s) >= 0) return !1;
            const o = r.x, l = a.x, c = s.x, u = r.y, h = a.y, d = s.y, p = o < l ? o < c ? o : c : l < c ? l : c, f = u < h ? u < d ? u : d : h < d ? h : d, A = o > l ? o > c ? o : c : l > c ? l : c, g = u > h ? u > d ? u : d : h > d ? h : d, m = WA(p, f, e, i, n), M = WA(A, g, e, i, n);
            let y = t1.prevZ, v = t1.nextZ;
            for(; y && y.z >= m && v && v.z <= M;){
                if (y.x >= p && y.x <= A && y.y >= f && y.y <= g && y !== r && y !== s && ZA(o, u, l, h, c, d, y.x, y.y) && KA(y.prev, y, y.next) >= 0) return !1;
                if (y = y.prevZ, v.x >= p && v.x <= A && v.y >= f && v.y <= g && v !== r && v !== s && ZA(o, u, l, h, c, d, v.x, v.y) && KA(v.prev, v, v.next) >= 0) return !1;
                v = v.nextZ;
            }
            for(; y && y.z >= m;){
                if (y.x >= p && y.x <= A && y.y >= f && y.y <= g && y !== r && y !== s && ZA(o, u, l, h, c, d, y.x, y.y) && KA(y.prev, y, y.next) >= 0) return !1;
                y = y.prevZ;
            }
            for(; v && v.z <= M;){
                if (v.x >= p && v.x <= A && v.y >= f && v.y <= g && v !== r && v !== s && ZA(o, u, l, h, c, d, v.x, v.y) && KA(v.prev, v, v.next) >= 0) return !1;
                v = v.nextZ;
            }
            return !0;
        }
        function QA(t1, e, i) {
            let n = t1;
            do {
                const r = n.prev, a = n.next.next;
                !qA(r, a) && $A(r, n, n.next, a) && ig(r, a) && ig(a, r) && (e.push(r.i / i | 0), e.push(n.i / i | 0), e.push(a.i / i | 0), ag(n), ag(n.next), n = t1 = a), n = n.next;
            }while (n !== t1);
            return UA(n);
        }
        function HA(t1, e, i, n, r, a) {
            let s = t1;
            do {
                let t1 = s.next.next;
                for(; t1 !== s.prev;){
                    if (s.i !== t1.i && JA(s, t1)) {
                        let o = ng(s, t1);
                        return s = UA(s, s.next), o = UA(o, o.next), kA(s, e, i, n, r, a, 0), void kA(o, e, i, n, r, a, 0);
                    }
                    t1 = t1.next;
                }
                s = s.next;
            }while (s !== t1);
        }
        function VA(t1, e) {
            return t1.x - e.x;
        }
        function GA(t1, e) {
            const i = function(t1, e) {
                let i, n = e, r = -1 / 0;
                const a = t1.x, s = t1.y;
                do {
                    if (s <= n.y && s >= n.next.y && n.next.y !== n.y) {
                        const t1 = n.x + (s - n.y) * (n.next.x - n.x) / (n.next.y - n.y);
                        if (t1 <= a && t1 > r && (r = t1, i = n.x < n.next.x ? n : n.next, t1 === a)) return i;
                    }
                    n = n.next;
                }while (n !== e);
                if (!i) return null;
                const o = i, l = i.x, c = i.y;
                let u, h = 1 / 0;
                n = i;
                do a >= n.x && n.x >= l && a !== n.x && ZA(s < c ? a : r, s, l, c, s < c ? r : a, s, n.x, n.y) && (u = Math.abs(s - n.y) / (a - n.x), ig(n, t1) && (u < h || u === h && (n.x > i.x || n.x === i.x && YA(i, n))) && (i = n, h = u)), n = n.next;
                while (n !== o);
                return i;
            }(t1, e);
            if (!i) return e;
            const n = ng(i, t1);
            return UA(n, n.next), UA(i, i.next);
        }
        function YA(t1, e) {
            return KA(t1.prev, t1, e.prev) < 0 && KA(e.next, t1, t1.next) < 0;
        }
        function WA(t1, e, i, n, r) {
            return (t1 = 1431655765 & ((t1 = 858993459 & ((t1 = 252645135 & ((t1 = 16711935 & ((t1 = (t1 - i) * r | 0) | t1 << 8)) | t1 << 4)) | t1 << 2)) | t1 << 1)) | (e = 1431655765 & ((e = 858993459 & ((e = 252645135 & ((e = 16711935 & ((e = (e - n) * r | 0) | e << 8)) | e << 4)) | e << 2)) | e << 1)) << 1;
        }
        function XA(t1) {
            let e = t1, i = t1;
            do (e.x < i.x || e.x === i.x && e.y < i.y) && (i = e), e = e.next;
            while (e !== t1);
            return i;
        }
        function ZA(t1, e, i, n, r, a, s, o) {
            return (r - s) * (e - o) >= (t1 - s) * (a - o) && (t1 - s) * (n - o) >= (i - s) * (e - o) && (i - s) * (a - o) >= (r - s) * (n - o);
        }
        function JA(t1, e) {
            return t1.next.i !== e.i && t1.prev.i !== e.i && !function(t1, e) {
                let i = t1;
                do {
                    if (i.i !== t1.i && i.next.i !== t1.i && i.i !== e.i && i.next.i !== e.i && $A(i, i.next, t1, e)) return !0;
                    i = i.next;
                }while (i !== t1);
                return !1;
            }(t1, e) && (ig(t1, e) && ig(e, t1) && function(t1, e) {
                let i = t1, n = !1;
                const r = (t1.x + e.x) / 2, a = (t1.y + e.y) / 2;
                do i.y > a != i.next.y > a && i.next.y !== i.y && r < (i.next.x - i.x) * (a - i.y) / (i.next.y - i.y) + i.x && (n = !n), i = i.next;
                while (i !== t1);
                return n;
            }(t1, e) && (KA(t1.prev, t1, e.prev) || KA(t1, e.prev, e)) || qA(t1, e) && KA(t1.prev, t1, t1.next) > 0 && KA(e.prev, e, e.next) > 0);
        }
        function KA(t1, e, i) {
            return (e.y - t1.y) * (i.x - e.x) - (e.x - t1.x) * (i.y - e.y);
        }
        function qA(t1, e) {
            return t1.x === e.x && t1.y === e.y;
        }
        function $A(t1, e, i, n) {
            const r = eg(KA(t1, e, i)), a = eg(KA(t1, e, n)), s = eg(KA(i, n, t1)), o = eg(KA(i, n, e));
            return r !== a && s !== o || !(0 !== r || !tg(t1, i, e)) || !(0 !== a || !tg(t1, n, e)) || !(0 !== s || !tg(i, t1, n)) || !(0 !== o || !tg(i, e, n));
        }
        function tg(t1, e, i) {
            return e.x <= Math.max(t1.x, i.x) && e.x >= Math.min(t1.x, i.x) && e.y <= Math.max(t1.y, i.y) && e.y >= Math.min(t1.y, i.y);
        }
        function eg(t1) {
            return t1 > 0 ? 1 : t1 < 0 ? -1 : 0;
        }
        function ig(t1, e) {
            return KA(t1.prev, t1, t1.next) < 0 ? KA(t1, e, t1.next) >= 0 && KA(t1, t1.prev, e) >= 0 : KA(t1, e, t1.prev) < 0 || KA(t1, t1.next, e) < 0;
        }
        function ng(t1, e) {
            const i = new sg(t1.i, t1.x, t1.y), n = new sg(e.i, e.x, e.y), r = t1.next, a = e.prev;
            return t1.next = e, e.prev = t1, i.next = r, r.prev = i, n.next = i, i.prev = n, a.next = n, n.prev = a, n;
        }
        function rg(t1, e, i, n) {
            const r = new sg(t1, e, i);
            return n ? (r.next = n.next, r.prev = n, n.next.prev = r, n.next = r) : (r.prev = r, r.next = r), r;
        }
        function ag(t1) {
            t1.next.prev = t1.prev, t1.prev.next = t1.next, t1.prevZ && (t1.prevZ.nextZ = t1.nextZ), t1.nextZ && (t1.nextZ.prevZ = t1.prevZ);
        }
        function sg(t1, e, i) {
            this.i = t1, this.x = e, this.y = i, this.prev = null, this.next = null, this.z = 0, this.prevZ = null, this.nextZ = null, this.steiner = !1;
        }
        class og {
            static area(t1) {
                const e = t1.length;
                let i = 0;
                for(let n = e - 1, r = 0; r < e; n = r++)i += t1[n].x * t1[r].y - t1[r].x * t1[n].y;
                return .5 * i;
            }
            static isClockWise(t1) {
                return og.area(t1) < 0;
            }
            static triangulateShape(t1, e) {
                const i = [], n = [], r = [];
                lg(t1), cg(i, t1);
                let a = t1.length;
                e.forEach(lg);
                for(let t1 = 0; t1 < e.length; t1++)n.push(a), a += e[t1].length, cg(i, e[t1]);
                const s = function(t1, e, i = 2) {
                    const n = e && e.length, r = n ? e[0] * i : t1.length;
                    let a = RA(t1, 0, r, i, !0);
                    const s = [];
                    if (!a || a.next === a.prev) return s;
                    let o, l, c, u, h, d, p;
                    if (n && (a = function(t1, e, i, n) {
                        const r = [];
                        let a, s, o, l, c;
                        for(a = 0, s = e.length; a < s; a++)o = e[a] * n, l = a < s - 1 ? e[a + 1] * n : t1.length, c = RA(t1, o, l, n, !1), c === c.next && (c.steiner = !0), r.push(XA(c));
                        for(r.sort(VA), a = 0; a < r.length; a++)i = GA(r[a], i);
                        return i;
                    }(t1, e, a, i)), t1.length > 80 * i) {
                        o = c = t1[0], l = u = t1[1];
                        for(let e = i; e < r; e += i)h = t1[e], d = t1[e + 1], h < o && (o = h), d < l && (l = d), h > c && (c = h), d > u && (u = d);
                        p = Math.max(c - o, u - l), p = 0 !== p ? 32767 / p : 0;
                    }
                    return kA(a, s, i, o, l, p, 0), s;
                }(i, n);
                for(let t1 = 0; t1 < s.length; t1 += 3)r.push(s.slice(t1, t1 + 3));
                return r;
            }
        }
        function lg(t1) {
            const e = t1.length;
            e > 2 && t1[e - 1].equals(t1[0]) && t1.pop();
        }
        function cg(t1, e) {
            for(let i = 0; i < e.length; i++)t1.push(e[i].x), t1.push(e[i].y);
        }
        class ug extends Au {
            constructor(t1 = new PA([
                new Qo(.5, .5),
                new Qo(-0.5, .5),
                new Qo(-0.5, -0.5),
                new Qo(.5, -0.5)
            ]), e = {}){
                super(), this.type = "ExtrudeGeometry", this.parameters = {
                    shapes: t1,
                    options: e
                }, t1 = Array.isArray(t1) ? t1 : [
                    t1
                ];
                const i = this, n = [], r = [];
                for(let e = 0, i = t1.length; e < i; e++)a(t1[e]);
                function a(t1) {
                    const a = [], s = void 0 !== e.curveSegments ? e.curveSegments : 12, o = void 0 !== e.steps ? e.steps : 1, l = void 0 !== e.depth ? e.depth : 1;
                    let c = void 0 === e.bevelEnabled || e.bevelEnabled, u = void 0 !== e.bevelThickness ? e.bevelThickness : .2, h = void 0 !== e.bevelSize ? e.bevelSize : u - .1, d = void 0 !== e.bevelOffset ? e.bevelOffset : 0, p = void 0 !== e.bevelSegments ? e.bevelSegments : 3;
                    const f = e.extrudePath, A = void 0 !== e.UVGenerator ? e.UVGenerator : hg;
                    let g, m, M, y, v, x = !1;
                    f && (g = f.getSpacedPoints(o), x = !0, c = !1, m = f.computeFrenetFrames(o, !1), M = new xl, y = new xl, v = new xl), c || (p = 0, u = 0, h = 0, d = 0);
                    const w = t1.extractPoints(s);
                    let b = w.shape;
                    const T = w.holes;
                    if (!og.isClockWise(b)) {
                        b = b.reverse();
                        for(let t1 = 0, e = T.length; t1 < e; t1++){
                            const e = T[t1];
                            og.isClockWise(e) && (T[t1] = e.reverse());
                        }
                    }
                    const E = og.triangulateShape(b, T), I = b;
                    for(let t1 = 0, e = T.length; t1 < e; t1++){
                        const e = T[t1];
                        b = b.concat(e);
                    }
                    function S(t1, e, i) {
                        return e || console.error("THREE.ExtrudeGeometry: vec does not exist"), t1.clone().addScaledVector(e, i);
                    }
                    const N = b.length, D = E.length;
                    function C(t1, e, i) {
                        let n, r, a;
                        const s = t1.x - e.x, o = t1.y - e.y, l = i.x - t1.x, c = i.y - t1.y, u = s * s + o * o, h = s * c - o * l;
                        if (Math.abs(h) > Number.EPSILON) {
                            const h = Math.sqrt(u), d = Math.sqrt(l * l + c * c), p = e.x - o / h, f = e.y + s / h, A = ((i.x - c / d - p) * c - (i.y + l / d - f) * l) / (s * c - o * l);
                            n = p + s * A - t1.x, r = f + o * A - t1.y;
                            const g = n * n + r * r;
                            if (g <= 2) return new Qo(n, r);
                            a = Math.sqrt(g / 2);
                        } else {
                            let t1 = !1;
                            s > Number.EPSILON ? l > Number.EPSILON && (t1 = !0) : s < -Number.EPSILON ? l < -Number.EPSILON && (t1 = !0) : Math.sign(o) === Math.sign(c) && (t1 = !0), t1 ? (n = -o, r = s, a = Math.sqrt(u)) : (n = s, r = o, a = Math.sqrt(u / 2));
                        }
                        return new Qo(n / a, r / a);
                    }
                    const z = [];
                    for(let t1 = 0, e = I.length, i = e - 1, n = t1 + 1; t1 < e; t1++, i++, n++)i === e && (i = 0), n === e && (n = 0), z[t1] = C(I[t1], I[i], I[n]);
                    const L = [];
                    let O, _ = z.concat();
                    for(let t1 = 0, e = T.length; t1 < e; t1++){
                        const e = T[t1];
                        O = [];
                        for(let t1 = 0, i = e.length, n = i - 1, r = t1 + 1; t1 < i; t1++, n++, r++)n === i && (n = 0), r === i && (r = 0), O[t1] = C(e[t1], e[n], e[r]);
                        L.push(O), _ = _.concat(O);
                    }
                    for(let t1 = 0; t1 < p; t1++){
                        const e = t1 / p, i = u * Math.cos(e * Math.PI / 2), n = h * Math.sin(e * Math.PI / 2) + d;
                        for(let t1 = 0, e = I.length; t1 < e; t1++){
                            const e = S(I[t1], z[t1], n);
                            R(e.x, e.y, -i);
                        }
                        for(let t1 = 0, e = T.length; t1 < e; t1++){
                            const e = T[t1];
                            O = L[t1];
                            for(let t1 = 0, r = e.length; t1 < r; t1++){
                                const r = S(e[t1], O[t1], n);
                                R(r.x, r.y, -i);
                            }
                        }
                    }
                    const j = h + d;
                    for(let t1 = 0; t1 < N; t1++){
                        const e = c ? S(b[t1], _[t1], j) : b[t1];
                        x ? (y.copy(m.normals[0]).multiplyScalar(e.x), M.copy(m.binormals[0]).multiplyScalar(e.y), v.copy(g[0]).add(y).add(M), R(v.x, v.y, v.z)) : R(e.x, e.y, 0);
                    }
                    for(let t1 = 1; t1 <= o; t1++)for(let e = 0; e < N; e++){
                        const i = c ? S(b[e], _[e], j) : b[e];
                        x ? (y.copy(m.normals[t1]).multiplyScalar(i.x), M.copy(m.binormals[t1]).multiplyScalar(i.y), v.copy(g[t1]).add(y).add(M), R(v.x, v.y, v.z)) : R(i.x, i.y, l / o * t1);
                    }
                    for(let t1 = p - 1; t1 >= 0; t1--){
                        const e = t1 / p, i = u * Math.cos(e * Math.PI / 2), n = h * Math.sin(e * Math.PI / 2) + d;
                        for(let t1 = 0, e = I.length; t1 < e; t1++){
                            const e = S(I[t1], z[t1], n);
                            R(e.x, e.y, l + i);
                        }
                        for(let t1 = 0, e = T.length; t1 < e; t1++){
                            const e = T[t1];
                            O = L[t1];
                            for(let t1 = 0, r = e.length; t1 < r; t1++){
                                const r = S(e[t1], O[t1], n);
                                x ? R(r.x, r.y + g[o - 1].y, g[o - 1].x + i) : R(r.x, r.y, l + i);
                            }
                        }
                    }
                    function P(t1, e) {
                        let i = t1.length;
                        for(; --i >= 0;){
                            const n = i;
                            let r = i - 1;
                            r < 0 && (r = t1.length - 1);
                            for(let t1 = 0, i = o + 2 * p; t1 < i; t1++){
                                const i = N * t1, a = N * (t1 + 1);
                                k(e + n + i, e + r + i, e + r + a, e + n + a);
                            }
                        }
                    }
                    function R(t1, e, i) {
                        a.push(t1), a.push(e), a.push(i);
                    }
                    function U(t1, e, r) {
                        B(t1), B(e), B(r);
                        const a = n.length / 3, s = A.generateTopUV(i, n, a - 3, a - 2, a - 1);
                        F(s[0]), F(s[1]), F(s[2]);
                    }
                    function k(t1, e, r, a) {
                        B(t1), B(e), B(a), B(e), B(r), B(a);
                        const s = n.length / 3, o = A.generateSideWallUV(i, n, s - 6, s - 3, s - 2, s - 1);
                        F(o[0]), F(o[1]), F(o[3]), F(o[1]), F(o[2]), F(o[3]);
                    }
                    function B(t1) {
                        n.push(a[3 * t1 + 0]), n.push(a[3 * t1 + 1]), n.push(a[3 * t1 + 2]);
                    }
                    function F(t1) {
                        r.push(t1.x), r.push(t1.y);
                    }
                    !function() {
                        const t1 = n.length / 3;
                        if (c) {
                            let t1 = 0, e = N * t1;
                            for(let t1 = 0; t1 < D; t1++){
                                const i = E[t1];
                                U(i[2] + e, i[1] + e, i[0] + e);
                            }
                            t1 = o + 2 * p, e = N * t1;
                            for(let t1 = 0; t1 < D; t1++){
                                const i = E[t1];
                                U(i[0] + e, i[1] + e, i[2] + e);
                            }
                        } else {
                            for(let t1 = 0; t1 < D; t1++){
                                const e = E[t1];
                                U(e[2], e[1], e[0]);
                            }
                            for(let t1 = 0; t1 < D; t1++){
                                const e = E[t1];
                                U(e[0] + N * o, e[1] + N * o, e[2] + N * o);
                            }
                        }
                        i.addGroup(t1, n.length / 3 - t1, 0);
                    }(), function() {
                        const t1 = n.length / 3;
                        let e = 0;
                        P(I, e), e += I.length;
                        for(let t1 = 0, i = T.length; t1 < i; t1++){
                            const i = T[t1];
                            P(i, e), e += i.length;
                        }
                        i.addGroup(t1, n.length / 3 - t1, 1);
                    }();
                }
                this.setAttribute("position", new su(n, 3)), this.setAttribute("uv", new su(r, 2)), this.computeVertexNormals();
            }
            copy(t1) {
                return super.copy(t1), this.parameters = Object.assign({}, t1.parameters), this;
            }
            toJSON() {
                const t1 = super.toJSON();
                return function(t1, e, i) {
                    if (i.shapes = [], Array.isArray(t1)) for(let e = 0, n = t1.length; e < n; e++){
                        const n = t1[e];
                        i.shapes.push(n.uuid);
                    }
                    else i.shapes.push(t1.uuid);
                    return i.options = Object.assign({}, e), void 0 !== e.extrudePath && (i.options.extrudePath = e.extrudePath.toJSON()), i;
                }(this.parameters.shapes, this.parameters.options, t1);
            }
            static fromJSON(t1, e) {
                const i = [];
                for(let n = 0, r = t1.shapes.length; n < r; n++){
                    const r = e[t1.shapes[n]];
                    i.push(r);
                }
                const n = t1.options.extrudePath;
                return void 0 !== n && (t1.options.extrudePath = (new xA[n.type]).fromJSON(n)), new ug(i, t1.options);
            }
        }
        const hg = {
            generateTopUV: function(t1, e, i, n, r) {
                const a = e[3 * i], s = e[3 * i + 1], o = e[3 * n], l = e[3 * n + 1], c = e[3 * r], u = e[3 * r + 1];
                return [
                    new Qo(a, s),
                    new Qo(o, l),
                    new Qo(c, u)
                ];
            },
            generateSideWallUV: function(t1, e, i, n, r, a) {
                const s = e[3 * i], o = e[3 * i + 1], l = e[3 * i + 2], c = e[3 * n], u = e[3 * n + 1], h = e[3 * n + 2], d = e[3 * r], p = e[3 * r + 1], f = e[3 * r + 2], A = e[3 * a], g = e[3 * a + 1], m = e[3 * a + 2];
                return Math.abs(o - u) < Math.abs(s - c) ? [
                    new Qo(s, 1 - l),
                    new Qo(c, 1 - h),
                    new Qo(d, 1 - f),
                    new Qo(A, 1 - m)
                ] : [
                    new Qo(o, 1 - l),
                    new Qo(u, 1 - h),
                    new Qo(p, 1 - f),
                    new Qo(g, 1 - m)
                ];
            }
        };
        class dg extends DA {
            constructor(t1 = 1, e = 0){
                const i = (1 + Math.sqrt(5)) / 2;
                super([
                    -1,
                    i,
                    0,
                    1,
                    i,
                    0,
                    -1,
                    -i,
                    0,
                    1,
                    -i,
                    0,
                    0,
                    -1,
                    i,
                    0,
                    1,
                    i,
                    0,
                    -1,
                    -i,
                    0,
                    1,
                    -i,
                    i,
                    0,
                    -1,
                    i,
                    0,
                    1,
                    -i,
                    0,
                    -1,
                    -i,
                    0,
                    1
                ], [
                    0,
                    11,
                    5,
                    0,
                    5,
                    1,
                    0,
                    1,
                    7,
                    0,
                    7,
                    10,
                    0,
                    10,
                    11,
                    1,
                    5,
                    9,
                    5,
                    11,
                    4,
                    11,
                    10,
                    2,
                    10,
                    7,
                    6,
                    7,
                    1,
                    8,
                    3,
                    9,
                    4,
                    3,
                    4,
                    2,
                    3,
                    2,
                    6,
                    3,
                    6,
                    8,
                    3,
                    8,
                    9,
                    4,
                    9,
                    5,
                    2,
                    4,
                    11,
                    6,
                    2,
                    10,
                    8,
                    6,
                    7,
                    9,
                    8,
                    1
                ], t1, e), this.type = "IcosahedronGeometry", this.parameters = {
                    radius: t1,
                    detail: e
                };
            }
            static fromJSON(t1) {
                return new dg(t1.radius, t1.detail);
            }
        }
        class pg extends DA {
            constructor(t1 = 1, e = 0){
                super([
                    1,
                    0,
                    0,
                    -1,
                    0,
                    0,
                    0,
                    1,
                    0,
                    0,
                    -1,
                    0,
                    0,
                    0,
                    1,
                    0,
                    0,
                    -1
                ], [
                    0,
                    2,
                    4,
                    0,
                    4,
                    3,
                    0,
                    3,
                    5,
                    0,
                    5,
                    2,
                    1,
                    2,
                    5,
                    1,
                    5,
                    3,
                    1,
                    3,
                    4,
                    1,
                    4,
                    2
                ], t1, e), this.type = "OctahedronGeometry", this.parameters = {
                    radius: t1,
                    detail: e
                };
            }
            static fromJSON(t1) {
                return new pg(t1.radius, t1.detail);
            }
        }
        class fg extends Au {
            constructor(t1 = .5, e = 1, i = 32, n = 1, r = 0, a = 2 * Math.PI){
                super(), this.type = "RingGeometry", this.parameters = {
                    innerRadius: t1,
                    outerRadius: e,
                    thetaSegments: i,
                    phiSegments: n,
                    thetaStart: r,
                    thetaLength: a
                }, i = Math.max(3, i);
                const s = [], o = [], l = [], c = [];
                let u = t1;
                const h = (e - t1) / (n = Math.max(1, n)), d = new xl, p = new Qo;
                for(let t1 = 0; t1 <= n; t1++){
                    for(let t1 = 0; t1 <= i; t1++){
                        const n = r + t1 / i * a;
                        d.x = u * Math.cos(n), d.y = u * Math.sin(n), o.push(d.x, d.y, d.z), l.push(0, 0, 1), p.x = (d.x / e + 1) / 2, p.y = (d.y / e + 1) / 2, c.push(p.x, p.y);
                    }
                    u += h;
                }
                for(let t1 = 0; t1 < n; t1++){
                    const e = t1 * (i + 1);
                    for(let t1 = 0; t1 < i; t1++){
                        const n = t1 + e, r = n, a = n + i + 1, o = n + i + 2, l = n + 1;
                        s.push(r, a, l), s.push(a, o, l);
                    }
                }
                this.setIndex(s), this.setAttribute("position", new su(o, 3)), this.setAttribute("normal", new su(l, 3)), this.setAttribute("uv", new su(c, 2));
            }
            copy(t1) {
                return super.copy(t1), this.parameters = Object.assign({}, t1.parameters), this;
            }
            static fromJSON(t1) {
                return new fg(t1.innerRadius, t1.outerRadius, t1.thetaSegments, t1.phiSegments, t1.thetaStart, t1.thetaLength);
            }
        }
        class Ag extends Au {
            constructor(t1 = new PA([
                new Qo(0, .5),
                new Qo(-0.5, -0.5),
                new Qo(.5, -0.5)
            ]), e = 12){
                super(), this.type = "ShapeGeometry", this.parameters = {
                    shapes: t1,
                    curveSegments: e
                };
                const i = [], n = [], r = [], a = [];
                let s = 0, o = 0;
                if (!1 === Array.isArray(t1)) l(t1);
                else for(let e = 0; e < t1.length; e++)l(t1[e]), this.addGroup(s, o, e), s += o, o = 0;
                function l(t1) {
                    const s = n.length / 3, l = t1.extractPoints(e);
                    let c = l.shape;
                    const u = l.holes;
                    !1 === og.isClockWise(c) && (c = c.reverse());
                    for(let t1 = 0, e = u.length; t1 < e; t1++){
                        const e = u[t1];
                        !0 === og.isClockWise(e) && (u[t1] = e.reverse());
                    }
                    const h = og.triangulateShape(c, u);
                    for(let t1 = 0, e = u.length; t1 < e; t1++){
                        const e = u[t1];
                        c = c.concat(e);
                    }
                    for(let t1 = 0, e = c.length; t1 < e; t1++){
                        const e = c[t1];
                        n.push(e.x, e.y, 0), r.push(0, 0, 1), a.push(e.x, e.y);
                    }
                    for(let t1 = 0, e = h.length; t1 < e; t1++){
                        const e = h[t1], n = e[0] + s, r = e[1] + s, a = e[2] + s;
                        i.push(n, r, a), o += 3;
                    }
                }
                this.setIndex(i), this.setAttribute("position", new su(n, 3)), this.setAttribute("normal", new su(r, 3)), this.setAttribute("uv", new su(a, 2));
            }
            copy(t1) {
                return super.copy(t1), this.parameters = Object.assign({}, t1.parameters), this;
            }
            toJSON() {
                const t1 = super.toJSON();
                return function(t1, e) {
                    if (e.shapes = [], Array.isArray(t1)) for(let i = 0, n = t1.length; i < n; i++){
                        const n = t1[i];
                        e.shapes.push(n.uuid);
                    }
                    else e.shapes.push(t1.uuid);
                    return e;
                }(this.parameters.shapes, t1);
            }
            static fromJSON(t1, e) {
                const i = [];
                for(let n = 0, r = t1.shapes.length; n < r; n++){
                    const r = e[t1.shapes[n]];
                    i.push(r);
                }
                return new Ag(i, t1.curveSegments);
            }
        }
        class gg extends Au {
            constructor(t1 = 1, e = 32, i = 16, n = 0, r = 2 * Math.PI, a = 0, s = Math.PI){
                super(), this.type = "SphereGeometry", this.parameters = {
                    radius: t1,
                    widthSegments: e,
                    heightSegments: i,
                    phiStart: n,
                    phiLength: r,
                    thetaStart: a,
                    thetaLength: s
                }, e = Math.max(3, Math.floor(e)), i = Math.max(2, Math.floor(i));
                const o = Math.min(a + s, Math.PI);
                let l = 0;
                const c = [], u = new xl, h = new xl, d = [], p = [], f = [], A = [];
                for(let d = 0; d <= i; d++){
                    const g = [], m = d / i;
                    let M = 0;
                    0 === d && 0 === a ? M = .5 / e : d === i && o === Math.PI && (M = -0.5 / e);
                    for(let i = 0; i <= e; i++){
                        const o = i / e;
                        u.x = -t1 * Math.cos(n + o * r) * Math.sin(a + m * s), u.y = t1 * Math.cos(a + m * s), u.z = t1 * Math.sin(n + o * r) * Math.sin(a + m * s), p.push(u.x, u.y, u.z), h.copy(u).normalize(), f.push(h.x, h.y, h.z), A.push(o + M, 1 - m), g.push(l++);
                    }
                    c.push(g);
                }
                for(let t1 = 0; t1 < i; t1++)for(let n = 0; n < e; n++){
                    const e = c[t1][n + 1], r = c[t1][n], s = c[t1 + 1][n], l = c[t1 + 1][n + 1];
                    (0 !== t1 || a > 0) && d.push(e, r, l), (t1 !== i - 1 || o < Math.PI) && d.push(r, s, l);
                }
                this.setIndex(d), this.setAttribute("position", new su(p, 3)), this.setAttribute("normal", new su(f, 3)), this.setAttribute("uv", new su(A, 2));
            }
            copy(t1) {
                return super.copy(t1), this.parameters = Object.assign({}, t1.parameters), this;
            }
            static fromJSON(t1) {
                return new gg(t1.radius, t1.widthSegments, t1.heightSegments, t1.phiStart, t1.phiLength, t1.thetaStart, t1.thetaLength);
            }
        }
        class mg extends DA {
            constructor(t1 = 1, e = 0){
                super([
                    1,
                    1,
                    1,
                    -1,
                    -1,
                    1,
                    -1,
                    1,
                    -1,
                    1,
                    -1,
                    -1
                ], [
                    2,
                    1,
                    0,
                    0,
                    3,
                    2,
                    1,
                    3,
                    0,
                    2,
                    3,
                    1
                ], t1, e), this.type = "TetrahedronGeometry", this.parameters = {
                    radius: t1,
                    detail: e
                };
            }
            static fromJSON(t1) {
                return new mg(t1.radius, t1.detail);
            }
        }
        class Mg extends Au {
            constructor(t1 = 1, e = .4, i = 12, n = 48, r = 2 * Math.PI){
                super(), this.type = "TorusGeometry", this.parameters = {
                    radius: t1,
                    tube: e,
                    radialSegments: i,
                    tubularSegments: n,
                    arc: r
                }, i = Math.floor(i), n = Math.floor(n);
                const a = [], s = [], o = [], l = [], c = new xl, u = new xl, h = new xl;
                for(let a = 0; a <= i; a++)for(let d = 0; d <= n; d++){
                    const p = d / n * r, f = a / i * Math.PI * 2;
                    u.x = (t1 + e * Math.cos(f)) * Math.cos(p), u.y = (t1 + e * Math.cos(f)) * Math.sin(p), u.z = e * Math.sin(f), s.push(u.x, u.y, u.z), c.x = t1 * Math.cos(p), c.y = t1 * Math.sin(p), h.subVectors(u, c).normalize(), o.push(h.x, h.y, h.z), l.push(d / n), l.push(a / i);
                }
                for(let t1 = 1; t1 <= i; t1++)for(let e = 1; e <= n; e++){
                    const i = (n + 1) * t1 + e - 1, r = (n + 1) * (t1 - 1) + e - 1, s = (n + 1) * (t1 - 1) + e, o = (n + 1) * t1 + e;
                    a.push(i, r, o), a.push(r, s, o);
                }
                this.setIndex(a), this.setAttribute("position", new su(s, 3)), this.setAttribute("normal", new su(o, 3)), this.setAttribute("uv", new su(l, 2));
            }
            copy(t1) {
                return super.copy(t1), this.parameters = Object.assign({}, t1.parameters), this;
            }
            static fromJSON(t1) {
                return new Mg(t1.radius, t1.tube, t1.radialSegments, t1.tubularSegments, t1.arc);
            }
        }
        class yg extends Au {
            constructor(t1 = 1, e = .4, i = 64, n = 8, r = 2, a = 3){
                super(), this.type = "TorusKnotGeometry", this.parameters = {
                    radius: t1,
                    tube: e,
                    tubularSegments: i,
                    radialSegments: n,
                    p: r,
                    q: a
                }, i = Math.floor(i), n = Math.floor(n);
                const s = [], o = [], l = [], c = [], u = new xl, h = new xl, d = new xl, p = new xl, f = new xl, A = new xl, g = new xl;
                for(let s = 0; s <= i; ++s){
                    const M = s / i * r * Math.PI * 2;
                    m(M, r, a, t1, d), m(M + .01, r, a, t1, p), A.subVectors(p, d), g.addVectors(p, d), f.crossVectors(A, g), g.crossVectors(f, A), f.normalize(), g.normalize();
                    for(let t1 = 0; t1 <= n; ++t1){
                        const r = t1 / n * Math.PI * 2, a = -e * Math.cos(r), p = e * Math.sin(r);
                        u.x = d.x + (a * g.x + p * f.x), u.y = d.y + (a * g.y + p * f.y), u.z = d.z + (a * g.z + p * f.z), o.push(u.x, u.y, u.z), h.subVectors(u, d).normalize(), l.push(h.x, h.y, h.z), c.push(s / i), c.push(t1 / n);
                    }
                }
                for(let t1 = 1; t1 <= i; t1++)for(let e = 1; e <= n; e++){
                    const i = (n + 1) * (t1 - 1) + (e - 1), r = (n + 1) * t1 + (e - 1), a = (n + 1) * t1 + e, o = (n + 1) * (t1 - 1) + e;
                    s.push(i, r, o), s.push(r, a, o);
                }
                function m(t1, e, i, n, r) {
                    const a = Math.cos(t1), s = Math.sin(t1), o = i / e * t1, l = Math.cos(o);
                    r.x = n * (2 + l) * .5 * a, r.y = n * (2 + l) * s * .5, r.z = n * Math.sin(o) * .5;
                }
                this.setIndex(s), this.setAttribute("position", new su(o, 3)), this.setAttribute("normal", new su(l, 3)), this.setAttribute("uv", new su(c, 2));
            }
            copy(t1) {
                return super.copy(t1), this.parameters = Object.assign({}, t1.parameters), this;
            }
            static fromJSON(t1) {
                return new yg(t1.radius, t1.tube, t1.tubularSegments, t1.radialSegments, t1.p, t1.q);
            }
        }
        class vg extends Au {
            constructor(t1 = new yA(new xl(-1, -1, 0), new xl(-1, 1, 0), new xl(1, 1, 0)), e = 64, i = 1, n = 8, r = !1){
                super(), this.type = "TubeGeometry", this.parameters = {
                    path: t1,
                    tubularSegments: e,
                    radius: i,
                    radialSegments: n,
                    closed: r
                };
                const a = t1.computeFrenetFrames(e, r);
                this.tangents = a.tangents, this.normals = a.normals, this.binormals = a.binormals;
                const s = new xl, o = new xl, l = new Qo;
                let c = new xl;
                const u = [], h = [], d = [], p = [];
                function f(r) {
                    c = t1.getPointAt(r / e, c);
                    const l = a.normals[r], d = a.binormals[r];
                    for(let t1 = 0; t1 <= n; t1++){
                        const e = t1 / n * Math.PI * 2, r = Math.sin(e), a = -Math.cos(e);
                        o.x = a * l.x + r * d.x, o.y = a * l.y + r * d.y, o.z = a * l.z + r * d.z, o.normalize(), h.push(o.x, o.y, o.z), s.x = c.x + i * o.x, s.y = c.y + i * o.y, s.z = c.z + i * o.z, u.push(s.x, s.y, s.z);
                    }
                }
                !function() {
                    for(let t1 = 0; t1 < e; t1++)f(t1);
                    f(!1 === r ? e : 0), function() {
                        for(let t1 = 0; t1 <= e; t1++)for(let i = 0; i <= n; i++)l.x = t1 / e, l.y = i / n, d.push(l.x, l.y);
                    }(), function() {
                        for(let t1 = 1; t1 <= e; t1++)for(let e = 1; e <= n; e++){
                            const i = (n + 1) * (t1 - 1) + (e - 1), r = (n + 1) * t1 + (e - 1), a = (n + 1) * t1 + e, s = (n + 1) * (t1 - 1) + e;
                            p.push(i, r, s), p.push(r, a, s);
                        }
                    }();
                }(), this.setIndex(p), this.setAttribute("position", new su(u, 3)), this.setAttribute("normal", new su(h, 3)), this.setAttribute("uv", new su(d, 2));
            }
            copy(t1) {
                return super.copy(t1), this.parameters = Object.assign({}, t1.parameters), this;
            }
            toJSON() {
                const t1 = super.toJSON();
                return t1.path = this.parameters.path.toJSON(), t1;
            }
            static fromJSON(t1) {
                return new vg((new xA[t1.path.type]).fromJSON(t1.path), t1.tubularSegments, t1.radius, t1.radialSegments, t1.closed);
            }
        }
        class xg extends Au {
            constructor(t1 = null){
                if (super(), this.type = "WireframeGeometry", this.parameters = {
                    geometry: t1
                }, null !== t1) {
                    const e = [], i = new Set, n = new xl, r = new xl;
                    if (null !== t1.index) {
                        const a = t1.attributes.position, s = t1.index;
                        let o = t1.groups;
                        0 === o.length && (o = [
                            {
                                start: 0,
                                count: s.count,
                                materialIndex: 0
                            }
                        ]);
                        for(let t1 = 0, l = o.length; t1 < l; ++t1){
                            const l = o[t1], c = l.start;
                            for(let t1 = c, o = c + l.count; t1 < o; t1 += 3)for(let o = 0; o < 3; o++){
                                const l = s.getX(t1 + o), c = s.getX(t1 + (o + 1) % 3);
                                n.fromBufferAttribute(a, l), r.fromBufferAttribute(a, c), !0 === wg(n, r, i) && (e.push(n.x, n.y, n.z), e.push(r.x, r.y, r.z));
                            }
                        }
                    } else {
                        const a = t1.attributes.position;
                        for(let t1 = 0, s = a.count / 3; t1 < s; t1++)for(let s = 0; s < 3; s++){
                            const o = 3 * t1 + s, l = 3 * t1 + (s + 1) % 3;
                            n.fromBufferAttribute(a, o), r.fromBufferAttribute(a, l), !0 === wg(n, r, i) && (e.push(n.x, n.y, n.z), e.push(r.x, r.y, r.z));
                        }
                    }
                    this.setAttribute("position", new su(e, 3));
                }
            }
            copy(t1) {
                return super.copy(t1), this.parameters = Object.assign({}, t1.parameters), this;
            }
        }
        function wg(t1, e, i) {
            const n = `${t1.x},${t1.y},${t1.z}-${e.x},${e.y},${e.z}`, r = `${e.x},${e.y},${e.z}-${t1.x},${t1.y},${t1.z}`;
            return !0 !== i.has(n) && !0 !== i.has(r) && (i.add(n), i.add(r), !0);
        }
        var bg = Object.freeze({
            __proto__: null,
            BoxGeometry: ju,
            CapsuleGeometry: EA,
            CircleGeometry: IA,
            ConeGeometry: NA,
            CylinderGeometry: SA,
            DodecahedronGeometry: CA,
            EdgesGeometry: jA,
            ExtrudeGeometry: ug,
            IcosahedronGeometry: dg,
            LatheGeometry: TA,
            OctahedronGeometry: pg,
            PlaneGeometry: ih,
            PolyhedronGeometry: DA,
            RingGeometry: fg,
            ShapeGeometry: Ag,
            SphereGeometry: gg,
            TetrahedronGeometry: mg,
            TorusGeometry: Mg,
            TorusKnotGeometry: yg,
            TubeGeometry: vg,
            WireframeGeometry: xg
        });
        class Tg extends Qc {
            constructor(t1){
                super(), this.isShadowMaterial = !0, this.type = "ShadowMaterial", this.color = new kc(0), this.transparent = !0, this.fog = !0, this.setValues(t1);
            }
            copy(t1) {
                return super.copy(t1), this.color.copy(t1.color), this.fog = t1.fog, this;
            }
        }
        class Eg extends Bu {
            constructor(t1){
                super(t1), this.isRawShaderMaterial = !0, this.type = "RawShaderMaterial";
            }
        }
        class Ig extends Qc {
            constructor(t1){
                super(), this.isMeshStandardMaterial = !0, this.defines = {
                    STANDARD: ""
                }, this.type = "MeshStandardMaterial", this.color = new kc(16777215), this.roughness = 1, this.metalness = 0, this.map = null, this.lightMap = null, this.lightMapIntensity = 1, this.aoMap = null, this.aoMapIntensity = 1, this.emissive = new kc(0), this.emissiveIntensity = 1, this.emissiveMap = null, this.bumpMap = null, this.bumpScale = 1, this.normalMap = null, this.normalMapType = zs, this.normalScale = new Qo(1, 1), this.displacementMap = null, this.displacementScale = 1, this.displacementBias = 0, this.roughnessMap = null, this.metalnessMap = null, this.alphaMap = null, this.envMap = null, this.envMapIntensity = 1, this.wireframe = !1, this.wireframeLinewidth = 1, this.wireframeLinecap = "round", this.wireframeLinejoin = "round", this.flatShading = !1, this.fog = !0, this.setValues(t1);
            }
            copy(t1) {
                return super.copy(t1), this.defines = {
                    STANDARD: ""
                }, this.color.copy(t1.color), this.roughness = t1.roughness, this.metalness = t1.metalness, this.map = t1.map, this.lightMap = t1.lightMap, this.lightMapIntensity = t1.lightMapIntensity, this.aoMap = t1.aoMap, this.aoMapIntensity = t1.aoMapIntensity, this.emissive.copy(t1.emissive), this.emissiveMap = t1.emissiveMap, this.emissiveIntensity = t1.emissiveIntensity, this.bumpMap = t1.bumpMap, this.bumpScale = t1.bumpScale, this.normalMap = t1.normalMap, this.normalMapType = t1.normalMapType, this.normalScale.copy(t1.normalScale), this.displacementMap = t1.displacementMap, this.displacementScale = t1.displacementScale, this.displacementBias = t1.displacementBias, this.roughnessMap = t1.roughnessMap, this.metalnessMap = t1.metalnessMap, this.alphaMap = t1.alphaMap, this.envMap = t1.envMap, this.envMapIntensity = t1.envMapIntensity, this.wireframe = t1.wireframe, this.wireframeLinewidth = t1.wireframeLinewidth, this.wireframeLinecap = t1.wireframeLinecap, this.wireframeLinejoin = t1.wireframeLinejoin, this.flatShading = t1.flatShading, this.fog = t1.fog, this;
            }
        }
        class Sg extends Ig {
            constructor(t1){
                super(), this.isMeshPhysicalMaterial = !0, this.defines = {
                    STANDARD: "",
                    PHYSICAL: ""
                }, this.type = "MeshPhysicalMaterial", this.anisotropyRotation = 0, this.anisotropyMap = null, this.clearcoatMap = null, this.clearcoatRoughness = 0, this.clearcoatRoughnessMap = null, this.clearcoatNormalScale = new Qo(1, 1), this.clearcoatNormalMap = null, this.ior = 1.5, Object.defineProperty(this, "reflectivity", {
                    get: function() {
                        return Oo(2.5 * (this.ior - 1) / (this.ior + 1), 0, 1);
                    },
                    set: function(t1) {
                        this.ior = (1 + .4 * t1) / (1 - .4 * t1);
                    }
                }), this.iridescenceMap = null, this.iridescenceIOR = 1.3, this.iridescenceThicknessRange = [
                    100,
                    400
                ], this.iridescenceThicknessMap = null, this.sheenColor = new kc(0), this.sheenColorMap = null, this.sheenRoughness = 1, this.sheenRoughnessMap = null, this.transmissionMap = null, this.thickness = 0, this.thicknessMap = null, this.attenuationDistance = 1 / 0, this.attenuationColor = new kc(1, 1, 1), this.specularIntensity = 1, this.specularIntensityMap = null, this.specularColor = new kc(1, 1, 1), this.specularColorMap = null, this._anisotropy = 0, this._clearcoat = 0, this._iridescence = 0, this._sheen = 0, this._transmission = 0, this.setValues(t1);
            }
            get anisotropy() {
                return this._anisotropy;
            }
            set anisotropy(t1) {
                this._anisotropy > 0 != t1 > 0 && this.version++, this._anisotropy = t1;
            }
            get clearcoat() {
                return this._clearcoat;
            }
            set clearcoat(t1) {
                this._clearcoat > 0 != t1 > 0 && this.version++, this._clearcoat = t1;
            }
            get iridescence() {
                return this._iridescence;
            }
            set iridescence(t1) {
                this._iridescence > 0 != t1 > 0 && this.version++, this._iridescence = t1;
            }
            get sheen() {
                return this._sheen;
            }
            set sheen(t1) {
                this._sheen > 0 != t1 > 0 && this.version++, this._sheen = t1;
            }
            get transmission() {
                return this._transmission;
            }
            set transmission(t1) {
                this._transmission > 0 != t1 > 0 && this.version++, this._transmission = t1;
            }
            copy(t1) {
                return super.copy(t1), this.defines = {
                    STANDARD: "",
                    PHYSICAL: ""
                }, this.anisotropy = t1.anisotropy, this.anisotropyRotation = t1.anisotropyRotation, this.anisotropyMap = t1.anisotropyMap, this.clearcoat = t1.clearcoat, this.clearcoatMap = t1.clearcoatMap, this.clearcoatRoughness = t1.clearcoatRoughness, this.clearcoatRoughnessMap = t1.clearcoatRoughnessMap, this.clearcoatNormalMap = t1.clearcoatNormalMap, this.clearcoatNormalScale.copy(t1.clearcoatNormalScale), this.ior = t1.ior, this.iridescence = t1.iridescence, this.iridescenceMap = t1.iridescenceMap, this.iridescenceIOR = t1.iridescenceIOR, this.iridescenceThicknessRange = [
                    ...t1.iridescenceThicknessRange
                ], this.iridescenceThicknessMap = t1.iridescenceThicknessMap, this.sheen = t1.sheen, this.sheenColor.copy(t1.sheenColor), this.sheenColorMap = t1.sheenColorMap, this.sheenRoughness = t1.sheenRoughness, this.sheenRoughnessMap = t1.sheenRoughnessMap, this.transmission = t1.transmission, this.transmissionMap = t1.transmissionMap, this.thickness = t1.thickness, this.thicknessMap = t1.thicknessMap, this.attenuationDistance = t1.attenuationDistance, this.attenuationColor.copy(t1.attenuationColor), this.specularIntensity = t1.specularIntensity, this.specularIntensityMap = t1.specularIntensityMap, this.specularColor.copy(t1.specularColor), this.specularColorMap = t1.specularColorMap, this;
            }
        }
        class Ng extends Qc {
            constructor(t1){
                super(), this.isMeshPhongMaterial = !0, this.type = "MeshPhongMaterial", this.color = new kc(16777215), this.specular = new kc(1118481), this.shininess = 30, this.map = null, this.lightMap = null, this.lightMapIntensity = 1, this.aoMap = null, this.aoMapIntensity = 1, this.emissive = new kc(0), this.emissiveIntensity = 1, this.emissiveMap = null, this.bumpMap = null, this.bumpScale = 1, this.normalMap = null, this.normalMapType = zs, this.normalScale = new Qo(1, 1), this.displacementMap = null, this.displacementScale = 1, this.displacementBias = 0, this.specularMap = null, this.alphaMap = null, this.envMap = null, this.combine = Rr, this.reflectivity = 1, this.refractionRatio = .98, this.wireframe = !1, this.wireframeLinewidth = 1, this.wireframeLinecap = "round", this.wireframeLinejoin = "round", this.flatShading = !1, this.fog = !0, this.setValues(t1);
            }
            copy(t1) {
                return super.copy(t1), this.color.copy(t1.color), this.specular.copy(t1.specular), this.shininess = t1.shininess, this.map = t1.map, this.lightMap = t1.lightMap, this.lightMapIntensity = t1.lightMapIntensity, this.aoMap = t1.aoMap, this.aoMapIntensity = t1.aoMapIntensity, this.emissive.copy(t1.emissive), this.emissiveMap = t1.emissiveMap, this.emissiveIntensity = t1.emissiveIntensity, this.bumpMap = t1.bumpMap, this.bumpScale = t1.bumpScale, this.normalMap = t1.normalMap, this.normalMapType = t1.normalMapType, this.normalScale.copy(t1.normalScale), this.displacementMap = t1.displacementMap, this.displacementScale = t1.displacementScale, this.displacementBias = t1.displacementBias, this.specularMap = t1.specularMap, this.alphaMap = t1.alphaMap, this.envMap = t1.envMap, this.combine = t1.combine, this.reflectivity = t1.reflectivity, this.refractionRatio = t1.refractionRatio, this.wireframe = t1.wireframe, this.wireframeLinewidth = t1.wireframeLinewidth, this.wireframeLinecap = t1.wireframeLinecap, this.wireframeLinejoin = t1.wireframeLinejoin, this.flatShading = t1.flatShading, this.fog = t1.fog, this;
            }
        }
        class Dg extends Qc {
            constructor(t1){
                super(), this.isMeshToonMaterial = !0, this.defines = {
                    TOON: ""
                }, this.type = "MeshToonMaterial", this.color = new kc(16777215), this.map = null, this.gradientMap = null, this.lightMap = null, this.lightMapIntensity = 1, this.aoMap = null, this.aoMapIntensity = 1, this.emissive = new kc(0), this.emissiveIntensity = 1, this.emissiveMap = null, this.bumpMap = null, this.bumpScale = 1, this.normalMap = null, this.normalMapType = zs, this.normalScale = new Qo(1, 1), this.displacementMap = null, this.displacementScale = 1, this.displacementBias = 0, this.alphaMap = null, this.wireframe = !1, this.wireframeLinewidth = 1, this.wireframeLinecap = "round", this.wireframeLinejoin = "round", this.fog = !0, this.setValues(t1);
            }
            copy(t1) {
                return super.copy(t1), this.color.copy(t1.color), this.map = t1.map, this.gradientMap = t1.gradientMap, this.lightMap = t1.lightMap, this.lightMapIntensity = t1.lightMapIntensity, this.aoMap = t1.aoMap, this.aoMapIntensity = t1.aoMapIntensity, this.emissive.copy(t1.emissive), this.emissiveMap = t1.emissiveMap, this.emissiveIntensity = t1.emissiveIntensity, this.bumpMap = t1.bumpMap, this.bumpScale = t1.bumpScale, this.normalMap = t1.normalMap, this.normalMapType = t1.normalMapType, this.normalScale.copy(t1.normalScale), this.displacementMap = t1.displacementMap, this.displacementScale = t1.displacementScale, this.displacementBias = t1.displacementBias, this.alphaMap = t1.alphaMap, this.wireframe = t1.wireframe, this.wireframeLinewidth = t1.wireframeLinewidth, this.wireframeLinecap = t1.wireframeLinecap, this.wireframeLinejoin = t1.wireframeLinejoin, this.fog = t1.fog, this;
            }
        }
        class Cg extends Qc {
            constructor(t1){
                super(), this.isMeshNormalMaterial = !0, this.type = "MeshNormalMaterial", this.bumpMap = null, this.bumpScale = 1, this.normalMap = null, this.normalMapType = zs, this.normalScale = new Qo(1, 1), this.displacementMap = null, this.displacementScale = 1, this.displacementBias = 0, this.wireframe = !1, this.wireframeLinewidth = 1, this.flatShading = !1, this.setValues(t1);
            }
            copy(t1) {
                return super.copy(t1), this.bumpMap = t1.bumpMap, this.bumpScale = t1.bumpScale, this.normalMap = t1.normalMap, this.normalMapType = t1.normalMapType, this.normalScale.copy(t1.normalScale), this.displacementMap = t1.displacementMap, this.displacementScale = t1.displacementScale, this.displacementBias = t1.displacementBias, this.wireframe = t1.wireframe, this.wireframeLinewidth = t1.wireframeLinewidth, this.flatShading = t1.flatShading, this;
            }
        }
        class zg extends Qc {
            constructor(t1){
                super(), this.isMeshLambertMaterial = !0, this.type = "MeshLambertMaterial", this.color = new kc(16777215), this.map = null, this.lightMap = null, this.lightMapIntensity = 1, this.aoMap = null, this.aoMapIntensity = 1, this.emissive = new kc(0), this.emissiveIntensity = 1, this.emissiveMap = null, this.bumpMap = null, this.bumpScale = 1, this.normalMap = null, this.normalMapType = zs, this.normalScale = new Qo(1, 1), this.displacementMap = null, this.displacementScale = 1, this.displacementBias = 0, this.specularMap = null, this.alphaMap = null, this.envMap = null, this.combine = Rr, this.reflectivity = 1, this.refractionRatio = .98, this.wireframe = !1, this.wireframeLinewidth = 1, this.wireframeLinecap = "round", this.wireframeLinejoin = "round", this.flatShading = !1, this.fog = !0, this.setValues(t1);
            }
            copy(t1) {
                return super.copy(t1), this.color.copy(t1.color), this.map = t1.map, this.lightMap = t1.lightMap, this.lightMapIntensity = t1.lightMapIntensity, this.aoMap = t1.aoMap, this.aoMapIntensity = t1.aoMapIntensity, this.emissive.copy(t1.emissive), this.emissiveMap = t1.emissiveMap, this.emissiveIntensity = t1.emissiveIntensity, this.bumpMap = t1.bumpMap, this.bumpScale = t1.bumpScale, this.normalMap = t1.normalMap, this.normalMapType = t1.normalMapType, this.normalScale.copy(t1.normalScale), this.displacementMap = t1.displacementMap, this.displacementScale = t1.displacementScale, this.displacementBias = t1.displacementBias, this.specularMap = t1.specularMap, this.alphaMap = t1.alphaMap, this.envMap = t1.envMap, this.combine = t1.combine, this.reflectivity = t1.reflectivity, this.refractionRatio = t1.refractionRatio, this.wireframe = t1.wireframe, this.wireframeLinewidth = t1.wireframeLinewidth, this.wireframeLinecap = t1.wireframeLinecap, this.wireframeLinejoin = t1.wireframeLinejoin, this.flatShading = t1.flatShading, this.fog = t1.fog, this;
            }
        }
        class Lg extends Qc {
            constructor(t1){
                super(), this.isMeshMatcapMaterial = !0, this.defines = {
                    MATCAP: ""
                }, this.type = "MeshMatcapMaterial", this.color = new kc(16777215), this.matcap = null, this.map = null, this.bumpMap = null, this.bumpScale = 1, this.normalMap = null, this.normalMapType = zs, this.normalScale = new Qo(1, 1), this.displacementMap = null, this.displacementScale = 1, this.displacementBias = 0, this.alphaMap = null, this.flatShading = !1, this.fog = !0, this.setValues(t1);
            }
            copy(t1) {
                return super.copy(t1), this.defines = {
                    MATCAP: ""
                }, this.color.copy(t1.color), this.matcap = t1.matcap, this.map = t1.map, this.bumpMap = t1.bumpMap, this.bumpScale = t1.bumpScale, this.normalMap = t1.normalMap, this.normalMapType = t1.normalMapType, this.normalScale.copy(t1.normalScale), this.displacementMap = t1.displacementMap, this.displacementScale = t1.displacementScale, this.displacementBias = t1.displacementBias, this.alphaMap = t1.alphaMap, this.flatShading = t1.flatShading, this.fog = t1.fog, this;
            }
        }
        class Og extends Lf {
            constructor(t1){
                super(), this.isLineDashedMaterial = !0, this.type = "LineDashedMaterial", this.scale = 1, this.dashSize = 3, this.gapSize = 1, this.setValues(t1);
            }
            copy(t1) {
                return super.copy(t1), this.scale = t1.scale, this.dashSize = t1.dashSize, this.gapSize = t1.gapSize, this;
            }
        }
        function _g(t1, e, i) {
            return !t1 || !i && t1.constructor === e ? t1 : "number" == typeof e.BYTES_PER_ELEMENT ? new e(t1) : Array.prototype.slice.call(t1);
        }
        function jg(t1) {
            return ArrayBuffer.isView(t1) && !(t1 instanceof DataView);
        }
        function Pg(t1) {
            const e = t1.length, i = new Array(e);
            for(let t1 = 0; t1 !== e; ++t1)i[t1] = t1;
            return i.sort(function(e, i) {
                return t1[e] - t1[i];
            }), i;
        }
        function Rg(t1, e, i) {
            const n = t1.length, r = new t1.constructor(n);
            for(let a = 0, s = 0; s !== n; ++a){
                const n = i[a] * e;
                for(let i = 0; i !== e; ++i)r[s++] = t1[n + i];
            }
            return r;
        }
        function Ug(t1, e, i, n) {
            let r = 1, a = t1[0];
            for(; void 0 !== a && void 0 === a[n];)a = t1[r++];
            if (void 0 === a) return;
            let s = a[n];
            if (void 0 !== s) {
                if (Array.isArray(s)) do s = a[n], void 0 !== s && (e.push(a.time), i.push.apply(i, s)), a = t1[r++];
                while (void 0 !== a);
                else if (void 0 !== s.toArray) do s = a[n], void 0 !== s && (e.push(a.time), s.toArray(i, i.length)), a = t1[r++];
                while (void 0 !== a);
                else do s = a[n], void 0 !== s && (e.push(a.time), i.push(s)), a = t1[r++];
                while (void 0 !== a);
            }
        }
        const kg = {
            convertArray: _g,
            isTypedArray: jg,
            getKeyframeOrder: Pg,
            sortedArray: Rg,
            flattenJSON: Ug,
            subclip: function(t1, e, i, n, r = 30) {
                const a = t1.clone();
                a.name = e;
                const s = [];
                for(let t1 = 0; t1 < a.tracks.length; ++t1){
                    const e = a.tracks[t1], o = e.getValueSize(), l = [], c = [];
                    for(let t1 = 0; t1 < e.times.length; ++t1){
                        const a = e.times[t1] * r;
                        if (!(a < i || a >= n)) {
                            l.push(e.times[t1]);
                            for(let i = 0; i < o; ++i)c.push(e.values[t1 * o + i]);
                        }
                    }
                    0 !== l.length && (e.times = _g(l, e.times.constructor), e.values = _g(c, e.values.constructor), s.push(e));
                }
                a.tracks = s;
                let o = 1 / 0;
                for(let t1 = 0; t1 < a.tracks.length; ++t1)o > a.tracks[t1].times[0] && (o = a.tracks[t1].times[0]);
                for(let t1 = 0; t1 < a.tracks.length; ++t1)a.tracks[t1].shift(-1 * o);
                return a.resetDuration(), a;
            },
            makeClipAdditive: function(t1, e = 0, i = t1, n = 30) {
                n <= 0 && (n = 30);
                const r = i.tracks.length, a = e / n;
                for(let e = 0; e < r; ++e){
                    const n = i.tracks[e], r = n.ValueTypeName;
                    if ("bool" === r || "string" === r) continue;
                    const s = t1.tracks.find(function(t1) {
                        return t1.name === n.name && t1.ValueTypeName === r;
                    });
                    if (void 0 === s) continue;
                    let o = 0;
                    const l = n.getValueSize();
                    n.createInterpolant.isInterpolantFactoryMethodGLTFCubicSpline && (o = l / 3);
                    let c = 0;
                    const u = s.getValueSize();
                    s.createInterpolant.isInterpolantFactoryMethodGLTFCubicSpline && (c = u / 3);
                    const h = n.times.length - 1;
                    let d;
                    if (a <= n.times[0]) {
                        const t1 = o, e = l - o;
                        d = n.values.slice(t1, e);
                    } else if (a >= n.times[h]) {
                        const t1 = h * l + o, e = t1 + l - o;
                        d = n.values.slice(t1, e);
                    } else {
                        const t1 = n.createInterpolant(), e = o, i = l - o;
                        t1.evaluate(a), d = t1.resultBuffer.slice(e, i);
                    }
                    "quaternion" === r && (new vl).fromArray(d).normalize().conjugate().toArray(d);
                    const p = s.times.length;
                    for(let t1 = 0; t1 < p; ++t1){
                        const e = t1 * u + c;
                        if ("quaternion" === r) vl.multiplyQuaternionsFlat(s.values, e, d, 0, s.values, e);
                        else {
                            const t1 = u - 2 * c;
                            for(let i = 0; i < t1; ++i)s.values[e + i] -= d[i];
                        }
                    }
                }
                return t1.blendMode = bs, t1;
            }
        };
        class Bg {
            constructor(t1, e, i, n){
                this.parameterPositions = t1, this._cachedIndex = 0, this.resultBuffer = void 0 !== n ? n : new e.constructor(i), this.sampleValues = e, this.valueSize = i, this.settings = null, this.DefaultSettings_ = {};
            }
            evaluate(t1) {
                const e = this.parameterPositions;
                let i = this._cachedIndex, n = e[i], r = e[i - 1];
                t: {
                    e: {
                        let a;
                        i: {
                            n: if (!(t1 < n)) {
                                for(let a = i + 2;;){
                                    if (void 0 === n) {
                                        if (t1 < r) break n;
                                        return i = e.length, this._cachedIndex = i, this.copySampleValue_(i - 1);
                                    }
                                    if (i === a) break;
                                    if (r = n, n = e[++i], t1 < n) break e;
                                }
                                a = e.length;
                                break i;
                            }
                            if (t1 >= r) break t;
                            {
                                const s = e[1];
                                t1 < s && (i = 2, r = s);
                                for(let a = i - 2;;){
                                    if (void 0 === r) return this._cachedIndex = 0, this.copySampleValue_(0);
                                    if (i === a) break;
                                    if (n = r, r = e[--i - 1], t1 >= r) break e;
                                }
                                a = i, i = 0;
                            }
                        }
                        for(; i < a;){
                            const n = i + a >>> 1;
                            t1 < e[n] ? a = n : i = n + 1;
                        }
                        if (n = e[i], r = e[i - 1], void 0 === r) return this._cachedIndex = 0, this.copySampleValue_(0);
                        if (void 0 === n) return i = e.length, this._cachedIndex = i, this.copySampleValue_(i - 1);
                    }
                    this._cachedIndex = i, this.intervalChanged_(i, r, n);
                }
                return this.interpolate_(i, r, t1, n);
            }
            getSettings_() {
                return this.settings || this.DefaultSettings_;
            }
            copySampleValue_(t1) {
                const e = this.resultBuffer, i = this.sampleValues, n = this.valueSize, r = t1 * n;
                for(let t1 = 0; t1 !== n; ++t1)e[t1] = i[r + t1];
                return e;
            }
            interpolate_() {
                throw new Error("call to abstract method");
            }
            intervalChanged_() {}
        }
        class Fg extends Bg {
            constructor(t1, e, i, n){
                super(t1, e, i, n), this._weightPrev = -0, this._offsetPrev = -0, this._weightNext = -0, this._offsetNext = -0, this.DefaultSettings_ = {
                    endingStart: ys,
                    endingEnd: ys
                };
            }
            intervalChanged_(t1, e, i) {
                const n = this.parameterPositions;
                let r = t1 - 2, a = t1 + 1, s = n[r], o = n[a];
                if (void 0 === s) switch(this.getSettings_().endingStart){
                    case vs:
                        r = t1, s = 2 * e - i;
                        break;
                    case xs:
                        r = n.length - 2, s = e + n[r] - n[r + 1];
                        break;
                    default:
                        r = t1, s = i;
                }
                if (void 0 === o) switch(this.getSettings_().endingEnd){
                    case vs:
                        a = t1, o = 2 * i - e;
                        break;
                    case xs:
                        a = 1, o = i + n[1] - n[0];
                        break;
                    default:
                        a = t1 - 1, o = e;
                }
                const l = .5 * (i - e), c = this.valueSize;
                this._weightPrev = l / (e - s), this._weightNext = l / (o - i), this._offsetPrev = r * c, this._offsetNext = a * c;
            }
            interpolate_(t1, e, i, n) {
                const r = this.resultBuffer, a = this.sampleValues, s = this.valueSize, o = t1 * s, l = o - s, c = this._offsetPrev, u = this._offsetNext, h = this._weightPrev, d = this._weightNext, p = (i - e) / (n - e), f = p * p, A = f * p, g = -h * A + 2 * h * f - h * p, m = (1 + h) * A + (-1.5 - 2 * h) * f + (-0.5 + h) * p + 1, M = (-1 - d) * A + (1.5 + d) * f + .5 * p, y = d * A - d * f;
                for(let t1 = 0; t1 !== s; ++t1)r[t1] = g * a[c + t1] + m * a[l + t1] + M * a[o + t1] + y * a[u + t1];
                return r;
            }
        }
        class Qg extends Bg {
            constructor(t1, e, i, n){
                super(t1, e, i, n);
            }
            interpolate_(t1, e, i, n) {
                const r = this.resultBuffer, a = this.sampleValues, s = this.valueSize, o = t1 * s, l = o - s, c = (i - e) / (n - e), u = 1 - c;
                for(let t1 = 0; t1 !== s; ++t1)r[t1] = a[l + t1] * u + a[o + t1] * c;
                return r;
            }
        }
        class Hg extends Bg {
            constructor(t1, e, i, n){
                super(t1, e, i, n);
            }
            interpolate_(t1) {
                return this.copySampleValue_(t1 - 1);
            }
        }
        class Vg {
            constructor(t1, e, i, n){
                if (void 0 === t1) throw new Error("THREE.KeyframeTrack: track name is undefined");
                if (void 0 === e || 0 === e.length) throw new Error("THREE.KeyframeTrack: no keyframes in track named " + t1);
                this.name = t1, this.times = _g(e, this.TimeBufferType), this.values = _g(i, this.ValueBufferType), this.setInterpolation(n || this.DefaultInterpolation);
            }
            static toJSON(t1) {
                const e = t1.constructor;
                let i;
                if (e.toJSON !== this.toJSON) i = e.toJSON(t1);
                else {
                    i = {
                        name: t1.name,
                        times: _g(t1.times, Array),
                        values: _g(t1.values, Array)
                    };
                    const e = t1.getInterpolation();
                    e !== t1.DefaultInterpolation && (i.interpolation = e);
                }
                return i.type = t1.ValueTypeName, i;
            }
            InterpolantFactoryMethodDiscrete(t1) {
                return new Hg(this.times, this.values, this.getValueSize(), t1);
            }
            InterpolantFactoryMethodLinear(t1) {
                return new Qg(this.times, this.values, this.getValueSize(), t1);
            }
            InterpolantFactoryMethodSmooth(t1) {
                return new Fg(this.times, this.values, this.getValueSize(), t1);
            }
            setInterpolation(t1) {
                let e;
                switch(t1){
                    case gs:
                        e = this.InterpolantFactoryMethodDiscrete;
                        break;
                    case ms:
                        e = this.InterpolantFactoryMethodLinear;
                        break;
                    case Ms:
                        e = this.InterpolantFactoryMethodSmooth;
                }
                if (void 0 === e) {
                    const e = "unsupported interpolation for " + this.ValueTypeName + " keyframe track named " + this.name;
                    if (void 0 === this.createInterpolant) {
                        if (t1 === this.DefaultInterpolation) throw new Error(e);
                        this.setInterpolation(this.DefaultInterpolation);
                    }
                    return console.warn("THREE.KeyframeTrack:", e), this;
                }
                return this.createInterpolant = e, this;
            }
            getInterpolation() {
                switch(this.createInterpolant){
                    case this.InterpolantFactoryMethodDiscrete:
                        return gs;
                    case this.InterpolantFactoryMethodLinear:
                        return ms;
                    case this.InterpolantFactoryMethodSmooth:
                        return Ms;
                }
            }
            getValueSize() {
                return this.values.length / this.times.length;
            }
            shift(t1) {
                if (0 !== t1) {
                    const e = this.times;
                    for(let i = 0, n = e.length; i !== n; ++i)e[i] += t1;
                }
                return this;
            }
            scale(t1) {
                if (1 !== t1) {
                    const e = this.times;
                    for(let i = 0, n = e.length; i !== n; ++i)e[i] *= t1;
                }
                return this;
            }
            trim(t1, e) {
                const i = this.times, n = i.length;
                let r = 0, a = n - 1;
                for(; r !== n && i[r] < t1;)++r;
                for(; -1 !== a && i[a] > e;)--a;
                if (++a, 0 !== r || a !== n) {
                    r >= a && (a = Math.max(a, 1), r = a - 1);
                    const t1 = this.getValueSize();
                    this.times = i.slice(r, a), this.values = this.values.slice(r * t1, a * t1);
                }
                return this;
            }
            validate() {
                let t1 = !0;
                const e = this.getValueSize();
                e - Math.floor(e) != 0 && (console.error("THREE.KeyframeTrack: Invalid value size in track.", this), t1 = !1);
                const i = this.times, n = this.values, r = i.length;
                0 === r && (console.error("THREE.KeyframeTrack: Track is empty.", this), t1 = !1);
                let a = null;
                for(let e = 0; e !== r; e++){
                    const n = i[e];
                    if ("number" == typeof n && isNaN(n)) {
                        console.error("THREE.KeyframeTrack: Time is not a valid number.", this, e, n), t1 = !1;
                        break;
                    }
                    if (null !== a && a > n) {
                        console.error("THREE.KeyframeTrack: Out of order keys.", this, e, n, a), t1 = !1;
                        break;
                    }
                    a = n;
                }
                if (void 0 !== n && jg(n)) for(let e = 0, i = n.length; e !== i; ++e){
                    const i = n[e];
                    if (isNaN(i)) {
                        console.error("THREE.KeyframeTrack: Value is not a valid number.", this, e, i), t1 = !1;
                        break;
                    }
                }
                return t1;
            }
            optimize() {
                const t1 = this.times.slice(), e = this.values.slice(), i = this.getValueSize(), n = this.getInterpolation() === Ms, r = t1.length - 1;
                let a = 1;
                for(let s = 1; s < r; ++s){
                    let r = !1;
                    const o = t1[s];
                    if (o !== t1[s + 1] && (1 !== s || o !== t1[0])) {
                        if (n) r = !0;
                        else {
                            const t1 = s * i, n = t1 - i, a = t1 + i;
                            for(let s = 0; s !== i; ++s){
                                const i = e[t1 + s];
                                if (i !== e[n + s] || i !== e[a + s]) {
                                    r = !0;
                                    break;
                                }
                            }
                        }
                    }
                    if (r) {
                        if (s !== a) {
                            t1[a] = t1[s];
                            const n = s * i, r = a * i;
                            for(let t1 = 0; t1 !== i; ++t1)e[r + t1] = e[n + t1];
                        }
                        ++a;
                    }
                }
                if (r > 0) {
                    t1[a] = t1[r];
                    for(let t1 = r * i, n = a * i, s = 0; s !== i; ++s)e[n + s] = e[t1 + s];
                    ++a;
                }
                return a !== t1.length ? (this.times = t1.slice(0, a), this.values = e.slice(0, a * i)) : (this.times = t1, this.values = e), this;
            }
            clone() {
                const t1 = this.times.slice(), e = this.values.slice(), i = new this.constructor(this.name, t1, e);
                return i.createInterpolant = this.createInterpolant, i;
            }
        }
        Vg.prototype.TimeBufferType = Float32Array, Vg.prototype.ValueBufferType = Float32Array, Vg.prototype.DefaultInterpolation = ms;
        class Gg extends Vg {
        }
        Gg.prototype.ValueTypeName = "bool", Gg.prototype.ValueBufferType = Array, Gg.prototype.DefaultInterpolation = gs, Gg.prototype.InterpolantFactoryMethodLinear = void 0, Gg.prototype.InterpolantFactoryMethodSmooth = void 0;
        class Yg extends Vg {
        }
        Yg.prototype.ValueTypeName = "color";
        class Wg extends Vg {
        }
        Wg.prototype.ValueTypeName = "number";
        class Xg extends Bg {
            constructor(t1, e, i, n){
                super(t1, e, i, n);
            }
            interpolate_(t1, e, i, n) {
                const r = this.resultBuffer, a = this.sampleValues, s = this.valueSize, o = (i - e) / (n - e);
                let l = t1 * s;
                for(let t1 = l + s; l !== t1; l += 4)vl.slerpFlat(r, 0, a, l - s, a, l, o);
                return r;
            }
        }
        class Zg extends Vg {
            InterpolantFactoryMethodLinear(t1) {
                return new Xg(this.times, this.values, this.getValueSize(), t1);
            }
        }
        Zg.prototype.ValueTypeName = "quaternion", Zg.prototype.DefaultInterpolation = ms, Zg.prototype.InterpolantFactoryMethodSmooth = void 0;
        class Jg extends Vg {
        }
        Jg.prototype.ValueTypeName = "string", Jg.prototype.ValueBufferType = Array, Jg.prototype.DefaultInterpolation = gs, Jg.prototype.InterpolantFactoryMethodLinear = void 0, Jg.prototype.InterpolantFactoryMethodSmooth = void 0;
        class Kg extends Vg {
        }
        Kg.prototype.ValueTypeName = "vector";
        class qg {
            constructor(t1, e = -1, i, n = ws){
                this.name = t1, this.tracks = i, this.duration = e, this.blendMode = n, this.uuid = Lo(), this.duration < 0 && this.resetDuration();
            }
            static parse(t1) {
                const e = [], i = t1.tracks, n = 1 / (t1.fps || 1);
                for(let t1 = 0, r = i.length; t1 !== r; ++t1)e.push($g(i[t1]).scale(n));
                const r = new this(t1.name, t1.duration, e, t1.blendMode);
                return r.uuid = t1.uuid, r;
            }
            static toJSON(t1) {
                const e = [], i = t1.tracks, n = {
                    name: t1.name,
                    duration: t1.duration,
                    tracks: e,
                    uuid: t1.uuid,
                    blendMode: t1.blendMode
                };
                for(let t1 = 0, n = i.length; t1 !== n; ++t1)e.push(Vg.toJSON(i[t1]));
                return n;
            }
            static CreateFromMorphTargetSequence(t1, e, i, n) {
                const r = e.length, a = [];
                for(let t1 = 0; t1 < r; t1++){
                    let s = [], o = [];
                    s.push((t1 + r - 1) % r, t1, (t1 + 1) % r), o.push(0, 1, 0);
                    const l = Pg(s);
                    s = Rg(s, 1, l), o = Rg(o, 1, l), n || 0 !== s[0] || (s.push(r), o.push(o[0])), a.push(new Wg(".morphTargetInfluences[" + e[t1].name + "]", s, o).scale(1 / i));
                }
                return new this(t1, -1, a);
            }
            static findByName(t1, e) {
                let i = t1;
                if (!Array.isArray(t1)) {
                    const e = t1;
                    i = e.geometry && e.geometry.animations || e.animations;
                }
                for(let t1 = 0; t1 < i.length; t1++)if (i[t1].name === e) return i[t1];
                return null;
            }
            static CreateClipsFromMorphTargetSequences(t1, e, i) {
                const n = {}, r = /^([\w-]*?)([\d]+)$/;
                for(let e = 0, i = t1.length; e < i; e++){
                    const i = t1[e], a = i.name.match(r);
                    if (a && a.length > 1) {
                        const t1 = a[1];
                        let e = n[t1];
                        e || (n[t1] = e = []), e.push(i);
                    }
                }
                const a = [];
                for(const t1 in n)a.push(this.CreateFromMorphTargetSequence(t1, n[t1], e, i));
                return a;
            }
            static parseAnimation(t1, e) {
                if (!t1) return console.error("THREE.AnimationClip: No animation in JSONLoader data."), null;
                const i = function(t1, e, i, n, r) {
                    if (0 !== i.length) {
                        const a = [], s = [];
                        Ug(i, a, s, n), 0 !== a.length && r.push(new t1(e, a, s));
                    }
                }, n = [], r = t1.name || "default", a = t1.fps || 30, s = t1.blendMode;
                let o = t1.length || -1;
                const l = t1.hierarchy || [];
                for(let t1 = 0; t1 < l.length; t1++){
                    const r = l[t1].keys;
                    if (r && 0 !== r.length) {
                        if (r[0].morphTargets) {
                            const t1 = {};
                            let e;
                            for(e = 0; e < r.length; e++)if (r[e].morphTargets) for(let i = 0; i < r[e].morphTargets.length; i++)t1[r[e].morphTargets[i]] = -1;
                            for(const i in t1){
                                const t1 = [], a = [];
                                for(let n = 0; n !== r[e].morphTargets.length; ++n){
                                    const n = r[e];
                                    t1.push(n.time), a.push(n.morphTarget === i ? 1 : 0);
                                }
                                n.push(new Wg(".morphTargetInfluence[" + i + "]", t1, a));
                            }
                            o = t1.length * a;
                        } else {
                            const a = ".bones[" + e[t1].name + "]";
                            i(Kg, a + ".position", r, "pos", n), i(Zg, a + ".quaternion", r, "rot", n), i(Kg, a + ".scale", r, "scl", n);
                        }
                    }
                }
                return 0 === n.length ? null : new this(r, o, n, s);
            }
            resetDuration() {
                let t1 = 0;
                for(let e = 0, i = this.tracks.length; e !== i; ++e){
                    const i = this.tracks[e];
                    t1 = Math.max(t1, i.times[i.times.length - 1]);
                }
                return this.duration = t1, this;
            }
            trim() {
                for(let t1 = 0; t1 < this.tracks.length; t1++)this.tracks[t1].trim(0, this.duration);
                return this;
            }
            validate() {
                let t1 = !0;
                for(let e = 0; e < this.tracks.length; e++)t1 = t1 && this.tracks[e].validate();
                return t1;
            }
            optimize() {
                for(let t1 = 0; t1 < this.tracks.length; t1++)this.tracks[t1].optimize();
                return this;
            }
            clone() {
                const t1 = [];
                for(let e = 0; e < this.tracks.length; e++)t1.push(this.tracks[e].clone());
                return new this.constructor(this.name, this.duration, t1, this.blendMode);
            }
            toJSON() {
                return this.constructor.toJSON(this);
            }
        }
        function $g(t1) {
            if (void 0 === t1.type) throw new Error("THREE.KeyframeTrack: track type undefined, can not parse");
            const e = function(t1) {
                switch(t1.toLowerCase()){
                    case "scalar":
                    case "double":
                    case "float":
                    case "number":
                    case "integer":
                        return Wg;
                    case "vector":
                    case "vector2":
                    case "vector3":
                    case "vector4":
                        return Kg;
                    case "color":
                        return Yg;
                    case "quaternion":
                        return Zg;
                    case "bool":
                    case "boolean":
                        return Gg;
                    case "string":
                        return Jg;
                }
                throw new Error("THREE.KeyframeTrack: Unsupported typeName: " + t1);
            }(t1.type);
            if (void 0 === t1.times) {
                const e = [], i = [];
                Ug(t1.keys, e, i, "value"), t1.times = e, t1.values = i;
            }
            return void 0 !== e.parse ? e.parse(t1) : new e(t1.name, t1.times, t1.values, t1.interpolation);
        }
        const tm = {
            enabled: !1,
            files: {},
            add: function(t1, e) {
                !1 !== this.enabled && (this.files[t1] = e);
            },
            get: function(t1) {
                if (!1 !== this.enabled) return this.files[t1];
            },
            remove: function(t1) {
                delete this.files[t1];
            },
            clear: function() {
                this.files = {};
            }
        };
        class em {
            constructor(t1, e, i){
                const n = this;
                let r, a = !1, s = 0, o = 0;
                const l = [];
                this.onStart = void 0, this.onLoad = t1, this.onProgress = e, this.onError = i, this.itemStart = function(t1) {
                    o++, !1 === a && void 0 !== n.onStart && n.onStart(t1, s, o), a = !0;
                }, this.itemEnd = function(t1) {
                    s++, void 0 !== n.onProgress && n.onProgress(t1, s, o), s === o && (a = !1, void 0 !== n.onLoad && n.onLoad());
                }, this.itemError = function(t1) {
                    void 0 !== n.onError && n.onError(t1);
                }, this.resolveURL = function(t1) {
                    return r ? r(t1) : t1;
                }, this.setURLModifier = function(t1) {
                    return r = t1, this;
                }, this.addHandler = function(t1, e) {
                    return l.push(t1, e), this;
                }, this.removeHandler = function(t1) {
                    const e = l.indexOf(t1);
                    return -1 !== e && l.splice(e, 2), this;
                }, this.getHandler = function(t1) {
                    for(let e = 0, i = l.length; e < i; e += 2){
                        const i = l[e], n = l[e + 1];
                        if (i.global && (i.lastIndex = 0), i.test(t1)) return n;
                    }
                    return null;
                };
            }
        }
        const im = new em;
        class nm {
            constructor(t1){
                this.manager = void 0 !== t1 ? t1 : im, this.crossOrigin = "anonymous", this.withCredentials = !1, this.path = "", this.resourcePath = "", this.requestHeader = {};
            }
            load() {}
            loadAsync(t1, e) {
                const i = this;
                return new Promise(function(n, r) {
                    i.load(t1, n, e, r);
                });
            }
            parse() {}
            setCrossOrigin(t1) {
                return this.crossOrigin = t1, this;
            }
            setWithCredentials(t1) {
                return this.withCredentials = t1, this;
            }
            setPath(t1) {
                return this.path = t1, this;
            }
            setResourcePath(t1) {
                return this.resourcePath = t1, this;
            }
            setRequestHeader(t1) {
                return this.requestHeader = t1, this;
            }
        }
        nm.DEFAULT_MATERIAL_NAME = "__DEFAULT";
        const rm = {};
        class am extends Error {
            constructor(t1, e){
                super(t1), this.response = e;
            }
        }
        class sm extends nm {
            constructor(t1){
                super(t1);
            }
            load(t1, e, i, n) {
                void 0 === t1 && (t1 = ""), void 0 !== this.path && (t1 = this.path + t1), t1 = this.manager.resolveURL(t1);
                const r = tm.get(t1);
                if (void 0 !== r) return this.manager.itemStart(t1), setTimeout(()=>{
                    e && e(r), this.manager.itemEnd(t1);
                }, 0), r;
                if (void 0 !== rm[t1]) return void rm[t1].push({
                    onLoad: e,
                    onProgress: i,
                    onError: n
                });
                rm[t1] = [], rm[t1].push({
                    onLoad: e,
                    onProgress: i,
                    onError: n
                });
                const a = new Request(t1, {
                    headers: new Headers(this.requestHeader),
                    credentials: this.withCredentials ? "include" : "same-origin"
                }), s = this.mimeType, o = this.responseType;
                fetch(a).then((e)=>{
                    if (200 === e.status || 0 === e.status) {
                        if (0 === e.status && console.warn("THREE.FileLoader: HTTP Status 0 received."), "undefined" == typeof ReadableStream || void 0 === e.body || void 0 === e.body.getReader) return e;
                        const i = rm[t1], n = e.body.getReader(), r = e.headers.get("Content-Length") || e.headers.get("X-File-Size"), a = r ? parseInt(r) : 0, s = 0 !== a;
                        let o = 0;
                        const l = new ReadableStream({
                            start (t1) {
                                !function e() {
                                    n.read().then(({ done: n, value: r })=>{
                                        if (n) t1.close();
                                        else {
                                            o += r.byteLength;
                                            const n = new ProgressEvent("progress", {
                                                lengthComputable: s,
                                                loaded: o,
                                                total: a
                                            });
                                            for(let t1 = 0, e = i.length; t1 < e; t1++){
                                                const e = i[t1];
                                                e.onProgress && e.onProgress(n);
                                            }
                                            t1.enqueue(r), e();
                                        }
                                    });
                                }();
                            }
                        });
                        return new Response(l);
                    }
                    throw new am(`fetch for "${e.url}" responded with ${e.status}: ${e.statusText}`, e);
                }).then((t1)=>{
                    switch(o){
                        case "arraybuffer":
                            return t1.arrayBuffer();
                        case "blob":
                            return t1.blob();
                        case "document":
                            return t1.text().then((t1)=>(new DOMParser).parseFromString(t1, s));
                        case "json":
                            return t1.json();
                        default:
                            if (void 0 === s) return t1.text();
                            {
                                const e = /charset="?([^;"\s]*)"?/i.exec(s), i = e && e[1] ? e[1].toLowerCase() : void 0, n = new TextDecoder(i);
                                return t1.arrayBuffer().then((t1)=>n.decode(t1));
                            }
                    }
                }).then((e)=>{
                    tm.add(t1, e);
                    const i = rm[t1];
                    delete rm[t1];
                    for(let t1 = 0, n = i.length; t1 < n; t1++){
                        const n = i[t1];
                        n.onLoad && n.onLoad(e);
                    }
                }).catch((e)=>{
                    const i = rm[t1];
                    if (void 0 === i) throw this.manager.itemError(t1), e;
                    delete rm[t1];
                    for(let t1 = 0, n = i.length; t1 < n; t1++){
                        const n = i[t1];
                        n.onError && n.onError(e);
                    }
                    this.manager.itemError(t1);
                }).finally(()=>{
                    this.manager.itemEnd(t1);
                }), this.manager.itemStart(t1);
            }
            setResponseType(t1) {
                return this.responseType = t1, this;
            }
            setMimeType(t1) {
                return this.mimeType = t1, this;
            }
        }
        class om extends nm {
            constructor(t1){
                super(t1);
            }
            load(t1, e, i, n) {
                const r = this, a = new sm(this.manager);
                a.setPath(this.path), a.setRequestHeader(this.requestHeader), a.setWithCredentials(this.withCredentials), a.load(t1, function(i) {
                    try {
                        e(r.parse(JSON.parse(i)));
                    } catch (e) {
                        n ? n(e) : console.error(e), r.manager.itemError(t1);
                    }
                }, i, n);
            }
            parse(t1) {
                const e = [];
                for(let i = 0; i < t1.length; i++){
                    const n = qg.parse(t1[i]);
                    e.push(n);
                }
                return e;
            }
        }
        class lm extends nm {
            constructor(t1){
                super(t1);
            }
            load(t1, e, i, n) {
                const r = this, a = [], s = new qf, o = new sm(this.manager);
                o.setPath(this.path), o.setResponseType("arraybuffer"), o.setRequestHeader(this.requestHeader), o.setWithCredentials(r.withCredentials);
                let l = 0;
                function c(c) {
                    o.load(t1[c], function(t1) {
                        const i = r.parse(t1, !0);
                        a[c] = {
                            width: i.width,
                            height: i.height,
                            format: i.format,
                            mipmaps: i.mipmaps
                        }, l += 1, 6 === l && (1 === i.mipmapCount && (s.minFilter = la), s.image = a, s.format = i.format, s.needsUpdate = !0, e && e(s));
                    }, i, n);
                }
                if (Array.isArray(t1)) for(let e = 0, i = t1.length; e < i; ++e)c(e);
                else o.load(t1, function(t1) {
                    const i = r.parse(t1, !0);
                    if (i.isCubemap) {
                        const t1 = i.mipmaps.length / i.mipmapCount;
                        for(let e = 0; e < t1; e++){
                            a[e] = {
                                mipmaps: []
                            };
                            for(let t1 = 0; t1 < i.mipmapCount; t1++)a[e].mipmaps.push(i.mipmaps[e * i.mipmapCount + t1]), a[e].format = i.format, a[e].width = i.width, a[e].height = i.height;
                        }
                        s.image = a;
                    } else s.image.width = i.width, s.image.height = i.height, s.mipmaps = i.mipmaps;
                    1 === i.mipmapCount && (s.minFilter = la), s.format = i.format, s.needsUpdate = !0, e && e(s);
                }, i, n);
                return s;
            }
        }
        class cm extends nm {
            constructor(t1){
                super(t1);
            }
            load(t1, e, i, n) {
                void 0 !== this.path && (t1 = this.path + t1), t1 = this.manager.resolveURL(t1);
                const r = this, a = tm.get(t1);
                if (void 0 !== a) return r.manager.itemStart(t1), setTimeout(function() {
                    e && e(a), r.manager.itemEnd(t1);
                }, 0), a;
                const s = Xo("img");
                function o() {
                    c(), tm.add(t1, this), e && e(this), r.manager.itemEnd(t1);
                }
                function l(e) {
                    c(), n && n(e), r.manager.itemError(t1), r.manager.itemEnd(t1);
                }
                function c() {
                    s.removeEventListener("load", o, !1), s.removeEventListener("error", l, !1);
                }
                return s.addEventListener("load", o, !1), s.addEventListener("error", l, !1), "data:" !== t1.slice(0, 5) && void 0 !== this.crossOrigin && (s.crossOrigin = this.crossOrigin), r.manager.itemStart(t1), s.src = t1, s;
            }
        }
        class um extends nm {
            constructor(t1){
                super(t1);
            }
            load(t1, e, i, n) {
                const r = new Gu;
                r.colorSpace = _s;
                const a = new cm(this.manager);
                a.setCrossOrigin(this.crossOrigin), a.setPath(this.path);
                let s = 0;
                function o(i) {
                    a.load(t1[i], function(t1) {
                        r.images[i] = t1, s++, 6 === s && (r.needsUpdate = !0, e && e(r));
                    }, void 0, n);
                }
                for(let e = 0; e < t1.length; ++e)o(e);
                return r;
            }
        }
        class hm extends nm {
            constructor(t1){
                super(t1);
            }
            load(t1, e, i, n) {
                const r = this, a = new yf, s = new sm(this.manager);
                return s.setResponseType("arraybuffer"), s.setRequestHeader(this.requestHeader), s.setPath(this.path), s.setWithCredentials(r.withCredentials), s.load(t1, function(t1) {
                    let i;
                    try {
                        i = r.parse(t1);
                    } catch (t1) {
                        if (void 0 === n) return void console.error(t1);
                        n(t1);
                    }
                    void 0 !== i.image ? a.image = i.image : void 0 !== i.data && (a.image.width = i.width, a.image.height = i.height, a.image.data = i.data), a.wrapS = void 0 !== i.wrapS ? i.wrapS : ea, a.wrapT = void 0 !== i.wrapT ? i.wrapT : ea, a.magFilter = void 0 !== i.magFilter ? i.magFilter : la, a.minFilter = void 0 !== i.minFilter ? i.minFilter : la, a.anisotropy = void 0 !== i.anisotropy ? i.anisotropy : 1, void 0 !== i.colorSpace ? a.colorSpace = i.colorSpace : void 0 !== i.encoding && (a.encoding = i.encoding), void 0 !== i.flipY && (a.flipY = i.flipY), void 0 !== i.format && (a.format = i.format), void 0 !== i.type && (a.type = i.type), void 0 !== i.mipmaps && (a.mipmaps = i.mipmaps, a.minFilter = ha), 1 === i.mipmapCount && (a.minFilter = la), void 0 !== i.generateMipmaps && (a.generateMipmaps = i.generateMipmaps), a.needsUpdate = !0, e && e(a, i);
                }, i, n), a;
            }
        }
        class dm extends nm {
            constructor(t1){
                super(t1);
            }
            load(t1, e, i, n) {
                const r = new hl, a = new cm(this.manager);
                return a.setCrossOrigin(this.crossOrigin), a.setPath(this.path), a.load(t1, function(t1) {
                    r.image = t1, r.needsUpdate = !0, void 0 !== e && e(r);
                }, i, n), r;
            }
        }
        class pm extends wc {
            constructor(t1, e = 1){
                super(), this.isLight = !0, this.type = "Light", this.color = new kc(t1), this.intensity = e;
            }
            dispose() {}
            copy(t1, e) {
                return super.copy(t1, e), this.color.copy(t1.color), this.intensity = t1.intensity, this;
            }
            toJSON(t1) {
                const e = super.toJSON(t1);
                return e.object.color = this.color.getHex(), e.object.intensity = this.intensity, void 0 !== this.groundColor && (e.object.groundColor = this.groundColor.getHex()), void 0 !== this.distance && (e.object.distance = this.distance), void 0 !== this.angle && (e.object.angle = this.angle), void 0 !== this.decay && (e.object.decay = this.decay), void 0 !== this.penumbra && (e.object.penumbra = this.penumbra), void 0 !== this.shadow && (e.object.shadow = this.shadow.toJSON()), e;
            }
        }
        class fm extends pm {
            constructor(t1, e, i){
                super(t1, i), this.isHemisphereLight = !0, this.type = "HemisphereLight", this.position.copy(wc.DEFAULT_UP), this.updateMatrix(), this.groundColor = new kc(e);
            }
            copy(t1, e) {
                return super.copy(t1, e), this.groundColor.copy(t1.groundColor), this;
            }
        }
        const Am = new Kl, gm = new xl, mm = new xl;
        class Mm {
            constructor(t1){
                this.camera = t1, this.bias = 0, this.normalBias = 0, this.radius = 1, this.blurSamples = 8, this.mapSize = new Qo(512, 512), this.map = null, this.mapPass = null, this.matrix = new Kl, this.autoUpdate = !0, this.needsUpdate = !1, this._frustum = new $u, this._frameExtents = new Qo(1, 1), this._viewportCount = 1, this._viewports = [
                    new dl(0, 0, 1, 1)
                ];
            }
            getViewportCount() {
                return this._viewportCount;
            }
            getFrustum() {
                return this._frustum;
            }
            updateMatrices(t1) {
                const e = this.camera, i = this.matrix;
                gm.setFromMatrixPosition(t1.matrixWorld), e.position.copy(gm), mm.setFromMatrixPosition(t1.target.matrixWorld), e.lookAt(mm), e.updateMatrixWorld(), Am.multiplyMatrices(e.projectionMatrix, e.matrixWorldInverse), this._frustum.setFromProjectionMatrix(Am), i.set(.5, 0, 0, .5, 0, .5, 0, .5, 0, 0, .5, .5, 0, 0, 0, 1), i.multiply(Am);
            }
            getViewport(t1) {
                return this._viewports[t1];
            }
            getFrameExtents() {
                return this._frameExtents;
            }
            dispose() {
                this.map && this.map.dispose(), this.mapPass && this.mapPass.dispose();
            }
            copy(t1) {
                return this.camera = t1.camera.clone(), this.bias = t1.bias, this.radius = t1.radius, this.mapSize.copy(t1.mapSize), this;
            }
            clone() {
                return (new this.constructor).copy(this);
            }
            toJSON() {
                const t1 = {};
                return 0 !== this.bias && (t1.bias = this.bias), 0 !== this.normalBias && (t1.normalBias = this.normalBias), 1 !== this.radius && (t1.radius = this.radius), 512 === this.mapSize.x && 512 === this.mapSize.y || (t1.mapSize = this.mapSize.toArray()), t1.camera = this.camera.toJSON(!1).object, delete t1.camera.matrix, t1;
            }
        }
        class ym extends Mm {
            constructor(){
                super(new Qu(50, 1, .5, 500)), this.isSpotLightShadow = !0, this.focus = 1;
            }
            updateMatrices(t1) {
                const e = this.camera, i = 2 * zo * t1.angle * this.focus, n = this.mapSize.width / this.mapSize.height, r = t1.distance || e.far;
                i === e.fov && n === e.aspect && r === e.far || (e.fov = i, e.aspect = n, e.far = r, e.updateProjectionMatrix()), super.updateMatrices(t1);
            }
            copy(t1) {
                return super.copy(t1), this.focus = t1.focus, this;
            }
        }
        class vm extends pm {
            constructor(t1, e, i = 0, n = Math.PI / 3, r = 0, a = 2){
                super(t1, e), this.isSpotLight = !0, this.type = "SpotLight", this.position.copy(wc.DEFAULT_UP), this.updateMatrix(), this.target = new wc, this.distance = i, this.angle = n, this.penumbra = r, this.decay = a, this.map = null, this.shadow = new ym;
            }
            get power() {
                return this.intensity * Math.PI;
            }
            set power(t1) {
                this.intensity = t1 / Math.PI;
            }
            dispose() {
                this.shadow.dispose();
            }
            copy(t1, e) {
                return super.copy(t1, e), this.distance = t1.distance, this.angle = t1.angle, this.penumbra = t1.penumbra, this.decay = t1.decay, this.target = t1.target.clone(), this.shadow = t1.shadow.clone(), this;
            }
        }
        const xm = new Kl, wm = new xl, bm = new xl;
        class Tm extends Mm {
            constructor(){
                super(new Qu(90, 1, .5, 500)), this.isPointLightShadow = !0, this._frameExtents = new Qo(4, 2), this._viewportCount = 6, this._viewports = [
                    new dl(2, 1, 1, 1),
                    new dl(0, 1, 1, 1),
                    new dl(3, 1, 1, 1),
                    new dl(1, 1, 1, 1),
                    new dl(3, 0, 1, 1),
                    new dl(1, 0, 1, 1)
                ], this._cubeDirections = [
                    new xl(1, 0, 0),
                    new xl(-1, 0, 0),
                    new xl(0, 0, 1),
                    new xl(0, 0, -1),
                    new xl(0, 1, 0),
                    new xl(0, -1, 0)
                ], this._cubeUps = [
                    new xl(0, 1, 0),
                    new xl(0, 1, 0),
                    new xl(0, 1, 0),
                    new xl(0, 1, 0),
                    new xl(0, 0, 1),
                    new xl(0, 0, -1)
                ];
            }
            updateMatrices(t1, e = 0) {
                const i = this.camera, n = this.matrix, r = t1.distance || i.far;
                r !== i.far && (i.far = r, i.updateProjectionMatrix()), wm.setFromMatrixPosition(t1.matrixWorld), i.position.copy(wm), bm.copy(i.position), bm.add(this._cubeDirections[e]), i.up.copy(this._cubeUps[e]), i.lookAt(bm), i.updateMatrixWorld(), n.makeTranslation(-wm.x, -wm.y, -wm.z), xm.multiplyMatrices(i.projectionMatrix, i.matrixWorldInverse), this._frustum.setFromProjectionMatrix(xm);
            }
        }
        class Em extends pm {
            constructor(t1, e, i = 0, n = 2){
                super(t1, e), this.isPointLight = !0, this.type = "PointLight", this.distance = i, this.decay = n, this.shadow = new Tm;
            }
            get power() {
                return 4 * this.intensity * Math.PI;
            }
            set power(t1) {
                this.intensity = t1 / (4 * Math.PI);
            }
            dispose() {
                this.shadow.dispose();
            }
            copy(t1, e) {
                return super.copy(t1, e), this.distance = t1.distance, this.decay = t1.decay, this.shadow = t1.shadow.clone(), this;
            }
        }
        class Im extends Mm {
            constructor(){
                super(new ph(-5, 5, 5, -5, .5, 500)), this.isDirectionalLightShadow = !0;
            }
        }
        class Sm extends pm {
            constructor(t1, e){
                super(t1, e), this.isDirectionalLight = !0, this.type = "DirectionalLight", this.position.copy(wc.DEFAULT_UP), this.updateMatrix(), this.target = new wc, this.shadow = new Im;
            }
            dispose() {
                this.shadow.dispose();
            }
            copy(t1) {
                return super.copy(t1), this.target = t1.target.clone(), this.shadow = t1.shadow.clone(), this;
            }
        }
        class Nm extends pm {
            constructor(t1, e){
                super(t1, e), this.isAmbientLight = !0, this.type = "AmbientLight";
            }
        }
        class Dm extends pm {
            constructor(t1, e, i = 10, n = 10){
                super(t1, e), this.isRectAreaLight = !0, this.type = "RectAreaLight", this.width = i, this.height = n;
            }
            get power() {
                return this.intensity * this.width * this.height * Math.PI;
            }
            set power(t1) {
                this.intensity = t1 / (this.width * this.height * Math.PI);
            }
            copy(t1) {
                return super.copy(t1), this.width = t1.width, this.height = t1.height, this;
            }
            toJSON(t1) {
                const e = super.toJSON(t1);
                return e.object.width = this.width, e.object.height = this.height, e;
            }
        }
        class Cm {
            constructor(){
                this.isSphericalHarmonics3 = !0, this.coefficients = [];
                for(let t1 = 0; t1 < 9; t1++)this.coefficients.push(new xl);
            }
            set(t1) {
                for(let e = 0; e < 9; e++)this.coefficients[e].copy(t1[e]);
                return this;
            }
            zero() {
                for(let t1 = 0; t1 < 9; t1++)this.coefficients[t1].set(0, 0, 0);
                return this;
            }
            getAt(t1, e) {
                const i = t1.x, n = t1.y, r = t1.z, a = this.coefficients;
                return e.copy(a[0]).multiplyScalar(.282095), e.addScaledVector(a[1], .488603 * n), e.addScaledVector(a[2], .488603 * r), e.addScaledVector(a[3], .488603 * i), e.addScaledVector(a[4], i * n * 1.092548), e.addScaledVector(a[5], n * r * 1.092548), e.addScaledVector(a[6], .315392 * (3 * r * r - 1)), e.addScaledVector(a[7], i * r * 1.092548), e.addScaledVector(a[8], .546274 * (i * i - n * n)), e;
            }
            getIrradianceAt(t1, e) {
                const i = t1.x, n = t1.y, r = t1.z, a = this.coefficients;
                return e.copy(a[0]).multiplyScalar(.886227), e.addScaledVector(a[1], 1.023328 * n), e.addScaledVector(a[2], 1.023328 * r), e.addScaledVector(a[3], 1.023328 * i), e.addScaledVector(a[4], .858086 * i * n), e.addScaledVector(a[5], .858086 * n * r), e.addScaledVector(a[6], .743125 * r * r - .247708), e.addScaledVector(a[7], .858086 * i * r), e.addScaledVector(a[8], .429043 * (i * i - n * n)), e;
            }
            add(t1) {
                for(let e = 0; e < 9; e++)this.coefficients[e].add(t1.coefficients[e]);
                return this;
            }
            addScaledSH(t1, e) {
                for(let i = 0; i < 9; i++)this.coefficients[i].addScaledVector(t1.coefficients[i], e);
                return this;
            }
            scale(t1) {
                for(let e = 0; e < 9; e++)this.coefficients[e].multiplyScalar(t1);
                return this;
            }
            lerp(t1, e) {
                for(let i = 0; i < 9; i++)this.coefficients[i].lerp(t1.coefficients[i], e);
                return this;
            }
            equals(t1) {
                for(let e = 0; e < 9; e++)if (!this.coefficients[e].equals(t1.coefficients[e])) return !1;
                return !0;
            }
            copy(t1) {
                return this.set(t1.coefficients);
            }
            clone() {
                return (new this.constructor).copy(this);
            }
            fromArray(t1, e = 0) {
                const i = this.coefficients;
                for(let n = 0; n < 9; n++)i[n].fromArray(t1, e + 3 * n);
                return this;
            }
            toArray(t1 = [], e = 0) {
                const i = this.coefficients;
                for(let n = 0; n < 9; n++)i[n].toArray(t1, e + 3 * n);
                return t1;
            }
            static getBasisAt(t1, e) {
                const i = t1.x, n = t1.y, r = t1.z;
                e[0] = .282095, e[1] = .488603 * n, e[2] = .488603 * r, e[3] = .488603 * i, e[4] = 1.092548 * i * n, e[5] = 1.092548 * n * r, e[6] = .315392 * (3 * r * r - 1), e[7] = 1.092548 * i * r, e[8] = .546274 * (i * i - n * n);
            }
        }
        class zm extends pm {
            constructor(t1 = new Cm, e = 1){
                super(void 0, e), this.isLightProbe = !0, this.sh = t1;
            }
            copy(t1) {
                return super.copy(t1), this.sh.copy(t1.sh), this;
            }
            fromJSON(t1) {
                return this.intensity = t1.intensity, this.sh.fromArray(t1.sh), this;
            }
            toJSON(t1) {
                const e = super.toJSON(t1);
                return e.object.sh = this.sh.toArray(), e;
            }
        }
        class Lm extends nm {
            constructor(t1){
                super(t1), this.textures = {};
            }
            load(t1, e, i, n) {
                const r = this, a = new sm(r.manager);
                a.setPath(r.path), a.setRequestHeader(r.requestHeader), a.setWithCredentials(r.withCredentials), a.load(t1, function(i) {
                    try {
                        e(r.parse(JSON.parse(i)));
                    } catch (e) {
                        n ? n(e) : console.error(e), r.manager.itemError(t1);
                    }
                }, i, n);
            }
            parse(t1) {
                const e = this.textures;
                function i(t1) {
                    return void 0 === e[t1] && console.warn("THREE.MaterialLoader: Undefined texture", t1), e[t1];
                }
                const n = Lm.createMaterialFromType(t1.type);
                if (void 0 !== t1.uuid && (n.uuid = t1.uuid), void 0 !== t1.name && (n.name = t1.name), void 0 !== t1.color && void 0 !== n.color && n.color.setHex(t1.color), void 0 !== t1.roughness && (n.roughness = t1.roughness), void 0 !== t1.metalness && (n.metalness = t1.metalness), void 0 !== t1.sheen && (n.sheen = t1.sheen), void 0 !== t1.sheenColor && (n.sheenColor = (new kc).setHex(t1.sheenColor)), void 0 !== t1.sheenRoughness && (n.sheenRoughness = t1.sheenRoughness), void 0 !== t1.emissive && void 0 !== n.emissive && n.emissive.setHex(t1.emissive), void 0 !== t1.specular && void 0 !== n.specular && n.specular.setHex(t1.specular), void 0 !== t1.specularIntensity && (n.specularIntensity = t1.specularIntensity), void 0 !== t1.specularColor && void 0 !== n.specularColor && n.specularColor.setHex(t1.specularColor), void 0 !== t1.shininess && (n.shininess = t1.shininess), void 0 !== t1.clearcoat && (n.clearcoat = t1.clearcoat), void 0 !== t1.clearcoatRoughness && (n.clearcoatRoughness = t1.clearcoatRoughness), void 0 !== t1.iridescence && (n.iridescence = t1.iridescence), void 0 !== t1.iridescenceIOR && (n.iridescenceIOR = t1.iridescenceIOR), void 0 !== t1.iridescenceThicknessRange && (n.iridescenceThicknessRange = t1.iridescenceThicknessRange), void 0 !== t1.transmission && (n.transmission = t1.transmission), void 0 !== t1.thickness && (n.thickness = t1.thickness), void 0 !== t1.attenuationDistance && (n.attenuationDistance = t1.attenuationDistance), void 0 !== t1.attenuationColor && void 0 !== n.attenuationColor && n.attenuationColor.setHex(t1.attenuationColor), void 0 !== t1.anisotropy && (n.anisotropy = t1.anisotropy), void 0 !== t1.anisotropyRotation && (n.anisotropyRotation = t1.anisotropyRotation), void 0 !== t1.fog && (n.fog = t1.fog), void 0 !== t1.flatShading && (n.flatShading = t1.flatShading), void 0 !== t1.blending && (n.blending = t1.blending), void 0 !== t1.combine && (n.combine = t1.combine), void 0 !== t1.side && (n.side = t1.side), void 0 !== t1.shadowSide && (n.shadowSide = t1.shadowSide), void 0 !== t1.opacity && (n.opacity = t1.opacity), void 0 !== t1.transparent && (n.transparent = t1.transparent), void 0 !== t1.alphaTest && (n.alphaTest = t1.alphaTest), void 0 !== t1.alphaHash && (n.alphaHash = t1.alphaHash), void 0 !== t1.depthFunc && (n.depthFunc = t1.depthFunc), void 0 !== t1.depthTest && (n.depthTest = t1.depthTest), void 0 !== t1.depthWrite && (n.depthWrite = t1.depthWrite), void 0 !== t1.colorWrite && (n.colorWrite = t1.colorWrite), void 0 !== t1.blendSrc && (n.blendSrc = t1.blendSrc), void 0 !== t1.blendDst && (n.blendDst = t1.blendDst), void 0 !== t1.blendEquation && (n.blendEquation = t1.blendEquation), void 0 !== t1.blendSrcAlpha && (n.blendSrcAlpha = t1.blendSrcAlpha), void 0 !== t1.blendDstAlpha && (n.blendDstAlpha = t1.blendDstAlpha), void 0 !== t1.blendEquationAlpha && (n.blendEquationAlpha = t1.blendEquationAlpha), void 0 !== t1.blendColor && void 0 !== n.blendColor && n.blendColor.setHex(t1.blendColor), void 0 !== t1.blendAlpha && (n.blendAlpha = t1.blendAlpha), void 0 !== t1.stencilWriteMask && (n.stencilWriteMask = t1.stencilWriteMask), void 0 !== t1.stencilFunc && (n.stencilFunc = t1.stencilFunc), void 0 !== t1.stencilRef && (n.stencilRef = t1.stencilRef), void 0 !== t1.stencilFuncMask && (n.stencilFuncMask = t1.stencilFuncMask), void 0 !== t1.stencilFail && (n.stencilFail = t1.stencilFail), void 0 !== t1.stencilZFail && (n.stencilZFail = t1.stencilZFail), void 0 !== t1.stencilZPass && (n.stencilZPass = t1.stencilZPass), void 0 !== t1.stencilWrite && (n.stencilWrite = t1.stencilWrite), void 0 !== t1.wireframe && (n.wireframe = t1.wireframe), void 0 !== t1.wireframeLinewidth && (n.wireframeLinewidth = t1.wireframeLinewidth), void 0 !== t1.wireframeLinecap && (n.wireframeLinecap = t1.wireframeLinecap), void 0 !== t1.wireframeLinejoin && (n.wireframeLinejoin = t1.wireframeLinejoin), void 0 !== t1.rotation && (n.rotation = t1.rotation), void 0 !== t1.linewidth && (n.linewidth = t1.linewidth), void 0 !== t1.dashSize && (n.dashSize = t1.dashSize), void 0 !== t1.gapSize && (n.gapSize = t1.gapSize), void 0 !== t1.scale && (n.scale = t1.scale), void 0 !== t1.polygonOffset && (n.polygonOffset = t1.polygonOffset), void 0 !== t1.polygonOffsetFactor && (n.polygonOffsetFactor = t1.polygonOffsetFactor), void 0 !== t1.polygonOffsetUnits && (n.polygonOffsetUnits = t1.polygonOffsetUnits), void 0 !== t1.dithering && (n.dithering = t1.dithering), void 0 !== t1.alphaToCoverage && (n.alphaToCoverage = t1.alphaToCoverage), void 0 !== t1.premultipliedAlpha && (n.premultipliedAlpha = t1.premultipliedAlpha), void 0 !== t1.forceSinglePass && (n.forceSinglePass = t1.forceSinglePass), void 0 !== t1.visible && (n.visible = t1.visible), void 0 !== t1.toneMapped && (n.toneMapped = t1.toneMapped), void 0 !== t1.userData && (n.userData = t1.userData), void 0 !== t1.vertexColors && ("number" == typeof t1.vertexColors ? n.vertexColors = t1.vertexColors > 0 : n.vertexColors = t1.vertexColors), void 0 !== t1.uniforms) for(const e in t1.uniforms){
                    const r = t1.uniforms[e];
                    switch(n.uniforms[e] = {}, r.type){
                        case "t":
                            n.uniforms[e].value = i(r.value);
                            break;
                        case "c":
                            n.uniforms[e].value = (new kc).setHex(r.value);
                            break;
                        case "v2":
                            n.uniforms[e].value = (new Qo).fromArray(r.value);
                            break;
                        case "v3":
                            n.uniforms[e].value = (new xl).fromArray(r.value);
                            break;
                        case "v4":
                            n.uniforms[e].value = (new dl).fromArray(r.value);
                            break;
                        case "m3":
                            n.uniforms[e].value = (new Ho).fromArray(r.value);
                            break;
                        case "m4":
                            n.uniforms[e].value = (new Kl).fromArray(r.value);
                            break;
                        default:
                            n.uniforms[e].value = r.value;
                    }
                }
                if (void 0 !== t1.defines && (n.defines = t1.defines), void 0 !== t1.vertexShader && (n.vertexShader = t1.vertexShader), void 0 !== t1.fragmentShader && (n.fragmentShader = t1.fragmentShader), void 0 !== t1.glslVersion && (n.glslVersion = t1.glslVersion), void 0 !== t1.extensions) for(const e in t1.extensions)n.extensions[e] = t1.extensions[e];
                if (void 0 !== t1.lights && (n.lights = t1.lights), void 0 !== t1.clipping && (n.clipping = t1.clipping), void 0 !== t1.size && (n.size = t1.size), void 0 !== t1.sizeAttenuation && (n.sizeAttenuation = t1.sizeAttenuation), void 0 !== t1.map && (n.map = i(t1.map)), void 0 !== t1.matcap && (n.matcap = i(t1.matcap)), void 0 !== t1.alphaMap && (n.alphaMap = i(t1.alphaMap)), void 0 !== t1.bumpMap && (n.bumpMap = i(t1.bumpMap)), void 0 !== t1.bumpScale && (n.bumpScale = t1.bumpScale), void 0 !== t1.normalMap && (n.normalMap = i(t1.normalMap)), void 0 !== t1.normalMapType && (n.normalMapType = t1.normalMapType), void 0 !== t1.normalScale) {
                    let e = t1.normalScale;
                    !1 === Array.isArray(e) && (e = [
                        e,
                        e
                    ]), n.normalScale = (new Qo).fromArray(e);
                }
                return void 0 !== t1.displacementMap && (n.displacementMap = i(t1.displacementMap)), void 0 !== t1.displacementScale && (n.displacementScale = t1.displacementScale), void 0 !== t1.displacementBias && (n.displacementBias = t1.displacementBias), void 0 !== t1.roughnessMap && (n.roughnessMap = i(t1.roughnessMap)), void 0 !== t1.metalnessMap && (n.metalnessMap = i(t1.metalnessMap)), void 0 !== t1.emissiveMap && (n.emissiveMap = i(t1.emissiveMap)), void 0 !== t1.emissiveIntensity && (n.emissiveIntensity = t1.emissiveIntensity), void 0 !== t1.specularMap && (n.specularMap = i(t1.specularMap)), void 0 !== t1.specularIntensityMap && (n.specularIntensityMap = i(t1.specularIntensityMap)), void 0 !== t1.specularColorMap && (n.specularColorMap = i(t1.specularColorMap)), void 0 !== t1.envMap && (n.envMap = i(t1.envMap)), void 0 !== t1.envMapIntensity && (n.envMapIntensity = t1.envMapIntensity), void 0 !== t1.reflectivity && (n.reflectivity = t1.reflectivity), void 0 !== t1.refractionRatio && (n.refractionRatio = t1.refractionRatio), void 0 !== t1.lightMap && (n.lightMap = i(t1.lightMap)), void 0 !== t1.lightMapIntensity && (n.lightMapIntensity = t1.lightMapIntensity), void 0 !== t1.aoMap && (n.aoMap = i(t1.aoMap)), void 0 !== t1.aoMapIntensity && (n.aoMapIntensity = t1.aoMapIntensity), void 0 !== t1.gradientMap && (n.gradientMap = i(t1.gradientMap)), void 0 !== t1.clearcoatMap && (n.clearcoatMap = i(t1.clearcoatMap)), void 0 !== t1.clearcoatRoughnessMap && (n.clearcoatRoughnessMap = i(t1.clearcoatRoughnessMap)), void 0 !== t1.clearcoatNormalMap && (n.clearcoatNormalMap = i(t1.clearcoatNormalMap)), void 0 !== t1.clearcoatNormalScale && (n.clearcoatNormalScale = (new Qo).fromArray(t1.clearcoatNormalScale)), void 0 !== t1.iridescenceMap && (n.iridescenceMap = i(t1.iridescenceMap)), void 0 !== t1.iridescenceThicknessMap && (n.iridescenceThicknessMap = i(t1.iridescenceThicknessMap)), void 0 !== t1.transmissionMap && (n.transmissionMap = i(t1.transmissionMap)), void 0 !== t1.thicknessMap && (n.thicknessMap = i(t1.thicknessMap)), void 0 !== t1.anisotropyMap && (n.anisotropyMap = i(t1.anisotropyMap)), void 0 !== t1.sheenColorMap && (n.sheenColorMap = i(t1.sheenColorMap)), void 0 !== t1.sheenRoughnessMap && (n.sheenRoughnessMap = i(t1.sheenRoughnessMap)), n;
            }
            setTextures(t1) {
                return this.textures = t1, this;
            }
            static createMaterialFromType(t1) {
                return new ({
                    ShadowMaterial: Tg,
                    SpriteMaterial: Qp,
                    RawShaderMaterial: Eg,
                    ShaderMaterial: Bu,
                    PointsMaterial: Hf,
                    MeshPhysicalMaterial: Sg,
                    MeshStandardMaterial: Ig,
                    MeshPhongMaterial: Ng,
                    MeshToonMaterial: Dg,
                    MeshNormalMaterial: Cg,
                    MeshLambertMaterial: zg,
                    MeshDepthMaterial: vp,
                    MeshDistanceMaterial: xp,
                    MeshBasicMaterial: Hc,
                    MeshMatcapMaterial: Lg,
                    LineDashedMaterial: Og,
                    LineBasicMaterial: Lf,
                    Material: Qc
                })[t1];
            }
        }
        class Om {
            static decodeText(t1) {
                if ("undefined" != typeof TextDecoder) return (new TextDecoder).decode(t1);
                let e = "";
                for(let i = 0, n = t1.length; i < n; i++)e += String.fromCharCode(t1[i]);
                try {
                    return decodeURIComponent(escape(e));
                } catch (t1) {
                    return e;
                }
            }
            static extractUrlBase(t1) {
                const e = t1.lastIndexOf("/");
                return -1 === e ? "./" : t1.slice(0, e + 1);
            }
            static resolveURL(t1, e) {
                return "string" != typeof t1 || "" === t1 ? "" : (/^https?:\/\//i.test(e) && /^\//.test(t1) && (e = e.replace(/(^https?:\/\/[^\/]+).*/i, "$1")), /^(https?:)?\/\//i.test(t1) || /^data:.*,.*$/i.test(t1) || /^blob:.*$/i.test(t1) ? t1 : e + t1);
            }
        }
        class _m extends Au {
            constructor(){
                super(), this.isInstancedBufferGeometry = !0, this.type = "InstancedBufferGeometry", this.instanceCount = 1 / 0;
            }
            copy(t1) {
                return super.copy(t1), this.instanceCount = t1.instanceCount, this;
            }
            toJSON() {
                const t1 = super.toJSON();
                return t1.instanceCount = this.instanceCount, t1.isInstancedBufferGeometry = !0, t1;
            }
        }
        class jm extends nm {
            constructor(t1){
                super(t1);
            }
            load(t1, e, i, n) {
                const r = this, a = new sm(r.manager);
                a.setPath(r.path), a.setRequestHeader(r.requestHeader), a.setWithCredentials(r.withCredentials), a.load(t1, function(i) {
                    try {
                        e(r.parse(JSON.parse(i)));
                    } catch (e) {
                        n ? n(e) : console.error(e), r.manager.itemError(t1);
                    }
                }, i, n);
            }
            parse(t1) {
                const e = {}, i = {};
                function n(t1, n) {
                    if (void 0 !== e[n]) return e[n];
                    const r = t1.interleavedBuffers[n], a = function(t1, e) {
                        if (void 0 !== i[e]) return i[e];
                        const n = t1.arrayBuffers[e], r = new Uint32Array(n).buffer;
                        return i[e] = r, r;
                    }(t1, r.buffer), s = Wo(r.type, a), o = new kp(s, r.stride);
                    return o.uuid = r.uuid, e[n] = o, o;
                }
                const r = t1.isInstancedBufferGeometry ? new _m : new Au, a = t1.data.index;
                if (void 0 !== a) {
                    const t1 = Wo(a.type, a.array);
                    r.setIndex(new Kc(t1, 1));
                }
                const s = t1.data.attributes;
                for(const e in s){
                    const i = s[e];
                    let a;
                    if (i.isInterleavedBufferAttribute) {
                        const e = n(t1.data, i.data);
                        a = new Fp(e, i.itemSize, i.offset, i.normalized);
                    } else {
                        const t1 = Wo(i.type, i.array);
                        a = new (i.isInstancedBufferAttribute ? bf : Kc)(t1, i.itemSize, i.normalized);
                    }
                    void 0 !== i.name && (a.name = i.name), void 0 !== i.usage && a.setUsage(i.usage), void 0 !== i.updateRange && (a.updateRange.offset = i.updateRange.offset, a.updateRange.count = i.updateRange.count), r.setAttribute(e, a);
                }
                const o = t1.data.morphAttributes;
                if (o) for(const e in o){
                    const i = o[e], a = [];
                    for(let e = 0, r = i.length; e < r; e++){
                        const r = i[e];
                        let s;
                        if (r.isInterleavedBufferAttribute) {
                            const e = n(t1.data, r.data);
                            s = new Fp(e, r.itemSize, r.offset, r.normalized);
                        } else {
                            const t1 = Wo(r.type, r.array);
                            s = new Kc(t1, r.itemSize, r.normalized);
                        }
                        void 0 !== r.name && (s.name = r.name), a.push(s);
                    }
                    r.morphAttributes[e] = a;
                }
                t1.data.morphTargetsRelative && (r.morphTargetsRelative = !0);
                const l = t1.data.groups || t1.data.drawcalls || t1.data.offsets;
                if (void 0 !== l) for(let t1 = 0, e = l.length; t1 !== e; ++t1){
                    const e = l[t1];
                    r.addGroup(e.start, e.count, e.materialIndex);
                }
                const c = t1.data.boundingSphere;
                if (void 0 !== c) {
                    const t1 = new xl;
                    void 0 !== c.center && t1.fromArray(c.center), r.boundingSphere = new Ql(t1, c.radius);
                }
                return t1.name && (r.name = t1.name), t1.userData && (r.userData = t1.userData), r;
            }
        }
        class Pm extends nm {
            constructor(t1){
                super(t1);
            }
            load(t1, e, i, n) {
                const r = this, a = "" === this.path ? Om.extractUrlBase(t1) : this.path;
                this.resourcePath = this.resourcePath || a;
                const s = new sm(this.manager);
                s.setPath(this.path), s.setRequestHeader(this.requestHeader), s.setWithCredentials(this.withCredentials), s.load(t1, function(i) {
                    let a = null;
                    try {
                        a = JSON.parse(i);
                    } catch (e) {
                        return void 0 !== n && n(e), void console.error("THREE:ObjectLoader: Can't parse " + t1 + ".", e.message);
                    }
                    const s = a.metadata;
                    if (void 0 === s || void 0 === s.type || "geometry" === s.type.toLowerCase()) return void 0 !== n && n(new Error("THREE.ObjectLoader: Can't load " + t1)), void console.error("THREE.ObjectLoader: Can't load " + t1);
                    r.parse(a, e);
                }, i, n);
            }
            async loadAsync(t1, e) {
                const i = "" === this.path ? Om.extractUrlBase(t1) : this.path;
                this.resourcePath = this.resourcePath || i;
                const n = new sm(this.manager);
                n.setPath(this.path), n.setRequestHeader(this.requestHeader), n.setWithCredentials(this.withCredentials);
                const r = await n.loadAsync(t1, e), a = JSON.parse(r), s = a.metadata;
                if (void 0 === s || void 0 === s.type || "geometry" === s.type.toLowerCase()) throw new Error("THREE.ObjectLoader: Can't load " + t1);
                return await this.parseAsync(a);
            }
            parse(t1, e) {
                const i = this.parseAnimations(t1.animations), n = this.parseShapes(t1.shapes), r = this.parseGeometries(t1.geometries, n), a = this.parseImages(t1.images, function() {
                    void 0 !== e && e(l);
                }), s = this.parseTextures(t1.textures, a), o = this.parseMaterials(t1.materials, s), l = this.parseObject(t1.object, r, o, s, i), c = this.parseSkeletons(t1.skeletons, l);
                if (this.bindSkeletons(l, c), void 0 !== e) {
                    let t1 = !1;
                    for(const e in a)if (a[e].data instanceof HTMLImageElement) {
                        t1 = !0;
                        break;
                    }
                    !1 === t1 && e(l);
                }
                return l;
            }
            async parseAsync(t1) {
                const e = this.parseAnimations(t1.animations), i = this.parseShapes(t1.shapes), n = this.parseGeometries(t1.geometries, i), r = await this.parseImagesAsync(t1.images), a = this.parseTextures(t1.textures, r), s = this.parseMaterials(t1.materials, a), o = this.parseObject(t1.object, n, s, a, e), l = this.parseSkeletons(t1.skeletons, o);
                return this.bindSkeletons(o, l), o;
            }
            parseShapes(t1) {
                const e = {};
                if (void 0 !== t1) for(let i = 0, n = t1.length; i < n; i++){
                    const n = (new PA).fromJSON(t1[i]);
                    e[n.uuid] = n;
                }
                return e;
            }
            parseSkeletons(t1, e) {
                const i = {}, n = {};
                if (e.traverse(function(t1) {
                    t1.isBone && (n[t1.uuid] = t1);
                }), void 0 !== t1) for(let e = 0, r = t1.length; e < r; e++){
                    const r = (new wf).fromJSON(t1[e], n);
                    i[r.uuid] = r;
                }
                return i;
            }
            parseGeometries(t1, e) {
                const i = {};
                if (void 0 !== t1) {
                    const n = new jm;
                    for(let r = 0, a = t1.length; r < a; r++){
                        let a;
                        const s = t1[r];
                        switch(s.type){
                            case "BufferGeometry":
                            case "InstancedBufferGeometry":
                                a = n.parse(s);
                                break;
                            default:
                                s.type in bg ? a = bg[s.type].fromJSON(s, e) : console.warn(`THREE.ObjectLoader: Unsupported geometry type "${s.type}"`);
                        }
                        a.uuid = s.uuid, void 0 !== s.name && (a.name = s.name), void 0 !== s.userData && (a.userData = s.userData), i[s.uuid] = a;
                    }
                }
                return i;
            }
            parseMaterials(t1, e) {
                const i = {}, n = {};
                if (void 0 !== t1) {
                    const r = new Lm;
                    r.setTextures(e);
                    for(let e = 0, a = t1.length; e < a; e++){
                        const a = t1[e];
                        void 0 === i[a.uuid] && (i[a.uuid] = r.parse(a)), n[a.uuid] = i[a.uuid];
                    }
                }
                return n;
            }
            parseAnimations(t1) {
                const e = {};
                if (void 0 !== t1) for(let i = 0; i < t1.length; i++){
                    const n = t1[i], r = qg.parse(n);
                    e[r.uuid] = r;
                }
                return e;
            }
            parseImages(t1, e) {
                const i = this, n = {};
                let r;
                function a(t1) {
                    if ("string" == typeof t1) {
                        const e = t1;
                        return function(t1) {
                            return i.manager.itemStart(t1), r.load(t1, function() {
                                i.manager.itemEnd(t1);
                            }, void 0, function() {
                                i.manager.itemError(t1), i.manager.itemEnd(t1);
                            });
                        }(/^(\/\/)|([a-z]+:(\/\/)?)/i.test(e) ? e : i.resourcePath + e);
                    }
                    return t1.data ? {
                        data: Wo(t1.type, t1.data),
                        width: t1.width,
                        height: t1.height
                    } : null;
                }
                if (void 0 !== t1 && t1.length > 0) {
                    const i = new em(e);
                    r = new cm(i), r.setCrossOrigin(this.crossOrigin);
                    for(let e = 0, i = t1.length; e < i; e++){
                        const i = t1[e], r = i.url;
                        if (Array.isArray(r)) {
                            const t1 = [];
                            for(let e = 0, i = r.length; e < i; e++){
                                const i = a(r[e]);
                                null !== i && (i instanceof HTMLImageElement ? t1.push(i) : t1.push(new yf(i.data, i.width, i.height)));
                            }
                            n[i.uuid] = new ll(t1);
                        } else {
                            const t1 = a(i.url);
                            n[i.uuid] = new ll(t1);
                        }
                    }
                }
                return n;
            }
            async parseImagesAsync(t1) {
                const e = this, i = {};
                let n;
                async function r(t1) {
                    if ("string" == typeof t1) {
                        const i = t1, r = /^(\/\/)|([a-z]+:(\/\/)?)/i.test(i) ? i : e.resourcePath + i;
                        return await n.loadAsync(r);
                    }
                    return t1.data ? {
                        data: Wo(t1.type, t1.data),
                        width: t1.width,
                        height: t1.height
                    } : null;
                }
                if (void 0 !== t1 && t1.length > 0) {
                    n = new cm(this.manager), n.setCrossOrigin(this.crossOrigin);
                    for(let e = 0, n = t1.length; e < n; e++){
                        const n = t1[e], a = n.url;
                        if (Array.isArray(a)) {
                            const t1 = [];
                            for(let e = 0, i = a.length; e < i; e++){
                                const i = a[e], n = await r(i);
                                null !== n && (n instanceof HTMLImageElement ? t1.push(n) : t1.push(new yf(n.data, n.width, n.height)));
                            }
                            i[n.uuid] = new ll(t1);
                        } else {
                            const t1 = await r(n.url);
                            i[n.uuid] = new ll(t1);
                        }
                    }
                }
                return i;
            }
            parseTextures(t1, e) {
                function i(t1, e) {
                    return "number" == typeof t1 ? t1 : (console.warn("THREE.ObjectLoader.parseTexture: Constant should be in numeric form.", t1), e[t1]);
                }
                const n = {};
                if (void 0 !== t1) for(let r = 0, a = t1.length; r < a; r++){
                    const a = t1[r];
                    void 0 === a.image && console.warn('THREE.ObjectLoader: No "image" specified for', a.uuid), void 0 === e[a.image] && console.warn("THREE.ObjectLoader: Undefined image", a.image);
                    const s = e[a.image], o = s.data;
                    let l;
                    Array.isArray(o) ? (l = new Gu, 6 === o.length && (l.needsUpdate = !0)) : (l = o && o.data ? new yf : new hl, o && (l.needsUpdate = !0)), l.source = s, l.uuid = a.uuid, void 0 !== a.name && (l.name = a.name), void 0 !== a.mapping && (l.mapping = i(a.mapping, Rm)), void 0 !== a.channel && (l.channel = a.channel), void 0 !== a.offset && l.offset.fromArray(a.offset), void 0 !== a.repeat && l.repeat.fromArray(a.repeat), void 0 !== a.center && l.center.fromArray(a.center), void 0 !== a.rotation && (l.rotation = a.rotation), void 0 !== a.wrap && (l.wrapS = i(a.wrap[0], Um), l.wrapT = i(a.wrap[1], Um)), void 0 !== a.format && (l.format = a.format), void 0 !== a.internalFormat && (l.internalFormat = a.internalFormat), void 0 !== a.type && (l.type = a.type), void 0 !== a.colorSpace && (l.colorSpace = a.colorSpace), void 0 !== a.encoding && (l.encoding = a.encoding), void 0 !== a.minFilter && (l.minFilter = i(a.minFilter, km)), void 0 !== a.magFilter && (l.magFilter = i(a.magFilter, km)), void 0 !== a.anisotropy && (l.anisotropy = a.anisotropy), void 0 !== a.flipY && (l.flipY = a.flipY), void 0 !== a.generateMipmaps && (l.generateMipmaps = a.generateMipmaps), void 0 !== a.premultiplyAlpha && (l.premultiplyAlpha = a.premultiplyAlpha), void 0 !== a.unpackAlignment && (l.unpackAlignment = a.unpackAlignment), void 0 !== a.compareFunction && (l.compareFunction = a.compareFunction), void 0 !== a.userData && (l.userData = a.userData), n[a.uuid] = l;
                }
                return n;
            }
            parseObject(t1, e, i, n, r) {
                let a, s, o;
                function l(t1) {
                    return void 0 === e[t1] && console.warn("THREE.ObjectLoader: Undefined geometry", t1), e[t1];
                }
                function c(t1) {
                    if (void 0 !== t1) {
                        if (Array.isArray(t1)) {
                            const e = [];
                            for(let n = 0, r = t1.length; n < r; n++){
                                const r = t1[n];
                                void 0 === i[r] && console.warn("THREE.ObjectLoader: Undefined material", r), e.push(i[r]);
                            }
                            return e;
                        }
                        return void 0 === i[t1] && console.warn("THREE.ObjectLoader: Undefined material", t1), i[t1];
                    }
                }
                function u(t1) {
                    return void 0 === n[t1] && console.warn("THREE.ObjectLoader: Undefined texture", t1), n[t1];
                }
                switch(t1.type){
                    case "Scene":
                        a = new Up, void 0 !== t1.background && (Number.isInteger(t1.background) ? a.background = new kc(t1.background) : a.background = u(t1.background)), void 0 !== t1.environment && (a.environment = u(t1.environment)), void 0 !== t1.fog && ("Fog" === t1.fog.type ? a.fog = new Rp(t1.fog.color, t1.fog.near, t1.fog.far) : "FogExp2" === t1.fog.type && (a.fog = new Pp(t1.fog.color, t1.fog.density)), "" !== t1.fog.name && (a.fog.name = t1.fog.name)), void 0 !== t1.backgroundBlurriness && (a.backgroundBlurriness = t1.backgroundBlurriness), void 0 !== t1.backgroundIntensity && (a.backgroundIntensity = t1.backgroundIntensity);
                        break;
                    case "PerspectiveCamera":
                        a = new Qu(t1.fov, t1.aspect, t1.near, t1.far), void 0 !== t1.focus && (a.focus = t1.focus), void 0 !== t1.zoom && (a.zoom = t1.zoom), void 0 !== t1.filmGauge && (a.filmGauge = t1.filmGauge), void 0 !== t1.filmOffset && (a.filmOffset = t1.filmOffset), void 0 !== t1.view && (a.view = Object.assign({}, t1.view));
                        break;
                    case "OrthographicCamera":
                        a = new ph(t1.left, t1.right, t1.top, t1.bottom, t1.near, t1.far), void 0 !== t1.zoom && (a.zoom = t1.zoom), void 0 !== t1.view && (a.view = Object.assign({}, t1.view));
                        break;
                    case "AmbientLight":
                        a = new Nm(t1.color, t1.intensity);
                        break;
                    case "DirectionalLight":
                        a = new Sm(t1.color, t1.intensity);
                        break;
                    case "PointLight":
                        a = new Em(t1.color, t1.intensity, t1.distance, t1.decay);
                        break;
                    case "RectAreaLight":
                        a = new Dm(t1.color, t1.intensity, t1.width, t1.height);
                        break;
                    case "SpotLight":
                        a = new vm(t1.color, t1.intensity, t1.distance, t1.angle, t1.penumbra, t1.decay);
                        break;
                    case "HemisphereLight":
                        a = new fm(t1.color, t1.groundColor, t1.intensity);
                        break;
                    case "LightProbe":
                        a = (new zm).fromJSON(t1);
                        break;
                    case "SkinnedMesh":
                        s = l(t1.geometry), o = c(t1.material), a = new mf(s, o), void 0 !== t1.bindMode && (a.bindMode = t1.bindMode), void 0 !== t1.bindMatrix && a.bindMatrix.fromArray(t1.bindMatrix), void 0 !== t1.skeleton && (a.skeleton = t1.skeleton);
                        break;
                    case "Mesh":
                        s = l(t1.geometry), o = c(t1.material), a = new Ou(s, o);
                        break;
                    case "InstancedMesh":
                        s = l(t1.geometry), o = c(t1.material);
                        const e1 = t1.count, i1 = t1.instanceMatrix, n1 = t1.instanceColor;
                        a = new zf(s, o, e1), a.instanceMatrix = new bf(new Float32Array(i1.array), 16), void 0 !== n1 && (a.instanceColor = new bf(new Float32Array(n1.array), n1.itemSize));
                        break;
                    case "LOD":
                        a = new of;
                        break;
                    case "Line":
                        a = new Uf(l(t1.geometry), c(t1.material));
                        break;
                    case "LineLoop":
                        a = new Qf(l(t1.geometry), c(t1.material));
                        break;
                    case "LineSegments":
                        a = new Ff(l(t1.geometry), c(t1.material));
                        break;
                    case "PointCloud":
                    case "Points":
                        a = new Xf(l(t1.geometry), c(t1.material));
                        break;
                    case "Sprite":
                        a = new nf(c(t1.material));
                        break;
                    case "Group":
                        a = new Sp;
                        break;
                    case "Bone":
                        a = new Mf;
                        break;
                    default:
                        a = new wc;
                }
                if (a.uuid = t1.uuid, void 0 !== t1.name && (a.name = t1.name), void 0 !== t1.matrix ? (a.matrix.fromArray(t1.matrix), void 0 !== t1.matrixAutoUpdate && (a.matrixAutoUpdate = t1.matrixAutoUpdate), a.matrixAutoUpdate && a.matrix.decompose(a.position, a.quaternion, a.scale)) : (void 0 !== t1.position && a.position.fromArray(t1.position), void 0 !== t1.rotation && a.rotation.fromArray(t1.rotation), void 0 !== t1.quaternion && a.quaternion.fromArray(t1.quaternion), void 0 !== t1.scale && a.scale.fromArray(t1.scale)), void 0 !== t1.up && a.up.fromArray(t1.up), void 0 !== t1.castShadow && (a.castShadow = t1.castShadow), void 0 !== t1.receiveShadow && (a.receiveShadow = t1.receiveShadow), t1.shadow && (void 0 !== t1.shadow.bias && (a.shadow.bias = t1.shadow.bias), void 0 !== t1.shadow.normalBias && (a.shadow.normalBias = t1.shadow.normalBias), void 0 !== t1.shadow.radius && (a.shadow.radius = t1.shadow.radius), void 0 !== t1.shadow.mapSize && a.shadow.mapSize.fromArray(t1.shadow.mapSize), void 0 !== t1.shadow.camera && (a.shadow.camera = this.parseObject(t1.shadow.camera))), void 0 !== t1.visible && (a.visible = t1.visible), void 0 !== t1.frustumCulled && (a.frustumCulled = t1.frustumCulled), void 0 !== t1.renderOrder && (a.renderOrder = t1.renderOrder), void 0 !== t1.userData && (a.userData = t1.userData), void 0 !== t1.layers && (a.layers.mask = t1.layers), void 0 !== t1.children) {
                    const s = t1.children;
                    for(let t1 = 0; t1 < s.length; t1++)a.add(this.parseObject(s[t1], e, i, n, r));
                }
                if (void 0 !== t1.animations) {
                    const e = t1.animations;
                    for(let t1 = 0; t1 < e.length; t1++){
                        const i = e[t1];
                        a.animations.push(r[i]);
                    }
                }
                if ("LOD" === t1.type) {
                    void 0 !== t1.autoUpdate && (a.autoUpdate = t1.autoUpdate);
                    const e = t1.levels;
                    for(let t1 = 0; t1 < e.length; t1++){
                        const i = e[t1], n = a.getObjectByProperty("uuid", i.object);
                        void 0 !== n && a.addLevel(n, i.distance, i.hysteresis);
                    }
                }
                return a;
            }
            bindSkeletons(t1, e) {
                0 !== Object.keys(e).length && t1.traverse(function(t1) {
                    if (!0 === t1.isSkinnedMesh && void 0 !== t1.skeleton) {
                        const i = e[t1.skeleton];
                        void 0 === i ? console.warn("THREE.ObjectLoader: No skeleton found with UUID:", t1.skeleton) : t1.bind(i, t1.bindMatrix);
                    }
                });
            }
        }
        const Rm = {
            UVMapping: Xr,
            CubeReflectionMapping: Zr,
            CubeRefractionMapping: Jr,
            EquirectangularReflectionMapping: Kr,
            EquirectangularRefractionMapping: qr,
            CubeUVReflectionMapping: $r
        }, Um = {
            RepeatWrapping: ta,
            ClampToEdgeWrapping: ea,
            MirroredRepeatWrapping: ia
        }, km = {
            NearestFilter: na,
            NearestMipmapNearestFilter: ra,
            NearestMipmapLinearFilter: sa,
            LinearFilter: la,
            LinearMipmapNearestFilter: ca,
            LinearMipmapLinearFilter: ha
        };
        class Bm extends nm {
            constructor(t1){
                super(t1), this.isImageBitmapLoader = !0, "undefined" == typeof createImageBitmap && console.warn("THREE.ImageBitmapLoader: createImageBitmap() not supported."), "undefined" == typeof fetch && console.warn("THREE.ImageBitmapLoader: fetch() not supported."), this.options = {
                    premultiplyAlpha: "none"
                };
            }
            setOptions(t1) {
                return this.options = t1, this;
            }
            load(t1, e, i, n) {
                void 0 === t1 && (t1 = ""), void 0 !== this.path && (t1 = this.path + t1), t1 = this.manager.resolveURL(t1);
                const r = this, a = tm.get(t1);
                if (void 0 !== a) return r.manager.itemStart(t1), setTimeout(function() {
                    e && e(a), r.manager.itemEnd(t1);
                }, 0), a;
                const s = {};
                s.credentials = "anonymous" === this.crossOrigin ? "same-origin" : "include", s.headers = this.requestHeader, fetch(t1, s).then(function(t1) {
                    return t1.blob();
                }).then(function(t1) {
                    return createImageBitmap(t1, Object.assign(r.options, {
                        colorSpaceConversion: "none"
                    }));
                }).then(function(i) {
                    tm.add(t1, i), e && e(i), r.manager.itemEnd(t1);
                }).catch(function(e) {
                    n && n(e), r.manager.itemError(t1), r.manager.itemEnd(t1);
                }), r.manager.itemStart(t1);
            }
        }
        let Fm;
        class Qm {
            static getContext() {
                return void 0 === Fm && (Fm = new (window.AudioContext || window.webkitAudioContext)), Fm;
            }
            static setContext(t1) {
                Fm = t1;
            }
        }
        class Hm extends nm {
            constructor(t1){
                super(t1);
            }
            load(t1, e, i, n) {
                const r = this, a = new sm(this.manager);
                function s(e) {
                    n ? n(e) : console.error(e), r.manager.itemError(t1);
                }
                a.setResponseType("arraybuffer"), a.setPath(this.path), a.setRequestHeader(this.requestHeader), a.setWithCredentials(this.withCredentials), a.load(t1, function(t1) {
                    try {
                        const i = t1.slice(0);
                        Qm.getContext().decodeAudioData(i, function(t1) {
                            e(t1);
                        }, s);
                    } catch (t1) {
                        s(t1);
                    }
                }, i, n);
            }
        }
        const Vm = new Kl, Gm = new Kl, Ym = new Kl;
        class Wm {
            constructor(){
                this.type = "StereoCamera", this.aspect = 1, this.eyeSep = .064, this.cameraL = new Qu, this.cameraL.layers.enable(1), this.cameraL.matrixAutoUpdate = !1, this.cameraR = new Qu, this.cameraR.layers.enable(2), this.cameraR.matrixAutoUpdate = !1, this._cache = {
                    focus: null,
                    fov: null,
                    aspect: null,
                    near: null,
                    far: null,
                    zoom: null,
                    eyeSep: null
                };
            }
            update(t1) {
                const e = this._cache;
                if (e.focus !== t1.focus || e.fov !== t1.fov || e.aspect !== t1.aspect * this.aspect || e.near !== t1.near || e.far !== t1.far || e.zoom !== t1.zoom || e.eyeSep !== this.eyeSep) {
                    e.focus = t1.focus, e.fov = t1.fov, e.aspect = t1.aspect * this.aspect, e.near = t1.near, e.far = t1.far, e.zoom = t1.zoom, e.eyeSep = this.eyeSep, Ym.copy(t1.projectionMatrix);
                    const i = e.eyeSep / 2, n = i * e.near / e.focus, r = e.near * Math.tan(Co * e.fov * .5) / e.zoom;
                    let a, s;
                    Gm.elements[12] = -i, Vm.elements[12] = i, a = -r * e.aspect + n, s = r * e.aspect + n, Ym.elements[0] = 2 * e.near / (s - a), Ym.elements[8] = (s + a) / (s - a), this.cameraL.projectionMatrix.copy(Ym), a = -r * e.aspect - n, s = r * e.aspect - n, Ym.elements[0] = 2 * e.near / (s - a), Ym.elements[8] = (s + a) / (s - a), this.cameraR.projectionMatrix.copy(Ym);
                }
                this.cameraL.matrixWorld.copy(t1.matrixWorld).multiply(Gm), this.cameraR.matrixWorld.copy(t1.matrixWorld).multiply(Vm);
            }
        }
        class Xm {
            constructor(t1 = !0){
                this.autoStart = t1, this.startTime = 0, this.oldTime = 0, this.elapsedTime = 0, this.running = !1;
            }
            start() {
                this.startTime = Zm(), this.oldTime = this.startTime, this.elapsedTime = 0, this.running = !0;
            }
            stop() {
                this.getElapsedTime(), this.running = !1, this.autoStart = !1;
            }
            getElapsedTime() {
                return this.getDelta(), this.elapsedTime;
            }
            getDelta() {
                let t1 = 0;
                if (this.autoStart && !this.running) return this.start(), 0;
                if (this.running) {
                    const e = Zm();
                    t1 = (e - this.oldTime) / 1e3, this.oldTime = e, this.elapsedTime += t1;
                }
                return t1;
            }
        }
        function Zm() {
            return ("undefined" == typeof performance ? Date : performance).now();
        }
        const Jm = new xl, Km = new vl, qm = new xl, $m = new xl;
        class tM extends wc {
            constructor(){
                super(), this.type = "AudioListener", this.context = Qm.getContext(), this.gain = this.context.createGain(), this.gain.connect(this.context.destination), this.filter = null, this.timeDelta = 0, this._clock = new Xm;
            }
            getInput() {
                return this.gain;
            }
            removeFilter() {
                return null !== this.filter && (this.gain.disconnect(this.filter), this.filter.disconnect(this.context.destination), this.gain.connect(this.context.destination), this.filter = null), this;
            }
            getFilter() {
                return this.filter;
            }
            setFilter(t1) {
                return null !== this.filter ? (this.gain.disconnect(this.filter), this.filter.disconnect(this.context.destination)) : this.gain.disconnect(this.context.destination), this.filter = t1, this.gain.connect(this.filter), this.filter.connect(this.context.destination), this;
            }
            getMasterVolume() {
                return this.gain.gain.value;
            }
            setMasterVolume(t1) {
                return this.gain.gain.setTargetAtTime(t1, this.context.currentTime, .01), this;
            }
            updateMatrixWorld(t1) {
                super.updateMatrixWorld(t1);
                const e = this.context.listener, i = this.up;
                if (this.timeDelta = this._clock.getDelta(), this.matrixWorld.decompose(Jm, Km, qm), $m.set(0, 0, -1).applyQuaternion(Km), e.positionX) {
                    const t1 = this.context.currentTime + this.timeDelta;
                    e.positionX.linearRampToValueAtTime(Jm.x, t1), e.positionY.linearRampToValueAtTime(Jm.y, t1), e.positionZ.linearRampToValueAtTime(Jm.z, t1), e.forwardX.linearRampToValueAtTime($m.x, t1), e.forwardY.linearRampToValueAtTime($m.y, t1), e.forwardZ.linearRampToValueAtTime($m.z, t1), e.upX.linearRampToValueAtTime(i.x, t1), e.upY.linearRampToValueAtTime(i.y, t1), e.upZ.linearRampToValueAtTime(i.z, t1);
                } else e.setPosition(Jm.x, Jm.y, Jm.z), e.setOrientation($m.x, $m.y, $m.z, i.x, i.y, i.z);
            }
        }
        class eM extends wc {
            constructor(t1){
                super(), this.type = "Audio", this.listener = t1, this.context = t1.context, this.gain = this.context.createGain(), this.gain.connect(t1.getInput()), this.autoplay = !1, this.buffer = null, this.detune = 0, this.loop = !1, this.loopStart = 0, this.loopEnd = 0, this.offset = 0, this.duration = void 0, this.playbackRate = 1, this.isPlaying = !1, this.hasPlaybackControl = !0, this.source = null, this.sourceType = "empty", this._startedAt = 0, this._progress = 0, this._connected = !1, this.filters = [];
            }
            getOutput() {
                return this.gain;
            }
            setNodeSource(t1) {
                return this.hasPlaybackControl = !1, this.sourceType = "audioNode", this.source = t1, this.connect(), this;
            }
            setMediaElementSource(t1) {
                return this.hasPlaybackControl = !1, this.sourceType = "mediaNode", this.source = this.context.createMediaElementSource(t1), this.connect(), this;
            }
            setMediaStreamSource(t1) {
                return this.hasPlaybackControl = !1, this.sourceType = "mediaStreamNode", this.source = this.context.createMediaStreamSource(t1), this.connect(), this;
            }
            setBuffer(t1) {
                return this.buffer = t1, this.sourceType = "buffer", this.autoplay && this.play(), this;
            }
            play(t1 = 0) {
                if (!0 === this.isPlaying) return void console.warn("THREE.Audio: Audio is already playing.");
                if (!1 === this.hasPlaybackControl) return void console.warn("THREE.Audio: this Audio has no playback control.");
                this._startedAt = this.context.currentTime + t1;
                const e = this.context.createBufferSource();
                return e.buffer = this.buffer, e.loop = this.loop, e.loopStart = this.loopStart, e.loopEnd = this.loopEnd, e.onended = this.onEnded.bind(this), e.start(this._startedAt, this._progress + this.offset, this.duration), this.isPlaying = !0, this.source = e, this.setDetune(this.detune), this.setPlaybackRate(this.playbackRate), this.connect();
            }
            pause() {
                if (!1 !== this.hasPlaybackControl) return !0 === this.isPlaying && (this._progress += Math.max(this.context.currentTime - this._startedAt, 0) * this.playbackRate, !0 === this.loop && (this._progress = this._progress % (this.duration || this.buffer.duration)), this.source.stop(), this.source.onended = null, this.isPlaying = !1), this;
                console.warn("THREE.Audio: this Audio has no playback control.");
            }
            stop() {
                if (!1 !== this.hasPlaybackControl) return this._progress = 0, null !== this.source && (this.source.stop(), this.source.onended = null), this.isPlaying = !1, this;
                console.warn("THREE.Audio: this Audio has no playback control.");
            }
            connect() {
                if (this.filters.length > 0) {
                    this.source.connect(this.filters[0]);
                    for(let t1 = 1, e = this.filters.length; t1 < e; t1++)this.filters[t1 - 1].connect(this.filters[t1]);
                    this.filters[this.filters.length - 1].connect(this.getOutput());
                } else this.source.connect(this.getOutput());
                return this._connected = !0, this;
            }
            disconnect() {
                if (!1 !== this._connected) {
                    if (this.filters.length > 0) {
                        this.source.disconnect(this.filters[0]);
                        for(let t1 = 1, e = this.filters.length; t1 < e; t1++)this.filters[t1 - 1].disconnect(this.filters[t1]);
                        this.filters[this.filters.length - 1].disconnect(this.getOutput());
                    } else this.source.disconnect(this.getOutput());
                    return this._connected = !1, this;
                }
            }
            getFilters() {
                return this.filters;
            }
            setFilters(t1) {
                return t1 || (t1 = []), !0 === this._connected ? (this.disconnect(), this.filters = t1.slice(), this.connect()) : this.filters = t1.slice(), this;
            }
            setDetune(t1) {
                if (this.detune = t1, void 0 !== this.source.detune) return !0 === this.isPlaying && this.source.detune.setTargetAtTime(this.detune, this.context.currentTime, .01), this;
            }
            getDetune() {
                return this.detune;
            }
            getFilter() {
                return this.getFilters()[0];
            }
            setFilter(t1) {
                return this.setFilters(t1 ? [
                    t1
                ] : []);
            }
            setPlaybackRate(t1) {
                if (!1 !== this.hasPlaybackControl) return this.playbackRate = t1, !0 === this.isPlaying && this.source.playbackRate.setTargetAtTime(this.playbackRate, this.context.currentTime, .01), this;
                console.warn("THREE.Audio: this Audio has no playback control.");
            }
            getPlaybackRate() {
                return this.playbackRate;
            }
            onEnded() {
                this.isPlaying = !1;
            }
            getLoop() {
                return !1 === this.hasPlaybackControl ? (console.warn("THREE.Audio: this Audio has no playback control."), !1) : this.loop;
            }
            setLoop(t1) {
                if (!1 !== this.hasPlaybackControl) return this.loop = t1, !0 === this.isPlaying && (this.source.loop = this.loop), this;
                console.warn("THREE.Audio: this Audio has no playback control.");
            }
            setLoopStart(t1) {
                return this.loopStart = t1, this;
            }
            setLoopEnd(t1) {
                return this.loopEnd = t1, this;
            }
            getVolume() {
                return this.gain.gain.value;
            }
            setVolume(t1) {
                return this.gain.gain.setTargetAtTime(t1, this.context.currentTime, .01), this;
            }
        }
        const iM = new xl, nM = new vl, rM = new xl, aM = new xl;
        class sM extends eM {
            constructor(t1){
                super(t1), this.panner = this.context.createPanner(), this.panner.panningModel = "HRTF", this.panner.connect(this.gain);
            }
            connect() {
                super.connect(), this.panner.connect(this.gain);
            }
            disconnect() {
                super.disconnect(), this.panner.disconnect(this.gain);
            }
            getOutput() {
                return this.panner;
            }
            getRefDistance() {
                return this.panner.refDistance;
            }
            setRefDistance(t1) {
                return this.panner.refDistance = t1, this;
            }
            getRolloffFactor() {
                return this.panner.rolloffFactor;
            }
            setRolloffFactor(t1) {
                return this.panner.rolloffFactor = t1, this;
            }
            getDistanceModel() {
                return this.panner.distanceModel;
            }
            setDistanceModel(t1) {
                return this.panner.distanceModel = t1, this;
            }
            getMaxDistance() {
                return this.panner.maxDistance;
            }
            setMaxDistance(t1) {
                return this.panner.maxDistance = t1, this;
            }
            setDirectionalCone(t1, e, i) {
                return this.panner.coneInnerAngle = t1, this.panner.coneOuterAngle = e, this.panner.coneOuterGain = i, this;
            }
            updateMatrixWorld(t1) {
                if (super.updateMatrixWorld(t1), !0 === this.hasPlaybackControl && !1 === this.isPlaying) return;
                this.matrixWorld.decompose(iM, nM, rM), aM.set(0, 0, 1).applyQuaternion(nM);
                const e = this.panner;
                if (e.positionX) {
                    const t1 = this.context.currentTime + this.listener.timeDelta;
                    e.positionX.linearRampToValueAtTime(iM.x, t1), e.positionY.linearRampToValueAtTime(iM.y, t1), e.positionZ.linearRampToValueAtTime(iM.z, t1), e.orientationX.linearRampToValueAtTime(aM.x, t1), e.orientationY.linearRampToValueAtTime(aM.y, t1), e.orientationZ.linearRampToValueAtTime(aM.z, t1);
                } else e.setPosition(iM.x, iM.y, iM.z), e.setOrientation(aM.x, aM.y, aM.z);
            }
        }
        class oM {
            constructor(t1, e = 2048){
                this.analyser = t1.context.createAnalyser(), this.analyser.fftSize = e, this.data = new Uint8Array(this.analyser.frequencyBinCount), t1.getOutput().connect(this.analyser);
            }
            getFrequencyData() {
                return this.analyser.getByteFrequencyData(this.data), this.data;
            }
            getAverageFrequency() {
                let t1 = 0;
                const e = this.getFrequencyData();
                for(let i = 0; i < e.length; i++)t1 += e[i];
                return t1 / e.length;
            }
        }
        class lM {
            constructor(t1, e, i){
                let n, r, a;
                switch(this.binding = t1, this.valueSize = i, e){
                    case "quaternion":
                        n = this._slerp, r = this._slerpAdditive, a = this._setAdditiveIdentityQuaternion, this.buffer = new Float64Array(6 * i), this._workIndex = 5;
                        break;
                    case "string":
                    case "bool":
                        n = this._select, r = this._select, a = this._setAdditiveIdentityOther, this.buffer = new Array(5 * i);
                        break;
                    default:
                        n = this._lerp, r = this._lerpAdditive, a = this._setAdditiveIdentityNumeric, this.buffer = new Float64Array(5 * i);
                }
                this._mixBufferRegion = n, this._mixBufferRegionAdditive = r, this._setIdentity = a, this._origIndex = 3, this._addIndex = 4, this.cumulativeWeight = 0, this.cumulativeWeightAdditive = 0, this.useCount = 0, this.referenceCount = 0;
            }
            accumulate(t1, e) {
                const i = this.buffer, n = this.valueSize, r = t1 * n + n;
                let a = this.cumulativeWeight;
                if (0 === a) {
                    for(let t1 = 0; t1 !== n; ++t1)i[r + t1] = i[t1];
                    a = e;
                } else {
                    a += e;
                    const t1 = e / a;
                    this._mixBufferRegion(i, r, 0, t1, n);
                }
                this.cumulativeWeight = a;
            }
            accumulateAdditive(t1) {
                const e = this.buffer, i = this.valueSize, n = i * this._addIndex;
                0 === this.cumulativeWeightAdditive && this._setIdentity(), this._mixBufferRegionAdditive(e, n, 0, t1, i), this.cumulativeWeightAdditive += t1;
            }
            apply(t1) {
                const e = this.valueSize, i = this.buffer, n = t1 * e + e, r = this.cumulativeWeight, a = this.cumulativeWeightAdditive, s = this.binding;
                if (this.cumulativeWeight = 0, this.cumulativeWeightAdditive = 0, r < 1) {
                    const t1 = e * this._origIndex;
                    this._mixBufferRegion(i, n, t1, 1 - r, e);
                }
                a > 0 && this._mixBufferRegionAdditive(i, n, this._addIndex * e, 1, e);
                for(let t1 = e, r = e + e; t1 !== r; ++t1)if (i[t1] !== i[t1 + e]) {
                    s.setValue(i, n);
                    break;
                }
            }
            saveOriginalState() {
                const t1 = this.binding, e = this.buffer, i = this.valueSize, n = i * this._origIndex;
                t1.getValue(e, n);
                for(let t1 = i, r = n; t1 !== r; ++t1)e[t1] = e[n + t1 % i];
                this._setIdentity(), this.cumulativeWeight = 0, this.cumulativeWeightAdditive = 0;
            }
            restoreOriginalState() {
                const t1 = 3 * this.valueSize;
                this.binding.setValue(this.buffer, t1);
            }
            _setAdditiveIdentityNumeric() {
                const t1 = this._addIndex * this.valueSize, e = t1 + this.valueSize;
                for(let i = t1; i < e; i++)this.buffer[i] = 0;
            }
            _setAdditiveIdentityQuaternion() {
                this._setAdditiveIdentityNumeric(), this.buffer[this._addIndex * this.valueSize + 3] = 1;
            }
            _setAdditiveIdentityOther() {
                const t1 = this._origIndex * this.valueSize, e = this._addIndex * this.valueSize;
                for(let i = 0; i < this.valueSize; i++)this.buffer[e + i] = this.buffer[t1 + i];
            }
            _select(t1, e, i, n, r) {
                if (n >= .5) for(let n = 0; n !== r; ++n)t1[e + n] = t1[i + n];
            }
            _slerp(t1, e, i, n) {
                vl.slerpFlat(t1, e, t1, e, t1, i, n);
            }
            _slerpAdditive(t1, e, i, n, r) {
                const a = this._workIndex * r;
                vl.multiplyQuaternionsFlat(t1, a, t1, e, t1, i), vl.slerpFlat(t1, e, t1, e, t1, a, n);
            }
            _lerp(t1, e, i, n, r) {
                const a = 1 - n;
                for(let s = 0; s !== r; ++s){
                    const r = e + s;
                    t1[r] = t1[r] * a + t1[i + s] * n;
                }
            }
            _lerpAdditive(t1, e, i, n, r) {
                for(let a = 0; a !== r; ++a){
                    const r = e + a;
                    t1[r] = t1[r] + t1[i + a] * n;
                }
            }
        }
        const cM = "\\[\\]\\.:\\/", uM = new RegExp("[" + cM + "]", "g"), hM = "[^" + cM + "]", dM = "[^" + cM.replace("\\.", "") + "]", pM = new RegExp("^" + /((?:WC+[\/:])*)/.source.replace("WC", hM) + /(WCOD+)?/.source.replace("WCOD", dM) + /(?:\.(WC+)(?:\[(.+)\])?)?/.source.replace("WC", hM) + /\.(WC+)(?:\[(.+)\])?/.source.replace("WC", hM) + "$"), fM = [
            "material",
            "materials",
            "bones",
            "map"
        ];
        class AM {
            constructor(t1, e, i){
                this.path = e, this.parsedPath = i || AM.parseTrackName(e), this.node = AM.findNode(t1, this.parsedPath.nodeName), this.rootNode = t1, this.getValue = this._getValue_unbound, this.setValue = this._setValue_unbound;
            }
            static create(t1, e, i) {
                return t1 && t1.isAnimationObjectGroup ? new AM.Composite(t1, e, i) : new AM(t1, e, i);
            }
            static sanitizeNodeName(t1) {
                return t1.replace(/\s/g, "_").replace(uM, "");
            }
            static parseTrackName(t1) {
                const e = pM.exec(t1);
                if (null === e) throw new Error("PropertyBinding: Cannot parse trackName: " + t1);
                const i = {
                    nodeName: e[2],
                    objectName: e[3],
                    objectIndex: e[4],
                    propertyName: e[5],
                    propertyIndex: e[6]
                }, n = i.nodeName && i.nodeName.lastIndexOf(".");
                if (void 0 !== n && -1 !== n) {
                    const t1 = i.nodeName.substring(n + 1);
                    -1 !== fM.indexOf(t1) && (i.nodeName = i.nodeName.substring(0, n), i.objectName = t1);
                }
                if (null === i.propertyName || 0 === i.propertyName.length) throw new Error("PropertyBinding: can not parse propertyName from trackName: " + t1);
                return i;
            }
            static findNode(t1, e) {
                if (void 0 === e || "" === e || "." === e || -1 === e || e === t1.name || e === t1.uuid) return t1;
                if (t1.skeleton) {
                    const i = t1.skeleton.getBoneByName(e);
                    if (void 0 !== i) return i;
                }
                if (t1.children) {
                    const i = function(t1) {
                        for(let n = 0; n < t1.length; n++){
                            const r = t1[n];
                            if (r.name === e || r.uuid === e) return r;
                            const a = i(r.children);
                            if (a) return a;
                        }
                        return null;
                    }, n = i(t1.children);
                    if (n) return n;
                }
                return null;
            }
            _getValue_unavailable() {}
            _setValue_unavailable() {}
            _getValue_direct(t1, e) {
                t1[e] = this.targetObject[this.propertyName];
            }
            _getValue_array(t1, e) {
                const i = this.resolvedProperty;
                for(let n = 0, r = i.length; n !== r; ++n)t1[e++] = i[n];
            }
            _getValue_arrayElement(t1, e) {
                t1[e] = this.resolvedProperty[this.propertyIndex];
            }
            _getValue_toArray(t1, e) {
                this.resolvedProperty.toArray(t1, e);
            }
            _setValue_direct(t1, e) {
                this.targetObject[this.propertyName] = t1[e];
            }
            _setValue_direct_setNeedsUpdate(t1, e) {
                this.targetObject[this.propertyName] = t1[e], this.targetObject.needsUpdate = !0;
            }
            _setValue_direct_setMatrixWorldNeedsUpdate(t1, e) {
                this.targetObject[this.propertyName] = t1[e], this.targetObject.matrixWorldNeedsUpdate = !0;
            }
            _setValue_array(t1, e) {
                const i = this.resolvedProperty;
                for(let n = 0, r = i.length; n !== r; ++n)i[n] = t1[e++];
            }
            _setValue_array_setNeedsUpdate(t1, e) {
                const i = this.resolvedProperty;
                for(let n = 0, r = i.length; n !== r; ++n)i[n] = t1[e++];
                this.targetObject.needsUpdate = !0;
            }
            _setValue_array_setMatrixWorldNeedsUpdate(t1, e) {
                const i = this.resolvedProperty;
                for(let n = 0, r = i.length; n !== r; ++n)i[n] = t1[e++];
                this.targetObject.matrixWorldNeedsUpdate = !0;
            }
            _setValue_arrayElement(t1, e) {
                this.resolvedProperty[this.propertyIndex] = t1[e];
            }
            _setValue_arrayElement_setNeedsUpdate(t1, e) {
                this.resolvedProperty[this.propertyIndex] = t1[e], this.targetObject.needsUpdate = !0;
            }
            _setValue_arrayElement_setMatrixWorldNeedsUpdate(t1, e) {
                this.resolvedProperty[this.propertyIndex] = t1[e], this.targetObject.matrixWorldNeedsUpdate = !0;
            }
            _setValue_fromArray(t1, e) {
                this.resolvedProperty.fromArray(t1, e);
            }
            _setValue_fromArray_setNeedsUpdate(t1, e) {
                this.resolvedProperty.fromArray(t1, e), this.targetObject.needsUpdate = !0;
            }
            _setValue_fromArray_setMatrixWorldNeedsUpdate(t1, e) {
                this.resolvedProperty.fromArray(t1, e), this.targetObject.matrixWorldNeedsUpdate = !0;
            }
            _getValue_unbound(t1, e) {
                this.bind(), this.getValue(t1, e);
            }
            _setValue_unbound(t1, e) {
                this.bind(), this.setValue(t1, e);
            }
            bind() {
                let t1 = this.node;
                const e = this.parsedPath, i = e.objectName, n = e.propertyName;
                let r = e.propertyIndex;
                if (t1 || (t1 = AM.findNode(this.rootNode, e.nodeName), this.node = t1), this.getValue = this._getValue_unavailable, this.setValue = this._setValue_unavailable, !t1) return void console.warn("THREE.PropertyBinding: No target node found for track: " + this.path + ".");
                if (i) {
                    let n = e.objectIndex;
                    switch(i){
                        case "materials":
                            if (!t1.material) return void console.error("THREE.PropertyBinding: Can not bind to material as node does not have a material.", this);
                            if (!t1.material.materials) return void console.error("THREE.PropertyBinding: Can not bind to material.materials as node.material does not have a materials array.", this);
                            t1 = t1.material.materials;
                            break;
                        case "bones":
                            if (!t1.skeleton) return void console.error("THREE.PropertyBinding: Can not bind to bones as node does not have a skeleton.", this);
                            t1 = t1.skeleton.bones;
                            for(let e = 0; e < t1.length; e++)if (t1[e].name === n) {
                                n = e;
                                break;
                            }
                            break;
                        case "map":
                            if ("map" in t1) {
                                t1 = t1.map;
                                break;
                            }
                            if (!t1.material) return void console.error("THREE.PropertyBinding: Can not bind to material as node does not have a material.", this);
                            if (!t1.material.map) return void console.error("THREE.PropertyBinding: Can not bind to material.map as node.material does not have a map.", this);
                            t1 = t1.material.map;
                            break;
                        default:
                            if (void 0 === t1[i]) return void console.error("THREE.PropertyBinding: Can not bind to objectName of node undefined.", this);
                            t1 = t1[i];
                    }
                    if (void 0 !== n) {
                        if (void 0 === t1[n]) return void console.error("THREE.PropertyBinding: Trying to bind to objectIndex of objectName, but is undefined.", this, t1);
                        t1 = t1[n];
                    }
                }
                const a = t1[n];
                if (void 0 === a) {
                    const i = e.nodeName;
                    return void console.error("THREE.PropertyBinding: Trying to update property for track: " + i + "." + n + " but it wasn't found.", t1);
                }
                let s = this.Versioning.None;
                this.targetObject = t1, void 0 !== t1.needsUpdate ? s = this.Versioning.NeedsUpdate : void 0 !== t1.matrixWorldNeedsUpdate && (s = this.Versioning.MatrixWorldNeedsUpdate);
                let o = this.BindingType.Direct;
                if (void 0 !== r) {
                    if ("morphTargetInfluences" === n) {
                        if (!t1.geometry) return void console.error("THREE.PropertyBinding: Can not bind to morphTargetInfluences because node does not have a geometry.", this);
                        if (!t1.geometry.morphAttributes) return void console.error("THREE.PropertyBinding: Can not bind to morphTargetInfluences because node does not have a geometry.morphAttributes.", this);
                        void 0 !== t1.morphTargetDictionary[r] && (r = t1.morphTargetDictionary[r]);
                    }
                    o = this.BindingType.ArrayElement, this.resolvedProperty = a, this.propertyIndex = r;
                } else void 0 !== a.fromArray && void 0 !== a.toArray ? (o = this.BindingType.HasFromToArray, this.resolvedProperty = a) : Array.isArray(a) ? (o = this.BindingType.EntireArray, this.resolvedProperty = a) : this.propertyName = n;
                this.getValue = this.GetterByBindingType[o], this.setValue = this.SetterByBindingTypeAndVersioning[o][s];
            }
            unbind() {
                this.node = null, this.getValue = this._getValue_unbound, this.setValue = this._setValue_unbound;
            }
        }
        AM.Composite = class {
            constructor(t1, e, i){
                const n = i || AM.parseTrackName(e);
                this._targetGroup = t1, this._bindings = t1.subscribe_(e, n);
            }
            getValue(t1, e) {
                this.bind();
                const i = this._targetGroup.nCachedObjects_, n = this._bindings[i];
                void 0 !== n && n.getValue(t1, e);
            }
            setValue(t1, e) {
                const i = this._bindings;
                for(let n = this._targetGroup.nCachedObjects_, r = i.length; n !== r; ++n)i[n].setValue(t1, e);
            }
            bind() {
                const t1 = this._bindings;
                for(let e = this._targetGroup.nCachedObjects_, i = t1.length; e !== i; ++e)t1[e].bind();
            }
            unbind() {
                const t1 = this._bindings;
                for(let e = this._targetGroup.nCachedObjects_, i = t1.length; e !== i; ++e)t1[e].unbind();
            }
        }, AM.prototype.BindingType = {
            Direct: 0,
            EntireArray: 1,
            ArrayElement: 2,
            HasFromToArray: 3
        }, AM.prototype.Versioning = {
            None: 0,
            NeedsUpdate: 1,
            MatrixWorldNeedsUpdate: 2
        }, AM.prototype.GetterByBindingType = [
            AM.prototype._getValue_direct,
            AM.prototype._getValue_array,
            AM.prototype._getValue_arrayElement,
            AM.prototype._getValue_toArray
        ], AM.prototype.SetterByBindingTypeAndVersioning = [
            [
                AM.prototype._setValue_direct,
                AM.prototype._setValue_direct_setNeedsUpdate,
                AM.prototype._setValue_direct_setMatrixWorldNeedsUpdate
            ],
            [
                AM.prototype._setValue_array,
                AM.prototype._setValue_array_setNeedsUpdate,
                AM.prototype._setValue_array_setMatrixWorldNeedsUpdate
            ],
            [
                AM.prototype._setValue_arrayElement,
                AM.prototype._setValue_arrayElement_setNeedsUpdate,
                AM.prototype._setValue_arrayElement_setMatrixWorldNeedsUpdate
            ],
            [
                AM.prototype._setValue_fromArray,
                AM.prototype._setValue_fromArray_setNeedsUpdate,
                AM.prototype._setValue_fromArray_setMatrixWorldNeedsUpdate
            ]
        ];
        class gM {
            constructor(){
                this.isAnimationObjectGroup = !0, this.uuid = Lo(), this._objects = Array.prototype.slice.call(arguments), this.nCachedObjects_ = 0;
                const t1 = {};
                this._indicesByUUID = t1;
                for(let e = 0, i = arguments.length; e !== i; ++e)t1[arguments[e].uuid] = e;
                this._paths = [], this._parsedPaths = [], this._bindings = [], this._bindingsIndicesByPath = {};
                const e = this;
                this.stats = {
                    objects: {
                        get total () {
                            return e._objects.length;
                        },
                        get inUse () {
                            return this.total - e.nCachedObjects_;
                        }
                    },
                    get bindingsPerObject () {
                        return e._bindings.length;
                    }
                };
            }
            add() {
                const t1 = this._objects, e = this._indicesByUUID, i = this._paths, n = this._parsedPaths, r = this._bindings, a = r.length;
                let s, o = t1.length, l = this.nCachedObjects_;
                for(let c = 0, u = arguments.length; c !== u; ++c){
                    const u = arguments[c], h = u.uuid;
                    let d = e[h];
                    if (void 0 === d) {
                        d = o++, e[h] = d, t1.push(u);
                        for(let t1 = 0, e = a; t1 !== e; ++t1)r[t1].push(new AM(u, i[t1], n[t1]));
                    } else if (d < l) {
                        s = t1[d];
                        const o = --l, c = t1[o];
                        e[c.uuid] = d, t1[d] = c, e[h] = o, t1[o] = u;
                        for(let t1 = 0, e = a; t1 !== e; ++t1){
                            const e = r[t1], a = e[o];
                            let s = e[d];
                            e[d] = a, void 0 === s && (s = new AM(u, i[t1], n[t1])), e[o] = s;
                        }
                    } else t1[d] !== s && console.error("THREE.AnimationObjectGroup: Different objects with the same UUID detected. Clean the caches or recreate your infrastructure when reloading scenes.");
                }
                this.nCachedObjects_ = l;
            }
            remove() {
                const t1 = this._objects, e = this._indicesByUUID, i = this._bindings, n = i.length;
                let r = this.nCachedObjects_;
                for(let a = 0, s = arguments.length; a !== s; ++a){
                    const s = arguments[a], o = s.uuid, l = e[o];
                    if (void 0 !== l && l >= r) {
                        const a = r++, c = t1[a];
                        e[c.uuid] = l, t1[l] = c, e[o] = a, t1[a] = s;
                        for(let t1 = 0, e = n; t1 !== e; ++t1){
                            const e = i[t1], n = e[a], r = e[l];
                            e[l] = n, e[a] = r;
                        }
                    }
                }
                this.nCachedObjects_ = r;
            }
            uncache() {
                const t1 = this._objects, e = this._indicesByUUID, i = this._bindings, n = i.length;
                let r = this.nCachedObjects_, a = t1.length;
                for(let s = 0, o = arguments.length; s !== o; ++s){
                    const o = arguments[s].uuid, l = e[o];
                    if (void 0 !== l) {
                        if (delete e[o], l < r) {
                            const s = --r, o = t1[s], c = --a, u = t1[c];
                            e[o.uuid] = l, t1[l] = o, e[u.uuid] = s, t1[s] = u, t1.pop();
                            for(let t1 = 0, e = n; t1 !== e; ++t1){
                                const e = i[t1], n = e[s], r = e[c];
                                e[l] = n, e[s] = r, e.pop();
                            }
                        } else {
                            const r = --a, s = t1[r];
                            r > 0 && (e[s.uuid] = l), t1[l] = s, t1.pop();
                            for(let t1 = 0, e = n; t1 !== e; ++t1){
                                const e = i[t1];
                                e[l] = e[r], e.pop();
                            }
                        }
                    }
                }
                this.nCachedObjects_ = r;
            }
            subscribe_(t1, e) {
                const i = this._bindingsIndicesByPath;
                let n = i[t1];
                const r = this._bindings;
                if (void 0 !== n) return r[n];
                const a = this._paths, s = this._parsedPaths, o = this._objects, l = o.length, c = this.nCachedObjects_, u = new Array(l);
                n = r.length, i[t1] = n, a.push(t1), s.push(e), r.push(u);
                for(let i = c, n = o.length; i !== n; ++i){
                    const n = o[i];
                    u[i] = new AM(n, t1, e);
                }
                return u;
            }
            unsubscribe_(t1) {
                const e = this._bindingsIndicesByPath, i = e[t1];
                if (void 0 !== i) {
                    const n = this._paths, r = this._parsedPaths, a = this._bindings, s = a.length - 1, o = a[s];
                    e[t1[s]] = i, a[i] = o, a.pop(), r[i] = r[s], r.pop(), n[i] = n[s], n.pop();
                }
            }
        }
        class mM {
            constructor(t1, e, i = null, n = e.blendMode){
                this._mixer = t1, this._clip = e, this._localRoot = i, this.blendMode = n;
                const r = e.tracks, a = r.length, s = new Array(a), o = {
                    endingStart: ys,
                    endingEnd: ys
                };
                for(let t1 = 0; t1 !== a; ++t1){
                    const e = r[t1].createInterpolant(null);
                    s[t1] = e, e.settings = o;
                }
                this._interpolantSettings = o, this._interpolants = s, this._propertyBindings = new Array(a), this._cacheIndex = null, this._byClipCacheIndex = null, this._timeScaleInterpolant = null, this._weightInterpolant = null, this.loop = fs, this._loopCount = -1, this._startTime = null, this.time = 0, this.timeScale = 1, this._effectiveTimeScale = 1, this.weight = 1, this._effectiveWeight = 1, this.repetitions = 1 / 0, this.paused = !1, this.enabled = !0, this.clampWhenFinished = !1, this.zeroSlopeAtStart = !0, this.zeroSlopeAtEnd = !0;
            }
            play() {
                return this._mixer._activateAction(this), this;
            }
            stop() {
                return this._mixer._deactivateAction(this), this.reset();
            }
            reset() {
                return this.paused = !1, this.enabled = !0, this.time = 0, this._loopCount = -1, this._startTime = null, this.stopFading().stopWarping();
            }
            isRunning() {
                return this.enabled && !this.paused && 0 !== this.timeScale && null === this._startTime && this._mixer._isActiveAction(this);
            }
            isScheduled() {
                return this._mixer._isActiveAction(this);
            }
            startAt(t1) {
                return this._startTime = t1, this;
            }
            setLoop(t1, e) {
                return this.loop = t1, this.repetitions = e, this;
            }
            setEffectiveWeight(t1) {
                return this.weight = t1, this._effectiveWeight = this.enabled ? t1 : 0, this.stopFading();
            }
            getEffectiveWeight() {
                return this._effectiveWeight;
            }
            fadeIn(t1) {
                return this._scheduleFading(t1, 0, 1);
            }
            fadeOut(t1) {
                return this._scheduleFading(t1, 1, 0);
            }
            crossFadeFrom(t1, e, i) {
                if (t1.fadeOut(e), this.fadeIn(e), i) {
                    const i = this._clip.duration, n = t1._clip.duration, r = n / i, a = i / n;
                    t1.warp(1, r, e), this.warp(a, 1, e);
                }
                return this;
            }
            crossFadeTo(t1, e, i) {
                return t1.crossFadeFrom(this, e, i);
            }
            stopFading() {
                const t1 = this._weightInterpolant;
                return null !== t1 && (this._weightInterpolant = null, this._mixer._takeBackControlInterpolant(t1)), this;
            }
            setEffectiveTimeScale(t1) {
                return this.timeScale = t1, this._effectiveTimeScale = this.paused ? 0 : t1, this.stopWarping();
            }
            getEffectiveTimeScale() {
                return this._effectiveTimeScale;
            }
            setDuration(t1) {
                return this.timeScale = this._clip.duration / t1, this.stopWarping();
            }
            syncWith(t1) {
                return this.time = t1.time, this.timeScale = t1.timeScale, this.stopWarping();
            }
            halt(t1) {
                return this.warp(this._effectiveTimeScale, 0, t1);
            }
            warp(t1, e, i) {
                const n = this._mixer, r = n.time, a = this.timeScale;
                let s = this._timeScaleInterpolant;
                null === s && (s = n._lendControlInterpolant(), this._timeScaleInterpolant = s);
                const o = s.parameterPositions, l = s.sampleValues;
                return o[0] = r, o[1] = r + i, l[0] = t1 / a, l[1] = e / a, this;
            }
            stopWarping() {
                const t1 = this._timeScaleInterpolant;
                return null !== t1 && (this._timeScaleInterpolant = null, this._mixer._takeBackControlInterpolant(t1)), this;
            }
            getMixer() {
                return this._mixer;
            }
            getClip() {
                return this._clip;
            }
            getRoot() {
                return this._localRoot || this._mixer._root;
            }
            _update(t1, e, i, n) {
                if (!this.enabled) return void this._updateWeight(t1);
                const r = this._startTime;
                if (null !== r) {
                    const n = (t1 - r) * i;
                    n < 0 || 0 === i ? e = 0 : (this._startTime = null, e = i * n);
                }
                e *= this._updateTimeScale(t1);
                const a = this._updateTime(e), s = this._updateWeight(t1);
                if (s > 0) {
                    const t1 = this._interpolants, e = this._propertyBindings;
                    if (this.blendMode === bs) for(let i = 0, n = t1.length; i !== n; ++i)t1[i].evaluate(a), e[i].accumulateAdditive(s);
                    else for(let i = 0, r = t1.length; i !== r; ++i)t1[i].evaluate(a), e[i].accumulate(n, s);
                }
            }
            _updateWeight(t1) {
                let e = 0;
                if (this.enabled) {
                    e = this.weight;
                    const i = this._weightInterpolant;
                    if (null !== i) {
                        const n = i.evaluate(t1)[0];
                        e *= n, t1 > i.parameterPositions[1] && (this.stopFading(), 0 === n && (this.enabled = !1));
                    }
                }
                return this._effectiveWeight = e, e;
            }
            _updateTimeScale(t1) {
                let e = 0;
                if (!this.paused) {
                    e = this.timeScale;
                    const i = this._timeScaleInterpolant;
                    null !== i && (e *= i.evaluate(t1)[0], t1 > i.parameterPositions[1] && (this.stopWarping(), 0 === e ? this.paused = !0 : this.timeScale = e));
                }
                return this._effectiveTimeScale = e, e;
            }
            _updateTime(t1) {
                const e = this._clip.duration, i = this.loop;
                let n = this.time + t1, r = this._loopCount;
                const a = i === As;
                if (0 === t1) return -1 === r || !a || 1 & ~r ? n : e - n;
                if (i === ps) {
                    -1 === r && (this._loopCount = 0, this._setEndings(!0, !0, !1));
                    t: {
                        if (n >= e) n = e;
                        else {
                            if (!(n < 0)) {
                                this.time = n;
                                break t;
                            }
                            n = 0;
                        }
                        this.clampWhenFinished ? this.paused = !0 : this.enabled = !1, this.time = n, this._mixer.dispatchEvent({
                            type: "finished",
                            action: this,
                            direction: t1 < 0 ? -1 : 1
                        });
                    }
                } else {
                    if (-1 === r && (t1 >= 0 ? (r = 0, this._setEndings(!0, 0 === this.repetitions, a)) : this._setEndings(0 === this.repetitions, !0, a)), n >= e || n < 0) {
                        const i = Math.floor(n / e);
                        n -= e * i, r += Math.abs(i);
                        const s = this.repetitions - r;
                        if (s <= 0) this.clampWhenFinished ? this.paused = !0 : this.enabled = !1, n = t1 > 0 ? e : 0, this.time = n, this._mixer.dispatchEvent({
                            type: "finished",
                            action: this,
                            direction: t1 > 0 ? 1 : -1
                        });
                        else {
                            if (1 === s) {
                                const e = t1 < 0;
                                this._setEndings(e, !e, a);
                            } else this._setEndings(!1, !1, a);
                            this._loopCount = r, this.time = n, this._mixer.dispatchEvent({
                                type: "loop",
                                action: this,
                                loopDelta: i
                            });
                        }
                    } else this.time = n;
                    if (a && !(1 & ~r)) return e - n;
                }
                return n;
            }
            _setEndings(t1, e, i) {
                const n = this._interpolantSettings;
                i ? (n.endingStart = vs, n.endingEnd = vs) : (n.endingStart = t1 ? this.zeroSlopeAtStart ? vs : ys : xs, n.endingEnd = e ? this.zeroSlopeAtEnd ? vs : ys : xs);
            }
            _scheduleFading(t1, e, i) {
                const n = this._mixer, r = n.time;
                let a = this._weightInterpolant;
                null === a && (a = n._lendControlInterpolant(), this._weightInterpolant = a);
                const s = a.parameterPositions, o = a.sampleValues;
                return s[0] = r, o[0] = e, s[1] = r + t1, o[1] = i, this;
            }
        }
        const MM = new Float32Array(1);
        class yM extends So {
            constructor(t1){
                super(), this._root = t1, this._initMemoryManager(), this._accuIndex = 0, this.time = 0, this.timeScale = 1;
            }
            _bindAction(t1, e) {
                const i = t1._localRoot || this._root, n = t1._clip.tracks, r = n.length, a = t1._propertyBindings, s = t1._interpolants, o = i.uuid, l = this._bindingsByRootAndName;
                let c = l[o];
                void 0 === c && (c = {}, l[o] = c);
                for(let t1 = 0; t1 !== r; ++t1){
                    const r = n[t1], l = r.name;
                    let u = c[l];
                    if (void 0 !== u) ++u.referenceCount, a[t1] = u;
                    else {
                        if (u = a[t1], void 0 !== u) {
                            null === u._cacheIndex && (++u.referenceCount, this._addInactiveBinding(u, o, l));
                            continue;
                        }
                        const n = e && e._propertyBindings[t1].binding.parsedPath;
                        u = new lM(AM.create(i, l, n), r.ValueTypeName, r.getValueSize()), ++u.referenceCount, this._addInactiveBinding(u, o, l), a[t1] = u;
                    }
                    s[t1].resultBuffer = u.buffer;
                }
            }
            _activateAction(t1) {
                if (!this._isActiveAction(t1)) {
                    if (null === t1._cacheIndex) {
                        const e = (t1._localRoot || this._root).uuid, i = t1._clip.uuid, n = this._actionsByClip[i];
                        this._bindAction(t1, n && n.knownActions[0]), this._addInactiveAction(t1, i, e);
                    }
                    const e = t1._propertyBindings;
                    for(let t1 = 0, i = e.length; t1 !== i; ++t1){
                        const i = e[t1];
                        0 == i.useCount++ && (this._lendBinding(i), i.saveOriginalState());
                    }
                    this._lendAction(t1);
                }
            }
            _deactivateAction(t1) {
                if (this._isActiveAction(t1)) {
                    const e = t1._propertyBindings;
                    for(let t1 = 0, i = e.length; t1 !== i; ++t1){
                        const i = e[t1];
                        0 == --i.useCount && (i.restoreOriginalState(), this._takeBackBinding(i));
                    }
                    this._takeBackAction(t1);
                }
            }
            _initMemoryManager() {
                this._actions = [], this._nActiveActions = 0, this._actionsByClip = {}, this._bindings = [], this._nActiveBindings = 0, this._bindingsByRootAndName = {}, this._controlInterpolants = [], this._nActiveControlInterpolants = 0;
                const t1 = this;
                this.stats = {
                    actions: {
                        get total () {
                            return t1._actions.length;
                        },
                        get inUse () {
                            return t1._nActiveActions;
                        }
                    },
                    bindings: {
                        get total () {
                            return t1._bindings.length;
                        },
                        get inUse () {
                            return t1._nActiveBindings;
                        }
                    },
                    controlInterpolants: {
                        get total () {
                            return t1._controlInterpolants.length;
                        },
                        get inUse () {
                            return t1._nActiveControlInterpolants;
                        }
                    }
                };
            }
            _isActiveAction(t1) {
                const e = t1._cacheIndex;
                return null !== e && e < this._nActiveActions;
            }
            _addInactiveAction(t1, e, i) {
                const n = this._actions, r = this._actionsByClip;
                let a = r[e];
                if (void 0 === a) a = {
                    knownActions: [
                        t1
                    ],
                    actionByRoot: {}
                }, t1._byClipCacheIndex = 0, r[e] = a;
                else {
                    const e = a.knownActions;
                    t1._byClipCacheIndex = e.length, e.push(t1);
                }
                t1._cacheIndex = n.length, n.push(t1), a.actionByRoot[i] = t1;
            }
            _removeInactiveAction(t1) {
                const e = this._actions, i = e[e.length - 1], n = t1._cacheIndex;
                i._cacheIndex = n, e[n] = i, e.pop(), t1._cacheIndex = null;
                const r = t1._clip.uuid, a = this._actionsByClip, s = a[r], o = s.knownActions, l = o[o.length - 1], c = t1._byClipCacheIndex;
                l._byClipCacheIndex = c, o[c] = l, o.pop(), t1._byClipCacheIndex = null, delete s.actionByRoot[(t1._localRoot || this._root).uuid], 0 === o.length && delete a[r], this._removeInactiveBindingsForAction(t1);
            }
            _removeInactiveBindingsForAction(t1) {
                const e = t1._propertyBindings;
                for(let t1 = 0, i = e.length; t1 !== i; ++t1){
                    const i = e[t1];
                    0 == --i.referenceCount && this._removeInactiveBinding(i);
                }
            }
            _lendAction(t1) {
                const e = this._actions, i = t1._cacheIndex, n = this._nActiveActions++, r = e[n];
                t1._cacheIndex = n, e[n] = t1, r._cacheIndex = i, e[i] = r;
            }
            _takeBackAction(t1) {
                const e = this._actions, i = t1._cacheIndex, n = --this._nActiveActions, r = e[n];
                t1._cacheIndex = n, e[n] = t1, r._cacheIndex = i, e[i] = r;
            }
            _addInactiveBinding(t1, e, i) {
                const n = this._bindingsByRootAndName, r = this._bindings;
                let a = n[e];
                void 0 === a && (a = {}, n[e] = a), a[i] = t1, t1._cacheIndex = r.length, r.push(t1);
            }
            _removeInactiveBinding(t1) {
                const e = this._bindings, i = t1.binding, n = i.rootNode.uuid, r = i.path, a = this._bindingsByRootAndName, s = a[n], o = e[e.length - 1], l = t1._cacheIndex;
                o._cacheIndex = l, e[l] = o, e.pop(), delete s[r], 0 === Object.keys(s).length && delete a[n];
            }
            _lendBinding(t1) {
                const e = this._bindings, i = t1._cacheIndex, n = this._nActiveBindings++, r = e[n];
                t1._cacheIndex = n, e[n] = t1, r._cacheIndex = i, e[i] = r;
            }
            _takeBackBinding(t1) {
                const e = this._bindings, i = t1._cacheIndex, n = --this._nActiveBindings, r = e[n];
                t1._cacheIndex = n, e[n] = t1, r._cacheIndex = i, e[i] = r;
            }
            _lendControlInterpolant() {
                const t1 = this._controlInterpolants, e = this._nActiveControlInterpolants++;
                let i = t1[e];
                return void 0 === i && (i = new Qg(new Float32Array(2), new Float32Array(2), 1, MM), i.__cacheIndex = e, t1[e] = i), i;
            }
            _takeBackControlInterpolant(t1) {
                const e = this._controlInterpolants, i = t1.__cacheIndex, n = --this._nActiveControlInterpolants, r = e[n];
                t1.__cacheIndex = n, e[n] = t1, r.__cacheIndex = i, e[i] = r;
            }
            clipAction(t1, e, i) {
                const n = e || this._root, r = n.uuid;
                let a = "string" == typeof t1 ? qg.findByName(n, t1) : t1;
                const s = null !== a ? a.uuid : t1, o = this._actionsByClip[s];
                let l = null;
                if (void 0 === i && (i = null !== a ? a.blendMode : ws), void 0 !== o) {
                    const t1 = o.actionByRoot[r];
                    if (void 0 !== t1 && t1.blendMode === i) return t1;
                    l = o.knownActions[0], null === a && (a = l._clip);
                }
                if (null === a) return null;
                const c = new mM(this, a, e, i);
                return this._bindAction(c, l), this._addInactiveAction(c, s, r), c;
            }
            existingAction(t1, e) {
                const i = e || this._root, n = i.uuid, r = "string" == typeof t1 ? qg.findByName(i, t1) : t1, a = r ? r.uuid : t1, s = this._actionsByClip[a];
                return void 0 !== s && s.actionByRoot[n] || null;
            }
            stopAllAction() {
                const t1 = this._actions;
                for(let e = this._nActiveActions - 1; e >= 0; --e)t1[e].stop();
                return this;
            }
            update(t1) {
                t1 *= this.timeScale;
                const e = this._actions, i = this._nActiveActions, n = this.time += t1, r = Math.sign(t1), a = this._accuIndex ^= 1;
                for(let s = 0; s !== i; ++s)e[s]._update(n, t1, r, a);
                const s = this._bindings, o = this._nActiveBindings;
                for(let t1 = 0; t1 !== o; ++t1)s[t1].apply(a);
                return this;
            }
            setTime(t1) {
                this.time = 0;
                for(let t1 = 0; t1 < this._actions.length; t1++)this._actions[t1].time = 0;
                return this.update(t1);
            }
            getRoot() {
                return this._root;
            }
            uncacheClip(t1) {
                const e = this._actions, i = t1.uuid, n = this._actionsByClip, r = n[i];
                if (void 0 !== r) {
                    const t1 = r.knownActions;
                    for(let i = 0, n = t1.length; i !== n; ++i){
                        const n = t1[i];
                        this._deactivateAction(n);
                        const r = n._cacheIndex, a = e[e.length - 1];
                        n._cacheIndex = null, n._byClipCacheIndex = null, a._cacheIndex = r, e[r] = a, e.pop(), this._removeInactiveBindingsForAction(n);
                    }
                    delete n[i];
                }
            }
            uncacheRoot(t1) {
                const e = t1.uuid, i = this._actionsByClip;
                for(const t1 in i){
                    const n = i[t1].actionByRoot[e];
                    void 0 !== n && (this._deactivateAction(n), this._removeInactiveAction(n));
                }
                const n = this._bindingsByRootAndName[e];
                if (void 0 !== n) for(const t1 in n){
                    const e = n[t1];
                    e.restoreOriginalState(), this._removeInactiveBinding(e);
                }
            }
            uncacheAction(t1, e) {
                const i = this.existingAction(t1, e);
                null !== i && (this._deactivateAction(i), this._removeInactiveAction(i));
            }
        }
        class vM {
            constructor(t1){
                this.value = t1;
            }
            clone() {
                return new vM(void 0 === this.value.clone ? this.value : this.value.clone());
            }
        }
        let xM = 0;
        class wM extends So {
            constructor(){
                super(), this.isUniformsGroup = !0, Object.defineProperty(this, "id", {
                    value: xM++
                }), this.name = "", this.usage = po, this.uniforms = [];
            }
            add(t1) {
                return this.uniforms.push(t1), this;
            }
            remove(t1) {
                const e = this.uniforms.indexOf(t1);
                return -1 !== e && this.uniforms.splice(e, 1), this;
            }
            setName(t1) {
                return this.name = t1, this;
            }
            setUsage(t1) {
                return this.usage = t1, this;
            }
            dispose() {
                return this.dispatchEvent({
                    type: "dispose"
                }), this;
            }
            copy(t1) {
                this.name = t1.name, this.usage = t1.usage;
                const e = t1.uniforms;
                this.uniforms.length = 0;
                for(let t1 = 0, i = e.length; t1 < i; t1++)this.uniforms.push(e[t1].clone());
                return this;
            }
            clone() {
                return (new this.constructor).copy(this);
            }
        }
        class bM extends kp {
            constructor(t1, e, i = 1){
                super(t1, e), this.isInstancedInterleavedBuffer = !0, this.meshPerAttribute = i;
            }
            copy(t1) {
                return super.copy(t1), this.meshPerAttribute = t1.meshPerAttribute, this;
            }
            clone(t1) {
                const e = super.clone(t1);
                return e.meshPerAttribute = this.meshPerAttribute, e;
            }
            toJSON(t1) {
                const e = super.toJSON(t1);
                return e.isInstancedInterleavedBuffer = !0, e.meshPerAttribute = this.meshPerAttribute, e;
            }
        }
        class TM {
            constructor(t1, e, i, n, r){
                this.isGLBufferAttribute = !0, this.name = "", this.buffer = t1, this.type = e, this.itemSize = i, this.elementSize = n, this.count = r, this.version = 0;
            }
            set needsUpdate(t1) {
                !0 === t1 && this.version++;
            }
            setBuffer(t1) {
                return this.buffer = t1, this;
            }
            setType(t1, e) {
                return this.type = t1, this.elementSize = e, this;
            }
            setItemSize(t1) {
                return this.itemSize = t1, this;
            }
            setCount(t1) {
                return this.count = t1, this;
            }
        }
        class EM {
            constructor(t1, e, i = 0, n = 1 / 0){
                this.ray = new Jl(t1, e), this.near = i, this.far = n, this.camera = null, this.layers = new lc, this.params = {
                    Mesh: {},
                    Line: {
                        threshold: 1
                    },
                    LOD: {},
                    Points: {
                        threshold: 1
                    },
                    Sprite: {}
                };
            }
            set(t1, e) {
                this.ray.set(t1, e);
            }
            setFromCamera(t1, e) {
                e.isPerspectiveCamera ? (this.ray.origin.setFromMatrixPosition(e.matrixWorld), this.ray.direction.set(t1.x, t1.y, .5).unproject(e).sub(this.ray.origin).normalize(), this.camera = e) : e.isOrthographicCamera ? (this.ray.origin.set(t1.x, t1.y, (e.near + e.far) / (e.near - e.far)).unproject(e), this.ray.direction.set(0, 0, -1).transformDirection(e.matrixWorld), this.camera = e) : console.error("THREE.Raycaster: Unsupported camera type: " + e.type);
            }
            intersectObject(t1, e = !0, i = []) {
                return SM(t1, this, i, e), i.sort(IM), i;
            }
            intersectObjects(t1, e = !0, i = []) {
                for(let n = 0, r = t1.length; n < r; n++)SM(t1[n], this, i, e);
                return i.sort(IM), i;
            }
        }
        function IM(t1, e) {
            return t1.distance - e.distance;
        }
        function SM(t1, e, i, n) {
            if (t1.layers.test(e.layers) && t1.raycast(e, i), !0 === n) {
                const n = t1.children;
                for(let t1 = 0, r = n.length; t1 < r; t1++)SM(n[t1], e, i, !0);
            }
        }
        class NM {
            constructor(t1 = 1, e = 0, i = 0){
                return this.radius = t1, this.phi = e, this.theta = i, this;
            }
            set(t1, e, i) {
                return this.radius = t1, this.phi = e, this.theta = i, this;
            }
            copy(t1) {
                return this.radius = t1.radius, this.phi = t1.phi, this.theta = t1.theta, this;
            }
            makeSafe() {
                const t1 = 1e-6;
                return this.phi = Math.max(t1, Math.min(Math.PI - t1, this.phi)), this;
            }
            setFromVector3(t1) {
                return this.setFromCartesianCoords(t1.x, t1.y, t1.z);
            }
            setFromCartesianCoords(t1, e, i) {
                return this.radius = Math.sqrt(t1 * t1 + e * e + i * i), 0 === this.radius ? (this.theta = 0, this.phi = 0) : (this.theta = Math.atan2(t1, i), this.phi = Math.acos(Oo(e / this.radius, -1, 1))), this;
            }
            clone() {
                return (new this.constructor).copy(this);
            }
        }
        class DM {
            constructor(t1 = 1, e = 0, i = 0){
                return this.radius = t1, this.theta = e, this.y = i, this;
            }
            set(t1, e, i) {
                return this.radius = t1, this.theta = e, this.y = i, this;
            }
            copy(t1) {
                return this.radius = t1.radius, this.theta = t1.theta, this.y = t1.y, this;
            }
            setFromVector3(t1) {
                return this.setFromCartesianCoords(t1.x, t1.y, t1.z);
            }
            setFromCartesianCoords(t1, e, i) {
                return this.radius = Math.sqrt(t1 * t1 + i * i), this.theta = Math.atan2(t1, i), this.y = e, this;
            }
            clone() {
                return (new this.constructor).copy(this);
            }
        }
        const CM = new Qo;
        class zM {
            constructor(t1 = new Qo(1 / 0, 1 / 0), e = new Qo(-1 / 0, -1 / 0)){
                this.isBox2 = !0, this.min = t1, this.max = e;
            }
            set(t1, e) {
                return this.min.copy(t1), this.max.copy(e), this;
            }
            setFromPoints(t1) {
                this.makeEmpty();
                for(let e = 0, i = t1.length; e < i; e++)this.expandByPoint(t1[e]);
                return this;
            }
            setFromCenterAndSize(t1, e) {
                const i = CM.copy(e).multiplyScalar(.5);
                return this.min.copy(t1).sub(i), this.max.copy(t1).add(i), this;
            }
            clone() {
                return (new this.constructor).copy(this);
            }
            copy(t1) {
                return this.min.copy(t1.min), this.max.copy(t1.max), this;
            }
            makeEmpty() {
                return this.min.x = this.min.y = 1 / 0, this.max.x = this.max.y = -1 / 0, this;
            }
            isEmpty() {
                return this.max.x < this.min.x || this.max.y < this.min.y;
            }
            getCenter(t1) {
                return this.isEmpty() ? t1.set(0, 0) : t1.addVectors(this.min, this.max).multiplyScalar(.5);
            }
            getSize(t1) {
                return this.isEmpty() ? t1.set(0, 0) : t1.subVectors(this.max, this.min);
            }
            expandByPoint(t1) {
                return this.min.min(t1), this.max.max(t1), this;
            }
            expandByVector(t1) {
                return this.min.sub(t1), this.max.add(t1), this;
            }
            expandByScalar(t1) {
                return this.min.addScalar(-t1), this.max.addScalar(t1), this;
            }
            containsPoint(t1) {
                return !(t1.x < this.min.x || t1.x > this.max.x || t1.y < this.min.y || t1.y > this.max.y);
            }
            containsBox(t1) {
                return this.min.x <= t1.min.x && t1.max.x <= this.max.x && this.min.y <= t1.min.y && t1.max.y <= this.max.y;
            }
            getParameter(t1, e) {
                return e.set((t1.x - this.min.x) / (this.max.x - this.min.x), (t1.y - this.min.y) / (this.max.y - this.min.y));
            }
            intersectsBox(t1) {
                return !(t1.max.x < this.min.x || t1.min.x > this.max.x || t1.max.y < this.min.y || t1.min.y > this.max.y);
            }
            clampPoint(t1, e) {
                return e.copy(t1).clamp(this.min, this.max);
            }
            distanceToPoint(t1) {
                return this.clampPoint(t1, CM).distanceTo(t1);
            }
            intersect(t1) {
                return this.min.max(t1.min), this.max.min(t1.max), this.isEmpty() && this.makeEmpty(), this;
            }
            union(t1) {
                return this.min.min(t1.min), this.max.max(t1.max), this;
            }
            translate(t1) {
                return this.min.add(t1), this.max.add(t1), this;
            }
            equals(t1) {
                return t1.min.equals(this.min) && t1.max.equals(this.max);
            }
        }
        const LM = new xl, OM = new xl;
        class _M {
            constructor(t1 = new xl, e = new xl){
                this.start = t1, this.end = e;
            }
            set(t1, e) {
                return this.start.copy(t1), this.end.copy(e), this;
            }
            copy(t1) {
                return this.start.copy(t1.start), this.end.copy(t1.end), this;
            }
            getCenter(t1) {
                return t1.addVectors(this.start, this.end).multiplyScalar(.5);
            }
            delta(t1) {
                return t1.subVectors(this.end, this.start);
            }
            distanceSq() {
                return this.start.distanceToSquared(this.end);
            }
            distance() {
                return this.start.distanceTo(this.end);
            }
            at(t1, e) {
                return this.delta(e).multiplyScalar(t1).add(this.start);
            }
            closestPointToPointParameter(t1, e) {
                LM.subVectors(t1, this.start), OM.subVectors(this.end, this.start);
                const i = OM.dot(OM);
                let n = OM.dot(LM) / i;
                return e && (n = Oo(n, 0, 1)), n;
            }
            closestPointToPoint(t1, e, i) {
                const n = this.closestPointToPointParameter(t1, e);
                return this.delta(i).multiplyScalar(n).add(this.start);
            }
            applyMatrix4(t1) {
                return this.start.applyMatrix4(t1), this.end.applyMatrix4(t1), this;
            }
            equals(t1) {
                return t1.start.equals(this.start) && t1.end.equals(this.end);
            }
            clone() {
                return (new this.constructor).copy(this);
            }
        }
        const jM = new xl;
        class PM extends wc {
            constructor(t1, e){
                super(), this.light = t1, this.matrix = t1.matrixWorld, this.matrixAutoUpdate = !1, this.color = e, this.type = "SpotLightHelper";
                const i = new Au, n = [
                    0,
                    0,
                    0,
                    0,
                    0,
                    1,
                    0,
                    0,
                    0,
                    1,
                    0,
                    1,
                    0,
                    0,
                    0,
                    -1,
                    0,
                    1,
                    0,
                    0,
                    0,
                    0,
                    1,
                    1,
                    0,
                    0,
                    0,
                    0,
                    -1,
                    1
                ];
                for(let t1 = 0, e = 1, i = 32; t1 < i; t1++, e++){
                    const r = t1 / i * Math.PI * 2, a = e / i * Math.PI * 2;
                    n.push(Math.cos(r), Math.sin(r), 1, Math.cos(a), Math.sin(a), 1);
                }
                i.setAttribute("position", new su(n, 3));
                const r = new Lf({
                    fog: !1,
                    toneMapped: !1
                });
                this.cone = new Ff(i, r), this.add(this.cone), this.update();
            }
            dispose() {
                this.cone.geometry.dispose(), this.cone.material.dispose();
            }
            update() {
                this.light.updateWorldMatrix(!0, !1), this.light.target.updateWorldMatrix(!0, !1);
                const t1 = this.light.distance ? this.light.distance : 1e3, e = t1 * Math.tan(this.light.angle);
                this.cone.scale.set(e, e, t1), jM.setFromMatrixPosition(this.light.target.matrixWorld), this.cone.lookAt(jM), void 0 !== this.color ? this.cone.material.color.set(this.color) : this.cone.material.color.copy(this.light.color);
            }
        }
        const RM = new xl, UM = new Kl, kM = new Kl;
        class BM extends Ff {
            constructor(t1){
                const e = FM(t1), i = new Au, n = [], r = [], a = new kc(0, 0, 1), s = new kc(0, 1, 0);
                for(let t1 = 0; t1 < e.length; t1++){
                    const i = e[t1];
                    i.parent && i.parent.isBone && (n.push(0, 0, 0), n.push(0, 0, 0), r.push(a.r, a.g, a.b), r.push(s.r, s.g, s.b));
                }
                i.setAttribute("position", new su(n, 3)), i.setAttribute("color", new su(r, 3)), super(i, new Lf({
                    vertexColors: !0,
                    depthTest: !1,
                    depthWrite: !1,
                    toneMapped: !1,
                    transparent: !0
                })), this.isSkeletonHelper = !0, this.type = "SkeletonHelper", this.root = t1, this.bones = e, this.matrix = t1.matrixWorld, this.matrixAutoUpdate = !1;
            }
            updateMatrixWorld(t1) {
                const e = this.bones, i = this.geometry, n = i.getAttribute("position");
                kM.copy(this.root.matrixWorld).invert();
                for(let t1 = 0, i = 0; t1 < e.length; t1++){
                    const r = e[t1];
                    r.parent && r.parent.isBone && (UM.multiplyMatrices(kM, r.matrixWorld), RM.setFromMatrixPosition(UM), n.setXYZ(i, RM.x, RM.y, RM.z), UM.multiplyMatrices(kM, r.parent.matrixWorld), RM.setFromMatrixPosition(UM), n.setXYZ(i + 1, RM.x, RM.y, RM.z), i += 2);
                }
                i.getAttribute("position").needsUpdate = !0, super.updateMatrixWorld(t1);
            }
            dispose() {
                this.geometry.dispose(), this.material.dispose();
            }
        }
        function FM(t1) {
            const e = [];
            !0 === t1.isBone && e.push(t1);
            for(let i = 0; i < t1.children.length; i++)e.push.apply(e, FM(t1.children[i]));
            return e;
        }
        class QM extends Ou {
            constructor(t1, e, i){
                super(new gg(e, 4, 2), new Hc({
                    wireframe: !0,
                    fog: !1,
                    toneMapped: !1
                })), this.light = t1, this.color = i, this.type = "PointLightHelper", this.matrix = this.light.matrixWorld, this.matrixAutoUpdate = !1, this.update();
            }
            dispose() {
                this.geometry.dispose(), this.material.dispose();
            }
            update() {
                this.light.updateWorldMatrix(!0, !1), void 0 !== this.color ? this.material.color.set(this.color) : this.material.color.copy(this.light.color);
            }
        }
        const HM = new xl, VM = new kc, GM = new kc;
        class YM extends wc {
            constructor(t1, e, i){
                super(), this.light = t1, this.matrix = t1.matrixWorld, this.matrixAutoUpdate = !1, this.color = i, this.type = "HemisphereLightHelper";
                const n = new pg(e);
                n.rotateY(.5 * Math.PI), this.material = new Hc({
                    wireframe: !0,
                    fog: !1,
                    toneMapped: !1
                }), void 0 === this.color && (this.material.vertexColors = !0);
                const r = n.getAttribute("position"), a = new Float32Array(3 * r.count);
                n.setAttribute("color", new Kc(a, 3)), this.add(new Ou(n, this.material)), this.update();
            }
            dispose() {
                this.children[0].geometry.dispose(), this.children[0].material.dispose();
            }
            update() {
                const t1 = this.children[0];
                if (void 0 !== this.color) this.material.color.set(this.color);
                else {
                    const e = t1.geometry.getAttribute("color");
                    VM.copy(this.light.color), GM.copy(this.light.groundColor);
                    for(let t1 = 0, i = e.count; t1 < i; t1++){
                        const n = t1 < i / 2 ? VM : GM;
                        e.setXYZ(t1, n.r, n.g, n.b);
                    }
                    e.needsUpdate = !0;
                }
                this.light.updateWorldMatrix(!0, !1), t1.lookAt(HM.setFromMatrixPosition(this.light.matrixWorld).negate());
            }
        }
        class WM extends Ff {
            constructor(t1 = 10, e = 10, i = 4473924, n = 8947848){
                i = new kc(i), n = new kc(n);
                const r = e / 2, a = t1 / e, s = t1 / 2, o = [], l = [];
                for(let t1 = 0, c = 0, u = -s; t1 <= e; t1++, u += a){
                    o.push(-s, 0, u, s, 0, u), o.push(u, 0, -s, u, 0, s);
                    const e = t1 === r ? i : n;
                    e.toArray(l, c), c += 3, e.toArray(l, c), c += 3, e.toArray(l, c), c += 3, e.toArray(l, c), c += 3;
                }
                const c = new Au;
                c.setAttribute("position", new su(o, 3)), c.setAttribute("color", new su(l, 3)), super(c, new Lf({
                    vertexColors: !0,
                    toneMapped: !1
                })), this.type = "GridHelper";
            }
            dispose() {
                this.geometry.dispose(), this.material.dispose();
            }
        }
        class XM extends Ff {
            constructor(t1 = 10, e = 16, i = 8, n = 64, r = 4473924, a = 8947848){
                r = new kc(r), a = new kc(a);
                const s = [], o = [];
                if (e > 1) for(let i = 0; i < e; i++){
                    const n = i / e * (2 * Math.PI), l = Math.sin(n) * t1, c = Math.cos(n) * t1;
                    s.push(0, 0, 0), s.push(l, 0, c);
                    const u = 1 & i ? r : a;
                    o.push(u.r, u.g, u.b), o.push(u.r, u.g, u.b);
                }
                for(let e = 0; e < i; e++){
                    const l = 1 & e ? r : a, c = t1 - t1 / i * e;
                    for(let t1 = 0; t1 < n; t1++){
                        let e = t1 / n * (2 * Math.PI), i = Math.sin(e) * c, r = Math.cos(e) * c;
                        s.push(i, 0, r), o.push(l.r, l.g, l.b), e = (t1 + 1) / n * (2 * Math.PI), i = Math.sin(e) * c, r = Math.cos(e) * c, s.push(i, 0, r), o.push(l.r, l.g, l.b);
                    }
                }
                const l = new Au;
                l.setAttribute("position", new su(s, 3)), l.setAttribute("color", new su(o, 3)), super(l, new Lf({
                    vertexColors: !0,
                    toneMapped: !1
                })), this.type = "PolarGridHelper";
            }
            dispose() {
                this.geometry.dispose(), this.material.dispose();
            }
        }
        const ZM = new xl, JM = new xl, KM = new xl;
        class qM extends wc {
            constructor(t1, e, i){
                super(), this.light = t1, this.matrix = t1.matrixWorld, this.matrixAutoUpdate = !1, this.color = i, this.type = "DirectionalLightHelper", void 0 === e && (e = 1);
                let n = new Au;
                n.setAttribute("position", new su([
                    -e,
                    e,
                    0,
                    e,
                    e,
                    0,
                    e,
                    -e,
                    0,
                    -e,
                    -e,
                    0,
                    -e,
                    e,
                    0
                ], 3));
                const r = new Lf({
                    fog: !1,
                    toneMapped: !1
                });
                this.lightPlane = new Uf(n, r), this.add(this.lightPlane), n = new Au, n.setAttribute("position", new su([
                    0,
                    0,
                    0,
                    0,
                    0,
                    1
                ], 3)), this.targetLine = new Uf(n, r), this.add(this.targetLine), this.update();
            }
            dispose() {
                this.lightPlane.geometry.dispose(), this.lightPlane.material.dispose(), this.targetLine.geometry.dispose(), this.targetLine.material.dispose();
            }
            update() {
                this.light.updateWorldMatrix(!0, !1), this.light.target.updateWorldMatrix(!0, !1), ZM.setFromMatrixPosition(this.light.matrixWorld), JM.setFromMatrixPosition(this.light.target.matrixWorld), KM.subVectors(JM, ZM), this.lightPlane.lookAt(JM), void 0 !== this.color ? (this.lightPlane.material.color.set(this.color), this.targetLine.material.color.set(this.color)) : (this.lightPlane.material.color.copy(this.light.color), this.targetLine.material.color.copy(this.light.color)), this.targetLine.lookAt(JM), this.targetLine.scale.z = KM.length();
            }
        }
        const $M = new xl, ty = new Fu;
        class ey extends Ff {
            constructor(t1){
                const e = new Au, i = new Lf({
                    color: 16777215,
                    vertexColors: !0,
                    toneMapped: !1
                }), n = [], r = [], a = {};
                function s(t1, e) {
                    o(t1), o(e);
                }
                function o(t1) {
                    n.push(0, 0, 0), r.push(0, 0, 0), void 0 === a[t1] && (a[t1] = []), a[t1].push(n.length / 3 - 1);
                }
                s("n1", "n2"), s("n2", "n4"), s("n4", "n3"), s("n3", "n1"), s("f1", "f2"), s("f2", "f4"), s("f4", "f3"), s("f3", "f1"), s("n1", "f1"), s("n2", "f2"), s("n3", "f3"), s("n4", "f4"), s("p", "n1"), s("p", "n2"), s("p", "n3"), s("p", "n4"), s("u1", "u2"), s("u2", "u3"), s("u3", "u1"), s("c", "t"), s("p", "c"), s("cn1", "cn2"), s("cn3", "cn4"), s("cf1", "cf2"), s("cf3", "cf4"), e.setAttribute("position", new su(n, 3)), e.setAttribute("color", new su(r, 3)), super(e, i), this.type = "CameraHelper", this.camera = t1, this.camera.updateProjectionMatrix && this.camera.updateProjectionMatrix(), this.matrix = t1.matrixWorld, this.matrixAutoUpdate = !1, this.pointMap = a, this.update();
                const l = new kc(16755200), c = new kc(16711680), u = new kc(43775), h = new kc(16777215), d = new kc(3355443);
                this.setColors(l, c, u, h, d);
            }
            setColors(t1, e, i, n, r) {
                const a = this.geometry.getAttribute("color");
                a.setXYZ(0, t1.r, t1.g, t1.b), a.setXYZ(1, t1.r, t1.g, t1.b), a.setXYZ(2, t1.r, t1.g, t1.b), a.setXYZ(3, t1.r, t1.g, t1.b), a.setXYZ(4, t1.r, t1.g, t1.b), a.setXYZ(5, t1.r, t1.g, t1.b), a.setXYZ(6, t1.r, t1.g, t1.b), a.setXYZ(7, t1.r, t1.g, t1.b), a.setXYZ(8, t1.r, t1.g, t1.b), a.setXYZ(9, t1.r, t1.g, t1.b), a.setXYZ(10, t1.r, t1.g, t1.b), a.setXYZ(11, t1.r, t1.g, t1.b), a.setXYZ(12, t1.r, t1.g, t1.b), a.setXYZ(13, t1.r, t1.g, t1.b), a.setXYZ(14, t1.r, t1.g, t1.b), a.setXYZ(15, t1.r, t1.g, t1.b), a.setXYZ(16, t1.r, t1.g, t1.b), a.setXYZ(17, t1.r, t1.g, t1.b), a.setXYZ(18, t1.r, t1.g, t1.b), a.setXYZ(19, t1.r, t1.g, t1.b), a.setXYZ(20, t1.r, t1.g, t1.b), a.setXYZ(21, t1.r, t1.g, t1.b), a.setXYZ(22, t1.r, t1.g, t1.b), a.setXYZ(23, t1.r, t1.g, t1.b), a.setXYZ(24, e.r, e.g, e.b), a.setXYZ(25, e.r, e.g, e.b), a.setXYZ(26, e.r, e.g, e.b), a.setXYZ(27, e.r, e.g, e.b), a.setXYZ(28, e.r, e.g, e.b), a.setXYZ(29, e.r, e.g, e.b), a.setXYZ(30, e.r, e.g, e.b), a.setXYZ(31, e.r, e.g, e.b), a.setXYZ(32, i.r, i.g, i.b), a.setXYZ(33, i.r, i.g, i.b), a.setXYZ(34, i.r, i.g, i.b), a.setXYZ(35, i.r, i.g, i.b), a.setXYZ(36, i.r, i.g, i.b), a.setXYZ(37, i.r, i.g, i.b), a.setXYZ(38, n.r, n.g, n.b), a.setXYZ(39, n.r, n.g, n.b), a.setXYZ(40, r.r, r.g, r.b), a.setXYZ(41, r.r, r.g, r.b), a.setXYZ(42, r.r, r.g, r.b), a.setXYZ(43, r.r, r.g, r.b), a.setXYZ(44, r.r, r.g, r.b), a.setXYZ(45, r.r, r.g, r.b), a.setXYZ(46, r.r, r.g, r.b), a.setXYZ(47, r.r, r.g, r.b), a.setXYZ(48, r.r, r.g, r.b), a.setXYZ(49, r.r, r.g, r.b), a.needsUpdate = !0;
            }
            update() {
                const t1 = this.geometry, e = this.pointMap;
                ty.projectionMatrixInverse.copy(this.camera.projectionMatrixInverse), iy("c", e, t1, ty, 0, 0, -1), iy("t", e, t1, ty, 0, 0, 1), iy("n1", e, t1, ty, -1, -1, -1), iy("n2", e, t1, ty, 1, -1, -1), iy("n3", e, t1, ty, -1, 1, -1), iy("n4", e, t1, ty, 1, 1, -1), iy("f1", e, t1, ty, -1, -1, 1), iy("f2", e, t1, ty, 1, -1, 1), iy("f3", e, t1, ty, -1, 1, 1), iy("f4", e, t1, ty, 1, 1, 1), iy("u1", e, t1, ty, .7, 1.1, -1), iy("u2", e, t1, ty, -0.7, 1.1, -1), iy("u3", e, t1, ty, 0, 2, -1), iy("cf1", e, t1, ty, -1, 0, 1), iy("cf2", e, t1, ty, 1, 0, 1), iy("cf3", e, t1, ty, 0, -1, 1), iy("cf4", e, t1, ty, 0, 1, 1), iy("cn1", e, t1, ty, -1, 0, -1), iy("cn2", e, t1, ty, 1, 0, -1), iy("cn3", e, t1, ty, 0, -1, -1), iy("cn4", e, t1, ty, 0, 1, -1), t1.getAttribute("position").needsUpdate = !0;
            }
            dispose() {
                this.geometry.dispose(), this.material.dispose();
            }
        }
        function iy(t1, e, i, n, r, a, s) {
            $M.set(r, a, s).unproject(n);
            const o = e[t1];
            if (void 0 !== o) {
                const t1 = i.getAttribute("position");
                for(let e = 0, i = o.length; e < i; e++)t1.setXYZ(o[e], $M.x, $M.y, $M.z);
            }
        }
        const ny = new Tl;
        class ry extends Ff {
            constructor(t1, e = 16776960){
                const i = new Uint16Array([
                    0,
                    1,
                    1,
                    2,
                    2,
                    3,
                    3,
                    0,
                    4,
                    5,
                    5,
                    6,
                    6,
                    7,
                    7,
                    4,
                    0,
                    4,
                    1,
                    5,
                    2,
                    6,
                    3,
                    7
                ]), n = new Float32Array(24), r = new Au;
                r.setIndex(new Kc(i, 1)), r.setAttribute("position", new Kc(n, 3)), super(r, new Lf({
                    color: e,
                    toneMapped: !1
                })), this.object = t1, this.type = "BoxHelper", this.matrixAutoUpdate = !1, this.update();
            }
            update(t1) {
                if (void 0 !== t1 && console.warn("THREE.BoxHelper: .update() has no longer arguments."), void 0 !== this.object && ny.setFromObject(this.object), ny.isEmpty()) return;
                const e = ny.min, i = ny.max, n = this.geometry.attributes.position, r = n.array;
                r[0] = i.x, r[1] = i.y, r[2] = i.z, r[3] = e.x, r[4] = i.y, r[5] = i.z, r[6] = e.x, r[7] = e.y, r[8] = i.z, r[9] = i.x, r[10] = e.y, r[11] = i.z, r[12] = i.x, r[13] = i.y, r[14] = e.z, r[15] = e.x, r[16] = i.y, r[17] = e.z, r[18] = e.x, r[19] = e.y, r[20] = e.z, r[21] = i.x, r[22] = e.y, r[23] = e.z, n.needsUpdate = !0, this.geometry.computeBoundingSphere();
            }
            setFromObject(t1) {
                return this.object = t1, this.update(), this;
            }
            copy(t1, e) {
                return super.copy(t1, e), this.object = t1.object, this;
            }
            dispose() {
                this.geometry.dispose(), this.material.dispose();
            }
        }
        class ay extends Ff {
            constructor(t1, e = 16776960){
                const i = new Uint16Array([
                    0,
                    1,
                    1,
                    2,
                    2,
                    3,
                    3,
                    0,
                    4,
                    5,
                    5,
                    6,
                    6,
                    7,
                    7,
                    4,
                    0,
                    4,
                    1,
                    5,
                    2,
                    6,
                    3,
                    7
                ]), n = new Au;
                n.setIndex(new Kc(i, 1)), n.setAttribute("position", new su([
                    1,
                    1,
                    1,
                    -1,
                    1,
                    1,
                    -1,
                    -1,
                    1,
                    1,
                    -1,
                    1,
                    1,
                    1,
                    -1,
                    -1,
                    1,
                    -1,
                    -1,
                    -1,
                    -1,
                    1,
                    -1,
                    -1
                ], 3)), super(n, new Lf({
                    color: e,
                    toneMapped: !1
                })), this.box = t1, this.type = "Box3Helper", this.geometry.computeBoundingSphere();
            }
            updateMatrixWorld(t1) {
                const e = this.box;
                e.isEmpty() || (e.getCenter(this.position), e.getSize(this.scale), this.scale.multiplyScalar(.5), super.updateMatrixWorld(t1));
            }
            dispose() {
                this.geometry.dispose(), this.material.dispose();
            }
        }
        class sy extends Uf {
            constructor(t1, e = 1, i = 16776960){
                const n = i, r = new Au;
                r.setAttribute("position", new su([
                    1,
                    -1,
                    0,
                    -1,
                    1,
                    0,
                    -1,
                    -1,
                    0,
                    1,
                    1,
                    0,
                    -1,
                    1,
                    0,
                    -1,
                    -1,
                    0,
                    1,
                    -1,
                    0,
                    1,
                    1,
                    0
                ], 3)), r.computeBoundingSphere(), super(r, new Lf({
                    color: n,
                    toneMapped: !1
                })), this.type = "PlaneHelper", this.plane = t1, this.size = e;
                const a = new Au;
                a.setAttribute("position", new su([
                    1,
                    1,
                    0,
                    -1,
                    1,
                    0,
                    -1,
                    -1,
                    0,
                    1,
                    1,
                    0,
                    -1,
                    -1,
                    0,
                    1,
                    -1,
                    0
                ], 3)), a.computeBoundingSphere(), this.add(new Ou(a, new Hc({
                    color: n,
                    opacity: .2,
                    transparent: !0,
                    depthWrite: !1,
                    toneMapped: !1
                })));
            }
            updateMatrixWorld(t1) {
                this.position.set(0, 0, 0), this.scale.set(.5 * this.size, .5 * this.size, 1), this.lookAt(this.plane.normal), this.translateZ(-this.plane.constant), super.updateMatrixWorld(t1);
            }
            dispose() {
                this.geometry.dispose(), this.material.dispose(), this.children[0].geometry.dispose(), this.children[0].material.dispose();
            }
        }
        const oy = new xl;
        let ly, cy;
        class uy extends wc {
            constructor(t1 = new xl(0, 0, 1), e = new xl(0, 0, 0), i = 1, n = 16776960, r = .2 * i, a = .2 * r){
                super(), this.type = "ArrowHelper", void 0 === ly && (ly = new Au, ly.setAttribute("position", new su([
                    0,
                    0,
                    0,
                    0,
                    1,
                    0
                ], 3)), cy = new SA(0, .5, 1, 5, 1), cy.translate(0, -0.5, 0)), this.position.copy(e), this.line = new Uf(ly, new Lf({
                    color: n,
                    toneMapped: !1
                })), this.line.matrixAutoUpdate = !1, this.add(this.line), this.cone = new Ou(cy, new Hc({
                    color: n,
                    toneMapped: !1
                })), this.cone.matrixAutoUpdate = !1, this.add(this.cone), this.setDirection(t1), this.setLength(i, r, a);
            }
            setDirection(t1) {
                if (t1.y > .99999) this.quaternion.set(0, 0, 0, 1);
                else if (t1.y < -0.99999) this.quaternion.set(1, 0, 0, 0);
                else {
                    oy.set(t1.z, 0, -t1.x).normalize();
                    const e = Math.acos(t1.y);
                    this.quaternion.setFromAxisAngle(oy, e);
                }
            }
            setLength(t1, e = .2 * t1, i = .2 * e) {
                this.line.scale.set(1, Math.max(1e-4, t1 - e), 1), this.line.updateMatrix(), this.cone.scale.set(i, e, i), this.cone.position.y = t1, this.cone.updateMatrix();
            }
            setColor(t1) {
                this.line.material.color.set(t1), this.cone.material.color.set(t1);
            }
            copy(t1) {
                return super.copy(t1, !1), this.line.copy(t1.line), this.cone.copy(t1.cone), this;
            }
            dispose() {
                this.line.geometry.dispose(), this.line.material.dispose(), this.cone.geometry.dispose(), this.cone.material.dispose();
            }
        }
        class hy extends Ff {
            constructor(t1 = 1){
                const e = [
                    0,
                    0,
                    0,
                    t1,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    t1,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    t1
                ], i = new Au;
                i.setAttribute("position", new su(e, 3)), i.setAttribute("color", new su([
                    1,
                    0,
                    0,
                    1,
                    .6,
                    0,
                    0,
                    1,
                    0,
                    .6,
                    1,
                    0,
                    0,
                    0,
                    1,
                    0,
                    .6,
                    1
                ], 3)), super(i, new Lf({
                    vertexColors: !0,
                    toneMapped: !1
                })), this.type = "AxesHelper";
            }
            setColors(t1, e, i) {
                const n = new kc, r = this.geometry.attributes.color.array;
                return n.set(t1), n.toArray(r, 0), n.toArray(r, 3), n.set(e), n.toArray(r, 6), n.toArray(r, 9), n.set(i), n.toArray(r, 12), n.toArray(r, 15), this.geometry.attributes.color.needsUpdate = !0, this;
            }
            dispose() {
                this.geometry.dispose(), this.material.dispose();
            }
        }
        class dy {
            constructor(){
                this.type = "ShapePath", this.color = new kc, this.subPaths = [], this.currentPath = null;
            }
            moveTo(t1, e) {
                return this.currentPath = new bA, this.subPaths.push(this.currentPath), this.currentPath.moveTo(t1, e), this;
            }
            lineTo(t1, e) {
                return this.currentPath.lineTo(t1, e), this;
            }
            quadraticCurveTo(t1, e, i, n) {
                return this.currentPath.quadraticCurveTo(t1, e, i, n), this;
            }
            bezierCurveTo(t1, e, i, n, r, a) {
                return this.currentPath.bezierCurveTo(t1, e, i, n, r, a), this;
            }
            splineThru(t1) {
                return this.currentPath.splineThru(t1), this;
            }
            toShapes(t1) {
                function e(t1, e) {
                    const i = e.length;
                    let n = !1;
                    for(let r = i - 1, a = 0; a < i; r = a++){
                        let i = e[r], s = e[a], o = s.x - i.x, l = s.y - i.y;
                        if (Math.abs(l) > Number.EPSILON) {
                            if (l < 0 && (i = e[a], o = -o, s = e[r], l = -l), t1.y < i.y || t1.y > s.y) continue;
                            if (t1.y === i.y) {
                                if (t1.x === i.x) return !0;
                            } else {
                                const e = l * (t1.x - i.x) - o * (t1.y - i.y);
                                if (0 === e) return !0;
                                if (e < 0) continue;
                                n = !n;
                            }
                        } else {
                            if (t1.y !== i.y) continue;
                            if (s.x <= t1.x && t1.x <= i.x || i.x <= t1.x && t1.x <= s.x) return !0;
                        }
                    }
                    return n;
                }
                const i = og.isClockWise, n = this.subPaths;
                if (0 === n.length) return [];
                let r, a, s;
                const o = [];
                if (1 === n.length) return a = n[0], s = new PA, s.curves = a.curves, o.push(s), o;
                let l = !i(n[0].getPoints());
                l = t1 ? !l : l;
                const c = [], u = [];
                let h, d, p = [], f = 0;
                u[f] = void 0, p[f] = [];
                for(let e = 0, s = n.length; e < s; e++)a = n[e], h = a.getPoints(), r = i(h), r = t1 ? !r : r, r ? (!l && u[f] && f++, u[f] = {
                    s: new PA,
                    p: h
                }, u[f].s.curves = a.curves, l && f++, p[f] = []) : p[f].push({
                    h: a,
                    p: h[0]
                });
                if (!u[0]) return function(t1) {
                    const e = [];
                    for(let i = 0, n = t1.length; i < n; i++){
                        const n = t1[i], r = new PA;
                        r.curves = n.curves, e.push(r);
                    }
                    return e;
                }(n);
                if (u.length > 1) {
                    let t1 = !1, i = 0;
                    for(let t1 = 0, e = u.length; t1 < e; t1++)c[t1] = [];
                    for(let n = 0, r = u.length; n < r; n++){
                        const r = p[n];
                        for(let a = 0; a < r.length; a++){
                            const s = r[a];
                            let o = !0;
                            for(let r = 0; r < u.length; r++)e(s.p, u[r].p) && (n !== r && i++, o ? (o = !1, c[r].push(s)) : t1 = !0);
                            o && c[n].push(s);
                        }
                    }
                    i > 0 && !1 === t1 && (p = c);
                }
                for(let t1 = 0, e = u.length; t1 < e; t1++){
                    s = u[t1].s, o.push(s), d = p[t1];
                    for(let t1 = 0, e = d.length; t1 < e; t1++)s.holes.push(d[t1].h);
                }
                return o;
            }
        }
        function py(t1, e) {
            if (e === Ts) return console.warn("THREE.BufferGeometryUtils.toTrianglesDrawMode(): Geometry already defined as triangles."), t1;
            if (e === Is || e === Es) {
                let i = t1.getIndex();
                if (null === i) {
                    const e = [], n = t1.getAttribute("position");
                    if (void 0 === n) return console.error("THREE.BufferGeometryUtils.toTrianglesDrawMode(): Undefined position attribute. Processing not possible."), t1;
                    for(let t1 = 0; t1 < n.count; t1++)e.push(t1);
                    t1.setIndex(e), i = t1.getIndex();
                }
                const n = i.count - 2, r = [];
                if (e === Is) for(let t1 = 1; t1 <= n; t1++)r.push(i.getX(0)), r.push(i.getX(t1)), r.push(i.getX(t1 + 1));
                else for(let t1 = 0; t1 < n; t1++)t1 % 2 == 0 ? (r.push(i.getX(t1)), r.push(i.getX(t1 + 1)), r.push(i.getX(t1 + 2))) : (r.push(i.getX(t1 + 2)), r.push(i.getX(t1 + 1)), r.push(i.getX(t1)));
                r.length / 3 !== n && console.error("THREE.BufferGeometryUtils.toTrianglesDrawMode(): Unable to generate correct amount of triangles.");
                const a = t1.clone();
                return a.setIndex(r), a.clearGroups(), a;
            }
            return console.error("THREE.BufferGeometryUtils.toTrianglesDrawMode(): Unknown draw mode:", e), t1;
        }
        "undefined" != typeof __THREE_DEVTOOLS__ && __THREE_DEVTOOLS__.dispatchEvent(new CustomEvent("register", {
            detail: {
                revision: Qn
            }
        })), "undefined" != typeof window && (window.__THREE__ ? console.warn("WARNING: Multiple instances of Three.js being imported.") : window.__THREE__ = Qn);
        class fy extends nm {
            constructor(t1){
                super(t1), this.dracoLoader = null, this.ktx2Loader = null, this.meshoptDecoder = null, this.pluginCallbacks = [], this.register(function(t1) {
                    return new vy(t1);
                }), this.register(function(t1) {
                    return new Ny(t1);
                }), this.register(function(t1) {
                    return new Dy(t1);
                }), this.register(function(t1) {
                    return new Cy(t1);
                }), this.register(function(t1) {
                    return new wy(t1);
                }), this.register(function(t1) {
                    return new by(t1);
                }), this.register(function(t1) {
                    return new Ty(t1);
                }), this.register(function(t1) {
                    return new Ey(t1);
                }), this.register(function(t1) {
                    return new yy(t1);
                }), this.register(function(t1) {
                    return new Iy(t1);
                }), this.register(function(t1) {
                    return new xy(t1);
                }), this.register(function(t1) {
                    return new Sy(t1);
                }), this.register(function(t1) {
                    return new my(t1);
                }), this.register(function(t1) {
                    return new zy(t1);
                }), this.register(function(t1) {
                    return new Ly(t1);
                });
            }
            load(t1, e, i, n) {
                const r = this;
                let a;
                a = "" !== this.resourcePath ? this.resourcePath : "" !== this.path ? this.path : Om.extractUrlBase(t1), this.manager.itemStart(t1);
                const s = function(e) {
                    n ? n(e) : console.error(e), r.manager.itemError(t1), r.manager.itemEnd(t1);
                }, o = new sm(this.manager);
                o.setPath(this.path), o.setResponseType("arraybuffer"), o.setRequestHeader(this.requestHeader), o.setWithCredentials(this.withCredentials), o.load(t1, function(i) {
                    try {
                        r.parse(i, a, function(i) {
                            e(i), r.manager.itemEnd(t1);
                        }, s);
                    } catch (t1) {
                        s(t1);
                    }
                }, i, s);
            }
            setDRACOLoader(t1) {
                return this.dracoLoader = t1, this;
            }
            setDDSLoader() {
                throw new Error('THREE.GLTFLoader: "MSFT_texture_dds" no longer supported. Please update to "KHR_texture_basisu".');
            }
            setKTX2Loader(t1) {
                return this.ktx2Loader = t1, this;
            }
            setMeshoptDecoder(t1) {
                return this.meshoptDecoder = t1, this;
            }
            register(t1) {
                return -1 === this.pluginCallbacks.indexOf(t1) && this.pluginCallbacks.push(t1), this;
            }
            unregister(t1) {
                return -1 !== this.pluginCallbacks.indexOf(t1) && this.pluginCallbacks.splice(this.pluginCallbacks.indexOf(t1), 1), this;
            }
            parse(t1, e, i, n) {
                let r;
                const a = {}, s = {}, o = new TextDecoder;
                if ("string" == typeof t1) r = JSON.parse(t1);
                else if (t1 instanceof ArrayBuffer) {
                    if (o.decode(new Uint8Array(t1, 0, 4)) === Oy) {
                        try {
                            a[gy.KHR_BINARY_GLTF] = new _y(t1);
                        } catch (t1) {
                            return void (n && n(t1));
                        }
                        r = JSON.parse(a[gy.KHR_BINARY_GLTF].content);
                    } else r = JSON.parse(o.decode(t1));
                } else r = t1;
                if (void 0 === r.asset || r.asset.version[0] < 2) return void (n && n(new Error("THREE.GLTFLoader: Unsupported asset. glTF versions >=2.0 are supported.")));
                const l = new iv(r, {
                    path: e || this.resourcePath || "",
                    crossOrigin: this.crossOrigin,
                    requestHeader: this.requestHeader,
                    manager: this.manager,
                    ktx2Loader: this.ktx2Loader,
                    meshoptDecoder: this.meshoptDecoder
                });
                l.fileLoader.setRequestHeader(this.requestHeader);
                for(let t1 = 0; t1 < this.pluginCallbacks.length; t1++){
                    const e = this.pluginCallbacks[t1](l);
                    e.name || console.error("THREE.GLTFLoader: Invalid plugin found: missing name"), s[e.name] = e, a[e.name] = !0;
                }
                if (r.extensionsUsed) for(let t1 = 0; t1 < r.extensionsUsed.length; ++t1){
                    const e = r.extensionsUsed[t1], i = r.extensionsRequired || [];
                    switch(e){
                        case gy.KHR_MATERIALS_UNLIT:
                            a[e] = new My;
                            break;
                        case gy.KHR_DRACO_MESH_COMPRESSION:
                            a[e] = new jy(r, this.dracoLoader);
                            break;
                        case gy.KHR_TEXTURE_TRANSFORM:
                            a[e] = new Py;
                            break;
                        case gy.KHR_MESH_QUANTIZATION:
                            a[e] = new Ry;
                            break;
                        default:
                            i.indexOf(e) >= 0 && void 0 === s[e] && console.warn('THREE.GLTFLoader: Unknown extension "' + e + '".');
                    }
                }
                l.setExtensions(a), l.setPlugins(s), l.parse(i, n);
            }
            parseAsync(t1, e) {
                const i = this;
                return new Promise(function(n, r) {
                    i.parse(t1, e, n, r);
                });
            }
        }
        function Ay() {
            let t1 = {};
            return {
                get: function(e) {
                    return t1[e];
                },
                add: function(e, i) {
                    t1[e] = i;
                },
                remove: function(e) {
                    delete t1[e];
                },
                removeAll: function() {
                    t1 = {};
                }
            };
        }
        const gy = {
            KHR_BINARY_GLTF: "KHR_binary_glTF",
            KHR_DRACO_MESH_COMPRESSION: "KHR_draco_mesh_compression",
            KHR_LIGHTS_PUNCTUAL: "KHR_lights_punctual",
            KHR_MATERIALS_CLEARCOAT: "KHR_materials_clearcoat",
            KHR_MATERIALS_IOR: "KHR_materials_ior",
            KHR_MATERIALS_SHEEN: "KHR_materials_sheen",
            KHR_MATERIALS_SPECULAR: "KHR_materials_specular",
            KHR_MATERIALS_TRANSMISSION: "KHR_materials_transmission",
            KHR_MATERIALS_IRIDESCENCE: "KHR_materials_iridescence",
            KHR_MATERIALS_ANISOTROPY: "KHR_materials_anisotropy",
            KHR_MATERIALS_UNLIT: "KHR_materials_unlit",
            KHR_MATERIALS_VOLUME: "KHR_materials_volume",
            KHR_TEXTURE_BASISU: "KHR_texture_basisu",
            KHR_TEXTURE_TRANSFORM: "KHR_texture_transform",
            KHR_MESH_QUANTIZATION: "KHR_mesh_quantization",
            KHR_MATERIALS_EMISSIVE_STRENGTH: "KHR_materials_emissive_strength",
            EXT_TEXTURE_WEBP: "EXT_texture_webp",
            EXT_TEXTURE_AVIF: "EXT_texture_avif",
            EXT_MESHOPT_COMPRESSION: "EXT_meshopt_compression",
            EXT_MESH_GPU_INSTANCING: "EXT_mesh_gpu_instancing"
        };
        class my {
            constructor(t1){
                this.parser = t1, this.name = gy.KHR_LIGHTS_PUNCTUAL, this.cache = {
                    refs: {},
                    uses: {}
                };
            }
            _markDefs() {
                const t1 = this.parser, e = this.parser.json.nodes || [];
                for(let i = 0, n = e.length; i < n; i++){
                    const n = e[i];
                    n.extensions && n.extensions[this.name] && void 0 !== n.extensions[this.name].light && t1._addNodeRef(this.cache, n.extensions[this.name].light);
                }
            }
            _loadLight(t1) {
                const e = this.parser, i = "light:" + t1;
                let n = e.cache.get(i);
                if (n) return n;
                const r = e.json, a = ((r.extensions && r.extensions[this.name] || {}).lights || [])[t1];
                let s;
                const o = new kc(16777215);
                void 0 !== a.color && o.setRGB(a.color[0], a.color[1], a.color[2], js);
                const l = void 0 !== a.range ? a.range : 0;
                switch(a.type){
                    case "directional":
                        s = new Sm(o), s.target.position.set(0, 0, -1), s.add(s.target);
                        break;
                    case "point":
                        s = new Em(o), s.distance = l;
                        break;
                    case "spot":
                        s = new vm(o), s.distance = l, a.spot = a.spot || {}, a.spot.innerConeAngle = void 0 !== a.spot.innerConeAngle ? a.spot.innerConeAngle : 0, a.spot.outerConeAngle = void 0 !== a.spot.outerConeAngle ? a.spot.outerConeAngle : Math.PI / 4, s.angle = a.spot.outerConeAngle, s.penumbra = 1 - a.spot.innerConeAngle / a.spot.outerConeAngle, s.target.position.set(0, 0, -1), s.add(s.target);
                        break;
                    default:
                        throw new Error("THREE.GLTFLoader: Unexpected light type: " + a.type);
                }
                return s.position.set(0, 0, 0), s.decay = 2, Jy(s, a), void 0 !== a.intensity && (s.intensity = a.intensity), s.name = e.createUniqueName(a.name || "light_" + t1), n = Promise.resolve(s), e.cache.add(i, n), n;
            }
            getDependency(t1, e) {
                if ("light" === t1) return this._loadLight(e);
            }
            createNodeAttachment(t1) {
                const e = this, i = this.parser, n = i.json.nodes[t1], r = (n.extensions && n.extensions[this.name] || {}).light;
                return void 0 === r ? null : this._loadLight(r).then(function(t1) {
                    return i._getNodeRef(e.cache, r, t1);
                });
            }
        }
        class My {
            constructor(){
                this.name = gy.KHR_MATERIALS_UNLIT;
            }
            getMaterialType() {
                return Hc;
            }
            extendParams(t1, e, i) {
                const n = [];
                t1.color = new kc(1, 1, 1), t1.opacity = 1;
                const r = e.pbrMetallicRoughness;
                if (r) {
                    if (Array.isArray(r.baseColorFactor)) {
                        const e = r.baseColorFactor;
                        t1.color.setRGB(e[0], e[1], e[2], js), t1.opacity = e[3];
                    }
                    void 0 !== r.baseColorTexture && n.push(i.assignTexture(t1, "map", r.baseColorTexture, _s));
                }
                return Promise.all(n);
            }
        }
        class yy {
            constructor(t1){
                this.parser = t1, this.name = gy.KHR_MATERIALS_EMISSIVE_STRENGTH;
            }
            extendMaterialParams(t1, e) {
                const i = this.parser.json.materials[t1];
                if (!i.extensions || !i.extensions[this.name]) return Promise.resolve();
                const n = i.extensions[this.name].emissiveStrength;
                return void 0 !== n && (e.emissiveIntensity = n), Promise.resolve();
            }
        }
        class vy {
            constructor(t1){
                this.parser = t1, this.name = gy.KHR_MATERIALS_CLEARCOAT;
            }
            getMaterialType(t1) {
                const e = this.parser.json.materials[t1];
                return e.extensions && e.extensions[this.name] ? Sg : null;
            }
            extendMaterialParams(t1, e) {
                const i = this.parser, n = i.json.materials[t1];
                if (!n.extensions || !n.extensions[this.name]) return Promise.resolve();
                const r = [], a = n.extensions[this.name];
                if (void 0 !== a.clearcoatFactor && (e.clearcoat = a.clearcoatFactor), void 0 !== a.clearcoatTexture && r.push(i.assignTexture(e, "clearcoatMap", a.clearcoatTexture)), void 0 !== a.clearcoatRoughnessFactor && (e.clearcoatRoughness = a.clearcoatRoughnessFactor), void 0 !== a.clearcoatRoughnessTexture && r.push(i.assignTexture(e, "clearcoatRoughnessMap", a.clearcoatRoughnessTexture)), void 0 !== a.clearcoatNormalTexture && (r.push(i.assignTexture(e, "clearcoatNormalMap", a.clearcoatNormalTexture)), void 0 !== a.clearcoatNormalTexture.scale)) {
                    const t1 = a.clearcoatNormalTexture.scale;
                    e.clearcoatNormalScale = new Qo(t1, t1);
                }
                return Promise.all(r);
            }
        }
        class xy {
            constructor(t1){
                this.parser = t1, this.name = gy.KHR_MATERIALS_IRIDESCENCE;
            }
            getMaterialType(t1) {
                const e = this.parser.json.materials[t1];
                return e.extensions && e.extensions[this.name] ? Sg : null;
            }
            extendMaterialParams(t1, e) {
                const i = this.parser, n = i.json.materials[t1];
                if (!n.extensions || !n.extensions[this.name]) return Promise.resolve();
                const r = [], a = n.extensions[this.name];
                return void 0 !== a.iridescenceFactor && (e.iridescence = a.iridescenceFactor), void 0 !== a.iridescenceTexture && r.push(i.assignTexture(e, "iridescenceMap", a.iridescenceTexture)), void 0 !== a.iridescenceIor && (e.iridescenceIOR = a.iridescenceIor), void 0 === e.iridescenceThicknessRange && (e.iridescenceThicknessRange = [
                    100,
                    400
                ]), void 0 !== a.iridescenceThicknessMinimum && (e.iridescenceThicknessRange[0] = a.iridescenceThicknessMinimum), void 0 !== a.iridescenceThicknessMaximum && (e.iridescenceThicknessRange[1] = a.iridescenceThicknessMaximum), void 0 !== a.iridescenceThicknessTexture && r.push(i.assignTexture(e, "iridescenceThicknessMap", a.iridescenceThicknessTexture)), Promise.all(r);
            }
        }
        class wy {
            constructor(t1){
                this.parser = t1, this.name = gy.KHR_MATERIALS_SHEEN;
            }
            getMaterialType(t1) {
                const e = this.parser.json.materials[t1];
                return e.extensions && e.extensions[this.name] ? Sg : null;
            }
            extendMaterialParams(t1, e) {
                const i = this.parser, n = i.json.materials[t1];
                if (!n.extensions || !n.extensions[this.name]) return Promise.resolve();
                const r = [];
                e.sheenColor = new kc(0, 0, 0), e.sheenRoughness = 0, e.sheen = 1;
                const a = n.extensions[this.name];
                if (void 0 !== a.sheenColorFactor) {
                    const t1 = a.sheenColorFactor;
                    e.sheenColor.setRGB(t1[0], t1[1], t1[2], js);
                }
                return void 0 !== a.sheenRoughnessFactor && (e.sheenRoughness = a.sheenRoughnessFactor), void 0 !== a.sheenColorTexture && r.push(i.assignTexture(e, "sheenColorMap", a.sheenColorTexture, _s)), void 0 !== a.sheenRoughnessTexture && r.push(i.assignTexture(e, "sheenRoughnessMap", a.sheenRoughnessTexture)), Promise.all(r);
            }
        }
        class by {
            constructor(t1){
                this.parser = t1, this.name = gy.KHR_MATERIALS_TRANSMISSION;
            }
            getMaterialType(t1) {
                const e = this.parser.json.materials[t1];
                return e.extensions && e.extensions[this.name] ? Sg : null;
            }
            extendMaterialParams(t1, e) {
                const i = this.parser, n = i.json.materials[t1];
                if (!n.extensions || !n.extensions[this.name]) return Promise.resolve();
                const r = [], a = n.extensions[this.name];
                return void 0 !== a.transmissionFactor && (e.transmission = a.transmissionFactor), void 0 !== a.transmissionTexture && r.push(i.assignTexture(e, "transmissionMap", a.transmissionTexture)), Promise.all(r);
            }
        }
        class Ty {
            constructor(t1){
                this.parser = t1, this.name = gy.KHR_MATERIALS_VOLUME;
            }
            getMaterialType(t1) {
                const e = this.parser.json.materials[t1];
                return e.extensions && e.extensions[this.name] ? Sg : null;
            }
            extendMaterialParams(t1, e) {
                const i = this.parser, n = i.json.materials[t1];
                if (!n.extensions || !n.extensions[this.name]) return Promise.resolve();
                const r = [], a = n.extensions[this.name];
                e.thickness = void 0 !== a.thicknessFactor ? a.thicknessFactor : 0, void 0 !== a.thicknessTexture && r.push(i.assignTexture(e, "thicknessMap", a.thicknessTexture)), e.attenuationDistance = a.attenuationDistance || 1 / 0;
                const s = a.attenuationColor || [
                    1,
                    1,
                    1
                ];
                return e.attenuationColor = (new kc).setRGB(s[0], s[1], s[2], js), Promise.all(r);
            }
        }
        class Ey {
            constructor(t1){
                this.parser = t1, this.name = gy.KHR_MATERIALS_IOR;
            }
            getMaterialType(t1) {
                const e = this.parser.json.materials[t1];
                return e.extensions && e.extensions[this.name] ? Sg : null;
            }
            extendMaterialParams(t1, e) {
                const i = this.parser.json.materials[t1];
                if (!i.extensions || !i.extensions[this.name]) return Promise.resolve();
                const n = i.extensions[this.name];
                return e.ior = void 0 !== n.ior ? n.ior : 1.5, Promise.resolve();
            }
        }
        class Iy {
            constructor(t1){
                this.parser = t1, this.name = gy.KHR_MATERIALS_SPECULAR;
            }
            getMaterialType(t1) {
                const e = this.parser.json.materials[t1];
                return e.extensions && e.extensions[this.name] ? Sg : null;
            }
            extendMaterialParams(t1, e) {
                const i = this.parser, n = i.json.materials[t1];
                if (!n.extensions || !n.extensions[this.name]) return Promise.resolve();
                const r = [], a = n.extensions[this.name];
                e.specularIntensity = void 0 !== a.specularFactor ? a.specularFactor : 1, void 0 !== a.specularTexture && r.push(i.assignTexture(e, "specularIntensityMap", a.specularTexture));
                const s = a.specularColorFactor || [
                    1,
                    1,
                    1
                ];
                return e.specularColor = (new kc).setRGB(s[0], s[1], s[2], js), void 0 !== a.specularColorTexture && r.push(i.assignTexture(e, "specularColorMap", a.specularColorTexture, _s)), Promise.all(r);
            }
        }
        class Sy {
            constructor(t1){
                this.parser = t1, this.name = gy.KHR_MATERIALS_ANISOTROPY;
            }
            getMaterialType(t1) {
                const e = this.parser.json.materials[t1];
                return e.extensions && e.extensions[this.name] ? Sg : null;
            }
            extendMaterialParams(t1, e) {
                const i = this.parser, n = i.json.materials[t1];
                if (!n.extensions || !n.extensions[this.name]) return Promise.resolve();
                const r = [], a = n.extensions[this.name];
                return void 0 !== a.anisotropyStrength && (e.anisotropy = a.anisotropyStrength), void 0 !== a.anisotropyRotation && (e.anisotropyRotation = a.anisotropyRotation), void 0 !== a.anisotropyTexture && r.push(i.assignTexture(e, "anisotropyMap", a.anisotropyTexture)), Promise.all(r);
            }
        }
        class Ny {
            constructor(t1){
                this.parser = t1, this.name = gy.KHR_TEXTURE_BASISU;
            }
            loadTexture(t1) {
                const e = this.parser, i = e.json, n = i.textures[t1];
                if (!n.extensions || !n.extensions[this.name]) return null;
                const r = n.extensions[this.name], a = e.options.ktx2Loader;
                if (!a) {
                    if (i.extensionsRequired && i.extensionsRequired.indexOf(this.name) >= 0) throw new Error("THREE.GLTFLoader: setKTX2Loader must be called before loading KTX2 textures");
                    return null;
                }
                return e.loadTextureImage(t1, r.source, a);
            }
        }
        class Dy {
            constructor(t1){
                this.parser = t1, this.name = gy.EXT_TEXTURE_WEBP, this.isSupported = null;
            }
            loadTexture(t1) {
                const e = this.name, i = this.parser, n = i.json, r = n.textures[t1];
                if (!r.extensions || !r.extensions[e]) return null;
                const a = r.extensions[e], s = n.images[a.source];
                let o = i.textureLoader;
                if (s.uri) {
                    const t1 = i.options.manager.getHandler(s.uri);
                    null !== t1 && (o = t1);
                }
                return this.detectSupport().then(function(r) {
                    if (r) return i.loadTextureImage(t1, a.source, o);
                    if (n.extensionsRequired && n.extensionsRequired.indexOf(e) >= 0) throw new Error("THREE.GLTFLoader: WebP required by asset but unsupported.");
                    return i.loadTexture(t1);
                });
            }
            detectSupport() {
                return this.isSupported || (this.isSupported = new Promise(function(t1) {
                    const e = new Image;
                    e.src = "data:image/webp;base64,UklGRiIAAABXRUJQVlA4IBYAAAAwAQCdASoBAAEADsD+JaQAA3AAAAAA", e.onload = e.onerror = function() {
                        t1(1 === e.height);
                    };
                })), this.isSupported;
            }
        }
        class Cy {
            constructor(t1){
                this.parser = t1, this.name = gy.EXT_TEXTURE_AVIF, this.isSupported = null;
            }
            loadTexture(t1) {
                const e = this.name, i = this.parser, n = i.json, r = n.textures[t1];
                if (!r.extensions || !r.extensions[e]) return null;
                const a = r.extensions[e], s = n.images[a.source];
                let o = i.textureLoader;
                if (s.uri) {
                    const t1 = i.options.manager.getHandler(s.uri);
                    null !== t1 && (o = t1);
                }
                return this.detectSupport().then(function(r) {
                    if (r) return i.loadTextureImage(t1, a.source, o);
                    if (n.extensionsRequired && n.extensionsRequired.indexOf(e) >= 0) throw new Error("THREE.GLTFLoader: AVIF required by asset but unsupported.");
                    return i.loadTexture(t1);
                });
            }
            detectSupport() {
                return this.isSupported || (this.isSupported = new Promise(function(t1) {
                    const e = new Image;
                    e.src = "data:image/avif;base64,AAAAIGZ0eXBhdmlmAAAAAGF2aWZtaWYxbWlhZk1BMUIAAADybWV0YQAAAAAAAAAoaGRscgAAAAAAAAAAcGljdAAAAAAAAAAAAAAAAGxpYmF2aWYAAAAADnBpdG0AAAAAAAEAAAAeaWxvYwAAAABEAAABAAEAAAABAAABGgAAABcAAAAoaWluZgAAAAAAAQAAABppbmZlAgAAAAABAABhdjAxQ29sb3IAAAAAamlwcnAAAABLaXBjbwAAABRpc3BlAAAAAAAAAAEAAAABAAAAEHBpeGkAAAAAAwgICAAAAAxhdjFDgQAMAAAAABNjb2xybmNseAACAAIABoAAAAAXaXBtYQAAAAAAAAABAAEEAQKDBAAAAB9tZGF0EgAKCBgABogQEDQgMgkQAAAAB8dSLfI=", e.onload = e.onerror = function() {
                        t1(1 === e.height);
                    };
                })), this.isSupported;
            }
        }
        class zy {
            constructor(t1){
                this.name = gy.EXT_MESHOPT_COMPRESSION, this.parser = t1;
            }
            loadBufferView(t1) {
                const e = this.parser.json, i = e.bufferViews[t1];
                if (i.extensions && i.extensions[this.name]) {
                    const t1 = i.extensions[this.name], n = this.parser.getDependency("buffer", t1.buffer), r = this.parser.options.meshoptDecoder;
                    if (!r || !r.supported) {
                        if (e.extensionsRequired && e.extensionsRequired.indexOf(this.name) >= 0) throw new Error("THREE.GLTFLoader: setMeshoptDecoder must be called before loading compressed files");
                        return null;
                    }
                    return n.then(function(e) {
                        const i = t1.byteOffset || 0, n = t1.byteLength || 0, a = t1.count, s = t1.byteStride, o = new Uint8Array(e, i, n);
                        return r.decodeGltfBufferAsync ? r.decodeGltfBufferAsync(a, s, o, t1.mode, t1.filter).then(function(t1) {
                            return t1.buffer;
                        }) : r.ready.then(function() {
                            const e = new ArrayBuffer(a * s);
                            return r.decodeGltfBuffer(new Uint8Array(e), a, s, o, t1.mode, t1.filter), e;
                        });
                    });
                }
                return null;
            }
        }
        class Ly {
            constructor(t1){
                this.name = gy.EXT_MESH_GPU_INSTANCING, this.parser = t1;
            }
            createNodeMesh(t1) {
                const e = this.parser.json, i = e.nodes[t1];
                if (!i.extensions || !i.extensions[this.name] || void 0 === i.mesh) return null;
                const n = e.meshes[i.mesh];
                for (const t1 of n.primitives)if (t1.mode !== Fy.TRIANGLES && t1.mode !== Fy.TRIANGLE_STRIP && t1.mode !== Fy.TRIANGLE_FAN && void 0 !== t1.mode) return null;
                const r = i.extensions[this.name].attributes, a = [], s = {};
                for(const t1 in r)a.push(this.parser.getDependency("accessor", r[t1]).then((e)=>(s[t1] = e, s[t1])));
                return a.length < 1 ? null : (a.push(this.parser.createNodeMesh(t1)), Promise.all(a).then((t1)=>{
                    const e = t1.pop(), i = e.isGroup ? e.children : [
                        e
                    ], n = t1[0].count, r = [];
                    for (const t1 of i){
                        const e = new Kl, i = new xl, a = new vl, o = new xl(1, 1, 1), l = new zf(t1.geometry, t1.material, n);
                        for(let t1 = 0; t1 < n; t1++)s.TRANSLATION && i.fromBufferAttribute(s.TRANSLATION, t1), s.ROTATION && a.fromBufferAttribute(s.ROTATION, t1), s.SCALE && o.fromBufferAttribute(s.SCALE, t1), l.setMatrixAt(t1, e.compose(i, a, o));
                        for(const e in s)if ("_COLOR_0" === e) {
                            const t1 = s[e];
                            l.instanceColor = new bf(t1.array, t1.itemSize, t1.normalized);
                        } else "TRANSLATION" !== e && "ROTATION" !== e && "SCALE" !== e && t1.geometry.setAttribute(e, s[e]);
                        wc.prototype.copy.call(l, t1), this.parser.assignFinalMaterial(l), r.push(l);
                    }
                    return e.isGroup ? (e.clear(), e.add(...r), e) : r[0];
                }));
            }
        }
        const Oy = "glTF";
        class _y {
            constructor(t1){
                this.name = gy.KHR_BINARY_GLTF, this.content = null, this.body = null;
                const e = new DataView(t1, 0, 12), i = new TextDecoder;
                if (this.header = {
                    magic: i.decode(new Uint8Array(t1.slice(0, 4))),
                    version: e.getUint32(4, !0),
                    length: e.getUint32(8, !0)
                }, this.header.magic !== Oy) throw new Error("THREE.GLTFLoader: Unsupported glTF-Binary header.");
                if (this.header.version < 2) throw new Error("THREE.GLTFLoader: Legacy binary file detected.");
                const n = this.header.length - 12, r = new DataView(t1, 12);
                let a = 0;
                for(; a < n;){
                    const e = r.getUint32(a, !0);
                    a += 4;
                    const n = r.getUint32(a, !0);
                    if (a += 4, 1313821514 === n) {
                        const n = new Uint8Array(t1, 12 + a, e);
                        this.content = i.decode(n);
                    } else if (5130562 === n) {
                        const i = 12 + a;
                        this.body = t1.slice(i, i + e);
                    }
                    a += e;
                }
                if (null === this.content) throw new Error("THREE.GLTFLoader: JSON content not found.");
            }
        }
        class jy {
            constructor(t1, e){
                if (!e) throw new Error("THREE.GLTFLoader: No DRACOLoader instance provided.");
                this.name = gy.KHR_DRACO_MESH_COMPRESSION, this.json = t1, this.dracoLoader = e, this.dracoLoader.preload();
            }
            decodePrimitive(t1, e) {
                const i = this.json, n = this.dracoLoader, r = t1.extensions[this.name].bufferView, a = t1.extensions[this.name].attributes, s = {}, o = {}, l = {};
                for(const t1 in a){
                    const e = Yy[t1] || t1.toLowerCase();
                    s[e] = a[t1];
                }
                for(const e in t1.attributes){
                    const n = Yy[e] || e.toLowerCase();
                    if (void 0 !== a[e]) {
                        const r = i.accessors[t1.attributes[e]], a = Qy[r.componentType];
                        l[n] = a.name, o[n] = !0 === r.normalized;
                    }
                }
                return e.getDependency("bufferView", r).then(function(t1) {
                    return new Promise(function(e) {
                        n.decodeDracoFile(t1, function(t1) {
                            for(const e in t1.attributes){
                                const i = t1.attributes[e], n = o[e];
                                void 0 !== n && (i.normalized = n);
                            }
                            e(t1);
                        }, s, l);
                    });
                });
            }
        }
        class Py {
            constructor(){
                this.name = gy.KHR_TEXTURE_TRANSFORM;
            }
            extendTexture(t1, e) {
                return void 0 !== e.texCoord && e.texCoord !== t1.channel || void 0 !== e.offset || void 0 !== e.rotation || void 0 !== e.scale ? (t1 = t1.clone(), void 0 !== e.texCoord && (t1.channel = e.texCoord), void 0 !== e.offset && t1.offset.fromArray(e.offset), void 0 !== e.rotation && (t1.rotation = e.rotation), void 0 !== e.scale && t1.repeat.fromArray(e.scale), t1.needsUpdate = !0, t1) : t1;
            }
        }
        class Ry {
            constructor(){
                this.name = gy.KHR_MESH_QUANTIZATION;
            }
        }
        class Uy extends Bg {
            constructor(t1, e, i, n){
                super(t1, e, i, n);
            }
            copySampleValue_(t1) {
                const e = this.resultBuffer, i = this.sampleValues, n = this.valueSize, r = t1 * n * 3 + n;
                for(let t1 = 0; t1 !== n; t1++)e[t1] = i[r + t1];
                return e;
            }
            interpolate_(t1, e, i, n) {
                const r = this.resultBuffer, a = this.sampleValues, s = this.valueSize, o = 2 * s, l = 3 * s, c = n - e, u = (i - e) / c, h = u * u, d = h * u, p = t1 * l, f = p - l, A = -2 * d + 3 * h, g = d - h, m = 1 - A, M = g - h + u;
                for(let t1 = 0; t1 !== s; t1++){
                    const e = a[f + t1 + s], i = a[f + t1 + o] * c, n = a[p + t1 + s], l = a[p + t1] * c;
                    r[t1] = m * e + M * i + A * n + g * l;
                }
                return r;
            }
        }
        const ky = new vl;
        class By extends Uy {
            interpolate_(t1, e, i, n) {
                const r = super.interpolate_(t1, e, i, n);
                return ky.fromArray(r).normalize().toArray(r), r;
            }
        }
        const Fy = {
            FLOAT: 5126,
            FLOAT_MAT3: 35675,
            FLOAT_MAT4: 35676,
            FLOAT_VEC2: 35664,
            FLOAT_VEC3: 35665,
            FLOAT_VEC4: 35666,
            LINEAR: 9729,
            REPEAT: 10497,
            SAMPLER_2D: 35678,
            POINTS: 0,
            LINES: 1,
            LINE_LOOP: 2,
            LINE_STRIP: 3,
            TRIANGLES: 4,
            TRIANGLE_STRIP: 5,
            TRIANGLE_FAN: 6,
            UNSIGNED_BYTE: 5121,
            UNSIGNED_SHORT: 5123
        }, Qy = {
            5120: Int8Array,
            5121: Uint8Array,
            5122: Int16Array,
            5123: Uint16Array,
            5125: Uint32Array,
            5126: Float32Array
        }, Hy = {
            9728: na,
            9729: la,
            9984: ra,
            9985: ca,
            9986: sa,
            9987: ha
        }, Vy = {
            33071: ea,
            33648: ia,
            10497: ta
        }, Gy = {
            SCALAR: 1,
            VEC2: 2,
            VEC3: 3,
            VEC4: 4,
            MAT2: 4,
            MAT3: 9,
            MAT4: 16
        }, Yy = {
            POSITION: "position",
            NORMAL: "normal",
            TANGENT: "tangent",
            TEXCOORD_0: "uv",
            TEXCOORD_1: "uv1",
            TEXCOORD_2: "uv2",
            TEXCOORD_3: "uv3",
            COLOR_0: "color",
            WEIGHTS_0: "skinWeight",
            JOINTS_0: "skinIndex"
        }, Wy = {
            scale: "scale",
            translation: "position",
            rotation: "quaternion",
            weights: "morphTargetInfluences"
        }, Xy = {
            CUBICSPLINE: void 0,
            LINEAR: ms,
            STEP: gs
        };
        function Zy(t1, e, i) {
            for(const n in i.extensions)void 0 === t1[n] && (e.userData.gltfExtensions = e.userData.gltfExtensions || {}, e.userData.gltfExtensions[n] = i.extensions[n]);
        }
        function Jy(t1, e) {
            void 0 !== e.extras && ("object" == typeof e.extras ? Object.assign(t1.userData, e.extras) : console.warn("THREE.GLTFLoader: Ignoring primitive type .extras, " + e.extras));
        }
        function Ky(t1, e) {
            if (t1.updateMorphTargets(), void 0 !== e.weights) for(let i = 0, n = e.weights.length; i < n; i++)t1.morphTargetInfluences[i] = e.weights[i];
            if (e.extras && Array.isArray(e.extras.targetNames)) {
                const i = e.extras.targetNames;
                if (t1.morphTargetInfluences.length === i.length) {
                    t1.morphTargetDictionary = {};
                    for(let e = 0, n = i.length; e < n; e++)t1.morphTargetDictionary[i[e]] = e;
                } else console.warn("THREE.GLTFLoader: Invalid extras.targetNames length. Ignoring names.");
            }
        }
        function qy(t1) {
            let e;
            const i = t1.extensions && t1.extensions[gy.KHR_DRACO_MESH_COMPRESSION];
            if (e = i ? "draco:" + i.bufferView + ":" + i.indices + ":" + $y(i.attributes) : t1.indices + ":" + $y(t1.attributes) + ":" + t1.mode, void 0 !== t1.targets) for(let i = 0, n = t1.targets.length; i < n; i++)e += ":" + $y(t1.targets[i]);
            return e;
        }
        function $y(t1) {
            let e = "";
            const i = Object.keys(t1).sort();
            for(let n = 0, r = i.length; n < r; n++)e += i[n] + ":" + t1[i[n]] + ";";
            return e;
        }
        function tv(t1) {
            switch(t1){
                case Int8Array:
                    return 1 / 127;
                case Uint8Array:
                    return 1 / 255;
                case Int16Array:
                    return 1 / 32767;
                case Uint16Array:
                    return 1 / 65535;
                default:
                    throw new Error("THREE.GLTFLoader: Unsupported normalized accessor component type.");
            }
        }
        const ev = new Kl;
        class iv {
            constructor(t1 = {}, e = {}){
                this.json = t1, this.extensions = {}, this.plugins = {}, this.options = e, this.cache = new Ay, this.associations = new Map, this.primitiveCache = {}, this.nodeCache = {}, this.meshCache = {
                    refs: {},
                    uses: {}
                }, this.cameraCache = {
                    refs: {},
                    uses: {}
                }, this.lightCache = {
                    refs: {},
                    uses: {}
                }, this.sourceCache = {}, this.textureCache = {}, this.nodeNamesUsed = {};
                let i = !1, n = !1, r = -1;
                "undefined" != typeof navigator && (i = !0 === /^((?!chrome|android).)*safari/i.test(navigator.userAgent), n = navigator.userAgent.indexOf("Firefox") > -1, r = n ? navigator.userAgent.match(/Firefox\/([0-9]+)\./)[1] : -1), "undefined" == typeof createImageBitmap || i || n && r < 98 ? this.textureLoader = new dm(this.options.manager) : this.textureLoader = new Bm(this.options.manager), this.textureLoader.setCrossOrigin(this.options.crossOrigin), this.textureLoader.setRequestHeader(this.options.requestHeader), this.fileLoader = new sm(this.options.manager), this.fileLoader.setResponseType("arraybuffer"), "use-credentials" === this.options.crossOrigin && this.fileLoader.setWithCredentials(!0);
            }
            setExtensions(t1) {
                this.extensions = t1;
            }
            setPlugins(t1) {
                this.plugins = t1;
            }
            parse(t1, e) {
                const i = this, n = this.json, r = this.extensions;
                this.cache.removeAll(), this.nodeCache = {}, this._invokeAll(function(t1) {
                    return t1._markDefs && t1._markDefs();
                }), Promise.all(this._invokeAll(function(t1) {
                    return t1.beforeRoot && t1.beforeRoot();
                })).then(function() {
                    return Promise.all([
                        i.getDependencies("scene"),
                        i.getDependencies("animation"),
                        i.getDependencies("camera")
                    ]);
                }).then(function(e) {
                    const a = {
                        scene: e[0][n.scene || 0],
                        scenes: e[0],
                        animations: e[1],
                        cameras: e[2],
                        asset: n.asset,
                        parser: i,
                        userData: {}
                    };
                    return Zy(r, a, n), Jy(a, n), Promise.all(i._invokeAll(function(t1) {
                        return t1.afterRoot && t1.afterRoot(a);
                    })).then(function() {
                        t1(a);
                    });
                }).catch(e);
            }
            _markDefs() {
                const t1 = this.json.nodes || [], e = this.json.skins || [], i = this.json.meshes || [];
                for(let i = 0, n = e.length; i < n; i++){
                    const n = e[i].joints;
                    for(let e = 0, i = n.length; e < i; e++)t1[n[e]].isBone = !0;
                }
                for(let e = 0, n = t1.length; e < n; e++){
                    const n = t1[e];
                    void 0 !== n.mesh && (this._addNodeRef(this.meshCache, n.mesh), void 0 !== n.skin && (i[n.mesh].isSkinnedMesh = !0)), void 0 !== n.camera && this._addNodeRef(this.cameraCache, n.camera);
                }
            }
            _addNodeRef(t1, e) {
                void 0 !== e && (void 0 === t1.refs[e] && (t1.refs[e] = t1.uses[e] = 0), t1.refs[e]++);
            }
            _getNodeRef(t1, e, i) {
                if (t1.refs[e] <= 1) return i;
                const n = i.clone(), r = (t1, e)=>{
                    const i = this.associations.get(t1);
                    null != i && this.associations.set(e, i);
                    for (const [i, n] of t1.children.entries())r(n, e.children[i]);
                };
                return r(i, n), n.name += "_instance_" + t1.uses[e]++, n;
            }
            _invokeOne(t1) {
                const e = Object.values(this.plugins);
                e.push(this);
                for(let i = 0; i < e.length; i++){
                    const n = t1(e[i]);
                    if (n) return n;
                }
                return null;
            }
            _invokeAll(t1) {
                const e = Object.values(this.plugins);
                e.unshift(this);
                const i = [];
                for(let n = 0; n < e.length; n++){
                    const r = t1(e[n]);
                    r && i.push(r);
                }
                return i;
            }
            getDependency(t1, e) {
                const i = t1 + ":" + e;
                let n = this.cache.get(i);
                if (!n) {
                    switch(t1){
                        case "scene":
                            n = this.loadScene(e);
                            break;
                        case "node":
                            n = this._invokeOne(function(t1) {
                                return t1.loadNode && t1.loadNode(e);
                            });
                            break;
                        case "mesh":
                            n = this._invokeOne(function(t1) {
                                return t1.loadMesh && t1.loadMesh(e);
                            });
                            break;
                        case "accessor":
                            n = this.loadAccessor(e);
                            break;
                        case "bufferView":
                            n = this._invokeOne(function(t1) {
                                return t1.loadBufferView && t1.loadBufferView(e);
                            });
                            break;
                        case "buffer":
                            n = this.loadBuffer(e);
                            break;
                        case "material":
                            n = this._invokeOne(function(t1) {
                                return t1.loadMaterial && t1.loadMaterial(e);
                            });
                            break;
                        case "texture":
                            n = this._invokeOne(function(t1) {
                                return t1.loadTexture && t1.loadTexture(e);
                            });
                            break;
                        case "skin":
                            n = this.loadSkin(e);
                            break;
                        case "animation":
                            n = this._invokeOne(function(t1) {
                                return t1.loadAnimation && t1.loadAnimation(e);
                            });
                            break;
                        case "camera":
                            n = this.loadCamera(e);
                            break;
                        default:
                            if (n = this._invokeOne(function(i) {
                                return i != this && i.getDependency && i.getDependency(t1, e);
                            }), !n) throw new Error("Unknown type: " + t1);
                    }
                    this.cache.add(i, n);
                }
                return n;
            }
            getDependencies(t1) {
                let e = this.cache.get(t1);
                if (!e) {
                    const i = this, n = this.json[t1 + ("mesh" === t1 ? "es" : "s")] || [];
                    e = Promise.all(n.map(function(e, n) {
                        return i.getDependency(t1, n);
                    })), this.cache.add(t1, e);
                }
                return e;
            }
            loadBuffer(t1) {
                const e = this.json.buffers[t1], i = this.fileLoader;
                if (e.type && "arraybuffer" !== e.type) throw new Error("THREE.GLTFLoader: " + e.type + " buffer type is not supported.");
                if (void 0 === e.uri && 0 === t1) return Promise.resolve(this.extensions[gy.KHR_BINARY_GLTF].body);
                const n = this.options;
                return new Promise(function(t1, r) {
                    i.load(Om.resolveURL(e.uri, n.path), t1, void 0, function() {
                        r(new Error('THREE.GLTFLoader: Failed to load buffer "' + e.uri + '".'));
                    });
                });
            }
            loadBufferView(t1) {
                const e = this.json.bufferViews[t1];
                return this.getDependency("buffer", e.buffer).then(function(t1) {
                    const i = e.byteLength || 0, n = e.byteOffset || 0;
                    return t1.slice(n, n + i);
                });
            }
            loadAccessor(t1) {
                const e = this, i = this.json, n = this.json.accessors[t1];
                if (void 0 === n.bufferView && void 0 === n.sparse) {
                    const t1 = Gy[n.type], e = Qy[n.componentType], i = !0 === n.normalized, r = new e(n.count * t1);
                    return Promise.resolve(new Kc(r, t1, i));
                }
                const r = [];
                return void 0 !== n.bufferView ? r.push(this.getDependency("bufferView", n.bufferView)) : r.push(null), void 0 !== n.sparse && (r.push(this.getDependency("bufferView", n.sparse.indices.bufferView)), r.push(this.getDependency("bufferView", n.sparse.values.bufferView))), Promise.all(r).then(function(t1) {
                    const r = t1[0], a = Gy[n.type], s = Qy[n.componentType], o = s.BYTES_PER_ELEMENT, l = o * a, c = n.byteOffset || 0, u = void 0 !== n.bufferView ? i.bufferViews[n.bufferView].byteStride : void 0, h = !0 === n.normalized;
                    let d, p;
                    if (u && u !== l) {
                        const t1 = Math.floor(c / u), i = "InterleavedBuffer:" + n.bufferView + ":" + n.componentType + ":" + t1 + ":" + n.count;
                        let l = e.cache.get(i);
                        l || (d = new s(r, t1 * u, n.count * u / o), l = new kp(d, u / o), e.cache.add(i, l)), p = new Fp(l, a, c % u / o, h);
                    } else d = null === r ? new s(n.count * a) : new s(r, c, n.count * a), p = new Kc(d, a, h);
                    if (void 0 !== n.sparse) {
                        const e = Gy.SCALAR, i = Qy[n.sparse.indices.componentType], o = n.sparse.indices.byteOffset || 0, l = n.sparse.values.byteOffset || 0, c = new i(t1[1], o, n.sparse.count * e), u = new s(t1[2], l, n.sparse.count * a);
                        null !== r && (p = new Kc(p.array.slice(), p.itemSize, p.normalized));
                        for(let t1 = 0, e = c.length; t1 < e; t1++){
                            const e = c[t1];
                            if (p.setX(e, u[t1 * a]), a >= 2 && p.setY(e, u[t1 * a + 1]), a >= 3 && p.setZ(e, u[t1 * a + 2]), a >= 4 && p.setW(e, u[t1 * a + 3]), a >= 5) throw new Error("THREE.GLTFLoader: Unsupported itemSize in sparse BufferAttribute.");
                        }
                    }
                    return p;
                });
            }
            loadTexture(t1) {
                const e = this.json, i = this.options, n = e.textures[t1].source, r = e.images[n];
                let a = this.textureLoader;
                if (r.uri) {
                    const t1 = i.manager.getHandler(r.uri);
                    null !== t1 && (a = t1);
                }
                return this.loadTextureImage(t1, n, a);
            }
            loadTextureImage(t1, e, i) {
                const n = this, r = this.json, a = r.textures[t1], s = r.images[e], o = (s.uri || s.bufferView) + ":" + a.sampler;
                if (this.textureCache[o]) return this.textureCache[o];
                const l = this.loadImageSource(e, i).then(function(e) {
                    e.flipY = !1, e.name = a.name || s.name || "", "" === e.name && "string" == typeof s.uri && !1 === s.uri.startsWith("data:image/") && (e.name = s.uri);
                    const i = (r.samplers || {})[a.sampler] || {};
                    return e.magFilter = Hy[i.magFilter] || la, e.minFilter = Hy[i.minFilter] || ha, e.wrapS = Vy[i.wrapS] || ta, e.wrapT = Vy[i.wrapT] || ta, n.associations.set(e, {
                        textures: t1
                    }), e;
                }).catch(function() {
                    return null;
                });
                return this.textureCache[o] = l, l;
            }
            loadImageSource(t1, e) {
                const i = this.json, n = this.options;
                if (void 0 !== this.sourceCache[t1]) return this.sourceCache[t1].then((t1)=>t1.clone());
                const r = i.images[t1], a = self.URL || self.webkitURL;
                let s = r.uri || "", o = !1;
                if (void 0 !== r.bufferView) s = this.getDependency("bufferView", r.bufferView).then(function(t1) {
                    o = !0;
                    const e = new Blob([
                        t1
                    ], {
                        type: r.mimeType
                    });
                    return s = a.createObjectURL(e), s;
                });
                else if (void 0 === r.uri) throw new Error("THREE.GLTFLoader: Image " + t1 + " is missing URI and bufferView");
                const l = Promise.resolve(s).then(function(t1) {
                    return new Promise(function(i, r) {
                        let a = i;
                        !0 === e.isImageBitmapLoader && (a = function(t1) {
                            const e = new hl(t1);
                            e.needsUpdate = !0, i(e);
                        }), e.load(Om.resolveURL(t1, n.path), a, void 0, r);
                    });
                }).then(function(t1) {
                    var e;
                    return !0 === o && a.revokeObjectURL(s), t1.userData.mimeType = r.mimeType || ((e = r.uri).search(/\.jpe?g($|\?)/i) > 0 || 0 === e.search(/^data\:image\/jpeg/) ? "image/jpeg" : e.search(/\.webp($|\?)/i) > 0 || 0 === e.search(/^data\:image\/webp/) ? "image/webp" : "image/png"), t1;
                }).catch(function(t1) {
                    throw console.error("THREE.GLTFLoader: Couldn't load texture", s), t1;
                });
                return this.sourceCache[t1] = l, l;
            }
            assignTexture(t1, e, i, n) {
                const r = this;
                return this.getDependency("texture", i.index).then(function(a) {
                    if (!a) return null;
                    if (void 0 !== i.texCoord && i.texCoord > 0 && ((a = a.clone()).channel = i.texCoord), r.extensions[gy.KHR_TEXTURE_TRANSFORM]) {
                        const t1 = void 0 !== i.extensions ? i.extensions[gy.KHR_TEXTURE_TRANSFORM] : void 0;
                        if (t1) {
                            const e = r.associations.get(a);
                            a = r.extensions[gy.KHR_TEXTURE_TRANSFORM].extendTexture(a, t1), r.associations.set(a, e);
                        }
                    }
                    return void 0 !== n && (a.colorSpace = n), t1[e] = a, a;
                });
            }
            assignFinalMaterial(t1) {
                const e = t1.geometry;
                let i = t1.material;
                const n = void 0 === e.attributes.tangent, r = void 0 !== e.attributes.color, a = void 0 === e.attributes.normal;
                if (t1.isPoints) {
                    const t1 = "PointsMaterial:" + i.uuid;
                    let e = this.cache.get(t1);
                    e || (e = new Hf, Qc.prototype.copy.call(e, i), e.color.copy(i.color), e.map = i.map, e.sizeAttenuation = !1, this.cache.add(t1, e)), i = e;
                } else if (t1.isLine) {
                    const t1 = "LineBasicMaterial:" + i.uuid;
                    let e = this.cache.get(t1);
                    e || (e = new Lf, Qc.prototype.copy.call(e, i), e.color.copy(i.color), e.map = i.map, this.cache.add(t1, e)), i = e;
                }
                if (n || r || a) {
                    let t1 = "ClonedMaterial:" + i.uuid + ":";
                    n && (t1 += "derivative-tangents:"), r && (t1 += "vertex-colors:"), a && (t1 += "flat-shading:");
                    let e = this.cache.get(t1);
                    e || (e = i.clone(), r && (e.vertexColors = !0), a && (e.flatShading = !0), n && (e.normalScale && (e.normalScale.y *= -1), e.clearcoatNormalScale && (e.clearcoatNormalScale.y *= -1)), this.cache.add(t1, e), this.associations.set(e, this.associations.get(i))), i = e;
                }
                t1.material = i;
            }
            getMaterialType() {
                return Ig;
            }
            loadMaterial(t1) {
                const e = this, i = this.json, n = this.extensions, r = i.materials[t1];
                let a;
                const s = {}, o = [];
                if ((r.extensions || {})[gy.KHR_MATERIALS_UNLIT]) {
                    const t1 = n[gy.KHR_MATERIALS_UNLIT];
                    a = t1.getMaterialType(), o.push(t1.extendParams(s, r, e));
                } else {
                    const i = r.pbrMetallicRoughness || {};
                    if (s.color = new kc(1, 1, 1), s.opacity = 1, Array.isArray(i.baseColorFactor)) {
                        const t1 = i.baseColorFactor;
                        s.color.setRGB(t1[0], t1[1], t1[2], js), s.opacity = t1[3];
                    }
                    void 0 !== i.baseColorTexture && o.push(e.assignTexture(s, "map", i.baseColorTexture, _s)), s.metalness = void 0 !== i.metallicFactor ? i.metallicFactor : 1, s.roughness = void 0 !== i.roughnessFactor ? i.roughnessFactor : 1, void 0 !== i.metallicRoughnessTexture && (o.push(e.assignTexture(s, "metalnessMap", i.metallicRoughnessTexture)), o.push(e.assignTexture(s, "roughnessMap", i.metallicRoughnessTexture))), a = this._invokeOne(function(e) {
                        return e.getMaterialType && e.getMaterialType(t1);
                    }), o.push(Promise.all(this._invokeAll(function(e) {
                        return e.extendMaterialParams && e.extendMaterialParams(t1, s);
                    })));
                }
                !0 === r.doubleSided && (s.side = er);
                const l = r.alphaMode || "OPAQUE";
                if ("BLEND" === l ? (s.transparent = !0, s.depthWrite = !1) : (s.transparent = !1, "MASK" === l && (s.alphaTest = void 0 !== r.alphaCutoff ? r.alphaCutoff : .5)), void 0 !== r.normalTexture && a !== Hc && (o.push(e.assignTexture(s, "normalMap", r.normalTexture)), s.normalScale = new Qo(1, 1), void 0 !== r.normalTexture.scale)) {
                    const t1 = r.normalTexture.scale;
                    s.normalScale.set(t1, t1);
                }
                if (void 0 !== r.occlusionTexture && a !== Hc && (o.push(e.assignTexture(s, "aoMap", r.occlusionTexture)), void 0 !== r.occlusionTexture.strength && (s.aoMapIntensity = r.occlusionTexture.strength)), void 0 !== r.emissiveFactor && a !== Hc) {
                    const t1 = r.emissiveFactor;
                    s.emissive = (new kc).setRGB(t1[0], t1[1], t1[2], js);
                }
                return void 0 !== r.emissiveTexture && a !== Hc && o.push(e.assignTexture(s, "emissiveMap", r.emissiveTexture, _s)), Promise.all(o).then(function() {
                    const i = new a(s);
                    return r.name && (i.name = r.name), Jy(i, r), e.associations.set(i, {
                        materials: t1
                    }), r.extensions && Zy(n, i, r), i;
                });
            }
            createUniqueName(t1) {
                const e = AM.sanitizeNodeName(t1 || "");
                return e in this.nodeNamesUsed ? e + "_" + ++this.nodeNamesUsed[e] : (this.nodeNamesUsed[e] = 0, e);
            }
            loadGeometries(t1) {
                const e = this, i = this.extensions, n = this.primitiveCache;
                function r(t1) {
                    return i[gy.KHR_DRACO_MESH_COMPRESSION].decodePrimitive(t1, e).then(function(i) {
                        return nv(i, t1, e);
                    });
                }
                const a = [];
                for(let i = 0, s = t1.length; i < s; i++){
                    const s = t1[i], o = qy(s), l = n[o];
                    if (l) a.push(l.promise);
                    else {
                        let t1;
                        t1 = s.extensions && s.extensions[gy.KHR_DRACO_MESH_COMPRESSION] ? r(s) : nv(new Au, s, e), n[o] = {
                            primitive: s,
                            promise: t1
                        }, a.push(t1);
                    }
                }
                return Promise.all(a);
            }
            loadMesh(t1) {
                const e = this, i = this.json, n = this.extensions, r = i.meshes[t1], a = r.primitives, s = [];
                for(let t1 = 0, e = a.length; t1 < e; t1++){
                    const e = void 0 === a[t1].material ? (void 0 === (o = this.cache).DefaultMaterial && (o.DefaultMaterial = new Ig({
                        color: 16777215,
                        emissive: 0,
                        metalness: 1,
                        roughness: 1,
                        transparent: !1,
                        depthTest: !0,
                        side: $n
                    })), o.DefaultMaterial) : this.getDependency("material", a[t1].material);
                    s.push(e);
                }
                var o;
                return s.push(e.loadGeometries(a)), Promise.all(s).then(function(i) {
                    const s = i.slice(0, i.length - 1), o = i[i.length - 1], l = [];
                    for(let i = 0, c = o.length; i < c; i++){
                        const c = o[i], u = a[i];
                        let h;
                        const d = s[i];
                        if (u.mode === Fy.TRIANGLES || u.mode === Fy.TRIANGLE_STRIP || u.mode === Fy.TRIANGLE_FAN || void 0 === u.mode) h = !0 === r.isSkinnedMesh ? new mf(c, d) : new Ou(c, d), !0 === h.isSkinnedMesh && h.normalizeSkinWeights(), u.mode === Fy.TRIANGLE_STRIP ? h.geometry = py(h.geometry, Es) : u.mode === Fy.TRIANGLE_FAN && (h.geometry = py(h.geometry, Is));
                        else if (u.mode === Fy.LINES) h = new Ff(c, d);
                        else if (u.mode === Fy.LINE_STRIP) h = new Uf(c, d);
                        else if (u.mode === Fy.LINE_LOOP) h = new Qf(c, d);
                        else {
                            if (u.mode !== Fy.POINTS) throw new Error("THREE.GLTFLoader: Primitive mode unsupported: " + u.mode);
                            h = new Xf(c, d);
                        }
                        Object.keys(h.geometry.morphAttributes).length > 0 && Ky(h, r), h.name = e.createUniqueName(r.name || "mesh_" + t1), Jy(h, r), u.extensions && Zy(n, h, u), e.assignFinalMaterial(h), l.push(h);
                    }
                    for(let i = 0, n = l.length; i < n; i++)e.associations.set(l[i], {
                        meshes: t1,
                        primitives: i
                    });
                    if (1 === l.length) return r.extensions && Zy(n, l[0], r), l[0];
                    const c = new Sp;
                    r.extensions && Zy(n, c, r), e.associations.set(c, {
                        meshes: t1
                    });
                    for(let t1 = 0, e = l.length; t1 < e; t1++)c.add(l[t1]);
                    return c;
                });
            }
            loadCamera(t1) {
                let e;
                const i = this.json.cameras[t1], n = i[i.type];
                if (n) return "perspective" === i.type ? e = new Qu(Fo.radToDeg(n.yfov), n.aspectRatio || 1, n.znear || 1, n.zfar || 2e6) : "orthographic" === i.type && (e = new ph(-n.xmag, n.xmag, n.ymag, -n.ymag, n.znear, n.zfar)), i.name && (e.name = this.createUniqueName(i.name)), Jy(e, i), Promise.resolve(e);
                console.warn("THREE.GLTFLoader: Missing camera parameters.");
            }
            loadSkin(t1) {
                const e = this.json.skins[t1], i = [];
                for(let t1 = 0, n = e.joints.length; t1 < n; t1++)i.push(this._loadNodeShallow(e.joints[t1]));
                return void 0 !== e.inverseBindMatrices ? i.push(this.getDependency("accessor", e.inverseBindMatrices)) : i.push(null), Promise.all(i).then(function(t1) {
                    const i = t1.pop(), n = t1, r = [], a = [];
                    for(let t1 = 0, s = n.length; t1 < s; t1++){
                        const s = n[t1];
                        if (s) {
                            r.push(s);
                            const e = new Kl;
                            null !== i && e.fromArray(i.array, 16 * t1), a.push(e);
                        } else console.warn('THREE.GLTFLoader: Joint "%s" could not be found.', e.joints[t1]);
                    }
                    return new wf(r, a);
                });
            }
            loadAnimation(t1) {
                const e = this.json, i = this, n = e.animations[t1], r = n.name ? n.name : "animation_" + t1, a = [], s = [], o = [], l = [], c = [];
                for(let t1 = 0, e = n.channels.length; t1 < e; t1++){
                    const e = n.channels[t1], i = n.samplers[e.sampler], r = e.target, u = r.node, h = void 0 !== n.parameters ? n.parameters[i.input] : i.input, d = void 0 !== n.parameters ? n.parameters[i.output] : i.output;
                    void 0 !== r.node && (a.push(this.getDependency("node", u)), s.push(this.getDependency("accessor", h)), o.push(this.getDependency("accessor", d)), l.push(i), c.push(r));
                }
                return Promise.all([
                    Promise.all(a),
                    Promise.all(s),
                    Promise.all(o),
                    Promise.all(l),
                    Promise.all(c)
                ]).then(function(t1) {
                    const e = t1[0], n = t1[1], a = t1[2], s = t1[3], o = t1[4], l = [];
                    for(let t1 = 0, r = e.length; t1 < r; t1++){
                        const r = e[t1], c = n[t1], u = a[t1], h = s[t1], d = o[t1];
                        if (void 0 === r) continue;
                        r.updateMatrix && r.updateMatrix();
                        const p = i._createAnimationTracks(r, c, u, h, d);
                        if (p) for(let t1 = 0; t1 < p.length; t1++)l.push(p[t1]);
                    }
                    return new qg(r, void 0, l);
                });
            }
            createNodeMesh(t1) {
                const e = this.json, i = this, n = e.nodes[t1];
                return void 0 === n.mesh ? null : i.getDependency("mesh", n.mesh).then(function(t1) {
                    const e = i._getNodeRef(i.meshCache, n.mesh, t1);
                    return void 0 !== n.weights && e.traverse(function(t1) {
                        if (t1.isMesh) for(let e = 0, i = n.weights.length; e < i; e++)t1.morphTargetInfluences[e] = n.weights[e];
                    }), e;
                });
            }
            loadNode(t1) {
                const e = this, i = this.json.nodes[t1], n = e._loadNodeShallow(t1), r = [], a = i.children || [];
                for(let t1 = 0, i = a.length; t1 < i; t1++)r.push(e.getDependency("node", a[t1]));
                const s = void 0 === i.skin ? Promise.resolve(null) : e.getDependency("skin", i.skin);
                return Promise.all([
                    n,
                    Promise.all(r),
                    s
                ]).then(function(t1) {
                    const e = t1[0], i = t1[1], n = t1[2];
                    null !== n && e.traverse(function(t1) {
                        t1.isSkinnedMesh && t1.bind(n, ev);
                    });
                    for(let t1 = 0, n = i.length; t1 < n; t1++)e.add(i[t1]);
                    return e;
                });
            }
            _loadNodeShallow(t1) {
                const e = this.json, i = this.extensions, n = this;
                if (void 0 !== this.nodeCache[t1]) return this.nodeCache[t1];
                const r = e.nodes[t1], a = r.name ? n.createUniqueName(r.name) : "", s = [], o = n._invokeOne(function(e) {
                    return e.createNodeMesh && e.createNodeMesh(t1);
                });
                return o && s.push(o), void 0 !== r.camera && s.push(n.getDependency("camera", r.camera).then(function(t1) {
                    return n._getNodeRef(n.cameraCache, r.camera, t1);
                })), n._invokeAll(function(e) {
                    return e.createNodeAttachment && e.createNodeAttachment(t1);
                }).forEach(function(t1) {
                    s.push(t1);
                }), this.nodeCache[t1] = Promise.all(s).then(function(e) {
                    let s;
                    if (s = !0 === r.isBone ? new Mf : e.length > 1 ? new Sp : 1 === e.length ? e[0] : new wc, s !== e[0]) for(let t1 = 0, i = e.length; t1 < i; t1++)s.add(e[t1]);
                    if (r.name && (s.userData.name = r.name, s.name = a), Jy(s, r), r.extensions && Zy(i, s, r), void 0 !== r.matrix) {
                        const t1 = new Kl;
                        t1.fromArray(r.matrix), s.applyMatrix4(t1);
                    } else void 0 !== r.translation && s.position.fromArray(r.translation), void 0 !== r.rotation && s.quaternion.fromArray(r.rotation), void 0 !== r.scale && s.scale.fromArray(r.scale);
                    return n.associations.has(s) || n.associations.set(s, {}), n.associations.get(s).nodes = t1, s;
                }), this.nodeCache[t1];
            }
            loadScene(t1) {
                const e = this.extensions, i = this.json.scenes[t1], n = this, r = new Sp;
                i.name && (r.name = n.createUniqueName(i.name)), Jy(r, i), i.extensions && Zy(e, r, i);
                const a = i.nodes || [], s = [];
                for(let t1 = 0, e = a.length; t1 < e; t1++)s.push(n.getDependency("node", a[t1]));
                return Promise.all(s).then(function(t1) {
                    for(let e = 0, i = t1.length; e < i; e++)r.add(t1[e]);
                    return n.associations = ((t1)=>{
                        const e = new Map;
                        for (const [t1, i] of n.associations)(t1 instanceof Qc || t1 instanceof hl) && e.set(t1, i);
                        return t1.traverse((t1)=>{
                            const i = n.associations.get(t1);
                            null != i && e.set(t1, i);
                        }), e;
                    })(r), r;
                });
            }
            _createAnimationTracks(t1, e, i, n, r) {
                const a = [], s = t1.name ? t1.name : t1.uuid, o = [];
                let l;
                switch(Wy[r.path] === Wy.weights ? t1.traverse(function(t1) {
                    t1.morphTargetInfluences && o.push(t1.name ? t1.name : t1.uuid);
                }) : o.push(s), Wy[r.path]){
                    case Wy.weights:
                        l = Wg;
                        break;
                    case Wy.rotation:
                        l = Zg;
                        break;
                    case Wy.position:
                    case Wy.scale:
                        l = Kg;
                        break;
                    default:
                        l = 1 === i.itemSize ? Wg : Kg;
                }
                const c = void 0 !== n.interpolation ? Xy[n.interpolation] : ms, u = this._getArrayFromAccessor(i);
                for(let t1 = 0, i = o.length; t1 < i; t1++){
                    const i = new l(o[t1] + "." + Wy[r.path], e.array, u, c);
                    "CUBICSPLINE" === n.interpolation && this._createCubicSplineTrackInterpolant(i), a.push(i);
                }
                return a;
            }
            _getArrayFromAccessor(t1) {
                let e = t1.array;
                if (t1.normalized) {
                    const t1 = tv(e.constructor), i = new Float32Array(e.length);
                    for(let n = 0, r = e.length; n < r; n++)i[n] = e[n] * t1;
                    e = i;
                }
                return e;
            }
            _createCubicSplineTrackInterpolant(t1) {
                t1.createInterpolant = function(t1) {
                    return new (this instanceof Zg ? By : Uy)(this.times, this.values, this.getValueSize() / 3, t1);
                }, t1.createInterpolant.isInterpolantFactoryMethodGLTFCubicSpline = !0;
            }
        }
        function nv(t1, e, i) {
            const n = e.attributes, r = [];
            function a(e, n) {
                return i.getDependency("accessor", e).then(function(e) {
                    t1.setAttribute(n, e);
                });
            }
            for(const e in n){
                const i = Yy[e] || e.toLowerCase();
                i in t1.attributes || r.push(a(n[e], i));
            }
            if (void 0 !== e.indices && !t1.index) {
                const n = i.getDependency("accessor", e.indices).then(function(e) {
                    t1.setIndex(e);
                });
                r.push(n);
            }
            return il.workingColorSpace !== js && "COLOR_0" in n && console.warn(`THREE.GLTFLoader: Converting vertex colors from "srgb-linear" to "${il.workingColorSpace}" not supported.`), Jy(t1, e), function(t1, e, i) {
                const n = e.attributes, r = new Tl;
                if (void 0 === n.POSITION) return;
                {
                    const t1 = i.json.accessors[n.POSITION], e = t1.min, a = t1.max;
                    if (void 0 === e || void 0 === a) return void console.warn("THREE.GLTFLoader: Missing min/max properties for accessor POSITION.");
                    if (r.set(new xl(e[0], e[1], e[2]), new xl(a[0], a[1], a[2])), t1.normalized) {
                        const e = tv(Qy[t1.componentType]);
                        r.min.multiplyScalar(e), r.max.multiplyScalar(e);
                    }
                }
                const a = e.targets;
                if (void 0 !== a) {
                    const t1 = new xl, e = new xl;
                    for(let n = 0, r = a.length; n < r; n++){
                        const r = a[n];
                        if (void 0 !== r.POSITION) {
                            const n = i.json.accessors[r.POSITION], a = n.min, s = n.max;
                            if (void 0 !== a && void 0 !== s) {
                                if (e.setX(Math.max(Math.abs(a[0]), Math.abs(s[0]))), e.setY(Math.max(Math.abs(a[1]), Math.abs(s[1]))), e.setZ(Math.max(Math.abs(a[2]), Math.abs(s[2]))), n.normalized) {
                                    const t1 = tv(Qy[n.componentType]);
                                    e.multiplyScalar(t1);
                                }
                                t1.max(e);
                            } else console.warn("THREE.GLTFLoader: Missing min/max properties for accessor POSITION.");
                        }
                    }
                    r.expandByVector(t1);
                }
                t1.boundingBox = r;
                const s = new Ql;
                r.getCenter(s.center), s.radius = r.min.distanceTo(r.max) / 2, t1.boundingSphere = s;
            }(t1, e, i), Promise.all(r).then(function() {
                return void 0 !== e.targets ? function(t1, e, i) {
                    let n = !1, r = !1, a = !1;
                    for(let t1 = 0, i = e.length; t1 < i; t1++){
                        const i = e[t1];
                        if (void 0 !== i.POSITION && (n = !0), void 0 !== i.NORMAL && (r = !0), void 0 !== i.COLOR_0 && (a = !0), n && r && a) break;
                    }
                    if (!n && !r && !a) return Promise.resolve(t1);
                    const s = [], o = [], l = [];
                    for(let c = 0, u = e.length; c < u; c++){
                        const u = e[c];
                        if (n) {
                            const e = void 0 !== u.POSITION ? i.getDependency("accessor", u.POSITION) : t1.attributes.position;
                            s.push(e);
                        }
                        if (r) {
                            const e = void 0 !== u.NORMAL ? i.getDependency("accessor", u.NORMAL) : t1.attributes.normal;
                            o.push(e);
                        }
                        if (a) {
                            const e = void 0 !== u.COLOR_0 ? i.getDependency("accessor", u.COLOR_0) : t1.attributes.color;
                            l.push(e);
                        }
                    }
                    return Promise.all([
                        Promise.all(s),
                        Promise.all(o),
                        Promise.all(l)
                    ]).then(function(e) {
                        const i = e[0], s = e[1], o = e[2];
                        return n && (t1.morphAttributes.position = i), r && (t1.morphAttributes.normal = s), a && (t1.morphAttributes.color = o), t1.morphTargetsRelative = !0, t1;
                    });
                }(t1, e.targets, i) : t1;
            });
        }
        const rv = {
            Handedness: Object.freeze({
                NONE: "none",
                LEFT: "left",
                RIGHT: "right"
            }),
            ComponentState: Object.freeze({
                DEFAULT: "default",
                TOUCHED: "touched",
                PRESSED: "pressed"
            }),
            ComponentProperty: Object.freeze({
                BUTTON: "button",
                X_AXIS: "xAxis",
                Y_AXIS: "yAxis",
                STATE: "state"
            }),
            ComponentType: Object.freeze({
                TRIGGER: "trigger",
                SQUEEZE: "squeeze",
                TOUCHPAD: "touchpad",
                THUMBSTICK: "thumbstick",
                BUTTON: "button"
            }),
            ButtonTouchThreshold: .05,
            AxisTouchThreshold: .1,
            VisualResponseProperty: Object.freeze({
                TRANSFORM: "transform",
                VISIBILITY: "visibility"
            })
        };
        async function av(t1) {
            const e = await fetch(t1);
            if (e.ok) return e.json();
            throw new Error(e.statusText);
        }
        const sv = {
            xAxis: 0,
            yAxis: 0,
            button: 0,
            state: rv.ComponentState.DEFAULT
        };
        class ov {
            constructor(t1){
                this.componentProperty = t1.componentProperty, this.states = t1.states, this.valueNodeName = t1.valueNodeName, this.valueNodeProperty = t1.valueNodeProperty, this.valueNodeProperty === rv.VisualResponseProperty.TRANSFORM && (this.minNodeName = t1.minNodeName, this.maxNodeName = t1.maxNodeName), this.value = 0, this.updateFromComponent(sv);
            }
            updateFromComponent({ xAxis: t1, yAxis: e, button: i, state: n }) {
                const { normalizedXAxis: r, normalizedYAxis: a } = function(t1 = 0, e = 0) {
                    let i = t1, n = e;
                    if (Math.sqrt(t1 * t1 + e * e) > 1) {
                        const r = Math.atan2(e, t1);
                        i = Math.cos(r), n = Math.sin(r);
                    }
                    return {
                        normalizedXAxis: .5 * i + .5,
                        normalizedYAxis: .5 * n + .5
                    };
                }(t1, e);
                switch(this.componentProperty){
                    case rv.ComponentProperty.X_AXIS:
                        this.value = this.states.includes(n) ? r : .5;
                        break;
                    case rv.ComponentProperty.Y_AXIS:
                        this.value = this.states.includes(n) ? a : .5;
                        break;
                    case rv.ComponentProperty.BUTTON:
                        this.value = this.states.includes(n) ? i : 0;
                        break;
                    case rv.ComponentProperty.STATE:
                        this.valueNodeProperty === rv.VisualResponseProperty.VISIBILITY ? this.value = this.states.includes(n) : this.value = this.states.includes(n) ? 1 : 0;
                        break;
                    default:
                        throw new Error(`Unexpected visualResponse componentProperty ${this.componentProperty}`);
                }
            }
        }
        class lv {
            constructor(t1, e){
                if (!(t1 && e && e.visualResponses && e.gamepadIndices && 0 !== Object.keys(e.gamepadIndices).length)) throw new Error("Invalid arguments supplied");
                this.id = t1, this.type = e.type, this.rootNodeName = e.rootNodeName, this.touchPointNodeName = e.touchPointNodeName, this.visualResponses = {}, Object.keys(e.visualResponses).forEach((t1)=>{
                    const i = new ov(e.visualResponses[t1]);
                    this.visualResponses[t1] = i;
                }), this.gamepadIndices = Object.assign({}, e.gamepadIndices), this.values = {
                    state: rv.ComponentState.DEFAULT,
                    button: void 0 !== this.gamepadIndices.button ? 0 : void 0,
                    xAxis: void 0 !== this.gamepadIndices.xAxis ? 0 : void 0,
                    yAxis: void 0 !== this.gamepadIndices.yAxis ? 0 : void 0
                };
            }
            get data() {
                return {
                    id: this.id,
                    ...this.values
                };
            }
            updateFromGamepad(t1) {
                if (this.values.state = rv.ComponentState.DEFAULT, void 0 !== this.gamepadIndices.button && t1.buttons.length > this.gamepadIndices.button) {
                    const e = t1.buttons[this.gamepadIndices.button];
                    this.values.button = e.value, this.values.button = this.values.button < 0 ? 0 : this.values.button, this.values.button = this.values.button > 1 ? 1 : this.values.button, e.pressed || 1 === this.values.button ? this.values.state = rv.ComponentState.PRESSED : (e.touched || this.values.button > rv.ButtonTouchThreshold) && (this.values.state = rv.ComponentState.TOUCHED);
                }
                void 0 !== this.gamepadIndices.xAxis && t1.axes.length > this.gamepadIndices.xAxis && (this.values.xAxis = t1.axes[this.gamepadIndices.xAxis], this.values.xAxis = this.values.xAxis < -1 ? -1 : this.values.xAxis, this.values.xAxis = this.values.xAxis > 1 ? 1 : this.values.xAxis, this.values.state === rv.ComponentState.DEFAULT && Math.abs(this.values.xAxis) > rv.AxisTouchThreshold && (this.values.state = rv.ComponentState.TOUCHED)), void 0 !== this.gamepadIndices.yAxis && t1.axes.length > this.gamepadIndices.yAxis && (this.values.yAxis = t1.axes[this.gamepadIndices.yAxis], this.values.yAxis = this.values.yAxis < -1 ? -1 : this.values.yAxis, this.values.yAxis = this.values.yAxis > 1 ? 1 : this.values.yAxis, this.values.state === rv.ComponentState.DEFAULT && Math.abs(this.values.yAxis) > rv.AxisTouchThreshold && (this.values.state = rv.ComponentState.TOUCHED)), Object.values(this.visualResponses).forEach((t1)=>{
                    t1.updateFromComponent(this.values);
                });
            }
        }
        class cv {
            constructor(t1, e, i){
                if (!t1) throw new Error("No xrInputSource supplied");
                if (!e) throw new Error("No profile supplied");
                this.xrInputSource = t1, this.assetUrl = i, this.id = e.profileId, this.layoutDescription = e.layouts[t1.handedness], this.components = {}, Object.keys(this.layoutDescription.components).forEach((t1)=>{
                    const e = this.layoutDescription.components[t1];
                    this.components[t1] = new lv(t1, e);
                }), this.updateFromGamepad();
            }
            get gripSpace() {
                return this.xrInputSource.gripSpace;
            }
            get targetRaySpace() {
                return this.xrInputSource.targetRaySpace;
            }
            get data() {
                const t1 = [];
                return Object.values(this.components).forEach((e)=>{
                    t1.push(e.data);
                }), t1;
            }
            updateFromGamepad() {
                Object.values(this.components).forEach((t1)=>{
                    t1.updateFromGamepad(this.xrInputSource.gamepad);
                });
            }
        }
        class uv extends wc {
            constructor(){
                super(), this.motionController = null, this.envMap = null;
            }
            setEnvironmentMap(t1) {
                return this.envMap == t1 || (this.envMap = t1, this.traverse((t1)=>{
                    t1.isMesh && (t1.material.envMap = this.envMap, t1.material.needsUpdate = !0);
                })), this;
            }
            updateMatrixWorld(t1) {
                super.updateMatrixWorld(t1), this.motionController && (this.motionController.updateFromGamepad(), Object.values(this.motionController.components).forEach((t1)=>{
                    Object.values(t1.visualResponses).forEach((t1)=>{
                        const { valueNode: e, minNode: i, maxNode: n, value: r, valueNodeProperty: a } = t1;
                        e && (a === rv.VisualResponseProperty.VISIBILITY ? e.visible = r : a === rv.VisualResponseProperty.TRANSFORM && (e.quaternion.slerpQuaternions(i.quaternion, n.quaternion, r), e.position.lerpVectors(i.position, n.position, r)));
                    });
                }));
            }
        }
        function hv(t1, e) {
            !function(t1, e) {
                Object.values(t1.components).forEach((t1)=>{
                    const { type: i, touchPointNodeName: n, visualResponses: r } = t1;
                    if (i === rv.ComponentType.TOUCHPAD) {
                        if (t1.touchPointNode = e.getObjectByName(n), t1.touchPointNode) {
                            const e = new gg(.001), i = new Hc({
                                color: 255
                            }), n = new Ou(e, i);
                            t1.touchPointNode.add(n);
                        } else console.warn(`Could not find touch dot, ${t1.touchPointNodeName}, in touchpad component ${t1.id}`);
                    }
                    Object.values(r).forEach((t1)=>{
                        const { valueNodeName: i, minNodeName: n, maxNodeName: r, valueNodeProperty: a } = t1;
                        if (a === rv.VisualResponseProperty.TRANSFORM) {
                            if (t1.minNode = e.getObjectByName(n), t1.maxNode = e.getObjectByName(r), !t1.minNode) return void console.warn(`Could not find ${n} in the model`);
                            if (!t1.maxNode) return void console.warn(`Could not find ${r} in the model`);
                        }
                        t1.valueNode = e.getObjectByName(i), t1.valueNode || console.warn(`Could not find ${i} in the model`);
                    });
                });
            }(t1.motionController, e), t1.envMap && e.traverse((e)=>{
                e.isMesh && (e.material.envMap = t1.envMap, e.material.needsUpdate = !0);
            }), t1.add(e);
        }
        class dv {
            constructor(t1 = null){
                this.gltfLoader = t1, this.path = "https://cdn.jsdelivr.net/npm/@webxr-input-profiles/assets@1.0/dist/profiles", this._assetCache = {}, this.gltfLoader || (this.gltfLoader = new fy);
            }
            createControllerModel(t1) {
                const e = new uv;
                let i = null;
                return t1.addEventListener("connected", (t1)=>{
                    const n = t1.data;
                    "tracked-pointer" === n.targetRayMode && n.gamepad && (async function(t1, e, i = null, n = !0) {
                        if (!t1) throw new Error("No xrInputSource supplied");
                        if (!e) throw new Error("No basePath supplied");
                        const r = await async function(t1) {
                            if (!t1) throw new Error("No basePath supplied");
                            return await av(`${t1}/profilesList.json`);
                        }(e);
                        let a;
                        if (t1.profiles.some((t1)=>{
                            const i = r[t1];
                            return i && (a = {
                                profileId: t1,
                                profilePath: `${e}/${i.path}`,
                                deprecated: !!i.deprecated
                            }), !!a;
                        }), !a) {
                            if (!i) throw new Error("No matching profile name found");
                            const t1 = r[i];
                            if (!t1) throw new Error(`No matching profile name found and default profile "${i}" missing.`);
                            a = {
                                profileId: i,
                                profilePath: `${e}/${t1.path}`,
                                deprecated: !!t1.deprecated
                            };
                        }
                        const s = await av(a.profilePath);
                        let o;
                        if (n) {
                            let e;
                            if (e = "any" === t1.handedness ? s.layouts[Object.keys(s.layouts)[0]] : s.layouts[t1.handedness], !e) throw new Error(`No matching handedness, ${t1.handedness}, in profile ${a.profileId}`);
                            e.assetPath && (o = a.profilePath.replace("profile.json", e.assetPath));
                        }
                        return {
                            profile: s,
                            assetPath: o
                        };
                    })(n, this.path, "generic-trigger").then(({ profile: t1, assetPath: r })=>{
                        e.motionController = new cv(n, t1, r);
                        const a = this._assetCache[e.motionController.assetUrl];
                        if (a) i = a.scene.clone(), hv(e, i);
                        else {
                            if (!this.gltfLoader) throw new Error("GLTFLoader not set.");
                            this.gltfLoader.setPath(""), this.gltfLoader.load(e.motionController.assetUrl, (t1)=>{
                                this._assetCache[e.motionController.assetUrl] = t1, i = t1.scene.clone(), hv(e, i);
                            }, null, ()=>{
                                throw new Error(`Asset ${e.motionController.assetUrl} missing or malformed.`);
                            });
                        }
                    }).catch((t1)=>{
                        console.warn(t1);
                    });
                }), t1.addEventListener("disconnected", ()=>{
                    e.motionController = null, e.remove(i), i = null;
                }), e;
            }
        }
        const pv = new Kl, fv = new xl;
        class Av {
            constructor(t1, e, i, n, r){
                let a;
                this.controller = e, this.handModel = t1, this.envMap = null, r && r.primitive && "sphere" !== r.primitive ? "box" === r.primitive && (a = new ju(1, 1, 1)) : a = new gg(1, 10, 10);
                const s = new Ig;
                this.handMesh = new zf(a, s, 30), this.handMesh.frustumCulled = !1, this.handMesh.instanceMatrix.setUsage(fo), this.handMesh.castShadow = !0, this.handMesh.receiveShadow = !0, this.handModel.add(this.handMesh), this.joints = [
                    "wrist",
                    "thumb-metacarpal",
                    "thumb-phalanx-proximal",
                    "thumb-phalanx-distal",
                    "thumb-tip",
                    "index-finger-metacarpal",
                    "index-finger-phalanx-proximal",
                    "index-finger-phalanx-intermediate",
                    "index-finger-phalanx-distal",
                    "index-finger-tip",
                    "middle-finger-metacarpal",
                    "middle-finger-phalanx-proximal",
                    "middle-finger-phalanx-intermediate",
                    "middle-finger-phalanx-distal",
                    "middle-finger-tip",
                    "ring-finger-metacarpal",
                    "ring-finger-phalanx-proximal",
                    "ring-finger-phalanx-intermediate",
                    "ring-finger-phalanx-distal",
                    "ring-finger-tip",
                    "pinky-finger-metacarpal",
                    "pinky-finger-phalanx-proximal",
                    "pinky-finger-phalanx-intermediate",
                    "pinky-finger-phalanx-distal",
                    "pinky-finger-tip"
                ];
            }
            updateMesh() {
                const t1 = this.controller.joints;
                let e = 0;
                for(let i = 0; i < this.joints.length; i++){
                    const n = t1[this.joints[i]];
                    n.visible && (fv.setScalar(n.jointRadius || .008), pv.compose(n.position, n.quaternion, fv), this.handMesh.setMatrixAt(i, pv), e++);
                }
                this.handMesh.count = e, this.handMesh.instanceMatrix.needsUpdate = !0;
            }
        }
        class gv {
            constructor(t1, e, i, n, r = null){
                this.controller = e, this.handModel = t1, this.bones = [], null === r && (r = new fy).setPath(i || "https://cdn.jsdelivr.net/npm/@webxr-input-profiles/assets@1.0/dist/profiles/generic-hand/"), r.load(`${n}.glb`, (t1)=>{
                    const e = t1.scene.children[0];
                    this.handModel.add(e);
                    const i = e.getObjectByProperty("type", "SkinnedMesh");
                    i.frustumCulled = !1, i.castShadow = !0, i.receiveShadow = !0, [
                        "wrist",
                        "thumb-metacarpal",
                        "thumb-phalanx-proximal",
                        "thumb-phalanx-distal",
                        "thumb-tip",
                        "index-finger-metacarpal",
                        "index-finger-phalanx-proximal",
                        "index-finger-phalanx-intermediate",
                        "index-finger-phalanx-distal",
                        "index-finger-tip",
                        "middle-finger-metacarpal",
                        "middle-finger-phalanx-proximal",
                        "middle-finger-phalanx-intermediate",
                        "middle-finger-phalanx-distal",
                        "middle-finger-tip",
                        "ring-finger-metacarpal",
                        "ring-finger-phalanx-proximal",
                        "ring-finger-phalanx-intermediate",
                        "ring-finger-phalanx-distal",
                        "ring-finger-tip",
                        "pinky-finger-metacarpal",
                        "pinky-finger-phalanx-proximal",
                        "pinky-finger-phalanx-intermediate",
                        "pinky-finger-phalanx-distal",
                        "pinky-finger-tip"
                    ].forEach((t1)=>{
                        const i = e.getObjectByName(t1);
                        void 0 !== i ? i.jointName = t1 : console.warn(`Couldn't find ${t1} in ${n} hand mesh`), this.bones.push(i);
                    });
                });
            }
            updateMesh() {
                const t1 = this.controller.joints;
                for(let e = 0; e < this.bones.length; e++){
                    const i = this.bones[e];
                    if (i) {
                        const e = t1[i.jointName];
                        if (e.visible) {
                            const t1 = e.position;
                            i.position.copy(t1), i.quaternion.copy(e.quaternion);
                        }
                    }
                }
            }
        }
        class mv extends wc {
            constructor(t1){
                super(), this.controller = t1, this.motionController = null, this.envMap = null, this.mesh = null;
            }
            updateMatrixWorld(t1) {
                super.updateMatrixWorld(t1), this.motionController && this.motionController.updateMesh();
            }
        }
        class Mv {
            constructor(){
                this.path = null;
            }
            setPath(t1) {
                return this.path = t1, this;
            }
            createHandModel(t1, e) {
                const i = new mv(t1);
                return t1.addEventListener("connected", (n)=>{
                    const r = n.data;
                    r.hand && !i.motionController && (i.xrInputSource = r, void 0 === e || "spheres" === e ? i.motionController = new Av(i, t1, this.path, r.handedness, {
                        primitive: "sphere"
                    }) : "boxes" === e ? i.motionController = new Av(i, t1, this.path, r.handedness, {
                        primitive: "box"
                    }) : "mesh" === e && (i.motionController = new gv(i, t1, this.path, r.handedness))), t1.visible = !0;
                }), t1.addEventListener("disconnected", ()=>{
                    t1.visible = !1;
                }), i;
            }
        }
        function yv(t1) {
            return Math.sqrt(Math.pow(t1[1][0] - t1[0][0], 2) + Math.pow(t1[1][1] - t1[0][1], 2));
        }
        const vv = 3.280839895, xv = (t1)=>{
            t1.preventDefault();
        }, wv = async (t1)=>{
            const e = new Promise((e)=>{
                const i = new Image;
                i.onload = ()=>e(i), i.src = t1;
            });
            return await e;
        }, bv = (t1, e, i, n, r, a)=>{
            let s = a;
            n < 2 * s && (s = n / 2), r < 2 * a && (s = r / 2), t1.beginPath(), t1.moveTo(e + s, i), t1.arcTo(e + n, i, e + n, i + r, s), t1.arcTo(e + n, i + r, e, i + r, s), t1.arcTo(e, i + r, e, i, s), t1.arcTo(e, i, e + n, i, s), t1.closePath();
        }, Tv = function(t1) {
            var e, i;
            let n = null !== (e = null === (i = zn.dictionaryOverrides) || void 0 === i ? void 0 : i[t1]) && void 0 !== e ? e : Dn.getLocaleText(t1);
            for(var r = arguments.length, a = new Array(r > 1 ? r - 1 : 0), s = 1; s < r; s++)a[s - 1] = arguments[s];
            return zn.config.floorNumberEndingsVisible && "floor" === t1 ? a.reduce((t1, e, i)=>{
                var n;
                return t1.replaceAll("$".concat(i), e + (null !== (n = Dn.getLocaleText("floorNumberEndings")[e]) && void 0 !== n ? n : Dn.getLocaleText("floorNumberEndings").rest));
            }, n) : a.reduce((t1, e, i)=>t1.replaceAll("$".concat(i), e), n);
        }, Ev = (t1)=>{
            const e = Math.floor(t1 * vv), i = 12 * (t1 * vv - e);
            return "".concat(e, "'").concat(Math.round(i), '"');
        };
        function Iv(t1, e, i) {
            (function(t1, e) {
                if (e.has(t1)) throw new TypeError("Cannot initialize the same private elements twice on an object");
            })(t1, e), e.set(t1, i);
        }
        function Sv(t1, e) {
            return t1.get(Dv(t1, e));
        }
        function Nv(t1, e, i) {
            return t1.set(Dv(t1, e), i), i;
        }
        function Dv(t1, e, i) {
            if ("function" == typeof t1 ? t1 === e : t1.has(e)) return arguments.length < 3 ? e : i;
            throw new TypeError("Private element is not present on this object");
        }
        var Cv = new WeakMap, zv = new WeakMap;
        const Lv = new class {
            constructor(){
                Iv(this, Cv, void 0), Iv(this, zv, void 0), Nv(Cv, this, {}), Nv(zv, this, {});
            }
            async get(t1) {
                return t1 ? (Sv(Cv, this)[t1] || await this.cache(t1), Sv(Cv, this)[t1]) : null;
            }
            async cache(t1) {
                if (!t1) return void console.warn("Cache empty url skipped!");
                if (this.isCached(t1)) return;
                if (this.isLoading(t1)) return await function(t1, e) {
                    let i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 100;
                    return new Promise((n)=>{
                        const r = setInterval(()=>{
                            t1() || (clearInterval(r), n(e));
                        }, i);
                    });
                }(()=>this.isLoading(t1)), void console.log("Await texture resolved");
                Sv(zv, this)[t1] = !0;
                const e = await (new dm).loadAsync(t1);
                e.center = new Qo(.5, .5), e.colorSpace = _s, e.minFilter = da, e.magFilter = la, e.anisotropy = 8, Sv(Cv, this)[t1] = e, Sv(zv, this)[t1] = !1;
            }
            isCached(t1) {
                return null != Sv(Cv, this)[t1];
            }
            isLoading(t1) {
                return Sv(zv, this)[t1];
            }
            invalidate(t1) {
                delete Sv(Cv, this)[t1], delete Sv(zv, this)[t1];
            }
            clear() {
                Nv(Cv, this, {}), Nv(zv, this, {});
            }
        };
        var Ov = function(t1) {
            return URL.createObjectURL(new Blob([
                t1
            ], {
                type: "text/javascript"
            }));
        };
        try {
            URL.revokeObjectURL(Ov(""));
        } catch (t1) {
            Ov = function(t1) {
                return "data:application/javascript;charset=UTF-8," + encodeURI(t1);
            };
        }
        var _v = Uint8Array, jv = Uint16Array, Pv = Uint32Array, Rv = new _v([
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            1,
            1,
            1,
            1,
            2,
            2,
            2,
            2,
            3,
            3,
            3,
            3,
            4,
            4,
            4,
            4,
            5,
            5,
            5,
            5,
            0,
            0,
            0,
            0
        ]), Uv = new _v([
            0,
            0,
            0,
            0,
            1,
            1,
            2,
            2,
            3,
            3,
            4,
            4,
            5,
            5,
            6,
            6,
            7,
            7,
            8,
            8,
            9,
            9,
            10,
            10,
            11,
            11,
            12,
            12,
            13,
            13,
            0,
            0
        ]), kv = new _v([
            16,
            17,
            18,
            0,
            8,
            7,
            9,
            6,
            10,
            5,
            11,
            4,
            12,
            3,
            13,
            2,
            14,
            1,
            15
        ]), Bv = function(t1, e) {
            for(var i = new jv(31), n = 0; n < 31; ++n)i[n] = e += 1 << t1[n - 1];
            var r = new Pv(i[30]);
            for(n = 1; n < 30; ++n)for(var a = i[n]; a < i[n + 1]; ++a)r[a] = a - i[n] << 5 | n;
            return [
                i,
                r
            ];
        }, Fv = Bv(Rv, 2), Qv = Fv[0], Hv = Fv[1];
        Qv[28] = 258, Hv[258] = 28;
        for(var Vv = Bv(Uv, 0), Gv = Vv[0], Yv = (Vv[1], new jv(32768)), Wv = 0; Wv < 32768; ++Wv){
            var Xv = (43690 & Wv) >>> 1 | (21845 & Wv) << 1;
            Xv = (61680 & (Xv = (52428 & Xv) >>> 2 | (13107 & Xv) << 2)) >>> 4 | (3855 & Xv) << 4, Yv[Wv] = ((65280 & Xv) >>> 8 | (255 & Xv) << 8) >>> 1;
        }
        var Zv = function(t1, e, i) {
            for(var n = t1.length, r = 0, a = new jv(e); r < n; ++r)++a[t1[r] - 1];
            var s, o = new jv(e);
            for(r = 0; r < e; ++r)o[r] = o[r - 1] + a[r - 1] << 1;
            if (i) {
                s = new jv(1 << e);
                var l = 15 - e;
                for(r = 0; r < n; ++r)if (t1[r]) for(var c = r << 4 | t1[r], u = e - t1[r], h = o[t1[r] - 1]++ << u, d = h | (1 << u) - 1; h <= d; ++h)s[Yv[h] >>> l] = c;
            } else for(s = new jv(n), r = 0; r < n; ++r)t1[r] && (s[r] = Yv[o[t1[r] - 1]++] >>> 15 - t1[r]);
            return s;
        }, Jv = new _v(288);
        for(Wv = 0; Wv < 144; ++Wv)Jv[Wv] = 8;
        for(Wv = 144; Wv < 256; ++Wv)Jv[Wv] = 9;
        for(Wv = 256; Wv < 280; ++Wv)Jv[Wv] = 7;
        for(Wv = 280; Wv < 288; ++Wv)Jv[Wv] = 8;
        var Kv = new _v(32);
        for(Wv = 0; Wv < 32; ++Wv)Kv[Wv] = 5;
        var qv = Zv(Jv, 9, 1), $v = Zv(Kv, 5, 1), tx = function(t1) {
            for(var e = t1[0], i = 1; i < t1.length; ++i)t1[i] > e && (e = t1[i]);
            return e;
        }, ex = function(t1, e, i) {
            var n = e / 8 | 0;
            return (t1[n] | t1[n + 1] << 8) >> (7 & e) & i;
        }, ix = function(t1, e) {
            var i = e / 8 | 0;
            return (t1[i] | t1[i + 1] << 8 | t1[i + 2] << 16) >> (7 & e);
        }, nx = function(t1, e, i) {
            var n = t1.length;
            if (!n || i && !i.l && n < 5) return e || new _v(0);
            var r = !e || i, a = !i || i.i;
            i || (i = {}), e || (e = new _v(3 * n));
            var s, o = function(t1) {
                var i = e.length;
                if (t1 > i) {
                    var n = new _v(Math.max(2 * i, t1));
                    n.set(e), e = n;
                }
            }, l = i.f || 0, c = i.p || 0, u = i.b || 0, h = i.l, d = i.d, p = i.m, f = i.n, A = 8 * n;
            do {
                if (!h) {
                    i.f = l = ex(t1, c, 1);
                    var g = ex(t1, c + 1, 3);
                    if (c += 3, !g) {
                        var m = t1[s = c, (N = (s / 8 | 0) + (7 & s && 1) + 4) - 4] | t1[N - 3] << 8, M = N + m;
                        if (M > n) {
                            if (a) throw "unexpected EOF";
                            break;
                        }
                        r && o(u + m), e.set(t1.subarray(N, M), u), i.b = u += m, i.p = c = 8 * M;
                        continue;
                    }
                    if (1 == g) h = qv, d = $v, p = 9, f = 5;
                    else {
                        if (2 != g) throw "invalid block type";
                        var y = ex(t1, c, 31) + 257, v = ex(t1, c + 10, 15) + 4, x = y + ex(t1, c + 5, 31) + 1;
                        c += 14;
                        for(var w = new _v(x), b = new _v(19), T = 0; T < v; ++T)b[kv[T]] = ex(t1, c + 3 * T, 7);
                        c += 3 * v;
                        var E = tx(b), I = (1 << E) - 1, S = Zv(b, E, 1);
                        for(T = 0; T < x;){
                            var N, D = S[ex(t1, c, I)];
                            if (c += 15 & D, (N = D >>> 4) < 16) w[T++] = N;
                            else {
                                var C = 0, z = 0;
                                for(16 == N ? (z = 3 + ex(t1, c, 3), c += 2, C = w[T - 1]) : 17 == N ? (z = 3 + ex(t1, c, 7), c += 3) : 18 == N && (z = 11 + ex(t1, c, 127), c += 7); z--;)w[T++] = C;
                            }
                        }
                        var L = w.subarray(0, y), O = w.subarray(y);
                        p = tx(L), f = tx(O), h = Zv(L, p, 1), d = Zv(O, f, 1);
                    }
                    if (c > A) {
                        if (a) throw "unexpected EOF";
                        break;
                    }
                }
                r && o(u + 131072);
                for(var _ = (1 << p) - 1, j = (1 << f) - 1, P = c;; P = c){
                    var R = (C = h[ix(t1, c) & _]) >>> 4;
                    if ((c += 15 & C) > A) {
                        if (a) throw "unexpected EOF";
                        break;
                    }
                    if (!C) throw "invalid length/literal";
                    if (R < 256) e[u++] = R;
                    else {
                        if (256 == R) {
                            P = c, h = null;
                            break;
                        }
                        var U = R - 254;
                        if (R > 264) {
                            var k = Rv[T = R - 257];
                            U = ex(t1, c, (1 << k) - 1) + Qv[T], c += k;
                        }
                        var B = d[ix(t1, c) & j], F = B >>> 4;
                        if (!B) throw "invalid distance";
                        if (c += 15 & B, O = Gv[F], F > 3 && (k = Uv[F], O += ix(t1, c) & (1 << k) - 1, c += k), c > A) {
                            if (a) throw "unexpected EOF";
                            break;
                        }
                        r && o(u + 131072);
                        for(var Q = u + U; u < Q; u += 4)e[u] = e[u - O], e[u + 1] = e[u + 1 - O], e[u + 2] = e[u + 2 - O], e[u + 3] = e[u + 3 - O];
                        u = Q;
                    }
                }
                i.l = h, i.p = P, i.b = u, h && (l = 1, i.m = p, i.d = d, i.n = f);
            }while (!l);
            return u == e.length ? e : function(t1, e, i) {
                (null == e || e < 0) && (e = 0), (null == i || i > t1.length) && (i = t1.length);
                var n = new (t1 instanceof jv ? jv : t1 instanceof Pv ? Pv : _v)(i - e);
                return n.set(t1.subarray(e, i)), n;
            }(e, 0, u);
        }, rx = new _v(0);
        function ax(t1, e) {
            return nx((function(t1) {
                if (8 != (15 & t1[0]) || t1[0] >>> 4 > 7 || (t1[0] << 8 | t1[1]) % 31) throw "invalid zlib data";
                if (32 & t1[1]) throw "invalid zlib data: preset dictionaries not supported";
            }(t1), t1.subarray(2, -4)), e);
        }
        var sx = "undefined" != typeof TextDecoder && new TextDecoder;
        try {
            sx.decode(rx, {
                stream: !0
            });
        } catch (t1) {}
        class ox extends hm {
            constructor(t1){
                super(t1), this.type = va;
            }
            parse(t1) {
                const e = 65536, i = 14, n = 65537, r = Math.pow(2.7182818, 2.2), a = {
                    l: 0,
                    c: 0,
                    lc: 0
                };
                function s(t1, e, i, n, r) {
                    for(; i < t1;)e = e << 8 | R(n, r), i += 8;
                    i -= t1, a.l = e >> i & (1 << t1) - 1, a.c = e, a.lc = i;
                }
                const o = new Array(59);
                function l(t1) {
                    return 63 & t1;
                }
                function c(t1) {
                    return t1 >> 6;
                }
                const u = {
                    c: 0,
                    lc: 0
                };
                function h(t1, e, i, n) {
                    t1 = t1 << 8 | R(i, n), e += 8, u.c = t1, u.lc = e;
                }
                const d = {
                    c: 0,
                    lc: 0
                };
                function p(t1, e, i, n, r, a, s, o, l) {
                    if (t1 == e) {
                        n < 8 && (h(i, n, r, a), i = u.c, n = u.lc);
                        let t1 = i >> (n -= 8);
                        if (t1 = new Uint8Array([
                            t1
                        ])[0], o.value + t1 > l) return !1;
                        const e = s[o.value - 1];
                        for(; t1-- > 0;)s[o.value++] = e;
                    } else {
                        if (!(o.value < l)) return !1;
                        s[o.value++] = t1;
                    }
                    d.c = i, d.lc = n;
                }
                function f(t1) {
                    return 65535 & t1;
                }
                function A(t1) {
                    const e = f(t1);
                    return e > 32767 ? e - 65536 : e;
                }
                const g = {
                    a: 0,
                    b: 0
                };
                function m(t1, e) {
                    const i = A(t1), n = A(e), r = i + (1 & n) + (n >> 1), a = r, s = r - n;
                    g.a = a, g.b = s;
                }
                function M(t1, e) {
                    const i = f(t1), n = f(e), r = i - (n >> 1) & 65535, a = n + r - 32768 & 65535;
                    g.a = a, g.b = r;
                }
                function y(t1, e, i, n, r, a, s) {
                    const o = s < 16384, l = i > r ? r : i;
                    let c, u, h = 1;
                    for(; h <= l;)h <<= 1;
                    for(h >>= 1, c = h, h >>= 1; h >= 1;){
                        u = 0;
                        const s = u + a * (r - c), l = a * h, d = a * c, p = n * h, f = n * c;
                        let A, y, v, x;
                        for(; u <= s; u += d){
                            let r = u;
                            const a = u + n * (i - c);
                            for(; r <= a; r += f){
                                const i = r + p, n = r + l, a = n + p;
                                o ? (m(t1[r + e], t1[n + e]), A = g.a, v = g.b, m(t1[i + e], t1[a + e]), y = g.a, x = g.b, m(A, y), t1[r + e] = g.a, t1[i + e] = g.b, m(v, x), t1[n + e] = g.a, t1[a + e] = g.b) : (M(t1[r + e], t1[n + e]), A = g.a, v = g.b, M(t1[i + e], t1[a + e]), y = g.a, x = g.b, M(A, y), t1[r + e] = g.a, t1[i + e] = g.b, M(v, x), t1[n + e] = g.a, t1[a + e] = g.b);
                            }
                            if (i & h) {
                                const i = r + l;
                                o ? m(t1[r + e], t1[i + e]) : M(t1[r + e], t1[i + e]), A = g.a, t1[i + e] = g.b, t1[r + e] = A;
                            }
                        }
                        if (r & h) {
                            let r = u;
                            const a = u + n * (i - c);
                            for(; r <= a; r += f){
                                const i = r + p;
                                o ? m(t1[r + e], t1[i + e]) : M(t1[r + e], t1[i + e]), A = g.a, t1[i + e] = g.b, t1[r + e] = A;
                            }
                        }
                        c = h, h >>= 1;
                    }
                    return u;
                }
                function v(t1, e, r, f, A, g) {
                    const m = r.value, M = P(e, r), y = P(e, r);
                    r.value += 4;
                    const v = P(e, r);
                    if (r.value += 4, M < 0 || M >= n || y < 0 || y >= n) throw new Error("Something wrong with HUF_ENCSIZE");
                    const x = new Array(n), w = new Array(16384);
                    if (function(t1) {
                        for(let e = 0; e < 16384; e++)t1[e] = {}, t1[e].len = 0, t1[e].lit = 0, t1[e].p = null;
                    }(w), function(t1, e, i, r, l, c) {
                        const u = e;
                        let h = 0, d = 0;
                        for(; r <= l; r++){
                            if (u.value - e.value > i) return !1;
                            s(6, h, d, t1, u);
                            const n = a.l;
                            if (h = a.c, d = a.lc, c[r] = n, 63 == n) {
                                if (u.value - e.value > i) throw new Error("Something wrong with hufUnpackEncTable");
                                s(8, h, d, t1, u);
                                let n = a.l + 6;
                                if (h = a.c, d = a.lc, r + n > l + 1) throw new Error("Something wrong with hufUnpackEncTable");
                                for(; n--;)c[r++] = 0;
                                r--;
                            } else if (n >= 59) {
                                let t1 = n - 59 + 2;
                                if (r + t1 > l + 1) throw new Error("Something wrong with hufUnpackEncTable");
                                for(; t1--;)c[r++] = 0;
                                r--;
                            }
                        }
                        !function(t1) {
                            for(let t1 = 0; t1 <= 58; ++t1)o[t1] = 0;
                            for(let e = 0; e < n; ++e)o[t1[e]] += 1;
                            let e = 0;
                            for(let t1 = 58; t1 > 0; --t1){
                                const i = e + o[t1] >> 1;
                                o[t1] = e, e = i;
                            }
                            for(let e = 0; e < n; ++e){
                                const i = t1[e];
                                i > 0 && (t1[e] = i | o[i]++ << 6);
                            }
                        }(c);
                    }(t1, r, f - (r.value - m), M, y, x), v > 8 * (f - (r.value - m))) throw new Error("Something wrong with hufUncompress");
                    !function(t1, e, n, r) {
                        for(; e <= n; e++){
                            const n = c(t1[e]), a = l(t1[e]);
                            if (n >> a) throw new Error("Invalid table entry");
                            if (a > i) {
                                const t1 = r[n >> a - i];
                                if (t1.len) throw new Error("Invalid table entry");
                                if (t1.lit++, t1.p) {
                                    const e = t1.p;
                                    t1.p = new Array(t1.lit);
                                    for(let i = 0; i < t1.lit - 1; ++i)t1.p[i] = e[i];
                                } else t1.p = new Array(1);
                                t1.p[t1.lit - 1] = e;
                            } else if (a) {
                                let t1 = 0;
                                for(let s = 1 << i - a; s > 0; s--){
                                    const s = r[(n << i - a) + t1];
                                    if (s.len || s.p) throw new Error("Invalid table entry");
                                    s.len = a, s.lit = e, t1++;
                                }
                            }
                        }
                    }(x, M, y, w), function(t1, e, n, r, a, s, o, f, A) {
                        let g = 0, m = 0;
                        const M = o, y = Math.trunc(r.value + (a + 7) / 8);
                        for(; r.value < y;)for(h(g, m, n, r), g = u.c, m = u.lc; m >= i;){
                            const a = e[g >> m - i & 16383];
                            if (a.len) m -= a.len, p(a.lit, s, g, m, n, r, f, A, M), g = d.c, m = d.lc;
                            else {
                                if (!a.p) throw new Error("hufDecode issues");
                                let e;
                                for(e = 0; e < a.lit; e++){
                                    const i = l(t1[a.p[e]]);
                                    for(; m < i && r.value < y;)h(g, m, n, r), g = u.c, m = u.lc;
                                    if (m >= i && c(t1[a.p[e]]) == (g >> m - i & (1 << i) - 1)) {
                                        m -= i, p(a.p[e], s, g, m, n, r, f, A, M), g = d.c, m = d.lc;
                                        break;
                                    }
                                }
                                if (e == a.lit) throw new Error("hufDecode issues");
                            }
                        }
                        const v = 8 - a & 7;
                        for(g >>= v, m -= v; m > 0;){
                            const t1 = e[g << i - m & 16383];
                            if (!t1.len) throw new Error("hufDecode issues");
                            m -= t1.len, p(t1.lit, s, g, m, n, r, f, A, M), g = d.c, m = d.lc;
                        }
                    }(x, w, t1, r, v, y, g, A, {
                        value: 0
                    });
                }
                function x(t1) {
                    for(let e = 1; e < t1.length; e++){
                        const i = t1[e - 1] + t1[e] - 128;
                        t1[e] = i;
                    }
                }
                function w(t1, e) {
                    let i = 0, n = Math.floor((t1.length + 1) / 2), r = 0;
                    const a = t1.length - 1;
                    for(; !(r > a || (e[r++] = t1[i++], r > a));)e[r++] = t1[n++];
                }
                function b(t1) {
                    let e = t1.byteLength;
                    const i = new Array;
                    let n = 0;
                    const r = new DataView(t1);
                    for(; e > 0;){
                        const t1 = r.getInt8(n++);
                        if (t1 < 0) {
                            const a = -t1;
                            e -= a + 1;
                            for(let t1 = 0; t1 < a; t1++)i.push(r.getUint8(n++));
                        } else {
                            const a = t1;
                            e -= 2;
                            const s = r.getUint8(n++);
                            for(let t1 = 0; t1 < a + 1; t1++)i.push(s);
                        }
                    }
                    return i;
                }
                function T(t1, e, i) {
                    let n, r = 1;
                    for(; r < 64;)n = e[t1.value], 65280 == n ? r = 64 : n >> 8 == 255 ? r += 255 & n : (i[r] = n, r++), t1.value++;
                }
                function E(t1) {
                    const e = .5 * Math.cos(.7853975), i = .5 * Math.cos(3.14159 / 16), n = .5 * Math.cos(3.14159 / 8), r = .5 * Math.cos(3 * 3.14159 / 16), a = .5 * Math.cos(.981746875), s = .5 * Math.cos(3 * 3.14159 / 8), o = .5 * Math.cos(1.374445625), l = new Array(4), c = new Array(4), u = new Array(4), h = new Array(4);
                    for(let d = 0; d < 8; ++d){
                        const p = 8 * d;
                        l[0] = n * t1[p + 2], l[1] = s * t1[p + 2], l[2] = n * t1[p + 6], l[3] = s * t1[p + 6], c[0] = i * t1[p + 1] + r * t1[p + 3] + a * t1[p + 5] + o * t1[p + 7], c[1] = r * t1[p + 1] - o * t1[p + 3] - i * t1[p + 5] - a * t1[p + 7], c[2] = a * t1[p + 1] - i * t1[p + 3] + o * t1[p + 5] + r * t1[p + 7], c[3] = o * t1[p + 1] - a * t1[p + 3] + r * t1[p + 5] - i * t1[p + 7], u[0] = e * (t1[p + 0] + t1[p + 4]), u[3] = e * (t1[p + 0] - t1[p + 4]), u[1] = l[0] + l[3], u[2] = l[1] - l[2], h[0] = u[0] + u[1], h[1] = u[3] + u[2], h[2] = u[3] - u[2], h[3] = u[0] - u[1], t1[p + 0] = h[0] + c[0], t1[p + 1] = h[1] + c[1], t1[p + 2] = h[2] + c[2], t1[p + 3] = h[3] + c[3], t1[p + 4] = h[3] - c[3], t1[p + 5] = h[2] - c[2], t1[p + 6] = h[1] - c[1], t1[p + 7] = h[0] - c[0];
                    }
                    for(let d = 0; d < 8; ++d)l[0] = n * t1[16 + d], l[1] = s * t1[16 + d], l[2] = n * t1[48 + d], l[3] = s * t1[48 + d], c[0] = i * t1[8 + d] + r * t1[24 + d] + a * t1[40 + d] + o * t1[56 + d], c[1] = r * t1[8 + d] - o * t1[24 + d] - i * t1[40 + d] - a * t1[56 + d], c[2] = a * t1[8 + d] - i * t1[24 + d] + o * t1[40 + d] + r * t1[56 + d], c[3] = o * t1[8 + d] - a * t1[24 + d] + r * t1[40 + d] - i * t1[56 + d], u[0] = e * (t1[d] + t1[32 + d]), u[3] = e * (t1[d] - t1[32 + d]), u[1] = l[0] + l[3], u[2] = l[1] - l[2], h[0] = u[0] + u[1], h[1] = u[3] + u[2], h[2] = u[3] - u[2], h[3] = u[0] - u[1], t1[0 + d] = h[0] + c[0], t1[8 + d] = h[1] + c[1], t1[16 + d] = h[2] + c[2], t1[24 + d] = h[3] + c[3], t1[32 + d] = h[3] - c[3], t1[40 + d] = h[2] - c[2], t1[48 + d] = h[1] - c[1], t1[56 + d] = h[0] - c[0];
                }
                function I(t1) {
                    for(let e = 0; e < 64; ++e){
                        const i = t1[0][e], n = t1[1][e], r = t1[2][e];
                        t1[0][e] = i + 1.5747 * r, t1[1][e] = i - .1873 * n - .4682 * r, t1[2][e] = i + 1.8556 * n;
                    }
                }
                function S(t1, e, i) {
                    for(let a = 0; a < 64; ++a)e[i + a] = Xc.toHalfFloat((n = t1[a]) <= 1 ? Math.sign(n) * Math.pow(Math.abs(n), 2.2) : Math.sign(n) * Math.pow(r, Math.abs(n) - 1));
                    var n;
                }
                function N(t1) {
                    return new DataView(t1.array.buffer, t1.offset.value, t1.size);
                }
                function D(t1) {
                    const e = t1.viewer.buffer.slice(t1.offset.value, t1.offset.value + t1.size), i = new Uint8Array(b(e)), n = new Uint8Array(i.length);
                    return x(i), w(i, n), new DataView(n.buffer);
                }
                function C(t1) {
                    const e = ax(t1.array.slice(t1.offset.value, t1.offset.value + t1.size)), i = new Uint8Array(e.length);
                    return x(e), w(e, i), new DataView(i.buffer);
                }
                function z(t1) {
                    const i = t1.viewer, n = {
                        value: t1.offset.value
                    }, r = new Uint16Array(t1.width * t1.scanlineBlockSize * (t1.channels * t1.type)), a = new Uint8Array(8192);
                    let s = 0;
                    const o = new Array(t1.channels);
                    for(let e = 0; e < t1.channels; e++)o[e] = {}, o[e].start = s, o[e].end = o[e].start, o[e].nx = t1.width, o[e].ny = t1.lines, o[e].size = t1.type, s += o[e].nx * o[e].ny * o[e].size;
                    const l = H(i, n), c = H(i, n);
                    if (c >= 8192) throw new Error("Something is wrong with PIZ_COMPRESSION BITMAP_SIZE");
                    if (l <= c) for(let t1 = 0; t1 < c - l + 1; t1++)a[t1 + l] = U(i, n);
                    const u = new Uint16Array(e), h = function(t1, i) {
                        let n = 0;
                        for(let r = 0; r < e; ++r)(0 == r || t1[r >> 3] & 1 << (7 & r)) && (i[n++] = r);
                        const r = n - 1;
                        for(; n < e;)i[n++] = 0;
                        return r;
                    }(a, u), d = P(i, n);
                    v(t1.array, i, n, d, r, s);
                    for(let e = 0; e < t1.channels; ++e){
                        const t1 = o[e];
                        for(let i = 0; i < o[e].size; ++i)y(r, t1.start + i, t1.nx, t1.size, t1.ny, t1.nx * t1.size, h);
                    }
                    !function(t1, e, i) {
                        for(let n = 0; n < i; ++n)e[n] = t1[e[n]];
                    }(u, r, s);
                    let p = 0;
                    const f = new Uint8Array(r.buffer.byteLength);
                    for(let e = 0; e < t1.lines; e++)for(let e = 0; e < t1.channels; e++){
                        const t1 = o[e], i = t1.nx * t1.size, n = new Uint8Array(r.buffer, 2 * t1.end, 2 * i);
                        f.set(n, p), p += 2 * i, t1.end += i;
                    }
                    return new DataView(f.buffer);
                }
                function L(t1) {
                    const e = ax(t1.array.slice(t1.offset.value, t1.offset.value + t1.size)), i = t1.lines * t1.channels * t1.width, n = 1 == t1.type ? new Uint16Array(i) : new Uint32Array(i);
                    let r = 0, a = 0;
                    const s = new Array(4);
                    for(let i = 0; i < t1.lines; i++)for(let i = 0; i < t1.channels; i++){
                        let i = 0;
                        switch(t1.type){
                            case 1:
                                s[0] = r, s[1] = s[0] + t1.width, r = s[1] + t1.width;
                                for(let r = 0; r < t1.width; ++r)i += e[s[0]++] << 8 | e[s[1]++], n[a] = i, a++;
                                break;
                            case 2:
                                s[0] = r, s[1] = s[0] + t1.width, s[2] = s[1] + t1.width, r = s[2] + t1.width;
                                for(let r = 0; r < t1.width; ++r)i += e[s[0]++] << 24 | e[s[1]++] << 16 | e[s[2]++] << 8, n[a] = i, a++;
                        }
                    }
                    return new DataView(n.buffer);
                }
                function O(t1) {
                    const e = t1.viewer, i = {
                        value: t1.offset.value
                    }, n = new Uint8Array(t1.width * t1.lines * (t1.channels * t1.type * 2)), r = {
                        version: k(e, i),
                        unknownUncompressedSize: k(e, i),
                        unknownCompressedSize: k(e, i),
                        acCompressedSize: k(e, i),
                        dcCompressedSize: k(e, i),
                        rleCompressedSize: k(e, i),
                        rleUncompressedSize: k(e, i),
                        rleRawSize: k(e, i),
                        totalAcUncompressedCount: k(e, i),
                        totalDcUncompressedCount: k(e, i),
                        acCompression: k(e, i)
                    };
                    if (r.version < 2) throw new Error("EXRLoader.parse: " + Z.compression + " version " + r.version + " is unsupported");
                    const a = new Array;
                    let s = H(e, i) - 2;
                    for(; s > 0;){
                        const t1 = _(e.buffer, i), n = U(e, i), r = n >> 2 & 3, o = new Int8Array([
                            (n >> 4) - 1
                        ])[0], l = U(e, i);
                        a.push({
                            name: t1,
                            index: o,
                            type: l,
                            compression: r
                        }), s -= t1.length + 3;
                    }
                    const o = Z.channels, l = new Array(t1.channels);
                    for(let e = 0; e < t1.channels; ++e){
                        const i = l[e] = {}, n = o[e];
                        i.name = n.name, i.compression = 0, i.decoded = !1, i.type = n.pixelType, i.pLinear = n.pLinear, i.width = t1.width, i.height = t1.lines;
                    }
                    const c = {
                        idx: new Array(3)
                    };
                    for(let e = 0; e < t1.channels; ++e){
                        const t1 = l[e];
                        for(let i = 0; i < a.length; ++i){
                            const n = a[i];
                            t1.name == n.name && (t1.compression = n.compression, n.index >= 0 && (c.idx[n.index] = e), t1.offset = e);
                        }
                    }
                    let u, h, d;
                    if (r.acCompressedSize > 0) switch(r.acCompression){
                        case 0:
                            u = new Uint16Array(r.totalAcUncompressedCount), v(t1.array, e, i, r.acCompressedSize, u, r.totalAcUncompressedCount);
                            break;
                        case 1:
                            const n1 = ax(t1.array.slice(i.value, i.value + r.totalAcUncompressedCount));
                            u = new Uint16Array(n1.buffer), i.value += r.totalAcUncompressedCount;
                    }
                    if (r.dcCompressedSize > 0) {
                        const e = {
                            array: t1.array,
                            offset: i,
                            size: r.dcCompressedSize
                        };
                        h = new Uint16Array(C(e).buffer), i.value += r.dcCompressedSize;
                    }
                    r.rleRawSize > 0 && (d = b(ax(t1.array.slice(i.value, i.value + r.rleCompressedSize)).buffer), i.value += r.rleCompressedSize);
                    let p = 0;
                    const f = new Array(l.length);
                    for(let t1 = 0; t1 < f.length; ++t1)f[t1] = new Array;
                    for(let e = 0; e < t1.lines; ++e)for(let e = 0; e < l.length; ++e)f[e].push(p), p += l[e].width * t1.type * 2;
                    !function(t1, e, i, n, r, a) {
                        let s = new DataView(a.buffer);
                        const o = i[t1.idx[0]].width, l = i[t1.idx[0]].height, c = Math.floor(o / 8), u = Math.ceil(o / 8), h = Math.ceil(l / 8), d = o - 8 * (u - 1), p = l - 8 * (h - 1), f = {
                            value: 0
                        }, A = new Array(3), g = new Array(3), m = new Array(3), M = new Array(3), y = new Array(3);
                        for(let i = 0; i < 3; ++i)y[i] = e[t1.idx[i]], A[i] = i < 1 ? 0 : A[i - 1] + u * h, g[i] = new Float32Array(64), m[i] = new Uint16Array(64), M[i] = new Uint16Array(64 * u);
                        for(let e = 0; e < h; ++e){
                            let a = 8;
                            e == h - 1 && (a = p);
                            let o = 8;
                            for(let t1 = 0; t1 < u; ++t1){
                                t1 == u - 1 && (o = d);
                                for(let t1 = 0; t1 < 3; ++t1)m[t1].fill(0), m[t1][0] = r[A[t1]++], T(f, n, m[t1]), v = m[t1], (x = g[t1])[0] = Q(v[0]), x[1] = Q(v[1]), x[2] = Q(v[5]), x[3] = Q(v[6]), x[4] = Q(v[14]), x[5] = Q(v[15]), x[6] = Q(v[27]), x[7] = Q(v[28]), x[8] = Q(v[2]), x[9] = Q(v[4]), x[10] = Q(v[7]), x[11] = Q(v[13]), x[12] = Q(v[16]), x[13] = Q(v[26]), x[14] = Q(v[29]), x[15] = Q(v[42]), x[16] = Q(v[3]), x[17] = Q(v[8]), x[18] = Q(v[12]), x[19] = Q(v[17]), x[20] = Q(v[25]), x[21] = Q(v[30]), x[22] = Q(v[41]), x[23] = Q(v[43]), x[24] = Q(v[9]), x[25] = Q(v[11]), x[26] = Q(v[18]), x[27] = Q(v[24]), x[28] = Q(v[31]), x[29] = Q(v[40]), x[30] = Q(v[44]), x[31] = Q(v[53]), x[32] = Q(v[10]), x[33] = Q(v[19]), x[34] = Q(v[23]), x[35] = Q(v[32]), x[36] = Q(v[39]), x[37] = Q(v[45]), x[38] = Q(v[52]), x[39] = Q(v[54]), x[40] = Q(v[20]), x[41] = Q(v[22]), x[42] = Q(v[33]), x[43] = Q(v[38]), x[44] = Q(v[46]), x[45] = Q(v[51]), x[46] = Q(v[55]), x[47] = Q(v[60]), x[48] = Q(v[21]), x[49] = Q(v[34]), x[50] = Q(v[37]), x[51] = Q(v[47]), x[52] = Q(v[50]), x[53] = Q(v[56]), x[54] = Q(v[59]), x[55] = Q(v[61]), x[56] = Q(v[35]), x[57] = Q(v[36]), x[58] = Q(v[48]), x[59] = Q(v[49]), x[60] = Q(v[57]), x[61] = Q(v[58]), x[62] = Q(v[62]), x[63] = Q(v[63]), E(g[t1]);
                                I(g);
                                for(let e = 0; e < 3; ++e)S(g[e], M[e], 64 * t1);
                            }
                            let l = 0;
                            for(let n = 0; n < 3; ++n){
                                const r = i[t1.idx[n]].type;
                                for(let t1 = 8 * e; t1 < 8 * e + a; ++t1){
                                    l = y[n][t1];
                                    for(let e = 0; e < c; ++e){
                                        const i = 64 * e + 8 * (7 & t1);
                                        s.setUint16(l + 0 * r, M[n][i + 0], !0), s.setUint16(l + 2 * r, M[n][i + 1], !0), s.setUint16(l + 4 * r, M[n][i + 2], !0), s.setUint16(l + 6 * r, M[n][i + 3], !0), s.setUint16(l + 8 * r, M[n][i + 4], !0), s.setUint16(l + 10 * r, M[n][i + 5], !0), s.setUint16(l + 12 * r, M[n][i + 6], !0), s.setUint16(l + 14 * r, M[n][i + 7], !0), l += 16 * r;
                                    }
                                }
                                if (c != u) for(let t1 = 8 * e; t1 < 8 * e + a; ++t1){
                                    const e = y[n][t1] + 8 * c * 2 * r, i = 64 * c + 8 * (7 & t1);
                                    for(let t1 = 0; t1 < o; ++t1)s.setUint16(e + 2 * t1 * r, M[n][i + t1], !0);
                                }
                            }
                        }
                        var v, x;
                        const w = new Uint16Array(o);
                        s = new DataView(a.buffer);
                        for(let e = 0; e < 3; ++e){
                            i[t1.idx[e]].decoded = !0;
                            const n = i[t1.idx[e]].type;
                            if (2 == i[e].type) for(let t1 = 0; t1 < l; ++t1){
                                const i = y[e][t1];
                                for(let t1 = 0; t1 < o; ++t1)w[t1] = s.getUint16(i + 2 * t1 * n, !0);
                                for(let t1 = 0; t1 < o; ++t1)s.setFloat32(i + 2 * t1 * n, Q(w[t1]), !0);
                            }
                        }
                    }(c, f, l, u, h, n);
                    for(let e = 0; e < l.length; ++e){
                        const i = l[e];
                        if (!i.decoded) {
                            if (2 !== i.compression) throw new Error("EXRLoader.parse: unsupported channel compression");
                            {
                                let r = 0, a = 0;
                                for(let s = 0; s < t1.lines; ++s){
                                    let t1 = f[e][r];
                                    for(let e = 0; e < i.width; ++e){
                                        for(let e = 0; e < 2 * i.type; ++e)n[t1++] = d[a + e * i.width * i.height];
                                        a++;
                                    }
                                    r++;
                                }
                            }
                        }
                    }
                    return new DataView(n.buffer);
                }
                function _(t1, e) {
                    const i = new Uint8Array(t1);
                    let n = 0;
                    for(; 0 != i[e.value + n];)n += 1;
                    const r = (new TextDecoder).decode(i.slice(e.value, e.value + n));
                    return e.value = e.value + n + 1, r;
                }
                function j(t1, e) {
                    const i = t1.getInt32(e.value, !0);
                    return e.value = e.value + 4, i;
                }
                function P(t1, e) {
                    const i = t1.getUint32(e.value, !0);
                    return e.value = e.value + 4, i;
                }
                function R(t1, e) {
                    const i = t1[e.value];
                    return e.value = e.value + 1, i;
                }
                function U(t1, e) {
                    const i = t1.getUint8(e.value);
                    return e.value = e.value + 1, i;
                }
                const k = function(t1, e) {
                    let i;
                    return i = "getBigInt64" in DataView.prototype ? Number(t1.getBigInt64(e.value, !0)) : t1.getUint32(e.value + 4, !0) + Number(t1.getUint32(e.value, !0) << 32), e.value += 8, i;
                };
                function B(t1, e) {
                    const i = t1.getFloat32(e.value, !0);
                    return e.value += 4, i;
                }
                function F(t1, e) {
                    return Xc.toHalfFloat(B(t1, e));
                }
                function Q(t1) {
                    const e = (31744 & t1) >> 10, i = 1023 & t1;
                    return (t1 >> 15 ? -1 : 1) * (e ? 31 === e ? i ? NaN : 1 / 0 : Math.pow(2, e - 15) * (1 + i / 1024) : i / 1024 * 6103515625e-14);
                }
                function H(t1, e) {
                    const i = t1.getUint16(e.value, !0);
                    return e.value += 2, i;
                }
                function V(t1, e) {
                    return Q(H(t1, e));
                }
                function G(t1, e, i, n, r) {
                    return "string" === n || "stringvector" === n || "iccProfile" === n ? function(t1, e, i) {
                        const n = (new TextDecoder).decode(new Uint8Array(t1).slice(e.value, e.value + i));
                        return e.value = e.value + i, n;
                    }(e, i, r) : "chlist" === n ? function(t1, e, i, n) {
                        const r = i.value, a = [];
                        for(; i.value < r + n - 1;){
                            const n = _(e, i), r = j(t1, i), s = U(t1, i);
                            i.value += 3;
                            const o = j(t1, i), l = j(t1, i);
                            a.push({
                                name: n,
                                pixelType: r,
                                pLinear: s,
                                xSampling: o,
                                ySampling: l
                            });
                        }
                        return i.value += 1, a;
                    }(t1, e, i, r) : "chromaticities" === n ? function(t1, e) {
                        return {
                            redX: B(t1, e),
                            redY: B(t1, e),
                            greenX: B(t1, e),
                            greenY: B(t1, e),
                            blueX: B(t1, e),
                            blueY: B(t1, e),
                            whiteX: B(t1, e),
                            whiteY: B(t1, e)
                        };
                    }(t1, i) : "compression" === n ? function(t1, e) {
                        return [
                            "NO_COMPRESSION",
                            "RLE_COMPRESSION",
                            "ZIPS_COMPRESSION",
                            "ZIP_COMPRESSION",
                            "PIZ_COMPRESSION",
                            "PXR24_COMPRESSION",
                            "B44_COMPRESSION",
                            "B44A_COMPRESSION",
                            "DWAA_COMPRESSION",
                            "DWAB_COMPRESSION"
                        ][U(t1, e)];
                    }(t1, i) : "box2i" === n ? function(t1, e) {
                        return {
                            xMin: P(t1, e),
                            yMin: P(t1, e),
                            xMax: P(t1, e),
                            yMax: P(t1, e)
                        };
                    }(t1, i) : "lineOrder" === n ? function(t1, e) {
                        return [
                            "INCREASING_Y"
                        ][U(t1, e)];
                    }(t1, i) : "float" === n ? B(t1, i) : "v2f" === n ? function(t1, e) {
                        return [
                            B(t1, e),
                            B(t1, e)
                        ];
                    }(t1, i) : "v3f" === n ? function(t1, e) {
                        return [
                            B(t1, e),
                            B(t1, e),
                            B(t1, e)
                        ];
                    }(t1, i) : "int" === n ? j(t1, i) : "rational" === n ? function(t1, e) {
                        return [
                            j(t1, e),
                            P(t1, e)
                        ];
                    }(t1, i) : "timecode" === n ? function(t1, e) {
                        return [
                            P(t1, e),
                            P(t1, e)
                        ];
                    }(t1, i) : "preview" === n ? (i.value += r, "skipped") : void (i.value += r);
                }
                const Y = new DataView(t1), W = new Uint8Array(t1), X = {
                    value: 0
                }, Z = function(t1, e, i) {
                    const n = {};
                    if (20000630 != t1.getUint32(0, !0)) throw new Error("THREE.EXRLoader: Provided file doesn't appear to be in OpenEXR format.");
                    n.version = t1.getUint8(4);
                    const r = t1.getUint8(5);
                    n.spec = {
                        singleTile: !!(2 & r),
                        longName: !!(4 & r),
                        deepFormat: !!(8 & r),
                        multiPart: !!(16 & r)
                    }, i.value = 8;
                    let a = !0;
                    for(; a;){
                        const r = _(e, i);
                        if (0 == r) a = !1;
                        else {
                            const a = _(e, i), s = G(t1, e, i, a, P(t1, i));
                            void 0 === s ? console.warn(`THREE.EXRLoader: Skipped unknown header attribute type '${a}'.`) : n[r] = s;
                        }
                    }
                    if (-5 & r) throw console.error("THREE.EXRHeader:", n), new Error("THREE.EXRLoader: Provided file is currently unsupported.");
                    return n;
                }(Y, t1, X), J = function(t1, e, i, n, r) {
                    const a = {
                        size: 0,
                        viewer: e,
                        array: i,
                        offset: n,
                        width: t1.dataWindow.xMax - t1.dataWindow.xMin + 1,
                        height: t1.dataWindow.yMax - t1.dataWindow.yMin + 1,
                        channels: t1.channels.length,
                        bytesPerLine: null,
                        lines: null,
                        inputSize: null,
                        type: t1.channels[0].pixelType,
                        uncompress: null,
                        getter: null,
                        format: null,
                        colorSpace: js
                    };
                    switch(t1.compression){
                        case "NO_COMPRESSION":
                            a.lines = 1, a.uncompress = N;
                            break;
                        case "RLE_COMPRESSION":
                            a.lines = 1, a.uncompress = D;
                            break;
                        case "ZIPS_COMPRESSION":
                            a.lines = 1, a.uncompress = C;
                            break;
                        case "ZIP_COMPRESSION":
                            a.lines = 16, a.uncompress = C;
                            break;
                        case "PIZ_COMPRESSION":
                            a.lines = 32, a.uncompress = z;
                            break;
                        case "PXR24_COMPRESSION":
                            a.lines = 16, a.uncompress = L;
                            break;
                        case "DWAA_COMPRESSION":
                            a.lines = 32, a.uncompress = O;
                            break;
                        case "DWAB_COMPRESSION":
                            a.lines = 256, a.uncompress = O;
                            break;
                        default:
                            throw new Error("EXRLoader.parse: " + t1.compression + " is unsupported");
                    }
                    if (a.scanlineBlockSize = a.lines, 1 == a.type) switch(r){
                        case ya:
                            a.getter = V, a.inputSize = 2;
                            break;
                        case va:
                            a.getter = H, a.inputSize = 2;
                    }
                    else {
                        if (2 != a.type) throw new Error("EXRLoader.parse: unsupported pixelType " + a.type + " for " + t1.compression + ".");
                        switch(r){
                            case ya:
                                a.getter = B, a.inputSize = 4;
                                break;
                            case va:
                                a.getter = F, a.inputSize = 4;
                        }
                    }
                    a.blockCount = (t1.dataWindow.yMax + 1) / a.scanlineBlockSize;
                    for(let t1 = 0; t1 < a.blockCount; t1++)k(e, n);
                    a.outputChannels = 3 == a.channels ? 4 : a.channels;
                    const s = a.width * a.height * a.outputChannels;
                    switch(r){
                        case ya:
                            a.byteArray = new Float32Array(s), a.channels < a.outputChannels && a.byteArray.fill(1, 0, s);
                            break;
                        case va:
                            a.byteArray = new Uint16Array(s), a.channels < a.outputChannels && a.byteArray.fill(15360, 0, s);
                            break;
                        default:
                            console.error("THREE.EXRLoader: unsupported type: ", r);
                    }
                    return a.bytesPerLine = a.width * a.inputSize * a.channels, 4 == a.outputChannels ? (a.format = Ea, a.colorSpace = js) : (a.format = Ca, a.colorSpace = Os), a;
                }(Z, Y, W, X, this.type), K = {
                    value: 0
                }, q = {
                    R: 0,
                    G: 1,
                    B: 2,
                    A: 3,
                    Y: 0
                };
                for(let t1 = 0; t1 < J.height / J.scanlineBlockSize; t1++){
                    const e = P(Y, X);
                    J.size = P(Y, X), J.lines = e + J.scanlineBlockSize > J.height ? J.height - e : J.scanlineBlockSize;
                    const i = J.size < J.lines * J.bytesPerLine ? J.uncompress(J) : N(J);
                    X.value += J.size;
                    for(let e = 0; e < J.scanlineBlockSize; e++){
                        const n = e + t1 * J.scanlineBlockSize;
                        if (n >= J.height) break;
                        for(let t1 = 0; t1 < J.channels; t1++){
                            const r = q[Z.channels[t1].name];
                            for(let a = 0; a < J.width; a++){
                                K.value = (e * (J.channels * J.width) + t1 * J.width + a) * J.inputSize;
                                const s = (J.height - 1 - n) * (J.width * J.outputChannels) + a * J.outputChannels + r;
                                J.byteArray[s] = J.getter(i, K);
                            }
                        }
                    }
                }
                return {
                    header: Z,
                    width: J.width,
                    height: J.height,
                    data: J.byteArray,
                    format: J.format,
                    colorSpace: J.colorSpace,
                    type: this.type
                };
            }
            setDataType(t1) {
                return this.type = t1, this;
            }
            load(t1, e, i, n) {
                return super.load(t1, function(t1, i) {
                    t1.colorSpace = i.colorSpace, t1.minFilter = la, t1.magFilter = la, t1.generateMipmaps = !1, t1.flipY = !1, e && e(t1, i);
                }, i, n);
            }
        }
        const lx = (t1)=>{
            const e = new hl(t1);
            return e.center = new Qo(.5, .5), e.colorSpace = _s, e.minFilter = da, e.magFilter = la, e.needsUpdate = !0, e;
        }, cx = (t1, e, i)=>t1.find((t1)=>t1.ID === e).Vertices.map((t1)=>{
                const e = i.find((e)=>e.ID === t1);
                return [
                    e.Location.X,
                    e.Location.Y
                ];
            }), ux = (t1, e)=>{
            const { Rooms: i } = t1.Floors[zn.currentFloorIndex].Units[0];
            return i.find((t1)=>{
                let { ID: i } = t1;
                return i === e;
            }) || null;
        }, hx = (t1, e)=>{
            const { CameraPoints: i } = t1.Floors[zn.currentFloorIndex];
            return (null == i ? void 0 : i.find((t1)=>{
                let { ID: i } = t1;
                return i === e;
            })) || null;
        }, dx = (t1, e)=>e.reduce((e, i)=>{
                const n = yv([
                    t1,
                    [
                        i.userData.left,
                        i.userData.top
                    ]
                ]);
                return n < e.length ? {
                    panorama: i,
                    length: n
                } : e;
            }, {
                length: 1 / 0,
                panorama: null
            }), px = async (t1, e)=>await new Promise((i)=>{
                const n = setInterval(()=>{
                    if (e < 0 && t1.opacity <= 0 || e > 0 && t1.opacity >= 1) return clearInterval(n), i();
                    t1.opacity = Math.min(1, t1.opacity + e);
                }, 1);
            }), fx = async (t1)=>await px(t1, -0.01), Ax = async (t1)=>await px(t1, .01), gx = (t1)=>Fo.DEG2RAD * t1, mx = (t1)=>Fo.RAD2DEG * t1, Mx = async (t1)=>{
            const e = new ox;
            return e.type = ya, new Promise((i)=>{
                e.load(t1, (t1, e)=>i(e));
            });
        }, yx = (t1, e, i)=>{
            const { data: n, width: r, height: a } = i, s = n.length / a, o = (Math.round(a - e * a) - 1) * s + 4 * Math.round(t1 * r), [l, c, u, h] = n.slice(o, o + 4);
            return {
                R: l,
                G: c,
                B: u,
                A: h
            };
        }, vx = (t1, e, i)=>{
            const { data: n, width: r, height: a } = i, s = 4 * r, o = (Math.round(a - e * a) - 1) * s + 4 * Math.round(t1 * r), [l, c, u, h] = n.slice(o, o + 4);
            return {
                R: l,
                G: c,
                B: u,
                A: h
            };
        }, xx = (t1, e)=>{
            const i = t1.X - e.X, n = t1.Y - e.Y;
            return i * i + n * n;
        }, wx = (t1, e, i)=>{
            const n = t1.clone().sub(e).normalize(), r = t1.clone().sub(i).normalize();
            return n.cross(r);
        };
        function bx(t1, e, i) {
            return (e = function(t1) {
                var e = function(t1) {
                    if ("object" != typeof t1 || !t1) return t1;
                    var e = t1[Symbol.toPrimitive];
                    if (void 0 !== e) {
                        var i = e.call(t1, "string");
                        if ("object" != typeof i) return i;
                        throw new TypeError("@@toPrimitive must return a primitive value.");
                    }
                    return String(t1);
                }(t1);
                return "symbol" == typeof e ? e : e + "";
            }(e)) in t1 ? Object.defineProperty(t1, e, {
                value: i,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : t1[e] = i, t1;
        }
        const Tx = class extends Sp {
            constructor(t1, e){
                super(), bx(this, "_tempPointer", new Qo), bx(this, "_raycaster", new EM), bx(this, "_tempMatrix", new Kl), bx(this, "_pointer", new Qo), bx(this, "deepChildren", []), bx(this, "_hoverElement", void 0), bx(this, "controller1", void 0), bx(this, "controller2", void 0), bx(this, "_renderer", void 0), bx(this, "_camera", void 0), bx(this, "updateDeepChildren", ()=>{
                    const t1 = [];
                    this.traverse((e)=>{
                        e.interactive && t1.push(e);
                    }, []), this.deepChildren = t1;
                }), this._camera = e, this._renderer = t1, this._renderer.domElement.addEventListener("pointermove", this.onPointerEvent.bind(this)), this._renderer.domElement.addEventListener("pointerdown", this.onPointerDown.bind(this)), this._renderer.domElement.addEventListener("pointerup", this.onPointerEvent.bind(this)), this._renderer.domElement.addEventListener("mousemove", this.onPointerEvent.bind(this)), this.controller1 = this.createController(0), this.controller2 = this.createController(1);
            }
            get hover() {
                return this._pointer.hover || this.controller1.hover || this.controller2.hover;
            }
            get cursor() {
                return this._pointer._hoverElement ? this._pointer._hoverElement.isLinkSphere ? "" : this._pointer._hoverElement.isDoor ? "url(".concat("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIHZpZXdCb3g9IjAgMCA1MCA1MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwXzE1MThfOTMyKSI+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMTAuMjc1NCA2LjIyOTIxQzEwLjI3NTQgNS44OTk4NiAxMC40ODgyIDUuNjA4MzMgMTAuODAxOCA1LjUwODJMMjcuMDYzNyAwLjMxNTAxNEMyNy41NTE2IDAuMTU5MTkxIDI4LjA1IDAuNTIzNTEyIDI4LjA1IDEuMDM2MDJWNDguOTk2OEMyOC4wNSA0OS40ODQ0IDI3LjU5NTggNDkuODQ0OCAyNy4xMjEzIDQ5LjczMzdMMTAuODU5NCA0NS45MjUzQzEwLjUxNzMgNDUuODQ1MyAxMC4yNzU0IDQ1LjU0IDEwLjI3NTQgNDUuMTg4NVY2LjIyOTIxWk0yNS40MDI3IDI2LjExMDhDMjQuOTg1IDI2LjExMDggMjQuNjQ2NCAyNS43NzIgMjQuNjQ2NCAyNS4zNTRWMjQuMjE4OEMyNC42NDY0IDIzLjgwMDggMjQuOTg1IDIzLjQ2MTkgMjUuNDAyNyAyMy40NjE5QzI1LjgyMDUgMjMuNDYxOSAyNi4xNTkxIDIzLjgwMDggMjYuMTU5MSAyNC4yMTg4VjI1LjM1NEMyNi4xNTkxIDI1Ljc3MiAyNS44MjA1IDI2LjExMDggMjUuNDAyNyAyNi4xMTA4Wk0zMC42OTczIDUuMjk3ODhDMzAuNjk3MyA1LjcxNTg4IDMxLjAzNTkgNi4wNTQ3MiAzMS40NTM2IDYuMDU0NzJIMzguMjYwOUMzOC42Nzg3IDYuMDU0NzIgMzkuMDE3MyA2LjM5MzU3IDM5LjAxNzMgNi44MTE1NlY0My44OTY1QzM5LjAxNzMgNDQuMzE0NSAzOC42Nzg3IDQ0LjY1MzMgMzguMjYwOSA0NC42NTMzSDMxLjQ1MzZDMzEuMDM1OSA0NC42NTMzIDMwLjY5NzMgNDQuOTkyMiAzMC42OTczIDQ1LjQxMDJDMzAuNjk3MyA0NS44MjgyIDMxLjAzNTkgNDYuMTY3IDMxLjQ1MzYgNDYuMTY3SDM5Ljc3MzdDNDAuMTkxNCA0Ni4xNjcgNDAuNTMgNDUuODI4MiA0MC41MyA0NS40MTAyVjUuMjk3ODhDNDAuNTMgNC44Nzk5IDQwLjE5MTQgNC41NDEwNSAzOS43NzM3IDQuNTQxMDVIMzEuNDUzNkMzMS4wMzU5IDQuNTQxMDUgMzAuNjk3MyA0Ljg3OTkgMzAuNjk3MyA1LjI5Nzg4WiIgZmlsbD0id2hpdGUiLz4KPC9nPgo8ZGVmcz4KPGNsaXBQYXRoIGlkPSJjbGlwMF8xNTE4XzkzMiI+CjxyZWN0IHdpZHRoPSIzNi45NjI5IiBoZWlnaHQ9IjQ5Ljk1MTIiIGZpbGw9IndoaXRlIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSg2LjU0Mjk3KSIvPgo8L2NsaXBQYXRoPgo8L2RlZnM+Cjwvc3ZnPgo=", ") 25 25, pointer") : "pointer" : "";
            }
            add() {
                super.add(...arguments), this.updateDeepChildren();
            }
            createControllerLine(t1) {
                const e = new gA(new xl(0, 0, 0), new xl(0, 0, -500)), i = new vg(e, 100, .002, 100, !1), n = new Ig({
                    color: new kc(16777215),
                    side: er
                }), r = new Ou(i, n);
                return r.isVrControllerLine = !0, r.defaultDistance = 500, r.renderOrder = 7, t1.distanceLine = r, t1.add(r), r;
            }
            createControllerCircle(t1) {
                const e = document.createElement("canvas"), i = e.getContext("2d");
                e.width = 128, e.height = 128, i.beginPath(), i.arc(e.width / 2, e.height / 2, e.width / 4, 0, 2 * Math.PI, !1), i.strokeStyle = "rgba(255, 255, 255, 1)", i.fillStyle = "rgba(20, 20, 20, 0.26)", i.lineWidth = 10, i.fill(), i.stroke();
                const n = lx(e), r = new Qp({
                    color: new kc(16777215),
                    sizeAttenuation: !1,
                    transparent: !0,
                    side: er,
                    map: n,
                    opacity: 1
                }), a = new nf(r);
                return a.isVrControllerCircle = !0, a.scale.setScalar(.05), a.renderOrder = 7, t1.distanceCircle = a, t1.add(a), a;
            }
            createController(t1) {
                const e = this._renderer.xr.getController(t1);
                e.isVrController = !0, this.createControllerLine(e), this.createControllerCircle(e);
                const i = new dv, n = new Mv, r = this._renderer.xr.getControllerGrip(t1);
                r.add(i.createControllerModel(r)), r.isVrControllerGrip = !0;
                const a = this._renderer.xr.getHand(t1);
                return a.add(n.createHandModel(a, "mesh")), a.isVrHand = !0, e.addEventListener("move", this.onXRControllerEvent.bind(this)), e.addEventListener("select", this.onXRControllerEvent.bind(this)), this.add(e, r, a), e;
            }
            getIntersections() {
                return this._raycaster.intersectObjects(this.deepChildren, !1).filter((t1)=>t1.object.visible && t1.object.parent).sort((t1)=>t1.object.isLinkSphere ? 1 : -1);
            }
            onPointerDown(t1) {
                let { clientX: e, clientY: i } = t1;
                this._tempPointer.x = Number(e.toFixed(0)), this._tempPointer.y = Number(i.toFixed(0));
            }
            onPointerEvent(t1) {
                var e;
                const i = Math.abs(this._tempPointer.x - Number(t1.clientX.toFixed(0))) < 10, n = Math.abs(this._tempPointer.y - Number(t1.clientY.toFixed(0))) < 10, r = "pointerup" === t1.type ? "click" : t1.type;
                if (!("click" !== r || i && n)) return;
                const a = this._renderer.domElement.getBoundingClientRect();
                this._pointer.x = (t1.clientX - a.left) / a.width * 2 - 1, this._pointer.y = -(t1.clientY - a.top) / a.height * 2 + 1, this._raycaster.setFromCamera(this._pointer, this._camera);
                const s = this.getIntersections();
                s.length > 0 && this.onIntersection(s, r, this._pointer) || (null === (e = this._pointer._hoverElement) || void 0 === e || e.dispatchEvent({
                    type: "hoverend",
                    controller: null
                }), this._pointer._hoverElement = null, this._pointer.hover = !1);
            }
            onXRControllerEvent(t1) {
                var e;
                const i = {
                    move: "mousemove",
                    select: "click"
                }, n = t1.target;
                this._tempMatrix.identity().extractRotation(n.matrixWorld), this._raycaster.ray.origin.setFromMatrixPosition(n.matrixWorld), this._raycaster.ray.direction.set(0, 0, -1).applyMatrix4(this._tempMatrix);
                const r = this.getIntersections();
                r.length > 0 && this.onIntersection(r, i[t1.type], n) ? n.distanceCircle.material.depthTest = !1 : (n.distanceCircle.material.depthTest = !0, this.updateControllerPointer(n, 500), null === (e = n._hoverElement) || void 0 === e || e.dispatchEvent({
                    type: "hoverend",
                    controller: n
                }), n._hoverElement = null, n.hover = !1);
            }
            onIntersection(t1, e, i) {
                this.deepChildren.forEach((e)=>{
                    if (!e.isLinkSphere) return;
                    const n = t1.some((t1)=>t1.object.uuid === e.uuid);
                    e.dispatchEvent({
                        type: n ? "hoverstart" : "hoverend",
                        controller: i
                    });
                });
                const n = t1[0];
                if (!n) return null;
                const { object: r } = n, a = {
                    x: n.uv.x,
                    y: 1 - n.uv.y
                };
                return r.dispatchEvent({
                    type: "hoverstart",
                    data: a,
                    controller: i
                }), r.dispatchEvent({
                    type: e,
                    data: a,
                    controller: i
                }), i && i.isVrController && this.updateControllerPointer(i, n.distance), i._hoverElement && i._hoverElement.uuid !== r.uuid && i._hoverElement.dispatchEvent({
                    type: "hoverend",
                    controller: i
                }), i._hoverElement = r, i.hover = !0, r;
            }
            updateControllerPointer(t1, e) {
                t1.distanceCircle.position.z = -e;
                const i = e / t1.distanceLine.defaultDistance;
                t1.distanceLine.scale.set(1, 1, i);
            }
        }, Ex = [
            "StraightStair_01",
            "StraightStairWithTurn_01",
            "HelicalStair_01",
            "QuarterLandingStair_01",
            "HalfLandingStair_01"
        ];
        var Ix = i(232), Sx = i.n(Ix);
        function Nx(t1, e, i) {
            return (e = function(t1) {
                var e = function(t1) {
                    if ("object" != typeof t1 || !t1) return t1;
                    var e = t1[Symbol.toPrimitive];
                    if (void 0 !== e) {
                        var i = e.call(t1, "string");
                        if ("object" != typeof i) return i;
                        throw new TypeError("@@toPrimitive must return a primitive value.");
                    }
                    return String(t1);
                }(t1);
                return "symbol" == typeof e ? e : e + "";
            }(e)) in t1 ? Object.defineProperty(t1, e, {
                value: i,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : t1[e] = i, t1;
        }
        ni({
            useProxies: "never"
        });
        const Dx = "granted", Cx = new class {
            constructor(){
                Nx(this, "parser", null), Nx(this, "deviceOrientationStatus", "denied"), Nx(this, "setDeviceOrientationStatus", (t1)=>(this.deviceOrientationStatus = t1, t1)), Nx(this, "requestDeviceOrientation", async ()=>{
                    try {
                        return DeviceOrientationEvent.requestPermission ? await DeviceOrientationEvent.requestPermission().then((t1)=>this.setDeviceOrientationStatus(t1)) : this.setDeviceOrientationStatus(Dx);
                    } catch (t1) {
                        console.log(t1);
                    }
                }), Ti(this), this.parser = new (Sx());
            }
            get device() {
                return this.parser.getDevice();
            }
            get isMobile() {
                return "mobile" === this.device.type;
            }
            get isTablet() {
                return "tablet" === this.device.type;
            }
            get isMobileDevice() {
                return this.isMobile || this.isTablet;
            }
            get deviceOrientationGranted() {
                return this.deviceOrientationStatus === Dx;
            }
        };
        function zx(t1, e, i) {
            return (e = function(t1) {
                var e = function(t1) {
                    if ("object" != typeof t1 || !t1) return t1;
                    var e = t1[Symbol.toPrimitive];
                    if (void 0 !== e) {
                        var i = e.call(t1, "string");
                        if ("object" != typeof i) return i;
                        throw new TypeError("@@toPrimitive must return a primitive value.");
                    }
                    return String(t1);
                }(t1);
                return "symbol" == typeof e ? e : e + "";
            }(e)) in t1 ? Object.defineProperty(t1, e, {
                value: i,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : t1[e] = i, t1;
        }
        const Lx = class extends Ou {
            constructor(t1){
                super(), zx(this, "interactive", !0), zx(this, "_visible", !0), zx(this, "isDoor", !0), this.userData = t1, this.position.copy(t1.position), this.rotation.copy(t1.rotation), this.renderOrder = 3, this.visible = !1, this.createGeometry(), this.createMaterial(), this.onHoverEnd(), this.addEventListeners();
            }
            get visible() {
                return this._visible;
            }
            set visible(t1) {
                this._visible = t1, this.sprite && (this.sprite.visible = t1 ? Cx.isMobileDevice : t1);
            }
            createGeometry() {
                return this.geometry = new ih(this.userData.width, this.userData.height, 10, 10), this;
            }
            async createMaterial() {
                const t1 = new Ig({
                    color: new kc(16777215),
                    transparent: !0,
                    depthTest: !1,
                    side: er,
                    opacity: 0
                });
                return this.material = t1, this;
            }
            addEventListeners() {
                return this.addEventListener("select", ()=>this.onClick()), this.addEventListener("click", ()=>this.onClick()), this.addEventListener("hoverstart", ()=>this.onHoverStart()), this.addEventListener("hoverend", ()=>this.onHoverEnd()), this;
            }
            dispose() {
                this.material.dispose(), this.removeFromParent();
            }
            onHoverStart() {}
            onHoverEnd() {}
            onClick() {}
        };
        function Ox(t1) {
            if (void 0 === t1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return t1;
        }
        function _x(t1, e) {
            t1.prototype = Object.create(e.prototype), t1.prototype.constructor = t1, t1.__proto__ = e;
        }
        var jx, Px, Rx, Ux, kx, Bx, Fx, Qx, Hx, Vx, Gx, Yx, Wx, Xx, Zx, Jx, Kx, qx = {
            autoSleep: 120,
            force3D: "auto",
            nullTargetWarn: 1,
            units: {
                lineHeight: ""
            }
        }, $x = {
            duration: .5,
            overwrite: !1,
            delay: 0
        }, tw = 1e8, ew = 1e-8, iw = 2 * Math.PI, nw = iw / 4, rw = 0, aw = Math.sqrt, sw = Math.cos, ow = Math.sin, lw = function(t1) {
            return "string" == typeof t1;
        }, cw = function(t1) {
            return "function" == typeof t1;
        }, uw = function(t1) {
            return "number" == typeof t1;
        }, hw = function(t1) {
            return void 0 === t1;
        }, dw = function(t1) {
            return "object" == typeof t1;
        }, pw = function(t1) {
            return !1 !== t1;
        }, fw = function() {
            return "undefined" != typeof window;
        }, Aw = function(t1) {
            return cw(t1) || lw(t1);
        }, gw = "function" == typeof ArrayBuffer && ArrayBuffer.isView || function() {}, mw = Array.isArray, Mw = /(?:-?\.?\d|\.)+/gi, yw = /[-+=.]*\d+[.e\-+]*\d*[e\-+]*\d*/g, vw = /[-+=.]*\d+[.e-]*\d*[a-z%]*/g, xw = /[-+=.]*\d+\.?\d*(?:e-|e\+)?\d*/gi, ww = /[+-]=-?[.\d]+/, bw = /[^,'"\[\]\s]+/gi, Tw = /^[+\-=e\s\d]*\d+[.\d]*([a-z]*|%)\s*$/i, Ew = {}, Iw = {}, Sw = function(t1) {
            return (Iw = ib(t1, Ew)) && iE;
        }, Nw = function(t1, e) {
            return console.warn("Invalid property", t1, "set to", e, "Missing plugin? gsap.registerPlugin()");
        }, Dw = function(t1, e) {
            return !e && console.warn(t1);
        }, Cw = function(t1, e) {
            return t1 && (Ew[t1] = e) && Iw && (Iw[t1] = e) || Ew;
        }, zw = function() {
            return 0;
        }, Lw = {
            suppressEvents: !0,
            isStart: !0,
            kill: !1
        }, Ow = {
            suppressEvents: !0,
            kill: !1
        }, _w = {
            suppressEvents: !0
        }, jw = {}, Pw = [], Rw = {}, Uw = {}, kw = {}, Bw = 30, Fw = [], Qw = "", Hw = function(t1) {
            var e, i, n = t1[0];
            if (dw(n) || cw(n) || (t1 = [
                t1
            ]), !(e = (n._gsap || {}).harness)) {
                for(i = Fw.length; i-- && !Fw[i].targetTest(n););
                e = Fw[i];
            }
            for(i = t1.length; i--;)t1[i] && (t1[i]._gsap || (t1[i]._gsap = new gT(t1[i], e))) || t1.splice(i, 1);
            return t1;
        }, Vw = function(t1) {
            return t1._gsap || Hw(Ob(t1))[0]._gsap;
        }, Gw = function(t1, e, i) {
            return (i = t1[e]) && cw(i) ? t1[e]() : hw(i) && t1.getAttribute && t1.getAttribute(e) || i;
        }, Yw = function(t1, e) {
            return (t1 = t1.split(",")).forEach(e) || t1;
        }, Ww = function(t1) {
            return Math.round(1e5 * t1) / 1e5 || 0;
        }, Xw = function(t1) {
            return Math.round(1e7 * t1) / 1e7 || 0;
        }, Zw = function(t1, e) {
            var i = e.charAt(0), n = parseFloat(e.substr(2));
            return t1 = parseFloat(t1), "+" === i ? t1 + n : "-" === i ? t1 - n : "*" === i ? t1 * n : t1 / n;
        }, Jw = function(t1, e) {
            for(var i = e.length, n = 0; t1.indexOf(e[n]) < 0 && ++n < i;);
            return n < i;
        }, Kw = function() {
            var t1, e, i = Pw.length, n = Pw.slice(0);
            for(Rw = {}, Pw.length = 0, t1 = 0; t1 < i; t1++)(e = n[t1]) && e._lazy && (e.render(e._lazy[0], e._lazy[1], !0)._lazy = 0);
        }, qw = function(t1, e, i, n) {
            Pw.length && !Px && Kw(), t1.render(e, i, n || Px && e < 0 && (t1._initted || t1._startAt)), Pw.length && !Px && Kw();
        }, $w = function(t1) {
            var e = parseFloat(t1);
            return (e || 0 === e) && (t1 + "").match(bw).length < 2 ? e : lw(t1) ? t1.trim() : t1;
        }, tb = function(t1) {
            return t1;
        }, eb = function(t1, e) {
            for(var i in e)i in t1 || (t1[i] = e[i]);
            return t1;
        }, ib = function(t1, e) {
            for(var i in e)t1[i] = e[i];
            return t1;
        }, nb = function t1(e, i) {
            for(var n in i)"__proto__" !== n && "constructor" !== n && "prototype" !== n && (e[n] = dw(i[n]) ? t1(e[n] || (e[n] = {}), i[n]) : i[n]);
            return e;
        }, rb = function(t1, e) {
            var i, n = {};
            for(i in t1)i in e || (n[i] = t1[i]);
            return n;
        }, ab = function(t1) {
            var e, i = t1.parent || Ux, n = t1.keyframes ? (e = mw(t1.keyframes), function(t1, i) {
                for(var n in i)n in t1 || "duration" === n && e || "ease" === n || (t1[n] = i[n]);
            }) : eb;
            if (pw(t1.inherit)) for(; i;)n(t1, i.vars.defaults), i = i.parent || i._dp;
            return t1;
        }, sb = function(t1, e, i, n, r) {
            void 0 === i && (i = "_first"), void 0 === n && (n = "_last");
            var a, s = t1[n];
            if (r) for(a = e[r]; s && s[r] > a;)s = s._prev;
            return s ? (e._next = s._next, s._next = e) : (e._next = t1[i], t1[i] = e), e._next ? e._next._prev = e : t1[n] = e, e._prev = s, e.parent = e._dp = t1, e;
        }, ob = function(t1, e, i, n) {
            void 0 === i && (i = "_first"), void 0 === n && (n = "_last");
            var r = e._prev, a = e._next;
            r ? r._next = a : t1[i] === e && (t1[i] = a), a ? a._prev = r : t1[n] === e && (t1[n] = r), e._next = e._prev = e.parent = null;
        }, lb = function(t1, e) {
            t1.parent && (!e || t1.parent.autoRemoveChildren) && t1.parent.remove && t1.parent.remove(t1), t1._act = 0;
        }, cb = function(t1, e) {
            if (t1 && (!e || e._end > t1._dur || e._start < 0)) for(var i = t1; i;)i._dirty = 1, i = i.parent;
            return t1;
        }, ub = function(t1, e, i, n) {
            return t1._startAt && (Px ? t1._startAt.revert(Ow) : t1.vars.immediateRender && !t1.vars.autoRevert || t1._startAt.render(e, !0, n));
        }, hb = function t1(e) {
            return !e || e._ts && t1(e.parent);
        }, db = function(t1) {
            return t1._repeat ? pb(t1._tTime, t1 = t1.duration() + t1._rDelay) * t1 : 0;
        }, pb = function(t1, e) {
            var i = Math.floor(t1 /= e);
            return t1 && i === t1 ? i - 1 : i;
        }, fb = function(t1, e) {
            return (t1 - e._start) * e._ts + (e._ts >= 0 ? 0 : e._dirty ? e.totalDuration() : e._tDur);
        }, Ab = function(t1) {
            return t1._end = Xw(t1._start + (t1._tDur / Math.abs(t1._ts || t1._rts || ew) || 0));
        }, gb = function(t1, e) {
            var i = t1._dp;
            return i && i.smoothChildTiming && t1._ts && (t1._start = Xw(i._time - (t1._ts > 0 ? e / t1._ts : ((t1._dirty ? t1.totalDuration() : t1._tDur) - e) / -t1._ts)), Ab(t1), i._dirty || cb(i, t1)), t1;
        }, mb = function(t1, e) {
            var i;
            if ((e._time || !e._dur && e._initted || e._start < t1._time && (e._dur || !e.add)) && (i = fb(t1.rawTime(), e), (!e._dur || Db(0, e.totalDuration(), i) - e._tTime > ew) && e.render(i, !0)), cb(t1, e)._dp && t1._initted && t1._time >= t1._dur && t1._ts) {
                if (t1._dur < t1.duration()) for(i = t1; i._dp;)i.rawTime() >= 0 && i.totalTime(i._tTime), i = i._dp;
                t1._zTime = -0.00000001;
            }
        }, Mb = function(t1, e, i, n) {
            return e.parent && lb(e), e._start = Xw((uw(i) ? i : i || t1 !== Ux ? Ib(t1, i, e) : t1._time) + e._delay), e._end = Xw(e._start + (e.totalDuration() / Math.abs(e.timeScale()) || 0)), sb(t1, e, "_first", "_last", t1._sort ? "_start" : 0), wb(e) || (t1._recent = e), n || mb(t1, e), t1._ts < 0 && gb(t1, t1._tTime), t1;
        }, yb = function(t1, e) {
            return (Ew.ScrollTrigger || Nw("scrollTrigger", e)) && Ew.ScrollTrigger.create(e, t1);
        }, vb = function(t1, e, i, n, r) {
            return TT(t1, e, r), t1._initted ? !i && t1._pt && !Px && (t1._dur && !1 !== t1.vars.lazy || !t1._dur && t1.vars.lazy) && Hx !== nT.frame ? (Pw.push(t1), t1._lazy = [
                r,
                n
            ], 1) : void 0 : 1;
        }, xb = function t1(e) {
            var i = e.parent;
            return i && i._ts && i._initted && !i._lock && (i.rawTime() < 0 || t1(i));
        }, wb = function(t1) {
            var e = t1.data;
            return "isFromStart" === e || "isStart" === e;
        }, bb = function(t1, e, i, n) {
            var r = t1._repeat, a = Xw(e) || 0, s = t1._tTime / t1._tDur;
            return s && !n && (t1._time *= a / t1._dur), t1._dur = a, t1._tDur = r ? r < 0 ? 1e10 : Xw(a * (r + 1) + t1._rDelay * r) : a, s > 0 && !n && gb(t1, t1._tTime = t1._tDur * s), t1.parent && Ab(t1), i || cb(t1.parent, t1), t1;
        }, Tb = function(t1) {
            return t1 instanceof MT ? cb(t1) : bb(t1, t1._dur);
        }, Eb = {
            _start: 0,
            endTime: zw,
            totalDuration: zw
        }, Ib = function t1(e, i, n) {
            var r, a, s, o = e.labels, l = e._recent || Eb, c = e.duration() >= tw ? l.endTime(!1) : e._dur;
            return lw(i) && (isNaN(i) || i in o) ? (a = i.charAt(0), s = "%" === i.substr(-1), r = i.indexOf("="), "<" === a || ">" === a ? (r >= 0 && (i = i.replace(/=/, "")), ("<" === a ? l._start : l.endTime(l._repeat >= 0)) + (parseFloat(i.substr(1)) || 0) * (s ? (r < 0 ? l : n).totalDuration() / 100 : 1)) : r < 0 ? (i in o || (o[i] = c), o[i]) : (a = parseFloat(i.charAt(r - 1) + i.substr(r + 1)), s && n && (a = a / 100 * (mw(n) ? n[0] : n).totalDuration()), r > 1 ? t1(e, i.substr(0, r - 1), n) + a : c + a)) : null == i ? c : +i;
        }, Sb = function(t1, e, i) {
            var n, r, a = uw(e[1]), s = (a ? 2 : 1) + (t1 < 2 ? 0 : 1), o = e[s];
            if (a && (o.duration = e[1]), o.parent = i, t1) {
                for(n = o, r = i; r && !("immediateRender" in n);)n = r.vars.defaults || {}, r = pw(r.vars.inherit) && r.parent;
                o.immediateRender = pw(n.immediateRender), t1 < 2 ? o.runBackwards = 1 : o.startAt = e[s - 1];
            }
            return new DT(e[0], o, e[s + 1]);
        }, Nb = function(t1, e) {
            return t1 || 0 === t1 ? e(t1) : e;
        }, Db = function(t1, e, i) {
            return i < t1 ? t1 : i > e ? e : i;
        }, Cb = function(t1, e) {
            return lw(t1) && (e = Tw.exec(t1)) ? e[1] : "";
        }, zb = [].slice, Lb = function(t1, e) {
            return t1 && dw(t1) && "length" in t1 && (!e && !t1.length || t1.length - 1 in t1 && dw(t1[0])) && !t1.nodeType && t1 !== kx;
        }, Ob = function(t1, e, i) {
            return Rx && !e && Rx.selector ? Rx.selector(t1) : !lw(t1) || i || !Bx && rT() ? mw(t1) ? function(t1, e, i) {
                return void 0 === i && (i = []), t1.forEach(function(t1) {
                    var n;
                    return lw(t1) && !e || Lb(t1, 1) ? (n = i).push.apply(n, Ob(t1)) : i.push(t1);
                }) || i;
            }(t1, i) : Lb(t1) ? zb.call(t1, 0) : t1 ? [
                t1
            ] : [] : zb.call((e || Fx).querySelectorAll(t1), 0);
        }, _b = function(t1) {
            return t1 = Ob(t1)[0] || Dw("Invalid scope") || {}, function(e) {
                var i = t1.current || t1.nativeElement || t1;
                return Ob(e, i.querySelectorAll ? i : i === t1 ? Dw("Invalid scope") || Fx.createElement("div") : t1);
            };
        }, jb = function(t1) {
            return t1.sort(function() {
                return .5 - Math.random();
            });
        }, Pb = function(t1) {
            if (cw(t1)) return t1;
            var e = dw(t1) ? t1 : {
                each: t1
            }, i = hT(e.ease), n = e.from || 0, r = parseFloat(e.base) || 0, a = {}, s = n > 0 && n < 1, o = isNaN(n) || s, l = e.axis, c = n, u = n;
            return lw(n) ? c = u = ({
                center: .5,
                edges: .5,
                end: 1
            })[n] || 0 : !s && o && (c = n[0], u = n[1]), function(t1, s, h) {
                var d, p, f, A, g, m, M, y, v, x = (h || e).length, w = a[x];
                if (!w) {
                    if (!(v = "auto" === e.grid ? 0 : (e.grid || [
                        1,
                        tw
                    ])[1])) {
                        for(M = -tw; M < (M = h[v++].getBoundingClientRect().left) && v < x;);
                        v < x && v--;
                    }
                    for(w = a[x] = [], d = o ? Math.min(v, x) * c - .5 : n % v, p = v === tw ? 0 : o ? x * u / v - .5 : n / v | 0, M = 0, y = tw, m = 0; m < x; m++)f = m % v - d, A = p - (m / v | 0), w[m] = g = l ? Math.abs("y" === l ? A : f) : aw(f * f + A * A), g > M && (M = g), g < y && (y = g);
                    "random" === n && jb(w), w.max = M - y, w.min = y, w.v = x = (parseFloat(e.amount) || parseFloat(e.each) * (v > x ? x - 1 : l ? "y" === l ? x / v : v : Math.max(v, x / v)) || 0) * ("edges" === n ? -1 : 1), w.b = x < 0 ? r - x : r, w.u = Cb(e.amount || e.each) || 0, i = i && x < 0 ? cT(i) : i;
                }
                return x = (w[t1] - w.min) / w.max || 0, Xw(w.b + (i ? i(x) : x) * w.v) + w.u;
            };
        }, Rb = function(t1) {
            var e = Math.pow(10, ((t1 + "").split(".")[1] || "").length);
            return function(i) {
                var n = Xw(Math.round(parseFloat(i) / t1) * t1 * e);
                return (n - n % 1) / e + (uw(i) ? 0 : Cb(i));
            };
        }, Ub = function(t1, e) {
            var i, n, r = mw(t1);
            return !r && dw(t1) && (i = r = t1.radius || tw, t1.values ? (t1 = Ob(t1.values), (n = !uw(t1[0])) && (i *= i)) : t1 = Rb(t1.increment)), Nb(e, r ? cw(t1) ? function(e) {
                return n = t1(e), Math.abs(n - e) <= i ? n : e;
            } : function(e) {
                for(var r, a, s = parseFloat(n ? e.x : e), o = parseFloat(n ? e.y : 0), l = tw, c = 0, u = t1.length; u--;)(r = n ? (r = t1[u].x - s) * r + (a = t1[u].y - o) * a : Math.abs(t1[u] - s)) < l && (l = r, c = u);
                return c = !i || l <= i ? t1[c] : e, n || c === e || uw(e) ? c : c + Cb(e);
            } : Rb(t1));
        }, kb = function(t1, e, i, n) {
            return Nb(mw(t1) ? !e : !0 === i ? (i = 0, false) : !n, function() {
                return mw(t1) ? t1[~~(Math.random() * t1.length)] : (i = i || 1e-5, n = i < 1 ? Math.pow(10, (i + "").length - 2) : 1) && Math.floor(Math.round((t1 - i / 2 + Math.random() * (e - t1 + .99 * i)) / i) * i * n) / n;
            });
        }, Bb = function(t1, e, i) {
            return Nb(i, function(i) {
                return t1[~~e(i)];
            });
        }, Fb = function(t1) {
            for(var e, i, n, r, a = 0, s = ""; ~(e = t1.indexOf("random(", a));)n = t1.indexOf(")", e), r = "[" === t1.charAt(e + 7), i = t1.substr(e + 7, n - e - 7).match(r ? bw : Mw), s += t1.substr(a, e - a) + kb(r ? i : +i[0], r ? 0 : +i[1], +i[2] || 1e-5), a = n + 1;
            return s + t1.substr(a, t1.length - a);
        }, Qb = function(t1, e, i, n, r) {
            var a = e - t1, s = n - i;
            return Nb(r, function(e) {
                return i + ((e - t1) / a * s || 0);
            });
        }, Hb = function(t1, e, i) {
            var n, r, a, s = t1.labels, o = tw;
            for(n in s)(r = s[n] - e) < 0 == !!i && r && o > (r = Math.abs(r)) && (a = n, o = r);
            return a;
        }, Vb = function(t1, e, i) {
            var n, r, a, s = t1.vars, o = s[e], l = Rx, c = t1._ctx;
            if (o) return n = s[e + "Params"], r = s.callbackScope || t1, i && Pw.length && Kw(), c && (Rx = c), a = n ? o.apply(r, n) : o.call(r), Rx = l, a;
        }, Gb = function(t1) {
            return lb(t1), t1.scrollTrigger && t1.scrollTrigger.kill(!!Px), t1.progress() < 1 && Vb(t1, "onInterrupt"), t1;
        }, Yb = [], Wb = function(t1) {
            if (t1) {
                if (t1 = !t1.name && t1.default || t1, fw() || t1.headless) {
                    var e = t1.name, i = cw(t1), n = e && !i && t1.init ? function() {
                        this._props = [];
                    } : t1, r = {
                        init: zw,
                        render: UT,
                        add: wT,
                        kill: BT,
                        modifier: kT,
                        rawVars: 0
                    }, a = {
                        targetTest: 0,
                        get: 0,
                        getSetter: _T,
                        aliases: {},
                        register: 0
                    };
                    if (rT(), t1 !== n) {
                        if (Uw[e]) return;
                        eb(n, eb(rb(t1, r), a)), ib(n.prototype, ib(r, rb(t1, a))), Uw[n.prop = e] = n, t1.targetTest && (Fw.push(n), jw[e] = 1), e = ("css" === e ? "CSS" : e.charAt(0).toUpperCase() + e.substr(1)) + "Plugin";
                    }
                    Cw(e, n), t1.register && t1.register(iE, n, HT);
                } else Yb.push(t1);
            }
        }, Xb = 255, Zb = {
            aqua: [
                0,
                Xb,
                Xb
            ],
            lime: [
                0,
                Xb,
                0
            ],
            silver: [
                192,
                192,
                192
            ],
            black: [
                0,
                0,
                0
            ],
            maroon: [
                128,
                0,
                0
            ],
            teal: [
                0,
                128,
                128
            ],
            blue: [
                0,
                0,
                Xb
            ],
            navy: [
                0,
                0,
                128
            ],
            white: [
                Xb,
                Xb,
                Xb
            ],
            olive: [
                128,
                128,
                0
            ],
            yellow: [
                Xb,
                Xb,
                0
            ],
            orange: [
                Xb,
                165,
                0
            ],
            gray: [
                128,
                128,
                128
            ],
            purple: [
                128,
                0,
                128
            ],
            green: [
                0,
                128,
                0
            ],
            red: [
                Xb,
                0,
                0
            ],
            pink: [
                Xb,
                192,
                203
            ],
            cyan: [
                0,
                Xb,
                Xb
            ],
            transparent: [
                Xb,
                Xb,
                Xb,
                0
            ]
        }, Jb = function(t1, e, i) {
            return (6 * (t1 += t1 < 0 ? 1 : t1 > 1 ? -1 : 0) < 1 ? e + (i - e) * t1 * 6 : t1 < .5 ? i : 3 * t1 < 2 ? e + (i - e) * (2 / 3 - t1) * 6 : e) * Xb + .5 | 0;
        }, Kb = function(t1, e, i) {
            var n, r, a, s, o, l, c, u, h, d, p = t1 ? uw(t1) ? [
                t1 >> 16,
                t1 >> 8 & Xb,
                t1 & Xb
            ] : 0 : Zb.black;
            if (!p) {
                if ("," === t1.substr(-1) && (t1 = t1.substr(0, t1.length - 1)), Zb[t1]) p = Zb[t1];
                else if ("#" === t1.charAt(0)) {
                    if (t1.length < 6 && (n = t1.charAt(1), r = t1.charAt(2), a = t1.charAt(3), t1 = "#" + n + n + r + r + a + a + (5 === t1.length ? t1.charAt(4) + t1.charAt(4) : "")), 9 === t1.length) return [
                        (p = parseInt(t1.substr(1, 6), 16)) >> 16,
                        p >> 8 & Xb,
                        p & Xb,
                        parseInt(t1.substr(7), 16) / 255
                    ];
                    p = [
                        (t1 = parseInt(t1.substr(1), 16)) >> 16,
                        t1 >> 8 & Xb,
                        t1 & Xb
                    ];
                } else if ("hsl" === t1.substr(0, 3)) {
                    if (p = d = t1.match(Mw), e) {
                        if (~t1.indexOf("=")) return p = t1.match(yw), i && p.length < 4 && (p[3] = 1), p;
                    } else s = +p[0] % 360 / 360, o = +p[1] / 100, n = 2 * (l = +p[2] / 100) - (r = l <= .5 ? l * (o + 1) : l + o - l * o), p.length > 3 && (p[3] *= 1), p[0] = Jb(s + 1 / 3, n, r), p[1] = Jb(s, n, r), p[2] = Jb(s - 1 / 3, n, r);
                } else p = t1.match(Mw) || Zb.transparent;
                p = p.map(Number);
            }
            return e && !d && (n = p[0] / Xb, r = p[1] / Xb, a = p[2] / Xb, l = ((c = Math.max(n, r, a)) + (u = Math.min(n, r, a))) / 2, c === u ? s = o = 0 : (h = c - u, o = l > .5 ? h / (2 - c - u) : h / (c + u), s = c === n ? (r - a) / h + (r < a ? 6 : 0) : c === r ? (a - n) / h + 2 : (n - r) / h + 4, s *= 60), p[0] = ~~(s + .5), p[1] = ~~(100 * o + .5), p[2] = ~~(100 * l + .5)), i && p.length < 4 && (p[3] = 1), p;
        }, qb = function(t1) {
            var e = [], i = [], n = -1;
            return t1.split(tT).forEach(function(t1) {
                var r = t1.match(vw) || [];
                e.push.apply(e, r), i.push(n += r.length + 1);
            }), e.c = i, e;
        }, $b = function(t1, e, i) {
            var n, r, a, s, o = "", l = (t1 + o).match(tT), c = e ? "hsla(" : "rgba(", u = 0;
            if (!l) return t1;
            if (l = l.map(function(t1) {
                return (t1 = Kb(t1, e, 1)) && c + (e ? t1[0] + "," + t1[1] + "%," + t1[2] + "%," + t1[3] : t1.join(",")) + ")";
            }), i && (a = qb(t1), (n = i.c).join(o) !== a.c.join(o))) for(s = (r = t1.replace(tT, "1").split(vw)).length - 1; u < s; u++)o += r[u] + (~n.indexOf(u) ? l.shift() || c + "0,0,0,0)" : (a.length ? a : l.length ? l : i).shift());
            if (!r) for(s = (r = t1.split(tT)).length - 1; u < s; u++)o += r[u] + l[u];
            return o + r[s];
        }, tT = function() {
            var t1, e = "(?:\\b(?:(?:rgb|rgba|hsl|hsla)\\(.+?\\))|\\B#(?:[0-9a-f]{3,4}){1,2}\\b";
            for(t1 in Zb)e += "|" + t1 + "\\b";
            return new RegExp(e + ")", "gi");
        }(), eT = /hsl[a]?\(/, iT = function(t1) {
            var e, i = t1.join(" ");
            if (tT.lastIndex = 0, tT.test(i)) return e = eT.test(i), t1[1] = $b(t1[1], e), t1[0] = $b(t1[0], e, qb(t1[1])), !0;
        }, nT = function() {
            var t1, e, i, n, r, a, s = Date.now, o = 500, l = 33, c = s(), u = c, h = 1e3 / 240, d = h, p = [], f = function i(f) {
                var A, g, m, M, y = s() - u, v = !0 === f;
                if ((y > o || y < 0) && (c += y - l), ((A = (m = (u += y) - c) - d) > 0 || v) && (M = ++n.frame, r = m - 1e3 * n.time, n.time = m /= 1e3, d += A + (A >= h ? 4 : h - A), g = 1), v || (t1 = e(i)), g) for(a = 0; a < p.length; a++)p[a](m, r, M, f);
            };
            return n = {
                time: 0,
                frame: 0,
                tick: function() {
                    f(!0);
                },
                deltaRatio: function(t1) {
                    return r / (1e3 / (t1 || 60));
                },
                wake: function() {
                    Qx && (!Bx && fw() && (kx = Bx = window, Fx = kx.document || {}, Ew.gsap = iE, (kx.gsapVersions || (kx.gsapVersions = [])).push(iE.version), Sw(Iw || kx.GreenSockGlobals || !kx.gsap && kx || {}), Yb.forEach(Wb)), i = "undefined" != typeof requestAnimationFrame && requestAnimationFrame, t1 && n.sleep(), e = i || function(t1) {
                        return setTimeout(t1, d - 1e3 * n.time + 1 | 0);
                    }, Gx = 1, f(2));
                },
                sleep: function() {
                    (i ? cancelAnimationFrame : clearTimeout)(t1), Gx = 0, e = zw;
                },
                lagSmoothing: function(t1, e) {
                    o = t1 || 1 / 0, l = Math.min(e || 33, o);
                },
                fps: function(t1) {
                    h = 1e3 / (t1 || 240), d = 1e3 * n.time + h;
                },
                add: function(t1, e, i) {
                    var r = e ? function(e, i, a, s) {
                        t1(e, i, a, s), n.remove(r);
                    } : t1;
                    return n.remove(t1), p[i ? "unshift" : "push"](r), rT(), r;
                },
                remove: function(t1, e) {
                    ~(e = p.indexOf(t1)) && p.splice(e, 1) && a >= e && a--;
                },
                _listeners: p
            }, n;
        }(), rT = function() {
            return !Gx && nT.wake();
        }, aT = {}, sT = /^[\d.\-M][\d.\-,\s]/, oT = /["']/g, lT = function(t1) {
            for(var e, i, n, r = {}, a = t1.substr(1, t1.length - 3).split(":"), s = a[0], o = 1, l = a.length; o < l; o++)i = a[o], e = o !== l - 1 ? i.lastIndexOf(",") : i.length, n = i.substr(0, e), r[s] = isNaN(n) ? n.replace(oT, "").trim() : +n, s = i.substr(e + 1).trim();
            return r;
        }, cT = function(t1) {
            return function(e) {
                return 1 - t1(1 - e);
            };
        }, uT = function t1(e, i) {
            for(var n, r = e._first; r;)r instanceof MT ? t1(r, i) : !r.vars.yoyoEase || r._yoyo && r._repeat || r._yoyo === i || (r.timeline ? t1(r.timeline, i) : (n = r._ease, r._ease = r._yEase, r._yEase = n, r._yoyo = i)), r = r._next;
        }, hT = function(t1, e) {
            return t1 && (cw(t1) ? t1 : aT[t1] || function(t1) {
                var e, i, n, r, a = (t1 + "").split("("), s = aT[a[0]];
                return s && a.length > 1 && s.config ? s.config.apply(null, ~t1.indexOf("{") ? [
                    lT(a[1])
                ] : (e = t1, i = e.indexOf("(") + 1, n = e.indexOf(")"), r = e.indexOf("(", i), e.substring(i, ~r && r < n ? e.indexOf(")", n + 1) : n)).split(",").map($w)) : aT._CE && sT.test(t1) ? aT._CE("", t1) : s;
            }(t1)) || e;
        }, dT = function(t1, e, i, n) {
            void 0 === i && (i = function(t1) {
                return 1 - e(1 - t1);
            }), void 0 === n && (n = function(t1) {
                return t1 < .5 ? e(2 * t1) / 2 : 1 - e(2 * (1 - t1)) / 2;
            });
            var r, a = {
                easeIn: e,
                easeOut: i,
                easeInOut: n
            };
            return Yw(t1, function(t1) {
                for(var e in aT[t1] = Ew[t1] = a, aT[r = t1.toLowerCase()] = i, a)aT[r + ("easeIn" === e ? ".in" : "easeOut" === e ? ".out" : ".inOut")] = aT[t1 + "." + e] = a[e];
            }), a;
        }, pT = function(t1) {
            return function(e) {
                return e < .5 ? (1 - t1(1 - 2 * e)) / 2 : .5 + t1(2 * (e - .5)) / 2;
            };
        }, fT = function t1(e, i, n) {
            var r = i >= 1 ? i : 1, a = (n || (e ? .3 : .45)) / (i < 1 ? i : 1), s = a / iw * (Math.asin(1 / r) || 0), o = function(t1) {
                return 1 === t1 ? 1 : r * Math.pow(2, -10 * t1) * ow((t1 - s) * a) + 1;
            }, l = "out" === e ? o : "in" === e ? function(t1) {
                return 1 - o(1 - t1);
            } : pT(o);
            return a = iw / a, l.config = function(i, n) {
                return t1(e, i, n);
            }, l;
        }, AT = function t1(e, i) {
            void 0 === i && (i = 1.70158);
            var n = function(t1) {
                return t1 ? --t1 * t1 * ((i + 1) * t1 + i) + 1 : 0;
            }, r = "out" === e ? n : "in" === e ? function(t1) {
                return 1 - n(1 - t1);
            } : pT(n);
            return r.config = function(i) {
                return t1(e, i);
            }, r;
        };
        Yw("Linear,Quad,Cubic,Quart,Quint,Strong", function(t1, e) {
            var i = e < 5 ? e + 1 : e;
            dT(t1 + ",Power" + (i - 1), e ? function(t1) {
                return Math.pow(t1, i);
            } : function(t1) {
                return t1;
            }, function(t1) {
                return 1 - Math.pow(1 - t1, i);
            }, function(t1) {
                return t1 < .5 ? Math.pow(2 * t1, i) / 2 : 1 - Math.pow(2 * (1 - t1), i) / 2;
            });
        }), aT.Linear.easeNone = aT.none = aT.Linear.easeIn, dT("Elastic", fT("in"), fT("out"), fT()), Yx = 7.5625, Zx = 2 * (Xx = 1 / (Wx = 2.75)), Jx = 2.5 * Xx, dT("Bounce", function(t1) {
            return 1 - Kx(1 - t1);
        }, Kx = function(t1) {
            return t1 < Xx ? Yx * t1 * t1 : t1 < Zx ? Yx * Math.pow(t1 - 1.5 / Wx, 2) + .75 : t1 < Jx ? Yx * (t1 -= 2.25 / Wx) * t1 + .9375 : Yx * Math.pow(t1 - 2.625 / Wx, 2) + .984375;
        }), dT("Expo", function(t1) {
            return t1 ? Math.pow(2, 10 * (t1 - 1)) : 0;
        }), dT("Circ", function(t1) {
            return -(aw(1 - t1 * t1) - 1);
        }), dT("Sine", function(t1) {
            return 1 === t1 ? 1 : 1 - sw(t1 * nw);
        }), dT("Back", AT("in"), AT("out"), AT()), aT.SteppedEase = aT.steps = Ew.SteppedEase = {
            config: function(t1, e) {
                void 0 === t1 && (t1 = 1);
                var i = 1 / t1, n = t1 + (e ? 0 : 1), r = e ? 1 : 0;
                return function(t1) {
                    return ((n * Db(0, .99999999, t1) | 0) + r) * i;
                };
            }
        }, $x.ease = aT["quad.out"], Yw("onComplete,onUpdate,onStart,onRepeat,onReverseComplete,onInterrupt", function(t1) {
            return Qw += t1 + "," + t1 + "Params,";
        });
        var gT = function(t1, e) {
            this.id = rw++, t1._gsap = this, this.target = t1, this.harness = e, this.get = e ? e.get : Gw, this.set = e ? e.getSetter : _T;
        }, mT = function() {
            function t1(t1) {
                this.vars = t1, this._delay = +t1.delay || 0, (this._repeat = t1.repeat === 1 / 0 ? -2 : t1.repeat || 0) && (this._rDelay = t1.repeatDelay || 0, this._yoyo = !!t1.yoyo || !!t1.yoyoEase), this._ts = 1, bb(this, +t1.duration, 1, 1), this.data = t1.data, Rx && (this._ctx = Rx, Rx.data.push(this)), Gx || nT.wake();
            }
            var e = t1.prototype;
            return e.delay = function(t1) {
                return t1 || 0 === t1 ? (this.parent && this.parent.smoothChildTiming && this.startTime(this._start + t1 - this._delay), this._delay = t1, this) : this._delay;
            }, e.duration = function(t1) {
                return arguments.length ? this.totalDuration(this._repeat > 0 ? t1 + (t1 + this._rDelay) * this._repeat : t1) : this.totalDuration() && this._dur;
            }, e.totalDuration = function(t1) {
                return arguments.length ? (this._dirty = 0, bb(this, this._repeat < 0 ? t1 : (t1 - this._repeat * this._rDelay) / (this._repeat + 1))) : this._tDur;
            }, e.totalTime = function(t1, e) {
                if (rT(), !arguments.length) return this._tTime;
                var i = this._dp;
                if (i && i.smoothChildTiming && this._ts) {
                    for(gb(this, t1), !i._dp || i.parent || mb(i, this); i && i.parent;)i.parent._time !== i._start + (i._ts >= 0 ? i._tTime / i._ts : (i.totalDuration() - i._tTime) / -i._ts) && i.totalTime(i._tTime, !0), i = i.parent;
                    !this.parent && this._dp.autoRemoveChildren && (this._ts > 0 && t1 < this._tDur || this._ts < 0 && t1 > 0 || !this._tDur && !t1) && Mb(this._dp, this, this._start - this._delay);
                }
                return (this._tTime !== t1 || !this._dur && !e || this._initted && Math.abs(this._zTime) === ew || !t1 && !this._initted && (this.add || this._ptLookup)) && (this._ts || (this._pTime = t1), qw(this, t1, e)), this;
            }, e.time = function(t1, e) {
                return arguments.length ? this.totalTime(Math.min(this.totalDuration(), t1 + db(this)) % (this._dur + this._rDelay) || (t1 ? this._dur : 0), e) : this._time;
            }, e.totalProgress = function(t1, e) {
                return arguments.length ? this.totalTime(this.totalDuration() * t1, e) : this.totalDuration() ? Math.min(1, this._tTime / this._tDur) : this.rawTime() > 0 ? 1 : 0;
            }, e.progress = function(t1, e) {
                return arguments.length ? this.totalTime(this.duration() * (!this._yoyo || 1 & this.iteration() ? t1 : 1 - t1) + db(this), e) : this.duration() ? Math.min(1, this._time / this._dur) : this.rawTime() > 0 ? 1 : 0;
            }, e.iteration = function(t1, e) {
                var i = this.duration() + this._rDelay;
                return arguments.length ? this.totalTime(this._time + (t1 - 1) * i, e) : this._repeat ? pb(this._tTime, i) + 1 : 1;
            }, e.timeScale = function(t1, e) {
                if (!arguments.length) return -0.00000001 === this._rts ? 0 : this._rts;
                if (this._rts === t1) return this;
                var i = this.parent && this._ts ? fb(this.parent._time, this) : this._tTime;
                return this._rts = +t1 || 0, this._ts = this._ps || -0.00000001 === t1 ? 0 : this._rts, this.totalTime(Db(-Math.abs(this._delay), this._tDur, i), !1 !== e), Ab(this), function(t1) {
                    for(var e = t1.parent; e && e.parent;)e._dirty = 1, e.totalDuration(), e = e.parent;
                    return t1;
                }(this);
            }, e.paused = function(t1) {
                return arguments.length ? (this._ps !== t1 && (this._ps = t1, t1 ? (this._pTime = this._tTime || Math.max(-this._delay, this.rawTime()), this._ts = this._act = 0) : (rT(), this._ts = this._rts, this.totalTime(this.parent && !this.parent.smoothChildTiming ? this.rawTime() : this._tTime || this._pTime, 1 === this.progress() && Math.abs(this._zTime) !== ew && (this._tTime -= ew)))), this) : this._ps;
            }, e.startTime = function(t1) {
                if (arguments.length) {
                    this._start = t1;
                    var e = this.parent || this._dp;
                    return e && (e._sort || !this.parent) && Mb(e, this, t1 - this._delay), this;
                }
                return this._start;
            }, e.endTime = function(t1) {
                return this._start + (pw(t1) ? this.totalDuration() : this.duration()) / Math.abs(this._ts || 1);
            }, e.rawTime = function(t1) {
                var e = this.parent || this._dp;
                return e ? t1 && (!this._ts || this._repeat && this._time && this.totalProgress() < 1) ? this._tTime % (this._dur + this._rDelay) : this._ts ? fb(e.rawTime(t1), this) : this._tTime : this._tTime;
            }, e.revert = function(t1) {
                void 0 === t1 && (t1 = _w);
                var e = Px;
                return Px = t1, (this._initted || this._startAt) && (this.timeline && this.timeline.revert(t1), this.totalTime(-0.01, t1.suppressEvents)), "nested" !== this.data && !1 !== t1.kill && this.kill(), Px = e, this;
            }, e.globalTime = function(t1) {
                for(var e = this, i = arguments.length ? t1 : e.rawTime(); e;)i = e._start + i / (Math.abs(e._ts) || 1), e = e._dp;
                return !this.parent && this._sat ? this._sat.globalTime(t1) : i;
            }, e.repeat = function(t1) {
                return arguments.length ? (this._repeat = t1 === 1 / 0 ? -2 : t1, Tb(this)) : -2 === this._repeat ? 1 / 0 : this._repeat;
            }, e.repeatDelay = function(t1) {
                if (arguments.length) {
                    var e = this._time;
                    return this._rDelay = t1, Tb(this), e ? this.time(e) : this;
                }
                return this._rDelay;
            }, e.yoyo = function(t1) {
                return arguments.length ? (this._yoyo = t1, this) : this._yoyo;
            }, e.seek = function(t1, e) {
                return this.totalTime(Ib(this, t1), pw(e));
            }, e.restart = function(t1, e) {
                return this.play().totalTime(t1 ? -this._delay : 0, pw(e));
            }, e.play = function(t1, e) {
                return null != t1 && this.seek(t1, e), this.reversed(!1).paused(!1);
            }, e.reverse = function(t1, e) {
                return null != t1 && this.seek(t1 || this.totalDuration(), e), this.reversed(!0).paused(!1);
            }, e.pause = function(t1, e) {
                return null != t1 && this.seek(t1, e), this.paused(!0);
            }, e.resume = function() {
                return this.paused(!1);
            }, e.reversed = function(t1) {
                return arguments.length ? (!!t1 !== this.reversed() && this.timeScale(-this._rts || (t1 ? -0.00000001 : 0)), this) : this._rts < 0;
            }, e.invalidate = function() {
                return this._initted = this._act = 0, this._zTime = -0.00000001, this;
            }, e.isActive = function() {
                var t1, e = this.parent || this._dp, i = this._start;
                return !(e && !(this._ts && this._initted && e.isActive() && (t1 = e.rawTime(!0)) >= i && t1 < this.endTime(!0) - ew));
            }, e.eventCallback = function(t1, e, i) {
                var n = this.vars;
                return arguments.length > 1 ? (e ? (n[t1] = e, i && (n[t1 + "Params"] = i), "onUpdate" === t1 && (this._onUpdate = e)) : delete n[t1], this) : n[t1];
            }, e.then = function(t1) {
                var e = this;
                return new Promise(function(i) {
                    var n = cw(t1) ? t1 : tb, r = function() {
                        var t1 = e.then;
                        e.then = null, cw(n) && (n = n(e)) && (n.then || n === e) && (e.then = t1), i(n), e.then = t1;
                    };
                    e._initted && 1 === e.totalProgress() && e._ts >= 0 || !e._tTime && e._ts < 0 ? r() : e._prom = r;
                });
            }, e.kill = function() {
                Gb(this);
            }, t1;
        }();
        eb(mT.prototype, {
            _time: 0,
            _start: 0,
            _end: 0,
            _tTime: 0,
            _tDur: 0,
            _dirty: 0,
            _repeat: 0,
            _yoyo: !1,
            parent: null,
            _initted: !1,
            _rDelay: 0,
            _ts: 1,
            _dp: 0,
            ratio: 0,
            _zTime: -0.00000001,
            _prom: 0,
            _ps: !1,
            _rts: 1
        });
        var MT = function(t1) {
            function e(e, i) {
                var n;
                return void 0 === e && (e = {}), (n = t1.call(this, e) || this).labels = {}, n.smoothChildTiming = !!e.smoothChildTiming, n.autoRemoveChildren = !!e.autoRemoveChildren, n._sort = pw(e.sortChildren), Ux && Mb(e.parent || Ux, Ox(n), i), e.reversed && n.reverse(), e.paused && n.paused(!0), e.scrollTrigger && yb(Ox(n), e.scrollTrigger), n;
            }
            _x(e, t1);
            var i = e.prototype;
            return i.to = function(t1, e, i) {
                return Sb(0, arguments, this), this;
            }, i.from = function(t1, e, i) {
                return Sb(1, arguments, this), this;
            }, i.fromTo = function(t1, e, i, n) {
                return Sb(2, arguments, this), this;
            }, i.set = function(t1, e, i) {
                return e.duration = 0, e.parent = this, ab(e).repeatDelay || (e.repeat = 0), e.immediateRender = !!e.immediateRender, new DT(t1, e, Ib(this, i), 1), this;
            }, i.call = function(t1, e, i) {
                return Mb(this, DT.delayedCall(0, t1, e), i);
            }, i.staggerTo = function(t1, e, i, n, r, a, s) {
                return i.duration = e, i.stagger = i.stagger || n, i.onComplete = a, i.onCompleteParams = s, i.parent = this, new DT(t1, i, Ib(this, r)), this;
            }, i.staggerFrom = function(t1, e, i, n, r, a, s) {
                return i.runBackwards = 1, ab(i).immediateRender = pw(i.immediateRender), this.staggerTo(t1, e, i, n, r, a, s);
            }, i.staggerFromTo = function(t1, e, i, n, r, a, s, o) {
                return n.startAt = i, ab(n).immediateRender = pw(n.immediateRender), this.staggerTo(t1, e, n, r, a, s, o);
            }, i.render = function(t1, e, i) {
                var n, r, a, s, o, l, c, u, h, d, p, f, A = this._time, g = this._dirty ? this.totalDuration() : this._tDur, m = this._dur, M = t1 <= 0 ? 0 : Xw(t1), y = this._zTime < 0 != t1 < 0 && (this._initted || !m);
                if (this !== Ux && M > g && t1 >= 0 && (M = g), M !== this._tTime || i || y) {
                    if (A !== this._time && m && (M += this._time - A, t1 += this._time - A), n = M, h = this._start, l = !(u = this._ts), y && (m || (A = this._zTime), (t1 || !e) && (this._zTime = t1)), this._repeat) {
                        if (p = this._yoyo, o = m + this._rDelay, this._repeat < -1 && t1 < 0) return this.totalTime(100 * o + t1, e, i);
                        if (n = Xw(M % o), M === g ? (s = this._repeat, n = m) : ((s = ~~(M / o)) && s === M / o && (n = m, s--), n > m && (n = m)), d = pb(this._tTime, o), !A && this._tTime && d !== s && this._tTime - d * o - this._dur <= 0 && (d = s), p && 1 & s && (n = m - n, f = 1), s !== d && !this._lock) {
                            var v = p && 1 & d, x = v === (p && 1 & s);
                            if (s < d && (v = !v), A = v ? 0 : M % m ? m : M, this._lock = 1, this.render(A || (f ? 0 : Xw(s * o)), e, !m)._lock = 0, this._tTime = M, !e && this.parent && Vb(this, "onRepeat"), this.vars.repeatRefresh && !f && (this.invalidate()._lock = 1), A && A !== this._time || l !== !this._ts || this.vars.onRepeat && !this.parent && !this._act) return this;
                            if (m = this._dur, g = this._tDur, x && (this._lock = 2, A = v ? m : -0.0001, this.render(A, !0), this.vars.repeatRefresh && !f && this.invalidate()), this._lock = 0, !this._ts && !l) return this;
                            uT(this, f);
                        }
                    }
                    if (this._hasPause && !this._forcing && this._lock < 2 && (c = function(t1, e, i) {
                        var n;
                        if (i > e) for(n = t1._first; n && n._start <= i;){
                            if ("isPause" === n.data && n._start > e) return n;
                            n = n._next;
                        }
                        else for(n = t1._last; n && n._start >= i;){
                            if ("isPause" === n.data && n._start < e) return n;
                            n = n._prev;
                        }
                    }(this, Xw(A), Xw(n)), c && (M -= n - (n = c._start))), this._tTime = M, this._time = n, this._act = !u, this._initted || (this._onUpdate = this.vars.onUpdate, this._initted = 1, this._zTime = t1, A = 0), !A && n && !e && !s && (Vb(this, "onStart"), this._tTime !== M)) return this;
                    if (n >= A && t1 >= 0) for(r = this._first; r;){
                        if (a = r._next, (r._act || n >= r._start) && r._ts && c !== r) {
                            if (r.parent !== this) return this.render(t1, e, i);
                            if (r.render(r._ts > 0 ? (n - r._start) * r._ts : (r._dirty ? r.totalDuration() : r._tDur) + (n - r._start) * r._ts, e, i), n !== this._time || !this._ts && !l) {
                                c = 0, a && (M += this._zTime = -0.00000001);
                                break;
                            }
                        }
                        r = a;
                    }
                    else {
                        r = this._last;
                        for(var w = t1 < 0 ? t1 : n; r;){
                            if (a = r._prev, (r._act || w <= r._end) && r._ts && c !== r) {
                                if (r.parent !== this) return this.render(t1, e, i);
                                if (r.render(r._ts > 0 ? (w - r._start) * r._ts : (r._dirty ? r.totalDuration() : r._tDur) + (w - r._start) * r._ts, e, i || Px && (r._initted || r._startAt)), n !== this._time || !this._ts && !l) {
                                    c = 0, a && (M += this._zTime = w ? -0.00000001 : ew);
                                    break;
                                }
                            }
                            r = a;
                        }
                    }
                    if (c && !e && (this.pause(), c.render(n >= A ? 0 : -0.00000001)._zTime = n >= A ? 1 : -1, this._ts)) return this._start = h, Ab(this), this.render(t1, e, i);
                    this._onUpdate && !e && Vb(this, "onUpdate", !0), (M === g && this._tTime >= this.totalDuration() || !M && A) && (h !== this._start && Math.abs(u) === Math.abs(this._ts) || this._lock || ((t1 || !m) && (M === g && this._ts > 0 || !M && this._ts < 0) && lb(this, 1), e || t1 < 0 && !A || !M && !A && g || (Vb(this, M === g && t1 >= 0 ? "onComplete" : "onReverseComplete", !0), this._prom && !(M < g && this.timeScale() > 0) && this._prom())));
                }
                return this;
            }, i.add = function(t1, e) {
                var i = this;
                if (uw(e) || (e = Ib(this, e, t1)), !(t1 instanceof mT)) {
                    if (mw(t1)) return t1.forEach(function(t1) {
                        return i.add(t1, e);
                    }), this;
                    if (lw(t1)) return this.addLabel(t1, e);
                    if (!cw(t1)) return this;
                    t1 = DT.delayedCall(0, t1);
                }
                return this !== t1 ? Mb(this, t1, e) : this;
            }, i.getChildren = function(t1, e, i, n) {
                void 0 === t1 && (t1 = !0), void 0 === e && (e = !0), void 0 === i && (i = !0), void 0 === n && (n = -tw);
                for(var r = [], a = this._first; a;)a._start >= n && (a instanceof DT ? e && r.push(a) : (i && r.push(a), t1 && r.push.apply(r, a.getChildren(!0, e, i)))), a = a._next;
                return r;
            }, i.getById = function(t1) {
                for(var e = this.getChildren(1, 1, 1), i = e.length; i--;)if (e[i].vars.id === t1) return e[i];
            }, i.remove = function(t1) {
                return lw(t1) ? this.removeLabel(t1) : cw(t1) ? this.killTweensOf(t1) : (ob(this, t1), t1 === this._recent && (this._recent = this._last), cb(this));
            }, i.totalTime = function(e, i) {
                return arguments.length ? (this._forcing = 1, !this._dp && this._ts && (this._start = Xw(nT.time - (this._ts > 0 ? e / this._ts : (this.totalDuration() - e) / -this._ts))), t1.prototype.totalTime.call(this, e, i), this._forcing = 0, this) : this._tTime;
            }, i.addLabel = function(t1, e) {
                return this.labels[t1] = Ib(this, e), this;
            }, i.removeLabel = function(t1) {
                return delete this.labels[t1], this;
            }, i.addPause = function(t1, e, i) {
                var n = DT.delayedCall(0, e || zw, i);
                return n.data = "isPause", this._hasPause = 1, Mb(this, n, Ib(this, t1));
            }, i.removePause = function(t1) {
                var e = this._first;
                for(t1 = Ib(this, t1); e;)e._start === t1 && "isPause" === e.data && lb(e), e = e._next;
            }, i.killTweensOf = function(t1, e, i) {
                for(var n = this.getTweensOf(t1, i), r = n.length; r--;)yT !== n[r] && n[r].kill(t1, e);
                return this;
            }, i.getTweensOf = function(t1, e) {
                for(var i, n = [], r = Ob(t1), a = this._first, s = uw(e); a;)a instanceof DT ? Jw(a._targets, r) && (s ? (!yT || a._initted && a._ts) && a.globalTime(0) <= e && a.globalTime(a.totalDuration()) > e : !e || a.isActive()) && n.push(a) : (i = a.getTweensOf(r, e)).length && n.push.apply(n, i), a = a._next;
                return n;
            }, i.tweenTo = function(t1, e) {
                e = e || {};
                var i, n = this, r = Ib(n, t1), a = e, s = a.startAt, o = a.onStart, l = a.onStartParams, c = a.immediateRender, u = DT.to(n, eb({
                    ease: e.ease || "none",
                    lazy: !1,
                    immediateRender: !1,
                    time: r,
                    overwrite: "auto",
                    duration: e.duration || Math.abs((r - (s && "time" in s ? s.time : n._time)) / n.timeScale()) || ew,
                    onStart: function() {
                        if (n.pause(), !i) {
                            var t1 = e.duration || Math.abs((r - (s && "time" in s ? s.time : n._time)) / n.timeScale());
                            u._dur !== t1 && bb(u, t1, 0, 1).render(u._time, !0, !0), i = 1;
                        }
                        o && o.apply(u, l || []);
                    }
                }, e));
                return c ? u.render(0) : u;
            }, i.tweenFromTo = function(t1, e, i) {
                return this.tweenTo(e, eb({
                    startAt: {
                        time: Ib(this, t1)
                    }
                }, i));
            }, i.recent = function() {
                return this._recent;
            }, i.nextLabel = function(t1) {
                return void 0 === t1 && (t1 = this._time), Hb(this, Ib(this, t1));
            }, i.previousLabel = function(t1) {
                return void 0 === t1 && (t1 = this._time), Hb(this, Ib(this, t1), 1);
            }, i.currentLabel = function(t1) {
                return arguments.length ? this.seek(t1, !0) : this.previousLabel(this._time + ew);
            }, i.shiftChildren = function(t1, e, i) {
                void 0 === i && (i = 0);
                for(var n, r = this._first, a = this.labels; r;)r._start >= i && (r._start += t1, r._end += t1), r = r._next;
                if (e) for(n in a)a[n] >= i && (a[n] += t1);
                return cb(this);
            }, i.invalidate = function(e) {
                var i = this._first;
                for(this._lock = 0; i;)i.invalidate(e), i = i._next;
                return t1.prototype.invalidate.call(this, e);
            }, i.clear = function(t1) {
                void 0 === t1 && (t1 = !0);
                for(var e, i = this._first; i;)e = i._next, this.remove(i), i = e;
                return this._dp && (this._time = this._tTime = this._pTime = 0), t1 && (this.labels = {}), cb(this);
            }, i.totalDuration = function(t1) {
                var e, i, n, r = 0, a = this, s = a._last, o = tw;
                if (arguments.length) return a.timeScale((a._repeat < 0 ? a.duration() : a.totalDuration()) / (a.reversed() ? -t1 : t1));
                if (a._dirty) {
                    for(n = a.parent; s;)e = s._prev, s._dirty && s.totalDuration(), (i = s._start) > o && a._sort && s._ts && !a._lock ? (a._lock = 1, Mb(a, s, i - s._delay, 1)._lock = 0) : o = i, i < 0 && s._ts && (r -= i, (!n && !a._dp || n && n.smoothChildTiming) && (a._start += i / a._ts, a._time -= i, a._tTime -= i), a.shiftChildren(-i, !1, -Infinity), o = 0), s._end > r && s._ts && (r = s._end), s = e;
                    bb(a, a === Ux && a._time > r ? a._time : r, 1, 1), a._dirty = 0;
                }
                return a._tDur;
            }, e.updateRoot = function(t1) {
                if (Ux._ts && (qw(Ux, fb(t1, Ux)), Hx = nT.frame), nT.frame >= Bw) {
                    Bw += qx.autoSleep || 120;
                    var e = Ux._first;
                    if ((!e || !e._ts) && qx.autoSleep && nT._listeners.length < 2) {
                        for(; e && !e._ts;)e = e._next;
                        e || nT.sleep();
                    }
                }
            }, e;
        }(mT);
        eb(MT.prototype, {
            _lock: 0,
            _hasPause: 0,
            _forcing: 0
        });
        var yT, vT, xT = function(t1, e, i, n, r, a, s) {
            var o, l, c, u, h, d, p, f, A = new HT(this._pt, t1, e, 0, 1, RT, null, r), g = 0, m = 0;
            for(A.b = i, A.e = n, i += "", (p = ~(n += "").indexOf("random(")) && (n = Fb(n)), a && (a(f = [
                i,
                n
            ], t1, e), i = f[0], n = f[1]), l = i.match(xw) || []; o = xw.exec(n);)u = o[0], h = n.substring(g, o.index), c ? c = (c + 1) % 5 : "rgba(" === h.substr(-5) && (c = 1), u !== l[m++] && (d = parseFloat(l[m - 1]) || 0, A._pt = {
                _next: A._pt,
                p: h || 1 === m ? h : ",",
                s: d,
                c: "=" === u.charAt(1) ? Zw(d, u) - d : parseFloat(u) - d,
                m: c && c < 4 ? Math.round : 0
            }, g = xw.lastIndex);
            return A.c = g < n.length ? n.substring(g, n.length) : "", A.fp = s, (ww.test(n) || p) && (A.e = 0), this._pt = A, A;
        }, wT = function(t1, e, i, n, r, a, s, o, l, c) {
            cw(n) && (n = n(r || 0, t1, a));
            var u, h = t1[e], d = "get" !== i ? i : cw(h) ? l ? t1[e.indexOf("set") || !cw(t1["get" + e.substr(3)]) ? e : "get" + e.substr(3)](l) : t1[e]() : h, p = cw(h) ? l ? LT : zT : CT;
            if (lw(n) && (~n.indexOf("random(") && (n = Fb(n)), "=" === n.charAt(1) && ((u = Zw(d, n) + (Cb(d) || 0)) || 0 === u) && (n = u)), !c || d !== n || vT) return isNaN(d * n) || "" === n ? (!h && !(e in t1) && Nw(e, n), xT.call(this, t1, e, d, n, p, o || qx.stringFilter, l)) : (u = new HT(this._pt, t1, e, +d || 0, n - (d || 0), "boolean" == typeof h ? PT : jT, 0, p), l && (u.fp = l), s && u.modifier(s, this, t1), this._pt = u);
        }, bT = function(t1, e, i, n, r, a) {
            var s, o, l, c;
            if (Uw[t1] && !1 !== (s = new Uw[t1]).init(r, s.rawVars ? e[t1] : function(t1, e, i, n, r) {
                if (cw(t1) && (t1 = IT(t1, r, e, i, n)), !dw(t1) || t1.style && t1.nodeType || mw(t1) || gw(t1)) return lw(t1) ? IT(t1, r, e, i, n) : t1;
                var a, s = {};
                for(a in t1)s[a] = IT(t1[a], r, e, i, n);
                return s;
            }(e[t1], n, r, a, i), i, n, a) && (i._pt = o = new HT(i._pt, r, t1, 0, 1, s.render, s, 0, s.priority), i !== Vx)) for(l = i._ptLookup[i._targets.indexOf(r)], c = s._props.length; c--;)l[s._props[c]] = o;
            return s;
        }, TT = function t1(e, i, n) {
            var r, a, s, o, l, c, u, h, d, p, f, A, g, m = e.vars, M = m.ease, y = m.startAt, v = m.immediateRender, x = m.lazy, w = m.onUpdate, b = m.runBackwards, T = m.yoyoEase, E = m.keyframes, I = m.autoRevert, S = e._dur, N = e._startAt, D = e._targets, C = e.parent, z = C && "nested" === C.data ? C.vars.targets : D, L = "auto" === e._overwrite && !jx, O = e.timeline;
            if (O && (!E || !M) && (M = "none"), e._ease = hT(M, $x.ease), e._yEase = T ? cT(hT(!0 === T ? M : T, $x.ease)) : 0, T && e._yoyo && !e._repeat && (T = e._yEase, e._yEase = e._ease, e._ease = T), e._from = !O && !!m.runBackwards, !O || E && !m.stagger) {
                if (A = (h = D[0] ? Vw(D[0]).harness : 0) && m[h.prop], r = rb(m, jw), N && (N._zTime < 0 && N.progress(1), i < 0 && b && v && !I ? N.render(-1, !0) : N.revert(b && S ? Ow : Lw), N._lazy = 0), y) {
                    if (lb(e._startAt = DT.set(D, eb({
                        data: "isStart",
                        overwrite: !1,
                        parent: C,
                        immediateRender: !0,
                        lazy: !N && pw(x),
                        startAt: null,
                        delay: 0,
                        onUpdate: w && function() {
                            return Vb(e, "onUpdate");
                        },
                        stagger: 0
                    }, y))), e._startAt._dp = 0, e._startAt._sat = e, i < 0 && (Px || !v && !I) && e._startAt.revert(Ow), v && S && i <= 0 && n <= 0) return void (i && (e._zTime = i));
                } else if (b && S && !N) {
                    if (i && (v = !1), s = eb({
                        overwrite: !1,
                        data: "isFromStart",
                        lazy: v && !N && pw(x),
                        immediateRender: v,
                        stagger: 0,
                        parent: C
                    }, r), A && (s[h.prop] = A), lb(e._startAt = DT.set(D, s)), e._startAt._dp = 0, e._startAt._sat = e, i < 0 && (Px ? e._startAt.revert(Ow) : e._startAt.render(-1, !0)), e._zTime = i, v) {
                        if (!i) return;
                    } else t1(e._startAt, ew, ew);
                }
                for(e._pt = e._ptCache = 0, x = S && pw(x) || x && !S, a = 0; a < D.length; a++){
                    if (u = (l = D[a])._gsap || Hw(D)[a]._gsap, e._ptLookup[a] = p = {}, Rw[u.id] && Pw.length && Kw(), f = z === D ? a : z.indexOf(l), h && !1 !== (d = new h).init(l, A || r, e, f, z) && (e._pt = o = new HT(e._pt, l, d.name, 0, 1, d.render, d, 0, d.priority), d._props.forEach(function(t1) {
                        p[t1] = o;
                    }), d.priority && (c = 1)), !h || A) for(s in r)Uw[s] && (d = bT(s, r, e, f, l, z)) ? d.priority && (c = 1) : p[s] = o = wT.call(e, l, s, "get", r[s], f, z, 0, m.stringFilter);
                    e._op && e._op[a] && e.kill(l, e._op[a]), L && e._pt && (yT = e, Ux.killTweensOf(l, p, e.globalTime(i)), g = !e.parent, yT = 0), e._pt && x && (Rw[u.id] = 1);
                }
                c && QT(e), e._onInit && e._onInit(e);
            }
            e._onUpdate = w, e._initted = (!e._op || e._pt) && !g, E && i <= 0 && O.render(tw, !0, !0);
        }, ET = function(t1, e, i, n) {
            var r, a, s = e.ease || n || "power1.inOut";
            if (mw(e)) a = i[t1] || (i[t1] = []), e.forEach(function(t1, i) {
                return a.push({
                    t: i / (e.length - 1) * 100,
                    v: t1,
                    e: s
                });
            });
            else for(r in e)a = i[r] || (i[r] = []), "ease" === r || a.push({
                t: parseFloat(t1),
                v: e[r],
                e: s
            });
        }, IT = function(t1, e, i, n, r) {
            return cw(t1) ? t1.call(e, i, n, r) : lw(t1) && ~t1.indexOf("random(") ? Fb(t1) : t1;
        }, ST = Qw + "repeat,repeatDelay,yoyo,repeatRefresh,yoyoEase,autoRevert", NT = {};
        Yw(ST + ",id,stagger,delay,duration,paused,scrollTrigger", function(t1) {
            return NT[t1] = 1;
        });
        var DT = function(t1) {
            function e(e, i, n, r) {
                var a;
                "number" == typeof i && (n.duration = i, i = n, n = null);
                var s, o, l, c, u, h, d, p, f = (a = t1.call(this, r ? i : ab(i)) || this).vars, A = f.duration, g = f.delay, m = f.immediateRender, M = f.stagger, y = f.overwrite, v = f.keyframes, x = f.defaults, w = f.scrollTrigger, b = f.yoyoEase, T = i.parent || Ux, E = (mw(e) || gw(e) ? uw(e[0]) : "length" in i) ? [
                    e
                ] : Ob(e);
                if (a._targets = E.length ? Hw(E) : Dw("GSAP target " + e + " not found. https://gsap.com", !qx.nullTargetWarn) || [], a._ptLookup = [], a._overwrite = y, v || M || Aw(A) || Aw(g)) {
                    if (i = a.vars, (s = a.timeline = new MT({
                        data: "nested",
                        defaults: x || {},
                        targets: T && "nested" === T.data ? T.vars.targets : E
                    })).kill(), s.parent = s._dp = Ox(a), s._start = 0, M || Aw(A) || Aw(g)) {
                        if (c = E.length, d = M && Pb(M), dw(M)) for(u in M)~ST.indexOf(u) && (p || (p = {}), p[u] = M[u]);
                        for(o = 0; o < c; o++)(l = rb(i, NT)).stagger = 0, b && (l.yoyoEase = b), p && ib(l, p), h = E[o], l.duration = +IT(A, Ox(a), o, h, E), l.delay = (+IT(g, Ox(a), o, h, E) || 0) - a._delay, !M && 1 === c && l.delay && (a._delay = g = l.delay, a._start += g, l.delay = 0), s.to(h, l, d ? d(o, h, E) : 0), s._ease = aT.none;
                        s.duration() ? A = g = 0 : a.timeline = 0;
                    } else if (v) {
                        ab(eb(s.vars.defaults, {
                            ease: "none"
                        })), s._ease = hT(v.ease || i.ease || "none");
                        var I, S, N, D = 0;
                        if (mw(v)) v.forEach(function(t1) {
                            return s.to(E, t1, ">");
                        }), s.duration();
                        else {
                            for(u in l = {}, v)"ease" === u || "easeEach" === u || ET(u, v[u], l, v.easeEach);
                            for(u in l)for(I = l[u].sort(function(t1, e) {
                                return t1.t - e.t;
                            }), D = 0, o = 0; o < I.length; o++)(N = {
                                ease: (S = I[o]).e,
                                duration: (S.t - (o ? I[o - 1].t : 0)) / 100 * A
                            })[u] = S.v, s.to(E, N, D), D += N.duration;
                            s.duration() < A && s.to({}, {
                                duration: A - s.duration()
                            });
                        }
                    }
                    A || a.duration(A = s.duration());
                } else a.timeline = 0;
                return !0 !== y || jx || (yT = Ox(a), Ux.killTweensOf(E), yT = 0), Mb(T, Ox(a), n), i.reversed && a.reverse(), i.paused && a.paused(!0), (m || !A && !v && a._start === Xw(T._time) && pw(m) && hb(Ox(a)) && "nested" !== T.data) && (a._tTime = -0.00000001, a.render(Math.max(0, -g) || 0)), w && yb(Ox(a), w), a;
            }
            _x(e, t1);
            var i = e.prototype;
            return i.render = function(t1, e, i) {
                var n, r, a, s, o, l, c, u, h, d = this._time, p = this._tDur, f = this._dur, A = t1 < 0, g = t1 > p - ew && !A ? p : t1 < ew ? 0 : t1;
                if (f) {
                    if (g !== this._tTime || !t1 || i || !this._initted && this._tTime || this._startAt && this._zTime < 0 !== A) {
                        if (n = g, u = this.timeline, this._repeat) {
                            if (s = f + this._rDelay, this._repeat < -1 && A) return this.totalTime(100 * s + t1, e, i);
                            if (n = Xw(g % s), g === p ? (a = this._repeat, n = f) : ((a = ~~(g / s)) && a === Xw(g / s) && (n = f, a--), n > f && (n = f)), (l = this._yoyo && 1 & a) && (h = this._yEase, n = f - n), o = pb(this._tTime, s), n === d && !i && this._initted && a === o) return this._tTime = g, this;
                            a !== o && (u && this._yEase && uT(u, l), this.vars.repeatRefresh && !l && !this._lock && this._time !== s && this._initted && (this._lock = i = 1, this.render(Xw(s * a), !0).invalidate()._lock = 0));
                        }
                        if (!this._initted) {
                            if (vb(this, A ? t1 : n, i, e, g)) return this._tTime = 0, this;
                            if (!(d === this._time || i && this.vars.repeatRefresh && a !== o)) return this;
                            if (f !== this._dur) return this.render(t1, e, i);
                        }
                        if (this._tTime = g, this._time = n, !this._act && this._ts && (this._act = 1, this._lazy = 0), this.ratio = c = (h || this._ease)(n / f), this._from && (this.ratio = c = 1 - c), n && !d && !e && !a && (Vb(this, "onStart"), this._tTime !== g)) return this;
                        for(r = this._pt; r;)r.r(c, r.d), r = r._next;
                        u && u.render(t1 < 0 ? t1 : u._dur * u._ease(n / this._dur), e, i) || this._startAt && (this._zTime = t1), this._onUpdate && !e && (A && ub(this, t1, 0, i), Vb(this, "onUpdate")), this._repeat && a !== o && this.vars.onRepeat && !e && this.parent && Vb(this, "onRepeat"), g !== this._tDur && g || this._tTime !== g || (A && !this._onUpdate && ub(this, t1, 0, !0), (t1 || !f) && (g === this._tDur && this._ts > 0 || !g && this._ts < 0) && lb(this, 1), e || A && !d || !(g || d || l) || (Vb(this, g === p ? "onComplete" : "onReverseComplete", !0), this._prom && !(g < p && this.timeScale() > 0) && this._prom()));
                    }
                } else !function(t1, e, i, n) {
                    var r, a, s, o = t1.ratio, l = e < 0 || !e && (!t1._start && xb(t1) && (t1._initted || !wb(t1)) || (t1._ts < 0 || t1._dp._ts < 0) && !wb(t1)) ? 0 : 1, c = t1._rDelay, u = 0;
                    if (c && t1._repeat && (u = Db(0, t1._tDur, e), a = pb(u, c), t1._yoyo && 1 & a && (l = 1 - l), a !== pb(t1._tTime, c) && (o = 1 - l, t1.vars.repeatRefresh && t1._initted && t1.invalidate())), l !== o || Px || n || t1._zTime === ew || !e && t1._zTime) {
                        if (!t1._initted && vb(t1, e, n, i, u)) return;
                        for(s = t1._zTime, t1._zTime = e || (i ? ew : 0), i || (i = e && !s), t1.ratio = l, t1._from && (l = 1 - l), t1._time = 0, t1._tTime = u, r = t1._pt; r;)r.r(l, r.d), r = r._next;
                        e < 0 && ub(t1, e, 0, !0), t1._onUpdate && !i && Vb(t1, "onUpdate"), u && t1._repeat && !i && t1.parent && Vb(t1, "onRepeat"), (e >= t1._tDur || e < 0) && t1.ratio === l && (l && lb(t1, 1), i || Px || (Vb(t1, l ? "onComplete" : "onReverseComplete", !0), t1._prom && t1._prom()));
                    } else t1._zTime || (t1._zTime = e);
                }(this, t1, e, i);
                return this;
            }, i.targets = function() {
                return this._targets;
            }, i.invalidate = function(e) {
                return (!e || !this.vars.runBackwards) && (this._startAt = 0), this._pt = this._op = this._onUpdate = this._lazy = this.ratio = 0, this._ptLookup = [], this.timeline && this.timeline.invalidate(e), t1.prototype.invalidate.call(this, e);
            }, i.resetTo = function(t1, e, i, n, r) {
                Gx || nT.wake(), this._ts || this.play();
                var a = Math.min(this._dur, (this._dp._time - this._start) * this._ts);
                return this._initted || TT(this, a), function(t1, e, i, n, r, a, s, o) {
                    var l, c, u, h, d = (t1._pt && t1._ptCache || (t1._ptCache = {}))[e];
                    if (!d) for(d = t1._ptCache[e] = [], u = t1._ptLookup, h = t1._targets.length; h--;){
                        if ((l = u[h][e]) && l.d && l.d._pt) for(l = l.d._pt; l && l.p !== e && l.fp !== e;)l = l._next;
                        if (!l) return vT = 1, t1.vars[e] = "+=0", TT(t1, s), vT = 0, o ? Dw(e + " not eligible for reset") : 1;
                        d.push(l);
                    }
                    for(h = d.length; h--;)(l = (c = d[h])._pt || c).s = !n && 0 !== n || r ? l.s + (n || 0) + a * l.c : n, l.c = i - l.s, c.e && (c.e = Ww(i) + Cb(c.e)), c.b && (c.b = l.s + Cb(c.b));
                }(this, t1, e, i, n, this._ease(a / this._dur), a, r) ? this.resetTo(t1, e, i, n, 1) : (gb(this, 0), this.parent || sb(this._dp, this, "_first", "_last", this._dp._sort ? "_start" : 0), this.render(0));
            }, i.kill = function(t1, e) {
                if (void 0 === e && (e = "all"), !(t1 || e && "all" !== e)) return this._lazy = this._pt = 0, this.parent ? Gb(this) : this;
                if (this.timeline) {
                    var i = this.timeline.totalDuration();
                    return this.timeline.killTweensOf(t1, e, yT && !0 !== yT.vars.overwrite)._first || Gb(this), this.parent && i !== this.timeline.totalDuration() && bb(this, this._dur * this.timeline._tDur / i, 0, 1), this;
                }
                var n, r, a, s, o, l, c, u = this._targets, h = t1 ? Ob(t1) : u, d = this._ptLookup, p = this._pt;
                if ((!e || "all" === e) && function(t1, e) {
                    for(var i = t1.length, n = i === e.length; n && i-- && t1[i] === e[i];);
                    return i < 0;
                }(u, h)) return "all" === e && (this._pt = 0), Gb(this);
                for(n = this._op = this._op || [], "all" !== e && (lw(e) && (o = {}, Yw(e, function(t1) {
                    return o[t1] = 1;
                }), e = o), e = function(t1, e) {
                    var i, n, r, a, s = t1[0] ? Vw(t1[0]).harness : 0, o = s && s.aliases;
                    if (!o) return e;
                    for(n in i = ib({}, e), o)if ((n in i)) for(r = (a = o[n].split(",")).length; r--;)i[a[r]] = i[n];
                    return i;
                }(u, e)), c = u.length; c--;)if (~h.indexOf(u[c])) for(o in r = d[c], "all" === e ? (n[c] = e, s = r, a = {}) : (a = n[c] = n[c] || {}, s = e), s)(l = r && r[o]) && ("kill" in l.d && !0 !== l.d.kill(o) || ob(this, l, "_pt"), delete r[o]), "all" !== a && (a[o] = 1);
                return this._initted && !this._pt && p && Gb(this), this;
            }, e.to = function(t1, i) {
                return new e(t1, i, arguments[2]);
            }, e.from = function(t1, e) {
                return Sb(1, arguments);
            }, e.delayedCall = function(t1, i, n, r) {
                return new e(i, 0, {
                    immediateRender: !1,
                    lazy: !1,
                    overwrite: !1,
                    delay: t1,
                    onComplete: i,
                    onReverseComplete: i,
                    onCompleteParams: n,
                    onReverseCompleteParams: n,
                    callbackScope: r
                });
            }, e.fromTo = function(t1, e, i) {
                return Sb(2, arguments);
            }, e.set = function(t1, i) {
                return i.duration = 0, i.repeatDelay || (i.repeat = 0), new e(t1, i);
            }, e.killTweensOf = function(t1, e, i) {
                return Ux.killTweensOf(t1, e, i);
            }, e;
        }(mT);
        eb(DT.prototype, {
            _targets: [],
            _lazy: 0,
            _startAt: 0,
            _op: 0,
            _onInit: 0
        }), Yw("staggerTo,staggerFrom,staggerFromTo", function(t1) {
            DT[t1] = function() {
                var e = new MT, i = zb.call(arguments, 0);
                return i.splice("staggerFromTo" === t1 ? 5 : 4, 0, 0), e[t1].apply(e, i);
            };
        });
        var CT = function(t1, e, i) {
            return t1[e] = i;
        }, zT = function(t1, e, i) {
            return t1[e](i);
        }, LT = function(t1, e, i, n) {
            return t1[e](n.fp, i);
        }, OT = function(t1, e, i) {
            return t1.setAttribute(e, i);
        }, _T = function(t1, e) {
            return cw(t1[e]) ? zT : hw(t1[e]) && t1.setAttribute ? OT : CT;
        }, jT = function(t1, e) {
            return e.set(e.t, e.p, Math.round(1e6 * (e.s + e.c * t1)) / 1e6, e);
        }, PT = function(t1, e) {
            return e.set(e.t, e.p, !!(e.s + e.c * t1), e);
        }, RT = function(t1, e) {
            var i = e._pt, n = "";
            if (!t1 && e.b) n = e.b;
            else if (1 === t1 && e.e) n = e.e;
            else {
                for(; i;)n = i.p + (i.m ? i.m(i.s + i.c * t1) : Math.round(1e4 * (i.s + i.c * t1)) / 1e4) + n, i = i._next;
                n += e.c;
            }
            e.set(e.t, e.p, n, e);
        }, UT = function(t1, e) {
            for(var i = e._pt; i;)i.r(t1, i.d), i = i._next;
        }, kT = function(t1, e, i, n) {
            for(var r, a = this._pt; a;)r = a._next, a.p === n && a.modifier(t1, e, i), a = r;
        }, BT = function(t1) {
            for(var e, i, n = this._pt; n;)i = n._next, n.p === t1 && !n.op || n.op === t1 ? ob(this, n, "_pt") : n.dep || (e = 1), n = i;
            return !e;
        }, FT = function(t1, e, i, n) {
            n.mSet(t1, e, n.m.call(n.tween, i, n.mt), n);
        }, QT = function(t1) {
            for(var e, i, n, r, a = t1._pt; a;){
                for(e = a._next, i = n; i && i.pr > a.pr;)i = i._next;
                (a._prev = i ? i._prev : r) ? a._prev._next = a : n = a, (a._next = i) ? i._prev = a : r = a, a = e;
            }
            t1._pt = n;
        }, HT = function() {
            function t1(t1, e, i, n, r, a, s, o, l) {
                this.t = e, this.s = n, this.c = r, this.p = i, this.r = a || jT, this.d = s || this, this.set = o || CT, this.pr = l || 0, this._next = t1, t1 && (t1._prev = this);
            }
            return t1.prototype.modifier = function(t1, e, i) {
                this.mSet = this.mSet || this.set, this.set = FT, this.m = t1, this.mt = i, this.tween = e;
            }, t1;
        }();
        Yw(Qw + "parent,duration,ease,delay,overwrite,runBackwards,startAt,yoyo,immediateRender,repeat,repeatDelay,data,paused,reversed,lazy,callbackScope,stringFilter,id,yoyoEase,stagger,inherit,repeatRefresh,keyframes,autoRevert,scrollTrigger", function(t1) {
            return jw[t1] = 1;
        }), Ew.TweenMax = Ew.TweenLite = DT, Ew.TimelineLite = Ew.TimelineMax = MT, Ux = new MT({
            sortChildren: !1,
            defaults: $x,
            autoRemoveChildren: !0,
            id: "root",
            smoothChildTiming: !0
        }), qx.stringFilter = iT;
        var VT = [], GT = {}, YT = [], WT = 0, XT = 0, ZT = function(t1) {
            return (GT[t1] || YT).map(function(t1) {
                return t1();
            });
        }, JT = function() {
            var t1 = Date.now(), e = [];
            t1 - WT > 2 && (ZT("matchMediaInit"), VT.forEach(function(t1) {
                var i, n, r, a, s = t1.queries, o = t1.conditions;
                for(n in s)(i = kx.matchMedia(s[n]).matches) && (r = 1), i !== o[n] && (o[n] = i, a = 1);
                a && (t1.revert(), r && e.push(t1));
            }), ZT("matchMediaRevert"), e.forEach(function(t1) {
                return t1.onMatch(t1, function(e) {
                    return t1.add(null, e);
                });
            }), WT = t1, ZT("matchMedia"));
        }, KT = function() {
            function t1(t1, e) {
                this.selector = e && _b(e), this.data = [], this._r = [], this.isReverted = !1, this.id = XT++, t1 && this.add(t1);
            }
            var e = t1.prototype;
            return e.add = function(t1, e, i) {
                cw(t1) && (i = e, e = t1, t1 = cw);
                var n = this, r = function() {
                    var t1, r = Rx, a = n.selector;
                    return r && r !== n && r.data.push(n), i && (n.selector = _b(i)), Rx = n, t1 = e.apply(n, arguments), cw(t1) && n._r.push(t1), Rx = r, n.selector = a, n.isReverted = !1, t1;
                };
                return n.last = r, t1 === cw ? r(n, function(t1) {
                    return n.add(null, t1);
                }) : t1 ? n[t1] = r : r;
            }, e.ignore = function(t1) {
                var e = Rx;
                Rx = null, t1(this), Rx = e;
            }, e.getTweens = function() {
                var e = [];
                return this.data.forEach(function(i) {
                    return i instanceof t1 ? e.push.apply(e, i.getTweens()) : i instanceof DT && !(i.parent && "nested" === i.parent.data) && e.push(i);
                }), e;
            }, e.clear = function() {
                this._r.length = this.data.length = 0;
            }, e.kill = function(t1, e) {
                var i = this;
                if (t1 ? function() {
                    for(var e, n = i.getTweens(), r = i.data.length; r--;)"isFlip" === (e = i.data[r]).data && (e.revert(), e.getChildren(!0, !0, !1).forEach(function(t1) {
                        return n.splice(n.indexOf(t1), 1);
                    }));
                    for(n.map(function(t1) {
                        return {
                            g: t1._dur || t1._delay || t1._sat && !t1._sat.vars.immediateRender ? t1.globalTime(0) : -1 / 0,
                            t: t1
                        };
                    }).sort(function(t1, e) {
                        return e.g - t1.g || -1 / 0;
                    }).forEach(function(e) {
                        return e.t.revert(t1);
                    }), r = i.data.length; r--;)(e = i.data[r]) instanceof MT ? "nested" !== e.data && (e.scrollTrigger && e.scrollTrigger.revert(), e.kill()) : !(e instanceof DT) && e.revert && e.revert(t1);
                    i._r.forEach(function(e) {
                        return e(t1, i);
                    }), i.isReverted = !0;
                }() : this.data.forEach(function(t1) {
                    return t1.kill && t1.kill();
                }), this.clear(), e) for(var n = VT.length; n--;)VT[n].id === this.id && VT.splice(n, 1);
            }, e.revert = function(t1) {
                this.kill(t1 || {});
            }, t1;
        }(), qT = function() {
            function t1(t1) {
                this.contexts = [], this.scope = t1, Rx && Rx.data.push(this);
            }
            var e = t1.prototype;
            return e.add = function(t1, e, i) {
                dw(t1) || (t1 = {
                    matches: t1
                });
                var n, r, a, s = new KT(0, i || this.scope), o = s.conditions = {};
                for(r in Rx && !s.selector && (s.selector = Rx.selector), this.contexts.push(s), e = s.add("onMatch", e), s.queries = t1, t1)"all" === r ? a = 1 : (n = kx.matchMedia(t1[r])) && (VT.indexOf(s) < 0 && VT.push(s), (o[r] = n.matches) && (a = 1), n.addListener ? n.addListener(JT) : n.addEventListener("change", JT));
                return a && e(s, function(t1) {
                    return s.add(null, t1);
                }), this;
            }, e.revert = function(t1) {
                this.kill(t1 || {});
            }, e.kill = function(t1) {
                this.contexts.forEach(function(e) {
                    return e.kill(t1, !0);
                });
            }, t1;
        }(), $T = {
            registerPlugin: function() {
                for(var t1 = arguments.length, e = new Array(t1), i = 0; i < t1; i++)e[i] = arguments[i];
                e.forEach(function(t1) {
                    return Wb(t1);
                });
            },
            timeline: function(t1) {
                return new MT(t1);
            },
            getTweensOf: function(t1, e) {
                return Ux.getTweensOf(t1, e);
            },
            getProperty: function(t1, e, i, n) {
                lw(t1) && (t1 = Ob(t1)[0]);
                var r = Vw(t1 || {}).get, a = i ? tb : $w;
                return "native" === i && (i = ""), t1 ? e ? a((Uw[e] && Uw[e].get || r)(t1, e, i, n)) : function(e, i, n) {
                    return a((Uw[e] && Uw[e].get || r)(t1, e, i, n));
                } : t1;
            },
            quickSetter: function(t1, e, i) {
                if ((t1 = Ob(t1)).length > 1) {
                    var n = t1.map(function(t1) {
                        return iE.quickSetter(t1, e, i);
                    }), r = n.length;
                    return function(t1) {
                        for(var e = r; e--;)n[e](t1);
                    };
                }
                t1 = t1[0] || {};
                var a = Uw[e], s = Vw(t1), o = s.harness && (s.harness.aliases || {})[e] || e, l = a ? function(e) {
                    var n = new a;
                    Vx._pt = 0, n.init(t1, i ? e + i : e, Vx, 0, [
                        t1
                    ]), n.render(1, n), Vx._pt && UT(1, Vx);
                } : s.set(t1, o);
                return a ? l : function(e) {
                    return l(t1, o, i ? e + i : e, s, 1);
                };
            },
            quickTo: function(t1, e, i) {
                var n, r = iE.to(t1, ib(((n = {})[e] = "+=0.1", n.paused = !0, n), i || {})), a = function(t1, i, n) {
                    return r.resetTo(e, t1, i, n);
                };
                return a.tween = r, a;
            },
            isTweening: function(t1) {
                return Ux.getTweensOf(t1, !0).length > 0;
            },
            defaults: function(t1) {
                return t1 && t1.ease && (t1.ease = hT(t1.ease, $x.ease)), nb($x, t1 || {});
            },
            config: function(t1) {
                return nb(qx, t1 || {});
            },
            registerEffect: function(t1) {
                var e = t1.name, i = t1.effect, n = t1.plugins, r = t1.defaults, a = t1.extendTimeline;
                (n || "").split(",").forEach(function(t1) {
                    return t1 && !Uw[t1] && !Ew[t1] && Dw(e + " effect requires " + t1 + " plugin.");
                }), kw[e] = function(t1, e, n) {
                    return i(Ob(t1), eb(e || {}, r), n);
                }, a && (MT.prototype[e] = function(t1, i, n) {
                    return this.add(kw[e](t1, dw(i) ? i : (n = i) && {}, this), n);
                });
            },
            registerEase: function(t1, e) {
                aT[t1] = hT(e);
            },
            parseEase: function(t1, e) {
                return arguments.length ? hT(t1, e) : aT;
            },
            getById: function(t1) {
                return Ux.getById(t1);
            },
            exportRoot: function(t1, e) {
                void 0 === t1 && (t1 = {});
                var i, n, r = new MT(t1);
                for(r.smoothChildTiming = pw(t1.smoothChildTiming), Ux.remove(r), r._dp = 0, r._time = r._tTime = Ux._time, i = Ux._first; i;)n = i._next, !e && !i._dur && i instanceof DT && i.vars.onComplete === i._targets[0] || Mb(r, i, i._start - i._delay), i = n;
                return Mb(Ux, r, 0), r;
            },
            context: function(t1, e) {
                return t1 ? new KT(t1, e) : Rx;
            },
            matchMedia: function(t1) {
                return new qT(t1);
            },
            matchMediaRefresh: function() {
                return VT.forEach(function(t1) {
                    var e, i, n = t1.conditions;
                    for(i in n)n[i] && (n[i] = !1, e = 1);
                    e && t1.revert();
                }) || JT();
            },
            addEventListener: function(t1, e) {
                var i = GT[t1] || (GT[t1] = []);
                ~i.indexOf(e) || i.push(e);
            },
            removeEventListener: function(t1, e) {
                var i = GT[t1], n = i && i.indexOf(e);
                n >= 0 && i.splice(n, 1);
            },
            utils: {
                wrap: function t1(e, i, n) {
                    var r = i - e;
                    return mw(e) ? Bb(e, t1(0, e.length), i) : Nb(n, function(t1) {
                        return (r + (t1 - e) % r) % r + e;
                    });
                },
                wrapYoyo: function t1(e, i, n) {
                    var r = i - e, a = 2 * r;
                    return mw(e) ? Bb(e, t1(0, e.length - 1), i) : Nb(n, function(t1) {
                        return e + ((t1 = (a + (t1 - e) % a) % a || 0) > r ? a - t1 : t1);
                    });
                },
                distribute: Pb,
                random: kb,
                snap: Ub,
                normalize: function(t1, e, i) {
                    return Qb(t1, e, 0, 1, i);
                },
                getUnit: Cb,
                clamp: function(t1, e, i) {
                    return Nb(i, function(i) {
                        return Db(t1, e, i);
                    });
                },
                splitColor: Kb,
                toArray: Ob,
                selector: _b,
                mapRange: Qb,
                pipe: function() {
                    for(var t1 = arguments.length, e = new Array(t1), i = 0; i < t1; i++)e[i] = arguments[i];
                    return function(t1) {
                        return e.reduce(function(t1, e) {
                            return e(t1);
                        }, t1);
                    };
                },
                unitize: function(t1, e) {
                    return function(i) {
                        return t1(parseFloat(i)) + (e || Cb(i));
                    };
                },
                interpolate: function t1(e, i, n, r) {
                    var a = isNaN(e + i) ? 0 : function(t1) {
                        return (1 - t1) * e + t1 * i;
                    };
                    if (!a) {
                        var s, o, l, c, u, h = lw(e), d = {};
                        if (!0 === n && (r = 1) && (n = null), h) e = {
                            p: e
                        }, i = {
                            p: i
                        };
                        else if (mw(e) && !mw(i)) {
                            for(l = [], c = e.length, u = c - 2, o = 1; o < c; o++)l.push(t1(e[o - 1], e[o]));
                            c--, a = function(t1) {
                                t1 *= c;
                                var e = Math.min(u, ~~t1);
                                return l[e](t1 - e);
                            }, n = i;
                        } else r || (e = ib(mw(e) ? [] : {}, e));
                        if (!l) {
                            for(s in i)wT.call(d, e, s, "get", i[s]);
                            a = function(t1) {
                                return UT(t1, d) || (h ? e.p : e);
                            };
                        }
                    }
                    return Nb(n, a);
                },
                shuffle: jb
            },
            install: Sw,
            effects: kw,
            ticker: nT,
            updateRoot: MT.updateRoot,
            plugins: Uw,
            globalTimeline: Ux,
            core: {
                PropTween: HT,
                globals: Cw,
                Tween: DT,
                Timeline: MT,
                Animation: mT,
                getCache: Vw,
                _removeLinkedListItem: ob,
                reverting: function() {
                    return Px;
                },
                context: function(t1) {
                    return t1 && Rx && (Rx.data.push(t1), t1._ctx = Rx), Rx;
                },
                suppressOverwrites: function(t1) {
                    return jx = t1;
                }
            }
        };
        Yw("to,from,fromTo,delayedCall,set,killTweensOf", function(t1) {
            return $T[t1] = DT[t1];
        }), nT.add(MT.updateRoot), Vx = $T.to({}, {
            duration: 0
        });
        var tE = function(t1, e) {
            for(var i = t1._pt; i && i.p !== e && i.op !== e && i.fp !== e;)i = i._next;
            return i;
        }, eE = function(t1, e) {
            return {
                name: t1,
                rawVars: 1,
                init: function(t1, i, n) {
                    n._onInit = function(t1) {
                        var n, r;
                        if (lw(i) && (n = {}, Yw(i, function(t1) {
                            return n[t1] = 1;
                        }), i = n), e) {
                            for(r in n = {}, i)n[r] = e(i[r]);
                            i = n;
                        }
                        !function(t1, e) {
                            var i, n, r, a = t1._targets;
                            for(i in e)for(n = a.length; n--;)(r = t1._ptLookup[n][i]) && (r = r.d) && (r._pt && (r = tE(r, i)), r && r.modifier && r.modifier(e[i], t1, a[n], i));
                        }(t1, i);
                    };
                }
            };
        }, iE = $T.registerPlugin({
            name: "attr",
            init: function(t1, e, i, n, r) {
                var a, s, o;
                for(a in this.tween = i, e)o = t1.getAttribute(a) || "", (s = this.add(t1, "setAttribute", (o || 0) + "", e[a], n, r, 0, 0, a)).op = a, s.b = o, this._props.push(a);
            },
            render: function(t1, e) {
                for(var i = e._pt; i;)Px ? i.set(i.t, i.p, i.b, i) : i.r(t1, i.d), i = i._next;
            }
        }, {
            name: "endArray",
            init: function(t1, e) {
                for(var i = e.length; i--;)this.add(t1, i, t1[i] || 0, e[i], 0, 0, 0, 0, 0, 1);
            }
        }, eE("roundProps", Rb), eE("modifiers"), eE("snap", Ub)) || $T;
        DT.version = MT.version = iE.version = "3.12.5", Qx = 1, fw() && rT(), aT.Power0, aT.Power1, aT.Power2, aT.Power3, aT.Power4, aT.Linear, aT.Quad, aT.Cubic, aT.Quart, aT.Quint, aT.Strong, aT.Elastic, aT.Back, aT.SteppedEase, aT.Bounce, aT.Sine, aT.Expo, aT.Circ;
        var nE, rE, aE, sE, oE, lE, cE, uE, hE = {}, dE = 180 / Math.PI, pE = Math.PI / 180, fE = Math.atan2, AE = /([A-Z])/g, gE = /(left|right|width|margin|padding|x)/i, mE = /[\s,\(]\S/, ME = {
            autoAlpha: "opacity,visibility",
            scale: "scaleX,scaleY",
            alpha: "opacity"
        }, yE = function(t1, e) {
            return e.set(e.t, e.p, Math.round(1e4 * (e.s + e.c * t1)) / 1e4 + e.u, e);
        }, vE = function(t1, e) {
            return e.set(e.t, e.p, 1 === t1 ? e.e : Math.round(1e4 * (e.s + e.c * t1)) / 1e4 + e.u, e);
        }, xE = function(t1, e) {
            return e.set(e.t, e.p, t1 ? Math.round(1e4 * (e.s + e.c * t1)) / 1e4 + e.u : e.b, e);
        }, wE = function(t1, e) {
            var i = e.s + e.c * t1;
            e.set(e.t, e.p, ~~(i + (i < 0 ? -0.5 : .5)) + e.u, e);
        }, bE = function(t1, e) {
            return e.set(e.t, e.p, t1 ? e.e : e.b, e);
        }, TE = function(t1, e) {
            return e.set(e.t, e.p, 1 !== t1 ? e.b : e.e, e);
        }, EE = function(t1, e, i) {
            return t1.style[e] = i;
        }, IE = function(t1, e, i) {
            return t1.style.setProperty(e, i);
        }, SE = function(t1, e, i) {
            return t1._gsap[e] = i;
        }, NE = function(t1, e, i) {
            return t1._gsap.scaleX = t1._gsap.scaleY = i;
        }, DE = function(t1, e, i, n, r) {
            var a = t1._gsap;
            a.scaleX = a.scaleY = i, a.renderTransform(r, a);
        }, CE = function(t1, e, i, n, r) {
            var a = t1._gsap;
            a[e] = i, a.renderTransform(r, a);
        }, zE = "transform", LE = zE + "Origin", OE = function t1(e, i) {
            var n = this, r = this.target, a = r.style, s = r._gsap;
            if (e in hE && a) {
                if (this.tfm = this.tfm || {}, "transform" === e) return ME.transform.split(",").forEach(function(e) {
                    return t1.call(n, e, i);
                });
                if (~(e = ME[e] || e).indexOf(",") ? e.split(",").forEach(function(t1) {
                    return n.tfm[t1] = KE(r, t1);
                }) : this.tfm[e] = s.x ? s[e] : KE(r, e), e === LE && (this.tfm.zOrigin = s.zOrigin), this.props.indexOf(zE) >= 0) return;
                s.svg && (this.svgo = r.getAttribute("data-svg-origin"), this.props.push(LE, i, "")), e = zE;
            }
            (a || i) && this.props.push(e, i, a[e]);
        }, _E = function(t1) {
            t1.translate && (t1.removeProperty("translate"), t1.removeProperty("scale"), t1.removeProperty("rotate"));
        }, jE = function() {
            var t1, e, i = this.props, n = this.target, r = n.style, a = n._gsap;
            for(t1 = 0; t1 < i.length; t1 += 3)i[t1 + 1] ? n[i[t1]] = i[t1 + 2] : i[t1 + 2] ? r[i[t1]] = i[t1 + 2] : r.removeProperty("--" === i[t1].substr(0, 2) ? i[t1] : i[t1].replace(AE, "-$1").toLowerCase());
            if (this.tfm) {
                for(e in this.tfm)a[e] = this.tfm[e];
                a.svg && (a.renderTransform(), n.setAttribute("data-svg-origin", this.svgo || "")), (t1 = cE()) && t1.isStart || r[zE] || (_E(r), a.zOrigin && r[LE] && (r[LE] += " " + a.zOrigin + "px", a.zOrigin = 0, a.renderTransform()), a.uncache = 1);
            }
        }, PE = function(t1, e) {
            var i = {
                target: t1,
                props: [],
                revert: jE,
                save: OE
            };
            return t1._gsap || iE.core.getCache(t1), e && e.split(",").forEach(function(t1) {
                return i.save(t1);
            }), i;
        }, RE = function(t1, e) {
            var i = rE.createElementNS ? rE.createElementNS((e || "http://www.w3.org/1999/xhtml").replace(/^https/, "http"), t1) : rE.createElement(t1);
            return i && i.style ? i : rE.createElement(t1);
        }, UE = function t1(e, i, n) {
            var r = getComputedStyle(e);
            return r[i] || r.getPropertyValue(i.replace(AE, "-$1").toLowerCase()) || r.getPropertyValue(i) || !n && t1(e, BE(i) || i, 1) || "";
        }, kE = "O,Moz,ms,Ms,Webkit".split(","), BE = function(t1, e, i) {
            var n = (e || oE).style, r = 5;
            if (t1 in n && !i) return t1;
            for(t1 = t1.charAt(0).toUpperCase() + t1.substr(1); r-- && !(kE[r] + t1 in n););
            return r < 0 ? null : (3 === r ? "ms" : r >= 0 ? kE[r] : "") + t1;
        }, FE = function() {
            "undefined" != typeof window && window.document && (nE = window, rE = nE.document, aE = rE.documentElement, oE = RE("div") || {
                style: {}
            }, RE("div"), zE = BE(zE), LE = zE + "Origin", oE.style.cssText = "border-width:0;line-height:0;position:absolute;padding:0", uE = !!BE("perspective"), cE = iE.core.reverting, sE = 1);
        }, QE = function t1(e) {
            var i, n = RE("svg", this.ownerSVGElement && this.ownerSVGElement.getAttribute("xmlns") || "http://www.w3.org/2000/svg"), r = this.parentNode, a = this.nextSibling, s = this.style.cssText;
            if (aE.appendChild(n), n.appendChild(this), this.style.display = "block", e) try {
                i = this.getBBox(), this._gsapBBox = this.getBBox, this.getBBox = t1;
            } catch (t1) {}
            else this._gsapBBox && (i = this._gsapBBox());
            return r && (a ? r.insertBefore(this, a) : r.appendChild(this)), aE.removeChild(n), this.style.cssText = s, i;
        }, HE = function(t1, e) {
            for(var i = e.length; i--;)if (t1.hasAttribute(e[i])) return t1.getAttribute(e[i]);
        }, VE = function(t1) {
            var e;
            try {
                e = t1.getBBox();
            } catch (i) {
                e = QE.call(t1, !0);
            }
            return e && (e.width || e.height) || t1.getBBox === QE || (e = QE.call(t1, !0)), !e || e.width || e.x || e.y ? e : {
                x: +HE(t1, [
                    "x",
                    "cx",
                    "x1"
                ]) || 0,
                y: +HE(t1, [
                    "y",
                    "cy",
                    "y1"
                ]) || 0,
                width: 0,
                height: 0
            };
        }, GE = function(t1) {
            return !(!t1.getCTM || t1.parentNode && !t1.ownerSVGElement || !VE(t1));
        }, YE = function(t1, e) {
            if (e) {
                var i, n = t1.style;
                e in hE && e !== LE && (e = zE), n.removeProperty ? ("ms" !== (i = e.substr(0, 2)) && "webkit" !== e.substr(0, 6) || (e = "-" + e), n.removeProperty("--" === i ? e : e.replace(AE, "-$1").toLowerCase())) : n.removeAttribute(e);
            }
        }, WE = function(t1, e, i, n, r, a) {
            var s = new HT(t1._pt, e, i, 0, 1, a ? TE : bE);
            return t1._pt = s, s.b = n, s.e = r, t1._props.push(i), s;
        }, XE = {
            deg: 1,
            rad: 1,
            turn: 1
        }, ZE = {
            grid: 1,
            flex: 1
        }, JE = function t1(e, i, n, r) {
            var a, s, o, l, c = parseFloat(n) || 0, u = (n + "").trim().substr((c + "").length) || "px", h = oE.style, d = gE.test(i), p = "svg" === e.tagName.toLowerCase(), f = (p ? "client" : "offset") + (d ? "Width" : "Height"), A = 100, g = "px" === r, m = "%" === r;
            if (r === u || !c || XE[r] || XE[u]) return c;
            if ("px" !== u && !g && (c = t1(e, i, n, "px")), l = e.getCTM && GE(e), (m || "%" === u) && (hE[i] || ~i.indexOf("adius"))) return a = l ? e.getBBox()[d ? "width" : "height"] : e[f], Ww(m ? c / a * A : c / 100 * a);
            if (h[d ? "width" : "height"] = A + (g ? u : r), s = ~i.indexOf("adius") || "em" === r && e.appendChild && !p ? e : e.parentNode, l && (s = (e.ownerSVGElement || {}).parentNode), s && s !== rE && s.appendChild || (s = rE.body), (o = s._gsap) && m && o.width && d && o.time === nT.time && !o.uncache) return Ww(c / o.width * A);
            if (!m || "height" !== i && "width" !== i) (m || "%" === u) && !ZE[UE(s, "display")] && (h.position = UE(e, "position")), s === e && (h.position = "static"), s.appendChild(oE), a = oE[f], s.removeChild(oE), h.position = "absolute";
            else {
                var M = e.style[i];
                e.style[i] = A + r, a = e[f], M ? e.style[i] = M : YE(e, i);
            }
            return d && m && ((o = Vw(s)).time = nT.time, o.width = s[f]), Ww(g ? a * c / A : a && c ? A / a * c : 0);
        }, KE = function(t1, e, i, n) {
            var r;
            return sE || FE(), e in ME && "transform" !== e && ~(e = ME[e]).indexOf(",") && (e = e.split(",")[0]), hE[e] && "transform" !== e ? (r = cI(t1, n), r = "transformOrigin" !== e ? r[e] : r.svg ? r.origin : uI(UE(t1, LE)) + " " + r.zOrigin + "px") : (!(r = t1.style[e]) || "auto" === r || n || ~(r + "").indexOf("calc(")) && (r = iI[e] && iI[e](t1, e, i) || UE(t1, e) || Gw(t1, e) || ("opacity" === e ? 1 : 0)), i && !~(r + "").trim().indexOf(" ") ? JE(t1, e, r, i) + i : r;
        }, qE = function(t1, e, i, n) {
            if (!i || "none" === i) {
                var r = BE(e, t1, 1), a = r && UE(t1, r, 1);
                a && a !== i ? (e = r, i = a) : "borderColor" === e && (i = UE(t1, "borderTopColor"));
            }
            var s, o, l, c, u, h, d, p, f, A, g, m = new HT(this._pt, t1.style, e, 0, 1, RT), M = 0, y = 0;
            if (m.b = i, m.e = n, i += "", "auto" == (n += "") && (h = t1.style[e], t1.style[e] = n, n = UE(t1, e) || n, h ? t1.style[e] = h : YE(t1, e)), iT(s = [
                i,
                n
            ]), n = s[1], l = (i = s[0]).match(vw) || [], (n.match(vw) || []).length) {
                for(; o = vw.exec(n);)d = o[0], f = n.substring(M, o.index), u ? u = (u + 1) % 5 : "rgba(" !== f.substr(-5) && "hsla(" !== f.substr(-5) || (u = 1), d !== (h = l[y++] || "") && (c = parseFloat(h) || 0, g = h.substr((c + "").length), "=" === d.charAt(1) && (d = Zw(c, d) + g), p = parseFloat(d), A = d.substr((p + "").length), M = vw.lastIndex - A.length, A || (A = A || qx.units[e] || g, M === n.length && (n += A, m.e += A)), g !== A && (c = JE(t1, e, h, A) || 0), m._pt = {
                    _next: m._pt,
                    p: f || 1 === y ? f : ",",
                    s: c,
                    c: p - c,
                    m: u && u < 4 || "zIndex" === e ? Math.round : 0
                });
                m.c = M < n.length ? n.substring(M, n.length) : "";
            } else m.r = "display" === e && "none" === n ? TE : bE;
            return ww.test(n) && (m.e = 0), this._pt = m, m;
        }, $E = {
            top: "0%",
            bottom: "100%",
            left: "0%",
            right: "100%",
            center: "50%"
        }, tI = function(t1) {
            var e = t1.split(" "), i = e[0], n = e[1] || "50%";
            return "top" !== i && "bottom" !== i && "left" !== n && "right" !== n || (t1 = i, i = n, n = t1), e[0] = $E[i] || i, e[1] = $E[n] || n, e.join(" ");
        }, eI = function(t1, e) {
            if (e.tween && e.tween._time === e.tween._dur) {
                var i, n, r, a = e.t, s = a.style, o = e.u, l = a._gsap;
                if ("all" === o || !0 === o) s.cssText = "", n = 1;
                else for(r = (o = o.split(",")).length; --r > -1;)i = o[r], hE[i] && (n = 1, i = "transformOrigin" === i ? LE : zE), YE(a, i);
                n && (YE(a, zE), l && (l.svg && a.removeAttribute("transform"), cI(a, 1), l.uncache = 1, _E(s)));
            }
        }, iI = {
            clearProps: function(t1, e, i, n, r) {
                if ("isFromStart" !== r.data) {
                    var a = t1._pt = new HT(t1._pt, e, i, 0, 0, eI);
                    return a.u = n, a.pr = -10, a.tween = r, t1._props.push(i), 1;
                }
            }
        }, nI = [
            1,
            0,
            0,
            1,
            0,
            0
        ], rI = {}, aI = function(t1) {
            return "matrix(1, 0, 0, 1, 0, 0)" === t1 || "none" === t1 || !t1;
        }, sI = function(t1) {
            var e = UE(t1, zE);
            return aI(e) ? nI : e.substr(7).match(yw).map(Ww);
        }, oI = function(t1, e) {
            var i, n, r, a, s = t1._gsap || Vw(t1), o = t1.style, l = sI(t1);
            return s.svg && t1.getAttribute("transform") ? "1,0,0,1,0,0" === (l = [
                (r = t1.transform.baseVal.consolidate().matrix).a,
                r.b,
                r.c,
                r.d,
                r.e,
                r.f
            ]).join(",") ? nI : l : (l !== nI || t1.offsetParent || t1 === aE || s.svg || (r = o.display, o.display = "block", (i = t1.parentNode) && t1.offsetParent || (a = 1, n = t1.nextElementSibling, aE.appendChild(t1)), l = sI(t1), r ? o.display = r : YE(t1, "display"), a && (n ? i.insertBefore(t1, n) : i ? i.appendChild(t1) : aE.removeChild(t1))), e && l.length > 6 ? [
                l[0],
                l[1],
                l[4],
                l[5],
                l[12],
                l[13]
            ] : l);
        }, lI = function(t1, e, i, n, r, a) {
            var s, o, l, c = t1._gsap, u = r || oI(t1, !0), h = c.xOrigin || 0, d = c.yOrigin || 0, p = c.xOffset || 0, f = c.yOffset || 0, A = u[0], g = u[1], m = u[2], M = u[3], y = u[4], v = u[5], x = e.split(" "), w = parseFloat(x[0]) || 0, b = parseFloat(x[1]) || 0;
            i ? u !== nI && (o = A * M - g * m) && (l = w * (-g / o) + b * (A / o) - (A * v - g * y) / o, w = w * (M / o) + b * (-m / o) + (m * v - M * y) / o, b = l) : (w = (s = VE(t1)).x + (~x[0].indexOf("%") ? w / 100 * s.width : w), b = s.y + (~(x[1] || x[0]).indexOf("%") ? b / 100 * s.height : b)), n || !1 !== n && c.smooth ? (y = w - h, v = b - d, c.xOffset = p + (y * A + v * m) - y, c.yOffset = f + (y * g + v * M) - v) : c.xOffset = c.yOffset = 0, c.xOrigin = w, c.yOrigin = b, c.smooth = !!n, c.origin = e, c.originIsAbsolute = !!i, t1.style[LE] = "0px 0px", a && (WE(a, c, "xOrigin", h, w), WE(a, c, "yOrigin", d, b), WE(a, c, "xOffset", p, c.xOffset), WE(a, c, "yOffset", f, c.yOffset)), t1.setAttribute("data-svg-origin", w + " " + b);
        }, cI = function(t1, e) {
            var i = t1._gsap || new gT(t1);
            if ("x" in i && !e && !i.uncache) return i;
            var n, r, a, s, o, l, c, u, h, d, p, f, A, g, m, M, y, v, x, w, b, T, E, I, S, N, D, C, z, L, O, _, j = t1.style, P = i.scaleX < 0, R = "px", U = "deg", k = getComputedStyle(t1), B = UE(t1, LE) || "0";
            return n = r = a = l = c = u = h = d = p = 0, s = o = 1, i.svg = !(!t1.getCTM || !GE(t1)), k.translate && ("none" === k.translate && "none" === k.scale && "none" === k.rotate || (j[zE] = ("none" !== k.translate ? "translate3d(" + (k.translate + " 0 0").split(" ").slice(0, 3).join(", ") + ") " : "") + ("none" !== k.rotate ? "rotate(" + k.rotate + ") " : "") + ("none" !== k.scale ? "scale(" + k.scale.split(" ").join(",") + ") " : "") + ("none" !== k[zE] ? k[zE] : "")), j.scale = j.rotate = j.translate = "none"), g = oI(t1, i.svg), i.svg && (i.uncache ? (S = t1.getBBox(), B = i.xOrigin - S.x + "px " + (i.yOrigin - S.y) + "px", I = "") : I = !e && t1.getAttribute("data-svg-origin"), lI(t1, I || B, !!I || i.originIsAbsolute, !1 !== i.smooth, g)), f = i.xOrigin || 0, A = i.yOrigin || 0, g !== nI && (v = g[0], x = g[1], w = g[2], b = g[3], n = T = g[4], r = E = g[5], 6 === g.length ? (s = Math.sqrt(v * v + x * x), o = Math.sqrt(b * b + w * w), l = v || x ? fE(x, v) * dE : 0, (h = w || b ? fE(w, b) * dE + l : 0) && (o *= Math.abs(Math.cos(h * pE))), i.svg && (n -= f - (f * v + A * w), r -= A - (f * x + A * b))) : (_ = g[6], L = g[7], D = g[8], C = g[9], z = g[10], O = g[11], n = g[12], r = g[13], a = g[14], c = (m = fE(_, z)) * dE, m && (I = T * (M = Math.cos(-m)) + D * (y = Math.sin(-m)), S = E * M + C * y, N = _ * M + z * y, D = T * -y + D * M, C = E * -y + C * M, z = _ * -y + z * M, O = L * -y + O * M, T = I, E = S, _ = N), u = (m = fE(-w, z)) * dE, m && (M = Math.cos(-m), O = b * (y = Math.sin(-m)) + O * M, v = I = v * M - D * y, x = S = x * M - C * y, w = N = w * M - z * y), l = (m = fE(x, v)) * dE, m && (I = v * (M = Math.cos(m)) + x * (y = Math.sin(m)), S = T * M + E * y, x = x * M - v * y, E = E * M - T * y, v = I, T = S), c && Math.abs(c) + Math.abs(l) > 359.9 && (c = l = 0, u = 180 - u), s = Ww(Math.sqrt(v * v + x * x + w * w)), o = Ww(Math.sqrt(E * E + _ * _)), m = fE(T, E), h = Math.abs(m) > 2e-4 ? m * dE : 0, p = O ? 1 / (O < 0 ? -O : O) : 0), i.svg && (I = t1.getAttribute("transform"), i.forceCSS = t1.setAttribute("transform", "") || !aI(UE(t1, zE)), I && t1.setAttribute("transform", I))), Math.abs(h) > 90 && Math.abs(h) < 270 && (P ? (s *= -1, h += l <= 0 ? 180 : -180, l += l <= 0 ? 180 : -180) : (o *= -1, h += h <= 0 ? 180 : -180)), e = e || i.uncache, i.x = n - ((i.xPercent = n && (!e && i.xPercent || (Math.round(t1.offsetWidth / 2) === Math.round(-n) ? -50 : 0))) ? t1.offsetWidth * i.xPercent / 100 : 0) + R, i.y = r - ((i.yPercent = r && (!e && i.yPercent || (Math.round(t1.offsetHeight / 2) === Math.round(-r) ? -50 : 0))) ? t1.offsetHeight * i.yPercent / 100 : 0) + R, i.z = a + R, i.scaleX = Ww(s), i.scaleY = Ww(o), i.rotation = Ww(l) + U, i.rotationX = Ww(c) + U, i.rotationY = Ww(u) + U, i.skewX = h + U, i.skewY = d + U, i.transformPerspective = p + R, (i.zOrigin = parseFloat(B.split(" ")[2]) || !e && i.zOrigin || 0) && (j[LE] = uI(B)), i.xOffset = i.yOffset = 0, i.force3D = qx.force3D, i.renderTransform = i.svg ? mI : uE ? gI : dI, i.uncache = 0, i;
        }, uI = function(t1) {
            return (t1 = t1.split(" "))[0] + " " + t1[1];
        }, hI = function(t1, e, i) {
            var n = Cb(e);
            return Ww(parseFloat(e) + parseFloat(JE(t1, "x", i + "px", n))) + n;
        }, dI = function(t1, e) {
            e.z = "0px", e.rotationY = e.rotationX = "0deg", e.force3D = 0, gI(t1, e);
        }, pI = "0deg", fI = "0px", AI = ") ", gI = function(t1, e) {
            var i = e || this, n = i.xPercent, r = i.yPercent, a = i.x, s = i.y, o = i.z, l = i.rotation, c = i.rotationY, u = i.rotationX, h = i.skewX, d = i.skewY, p = i.scaleX, f = i.scaleY, A = i.transformPerspective, g = i.force3D, m = i.target, M = i.zOrigin, y = "", v = "auto" === g && t1 && 1 !== t1 || !0 === g;
            if (M && (u !== pI || c !== pI)) {
                var x, w = parseFloat(c) * pE, b = Math.sin(w), T = Math.cos(w);
                w = parseFloat(u) * pE, x = Math.cos(w), a = hI(m, a, b * x * -M), s = hI(m, s, -Math.sin(w) * -M), o = hI(m, o, T * x * -M + M);
            }
            A !== fI && (y += "perspective(" + A + AI), (n || r) && (y += "translate(" + n + "%, " + r + "%) "), (v || a !== fI || s !== fI || o !== fI) && (y += o !== fI || v ? "translate3d(" + a + ", " + s + ", " + o + ") " : "translate(" + a + ", " + s + AI), l !== pI && (y += "rotate(" + l + AI), c !== pI && (y += "rotateY(" + c + AI), u !== pI && (y += "rotateX(" + u + AI), h === pI && d === pI || (y += "skew(" + h + ", " + d + AI), 1 === p && 1 === f || (y += "scale(" + p + ", " + f + AI), m.style[zE] = y || "translate(0, 0)";
        }, mI = function(t1, e) {
            var i, n, r, a, s, o = e || this, l = o.xPercent, c = o.yPercent, u = o.x, h = o.y, d = o.rotation, p = o.skewX, f = o.skewY, A = o.scaleX, g = o.scaleY, m = o.target, M = o.xOrigin, y = o.yOrigin, v = o.xOffset, x = o.yOffset, w = o.forceCSS, b = parseFloat(u), T = parseFloat(h);
            d = parseFloat(d), p = parseFloat(p), (f = parseFloat(f)) && (p += f = parseFloat(f), d += f), d || p ? (d *= pE, p *= pE, i = Math.cos(d) * A, n = Math.sin(d) * A, r = Math.sin(d - p) * -g, a = Math.cos(d - p) * g, p && (f *= pE, s = Math.tan(p - f), r *= s = Math.sqrt(1 + s * s), a *= s, f && (s = Math.tan(f), i *= s = Math.sqrt(1 + s * s), n *= s)), i = Ww(i), n = Ww(n), r = Ww(r), a = Ww(a)) : (i = A, a = g, n = r = 0), (b && !~(u + "").indexOf("px") || T && !~(h + "").indexOf("px")) && (b = JE(m, "x", u, "px"), T = JE(m, "y", h, "px")), (M || y || v || x) && (b = Ww(b + M - (M * i + y * r) + v), T = Ww(T + y - (M * n + y * a) + x)), (l || c) && (s = m.getBBox(), b = Ww(b + l / 100 * s.width), T = Ww(T + c / 100 * s.height)), s = "matrix(" + i + "," + n + "," + r + "," + a + "," + b + "," + T + ")", m.setAttribute("transform", s), w && (m.style[zE] = s);
        }, MI = function(t1, e, i, n, r) {
            var a, s, o = 360, l = lw(r), c = parseFloat(r) * (l && ~r.indexOf("rad") ? dE : 1) - n, u = n + c + "deg";
            return l && ("short" === (a = r.split("_")[1]) && (c %= o) != c % 180 && (c += c < 0 ? o : -360), "cw" === a && c < 0 ? c = (c + 36e9) % o - ~~(c / o) * o : "ccw" === a && c > 0 && (c = (c - 36e9) % o - ~~(c / o) * o)), t1._pt = s = new HT(t1._pt, e, i, n, c, vE), s.e = u, s.u = "deg", t1._props.push(i), s;
        }, yI = function(t1, e) {
            for(var i in e)t1[i] = e[i];
            return t1;
        }, vI = function(t1, e, i) {
            var n, r, a, s, o, l, c, u = yI({}, i._gsap), h = i.style;
            for(r in u.svg ? (a = i.getAttribute("transform"), i.setAttribute("transform", ""), h[zE] = e, n = cI(i, 1), YE(i, zE), i.setAttribute("transform", a)) : (a = getComputedStyle(i)[zE], h[zE] = e, n = cI(i, 1), h[zE] = a), hE)(a = u[r]) !== (s = n[r]) && "perspective,force3D,transformOrigin,svgOrigin".indexOf(r) < 0 && (o = Cb(a) !== (c = Cb(s)) ? JE(i, r, a, c) : parseFloat(a), l = parseFloat(s), t1._pt = new HT(t1._pt, n, r, o, l - o, yE), t1._pt.u = c || 0, t1._props.push(r));
            yI(n, u);
        };
        Yw("padding,margin,Width,Radius", function(t1, e) {
            var i = "Top", n = "Right", r = "Bottom", a = "Left", s = (e < 3 ? [
                i,
                n,
                r,
                a
            ] : [
                i + a,
                i + n,
                r + n,
                r + a
            ]).map(function(i) {
                return e < 2 ? t1 + i : "border" + i + t1;
            });
            iI[e > 1 ? "border" + t1 : t1] = function(t1, e, i, n, r) {
                var a, o;
                if (arguments.length < 4) return a = s.map(function(e) {
                    return KE(t1, e, i);
                }), 5 === (o = a.join(" ")).split(a[0]).length ? a[0] : o;
                a = (n + "").split(" "), o = {}, s.forEach(function(t1, e) {
                    return o[t1] = a[e] = a[e] || a[(e - 1) / 2 | 0];
                }), t1.init(e, o, r);
            };
        });
        var xI, wI, bI = {
            name: "css",
            register: FE,
            targetTest: function(t1) {
                return t1.style && t1.nodeType;
            },
            init: function(t1, e, i, n, r) {
                var a, s, o, l, c, u, h, d, p, f, A, g, m, M, y, v, x = this._props, w = t1.style, b = i.vars.startAt;
                for(h in sE || FE(), this.styles = this.styles || PE(t1), v = this.styles.props, this.tween = i, e)if ("autoRound" !== h && (s = e[h], !Uw[h] || !bT(h, e, i, n, t1, r))) {
                    if (c = typeof s, u = iI[h], "function" === c && (c = typeof (s = s.call(i, n, t1, r))), "string" === c && ~s.indexOf("random(") && (s = Fb(s)), u) u(this, t1, h, s, i) && (y = 1);
                    else if ("--" === h.substr(0, 2)) a = (getComputedStyle(t1).getPropertyValue(h) + "").trim(), s += "", tT.lastIndex = 0, tT.test(a) || (d = Cb(a), p = Cb(s)), p ? d !== p && (a = JE(t1, h, a, p) + p) : d && (s += d), this.add(w, "setProperty", a, s, n, r, 0, 0, h), x.push(h), v.push(h, 0, w[h]);
                    else if ("undefined" !== c) {
                        if (b && h in b ? (a = "function" == typeof b[h] ? b[h].call(i, n, t1, r) : b[h], lw(a) && ~a.indexOf("random(") && (a = Fb(a)), Cb(a + "") || "auto" === a || (a += qx.units[h] || Cb(KE(t1, h)) || ""), "=" === (a + "").charAt(1) && (a = KE(t1, h))) : a = KE(t1, h), l = parseFloat(a), (f = "string" === c && "=" === s.charAt(1) && s.substr(0, 2)) && (s = s.substr(2)), o = parseFloat(s), h in ME && ("autoAlpha" === h && (1 === l && "hidden" === KE(t1, "visibility") && o && (l = 0), v.push("visibility", 0, w.visibility), WE(this, w, "visibility", l ? "inherit" : "hidden", o ? "inherit" : "hidden", !o)), "scale" !== h && "transform" !== h && ~(h = ME[h]).indexOf(",") && (h = h.split(",")[0])), A = h in hE) {
                            if (this.styles.save(h), g || ((m = t1._gsap).renderTransform && !e.parseTransform || cI(t1, e.parseTransform), M = !1 !== e.smoothOrigin && m.smooth, (g = this._pt = new HT(this._pt, w, zE, 0, 1, m.renderTransform, m, 0, -1)).dep = 1), "scale" === h) this._pt = new HT(this._pt, m, "scaleY", m.scaleY, (f ? Zw(m.scaleY, f + o) : o) - m.scaleY || 0, yE), this._pt.u = 0, x.push("scaleY", h), h += "X";
                            else {
                                if ("transformOrigin" === h) {
                                    v.push(LE, 0, w[LE]), s = tI(s), m.svg ? lI(t1, s, 0, M, 0, this) : ((p = parseFloat(s.split(" ")[2]) || 0) !== m.zOrigin && WE(this, m, "zOrigin", m.zOrigin, p), WE(this, w, h, uI(a), uI(s)));
                                    continue;
                                }
                                if ("svgOrigin" === h) {
                                    lI(t1, s, 1, M, 0, this);
                                    continue;
                                }
                                if (h in rI) {
                                    MI(this, m, h, l, f ? Zw(l, f + s) : s);
                                    continue;
                                }
                                if ("smoothOrigin" === h) {
                                    WE(this, m, "smooth", m.smooth, s);
                                    continue;
                                }
                                if ("force3D" === h) {
                                    m[h] = s;
                                    continue;
                                }
                                if ("transform" === h) {
                                    vI(this, s, t1);
                                    continue;
                                }
                            }
                        } else h in w || (h = BE(h) || h);
                        if (A || (o || 0 === o) && (l || 0 === l) && !mE.test(s) && h in w) o || (o = 0), (d = (a + "").substr((l + "").length)) !== (p = Cb(s) || (h in qx.units ? qx.units[h] : d)) && (l = JE(t1, h, a, p)), this._pt = new HT(this._pt, A ? m : w, h, l, (f ? Zw(l, f + o) : o) - l, A || "px" !== p && "zIndex" !== h || !1 === e.autoRound ? yE : wE), this._pt.u = p || 0, d !== p && "%" !== p && (this._pt.b = a, this._pt.r = xE);
                        else if (h in w) qE.call(this, t1, h, a, f ? f + s : s);
                        else if (h in t1) this.add(t1, h, a || t1[h], f ? f + s : s, n, r);
                        else if ("parseTransform" !== h) {
                            Nw(h, s);
                            continue;
                        }
                        A || (h in w ? v.push(h, 0, w[h]) : v.push(h, 1, a || t1[h])), x.push(h);
                    }
                }
                y && QT(this);
            },
            render: function(t1, e) {
                if (e.tween._time || !cE()) for(var i = e._pt; i;)i.r(t1, i.d), i = i._next;
                else e.styles.revert();
            },
            get: KE,
            aliases: ME,
            getSetter: function(t1, e, i) {
                var n = ME[e];
                return n && n.indexOf(",") < 0 && (e = n), e in hE && e !== LE && (t1._gsap.x || KE(t1, "x")) ? i && lE === i ? "scale" === e ? NE : SE : (lE = i || {}, "scale" === e ? DE : CE) : t1.style && !hw(t1.style[e]) ? EE : ~e.indexOf("-") ? IE : _T(t1, e);
            },
            core: {
                _removeProperty: YE,
                _getMatrix: oI
            }
        };
        iE.utils.checkPrefix = BE, iE.core.getStyleSaver = PE, wI = Yw("x,y,z,scale,scaleX,scaleY,xPercent,yPercent," + (xI = "rotation,rotationX,rotationY,skewX,skewY") + ",transform,transformOrigin,svgOrigin,force3D,smoothOrigin,transformPerspective", function(t1) {
            hE[t1] = 1;
        }), Yw(xI, function(t1) {
            qx.units[t1] = "deg", rI[t1] = 1;
        }), ME[wI[13]] = "x,y,z,scale,scaleX,scaleY,xPercent,yPercent," + xI, Yw("0:translateX,1:translateY,2:translateZ,8:rotate,8:rotationZ,8:rotateZ,9:rotateX,10:rotateY", function(t1) {
            var e = t1.split(":");
            ME[e[1]] = wI[e[0]];
        }), Yw("x,y,z,top,right,bottom,left,width,height,fontSize,padding,margin,perspective", function(t1) {
            qx.units[t1] = "px";
        }), iE.registerPlugin(bI);
        var TI = iE.registerPlugin(bI) || iE;
        TI.core.Tween;
        const EI = class extends Sp {
            constructor(t1){
                var e, i, n;
                super(), e = this, n = !0, (i = function(t1) {
                    var e = function(t1) {
                        if ("object" != typeof t1 || !t1) return t1;
                        var e = t1[Symbol.toPrimitive];
                        if (void 0 !== e) {
                            var i = e.call(t1, "string");
                            if ("object" != typeof i) return i;
                            throw new TypeError("@@toPrimitive must return a primitive value.");
                        }
                        return String(t1);
                    }(t1);
                    return "symbol" == typeof e ? e : e + "";
                }(i = "_visible")) in e ? Object.defineProperty(e, i, {
                    value: n,
                    enumerable: !0,
                    configurable: !0,
                    writable: !0
                }) : e[i] = n, this.userData = t1, this.visible = !1, this.createHoverArea(), this.createPoint().then(()=>this.addEventListeners());
            }
            get visible() {
                return this._visible;
            }
            set visible(t1) {
                this._visible = t1, this.hoverArea && (this.hoverArea.visible = t1), this.point && (this.point.visible = t1);
            }
            async createPoint() {
                const t1 = new ih(30, 30, 10, 10), e = new dm, i = await e.loadAsync(this.userData.icon);
                i.center = new Qo(.5, .5), i.colorSpace = _s, i.minFilter = da, i.magFilter = la, i.anisotropy = 8;
                const n = new Ig({
                    color: new kc(16777215),
                    transparent: !0,
                    depthTest: !1,
                    side: er,
                    map: i,
                    opacity: Cx.isMobileDevice ? .5 : 0
                });
                this.point = new Ou(t1, n), this.point.position.copy(this.userData.position), this.point.rotation.x = Math.PI / 2, this.point.visible = this.visible, this.point.interactive = !0, this.point.renderOrder = 3, this.point.isLink = !0, this.point.updateOpacity = TI.quickTo(this.point.material, "opacity", {
                    ease: "back",
                    duration: .5
                }), this.add(this.point);
            }
            createHoverArea() {
                const t1 = new IA(125, 10, 10), e = new Ig({
                    color: new kc(16777215),
                    transparent: !0,
                    depthTest: !1,
                    side: er,
                    opacity: 0
                });
                this.hoverArea = new Ou(t1, e), this.hoverArea.position.copy(this.userData.position), this.hoverArea.rotation.x = Math.PI / 2, this.hoverArea.visible = this.visible, this.hoverArea.isLinkSphere = !0, this.hoverArea.interactive = !0, this.hoverArea.renderOrder = 2, this.add(this.hoverArea);
            }
            addEventListeners() {
                return this.point.addEventListener("select", ()=>this.onClick()), this.point.addEventListener("click", ()=>this.onClick()), this.point.addEventListener("hoverstart", ()=>this.onHoverStart()), this.point.addEventListener("hoverend", ()=>this.onHoverEnd()), this.hoverArea.addEventListener("hoverstart", ()=>this.onHoverStart()), this.hoverArea.addEventListener("hoverend", ()=>this.onHoverEnd()), this;
            }
            dispose() {
                this.point && (this.point.material.dispose(), this.point.removeFromParent()), this.hoverArea && (this.hoverArea.material.dispose(), this.hoverArea.removeFromParent()), this.removeFromParent();
            }
            onHoverStart() {
                Cx.isMobileDevice || this.point.updateOpacity(1);
            }
            onHoverEnd() {
                Cx.isMobileDevice || this.point.updateOpacity(0);
            }
            onClick() {}
        };
        const II = class extends nf {
            constructor(t1){
                var e, i, n;
                super(), e = this, n = !0, (i = function(t1) {
                    var e = function(t1) {
                        if ("object" != typeof t1 || !t1) return t1;
                        var e = t1[Symbol.toPrimitive];
                        if (void 0 !== e) {
                            var i = e.call(t1, "string");
                            if ("object" != typeof i) return i;
                            throw new TypeError("@@toPrimitive must return a primitive value.");
                        }
                        return String(t1);
                    }(t1);
                    return "symbol" == typeof e ? e : e + "";
                }(i = "interactive")) in e ? Object.defineProperty(e, i, {
                    value: n,
                    enumerable: !0,
                    configurable: !0,
                    writable: !0
                }) : e[i] = n, this.userData = t1, this.position.copy(t1.position), this.renderOrder = 3, this.visible = !1, this.onHoverEnd(), this.createMaterial(), this.addEventListeners();
            }
            createGeometry() {
                return this.geometry = new ih(1, 1, 10, 10), this;
            }
            async createMaterial() {
                const t1 = new dm, e = await t1.loadAsync(this.userData.icon);
                e.center = new Qo(.5, .5), e.colorSpace = _s, e.minFilter = da, e.magFilter = la, e.anisotropy = 8;
                const i = new Qp({
                    color: new kc(16777215),
                    sizeAttenuation: !1,
                    transparent: !0,
                    depthTest: !1,
                    side: er,
                    map: e,
                    opacity: 1
                });
                return this.material = i, this;
            }
            addEventListeners() {
                return this.addEventListener("select", ()=>this.onClick()), this.addEventListener("click", ()=>this.onClick()), this.addEventListener("hoverstart", ()=>this.onHoverStart()), this.addEventListener("hoverend", ()=>this.onHoverEnd()), this;
            }
            dispose() {
                this.material.dispose(), this.removeFromParent();
            }
            onHoverStart() {
                this.scale.setScalar(this.userData.scale + 20 * this.userData.scale / 100);
            }
            onHoverEnd() {
                this.scale.setScalar(this.userData.scale);
            }
            onClick() {}
        };
        function SI(t1, e, i) {
            return (e = function(t1) {
                var e = function(t1) {
                    if ("object" != typeof t1 || !t1) return t1;
                    var e = t1[Symbol.toPrimitive];
                    if (void 0 !== e) {
                        var i = e.call(t1, "string");
                        if ("object" != typeof i) return i;
                        throw new TypeError("@@toPrimitive must return a primitive value.");
                    }
                    return String(t1);
                }(t1);
                return "symbol" == typeof e ? e : e + "";
            }(e)) in t1 ? Object.defineProperty(t1, e, {
                value: i,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : t1[e] = i, t1;
        }
        function NI(t1, e) {
            return t1.get(function(t1, e, i) {
                if ("function" == typeof t1 ? t1 === e : t1.has(e)) return arguments.length < 3 ? e : i;
                throw new TypeError("Private element is not present on this object");
            }(t1, e));
        }
        var DI = new WeakMap;
        const CI = class extends Ou {
            constructor(t1, e){
                var i, n, r;
                super(e), SI(this, "depthMap", null), SI(this, "loaded", !1), SI(this, "links", []), r = [], function(t1, e) {
                    if (e.has(t1)) throw new TypeError("Cannot initialize the same private elements twice on an object");
                }(i = this, n = DI), n.set(i, r), this.renderOrder = 0, this.userData = t1;
            }
            get panoramaId() {
                return this.userData.camera_id;
            }
            async loadDepth() {
                performance.mark("start downloadingDepth");
                try {
                    this.depthMap = await Mx(this.userData.images.scene_depth);
                } catch (t1) {
                    this.depthMap = null, console.error("Error loading depthMap");
                }
                performance.mark("finish start downloadingDepth"), performance.measure("downloadingDepth", "start downloadingDepth", "finish start downloadingDepth");
            }
            async loadMask() {
                try {
                    this.mask = await Mx(this.userData.images.object_ids);
                } catch (t1) {
                    this.mask = null, console.error("Error loading mask");
                }
            }
            async load() {
                var t1;
                return this.userData.images.scene_depth && await this.loadDepth().then(()=>this.removeBlockedLinks()), "mask" === (null === (t1 = zn.config.capabilities) || void 0 === t1 ? void 0 : t1.floor_navigation) && await this.loadMask(), await this.createMaterial().then(()=>this.loaded = !0);
            }
            removeBlockedLinks() {
                const t1 = [];
                this.links.forEach((e)=>{
                    const { delta: i, distance: n } = ((t1, e)=>{
                        const { direction: i } = (new Jl).lookAt(t1), n = (1 + Math.atan2(i.z, i.x) / Math.PI) / 2, r = Math.acos(i.y) / Math.PI, { R: a } = yx(n, r, e), s = a || 140, o = (new xl).distanceTo(t1);
                        return {
                            depth: s,
                            distance: o,
                            delta: o - s
                        };
                    })(e.userData.position, this.depthMap);
                    if (i > 40 || n > 800) return e.dispose();
                    t1.push(e);
                });
            }
            createLinks(t1) {
                return this.createCameraPoints(), this.createDoors(t1), this;
            }
            createCameraPoints() {
                for (const t1 of this.userData.roomPanoramas){
                    if (t1 === this.panoramaId) continue;
                    const e = hx(zn.config.json, t1);
                    e && this.createLink(t1, e.Location, !1);
                }
                return this;
            }
            createDoors(t1) {
                var e, i;
                const n = zn.config.json.Floors[zn.currentFloorIndex], r = null !== (e = n.Apertures) && void 0 !== e ? e : [], a = null !== (i = n.Doors) && void 0 !== i ? i : [], s = ux(zn.config.json, this.userData.room_id), { Rooms: o } = n.Units[0];
                for (const { Location: e, Walls: i, ...n } of [
                    ...a,
                    ...r
                ]){
                    if (!i.some((t1)=>s.Walls.some((e)=>e === t1))) continue;
                    const r = o.find((t1)=>{
                        const e = t1.Walls.some((t1)=>i.some((e)=>t1 === e)), n = t1.ID === s.ID;
                        return e && !n;
                    });
                    if (!r) continue;
                    const a = t1.filter((t1)=>{
                        let { userData: e } = t1;
                        return e.room_id === r.ID;
                    }), { panorama: l } = dx([
                        e.X,
                        e.Y
                    ], a);
                    l && this.createLink(l.panoramaId, e, !0, n);
                }
                return this;
            }
            createLink(t1, e) {
                var i;
                let n = arguments.length > 2 && void 0 !== arguments[2] && arguments[2], r = arguments.length > 3 ? arguments[3] : void 0;
                const a = (null === (i = this.userData.cameraData) || void 0 === i ? void 0 : i.Location.Z) || 140, s = [
                    this.userData.left,
                    this.userData.top
                ], o = e.X - s[0], l = e.Y - s[1], c = n ? r.Height / 2 - a : -a, u = new xl(o, c, l);
                u.applyAxisAngle(new xl(0, 1, 0), Math.PI / 2);
                const h = {
                    panoramaId: this.panoramaId,
                    position: u,
                    targetId: t1
                };
                if (n) {
                    const t1 = zn.config.panoramaIcons.door, e = fN.isProActive ? new Lx({
                        ...h,
                        rotation: new oc(0, gx(r.Rotation.Yaw + 90), 0),
                        height: r.Height,
                        width: r.Width,
                        scale: .1,
                        icon: t1,
                        loc: this.userData.cameraData.Location
                    }) : new II({
                        ...h,
                        scale: .1,
                        icon: t1
                    });
                    return this.links.push(e), e;
                }
                const d = fN.isProActive ? zn.config.panoramaIcons.interactiveSpot : zn.config.panoramaIcons.spot, p = fN.isProActive ? new EI({
                    ...h,
                    icon: d,
                    scale: 1
                }) : new II({
                    ...h,
                    scale: .1,
                    icon: d
                });
                return this.links.push(p), p;
            }
            addEventListener(t1, e) {
                "materialcreate" === t1 ? NI(DI, this).push({
                    type: t1,
                    listener: e
                }) : super.addEventListener(t1, e);
            }
            invoke(t1, e) {
                NI(DI, this).forEach((i)=>{
                    t1 === i.type && i.listener(e);
                });
            }
        }, zI = class extends CI {
            constructor(t1){
                performance.mark("start creating SphereGeometry");
                const e = new gg(1e3, 512, 512).scale(-1, 1, 1);
                performance.mark("finish creating SphereGeometry"), performance.measure("creating SphereGeometry", "start creating SphereGeometry", "finish creating SphereGeometry"), super(t1, e), this.userData.image = t1.images.sphere || t1.images[0];
            }
            async createBareshellMaterial() {
                if (this.bareshellMaterial) return this.material = this.bareshellMaterial, this.bareshellMaterial;
                const t1 = await Lv.get(this.userData.image.replace(/\.jpe?g|\.webp/, (t1)=>{
                    switch(t1){
                        case ".jpg":
                        case ".jpeg":
                            return "_Unfurnished.jpg";
                        case ".webp":
                            return "_Unfurnished.webp";
                        default:
                            return t1;
                    }
                }));
                return this.material = new Ig({
                    transparent: !0,
                    side: $n,
                    map: t1,
                    opacity: 0
                }), this.bareshellMaterial = this.material, this;
            }
            async createDefaultMaterial() {
                if (this.defaultMaterial) return this.material = this.defaultMaterial, this.defaultMaterial;
                const t1 = await Lv.get(this.userData.image);
                return this.material = new Ig({
                    transparent: !0,
                    side: $n,
                    map: t1,
                    opacity: 0
                }), this.defaultMaterial = this.material, this;
            }
            async createMaterial() {
                const t1 = await (fN.bareshell ? this.createBareshellMaterial() : this.createDefaultMaterial());
                return this.invoke("materialcreate"), t1;
            }
            async fadeOut() {
                return await fx(this.material).then(()=>this.visible = !1);
            }
            async fadeIn() {
                return this.visible = !0, await Ax(this.material);
            }
        }, LI = class extends CI {
            constructor(t1){
                performance.mark("start creating BoxGeometry");
                const e = new ju(2e3, 2e3, 2e3).scale(-1, 1, 1);
                performance.mark("finish creating BoxGeometry"), performance.measure("creating BoxGeometry", "start creating BoxGeometry", "finish creating BoxGeometry"), super(t1, e), this.userData.cubemap = [
                    {
                        url: t1.images.front,
                        rotation: 0
                    },
                    {
                        url: t1.images.back,
                        rotation: 0
                    },
                    {
                        url: t1.images.top,
                        rotation: 90
                    },
                    {
                        url: t1.images.bottom,
                        rotation: 270
                    },
                    {
                        url: t1.images.left,
                        rotation: 0
                    },
                    {
                        url: t1.images.right,
                        rotation: 0
                    }
                ];
            }
            async loadSides() {
                let t1 = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
                const { cubemap: e } = this.userData;
                let i = 0;
                const n = e.length, r = new Array(e.length);
                return new Promise((a)=>{
                    const s = ()=>{
                        i++, i === n && a(r);
                    };
                    e.forEach((e, i)=>{
                        let n = e.url;
                        if (t1) {
                            const t1 = /(Panorama_\d_\d_\d_([a-zA-Zа-яА-Я0-9-]+)\/.+)\.[a-zA-Z0-9]+/gm, i = e.url.match(t1)[0], r = i.replace("/", "_Unfurnished/");
                            n = e.url.replace(i, r);
                        }
                        Lv.get(n).then((t1)=>{
                            t1.rotation = gx(e.rotation), r[i] = t1, s();
                        }).catch(s);
                    });
                });
            }
            async createBareshellMaterial() {
                if (this.bareshellMaterial) return this.material = this.bareshellMaterial, this.bareshellMaterial;
                const t1 = await this.loadSides(!0);
                this.material = t1.map((t1)=>new Ig({
                        transparent: !0,
                        side: $n,
                        opacity: 0,
                        map: t1
                    })), this.bareshellMaterial = this.material;
            }
            async createDefaultMaterial() {
                if (this.defaultMaterial) return this.material = this.defaultMaterial, this.defaultMaterial;
                const t1 = await this.loadSides();
                this.material = t1.map((t1)=>new Ig({
                        transparent: !0,
                        side: $n,
                        opacity: 0,
                        map: t1
                    })), this.defaultMaterial = this.material;
            }
            async createMaterial() {
                const t1 = await (fN.bareshell ? this.createBareshellMaterial() : this.createDefaultMaterial());
                return this.invoke("materialcreate"), t1;
            }
            async fadeOut() {
                const t1 = this.material.map(fx);
                return await Promise.all(t1).then(()=>this.visible = !1);
            }
            async fadeIn() {
                this.visible = !0;
                const t1 = this.material.map(Ax);
                return await Promise.all(t1);
            }
        };
        function OI(t1, e, i) {
            return (e = function(t1) {
                var e = function(t1) {
                    if ("object" != typeof t1 || !t1) return t1;
                    var e = t1[Symbol.toPrimitive];
                    if (void 0 !== e) {
                        var i = e.call(t1, "string");
                        if ("object" != typeof i) return i;
                        throw new TypeError("@@toPrimitive must return a primitive value.");
                    }
                    return String(t1);
                }(t1);
                return "symbol" == typeof e ? e : e + "";
            }(e)) in t1 ? Object.defineProperty(t1, e, {
                value: i,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : t1[e] = i, t1;
        }
        const _I = class extends Sp {
            constructor(t1){
                super(), OI(this, "type", "sphere"), OI(this, "items", []), OI(this, "floorIndex", void 0), this.floorIndex = t1;
            }
            getCreatedPanoramas() {
                const { json: t1 } = zn.config, e = t1.Floors[zn.currentFloorIndex];
                if (!e) return this.items.map((t1)=>{
                    const e = {
                        svgPathActions: [],
                        roomPanoramas: [],
                        rotation: 0,
                        points: [],
                        left: 0,
                        top: 0,
                        ...t1
                    };
                    return this.createPanorama(e);
                });
                const { primaryCameraPointId: i } = zn, n = hx(t1, i), { Walls: r } = e, { Vertices: a } = t1;
                return this.items.reduce((e, i)=>{
                    var s;
                    performance.mark("start getting rooms, cameras, svg paths ...");
                    const o = hx(t1, i.camera_id), l = ux(t1, i.room_id), c = this.items.reduce((t1, e)=>e.room_id !== i.room_id ? t1 : [
                            ...t1,
                            e.camera_id
                        ], []), u = ((t1, e, i)=>{
                        const n = t1.Walls.reduce((t1, n)=>{
                            const r = e.find((t1)=>t1.ID === n);
                            return cx(e, r.ID, i).forEach((e)=>t1.push(e)), t1;
                        }, []);
                        return n;
                    })(l, r, a), h = l.Walls.reduce((t1, e, i)=>{
                        const n = r.find((t1)=>t1.ID === e), [s, o] = cx(r, e, a), l = [];
                        return 0 === i && t1.push({
                            type: "M",
                            x: s[0],
                            y: s[1]
                        }), t1.push({
                            type: "L",
                            x: s[0],
                            y: s[1]
                        }), n.ControlPoint && l.push({
                            type: "Q",
                            x: n.ControlPoint.Location.X,
                            y: n.ControlPoint.Location.Y,
                            dx: o[0],
                            dy: o[1]
                        }), l.push({
                            type: "L",
                            x: o[0],
                            y: o[1]
                        }), [
                            ...t1,
                            ...l
                        ];
                    }, []);
                    performance.mark("finish getting rooms, cameras, svg paths ..."), performance.measure("getting rooms, cameras, svg paths ...", "start getting rooms, cameras, svg paths ...", "finish getting rooms, cameras, svg paths ...");
                    const [d, p] = o ? [
                        o.Location.X,
                        o.Location.Y
                    ] : function(t1) {
                        let e = 0, i = 0, n = t1.length;
                        for(let r = 0; r < n; r++){
                            const n = t1[r];
                            e += n[0], i += n[1];
                        }
                        return [
                            e / n,
                            i / n
                        ];
                    }(u), f = -1 * gx((null === (s = o.Rotation) || void 0 === s ? void 0 : s.Yaw) || 0), A = {
                        svgPathActions: [],
                        roomPanoramas: [],
                        rotation: 0,
                        points: [],
                        left: 0,
                        top: 0,
                        ...i,
                        cameraData: o || null,
                        roomPanoramas: c,
                        svgPathActions: h,
                        rotation: f,
                        points: u,
                        left: d,
                        top: p
                    }, g = this.createPanorama(A);
                    return n && n.ID === o.ID ? (e.unshift(g), e) : n || l.ID !== zn.initialPanoramaRoomId ? (e.push(g), e) : (e.unshift(g), e);
                }, []);
            }
            createPanoramas(t1, e) {
                this.items = t1, this.type = e, performance.mark("start create panorama's data");
                const i = this.getCreatedPanoramas();
                return performance.mark("finish create panorama's data"), performance.measure("creating panorama's data", "start create panorama's data", "finish create panorama's data"), i.forEach((t1, e)=>{
                    t1.userData.panorama_index = e, zn.config.json && t1.createLinks(i);
                }), i;
            }
            createPanorama(t1) {
                const e = "cube" === this.type ? new LI(t1) : new zI(t1);
                return e.addEventListener("materialcreate", ()=>{
                    ((t1, e)=>{
                        var i, n, r;
                        const { currentFloorIndex: a } = zn, s = null == t1 || null === (i = t1.Floors) || void 0 === i || null === (i = i[a]) || void 0 === i ? void 0 : i.CameraPoints;
                        if (!s) return void console.warn("Panorama cache: can't get floor cameras!");
                        const o = null === (n = zn.configParams.floors) || void 0 === n || null === (n = n[a]) || void 0 === n || null === (n = n.panorama) || void 0 === n ? void 0 : n.items;
                        if (!o) return void console.warn("Panorama cache: can't get panorama images data!");
                        let l = null;
                        const c = [];
                        if (s.forEach((t1)=>{
                            var i;
                            if (t1.ID === e) return void (l = t1);
                            const n = null === (i = o.find((e)=>e.camera_id === t1.ID)) || void 0 === i ? void 0 : i.images;
                            n && c.push({
                                id: t1.ID,
                                images: n.sphere ? [
                                    n.sphere
                                ] : [
                                    n.front,
                                    n.back,
                                    n.left,
                                    n.right,
                                    n.top,
                                    n.bottom
                                ],
                                location: t1.Location
                            });
                        }), !l) return;
                        const u = null !== (r = zn.config.preloadPerPanoramaCount) && void 0 !== r ? r : 3;
                        c.length > u && c.sort((t1, e)=>{
                            if (zn.config.forcePreloadNonCached) {
                                const i = Number(t1.images.every((t1)=>Lv.isCached(t1))), n = Number(e.images.every((t1)=>Lv.isCached(t1)));
                                if (i || n) return i - n;
                            }
                            return xx(t1.location, l.Location) - xx(e.location, l.Location);
                        });
                        const h = Math.min(u, c.length);
                        for(let t1 = 0; t1 < h; t1++)c[t1].images.forEach((t1)=>{
                            Lv.cache(t1);
                        });
                    })(zn.config.json, e.panoramaId);
                }), e.visible = !1, this.add(e), e;
            }
        };
        const jI = class extends _p {
            constructor(){
                var t1, e, i;
                super({
                    preserveDrawingBuffer: !0,
                    antialias: !0,
                    alpha: !0
                }), t1 = this, i = void 0, (e = function(t1) {
                    var e = function(t1) {
                        if ("object" != typeof t1 || !t1) return t1;
                        var e = t1[Symbol.toPrimitive];
                        if (void 0 !== e) {
                            var i = e.call(t1, "string");
                            if ("object" != typeof i) return i;
                            throw new TypeError("@@toPrimitive must return a primitive value.");
                        }
                        return String(t1);
                    }(t1);
                    return "symbol" == typeof e ? e : e + "";
                }(e = "currentVrSession")) in t1 ? Object.defineProperty(t1, e, {
                    value: i,
                    enumerable: !0,
                    configurable: !0,
                    writable: !0
                }) : t1[e] = i, this.toneMapping = Fr, this.toneMappingExposure = 1, this.setPixelRatio(window.devicePixelRatio), this.setClearColor(new kc(0), 0), this.setClearAlpha(1), this.xr.setReferenceSpaceType("local"), this.xr.enabled = !0;
            }
            async checkVrSessionSupport() {
                try {
                    return await navigator.xr.isSessionSupported("immersive-vr");
                } catch (t1) {
                    return !1;
                }
            }
            async onSessionStarted(t1) {
                t1.addEventListener("end", this.onSessionEnded.bind(this)), await this.xr.setSession(t1), this.xr.setFoveation(0), this.currentVrSession = t1;
            }
            onSessionEnded() {
                this.currentVrSession.removeEventListener("end", this.onSessionEnded.bind(this)), this.currentVrSession = null;
            }
            async enterVR() {
                return await navigator.xr.requestSession("immersive-vr", {
                    optionalFeatures: [
                        "local-floor",
                        "bounded-floor",
                        "hand-tracking",
                        "layers"
                    ]
                }).then(this.onSessionStarted.bind(this));
            }
            async exitVR() {
                if (this.currentVrSession) return await this.xr.getSession().end();
            }
        };
        function PI(t1, e, i) {
            return (e = function(t1) {
                var e = function(t1) {
                    if ("object" != typeof t1 || !t1) return t1;
                    var e = t1[Symbol.toPrimitive];
                    if (void 0 !== e) {
                        var i = e.call(t1, "string");
                        if ("object" != typeof i) return i;
                        throw new TypeError("@@toPrimitive must return a primitive value.");
                    }
                    return String(t1);
                }(t1);
                return "symbol" == typeof e ? e : e + "";
            }(e)) in t1 ? Object.defineProperty(t1, e, {
                value: i,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : t1[e] = i, t1;
        }
        const RI = class {
            constructor(t1, e){
                PI(this, "deviceOrientation", {}), PI(this, "screenOrientation", 0), PI(this, "alphaOffsetAngle", 0), PI(this, "connected", !1), PI(this, "enabled", !1), PI(this, "domElement", void 0), PI(this, "alpha", 0), PI(this, "tempX", 0), PI(this, "tempY", 0), PI(this, "rotY", 0), PI(this, "rotX", 0), PI(this, "camera", void 0), this.camera = t1, this.camera.rotation.reorder("YXZ"), this.domElement = e || document;
            }
            enable() {
                this.enabled = !0;
            }
            disable() {
                this.enabled = !1;
            }
            connect() {
                this.onScreenOrientationChange(), window.addEventListener("orientationchange", this.onScreenOrientationChange.bind(this)), window.addEventListener("deviceorientation", this.onDeviceOrientationChange.bind(this)), window.addEventListener("deviceorientation", this.update.bind(this)), this.domElement.addEventListener("touchstart", this.onTouchStart.bind(this)), this.domElement.addEventListener("touchmove", this.onTouchMove.bind(this)), this.connected = !0;
            }
            disconnect() {
                window.removeEventListener("orientationchange", this.onScreenOrientationChange.bind(this)), window.removeEventListener("deviceorientation", this.onDeviceOrientationChange.bind(this)), window.removeEventListener("deviceorientation", this.update.bind(this)), this.domElement.removeEventListener("touchstart", this.onTouchStart), this.domElement.removeEventListener("touchmove", this.onTouchMove), this.connected = !1;
            }
            onDeviceOrientationChange(t1) {
                this.deviceOrientation = t1;
            }
            onScreenOrientationChange() {
                this.screenOrientation = window.orientation || 0;
            }
            onTouchStart(t1) {
                t1.preventDefault(), t1.stopPropagation(), this.tempX = t1.touches[0].pageX, this.tempY = t1.touches[0].pageY;
            }
            onTouchMove(t1) {
                t1.preventDefault(), t1.stopPropagation(), this.rotY += gx((t1.touches[0].pageX - this.tempX) / 4), this.rotX += gx((this.tempY - t1.touches[0].pageY) / 4), this.updateAlphaOffsetAngle(this.rotY), this.tempX = t1.touches[0].pageX, this.tempY = t1.touches[0].pageY;
            }
            setCameraQuaternion(t1, e, i, n, r) {
                const a = new xl(0, 0, 1), s = new oc, o = new vl, l = new vl(-Math.sqrt(.5), 0, 0, Math.sqrt(.5)), c = new vl, u = new vl;
                let h = null;
                0 === this.screenOrientation ? (h = new xl(1, 0, 0), c.setFromAxisAngle(h, -this.rotX)) : 180 === this.screenOrientation ? (h = new xl(1, 0, 0), c.setFromAxisAngle(h, this.rotX)) : 90 === this.screenOrientation ? (h = new xl(0, 1, 0), c.setFromAxisAngle(h, this.rotX)) : -90 === this.screenOrientation && (h = new xl(0, 1, 0), c.setFromAxisAngle(h, -this.rotX)), l.multiply(c), l.multiply(u), s.set(i, e, -n, "YXZ"), t1.setFromEuler(s), t1.multiply(l), t1.multiply(o.setFromAxisAngle(a, -r));
            }
            updateAlphaOffsetAngle(t1) {
                this.alphaOffsetAngle = t1, this.update();
            }
            update() {
                if (!1 === this.enabled) return;
                const t1 = this.deviceOrientation.alpha ? gx(this.deviceOrientation.alpha + 90) + this.alphaOffsetAngle : 0, e = this.deviceOrientation.beta ? gx(this.deviceOrientation.beta) : 0, i = this.deviceOrientation.gamma ? gx(this.deviceOrientation.gamma) : 0, n = this.screenOrientation ? gx(this.screenOrientation) : 0;
                this.setCameraQuaternion(this.camera.quaternion, t1, e, i, n), this.alpha = t1;
            }
            dispose() {
                this.disconnect();
            }
        }, UI = Object.freeze({
            NONE: 0,
            ROTATE: 1,
            TRUCK: 2,
            OFFSET: 4,
            DOLLY: 8,
            ZOOM: 16,
            TOUCH_ROTATE: 32,
            TOUCH_TRUCK: 64,
            TOUCH_OFFSET: 128,
            TOUCH_DOLLY: 256,
            TOUCH_ZOOM: 512,
            TOUCH_DOLLY_TRUCK: 1024,
            TOUCH_DOLLY_OFFSET: 2048,
            TOUCH_DOLLY_ROTATE: 4096,
            TOUCH_ZOOM_TRUCK: 8192,
            TOUCH_ZOOM_OFFSET: 16384,
            TOUCH_ZOOM_ROTATE: 32768
        });
        function kI(t1) {
            return t1.isPerspectiveCamera;
        }
        function BI(t1) {
            return t1.isOrthographicCamera;
        }
        const FI = 2 * Math.PI, QI = Math.PI / 2, HI = 1e-5, VI = Math.PI / 180;
        function GI(t1, e, i) {
            return Math.max(e, Math.min(i, t1));
        }
        function YI(t1, e = HI) {
            return Math.abs(t1) < e;
        }
        function WI(t1, e, i = HI) {
            return YI(t1 - e, i);
        }
        function XI(t1, e) {
            return Math.round(t1 / e) * e;
        }
        function ZI(t1) {
            return isFinite(t1) ? t1 : t1 < 0 ? -Number.MAX_VALUE : Number.MAX_VALUE;
        }
        function JI(t1) {
            return Math.abs(t1) < Number.MAX_VALUE ? t1 : t1 * (1 / 0);
        }
        function KI(t1, e, i, n, r = 1 / 0, a) {
            const s = 2 / (n = Math.max(1e-4, n)), o = s * a, l = 1 / (1 + o + .48 * o * o + .235 * o * o * o);
            let c = t1 - e;
            const u = e, h = r * n;
            c = GI(c, -h, h), e = t1 - c;
            const d = (i.value + s * c) * a;
            i.value = (i.value - s * d) * l;
            let p = e + (c + d) * l;
            return u - t1 > 0 == p > u && (p = u, i.value = (p - u) / a), p;
        }
        function qI(t1, e, i, n, r = 1 / 0, a, s) {
            const o = 2 / (n = Math.max(1e-4, n)), l = o * a, c = 1 / (1 + l + .48 * l * l + .235 * l * l * l);
            let u = e.x, h = e.y, d = e.z, p = t1.x - u, f = t1.y - h, A = t1.z - d;
            const g = u, m = h, M = d, y = r * n, v = p * p + f * f + A * A;
            if (v > y * y) {
                const t1 = Math.sqrt(v);
                p = p / t1 * y, f = f / t1 * y, A = A / t1 * y;
            }
            u = t1.x - p, h = t1.y - f, d = t1.z - A;
            const x = (i.x + o * p) * a, w = (i.y + o * f) * a, b = (i.z + o * A) * a;
            i.x = (i.x - o * x) * c, i.y = (i.y - o * w) * c, i.z = (i.z - o * b) * c, s.x = u + (p + x) * c, s.y = h + (f + w) * c, s.z = d + (A + b) * c;
            const T = g - t1.x, E = m - t1.y, I = M - t1.z;
            return T * (s.x - g) + E * (s.y - m) + I * (s.z - M) > 0 && (s.x = g, s.y = m, s.z = M, i.x = (s.x - g) / a, i.y = (s.y - m) / a, i.z = (s.z - M) / a), s;
        }
        function $I(t1, e) {
            e.set(0, 0), t1.forEach((t1)=>{
                e.x += t1.clientX, e.y += t1.clientY;
            }), e.x /= t1.length, e.y /= t1.length;
        }
        function tS(t1, e) {
            return !!BI(t1) && (console.warn(`${e} is not supported in OrthographicCamera`), !0);
        }
        class eS {
            constructor(){
                this._listeners = {};
            }
            addEventListener(t1, e) {
                const i = this._listeners;
                void 0 === i[t1] && (i[t1] = []), -1 === i[t1].indexOf(e) && i[t1].push(e);
            }
            hasEventListener(t1, e) {
                const i = this._listeners;
                return void 0 !== i[t1] && -1 !== i[t1].indexOf(e);
            }
            removeEventListener(t1, e) {
                const i = this._listeners[t1];
                if (void 0 !== i) {
                    const t1 = i.indexOf(e);
                    -1 !== t1 && i.splice(t1, 1);
                }
            }
            removeAllEventListeners(t1) {
                t1 ? Array.isArray(this._listeners[t1]) && (this._listeners[t1].length = 0) : this._listeners = {};
            }
            dispatchEvent(t1) {
                const e = this._listeners[t1.type];
                if (void 0 !== e) {
                    t1.target = this;
                    const i = e.slice(0);
                    for(let e = 0, n = i.length; e < n; e++)i[e].call(this, t1);
                }
            }
        }
        var iS;
        const nS = 1 / 8, rS = /Mac/.test(null === (iS = null === globalThis || void 0 === globalThis ? void 0 : globalThis.navigator) || void 0 === iS ? void 0 : iS.platform);
        let aS, sS, oS, lS, cS, uS, hS, dS, pS, fS, AS, gS, mS, MS, yS, vS, xS, wS, bS, TS, ES, IS, SS;
        class NS extends eS {
            static install(t1) {
                aS = t1.THREE, sS = Object.freeze(new aS.Vector3(0, 0, 0)), oS = Object.freeze(new aS.Vector3(0, 1, 0)), lS = Object.freeze(new aS.Vector3(0, 0, 1)), cS = new aS.Vector2, uS = new aS.Vector3, hS = new aS.Vector3, dS = new aS.Vector3, pS = new aS.Vector3, fS = new aS.Vector3, AS = new aS.Vector3, gS = new aS.Vector3, mS = new aS.Vector3, MS = new aS.Vector3, yS = new aS.Spherical, vS = new aS.Spherical, xS = new aS.Box3, wS = new aS.Box3, bS = new aS.Sphere, TS = new aS.Quaternion, ES = new aS.Quaternion, IS = new aS.Matrix4, SS = new aS.Raycaster;
            }
            static get ACTION() {
                return UI;
            }
            constructor(t1, e){
                super(), this.minPolarAngle = 0, this.maxPolarAngle = Math.PI, this.minAzimuthAngle = -1 / 0, this.maxAzimuthAngle = 1 / 0, this.minDistance = Number.EPSILON, this.maxDistance = 1 / 0, this.infinityDolly = !1, this.minZoom = .01, this.maxZoom = 1 / 0, this.smoothTime = .25, this.draggingSmoothTime = .125, this.maxSpeed = 1 / 0, this.azimuthRotateSpeed = 1, this.polarRotateSpeed = 1, this.dollySpeed = 1, this.dollyDragInverted = !1, this.truckSpeed = 2, this.dollyToCursor = !1, this.dragToOffset = !1, this.verticalDragToForward = !1, this.boundaryFriction = 0, this.restThreshold = .01, this.colliderMeshes = [], this.cancel = ()=>{}, this._enabled = !0, this._state = UI.NONE, this._viewport = null, this._changedDolly = 0, this._changedZoom = 0, this._hasRested = !0, this._boundaryEnclosesCamera = !1, this._needsUpdate = !0, this._updatedLastTime = !1, this._elementRect = new DOMRect, this._isDragging = !1, this._dragNeedsUpdate = !0, this._activePointers = [], this._lockedPointer = null, this._interactiveArea = new DOMRect(0, 0, 1, 1), this._isUserControllingRotate = !1, this._isUserControllingDolly = !1, this._isUserControllingTruck = !1, this._isUserControllingOffset = !1, this._isUserControllingZoom = !1, this._lastDollyDirection = 0, this._thetaVelocity = {
                    value: 0
                }, this._phiVelocity = {
                    value: 0
                }, this._radiusVelocity = {
                    value: 0
                }, this._targetVelocity = new aS.Vector3, this._focalOffsetVelocity = new aS.Vector3, this._zoomVelocity = {
                    value: 0
                }, this._truckInternal = (t1, e, i)=>{
                    let n, r;
                    if (kI(this._camera)) {
                        const i = uS.copy(this._camera.position).sub(this._target), a = this._camera.getEffectiveFOV() * VI, s = i.length() * Math.tan(.5 * a);
                        n = this.truckSpeed * t1 * s / this._elementRect.height, r = this.truckSpeed * e * s / this._elementRect.height;
                    } else {
                        if (!BI(this._camera)) return;
                        {
                            const i = this._camera;
                            n = t1 * (i.right - i.left) / i.zoom / this._elementRect.width, r = e * (i.top - i.bottom) / i.zoom / this._elementRect.height;
                        }
                    }
                    this.verticalDragToForward ? (i ? this.setFocalOffset(this._focalOffsetEnd.x + n, this._focalOffsetEnd.y, this._focalOffsetEnd.z, !0) : this.truck(n, 0, !0), this.forward(-r, !0)) : i ? this.setFocalOffset(this._focalOffsetEnd.x + n, this._focalOffsetEnd.y + r, this._focalOffsetEnd.z, !0) : this.truck(n, r, !0);
                }, this._rotateInternal = (t1, e)=>{
                    const i = FI * this.azimuthRotateSpeed * t1 / this._elementRect.height, n = FI * this.polarRotateSpeed * e / this._elementRect.height;
                    this.rotate(i, n, !0);
                }, this._dollyInternal = (t1, e, i)=>{
                    const n = Math.pow(.95, -t1 * this.dollySpeed), r = this._sphericalEnd.radius, a = this._sphericalEnd.radius * n, s = GI(a, this.minDistance, this.maxDistance), o = s - a;
                    this.infinityDolly && this.dollyToCursor ? this._dollyToNoClamp(a, !0) : this.infinityDolly && !this.dollyToCursor ? (this.dollyInFixed(o, !0), this._dollyToNoClamp(s, !0)) : this._dollyToNoClamp(s, !0), this.dollyToCursor && (this._changedDolly += (this.infinityDolly ? a : s) - r, this._dollyControlCoord.set(e, i)), this._lastDollyDirection = Math.sign(-t1);
                }, this._zoomInternal = (t1, e, i)=>{
                    const n = Math.pow(.95, t1 * this.dollySpeed), r = this._zoom, a = this._zoom * n;
                    this.zoomTo(a, !0), this.dollyToCursor && (this._changedZoom += a - r, this._dollyControlCoord.set(e, i));
                }, void 0 === aS && console.error("camera-controls: `THREE` is undefined. You must first run `CameraControls.install( { THREE: THREE } )`. Check the docs for further information."), this._camera = t1, this._yAxisUpSpace = (new aS.Quaternion).setFromUnitVectors(this._camera.up, oS), this._yAxisUpSpaceInverse = this._yAxisUpSpace.clone().invert(), this._state = UI.NONE, this._target = new aS.Vector3, this._targetEnd = this._target.clone(), this._focalOffset = new aS.Vector3, this._focalOffsetEnd = this._focalOffset.clone(), this._spherical = (new aS.Spherical).setFromVector3(uS.copy(this._camera.position).applyQuaternion(this._yAxisUpSpace)), this._sphericalEnd = this._spherical.clone(), this._lastDistance = this._spherical.radius, this._zoom = this._camera.zoom, this._zoomEnd = this._zoom, this._lastZoom = this._zoom, this._nearPlaneCorners = [
                    new aS.Vector3,
                    new aS.Vector3,
                    new aS.Vector3,
                    new aS.Vector3
                ], this._updateNearPlaneCorners(), this._boundary = new aS.Box3(new aS.Vector3(-1 / 0, -1 / 0, -1 / 0), new aS.Vector3(1 / 0, 1 / 0, 1 / 0)), this._cameraUp0 = this._camera.up.clone(), this._target0 = this._target.clone(), this._position0 = this._camera.position.clone(), this._zoom0 = this._zoom, this._focalOffset0 = this._focalOffset.clone(), this._dollyControlCoord = new aS.Vector2, this.mouseButtons = {
                    left: UI.ROTATE,
                    middle: UI.DOLLY,
                    right: UI.TRUCK,
                    wheel: kI(this._camera) ? UI.DOLLY : BI(this._camera) ? UI.ZOOM : UI.NONE
                }, this.touches = {
                    one: UI.TOUCH_ROTATE,
                    two: kI(this._camera) ? UI.TOUCH_DOLLY_TRUCK : BI(this._camera) ? UI.TOUCH_ZOOM_TRUCK : UI.NONE,
                    three: UI.TOUCH_TRUCK
                };
                const i = new aS.Vector2, n = new aS.Vector2, r = new aS.Vector2, a = (t1)=>{
                    if (!this._enabled || !this._domElement) return;
                    if (0 !== this._interactiveArea.left || 0 !== this._interactiveArea.top || 1 !== this._interactiveArea.width || 1 !== this._interactiveArea.height) {
                        const e = this._domElement.getBoundingClientRect(), i = t1.clientX / e.width, n = t1.clientY / e.height;
                        if (i < this._interactiveArea.left || i > this._interactiveArea.right || n < this._interactiveArea.top || n > this._interactiveArea.bottom) return;
                    }
                    const e = "mouse" !== t1.pointerType ? null : 1 & ~t1.buttons ? 4 & ~t1.buttons ? 2 & ~t1.buttons ? null : 2 : 4 : 1;
                    if (null !== e) {
                        const t1 = this._findPointerByMouseButton(e);
                        t1 && this._disposePointer(t1);
                    }
                    if (!(1 & ~t1.buttons) && this._lockedPointer) return;
                    const i = {
                        pointerId: t1.pointerId,
                        clientX: t1.clientX,
                        clientY: t1.clientY,
                        deltaX: 0,
                        deltaY: 0,
                        mouseButton: e
                    };
                    this._activePointers.push(i), this._domElement.ownerDocument.removeEventListener("pointermove", s, {
                        passive: !1
                    }), this._domElement.ownerDocument.removeEventListener("pointerup", o), this._domElement.ownerDocument.addEventListener("pointermove", s, {
                        passive: !1
                    }), this._domElement.ownerDocument.addEventListener("pointerup", o), this._isDragging = !0, h(t1);
                }, s = (t1)=>{
                    t1.cancelable && t1.preventDefault();
                    const e = t1.pointerId, i = this._lockedPointer || this._findPointerById(e);
                    if (i) {
                        if (i.clientX = t1.clientX, i.clientY = t1.clientY, i.deltaX = t1.movementX, i.deltaY = t1.movementY, this._state = 0, "touch" === t1.pointerType) switch(this._activePointers.length){
                            case 1:
                                this._state = this.touches.one;
                                break;
                            case 2:
                                this._state = this.touches.two;
                                break;
                            case 3:
                                this._state = this.touches.three;
                        }
                        else (!this._isDragging && this._lockedPointer || this._isDragging && !(1 & ~t1.buttons)) && (this._state = this._state | this.mouseButtons.left), this._isDragging && !(4 & ~t1.buttons) && (this._state = this._state | this.mouseButtons.middle), this._isDragging && !(2 & ~t1.buttons) && (this._state = this._state | this.mouseButtons.right);
                        d();
                    }
                }, o = (t1)=>{
                    const e = this._findPointerById(t1.pointerId);
                    if (!e || e !== this._lockedPointer) {
                        if (e && this._disposePointer(e), "touch" === t1.pointerType) switch(this._activePointers.length){
                            case 0:
                                this._state = UI.NONE;
                                break;
                            case 1:
                                this._state = this.touches.one;
                                break;
                            case 2:
                                this._state = this.touches.two;
                                break;
                            case 3:
                                this._state = this.touches.three;
                        }
                        else this._state = UI.NONE;
                        p();
                    }
                };
                let l = -1;
                const c = (t1)=>{
                    if (!this._domElement) return;
                    if (!this._enabled || this.mouseButtons.wheel === UI.NONE) return;
                    if (0 !== this._interactiveArea.left || 0 !== this._interactiveArea.top || 1 !== this._interactiveArea.width || 1 !== this._interactiveArea.height) {
                        const e = this._domElement.getBoundingClientRect(), i = t1.clientX / e.width, n = t1.clientY / e.height;
                        if (i < this._interactiveArea.left || i > this._interactiveArea.right || n < this._interactiveArea.top || n > this._interactiveArea.bottom) return;
                    }
                    if (t1.preventDefault(), this.dollyToCursor || this.mouseButtons.wheel === UI.ROTATE || this.mouseButtons.wheel === UI.TRUCK) {
                        const t1 = performance.now();
                        l - t1 < 1e3 && this._getClientRect(this._elementRect), l = t1;
                    }
                    const e = rS ? -1 : -3, i = 1 === t1.deltaMode ? t1.deltaY / e : t1.deltaY / (10 * e), n = this.dollyToCursor ? (t1.clientX - this._elementRect.x) / this._elementRect.width * 2 - 1 : 0, r = this.dollyToCursor ? (t1.clientY - this._elementRect.y) / this._elementRect.height * -2 + 1 : 0;
                    switch(this.mouseButtons.wheel){
                        case UI.ROTATE:
                            this._rotateInternal(t1.deltaX, t1.deltaY), this._isUserControllingRotate = !0;
                            break;
                        case UI.TRUCK:
                            this._truckInternal(t1.deltaX, t1.deltaY, !1), this._isUserControllingTruck = !0;
                            break;
                        case UI.OFFSET:
                            this._truckInternal(t1.deltaX, t1.deltaY, !0), this._isUserControllingOffset = !0;
                            break;
                        case UI.DOLLY:
                            this._dollyInternal(-i, n, r), this._isUserControllingDolly = !0;
                            break;
                        case UI.ZOOM:
                            this._zoomInternal(-i, n, r), this._isUserControllingZoom = !0;
                    }
                    this.dispatchEvent({
                        type: "control"
                    });
                }, u = (t1)=>{
                    if (this._domElement && this._enabled) {
                        if (this.mouseButtons.right === NS.ACTION.NONE) {
                            const e = t1 instanceof PointerEvent ? t1.pointerId : 0, i = this._findPointerById(e);
                            return i && this._disposePointer(i), this._domElement.ownerDocument.removeEventListener("pointermove", s, {
                                passive: !1
                            }), void this._domElement.ownerDocument.removeEventListener("pointerup", o);
                        }
                        t1.preventDefault();
                    }
                }, h = (t1)=>{
                    if (this._enabled) {
                        if ($I(this._activePointers, cS), this._getClientRect(this._elementRect), i.copy(cS), n.copy(cS), this._activePointers.length >= 2) {
                            const t1 = cS.x - this._activePointers[1].clientX, e = cS.y - this._activePointers[1].clientY, i = Math.sqrt(t1 * t1 + e * e);
                            r.set(0, i);
                            const a = .5 * (this._activePointers[0].clientX + this._activePointers[1].clientX), s = .5 * (this._activePointers[0].clientY + this._activePointers[1].clientY);
                            n.set(a, s);
                        }
                        if (this._state = 0, t1) {
                            if ("pointerType" in t1 && "touch" === t1.pointerType) switch(this._activePointers.length){
                                case 1:
                                    this._state = this.touches.one;
                                    break;
                                case 2:
                                    this._state = this.touches.two;
                                    break;
                                case 3:
                                    this._state = this.touches.three;
                            }
                            else this._lockedPointer || !!(1 & ~t1.buttons) || (this._state = this._state | this.mouseButtons.left), !(4 & ~t1.buttons) && (this._state = this._state | this.mouseButtons.middle), !(2 & ~t1.buttons) && (this._state = this._state | this.mouseButtons.right);
                        } else this._lockedPointer && (this._state = this._state | this.mouseButtons.left);
                        (this._state & UI.ROTATE) !== UI.ROTATE && (this._state & UI.TOUCH_ROTATE) !== UI.TOUCH_ROTATE && (this._state & UI.TOUCH_DOLLY_ROTATE) !== UI.TOUCH_DOLLY_ROTATE && (this._state & UI.TOUCH_ZOOM_ROTATE) !== UI.TOUCH_ZOOM_ROTATE || (this._sphericalEnd.theta = this._spherical.theta, this._sphericalEnd.phi = this._spherical.phi, this._thetaVelocity.value = 0, this._phiVelocity.value = 0), (this._state & UI.TRUCK) !== UI.TRUCK && (this._state & UI.TOUCH_TRUCK) !== UI.TOUCH_TRUCK && (this._state & UI.TOUCH_DOLLY_TRUCK) !== UI.TOUCH_DOLLY_TRUCK && (this._state & UI.TOUCH_ZOOM_TRUCK) !== UI.TOUCH_ZOOM_TRUCK || (this._targetEnd.copy(this._target), this._targetVelocity.set(0, 0, 0)), (this._state & UI.DOLLY) !== UI.DOLLY && (this._state & UI.TOUCH_DOLLY) !== UI.TOUCH_DOLLY && (this._state & UI.TOUCH_DOLLY_TRUCK) !== UI.TOUCH_DOLLY_TRUCK && (this._state & UI.TOUCH_DOLLY_OFFSET) !== UI.TOUCH_DOLLY_OFFSET && (this._state & UI.TOUCH_DOLLY_ROTATE) !== UI.TOUCH_DOLLY_ROTATE || (this._sphericalEnd.radius = this._spherical.radius, this._radiusVelocity.value = 0), (this._state & UI.ZOOM) !== UI.ZOOM && (this._state & UI.TOUCH_ZOOM) !== UI.TOUCH_ZOOM && (this._state & UI.TOUCH_ZOOM_TRUCK) !== UI.TOUCH_ZOOM_TRUCK && (this._state & UI.TOUCH_ZOOM_OFFSET) !== UI.TOUCH_ZOOM_OFFSET && (this._state & UI.TOUCH_ZOOM_ROTATE) !== UI.TOUCH_ZOOM_ROTATE || (this._zoomEnd = this._zoom, this._zoomVelocity.value = 0), (this._state & UI.OFFSET) !== UI.OFFSET && (this._state & UI.TOUCH_OFFSET) !== UI.TOUCH_OFFSET && (this._state & UI.TOUCH_DOLLY_OFFSET) !== UI.TOUCH_DOLLY_OFFSET && (this._state & UI.TOUCH_ZOOM_OFFSET) !== UI.TOUCH_ZOOM_OFFSET || (this._focalOffsetEnd.copy(this._focalOffset), this._focalOffsetVelocity.set(0, 0, 0)), this.dispatchEvent({
                            type: "controlstart"
                        });
                    }
                }, d = ()=>{
                    if (!this._enabled || !this._dragNeedsUpdate) return;
                    this._dragNeedsUpdate = !1, $I(this._activePointers, cS);
                    const t1 = this._domElement && this._domElement.ownerDocument.pointerLockElement === this._domElement ? this._lockedPointer || this._activePointers[0] : null, e = t1 ? -t1.deltaX : n.x - cS.x, a = t1 ? -t1.deltaY : n.y - cS.y;
                    if (n.copy(cS), (this._state & UI.ROTATE) !== UI.ROTATE && (this._state & UI.TOUCH_ROTATE) !== UI.TOUCH_ROTATE && (this._state & UI.TOUCH_DOLLY_ROTATE) !== UI.TOUCH_DOLLY_ROTATE && (this._state & UI.TOUCH_ZOOM_ROTATE) !== UI.TOUCH_ZOOM_ROTATE || (this._rotateInternal(e, a), this._isUserControllingRotate = !0), (this._state & UI.DOLLY) === UI.DOLLY || (this._state & UI.ZOOM) === UI.ZOOM) {
                        const t1 = this.dollyToCursor ? (i.x - this._elementRect.x) / this._elementRect.width * 2 - 1 : 0, e = this.dollyToCursor ? (i.y - this._elementRect.y) / this._elementRect.height * -2 + 1 : 0, n = this.dollyDragInverted ? -1 : 1;
                        (this._state & UI.DOLLY) === UI.DOLLY ? (this._dollyInternal(n * a * nS, t1, e), this._isUserControllingDolly = !0) : (this._zoomInternal(n * a * nS, t1, e), this._isUserControllingZoom = !0);
                    }
                    if ((this._state & UI.TOUCH_DOLLY) === UI.TOUCH_DOLLY || (this._state & UI.TOUCH_ZOOM) === UI.TOUCH_ZOOM || (this._state & UI.TOUCH_DOLLY_TRUCK) === UI.TOUCH_DOLLY_TRUCK || (this._state & UI.TOUCH_ZOOM_TRUCK) === UI.TOUCH_ZOOM_TRUCK || (this._state & UI.TOUCH_DOLLY_OFFSET) === UI.TOUCH_DOLLY_OFFSET || (this._state & UI.TOUCH_ZOOM_OFFSET) === UI.TOUCH_ZOOM_OFFSET || (this._state & UI.TOUCH_DOLLY_ROTATE) === UI.TOUCH_DOLLY_ROTATE || (this._state & UI.TOUCH_ZOOM_ROTATE) === UI.TOUCH_ZOOM_ROTATE) {
                        const t1 = cS.x - this._activePointers[1].clientX, e = cS.y - this._activePointers[1].clientY, i = Math.sqrt(t1 * t1 + e * e), a = r.y - i;
                        r.set(0, i);
                        const s = this.dollyToCursor ? (n.x - this._elementRect.x) / this._elementRect.width * 2 - 1 : 0, o = this.dollyToCursor ? (n.y - this._elementRect.y) / this._elementRect.height * -2 + 1 : 0;
                        (this._state & UI.TOUCH_DOLLY) === UI.TOUCH_DOLLY || (this._state & UI.TOUCH_DOLLY_ROTATE) === UI.TOUCH_DOLLY_ROTATE || (this._state & UI.TOUCH_DOLLY_TRUCK) === UI.TOUCH_DOLLY_TRUCK || (this._state & UI.TOUCH_DOLLY_OFFSET) === UI.TOUCH_DOLLY_OFFSET ? (this._dollyInternal(a * nS, s, o), this._isUserControllingDolly = !0) : (this._zoomInternal(a * nS, s, o), this._isUserControllingZoom = !0);
                    }
                    (this._state & UI.TRUCK) !== UI.TRUCK && (this._state & UI.TOUCH_TRUCK) !== UI.TOUCH_TRUCK && (this._state & UI.TOUCH_DOLLY_TRUCK) !== UI.TOUCH_DOLLY_TRUCK && (this._state & UI.TOUCH_ZOOM_TRUCK) !== UI.TOUCH_ZOOM_TRUCK || (this._truckInternal(e, a, !1), this._isUserControllingTruck = !0), (this._state & UI.OFFSET) !== UI.OFFSET && (this._state & UI.TOUCH_OFFSET) !== UI.TOUCH_OFFSET && (this._state & UI.TOUCH_DOLLY_OFFSET) !== UI.TOUCH_DOLLY_OFFSET && (this._state & UI.TOUCH_ZOOM_OFFSET) !== UI.TOUCH_ZOOM_OFFSET || (this._truckInternal(e, a, !0), this._isUserControllingOffset = !0), this.dispatchEvent({
                        type: "control"
                    });
                }, p = ()=>{
                    $I(this._activePointers, cS), n.copy(cS), this._dragNeedsUpdate = !1, (0 === this._activePointers.length || 1 === this._activePointers.length && this._activePointers[0] === this._lockedPointer) && (this._isDragging = !1), 0 === this._activePointers.length && this._domElement && (this._domElement.ownerDocument.removeEventListener("pointermove", s, {
                        passive: !1
                    }), this._domElement.ownerDocument.removeEventListener("pointerup", o), this.dispatchEvent({
                        type: "controlend"
                    }));
                };
                this.lockPointer = ()=>{
                    this._enabled && this._domElement && (this.cancel(), this._lockedPointer = {
                        pointerId: -1,
                        clientX: 0,
                        clientY: 0,
                        deltaX: 0,
                        deltaY: 0,
                        mouseButton: null
                    }, this._activePointers.push(this._lockedPointer), this._domElement.ownerDocument.removeEventListener("pointermove", s, {
                        passive: !1
                    }), this._domElement.ownerDocument.removeEventListener("pointerup", o), this._domElement.requestPointerLock(), this._domElement.ownerDocument.addEventListener("pointerlockchange", f), this._domElement.ownerDocument.addEventListener("pointerlockerror", A), this._domElement.ownerDocument.addEventListener("pointermove", s, {
                        passive: !1
                    }), this._domElement.ownerDocument.addEventListener("pointerup", o), h());
                }, this.unlockPointer = ()=>{
                    var t1, e, i;
                    null !== this._lockedPointer && (this._disposePointer(this._lockedPointer), this._lockedPointer = null), null === (t1 = this._domElement) || void 0 === t1 || t1.ownerDocument.exitPointerLock(), null === (e = this._domElement) || void 0 === e || e.ownerDocument.removeEventListener("pointerlockchange", f), null === (i = this._domElement) || void 0 === i || i.ownerDocument.removeEventListener("pointerlockerror", A), this.cancel();
                };
                const f = ()=>{
                    this._domElement && this._domElement.ownerDocument.pointerLockElement === this._domElement || this.unlockPointer();
                }, A = ()=>{
                    this.unlockPointer();
                };
                this._addAllEventListeners = (t1)=>{
                    this._domElement = t1, this._domElement.style.touchAction = "none", this._domElement.style.userSelect = "none", this._domElement.style.webkitUserSelect = "none", this._domElement.addEventListener("pointerdown", a), this._domElement.addEventListener("pointercancel", o), this._domElement.addEventListener("wheel", c, {
                        passive: !1
                    }), this._domElement.addEventListener("contextmenu", u);
                }, this._removeAllEventListeners = ()=>{
                    this._domElement && (this._domElement.style.touchAction = "", this._domElement.style.userSelect = "", this._domElement.style.webkitUserSelect = "", this._domElement.removeEventListener("pointerdown", a), this._domElement.removeEventListener("pointercancel", o), this._domElement.removeEventListener("wheel", c, {
                        passive: !1
                    }), this._domElement.removeEventListener("contextmenu", u), this._domElement.ownerDocument.removeEventListener("pointermove", s, {
                        passive: !1
                    }), this._domElement.ownerDocument.removeEventListener("pointerup", o), this._domElement.ownerDocument.removeEventListener("pointerlockchange", f), this._domElement.ownerDocument.removeEventListener("pointerlockerror", A));
                }, this.cancel = ()=>{
                    this._state !== UI.NONE && (this._state = UI.NONE, this._activePointers.length = 0, p());
                }, e && this.connect(e), this.update(0);
            }
            get camera() {
                return this._camera;
            }
            set camera(t1) {
                this._camera = t1, this.updateCameraUp(), this._camera.updateProjectionMatrix(), this._updateNearPlaneCorners(), this._needsUpdate = !0;
            }
            get enabled() {
                return this._enabled;
            }
            set enabled(t1) {
                this._enabled = t1, this._domElement && (t1 ? (this._domElement.style.touchAction = "none", this._domElement.style.userSelect = "none", this._domElement.style.webkitUserSelect = "none") : (this.cancel(), this._domElement.style.touchAction = "", this._domElement.style.userSelect = "", this._domElement.style.webkitUserSelect = ""));
            }
            get active() {
                return !this._hasRested;
            }
            get currentAction() {
                return this._state;
            }
            get distance() {
                return this._spherical.radius;
            }
            set distance(t1) {
                this._spherical.radius === t1 && this._sphericalEnd.radius === t1 || (this._spherical.radius = t1, this._sphericalEnd.radius = t1, this._needsUpdate = !0);
            }
            get azimuthAngle() {
                return this._spherical.theta;
            }
            set azimuthAngle(t1) {
                this._spherical.theta === t1 && this._sphericalEnd.theta === t1 || (this._spherical.theta = t1, this._sphericalEnd.theta = t1, this._needsUpdate = !0);
            }
            get polarAngle() {
                return this._spherical.phi;
            }
            set polarAngle(t1) {
                this._spherical.phi === t1 && this._sphericalEnd.phi === t1 || (this._spherical.phi = t1, this._sphericalEnd.phi = t1, this._needsUpdate = !0);
            }
            get boundaryEnclosesCamera() {
                return this._boundaryEnclosesCamera;
            }
            set boundaryEnclosesCamera(t1) {
                this._boundaryEnclosesCamera = t1, this._needsUpdate = !0;
            }
            set interactiveArea(t1) {
                this._interactiveArea.width = GI(t1.width, 0, 1), this._interactiveArea.height = GI(t1.height, 0, 1), this._interactiveArea.x = GI(t1.x, 0, 1 - this._interactiveArea.width), this._interactiveArea.y = GI(t1.y, 0, 1 - this._interactiveArea.height);
            }
            addEventListener(t1, e) {
                super.addEventListener(t1, e);
            }
            removeEventListener(t1, e) {
                super.removeEventListener(t1, e);
            }
            rotate(t1, e, i = !1) {
                return this.rotateTo(this._sphericalEnd.theta + t1, this._sphericalEnd.phi + e, i);
            }
            rotateAzimuthTo(t1, e = !1) {
                return this.rotateTo(t1, this._sphericalEnd.phi, e);
            }
            rotatePolarTo(t1, e = !1) {
                return this.rotateTo(this._sphericalEnd.theta, t1, e);
            }
            rotateTo(t1, e, i = !1) {
                this._isUserControllingRotate = !1;
                const n = GI(t1, this.minAzimuthAngle, this.maxAzimuthAngle), r = GI(e, this.minPolarAngle, this.maxPolarAngle);
                this._sphericalEnd.theta = n, this._sphericalEnd.phi = r, this._sphericalEnd.makeSafe(), this._needsUpdate = !0, i || (this._spherical.theta = this._sphericalEnd.theta, this._spherical.phi = this._sphericalEnd.phi);
                const a = !i || WI(this._spherical.theta, this._sphericalEnd.theta, this.restThreshold) && WI(this._spherical.phi, this._sphericalEnd.phi, this.restThreshold);
                return this._createOnRestPromise(a);
            }
            dolly(t1, e = !1) {
                return this.dollyTo(this._sphericalEnd.radius - t1, e);
            }
            dollyTo(t1, e = !1) {
                return this._isUserControllingDolly = !1, this._lastDollyDirection = 0, this._changedDolly = 0, this._dollyToNoClamp(GI(t1, this.minDistance, this.maxDistance), e);
            }
            _dollyToNoClamp(t1, e = !1) {
                const i = this._sphericalEnd.radius;
                if (this.colliderMeshes.length >= 1) {
                    const e = this._collisionTest(), n = WI(e, this._spherical.radius);
                    if (!(i > t1) && n) return Promise.resolve();
                    this._sphericalEnd.radius = Math.min(t1, e);
                } else this._sphericalEnd.radius = t1;
                this._needsUpdate = !0, e || (this._spherical.radius = this._sphericalEnd.radius);
                const n = !e || WI(this._spherical.radius, this._sphericalEnd.radius, this.restThreshold);
                return this._createOnRestPromise(n);
            }
            dollyInFixed(t1, e = !1) {
                this._targetEnd.add(this._getCameraDirection(pS).multiplyScalar(t1)), e || this._target.copy(this._targetEnd);
                const i = !e || WI(this._target.x, this._targetEnd.x, this.restThreshold) && WI(this._target.y, this._targetEnd.y, this.restThreshold) && WI(this._target.z, this._targetEnd.z, this.restThreshold);
                return this._createOnRestPromise(i);
            }
            zoom(t1, e = !1) {
                return this.zoomTo(this._zoomEnd + t1, e);
            }
            zoomTo(t1, e = !1) {
                this._isUserControllingZoom = !1, this._zoomEnd = GI(t1, this.minZoom, this.maxZoom), this._needsUpdate = !0, e || (this._zoom = this._zoomEnd);
                const i = !e || WI(this._zoom, this._zoomEnd, this.restThreshold);
                return this._changedZoom = 0, this._createOnRestPromise(i);
            }
            pan(t1, e, i = !1) {
                return console.warn("`pan` has been renamed to `truck`"), this.truck(t1, e, i);
            }
            truck(t1, e, i = !1) {
                this._camera.updateMatrix(), fS.setFromMatrixColumn(this._camera.matrix, 0), AS.setFromMatrixColumn(this._camera.matrix, 1), fS.multiplyScalar(t1), AS.multiplyScalar(-e);
                const n = uS.copy(fS).add(AS), r = hS.copy(this._targetEnd).add(n);
                return this.moveTo(r.x, r.y, r.z, i);
            }
            forward(t1, e = !1) {
                uS.setFromMatrixColumn(this._camera.matrix, 0), uS.crossVectors(this._camera.up, uS), uS.multiplyScalar(t1);
                const i = hS.copy(this._targetEnd).add(uS);
                return this.moveTo(i.x, i.y, i.z, e);
            }
            elevate(t1, e = !1) {
                return uS.copy(this._camera.up).multiplyScalar(t1), this.moveTo(this._targetEnd.x + uS.x, this._targetEnd.y + uS.y, this._targetEnd.z + uS.z, e);
            }
            moveTo(t1, e, i, n = !1) {
                this._isUserControllingTruck = !1;
                const r = uS.set(t1, e, i).sub(this._targetEnd);
                this._encloseToBoundary(this._targetEnd, r, this.boundaryFriction), this._needsUpdate = !0, n || this._target.copy(this._targetEnd);
                const a = !n || WI(this._target.x, this._targetEnd.x, this.restThreshold) && WI(this._target.y, this._targetEnd.y, this.restThreshold) && WI(this._target.z, this._targetEnd.z, this.restThreshold);
                return this._createOnRestPromise(a);
            }
            lookInDirectionOf(t1, e, i, n = !1) {
                const r = uS.set(t1, e, i).sub(this._targetEnd).normalize().multiplyScalar(-this._sphericalEnd.radius).add(this._targetEnd);
                return this.setPosition(r.x, r.y, r.z, n);
            }
            fitToBox(t1, e, { cover: i = !1, paddingLeft: n = 0, paddingRight: r = 0, paddingBottom: a = 0, paddingTop: s = 0 } = {}) {
                const o = [], l = t1.isBox3 ? xS.copy(t1) : xS.setFromObject(t1);
                l.isEmpty() && (console.warn("camera-controls: fitTo() cannot be used with an empty box. Aborting"), Promise.resolve());
                const c = XI(this._sphericalEnd.theta, QI), u = XI(this._sphericalEnd.phi, QI);
                o.push(this.rotateTo(c, u, e));
                const h = uS.setFromSpherical(this._sphericalEnd).normalize(), d = TS.setFromUnitVectors(h, lS), p = WI(Math.abs(h.y), 1);
                p && d.multiply(ES.setFromAxisAngle(oS, c)), d.multiply(this._yAxisUpSpaceInverse);
                const f = wS.makeEmpty();
                hS.copy(l.min).applyQuaternion(d), f.expandByPoint(hS), hS.copy(l.min).setX(l.max.x).applyQuaternion(d), f.expandByPoint(hS), hS.copy(l.min).setY(l.max.y).applyQuaternion(d), f.expandByPoint(hS), hS.copy(l.max).setZ(l.min.z).applyQuaternion(d), f.expandByPoint(hS), hS.copy(l.min).setZ(l.max.z).applyQuaternion(d), f.expandByPoint(hS), hS.copy(l.max).setY(l.min.y).applyQuaternion(d), f.expandByPoint(hS), hS.copy(l.max).setX(l.min.x).applyQuaternion(d), f.expandByPoint(hS), hS.copy(l.max).applyQuaternion(d), f.expandByPoint(hS), f.min.x -= n, f.min.y -= a, f.max.x += r, f.max.y += s, d.setFromUnitVectors(lS, h), p && d.premultiply(ES.invert()), d.premultiply(this._yAxisUpSpace);
                const A = f.getSize(uS), g = f.getCenter(hS).applyQuaternion(d);
                if (kI(this._camera)) {
                    const t1 = this.getDistanceToFitBox(A.x, A.y, A.z, i);
                    o.push(this.moveTo(g.x, g.y, g.z, e)), o.push(this.dollyTo(t1, e)), o.push(this.setFocalOffset(0, 0, 0, e));
                } else if (BI(this._camera)) {
                    const t1 = this._camera, n = t1.right - t1.left, r = t1.top - t1.bottom, a = i ? Math.max(n / A.x, r / A.y) : Math.min(n / A.x, r / A.y);
                    o.push(this.moveTo(g.x, g.y, g.z, e)), o.push(this.zoomTo(a, e)), o.push(this.setFocalOffset(0, 0, 0, e));
                }
                return Promise.all(o);
            }
            fitToSphere(t1, e) {
                const i = [], n = "isObject3D" in t1 ? NS.createBoundingSphere(t1, bS) : bS.copy(t1);
                if (i.push(this.moveTo(n.center.x, n.center.y, n.center.z, e)), kI(this._camera)) {
                    const t1 = this.getDistanceToFitSphere(n.radius);
                    i.push(this.dollyTo(t1, e));
                } else if (BI(this._camera)) {
                    const t1 = this._camera.right - this._camera.left, r = this._camera.top - this._camera.bottom, a = 2 * n.radius, s = Math.min(t1 / a, r / a);
                    i.push(this.zoomTo(s, e));
                }
                return i.push(this.setFocalOffset(0, 0, 0, e)), Promise.all(i);
            }
            setLookAt(t1, e, i, n, r, a, s = !1) {
                this._isUserControllingRotate = !1, this._isUserControllingDolly = !1, this._isUserControllingTruck = !1, this._lastDollyDirection = 0, this._changedDolly = 0;
                const o = hS.set(n, r, a), l = uS.set(t1, e, i);
                this._targetEnd.copy(o), this._sphericalEnd.setFromVector3(l.sub(o).applyQuaternion(this._yAxisUpSpace)), this.normalizeRotations(), this._needsUpdate = !0, s || (this._target.copy(this._targetEnd), this._spherical.copy(this._sphericalEnd));
                const c = !s || WI(this._target.x, this._targetEnd.x, this.restThreshold) && WI(this._target.y, this._targetEnd.y, this.restThreshold) && WI(this._target.z, this._targetEnd.z, this.restThreshold) && WI(this._spherical.theta, this._sphericalEnd.theta, this.restThreshold) && WI(this._spherical.phi, this._sphericalEnd.phi, this.restThreshold) && WI(this._spherical.radius, this._sphericalEnd.radius, this.restThreshold);
                return this._createOnRestPromise(c);
            }
            lerpLookAt(t1, e, i, n, r, a, s, o, l, c, u, h, d, p = !1) {
                this._isUserControllingRotate = !1, this._isUserControllingDolly = !1, this._isUserControllingTruck = !1, this._lastDollyDirection = 0, this._changedDolly = 0;
                const f = uS.set(n, r, a), A = hS.set(t1, e, i);
                yS.setFromVector3(A.sub(f).applyQuaternion(this._yAxisUpSpace));
                const g = dS.set(c, u, h), m = hS.set(s, o, l);
                vS.setFromVector3(m.sub(g).applyQuaternion(this._yAxisUpSpace)), this._targetEnd.copy(f.lerp(g, d));
                const M = vS.theta - yS.theta, y = vS.phi - yS.phi, v = vS.radius - yS.radius;
                this._sphericalEnd.set(yS.radius + v * d, yS.phi + y * d, yS.theta + M * d), this.normalizeRotations(), this._needsUpdate = !0, p || (this._target.copy(this._targetEnd), this._spherical.copy(this._sphericalEnd));
                const x = !p || WI(this._target.x, this._targetEnd.x, this.restThreshold) && WI(this._target.y, this._targetEnd.y, this.restThreshold) && WI(this._target.z, this._targetEnd.z, this.restThreshold) && WI(this._spherical.theta, this._sphericalEnd.theta, this.restThreshold) && WI(this._spherical.phi, this._sphericalEnd.phi, this.restThreshold) && WI(this._spherical.radius, this._sphericalEnd.radius, this.restThreshold);
                return this._createOnRestPromise(x);
            }
            setPosition(t1, e, i, n = !1) {
                return this.setLookAt(t1, e, i, this._targetEnd.x, this._targetEnd.y, this._targetEnd.z, n);
            }
            setTarget(t1, e, i, n = !1) {
                const r = this.getPosition(uS), a = this.setLookAt(r.x, r.y, r.z, t1, e, i, n);
                return this._sphericalEnd.phi = GI(this._sphericalEnd.phi, this.minPolarAngle, this.maxPolarAngle), a;
            }
            setFocalOffset(t1, e, i, n = !1) {
                this._isUserControllingOffset = !1, this._focalOffsetEnd.set(t1, e, i), this._needsUpdate = !0, n || this._focalOffset.copy(this._focalOffsetEnd);
                const r = !n || WI(this._focalOffset.x, this._focalOffsetEnd.x, this.restThreshold) && WI(this._focalOffset.y, this._focalOffsetEnd.y, this.restThreshold) && WI(this._focalOffset.z, this._focalOffsetEnd.z, this.restThreshold);
                return this._createOnRestPromise(r);
            }
            setOrbitPoint(t1, e, i) {
                this._camera.updateMatrixWorld(), fS.setFromMatrixColumn(this._camera.matrixWorldInverse, 0), AS.setFromMatrixColumn(this._camera.matrixWorldInverse, 1), gS.setFromMatrixColumn(this._camera.matrixWorldInverse, 2);
                const n = uS.set(t1, e, i), r = n.distanceTo(this._camera.position), a = n.sub(this._camera.position);
                fS.multiplyScalar(a.x), AS.multiplyScalar(a.y), gS.multiplyScalar(a.z), uS.copy(fS).add(AS).add(gS), uS.z = uS.z + r, this.dollyTo(r, !1), this.setFocalOffset(-uS.x, uS.y, -uS.z, !1), this.moveTo(t1, e, i, !1);
            }
            setBoundary(t1) {
                if (!t1) return this._boundary.min.set(-1 / 0, -1 / 0, -1 / 0), this._boundary.max.set(1 / 0, 1 / 0, 1 / 0), void (this._needsUpdate = !0);
                this._boundary.copy(t1), this._boundary.clampPoint(this._targetEnd, this._targetEnd), this._needsUpdate = !0;
            }
            setViewport(t1, e, i, n) {
                null !== t1 ? (this._viewport = this._viewport || new aS.Vector4, "number" == typeof t1 ? this._viewport.set(t1, e, i, n) : this._viewport.copy(t1)) : this._viewport = null;
            }
            getDistanceToFitBox(t1, e, i, n = !1) {
                if (tS(this._camera, "getDistanceToFitBox")) return this._spherical.radius;
                const r = t1 / e, a = this._camera.getEffectiveFOV() * VI, s = this._camera.aspect;
                return .5 * ((n ? r > s : r < s) ? e : t1 / s) / Math.tan(.5 * a) + .5 * i;
            }
            getDistanceToFitSphere(t1) {
                if (tS(this._camera, "getDistanceToFitSphere")) return this._spherical.radius;
                const e = this._camera.getEffectiveFOV() * VI, i = 2 * Math.atan(Math.tan(.5 * e) * this._camera.aspect), n = 1 < this._camera.aspect ? e : i;
                return t1 / Math.sin(.5 * n);
            }
            getTarget(t1, e = !0) {
                return (t1 && t1.isVector3 ? t1 : new aS.Vector3).copy(e ? this._targetEnd : this._target);
            }
            getPosition(t1, e = !0) {
                return (t1 && t1.isVector3 ? t1 : new aS.Vector3).setFromSpherical(e ? this._sphericalEnd : this._spherical).applyQuaternion(this._yAxisUpSpaceInverse).add(e ? this._targetEnd : this._target);
            }
            getSpherical(t1, e = !0) {
                return (t1 || new aS.Spherical).copy(e ? this._sphericalEnd : this._spherical);
            }
            getFocalOffset(t1, e = !0) {
                return (t1 && t1.isVector3 ? t1 : new aS.Vector3).copy(e ? this._focalOffsetEnd : this._focalOffset);
            }
            normalizeRotations() {
                this._sphericalEnd.theta = this._sphericalEnd.theta % FI, this._sphericalEnd.theta < 0 && (this._sphericalEnd.theta += FI), this._spherical.theta += FI * Math.round((this._sphericalEnd.theta - this._spherical.theta) / FI);
            }
            reset(t1 = !1) {
                if (!WI(this._camera.up.x, this._cameraUp0.x) || !WI(this._camera.up.y, this._cameraUp0.y) || !WI(this._camera.up.z, this._cameraUp0.z)) {
                    this._camera.up.copy(this._cameraUp0);
                    const t1 = this.getPosition(uS);
                    this.updateCameraUp(), this.setPosition(t1.x, t1.y, t1.z);
                }
                const e = [
                    this.setLookAt(this._position0.x, this._position0.y, this._position0.z, this._target0.x, this._target0.y, this._target0.z, t1),
                    this.setFocalOffset(this._focalOffset0.x, this._focalOffset0.y, this._focalOffset0.z, t1),
                    this.zoomTo(this._zoom0, t1)
                ];
                return Promise.all(e);
            }
            saveState() {
                this._cameraUp0.copy(this._camera.up), this.getTarget(this._target0), this.getPosition(this._position0), this._zoom0 = this._zoom, this._focalOffset0.copy(this._focalOffset);
            }
            updateCameraUp() {
                this._yAxisUpSpace.setFromUnitVectors(this._camera.up, oS), this._yAxisUpSpaceInverse.copy(this._yAxisUpSpace).invert();
            }
            applyCameraUp() {
                const t1 = uS.subVectors(this._target, this._camera.position).normalize(), e = hS.crossVectors(t1, this._camera.up);
                this._camera.up.crossVectors(e, t1).normalize(), this._camera.updateMatrixWorld();
                const i = this.getPosition(uS);
                this.updateCameraUp(), this.setPosition(i.x, i.y, i.z);
            }
            update(t1) {
                const e = this._sphericalEnd.theta - this._spherical.theta, i = this._sphericalEnd.phi - this._spherical.phi, n = this._sphericalEnd.radius - this._spherical.radius, r = mS.subVectors(this._targetEnd, this._target), a = MS.subVectors(this._focalOffsetEnd, this._focalOffset), s = this._zoomEnd - this._zoom;
                if (YI(e)) this._thetaVelocity.value = 0, this._spherical.theta = this._sphericalEnd.theta;
                else {
                    const e = this._isUserControllingRotate ? this.draggingSmoothTime : this.smoothTime;
                    this._spherical.theta = KI(this._spherical.theta, this._sphericalEnd.theta, this._thetaVelocity, e, 1 / 0, t1), this._needsUpdate = !0;
                }
                if (YI(i)) this._phiVelocity.value = 0, this._spherical.phi = this._sphericalEnd.phi;
                else {
                    const e = this._isUserControllingRotate ? this.draggingSmoothTime : this.smoothTime;
                    this._spherical.phi = KI(this._spherical.phi, this._sphericalEnd.phi, this._phiVelocity, e, 1 / 0, t1), this._needsUpdate = !0;
                }
                if (YI(n)) this._radiusVelocity.value = 0, this._spherical.radius = this._sphericalEnd.radius;
                else {
                    const e = this._isUserControllingDolly ? this.draggingSmoothTime : this.smoothTime;
                    this._spherical.radius = KI(this._spherical.radius, this._sphericalEnd.radius, this._radiusVelocity, e, this.maxSpeed, t1), this._needsUpdate = !0;
                }
                if (YI(r.x) && YI(r.y) && YI(r.z)) this._targetVelocity.set(0, 0, 0), this._target.copy(this._targetEnd);
                else {
                    const e = this._isUserControllingTruck ? this.draggingSmoothTime : this.smoothTime;
                    qI(this._target, this._targetEnd, this._targetVelocity, e, this.maxSpeed, t1, this._target), this._needsUpdate = !0;
                }
                if (YI(a.x) && YI(a.y) && YI(a.z)) this._focalOffsetVelocity.set(0, 0, 0), this._focalOffset.copy(this._focalOffsetEnd);
                else {
                    const e = this._isUserControllingOffset ? this.draggingSmoothTime : this.smoothTime;
                    qI(this._focalOffset, this._focalOffsetEnd, this._focalOffsetVelocity, e, this.maxSpeed, t1, this._focalOffset), this._needsUpdate = !0;
                }
                if (YI(s)) this._zoomVelocity.value = 0, this._zoom = this._zoomEnd;
                else {
                    const e = this._isUserControllingZoom ? this.draggingSmoothTime : this.smoothTime;
                    this._zoom = KI(this._zoom, this._zoomEnd, this._zoomVelocity, e, 1 / 0, t1);
                }
                if (this.dollyToCursor) {
                    if (kI(this._camera) && 0 !== this._changedDolly) {
                        const t1 = this._spherical.radius - this._lastDistance, e = this._camera, i = this._getCameraDirection(pS), n = uS.copy(i).cross(e.up).normalize();
                        0 === n.lengthSq() && (n.x = 1);
                        const r = hS.crossVectors(n, i), a = this._sphericalEnd.radius * Math.tan(e.getEffectiveFOV() * VI * .5), s = (this._sphericalEnd.radius - t1 - this._sphericalEnd.radius) / this._sphericalEnd.radius, o = dS.copy(this._targetEnd).add(n.multiplyScalar(this._dollyControlCoord.x * a * e.aspect)).add(r.multiplyScalar(this._dollyControlCoord.y * a)), l = uS.copy(this._targetEnd).lerp(o, s), c = 1 === this._lastDollyDirection && this._spherical.radius <= this.minDistance, u = -1 === this._lastDollyDirection && this.maxDistance <= this._spherical.radius;
                        if (this.infinityDolly && (c || u)) {
                            this._sphericalEnd.radius -= t1, this._spherical.radius -= t1;
                            const e = hS.copy(i).multiplyScalar(-t1);
                            l.add(e);
                        }
                        this._boundary.clampPoint(l, l);
                        const h = hS.subVectors(l, this._targetEnd);
                        this._targetEnd.copy(l), this._target.add(h), this._changedDolly -= t1, YI(this._changedDolly) && (this._changedDolly = 0);
                    } else if (BI(this._camera) && 0 !== this._changedZoom) {
                        const t1 = this._zoom - this._lastZoom, e = this._camera, i = uS.set(this._dollyControlCoord.x, this._dollyControlCoord.y, (e.near + e.far) / (e.near - e.far)).unproject(e), n = hS.set(0, 0, -1).applyQuaternion(e.quaternion), r = dS.copy(i).add(n.multiplyScalar(-i.dot(e.up))), a = -(this._zoom - t1 - this._zoom) / this._zoom, s = this._getCameraDirection(pS), o = this._targetEnd.dot(s), l = uS.copy(this._targetEnd).lerp(r, a), c = l.dot(s), u = s.multiplyScalar(c - o);
                        l.sub(u), this._boundary.clampPoint(l, l);
                        const h = hS.subVectors(l, this._targetEnd);
                        this._targetEnd.copy(l), this._target.add(h), this._changedZoom -= t1, YI(this._changedZoom) && (this._changedZoom = 0);
                    }
                }
                this._camera.zoom !== this._zoom && (this._camera.zoom = this._zoom, this._camera.updateProjectionMatrix(), this._updateNearPlaneCorners(), this._needsUpdate = !0), this._dragNeedsUpdate = !0;
                const o = this._collisionTest();
                this._spherical.radius = Math.min(this._spherical.radius, o), this._spherical.makeSafe(), this._camera.position.setFromSpherical(this._spherical).applyQuaternion(this._yAxisUpSpaceInverse).add(this._target), this._camera.lookAt(this._target), (!YI(this._focalOffset.x) || !YI(this._focalOffset.y) || !YI(this._focalOffset.z)) && (this._camera.updateMatrixWorld(), fS.setFromMatrixColumn(this._camera.matrix, 0), AS.setFromMatrixColumn(this._camera.matrix, 1), gS.setFromMatrixColumn(this._camera.matrix, 2), fS.multiplyScalar(this._focalOffset.x), AS.multiplyScalar(-this._focalOffset.y), gS.multiplyScalar(this._focalOffset.z), uS.copy(fS).add(AS).add(gS), this._camera.position.add(uS)), this._boundaryEnclosesCamera && this._encloseToBoundary(this._camera.position.copy(this._target), uS.setFromSpherical(this._spherical).applyQuaternion(this._yAxisUpSpaceInverse), 1);
                const l = this._needsUpdate;
                return l && !this._updatedLastTime ? (this._hasRested = !1, this.dispatchEvent({
                    type: "wake"
                }), this.dispatchEvent({
                    type: "update"
                })) : l ? (this.dispatchEvent({
                    type: "update"
                }), YI(e, this.restThreshold) && YI(i, this.restThreshold) && YI(n, this.restThreshold) && YI(r.x, this.restThreshold) && YI(r.y, this.restThreshold) && YI(r.z, this.restThreshold) && YI(a.x, this.restThreshold) && YI(a.y, this.restThreshold) && YI(a.z, this.restThreshold) && YI(s, this.restThreshold) && !this._hasRested && (this._hasRested = !0, this.dispatchEvent({
                    type: "rest"
                }))) : !l && this._updatedLastTime && this.dispatchEvent({
                    type: "sleep"
                }), this._lastDistance = this._spherical.radius, this._lastZoom = this._zoom, this._updatedLastTime = l, this._needsUpdate = !1, l;
            }
            toJSON() {
                return JSON.stringify({
                    enabled: this._enabled,
                    minDistance: this.minDistance,
                    maxDistance: ZI(this.maxDistance),
                    minZoom: this.minZoom,
                    maxZoom: ZI(this.maxZoom),
                    minPolarAngle: this.minPolarAngle,
                    maxPolarAngle: ZI(this.maxPolarAngle),
                    minAzimuthAngle: ZI(this.minAzimuthAngle),
                    maxAzimuthAngle: ZI(this.maxAzimuthAngle),
                    smoothTime: this.smoothTime,
                    draggingSmoothTime: this.draggingSmoothTime,
                    dollySpeed: this.dollySpeed,
                    truckSpeed: this.truckSpeed,
                    dollyToCursor: this.dollyToCursor,
                    verticalDragToForward: this.verticalDragToForward,
                    target: this._targetEnd.toArray(),
                    position: uS.setFromSpherical(this._sphericalEnd).add(this._targetEnd).toArray(),
                    zoom: this._zoomEnd,
                    focalOffset: this._focalOffsetEnd.toArray(),
                    target0: this._target0.toArray(),
                    position0: this._position0.toArray(),
                    zoom0: this._zoom0,
                    focalOffset0: this._focalOffset0.toArray()
                });
            }
            fromJSON(t1, e = !1) {
                const i = JSON.parse(t1);
                this.enabled = i.enabled, this.minDistance = i.minDistance, this.maxDistance = JI(i.maxDistance), this.minZoom = i.minZoom, this.maxZoom = JI(i.maxZoom), this.minPolarAngle = i.minPolarAngle, this.maxPolarAngle = JI(i.maxPolarAngle), this.minAzimuthAngle = JI(i.minAzimuthAngle), this.maxAzimuthAngle = JI(i.maxAzimuthAngle), this.smoothTime = i.smoothTime, this.draggingSmoothTime = i.draggingSmoothTime, this.dollySpeed = i.dollySpeed, this.truckSpeed = i.truckSpeed, this.dollyToCursor = i.dollyToCursor, this.verticalDragToForward = i.verticalDragToForward, this._target0.fromArray(i.target0), this._position0.fromArray(i.position0), this._zoom0 = i.zoom0, this._focalOffset0.fromArray(i.focalOffset0), this.moveTo(i.target[0], i.target[1], i.target[2], e), yS.setFromVector3(uS.fromArray(i.position).sub(this._targetEnd).applyQuaternion(this._yAxisUpSpace)), this.rotateTo(yS.theta, yS.phi, e), this.dollyTo(yS.radius, e), this.zoomTo(i.zoom, e), this.setFocalOffset(i.focalOffset[0], i.focalOffset[1], i.focalOffset[2], e), this._needsUpdate = !0;
            }
            connect(t1) {
                this._domElement ? console.warn("camera-controls is already connected.") : (t1.setAttribute("data-camera-controls-version", "2.8.5"), this._addAllEventListeners(t1), this._getClientRect(this._elementRect));
            }
            disconnect() {
                this.cancel(), this._removeAllEventListeners(), this._domElement && (this._domElement.removeAttribute("data-camera-controls-version"), this._domElement = void 0);
            }
            dispose() {
                this.removeAllEventListeners(), this.disconnect();
            }
            _getTargetDirection(t1) {
                return t1.setFromSpherical(this._spherical).divideScalar(this._spherical.radius).applyQuaternion(this._yAxisUpSpaceInverse);
            }
            _getCameraDirection(t1) {
                return this._getTargetDirection(t1).negate();
            }
            _findPointerById(t1) {
                return this._activePointers.find((e)=>e.pointerId === t1);
            }
            _findPointerByMouseButton(t1) {
                return this._activePointers.find((e)=>e.mouseButton === t1);
            }
            _disposePointer(t1) {
                this._activePointers.splice(this._activePointers.indexOf(t1), 1);
            }
            _encloseToBoundary(t1, e, i) {
                const n = e.lengthSq();
                if (0 === n) return t1;
                const r = hS.copy(e).add(t1), a = this._boundary.clampPoint(r, dS).sub(r), s = a.lengthSq();
                if (0 === s) return t1.add(e);
                if (s === n) return t1;
                if (0 === i) return t1.add(e).add(a);
                {
                    const n = 1 + i * s / e.dot(a);
                    return t1.add(hS.copy(e).multiplyScalar(n)).add(a.multiplyScalar(1 - i));
                }
            }
            _updateNearPlaneCorners() {
                if (kI(this._camera)) {
                    const t1 = this._camera, e = t1.near, i = t1.getEffectiveFOV() * VI, n = Math.tan(.5 * i) * e, r = n * t1.aspect;
                    this._nearPlaneCorners[0].set(-r, -n, 0), this._nearPlaneCorners[1].set(r, -n, 0), this._nearPlaneCorners[2].set(r, n, 0), this._nearPlaneCorners[3].set(-r, n, 0);
                } else if (BI(this._camera)) {
                    const t1 = this._camera, e = 1 / t1.zoom, i = t1.left * e, n = t1.right * e, r = t1.top * e, a = t1.bottom * e;
                    this._nearPlaneCorners[0].set(i, r, 0), this._nearPlaneCorners[1].set(n, r, 0), this._nearPlaneCorners[2].set(n, a, 0), this._nearPlaneCorners[3].set(i, a, 0);
                }
            }
            _collisionTest() {
                let t1 = 1 / 0;
                if (!(this.colliderMeshes.length >= 1)) return t1;
                if (tS(this._camera, "_collisionTest")) return t1;
                const e = this._getTargetDirection(pS);
                IS.lookAt(sS, e, this._camera.up);
                for(let i = 0; i < 4; i++){
                    const n = hS.copy(this._nearPlaneCorners[i]);
                    n.applyMatrix4(IS);
                    const r = dS.addVectors(this._target, n);
                    SS.set(r, e), SS.far = this._spherical.radius + 1;
                    const a = SS.intersectObjects(this.colliderMeshes);
                    0 !== a.length && a[0].distance < t1 && (t1 = a[0].distance);
                }
                return t1;
            }
            _getClientRect(t1) {
                if (!this._domElement) return;
                const e = this._domElement.getBoundingClientRect();
                return t1.x = e.left, t1.y = e.top, this._viewport ? (t1.x += this._viewport.x, t1.y += e.height - this._viewport.w - this._viewport.y, t1.width = this._viewport.z, t1.height = this._viewport.w) : (t1.width = e.width, t1.height = e.height), t1;
            }
            _createOnRestPromise(t1) {
                return t1 ? Promise.resolve() : (this._hasRested = !1, this.dispatchEvent({
                    type: "transitionstart"
                }), new Promise((t1)=>{
                    const e = ()=>{
                        this.removeEventListener("rest", e), t1();
                    };
                    this.addEventListener("rest", e);
                }));
            }
            _addAllEventListeners(t1) {}
            _removeAllEventListeners() {}
            get dampingFactor() {
                return console.warn(".dampingFactor has been deprecated. use smoothTime (in seconds) instead."), 0;
            }
            set dampingFactor(t1) {
                console.warn(".dampingFactor has been deprecated. use smoothTime (in seconds) instead.");
            }
            get draggingDampingFactor() {
                return console.warn(".draggingDampingFactor has been deprecated. use draggingSmoothTime (in seconds) instead."), 0;
            }
            set draggingDampingFactor(t1) {
                console.warn(".draggingDampingFactor has been deprecated. use draggingSmoothTime (in seconds) instead.");
            }
            static createBoundingSphere(t1, e = new aS.Sphere) {
                const i = e, n = i.center;
                xS.makeEmpty(), t1.traverseVisible((t1)=>{
                    t1.isMesh && xS.expandByObject(t1);
                }), xS.getCenter(n);
                let r = 0;
                return t1.traverseVisible((t1)=>{
                    if (!t1.isMesh) return;
                    const e = t1, i = e.geometry.clone();
                    i.applyMatrix4(e.matrixWorld);
                    const a = i.attributes.position;
                    for(let t1 = 0, e = a.count; t1 < e; t1++)uS.fromBufferAttribute(a, t1), r = Math.max(r, n.distanceToSquared(uS));
                }), i.radius = Math.sqrt(r), i;
            }
        }
        function DS(t1, e, i) {
            return (e = function(t1) {
                var e = function(t1) {
                    if ("object" != typeof t1 || !t1) return t1;
                    var e = t1[Symbol.toPrimitive];
                    if (void 0 !== e) {
                        var i = e.call(t1, "string");
                        if ("object" != typeof i) return i;
                        throw new TypeError("@@toPrimitive must return a primitive value.");
                    }
                    return String(t1);
                }(t1);
                return "symbol" == typeof e ? e : e + "";
            }(e)) in t1 ? Object.defineProperty(t1, e, {
                value: i,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : t1[e] = i, t1;
        }
        NS.install({
            THREE: t1
        });
        const CS = class extends NS {
            constructor(t1, e){
                super(e, t1.domElement), DS(this, "disableAutoRotate", !1), DS(this, "userDragging", !1), DS(this, "_renderer", void 0), DS(this, "_camera", void 0), this._renderer = t1, this._camera = e, this.mouseButtons.middle = NS.ACTION.NONE, this.mouseButtons.left = NS.ACTION.ROTATE, this.mouseButtons.right = NS.ACTION.NONE, this.mouseButtons.wheel = NS.ACTION.NONE, this.touches.three = NS.ACTION.NONE, this.touches.two = NS.ACTION.NONE, this.touches.one = NS.ACTION.TOUCH_ROTATE, this.verticalDragToForward = !0, this.azimuthRotateSpeed = -0.25, this.polarRotateSpeed = -0.25, this.maxDistance = .001, this.truckSpeed = 1e4, this.minDistance = 0, this.dollySpeed = 0, this.minZoom = 1, this.maxZoom = 2, this.rotateTo(0, Math.PI / 2), this.setDefaultPosition(), this.addListeners();
            }
            setDefaultPosition() {
                this.moveTo(0, 0, 0), this.dollyTo(1e-9), this.zoomTo(1);
            }
            onRest() {
                this.removeEventListener("rest", this.onRest), this.disableAutoRotate = !1, this.holding = !1;
            }
            onControlStart() {
                this.currentAction !== NS.ACTION.NONE && (this.removeEventListener("rest", this.onRest), this.disableAutoRotate = !0, this.holding = !0);
            }
            onControlEnd() {
                this.active ? this.addEventListener("rest", this.onRest) : this.onRest();
            }
            onTransitionStart() {
                this.holding || (this.disableAutoRotate = !0, this.addEventListener("rest", this.onRest));
            }
            addListeners() {
                this.addEventListener("transitionstart", this.onTransitionStart), this.addEventListener("controlstart", this.onControlStart), this.addEventListener("controlend", this.onControlEnd);
            }
        };
        function zS(t1, e, i) {
            return (e = function(t1) {
                var e = function(t1) {
                    if ("object" != typeof t1 || !t1) return t1;
                    var e = t1[Symbol.toPrimitive];
                    if (void 0 !== e) {
                        var i = e.call(t1, "string");
                        if ("object" != typeof i) return i;
                        throw new TypeError("@@toPrimitive must return a primitive value.");
                    }
                    return String(t1);
                }(t1);
                return "symbol" == typeof e ? e : e + "";
            }(e)) in t1 ? Object.defineProperty(t1, e, {
                value: i,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : t1[e] = i, t1;
        }
        const LS = class extends Qu {
            constructor(t1){
                super(60, 1, .1, 1e4), zS(this, "deviceOrientationControls", void 0), zS(this, "controls", void 0), this.controls = new CS(t1, this), this.deviceOrientationControls = new RI(this, t1.domElement);
            }
        };
        const OS = class extends Up {
            constructor(){
                var t1, e, i;
                super(), t1 = this, i = void 0, (e = function(t1) {
                    var e = function(t1) {
                        if ("object" != typeof t1 || !t1) return t1;
                        var e = t1[Symbol.toPrimitive];
                        if (void 0 !== e) {
                            var i = e.call(t1, "string");
                            if ("object" != typeof i) return i;
                            throw new TypeError("@@toPrimitive must return a primitive value.");
                        }
                        return String(t1);
                    }(t1);
                    return "symbol" == typeof e ? e : e + "";
                }(e = "controls")) in t1 ? Object.defineProperty(t1, e, {
                    value: i,
                    enumerable: !0,
                    configurable: !0,
                    writable: !0
                }) : t1[e] = i, this.background = new kc(16777215), this.add(new Nm(new kc(16777215), 3));
            }
        };
        function _S(t1, e, i) {
            return (e = function(t1) {
                var e = function(t1) {
                    if ("object" != typeof t1 || !t1) return t1;
                    var e = t1[Symbol.toPrimitive];
                    if (void 0 !== e) {
                        var i = e.call(t1, "string");
                        if ("object" != typeof i) return i;
                        throw new TypeError("@@toPrimitive must return a primitive value.");
                    }
                    return String(t1);
                }(t1);
                return "symbol" == typeof e ? e : e + "";
            }(e)) in t1 ? Object.defineProperty(t1, e, {
                value: i,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : t1[e] = i, t1;
        }
        const jS = class extends Ou {
            constructor(){
                super(), _S(this, "canvas", document.createElement("canvas")), _S(this, "interactive", !0), _S(this, "height", 775), _S(this, "width", 775), this.canvas.height = this.height, this.canvas.width = this.width, this.createGeomtery(), this.createMaterial(), this.addEventListener("select", (t1)=>this.onClick(t1)), this.addEventListener("click", (t1)=>this.onClick(t1)), this.addEventListener("hoverstart", this.onHoverStart), this.addEventListener("hoverend", this.onHoverEnd), this.renderOrder = 5;
            }
            get context() {
                return this.canvas.getContext("2d");
            }
            onClick() {}
            onHoverStart() {
                this.scale.setScalar(1.15);
            }
            onHoverEnd() {
                this.scale.setScalar(1);
            }
            createGeomtery() {
                this.geometry = new ih(this.width, this.height, 100, 100);
            }
            createMaterial() {
                return this.material = new Ig({
                    color: new kc(16777215),
                    transparent: !0,
                    side: er,
                    opacity: 1
                }), this;
            }
            async loadImage(t1) {
                const e = await fetch(t1, {
                    method: "GET",
                    cache: "no-cache"
                }), i = await e.blob();
                return await wv(URL.createObjectURL(i));
            }
            setVisibility(t1) {
                this.visible = t1, this.scale.setScalar(t1 ? 1 : 0);
            }
            async updateMaterial(t1) {
                const e = "".concat(t1 + 1, " ").concat(Tv("floor")), i = zn.config.colors.mainText, n = zn.getFloorConfig(t1);
                return this.loadImage(n.planImage).then((t1)=>{
                    this.context.clearRect(0, 0, this.canvas.width, this.canvas.height), this.context.beginPath(), this.context.fillStyle = "rgba(255, 255, 255, 1)", bv(this.context, 0, 0, this.canvas.width, this.canvas.height, 50), this.context.fill(), this.context.drawImage(t1, 165, 75, 450, 450), this.context.textAlign = "center", this.context.font = "Bold 80px/1 Roboto Mono", this.context.fillStyle = i, this.context.fillColor = i, this.context.fillText(e, this.canvas.width / 2, this.canvas.height - 100), this.context.fillRect((this.canvas.width - 430) / 2, this.canvas.height - 55, 430, 5), this.material.map || (this.material.map = lx(this.canvas)), this.material.map.needsUpdate = !0, this.material.needsUpdate = !0;
                }), this;
            }
        };
        function PS(t1, e, i) {
            return (e = function(t1) {
                var e = function(t1) {
                    if ("object" != typeof t1 || !t1) return t1;
                    var e = t1[Symbol.toPrimitive];
                    if (void 0 !== e) {
                        var i = e.call(t1, "string");
                        if ("object" != typeof i) return i;
                        throw new TypeError("@@toPrimitive must return a primitive value.");
                    }
                    return String(t1);
                }(t1);
                return "symbol" == typeof e ? e : e + "";
            }(e)) in t1 ? Object.defineProperty(t1, e, {
                value: i,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : t1[e] = i, t1;
        }
        const RS = class extends Ou {
            constructor(){
                super(), PS(this, "canvas", document.createElement("canvas")), PS(this, "height", 700), PS(this, "width", 700), this.canvas.height = this.height, this.canvas.width = this.width, this.createGeomtery(), this.createMaterial(), this.renderOrder = 5;
            }
            get context() {
                return this.canvas.getContext("2d");
            }
            createGeomtery() {
                this.geometry = new ih(this.width, this.height, 100, 100);
            }
            createMaterial() {
                return this.material = new Ig({
                    color: new kc(16777215),
                    transparent: !0,
                    side: er,
                    opacity: 1
                }), this;
            }
            updateMaterial() {
                const t1 = "".concat(zn.currentFloorIndex + 1, " ").concat(Tv("floor")), e = zn.config.colors.mainText;
                return this.context.clearRect(0, 0, this.canvas.width, this.canvas.height), this.context.textAlign = "center", this.context.font = "Bold 140px/1 Roboto Mono", this.context.fillStyle = e, this.context.fillColor = e, this.context.fillText(t1, this.canvas.width / 2, this.canvas.height / 2), this.context.fillRect(0, this.canvas.height / 2 + 50, this.canvas.width, 5), this.material.map || (this.material.map = lx(this.canvas)), this.material.map.needsUpdate = !0, this.material.needsUpdate = !0, this;
            }
        };
        function US(t1, e, i) {
            return (e = function(t1) {
                var e = function(t1) {
                    if ("object" != typeof t1 || !t1) return t1;
                    var e = t1[Symbol.toPrimitive];
                    if (void 0 !== e) {
                        var i = e.call(t1, "string");
                        if ("object" != typeof i) return i;
                        throw new TypeError("@@toPrimitive must return a primitive value.");
                    }
                    return String(t1);
                }(t1);
                return "symbol" == typeof e ? e : e + "";
            }(e)) in t1 ? Object.defineProperty(t1, e, {
                value: i,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : t1[e] = i, t1;
        }
        const kS = class extends Ou {
            constructor(){
                let t1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 400;
                super(), US(this, "canvas", document.createElement("canvas")), US(this, "isContainer", !0), this.canvas.width = t1, this.canvas.height = 120, this.createGeometry(), this.createMaterial(), this.renderOrder = 5;
            }
            get context() {
                return this.canvas.getContext("2d");
            }
            createGeometry() {
                return this.geometry = new ih(this.canvas.width, this.canvas.height, 10, 10), this;
            }
            createMaterial() {
                this.context.clearRect(0, 0, this.canvas.width, this.canvas.height), this.context.beginPath(), this.context.fillStyle = "rgba(20, 20, 20, 0.26)", bv(this.context, 0, 0, this.canvas.width, this.canvas.height, 64), this.context.fill();
                const t1 = lx(this.canvas);
                return this.material = new Ig({
                    color: new kc(16777215),
                    transparent: !0,
                    side: er,
                    map: t1,
                    opacity: 1
                }), this;
            }
            dispose() {
                this.material.map.dispose(), this.material.dispose(), this.removeFromParent();
            }
        };
        function BS(t1, e, i) {
            return (e = function(t1) {
                var e = function(t1) {
                    if ("object" != typeof t1 || !t1) return t1;
                    var e = t1[Symbol.toPrimitive];
                    if (void 0 !== e) {
                        var i = e.call(t1, "string");
                        if ("object" != typeof i) return i;
                        throw new TypeError("@@toPrimitive must return a primitive value.");
                    }
                    return String(t1);
                }(t1);
                return "symbol" == typeof e ? e : e + "";
            }(e)) in t1 ? Object.defineProperty(t1, e, {
                value: i,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : t1[e] = i, t1;
        }
        const FS = class extends Ou {
            constructor(t1){
                super(), BS(this, "canvas", document.createElement("canvas")), BS(this, "interactive", !0), BS(this, "isButton", !0), this.canvas.height = 92, this.canvas.width = 92, this.createGeometry(), this.createMaterial(), this.update(t1), this.addEventListener("select", (t1)=>this.onClick(t1)), this.addEventListener("click", (t1)=>this.onClick(t1)), this.position.set(0, 0, 1), this.renderOrder = 6;
            }
            get context() {
                return this.canvas.getContext("2d");
            }
            onClick() {}
            createGeometry() {
                return this.geometry = new ih(this.canvas.width, this.canvas.height, 10, 10), this;
            }
            createMaterial() {
                return this.material = new Ig({
                    color: new kc(16777215),
                    transparent: !0,
                    side: er,
                    opacity: 1
                }), this;
            }
            update(t1) {
                return wv(t1).then((t1)=>{
                    this.context.clearRect(0, 0, this.canvas.width, this.canvas.height), this.context.beginPath(), this.context.fillStyle = "rgba(255, 255, 255, 1)", bv(this.context, 0, 0, this.canvas.width, this.canvas.height, 46), this.context.fill(), this.context.drawImage(t1, 20, 20, 52, 52), this.material.map || (this.material.map = lx(this.canvas)), this.material.map.needsUpdate = !0, this.material.needsUpdate = !0;
                }), this;
            }
            setVisibility(t1) {
                this.visible = t1, this.scale.setScalar(t1 ? 1 : 0);
            }
        };
        function QS(t1, e) {
            let i = t1[0], n = t1[1], r = !1;
            for(let t1 = 0, a = e.length - 1; t1 < e.length; a = t1++){
                const s = e[t1][0], o = e[t1][1], l = e[a][0], c = e[a][1];
                o > n != c > n && i < (l - s) * (n - o) / (c - o) + s && (r = !r);
            }
            return r;
        }
        function HS(t1, e, i) {
            return (e = function(t1) {
                var e = function(t1) {
                    if ("object" != typeof t1 || !t1) return t1;
                    var e = t1[Symbol.toPrimitive];
                    if (void 0 !== e) {
                        var i = e.call(t1, "string");
                        if ("object" != typeof i) return i;
                        throw new TypeError("@@toPrimitive must return a primitive value.");
                    }
                    return String(t1);
                }(t1);
                return "symbol" == typeof e ? e : e + "";
            }(e)) in t1 ? Object.defineProperty(t1, e, {
                value: i,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : t1[e] = i, t1;
        }
        const VS = class extends Sp {
            constructor(){
                super(), HS(this, "planScale", new Qo(1, 1)), HS(this, "currentPanoramasGroup", void 0), HS(this, "padding", 16), HS(this, "rooms", []), this.scale.set(1, -1, 1), this.renderOrder = 6;
            }
            updateScale(t1) {
                let { X: e, Y: i } = t1;
                return this.planScale.x = e, this.planScale.y = i, this.deleteRooms(), this.createRooms(this.currentPanoramasGroup), this;
            }
            showRoomById(t1) {
                return this.rooms.forEach((e)=>{
                    e.material.opacity = e.userData.id === t1 ? .3 : 0;
                }), this;
            }
            createRooms(t1) {
                return this.currentPanoramasGroup = t1, this.currentPanoramasGroup.children.forEach((t1)=>{
                    let { userData: e, panoramaId: i } = t1;
                    const n = e.points.map((t1)=>{
                        let [e, i] = t1;
                        return [
                            this.padding + 2 * e * this.planScale.x,
                            this.padding + 2 * i * this.planScale.y
                        ];
                    }).filter((t1)=>{
                        let [e, i] = t1;
                        return !isNaN(e) && !isNaN(i);
                    });
                    if (!n.length) return;
                    const r = this.padding + 2 * e.left * this.planScale.x, a = this.padding + 2 * e.top * this.planScale.y, s = new PA;
                    s.moveTo(n[0][0], n[0][1]), n.forEach((t1)=>{
                        let [e, i] = t1;
                        return s.lineTo(e, i);
                    });
                    const o = new Ag(s), l = new Ig({
                        color: new kc(zn.config.colors.main),
                        transparent: !0,
                        side: er,
                        opacity: 0
                    }), c = new Ou(o, l);
                    c.userData = {
                        id: i,
                        points: n,
                        left: r,
                        top: a
                    }, this.rooms.push(c), this.add(c);
                }), this;
            }
            deleteRooms() {
                return this.rooms.forEach((t1)=>{
                    t1.material.dispose(), t1.removeFromParent();
                }), this.rooms = [], this;
            }
        };
        function GS(t1, e, i) {
            return (e = function(t1) {
                var e = function(t1) {
                    if ("object" != typeof t1 || !t1) return t1;
                    var e = t1[Symbol.toPrimitive];
                    if (void 0 !== e) {
                        var i = e.call(t1, "string");
                        if ("object" != typeof i) return i;
                        throw new TypeError("@@toPrimitive must return a primitive value.");
                    }
                    return String(t1);
                }(t1);
                return "symbol" == typeof e ? e : e + "";
            }(e)) in t1 ? Object.defineProperty(t1, e, {
                value: i,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : t1[e] = i, t1;
        }
        const YS = class extends Ou {
            constructor(){
                super(), GS(this, "height", 140), GS(this, "width", 140), this.createGeometry(), this.createMaterial(), this.renderOrder = 7;
            }
            createGeometry() {
                return this.geometry = new ih(this.width, this.height, 10, 10), this;
            }
            createMaterial() {
                const t1 = this.width / 2, e = this.height / 2, i = Math.PI / 3 * 4, n = i + Math.PI / 3, r = document.createElement("canvas"), a = r.getContext("2d");
                return r.height = this.height, r.width = this.width, a.clearRect(0, 0, this.width, this.height), a.globalAlpha = .4, a.beginPath(), a.moveTo(t1, e), a.fillStyle = zn.config.colors.main, a.arc(t1, e, 70, i, n), a.lineTo(t1, e), a.fill(), a.closePath(), a.globalAlpha = 1, a.beginPath(), a.fillStyle = zn.config.colors.main, a.arc(t1, e, 16, 0, 2 * Math.PI), a.fill(), a.closePath(), a.beginPath(), a.fillStyle = "rgba(255, 255, 255, 1)", a.arc(t1, e, 12, 0, 2 * Math.PI), a.fill(), a.closePath(), a.beginPath(), a.fillStyle = zn.config.colors.main, a.arc(t1, e, 8, 0, 2 * Math.PI), a.fill(), a.closePath(), this.material = new Ig({
                    map: lx(r),
                    color: new kc(16777215),
                    transparent: !0,
                    depthTest: !1,
                    side: er,
                    opacity: 1
                }), this;
            }
            update(t1, e, i) {
                this.position.set(t1, e, 10), this.rotation.set(0, 0, i);
            }
        };
        function WS(t1, e, i) {
            return (e = function(t1) {
                var e = function(t1) {
                    if ("object" != typeof t1 || !t1) return t1;
                    var e = t1[Symbol.toPrimitive];
                    if (void 0 !== e) {
                        var i = e.call(t1, "string");
                        if ("object" != typeof i) return i;
                        throw new TypeError("@@toPrimitive must return a primitive value.");
                    }
                    return String(t1);
                }(t1);
                return "symbol" == typeof e ? e : e + "";
            }(e)) in t1 ? Object.defineProperty(t1, e, {
                value: i,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : t1[e] = i, t1;
        }
        const XS = class extends Ou {
            constructor(){
                super(), WS(this, "planScale", new Qo(1, 1)), WS(this, "pointer", new Qo(-1, -1)), WS(this, "interactive", !0), WS(this, "boundingScale", 4), WS(this, "padding", 16), WS(this, "hoverRoom", void 0), WS(this, "fovLayer", void 0), WS(this, "height", void 0), WS(this, "width", void 0), this.height = 200, this.width = 200, this.createGeometry(), this.createMaterial(), this.creteRoomsLayer(), this.createFovLayer(), this.addEventListener("hoverstart", this.onHoverStart), this.addEventListener("hoverend", this.onHoverEnd), this.addEventListener("click", this.handleClick), this.renderOrder = 5;
            }
            createGeometry() {
                return this.geometry = new ih(this.width, this.height, 100, 100), this;
            }
            createMaterial() {
                return this.material = new Ig({
                    color: new kc(16777215),
                    transparent: !0,
                    side: er,
                    opacity: 1
                }), this;
            }
            async loadImage(t1) {
                const e = await fetch(t1, {
                    method: "GET",
                    cache: "no-cache"
                }), i = await e.blob();
                return this.image = new Image, this.image.onload = ()=>this.updateMaterial(), this.image.src = URL.createObjectURL(i), this;
            }
            createFovLayer() {
                return this.fovLayer = new YS, this.add(this.fovLayer), this;
            }
            creteRoomsLayer() {
                return this.roomsLayer = new VS, this.add(this.roomsLayer), this;
            }
            setDisabledState(t1) {
                this.disabled = t1;
            }
            setVisibility(t1) {
                this.visible = t1, this.scale.setScalar(t1 ? this.boundingScale : 0);
            }
            onHoverStart(t1) {
                const { x: e, y: i } = t1.data, n = this.height * i, r = this.width * e;
                this.pointer.x = r, this.pointer.y = n;
            }
            onHoverEnd() {
                this.pointer.x = -1, this.pointer.y = -1;
            }
            handleClick() {
                this.hoverRoom && (this.onClick(this.hoverRoom.userData.id), this.dispatchEvent({
                    type: "closemap"
                }));
            }
            onClick() {}
            updateMaterial() {
                const t1 = document.createElement("canvas"), e = t1.getContext("2d");
                return t1.height = this.height, t1.width = this.width, e.fillStyle = "rgba(255, 255, 255, 1)", bv(e, 0, 0, this.width, this.height, 20), e.fill(), this.image && e.drawImage(this.image, this.padding, this.padding, this.width - 2 * this.padding, this.height - 2 * this.padding), this.material.map && this.material.map.dispose(), this.material.map = lx(t1), this.material.needsUpdate = !0, this;
            }
            updateSize(t1, e) {
                this.height = e + 2 * this.padding, this.width = t1 + 2 * this.padding, this.roomsLayer.position.set(-this.width / 2, this.height / 2, 5), this.createGeometry();
                const i = Math.min(this.width / this.height, 1);
                return this.boundingScale = 5 * i, this.setVisibility(this.visible), this;
            }
            updateScale(t1) {
                let { X: e, Y: i } = t1;
                return this.planScale.x = e, this.planScale.y = i, this.roomsLayer.updateScale({
                    X: e,
                    Y: i
                }), this;
            }
            updateRoomsLayer(t1) {
                return this.roomsLayer.deleteRooms(), this.roomsLayer.createRooms(t1), this;
            }
            update(t1, e, i) {
                var n;
                if (i) {
                    const t1 = this.roomsLayer.rooms.filter((t1)=>QS([
                            this.pointer.x,
                            this.pointer.y
                        ], t1.userData.points));
                    this.hoverRoom = dx([
                        this.pointer.x,
                        this.pointer.y
                    ], t1).panorama;
                }
                if (this.roomsLayer.showRoomById((null === (n = this.hoverRoom) || void 0 === n ? void 0 : n.userData.id) || null), !this.disabled && e) {
                    const i = this.padding + 2 * e.userData.left * this.planScale.x, n = this.padding + 2 * e.userData.top * this.planScale.y, r = this.height / 2, a = i - this.width / 2, s = -1 * (n - r);
                    this.fovLayer.update(a, s, t1);
                }
                return this;
            }
        }, ZS = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjgiIGhlaWdodD0iMjgiIHZpZXdCb3g9IjAgMCAyOCAyOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwXzE4NDhfNjI0KSI+CjxwYXRoIGQ9Ik0xOC44MjI2IDEuODc0ODlMMS44NzUwNSAxOC44MjI0QzEuNDc2MDEgMTkuMjIxNCAxLjQ0MTUgMTkuODMzOSAxLjc5Nzk3IDIwLjE5MDRMNy44MDk0OCAyNi4yMDE5QzguMTY1OTUgMjYuNTU4MyA4Ljc3ODQyIDI2LjUyMzggOS4xNzc0NiAyNi4xMjQ4TDI2LjEyNSA5LjE3NzI5QzI2LjUyNCA4Ljc3ODI1IDI2LjU1ODUgOC4xNjU3OSAyNi4yMDIgNy44MDkzMkwyMC4xOTA1IDEuNzk3ODFDMTkuODM0MSAxLjQ0MTM0IDE5LjIyMTYgMS40NzU4NSAxOC44MjI2IDEuODc0ODlaIiBzdHJva2U9IiM0MTNFM0UiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik0xNS41MjUgNi4zMjg2MUwxOS42MTIyIDEwLjQxNTgiIHN0cm9rZT0iIzQxM0UzRSIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTEwLjkyNjkgMTAuOTI2OEwxNC4wMTQyIDE0LjAxNCIgc3Ryb2tlPSIjNDEzRTNFIiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNNi4zMjg3NCAxNS41MjQ5TDEwLjQxNiAxOS42MTIxIiBzdHJva2U9IiM0MTNFM0UiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjwvZz4KPGRlZnM+CjxjbGlwUGF0aCBpZD0iY2xpcDBfMTg0OF82MjQiPgo8cmVjdCB3aWR0aD0iMjgiIGhlaWdodD0iMjgiIGZpbGw9IndoaXRlIi8+CjwvY2xpcFBhdGg+CjwvZGVmcz4KPC9zdmc+Cg==";
        function JS(t1, e, i) {
            (function(t1, e) {
                if (e.has(t1)) throw new TypeError("Cannot initialize the same private elements twice on an object");
            })(t1, e), e.set(t1, i);
        }
        function KS(t1, e, i) {
            return (e = function(t1) {
                var e = function(t1) {
                    if ("object" != typeof t1 || !t1) return t1;
                    var e = t1[Symbol.toPrimitive];
                    if (void 0 !== e) {
                        var i = e.call(t1, "string");
                        if ("object" != typeof i) return i;
                        throw new TypeError("@@toPrimitive must return a primitive value.");
                    }
                    return String(t1);
                }(t1);
                return "symbol" == typeof e ? e : e + "";
            }(e)) in t1 ? Object.defineProperty(t1, e, {
                value: i,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : t1[e] = i, t1;
        }
        function qS(t1, e) {
            return t1.get(tN(t1, e));
        }
        function $S(t1, e, i) {
            return t1.set(tN(t1, e), i), i;
        }
        function tN(t1, e, i) {
            if ("function" == typeof t1 ? t1 === e : t1.has(e)) return arguments.length < 3 ? e : i;
            throw new TypeError("Private element is not present on this object");
        }
        var eN = new WeakMap, iN = new WeakMap;
        const nN = class extends Sp {
            constructor(){
                super(), KS(this, "mapGroup", new Sp), JS(this, eN, void 0), JS(this, iN, void 0), KS(this, "prevFloorButton", void 0), KS(this, "nextFloorButton", void 0), KS(this, "rulerButton", void 0), KS(this, "floorTitle", void 0), KS(this, "exitButton", void 0), KS(this, "mapButton", void 0), KS(this, "container", void 0), KS(this, "map", void 0), this.createContainer(), this.createButtons(), this.createMap(), this.createFloorTitle(), this.createPrevFloorButton(), this.createNextFloorButton(), this.closeMap(), this.mapButton.setVisibility(!1), this.setVisibility(!1), this.mapGroup.position.set(0, 2e3, -2500), this.mapGroup.rotation.set(gx(30), 0, 0), this.add(this.mapGroup);
            }
            set rulerButtonAvailable(t1) {
                $S(eN, this, t1), this.map.visible || this.setRulerButtonVisibility(t1);
            }
            set mapButtonAvailable(t1) {
                $S(iN, this, t1), this.map.visible || this.setMapButtonVisibility(t1);
            }
            onRulerButtonClick() {}
            onExitButtonClick() {}
            createContainer() {
                let t1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 400;
                if (this.container) {
                    const e = new kS(t1);
                    this.container.geometry = e.geometry.clone(), this.container.material = e.material.clone(), e.dispose();
                } else this.container = new kS(t1), this.add(this.container);
                return this;
            }
            createButtons() {
                return this.exitButton = new FS("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjgiIGhlaWdodD0iMjgiIHZpZXdCb3g9IjAgMCAyOCAyOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTIzLjE2NjEgNC44MzM5OEwxNCAxNC4wMDAxTTE0IDE0LjAwMDFMNC44MzM4IDIzLjE2NjNNMTQgMTQuMDAwMUwyMy4xNjYxIDIzLjE2NjNNMTQgMTQuMDAwMUw0LjgzMzggNC44MzM5OCIgc3Ryb2tlPSIjNDEzRTNFIiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIvPgo8L3N2Zz4K"), this.exitButton.onClick = (t1)=>{
                    if (this.map.visible) return this.closeMap();
                    this.onExitButtonClick(t1);
                }, this.rulerButton = new FS(ZS), this.rulerButton.onClick = (t1)=>this.onRulerButtonClick(t1), this.mapButton = new FS("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjgiIGhlaWdodD0iMjgiIHZpZXdCb3g9IjAgMCAyOCAyOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTI0LjIxMTQgMjQuNDIxMUgzLjc4ODY1QzMuNjI3NDggMjQuNDIxMSAzLjQ5NjgzIDI0LjI5MDQgMy40OTY4MyAyNC4xMjkzTDMuNDk2NzcgNC4wNjYyNEMzLjQ5Njc3IDMuOTA1MDcgMy42Mjc0MiAzLjc3NDQxIDMuNzg4NTkgMy43NzQ0MUgyNC4yMTE0QzI0LjM3MjUgMy43NzQ0MSAyNC41MDMyIDMuOTA1MDcgMjQuNTAzMiA0LjA2NjI0VjI0LjEyOTNDMjQuNTAzMiAyNC4yOTA0IDI0LjM3MjUgMjQuNDIxMSAyNC4yMTE0IDI0LjQyMTFaIiBzdHJva2U9IiM0MTNFM0UiIHN0cm9rZS13aWR0aD0iMiIvPgo8cGF0aCBkPSJNNC4wMDE0NiAxMC4wNDU0SDEzLjM2ODRDMTMuNTI5NiAxMC4wNDU0IDEzLjY2MDIgMTAuMTc2MSAxMy42NjAyIDEwLjMzNzJWMjQuMjA1OSIgc3Ryb2tlPSIjNDEzRTNFIiBzdHJva2Utd2lkdGg9IjEuNDU5MSIvPgo8cGF0aCBkPSJNMjQuNTAzMiAxMS4wNjU2SDE4LjM2NTFDMTguMjA0IDExLjA2NTYgMTguMDczMyAxMC45MzQ5IDE4LjA3MzMgMTAuNzczOFYzLjU3OTEiIHN0cm9rZT0iIzQxM0UzRSIgc3Ryb2tlLXdpZHRoPSIxLjQ1OTEiLz4KPC9zdmc+Cg=="), this.mapButton.onClick = (t1)=>this.openMap(t1), this.add(this.exitButton, this.rulerButton, this.mapButton), this;
            }
            createMap() {
                return this.map = new XS, this.map.addEventListener("closemap", this.closeMap.bind(this)), this.mapGroup.add(this.map), this;
            }
            createFloorTitle() {
                return this.floorTitle = new RS, this.mapGroup.add(this.floorTitle), this;
            }
            createNextFloorButton() {
                return this.nextFloorButton = new jS, this.mapGroup.add(this.nextFloorButton), this;
            }
            createPrevFloorButton() {
                return this.prevFloorButton = new jS, this.mapGroup.add(this.prevFloorButton), this;
            }
            openMap() {
                this.floorTitle.updateMaterial(), this.prevFloorButton.updateMaterial(zn.prevFloorIndex), this.nextFloorButton.updateMaterial(zn.nextFloorIndex), this.mapGroup.visible = !0, this.map.setVisibility(!0), this.rulerButton.setVisibility(!1), this.setMapButtonVisibility(!1);
                const t1 = zn.configParams.floors.length > 1;
                this.prevFloorButton.setVisibility(t1), this.nextFloorButton.setVisibility(t1);
            }
            closeMap() {
                this.mapGroup.visible = !1, this.map.setVisibility(!1), this.rulerButton.setVisibility(qS(eN, this)), this.setMapButtonVisibility(!0), this.prevFloorButton.setVisibility(!1), this.nextFloorButton.setVisibility(!1);
            }
            setRulerButtonVisibility(t1) {
                this.rulerButton.setVisibility(t1), this.updateButtonsPositions();
            }
            setMapButtonVisibility(t1) {
                this.mapButton.setVisibility(t1), this.updateButtonsPositions();
            }
            setVisibility(t1) {
                t1 ? (this.setRulerButtonVisibility(qS(eN, this)), this.setMapButtonVisibility(qS(iN, this))) : (this.setRulerButtonVisibility(!1), this.setMapButtonVisibility(!1)), this.exitButton.setVisibility(t1), this.container.visible = t1, this.visible = t1, this.scale.setScalar(t1 ? 6e-4 : 0);
            }
            setRulerIcon(t1) {
                return t1 ? this.rulerButton.update("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjgiIGhlaWdodD0iMjgiIHZpZXdCb3g9IjAgMCAyOCAyOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwXzE4NDhfNjU5KSI+CjxwYXRoIGQ9Ik0xOC44MjI2IDEuODc0ODlMMS44NzUwNSAxOC44MjI0QzEuNDc2MDEgMTkuMjIxNCAxLjQ0MTUgMTkuODMzOSAxLjc5Nzk3IDIwLjE5MDRMNy44MDk0OCAyNi4yMDE5QzguMTY1OTUgMjYuNTU4MyA4Ljc3ODQyIDI2LjUyMzggOS4xNzc0NiAyNi4xMjQ4TDI2LjEyNSA5LjE3NzI5QzI2LjUyNCA4Ljc3ODI1IDI2LjU1ODUgOC4xNjU3OSAyNi4yMDIgNy44MDkzMkwyMC4xOTA1IDEuNzk3ODFDMTkuODM0MSAxLjQ0MTM0IDE5LjIyMTYgMS40NzU4NSAxOC44MjI2IDEuODc0ODlaIiBzdHJva2U9IiM0MTNFM0UiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik0xNS41MjUgNi4zMjg2MUwxOS42MTIyIDEwLjQxNTgiIHN0cm9rZT0iIzQxM0UzRSIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTEwLjkyNjkgMTAuOTI2OEwxNC4wMTQyIDE0LjAxNCIgc3Ryb2tlPSIjNDEzRTNFIiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNNi4zMjg3NCAxNS41MjQ5TDEwLjQxNiAxOS42MTIxIiBzdHJva2U9IiM0MTNFM0UiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxyZWN0IHg9IjEwLjYyNDYiIHk9IjYuMjkzNDYiIHdpZHRoPSIxNS44MDAyIiBoZWlnaHQ9IjMuNjYxNiIgdHJhbnNmb3JtPSJyb3RhdGUoNDUgMTAuNjI0NiA2LjI5MzQ2KSIgZmlsbD0id2hpdGUiLz4KPHBhdGggZD0iTTMuMDA2MjkgNC43MTE0M0wyMi45OTM4IDI1LjI4NzkiIHN0cm9rZT0iIzQxM0UzRSIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9nPgo8ZGVmcz4KPGNsaXBQYXRoIGlkPSJjbGlwMF8xODQ4XzY1OSI+CjxyZWN0IHdpZHRoPSIyOCIgaGVpZ2h0PSIyOCIgZmlsbD0id2hpdGUiLz4KPC9jbGlwUGF0aD4KPC9kZWZzPgo8L3N2Zz4K") : this.rulerButton.update(ZS);
            }
            updateButtonsPositions() {
                return this.map.visible ? (this.exitButton.position.x = 0, void this.createContainer(120)) : this.mapButton.visible ? this.rulerButton.visible ? (this.rulerButton.position.x = 0, this.exitButton.position.x = 140, this.mapButton.position.x = -140, void this.createContainer(400)) : (this.exitButton.position.x = 70, this.mapButton.position.x = -70, void this.createContainer(260)) : this.rulerButton.visible ? (this.rulerButton.position.x = -70, this.exitButton.position.x = 70, void this.createContainer(260)) : (this.exitButton.position.x = 0, void this.createContainer(120));
            }
            updateFloorMaterials() {
                this.floorTitle.updateMaterial(), this.prevFloorButton.updateMaterial(zn.prevFloorIndex), this.nextFloorButton.updateMaterial(zn.nextFloorIndex);
            }
            updateFloorTitlePosition() {
                const t1 = 210 + this.map.height * this.map.scale.y / 2;
                this.floorTitle.position.set(0, t1, 0);
            }
            updateFloorButtonsPositions() {
                const { width: t1, height: e } = this.nextFloorButton, i = e / 2 - this.map.height * this.map.scale.y / 2, n = t1 / 2 + 200 + this.map.width * this.map.scale.x / 2;
                this.prevFloorButton.position.set(-n, i, 0), this.nextFloorButton.position.set(n, i, 0);
            }
            update(t1, e, i, n) {
                this.map.visible && this.map.update(e, i, n);
                const r = new xl(.025, -0.5, -0.9);
                r.applyMatrix4(t1.matrixWorld);
                const a = new oc(0, 0, 0);
                a.setFromRotationMatrix(t1.matrixWorld), this.position.copy(r), this.rotation.copy(a), this.rotateX(gx(-30)), this.updateMatrix(), this.updateFloorTitlePosition(), this.updateFloorButtonsPositions();
            }
        };
        const rN = class extends Ou {
            constructor(){
                var t1, e, i;
                super(), t1 = this, i = !0, (e = function(t1) {
                    var e = function(t1) {
                        if ("object" != typeof t1 || !t1) return t1;
                        var e = t1[Symbol.toPrimitive];
                        if (void 0 !== e) {
                            var i = e.call(t1, "string");
                            if ("object" != typeof i) return i;
                            throw new TypeError("@@toPrimitive must return a primitive value.");
                        }
                        return String(t1);
                    }(t1);
                    return "symbol" == typeof e ? e : e + "";
                }(e = "isDistanceLine")) in t1 ? Object.defineProperty(t1, e, {
                    value: i,
                    enumerable: !0,
                    configurable: !0,
                    writable: !0
                }) : t1[e] = i, this.createGeometry(), this.createMaterial(), this.renderOrder = 3;
            }
            createGeometry(t1, e) {
                const i = new gA(t1, e);
                return this.geometry = new vg(i, 100, .1, 100, !1), this;
            }
            createMaterial() {
                return this.material = new Ig({
                    color: new kc(4275774),
                    transparent: !0,
                    depthTest: !1,
                    side: er,
                    opacity: 1
                }), this;
            }
            update(t1, e) {
                return this.createGeometry(t1, e), this;
            }
            dispose() {
                this.material.dispose(), this.removeFromParent();
            }
        };
        function aN(t1, e, i) {
            return (e = function(t1) {
                var e = function(t1) {
                    if ("object" != typeof t1 || !t1) return t1;
                    var e = t1[Symbol.toPrimitive];
                    if (void 0 !== e) {
                        var i = e.call(t1, "string");
                        if ("object" != typeof i) return i;
                        throw new TypeError("@@toPrimitive must return a primitive value.");
                    }
                    return String(t1);
                }(t1);
                return "symbol" == typeof e ? e : e + "";
            }(e)) in t1 ? Object.defineProperty(t1, e, {
                value: i,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : t1[e] = i, t1;
        }
        const sN = class extends nf {
            constructor(t1){
                super(), aN(this, "canvas", document.createElement("canvas")), aN(this, "isCenterPoint", !0), aN(this, "interactive", !0), aN(this, "materialValue", 0), aN(this, "ruler", void 0), this.ruler = t1;
                const e = .15;
                this.canvas.width = 256, this.canvas.height = 128, this.scale.set(e, e / (this.canvas.width / this.canvas.height), e), this.renderOrder = 5, this.createMaterial();
            }
            get context() {
                return this.canvas.getContext("2d");
            }
            onClick() {
                this.ruler.dispose();
            }
            onHoverStart() {
                this.updateMaterial(this.materialValue, "rgba(255, 99, 64, 0.8)", "rgba(255, 255, 255, 1)");
            }
            onHoverEnd() {
                this.updateMaterial(this.materialValue);
            }
            addEventListeners() {
                return this.addEventListener("select", this.onClick), this.addEventListener("click", this.onClick), this.addEventListener("hoverstart", this.onHoverStart), this.addEventListener("hoverend", this.onHoverEnd), this;
            }
            createMaterial() {
                return this.material = new Qp({
                    color: new kc(16777215),
                    sizeAttenuation: !1,
                    transparent: !0,
                    depthTest: !1,
                    side: er,
                    opacity: 1
                }), this;
            }
            updateMaterial(t1) {
                let e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "rgba(255, 255, 255, 0.8)", i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : zn.config.colors.mainText;
                this.materialValue = t1;
                const n = "".concat(Number(t1 / 100).toFixed(2), " m "), r = "".concat(Number(.0328084 * t1).toFixed(2), " ft");
                return this.context.clearRect(0, 0, this.canvas.width, this.canvas.height), this.context.beginPath(), this.context.fillStyle = e, bv(this.context, 0, 0, this.canvas.width, this.canvas.height, 55), this.context.fill(), this.context.textAlign = "center", this.context.font = "Bold 38px/1 Roboto Mono", this.context.fillStyle = i, this.context.fillText(r, this.canvas.width / 2, 100), this.context.fillText(n, this.canvas.width / 2, 50), this.material.map || (this.material.map = lx(this.canvas)), this.material.map.needsUpdate = !0, this.material.needsUpdate = !0, this;
            }
            updatePosition(t1, e) {
                const i = new gA(t1, e).getPoint(.5, new xl);
                return this.position.copy(i), this;
            }
            update(t1, e, i) {
                return this.updateMaterial(t1), this.updatePosition(e, i), this;
            }
            dispose() {
                this.material.map.dispose(), this.material.dispose(), this.removeFromParent();
            }
        };
        function oN(t1, e, i) {
            return (e = function(t1) {
                var e = function(t1) {
                    if ("object" != typeof t1 || !t1) return t1;
                    var e = t1[Symbol.toPrimitive];
                    if (void 0 !== e) {
                        var i = e.call(t1, "string");
                        if ("object" != typeof i) return i;
                        throw new TypeError("@@toPrimitive must return a primitive value.");
                    }
                    return String(t1);
                }(t1);
                return "symbol" == typeof e ? e : e + "";
            }(e)) in t1 ? Object.defineProperty(t1, e, {
                value: i,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : t1[e] = i, t1;
        }
        const lN = class extends Ou {
            constructor(){
                super(), oN(this, "canvas", document.createElement("canvas")), oN(this, "isPoint", !0), this.canvas.width = 128, this.canvas.height = 128, this.createGeometry(), this.createMaterial(), this.renderOrder = 4;
            }
            get context() {
                return this.canvas.getContext("2d");
            }
            createGeometry() {
                return this.geometry = new ih(15, 15, 10, 10), this.geometry.rotateX(-Math.PI / 2), this;
            }
            createMaterial() {
                const t1 = this.canvas.width / 2, e = this.canvas.height / 2;
                this.context.beginPath(), this.context.arc(t1, e, this.canvas.width / 4, 0, 2 * Math.PI, !1), this.context.fillStyle = "rgba(255, 255, 255, 1)", this.context.fill(), this.context.lineWidth = 15, this.context.strokeStyle = zn.config.colors.main, this.context.stroke();
                const i = lx(this.canvas);
                return this.material = new Ig({
                    color: new kc(16777215),
                    transparent: !0,
                    depthWrite: !1,
                    depthTest: !1,
                    side: er,
                    map: i,
                    opacity: 1
                }), this;
            }
            update(t1, e) {
                let i = !(arguments.length > 2 && void 0 !== arguments[2]) || arguments[2];
                return this.position.copy(t1), i ? (this.quaternion.slerp(e, .5), this) : (this.quaternion.copy(e), this);
            }
            dispose() {
                this.material.map.dispose(), this.material.dispose(), this.removeFromParent();
            }
        };
        function cN(t1, e, i) {
            return (e = function(t1) {
                var e = function(t1) {
                    if ("object" != typeof t1 || !t1) return t1;
                    var e = t1[Symbol.toPrimitive];
                    if (void 0 !== e) {
                        var i = e.call(t1, "string");
                        if ("object" != typeof i) return i;
                        throw new TypeError("@@toPrimitive must return a primitive value.");
                    }
                    return String(t1);
                }(t1);
                return "symbol" == typeof e ? e : e + "";
            }(e)) in t1 ? Object.defineProperty(t1, e, {
                value: i,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : t1[e] = i, t1;
        }
        const uN = class extends Sp {
            constructor(t1){
                super(), cN(this, "distanceLine", null), cN(this, "centerPoint", null), cN(this, "secondPoint", null), cN(this, "firstPoint", null), cN(this, "isRuler", !0), this.userData = {
                    panoramaId: t1
                };
            }
            get distance() {
                return this.firstPoint && this.secondPoint ? this.firstPoint.position.distanceTo(this.secondPoint.position) : 0;
            }
            createRest(t1, e) {
                return this.createSecondPoint(t1, e), this.createDistanceLine(), this.createCenterPoint(), this;
            }
            createFirstPoint(t1, e) {
                return this.firstPoint = (new lN).update(t1, e, !1), this.add(this.firstPoint), this;
            }
            createSecondPoint(t1, e) {
                return this.secondPoint = (new lN).update(t1, e, !1), this.add(this.secondPoint), this;
            }
            createDistanceLine() {
                return this.distanceLine = new rN, this.add(this.distanceLine), this;
            }
            createCenterPoint() {
                return this.centerPoint = new sN(this), this.add(this.centerPoint), this;
            }
            update(t1, e) {
                var i, n, r;
                return null === (i = this.secondPoint) || void 0 === i || i.update(t1, e, !0), null === (n = this.centerPoint) || void 0 === n || n.update(this.distance, this.firstPoint.position, this.secondPoint.position), null === (r = this.distanceLine) || void 0 === r || r.update(this.firstPoint.position, this.secondPoint.position), this;
            }
            dispose() {
                var t1, e, i, n;
                return null === (t1 = this.firstPoint) || void 0 === t1 || t1.dispose(), null === (e = this.secondPoint) || void 0 === e || e.dispose(), null === (i = this.centerPoint) || void 0 === i || i.dispose(), null === (n = this.distanceLine) || void 0 === n || n.dispose(), this.removeFromParent(), this;
            }
        }, hN = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDQiIGhlaWdodD0iNDQiIHZpZXdCb3g9IjAgMCA0NCA0NCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE2LjQ5OCAyMC41MzUySDI0Ljc0ODgiIHN0cm9rZT0iIzQxM0UzRSIgc3Ryb2tlLXdpZHRoPSIxLjk0ODA5IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTIwLjUzOCAzMC43NjM1QzI2LjE4NjUgMzAuNzYzNSAzMC43NjU0IDI2LjE4NDUgMzAuNzY1NCAyMC41MzZDMzAuNzY1NCAxNC44ODc2IDI2LjE4NjUgMTAuMzA4NiAyMC41MzggMTAuMzA4NkMxNC44ODk1IDEwLjMwODYgMTAuMzEwNSAxNC44ODc2IDEwLjMxMDUgMjAuNTM2QzEwLjMxMDUgMjYuMTg0NSAxNC44ODk1IDMwLjc2MzUgMjAuNTM4IDMwLjc2MzVaIiBzdHJva2U9IiM0MTNFM0UiIHN0cm9rZS13aWR0aD0iMS45NDgwOSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik0yNy43NzE1IDI3Ljc2NTZMMzMuNjg4OCAzMy42ODI5IiBzdHJva2U9IiM0MTNFM0UiIHN0cm9rZS13aWR0aD0iMS45NDgwOSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo=", dN = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDQiIGhlaWdodD0iNDQiIHZpZXdCb3g9IjAgMCA0NCA0NCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTI2LjM0NTEgMTAuODMwN0wxMC44MjU3IDI2LjM1MDFDMTAuNDYwMyAyNi43MTU1IDEwLjQyODcgMjcuMjc2MyAxMC43NTUxIDI3LjYwMjhMMTYuMjYwMSAzMy4xMDc3QzE2LjU4NjUgMzMuNDM0MiAxNy4xNDczIDMzLjQwMjUgMTcuNTEyOCAzMy4wMzcxTDMzLjAzMjIgMTcuNTE3N0MzMy4zOTc2IDE3LjE1MjMgMzMuNDI5MiAxNi41OTE1IDMzLjEwMjggMTYuMjY1TDI3LjU5NzggMTAuNzYwMUMyNy4yNzE0IDEwLjQzMzcgMjYuNzEwNSAxMC40NjUzIDI2LjM0NTEgMTAuODMwN1oiIHN0cm9rZT0iIzQxM0UzRSIgc3Ryb2tlLXdpZHRoPSIxLjk5Mzk0IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTIzLjMyNDIgMTQuOTA2MkwyNy4wNjcgMTguNjQ5MSIgc3Ryb2tlPSIjNDEzRTNFIiBzdHJva2Utd2lkdGg9IjEuOTkzOTQiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNMTkuMTEzMyAxOS4xMjExTDIxLjk0MDMgMjEuOTQ4MiIgc3Ryb2tlPSIjNDEzRTNFIiBzdHJva2Utd2lkdGg9IjEuOTkzOTQiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNMTQuOTAyMyAyMy4zMzJMMTguNjQ1MiAyNy4wNzQ5IiBzdHJva2U9IiM0MTNFM0UiIHN0cm9rZS13aWR0aD0iMS45OTM5NCIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo=";
        function pN(t1, e, i) {
            return (e = function(t1) {
                var e = function(t1) {
                    if ("object" != typeof t1 || !t1) return t1;
                    var e = t1[Symbol.toPrimitive];
                    if (void 0 !== e) {
                        var i = e.call(t1, "string");
                        if ("object" != typeof i) return i;
                        throw new TypeError("@@toPrimitive must return a primitive value.");
                    }
                    return String(t1);
                }(t1);
                return "symbol" == typeof e ? e : e + "";
            }(e)) in t1 ? Object.defineProperty(t1, e, {
                value: i,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : t1[e] = i, t1;
        }
        ni({
            useProxies: "never"
        });
        const fN = new class {
            constructor(){
                pN(this, "currentRulerIcon", dN), pN(this, "currentFovIcon", hN), pN(this, "rulerInstructionShown", !1), pN(this, "tempPointer", new Qo), pN(this, "raycaster", new EM), pN(this, "tempMatrix", new Kl), pN(this, "vrSessionSupported", !1), pN(this, "rulerButtonEnabled", !1), pN(this, "rulersGroup", new Sp), pN(this, "renderer", new jI), pN(this, "floorsGroup", new Sp), pN(this, "initialPanoramaId", null), pN(this, "rulerModeEnabled", !1), pN(this, "autoRotateState", !1), pN(this, "pointer", new Qo), pN(this, "panoramasGroup", null), pN(this, "initialized", !1), pN(this, "clock", new Xm), pN(this, "scene", new OS), pN(this, "animation", !1), pN(this, "currentPanoramaId", void 0), pN(this, "interactiveGroup", void 0), pN(this, "tempRuler", null), pN(this, "currentPanorama", void 0), pN(this, "loading", !1), pN(this, "vrControlPanel", void 0), pN(this, "maskCursor", void 0), pN(this, "camera", void 0), pN(this, "bareshell", !1), pN(this, "isFirstRender", !0), pN(this, "onMouseMove", (t1)=>{
                    let { clientX: e, clientY: i } = t1;
                    this.pointer.x = e / zn.config.width * 2 - 1, this.pointer.y = -i / zn.config.height * 2 + 1;
                }), pN(this, "onPointerDown", (t1)=>{
                    let { clientX: e, clientY: i } = t1;
                    this.tempPointer.x = Number(e.toFixed(0)), this.tempPointer.y = Number(i.toFixed(0)), this.onMouseMove({
                        clientX: e,
                        clientY: i
                    });
                }), pN(this, "onPointerUp", (t1)=>{
                    let { clientX: e, clientY: i } = t1;
                    if (this.interactiveGroup.hover) return;
                    const n = Math.abs(this.tempPointer.x - Number(e.toFixed(0))) < 10, r = Math.abs(this.tempPointer.y - Number(i.toFixed(0))) < 10;
                    if (n && r) {
                        if (this.rulerModeEnabled) this.addRulerPoint();
                        else {
                            this.onMaskObjectClick();
                            const t1 = ((t1, e)=>{
                                let i = null, n = 1 / 0;
                                for (const r of e){
                                    const e = t1.ray.closestPointToPoint(r.position, new xl), a = r.position.distanceTo(e);
                                    a < n && (n = a, i = r.position);
                                }
                                return e.find((t1)=>t1.position === i);
                            })(this.raycaster, this.currentPanorama.links);
                            t1 && this.setCurrentPanoramaById(t1.userData.targetId);
                        }
                    }
                }), pN(this, "onControllerMove", (t1)=>{
                    const e = t1.target;
                    this.tempMatrix.identity().extractRotation(e.matrixWorld), this.raycaster.ray.origin.setFromMatrixPosition(e.matrixWorld), this.raycaster.ray.direction.set(0, 0, -1).applyMatrix4(this.tempMatrix);
                }), pN(this, "onControllerSelect", ()=>{
                    this.rulerModeEnabled ? this.addRulerPoint() : this.onMaskObjectClick();
                }), pN(this, "onMaskObjectClick", ()=>{}), Ti(this), this.camera = new LS(this.renderer), this.interactiveGroup = new Tx(this.renderer, this.camera), this.floorsGroup.rotation.y = Math.PI, this.scene.add(this.interactiveGroup, this.rulersGroup, this.floorsGroup), this.addEventListeners();
            }
            get currentViewAngle() {
                const t1 = this.currentCamera.getWorldDirection(new xl), e = new xl(-1, 0, 0), i = t1.x * e.x + t1.z * e.z, n = Math.sqrt(Math.pow(t1.x, 2) + Math.pow(t1.z, 2)), r = Math.sqrt(Math.pow(e.x, 2) + Math.pow(e.z, 2)), a = Math.acos(i / (n * r));
                return Math.sign(t1.z) * a;
            }
            get currentCamera() {
                return this.renderer.xr.getCamera().cameras[0] || this.camera;
            }
            get currentControls() {
                return this.camera.deviceOrientationControls.enabled ? this.camera.deviceOrientationControls : this.camera.controls;
            }
            get isProActive() {
                var t1;
                return "proactive" === (null === (t1 = zn.config.capabilities) || void 0 === t1 ? void 0 : t1.camera_navigation);
            }
            getPanoramaById(t1) {
                return this.panoramasGroup.children.find((e)=>{
                    let { panoramaId: i } = e;
                    return i === t1;
                });
            }
            setLoadingState(t1) {
                this.loading = t1;
            }
            setInitializedState(t1) {
                this.initialized = t1;
            }
            setBareshell(t1) {
                this.bareshell = t1;
            }
            updateWindowSize(t1, e) {
                return this.renderer.setSize(t1, e), this.camera.aspect = t1 / e, this.camera.updateProjectionMatrix(), this.render();
            }
            enableRender() {
                this.renderer.setAnimationLoop(this.render.bind(this));
            }
            disableRender() {
                this.renderer.setAnimationLoop(null);
            }
            render() {
                const t1 = this.clock.getDelta();
                this.currentControls.update(t1), this.camera.updateProjectionMatrix(), this.autoRotateState && !this.camera.controls.disableAutoRotate && (this.camera.controls.azimuthAngle -= gx(10 * t1)), this.renderer.currentVrSession || this.raycaster.setFromCamera(this.pointer, this.camera), Cx.isMobileDevice || (this.tempRuler ? this.updateRuler() : this.updateMask()), this.maskCursor ? this.renderer.domElement.style.cursor = this.maskCursor : this.interactiveGroup.hover && this.interactiveGroup.cursor.length > 0 ? this.renderer.domElement.style.cursor = this.interactiveGroup.cursor : this.rulerModeEnabled ? this.renderer.domElement.style.cursor = "none" : this.camera.controls.holding ? this.renderer.domElement.style.cursor = "grabbing" : this.renderer.domElement.style.cursor = "grab";
                const e = document.querySelector(".widget-tab__panorama-map__fov");
                e && e.style.setProperty("--rotate", -this.currentViewAngle);
                const i = document.querySelector(".camera--current");
                return i && i.style.setProperty("--rotate", -this.currentViewAngle), this.renderer.currentVrSession && this.vrControlPanel.update(this.currentCamera, this.currentViewAngle, this.getPanoramaById(this.currentPanoramaId), this.panoramasGroup), this.renderer.render(this.scene, this.camera), this.isFirstRender && (this.isFirstRender = !1, performance.mark("first render")), this;
            }
            async init(t1, e, i) {
                return this.vrControlPanel = new nN, this.interactiveGroup.add(this.vrControlPanel), this.vrControlPanel.onRulerButtonClick = this.toggleRulerMode.bind(this), this.vrControlPanel.onExitButtonClick = this.exitVr.bind(this), this.vrControlPanel.map.onClick = this.setCurrentPanoramaById.bind(this), this.vrControlPanel.prevFloorButton.onClick = ()=>zn.setPrevFloorIndex(), this.vrControlPanel.nextFloorButton.onClick = ()=>zn.setNextFloorIndex(), this.setRulerButtonState(!1), this.cameraFovValues = {
                    x1: zn.config.panoramaFov,
                    x05: 1.35 * zn.config.panoramaFov
                }, this.setCameraFov(this.cameraFovValues[zn.scales[0]]), this.checkVrSessionSupport(), await this.createPanoramasGroup(t1, e, i), this.setInitializedState(!0), this;
            }
            async createPanoramasGroup(t1, e, i) {
                performance.mark("start creatingPanoramas");
                const n = new _I(i);
                return this.floorsGroup.add(n), this.setCurrentPanoramasGroup(i), this.createPanoramas(t1, e), await this.setInitialCurrentPanorama(), this.interactiveGroup.updateDeepChildren(), this;
            }
            addEventListeners() {
                const { domElement: t1 } = this.renderer;
                t1.addEventListener("contextmenu", (t1)=>t1.preventDefault()), t1.addEventListener("pointerdown", this.onPointerDown), t1.addEventListener("pointerup", this.onPointerUp), t1.addEventListener("mousemove", this.onMouseMove);
            }
            async enterVr() {
                return await this.renderer.enterVR().then(()=>{
                    this.vrControlPanel.setVisibility(!0);
                });
            }
            async exitVr() {
                return await this.renderer.exitVR().then(()=>{
                    this.camera.fov = this.cameraFov, this.vrControlPanel.setVisibility(!1);
                });
            }
            async checkVrSessionSupport() {
                const t1 = await this.renderer.checkVrSessionSupport();
                return this.setVrSessionSupport(t1), this.vrSessionSupported;
            }
            setVrSessionSupport(t1) {
                this.vrSessionSupported = t1;
            }
            resetMaskOptions() {
                this.onMaskObjectClick = ()=>{}, this.maskCursor = null;
            }
            setMaskObjectStairs(t1) {
                const e = t1.RoomID === this.currentPanorama.userData.room_id, i = "url(".concat(e ? "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIHZpZXdCb3g9IjAgMCA1MCA1MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwXzI1NjZfMikiPgo8cGF0aCBkPSJNMi43MDIyMSAxNS4yOTgxTDE0LjQ0NjggMy41NTM0NiIgc3Ryb2tlPSJ3aGl0ZSIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTQuOTA0MzMgMy41NTM0N0wxNC40NDY4IDMuNTUzNDdMMTQuNDQ2OSAxMy4wOTYiIHN0cm9rZT0id2hpdGUiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik00NS4xOTA0IDQ2LjMzMzNINC44MDk1N0M0LjE3ODM5IDQ2LjMzMzMgMy42NjY3MiA0NS44MjE2IDMuNjY2NzIgNDUuMTkwNFYzNy45OTQ3QzMuNjY2NzIgMzcuMzYzNSA0LjE3ODM5IDM2Ljg1MTggNC44MDk1NyAzNi44NTE4SDEzLjAyNzZDMTMuNjU4OCAzNi44NTE4IDE0LjE3MDUgMzYuMzQwMSAxNC4xNzA1IDM1LjcwOVYyNy4yNDM0QzE0LjE3MDUgMjYuNjEyMiAxNC42ODIyIDI2LjEwMDUgMTUuMzEzNCAyNi4xMDA1SDI0LjE4MjhDMjQuODE0IDI2LjEwMDUgMjUuMzI1NyAyNS41ODg5IDI1LjMyNTcgMjQuOTU3N1YxNS41NjA5QzI1LjMyNTcgMTQuOTI5NyAyNS44MzczIDE0LjQxOCAyNi40Njg1IDE0LjQxOEgzNC42ODY2QzM1LjMxNzggMTQuNDE4IDM1LjgyOTUgMTMuOTA2NCAzNS44Mjk1IDEzLjI3NTJWNC44MDk2QzM1LjgyOTUgNC4xNzg0MiAzNi4zNDExIDMuNjY2NzUgMzYuOTcyMyAzLjY2Njc1SDQ1LjE5MDRDNDUuODIxNiAzLjY2Njc1IDQ2LjMzMzIgNC4xNzg0MiA0Ni4zMzMyIDQuODA5NlY0NS4xOTA0QzQ2LjMzMzIgNDUuODIxNiA0NS44MjE2IDQ2LjMzMzMgNDUuMTkwNCA0Ni4zMzMzWiIgZmlsbD0id2hpdGUiIHN0cm9rZT0id2hpdGUiIHN0cm9rZS13aWR0aD0iMiIvPgo8L2c+CjxkZWZzPgo8Y2xpcFBhdGggaWQ9ImNsaXAwXzI1NjZfMiI+CjxyZWN0IHdpZHRoPSI0Ny45OTk4IiBoZWlnaHQ9IjQ3Ljk5OTgiIGZpbGw9IndoaXRlIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxLjAwMDA2IDEuMDAwMjQpIi8+CjwvY2xpcFBhdGg+CjwvZGVmcz4KPC9zdmc+Cg==" : "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIHZpZXdCb3g9IjAgMCA1MCA1MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwXzI1NTFfMTcyKSI+CjxwYXRoIGQ9Ik0xNC40NDY4IDMuNTUzNDZMMi43MDIyIDE1LjI5ODEiIHN0cm9rZT0id2hpdGUiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik0xMi4yNDQ3IDE1LjI5ODFMMi43MDIyIDE1LjI5ODFMMi43MDIyIDUuNzU1NTciIHN0cm9rZT0id2hpdGUiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik00NS4xOTA0IDQ2LjMzMzNINC44MDk1N0M0LjE3ODM5IDQ2LjMzMzMgMy42NjY3MiA0NS44MjE2IDMuNjY2NzIgNDUuMTkwNFYzNy45OTQ3QzMuNjY2NzIgMzcuMzYzNSA0LjE3ODM5IDM2Ljg1MTggNC44MDk1NyAzNi44NTE4SDEzLjAyNzZDMTMuNjU4OCAzNi44NTE4IDE0LjE3MDUgMzYuMzQwMSAxNC4xNzA1IDM1LjcwOVYyNy4yNDM0QzE0LjE3MDUgMjYuNjEyMiAxNC42ODIyIDI2LjEwMDUgMTUuMzEzNCAyNi4xMDA1SDI0LjE4MjhDMjQuODE0IDI2LjEwMDUgMjUuMzI1NyAyNS41ODg5IDI1LjMyNTcgMjQuOTU3N1YxNS41NjA5QzI1LjMyNTcgMTQuOTI5NyAyNS44MzczIDE0LjQxOCAyNi40Njg1IDE0LjQxOEgzNC42ODY2QzM1LjMxNzggMTQuNDE4IDM1LjgyOTUgMTMuOTA2NCAzNS44Mjk1IDEzLjI3NTJWNC44MDk2QzM1LjgyOTUgNC4xNzg0MiAzNi4zNDExIDMuNjY2NzUgMzYuOTcyMyAzLjY2Njc1SDQ1LjE5MDRDNDUuODIxNiAzLjY2Njc1IDQ2LjMzMzIgNC4xNzg0MiA0Ni4zMzMyIDQuODA5NlY0NS4xOTA0QzQ2LjMzMzIgNDUuODIxNiA0NS44MjE2IDQ2LjMzMzMgNDUuMTkwNCA0Ni4zMzMzWiIgZmlsbD0id2hpdGUiIHN0cm9rZT0id2hpdGUiIHN0cm9rZS13aWR0aD0iMiIvPgo8L2c+CjxkZWZzPgo8Y2xpcFBhdGggaWQ9ImNsaXAwXzI1NTFfMTcyIj4KPHJlY3Qgd2lkdGg9IjQ3Ljk5OTgiIGhlaWdodD0iNDcuOTk5OCIgZmlsbD0id2hpdGUiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDEuMDAwMDYgMS4wMDAyNCkiLz4KPC9jbGlwUGF0aD4KPC9kZWZzPgo8L3N2Zz4K", ") 25 25, pointer"), n = e ? zn.nextFloorIndex : zn.prevFloorIndex, r = e ? t1.UpperFloorCameraPointID : t1.LowerFloorCameraPointID, { CameraPoints: a } = zn.config.json.Floors[n], { id: s } = a.reduce((e, i)=>{
                    const n = [
                        i.Location.X,
                        i.Location.Y
                    ], r = yv([
                        [
                            t1.Location.X,
                            t1.Location.Y
                        ],
                        n
                    ]);
                    return r < e.length ? {
                        id: i.ID,
                        length: r
                    } : e;
                }, {
                    length: 1 / 0,
                    id: null
                });
                this.initialPanoramaId = r || s, this.maskCursor = i, this.onMaskObjectClick = ()=>e ? zn.setNextFloorIndex() : zn.setPrevFloorIndex();
            }
            setMaskObjectDefault() {
                this.maskCursor = "pointer", this.onMaskObjectClick = ()=>{};
            }
            updateMask() {
                const t1 = this.getObjectFromMask(), e = Ex.some((e)=>(null == t1 ? void 0 : t1.Model) === e);
                return t1 ? e ? this.setMaskObjectStairs(t1) : this.setMaskObjectDefault() : this.resetMaskOptions();
            }
            getObjectFromMask() {
                if (!this.currentPanorama || !this.currentPanorama.mask) return;
                if (!zn.config.json || !zn.config.json.ObjectMaskColorPairs) return;
                if (this.interactiveGroup.hover) return;
                const { direction: t1 } = this.raycaster.ray, e = (1 + Math.atan2(t1.z, t1.x) / Math.PI) / 2, i = Math.acos(t1.y) / Math.PI, { R: n } = yx(e, i, this.currentPanorama.mask), r = Math.round(n), a = zn.config.json.ObjectMaskColorPairs.find((t1)=>t1.MaskColorID.R === r);
                return a && "Furniture" === a.Type && ux(zn.config.json, this.currentPanorama.userData.room_id) ? ((t1, e)=>{
                    for (const i of t1.Floors)for (const t1 of i.Units)for (const i of t1.Rooms)for (const t1 of i.Furniture)if (t1.ID === e) return t1;
                    return null;
                })(zn.config.json, a.ObjectID) : void 0;
            }
            setRulerInstructionShown(t1) {
                this.rulerInstructionShown = t1;
            }
            setRulerButtonState(t1) {
                this.rulerButtonEnabled = t1, this.vrControlPanel.rulerButtonAvailable = t1;
            }
            setRulerMode(t1) {
                this.rulerModeEnabled = t1, this.vrControlPanel.setRulerIcon(t1), this.rulersGroup.children.forEach((e)=>{
                    const i = !!t1 && e.userData.panoramaId === this.currentPanorama.panoramaId;
                    e.centerPoint && (e.centerPoint.visible = i), e.visible = i;
                }), t1 ? (this.currentRulerIcon = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzIiIGhlaWdodD0iMzIiIHZpZXdCb3g9IjAgMCAzMiAzMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTIyLjkyMjggMTcuODIyTDI1LjM1NSAxNS4zODk3TDMwLjIxOTYgMTAuNTI1MUMzMC42Nzc4IDEwLjA2NyAzMC43MTc0IDkuMzYzNzggMzAuMzA4MSA4Ljk1NDVMMjMuNDA2IDIuMDUyNEMyMi45OTY3IDEuNjQzMTIgMjIuMjkzNSAxLjY4Mjc0IDIxLjgzNTQgMi4xNDA5TDE2Ljk3MDggNy4wMDU0NkwxNC41Mzg1IDkuNDM3NzRNMTkuMzE3OCAyMS40MjdMMTAuNzYxNCAyOS45ODM0QzEwLjMwMzIgMzAuNDQxNSA5LjYgMzAuNDgxMiA5LjE5MDcyIDMwLjA3MTlMMi4yODg2MiAyMy4xNjk4QzEuODc5MzMgMjIuNzYwNSAxLjkxODk2IDIyLjA1NzMgMi4zNzcxMiAyMS41OTkxTDEwLjc2MTQgMTMuMjE0OSIgc3Ryb2tlPSIjNDEzRTNFIiBzdHJva2Utd2lkdGg9IjIuNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik0xOC4wNDkzIDcuMjU0MzlMMjIuNzQyIDExLjk0NzEiIHN0cm9rZT0iIzQxM0UzRSIgc3Ryb2tlLXdpZHRoPSIyLjUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNNy40OTA2IDE3LjgxM0wxMi4xODM0IDIyLjUwNTciIHN0cm9rZT0iIzQxM0UzRSIgc3Ryb2tlLXdpZHRoPSIyLjUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNMS41NDkyNiAzLjQ5NjA5TDI5LjEwMjMgMzAuODExMyIgc3Ryb2tlPSIjNDEzRTNFIiBzdHJva2Utd2lkdGg9IjIuMjgzMjIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8L3N2Zz4K", Cx.isMobileDevice || this.createTempRuler()) : (this.currentRulerIcon = dN, this.destroyTempRuler());
            }
            toggleRulerMode(t1) {
                this.setRulerMode(!this.rulerModeEnabled), t1 && t1.controller && (this.interactiveGroup.controller1.removeEventListener("select", this.onControllerSelect), this.interactiveGroup.controller1.removeEventListener("move", this.onControllerMove), this.interactiveGroup.controller2.removeEventListener("select", this.onControllerSelect), this.interactiveGroup.controller2.removeEventListener("move", this.onControllerMove), t1.controller.addEventListener("select", this.onControllerSelect), t1.controller.addEventListener("move", this.onControllerMove));
            }
            getRulerPoint() {
                const { direction: t1 } = this.raycaster.ray, e = (1 + Math.atan2(t1.z, t1.x) / Math.PI) / 2, i = Math.acos(t1.y) / Math.PI, { R: n } = yx(e, i, this.currentPanorama.depthMap), r = n || 140;
                return {
                    depthValue: r,
                    position: t1.clone().multiplyScalar(r).add(this.currentCamera.position),
                    quaternion: this.getRulerPointQuaternion()
                };
            }
            getRulerPointQuaternion() {
                const { width: t1, height: e } = this.currentPanorama.depthMap, { direction: i } = this.raycaster.ray, n = [
                    {
                        x: -1,
                        y: -1
                    },
                    {
                        x: 0,
                        y: -1
                    },
                    {
                        x: 1,
                        y: -1
                    },
                    {
                        x: -1,
                        y: 0
                    },
                    {
                        x: 0,
                        y: 0
                    },
                    {
                        x: 1,
                        y: 0
                    },
                    {
                        x: -1,
                        y: 1
                    },
                    {
                        x: 0,
                        y: 1
                    },
                    {
                        x: 1,
                        y: 1
                    }
                ], r = (1 + Math.atan2(i.z, i.x) / Math.PI) / 2, a = Math.acos(i.y) / Math.PI, s = 1 / e, o = 1 / t1, l = Math.round(Math.sqrt(n.length)), c = n.map((t1)=>{
                    let { x: e, y: i } = t1;
                    const n = r + o * e, l = a + s * i, { R: c } = yx(n, l, this.currentPanorama.depthMap), u = c || 140, h = ((t1, e)=>{
                        const i = new xl;
                        return i.x = Math.cos((2 * t1 - 1) * Math.PI) * Math.sin(e * Math.PI), i.z = Math.sin((2 * t1 - 1) * Math.PI) * Math.sin(e * Math.PI), i.y = Math.cos(e * Math.PI), i;
                    })(n, l);
                    return h.clone().multiplyScalar(u).add(this.currentCamera.position);
                }), u = new xl(0, 0, 0);
                for(let t1 = 0; t1 < l - 1; t1++)for(let e = 0; e < l - 1; e++){
                    const i = t1 * l + e, n = (t1 + 1) * l + e, r = c[i], a = c[i + 1], s = c[n], o = c[n + 1];
                    u.add(wx(r, a, s)), u.add(wx(a, o, s));
                }
                u.normalize();
                const h = new xl(0, Math.sign(i.y), 0), d = (new xl).crossVectors(h, u), p = u.angleTo(h);
                return (new vl).setFromAxisAngle(d, p);
            }
            updateRuler() {
                if (this.interactiveGroup.hover) return;
                const { position: t1, quaternion: e } = this.getRulerPoint();
                return this.tempRuler.secondPoint ? this.tempRuler.update(t1, e) : this.tempRuler.firstPoint.update(t1, e);
            }
            finishRuler() {
                return this.interactiveGroup.add(this.tempRuler.centerPoint), this.tempRuler.centerPoint.addEventListeners(), this.tempRuler = null, this;
            }
            addRulerPoint() {
                if (this.interactiveGroup.hover) return;
                const { position: t1, quaternion: e } = this.getRulerPoint();
                return Cx.isMobileDevice ? this.tempRuler ? void (this.tempRuler.firstPoint && (this.tempRuler.createRest(t1, e), this.updateRuler(), this.finishRuler())) : this.createTempRuler() : this.tempRuler.secondPoint ? (this.finishRuler(), this.createTempRuler()) : this.tempRuler.createRest(t1, e);
            }
            createTempRuler() {
                const { position: t1, quaternion: e } = this.getRulerPoint();
                return this.tempRuler = new uN(this.currentPanorama.panoramaId), this.tempRuler.createFirstPoint(t1, e), this.rulersGroup.add(this.tempRuler), this;
            }
            destroyTempRuler() {
                return this.tempRuler ? (this.tempRuler.dispose(), this.tempRuler = null, this) : this;
            }
            setCameraFov(t1) {
                this.camera.fov = t1, this.cameraFov = t1, t1 === this.cameraFovValues.x1 && (this.currentFovIcon = hN), t1 === this.cameraFovValues.x05 && (this.currentFovIcon = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDQiIGhlaWdodD0iNDQiIHZpZXdCb3g9IjAgMCA0NCA0NCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE2LjQ5OCAyMC42MjVIMjQuNzQ4OCIgc3Ryb2tlPSIjNDEzRTNFIiBzdHJva2Utd2lkdGg9IjEuOTQ4MDkiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNMjAuNjIzIDE2LjVWMjQuNzUwNyIgc3Ryb2tlPSIjNDEzRTNFIiBzdHJva2Utd2lkdGg9IjEuOTQ4MDkiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNMjAuNTM4IDMwLjc2NzRDMjYuMTg2NSAzMC43Njc0IDMwLjc2NTQgMjYuMTg4NCAzMC43NjU0IDIwLjUzOTlDMzAuNzY1NCAxNC44OTE1IDI2LjE4NjUgMTAuMzEyNSAyMC41MzggMTAuMzEyNUMxNC44ODk1IDEwLjMxMjUgMTAuMzEwNSAxNC44OTE1IDEwLjMxMDUgMjAuNTM5OUMxMC4zMTA1IDI2LjE4ODQgMTQuODg5NSAzMC43Njc0IDIwLjUzOCAzMC43Njc0WiIgc3Ryb2tlPSIjNDEzRTNFIiBzdHJva2Utd2lkdGg9IjEuOTQ4MDkiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNMjcuNzcxNSAyNy43Njk1TDMzLjY4ODggMzMuNjg2OCIgc3Ryb2tlPSIjNDEzRTNFIiBzdHJva2Utd2lkdGg9IjEuOTQ4MDkiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8L3N2Zz4K");
            }
            toggleFov() {
                const t1 = Object.entries(this.cameraFovValues).find((t1)=>{
                    let [e, i] = t1;
                    return i === this.camera.fov;
                })[0], e = zn.scales.findIndex((e)=>e === t1);
                zn.scales[e + 1] ? this.setCameraFov(this.cameraFovValues[zn.scales[e + 1]]) : this.setCameraFov(this.cameraFovValues[zn.scales[0]]);
            }
            setAutoRotateState(t1) {
                this.autoRotateState = t1;
            }
            toggleAutoRotate() {
                this.setAutoRotateState(!this.autoRotateState), this.autoRotateState ? this.camera.deviceOrientationControls.disable() : Cx.deviceOrientationGranted && this.camera.deviceOrientationControls.enable();
            }
            setCurrentPanoramasGroup(t1) {
                const e = this.floorsGroup.children.find((e)=>e.floorIndex === t1);
                if (e) return this.panoramasGroup = e, this.vrControlPanel.map.updateRoomsLayer(e), this.vrControlPanel.updateFloorMaterials(), this;
            }
            async setCurrentPanoramaById(t1) {
                var e;
                if ((null === (e = this.currentPanorama) || void 0 === e ? void 0 : e.panoramaId) === t1) return;
                const i = this.getPanoramaById(t1);
                if (this.animation || !i) return this;
                if (this.setCurrentPanoramaId(t1), this.animation = !0, zn.isCapable("hidden_furniture") && i.loaded && (this.setLoadingState(!0), performance.mark("start downloadingPanoramas"), await i.load(), performance.mark("finish downloadingPanoramas"), performance.measure("downloadingPanorama", "start downloadingPanoramas", "finish downloadingPanoramas"), this.setLoadingState(!1)), !i.loaded && (this.setLoadingState(!0), performance.mark("start downloadingPanoramas"), await i.load(), performance.mark("finish downloadingPanoramas"), performance.measure("downloadingPanoramas", "start downloadingPanoramas", "finish downloadingPanoramas"), this.setLoadingState(!1), zn.config.enableCameraRotationBetweenPanoramas && 0 !== i.userData.rotation)) {
                    const t1 = !!zn.config.enableCameraTransitionBetweenPanoramas && this.currentPanorama;
                    setTimeout(()=>{
                        this.camera.controls.normalizeRotations();
                        const e = mx(this.camera.controls.azimuthAngle), n = mx(i.userData.rotation), r = gx(((t1, e)=>{
                            const i = (e - t1) % 360;
                            return i > 180 ? i - 360 : i < -180 ? i + 360 : i;
                        })(e, n));
                        this.camera.controls.rotate(r, 0, t1);
                    }, t1 ? 200 : 0);
                }
                for (const t1 of (null === (n = this.currentPanorama) || void 0 === n ? void 0 : n.links) || []){
                    var n;
                    t1.visible = !1;
                }
                for (const t1 of i.links)t1.visible = !0;
                if (this.rulerModeEnabled) for (const e of this.rulersGroup.children){
                    const i = e.userData.panoramaId === t1;
                    e.centerPoint && (e.centerPoint.visible = i), e.visible = i;
                }
                this.currentPanorama && (this.currentPanorama.renderOrder = 0), i.renderOrder = 1, i.visible = !0, await i.fadeIn(), this.currentPanorama && (await this.currentPanorama.fadeOut(), this.currentPanorama.visible = !1);
                const r = null !== i.depthMap;
                return this.setCurrentPanorama(i), this.animation = !1, this.destroyTempRuler(), this.setRulerButtonState(r), this.rulerModeEnabled && this.setRulerMode(r), this;
            }
            setCurrentPanoramaId(t1) {
                this.currentPanoramaId = t1;
            }
            setCurrentPanorama(t1) {
                this.currentPanorama = t1;
            }
            async setInitialCurrentPanorama() {
                const t1 = this.panoramasGroup.children.find((t1)=>0 === t1.userData.panorama_index), e = this.initialPanoramaId || (null == t1 ? void 0 : t1.panoramaId) || null;
                return this.setCurrentPanoramaById(e).then(()=>{
                    this.initialPanoramaId = null;
                });
            }
            createPanoramas(t1, e) {
                const i = this.panoramasGroup.createPanoramas(t1, e);
                for (const t1 of i)for (const e of t1.links)e.onClick = ()=>this.setCurrentPanoramaById(e.userData.targetId), this.interactiveGroup.add(e);
                return this;
            }
        };
        if (!e.useState) throw new Error("mobx-react-lite requires React with Hooks support");
        var AN = i(961);
        function gN(t1) {
            t1();
        }
        function mN(t1) {
            var e;
            return ai(hn(t1, e));
        }
        var MN = function() {
            function t1(t1) {
                var e = this;
                Object.defineProperty(this, "finalize", {
                    enumerable: !0,
                    configurable: !0,
                    writable: !0,
                    value: t1
                }), Object.defineProperty(this, "registrations", {
                    enumerable: !0,
                    configurable: !0,
                    writable: !0,
                    value: new Map
                }), Object.defineProperty(this, "sweepTimeout", {
                    enumerable: !0,
                    configurable: !0,
                    writable: !0,
                    value: void 0
                }), Object.defineProperty(this, "sweep", {
                    enumerable: !0,
                    configurable: !0,
                    writable: !0,
                    value: function(t1) {
                        void 0 === t1 && (t1 = 1e4), clearTimeout(e.sweepTimeout), e.sweepTimeout = void 0;
                        var i = Date.now();
                        e.registrations.forEach(function(n, r) {
                            i - n.registeredAt >= t1 && (e.finalize(n.value), e.registrations.delete(r));
                        }), e.registrations.size > 0 && e.scheduleSweep();
                    }
                }), Object.defineProperty(this, "finalizeAllImmediately", {
                    enumerable: !0,
                    configurable: !0,
                    writable: !0,
                    value: function() {
                        e.sweep(0);
                    }
                });
            }
            return Object.defineProperty(t1.prototype, "register", {
                enumerable: !1,
                configurable: !0,
                writable: !0,
                value: function(t1, e, i) {
                    this.registrations.set(i, {
                        value: e,
                        registeredAt: Date.now()
                    }), this.scheduleSweep();
                }
            }), Object.defineProperty(t1.prototype, "unregister", {
                enumerable: !1,
                configurable: !0,
                writable: !0,
                value: function(t1) {
                    this.registrations.delete(t1);
                }
            }), Object.defineProperty(t1.prototype, "scheduleSweep", {
                enumerable: !1,
                configurable: !0,
                writable: !0,
                value: function() {
                    void 0 === this.sweepTimeout && (this.sweepTimeout = setTimeout(this.sweep, 1e4));
                }
            }), t1;
        }(), yN = new ("undefined" != typeof FinalizationRegistry ? FinalizationRegistry : MN)(function(t1) {
            var e;
            null === (e = t1.reaction) || void 0 === e || e.dispose(), t1.reaction = null;
        }), vN = !1;
        function xN() {
            return vN;
        }
        var wN = function(t1, e) {
            var i = "function" == typeof Symbol && t1[Symbol.iterator];
            if (!i) return t1;
            var n, r, a = i.call(t1), s = [];
            try {
                for(; (void 0 === e || e-- > 0) && !(n = a.next()).done;)s.push(n.value);
            } catch (t1) {
                r = {
                    error: t1
                };
            } finally{
                try {
                    n && !n.done && (i = a.return) && i.call(a);
                } finally{
                    if (r) throw r.error;
                }
            }
            return s;
        };
        function bN(t1) {
            return "observer".concat(t1);
        }
        var TN = function() {};
        function EN() {
            return new TN;
        }
        var IN = "function" == typeof Symbol && Symbol.for, SN = IN ? Symbol.for("react.forward_ref") : "function" == typeof e.forwardRef && (0, e.forwardRef)(function(t1) {
            return null;
        }).$$typeof, NN = IN ? Symbol.for("react.memo") : "function" == typeof e.memo && (0, e.memo)(function(t1) {
            return null;
        }).$$typeof;
        function DN(t1, i) {
            var n;
            if (NN && t1.$$typeof === NN) throw new Error("[mobx-react-lite] You are trying to use `observer` on a function component wrapped in either another `observer` or `React.memo`. The observer already applies 'React.memo' for you.");
            if (xN()) return t1;
            var r = null !== (n = null == i ? void 0 : i.forwardRef) && void 0 !== n && n, a = t1, s = t1.displayName || t1.name;
            if (SN && t1.$$typeof === SN && (r = !0, "function" != typeof (a = t1.render))) throw new Error("[mobx-react-lite] `render` property of ForwardRef was not a function");
            var o, l, c = function(t1, i) {
                return function(t1, i) {
                    if (void 0 === i && (i = "observed"), xN()) return t1();
                    var n = wN(e.useState(EN), 1)[0], r = wN(e.useState(), 2)[1], a = function() {
                        return r([]);
                    }, s = e.useRef(null);
                    s.current || (s.current = {
                        reaction: null,
                        mounted: !1,
                        changedBeforeMount: !1
                    });
                    var o, l, c = s.current;
                    if (c.reaction || (c.reaction = new je(bN(i), function() {
                        c.mounted ? a() : c.changedBeforeMount = !0;
                    }), yN.register(n, c, c)), e.useDebugValue(c.reaction, mN), e.useEffect(function() {
                        return yN.unregister(c), c.mounted = !0, c.reaction ? c.changedBeforeMount && (c.changedBeforeMount = !1, a()) : (c.reaction = new je(bN(i), function() {
                            a();
                        }), a()), function() {
                            c.reaction.dispose(), c.reaction = null, c.mounted = !1, c.changedBeforeMount = !1;
                        };
                    }, []), c.reaction.track(function() {
                        try {
                            o = t1();
                        } catch (t1) {
                            l = t1;
                        }
                    }), l) throw l;
                    return o;
                }(function() {
                    return a(t1, i);
                }, s);
            };
            return "" !== s && (c.displayName = s), t1.contextTypes && (c.contextTypes = t1.contextTypes), r && (c = (0, e.forwardRef)(c)), c = (0, e.memo)(c), o = t1, l = c, Object.keys(o).forEach(function(t1) {
                CN[t1] || Object.defineProperty(l, t1, Object.getOwnPropertyDescriptor(o, t1));
            }), c;
        }
        var CN = {
            $$typeof: !0,
            render: !0,
            compare: !0,
            type: !0,
            displayName: !0
        };
        !function(t1) {
            t1 || (t1 = gN), ni({
                reactionScheduler: t1
            });
        }(AN.unstable_batchedUpdates), yN.finalizeAllImmediately;
        const zN = {
            smallMobile: 374,
            mobile: 670,
            tablet: 1100,
            laptop: 1440
        }, LN = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTEiIGhlaWdodD0iNTEiIHZpZXdCb3g9IjAgMCA1MSA1MSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTM5LjQwODkgMTAuMjc2OUwxMS4wMzQ1IDM4LjY1MTMiIHN0cm9rZT0iIzQxM0UzRSIgc3Ryb2tlLXdpZHRoPSIzLjE1MjcxIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTM5LjQwODkgMzguNjUxM0wxMS4wMzQ1IDEwLjI3NjkiIHN0cm9rZT0iIzQxM0UzRSIgc3Ryb2tlLXdpZHRoPSIzLjE1MjcxIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9zdmc+Cg==", ON = DN(()=>Un.enabled ? Un.active ? e.createElement("button", {
                type: "button",
                className: "widget-exit-fullscreen",
                onClick: ()=>Un.exit()
            }, e.createElement("img", {
                src: LN,
                alt: "exit-fullscreen"
            })) : e.createElement("button", {
                type: "button",
                className: "widget-enter-fullscreen",
                onClick: ()=>Un.enter()
            }, e.createElement("img", {
                src: "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTEiIHZpZXdCb3g9IjAgMCA1MCA1MSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTMxLjI1IDkuODc1SDQwLjYyNVYxOS4yNSIgc3Ryb2tlPSIjNDEzRTNFIiBzdHJva2Utd2lkdGg9IjMuMTUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNMjkuNjg3NSAyMC44MTI1TDQwLjYyNSA5Ljg3NSIgc3Ryb2tlPSIjNDEzRTNFIiBzdHJva2Utd2lkdGg9IjMuMTUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNMTguNzUgNDEuMTI1SDkuMzc1VjMxLjc1IiBzdHJva2U9IiM0MTNFM0UiIHN0cm9rZS13aWR0aD0iMy4xNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik0yMC4zMTI1IDMwLjE4NzVMOS4zNzUgNDEuMTI1IiBzdHJva2U9IiM0MTNFM0UiIHN0cm9rZS13aWR0aD0iMy4xNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo=",
                alt: "enter-fullscreen"
            })) : null), _N = DN(()=>{
            const [t1, i] = (0, e.useState)(!1);
            return e.createElement("button", {
                type: "button",
                className: "widget-tab-button",
                disabled: t1,
                onClick: async ()=>{
                    i(!0), fN.enterVr().finally(()=>i(!1));
                }
            }, "VR");
        }), jN = (t1)=>{
            let { active: i, text: n, img: r, onClick: a } = t1;
            return e.createElement("button", {
                type: "button",
                className: "widget-tab-button ".concat(i ? "widget-tab-button--active" : ""),
                onClick: a
            }, n, Boolean(r) && e.createElement("img", {
                src: r,
                alt: "icon"
            }));
        }, PN = (t1)=>{
            let { href: i, text: n } = t1;
            return e.createElement("a", {
                href: i,
                target: "_blank",
                rel: "noreferrer"
            }, e.createElement("span", null, "made by"), " ", n);
        };
        var RN = i(611), UN = i.n(RN);
        function kN(t1, e, i) {
            (function(t1, e) {
                if (e.has(t1)) throw new TypeError("Cannot initialize the same private elements twice on an object");
            })(t1, e), e.set(t1, i);
        }
        function BN(t1, e) {
            return t1.get(QN(t1, e));
        }
        function FN(t1, e, i) {
            return t1.set(QN(t1, e), i), i;
        }
        function QN(t1, e, i) {
            if ("function" == typeof t1 ? t1 === e : t1.has(e)) return arguments.length < 3 ? e : i;
            throw new TypeError("Private element is not present on this object");
        }
        var HN = new WeakMap, VN = new WeakMap, GN = new WeakMap;
        const YN = class {
            constructor(t1, e){
                kN(this, HN, null), kN(this, VN, null), kN(this, GN, null), FN(VN, this, e), FN(GN, this, {
                    container: {
                        mousedown: (t1)=>{
                            0 === t1.button && FN(HN, this, t1.pageX);
                        },
                        touchstart: (t1)=>FN(HN, this, t1.touches[0].clientX),
                        touchend: ()=>FN(HN, this, null)
                    },
                    prev: {
                        mousedown: (e)=>{
                            e.preventDefault(), t1.play(!0);
                        },
                        mouseup: (e)=>{
                            e.preventDefault(), t1.stop();
                        },
                        touchstart: (e)=>{
                            e.preventDefault(), t1.prev();
                        }
                    },
                    next: {
                        mousedown: (e)=>{
                            e.preventDefault(), t1.play();
                        },
                        mouseup: (e)=>{
                            e.preventDefault(), t1.stop();
                        },
                        touchstart: (e)=>{
                            e.preventDefault(), t1.next();
                        }
                    },
                    global: {
                        mouseup: ()=>FN(HN, this, null),
                        mousemove: (e)=>{
                            BN(HN, this) && Math.abs(BN(HN, this) - e.pageX) > BN(VN, this).dragTolerance && (t1.stop(), BN(HN, this) > e.pageX ? t1.prev() : t1.next(), FN(HN, this, e.pageX));
                        },
                        touchmove: (e)=>{
                            2 !== e.touches.length && (1 === e.touches.length && e.stopPropagation(), BN(HN, this) && Math.abs(BN(HN, this) - e.touches[0].clientX) > BN(VN, this).swipeTolerance && (t1.stop(), BN(HN, this) > e.touches[0].clientX ? t1.prev() : t1.next(), FN(HN, this, e.touches[0].clientX)));
                        },
                        keydown: (e)=>{
                            [
                                37,
                                39
                            ].includes(e.keyCode) && t1.play(37 === e.keyCode);
                        },
                        keyup: (e)=>{
                            [
                                37,
                                39
                            ].includes(e.keyCode) && t1.stop();
                        }
                    }
                }), this._initEvents();
            }
            destroy() {
                BN(VN, this).swipeTarget.removeEventListener("mousedown", BN(GN, this).container.mousedown), BN(VN, this).swipeTarget.removeEventListener("touchstart", BN(GN, this).container.touchstart), BN(VN, this).swipeTarget.removeEventListener("touchend", BN(GN, this).container.touchend), i.g.removeEventListener("mouseup", BN(GN, this).global.mouseup), i.g.removeEventListener("mousemove", BN(GN, this).global.mousemove), BN(VN, this).parentElement.removeEventListener("touchmove", BN(GN, this).global.touchmove), i.g.removeEventListener("keydown", BN(GN, this).global.keydown), i.g.removeEventListener("keyup", BN(GN, this).global.keyup), BN(VN, this).prev && (BN(VN, this).prev.removeEventListener("mousedown", BN(GN, this).prev.mousedown), BN(VN, this).prev.removeEventListener("mouseup", BN(GN, this).prev.mouseup), BN(VN, this).prev.removeEventListener("touchstart", BN(GN, this).prev.touchstart)), BN(VN, this).next && (BN(VN, this).next.removeEventListener("mousedown", BN(GN, this).next.mousedown), BN(VN, this).next.removeEventListener("mouseup", BN(GN, this).next.mouseup), BN(VN, this).next.removeEventListener("touchstart", BN(GN, this).next.touchstart));
            }
            _initEvents() {
                BN(VN, this).draggable && (BN(VN, this).swipeTarget.addEventListener("mousedown", BN(GN, this).container.mousedown), i.g.addEventListener("mouseup", BN(GN, this).global.mouseup), i.g.addEventListener("mousemove", BN(GN, this).global.mousemove)), BN(VN, this).swipeable && (BN(VN, this).swipeTarget.addEventListener("touchstart", BN(GN, this).container.touchstart), BN(VN, this).swipeTarget.addEventListener("touchend", BN(GN, this).container.touchend), BN(VN, this).parentElement.addEventListener("touchmove", BN(GN, this).global.touchmove)), BN(VN, this).keys && (i.g.addEventListener("keydown", BN(GN, this).global.keydown), i.g.addEventListener("keyup", BN(GN, this).global.keyup)), BN(VN, this).prev && (BN(VN, this).prev.addEventListener("mousedown", BN(GN, this).prev.mousedown), BN(VN, this).prev.addEventListener("mouseup", BN(GN, this).prev.mouseup), BN(VN, this).prev.addEventListener("touchstart", BN(GN, this).prev.touchstart)), BN(VN, this).next && (BN(VN, this).next.addEventListener("mousedown", BN(GN, this).next.mousedown), BN(VN, this).next.addEventListener("mouseup", BN(GN, this).next.mouseup), BN(VN, this).next.addEventListener("touchstart", BN(GN, this).next.touchstart));
            }
        };
        function WN(t1, e, i) {
            (function(t1, e) {
                if (e.has(t1)) throw new TypeError("Cannot initialize the same private elements twice on an object");
            })(t1, e), e.set(t1, i);
        }
        function XN(t1, e) {
            return t1.get(JN(t1, e));
        }
        function ZN(t1, e, i) {
            return t1.set(JN(t1, e), i), i;
        }
        function JN(t1, e, i) {
            if ("function" == typeof t1 ? t1 === e : t1.has(e)) return arguments.length < 3 ? e : i;
            throw new TypeError("Private element is not present on this object");
        }
        var KN = new WeakMap, qN = new WeakMap, $N = new WeakMap, tD = new WeakMap, eD = new WeakMap, iD = new WeakMap;
        const nD = class {
            constructor(t1, e){
                WN(this, KN, null), WN(this, qN, 0), WN(this, $N, null), WN(this, tD, !1), WN(this, eD, null), WN(this, iD, !1), this.container = t1, ZN(KN, this, Object.assign({
                    width: 300,
                    height: 300,
                    aspectRatio: 0,
                    count: 0,
                    perRow: 0,
                    speed: 100,
                    dragTolerance: 10,
                    swipeTolerance: 10,
                    draggable: !0,
                    swipeable: !0,
                    keys: !0,
                    inverted: !1
                }, e)), XN(KN, this).swipeTarget = XN(KN, this).swipeTarget || this.container, ZN(iD, this, !Array.isArray(XN(KN, this).image)), this.sprite || (XN(KN, this).count = XN(KN, this).image.length), Object.freeze(XN(KN, this)), ZN(eD, this, new YN(this, XN(KN, this))), this._windowResizeListener = this._windowResizeListener.bind(this), this._initContainer();
            }
            get isResponsive() {
                return XN(KN, this).aspectRatio > 0;
            }
            get containerWidth() {
                return this.isResponsive ? this.container.clientWidth : XN(KN, this).width;
            }
            get containerHeight() {
                return this.isResponsive ? this.container.clientWidth * XN(KN, this).aspectRatio : XN(KN, this).height;
            }
            get index() {
                return XN(qN, this);
            }
            get looping() {
                return XN(tD, this);
            }
            get sprite() {
                return XN(iD, this);
            }
            next() {
                this.goto(XN(KN, this).inverted ? XN(qN, this) - 1 : XN(qN, this) + 1);
            }
            prev() {
                this.goto(XN(KN, this).inverted ? XN(qN, this) + 1 : XN(qN, this) - 1);
            }
            goto(t1) {
                ZN(qN, this, (XN(KN, this).count + t1) % XN(KN, this).count), this._update();
            }
            play(t1) {
                this.looping || (this._loop(t1), ZN(tD, this, !0));
            }
            stop() {
                this.looping && (i.g.clearTimeout(XN($N, this)), ZN(tD, this, !1));
            }
            toggle(t1) {
                this.looping ? this.stop() : this.play(t1);
            }
            destroy() {
                this.stop(), XN(eD, this).destroy(), this.container.style.width = "", this.container.style.height = "", this.container.style.backgroundImage = "", this.container.style.backgroundPositionX = "", this.container.style.backgroundPositionY = "", this.container.style.backgroundSize = "", this.isResponsive && window.removeEventListener("resize", this._windowResizeListener);
            }
            _loop(t1) {
                t1 ? this.prev() : this.next(), ZN($N, this, i.g.setTimeout(()=>{
                    this._loop(t1);
                }, XN(KN, this).speed));
            }
            _update() {
                this.sprite ? (this.container.style.backgroundPositionX = -XN(qN, this) % XN(KN, this).perRow * this.containerWidth + "px", this.container.style.backgroundPositionY = -Math.floor(XN(qN, this) / XN(KN, this).perRow) * this.containerHeight + "px") : this.container.style.backgroundImage = 'url("'.concat(XN(KN, this).image[XN(qN, this)], '")');
            }
            _windowResizeListener() {
                this.container.style.height = this.containerHeight + "px", this._update();
            }
            _initContainer() {
                if (this.isResponsive || (this.container.style.width = this.containerWidth + "px"), this.container.style.height = this.containerHeight + "px", this.sprite) {
                    this.container.style.backgroundImage = 'url("'.concat(XN(KN, this).image, '")');
                    const t1 = XN(KN, this).perRow, e = Math.ceil(XN(KN, this).count / XN(KN, this).perRow);
                    this.container.style.backgroundSize = 100 * t1 + "% " + 100 * e + "%";
                }
                this.isResponsive && window.addEventListener("resize", this._windowResizeListener), this._update();
            }
        }, rD = (t1)=>{
            let { initialized: i, images: n, activeIndex: r } = t1;
            return e.createElement(e.Fragment, null, e.createElement("div", {
                className: "widget-tab__threesixty ".concat(i ? "widget-tab__threesixty--active" : "")
            }, e.createElement("div", {
                className: "widget-tab__threesixty-container",
                onTouchMove: (t1)=>{
                    t1.touches.length > 1 || i || t1.stopPropagation();
                }
            }, n.map((t1, i)=>e.createElement("img", {
                    className: r === i ? "active" : "",
                    alt: "rotation-view-".concat(i),
                    key: i,
                    src: t1
                })))));
        }, aD = (t1)=>{
            let { steps: i = [], disabled: n = !1, onClick: r = ()=>{} } = t1;
            const a = Tv("instructions-hint-text");
            return e.createElement("div", {
                className: "widget-instructions",
                onClick: ()=>{
                    n || r();
                }
            }, e.createElement("div", {
                className: "widget-instructions__content",
                onClick: (t1)=>t1.stopPropagation()
            }, e.createElement("div", {
                className: "widget-instructions__steps"
            }, i.map((t1, i)=>{
                let { text: n, icon: r } = t1;
                return e.createElement("div", {
                    className: "widget-instructions__step",
                    key: i
                }, e.createElement("img", {
                    src: r,
                    alt: "step-icon"
                }), e.createElement("p", null, n));
            })), e.createElement("button", {
                disabled: n,
                onClick: r,
                type: "button"
            }, Tv("ok")), Boolean(a) && e.createElement("div", {
                className: "widget-instructions__hint"
            }, e.createElement("p", null, a))));
        };
        class sD {
            constructor(t1 = 0, e = 0, i = 0, n = 1){
                sD.prototype.isVector4 = !0, this.x = t1, this.y = e, this.z = i, this.w = n;
            }
            get width() {
                return this.z;
            }
            set width(t1) {
                this.z = t1;
            }
            get height() {
                return this.w;
            }
            set height(t1) {
                this.w = t1;
            }
            set(t1, e, i, n) {
                return this.x = t1, this.y = e, this.z = i, this.w = n, this;
            }
            setScalar(t1) {
                return this.x = t1, this.y = t1, this.z = t1, this.w = t1, this;
            }
            setX(t1) {
                return this.x = t1, this;
            }
            setY(t1) {
                return this.y = t1, this;
            }
            setZ(t1) {
                return this.z = t1, this;
            }
            setW(t1) {
                return this.w = t1, this;
            }
            setComponent(t1, e) {
                switch(t1){
                    case 0:
                        this.x = e;
                        break;
                    case 1:
                        this.y = e;
                        break;
                    case 2:
                        this.z = e;
                        break;
                    case 3:
                        this.w = e;
                        break;
                    default:
                        throw new Error("index is out of range: " + t1);
                }
                return this;
            }
            getComponent(t1) {
                switch(t1){
                    case 0:
                        return this.x;
                    case 1:
                        return this.y;
                    case 2:
                        return this.z;
                    case 3:
                        return this.w;
                    default:
                        throw new Error("index is out of range: " + t1);
                }
            }
            clone() {
                return new this.constructor(this.x, this.y, this.z, this.w);
            }
            copy(t1) {
                return this.x = t1.x, this.y = t1.y, this.z = t1.z, this.w = void 0 !== t1.w ? t1.w : 1, this;
            }
            add(t1) {
                return this.x += t1.x, this.y += t1.y, this.z += t1.z, this.w += t1.w, this;
            }
            addScalar(t1) {
                return this.x += t1, this.y += t1, this.z += t1, this.w += t1, this;
            }
            addVectors(t1, e) {
                return this.x = t1.x + e.x, this.y = t1.y + e.y, this.z = t1.z + e.z, this.w = t1.w + e.w, this;
            }
            addScaledVector(t1, e) {
                return this.x += t1.x * e, this.y += t1.y * e, this.z += t1.z * e, this.w += t1.w * e, this;
            }
            sub(t1) {
                return this.x -= t1.x, this.y -= t1.y, this.z -= t1.z, this.w -= t1.w, this;
            }
            subScalar(t1) {
                return this.x -= t1, this.y -= t1, this.z -= t1, this.w -= t1, this;
            }
            subVectors(t1, e) {
                return this.x = t1.x - e.x, this.y = t1.y - e.y, this.z = t1.z - e.z, this.w = t1.w - e.w, this;
            }
            multiply(t1) {
                return this.x *= t1.x, this.y *= t1.y, this.z *= t1.z, this.w *= t1.w, this;
            }
            multiplyScalar(t1) {
                return this.x *= t1, this.y *= t1, this.z *= t1, this.w *= t1, this;
            }
            applyMatrix4(t1) {
                const e = this.x, i = this.y, n = this.z, r = this.w, a = t1.elements;
                return this.x = a[0] * e + a[4] * i + a[8] * n + a[12] * r, this.y = a[1] * e + a[5] * i + a[9] * n + a[13] * r, this.z = a[2] * e + a[6] * i + a[10] * n + a[14] * r, this.w = a[3] * e + a[7] * i + a[11] * n + a[15] * r, this;
            }
            divideScalar(t1) {
                return this.multiplyScalar(1 / t1);
            }
            setAxisAngleFromQuaternion(t1) {
                this.w = 2 * Math.acos(t1.w);
                const e = Math.sqrt(1 - t1.w * t1.w);
                return e < 1e-4 ? (this.x = 1, this.y = 0, this.z = 0) : (this.x = t1.x / e, this.y = t1.y / e, this.z = t1.z / e), this;
            }
            setAxisAngleFromRotationMatrix(t1) {
                let e, i, n, r;
                const a = .01, s = .1, o = t1.elements, l = o[0], c = o[4], u = o[8], h = o[1], d = o[5], p = o[9], f = o[2], A = o[6], g = o[10];
                if (Math.abs(c - h) < a && Math.abs(u - f) < a && Math.abs(p - A) < a) {
                    if (Math.abs(c + h) < s && Math.abs(u + f) < s && Math.abs(p + A) < s && Math.abs(l + d + g - 3) < s) return this.set(1, 0, 0, 0), this;
                    e = Math.PI;
                    const t1 = (l + 1) / 2, o = (d + 1) / 2, m = (g + 1) / 2, M = (c + h) / 4, y = (u + f) / 4, v = (p + A) / 4;
                    return t1 > o && t1 > m ? t1 < a ? (i = 0, n = .707106781, r = .707106781) : (i = Math.sqrt(t1), n = M / i, r = y / i) : o > m ? o < a ? (i = .707106781, n = 0, r = .707106781) : (n = Math.sqrt(o), i = M / n, r = v / n) : m < a ? (i = .707106781, n = .707106781, r = 0) : (r = Math.sqrt(m), i = y / r, n = v / r), this.set(i, n, r, e), this;
                }
                let m = Math.sqrt((A - p) * (A - p) + (u - f) * (u - f) + (h - c) * (h - c));
                return Math.abs(m) < .001 && (m = 1), this.x = (A - p) / m, this.y = (u - f) / m, this.z = (h - c) / m, this.w = Math.acos((l + d + g - 1) / 2), this;
            }
            min(t1) {
                return this.x = Math.min(this.x, t1.x), this.y = Math.min(this.y, t1.y), this.z = Math.min(this.z, t1.z), this.w = Math.min(this.w, t1.w), this;
            }
            max(t1) {
                return this.x = Math.max(this.x, t1.x), this.y = Math.max(this.y, t1.y), this.z = Math.max(this.z, t1.z), this.w = Math.max(this.w, t1.w), this;
            }
            clamp(t1, e) {
                return this.x = Math.max(t1.x, Math.min(e.x, this.x)), this.y = Math.max(t1.y, Math.min(e.y, this.y)), this.z = Math.max(t1.z, Math.min(e.z, this.z)), this.w = Math.max(t1.w, Math.min(e.w, this.w)), this;
            }
            clampScalar(t1, e) {
                return this.x = Math.max(t1, Math.min(e, this.x)), this.y = Math.max(t1, Math.min(e, this.y)), this.z = Math.max(t1, Math.min(e, this.z)), this.w = Math.max(t1, Math.min(e, this.w)), this;
            }
            clampLength(t1, e) {
                const i = this.length();
                return this.divideScalar(i || 1).multiplyScalar(Math.max(t1, Math.min(e, i)));
            }
            floor() {
                return this.x = Math.floor(this.x), this.y = Math.floor(this.y), this.z = Math.floor(this.z), this.w = Math.floor(this.w), this;
            }
            ceil() {
                return this.x = Math.ceil(this.x), this.y = Math.ceil(this.y), this.z = Math.ceil(this.z), this.w = Math.ceil(this.w), this;
            }
            round() {
                return this.x = Math.round(this.x), this.y = Math.round(this.y), this.z = Math.round(this.z), this.w = Math.round(this.w), this;
            }
            roundToZero() {
                return this.x = Math.trunc(this.x), this.y = Math.trunc(this.y), this.z = Math.trunc(this.z), this.w = Math.trunc(this.w), this;
            }
            negate() {
                return this.x = -this.x, this.y = -this.y, this.z = -this.z, this.w = -this.w, this;
            }
            dot(t1) {
                return this.x * t1.x + this.y * t1.y + this.z * t1.z + this.w * t1.w;
            }
            lengthSq() {
                return this.x * this.x + this.y * this.y + this.z * this.z + this.w * this.w;
            }
            length() {
                return Math.sqrt(this.x * this.x + this.y * this.y + this.z * this.z + this.w * this.w);
            }
            manhattanLength() {
                return Math.abs(this.x) + Math.abs(this.y) + Math.abs(this.z) + Math.abs(this.w);
            }
            normalize() {
                return this.divideScalar(this.length() || 1);
            }
            setLength(t1) {
                return this.normalize().multiplyScalar(t1);
            }
            lerp(t1, e) {
                return this.x += (t1.x - this.x) * e, this.y += (t1.y - this.y) * e, this.z += (t1.z - this.z) * e, this.w += (t1.w - this.w) * e, this;
            }
            lerpVectors(t1, e, i) {
                return this.x = t1.x + (e.x - t1.x) * i, this.y = t1.y + (e.y - t1.y) * i, this.z = t1.z + (e.z - t1.z) * i, this.w = t1.w + (e.w - t1.w) * i, this;
            }
            equals(t1) {
                return t1.x === this.x && t1.y === this.y && t1.z === this.z && t1.w === this.w;
            }
            fromArray(t1, e = 0) {
                return this.x = t1[e], this.y = t1[e + 1], this.z = t1[e + 2], this.w = t1[e + 3], this;
            }
            toArray(t1 = [], e = 0) {
                return t1[e] = this.x, t1[e + 1] = this.y, t1[e + 2] = this.z, t1[e + 3] = this.w, t1;
            }
            fromBufferAttribute(t1, e) {
                return this.x = t1.getX(e), this.y = t1.getY(e), this.z = t1.getZ(e), this.w = t1.getW(e), this;
            }
            random() {
                return this.x = Math.random(), this.y = Math.random(), this.z = Math.random(), this.w = Math.random(), this;
            }
            *[Symbol.iterator]() {
                yield this.x, yield this.y, yield this.z, yield this.w;
            }
        }
        const oD = {
            enabled: !1,
            files: {},
            add: function(t1, e) {
                !1 !== this.enabled && (this.files[t1] = e);
            },
            get: function(t1) {
                if (!1 !== this.enabled) return this.files[t1];
            },
            remove: function(t1) {
                delete this.files[t1];
            },
            clear: function() {
                this.files = {};
            }
        };
        class lD {
            constructor(t1, e, i){
                const n = this;
                let r, a = !1, s = 0, o = 0;
                const l = [];
                this.onStart = void 0, this.onLoad = t1, this.onProgress = e, this.onError = i, this.itemStart = function(t1) {
                    o++, !1 === a && void 0 !== n.onStart && n.onStart(t1, s, o), a = !0;
                }, this.itemEnd = function(t1) {
                    s++, void 0 !== n.onProgress && n.onProgress(t1, s, o), s === o && (a = !1, void 0 !== n.onLoad && n.onLoad());
                }, this.itemError = function(t1) {
                    void 0 !== n.onError && n.onError(t1);
                }, this.resolveURL = function(t1) {
                    return r ? r(t1) : t1;
                }, this.setURLModifier = function(t1) {
                    return r = t1, this;
                }, this.addHandler = function(t1, e) {
                    return l.push(t1, e), this;
                }, this.removeHandler = function(t1) {
                    const e = l.indexOf(t1);
                    return -1 !== e && l.splice(e, 2), this;
                }, this.getHandler = function(t1) {
                    for(let e = 0, i = l.length; e < i; e += 2){
                        const i = l[e], n = l[e + 1];
                        if (i.global && (i.lastIndex = 0), i.test(t1)) return n;
                    }
                    return null;
                };
            }
        }
        const cD = new lD;
        class uD {
            constructor(t1){
                this.manager = void 0 !== t1 ? t1 : cD, this.crossOrigin = "anonymous", this.withCredentials = !1, this.path = "", this.resourcePath = "", this.requestHeader = {};
            }
            load() {}
            loadAsync(t1, e) {
                const i = this;
                return new Promise(function(n, r) {
                    i.load(t1, n, e, r);
                });
            }
            parse() {}
            setCrossOrigin(t1) {
                return this.crossOrigin = t1, this;
            }
            setWithCredentials(t1) {
                return this.withCredentials = t1, this;
            }
            setPath(t1) {
                return this.path = t1, this;
            }
            setResourcePath(t1) {
                return this.resourcePath = t1, this;
            }
            setRequestHeader(t1) {
                return this.requestHeader = t1, this;
            }
        }
        function hD(t1) {
            return document.createElementNS("http://www.w3.org/1999/xhtml", t1);
        }
        uD.DEFAULT_MATERIAL_NAME = "__DEFAULT", Int8Array, Uint8Array, Uint8ClampedArray, Int16Array, Uint16Array, Int32Array, Uint32Array, Float32Array, Float64Array;
        const dD = {};
        function pD(t1) {
            t1 in dD || (dD[t1] = !0, console.warn(t1));
        }
        class fD extends uD {
            constructor(t1){
                super(t1);
            }
            load(t1, e, i, n) {
                void 0 !== this.path && (t1 = this.path + t1), t1 = this.manager.resolveURL(t1);
                const r = this, a = oD.get(t1);
                if (void 0 !== a) return r.manager.itemStart(t1), setTimeout(function() {
                    e && e(a), r.manager.itemEnd(t1);
                }, 0), a;
                const s = hD("img");
                function o() {
                    c(), oD.add(t1, this), e && e(this), r.manager.itemEnd(t1);
                }
                function l(e) {
                    c(), n && n(e), r.manager.itemError(t1), r.manager.itemEnd(t1);
                }
                function c() {
                    s.removeEventListener("load", o, !1), s.removeEventListener("error", l, !1);
                }
                return s.addEventListener("load", o, !1), s.addEventListener("error", l, !1), "data:" !== t1.slice(0, 5) && void 0 !== this.crossOrigin && (s.crossOrigin = this.crossOrigin), r.manager.itemStart(t1), s.src = t1, s;
            }
        }
        class AD {
            addEventListener(t1, e) {
                void 0 === this._listeners && (this._listeners = {});
                const i = this._listeners;
                void 0 === i[t1] && (i[t1] = []), -1 === i[t1].indexOf(e) && i[t1].push(e);
            }
            hasEventListener(t1, e) {
                if (void 0 === this._listeners) return !1;
                const i = this._listeners;
                return void 0 !== i[t1] && -1 !== i[t1].indexOf(e);
            }
            removeEventListener(t1, e) {
                if (void 0 === this._listeners) return;
                const i = this._listeners[t1];
                if (void 0 !== i) {
                    const t1 = i.indexOf(e);
                    -1 !== t1 && i.splice(t1, 1);
                }
            }
            dispatchEvent(t1) {
                if (void 0 === this._listeners) return;
                const e = this._listeners[t1.type];
                if (void 0 !== e) {
                    t1.target = this;
                    const i = e.slice(0);
                    for(let e = 0, n = i.length; e < n; e++)i[e].call(this, t1);
                    t1.target = null;
                }
            }
        }
        const gD = 3001, mD = "srgb", MD = [
            "00",
            "01",
            "02",
            "03",
            "04",
            "05",
            "06",
            "07",
            "08",
            "09",
            "0a",
            "0b",
            "0c",
            "0d",
            "0e",
            "0f",
            "10",
            "11",
            "12",
            "13",
            "14",
            "15",
            "16",
            "17",
            "18",
            "19",
            "1a",
            "1b",
            "1c",
            "1d",
            "1e",
            "1f",
            "20",
            "21",
            "22",
            "23",
            "24",
            "25",
            "26",
            "27",
            "28",
            "29",
            "2a",
            "2b",
            "2c",
            "2d",
            "2e",
            "2f",
            "30",
            "31",
            "32",
            "33",
            "34",
            "35",
            "36",
            "37",
            "38",
            "39",
            "3a",
            "3b",
            "3c",
            "3d",
            "3e",
            "3f",
            "40",
            "41",
            "42",
            "43",
            "44",
            "45",
            "46",
            "47",
            "48",
            "49",
            "4a",
            "4b",
            "4c",
            "4d",
            "4e",
            "4f",
            "50",
            "51",
            "52",
            "53",
            "54",
            "55",
            "56",
            "57",
            "58",
            "59",
            "5a",
            "5b",
            "5c",
            "5d",
            "5e",
            "5f",
            "60",
            "61",
            "62",
            "63",
            "64",
            "65",
            "66",
            "67",
            "68",
            "69",
            "6a",
            "6b",
            "6c",
            "6d",
            "6e",
            "6f",
            "70",
            "71",
            "72",
            "73",
            "74",
            "75",
            "76",
            "77",
            "78",
            "79",
            "7a",
            "7b",
            "7c",
            "7d",
            "7e",
            "7f",
            "80",
            "81",
            "82",
            "83",
            "84",
            "85",
            "86",
            "87",
            "88",
            "89",
            "8a",
            "8b",
            "8c",
            "8d",
            "8e",
            "8f",
            "90",
            "91",
            "92",
            "93",
            "94",
            "95",
            "96",
            "97",
            "98",
            "99",
            "9a",
            "9b",
            "9c",
            "9d",
            "9e",
            "9f",
            "a0",
            "a1",
            "a2",
            "a3",
            "a4",
            "a5",
            "a6",
            "a7",
            "a8",
            "a9",
            "aa",
            "ab",
            "ac",
            "ad",
            "ae",
            "af",
            "b0",
            "b1",
            "b2",
            "b3",
            "b4",
            "b5",
            "b6",
            "b7",
            "b8",
            "b9",
            "ba",
            "bb",
            "bc",
            "bd",
            "be",
            "bf",
            "c0",
            "c1",
            "c2",
            "c3",
            "c4",
            "c5",
            "c6",
            "c7",
            "c8",
            "c9",
            "ca",
            "cb",
            "cc",
            "cd",
            "ce",
            "cf",
            "d0",
            "d1",
            "d2",
            "d3",
            "d4",
            "d5",
            "d6",
            "d7",
            "d8",
            "d9",
            "da",
            "db",
            "dc",
            "dd",
            "de",
            "df",
            "e0",
            "e1",
            "e2",
            "e3",
            "e4",
            "e5",
            "e6",
            "e7",
            "e8",
            "e9",
            "ea",
            "eb",
            "ec",
            "ed",
            "ee",
            "ef",
            "f0",
            "f1",
            "f2",
            "f3",
            "f4",
            "f5",
            "f6",
            "f7",
            "f8",
            "f9",
            "fa",
            "fb",
            "fc",
            "fd",
            "fe",
            "ff"
        ];
        function yD() {
            const t1 = 4294967295 * Math.random() | 0, e = 4294967295 * Math.random() | 0, i = 4294967295 * Math.random() | 0, n = 4294967295 * Math.random() | 0;
            return (MD[255 & t1] + MD[t1 >> 8 & 255] + MD[t1 >> 16 & 255] + MD[t1 >> 24 & 255] + "-" + MD[255 & e] + MD[e >> 8 & 255] + "-" + MD[e >> 16 & 15 | 64] + MD[e >> 24 & 255] + "-" + MD[63 & i | 128] + MD[i >> 8 & 255] + "-" + MD[i >> 16 & 255] + MD[i >> 24 & 255] + MD[255 & n] + MD[n >> 8 & 255] + MD[n >> 16 & 255] + MD[n >> 24 & 255]).toLowerCase();
        }
        function vD(t1, e, i) {
            return Math.max(e, Math.min(i, t1));
        }
        Math.PI, Math.PI;
        class xD {
            constructor(t1 = 0, e = 0){
                xD.prototype.isVector2 = !0, this.x = t1, this.y = e;
            }
            get width() {
                return this.x;
            }
            set width(t1) {
                this.x = t1;
            }
            get height() {
                return this.y;
            }
            set height(t1) {
                this.y = t1;
            }
            set(t1, e) {
                return this.x = t1, this.y = e, this;
            }
            setScalar(t1) {
                return this.x = t1, this.y = t1, this;
            }
            setX(t1) {
                return this.x = t1, this;
            }
            setY(t1) {
                return this.y = t1, this;
            }
            setComponent(t1, e) {
                switch(t1){
                    case 0:
                        this.x = e;
                        break;
                    case 1:
                        this.y = e;
                        break;
                    default:
                        throw new Error("index is out of range: " + t1);
                }
                return this;
            }
            getComponent(t1) {
                switch(t1){
                    case 0:
                        return this.x;
                    case 1:
                        return this.y;
                    default:
                        throw new Error("index is out of range: " + t1);
                }
            }
            clone() {
                return new this.constructor(this.x, this.y);
            }
            copy(t1) {
                return this.x = t1.x, this.y = t1.y, this;
            }
            add(t1) {
                return this.x += t1.x, this.y += t1.y, this;
            }
            addScalar(t1) {
                return this.x += t1, this.y += t1, this;
            }
            addVectors(t1, e) {
                return this.x = t1.x + e.x, this.y = t1.y + e.y, this;
            }
            addScaledVector(t1, e) {
                return this.x += t1.x * e, this.y += t1.y * e, this;
            }
            sub(t1) {
                return this.x -= t1.x, this.y -= t1.y, this;
            }
            subScalar(t1) {
                return this.x -= t1, this.y -= t1, this;
            }
            subVectors(t1, e) {
                return this.x = t1.x - e.x, this.y = t1.y - e.y, this;
            }
            multiply(t1) {
                return this.x *= t1.x, this.y *= t1.y, this;
            }
            multiplyScalar(t1) {
                return this.x *= t1, this.y *= t1, this;
            }
            divide(t1) {
                return this.x /= t1.x, this.y /= t1.y, this;
            }
            divideScalar(t1) {
                return this.multiplyScalar(1 / t1);
            }
            applyMatrix3(t1) {
                const e = this.x, i = this.y, n = t1.elements;
                return this.x = n[0] * e + n[3] * i + n[6], this.y = n[1] * e + n[4] * i + n[7], this;
            }
            min(t1) {
                return this.x = Math.min(this.x, t1.x), this.y = Math.min(this.y, t1.y), this;
            }
            max(t1) {
                return this.x = Math.max(this.x, t1.x), this.y = Math.max(this.y, t1.y), this;
            }
            clamp(t1, e) {
                return this.x = Math.max(t1.x, Math.min(e.x, this.x)), this.y = Math.max(t1.y, Math.min(e.y, this.y)), this;
            }
            clampScalar(t1, e) {
                return this.x = Math.max(t1, Math.min(e, this.x)), this.y = Math.max(t1, Math.min(e, this.y)), this;
            }
            clampLength(t1, e) {
                const i = this.length();
                return this.divideScalar(i || 1).multiplyScalar(Math.max(t1, Math.min(e, i)));
            }
            floor() {
                return this.x = Math.floor(this.x), this.y = Math.floor(this.y), this;
            }
            ceil() {
                return this.x = Math.ceil(this.x), this.y = Math.ceil(this.y), this;
            }
            round() {
                return this.x = Math.round(this.x), this.y = Math.round(this.y), this;
            }
            roundToZero() {
                return this.x = Math.trunc(this.x), this.y = Math.trunc(this.y), this;
            }
            negate() {
                return this.x = -this.x, this.y = -this.y, this;
            }
            dot(t1) {
                return this.x * t1.x + this.y * t1.y;
            }
            cross(t1) {
                return this.x * t1.y - this.y * t1.x;
            }
            lengthSq() {
                return this.x * this.x + this.y * this.y;
            }
            length() {
                return Math.sqrt(this.x * this.x + this.y * this.y);
            }
            manhattanLength() {
                return Math.abs(this.x) + Math.abs(this.y);
            }
            normalize() {
                return this.divideScalar(this.length() || 1);
            }
            angle() {
                return Math.atan2(-this.y, -this.x) + Math.PI;
            }
            angleTo(t1) {
                const e = Math.sqrt(this.lengthSq() * t1.lengthSq());
                if (0 === e) return Math.PI / 2;
                const i = this.dot(t1) / e;
                return Math.acos(vD(i, -1, 1));
            }
            distanceTo(t1) {
                return Math.sqrt(this.distanceToSquared(t1));
            }
            distanceToSquared(t1) {
                const e = this.x - t1.x, i = this.y - t1.y;
                return e * e + i * i;
            }
            manhattanDistanceTo(t1) {
                return Math.abs(this.x - t1.x) + Math.abs(this.y - t1.y);
            }
            setLength(t1) {
                return this.normalize().multiplyScalar(t1);
            }
            lerp(t1, e) {
                return this.x += (t1.x - this.x) * e, this.y += (t1.y - this.y) * e, this;
            }
            lerpVectors(t1, e, i) {
                return this.x = t1.x + (e.x - t1.x) * i, this.y = t1.y + (e.y - t1.y) * i, this;
            }
            equals(t1) {
                return t1.x === this.x && t1.y === this.y;
            }
            fromArray(t1, e = 0) {
                return this.x = t1[e], this.y = t1[e + 1], this;
            }
            toArray(t1 = [], e = 0) {
                return t1[e] = this.x, t1[e + 1] = this.y, t1;
            }
            fromBufferAttribute(t1, e) {
                return this.x = t1.getX(e), this.y = t1.getY(e), this;
            }
            rotateAround(t1, e) {
                const i = Math.cos(e), n = Math.sin(e), r = this.x - t1.x, a = this.y - t1.y;
                return this.x = r * i - a * n + t1.x, this.y = r * n + a * i + t1.y, this;
            }
            random() {
                return this.x = Math.random(), this.y = Math.random(), this;
            }
            *[Symbol.iterator]() {
                yield this.x, yield this.y;
            }
        }
        class wD {
            constructor(t1, e, i, n, r, a, s, o, l){
                wD.prototype.isMatrix3 = !0, this.elements = [
                    1,
                    0,
                    0,
                    0,
                    1,
                    0,
                    0,
                    0,
                    1
                ], void 0 !== t1 && this.set(t1, e, i, n, r, a, s, o, l);
            }
            set(t1, e, i, n, r, a, s, o, l) {
                const c = this.elements;
                return c[0] = t1, c[1] = n, c[2] = s, c[3] = e, c[4] = r, c[5] = o, c[6] = i, c[7] = a, c[8] = l, this;
            }
            identity() {
                return this.set(1, 0, 0, 0, 1, 0, 0, 0, 1), this;
            }
            copy(t1) {
                const e = this.elements, i = t1.elements;
                return e[0] = i[0], e[1] = i[1], e[2] = i[2], e[3] = i[3], e[4] = i[4], e[5] = i[5], e[6] = i[6], e[7] = i[7], e[8] = i[8], this;
            }
            extractBasis(t1, e, i) {
                return t1.setFromMatrix3Column(this, 0), e.setFromMatrix3Column(this, 1), i.setFromMatrix3Column(this, 2), this;
            }
            setFromMatrix4(t1) {
                const e = t1.elements;
                return this.set(e[0], e[4], e[8], e[1], e[5], e[9], e[2], e[6], e[10]), this;
            }
            multiply(t1) {
                return this.multiplyMatrices(this, t1);
            }
            premultiply(t1) {
                return this.multiplyMatrices(t1, this);
            }
            multiplyMatrices(t1, e) {
                const i = t1.elements, n = e.elements, r = this.elements, a = i[0], s = i[3], o = i[6], l = i[1], c = i[4], u = i[7], h = i[2], d = i[5], p = i[8], f = n[0], A = n[3], g = n[6], m = n[1], M = n[4], y = n[7], v = n[2], x = n[5], w = n[8];
                return r[0] = a * f + s * m + o * v, r[3] = a * A + s * M + o * x, r[6] = a * g + s * y + o * w, r[1] = l * f + c * m + u * v, r[4] = l * A + c * M + u * x, r[7] = l * g + c * y + u * w, r[2] = h * f + d * m + p * v, r[5] = h * A + d * M + p * x, r[8] = h * g + d * y + p * w, this;
            }
            multiplyScalar(t1) {
                const e = this.elements;
                return e[0] *= t1, e[3] *= t1, e[6] *= t1, e[1] *= t1, e[4] *= t1, e[7] *= t1, e[2] *= t1, e[5] *= t1, e[8] *= t1, this;
            }
            determinant() {
                const t1 = this.elements, e = t1[0], i = t1[1], n = t1[2], r = t1[3], a = t1[4], s = t1[5], o = t1[6], l = t1[7], c = t1[8];
                return e * a * c - e * s * l - i * r * c + i * s * o + n * r * l - n * a * o;
            }
            invert() {
                const t1 = this.elements, e = t1[0], i = t1[1], n = t1[2], r = t1[3], a = t1[4], s = t1[5], o = t1[6], l = t1[7], c = t1[8], u = c * a - s * l, h = s * o - c * r, d = l * r - a * o, p = e * u + i * h + n * d;
                if (0 === p) return this.set(0, 0, 0, 0, 0, 0, 0, 0, 0);
                const f = 1 / p;
                return t1[0] = u * f, t1[1] = (n * l - c * i) * f, t1[2] = (s * i - n * a) * f, t1[3] = h * f, t1[4] = (c * e - n * o) * f, t1[5] = (n * r - s * e) * f, t1[6] = d * f, t1[7] = (i * o - l * e) * f, t1[8] = (a * e - i * r) * f, this;
            }
            transpose() {
                let t1;
                const e = this.elements;
                return t1 = e[1], e[1] = e[3], e[3] = t1, t1 = e[2], e[2] = e[6], e[6] = t1, t1 = e[5], e[5] = e[7], e[7] = t1, this;
            }
            getNormalMatrix(t1) {
                return this.setFromMatrix4(t1).invert().transpose();
            }
            transposeIntoArray(t1) {
                const e = this.elements;
                return t1[0] = e[0], t1[1] = e[3], t1[2] = e[6], t1[3] = e[1], t1[4] = e[4], t1[5] = e[7], t1[6] = e[2], t1[7] = e[5], t1[8] = e[8], this;
            }
            setUvTransform(t1, e, i, n, r, a, s) {
                const o = Math.cos(r), l = Math.sin(r);
                return this.set(i * o, i * l, -i * (o * a + l * s) + a + t1, -n * l, n * o, -n * (-l * a + o * s) + s + e, 0, 0, 1), this;
            }
            scale(t1, e) {
                return this.premultiply(bD.makeScale(t1, e)), this;
            }
            rotate(t1) {
                return this.premultiply(bD.makeRotation(-t1)), this;
            }
            translate(t1, e) {
                return this.premultiply(bD.makeTranslation(t1, e)), this;
            }
            makeTranslation(t1, e) {
                return t1.isVector2 ? this.set(1, 0, t1.x, 0, 1, t1.y, 0, 0, 1) : this.set(1, 0, t1, 0, 1, e, 0, 0, 1), this;
            }
            makeRotation(t1) {
                const e = Math.cos(t1), i = Math.sin(t1);
                return this.set(e, -i, 0, i, e, 0, 0, 0, 1), this;
            }
            makeScale(t1, e) {
                return this.set(t1, 0, 0, 0, e, 0, 0, 0, 1), this;
            }
            equals(t1) {
                const e = this.elements, i = t1.elements;
                for(let t1 = 0; t1 < 9; t1++)if (e[t1] !== i[t1]) return !1;
                return !0;
            }
            fromArray(t1, e = 0) {
                for(let i = 0; i < 9; i++)this.elements[i] = t1[i + e];
                return this;
            }
            toArray(t1 = [], e = 0) {
                const i = this.elements;
                return t1[e] = i[0], t1[e + 1] = i[1], t1[e + 2] = i[2], t1[e + 3] = i[3], t1[e + 4] = i[4], t1[e + 5] = i[5], t1[e + 6] = i[6], t1[e + 7] = i[7], t1[e + 8] = i[8], t1;
            }
            clone() {
                return (new this.constructor).fromArray(this.elements);
            }
        }
        const bD = new wD;
        function TD(t1) {
            return t1 < .04045 ? .0773993808 * t1 : Math.pow(.9478672986 * t1 + .0521327014, 2.4);
        }
        let ED;
        new Set([
            "srgb-linear",
            "display-p3-linear"
        ]);
        class ID {
            static getDataURL(t1) {
                if (/^data:/i.test(t1.src)) return t1.src;
                if ("undefined" == typeof HTMLCanvasElement) return t1.src;
                let e;
                if (t1 instanceof HTMLCanvasElement) e = t1;
                else {
                    void 0 === ED && (ED = hD("canvas")), ED.width = t1.width, ED.height = t1.height;
                    const i = ED.getContext("2d");
                    t1 instanceof ImageData ? i.putImageData(t1, 0, 0) : i.drawImage(t1, 0, 0, t1.width, t1.height), e = ED;
                }
                return e.width > 2048 || e.height > 2048 ? (console.warn("THREE.ImageUtils.getDataURL: Image converted to jpg for performance reasons", t1), e.toDataURL("image/jpeg", .6)) : e.toDataURL("image/png");
            }
            static sRGBToLinear(t1) {
                if ("undefined" != typeof HTMLImageElement && t1 instanceof HTMLImageElement || "undefined" != typeof HTMLCanvasElement && t1 instanceof HTMLCanvasElement || "undefined" != typeof ImageBitmap && t1 instanceof ImageBitmap) {
                    const e = hD("canvas");
                    e.width = t1.width, e.height = t1.height;
                    const i = e.getContext("2d");
                    i.drawImage(t1, 0, 0, t1.width, t1.height);
                    const n = i.getImageData(0, 0, t1.width, t1.height), r = n.data;
                    for(let t1 = 0; t1 < r.length; t1++)r[t1] = 255 * TD(r[t1] / 255);
                    return i.putImageData(n, 0, 0), e;
                }
                if (t1.data) {
                    const e = t1.data.slice(0);
                    for(let t1 = 0; t1 < e.length; t1++)e instanceof Uint8Array || e instanceof Uint8ClampedArray ? e[t1] = Math.floor(255 * TD(e[t1] / 255)) : e[t1] = TD(e[t1]);
                    return {
                        data: e,
                        width: t1.width,
                        height: t1.height
                    };
                }
                return console.warn("THREE.ImageUtils.sRGBToLinear(): Unsupported image type. No color space conversion applied."), t1;
            }
        }
        let SD = 0;
        class ND {
            constructor(t1 = null){
                this.isSource = !0, Object.defineProperty(this, "id", {
                    value: SD++
                }), this.uuid = yD(), this.data = t1, this.version = 0;
            }
            set needsUpdate(t1) {
                !0 === t1 && this.version++;
            }
            toJSON(t1) {
                const e = void 0 === t1 || "string" == typeof t1;
                if (!e && void 0 !== t1.images[this.uuid]) return t1.images[this.uuid];
                const i = {
                    uuid: this.uuid,
                    url: ""
                }, n = this.data;
                if (null !== n) {
                    let t1;
                    if (Array.isArray(n)) {
                        t1 = [];
                        for(let e = 0, i = n.length; e < i; e++)n[e].isDataTexture ? t1.push(DD(n[e].image)) : t1.push(DD(n[e]));
                    } else t1 = DD(n);
                    i.url = t1;
                }
                return e || (t1.images[this.uuid] = i), i;
            }
        }
        function DD(t1) {
            return "undefined" != typeof HTMLImageElement && t1 instanceof HTMLImageElement || "undefined" != typeof HTMLCanvasElement && t1 instanceof HTMLCanvasElement || "undefined" != typeof ImageBitmap && t1 instanceof ImageBitmap ? ID.getDataURL(t1) : t1.data ? {
                data: Array.from(t1.data),
                width: t1.width,
                height: t1.height,
                type: t1.data.constructor.name
            } : (console.warn("THREE.Texture: Unable to serialize Texture."), {});
        }
        let CD = 0;
        class zD extends AD {
            constructor(t1 = zD.DEFAULT_IMAGE, e = zD.DEFAULT_MAPPING, i = 1001, n = 1001, r = 1006, a = 1008, s = 1023, o = 1009, l = zD.DEFAULT_ANISOTROPY, c = ""){
                super(), this.isTexture = !0, Object.defineProperty(this, "id", {
                    value: CD++
                }), this.uuid = yD(), this.name = "", this.source = new ND(t1), this.mipmaps = [], this.mapping = e, this.channel = 0, this.wrapS = i, this.wrapT = n, this.magFilter = r, this.minFilter = a, this.anisotropy = l, this.format = s, this.internalFormat = null, this.type = o, this.offset = new xD(0, 0), this.repeat = new xD(1, 1), this.center = new xD(0, 0), this.rotation = 0, this.matrixAutoUpdate = !0, this.matrix = new wD, this.generateMipmaps = !0, this.premultiplyAlpha = !1, this.flipY = !0, this.unpackAlignment = 4, "string" == typeof c ? this.colorSpace = c : (pD("THREE.Texture: Property .encoding has been replaced by .colorSpace."), this.colorSpace = c === gD ? mD : ""), this.userData = {}, this.version = 0, this.onUpdate = null, this.isRenderTargetTexture = !1, this.needsPMREMUpdate = !1;
            }
            get image() {
                return this.source.data;
            }
            set image(t1 = null) {
                this.source.data = t1;
            }
            updateMatrix() {
                this.matrix.setUvTransform(this.offset.x, this.offset.y, this.repeat.x, this.repeat.y, this.rotation, this.center.x, this.center.y);
            }
            clone() {
                return (new this.constructor).copy(this);
            }
            copy(t1) {
                return this.name = t1.name, this.source = t1.source, this.mipmaps = t1.mipmaps.slice(0), this.mapping = t1.mapping, this.channel = t1.channel, this.wrapS = t1.wrapS, this.wrapT = t1.wrapT, this.magFilter = t1.magFilter, this.minFilter = t1.minFilter, this.anisotropy = t1.anisotropy, this.format = t1.format, this.internalFormat = t1.internalFormat, this.type = t1.type, this.offset.copy(t1.offset), this.repeat.copy(t1.repeat), this.center.copy(t1.center), this.rotation = t1.rotation, this.matrixAutoUpdate = t1.matrixAutoUpdate, this.matrix.copy(t1.matrix), this.generateMipmaps = t1.generateMipmaps, this.premultiplyAlpha = t1.premultiplyAlpha, this.flipY = t1.flipY, this.unpackAlignment = t1.unpackAlignment, this.colorSpace = t1.colorSpace, this.userData = JSON.parse(JSON.stringify(t1.userData)), this.needsUpdate = !0, this;
            }
            toJSON(t1) {
                const e = void 0 === t1 || "string" == typeof t1;
                if (!e && void 0 !== t1.textures[this.uuid]) return t1.textures[this.uuid];
                const i = {
                    metadata: {
                        version: 4.6,
                        type: "Texture",
                        generator: "Texture.toJSON"
                    },
                    uuid: this.uuid,
                    name: this.name,
                    image: this.source.toJSON(t1).uuid,
                    mapping: this.mapping,
                    channel: this.channel,
                    repeat: [
                        this.repeat.x,
                        this.repeat.y
                    ],
                    offset: [
                        this.offset.x,
                        this.offset.y
                    ],
                    center: [
                        this.center.x,
                        this.center.y
                    ],
                    rotation: this.rotation,
                    wrap: [
                        this.wrapS,
                        this.wrapT
                    ],
                    format: this.format,
                    internalFormat: this.internalFormat,
                    type: this.type,
                    colorSpace: this.colorSpace,
                    minFilter: this.minFilter,
                    magFilter: this.magFilter,
                    anisotropy: this.anisotropy,
                    flipY: this.flipY,
                    generateMipmaps: this.generateMipmaps,
                    premultiplyAlpha: this.premultiplyAlpha,
                    unpackAlignment: this.unpackAlignment
                };
                return Object.keys(this.userData).length > 0 && (i.userData = this.userData), e || (t1.textures[this.uuid] = i), i;
            }
            dispose() {
                this.dispatchEvent({
                    type: "dispose"
                });
            }
            transformUv(t1) {
                if (300 !== this.mapping) return t1;
                if (t1.applyMatrix3(this.matrix), t1.x < 0 || t1.x > 1) switch(this.wrapS){
                    case 1e3:
                        t1.x = t1.x - Math.floor(t1.x);
                        break;
                    case 1001:
                        t1.x = t1.x < 0 ? 0 : 1;
                        break;
                    case 1002:
                        1 === Math.abs(Math.floor(t1.x) % 2) ? t1.x = Math.ceil(t1.x) - t1.x : t1.x = t1.x - Math.floor(t1.x);
                }
                if (t1.y < 0 || t1.y > 1) switch(this.wrapT){
                    case 1e3:
                        t1.y = t1.y - Math.floor(t1.y);
                        break;
                    case 1001:
                        t1.y = t1.y < 0 ? 0 : 1;
                        break;
                    case 1002:
                        1 === Math.abs(Math.floor(t1.y) % 2) ? t1.y = Math.ceil(t1.y) - t1.y : t1.y = t1.y - Math.floor(t1.y);
                }
                return this.flipY && (t1.y = 1 - t1.y), t1;
            }
            set needsUpdate(t1) {
                !0 === t1 && (this.version++, this.source.needsUpdate = !0);
            }
            get encoding() {
                return pD("THREE.Texture: Property .encoding has been replaced by .colorSpace."), this.colorSpace === mD ? gD : 3e3;
            }
            set encoding(t1) {
                pD("THREE.Texture: Property .encoding has been replaced by .colorSpace."), this.colorSpace = t1 === gD ? mD : "";
            }
        }
        zD.DEFAULT_IMAGE = null, zD.DEFAULT_MAPPING = 300, zD.DEFAULT_ANISOTROPY = 1;
        class LD extends uD {
            constructor(t1){
                super(t1);
            }
            load(t1, e, i, n) {
                const r = new zD, a = new fD(this.manager);
                return a.setCrossOrigin(this.crossOrigin), a.setPath(this.path), a.load(t1, function(t1) {
                    r.image = t1, r.needsUpdate = !0, void 0 !== e && e(r);
                }, i, n), r;
            }
        }
        class OD extends zD {
            constructor(t1 = null, e = 1, i = 1, n, r, a, s, o, l = 1003, c = 1003, u, h){
                super(null, a, s, o, l, c, n, r, u, h), this.isDataTexture = !0, this.image = {
                    data: t1,
                    width: e,
                    height: i
                }, this.generateMipmaps = !1, this.flipY = !1, this.unpackAlignment = 1;
            }
        }
        function _D(t1, e, i) {
            return (e = function(t1) {
                var e = function(t1) {
                    if ("object" != typeof t1 || !t1) return t1;
                    var e = t1[Symbol.toPrimitive];
                    if (void 0 !== e) {
                        var i = e.call(t1, "string");
                        if ("object" != typeof i) return i;
                        throw new TypeError("@@toPrimitive must return a primitive value.");
                    }
                    return String(t1);
                }(t1);
                return "symbol" == typeof e ? e : e + "";
            }(e)) in t1 ? Object.defineProperty(t1, e, {
                value: i,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : t1[e] = i, t1;
        }
        ni({
            useProxies: "never"
        });
        const jD = new class {
            constructor(){
                _D(this, "roomMask", null), _D(this, "roomsVisible", null), _D(this, "currentColor", {
                    R: 0,
                    G: 0,
                    B: 0,
                    A: 0
                }), _D(this, "fixedColor", {
                    R: 0,
                    G: 0,
                    B: 0,
                    A: 0
                }), _D(this, "textureImg", null), _D(this, "textureMask", null), Ti(this);
            }
            getCurrentColorVector() {
                return new sD(this.currentColor.R, this.currentColor.G, this.currentColor.B, this.currentColor.A);
            }
            getFixedColorVector() {
                return new sD(this.fixedColor.R, this.fixedColor.G, this.fixedColor.B, this.fixedColor.A);
            }
            setRoomMask(t1) {
                this.roomMask = t1;
            }
            setRoomsVisible(t1) {
                this.roomsVisible = t1;
            }
            setCurrentColor(t1) {
                this.currentColor = t1;
            }
            setFixedColor(t1) {
                this.fixedColor = t1;
            }
            setTextureImg(t1) {
                const e = new LD;
                this.textureImg = e.load(t1);
            }
            setTextureMask(t1) {
                const e = new OD(t1.data, t1.width, t1.height);
                e.needsUpdate = !0, e.type = ya, this.textureMask = e;
            }
        }, PD = DN((t1)=>{
            let { imgs: i, masks: n, activeIndex: r, visible: a } = t1;
            const s = (0, e.useRef)(null), [o, l] = (0, e.useState)(null);
            (0, e.useEffect)(()=>{
                const t1 = new ox;
                t1.type = ya, t1.load(n[r], (t1, e)=>{
                    jD.setRoomMask(e), jD.setTextureImg(i[r]), jD.setTextureMask(e), o || h();
                });
            }, [
                r
            ]);
            const c = (t1, e)=>{
                const i = document.getElementsByClassName("widget-tab__isometry-container")[0].style.transform.match(/\((.*?)\)/)[1].split(",")[0], n = t1.getBoundingClientRect(), r = e.clientX - n.left, a = e.clientY - n.top, s = r / (i * t1.offsetWidth), o = a / (i * t1.offsetHeight);
                return vx(s.toFixed(2), o.toFixed(2), jD.roomMask);
            }, u = (t1, e)=>{
                const i = c(t1, e);
                jD.setCurrentColor(i);
            }, h = ()=>{
                var t1;
                const e = s.current, i = (3 === (n = (n = zn.config.colors.main).slice(1)).length && (n = n.split("").map((t1)=>"".concat(t1).concat(t1)).join("")), {
                    r: parseInt(n.slice(0, 2), 16),
                    g: parseInt(n.slice(2, 4), 16),
                    b: parseInt(n.slice(4, 6), 16)
                });
                var n;
                const r = new ph(-1, 1, 1, -1, 0, 1), a = new Up, o = new ih(2, 2), h = {
                    texture1: {
                        value: jD.textureImg
                    },
                    texture2: {
                        value: jD.textureMask
                    },
                    color: {
                        type: "vec4",
                        value: new dl
                    },
                    fixedColor: {
                        type: "vec4",
                        value: new dl
                    },
                    shaderEnabled: {
                        value: null !== (t1 = jD.roomsVisible) && void 0 !== t1 && t1
                    },
                    fillColor: {
                        type: "vec4",
                        value: new dl(i.r, i.g, i.b, 1)
                    }
                }, d = new Bu({
                    uniforms: h,
                    fragmentShader: "\n      varying vec2 vUv;\n\n      uniform vec4 color;\n      uniform vec4 fixedColor;\n      uniform sampler2D texture1; \n      uniform sampler2D texture2; \n      uniform int shaderEnabled;\n      uniform vec4 fillColor;\n\n      void main()	{\n        vec4 color1 = texture2D(texture1, vUv);\n        vec4 color2 = texture2D(texture2, vUv);\n\n        gl_FragColor = color1;\n        if (color2.r == 0.0 || shaderEnabled == 0) {\n          return;\n        }\n\n        vec4 mixColor = vec4(fillColor.rgb / 255.0, 1.0);\n\n        if (color2.r == fixedColor.r) {\n          gl_FragColor = mix(color1, mixColor, 0.6);\n        } else if (color2.r == color.r) {\n          gl_FragColor = mix(color1, mixColor, 0.4);\n        }\n      }\n\n  ",
                    vertexShader: "\n      varying vec2 vUv;\n\n      void main()	{\n\n          vUv = uv;\n          gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);\n\n      }\n  "
                }), p = new Ou(o, d);
                a.add(p);
                const f = new _p({
                    preserveDrawingBuffer: !0,
                    antialias: !0,
                    alpha: !0
                });
                f.toneMapping = Fr, f.toneMappingExposure = 1, f.setPixelRatio(window.devicePixelRatio), f.setSize(3 * e.offsetWidth, 3 * e.offsetHeight), f.render(a, r), f.setAnimationLoop(()=>{
                    var t1;
                    h.texture1.value = jD.textureImg, h.texture2.value = jD.textureMask, h.color = {
                        type: "vec4",
                        value: jD.getCurrentColorVector()
                    }, h.fixedColor = {
                        type: "vec4",
                        value: jD.getFixedColorVector()
                    }, h.shaderEnabled = {
                        value: null !== (t1 = jD.roomsVisible) && void 0 !== t1 && t1
                    }, f.render(a, r);
                }), e.appendChild(f.domElement), l(f), ((t1, e)=>{
                    e.addEventListener("mousemove", (t1)=>{
                        u(e, t1);
                    }), e.addEventListener("onTouchStart", (t1)=>{
                        u(e, t1);
                    }), e.addEventListener("onTouchMove", (t1)=>{
                        u(e, t1);
                    }), e.addEventListener("onTouchEnd", (t1)=>{
                        u(e, t1);
                    }), e.addEventListener("click", (t1)=>{
                        ((t1, e)=>{
                            const i = c(t1, e);
                            jD.setFixedColor(i);
                        })(e, t1);
                    }), window.addEventListener("resize", ()=>t1.setSize(3 * e.offsetWidth, 3 * e.offsetHeight));
                })(f, e);
            };
            return e.createElement("div", {
                ref: s,
                className: "widget-tab__isometry-shader ".concat(a ? "" : "hidden")
            });
        }), RD = PD, UD = (t1)=>{
            let { activeIndex: i, planImage: n, images: r, masks: a = [], setActiveIndex: s } = t1;
            const o = (t1)=>{
                t1.preventDefault();
                const e = i + 1;
                s(r[e] ? e : 0);
            }, l = (t1)=>{
                t1.preventDefault();
                const e = i - 1;
                s(r[e] ? e : r.length - 1);
            };
            let c = {
                x: 0,
                y: 0
            };
            const u = ()=>c = {
                    x: 0,
                    y: 0
                };
            return e.createElement(e.Fragment, null, e.createElement("div", {
                className: "widget-tab__isometry"
            }, e.createElement("div", {
                className: "widget-tab__isometry-container",
                onTouchStart: (t1)=>{
                    if (t1.touches.length > 1) return;
                    const e = t1.touches[0];
                    c = {
                        x: e.screenX
                    };
                },
                onTouchMove: (t1)=>{
                    if (t1.touches.length > 1) return;
                    t1.stopPropagation();
                    const e = t1.touches[0], i = c.x - e.screenX;
                    0 !== c.x && (i >= 100 ? (o(), u()) : i <= -100 && (l(), u()));
                },
                onTouchEnd: u
            }, n && e.createElement("img", {
                className: "widget-tab__isometry--plan active",
                src: n,
                alt: "plan-view"
            }), a.length > 0 && !n && e.createElement(RD, {
                imgs: r,
                masks: a,
                activeIndex: i,
                visible: a || 0 === i
            }), 0 === a.length && !n && e.createElement(e.Fragment, null, null == r ? void 0 : r.map((t1, n)=>e.createElement("img", {
                    className: i === n ? "active" : "",
                    alt: "rotation-view-".concat(n),
                    key: n,
                    src: t1
                }))))), !n && e.createElement("div", {
                className: "widget-tab__isometry-arrows"
            }, e.createElement("button", {
                className: "widget-tab__isometry-arrow widget-tab__isometry-arrow--prev",
                onClick: (t1)=>l(t1)
            }, e.createElement("img", {
                src: "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzIiIGhlaWdodD0iMzIiIHZpZXdCb3g9IjAgMCAzMiAzMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTI3IDE2SDUiIHN0cm9rZT0iIzQxM0UzRSIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTE0IDdMNSAxNkwxNCAyNSIgc3Ryb2tlPSIjNDEzRTNFIiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8L3N2Zz4K",
                alt: "arrow-left"
            })), e.createElement("span", null, i + 1, "/", r.length), e.createElement("button", {
                className: "widget-tab__isometry-arrow widget-tab__isometry-arrow--next",
                onClick: (t1)=>o(t1)
            }, e.createElement("img", {
                src: "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzIiIGhlaWdodD0iMzIiIHZpZXdCb3g9IjAgMCAzMiAzMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTUgMTZIMjciIHN0cm9rZT0iIzQxM0UzRSIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTE4IDdMMjcgMTZMMTggMjUiIHN0cm9rZT0iIzQxM0UzRSIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9zdmc+Cg==",
                alt: "arrow-right"
            }))));
        }, kD = "data:image/svg+xml;base64,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", BD = (t1)=>{
            let { images: i, masks: n, mode: r, disabled: a = !1 } = t1;
            const s = [
                {
                    icon: kD,
                    text: Tv("rotate-plan")
                }
            ], [o, l] = (0, e.useState)(!1), [c, u] = (0, e.useState)(null), [h, d] = (0, e.useState)(0), [p, f] = (0, e.useState)(null);
            function A() {
                d(this.index);
            }
            return (0, e.useEffect)(()=>{
                performance.mark("opening rotation mode");
                const t1 = document.querySelector(".widget-tab__threesixty-container"), e = document.querySelector(".widget-tab__isometry-container"), i = r === kn.THREESIXTY ? t1 : e, n = UN()(i, {
                    beforeMouseDown: ()=>!0,
                    onTouch: ()=>!1,
                    zoomDoubleClickSpeed: 1,
                    minZoom: .5,
                    maxZoom: 3
                });
                u(n);
            }, []), e.createElement("div", {
                className: "widget-tab__rotation",
                onContextMenu: xv
            }, r === kn.THREESIXTY && e.createElement(rD, {
                initialized: o,
                activeIndex: h,
                images: i
            }), r === kn.DEFAULT && e.createElement(UD, {
                setActiveIndex: d,
                activeIndex: h,
                images: i,
                masks: n
            }), r === kn.THREESIXTY && !o && e.createElement(aD, {
                onClick: ()=>{
                    l(!0);
                    const t1 = document.querySelector(".widget-tab__threesixty-container"), e = document.querySelector(".widget-tab__rotation"), n = new nD(t1, {
                        image: [
                            ...i
                        ],
                        parentElement: e,
                        inverted: !0,
                        speed: 300
                    });
                    n._update = A, c.on("panstart", ()=>{
                        n.stop(), n._update = ()=>{};
                    }), c.on("panend", ()=>{
                        n.goto(n.index), n._update = A;
                    }), f(n);
                },
                steps: s,
                disabled: a
            }));
        }, FD = (t1)=>{
            let { absolute: i, size: n = "lg" } = t1;
            return e.createElement("div", {
                className: "widget-loader widget-loader--".concat(n, " ").concat(i ? "widget-loader--absolute" : "")
            }, e.createElement("div", null), e.createElement("div", null), e.createElement("div", null), e.createElement("div", null));
        }, QD = DN((t1)=>{
            let { disabled: i } = t1;
            const { planImage: n, json: r } = zn.config, [a, s] = (0, e.useState)({
                width: "200px",
                height: "auto"
            }), [o, l] = (0, e.useState)(!0), [c, u] = (0, e.useState)({
                X: 1,
                Y: 1
            }), [h, d] = (0, e.useState)(!1), p = ()=>{
                const t1 = document.querySelector(".widget-tab__panorama-map img"), e = t1.naturalWidth / t1.naturalHeight || 1, i = zn.config.height - 200;
                let n = 200, a = n / e;
                a >= i && (a = i, n = a * e);
                const o = ((t1, e)=>{
                    let { width: i, height: n } = t1;
                    if (!e) return {
                        X: 1,
                        Y: 1
                    };
                    const r = ((t1)=>{
                        var e, i, n, r, a;
                        const s = t1.Meta;
                        if (!s) return {
                            X: t1.Scale.X,
                            Y: t1.Scale.X
                        };
                        const o = zn.currentFloorIndex, l = null === (e = s.BackgroundsTransforms) || void 0 === e ? void 0 : e[o], c = null === (i = s.WidgetInfo) || void 0 === i || null === (i = i.PlanBounds) || void 0 === i ? void 0 : i[o];
                        if (null != l && l.Modified && c) return {
                            Width: c.Right,
                            Height: c.Bottom
                        };
                        const u = null === (n = s.FloorsScales) || void 0 === n ? void 0 : n[o];
                        return {
                            X: null !== (r = null == u ? void 0 : u.X) && void 0 !== r ? r : t1.Scale.X,
                            Y: null !== (a = null == u ? void 0 : u.Y) && void 0 !== a ? a : t1.Scale.X
                        };
                    })(e);
                    if (r.Width && r.Height) return {
                        X: i / r.Width,
                        Y: n / r.Height
                    };
                    const a = n * (1024 / i);
                    return {
                        X: i / 1024 / r.X,
                        Y: n / a / r.Y
                    };
                })({
                    width: n,
                    height: a
                }, r);
                s({
                    width: "".concat(n, "px"),
                    height: "".concat(a, "px")
                }), u(o), fN.updateWindowSize(zn.config.width, zn.config.height), fN.vrControlPanel.map.updateSize(2 * n, 2 * a), fN.vrControlPanel.map.updateScale(o);
            }, f = ()=>{
                zn.showControls(), d(!1);
            };
            return (0, e.useEffect)(p, [
                zn.config.width,
                zn.config.height,
                zn.currentFloorIndex
            ]), e.createElement(e.Fragment, null, h && e.createElement("div", {
                className: "widget-tab__panorama-close-map",
                onClick: f
            }, e.createElement("img", {
                src: LN,
                alt: "close-map"
            })), h && e.createElement("div", {
                className: "map-overlay map-overlay--visible",
                onClick: f
            }), e.createElement("div", {
                className: (()=>{
                    let t1 = "widget-tab__panorama-map";
                    return zn.isCapable("hidden_furniture") && (t1 += " widget-tab__panorama-map--bottom"), o && (t1 += " widget-tab__panorama-map--hidden"), h && (t1 += " widget-tab__panorama-map--scaled"), t1;
                })()
            }, e.createElement("img", {
                src: n,
                style: a,
                alt: "plan",
                onLoad: ()=>{
                    p(), l(!r || i), fN.vrControlPanel.map.setDisabledState(!r || i), fN.vrControlPanel.map.loadImage(n).then(()=>{
                        fN.vrControlPanel.mapButtonAvailable = !0;
                    });
                }
            }), !o && e.createElement(e.Fragment, null, e.createElement("div", {
                className: "widget-tab__panorama-map__fov",
                style: (()=>{
                    const t1 = fN.getPanoramaById(fN.currentPanoramaId);
                    if (!t1) return {
                        display: "none"
                    };
                    const { left: e, top: i } = t1.userData;
                    return {
                        "--x": "".concat(e * c.X, "px"),
                        "--y": "".concat(i * c.Y, "px")
                    };
                })()
            }, e.createElement("div", {
                className: "widget-tab__panorama-map__fov-direction"
            }), e.createElement("div", {
                className: "widget-tab__panorama-map__fov-dot"
            })), e.createElement("svg", {
                style: {
                    width: a.width
                },
                key: "X-".concat(c.X, "-Y-").concat(c.Y),
                onClick: (t1)=>{
                    if (fN.loading) return;
                    if (zn.config.width <= zN.tablet && !h) return zn.hideControls(), void d(!0);
                    const e = document.querySelector(".widget-tab__panorama-map"), i = e.getBoundingClientRect().width / e.offsetWidth, n = document.querySelector(".widget-tab__panorama-map img").getBoundingClientRect(), { clientX: r, clientY: a } = t1, s = (r - n.left) / i / c.X, o = (a - n.top) / i / c.Y, l = fN.panoramasGroup.children.filter((t1)=>{
                        let { userData: e } = t1;
                        return QS([
                            s,
                            o
                        ], e.points);
                    }), { panorama: u } = dx([
                        s,
                        o
                    ], l);
                    f(), u && fN.setCurrentPanoramaById(u.panoramaId);
                }
            }, fN.panoramasGroup.children.map((t1, i)=>{
                let { userData: n } = t1;
                const r = n.svgPathActions.reduce((t1, e)=>{
                    const i = e.x * c.X, n = e.y * c.Y;
                    let r = "".concat(e.type, " ").concat(i, " ").concat(n);
                    if ("Q" === e.type) {
                        const t1 = e.dx * c.X, i = e.dy * c.Y;
                        r += " ".concat(t1, " ").concat(i);
                    }
                    return "".concat(t1, " ").concat(r);
                }, "");
                return e.createElement("path", {
                    key: i,
                    d: r
                });
            })))));
        }), HD = (t1, e, i, n)=>{
            const r = 1 - t1;
            return {
                x: r * r * e.Location.X + 2 * r * t1 * i.Location.X + t1 * t1 * n.Location.X,
                y: r * r * e.Location.Y + 2 * r * t1 * i.Location.Y + t1 * t1 * n.Location.Y
            };
        }, VD = (t1, e)=>{
            const i = t1.length;
            for(let n = 0; n < i; n++){
                const i = t1[n];
                if (i.ID === e) return i;
            }
            return null;
        }, GD = (t1, e, i, n, r)=>{
            const a = [
                {
                    x: -i,
                    y: -n
                },
                {
                    x: i,
                    y: -n
                },
                {
                    x: i,
                    y: n
                },
                {
                    x: -i,
                    y: n
                }
            ], s = Math.cos(r), o = Math.sin(r);
            for(let i = 0; i < 4; i++){
                const n = a[i], r = t1 + n.x * s - n.y * o;
                n.y = e + n.y * s + n.x * o, n.x = r;
            }
            return a;
        };
        class YD {
            constructor(t1 = 0, e = 0, i = 0, n = 1){
                this.isQuaternion = !0, this._x = t1, this._y = e, this._z = i, this._w = n;
            }
            static slerpFlat(t1, e, i, n, r, a, s) {
                let o = i[n + 0], l = i[n + 1], c = i[n + 2], u = i[n + 3];
                const h = r[a + 0], d = r[a + 1], p = r[a + 2], f = r[a + 3];
                if (0 === s) return t1[e + 0] = o, t1[e + 1] = l, t1[e + 2] = c, void (t1[e + 3] = u);
                if (1 === s) return t1[e + 0] = h, t1[e + 1] = d, t1[e + 2] = p, void (t1[e + 3] = f);
                if (u !== f || o !== h || l !== d || c !== p) {
                    let t1 = 1 - s;
                    const e = o * h + l * d + c * p + u * f, i = e >= 0 ? 1 : -1, n = 1 - e * e;
                    if (n > Number.EPSILON) {
                        const r = Math.sqrt(n), a = Math.atan2(r, e * i);
                        t1 = Math.sin(t1 * a) / r, s = Math.sin(s * a) / r;
                    }
                    const r = s * i;
                    if (o = o * t1 + h * r, l = l * t1 + d * r, c = c * t1 + p * r, u = u * t1 + f * r, t1 === 1 - s) {
                        const t1 = 1 / Math.sqrt(o * o + l * l + c * c + u * u);
                        o *= t1, l *= t1, c *= t1, u *= t1;
                    }
                }
                t1[e] = o, t1[e + 1] = l, t1[e + 2] = c, t1[e + 3] = u;
            }
            static multiplyQuaternionsFlat(t1, e, i, n, r, a) {
                const s = i[n], o = i[n + 1], l = i[n + 2], c = i[n + 3], u = r[a], h = r[a + 1], d = r[a + 2], p = r[a + 3];
                return t1[e] = s * p + c * u + o * d - l * h, t1[e + 1] = o * p + c * h + l * u - s * d, t1[e + 2] = l * p + c * d + s * h - o * u, t1[e + 3] = c * p - s * u - o * h - l * d, t1;
            }
            get x() {
                return this._x;
            }
            set x(t1) {
                this._x = t1, this._onChangeCallback();
            }
            get y() {
                return this._y;
            }
            set y(t1) {
                this._y = t1, this._onChangeCallback();
            }
            get z() {
                return this._z;
            }
            set z(t1) {
                this._z = t1, this._onChangeCallback();
            }
            get w() {
                return this._w;
            }
            set w(t1) {
                this._w = t1, this._onChangeCallback();
            }
            set(t1, e, i, n) {
                return this._x = t1, this._y = e, this._z = i, this._w = n, this._onChangeCallback(), this;
            }
            clone() {
                return new this.constructor(this._x, this._y, this._z, this._w);
            }
            copy(t1) {
                return this._x = t1.x, this._y = t1.y, this._z = t1.z, this._w = t1.w, this._onChangeCallback(), this;
            }
            setFromEuler(t1, e) {
                const i = t1._x, n = t1._y, r = t1._z, a = t1._order, s = Math.cos, o = Math.sin, l = s(i / 2), c = s(n / 2), u = s(r / 2), h = o(i / 2), d = o(n / 2), p = o(r / 2);
                switch(a){
                    case "XYZ":
                        this._x = h * c * u + l * d * p, this._y = l * d * u - h * c * p, this._z = l * c * p + h * d * u, this._w = l * c * u - h * d * p;
                        break;
                    case "YXZ":
                        this._x = h * c * u + l * d * p, this._y = l * d * u - h * c * p, this._z = l * c * p - h * d * u, this._w = l * c * u + h * d * p;
                        break;
                    case "ZXY":
                        this._x = h * c * u - l * d * p, this._y = l * d * u + h * c * p, this._z = l * c * p + h * d * u, this._w = l * c * u - h * d * p;
                        break;
                    case "ZYX":
                        this._x = h * c * u - l * d * p, this._y = l * d * u + h * c * p, this._z = l * c * p - h * d * u, this._w = l * c * u + h * d * p;
                        break;
                    case "YZX":
                        this._x = h * c * u + l * d * p, this._y = l * d * u + h * c * p, this._z = l * c * p - h * d * u, this._w = l * c * u - h * d * p;
                        break;
                    case "XZY":
                        this._x = h * c * u - l * d * p, this._y = l * d * u - h * c * p, this._z = l * c * p + h * d * u, this._w = l * c * u + h * d * p;
                        break;
                    default:
                        console.warn("THREE.Quaternion: .setFromEuler() encountered an unknown order: " + a);
                }
                return !1 !== e && this._onChangeCallback(), this;
            }
            setFromAxisAngle(t1, e) {
                const i = e / 2, n = Math.sin(i);
                return this._x = t1.x * n, this._y = t1.y * n, this._z = t1.z * n, this._w = Math.cos(i), this._onChangeCallback(), this;
            }
            setFromRotationMatrix(t1) {
                const e = t1.elements, i = e[0], n = e[4], r = e[8], a = e[1], s = e[5], o = e[9], l = e[2], c = e[6], u = e[10], h = i + s + u;
                if (h > 0) {
                    const t1 = .5 / Math.sqrt(h + 1);
                    this._w = .25 / t1, this._x = (c - o) * t1, this._y = (r - l) * t1, this._z = (a - n) * t1;
                } else if (i > s && i > u) {
                    const t1 = 2 * Math.sqrt(1 + i - s - u);
                    this._w = (c - o) / t1, this._x = .25 * t1, this._y = (n + a) / t1, this._z = (r + l) / t1;
                } else if (s > u) {
                    const t1 = 2 * Math.sqrt(1 + s - i - u);
                    this._w = (r - l) / t1, this._x = (n + a) / t1, this._y = .25 * t1, this._z = (o + c) / t1;
                } else {
                    const t1 = 2 * Math.sqrt(1 + u - i - s);
                    this._w = (a - n) / t1, this._x = (r + l) / t1, this._y = (o + c) / t1, this._z = .25 * t1;
                }
                return this._onChangeCallback(), this;
            }
            setFromUnitVectors(t1, e) {
                let i = t1.dot(e) + 1;
                return i < Number.EPSILON ? (i = 0, Math.abs(t1.x) > Math.abs(t1.z) ? (this._x = -t1.y, this._y = t1.x, this._z = 0, this._w = i) : (this._x = 0, this._y = -t1.z, this._z = t1.y, this._w = i)) : (this._x = t1.y * e.z - t1.z * e.y, this._y = t1.z * e.x - t1.x * e.z, this._z = t1.x * e.y - t1.y * e.x, this._w = i), this.normalize();
            }
            angleTo(t1) {
                return 2 * Math.acos(Math.abs(vD(this.dot(t1), -1, 1)));
            }
            rotateTowards(t1, e) {
                const i = this.angleTo(t1);
                if (0 === i) return this;
                const n = Math.min(1, e / i);
                return this.slerp(t1, n), this;
            }
            identity() {
                return this.set(0, 0, 0, 1);
            }
            invert() {
                return this.conjugate();
            }
            conjugate() {
                return this._x *= -1, this._y *= -1, this._z *= -1, this._onChangeCallback(), this;
            }
            dot(t1) {
                return this._x * t1._x + this._y * t1._y + this._z * t1._z + this._w * t1._w;
            }
            lengthSq() {
                return this._x * this._x + this._y * this._y + this._z * this._z + this._w * this._w;
            }
            length() {
                return Math.sqrt(this._x * this._x + this._y * this._y + this._z * this._z + this._w * this._w);
            }
            normalize() {
                let t1 = this.length();
                return 0 === t1 ? (this._x = 0, this._y = 0, this._z = 0, this._w = 1) : (t1 = 1 / t1, this._x = this._x * t1, this._y = this._y * t1, this._z = this._z * t1, this._w = this._w * t1), this._onChangeCallback(), this;
            }
            multiply(t1) {
                return this.multiplyQuaternions(this, t1);
            }
            premultiply(t1) {
                return this.multiplyQuaternions(t1, this);
            }
            multiplyQuaternions(t1, e) {
                const i = t1._x, n = t1._y, r = t1._z, a = t1._w, s = e._x, o = e._y, l = e._z, c = e._w;
                return this._x = i * c + a * s + n * l - r * o, this._y = n * c + a * o + r * s - i * l, this._z = r * c + a * l + i * o - n * s, this._w = a * c - i * s - n * o - r * l, this._onChangeCallback(), this;
            }
            slerp(t1, e) {
                if (0 === e) return this;
                if (1 === e) return this.copy(t1);
                const i = this._x, n = this._y, r = this._z, a = this._w;
                let s = a * t1._w + i * t1._x + n * t1._y + r * t1._z;
                if (s < 0 ? (this._w = -t1._w, this._x = -t1._x, this._y = -t1._y, this._z = -t1._z, s = -s) : this.copy(t1), s >= 1) return this._w = a, this._x = i, this._y = n, this._z = r, this;
                const o = 1 - s * s;
                if (o <= Number.EPSILON) {
                    const t1 = 1 - e;
                    return this._w = t1 * a + e * this._w, this._x = t1 * i + e * this._x, this._y = t1 * n + e * this._y, this._z = t1 * r + e * this._z, this.normalize(), this._onChangeCallback(), this;
                }
                const l = Math.sqrt(o), c = Math.atan2(l, s), u = Math.sin((1 - e) * c) / l, h = Math.sin(e * c) / l;
                return this._w = a * u + this._w * h, this._x = i * u + this._x * h, this._y = n * u + this._y * h, this._z = r * u + this._z * h, this._onChangeCallback(), this;
            }
            slerpQuaternions(t1, e, i) {
                return this.copy(t1).slerp(e, i);
            }
            random() {
                const t1 = Math.random(), e = Math.sqrt(1 - t1), i = Math.sqrt(t1), n = 2 * Math.PI * Math.random(), r = 2 * Math.PI * Math.random();
                return this.set(e * Math.cos(n), i * Math.sin(r), i * Math.cos(r), e * Math.sin(n));
            }
            equals(t1) {
                return t1._x === this._x && t1._y === this._y && t1._z === this._z && t1._w === this._w;
            }
            fromArray(t1, e = 0) {
                return this._x = t1[e], this._y = t1[e + 1], this._z = t1[e + 2], this._w = t1[e + 3], this._onChangeCallback(), this;
            }
            toArray(t1 = [], e = 0) {
                return t1[e] = this._x, t1[e + 1] = this._y, t1[e + 2] = this._z, t1[e + 3] = this._w, t1;
            }
            fromBufferAttribute(t1, e) {
                return this._x = t1.getX(e), this._y = t1.getY(e), this._z = t1.getZ(e), this._w = t1.getW(e), this;
            }
            toJSON() {
                return this.toArray();
            }
            _onChange(t1) {
                return this._onChangeCallback = t1, this;
            }
            _onChangeCallback() {}
            *[Symbol.iterator]() {
                yield this._x, yield this._y, yield this._z, yield this._w;
            }
        }
        class WD {
            constructor(t1 = 0, e = 0, i = 0){
                WD.prototype.isVector3 = !0, this.x = t1, this.y = e, this.z = i;
            }
            set(t1, e, i) {
                return void 0 === i && (i = this.z), this.x = t1, this.y = e, this.z = i, this;
            }
            setScalar(t1) {
                return this.x = t1, this.y = t1, this.z = t1, this;
            }
            setX(t1) {
                return this.x = t1, this;
            }
            setY(t1) {
                return this.y = t1, this;
            }
            setZ(t1) {
                return this.z = t1, this;
            }
            setComponent(t1, e) {
                switch(t1){
                    case 0:
                        this.x = e;
                        break;
                    case 1:
                        this.y = e;
                        break;
                    case 2:
                        this.z = e;
                        break;
                    default:
                        throw new Error("index is out of range: " + t1);
                }
                return this;
            }
            getComponent(t1) {
                switch(t1){
                    case 0:
                        return this.x;
                    case 1:
                        return this.y;
                    case 2:
                        return this.z;
                    default:
                        throw new Error("index is out of range: " + t1);
                }
            }
            clone() {
                return new this.constructor(this.x, this.y, this.z);
            }
            copy(t1) {
                return this.x = t1.x, this.y = t1.y, this.z = t1.z, this;
            }
            add(t1) {
                return this.x += t1.x, this.y += t1.y, this.z += t1.z, this;
            }
            addScalar(t1) {
                return this.x += t1, this.y += t1, this.z += t1, this;
            }
            addVectors(t1, e) {
                return this.x = t1.x + e.x, this.y = t1.y + e.y, this.z = t1.z + e.z, this;
            }
            addScaledVector(t1, e) {
                return this.x += t1.x * e, this.y += t1.y * e, this.z += t1.z * e, this;
            }
            sub(t1) {
                return this.x -= t1.x, this.y -= t1.y, this.z -= t1.z, this;
            }
            subScalar(t1) {
                return this.x -= t1, this.y -= t1, this.z -= t1, this;
            }
            subVectors(t1, e) {
                return this.x = t1.x - e.x, this.y = t1.y - e.y, this.z = t1.z - e.z, this;
            }
            multiply(t1) {
                return this.x *= t1.x, this.y *= t1.y, this.z *= t1.z, this;
            }
            multiplyScalar(t1) {
                return this.x *= t1, this.y *= t1, this.z *= t1, this;
            }
            multiplyVectors(t1, e) {
                return this.x = t1.x * e.x, this.y = t1.y * e.y, this.z = t1.z * e.z, this;
            }
            applyEuler(t1) {
                return this.applyQuaternion(ZD.setFromEuler(t1));
            }
            applyAxisAngle(t1, e) {
                return this.applyQuaternion(ZD.setFromAxisAngle(t1, e));
            }
            applyMatrix3(t1) {
                const e = this.x, i = this.y, n = this.z, r = t1.elements;
                return this.x = r[0] * e + r[3] * i + r[6] * n, this.y = r[1] * e + r[4] * i + r[7] * n, this.z = r[2] * e + r[5] * i + r[8] * n, this;
            }
            applyNormalMatrix(t1) {
                return this.applyMatrix3(t1).normalize();
            }
            applyMatrix4(t1) {
                const e = this.x, i = this.y, n = this.z, r = t1.elements, a = 1 / (r[3] * e + r[7] * i + r[11] * n + r[15]);
                return this.x = (r[0] * e + r[4] * i + r[8] * n + r[12]) * a, this.y = (r[1] * e + r[5] * i + r[9] * n + r[13]) * a, this.z = (r[2] * e + r[6] * i + r[10] * n + r[14]) * a, this;
            }
            applyQuaternion(t1) {
                const e = this.x, i = this.y, n = this.z, r = t1.x, a = t1.y, s = t1.z, o = t1.w, l = 2 * (a * n - s * i), c = 2 * (s * e - r * n), u = 2 * (r * i - a * e);
                return this.x = e + o * l + a * u - s * c, this.y = i + o * c + s * l - r * u, this.z = n + o * u + r * c - a * l, this;
            }
            project(t1) {
                return this.applyMatrix4(t1.matrixWorldInverse).applyMatrix4(t1.projectionMatrix);
            }
            unproject(t1) {
                return this.applyMatrix4(t1.projectionMatrixInverse).applyMatrix4(t1.matrixWorld);
            }
            transformDirection(t1) {
                const e = this.x, i = this.y, n = this.z, r = t1.elements;
                return this.x = r[0] * e + r[4] * i + r[8] * n, this.y = r[1] * e + r[5] * i + r[9] * n, this.z = r[2] * e + r[6] * i + r[10] * n, this.normalize();
            }
            divide(t1) {
                return this.x /= t1.x, this.y /= t1.y, this.z /= t1.z, this;
            }
            divideScalar(t1) {
                return this.multiplyScalar(1 / t1);
            }
            min(t1) {
                return this.x = Math.min(this.x, t1.x), this.y = Math.min(this.y, t1.y), this.z = Math.min(this.z, t1.z), this;
            }
            max(t1) {
                return this.x = Math.max(this.x, t1.x), this.y = Math.max(this.y, t1.y), this.z = Math.max(this.z, t1.z), this;
            }
            clamp(t1, e) {
                return this.x = Math.max(t1.x, Math.min(e.x, this.x)), this.y = Math.max(t1.y, Math.min(e.y, this.y)), this.z = Math.max(t1.z, Math.min(e.z, this.z)), this;
            }
            clampScalar(t1, e) {
                return this.x = Math.max(t1, Math.min(e, this.x)), this.y = Math.max(t1, Math.min(e, this.y)), this.z = Math.max(t1, Math.min(e, this.z)), this;
            }
            clampLength(t1, e) {
                const i = this.length();
                return this.divideScalar(i || 1).multiplyScalar(Math.max(t1, Math.min(e, i)));
            }
            floor() {
                return this.x = Math.floor(this.x), this.y = Math.floor(this.y), this.z = Math.floor(this.z), this;
            }
            ceil() {
                return this.x = Math.ceil(this.x), this.y = Math.ceil(this.y), this.z = Math.ceil(this.z), this;
            }
            round() {
                return this.x = Math.round(this.x), this.y = Math.round(this.y), this.z = Math.round(this.z), this;
            }
            roundToZero() {
                return this.x = Math.trunc(this.x), this.y = Math.trunc(this.y), this.z = Math.trunc(this.z), this;
            }
            negate() {
                return this.x = -this.x, this.y = -this.y, this.z = -this.z, this;
            }
            dot(t1) {
                return this.x * t1.x + this.y * t1.y + this.z * t1.z;
            }
            lengthSq() {
                return this.x * this.x + this.y * this.y + this.z * this.z;
            }
            length() {
                return Math.sqrt(this.x * this.x + this.y * this.y + this.z * this.z);
            }
            manhattanLength() {
                return Math.abs(this.x) + Math.abs(this.y) + Math.abs(this.z);
            }
            normalize() {
                return this.divideScalar(this.length() || 1);
            }
            setLength(t1) {
                return this.normalize().multiplyScalar(t1);
            }
            lerp(t1, e) {
                return this.x += (t1.x - this.x) * e, this.y += (t1.y - this.y) * e, this.z += (t1.z - this.z) * e, this;
            }
            lerpVectors(t1, e, i) {
                return this.x = t1.x + (e.x - t1.x) * i, this.y = t1.y + (e.y - t1.y) * i, this.z = t1.z + (e.z - t1.z) * i, this;
            }
            cross(t1) {
                return this.crossVectors(this, t1);
            }
            crossVectors(t1, e) {
                const i = t1.x, n = t1.y, r = t1.z, a = e.x, s = e.y, o = e.z;
                return this.x = n * o - r * s, this.y = r * a - i * o, this.z = i * s - n * a, this;
            }
            projectOnVector(t1) {
                const e = t1.lengthSq();
                if (0 === e) return this.set(0, 0, 0);
                const i = t1.dot(this) / e;
                return this.copy(t1).multiplyScalar(i);
            }
            projectOnPlane(t1) {
                return XD.copy(this).projectOnVector(t1), this.sub(XD);
            }
            reflect(t1) {
                return this.sub(XD.copy(t1).multiplyScalar(2 * this.dot(t1)));
            }
            angleTo(t1) {
                const e = Math.sqrt(this.lengthSq() * t1.lengthSq());
                if (0 === e) return Math.PI / 2;
                const i = this.dot(t1) / e;
                return Math.acos(vD(i, -1, 1));
            }
            distanceTo(t1) {
                return Math.sqrt(this.distanceToSquared(t1));
            }
            distanceToSquared(t1) {
                const e = this.x - t1.x, i = this.y - t1.y, n = this.z - t1.z;
                return e * e + i * i + n * n;
            }
            manhattanDistanceTo(t1) {
                return Math.abs(this.x - t1.x) + Math.abs(this.y - t1.y) + Math.abs(this.z - t1.z);
            }
            setFromSpherical(t1) {
                return this.setFromSphericalCoords(t1.radius, t1.phi, t1.theta);
            }
            setFromSphericalCoords(t1, e, i) {
                const n = Math.sin(e) * t1;
                return this.x = n * Math.sin(i), this.y = Math.cos(e) * t1, this.z = n * Math.cos(i), this;
            }
            setFromCylindrical(t1) {
                return this.setFromCylindricalCoords(t1.radius, t1.theta, t1.y);
            }
            setFromCylindricalCoords(t1, e, i) {
                return this.x = t1 * Math.sin(e), this.y = i, this.z = t1 * Math.cos(e), this;
            }
            setFromMatrixPosition(t1) {
                const e = t1.elements;
                return this.x = e[12], this.y = e[13], this.z = e[14], this;
            }
            setFromMatrixScale(t1) {
                const e = this.setFromMatrixColumn(t1, 0).length(), i = this.setFromMatrixColumn(t1, 1).length(), n = this.setFromMatrixColumn(t1, 2).length();
                return this.x = e, this.y = i, this.z = n, this;
            }
            setFromMatrixColumn(t1, e) {
                return this.fromArray(t1.elements, 4 * e);
            }
            setFromMatrix3Column(t1, e) {
                return this.fromArray(t1.elements, 3 * e);
            }
            setFromEuler(t1) {
                return this.x = t1._x, this.y = t1._y, this.z = t1._z, this;
            }
            setFromColor(t1) {
                return this.x = t1.r, this.y = t1.g, this.z = t1.b, this;
            }
            equals(t1) {
                return t1.x === this.x && t1.y === this.y && t1.z === this.z;
            }
            fromArray(t1, e = 0) {
                return this.x = t1[e], this.y = t1[e + 1], this.z = t1[e + 2], this;
            }
            toArray(t1 = [], e = 0) {
                return t1[e] = this.x, t1[e + 1] = this.y, t1[e + 2] = this.z, t1;
            }
            fromBufferAttribute(t1, e) {
                return this.x = t1.getX(e), this.y = t1.getY(e), this.z = t1.getZ(e), this;
            }
            random() {
                return this.x = Math.random(), this.y = Math.random(), this.z = Math.random(), this;
            }
            randomDirection() {
                const t1 = 2 * (Math.random() - .5), e = Math.random() * Math.PI * 2, i = Math.sqrt(1 - t1 ** 2);
                return this.x = i * Math.cos(e), this.y = i * Math.sin(e), this.z = t1, this;
            }
            *[Symbol.iterator]() {
                yield this.x, yield this.y, yield this.z;
            }
        }
        const XD = new WD, ZD = new YD;
        class JD {
            constructor(t1, e, i, n, r, a, s, o, l, c, u, h, d, p, f, A){
                JD.prototype.isMatrix4 = !0, this.elements = [
                    1,
                    0,
                    0,
                    0,
                    0,
                    1,
                    0,
                    0,
                    0,
                    0,
                    1,
                    0,
                    0,
                    0,
                    0,
                    1
                ], void 0 !== t1 && this.set(t1, e, i, n, r, a, s, o, l, c, u, h, d, p, f, A);
            }
            set(t1, e, i, n, r, a, s, o, l, c, u, h, d, p, f, A) {
                const g = this.elements;
                return g[0] = t1, g[4] = e, g[8] = i, g[12] = n, g[1] = r, g[5] = a, g[9] = s, g[13] = o, g[2] = l, g[6] = c, g[10] = u, g[14] = h, g[3] = d, g[7] = p, g[11] = f, g[15] = A, this;
            }
            identity() {
                return this.set(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1), this;
            }
            clone() {
                return (new JD).fromArray(this.elements);
            }
            copy(t1) {
                const e = this.elements, i = t1.elements;
                return e[0] = i[0], e[1] = i[1], e[2] = i[2], e[3] = i[3], e[4] = i[4], e[5] = i[5], e[6] = i[6], e[7] = i[7], e[8] = i[8], e[9] = i[9], e[10] = i[10], e[11] = i[11], e[12] = i[12], e[13] = i[13], e[14] = i[14], e[15] = i[15], this;
            }
            copyPosition(t1) {
                const e = this.elements, i = t1.elements;
                return e[12] = i[12], e[13] = i[13], e[14] = i[14], this;
            }
            setFromMatrix3(t1) {
                const e = t1.elements;
                return this.set(e[0], e[3], e[6], 0, e[1], e[4], e[7], 0, e[2], e[5], e[8], 0, 0, 0, 0, 1), this;
            }
            extractBasis(t1, e, i) {
                return t1.setFromMatrixColumn(this, 0), e.setFromMatrixColumn(this, 1), i.setFromMatrixColumn(this, 2), this;
            }
            makeBasis(t1, e, i) {
                return this.set(t1.x, e.x, i.x, 0, t1.y, e.y, i.y, 0, t1.z, e.z, i.z, 0, 0, 0, 0, 1), this;
            }
            extractRotation(t1) {
                const e = this.elements, i = t1.elements, n = 1 / KD.setFromMatrixColumn(t1, 0).length(), r = 1 / KD.setFromMatrixColumn(t1, 1).length(), a = 1 / KD.setFromMatrixColumn(t1, 2).length();
                return e[0] = i[0] * n, e[1] = i[1] * n, e[2] = i[2] * n, e[3] = 0, e[4] = i[4] * r, e[5] = i[5] * r, e[6] = i[6] * r, e[7] = 0, e[8] = i[8] * a, e[9] = i[9] * a, e[10] = i[10] * a, e[11] = 0, e[12] = 0, e[13] = 0, e[14] = 0, e[15] = 1, this;
            }
            makeRotationFromEuler(t1) {
                const e = this.elements, i = t1.x, n = t1.y, r = t1.z, a = Math.cos(i), s = Math.sin(i), o = Math.cos(n), l = Math.sin(n), c = Math.cos(r), u = Math.sin(r);
                if ("XYZ" === t1.order) {
                    const t1 = a * c, i = a * u, n = s * c, r = s * u;
                    e[0] = o * c, e[4] = -o * u, e[8] = l, e[1] = i + n * l, e[5] = t1 - r * l, e[9] = -s * o, e[2] = r - t1 * l, e[6] = n + i * l, e[10] = a * o;
                } else if ("YXZ" === t1.order) {
                    const t1 = o * c, i = o * u, n = l * c, r = l * u;
                    e[0] = t1 + r * s, e[4] = n * s - i, e[8] = a * l, e[1] = a * u, e[5] = a * c, e[9] = -s, e[2] = i * s - n, e[6] = r + t1 * s, e[10] = a * o;
                } else if ("ZXY" === t1.order) {
                    const t1 = o * c, i = o * u, n = l * c, r = l * u;
                    e[0] = t1 - r * s, e[4] = -a * u, e[8] = n + i * s, e[1] = i + n * s, e[5] = a * c, e[9] = r - t1 * s, e[2] = -a * l, e[6] = s, e[10] = a * o;
                } else if ("ZYX" === t1.order) {
                    const t1 = a * c, i = a * u, n = s * c, r = s * u;
                    e[0] = o * c, e[4] = n * l - i, e[8] = t1 * l + r, e[1] = o * u, e[5] = r * l + t1, e[9] = i * l - n, e[2] = -l, e[6] = s * o, e[10] = a * o;
                } else if ("YZX" === t1.order) {
                    const t1 = a * o, i = a * l, n = s * o, r = s * l;
                    e[0] = o * c, e[4] = r - t1 * u, e[8] = n * u + i, e[1] = u, e[5] = a * c, e[9] = -s * c, e[2] = -l * c, e[6] = i * u + n, e[10] = t1 - r * u;
                } else if ("XZY" === t1.order) {
                    const t1 = a * o, i = a * l, n = s * o, r = s * l;
                    e[0] = o * c, e[4] = -u, e[8] = l * c, e[1] = t1 * u + r, e[5] = a * c, e[9] = i * u - n, e[2] = n * u - i, e[6] = s * c, e[10] = r * u + t1;
                }
                return e[3] = 0, e[7] = 0, e[11] = 0, e[12] = 0, e[13] = 0, e[14] = 0, e[15] = 1, this;
            }
            makeRotationFromQuaternion(t1) {
                return this.compose($D, t1, tC);
            }
            lookAt(t1, e, i) {
                const n = this.elements;
                return nC.subVectors(t1, e), 0 === nC.lengthSq() && (nC.z = 1), nC.normalize(), eC.crossVectors(i, nC), 0 === eC.lengthSq() && (1 === Math.abs(i.z) ? nC.x += 1e-4 : nC.z += 1e-4, nC.normalize(), eC.crossVectors(i, nC)), eC.normalize(), iC.crossVectors(nC, eC), n[0] = eC.x, n[4] = iC.x, n[8] = nC.x, n[1] = eC.y, n[5] = iC.y, n[9] = nC.y, n[2] = eC.z, n[6] = iC.z, n[10] = nC.z, this;
            }
            multiply(t1) {
                return this.multiplyMatrices(this, t1);
            }
            premultiply(t1) {
                return this.multiplyMatrices(t1, this);
            }
            multiplyMatrices(t1, e) {
                const i = t1.elements, n = e.elements, r = this.elements, a = i[0], s = i[4], o = i[8], l = i[12], c = i[1], u = i[5], h = i[9], d = i[13], p = i[2], f = i[6], A = i[10], g = i[14], m = i[3], M = i[7], y = i[11], v = i[15], x = n[0], w = n[4], b = n[8], T = n[12], E = n[1], I = n[5], S = n[9], N = n[13], D = n[2], C = n[6], z = n[10], L = n[14], O = n[3], _ = n[7], j = n[11], P = n[15];
                return r[0] = a * x + s * E + o * D + l * O, r[4] = a * w + s * I + o * C + l * _, r[8] = a * b + s * S + o * z + l * j, r[12] = a * T + s * N + o * L + l * P, r[1] = c * x + u * E + h * D + d * O, r[5] = c * w + u * I + h * C + d * _, r[9] = c * b + u * S + h * z + d * j, r[13] = c * T + u * N + h * L + d * P, r[2] = p * x + f * E + A * D + g * O, r[6] = p * w + f * I + A * C + g * _, r[10] = p * b + f * S + A * z + g * j, r[14] = p * T + f * N + A * L + g * P, r[3] = m * x + M * E + y * D + v * O, r[7] = m * w + M * I + y * C + v * _, r[11] = m * b + M * S + y * z + v * j, r[15] = m * T + M * N + y * L + v * P, this;
            }
            multiplyScalar(t1) {
                const e = this.elements;
                return e[0] *= t1, e[4] *= t1, e[8] *= t1, e[12] *= t1, e[1] *= t1, e[5] *= t1, e[9] *= t1, e[13] *= t1, e[2] *= t1, e[6] *= t1, e[10] *= t1, e[14] *= t1, e[3] *= t1, e[7] *= t1, e[11] *= t1, e[15] *= t1, this;
            }
            determinant() {
                const t1 = this.elements, e = t1[0], i = t1[4], n = t1[8], r = t1[12], a = t1[1], s = t1[5], o = t1[9], l = t1[13], c = t1[2], u = t1[6], h = t1[10], d = t1[14];
                return t1[3] * (+r * o * u - n * l * u - r * s * h + i * l * h + n * s * d - i * o * d) + t1[7] * (+e * o * d - e * l * h + r * a * h - n * a * d + n * l * c - r * o * c) + t1[11] * (+e * l * u - e * s * d - r * a * u + i * a * d + r * s * c - i * l * c) + t1[15] * (-n * s * c - e * o * u + e * s * h + n * a * u - i * a * h + i * o * c);
            }
            transpose() {
                const t1 = this.elements;
                let e;
                return e = t1[1], t1[1] = t1[4], t1[4] = e, e = t1[2], t1[2] = t1[8], t1[8] = e, e = t1[6], t1[6] = t1[9], t1[9] = e, e = t1[3], t1[3] = t1[12], t1[12] = e, e = t1[7], t1[7] = t1[13], t1[13] = e, e = t1[11], t1[11] = t1[14], t1[14] = e, this;
            }
            setPosition(t1, e, i) {
                const n = this.elements;
                return t1.isVector3 ? (n[12] = t1.x, n[13] = t1.y, n[14] = t1.z) : (n[12] = t1, n[13] = e, n[14] = i), this;
            }
            invert() {
                const t1 = this.elements, e = t1[0], i = t1[1], n = t1[2], r = t1[3], a = t1[4], s = t1[5], o = t1[6], l = t1[7], c = t1[8], u = t1[9], h = t1[10], d = t1[11], p = t1[12], f = t1[13], A = t1[14], g = t1[15], m = u * A * l - f * h * l + f * o * d - s * A * d - u * o * g + s * h * g, M = p * h * l - c * A * l - p * o * d + a * A * d + c * o * g - a * h * g, y = c * f * l - p * u * l + p * s * d - a * f * d - c * s * g + a * u * g, v = p * u * o - c * f * o - p * s * h + a * f * h + c * s * A - a * u * A, x = e * m + i * M + n * y + r * v;
                if (0 === x) return this.set(0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0);
                const w = 1 / x;
                return t1[0] = m * w, t1[1] = (f * h * r - u * A * r - f * n * d + i * A * d + u * n * g - i * h * g) * w, t1[2] = (s * A * r - f * o * r + f * n * l - i * A * l - s * n * g + i * o * g) * w, t1[3] = (u * o * r - s * h * r - u * n * l + i * h * l + s * n * d - i * o * d) * w, t1[4] = M * w, t1[5] = (c * A * r - p * h * r + p * n * d - e * A * d - c * n * g + e * h * g) * w, t1[6] = (p * o * r - a * A * r - p * n * l + e * A * l + a * n * g - e * o * g) * w, t1[7] = (a * h * r - c * o * r + c * n * l - e * h * l - a * n * d + e * o * d) * w, t1[8] = y * w, t1[9] = (p * u * r - c * f * r - p * i * d + e * f * d + c * i * g - e * u * g) * w, t1[10] = (a * f * r - p * s * r + p * i * l - e * f * l - a * i * g + e * s * g) * w, t1[11] = (c * s * r - a * u * r - c * i * l + e * u * l + a * i * d - e * s * d) * w, t1[12] = v * w, t1[13] = (c * f * n - p * u * n + p * i * h - e * f * h - c * i * A + e * u * A) * w, t1[14] = (p * s * n - a * f * n - p * i * o + e * f * o + a * i * A - e * s * A) * w, t1[15] = (a * u * n - c * s * n + c * i * o - e * u * o - a * i * h + e * s * h) * w, this;
            }
            scale(t1) {
                const e = this.elements, i = t1.x, n = t1.y, r = t1.z;
                return e[0] *= i, e[4] *= n, e[8] *= r, e[1] *= i, e[5] *= n, e[9] *= r, e[2] *= i, e[6] *= n, e[10] *= r, e[3] *= i, e[7] *= n, e[11] *= r, this;
            }
            getMaxScaleOnAxis() {
                const t1 = this.elements, e = t1[0] * t1[0] + t1[1] * t1[1] + t1[2] * t1[2], i = t1[4] * t1[4] + t1[5] * t1[5] + t1[6] * t1[6], n = t1[8] * t1[8] + t1[9] * t1[9] + t1[10] * t1[10];
                return Math.sqrt(Math.max(e, i, n));
            }
            makeTranslation(t1, e, i) {
                return t1.isVector3 ? this.set(1, 0, 0, t1.x, 0, 1, 0, t1.y, 0, 0, 1, t1.z, 0, 0, 0, 1) : this.set(1, 0, 0, t1, 0, 1, 0, e, 0, 0, 1, i, 0, 0, 0, 1), this;
            }
            makeRotationX(t1) {
                const e = Math.cos(t1), i = Math.sin(t1);
                return this.set(1, 0, 0, 0, 0, e, -i, 0, 0, i, e, 0, 0, 0, 0, 1), this;
            }
            makeRotationY(t1) {
                const e = Math.cos(t1), i = Math.sin(t1);
                return this.set(e, 0, i, 0, 0, 1, 0, 0, -i, 0, e, 0, 0, 0, 0, 1), this;
            }
            makeRotationZ(t1) {
                const e = Math.cos(t1), i = Math.sin(t1);
                return this.set(e, -i, 0, 0, i, e, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1), this;
            }
            makeRotationAxis(t1, e) {
                const i = Math.cos(e), n = Math.sin(e), r = 1 - i, a = t1.x, s = t1.y, o = t1.z, l = r * a, c = r * s;
                return this.set(l * a + i, l * s - n * o, l * o + n * s, 0, l * s + n * o, c * s + i, c * o - n * a, 0, l * o - n * s, c * o + n * a, r * o * o + i, 0, 0, 0, 0, 1), this;
            }
            makeScale(t1, e, i) {
                return this.set(t1, 0, 0, 0, 0, e, 0, 0, 0, 0, i, 0, 0, 0, 0, 1), this;
            }
            makeShear(t1, e, i, n, r, a) {
                return this.set(1, i, r, 0, t1, 1, a, 0, e, n, 1, 0, 0, 0, 0, 1), this;
            }
            compose(t1, e, i) {
                const n = this.elements, r = e._x, a = e._y, s = e._z, o = e._w, l = r + r, c = a + a, u = s + s, h = r * l, d = r * c, p = r * u, f = a * c, A = a * u, g = s * u, m = o * l, M = o * c, y = o * u, v = i.x, x = i.y, w = i.z;
                return n[0] = (1 - (f + g)) * v, n[1] = (d + y) * v, n[2] = (p - M) * v, n[3] = 0, n[4] = (d - y) * x, n[5] = (1 - (h + g)) * x, n[6] = (A + m) * x, n[7] = 0, n[8] = (p + M) * w, n[9] = (A - m) * w, n[10] = (1 - (h + f)) * w, n[11] = 0, n[12] = t1.x, n[13] = t1.y, n[14] = t1.z, n[15] = 1, this;
            }
            decompose(t1, e, i) {
                const n = this.elements;
                let r = KD.set(n[0], n[1], n[2]).length();
                const a = KD.set(n[4], n[5], n[6]).length(), s = KD.set(n[8], n[9], n[10]).length();
                this.determinant() < 0 && (r = -r), t1.x = n[12], t1.y = n[13], t1.z = n[14], qD.copy(this);
                const o = 1 / r, l = 1 / a, c = 1 / s;
                return qD.elements[0] *= o, qD.elements[1] *= o, qD.elements[2] *= o, qD.elements[4] *= l, qD.elements[5] *= l, qD.elements[6] *= l, qD.elements[8] *= c, qD.elements[9] *= c, qD.elements[10] *= c, e.setFromRotationMatrix(qD), i.x = r, i.y = a, i.z = s, this;
            }
            makePerspective(t1, e, i, n, r, a, s = 2e3) {
                const o = this.elements, l = 2 * r / (e - t1), c = 2 * r / (i - n), u = (e + t1) / (e - t1), h = (i + n) / (i - n);
                let d, p;
                if (2e3 === s) d = -(a + r) / (a - r), p = -2 * a * r / (a - r);
                else {
                    if (2001 !== s) throw new Error("THREE.Matrix4.makePerspective(): Invalid coordinate system: " + s);
                    d = -a / (a - r), p = -a * r / (a - r);
                }
                return o[0] = l, o[4] = 0, o[8] = u, o[12] = 0, o[1] = 0, o[5] = c, o[9] = h, o[13] = 0, o[2] = 0, o[6] = 0, o[10] = d, o[14] = p, o[3] = 0, o[7] = 0, o[11] = -1, o[15] = 0, this;
            }
            makeOrthographic(t1, e, i, n, r, a, s = 2e3) {
                const o = this.elements, l = 1 / (e - t1), c = 1 / (i - n), u = 1 / (a - r), h = (e + t1) * l, d = (i + n) * c;
                let p, f;
                if (2e3 === s) p = (a + r) * u, f = -2 * u;
                else {
                    if (2001 !== s) throw new Error("THREE.Matrix4.makeOrthographic(): Invalid coordinate system: " + s);
                    p = r * u, f = -1 * u;
                }
                return o[0] = 2 * l, o[4] = 0, o[8] = 0, o[12] = -h, o[1] = 0, o[5] = 2 * c, o[9] = 0, o[13] = -d, o[2] = 0, o[6] = 0, o[10] = f, o[14] = -p, o[3] = 0, o[7] = 0, o[11] = 0, o[15] = 1, this;
            }
            equals(t1) {
                const e = this.elements, i = t1.elements;
                for(let t1 = 0; t1 < 16; t1++)if (e[t1] !== i[t1]) return !1;
                return !0;
            }
            fromArray(t1, e = 0) {
                for(let i = 0; i < 16; i++)this.elements[i] = t1[i + e];
                return this;
            }
            toArray(t1 = [], e = 0) {
                const i = this.elements;
                return t1[e] = i[0], t1[e + 1] = i[1], t1[e + 2] = i[2], t1[e + 3] = i[3], t1[e + 4] = i[4], t1[e + 5] = i[5], t1[e + 6] = i[6], t1[e + 7] = i[7], t1[e + 8] = i[8], t1[e + 9] = i[9], t1[e + 10] = i[10], t1[e + 11] = i[11], t1[e + 12] = i[12], t1[e + 13] = i[13], t1[e + 14] = i[14], t1[e + 15] = i[15], t1;
            }
        }
        const KD = new WD, qD = new JD, $D = new WD(0, 0, 0), tC = new WD(1, 1, 1), eC = new WD, iC = new WD, nC = new WD, rC = (t1)=>Math.cos(t1 * Math.PI / 180), aC = (t1)=>Math.sin(t1 * Math.PI / 180), sC = (t1)=>Math.tan(t1 * Math.PI / 180), oC = function(t1, e) {
            let i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 21;
            const n = new JD(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, -e.X, -e.Y, -e.Z, 1), r = -90, a = -90, s = new JD(rC(a), -aC(a), 0, 0, aC(a), rC(a), 0, 0, 0, 0, 1, 0, 0, 0, 0, 1), o = new JD(rC(r), 0, -aC(r), 0, 0, 1, 0, 0, aC(r), 0, rC(r), 0, 0, 0, 0, 1), l = new JD(1, 0, 0, 0, 0, rC(0), aC(0), 0, 0, -aC(0), rC(0), 0, 0, 0, 0, 1), c = s.multiply(o).multiply(l).multiply(new JD(0, 0, 1, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 1)), u = i / 2, h = new JD(1 / sC(u), 0, 0, 0, 0, 1 / sC(u), 0, 0, 0, 0, 0, 1, 0, 0, 1, 0), d = n.multiply(c).multiply(h), { X: p, Y: f, Z: A } = t1, g = ((t1, e)=>{
                const i = e.elements;
                return new sD(t1.x * i[0] + t1.y * i[1] + t1.z * i[2] + t1.w * i[3], t1.x * i[4] + t1.y * i[5] + t1.z * i[6] + t1.w * i[7], t1.x * i[8] + t1.y * i[9] + t1.z * i[10] + t1.w * i[11], t1.x * i[12] + t1.y * i[13] + t1.z * i[14] + t1.w * i[15]);
            })(new sD(p, f, A, 1), d);
            if (g.w > 0) {
                const t1 = 1 / g.w;
                return {
                    x: g.x * t1 / 2 + .5,
                    y: 1 - g.y * t1 / 2 - .5
                };
            }
            return null;
        }, lC = "#version 300 es", cC = "".concat(lC, "\n  precision lowp float;\n\n  in vec2 iPos;\n  in vec2 iTexCoord;\n\n  out vec2 vTexCoord;\n  out vec2 vAltTexCoord;\n\n  void main()	{\n    vTexCoord = iTexCoord;\n    vAltTexCoord = vec2(iTexCoord.x, 1.0 - iTexCoord.y);\n    gl_Position = vec4(iPos, 0, 1);\n  }\n"), uC = "".concat(lC, "\n  precision lowp float;\n  precision lowp int;\n\n  in vec2 vTexCoord;\n  in vec2 vAltTexCoord;\n\n  out vec4 oColor;\n\n  uniform vec4 uColor;\n  uniform sampler2D uTexture0;\n  uniform sampler2D uTexture1;\n\n  void main()	{\n    vec4 color1 = texture(uTexture0, vTexCoord);\n    vec4 color2 = texture(uTexture1, vAltTexCoord);\n\n    int r = int(uColor.r);\n    int rColor = int(color2.r);\n\n    if (r != 0 && r == rColor) {\n      vec4 uSelectColor = vec4(1.0, 0.65, 0.0, 1.0);\n\n      float t = 0.7;\n      oColor = color1 * t + uSelectColor * (1.0 - t);\n    } else {\n      oColor = color1;\n    }\n  }\n");
        function hC(t1, e, i) {
            dC(t1, e), e.set(t1, i);
        }
        function dC(t1, e) {
            if (e.has(t1)) throw new TypeError("Cannot initialize the same private elements twice on an object");
        }
        function pC(t1, e, i) {
            return (e = function(t1) {
                var e = function(t1) {
                    if ("object" != typeof t1 || !t1) return t1;
                    var e = t1[Symbol.toPrimitive];
                    if (void 0 !== e) {
                        var i = e.call(t1, "string");
                        if ("object" != typeof i) return i;
                        throw new TypeError("@@toPrimitive must return a primitive value.");
                    }
                    return String(t1);
                }(t1);
                return "symbol" == typeof e ? e : e + "";
            }(e)) in t1 ? Object.defineProperty(t1, e, {
                value: i,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : t1[e] = i, t1;
        }
        function fC(t1, e) {
            return t1.get(AC(t1, e));
        }
        function AC(t1, e, i) {
            if ("function" == typeof t1 ? t1 === e : t1.has(e)) return arguments.length < 3 ? e : i;
            throw new TypeError("Private element is not present on this object");
        }
        var gC = new WeakSet, mC = new WeakMap, MC = new WeakMap;
        function yC() {
            const t1 = this._gl, e = t1.createVertexArray();
            t1.bindVertexArray(e);
            const i = t1.createBuffer();
            t1.bindBuffer(t1.ARRAY_BUFFER, i), t1.bufferData(t1.ARRAY_BUFFER, new Float32Array([
                -1,
                1,
                1,
                1,
                1,
                -1,
                -1,
                -1
            ]), t1.STATIC_DRAW), t1.vertexAttribPointer(0, 2, t1.FLOAT, !1, 0, 0), t1.enableVertexAttribArray(0);
            const n = t1.createBuffer();
            t1.bindBuffer(t1.ARRAY_BUFFER, n), t1.bufferData(t1.ARRAY_BUFFER, new Float32Array([
                0,
                0,
                1,
                0,
                1,
                1,
                0,
                1
            ]), t1.STATIC_DRAW), t1.vertexAttribPointer(1, 2, t1.FLOAT, !1, 0, 0), t1.enableVertexAttribArray(1);
            const r = t1.createBuffer();
            t1.bindBuffer(t1.ELEMENT_ARRAY_BUFFER, r), t1.bufferData(t1.ELEMENT_ARRAY_BUFFER, new Uint16Array([
                0,
                1,
                2,
                0,
                2,
                3
            ]), t1.STATIC_DRAW), this._vao && t1.deleteVertexArray(this._vao), this._posBuf && t1.deleteBuffer(this._posBuf), this._texCoordBuf && t1.deleteBuffer(this._texCoordBuf), this._ebo && t1.deleteBuffer(this._ebo), this._vao = e, this._posBuf = i, this._texCoordBuf = n, this._ebo = r;
        }
        function vC() {
            const t1 = this._gl, e = this._program;
            this._uColorLocation = t1.getUniformLocation(e, "uColor"), t1.uniform1i(t1.getUniformLocation(e, "uTexture0"), 0), t1.uniform1i(t1.getUniformLocation(e, "uTexture1"), 1);
        }
        async function xC(t1) {
            const e = this._gl, i = fC(MC, this);
            return new Promise((n)=>{
                const r = new Image;
                r.crossOrigin = "anonymous", r.onload = ()=>{
                    const t1 = e.createTexture();
                    e.bindTexture(e.TEXTURE_2D, t1), e.texImage2D(e.TEXTURE_2D, 0, e.RGBA, e.RGBA, e.UNSIGNED_BYTE, r), i(r.width) && i(r.height) ? (e.generateMipmap(e.TEXTURE_2D), e.texParameteri(e.TEXTURE_2D, e.TEXTURE_WRAP_S, e.REPEAT), e.texParameteri(e.TEXTURE_2D, e.TEXTURE_WRAP_T, e.REPEAT), e.texParameteri(e.TEXTURE_2D, e.TEXTURE_MIN_FILTER, e.LINEAR_MIPMAP_LINEAR)) : (e.texParameteri(e.TEXTURE_2D, e.TEXTURE_WRAP_S, e.CLAMP_TO_EDGE), e.texParameteri(e.TEXTURE_2D, e.TEXTURE_WRAP_T, e.CLAMP_TO_EDGE), e.texParameteri(e.TEXTURE_2D, e.TEXTURE_MIN_FILTER, e.LINEAR)), e.texParameteri(e.TEXTURE_2D, e.TEXTURE_MAG_FILTER, e.LINEAR), n(t1);
                }, r.onerror = (t1)=>{
                    console.error(t1), n(null);
                }, r.src = t1;
            });
        }
        async function wC(t1) {
            const e = this._gl, i = e.createTexture();
            return e.bindTexture(e.TEXTURE_2D, i), e.texImage2D(e.TEXTURE_2D, 0, e.RGBA32F, t1.width, t1.height, 0, e.RGBA, e.FLOAT, t1.data.slice()), e.texParameteri(e.TEXTURE_2D, e.TEXTURE_WRAP_S, e.CLAMP_TO_EDGE), e.texParameteri(e.TEXTURE_2D, e.TEXTURE_WRAP_T, e.CLAMP_TO_EDGE), e.texParameteri(e.TEXTURE_2D, e.TEXTURE_MIN_FILTER, e.NEAREST), e.texParameteri(e.TEXTURE_2D, e.TEXTURE_MAG_FILTER, e.NEAREST), i;
        }
        function bC(t1, e) {
            const i = this._gl, n = fC(mC, this), r = n(i, i.VERTEX_SHADER, t1), a = n(i, i.FRAGMENT_SHADER, e);
            if (!r || !a) return r && i.deleteShader(r), a && i.deleteShader(a), null;
            const s = i.createProgram();
            return i.attachShader(s, r), i.attachShader(s, a), i.linkProgram(s), i.deleteShader(r), i.deleteShader(a), i.getProgramParameter(s, i.LINK_STATUS) ? (i.useProgram(s), s) : (console.error("Failed to link program:", i.getProgramInfoLog(s)), i.deleteProgram(s), null);
        }
        const TC = new class {
            constructor(){
                var t1;
                dC(this, t1 = gC), t1.add(this), pC(this, "_textures", []), pC(this, "_canvas", void 0), pC(this, "_gl", void 0), pC(this, "_program", void 0), pC(this, "_vao", void 0), pC(this, "_ebo", void 0), pC(this, "_posBuf", void 0), pC(this, "_texCoordBuf", void 0), pC(this, "_uColorLocation", void 0), hC(this, mC, (t1, e, i)=>{
                    const n = t1.createShader(e);
                    return t1.shaderSource(n, i), t1.compileShader(n), t1.getShaderParameter(n, t1.COMPILE_STATUS) ? n : (console.error("Failed to load shader:", t1.getShaderInfoLog(n)), t1.deleteShader(n), null);
                }), hC(this, MC, (t1)=>!(t1 & t1 - 1));
            }
            async init(t1) {
                this._canvas = t1, this._gl = t1.getContext("webgl2"), this._program && this._gl.deleteProgram(this._program), this._program = AC(gC, this, bC).call(this, cC, uC), AC(gC, this, yC).call(this), AC(gC, this, vC).call(this);
            }
            async setTextures(t1, e) {
                const i = this._gl;
                this._textures.forEach((t1)=>{
                    t1 && i.deleteTexture(t1);
                }), this._textures = new Array(2), t1 && (this._textures[0] = await AC(gC, this, xC).call(this, t1)), e && (this._textures[1] = await AC(gC, this, wC).call(this, e));
            }
            draw(t1) {
                const e = this._gl;
                e.clearColor(1, 1, 1, 1), e.clear(e.COLOR_BUFFER_BIT), this._textures.forEach((t1, i)=>{
                    e.activeTexture(e.TEXTURE0 + i), e.bindTexture(e.TEXTURE_2D, t1);
                }), t1 ? e.uniform4f(this._uColorLocation, t1.R, t1.G, t1.B, t1.A) : e.uniform4f(this._uColorLocation, 0, 0, 0, 0), e.drawElements(e.TRIANGLES, 6, e.UNSIGNED_SHORT, 0);
            }
        }, EC = "top-view-mask", IC = DN((t1)=>{
            let { disabled: i } = t1;
            const { currentFloorIndex: n } = zn, { json: r, topViewImage: a, bareshell: s, topViewResolutionUpscale: o } = zn.config, l = fN.currentPanoramaId, c = 200, u = 200, [h, d] = (0, e.useState)(!0), [p, f] = (0, e.useState)(!1), [A, g] = (0, e.useState)(null), m = (0, e.useMemo)(()=>((t1, e)=>{
                    const i = t1.Floors[e];
                    if (!i) return null;
                    let n = 1 / 0, r = 1 / 0, a = i.Location.Z, s = -1 / 0, o = -1 / 0, l = i.Location.Z + i.Height;
                    const c = ((t1, e)=>{
                        const i = [];
                        return ((t1, e)=>{
                            const i = e.length;
                            for(let n = 0; n < i; n++){
                                const i = e[n], r = GD(i.Location.X, i.Location.Y, i.Extent.X, i.Extent.Y, i.Rotation.Yaw * Math.PI / 180);
                                for(let e = 0; e < 4; e++)t1.push(r[e]);
                            }
                        })(i, t1.Decors), ((t1, e, i)=>{
                            const n = e.length, r = new Set;
                            for(let a = 0; a < n; a++){
                                const n = e[a];
                                if (!n.IsExterior) continue;
                                const s = VD(i, n.Vertices[0]), o = n.ControlPoint, l = VD(i, n.Vertices[1]);
                                if (r.has(s) || (t1.push({
                                    x: s.Location.X,
                                    y: s.Location.Y
                                }), r.add(s.ID)), o) {
                                    const e = 1 / 21, i = 1 - e;
                                    for(let n = e; n <= i; n += e)t1.push(HD(n, s, o, l));
                                }
                                r.has(l) || (t1.push({
                                    x: l.Location.X,
                                    y: l.Location.Y
                                }), r.add(l.ID));
                            }
                        })(i, t1.Walls, e), i;
                    })(i, t1.Vertices), u = c.length;
                    for(let t1 = 0; t1 < u; t1++){
                        const { x: e, y: i } = c[t1];
                        e < n && (n = e), e > s && (s = e), i < r && (r = i), i > o && (o = i);
                    }
                    return {
                        Origin: {
                            X: (n + s) / 2,
                            Y: (r + o) / 2,
                            Z: (a + l) / 2
                        },
                        Extent: {
                            X: (s - n) / 2,
                            Y: (o - r) / 2,
                            Z: (l - a) / 2
                        }
                    };
                })(r, n), []), M = (0, e.useMemo)(()=>(function(t1) {
                    let e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 50;
                    const i = sC((arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 21) / 2), n = Math.max(t1.Extent.X, t1.Extent.Y) + e, r = t1.Extent.Z + n / i;
                    return {
                        X: t1.Origin.X,
                        Y: t1.Origin.Y,
                        Z: t1.Origin.Z + r
                    };
                })(m), [
                n
            ]), y = (0, e.useMemo)(()=>{
                if (!M) return [];
                const t1 = r.Floors[n];
                return t1.CameraPoints.map((e)=>{
                    const { X: i, Y: n } = e.Location, r = t1.Location.Z + e.Location.Z;
                    return {
                        id: e.ID,
                        roomId: e.RoomID,
                        position: oC({
                            X: i,
                            Y: n,
                            Z: r
                        }, M)
                    };
                });
            }, [
                n,
                M,
                c
            ]);
            (0, e.useEffect)(()=>{
                d(!0), r && !i && v().then(()=>{
                    d(!1);
                });
            }, [
                a
            ]);
            const v = async ()=>{
                const t1 = await Mx(b);
                g(t1), t1 || console.warn("Failed to load top view color mask: ".concat(b));
                const e = document.getElementById(EC);
                e && (await TC.init(e), await TC.setTextures(a, t1), TC.draw());
            }, x = ()=>{
                jD.setCurrentColor({
                    r: 0,
                    g: 0,
                    b: 0,
                    a: 0
                }), TC.draw();
            }, w = ()=>{
                zn.showControls(), f(!1);
            }, b = a.replace(/\.(jpe?g|webp|png|svg)/, "_RoomIDs.exr"), T = {
                width: c,
                height: u
            }, E = {
                width: c * o,
                height: u * o
            };
            return e.createElement(e.Fragment, null, p && e.createElement(e.Fragment, null, e.createElement("div", {
                className: "widget-tab__panorama-close-map",
                onClick: w
            }, e.createElement("img", {
                src: LN,
                alt: "close-map"
            })), e.createElement("div", {
                className: "map-overlay map-overlay--visible",
                onClick: w
            })), e.createElement("div", {
                className: (()=>{
                    const t1 = [
                        "widget-tab__panorama-top-view-map"
                    ];
                    return s && t1.push("widget-tab__panorama-top-view-map--bottom"), h && t1.push("widget-tab__panorama-top-view-map--hidden"), p && t1.push("widget-tab__panorama-top-view-map--scaled"), t1.join(" ");
                })()
            }, e.createElement("div", {
                className: "display-wrapper"
            }, e.createElement("canvas", {
                id: EC,
                width: E.width,
                height: E.height,
                style: T,
                onClick: (t1)=>{
                    if (zn.config.width <= zN.tablet && !p) return x(), zn.hideControls(), void f(!0);
                    if (!document.getElementById(EC)) return;
                    w();
                    const e = t1.nativeEvent.layerX / c, i = t1.nativeEvent.layerY / u, n = jD.currentColor, a = r.RoomColorIDPairs.find((t1)=>t1.ColorID.R === n.R && t1.ColorID.G === n.G && t1.ColorID.B === n.B);
                    let s = y;
                    a && (s = s.filter((t1)=>t1.roomId === a.ObjectID));
                    const [o] = s.sort((t1, n)=>{
                        const r = t1.position.x - e, a = t1.position.y - i, s = n.position.x - e, o = n.position.y - i;
                        return r * r + a * a - (s * s + o * o);
                    });
                    o && fN.setCurrentPanoramaById(o.id);
                },
                onMouseMove: (t1)=>{
                    if (!A || h) return;
                    const e = t1.nativeEvent.layerX / c, i = t1.nativeEvent.layerY / u;
                    if (e < 0 || i < 0 || e > 1 || i > 1) return;
                    const { R: n, G: r, B: a, A: s } = vx(e, i, A);
                    t1.target.style.cursor = 0 === n ? "default" : "pointer";
                    const o = {
                        R: n,
                        G: r,
                        B: a,
                        A: s
                    };
                    TC.draw(o), jD.setCurrentColor(o);
                },
                onMouseLeave: x
            }), y.map((t1)=>{
                const i = t1.id === l ? "camera camera--current" : "camera", n = {
                    left: t1.position.x * c,
                    top: t1.position.y * c
                };
                return e.createElement("span", {
                    className: i,
                    key: t1.id,
                    style: n
                });
            }))));
        }), SC = DN((t1)=>{
            let { disabled: i } = t1;
            const n = zn.isCapable("top_view_as_miniplan") || Boolean(zn.config.forceTopViewOnMap), r = Boolean(zn.config.topViewImage), a = n && r;
            n && !r && console.warn("Top view map requested, but image missed!");
            const s = a ? IC : QD;
            return e.createElement(s, {
                disabled: i
            });
        }), NC = "data:image/svg+xml;base64,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", DC = DN((t1)=>{
            let { items: i, type: n, disabled: r, showRulerInstructions: a, setRulerInstructionsState: s } = t1;
            const o = [
                {
                    icon: kD,
                    text: Tv("rotate-plan")
                },
                {
                    icon: NC,
                    text: Tv("research-plan")
                }
            ], l = [
                {
                    icon: kD,
                    text: Tv("create-points")
                },
                {
                    icon: NC,
                    text: Tv("delete-points")
                }
            ], [c, u] = (0, e.useState)(zn.instructionVisible), h = ()=>fN.updateWindowSize(zn.config.width, zn.config.height);
            return (0, e.useEffect)(()=>{
                performance.mark("opening panorama mode"), fN.enableRender();
                const t1 = document.querySelector(".widget-tab__panorama-overlay");
                return t1.appendChild(fN.renderer.domElement), ()=>{
                    fN.setInitialCurrentPanorama(), fN.camera.deviceOrientationControls.disable(), fN.setCameraFov(fN.cameraFovValues.x1), fN.camera.controls.setDefaultPosition(), fN.setAutoRotateState(!1), fN.setRulerMode(!1), fN.disableRender(), t1.innerHTML = "";
                };
            }, []), (0, e.useEffect)(()=>{
                const t1 = fN.floorsGroup.children.some((t1)=>t1.floorIndex === zn.currentFloorIndex);
                return fN.initialized ? t1 ? (fN.setCurrentPanoramasGroup(zn.currentFloorIndex), void fN.setInitialCurrentPanorama()) : (fN.setLoadingState(!0), void fN.createPanoramasGroup(i, n, zn.currentFloorIndex).finally(()=>fN.setLoadingState(!1))) : (fN.setLoadingState(!0), performance.mark("start PanaramaStore Init"), void fN.init(i, n, zn.currentFloorIndex).finally(()=>fN.setLoadingState(!1)));
            }, [
                zn.currentFloorIndex
            ]), (0, e.useEffect)(h, [
                zn.config.width,
                zn.config.height
            ]), e.createElement(e.Fragment, null, e.createElement("div", {
                className: "widget-tab__panorama"
            }, fN.loading && e.createElement(FD, {
                absolute: !0
            }), e.createElement("div", {
                className: "widget-tab__panorama-overlay",
                onContextMenu: xv
            }), fN.currentPanorama && e.createElement(SC, {
                disabled: r
            })), c && e.createElement(aD, {
                disabled: r,
                steps: o,
                onClick: async ()=>{
                    if (u(!1), h(), !Cx.isMobile && !Cx.isTablet) return;
                    if (!zn.configParams.enableGyroscope) return;
                    if (fN.camera.deviceOrientationControls.connected) return fN.camera.deviceOrientationControls.enable();
                    if (await Cx.requestDeviceOrientation() !== Dx) return;
                    const t1 = ()=>{
                        window.removeEventListener("deviceorientation", t1), fN.camera.deviceOrientationControls.connect(), setTimeout(()=>fN.camera.deviceOrientationControls.enable(), 250);
                    };
                    window.addEventListener("deviceorientation", t1);
                }
            }), a && e.createElement(aD, {
                steps: l,
                onClick: ()=>{
                    fN.setRulerInstructionShown(!0), s(!1);
                }
            }));
        }), CC = (t1)=>{
            let { planImage: i } = t1;
            const [n, r] = (0, e.useState)(null);
            return (0, e.useEffect)(()=>{
                const t1 = document.querySelector(".widget-tab__isometry-container"), e = UN()(t1, {
                    beforeMouseDown: ()=>!0,
                    onTouch: ()=>!1,
                    zoomDoubleClickSpeed: 1,
                    minZoom: .5,
                    maxZoom: 3
                });
                r(e);
            }, []), e.createElement(UD, {
                planImage: i
            });
        }, zC = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDciIGhlaWdodD0iMjYiIHZpZXdCb3g9IjAgMCA0NyAyNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTM5LjUyNzcgOS44MjM0MUwzNC4xODI0IDUuNDI3MzZDMzMuOTc2OSA1LjI1ODM5IDMzLjcxOTIgNS4xNjYwMiAzMy40NTMyIDUuMTY2MDJIMTMuMzMwMkMxMy4wNTcgNS4xNjYwMiAxMi43OTI4IDUuMjYzNDUgMTIuNTg1IDUuNDQwOEw3LjQ0NTg4IDkuODI2NzdDNy4yNDI5NyA5Ljk5OTk0IDcuMzY1NDQgMTAuMzMyMSA3LjYzMjIgMTAuMzMyMUgzOS4zNDU0QzM5LjYxNDcgMTAuMzMyMSAzOS43MzU3IDkuOTk0NSAzOS41Mjc3IDkuODIzNDFaIiBzdHJva2U9IiM0MTNFM0UiIHN0cm9rZS13aWR0aD0iMS41Ii8+CjxwYXRoIGQ9Ik0xMC4zNzk4IDIyLjM4NjdDMTAuMzc5OCAyMi44MDA5IDEwLjcxNTUgMjMuMTM2NyAxMS4xMjk4IDIzLjEzNjdDMTEuNTQ0IDIzLjEzNjcgMTEuODc5OCAyMi44MDA5IDExLjg3OTggMjIuMzg2N0wxMC4zNzk4IDIyLjM4NjdaTTExLjg3OTggMjIuMzg2N0wxMS44Nzk4IDEwLjMzMjZMMTAuMzc5OCAxMC4zMzI2TDEwLjM3OTggMjIuMzg2N0wxMS44Nzk4IDIyLjM4NjdaIiBmaWxsPSIjNDEzRTNFIi8+CjxwYXRoIGQ9Ik0zNC40MjQzIDIyLjM4NjdDMzQuNDI0MyAyMi44MDA5IDM0Ljc2MDEgMjMuMTM2NyAzNS4xNzQzIDIzLjEzNjdDMzUuNTg4NSAyMy4xMzY3IDM1LjkyNDMgMjIuODAwOSAzNS45MjQzIDIyLjM4NjdMMzQuNDI0MyAyMi4zODY3Wk0zNS45MjQzIDIyLjM4NjdMMzUuOTI0MyAxMC4zMzI2TDM0LjQyNDMgMTAuMzMyNkwzNC40MjQzIDIyLjM4NjdMMzUuOTI0MyAyMi4zODY3WiIgZmlsbD0iIzQxM0UzRSIvPgo8cGF0aCBkPSJNMTQuNjk1NCAxNi45MDYyQzE0LjY5NTQgMTcuMzIwNSAxNS4wMzEyIDE3LjY1NjIgMTUuNDQ1NCAxNy42NTYyQzE1Ljg1OTYgMTcuNjU2MyAxNi4xOTU0IDE3LjMyMDUgMTYuMTk1NCAxNi45MDYzTDE0LjY5NTQgMTYuOTA2MlpNMTYuMTk1NCAxNi45MDYzTDE2LjE5NTQgMTAuMzMxM0wxNC42OTU0IDEwLjMzMTNMMTQuNjk1NCAxNi45MDYyTDE2LjE5NTQgMTYuOTA2M1oiIGZpbGw9IiM0MTNFM0UiLz4KPHBhdGggZD0iTTMwLjEwODYgMTYuOTA2MkMzMC4xMDg2IDE3LjMyMDUgMzAuNDQ0NCAxNy42NTYyIDMwLjg1ODYgMTcuNjU2MkMzMS4yNzI4IDE3LjY1NjMgMzEuNjA4NiAxNy4zMjA1IDMxLjYwODYgMTYuOTA2M0wzMC4xMDg2IDE2LjkwNjJaTTMxLjYwODYgMTYuOTA2M0wzMS42MDg2IDEwLjMzMTNMMzAuMTA4NiAxMC4zMzEzTDMwLjEwODYgMTYuOTA2MkwzMS42MDg2IDE2LjkwNjNaIiBmaWxsPSIjNDEzRTNFIi8+Cjwvc3ZnPgo=", LC = "data:image/svg+xml;base64,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", OC = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDciIGhlaWdodD0iMjYiIHZpZXdCb3g9IjAgMCA0NyAyNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEyLjY4MDUgMTkuNjAxNlYyMi4wMzkxIiBzdHJva2U9IiMxNDE0MTQiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTMzLjQ2ODkgMTkuNjAxNlYyMi4wMzkxIiBzdHJva2U9IiMxNDE0MTQiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTEwLjcwODIgMTAuMDU0N1Y1Ljk5MjE5QzEwLjcwODIgNS40NTM0NyAxMC45Njc0IDQuOTM2ODEgMTEuNDI4OSA0LjU1NTg4QzExLjg5MDMgNC4xNzQ5NCAxMi41MTYyIDMuOTYwOTQgMTMuMTY4NyAzLjk2MDk0QzEzLjgyMTMgMy45NjA5NCAxNC40NDcxIDQuMTc0OTQgMTQuOTA4NiA0LjU1NTg4QzE1LjM3IDQuOTM2ODEgMTUuNjI5MyA1LjQ1MzQ3IDE1LjYyOTMgNS45OTIxOSIgc3Ryb2tlPSIjMTQxNDE0IiBzdHJva2Utd2lkdGg9IjEuNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik0zMy45NDIxIDkuMjQyMTlIMjUuNjU0NlYxNC4xMTcySDMzLjk0MjFWOS4yNDIxOVoiIHN0cm9rZT0iIzE0MTQxNCIgc3Ryb2tlLXdpZHRoPSIxLjUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNMzQuNzk5MyAxMC4wNTQ3SDM4LjczNjJDMzguOTk3MiAxMC4wNTQ3IDM5LjI0NzUgMTAuMTQwMyAzOS40MzIxIDEwLjI5MjdDMzkuNjE2NyAxMC40NDUgMzkuNzIwNCAxMC42NTE3IDM5LjcyMDQgMTAuODY3MlYxNC43MjY2QzM5LjcyMDQgMTYuMDE5NSAzOS4wOTgyIDE3LjI1OTUgMzcuOTkwOCAxOC4xNzM3QzM2Ljg4MzMgMTkuMDg3OSAzNS4zODEzIDE5LjYwMTYgMzMuODE1MSAxOS42MDE2SDEyLjMzMDNDMTAuNzY0MSAxOS42MDE2IDkuMjYyMDcgMTkuMDg3OSA4LjE1NDYxIDE4LjE3MzdDNy4wNDcxNiAxNy4yNTk1IDYuNDI1IDE2LjAxOTUgNi40MjUgMTQuNzI2NlYxMC44NjcyQzYuNDI1IDEwLjY1MTcgNi41Mjg3IDEwLjQ0NSA2LjcxMzI3IDEwLjI5MjdDNi44OTc4NSAxMC4xNDAzIDcuMTQ4MTggMTAuMDU0NyA3LjQwOTIxIDEwLjA1NDdIMjUuNjUwNyIgc3Ryb2tlPSIjMTQxNDE0IiBzdHJva2Utd2lkdGg9IjEuNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo=", _C = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDciIGhlaWdodD0iMjYiIHZpZXdCb3g9IjAgMCA0NyAyNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE2LjQ1OTYgMjMuNTMzNlYyLjQ2NzEzTDI0LjMxNTcgMi40NjY4TTE2LjQ1OTYgMjMuNTMzNkgzMC4zOTYzTTE2LjQ1OTYgMjMuNTMzNkwyNC4zMTU3IDIwLjA1OTFWMi40NjY4TTE2LjQ1OTYgMjMuNTMzNkg5Ljc2NjZNMzAuMzk2MyAyMy41MzM2VjIuNDY3MTNMMjQuMzE1NyAyLjQ2NjhNMzAuMzk2MyAyMy41MzM2SDM3Ljg0OTdNMjEuNTEwNiAxMS41MTM2TDE5LjgxNDYgMTIuMzgyMyIgc3Ryb2tlPSIjNDEzRTNFIiBzdHJva2Utd2lkdGg9IjEuNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo=", jC = "data:image/svg+xml;base64,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", PC = {
            Kitchen: {
                name: "Kitchen",
                img: zC
            },
            BrownTilesKitchen: {
                name: "Kitchen",
                img: zC
            },
            Living: {
                name: "Living",
                img: LC
            },
            KitchenLiving: {
                name: "KitchLiv",
                img: LC
            },
            Bedroom: {
                name: "Bedroom",
                img: "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDciIGhlaWdodD0iMjYiIHZpZXdCb3g9IjAgMCA0NyAyNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTM4Ljk1ODUgMjIuMzg1NVYxNS40OTc0QzM4Ljk1ODUgMTQuNTQ2NCAzOC4xODc1IDEzLjc3NTQgMzcuMjM2NCAxMy43NzU0SDEwLjI1ODFDOS4zMDcwOCAxMy43NzU0IDguNTM2MSAxNC41NDY0IDguNTM2MSAxNS40OTc0VjIyLjM4NTUiIHN0cm9rZT0iIzE0MTQxNCIgc3Ryb2tlLXdpZHRoPSIxLjUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNMjEuNzM4MiAxMi42Mjc2VjEwLjMzMTZDMjEuNzM4MiA5LjY5NzU4IDIxLjIyNDMgOS4xODM1OSAyMC41OTAyIDkuMTgzNTlIMTYuNDkwOEMxNS45ODIgOS4xODM1OSAxNS41MzQgOS41MTg0MyAxNS4zODk4IDEwLjAwNjNMMTQuNzExNCAxMi4zMDI0QzE0LjQ5NDEgMTMuMDM3OSAxNS4wNDU0IDEzLjc3NTYgMTUuODEyNCAxMy43NzU2SDIwLjU5MDJDMjEuMjI0MyAxMy43NzU2IDIxLjczODIgMTMuMjYxNyAyMS43MzgyIDEyLjYyNzZaIiBzdHJva2U9IiMxNDE0MTQiIHN0cm9rZS13aWR0aD0iMS41Ii8+CjxwYXRoIGQ9Ik0yNS43NTYzIDEyLjYyNzZWMTAuMzMxNkMyNS43NTYzIDkuNjk3NTggMjYuMjcwMyA5LjE4MzU5IDI2LjkwNDMgOS4xODM1OUgzMS4wMDM4QzMxLjUxMjUgOS4xODM1OSAzMS45NjA2IDkuNTE4NDMgMzIuMTA0NyAxMC4wMDYzTDMyLjc4MzEgMTIuMzAyNEMzMy4wMDA0IDEzLjAzNzkgMzIuNDQ5MSAxMy43NzU2IDMxLjY4MjEgMTMuNzc1NkgyNi45MDQzQzI2LjI3MDMgMTMuNzc1NiAyNS43NTYzIDEzLjI2MTcgMjUuNzU2MyAxMi42Mjc2WiIgc3Ryb2tlPSIjMTQxNDE0IiBzdHJva2Utd2lkdGg9IjEuNSIvPgo8cGF0aCBkPSJNOC41MzYxIDIwLjA4OThIMzguOTU4NSIgc3Ryb2tlPSIjMTQxNDE0IiBzdHJva2Utd2lkdGg9IjEuNSIvPgo8cGF0aCBkPSJNMzUuNTE0NCAxMy4yMDIzVjguMDM2MjZDMzUuNTE0NCA2Ljc2ODIgMzQuNDg2NSA1Ljc0MDIzIDMzLjIxODQgNS43NDAyM0gxNC4yNzYyQzEzLjAwODEgNS43NDAyMyAxMS45ODAxIDYuNzY4MiAxMS45ODAxIDguMDM2MjZWMTMuMjAyMyIgc3Ryb2tlPSIjMTQxNDE0IiBzdHJva2Utd2lkdGg9IjEuNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo="
            },
            Kid_room: {
                name: "Kid room",
                img: "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDciIGhlaWdodD0iMjYiIHZpZXdCb3g9IjAgMCA0NyAyNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTIzLjI0ODIgMjIuNzVDMjguNjMyNSAyMi43NSAzMi45OTc0IDE4LjM4NDggMzIuOTk3NCAxM0MzMi45OTc0IDcuNjE1MjIgMjguNjMyNSAzLjI1IDIzLjI0ODIgMy4yNUMxNy44NjM4IDMuMjUgMTMuNDk5IDcuNjE1MjIgMTMuNDk5IDEzQzEzLjQ5OSAxOC4zODQ4IDE3Ljg2MzggMjIuNzUgMjMuMjQ4MiAyMi43NVoiIHN0cm9rZT0iIzQxM0UzRSIgc3Ryb2tlLXdpZHRoPSIxLjUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNMTkuNTkyMiAxNC4yMTg4QzIwLjI2NTIgMTQuMjE4OCAyMC44MTA4IDEzLjY3MzEgMjAuODEwOCAxM0MyMC44MTA4IDEyLjMyNjkgMjAuMjY1MiAxMS43ODEyIDE5LjU5MjIgMTEuNzgxMkMxOC45MTkxIDExLjc4MTIgMTguMzczNSAxMi4zMjY5IDE4LjM3MzUgMTNDMTguMzczNSAxMy42NzMxIDE4LjkxOTEgMTQuMjE4OCAxOS41OTIyIDE0LjIxODhaIiBmaWxsPSIjNDEzRTNFIi8+CjxwYXRoIGQ9Ik0yNi45MDQxIDE0LjIxODhDMjcuNTc3MSAxNC4yMTg4IDI4LjEyMjcgMTMuNjczMSAyOC4xMjI3IDEzQzI4LjEyMjcgMTIuMzI2OSAyNy41NzcxIDExLjc4MTIgMjYuOTA0MSAxMS43ODEyQzI2LjIzMSAxMS43ODEyIDI1LjY4NTQgMTIuMzI2OSAyNS42ODU0IDEzQzI1LjY4NTQgMTMuNjczMSAyNi4yMzEgMTQuMjE4OCAyNi45MDQxIDE0LjIxODhaIiBmaWxsPSIjNDEzRTNFIi8+CjxwYXRoIGQ9Ik0yNS45MzkzIDE3LjA2MjVDMjUuMTQxNyAxNy41OTIyIDI0LjIwNTYgMTcuODc0OCAyMy4yNDgxIDE3Ljg3NDhDMjIuMjkwNyAxNy44NzQ4IDIxLjM1NDUgMTcuNTkyMiAyMC41NTY5IDE3LjA2MjUiIHN0cm9rZT0iIzQxM0UzRSIgc3Ryb2tlLXdpZHRoPSIxLjUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNMjMuMjQ4MiAzLjI1QzIxLjYyMzMgNS4yODEyNSAyMS42MjMzIDcuMzEyNSAyMS42MjMzIDcuMzEyNUMyMS42MjMzIDcuNzQzNDggMjEuNzk0NSA4LjE1NjggMjIuMDk5MiA4LjQ2MTU1QzIyLjQwMzkgOC43NjYyOSAyMi44MTcyIDguOTM3NSAyMy4yNDgyIDguOTM3NUMyMy42NzkxIDguOTM3NSAyNC4wOTI0IDguNzY2MjkgMjQuMzk3MSA4LjQ2MTU1QzI0LjcwMTggOC4xNTY4IDI0Ljg3MyA3Ljc0MzQ4IDI0Ljg3MyA3LjMxMjUiIHN0cm9rZT0iIzQxM0UzRSIgc3Ryb2tlLXdpZHRoPSIxLjUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8L3N2Zz4K"
            },
            Hall: {
                name: "Hall",
                img: _C
            },
            Bathroom: {
                name: "Bathroom",
                img: OC
            },
            BathLaminate: {
                name: "Bathroom",
                img: OC
            },
            CombinedBathroom: {
                name: "CombBath",
                img: OC
            },
            LightWoodBath: {
                name: "Bathroom",
                img: OC
            },
            BrownTilesBath: {
                name: "Bathroom",
                img: OC
            },
            Toilet: {
                name: "Toilet",
                img: "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDciIGhlaWdodD0iMjYiIHZpZXdCb3g9IjAgMCA0NyAyNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE2Ljc1IDExLjM3NVY0LjA2MjVDMTYuNzUgMy44NDcwMSAxNi44MzU2IDMuNjQwMzUgMTYuOTg4IDMuNDg3OThDMTcuMTQwMyAzLjMzNTYgMTcuMzQ3IDMuMjUgMTcuNTYyNSAzLjI1SDI4LjkzNzVDMjkuMTUzIDMuMjUgMjkuMzU5NyAzLjMzNTYgMjkuNTEyIDMuNDg3OThDMjkuNjY0NCAzLjY0MDM1IDI5Ljc1IDMuODQ3MDEgMjkuNzUgNC4wNjI1VjExLjM3NSIgc3Ryb2tlPSIjNDEzRTNFIiBzdHJva2Utd2lkdGg9IjEuNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik0yMCA2LjVIMjEuNjI1IiBzdHJva2U9IiM0MTNFM0UiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTMyLjE4NzUgMTEuMzc1QzMyLjE4NzUgMTMuNzQ1NCAzMS4yNDU5IDE2LjAxODcgMjkuNTY5OCAxNy42OTQ4QzI3Ljg5MzcgMTkuMzcwOSAyNS42MjA0IDIwLjMxMjUgMjMuMjUgMjAuMzEyNUMyMC44Nzk2IDIwLjMxMjUgMTguNjA2MyAxOS4zNzA5IDE2LjkzMDIgMTcuNjk0OEMxNS4yNTQxIDE2LjAxODcgMTQuMzEyNSAxMy43NDU0IDE0LjMxMjUgMTEuMzc1SDMyLjE4NzVaIiBzdHJva2U9IiM0MTNFM0UiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTE5Ljc1NjMgMTkuNjAxNkwxOS4zMTk1IDIyLjYzODNDMTkuMzAzNiAyMi43NTMxIDE5LjMxMjQgMjIuODcgMTkuMzQ1NCAyMi45ODEyQzE5LjM3ODQgMjMuMDkyMyAxOS40MzQ4IDIzLjE5NTEgMTkuNTEwOCAyMy4yODI2QzE5LjU4NjggMjMuMzcwMiAxOS42ODA2IDIzLjQ0MDUgMTkuNzg2IDIzLjQ4ODdDMTkuODkxNCAyMy41MzcgMjAuMDA2IDIzLjU2MjIgMjAuMTIxOSAyMy41NjI1SDI2LjM3ODFDMjYuNDk0MSAyMy41NjIyIDI2LjYwODYgMjMuNTM3IDI2LjcxNCAyMy40ODg3QzI2LjgxOTQgMjMuNDQwNSAyNi45MTMzIDIzLjM3MDIgMjYuOTg5MyAyMy4yODI2QzI3LjA2NTMgMjMuMTk1MSAyNy4xMjE2IDIzLjA5MjMgMjcuMTU0NiAyMi45ODEyQzI3LjE4NzYgMjIuODcgMjcuMTk2NCAyMi43NTMxIDI3LjE4MDUgMjIuNjM4M0wyNi43NDM4IDE5LjYwMTYiIHN0cm9rZT0iIzQxM0UzRSIgc3Ryb2tlLXdpZHRoPSIxLjUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8L3N2Zz4K"
            },
            Balcony: {
                name: "Balcony",
                img: "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTciIGhlaWdodD0iMjYiIHZpZXdCb3g9IjAgMCA1NyAyNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE1LjI0MzIgMTUuOTgwN1YxNS40ODc4QzE1LjI0MzIgMTQuMzgzMyAxNi4xMzg2IDEzLjQ4NzggMTcuMjQzMiAxMy40ODc4SDE5LjM3OTNNNDAuNDM5MyAxNS45ODA3VjE1LjQ4NzhDNDAuNDM5MyAxNC4zODMzIDM5LjU0MzkgMTMuNDg3OCAzOC40MzkzIDEzLjQ4NzhIMzYuMzAzMU0zNi4zMDMxIDEwLjg1NTdWMy4zMjIyN0gyNy44NDEyTTE5LjM3OTMgMTAuODU1N1YzLjMyMjI3SDI3Ljg0MTJNMjcuODQxMiAzLjMyMjI3VjEwLjg1NTdNMTYuMzQ2MSAyMi4xMTRIMTkuMzc5M00zOS4zMzYzIDIyLjExNEgzNi4zMDMxTTI3Ljg0MTIgMjIuMTE0VjEzLjQ4NzhNMjcuODQxMiAyMi4xMTRIMzIuMDI5MU0yNy44NDEyIDIyLjExNEgyMy42MTAyTTI3Ljg0MTIgMTMuNDg3OEgzMi4wMjkxTTI3Ljg0MTIgMTMuNDg3OEgxOS4zNzkzTTMyLjAyOTEgMTMuNDg3OFYyMi4xMTRNMzIuMDI5MSAxMy40ODc4SDM2LjMwMzFNMzIuMDI5MSAyMi4xMTRIMzYuMzAzMU0zNi4zMDMxIDIyLjExNFYxMy40ODc4TTE5LjM3OTMgMTMuNDg3OFYyMi4xMTRNMTkuMzc5MyAyMi4xMTRIMjMuNjEwMk0yMy42MTAyIDIyLjExNFYxMy42Mjg0IiBzdHJva2U9IiM0MTNFM0UiIHN0cm9rZS13aWR0aD0iMS41Ii8+Cjwvc3ZnPgo="
            },
            Hallway: {
                name: "Hallway",
                img: _C
            },
            Cabinet: {
                name: "Cabinet",
                img: "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTciIGhlaWdodD0iMzMiIHZpZXdCb3g9IjAgMCA1NyAzMyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTM5IDkuNzI2NTZIMTdDMTYuNDQ3NyA5LjcyNjU2IDE2IDEwLjE3NDMgMTYgMTAuNzI2NlYyNi43MjY2QzE2IDI3LjI3ODggMTYuNDQ3NyAyNy43MjY2IDE3IDI3LjcyNjZIMzlDMzkuNTUyMyAyNy43MjY2IDQwIDI3LjI3ODggNDAgMjYuNzI2NlYxMC43MjY2QzQwIDEwLjE3NDMgMzkuNTUyMyA5LjcyNjU2IDM5IDkuNzI2NTZaIiBzdHJva2U9IiM0MTNFM0UiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTMzIDkuNzI2NTZWNy43MjY1NkMzMyA3LjE5NjEzIDMyLjc4OTMgNi42ODc0MiAzMi40MTQyIDYuMzEyMzVDMzIuMDM5MSA1LjkzNzI4IDMxLjUzMDQgNS43MjY1NiAzMSA1LjcyNjU2SDI1QzI0LjQ2OTYgNS43MjY1NiAyMy45NjA5IDUuOTM3MjggMjMuNTg1OCA2LjMxMjM1QzIzLjIxMDcgNi42ODc0MiAyMyA3LjE5NjEzIDIzIDcuNzI2NTZWOS43MjY1NiIgc3Ryb2tlPSIjNDEzRTNFIiBzdHJva2Utd2lkdGg9IjEuNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik00MCAxNi41MTM3QzM2LjM1MjkgMTguNjIzIDMyLjIxMzIgMTkuNzMxMiAyOCAxOS43MjYyQzIzLjc4NjEgMTkuNzM3MSAxOS42NDQ4IDE4LjYyODUgMTYgMTYuNTEzNyIgc3Ryb2tlPSIjNDEzRTNFIiBzdHJva2Utd2lkdGg9IjEuNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik0yNi41IDE1LjcyNjZIMjkuNSIgc3Ryb2tlPSIjNDEzRTNFIiBzdHJva2Utd2lkdGg9IjEuNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo="
            },
            Wardrobe: {
                name: "Wardrobe",
                img: "data:image/svg+xml;base64,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"
            },
            Terrace: {
                name: "Terrace",
                img: jC
            },
            Terrace_2: {
                name: "Terrace",
                img: jC
            },
            Garage: {
                name: "Garage",
                img: "data:image/svg+xml;base64,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"
            },
            Gym: {
                name: "Gym",
                img: "data:image/svg+xml;base64,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"
            },
            Carpet: {
                name: "Pooja Room",
                img: zC
            }
        }, RC = DN(()=>{
            const t1 = (0, e.useRef)(null), i = t1.current, [n, r] = (0, e.useState)(!1), a = zn.config.json.Floors[zn.currentFloorIndex].Units[0].Rooms, s = [];
            Object.keys(PC).forEach((t1)=>{
                const e = a.filter((e)=>e.Type === t1 && "Flipped" !== e.WallsState && "Gap" !== e.CeilingState);
                e.length > 1 && e.forEach((t1, i)=>e[i].Numeric = i + 1), s.push(...e);
            });
            const o = function(t1) {
                var e;
                let i = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
                const n = null !== (e = t1.getAttribute("data-test-id")) && void 0 !== e ? e : t1.closest("div").getAttribute("data-test-id");
                n && (i ? jD.setFixedColor({
                    R: Number(n),
                    G: 0,
                    B: 0,
                    A: 0
                }) : jD.setCurrentColor({
                    R: Number(n),
                    G: 0,
                    B: 0,
                    A: 0
                }));
            };
            return (0, e.useEffect)(()=>{
                i && i.addEventListener("mousedown", (t1)=>{
                    const e = t1.screenX, n = i.scrollLeft;
                    let r = !0;
                    const a = (t1)=>{
                        if (r) {
                            const r = e - t1.screenX;
                            i.scrollLeft = n + r;
                        }
                    }, s = ()=>{
                        r = !1, i.removeEventListener("mousemove", a), i.removeEventListener("mouseup", s), i.removeEventListener("mouseleave", o);
                    }, o = ()=>{
                        r = !1, i.removeEventListener("mousemove", a), i.removeEventListener("mouseup", s), i.removeEventListener("mouseleave", o);
                    };
                    i.addEventListener("mousemove", a), i.addEventListener("mouseup", s), i.addEventListener("mouseleave", o);
                });
            }, [
                i
            ]), (0, e.useEffect)(()=>{
                const t1 = s.findIndex((t1)=>t1.ColorID);
                t1 >= 0 && jD.setFixedColor(s[t1].ColorID);
            }, []), e.createElement(e.Fragment, null, e.createElement("div", {
                ref: t1,
                className: "widget-tab-rooms",
                onClick: (t1)=>o(t1.target, !0),
                onMouseMove: (t1)=>o(t1.target)
            }, e.createElement("div", {
                className: "widget-tab-rooms-switch"
            }, e.createElement("input", {
                onChange: ()=>{
                    r((t1)=>!t1);
                },
                className: "widget-tab-rooms-switch-checkbox",
                id: "area-type-switch",
                type: "checkbox"
            }), e.createElement("label", {
                className: "widget-tab-rooms-switch-label",
                htmlFor: "area-type-switch"
            }, e.createElement("span", {
                className: "widget-tab-rooms-switch-button"
            }, n ? "Meters" : "Feet"))), e.createElement("div", {
                className: "widget-tab-rooms-container"
            }, s.map((t1)=>{
                var i, r, a, s, o;
                return e.createElement("div", {
                    "data-test-id": null === (i = t1.ColorID) || void 0 === i ? void 0 : i.R,
                    className: "widget-tab-rooms-item ".concat((o = null === (r = t1.ColorID) || void 0 === r ? void 0 : r.R, o === jD.currentColor.R || o === jD.fixedColor.R ? "widget-tab-rooms-item-active" : "")),
                    key: t1.ID
                }, e.createElement("img", {
                    className: "widget-tab-rooms-item-img",
                    src: (a = t1.Type, null === (s = Object.entries(PC).find((t1)=>{
                        let [e, i] = t1;
                        return e === a;
                    })) || void 0 === s ? void 0 : s[1].img),
                    alt: "icon"
                }), e.createElement("p", {
                    className: "widget-tab-rooms-item-type"
                }, ((t1, e)=>{
                    var i;
                    const n = null === (i = Object.entries(PC).find((e)=>{
                        let [i, n] = e;
                        return i === t1;
                    })) || void 0 === i ? void 0 : i[1].name;
                    return e ? "".concat(n, " ").concat(e) : n;
                })(t1.Type, t1.Numeric)), e.createElement("p", {
                    className: "widget-tab-rooms-item-area"
                }, ((t1)=>{
                    var e, i;
                    const r = t1.Length * t1.Width;
                    return Math.abs(r / t1.Area - 1) >= .15 ? n ? "".concat(t1.Area.toFixed(1), "m\xb2") : "".concat(((t1)=>{
                        const e = Math.floor(t1 * Math.pow(vv, 2)), i = 144 * (t1 * Math.pow(vv, 2) - e);
                        return "".concat(e, "'").concat(Math.round(i), '"');
                    })(t1.Area)) : n ? "".concat(null === (e = t1.Width) || void 0 === e ? void 0 : e.toFixed(1), "m x ").concat(null === (i = t1.Length) || void 0 === i ? void 0 : i.toFixed(1), "m") : "".concat(Ev(t1.Width), " x ").concat(Ev(t1.Length));
                })(t1)));
            }))));
        }), UC = DN((t1)=>{
            let { currentTab: i, setRulerInstructionsState: n } = t1;
            const [r, a] = (0, e.useState)(!1), [s, o] = (0, e.useState)([]), [l, c] = (0, e.useState)(!0), [u, h] = (0, e.useState)(!1), [d, p] = (0, e.useState)(zn.autoRotatePanarama), [f, A] = (0, e.useState)(!0), g = (0, e.useRef)(null), m = g.current, M = "rotation" !== i || zn.config.floors.length > 1 || zn.isCapable("interactive_top_view"), y = ()=>{
                o([]), a(!1);
            }, v = async ()=>{
                u && fN.toggleRulerMode(), h(!1), c((t1)=>!t1), fN.setBareshell(!fN.bareshell), fN.currentPanorama && (fN.setLoadingState(!0), await fN.currentPanorama.fadeOut(), await fN.currentPanorama.createMaterial(), await fN.currentPanorama.fadeIn(), fN.setLoadingState(!1));
            }, x = [
                {
                    isVisible: zn.isCapable("hidden_furniture"),
                    click: ()=>v(),
                    buttonActivity: !l,
                    icon: "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDQiIGhlaWdodD0iNDQiIHZpZXdCb3g9IjAgMCA0NCA0NCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPG1hc2sgaWQ9InBhdGgtMi1pbnNpZGUtMV8zNTA2XzgyOTUiIGZpbGw9IndoaXRlIj4KPHJlY3QgeD0iOS42MjEwOSIgeT0iOS42MjUiIHdpZHRoPSIyNC43NSIgaGVpZ2h0PSIxMS45ODI3IiByeD0iMS40Njc5MSIvPgo8L21hc2s+CjxyZWN0IHg9IjkuNjIxMDkiIHk9IjkuNjI1IiB3aWR0aD0iMjQuNzUiIGhlaWdodD0iMTEuOTgyNyIgcng9IjEuNDY3OTEiIHN0cm9rZT0iIzQxM0UzRSIgc3Ryb2tlLXdpZHRoPSIzLjk4NzUiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIG1hc2s9InVybCgjcGF0aC0yLWluc2lkZS0xXzM1MDZfODI5NSkiLz4KPG1hc2sgaWQ9InBhdGgtMy1pbnNpZGUtMl8zNTA2XzgyOTUiIGZpbGw9IndoaXRlIj4KPHJlY3QgeD0iOS42MjEwOSIgeT0iMTkuNDk2MSIgd2lkdGg9IjI0Ljc1IiBoZWlnaHQ9IjExLjk4MjciIHJ4PSIxLjQ2NzkxIi8+CjwvbWFzaz4KPHJlY3QgeD0iOS42MjEwOSIgeT0iMTkuNDk2MSIgd2lkdGg9IjI0Ljc1IiBoZWlnaHQ9IjExLjk4MjciIHJ4PSIxLjQ2NzkxIiBzdHJva2U9IiM0MTNFM0UiIHN0cm9rZS13aWR0aD0iMy45ODc1IiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBtYXNrPSJ1cmwoI3BhdGgtMy1pbnNpZGUtMl8zNTA2XzgyOTUpIi8+CjxwYXRoIGQ9Ik0xOC45ODYzIDI1Ljc1NzhIMjQuOTk1MyIgc3Ryb2tlPSIjNDEzRTNFIiBzdHJva2Utd2lkdGg9IjEuOTkzNzUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNMTguOTg2MyAxNS42MTcyTDI0Ljk5NTMgMTUuNjE3MiIgc3Ryb2tlPSIjNDEzRTNFIiBzdHJva2Utd2lkdGg9IjEuOTkzNzUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNMzAuNzI2NiAzNC41NzgxTDMwLjcyNjYgMzEuNDc4MiIgc3Ryb2tlPSIjNDEzRTNFIiBzdHJva2Utd2lkdGg9IjEuOTkzNzUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNMTMuMjY3NiAzNC41NzgxTDEzLjI2NzYgMzEuNDc4MiIgc3Ryb2tlPSIjNDEzRTNFIiBzdHJva2Utd2lkdGg9IjEuOTkzNzUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8L3N2Zz4K"
                },
                {
                    isVisible: zn.isCapable("ruler"),
                    click: ()=>(fN.bareshell && v(), h((t1)=>!t1), fN.toggleRulerMode(), void (fN.rulerInstructionShown || n(!0))),
                    buttonActivity: !l,
                    icon: dN
                },
                {
                    isVisible: !0,
                    click: ()=>{
                        fN.toggleFov();
                    },
                    buttonActivity: !1,
                    icon: fN.currentFovIcon
                },
                {
                    isVisible: !0,
                    click: ()=>(p((t1)=>!t1), void fN.toggleAutoRotate()),
                    buttonActivity: d,
                    icon: "data:image/svg+xml;base64,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"
                }
            ];
            return (0, e.useEffect)(()=>{
                null === jD.roomsVisible && jD.setRoomsVisible(zn.isCapable("interactive_top_view")), A(jD.roomsVisible), fN.setAutoRotateState(zn.autoRotatePanarama);
            }, []), M ? e.createElement("div", {
                className: "panel"
            }, e.createElement("div", {
                className: "panel-sidebar"
            }, e.createElement("div", {
                ref: g,
                onWheel: (t1)=>{
                    const e = Math.sign(t1.deltaY);
                    m.scrollTo({
                        top: m.scrollTop + 90 * e,
                        left: 0,
                        behavior: "smooth"
                    });
                },
                className: "panel-sidebar-select-wrapper ".concat(s.length > 0 ? "panel-sidebar-select-wrapper-visible" : "")
            }, e.createElement("div", {
                className: "panel-sidebar-select"
            }, s.map((t1)=>e.createElement("div", {
                    key: t1.value,
                    className: "panel-sidebar-select-item ".concat(t1.active ? "panel-sidebar-select-item-active" : ""),
                    onClick: t1.click
                }, t1.label)))), e.createElement("div", {
                className: "panel-sidebar-menu ".concat(r ? "panel-sidebar-menu-visible" : "")
            }, zn.config.floors.length > 1 && e.createElement("button", {
                className: "panel-sidebar-menu-item ".concat(s.length > 0 ? "panel-sidebar-menu-item-active" : ""),
                onClick: ()=>{
                    o(zn.config.floors.map((t1, e)=>({
                            label: Tv("floor", e + 1),
                            value: e,
                            active: e === zn.currentFloorIndex,
                            click: ()=>{
                                zn.setCurrentFloorIndex(e), y();
                            }
                        })));
                }
            }, e.createElement("img", {
                src: "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDQiIGhlaWdodD0iNDQiIHZpZXdCb3g9IjAgMCA0NCA0NCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwXzM1MDZfODEwNSkiPgo8cGF0aCBkPSJNMTAuOTk4IDI3LjcxNDhMMjIuNDIxMSAzNC4zNzgzTDMzLjg0NDIgMjcuNzE0OCIgc3Ryb2tlPSIjNDEzRTNFIiBzdHJva2Utd2lkdGg9IjEuOTAzODUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNMTAuOTk4IDIyTDIyLjQyMTEgMjguNjYzNUwzMy44NDQyIDIyIiBzdHJva2U9IiM0MTNFM0UiIHN0cm9rZS13aWR0aD0iMS45MDM4NSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik0xMC45OTggMTYuMjg4NUwyMi40MjExIDIyLjk1MTlMMzMuODQ0MiAxNi4yODg1TDIyLjQyMTEgOS42MjVMMTAuOTk4IDE2LjI4ODVaIiBzdHJva2U9IiM0MTNFM0UiIHN0cm9rZS13aWR0aD0iMS45MDM4NSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjwvZz4KPGRlZnM+CjxjbGlwUGF0aCBpZD0iY2xpcDBfMzUwNl84MTA1Ij4KPHJlY3Qgd2lkdGg9IjQ0IiBoZWlnaHQ9IjQ0IiBmaWxsPSJ3aGl0ZSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTAuMDAxOTUzMTIpIi8+CjwvY2xpcFBhdGg+CjwvZGVmcz4KPC9zdmc+Cg==",
                alt: "icon"
            })), zn.config.floors.length > 1 && e.createElement("div", {
                className: "panel-sidebar-menu-line"
            }), "panorama" === i && x.map((t1, i)=>t1.isVisible && e.createElement("button", {
                    key: i,
                    className: "panel-sidebar-menu-item ".concat(t1.buttonActivity ? "panel-sidebar-menu-item-active" : ""),
                    onClick: t1.click
                }, e.createElement("img", {
                    src: t1.icon,
                    alt: "icon"
                }))), "rotation" === i && zn.isCapable("interactive_top_view") && e.createElement("button", {
                className: "panel-sidebar-menu-item ".concat(f ? "panel-sidebar-menu-item-active" : ""),
                onClick: ()=>{
                    jD.setRoomsVisible(!f), A((t1)=>!t1);
                }
            }, e.createElement("img", {
                src: "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDQiIGhlaWdodD0iNDQiIHZpZXdCb3g9IjAgMCA0NCA0NCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTMxLjUxODggMTguNTA5NlYzNC4zNzUyTTMxLjUxODggMzQuMzc1MkwzNC42OTE5IDMxLjEzTTMxLjUxODggMzQuMzc1MkwyOC4zNDU3IDMxLjEzTTMxLjUxODggMzEuMjAyMUwzMS41MTg4IDE3Ljg3NU0zMS41MTg4IDE3Ljg3NUwyOC4zNDU3IDIxLjAzMTRNMzEuNTE4OCAxNy44NzVMMzQuNjkxOSAyMS4wMzE0IiBzdHJva2U9IiM0MTNFM0UiIHN0cm9rZS13aWR0aD0iMS42NSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIi8+CjxwYXRoIGQ9Ik05Ljk0MzIyIDEyLjc5ODFMMjUuODA4OCAxMi43OTgxTTI1LjgwODggMTIuNzk4MUwyMi41NjM1IDkuNjI1TTI1LjgwODggMTIuNzk4MUwyMi41NjM1IDE1Ljk3MTJNMjIuNjM1NyAxMi43OTgxSDkuMzA4NTlNOS4zMDg1OSAxMi43OTgxTDEyLjQ2NSAxNS45NzEyTTkuMzA4NTkgMTIuNzk4MUwxMi40NjUgOS42MjUiIHN0cm9rZT0iIzQxM0UzRSIgc3Ryb2tlLXdpZHRoPSIxLjY1IiBzdHJva2UtbGluZWNhcD0icm91bmQiLz4KPHBhdGggZD0iTTI0LjYxNTcgMzQuMDYwN0g5Ljk0MzM1QzkuODAzMTUgMzQuMDYwNyA5LjY4OTUgMzMuOTQ3MSA5LjY4OTUgMzMuODA2OUw5LjY4OTQ1IDE5LjM5NDVDOS42ODk0NSAxOS4yNTQzIDkuODAzMSAxOS4xNDA2IDkuOTQzMyAxOS4xNDA2SDI0LjYxNTdDMjQuNzU1OSAxOS4xNDA2IDI0Ljg2OTUgMTkuMjU0MyAyNC44Njk1IDE5LjM5NDVWMzMuODA2OUMyNC44Njk1IDMzLjk0NzEgMjQuNzU1OSAzNC4wNjA3IDI0LjYxNTcgMzQuMDYwN1oiIHN0cm9rZT0iIzQxM0UzRSIgc3Ryb2tlLXdpZHRoPSIxLjY1Ii8+Cjwvc3ZnPgo=",
                alt: "icon"
            })), "rotation" === i && zn.isCapable("interactive_top_view") && e.createElement("div", {
                className: "panel-sidebar-menu-line"
            }), e.createElement("button", {
                className: "panel-sidebar-menu-item",
                onClick: y
            }, e.createElement("img", {
                src: "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjIiIGhlaWdodD0iMjIiIHZpZXdCb3g9IjAgMCAyMiAyMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTcuNTYwNTUgNC4xMjg5MUwxNC40MzU1IDExLjAwMzlMNy41NjA1NSAxNy44Nzg5IiBzdHJva2U9IiM0MTNFM0UiIHN0cm9rZS13aWR0aD0iMi4wNjI1IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9zdmc+Cg==",
                alt: "icon"
            }))), e.createElement("button", {
                className: "panel-sidebar-menu-toggle ".concat(r ? "" : "panel-sidebar-menu-toggle-visible"),
                onClick: ()=>{
                    a(!0);
                }
            }, e.createElement("img", {
                src: "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjIiIGhlaWdodD0iMjIiIHZpZXdCb3g9IjAgMCAyMiAyMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE0LjQzNzUgMTcuODc1TDcuNTYyNSAxMUwxNC40Mzc1IDQuMTI1IiBzdHJva2U9IiM0MTNFM0UiIHN0cm9rZS13aWR0aD0iMi4wNjI1IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9zdmc+Cg==",
                alt: "icon"
            })))) : null;
        }), kC = UC, BC = DN(()=>{
            var t1, i, n, r, a, s;
            const { config: o } = zn, l = {
                width: o.width,
                height: o.height,
                "--main-color": o.colors.main,
                "--main-text": o.colors.mainText
            }, [c, u] = (0, e.useState)(o.tabs[0]), [h, d] = (0, e.useState)(!1), p = {
                plan: e.createElement(CC, {
                    planImage: o.planImage,
                    key: "plan"
                }),
                panorama: e.createElement(DC, {
                    disabled: !o.panoramaData || !o.panoramaData.items.length,
                    items: (null === (t1 = o.panoramaData) || void 0 === t1 ? void 0 : t1.items) || [],
                    type: (null === (i = o.panoramaData) || void 0 === i ? void 0 : i.type) || "sphere",
                    showRulerInstructions: h,
                    setRulerInstructionsState: d
                }),
                rotation: e.createElement(BD, {
                    disabled: !o.rotationData || !o.rotationData.items.length,
                    images: [
                        o.topViewImage,
                        ...(null === (n = o.rotationData) || void 0 === n ? void 0 : n.items) || []
                    ],
                    masks: (f = (null === (r = o.rotationData) || void 0 === r ? void 0 : r.items) || [], zn.isCapable("interactive_top_view") ? [
                        o.topViewImage,
                        ...f
                    ].map((t1)=>t1.replace(/\.jpe?g|\.webp/, "_RoomIDs.exr")) : []),
                    type: (null === (a = o.rotationData) || void 0 === a ? void 0 : a.type) || "top_down",
                    mode: o.rotationMode,
                    key: "area"
                })
            };
            var f;
            var A;
            return (0, e.useEffect)(()=>{
                Un.init();
            }, []), (0, e.useEffect)(()=>{
                o.tabs.some((t1)=>t1 === c) || u(o.tabs[0]);
            }, [
                o,
                c
            ]), e.createElement("main", {
                className: (A = o.width, Object.keys(zN).filter((t1)=>A <= zN[t1])).reduce((t1, e)=>t1 + " widget-application--".concat(e), "widget-application"),
                id: "widget-application",
                style: l
            }, e.createElement("section", {
                className: "widget-tab widget-tab--".concat(c)
            }, p[c], "plan" !== c && e.createElement(kC, {
                currentTab: c,
                setRulerInstructionsState: d
            })), o.logo && e.createElement("a", {
                href: (null === (s = o.branding) || void 0 === s ? void 0 : s.url) || o.logoUrl,
                className: "widget-logo",
                target: "_blank",
                rel: "noreferrer"
            }, e.createElement("img", {
                src: o.logo,
                alt: "logo"
            })), zn.controlsVisible && e.createElement(ON, null), e.createElement("div", {
                className: "widget-tab-buttons"
            }, [
                {
                    tab: "plan",
                    img: "data:image/svg+xml;base64,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"
                },
                {
                    tab: "rotation",
                    img: "data:image/svg+xml;base64,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"
                },
                {
                    tab: "panorama",
                    img: "data:image/svg+xml;base64,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"
                }
            ].map((t1, i)=>!zn.isTabIncluded(t1.tab) || o.tabs.length < 2 ? null : zn.controlsVisible ? e.createElement(jN, {
                    key: i,
                    img: t1.img,
                    active: c === t1.tab,
                    onClick: ()=>u(t1.tab)
                }) : null), "panorama" === c && fN.vrSessionSupported && fN.currentPanorama && !Cx.isMobileDevice && e.createElement(_N, null)), "rotation" === c && jD.roomsVisible && e.createElement(RC, null), e.createElement("div", {
                className: "widget-watermark-button"
            }, e.createElement(PN, {
                href: o.branding ? o.branding.url : (()=>{
                    const t1 = Tv("made-by-link");
                    return "en" === Dn.currentLocale ? t1 + "?utm_source=widget&utm_medium=widget" : t1;
                })(),
                text: o.branding ? o.branding.name : Tv("made-by-text")
            })));
        }), FC = class {
            constructor(t1){
                let i = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                const n = {
                    ...Fn,
                    ...i
                }, r = document.querySelector(t1);
                if (!r) throw new Error("\u041D\u0435 \u0443\u0434\u0430\u043B\u043E\u0441\u044C \u043D\u0430\u0439\u0442\u0438 \u044D\u043B\u0435\u043C\u0435\u043D\u0442: ".concat(t1));
                r.addEventListener("wheel", (t1)=>t1.preventDefault()), i.width || (n.width = r.offsetWidth), i.height || (n.height = r.offsetHeight), i.panoramaFov && "number" == typeof i.panoramaFov || (n.panoramaFov = Fn.panoramaFov), i.panoramaIcons && "object" == typeof i.panoramaIcons ? n.panoramaIcons = {
                    ...Fn.panoramaIcons,
                    ...i.panoramaIcons
                } : n.panoramaIcons = {
                    ...Fn.panoramaIcons
                }, n.containerElement = r, zn.setConfig(n), Un.resize(n), n.resizable && new ResizeObserver(()=>this.onResize()).observe(r), AN.render(e.createElement(BC, null), r);
            }
            get options() {
                return zn.config;
            }
            get panoramaStore() {
                return fN;
            }
            updateSize(t1) {
                const e = {
                    ...this.options,
                    ...t1
                };
                zn.setConfig(e), Un.resize(e);
            }
            onResize() {
                const { offsetWidth: t1, offsetHeight: e } = this.options.containerElement;
                this.updateSize({
                    width: t1,
                    height: e
                });
            }
            on(t1, e) {
                zn.addEventListener(t1, e);
            }
        };
    })(), $a5056a6656605403$exports = n;
})();



const $8f6a480bb40b134f$var$WIDGET_API_URL = "https://backend.estate.hart-digital.com";
const $8f6a480bb40b134f$var$WIDGET_API_STAGE_URL = "https://backend-stage.estate.hart-digital.com";
const $8f6a480bb40b134f$var$createWidget = async ()=>{
    const searchParams = new URL(document.location).searchParams;
    const planId = searchParams.get("id");
    const env = searchParams.get("env");
    const widgetApiHandler = new (0, $a5056a6656605403$exports.ApiStore)(env === "stage" ? $8f6a480bb40b134f$var$WIDGET_API_STAGE_URL : $8f6a480bb40b134f$var$WIDGET_API_URL);
    const planData = await widgetApiHandler.loadWidgetData(planId);
    const options = {
        ...planData.parsed,
        API_URL: env === "stage" ? $8f6a480bb40b134f$var$WIDGET_API_STAGE_URL : $8f6a480bb40b134f$var$WIDGET_API_URL,
        rotationMode: (0, $a5056a6656605403$exports.rotationModes).DEFAULT,
        tabs: [
            "panorama",
            "plan",
            "rotation"
        ],
        locale: "en"
    };
    new (0, $a5056a6656605403$exports.Widget)("#widget", options);
};
$8f6a480bb40b134f$var$createWidget();


//# sourceMappingURL=index.b7f3e79f.js.map
